export const strongsdictionary = {
   "strongsdictionary": {
      "prologue": "Dictionary of Greek Words\n\t\t\t      taken from\n                   Strong's Exhaustive Concordance\n                                  by\n                     James Strong, S.T.D., LL.D.\n                                 1890\n\n                     Public Domain -- Copy Freely\n\nXML e-text version\n==================\n\nThe XML version of this work was prepared in 2006 by Ulrik\nSandborg-Petersen (http://ulrikp.org) from the ASCII e-text version\npresented below.  The XML version contains \"real\" UTF-8 Greek where\nthe original ASCII e-text version had transliteration.  The XML has a\nstand-alone DTD which should be easy to follow.\n\nUlrik Sandborg-Petersen welcomes bugfixes to the text.  Please send\nthem to the address provided on the website:\n\nhttp://ulrikp.org\n\n\nUlrik Sandborg-Petersen\n\n\n\n     -------------- original announcement follows --------------\n\n\n                Dictionaries of Hebrew and Greek Words\n                              taken from\n                   Strong's Exhaustive Concordance\n                                  by\n                     James Strong, S.T.D., LL.D.\n                                 1890\n\n                     Public Domain -- Copy Freely\n\nFor a hundred years Strong's Dictionaries have been popular with Bible\nstudents.  By assigning numbers to each unique word in the Old and New\nTestaments and listing each word with its number, Strong produced a\nstandard, still used today, for referencing definitions. Bible\nstudents, with little or no knowledge of Greek and Hebrew, are able to\nuse Strong's numbers to learn about the Greek and Hebrew of the Bible.\n\nASCII e-text version:\n=====================\n\nThe files for this e-text were produced by Michael Grier,\nmgrier@pdnt.com, in 1996, and download from\nhttp://members.tripod.com/~SoftIdeas, in February 1998. The files have\nbeen setup for importing into the Online Bible for DOS. But to make\nthese files into generic text files, all that is needed is to replace\nthe terms \"GREEK\" and \"HEBREW\" with \"Greek\" and \"Hebrew\" or the names\nof the appropriate files.\n\nThe e-text has been changed from the printed version in three ways.\n\n1) A five digit Strong's word number with leading zeros has been placed before\n   each entry. \n2) Where Strong provides the number of another word for etymology,\n   a line with \"see GREEK for\" or \"see HEBREW for\" and the number, has been\n   added after Strong's entry for the word. (This is for use after\n   importing into the DOS version of Online Bible, but also provides a good\n   way to programmatically add links.)\n3) The abbreviations used by Strong in the\n   Greek dictionary, (not Hebrew) have been replaced by the abbreviated words.\n\nMichael Grier did a check of the e-text against a printed Strong's\ndictionary.  The work seems clean but more proofreading is needed to\ncertify it clean from errors.\n\nFurther info:\n=============\n\nIf you are looking for Strong's that will self install into the Online\nBible see:\n           Michael Grier\n           mgrier@pdnt.com\n           http://members.tripod.com/~SoftIdeas\n\nIf any errors are located, please ensure you have the latest files,\nand if so, we would appreciate being informed of the error.\n\n           Bible Foundation\n           bf@bf.org\n           http://www.bf.org/\n           or the e-text Library\n           http://www.bf.org/bfetexts.htm",
      "entries": {
         "entry": [
            {
               "strongs": "1",
               "greek": [
                  {
                     "_BETA": "*A",
                     "_unicode": "Α",
                     "_translit": "A"
                  },
                  {
                     "_BETA": "A)/N",
                     "_unicode": "ἄν",
                     "_translit": "án"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al'-fah"
                  }
               ],
               "strongs_derivation": "of Hebrew origin;",
               "strongs_def": "the first letter of the alphabet; figuratively, only\n (from its use as a numeral) the first:",
               "kjv_def": "--Alpha.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "427"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "260"
                  }
               ],
               "_strongs": "00001",
               "__text": "Often used (usually\n \n, before a vowel) also in composition (as a contraction from \n) in\n the sense of privation; so, in many words, beginning with this letter;\n occasionally in the sense of union (as a contraction of \n)."
            },
            {
               "strongs": "2",
               "greek": [
                  {
                     "_BETA": "*)AARW/N",
                     "_unicode": "Ἀαρών",
                     "_translit": "Aarṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah-ar-ohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0175"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Aaron, the brother of Moses",
               "kjv_def": ":--Aaron.",
               "_strongs": "00002"
            },
            {
               "strongs": "3",
               "greek": [
                  {
                     "_BETA": "*)ABADDW/N",
                     "_unicode": "Ἀβαδδών",
                     "_translit": "Abaddṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab-ad-dohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "011"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "a destroying angel",
               "kjv_def": ":--Abaddon.",
               "_strongs": "00003"
            },
            {
               "strongs": "4",
               "greek": [
                  {
                     "_BETA": "A)BARH/S",
                     "_unicode": "ἀβαρής",
                     "_translit": "abarḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab-ar-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "922"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "weightless, i.e.\n (figuratively) not burdensome",
               "kjv_def": ":--from being burdensome.",
               "_strongs": "00004"
            },
            {
               "strongs": "5",
               "greek": [
                  {
                     "_BETA": "*)ABBA=",
                     "_unicode": "Ἀββᾶ",
                     "_translit": "Abbâ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab-bah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02"
                     }
                  ],
                  "__text": "of Chaldee origin (\n);"
               },
               "strongs_def": "father as a vocative",
               "kjv_def": ":--Abba.",
               "_strongs": "00005"
            },
            {
               "strongs": "6",
               "greek": [
                  {
                     "_BETA": "*)/ABEL",
                     "_unicode": "Ἄβελ",
                     "_translit": "Ábel"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab'-el"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01893"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Abel, the son of Adam",
               "kjv_def": ":--Abel.",
               "_strongs": "00006"
            },
            {
               "strongs": "7",
               "greek": [
                  {
                     "_BETA": "*)ABIA/",
                     "_unicode": "Ἀβιά",
                     "_translit": "Abiá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab-ee-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "029"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Abijah, the name of two Israelites",
               "kjv_def": ":--Abia.",
               "_strongs": "00007"
            },
            {
               "strongs": "8",
               "greek": [
                  {
                     "_BETA": "*)ABIAQA/R",
                     "_unicode": "Ἀβιαθάρ",
                     "_translit": "Abiathár"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab-ee-ath'-ar"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "054"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Abiathar, an Israelite",
               "kjv_def": ":--Abiathar.",
               "_strongs": "00008"
            },
            {
               "strongs": "9",
               "greek": [
                  {
                     "_BETA": "*)ABILHNH/",
                     "_unicode": "Ἀβιληνή",
                     "_translit": "Abilēnḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab-ee-lay-nay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "058"
                     }
                  ],
                  "__text": "of foreign origin (compare \n);"
               },
               "strongs_def": "Abilene, a region of Syria",
               "kjv_def": ":--Abilene.",
               "_strongs": "00009"
            },
            {
               "strongs": "10",
               "greek": [
                  {
                     "_BETA": "*)ABIOU/D",
                     "_unicode": "Ἀβιούδ",
                     "_translit": "Abioúd"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab-ee-ood'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "031"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Abihud, an Israelite",
               "kjv_def": ":--Abiud.",
               "_strongs": "00010"
            },
            {
               "strongs": "11",
               "greek": [
                  {
                     "_BETA": "*)ABRAA/M",
                     "_unicode": "Ἀβραάμ",
                     "_translit": "Abraám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab-rah-am'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "085"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Abraham, the Hebrew patriarch",
               "kjv_def": ":--Abraham.",
               "_strongs": "00011",
               "__text": "(In\n Acts 7:16 the text should probably read Jacob.)"
            },
            {
               "strongs": "12",
               "greek": [
                  {
                     "_BETA": "A)/BUSSOS",
                     "_unicode": "ἄβυσσος",
                     "_translit": "ábyssos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ab'-us-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1037"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a variation of \n;"
               },
               "strongs_def": "depthless,\n i.e. (specially) (infernal) \"abyss\"",
               "kjv_def": ":--deep, (bottomless) pit.",
               "_strongs": "00012"
            },
            {
               "strongs": "13",
               "greek": [
                  {
                     "_BETA": "*)/AGABOS",
                     "_unicode": "Ἄγαβος",
                     "_translit": "Ágabos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-ab-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02285"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "Agabus, an Israelite",
               "kjv_def": ":--Agabus.",
               "_strongs": "00013"
            },
            {
               "strongs": "14",
               "greek": [
                  {
                     "_BETA": "A)GAQOERGE/W",
                     "_unicode": "ἀγαθοεργέω",
                     "_translit": "agathoergéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ath-er-gheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "18"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to work good",
               "kjv_def": ":--do good.",
               "_strongs": "00014"
            },
            {
               "strongs": "15",
               "greek": [
                  {
                     "_BETA": "A)GAQOPOIE/W",
                     "_unicode": "ἀγαθοποιέω",
                     "_translit": "agathopoiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ath-op-oy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "17"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a well-doer (as a favor or a duty)",
               "kjv_def": ":--(when) do good\n (well).",
               "_strongs": "00015"
            },
            {
               "strongs": "16",
               "greek": [
                  {
                     "_BETA": "A)GAQOPOII/+A",
                     "_unicode": "ἀγαθοποιΐα",
                     "_translit": "agathopoiḯa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ath-op-oy-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "17"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "well-doing, i.e. virtue",
               "kjv_def": ":--well-doing.",
               "_strongs": "00016"
            },
            {
               "strongs": "17",
               "greek": [
                  {
                     "_BETA": "A)GAQOPOIO/S",
                     "_unicode": "ἀγαθοποιός",
                     "_translit": "agathopoiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ath-op-oy-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "18"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a well-doer, i.e. virtuous",
               "kjv_def": ":--them that do well.",
               "_strongs": "00017"
            },
            {
               "strongs": "18",
               "greek": [
                  {
                     "_BETA": "A)GAQO/S",
                     "_unicode": "ἀγαθός",
                     "_translit": "agathós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ath-os'"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "\"good\" (in any sense, often as noun)",
               "kjv_def": ":--benefit,\n good(-s, things), well.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2570"
                  }
               ],
               "_strongs": "00018",
               "__text": "Compare \n."
            },
            {
               "strongs": "19",
               "greek": [
                  {
                     "_BETA": "A)GAQWSU/NH",
                     "_unicode": "ἀγαθωσύνη",
                     "_translit": "agathōsýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ath-o-soo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "18"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "goodness, i.e. virtue or beneficence",
               "kjv_def": ":--goodness.",
               "_strongs": "00019"
            },
            {
               "strongs": "20",
               "greek": [
                  {
                     "_BETA": "A)GALLI/ASIS",
                     "_unicode": "ἀγαλλίασις",
                     "_translit": "agallíasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-al-lee'-as-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "21"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "exultation; specially, welcome",
               "kjv_def": ":--gladness, (exceeding) joy.",
               "_strongs": "00020"
            },
            {
               "strongs": "21",
               "greek": [
                  {
                     "_BETA": "A)GALLIA/W",
                     "_unicode": "ἀγαλλιάω",
                     "_translit": "agalliáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-al-lee-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/GAN",
                        "_unicode": "ἄγαν",
                        "_translit": "ágan"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "242"
                     }
                  ],
                  "__text": "from \n (much) and \n;"
               },
               "strongs_def": "properly, to jump for joy, i.e. exult",
               "kjv_def": ":--be\n (exceeding) glad, with exceeding joy, rejoice (greatly).",
               "_strongs": "00021"
            },
            {
               "strongs": "22",
               "greek": [
                  {
                     "_BETA": "A)/GAMOS",
                     "_unicode": "ἄγαμος",
                     "_translit": "ágamos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-am-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1062"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unmarried",
               "kjv_def": ":--unmarried.",
               "_strongs": "00022"
            },
            {
               "strongs": "23",
               "greek": [
                  {
                     "_BETA": "A)GANAKTE/W",
                     "_unicode": "ἀγανακτέω",
                     "_translit": "aganaktéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-an-ak-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/GAN",
                        "_unicode": "ἄγαν",
                        "_translit": "ágan"
                     },
                     {
                        "_BETA": "A)/XQOS",
                        "_unicode": "ἄχθος",
                        "_translit": "áchthos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "__text": "from \n (much) and \n (grief; akin to the base of \n);"
               },
               "strongs_def": "to be\n greatly afflicted, i.e. (figuratively) indignant",
               "kjv_def": ":--be much (sore)\n displeased, have (be moved with, with) indignation.",
               "_strongs": "00023"
            },
            {
               "strongs": "24",
               "greek": [
                  {
                     "_BETA": "A)GANA/KTHSIS",
                     "_unicode": "ἀγανάκτησις",
                     "_translit": "aganáktēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-an-ak'-tay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "23"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "indignation",
               "kjv_def": ":--indignation.",
               "_strongs": "00024"
            },
            {
               "strongs": "25",
               "greek": [
                  {
                     "_BETA": "A)GAPA/W",
                     "_unicode": "ἀγαπάω",
                     "_translit": "agapáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ap-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/GAN",
                        "_unicode": "ἄγαν",
                        "_translit": "ágan"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "5689"
                     }
                  ],
                  "__text": "perhaps from \n (much) [or compare \n];"
               },
               "strongs_def": "to love (in a social or\n moral sense)",
               "kjv_def": ":--(be-)love(-ed).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5368"
                  }
               ],
               "_strongs": "00025",
               "__text": "Compare \n."
            },
            {
               "strongs": "26",
               "greek": [
                  {
                     "_BETA": "A)GA/PH",
                     "_unicode": "ἀγάπη",
                     "_translit": "agápē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ah'-pay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "25"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "love, i.e. affection or benevolence; specially (plural) a\n love-feast",
               "kjv_def": ":--(feast of) charity(-ably), dear, love.",
               "_strongs": "00026"
            },
            {
               "strongs": "27",
               "greek": [
                  {
                     "_BETA": "A)GAPHTO/S",
                     "_unicode": "ἀγαπητός",
                     "_translit": "agapētós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ap-ay-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "25"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "beloved",
               "kjv_def": ":--(dearly, well) beloved, dear.",
               "_strongs": "00027"
            },
            {
               "strongs": "28",
               "greek": [
                  {
                     "_BETA": "*)/AGAR",
                     "_unicode": "Ἄγαρ",
                     "_translit": "Ágar"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-ar"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01904"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Hagar, the concubine of Abraham",
               "kjv_def": ":--Hagar.",
               "_strongs": "00028"
            },
            {
               "strongs": "29",
               "greek": [
                  {
                     "_BETA": "A)GGAREU/W",
                     "_unicode": "ἀγγαρεύω",
                     "_translit": "angareúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ang-ar-yew'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0104"
                     }
                  ],
                  "__text": "of foreign origin (compare \n);"
               },
               "strongs_def": "properly, to be a courier, i.e. (by\n implication) to press into public service",
               "kjv_def": ":--compel (to go).",
               "_strongs": "00029"
            },
            {
               "strongs": "30",
               "greek": [
                  {
                     "_BETA": "A)GGEI=ON",
                     "_unicode": "ἀγγεῖον",
                     "_translit": "angeîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ang-eye'-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/GGOS",
                        "_unicode": "ἄγγος",
                        "_translit": "ángos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "__text": "from \n (a pail, perhaps as bent; compare the base of \n);"
               },
               "strongs_def": "a\n receptacle",
               "kjv_def": ":--vessel.",
               "_strongs": "00030"
            },
            {
               "strongs": "31",
               "greek": [
                  {
                     "_BETA": "A)GGELI/A",
                     "_unicode": "ἀγγελία",
                     "_translit": "angelía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ang-el-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an announcement, i.e. (by implication) precept",
               "kjv_def": ":--message.",
               "_strongs": "00031"
            },
            {
               "strongs": "32",
               "greek": [
                  {
                     "_BETA": "A)/GGELOS",
                     "_unicode": "ἄγγελος",
                     "_translit": "ángelos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ang'-el-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)GGE/LLW",
                        "_unicode": "ἀγγέλλω",
                        "_translit": "angéllō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n (probably derived from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "34"
                     }
                  ],
                  "__text": "compare \n) (to bring\n tidings); a messenger; especially an \"angel\"; by implication, a\n pastor"
               },
               "kjv_def": ":--angel, messenger.",
               "_strongs": "00032"
            },
            {
               "strongs": "33",
               "greek": [
                  {
                     "_BETA": "A)/GE",
                     "_unicode": "ἄγε",
                     "_translit": "áge"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "imperative of \n;"
               },
               "strongs_def": "properly, lead, i.e. come on",
               "kjv_def": ":--go to.",
               "_strongs": "00033"
            },
            {
               "strongs": "34",
               "greek": [
                  {
                     "_BETA": "A)GE/LH",
                     "_unicode": "ἀγέλη",
                     "_translit": "agélē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-el'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n (compare \n);"
               },
               "strongs_def": "a drove",
               "kjv_def": ":--herd.",
               "_strongs": "00034"
            },
            {
               "strongs": "35",
               "greek": [
                  {
                     "_BETA": "A)GENEALO/GHTOS",
                     "_unicode": "ἀγενεαλόγητος",
                     "_translit": "agenealógētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-en-eh-al-og'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1075"
                     }
                  ],
                  "__text": "from \n (as negative particle) and \n;"
               },
               "strongs_def": "unregistered as to\n birth",
               "kjv_def": ":--without descent.",
               "_strongs": "00035"
            },
            {
               "strongs": "36",
               "greek": [
                  {
                     "_BETA": "A)GENH/S",
                     "_unicode": "ἀγενής",
                     "_translit": "agenḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-en-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1085"
                     }
                  ],
                  "__text": "from \n (as negative particle) and \n;"
               },
               "strongs_def": "properly, without kin, i.e.\n (of unknown descent, and by implication) ignoble",
               "kjv_def": ":--base things.",
               "_strongs": "00036"
            },
            {
               "strongs": "37",
               "greek": [
                  {
                     "_BETA": "A(GIA/ZW",
                     "_unicode": "ἁγιάζω",
                     "_translit": "hagiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-ee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "40"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make holy, i.e. (ceremonially) purify or consecrate;\n (mentally) to venerate",
               "kjv_def": ":--hallow, be holy, sanctify.",
               "_strongs": "00037"
            },
            {
               "strongs": "38",
               "greek": [
                  {
                     "_BETA": "A(GIASMO/S",
                     "_unicode": "ἁγιασμός",
                     "_translit": "hagiasmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-ee-as-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "37"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, purification, i.e. (the state) purity; concretely\n (by Hebraism) a purifier",
               "kjv_def": ":--holiness, sanctification.",
               "_strongs": "00038"
            },
            {
               "strongs": "39",
               "greek": [
                  {
                     "_BETA": "A(/GION",
                     "_unicode": "ἅγιον",
                     "_translit": "hágion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "40"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": "a sacred thing (i.e. spot)",
               "kjv_def": ":--holiest (of all), holy\n place, sanctuary.",
               "_strongs": "00039"
            },
            {
               "strongs": "40",
               "greek": [
                  {
                     "_BETA": "A(/GIOS",
                     "_unicode": "ἅγιος",
                     "_translit": "hágios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A(/GOS",
                        "_unicode": "ἅγος",
                        "_translit": "hágos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "53"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2282"
                     }
                  ],
                  "__text": "from \n (an awful thing) (compare \n, \n);"
               },
               "strongs_def": "sacred (physically,\n pure, morally blameless or religious, ceremonially,\n consecrated)",
               "kjv_def": ":--(most) holy (one, thing), saint.",
               "_strongs": "00040"
            },
            {
               "strongs": "41",
               "greek": [
                  {
                     "_BETA": "A(GIO/THS",
                     "_unicode": "ἁγιότης",
                     "_translit": "hagiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-ee-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "40"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sanctity (i.e. properly, the state)",
               "kjv_def": ":--holiness.",
               "_strongs": "00041"
            },
            {
               "strongs": "42",
               "greek": [
                  {
                     "_BETA": "A(GIWSU/NH",
                     "_unicode": "ἁγιωσύνη",
                     "_translit": "hagiōsýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-ee-o-soo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "40"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sacredness (i.e. properly, the quality)",
               "kjv_def": ":--holiness.",
               "_strongs": "00042"
            },
            {
               "strongs": "43",
               "greek": [
                  {
                     "_BETA": "A)GKA/LH",
                     "_unicode": "ἀγκάλη",
                     "_translit": "ankálē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ang-kal'-ay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/GKOS",
                        "_unicode": "ἄγκος",
                        "_translit": "ánkos"
                     }
                  ],
                  "__text": "from \n (a bend, \"ache\");"
               },
               "strongs_def": "an arm (as curved)",
               "kjv_def": ":--arm.",
               "_strongs": "00043"
            },
            {
               "strongs": "44",
               "greek": [
                  {
                     "_BETA": "A)/GKISTRON",
                     "_unicode": "ἄγκιστρον",
                     "_translit": "ánkistron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ang'-kis-tron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a hook (as bent)",
               "kjv_def": ":--hook.",
               "_strongs": "00044"
            },
            {
               "strongs": "45",
               "greek": [
                  {
                     "_BETA": "A)/GKURA",
                     "_unicode": "ἄγκυρα",
                     "_translit": "ánkyra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ang'-koo-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "an \"anchor\" (as crooked)",
               "kjv_def": ":--anchor.",
               "_strongs": "00045"
            },
            {
               "strongs": "46",
               "greek": [
                  {
                     "_BETA": "A)/GNAFOS",
                     "_unicode": "ἄγναφος",
                     "_translit": "ágnaphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-naf-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1102"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and the same as \n;"
               },
               "strongs_def": "properly,\n unfulled, i.e. (by implication) new (cloth)",
               "kjv_def": ":--new.",
               "_strongs": "00046"
            },
            {
               "strongs": "47",
               "greek": [
                  {
                     "_BETA": "A(GNEI/A",
                     "_unicode": "ἁγνεία",
                     "_translit": "hagneía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-ni'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "53"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cleanliness (the quality), i.e. (specially)\n chastity",
               "kjv_def": ":--purity.",
               "_strongs": "00047"
            },
            {
               "strongs": "48",
               "greek": [
                  {
                     "_BETA": "A(GNI/ZW",
                     "_unicode": "ἁγνίζω",
                     "_translit": "hagnízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-nid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "53"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make clean, i.e. (figuratively) sanctify (ceremonially or\n morally)",
               "kjv_def": ":--purify (self).",
               "_strongs": "00048"
            },
            {
               "strongs": "49",
               "greek": [
                  {
                     "_BETA": "A(GNISMO/S",
                     "_unicode": "ἁγνισμός",
                     "_translit": "hagnismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-nis-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "48"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a cleansing (the act), i.e. (ceremonially)\n lustration",
               "kjv_def": ":--purification.",
               "_strongs": "00049"
            },
            {
               "strongs": "50",
               "greek": [
                  {
                     "_BETA": "A)GNOE/W",
                     "_unicode": "ἀγνοέω",
                     "_translit": "agnoéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-no-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "not to know (through lack of\n information or intelligence); by implication, to ignore (through\n disinclination)",
               "kjv_def": ":--(be) ignorant(-ly), not know, not understand,\n unknown.",
               "_strongs": "00050"
            },
            {
               "strongs": "51",
               "greek": [
                  {
                     "_BETA": "A)GNO/HMA",
                     "_unicode": "ἀγνόημα",
                     "_translit": "agnóēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-no'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "50"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a thing ignored, i.e. shortcoming",
               "kjv_def": ":--error.",
               "_strongs": "00051"
            },
            {
               "strongs": "52",
               "greek": [
                  {
                     "_BETA": "A)/GNOIA",
                     "_unicode": "ἄγνοια",
                     "_translit": "ágnoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-noy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "50"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "ignorance (properly, the quality)",
               "kjv_def": ":--ignorance.",
               "_strongs": "00052"
            },
            {
               "strongs": "53",
               "greek": [
                  {
                     "_BETA": "A(GNO/S",
                     "_unicode": "ἁγνός",
                     "_translit": "hagnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "40"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "properly, clean, i.e. (figuratively) innocent,\n modest, perfect",
               "kjv_def": ":--chaste, clean, pure.",
               "_strongs": "00053"
            },
            {
               "strongs": "54",
               "greek": [
                  {
                     "_BETA": "A(GNO/THS",
                     "_unicode": "ἁγνότης",
                     "_translit": "hagnótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-not'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "53"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cleanness (the state), i.e. (figuratively)\n blamelessness",
               "kjv_def": ":--pureness.",
               "_strongs": "00054"
            },
            {
               "strongs": "55",
               "greek": [
                  {
                     "_BETA": "A(GNW=S",
                     "_unicode": "ἁγνῶς",
                     "_translit": "hagnōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hag-noce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "53"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "purely, i.e. honestly",
               "kjv_def": ":--sincerely.",
               "_strongs": "00055"
            },
            {
               "strongs": "56",
               "greek": [
                  {
                     "_BETA": "A)GNWSI/A",
                     "_unicode": "ἀγνωσία",
                     "_translit": "agnōsía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-no-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1108"
                     }
                  ],
                  "__text": "from \n (as negative particle) and \n;"
               },
               "strongs_def": "ignorance (properly, the\n state)",
               "kjv_def": ":--ignorance, not the knowledge.",
               "_strongs": "00056"
            },
            {
               "strongs": "57",
               "greek": [
                  {
                     "_BETA": "A)/GNWSTOS",
                     "_unicode": "ἄγνωστος",
                     "_translit": "ágnōstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-noce-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1110"
                     }
                  ],
                  "__text": "from \n (as negative particle) and \n;"
               },
               "strongs_def": "unknown",
               "kjv_def": ":--unknown.",
               "_strongs": "00057"
            },
            {
               "strongs": "58",
               "greek": [
                  {
                     "_BETA": "A)GORA/",
                     "_unicode": "ἀγορά",
                     "_translit": "agorá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-or-ah'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)GEI/RW",
                        "_unicode": "ἀγείρω",
                        "_translit": "ageírō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1453"
                     }
                  ],
                  "__text": "from \n (to gather; probably akin to \n);"
               },
               "strongs_def": "properly, the\n town-square (as a place of public resort); by implication, a market or\n thoroughfare",
               "kjv_def": ":--market(-place), street.",
               "_strongs": "00058"
            },
            {
               "strongs": "59",
               "greek": [
                  {
                     "_BETA": "A)GORA/ZW",
                     "_unicode": "ἀγοράζω",
                     "_translit": "agorázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-or-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, to go to market, i.e. (by implication) to purchase;\n specially, to redeem",
               "kjv_def": ":--buy, redeem.",
               "_strongs": "00059"
            },
            {
               "strongs": "60",
               "greek": [
                  {
                     "_BETA": "A)GORAI=OS",
                     "_unicode": "ἀγοραῖος",
                     "_translit": "agoraîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-or-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "relating to the market-place, i.e. forensic (times); by\n implication, vulgar",
               "kjv_def": ":--baser sort, low.",
               "_strongs": "00060"
            },
            {
               "strongs": "61",
               "greek": [
                  {
                     "_BETA": "A)/GRA",
                     "_unicode": "ἄγρα",
                     "_translit": "ágra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(abstractly) a catching (of fish); also (concretely) a haul\n (of fish)",
               "kjv_def": ":--draught.",
               "_strongs": "00061"
            },
            {
               "strongs": "62",
               "greek": [
                  {
                     "_BETA": "A)GRA/MMATOS",
                     "_unicode": "ἀγράμματος",
                     "_translit": "agrámmatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ram-mat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1121"
                     }
                  ],
                  "__text": "from \n (as negative particle) and \n;"
               },
               "strongs_def": "unlettered, i.e.\n illiterate",
               "kjv_def": ":--unlearned.",
               "_strongs": "00062"
            },
            {
               "strongs": "63",
               "greek": [
                  {
                     "_BETA": "A)GRAULE/W",
                     "_unicode": "ἀγραυλέω",
                     "_translit": "agrauléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-row-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "68"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "832"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "833"
                     }
                  ],
                  "__text": "from \n and \n (in the sense of \n);"
               },
               "strongs_def": "to camp out",
               "kjv_def": ":--abide in the\n field.",
               "_strongs": "00063"
            },
            {
               "strongs": "64",
               "greek": [
                  {
                     "_BETA": "A)GREU/W",
                     "_unicode": "ἀγρεύω",
                     "_translit": "agreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-rew'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "61"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to hunt, i.e. (figuratively) to entrap",
               "kjv_def": ":--catch.",
               "_strongs": "00064"
            },
            {
               "strongs": "65",
               "greek": [
                  {
                     "_BETA": "A)GRIE/LAIOS",
                     "_unicode": "ἀγριέλαιος",
                     "_translit": "agriélaios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ree-el'-ah-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "66"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1636"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an oleaster",
               "kjv_def": ":--olive tree (which is) wild.",
               "_strongs": "00065"
            },
            {
               "strongs": "66",
               "greek": [
                  {
                     "_BETA": "A)/GRIOS",
                     "_unicode": "ἄγριος",
                     "_translit": "ágrios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-ree-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "68"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "wild (as pertaining to the country), literally (natural) or\n figuratively (fierce)",
               "kjv_def": ":--wild, raging.",
               "_strongs": "00066"
            },
            {
               "strongs": "67",
               "greek": [
                  {
                     "_BETA": "*)AGRI/PPAS",
                     "_unicode": "Ἀγρίππας",
                     "_translit": "Agríppas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-rip'-pas"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "66"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2462"
                     }
                  ],
                  "__text": "apparently from \n and \n;"
               },
               "strongs_def": "wild-horse tamer; Agrippas, one of the\n Herods",
               "kjv_def": ":--Agrippa.",
               "_strongs": "00067"
            },
            {
               "strongs": "68",
               "greek": [
                  {
                     "_BETA": "A)GRO/S",
                     "_unicode": "ἀγρός",
                     "_translit": "agrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a field (as a drive for cattle); genitive case, the country;\n specially, a farm, i.e. hamlet",
               "kjv_def": ":--country, farm, piece of ground, land.",
               "_strongs": "00068"
            },
            {
               "strongs": "69",
               "greek": [
                  {
                     "_BETA": "A)GRUPNE/W",
                     "_unicode": "ἀγρυπνέω",
                     "_translit": "agrypnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-roop-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5258"
                     }
                  ],
                  "__text": "ultimately from \n (as negative particle) and \n;"
               },
               "strongs_def": "to be sleepless,\n i.e. keep awake",
               "kjv_def": ":--watch.",
               "_strongs": "00069"
            },
            {
               "strongs": "70",
               "greek": [
                  {
                     "_BETA": "A)GRUPNI/A",
                     "_unicode": "ἀγρυπνία",
                     "_translit": "agrypnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-roop-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "69"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sleeplessness, i.e. a keeping awake",
               "kjv_def": ":--watch.",
               "_strongs": "00070"
            },
            {
               "strongs": "71",
               "greek": [
                  {
                     "_BETA": "A)/GW",
                     "_unicode": "ἄγω",
                     "_translit": "ágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "properly, to lead; by implication, to bring, drive,\n (reflexively) go, (specially) pass (time), or (figuratively)\n induce",
               "kjv_def": ":--be, bring (forth), carry, (let) go, keep, lead away, be open.",
               "_strongs": "00071"
            },
            {
               "strongs": "72",
               "greek": [
                  {
                     "_BETA": "A)GWGH/",
                     "_unicode": "ἀγωγή",
                     "_translit": "agōgḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-o-gay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "reduplicated from \n;"
               },
               "strongs_def": "a bringing up, i.e. mode of living",
               "kjv_def": ":--manner of\n life.",
               "_strongs": "00072"
            },
            {
               "strongs": "73",
               "greek": [
                  {
                     "_BETA": "A)GW/N",
                     "_unicode": "ἀγών",
                     "_translit": "agṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-one'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a place of assembly (as if led), i.e. (by\n implication) a contest (held there); figuratively, an effort or\n anxiety",
               "kjv_def": ":--conflict, contention, fight, race.",
               "_strongs": "00073"
            },
            {
               "strongs": "74",
               "greek": [
                  {
                     "_BETA": "A)GWNI/A",
                     "_unicode": "ἀγωνία",
                     "_translit": "agōnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-o-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "73"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a struggle (properly, the state), i.e. (figuratively)\n anguish",
               "kjv_def": ":--agony.",
               "_strongs": "00074"
            },
            {
               "strongs": "75",
               "greek": [
                  {
                     "_BETA": "A)GWNI/ZOMAI",
                     "_unicode": "ἀγωνίζομαι",
                     "_translit": "agōnízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ag-o-nid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "73"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to struggle, literally (to compete for a prize), figuratively\n (to contend with an adversary), or genitive case (to endeavor to\n accomplish something)",
               "kjv_def": ":--fight, labor fervently, strive.",
               "_strongs": "00075"
            },
            {
               "strongs": "76",
               "greek": [
                  {
                     "_BETA": "*)ADA/M",
                     "_unicode": "Ἀδάμ",
                     "_translit": "Adám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-am'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0121"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Adam, the first man; typically (of Jesus) man\n (as his representative)",
               "kjv_def": ":--Adam.",
               "_strongs": "00076"
            },
            {
               "strongs": "77",
               "greek": [
                  {
                     "_BETA": "A)DA/PANOS",
                     "_unicode": "ἀδάπανος",
                     "_translit": "adápanos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ap'-an-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "__text": "from \n (as negative particle);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1160"
                     }
                  ],
                  "__text": "and \n; costless, i.e.\n gratuitous"
               },
               "kjv_def": ":--without expense.",
               "_strongs": "00077"
            },
            {
               "strongs": "78",
               "greek": [
                  {
                     "_BETA": "*)ADDI/",
                     "_unicode": "Ἀδδί",
                     "_translit": "Addí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-dee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05716"
                     }
                  ],
                  "__text": "probably of Hebrew origin (compare \n);"
               },
               "strongs_def": "Addi, an Israelite",
               "kjv_def": ":--Addi.",
               "_strongs": "00078"
            },
            {
               "strongs": "79",
               "greek": [
                  {
                     "_BETA": "A)DELFH/",
                     "_unicode": "ἀδελφή",
                     "_translit": "adelphḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-el-fay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "80"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a sister (naturally or ecclesiastically)",
               "kjv_def": ":--sister.",
               "_strongs": "00079"
            },
            {
               "strongs": "80",
               "greek": [
                  {
                     "_BETA": "A)DELFO/S",
                     "_unicode": "ἀδελφός",
                     "_translit": "adelphós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-el-fos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "DELFU/S",
                        "_unicode": "δελφύς",
                        "_translit": "delphýs"
                     }
                  ],
                  "__text": "from \n (as a connective particle) and \n (the womb);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "__text": "a brother\n (literally or figuratively) near or remote (much like \n)"
               },
               "kjv_def": ":--brother.",
               "_strongs": "00080"
            },
            {
               "strongs": "81",
               "greek": [
                  {
                     "_BETA": "A)DELFO/THS",
                     "_unicode": "ἀδελφότης",
                     "_translit": "adelphótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-el-fot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "80"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "brotherhood (properly, the feeling of brotherliness), i.e.\n the (Christian) fraternity",
               "kjv_def": ":--brethren, brotherhood.",
               "_strongs": "00081"
            },
            {
               "strongs": "82",
               "greek": [
                  {
                     "_BETA": "A)/DHLOS",
                     "_unicode": "ἄδηλος",
                     "_translit": "ádēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad'-ay-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1212"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "hidden, figuratively,\n indistinct",
               "kjv_def": ":--appear not, uncertain.",
               "_strongs": "00082"
            },
            {
               "strongs": "83",
               "greek": [
                  {
                     "_BETA": "A)DHLO/THS",
                     "_unicode": "ἀδηλότης",
                     "_translit": "adēlótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ay-lot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "82"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "uncertainty",
               "kjv_def": ":--X uncertain.",
               "_strongs": "00083"
            },
            {
               "strongs": "84",
               "greek": [
                  {
                     "_BETA": "A)DH/LWS",
                     "_unicode": "ἀδήλως",
                     "_translit": "adḗlōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ay'-loce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "82"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "uncertainly",
               "kjv_def": ":--uncertainly.",
               "_strongs": "00084"
            },
            {
               "strongs": "85",
               "greek": [
                  {
                     "_BETA": "A)DHMONE/W",
                     "_unicode": "ἀδημονέω",
                     "_translit": "adēmonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ay-mon-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)DE/W",
                        "_unicode": "ἀδέω",
                        "_translit": "adéō"
                     }
                  ],
                  "__text": "from a derivative of \n (to be sated to loathing);"
               },
               "strongs_def": "to be in distress\n (of mind)",
               "kjv_def": ":--be full of heaviness, be very heavy.",
               "_strongs": "00085"
            },
            {
               "strongs": "86",
               "greek": [
                  {
                     "_BETA": "A(/|DHS",
                     "_unicode": "ᾅδης",
                     "_translit": "háidēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hah'-dace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "from \n (as negative particle) and \n;"
               },
               "strongs_def": "properly, unseen, i.e. \"Hades\"\n or the place (state) of departed souls",
               "kjv_def": ":--grave, hell.",
               "_strongs": "00086"
            },
            {
               "strongs": "87",
               "greek": [
                  {
                     "_BETA": "A)DIA/KRITOS",
                     "_unicode": "ἀδιάκριτος",
                     "_translit": "adiákritos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ee-ak'-ree-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1252"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "properly,\n undistinguished, i.e. (actively) impartial",
               "kjv_def": ":--without partiality.",
               "_strongs": "00087"
            },
            {
               "strongs": "88",
               "greek": [
                  {
                     "_BETA": "A)DIA/LEIPTOS",
                     "_unicode": "ἀδιάλειπτος",
                     "_translit": "adiáleiptos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ee-al'-ipe-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of a compound of \n\n and \n;"
               },
               "strongs_def": "unintermitted, i.e. permanent",
               "kjv_def": ":--without ceasing, continual.",
               "_strongs": "00088"
            },
            {
               "strongs": "89",
               "greek": [
                  {
                     "_BETA": "A)DIALEI/PTWS",
                     "_unicode": "ἀδιαλείπτως",
                     "_translit": "adialeíptōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ee-al-ipe'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "88"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "uninterruptedly, i.e. without omission (on an\n appropriate occasion)",
               "kjv_def": ":--without ceasing.",
               "_strongs": "00089"
            },
            {
               "strongs": "90",
               "greek": [
                  {
                     "_BETA": "A)DIAFQORI/A",
                     "_unicode": "ἀδιαφθορία",
                     "_translit": "adiaphthoría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ee-af-thor-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1311"
                     }
                  ],
                  "__text": "from a derivative of a compound of \n (as a negative particle) and a\n derivative of \n;"
               },
               "strongs_def": "incorruptibleness, i.e. (figuratively) purity (of\n doctrine)",
               "kjv_def": ":--uncorruptness.",
               "_strongs": "00090"
            },
            {
               "strongs": "91",
               "greek": [
                  {
                     "_BETA": "A)DIKE/W",
                     "_unicode": "ἀδικέω",
                     "_translit": "adikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ee-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "94"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be unjust, i.e. (actively) do wrong (morally, socially or\n physically)",
               "kjv_def": ":--hurt, injure, be an offender, be unjust, (do, suffer,\n take) wrong.",
               "_strongs": "00091"
            },
            {
               "strongs": "92",
               "greek": [
                  {
                     "_BETA": "A)DI/KHMA",
                     "_unicode": "ἀδίκημα",
                     "_translit": "adíkēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-eek'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "91"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a wrong done",
               "kjv_def": ":--evil doing, iniquity, matter of wrong.",
               "_strongs": "00092"
            },
            {
               "strongs": "93",
               "greek": [
                  {
                     "_BETA": "A)DIKI/A",
                     "_unicode": "ἀδικία",
                     "_translit": "adikía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ee-kee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "94"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(legal) injustice (properly, the quality, by implication, the\n act); morally, wrongfulness (of character, life or act)",
               "kjv_def": ":--iniquity,\n unjust, unrighteousness, wrong.",
               "_strongs": "00093"
            },
            {
               "strongs": "94",
               "greek": [
                  {
                     "_BETA": "A)/DIKOS",
                     "_unicode": "ἄδικος",
                     "_translit": "ádikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad'-ee-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unjust; by extension wicked;\n by implication, treacherous; specially, heathen",
               "kjv_def": ":--unjust, unrighteous.",
               "_strongs": "00094"
            },
            {
               "strongs": "95",
               "greek": [
                  {
                     "_BETA": "A)DI/KWS",
                     "_unicode": "ἀδίκως",
                     "_translit": "adíkōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ee'-koce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "94"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "unjustly",
               "kjv_def": ":--wrongfully.",
               "_strongs": "00095"
            },
            {
               "strongs": "96",
               "greek": [
                  {
                     "_BETA": "A)DO/KIMOS",
                     "_unicode": "ἀδόκιμος",
                     "_translit": "adókimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ok'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1384"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unapproved, i.e. rejected;\n by implication, worthless (literally or morally)",
               "kjv_def": ":--castaway, rejected,\n reprobate.",
               "_strongs": "00096"
            },
            {
               "strongs": "97",
               "greek": [
                  {
                     "_BETA": "A)/DOLOS",
                     "_unicode": "ἄδολος",
                     "_translit": "ádolos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad'-ol-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "__text": "from \n (as a negative particle);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1388"
                     }
                  ],
                  "__text": "and \n; undeceitful, i.e.\n (figuratively) unadulterated"
               },
               "kjv_def": ":--sincere.",
               "_strongs": "00097"
            },
            {
               "strongs": "98",
               "greek": [
                  {
                     "_BETA": "*)ADRAMUTTHNO/S",
                     "_unicode": "Ἀδραμυττηνός",
                     "_translit": "Adramyttēnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ram-oot-tay-nos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)ADRAMU/TTEION",
                        "_unicode": "Ἀδραμύττειον",
                        "_translit": "Adramýtteion"
                     }
                  ],
                  "__text": "from \n (a place in Asia Minor);"
               },
               "strongs_def": "Adramyttene or belonging to\n Adramyttium",
               "kjv_def": ":--of Adramyttium.",
               "_strongs": "00098"
            },
            {
               "strongs": "99",
               "greek": [
                  {
                     "_BETA": "*)ADRI/AS",
                     "_unicode": "Ἀδρίας",
                     "_translit": "Adrías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-ree'-as"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)ADRI/A",
                        "_unicode": "Ἀδρία",
                        "_translit": "Adría"
                     }
                  ],
                  "__text": "from \n (a place near its shore);"
               },
               "strongs_def": "the Adriatic sea (including the\n Ionian)",
               "kjv_def": ":--Adria.",
               "_strongs": "00099"
            },
            {
               "strongs": "100",
               "greek": [
                  {
                     "_BETA": "A(DRO/THS",
                     "_unicode": "ἁδρότης",
                     "_translit": "hadrótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "had-rot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A(DRO/S",
                        "_unicode": "ἁδρός",
                        "_translit": "hadrós"
                     }
                  ],
                  "__text": "from \n (stout);"
               },
               "strongs_def": "plumpness, i.e. (figuratively)\n liberality",
               "kjv_def": ":--abundance.",
               "_strongs": "00100"
            },
            {
               "strongs": "101",
               "greek": [
                  {
                     "_BETA": "A)DUNATE/W",
                     "_unicode": "ἀδυνατέω",
                     "_translit": "adynatéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-oo-nat-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "102"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be unable, i.e. (passively) impossible",
               "kjv_def": ":--be impossible.",
               "_strongs": "00101"
            },
            {
               "strongs": "102",
               "greek": [
                  {
                     "_BETA": "A)DU/NATOS",
                     "_unicode": "ἀδύνατος",
                     "_translit": "adýnatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-oo'-nat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1415"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unable, i.e. weak (literally\n or figuratively); passively, impossible",
               "kjv_def": ":--could not do, impossible,\n impotent, not possible, weak.",
               "_strongs": "00102"
            },
            {
               "strongs": "103",
               "greek": [
                  {
                     "_BETA": "A)/|DW",
                     "_unicode": "ᾄδω",
                     "_translit": "áidō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to sing",
               "kjv_def": ":--sing.",
               "_strongs": "00103"
            },
            {
               "strongs": "104",
               "greek": [
                  {
                     "_BETA": "A)EI/",
                     "_unicode": "ἀεί",
                     "_translit": "aeí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah-eye'"
                  }
               ],
               "strongs_derivation": "from an obsolete primary noun (apparently meaning continued duration);",
               "strongs_def": "\"ever,\" by qualification regularly; by implication, earnestly",
               "kjv_def": ":--always, ever.",
               "_strongs": "00104"
            },
            {
               "strongs": "105",
               "greek": [
                  {
                     "_BETA": "A)ETO/S",
                     "_unicode": "ἀετός",
                     "_translit": "aetós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah-et-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "an eagle (from its wind-like flight)",
               "kjv_def": ":--eagle.",
               "_strongs": "00105"
            },
            {
               "strongs": "106",
               "greek": [
                  {
                     "_BETA": "A)/ZUMOS",
                     "_unicode": "ἄζυμος",
                     "_translit": "ázymos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad'-zoo-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2219"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unleavened, i.e.\n (figuratively) uncorrupted; (in the neutral plural) specially (by\n implication) the Passover week",
               "kjv_def": ":--unleavened (bread).",
               "_strongs": "00106"
            },
            {
               "strongs": "107",
               "greek": [
                  {
                     "_BETA": "*)AZW/R",
                     "_unicode": "Ἀζώρ",
                     "_translit": "Azṓr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad-zore'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05809"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "Azor, an Israelite",
               "kjv_def": ":--Azor.",
               "_strongs": "00107"
            },
            {
               "strongs": "108",
               "greek": [
                  {
                     "_BETA": "*)/AZWTOS",
                     "_unicode": "Ἄζωτος",
                     "_translit": "Ázōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ad'-zo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0795"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Azotus (i.e. Ashdod), a place in\n Palestine",
               "kjv_def": ":--Azotus.",
               "_strongs": "00108"
            },
            {
               "strongs": "109",
               "greek": [
                  {
                     "_BETA": "A)H/R",
                     "_unicode": "ἀήρ",
                     "_translit": "aḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah-ayr'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/HMI",
                        "_unicode": "ἄημι",
                        "_translit": "áēmi"
                     }
                  ],
                  "__text": "from \n (to breathe unconsciously, i.e. respire; by analogy, to\n blow);"
               },
               "strongs_def": "\"air\" (as naturally circumambient)",
               "kjv_def": ":--air.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5594"
                  }
               ],
               "_strongs": "00109",
               "__text": "Compare \n."
            },
            {
               "strongs": "110",
               "greek": [
                  {
                     "_BETA": "A)QANASI/A",
                     "_unicode": "ἀθανασία",
                     "_translit": "athanasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath-an-as-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2288"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and \n;"
               },
               "strongs_def": "deathlessness",
               "kjv_def": ":--immortality.",
               "_strongs": "00110"
            },
            {
               "strongs": "111",
               "greek": [
                  {
                     "_BETA": "A)QE/MITOS",
                     "_unicode": "ἀθέμιτος",
                     "_translit": "athémitos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath-em'-ee-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "QE/MIS",
                        "_unicode": "θέμις",
                        "_translit": "thémis"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n (statute;\n from the base of \n);"
               },
               "strongs_def": "illegal; by implication,\n flagitious",
               "kjv_def": ":--abominable, unlawful thing.",
               "_strongs": "00111"
            },
            {
               "strongs": "112",
               "greek": [
                  {
                     "_BETA": "A)/QEOS",
                     "_unicode": "ἄθεος",
                     "_translit": "átheos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath'-eh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "godless",
               "kjv_def": ":--without God.",
               "_strongs": "00112"
            },
            {
               "strongs": "113",
               "greek": [
                  {
                     "_BETA": "A)/QESMOS",
                     "_unicode": "ἄθεσμος",
                     "_translit": "áthesmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath'-es-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n (in the sense\n of enacting);"
               },
               "strongs_def": "lawless, i.e. (by implication) criminal",
               "kjv_def": ":--wicked.",
               "_strongs": "00113"
            },
            {
               "strongs": "114",
               "greek": [
                  {
                     "_BETA": "A)QETE/W",
                     "_unicode": "ἀθετέω",
                     "_translit": "athetéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath-et-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and a derivative of\n \n;"
               },
               "strongs_def": "to set aside, i.e. (by implication) to disesteem, neutralize or\n violate",
               "kjv_def": ":--cast off, despise, disannul, frustrate, bring to nought,\n reject.",
               "_strongs": "00114"
            },
            {
               "strongs": "115",
               "greek": [
                  {
                     "_BETA": "A)QE/THSIS",
                     "_unicode": "ἀθέτησις",
                     "_translit": "athétēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath-et'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "114"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cancellation (literally or figuratively)",
               "kjv_def": ":--disannulling, put\n away.",
               "_strongs": "00115"
            },
            {
               "strongs": "116",
               "greek": [
                  {
                     "_BETA": "*)AQH=NAI",
                     "_unicode": "Ἀθῆναι",
                     "_translit": "Athēnai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath-ay-nahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)AQH/NH",
                        "_unicode": "Ἀθήνη",
                        "_translit": "Athḗnē"
                     }
                  ],
                  "__text": "plural of \n (the goddess of wisdom, who was reputed to have\n founded the city);"
               },
               "strongs_def": "Athenæ, the capitol of Greece",
               "kjv_def": ":-- Athens.",
               "_strongs": "00116"
            },
            {
               "strongs": "117",
               "greek": [
                  {
                     "_BETA": "*)AQHNAI=OS",
                     "_unicode": "Ἀθηναῖος",
                     "_translit": "Athēnaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath-ay-nah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "116"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an Athenæan or inhabitant of Athenæ",
               "kjv_def": ":--Athenian.",
               "_strongs": "00117"
            },
            {
               "strongs": "118",
               "greek": [
                  {
                     "_BETA": "A)QLE/W",
                     "_unicode": "ἀθλέω",
                     "_translit": "athléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/QLOS",
                        "_unicode": "ἄθλος",
                        "_translit": "áthlos"
                     }
                  ],
                  "__text": "from \n (a contest in the public lists);"
               },
               "strongs_def": "to contend in the\n competitive games",
               "kjv_def": ":--strive.",
               "_strongs": "00118"
            },
            {
               "strongs": "119",
               "greek": [
                  {
                     "_BETA": "A)/QLHSIS",
                     "_unicode": "ἄθλησις",
                     "_translit": "áthlēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath'-lay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "118"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a struggle (figuratively)",
               "kjv_def": ":--fight.",
               "_strongs": "00119"
            },
            {
               "strongs": "120",
               "greek": [
                  {
                     "_BETA": "A)QUME/W",
                     "_unicode": "ἀθυμέω",
                     "_translit": "athyméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath-oo-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and \n;"
               },
               "strongs_def": "to be\n spiritless, i.e. disheartened",
               "kjv_def": ":--be dismayed.",
               "_strongs": "00120"
            },
            {
               "strongs": "121",
               "greek": [
                  {
                     "_BETA": "A)/QWOS",
                     "_unicode": "ἄθωος",
                     "_translit": "áthōos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ath'-o-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and probably a derivative of \n\n (meaning a penalty);"
               },
               "strongs_def": "not guilty",
               "kjv_def": ":--innocent.",
               "_strongs": "00121"
            },
            {
               "strongs": "122",
               "greek": [
                  {
                     "_BETA": "AI)/GEIOS",
                     "_unicode": "αἴγειος",
                     "_translit": "aígeios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-ghi-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "AI)/C",
                        "_unicode": "αἴξ",
                        "_translit": "aíx"
                     }
                  ],
                  "__text": "from \n (a goat);"
               },
               "strongs_def": "belonging to a goat",
               "kjv_def": ":--goat.",
               "_strongs": "00122"
            },
            {
               "strongs": "123",
               "greek": [
                  {
                     "_BETA": "AI)GIALO/S",
                     "_unicode": "αἰγιαλός",
                     "_translit": "aigialós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-ghee-al-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)I/+SSW",
                        "_unicode": "ἀΐσσω",
                        "_translit": "aḯssō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "from \n (to rush) and \n (in the sense of the sea);"
               },
               "strongs_def": "a beach (on\n which the waves dash)",
               "kjv_def": ":--shore.",
               "_strongs": "00123"
            },
            {
               "strongs": "124",
               "greek": [
                  {
                     "_BETA": "*AI)GU/PTIOS",
                     "_unicode": "Αἰγύπτιος",
                     "_translit": "Aigýptios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-goop'-tee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "125"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an Ægyptian or inhabitant of Ægyptus",
               "kjv_def": ":--Egyptian.",
               "_strongs": "00124"
            },
            {
               "strongs": "125",
               "greek": [
                  {
                     "_BETA": "*AI)/GUPTOS",
                     "_unicode": "Αἴγυπτος",
                     "_translit": "Aígyptos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-goop-tos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Ægyptus, the land of the Nile",
               "kjv_def": ":--Egypt.",
               "_strongs": "00125"
            },
            {
               "strongs": "126",
               "greek": [
                  {
                     "_BETA": "A)I/+DIOS",
                     "_unicode": "ἀΐδιος",
                     "_translit": "aḯdios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah-id'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "104"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "everduring (forward and backward, or forward\n only)",
               "kjv_def": ":--eternal, everlasting.",
               "_strongs": "00126"
            },
            {
               "strongs": "127",
               "greek": [
                  {
                     "_BETA": "AI)DW/S",
                     "_unicode": "αἰδώς",
                     "_translit": "aidṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-doce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "perhaps from \n (as a negative particle) and \n (through the idea of\n downcast eyes);"
               },
               "strongs_def": "bashfulness, i.e. (towards men), modesty or (towards\n God) awe",
               "kjv_def": ":--reverence, shamefacedness.",
               "_strongs": "00127"
            },
            {
               "strongs": "128",
               "greek": [
                  {
                     "_BETA": "*AI)QI/OY",
                     "_unicode": "Αἰθίοψ",
                     "_translit": "Aithíops"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-thee'-ops"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "AI)/QW",
                        "_unicode": "αἴθω",
                        "_translit": "aíthō"
                     },
                     {
                        "_BETA": "W)/Y",
                        "_unicode": "ὤψ",
                        "_translit": "ṓps"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n (to scorch) and \n (the face, from \n);"
               },
               "strongs_def": "an Æthiopian (as\n a blackamoor)",
               "kjv_def": ":--Ethiopian.",
               "_strongs": "00128"
            },
            {
               "strongs": "129",
               "greek": [
                  {
                     "_BETA": "AI(=MA",
                     "_unicode": "αἷμα",
                     "_translit": "haîma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hah'-ee-mah"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "blood, literally (of men or animals),\n figuratively (the juice of grapes) or specially (the atoning blood of\n Christ); by implication, bloodshed, also kindred",
               "kjv_def": ":--blood.",
               "_strongs": "00129"
            },
            {
               "strongs": "130",
               "greek": [
                  {
                     "_BETA": "AI(MATEKXUSI/A",
                     "_unicode": "αἱματεκχυσία",
                     "_translit": "haimatekchysía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hahee-mat-ek-khoo-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "129"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1632"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "an effusion of blood",
               "kjv_def": ":--shedding of\n blood.",
               "_strongs": "00130"
            },
            {
               "strongs": "131",
               "greek": [
                  {
                     "_BETA": "AI(MOR)R(E/W",
                     "_unicode": "αἱμοῤῥέω",
                     "_translit": "haimorrhéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hahee-mor-hreh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "129"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4482"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to flow blood, i.e. have a hæmorrhage",
               "kjv_def": ":--diseased\n with an issue of blood.",
               "_strongs": "00131"
            },
            {
               "strongs": "132",
               "greek": [
                  {
                     "_BETA": "*AI)NE/AS",
                     "_unicode": "Αἰνέας",
                     "_translit": "Ainéas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-neh'-as"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Ænĕas, an Israelite",
               "kjv_def": ":--Æneas.",
               "_strongs": "00132"
            },
            {
               "strongs": "133",
               "greek": [
                  {
                     "_BETA": "AI)/NESIS",
                     "_unicode": "αἴνεσις",
                     "_translit": "aínesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-nes-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "134"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a praising (the act), i.e. (specially) a\n thank(-offering)",
               "kjv_def": ":--praise.",
               "_strongs": "00133"
            },
            {
               "strongs": "134",
               "greek": [
                  {
                     "_BETA": "AI)NE/W",
                     "_unicode": "αἰνέω",
                     "_translit": "ainéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "136"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to praise (God)",
               "kjv_def": ":--praise.",
               "_strongs": "00134"
            },
            {
               "strongs": "135",
               "greek": [
                  {
                     "_BETA": "AI)/NIGMA",
                     "_unicode": "αἴνιγμα",
                     "_translit": "aínigma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-nig-ma"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "136"
                     }
                  ],
                  "__text": "from a derivative of \n (in its primary sense);"
               },
               "strongs_def": "an obscure saying\n (\"enigma\"), i.e. (abstractly) obscureness",
               "kjv_def": ":--X darkly.",
               "_strongs": "00135"
            },
            {
               "strongs": "136",
               "greek": [
                  {
                     "_BETA": "AI)=NOS",
                     "_unicode": "αἶνος",
                     "_translit": "aînos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-nos"
                  }
               ],
               "strongs_derivation": "apparently a prime word;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1868"
                     }
                  ],
                  "__text": "properly, a story, but used in the sense of\n \n; praise (of God)"
               },
               "kjv_def": ":--praise.",
               "_strongs": "00136"
            },
            {
               "strongs": "137",
               "greek": [
                  {
                     "_BETA": "*AI)NW/N",
                     "_unicode": "Αἰνών",
                     "_translit": "Ainṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-nohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "5869"
                     }
                  ],
                  "__text": "of Hebrew origin (a derivative of \n, place of springs);"
               },
               "strongs_def": "Ænon, a\n place in Palestine",
               "kjv_def": ":--Ænon.",
               "_strongs": "00137"
            },
            {
               "strongs": "138",
               "greek": [
                  {
                     "_BETA": "AI(RE/OMAI",
                     "_unicode": "αἱρέομαι",
                     "_translit": "hairéomai"
                  },
                  {
                     "_BETA": "E(/LLOMAI",
                     "_unicode": "ἕλλομαι",
                     "_translit": "héllomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hahee-reh'-om-ahee"
                  },
                  {
                     "_strongs": "hel'-lom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "probably akin to \n;"
               },
               "strongs_def": "to take for oneself, i.e. to prefer",
               "kjv_def": ":--choose.",
               "_strongs": "00138",
               "__text": "Some of the forms are borrowed from a cognate \n \n;\n which is otherwise obsolete."
            },
            {
               "strongs": "139",
               "greek": [
                  {
                     "_BETA": "AI(/RESIS",
                     "_unicode": "αἵρεσις",
                     "_translit": "haíresis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hah'-ee-res-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a choice, i.e. (specially) a party or (abstractly)\n disunion",
               "kjv_def": ":--heresy (which is the Greek word itself), sect.",
               "_strongs": "00139"
            },
            {
               "strongs": "140",
               "greek": [
                  {
                     "_BETA": "AI(RETI/ZW",
                     "_unicode": "αἱρετίζω",
                     "_translit": "hairetízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hahee-ret-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to make a choice",
               "kjv_def": ":--choose.",
               "_strongs": "00140"
            },
            {
               "strongs": "141",
               "greek": [
                  {
                     "_BETA": "AI(RETIKO/S",
                     "_unicode": "αἱρετικός",
                     "_translit": "hairetikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hahee-ret-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "140"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a schismatic",
               "kjv_def": ":--heretic (the Greek word itself).",
               "_strongs": "00141"
            },
            {
               "strongs": "142",
               "greek": [
                  {
                     "_BETA": "AI)/RW",
                     "_unicode": "αἴρω",
                     "_translit": "aírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-ro"
                  }
               ],
               "strongs_derivation": "a primary root;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05375"
                     }
                  ],
                  "__text": "to lift up; by implication, to take up or away;\n figuratively, to raise (the voice), keep in suspense (the mind),\n specially, to sail away (i.e. weigh anchor); by Hebraism (compare\n \n) to expiate sin"
               },
               "kjv_def": ":--away with, bear (up), carry, lift up, loose,\n make to doubt, put away, remove, take (away, up).",
               "_strongs": "00142"
            },
            {
               "strongs": "143",
               "greek": [
                  {
                     "_BETA": "AI)SQA/NOMAI",
                     "_unicode": "αἰσθάνομαι",
                     "_translit": "aisthánomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-sthan'-om-ahee"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "to apprehend (properly, by the\n senses)",
               "kjv_def": ":--perceive.",
               "_strongs": "00143"
            },
            {
               "strongs": "144",
               "greek": [
                  {
                     "_BETA": "AI)/SQHSIS",
                     "_unicode": "αἴσθησις",
                     "_translit": "aísthēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-sthay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "143"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "perception, i.e. (figuratively) discernment",
               "kjv_def": ":--judgment.",
               "_strongs": "00144"
            },
            {
               "strongs": "145",
               "greek": [
                  {
                     "_BETA": "AI)SQHTH/RION",
                     "_unicode": "αἰσθητήριον",
                     "_translit": "aisthētḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-sthay-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "143"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "properly, an organ of perception, i.e.\n (figuratively) judgment",
               "kjv_def": ":--senses.",
               "_strongs": "00145"
            },
            {
               "strongs": "146",
               "greek": [
                  {
                     "_BETA": "AI)SXROKERDH/S",
                     "_unicode": "αἰσχροκερδής",
                     "_translit": "aischrokerdḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-skhrok-er-dace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "150"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KE/RDOS",
                        "_unicode": "κέρδος",
                        "_translit": "kérdos"
                     }
                  ],
                  "__text": "from \n and \n (gain);"
               },
               "strongs_def": "sordid",
               "kjv_def": ":--given to (greedy of) filthy\n lucre.",
               "_strongs": "00146"
            },
            {
               "strongs": "147",
               "greek": [
                  {
                     "_BETA": "AI)SXROKERDW=S",
                     "_unicode": "αἰσχροκερδῶς",
                     "_translit": "aischrokerdōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-skhrok-er-doce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "146"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "sordidly",
               "kjv_def": ":--for filthy lucre's sake.",
               "_strongs": "00147"
            },
            {
               "strongs": "148",
               "greek": [
                  {
                     "_BETA": "AI)SXROLOGI/A",
                     "_unicode": "αἰσχρολογία",
                     "_translit": "aischrología"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-skhrol-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "150"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "vile conversation",
               "kjv_def": ":--filthy communication.",
               "_strongs": "00148"
            },
            {
               "strongs": "149",
               "greek": [
                  {
                     "_BETA": "AI)SXRO/N",
                     "_unicode": "αἰσχρόν",
                     "_translit": "aischrón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-skhron'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "150"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": "a shameful thing, i.e. indecorum",
               "kjv_def": ":--shame.",
               "_strongs": "00149"
            },
            {
               "strongs": "150",
               "greek": [
                  {
                     "_BETA": "AI)SXRO/S",
                     "_unicode": "αἰσχρός",
                     "_translit": "aischrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-skhros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "153"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "shameful, i.e. base (specially, venal)",
               "kjv_def": ":--filthy.",
               "_strongs": "00150"
            },
            {
               "strongs": "151",
               "greek": [
                  {
                     "_BETA": "AI)SXRO/THS",
                     "_unicode": "αἰσχρότης",
                     "_translit": "aischrótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-skhrot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "150"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "shamefulness, i.e. obscenity",
               "kjv_def": ":--filthiness.",
               "_strongs": "00151"
            },
            {
               "strongs": "152",
               "greek": [
                  {
                     "_BETA": "AI)SXU/NH",
                     "_unicode": "αἰσχύνη",
                     "_translit": "aischýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-skhoo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "153"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "shame or disgrace (abstractly or concretely)",
               "kjv_def": ":--dishonesty,\n shame.",
               "_strongs": "00152"
            },
            {
               "strongs": "153",
               "greek": [
                  {
                     "_BETA": "AI)SXU/NOMAI",
                     "_unicode": "αἰσχύνομαι",
                     "_translit": "aischýnomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-skhoo'-nom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "AI)=SXOS",
                        "_unicode": "αἶσχος",
                        "_translit": "aîschos"
                     }
                  ],
                  "__text": "from \n (disfigurement, i.e. disgrace);"
               },
               "strongs_def": "to feel shame (for\n oneself)",
               "kjv_def": ":--be ashamed.",
               "_strongs": "00153"
            },
            {
               "strongs": "154",
               "greek": [
                  {
                     "_BETA": "AI)TE/W",
                     "_unicode": "αἰτέω",
                     "_translit": "aitéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-teh'-o"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "to ask (in genitive case)",
               "kjv_def": ":--ask, beg, call\n for, crave, desire, require.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4441"
                  }
               ],
               "_strongs": "00154",
               "__text": "Compare \n."
            },
            {
               "strongs": "155",
               "greek": [
                  {
                     "_BETA": "AI)/THMA",
                     "_unicode": "αἴτημα",
                     "_translit": "aítēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-tay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a thing asked or (abstractly) an asking",
               "kjv_def": ":--petition, request,\n required.",
               "_strongs": "00155"
            },
            {
               "strongs": "156",
               "greek": [
                  {
                     "_BETA": "AI)TI/A",
                     "_unicode": "αἰτία",
                     "_translit": "aitía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-tee'-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a cause (as if asked for), i.e. (logical) reason\n (motive, matter), (legal) crime (alleged or proved)",
               "kjv_def": ":--accusation,\n case, cause, crime, fault, (wh-)ere(-fore).",
               "_strongs": "00156"
            },
            {
               "strongs": "157",
               "greek": [
                  {
                     "_BETA": "AI)TI/AMA",
                     "_unicode": "αἰτίαμα",
                     "_translit": "aitíama"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-tee'-am-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "156"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a thing charged",
               "kjv_def": ":--complaint.",
               "_strongs": "00157"
            },
            {
               "strongs": "158",
               "greek": [
                  {
                     "_BETA": "AI)/TION",
                     "_unicode": "αἴτιον",
                     "_translit": "aítion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-tee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "159"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "156"
                     }
                  ],
                  "__text": "a reason or crime (like \n)"
               },
               "kjv_def": ":--cause, fault.",
               "_strongs": "00158"
            },
            {
               "strongs": "159",
               "greek": [
                  {
                     "_BETA": "AI)/TIOS",
                     "_unicode": "αἴτιος",
                     "_translit": "aítios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah'-ee-tee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "causative, i.e. (concretely) a causer",
               "kjv_def": ":--author.",
               "_strongs": "00159"
            },
            {
               "strongs": "160",
               "greek": [
                  {
                     "_BETA": "AI)FNI/DIOS",
                     "_unicode": "αἰφνίδιος",
                     "_translit": "aiphnídios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "aheef-nid'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1810"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and \n (compare \n)\n (meaning non-apparent);"
               },
               "strongs_def": "unexpected, i.e. (adverbially)\n suddenly",
               "kjv_def": ":--sudden, unawares.",
               "_strongs": "00160"
            },
            {
               "strongs": "161",
               "greek": [
                  {
                     "_BETA": "AI)XMALWSI/A",
                     "_unicode": "αἰχμαλωσία",
                     "_translit": "aichmalōsía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "aheekh-mal-o-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "164"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "captivity",
               "kjv_def": ":--captivity.",
               "_strongs": "00161"
            },
            {
               "strongs": "162",
               "greek": [
                  {
                     "_BETA": "AI)XMALWTEU/W",
                     "_unicode": "αἰχμαλωτεύω",
                     "_translit": "aichmalōteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "aheekh-mal-o-tew'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "164"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "163"
                     }
                  ],
                  "__text": "to capture (like \n)"
               },
               "kjv_def": ":--lead captive.",
               "_strongs": "00162"
            },
            {
               "strongs": "163",
               "greek": [
                  {
                     "_BETA": "AI)XMALWTI/ZW",
                     "_unicode": "αἰχμαλωτίζω",
                     "_translit": "aichmalōtízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "aheekh-mal-o-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "164"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make captive",
               "kjv_def": ":--lead away captive, bring into captivity.",
               "_strongs": "00163"
            },
            {
               "strongs": "164",
               "greek": [
                  {
                     "_BETA": "AI)XMA/LWTOS",
                     "_unicode": "αἰχμάλωτος",
                     "_translit": "aichmálōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "aheekh-mal-o-tos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "AI)XMH/",
                        "_unicode": "αἰχμή",
                        "_translit": "aichmḗ"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "259"
                     }
                  ],
                  "__text": "from \n (a spear) and a derivative of the same as \n;"
               },
               "strongs_def": "properly, a\n prisoner of war, i.e. (genitive case) a captive",
               "kjv_def": ":--captive.",
               "_strongs": "00164"
            },
            {
               "strongs": "165",
               "greek": [
                  {
                     "_BETA": "AI)W/N",
                     "_unicode": "αἰών",
                     "_translit": "aiṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-ohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "104"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "properly, an age; by extension, perpetuity (also\n past); by implication, the world; specially (Jewish) a Messianic\n period (present or future)",
               "kjv_def": ":--age, course, eternal, (for) ever(-more),\n (n-)ever, (beginning of the , while the) world (began, without end).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5550"
                  }
               ],
               "_strongs": "00165",
               "__text": "Compare \n."
            },
            {
               "strongs": "166",
               "greek": [
                  {
                     "_BETA": "AI)W/NIOS",
                     "_unicode": "αἰώνιος",
                     "_translit": "aiṓnios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ahee-o'-nee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "165"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "perpetual (also used of past time, or past and future as\n well)",
               "kjv_def": ":--eternal, for ever, everlasting, world (began).",
               "_strongs": "00166"
            },
            {
               "strongs": "167",
               "greek": [
                  {
                     "_BETA": "A)KAQARSI/A",
                     "_unicode": "ἀκαθαρσία",
                     "_translit": "akatharsía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ath-ar-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "169"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "impurity (the quality), physically or morally",
               "kjv_def": ":--uncleanness.",
               "_strongs": "00167"
            },
            {
               "strongs": "168",
               "greek": [
                  {
                     "_BETA": "A)KAQA/RTHS",
                     "_unicode": "ἀκαθάρτης",
                     "_translit": "akathártēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ath-ar'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "169"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "impurity (the state), morally",
               "kjv_def": ":--filthiness.",
               "_strongs": "00168"
            },
            {
               "strongs": "169",
               "greek": [
                  {
                     "_BETA": "A)KA/QARTOS",
                     "_unicode": "ἀκάθαρτος",
                     "_translit": "akáthartos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ath'-ar-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2508"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n\n (meaning cleansed);"
               },
               "strongs_def": "impure (ceremonially, morally (lewd) or specially,\n (demonic))",
               "kjv_def": ":--foul, unclean.",
               "_strongs": "00169"
            },
            {
               "strongs": "170",
               "greek": [
                  {
                     "_BETA": "A)KAIRE/OMAI",
                     "_unicode": "ἀκαιρέομαι",
                     "_translit": "akairéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ahee-reh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2540"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and \n (meaning\n unseasonable);"
               },
               "strongs_def": "to be inopportune (for oneself), i.e. to fail of a\n proper occasion",
               "kjv_def": ":--lack opportunity.",
               "_strongs": "00170"
            },
            {
               "strongs": "171",
               "greek": [
                  {
                     "_BETA": "A)KAI/RWS",
                     "_unicode": "ἀκαίρως",
                     "_translit": "akaírōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ah'-ee-roce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "170"
                     }
                  ],
                  "__text": "adverb from the same as \n;"
               },
               "strongs_def": "inopportunely",
               "kjv_def": ":--out of season.",
               "_strongs": "00171"
            },
            {
               "strongs": "172",
               "greek": [
                  {
                     "_BETA": "A)/KAKOS",
                     "_unicode": "ἄκακος",
                     "_translit": "ákakos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak'-ak-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "not bad, i.e. (objectively)\n innocent or (subjectively) unsuspecting",
               "kjv_def": ":--harmless, simple.",
               "_strongs": "00172"
            },
            {
               "strongs": "173",
               "greek": [
                  {
                     "_BETA": "A)/KANQA",
                     "_unicode": "ἄκανθα",
                     "_translit": "ákantha"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak'-an-thah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "188"
                     }
                  ],
                  "__text": "probably from the same as \n;"
               },
               "strongs_def": "a thorn",
               "kjv_def": ":--thorn.",
               "_strongs": "00173"
            },
            {
               "strongs": "174",
               "greek": [
                  {
                     "_BETA": "A)KA/NQINOS",
                     "_unicode": "ἀκάνθινος",
                     "_translit": "akánthinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-an'-thee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "173"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "thorny",
               "kjv_def": ":--of thorns.",
               "_strongs": "00174"
            },
            {
               "strongs": "175",
               "greek": [
                  {
                     "_BETA": "A)/KARPOS",
                     "_unicode": "ἄκαρπος",
                     "_translit": "ákarpos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak'-ar-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2590"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "barren (literally or\n figuratively)",
               "kjv_def": ":--without fruit, unfruitful.",
               "_strongs": "00175"
            },
            {
               "strongs": "176",
               "greek": [
                  {
                     "_BETA": "A)KATA/GNWSTOS",
                     "_unicode": "ἀκατάγνωστος",
                     "_translit": "akatágnōstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-at-ag'-noce-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2607"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unblamable",
               "kjv_def": ":--that cannot be condemned.",
               "_strongs": "00176"
            },
            {
               "strongs": "177",
               "greek": [
                  {
                     "_BETA": "A)KATAKA/LUPTOS",
                     "_unicode": "ἀκατακάλυπτος",
                     "_translit": "akatakályptos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-at-ak-al'-oop-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of a compound of \n\n and \n;"
               },
               "strongs_def": "unveiled",
               "kjv_def": ":--uncovered.",
               "_strongs": "00177"
            },
            {
               "strongs": "178",
               "greek": [
                  {
                     "_BETA": "A)KATA/KRITOS",
                     "_unicode": "ἀκατάκριτος",
                     "_translit": "akatákritos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-at-ak'-ree-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2632"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "without\n (legal) trial",
               "kjv_def": ":--uncondemned.",
               "_strongs": "00178"
            },
            {
               "strongs": "179",
               "greek": [
                  {
                     "_BETA": "A)KATA/LUTOS",
                     "_unicode": "ἀκατάλυτος",
                     "_translit": "akatálytos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-at-al'-oo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2647"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "indissoluble, i.e. (figuratively) permanent",
               "kjv_def": ":--endless.",
               "_strongs": "00179"
            },
            {
               "strongs": "180",
               "greek": [
                  {
                     "_BETA": "A)KATA/PAUSTOS",
                     "_unicode": "ἀκατάπαυστος",
                     "_translit": "akatápaustos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-at-ap'-ow-stos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2664"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unrefraining",
               "kjv_def": ":--that cannot cease.",
               "_strongs": "00180"
            },
            {
               "strongs": "181",
               "greek": [
                  {
                     "_BETA": "A)KATASTASI/A",
                     "_unicode": "ἀκαταστασία",
                     "_translit": "akatastasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-at-as-tah-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "182"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "instability, i.e. disorder",
               "kjv_def": ":--commotion, confusion, tumult.",
               "_strongs": "00181"
            },
            {
               "strongs": "182",
               "greek": [
                  {
                     "_BETA": "A)KATA/STATOS",
                     "_unicode": "ἀκατάστατος",
                     "_translit": "akatástatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-at-as'-tat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2525"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "inconstant",
               "kjv_def": ":--unstable.",
               "_strongs": "00182"
            },
            {
               "strongs": "183",
               "greek": [
                  {
                     "_BETA": "A)KATA/SXETOS",
                     "_unicode": "ἀκατάσχετος",
                     "_translit": "akatáschetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-at-as'-khet-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2722"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unrestrainable",
               "kjv_def": ":--unruly.",
               "_strongs": "00183"
            },
            {
               "strongs": "184",
               "greek": [
                  {
                     "_BETA": "*)AKELDAMA/",
                     "_unicode": "Ἀκελδαμά",
                     "_translit": "Akeldamá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-el-dam-ah'"
                  }
               ],
               "strongs_derivation": "of Chaldee origin (meaning field of blood;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02506"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "01818"
                     }
                  ],
                  "__text": "corresponding to \n and\n \n); Akeldama, a place near Jerusalem"
               },
               "kjv_def": ":--Aceldama.",
               "_strongs": "00184"
            },
            {
               "strongs": "185",
               "greek": [
                  {
                     "_BETA": "A)KE/RAIOS",
                     "_unicode": "ἀκέραιος",
                     "_translit": "akéraios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-er'-ah-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2767"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "unmixed, i.e. (figuratively) innocent",
               "kjv_def": ":--harmless, simple.",
               "_strongs": "00185"
            },
            {
               "strongs": "186",
               "greek": [
                  {
                     "_BETA": "A)KLINH/S",
                     "_unicode": "ἀκλινής",
                     "_translit": "aklinḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-lee-nace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "not leaning, i.e.\n (figuratively) firm",
               "kjv_def": ":--without wavering.",
               "_strongs": "00186"
            },
            {
               "strongs": "187",
               "greek": [
                  {
                     "_BETA": "A)KMA/ZW",
                     "_unicode": "ἀκμάζω",
                     "_translit": "akmázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-mad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "188"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to make a point, i.e. (figuratively) mature",
               "kjv_def": ":--be\n fully ripe.",
               "_strongs": "00187"
            },
            {
               "strongs": "188",
               "greek": [
                  {
                     "_BETA": "A)KMH/N",
                     "_unicode": "ἀκμήν",
                     "_translit": "akmḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-mane'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)KH/",
                        "_unicode": "ἀκή",
                        "_translit": "akḗ"
                     }
                  ],
                  "__text": "accusative case of a noun (\"acme\") akin to \n (a point) and meaning\n the same;"
               },
               "strongs_def": "adverbially, just now, i.e. still",
               "kjv_def": ":--yet.",
               "_strongs": "00188"
            },
            {
               "strongs": "189",
               "greek": [
                  {
                     "_BETA": "A)KOH/",
                     "_unicode": "ἀκοή",
                     "_translit": "akoḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-o-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "191"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "hearing (the act, the sense or the thing heard)",
               "kjv_def": ":--audience,\n ear, fame, which ye heard, hearing, preached, report, rumor.",
               "_strongs": "00189"
            },
            {
               "strongs": "190",
               "greek": [
                  {
                     "_BETA": "A)KOLOUQE/W",
                     "_unicode": "ἀκολουθέω",
                     "_translit": "akolouthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ol-oo-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KE/LEUQOS",
                        "_unicode": "κέλευθος",
                        "_translit": "kéleuthos"
                     }
                  ],
                  "__text": "from \n (as a particle of union) and \n (a road);"
               },
               "strongs_def": "properly, to\n be in the same way with, i.e. to accompany (specially, as a\n disciple)",
               "kjv_def": ":--follow, reach.",
               "_strongs": "00190"
            },
            {
               "strongs": "191",
               "greek": [
                  {
                     "_BETA": "A)KOU/W",
                     "_unicode": "ἀκούω",
                     "_translit": "akoúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-oo'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to hear (in various senses)",
               "kjv_def": ":--give (in the) audience\n (of), come (to the ears), (shall) hear(-er, -ken), be noised, be\n reported, understand.",
               "_strongs": "00191"
            },
            {
               "strongs": "192",
               "greek": [
                  {
                     "_BETA": "A)KRASI/A",
                     "_unicode": "ἀκρασία",
                     "_translit": "akrasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ras-ee'-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "193"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "want of self-restraint",
               "kjv_def": ":--excess, incontinency.",
               "_strongs": "00192"
            },
            {
               "strongs": "193",
               "greek": [
                  {
                     "_BETA": "A)KRATH/S",
                     "_unicode": "ἀκρατής",
                     "_translit": "akratḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-rat'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "powerless, i.e. without\n self-control",
               "kjv_def": ":--incontinent.",
               "_strongs": "00193"
            },
            {
               "strongs": "194",
               "greek": [
                  {
                     "_BETA": "A)/KRATOS",
                     "_unicode": "ἄκρατος",
                     "_translit": "ákratos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak'-rat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2767"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "undiluted",
               "kjv_def": ":--without mixture.",
               "_strongs": "00194"
            },
            {
               "strongs": "195",
               "greek": [
                  {
                     "_BETA": "A)KRI/BEIA",
                     "_unicode": "ἀκρίβεια",
                     "_translit": "akríbeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ree'-bi-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "196"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "exactness",
               "kjv_def": ":--perfect manner.",
               "_strongs": "00195"
            },
            {
               "strongs": "196",
               "greek": [
                  {
                     "_BETA": "A)KRIBE/STATOS",
                     "_unicode": "ἀκριβέστατος",
                     "_translit": "akribéstatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ree-bes'-ta-tos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)KRI/BHS",
                        "_unicode": "ἀκρίβης",
                        "_translit": "akríbēs"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "206"
                     }
                  ],
                  "__text": "superlative of \n (a derivative of the same as \n);"
               },
               "strongs_def": "most\n exact",
               "kjv_def": ":--most straitest.",
               "_strongs": "00196"
            },
            {
               "strongs": "197",
               "greek": [
                  {
                     "_BETA": "A)KRIBE/STERON",
                     "_unicode": "ἀκριβέστερον",
                     "_translit": "akribésteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ree-bes'-ter-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "196"
                     }
                  ],
                  "__text": "neuter of the comparative of the same as \n;"
               },
               "strongs_def": "(adverbially) more\n exactly",
               "kjv_def": ":--more perfect(-ly).",
               "_strongs": "00197"
            },
            {
               "strongs": "198",
               "greek": [
                  {
                     "_BETA": "A)KRIBO/W",
                     "_unicode": "ἀκριβόω",
                     "_translit": "akribóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ree-bo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "196"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to be exact, i.e. ascertain",
               "kjv_def": ":--enquire\n diligently.",
               "_strongs": "00198"
            },
            {
               "strongs": "199",
               "greek": [
                  {
                     "_BETA": "A)KRIBW=S",
                     "_unicode": "ἀκριβῶς",
                     "_translit": "akribōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ree-boce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "196"
                     }
                  ],
                  "__text": "adverb from the same as \n;"
               },
               "strongs_def": "exactly",
               "kjv_def": ":--circumspectly, diligently,\n perfect(-ly).",
               "_strongs": "00199"
            },
            {
               "strongs": "200",
               "greek": [
                  {
                     "_BETA": "A)KRI/S",
                     "_unicode": "ἀκρίς",
                     "_translit": "akrís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-rece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "206"
                     }
                  ],
                  "__text": "apparently from the same as \n;"
               },
               "strongs_def": "a locust (as pointed, or as lighting\n on the top of vegetation)",
               "kjv_def": ":--locust.",
               "_strongs": "00200"
            },
            {
               "strongs": "201",
               "greek": [
                  {
                     "_BETA": "A)KROATH/RION",
                     "_unicode": "ἀκροατήριον",
                     "_translit": "akroatḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ro-at-ay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "202"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an audience-room",
               "kjv_def": ":--place of hearing.",
               "_strongs": "00201"
            },
            {
               "strongs": "202",
               "greek": [
                  {
                     "_BETA": "A)KROATH/S",
                     "_unicode": "ἀκροατής",
                     "_translit": "akroatḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-ro-at-ace'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)KROA/OMAI",
                        "_unicode": "ἀκροάομαι",
                        "_translit": "akroáomai"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "191"
                     }
                  ],
                  "__text": "from \n (to listen; apparently an intensive of \n);"
               },
               "strongs_def": "a hearer\n (merely)",
               "kjv_def": ":--hearer.",
               "_strongs": "00202"
            },
            {
               "strongs": "203",
               "greek": [
                  {
                     "_BETA": "A)KROBUSTI/A",
                     "_unicode": "ἀκροβυστία",
                     "_translit": "akrobystía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-rob-oos-tee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "206"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "PO/SQH",
                        "_unicode": "πόσθη",
                        "_translit": "pósthē"
                     }
                  ],
                  "__text": "from \n and probably a modified form of \n (the penis or male\n sexual organ);"
               },
               "strongs_def": "the prepuce; by implication, an uncircumcised (i.e.\n gentile, figuratively, unregenerate) state or person",
               "kjv_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": ":--not\n circumcised, uncircumcised (with \n), uncircumcision."
               },
               "_strongs": "00203"
            },
            {
               "strongs": "204",
               "greek": [
                  {
                     "_BETA": "A)KROGWNIAI=OS",
                     "_unicode": "ἀκρογωνιαῖος",
                     "_translit": "akrogōniaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-rog-o-nee-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "206"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1137"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "belonging to the extreme corner",
               "kjv_def": ":--chief corner.",
               "_strongs": "00204"
            },
            {
               "strongs": "205",
               "greek": [
                  {
                     "_BETA": "A)KROQI/NION",
                     "_unicode": "ἀκροθίνιον",
                     "_translit": "akrothínion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-roth-in'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "206"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "QI/S",
                        "_unicode": "θίς",
                        "_translit": "thís"
                     }
                  ],
                  "__text": "from \n and \n (a heap);"
               },
               "strongs_def": "properly (in the plural) the top of the\n heap, i.e. (by implication) best of the booty",
               "kjv_def": ":--spoils.",
               "_strongs": "00205"
            },
            {
               "strongs": "206",
               "greek": [
                  {
                     "_BETA": "A)/KRON",
                     "_unicode": "ἄκρον",
                     "_translit": "ákron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak'-ron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "188"
                     }
                  ],
                  "__text": "neuter of an adjective probably akin to the base of \n;"
               },
               "strongs_def": "the\n extremity",
               "kjv_def": ":--one end… other, tip, top, uttermost part.",
               "_strongs": "00206"
            },
            {
               "strongs": "207",
               "greek": [
                  {
                     "_BETA": "*)AKU/LAS",
                     "_unicode": "Ἀκύλας",
                     "_translit": "Akýlas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-oo'-las"
                  }
               ],
               "strongs_derivation": {
                  "latin": "aquila",
                  "__text": "probably for Latin \n (an eagle);"
               },
               "strongs_def": "Akulas, an Israelite",
               "kjv_def": ":--Aquila.",
               "_strongs": "00207"
            },
            {
               "strongs": "208",
               "greek": [
                  {
                     "_BETA": "A)KURO/W",
                     "_unicode": "ἀκυρόω",
                     "_translit": "akyróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-oo-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2964"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "to invalidate",
               "kjv_def": ":--disannul,\n make of none effect.",
               "_strongs": "00208"
            },
            {
               "strongs": "209",
               "greek": [
                  {
                     "_BETA": "A)KWLU/TWS",
                     "_unicode": "ἀκωλύτως",
                     "_translit": "akōlýtōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak-o-loo'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2967"
                     }
                  ],
                  "__text": "adverb from a compound of \n (as a negative particle) and a derivative\n of \n;"
               },
               "strongs_def": "in an unhindered manner, i.e. freely",
               "kjv_def": ":--no man forbidding him.",
               "_strongs": "00209"
            },
            {
               "strongs": "210",
               "greek": [
                  {
                     "_BETA": "A)/KWN",
                     "_unicode": "ἄκων",
                     "_translit": "ákōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ak'-ohn"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1635"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unwilling",
               "kjv_def": ":--against the\n will.",
               "_strongs": "00210"
            },
            {
               "strongs": "211",
               "greek": [
                  {
                     "_BETA": "A)LA/BASTRON",
                     "_unicode": "ἀλάβαστρον",
                     "_translit": "alábastron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ab'-as-tron"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)LA/BASTROS",
                        "_unicode": "ἀλάβαστρος",
                        "_translit": "alábastros"
                     }
                  ],
                  "__text": "neuter of \n (of uncertain derivation), the name of a stone;"
               },
               "strongs_def": "properly, an \"alabaster\" box, i.e. (by extension) a perfume vase (of\n any material)",
               "kjv_def": ":--(alabaster) box.",
               "_strongs": "00211"
            },
            {
               "strongs": "212",
               "greek": [
                  {
                     "_BETA": "A)LAZONEI/A",
                     "_unicode": "ἀλαζονεία",
                     "_translit": "alazoneía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ad-zon-i'-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "213"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "braggadocio, i.e. (by implication)\n self-confidence",
               "kjv_def": ":--boasting, pride.",
               "_strongs": "00212"
            },
            {
               "strongs": "213",
               "greek": [
                  {
                     "_BETA": "A)LAZW/N",
                     "_unicode": "ἀλαζών",
                     "_translit": "alazṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ad-zone'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/LH",
                        "_unicode": "ἄλη",
                        "_translit": "álē"
                     }
                  ],
                  "__text": "from \n (vagrancy);"
               },
               "strongs_def": "braggart",
               "kjv_def": ":--boaster.",
               "_strongs": "00213"
            },
            {
               "strongs": "214",
               "greek": [
                  {
                     "_BETA": "A)LALA/ZW",
                     "_unicode": "ἀλαλάζω",
                     "_translit": "alalázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-al-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)LALH/",
                        "_unicode": "ἀλαλή",
                        "_translit": "alalḗ"
                     }
                  ],
                  "__text": "from \n ( a shout, \"halloo\");"
               },
               "strongs_def": "to vociferate, i.e. (by implication)\n to wail; figuratively, to clang",
               "kjv_def": ":--tinkle, wail.",
               "_strongs": "00214"
            },
            {
               "strongs": "215",
               "greek": [
                  {
                     "_BETA": "A)LA/LHTOS",
                     "_unicode": "ἀλάλητος",
                     "_translit": "alálētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-al'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unspeakable",
               "kjv_def": ":--unutterable, which cannot be uttered.",
               "_strongs": "00215"
            },
            {
               "strongs": "216",
               "greek": [
                  {
                     "_BETA": "A)/LALOS",
                     "_unicode": "ἄλαλος",
                     "_translit": "álalos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al'-al-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "mute",
               "kjv_def": ":--dumb.",
               "_strongs": "00216"
            },
            {
               "strongs": "217",
               "greek": [
                  {
                     "_BETA": "A(/LAS",
                     "_unicode": "ἅλας",
                     "_translit": "hálas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "salt; figuratively, prudence",
               "kjv_def": ":--salt.",
               "_strongs": "00217"
            },
            {
               "strongs": "218",
               "greek": [
                  {
                     "_BETA": "A)LEI/FW",
                     "_unicode": "ἀλείφω",
                     "_translit": "aleíphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-i'-fo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3045"
                     }
                  ],
                  "__text": "from \n (as particle of union) and the base of \n;"
               },
               "strongs_def": "to oil (with\n perfume)",
               "kjv_def": ":--anoint.",
               "_strongs": "00218"
            },
            {
               "strongs": "219",
               "greek": [
                  {
                     "_BETA": "A)LEKTOROFWNI/A",
                     "_unicode": "ἀλεκτοροφωνία",
                     "_translit": "alektorophōnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ek-tor-of-o-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "220"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5456"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "cock-crow, i.e. the third\n night-watch",
               "kjv_def": ":--cockcrowing.",
               "_strongs": "00219"
            },
            {
               "strongs": "220",
               "greek": [
                  {
                     "_BETA": "A)LE/KTWR",
                     "_unicode": "ἀλέκτωρ",
                     "_translit": "aléktōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ek'-tore"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)LE/KW",
                        "_unicode": "ἀλέκω",
                        "_translit": "alékō"
                     }
                  ],
                  "__text": "from \n (to ward off);"
               },
               "strongs_def": "a cock or male fowl",
               "kjv_def": ":--cock.",
               "_strongs": "00220"
            },
            {
               "strongs": "221",
               "greek": [
                  {
                     "_BETA": "*)ALECANDREU/S",
                     "_unicode": "Ἀλεξανδρεύς",
                     "_translit": "Alexandreús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ex-and-reuce'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)ALECA/NDREIA",
                        "_unicode": "Ἀλεξάνδρεια",
                        "_translit": "Alexándreia"
                     }
                  ],
                  "__text": "from \n (the city so called);"
               },
               "strongs_def": "an Alexandreian or inhabitant\n of Alexandria",
               "kjv_def": ":--of Alexandria, Alexandrian.",
               "_strongs": "00221"
            },
            {
               "strongs": "222",
               "greek": [
                  {
                     "_BETA": "*)ALECANDRI=NOS",
                     "_unicode": "Ἀλεξανδρῖνος",
                     "_translit": "Alexandrînos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ex-an-dree'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "221"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "Alexandrine, or belonging to Alexandria",
               "kjv_def": ":--of\n Alexandria.",
               "_strongs": "00222"
            },
            {
               "strongs": "223",
               "greek": [
                  {
                     "_BETA": "*)ALE/CANDROS",
                     "_unicode": "Ἀλέξανδρος",
                     "_translit": "Aléxandros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ex'-an-dros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "220"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     }
                  ],
                  "__text": "from the same as (the first part of) \n and \n;"
               },
               "strongs_def": "man-defender;\n Alexander, the name of three Israelites and one other man",
               "kjv_def": ":--Alexander.",
               "_strongs": "00223"
            },
            {
               "strongs": "224",
               "greek": [
                  {
                     "_BETA": "A)/LEURON",
                     "_unicode": "ἄλευρον",
                     "_translit": "áleuron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al'-yoo-ron"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)LE/W",
                        "_unicode": "ἀλέω",
                        "_translit": "aléō"
                     }
                  ],
                  "__text": "from \n(to grind);"
               },
               "strongs_def": "flour",
               "kjv_def": ":--meal.",
               "_strongs": "00224"
            },
            {
               "strongs": "225",
               "greek": [
                  {
                     "_BETA": "A)LH/QEIA",
                     "_unicode": "ἀλήθεια",
                     "_translit": "alḗtheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ay'-thi-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "227"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "truth",
               "kjv_def": ":--true, X truly, truth, verity.",
               "_strongs": "00225"
            },
            {
               "strongs": "226",
               "greek": [
                  {
                     "_BETA": "A)LHQEU/W",
                     "_unicode": "ἀληθεύω",
                     "_translit": "alētheúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ayth-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "227"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be true (in doctrine and profession)",
               "kjv_def": ":--speak (tell) the\n truth.",
               "_strongs": "00226"
            },
            {
               "strongs": "227",
               "greek": [
                  {
                     "_BETA": "A)LHQH/S",
                     "_unicode": "ἀληθής",
                     "_translit": "alēthḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ay-thace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2990"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "true (as not\n concealing)",
               "kjv_def": ":--true, truly, truth.",
               "_strongs": "00227"
            },
            {
               "strongs": "228",
               "greek": [
                  {
                     "_BETA": "A)LHQINO/S",
                     "_unicode": "ἀληθινός",
                     "_translit": "alēthinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ay-thee-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "227"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "truthful",
               "kjv_def": ":--true.",
               "_strongs": "00228"
            },
            {
               "strongs": "229",
               "greek": [
                  {
                     "_BETA": "A)LH/QW",
                     "_unicode": "ἀλήθω",
                     "_translit": "alḗthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ay'-tho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "224"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to grind",
               "kjv_def": ":--grind.",
               "_strongs": "00229"
            },
            {
               "strongs": "230",
               "greek": [
                  {
                     "_BETA": "A)LHQW=S",
                     "_unicode": "ἀληθῶς",
                     "_translit": "alēthōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-ay-thoce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "227"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "truly",
               "kjv_def": ":--indeed, surely, of a surety, truly, of a (in)\n truth, verily, very.",
               "_strongs": "00230"
            },
            {
               "strongs": "231",
               "greek": [
                  {
                     "_BETA": "A(LIEU/S",
                     "_unicode": "ἁλιεύς",
                     "_translit": "halieús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal-ee-yoos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sailor (as engaged on the salt water), i.e. (by\n implication) a fisher",
               "kjv_def": ":--fisher(-man).",
               "_strongs": "00231"
            },
            {
               "strongs": "232",
               "greek": [
                  {
                     "_BETA": "A(LIEU/W",
                     "_unicode": "ἁλιεύω",
                     "_translit": "halieúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal-ee-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "231"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a fisher, i.e. (by implication) to fish",
               "kjv_def": ":--go\n a-fishing.",
               "_strongs": "00232"
            },
            {
               "strongs": "233",
               "greek": [
                  {
                     "_BETA": "A(LI/ZW",
                     "_unicode": "ἁλίζω",
                     "_translit": "halízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to salt",
               "kjv_def": ":--salt.",
               "_strongs": "00233"
            },
            {
               "strongs": "234",
               "greek": [
                  {
                     "_BETA": "A)LI/SGEMA",
                     "_unicode": "ἀλίσγεμα",
                     "_translit": "alísgema"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-is'-ghem-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)LISGE/W",
                        "_unicode": "ἀλισγέω",
                        "_translit": "alisgéō"
                     }
                  ],
                  "__text": "from \n (to soil);"
               },
               "strongs_def": "(ceremonially) defilement",
               "kjv_def": ":--pollution.",
               "_strongs": "00234"
            },
            {
               "strongs": "235",
               "greek": [
                  {
                     "_BETA": "A)LLA/",
                     "_unicode": "ἀλλά",
                     "_translit": "allá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-lah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     }
                  ],
                  "__text": "neuter plural of \n;"
               },
               "strongs_def": "properly, other things, i.e. (adverbially)\n contrariwise (in many relations)",
               "kjv_def": ":--and, but (even), howbeit, indeed,\n nay, nevertheless, no, notwithstanding, save, therefore, yea, yet.",
               "_strongs": "00235"
            },
            {
               "strongs": "236",
               "greek": [
                  {
                     "_BETA": "A)LLA/SSW",
                     "_unicode": "ἀλλάσσω",
                     "_translit": "allássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-las'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make different",
               "kjv_def": ":--change.",
               "_strongs": "00236"
            },
            {
               "strongs": "237",
               "greek": [
                  {
                     "_BETA": "A)LLAXO/QEN",
                     "_unicode": "ἀλλαχόθεν",
                     "_translit": "allachóthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-lakh-oth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "from elsewhere",
               "kjv_def": ":--some other way.",
               "_strongs": "00237"
            },
            {
               "strongs": "238",
               "greek": [
                  {
                     "_BETA": "A)LLHGORE/W",
                     "_unicode": "ἀλληγορέω",
                     "_translit": "allēgoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-lay-gor-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)GORE/W",
                        "_unicode": "ἀγορέω",
                        "_translit": "agoréō"
                     }
                  ],
                  "__text": "from \n and \n (to harangue (compare \n));"
               },
               "strongs_def": "to allegorize",
               "kjv_def": ":--be an\n allegory (the Greek word itself).",
               "_strongs": "00238"
            },
            {
               "strongs": "239",
               "greek": [
                  {
                     "_BETA": "A)LLHLOUI+A",
                     "_unicode": "ἀλληλουϊα",
                     "_translit": "allēlouïa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-lay-loo'-ee-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01984"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "03050"
                     }
                  ],
                  "__text": "of Hebrew origin (imperative of \n and \n);"
               },
               "strongs_def": "praise ye Jah!, an\n adoring exclamation",
               "kjv_def": ":--alleluiah.",
               "_strongs": "00239"
            },
            {
               "strongs": "240",
               "greek": [
                  {
                     "_BETA": "A)LLH/LWN",
                     "_unicode": "ἀλλήλων",
                     "_translit": "allḗlōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-lay'-lone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     }
                  ],
                  "__text": "Genitive plural from \n reduplicated;"
               },
               "strongs_def": "one another",
               "kjv_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     }
                  ],
                  "__text": ":--each other,\n mutual, one another, (the other), (them-, your-)selves, (selves)\n together (sometimes with \n or \n)."
               },
               "_strongs": "00240"
            },
            {
               "strongs": "241",
               "greek": [
                  {
                     "_BETA": "A)LLOGENH/S",
                     "_unicode": "ἀλλογενής",
                     "_translit": "allogenḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-log-en-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1085"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "foreign, i.e. not a Jew",
               "kjv_def": ":--stranger.",
               "_strongs": "00241"
            },
            {
               "strongs": "242",
               "greek": [
                  {
                     "_BETA": "A(/LLOMAI",
                     "_unicode": "ἅλλομαι",
                     "_translit": "hállomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal'-lom-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of apparently a primary verb;",
               "strongs_def": "to jump; figuratively, to\n gush",
               "kjv_def": ":--leap, spring up.",
               "_strongs": "00242"
            },
            {
               "strongs": "243",
               "greek": [
                  {
                     "_BETA": "A)/LLOS",
                     "_unicode": "ἄλλος",
                     "_translit": "állos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al'-los"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "\"else,\" i.e. different (in many applications)",
               "kjv_def": ":--more,\n one (another), (an-, some an-)other(-s, -wise).",
               "_strongs": "00243"
            },
            {
               "strongs": "244",
               "greek": [
                  {
                     "_BETA": "A)LLOTRIEPI/SKOPOS",
                     "_unicode": "ἀλλοτριεπίσκοπος",
                     "_translit": "allotriepískopos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-lot-ree-ep-is'-kop-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "245"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1985"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "overseeing others' affairs, i.e. a meddler\n (specially, in Gentile customs)",
               "kjv_def": ":--busybody in other men's matters.",
               "_strongs": "00244"
            },
            {
               "strongs": "245",
               "greek": [
                  {
                     "_BETA": "A)LLO/TRIOS",
                     "_unicode": "ἀλλότριος",
                     "_translit": "allótrios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-lot'-ree-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "another's, i.e. not one's own; by extension foreign, not\n akin, hostile",
               "kjv_def": ":--alien, (an-)other (man's, men's), strange(-r).",
               "_strongs": "00245"
            },
            {
               "strongs": "246",
               "greek": [
                  {
                     "_BETA": "A)LLO/FULOS",
                     "_unicode": "ἀλλόφυλος",
                     "_translit": "allóphylos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-lof'-oo-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5443"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "foreign, i.e. (specially) Gentile",
               "kjv_def": ":--one of another\n nation.",
               "_strongs": "00246"
            },
            {
               "strongs": "247",
               "greek": [
                  {
                     "_BETA": "A)/LLWS",
                     "_unicode": "ἄλλως",
                     "_translit": "állōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al'-loce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "243"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "differently",
               "kjv_def": ":--otherwise.",
               "_strongs": "00247"
            },
            {
               "strongs": "248",
               "greek": [
                  {
                     "_BETA": "A)LOA/W",
                     "_unicode": "ἀλοάω",
                     "_translit": "aloáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-o-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "257"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to tread out grain",
               "kjv_def": ":--thresh, tread out the corn.",
               "_strongs": "00248"
            },
            {
               "strongs": "249",
               "greek": [
                  {
                     "_BETA": "A)/LOGOS",
                     "_unicode": "ἄλογος",
                     "_translit": "álogos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al'-og-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "irrational",
               "kjv_def": ":--brute,\n unreasonable.",
               "_strongs": "00249"
            },
            {
               "strongs": "250",
               "greek": [
                  {
                     "_BETA": "A)LO/H",
                     "_unicode": "ἀλόη",
                     "_translit": "alóē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-o-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "174"
                     }
                  ],
                  "__text": "of foreign origin (compare \n);"
               },
               "strongs_def": "aloes (the gum)",
               "kjv_def": ":--aloes.",
               "_strongs": "00250"
            },
            {
               "strongs": "251",
               "greek": [
                  {
                     "_BETA": "A(/LS",
                     "_unicode": "ἅλς",
                     "_translit": "háls"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "halce"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "\"salt\"",
               "kjv_def": ":--salt.",
               "_strongs": "00251"
            },
            {
               "strongs": "252",
               "greek": [
                  {
                     "_BETA": "A(LUKO/S",
                     "_unicode": "ἁλυκός",
                     "_translit": "halykós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal-oo-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "briny",
               "kjv_def": ":--salt.",
               "_strongs": "00252"
            },
            {
               "strongs": "253",
               "greek": [
                  {
                     "_BETA": "A)LUPO/TEROS",
                     "_unicode": "ἀλυπότερος",
                     "_translit": "alypóteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-oo-pot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3077"
                     }
                  ],
                  "__text": "comparative of a compound of \n (as a negative particle) and \n;"
               },
               "strongs_def": "more\n without grief",
               "kjv_def": ":--less sorrowful.",
               "_strongs": "00253"
            },
            {
               "strongs": "254",
               "greek": [
                  {
                     "_BETA": "A(/LUSIS",
                     "_unicode": "ἅλυσις",
                     "_translit": "hálysis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal'-oo-sis"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a fetter or manacle",
               "kjv_def": ":--bonds, chain.",
               "_strongs": "00254"
            },
            {
               "strongs": "255",
               "greek": [
                  {
                     "_BETA": "A)LUSITELH/S",
                     "_unicode": "ἀλυσιτελής",
                     "_translit": "alysitelḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-oo-sit-el-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3081"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and the base of \n;"
               },
               "strongs_def": "gainless, i.e.\n (by implication) pernicious",
               "kjv_def": ":--unprofitable.",
               "_strongs": "00255"
            },
            {
               "strongs": "256",
               "greek": [
                  {
                     "_BETA": "*)ALFAI=OS",
                     "_unicode": "Ἀλφαῖος",
                     "_translit": "Alphaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-fah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02501"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "Alphæus, an Israelite",
               "kjv_def": ":--Alpheus.",
               "_strongs": "00256"
            },
            {
               "strongs": "257",
               "greek": [
                  {
                     "_BETA": "A(/LWN",
                     "_unicode": "ἅλων",
                     "_translit": "hálōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal'-ohn"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1507"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "a threshing-floor (as rolled hard),\n i.e. (figuratively) the grain (and chaff, as just threshed)",
               "kjv_def": ":--floor.",
               "_strongs": "00257"
            },
            {
               "strongs": "258",
               "greek": [
                  {
                     "_BETA": "A)LW/PHC",
                     "_unicode": "ἀλώπηξ",
                     "_translit": "alṓpēx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "al-o'-pakes"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a fox, i.e. (figuratively) a cunning\n person",
               "kjv_def": ":--fox.",
               "_strongs": "00258"
            },
            {
               "strongs": "259",
               "greek": [
                  {
                     "_BETA": "A(/LWSIS",
                     "_unicode": "ἅλωσις",
                     "_translit": "hálōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hal'-o-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from a collateral form of \n;"
               },
               "strongs_def": "capture",
               "kjv_def": ":--be taken.",
               "_strongs": "00259"
            },
            {
               "strongs": "260",
               "greek": [
                  {
                     "_BETA": "A(/MA",
                     "_unicode": "ἅμα",
                     "_translit": "háma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ham'-ah"
                  }
               ],
               "strongs_derivation": "a primary particle;",
               "strongs_def": "properly, at the \"same\" time, but freely used as a\n preposition or adverb denoting close association",
               "kjv_def": ":--also, and,\n together, with(-al).",
               "_strongs": "00260"
            },
            {
               "strongs": "261",
               "greek": [
                  {
                     "_BETA": "A)MAQH/S",
                     "_unicode": "ἀμαθής",
                     "_translit": "amathḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ath-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3129"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "ignorant",
               "kjv_def": ":--unlearned.",
               "_strongs": "00261"
            },
            {
               "strongs": "262",
               "greek": [
                  {
                     "_BETA": "A)MARA/NTINOS",
                     "_unicode": "ἀμαράντινος",
                     "_translit": "amarántinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ar-an'-tee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "263"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "\"amaranthine\", i.e. (by implication) fadeless",
               "kjv_def": ":--that fadeth\n not away.",
               "_strongs": "00262"
            },
            {
               "strongs": "263",
               "greek": [
                  {
                     "_BETA": "A)MA/RANTOS",
                     "_unicode": "ἀμάραντος",
                     "_translit": "amárantos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ar'-an-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3133"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "unfading, i.e. (by implication) perpetual",
               "kjv_def": ":--that fadeth not away.",
               "_strongs": "00263"
            },
            {
               "strongs": "264",
               "greek": [
                  {
                     "_BETA": "A(MARTA/NW",
                     "_unicode": "ἁμαρτάνω",
                     "_translit": "hamartánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ham-ar-tan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3313"
                     }
                  ],
                  "__text": "perhaps from \n (as a negative particle) and the base of \n;"
               },
               "strongs_def": "properly, to miss the mark (and so not share in the prize), i.e.\n (figuratively) to err, especially (morally) to sin",
               "kjv_def": ":--for your faults,\n offend, sin, trespass.",
               "_strongs": "00264"
            },
            {
               "strongs": "265",
               "greek": [
                  {
                     "_BETA": "A(MA/RTHMA",
                     "_unicode": "ἁμάρτημα",
                     "_translit": "hamártēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ham-ar'-tay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "264"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sin (properly concrete)",
               "kjv_def": ":--sin.",
               "_strongs": "00265"
            },
            {
               "strongs": "266",
               "greek": [
                  {
                     "_BETA": "A(MARTI/A",
                     "_unicode": "ἁμαρτία",
                     "_translit": "hamartía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ham-ar-tee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "264"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sin (properly abstract)",
               "kjv_def": ":--offence, sin(-ful).",
               "_strongs": "00266"
            },
            {
               "strongs": "267",
               "greek": [
                  {
                     "_BETA": "A)MA/RTUROS",
                     "_unicode": "ἀμάρτυρος",
                     "_translit": "amártyros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ar'-too-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3144"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a form of \n;"
               },
               "strongs_def": "unattested",
               "kjv_def": ":--without witness.",
               "_strongs": "00267"
            },
            {
               "strongs": "268",
               "greek": [
                  {
                     "_BETA": "A(MARTWLO/S",
                     "_unicode": "ἁμαρτωλός",
                     "_translit": "hamartōlós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ham-ar-to-los'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "264"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sinful, i.e. a sinner",
               "kjv_def": ":--sinful, sinner.",
               "_strongs": "00268"
            },
            {
               "strongs": "269",
               "greek": [
                  {
                     "_BETA": "A)/MAXOS",
                     "_unicode": "ἄμαχος",
                     "_translit": "ámachos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am'-akh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3163"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "peaceable",
               "kjv_def": ":--not a brawler.",
               "_strongs": "00269"
            },
            {
               "strongs": "270",
               "greek": [
                  {
                     "_BETA": "A)MA/W",
                     "_unicode": "ἀμάω",
                     "_translit": "amáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "260"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, to collect, i.e. (by implication) reap",
               "kjv_def": ":--reap\n down.",
               "_strongs": "00270"
            },
            {
               "strongs": "271",
               "greek": [
                  {
                     "_BETA": "A)ME/QUSTOS",
                     "_unicode": "ἀμέθυστος",
                     "_translit": "améthystos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-eth'-oos-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3184"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "the\n \"amethyst\" (supposed to prevent intoxication)",
               "kjv_def": ":--amethyst.",
               "_strongs": "00271"
            },
            {
               "strongs": "272",
               "greek": [
                  {
                     "_BETA": "A)MELE/W",
                     "_unicode": "ἀμελέω",
                     "_translit": "ameléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-el-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3199"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "to be careless of",
               "kjv_def": ":--make\n light of, neglect, be negligent, no regard.",
               "_strongs": "00272"
            },
            {
               "strongs": "273",
               "greek": [
                  {
                     "_BETA": "A)/MEMPTOS",
                     "_unicode": "ἄμεμπτος",
                     "_translit": "ámemptos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am'-emp-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3201"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "irreproachable",
               "kjv_def": ":--blameless, faultless, unblamable.",
               "_strongs": "00273"
            },
            {
               "strongs": "274",
               "greek": [
                  {
                     "_BETA": "A)ME/MPTWS",
                     "_unicode": "ἀμέμπτως",
                     "_translit": "amémptōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-emp'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "273"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "faultlessly",
               "kjv_def": ":--blameless, unblamably.",
               "_strongs": "00274"
            },
            {
               "strongs": "275",
               "greek": [
                  {
                     "_BETA": "A)ME/RIMNOS",
                     "_unicode": "ἀμέριμνος",
                     "_translit": "amérimnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-er'-im-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3308"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "not anxious",
               "kjv_def": ":--without\n care(-fulness), secure.",
               "_strongs": "00275"
            },
            {
               "strongs": "276",
               "greek": [
                  {
                     "_BETA": "A)META/QETOS",
                     "_unicode": "ἀμετάθετος",
                     "_translit": "ametáthetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-et-ath'-et-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3346"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unchangeable, or (neuter as abstract)\n unchangeability",
               "kjv_def": ":--immutable(-ility).",
               "_strongs": "00276"
            },
            {
               "strongs": "277",
               "greek": [
                  {
                     "_BETA": "A)METAKI/NHTOS",
                     "_unicode": "ἀμετακίνητος",
                     "_translit": "ametakínētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-et-ak-in'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3334"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "immovable",
               "kjv_def": ":--unmovable.",
               "_strongs": "00277"
            },
            {
               "strongs": "278",
               "greek": [
                  {
                     "_BETA": "A)METAME/LHTOS",
                     "_unicode": "ἀμεταμέλητος",
                     "_translit": "ametamélētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-et-am-el'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3338"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "irrevocable",
               "kjv_def": ":--without repentance, not to be repented of.",
               "_strongs": "00278"
            },
            {
               "strongs": "279",
               "greek": [
                  {
                     "_BETA": "A)METANO/HTOS",
                     "_unicode": "ἀμετανόητος",
                     "_translit": "ametanóētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-et-an-o'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3340"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "unrepentant",
               "kjv_def": ":--impenitent.",
               "_strongs": "00279"
            },
            {
               "strongs": "280",
               "greek": [
                  {
                     "_BETA": "A)/METROS",
                     "_unicode": "ἄμετρος",
                     "_translit": "ámetros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am'-et-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3358"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "immoderate",
               "kjv_def": ":--(thing) without\n measure.",
               "_strongs": "00280"
            },
            {
               "strongs": "281",
               "greek": [
                  {
                     "_BETA": "A)MH/N",
                     "_unicode": "ἀμήν",
                     "_translit": "amḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ane'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0543"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "properly, firm, i.e. (figuratively)\n trustworthy; adverbially, surely (often as interjection, so be\n it)",
               "kjv_def": ":--amen, verily.",
               "_strongs": "00281"
            },
            {
               "strongs": "282",
               "greek": [
                  {
                     "_BETA": "A)MH/TWR",
                     "_unicode": "ἀμήτωρ",
                     "_translit": "amḗtōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ay'-tore"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3384"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "motherless, i.e. of unknown\n maternity",
               "kjv_def": ":--without mother.",
               "_strongs": "00282"
            },
            {
               "strongs": "283",
               "greek": [
                  {
                     "_BETA": "A)MI/ANTOS",
                     "_unicode": "ἀμίαντος",
                     "_translit": "amíantos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ee'-an-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3392"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unsoiled,\n i.e. (figuratively) pure",
               "kjv_def": ":--undefiled.",
               "_strongs": "00283"
            },
            {
               "strongs": "284",
               "greek": [
                  {
                     "_BETA": "*)AMINADA/B",
                     "_unicode": "Ἀμιναδάβ",
                     "_translit": "Aminadáb"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-ee-nad-ab'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05992"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Aminadab, an Israelite",
               "kjv_def": ":--Aminadab.",
               "_strongs": "00284"
            },
            {
               "strongs": "285",
               "greek": [
                  {
                     "_BETA": "A)/MMOS",
                     "_unicode": "ἄμμος",
                     "_translit": "ámmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am'-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "260"
                     }
                  ],
                  "__text": "perhaps from \n;"
               },
               "strongs_def": "sand (as heaped on the beach)",
               "kjv_def": ":--sand.",
               "_strongs": "00285"
            },
            {
               "strongs": "286",
               "greek": [
                  {
                     "_BETA": "A)MNO/S",
                     "_unicode": "ἀμνός",
                     "_translit": "amnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-nos'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a lamb",
               "kjv_def": ":--lamb.",
               "_strongs": "00286"
            },
            {
               "strongs": "287",
               "greek": [
                  {
                     "_BETA": "A)MOIBH/",
                     "_unicode": "ἀμοιβή",
                     "_translit": "amoibḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-oy-bay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)MEI/BW",
                        "_unicode": "ἀμείβω",
                        "_translit": "ameíbō"
                     }
                  ],
                  "__text": "from \n (to exchange);"
               },
               "strongs_def": "requital",
               "kjv_def": ":--requite.",
               "_strongs": "00287"
            },
            {
               "strongs": "288",
               "greek": [
                  {
                     "_BETA": "A)/MPELOS",
                     "_unicode": "ἄμπελος",
                     "_translit": "ámpelos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am'-pel-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "297"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "257"
                     }
                  ],
                  "__text": "probably from the base of \n and that of \n;"
               },
               "strongs_def": "a vine (as coiling\n about a support)",
               "kjv_def": ":--vine.",
               "_strongs": "00288"
            },
            {
               "strongs": "289",
               "greek": [
                  {
                     "_BETA": "A)MPELOURGO/S",
                     "_unicode": "ἀμπελουργός",
                     "_translit": "ampelourgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-pel-oor-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "288"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a vine-worker, i.e. pruner",
               "kjv_def": ":--vine-dresser.",
               "_strongs": "00289"
            },
            {
               "strongs": "290",
               "greek": [
                  {
                     "_BETA": "A)MPELW/N",
                     "_unicode": "ἀμπελών",
                     "_translit": "ampelṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-pel-ohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "288"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a vineyard",
               "kjv_def": ":--vineyard.",
               "_strongs": "00290"
            },
            {
               "strongs": "291",
               "greek": [
                  {
                     "_BETA": "*)AMPLI/AS",
                     "_unicode": "Ἀμπλίας",
                     "_translit": "Amplías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-plee'-as"
                  }
               ],
               "strongs_derivation": {
                  "latin": "ampliatus",
                  "__text": "contracted for Latin \n (enlarged);"
               },
               "strongs_def": "Amplias, a Roman\n Christian",
               "kjv_def": ":--Amplias.",
               "_strongs": "00291"
            },
            {
               "strongs": "292",
               "greek": [
                  {
                     "_BETA": "A)MU/NOMAI",
                     "_unicode": "ἀμύνομαι",
                     "_translit": "amýnomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-oo'-nom-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of a primary verb;",
               "strongs_def": "to ward off (for oneself), i.e.\n protect",
               "kjv_def": ":--defend.",
               "_strongs": "00292"
            },
            {
               "strongs": "293",
               "greek": [
                  {
                     "_BETA": "A)MFI/BLHSTRON",
                     "_unicode": "ἀμφίβληστρον",
                     "_translit": "amphíblēstron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-fib'-lace-tron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "297"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from a compound of the base of \n and \n;"
               },
               "strongs_def": "a (fishing) net (as thrown\n about the fish)",
               "kjv_def": ":--net.",
               "_strongs": "00293"
            },
            {
               "strongs": "294",
               "greek": [
                  {
                     "_BETA": "A)MFIE/NNUMI",
                     "_unicode": "ἀμφιέννυμι",
                     "_translit": "amphiénnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-fee-en'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "297"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "E(/NNUMI",
                        "_unicode": "ἕννυμι",
                        "_translit": "hénnymi"
                     }
                  ],
                  "__text": "from the base of \n and \n (to invest);"
               },
               "strongs_def": "to enrobe",
               "kjv_def": ":--clothe.",
               "_strongs": "00294"
            },
            {
               "strongs": "295",
               "greek": [
                  {
                     "_BETA": "*)AMFI/POLIS",
                     "_unicode": "Ἀμφίπολις",
                     "_translit": "Amphípolis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-fip'-ol-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "297"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "a city surrounded by a river;\n Amphipolis, a place in Macedonia",
               "kjv_def": ":--Amphipolis.",
               "_strongs": "00295"
            },
            {
               "strongs": "296",
               "greek": [
                  {
                     "_BETA": "A)/MFODON",
                     "_unicode": "ἄμφοδον",
                     "_translit": "ámphodon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am'-fod-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "297"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "a fork in the road",
               "kjv_def": ":--where two ways\n meet.",
               "_strongs": "00296"
            },
            {
               "strongs": "297",
               "greek": [
                  {
                     "_BETA": "A)MFO/TEROS",
                     "_unicode": "ἀμφότερος",
                     "_translit": "amphóteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-fot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)MFI/",
                        "_unicode": "ἀμφί",
                        "_translit": "amphí"
                     }
                  ],
                  "__text": "comparative of \n (around);"
               },
               "strongs_def": "(in plural) both",
               "kjv_def": ":--both.",
               "_strongs": "00297"
            },
            {
               "strongs": "298",
               "greek": [
                  {
                     "_BETA": "A)MW/MHTOS",
                     "_unicode": "ἀμώμητος",
                     "_translit": "amṓmētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-o'-may-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3469"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unblamable",
               "kjv_def": ":--blameless.",
               "_strongs": "00298"
            },
            {
               "strongs": "299",
               "greek": [
                  {
                     "_BETA": "A)/MWMOS",
                     "_unicode": "ἄμωμος",
                     "_translit": "ámōmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am'-o-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3470"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unblemished (literally or\n figuratively)",
               "kjv_def": ":--without blame (blemish, fault, spot), faultless,\n unblamable.",
               "_strongs": "00299"
            },
            {
               "strongs": "300",
               "greek": [
                  {
                     "_BETA": "*)AMW/N",
                     "_unicode": "Ἀμών",
                     "_translit": "Amṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-one'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0526"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Amon, an Israelite",
               "kjv_def": ":--Amon.",
               "_strongs": "00300"
            },
            {
               "strongs": "301",
               "greek": [
                  {
                     "_BETA": "*)AMW/S",
                     "_unicode": "Ἀμώς",
                     "_translit": "Amṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "am-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0531"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Amos, an Israelite",
               "kjv_def": ":--Amos.",
               "_strongs": "00301"
            },
            {
               "strongs": "302",
               "greek": [
                  {
                     "_BETA": "A)/N",
                     "_unicode": "ἄν",
                     "_translit": "án"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an"
                  }
               ],
               "strongs_derivation": "a primary particle, denoting a supposition, wish, possibility or\n uncertainty",
               "kjv_def": ":--(what-, where-, wither-, who-)soever.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1437"
                  }
               ],
               "_strongs": "00302",
               "__text": "Usually\n unexpressed except by the subjunctive or potential mood. Also\n contracted for \n."
            },
            {
               "strongs": "303",
               "greek": [
                  {
                     "_BETA": "A)NA/",
                     "_unicode": "ἀνά",
                     "_translit": "aná"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ah'"
                  }
               ],
               "strongs_derivation": "a primary preposition and adverb;",
               "strongs_def": "properly, up; but (by extension)\n used (distributively) severally, or (locally) at (etc.)",
               "kjv_def": ":--and, apiece,\n by, each, every (man), in, through.",
               "_strongs": "00303",
               "__text": "In compounds (as a prefix) it\n often means (by implication) repetition, intensity, reversal, etc."
            },
            {
               "strongs": "304",
               "greek": [
                  {
                     "_BETA": "A)NABAQMO/S",
                     "_unicode": "ἀναβαθμός",
                     "_translit": "anabathmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ab-ath-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "305"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "898"
                     }
                  ],
                  "__text": "from \n (compare \n);"
               },
               "strongs_def": "a stairway",
               "kjv_def": ":--stairs.",
               "_strongs": "00304"
            },
            {
               "strongs": "305",
               "greek": [
                  {
                     "_BETA": "A)NABAI/NW",
                     "_unicode": "ἀναβαίνω",
                     "_translit": "anabaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ab-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to go up (literally or\n figuratively)",
               "kjv_def": ":--arise, ascend (up), climb (go, grow, rise, spring) up,\n come (up).",
               "_strongs": "00305"
            },
            {
               "strongs": "306",
               "greek": [
                  {
                     "_BETA": "A)NABA/LLOMAI",
                     "_unicode": "ἀναβάλλομαι",
                     "_translit": "anabállomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ab-al'-lom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to put off (for oneself)",
               "kjv_def": ":--defer.",
               "_strongs": "00306"
            },
            {
               "strongs": "307",
               "greek": [
                  {
                     "_BETA": "A)NABIBA/ZW",
                     "_unicode": "ἀναβιβάζω",
                     "_translit": "anabibázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ab-ee-bad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and a derivative of the base of \n;"
               },
               "strongs_def": "to cause to go up, i.e.\n haul (a net)",
               "kjv_def": ":--draw.",
               "_strongs": "00307"
            },
            {
               "strongs": "308",
               "greek": [
                  {
                     "_BETA": "A)NABLE/PW",
                     "_unicode": "ἀναβλέπω",
                     "_translit": "anablépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ab-lep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to look up; by implication, to recover sight",
               "kjv_def": ":--look\n (up), see, receive sight.",
               "_strongs": "00308"
            },
            {
               "strongs": "309",
               "greek": [
                  {
                     "_BETA": "A)NA/BLEYIS",
                     "_unicode": "ἀνάβλεψις",
                     "_translit": "anáblepsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ab'-lep-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "308"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "restoration of sight",
               "kjv_def": ":--recovery of sight.",
               "_strongs": "00309"
            },
            {
               "strongs": "310",
               "greek": [
                  {
                     "_BETA": "A)NABOA/W",
                     "_unicode": "ἀναβοάω",
                     "_translit": "anaboáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ab-o-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "994"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to halloo",
               "kjv_def": ":--cry (aloud, out).",
               "_strongs": "00310"
            },
            {
               "strongs": "311",
               "greek": [
                  {
                     "_BETA": "A)NABOLH/",
                     "_unicode": "ἀναβολή",
                     "_translit": "anabolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ab-ol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "306"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a putting off",
               "kjv_def": ":--delay.",
               "_strongs": "00311"
            },
            {
               "strongs": "312",
               "greek": [
                  {
                     "_BETA": "A)NAGGE/LLW",
                     "_unicode": "ἀναγγέλλω",
                     "_translit": "anangéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ang-el'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to announce (in detail)",
               "kjv_def": ":--declare,\n rehearse, report, show, speak, tell.",
               "_strongs": "00312"
            },
            {
               "strongs": "313",
               "greek": [
                  {
                     "_BETA": "A)NAGENNA/W",
                     "_unicode": "ἀναγεννάω",
                     "_translit": "anagennáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ag-en-nah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1080"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to beget or (by extension) bear (again)",
               "kjv_def": ":--beget,\n (bear) X (again).",
               "_strongs": "00313"
            },
            {
               "strongs": "314",
               "greek": [
                  {
                     "_BETA": "A)NAGINW/SKW",
                     "_unicode": "ἀναγινώσκω",
                     "_translit": "anaginṓskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ag-in-oce'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to know again, i.e. (by extension) to read",
               "kjv_def": ":--read.",
               "_strongs": "00314"
            },
            {
               "strongs": "315",
               "greek": [
                  {
                     "_BETA": "A)NAGKA/ZW",
                     "_unicode": "ἀναγκάζω",
                     "_translit": "anankázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ang-kad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "318"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to necessitate",
               "kjv_def": ":--compel, constrain.",
               "_strongs": "00315"
            },
            {
               "strongs": "316",
               "greek": [
                  {
                     "_BETA": "A)NAGKAI=OS",
                     "_unicode": "ἀναγκαῖος",
                     "_translit": "anankaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ang-kah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "318"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "necessary; by implication, close (of kin)",
               "kjv_def": ":--near, necessary,\n necessity, needful.",
               "_strongs": "00316"
            },
            {
               "strongs": "317",
               "greek": [
                  {
                     "_BETA": "A)NAGKASTW=S",
                     "_unicode": "ἀναγκαστῶς",
                     "_translit": "anankastōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ang-kas-toce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "315"
                     }
                  ],
                  "__text": "adverb from a derivative of \n;"
               },
               "strongs_def": "compulsorily",
               "kjv_def": ":--by constraint.",
               "_strongs": "00317"
            },
            {
               "strongs": "318",
               "greek": [
                  {
                     "_BETA": "A)NA/GKH",
                     "_unicode": "ἀνάγκη",
                     "_translit": "anánkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ang-kay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "constraint (literally or figuratively);\n by implication, distress",
               "kjv_def": ":--distress, must needs, (of)\n necessity(-sary), needeth, needful.",
               "_strongs": "00318"
            },
            {
               "strongs": "319",
               "greek": [
                  {
                     "_BETA": "A)NAGNWRI/ZOMAI",
                     "_unicode": "ἀναγνωρίζομαι",
                     "_translit": "anagnōrízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ag-no-rid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1107"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to make (oneself) known",
               "kjv_def": ":--be made\n known.",
               "_strongs": "00319"
            },
            {
               "strongs": "320",
               "greek": [
                  {
                     "_BETA": "A)NA/GNWSIS",
                     "_unicode": "ἀνάγνωσις",
                     "_translit": "anágnōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ag'-no-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "314"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(the act of) reading",
               "kjv_def": ":--reading.",
               "_strongs": "00320"
            },
            {
               "strongs": "321",
               "greek": [
                  {
                     "_BETA": "A)NA/GW",
                     "_unicode": "ἀνάγω",
                     "_translit": "anágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead up; by extension to bring out; specially, to\n sail away",
               "kjv_def": ":--bring (again, forth, up again), depart, launch (forth),\n lead (up), loose, offer, sail, set forth, take up.",
               "_strongs": "00321"
            },
            {
               "strongs": "322",
               "greek": [
                  {
                     "_BETA": "A)NADEI/KNUMI",
                     "_unicode": "ἀναδείκνυμι",
                     "_translit": "anadeíknymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ad-ike'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1166"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exhibit, i.e. (by implication) to indicate,\n appoint",
               "kjv_def": ":--appoint, shew.",
               "_strongs": "00322"
            },
            {
               "strongs": "323",
               "greek": [
                  {
                     "_BETA": "A)NA/DEICIS",
                     "_unicode": "ἀνάδειξις",
                     "_translit": "anádeixis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ad'-ike-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "322"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(the act of) exhibition",
               "kjv_def": ":--shewing.",
               "_strongs": "00323"
            },
            {
               "strongs": "324",
               "greek": [
                  {
                     "_BETA": "A)NADE/XOMAI",
                     "_unicode": "ἀναδέχομαι",
                     "_translit": "anadéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ad-ekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to entertain (as a guest)",
               "kjv_def": ":--receive.",
               "_strongs": "00324"
            },
            {
               "strongs": "325",
               "greek": [
                  {
                     "_BETA": "A)NADI/DWMI",
                     "_unicode": "ἀναδίδωμι",
                     "_translit": "anadídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ad-eed'-om-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hand over",
               "kjv_def": ":--deliver.",
               "_strongs": "00325"
            },
            {
               "strongs": "326",
               "greek": [
                  {
                     "_BETA": "A)NAZA/W",
                     "_unicode": "ἀναζάω",
                     "_translit": "anazáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ad-zah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to recover life (literally or figuratively)",
               "kjv_def": ":--(be a-)live again, revive.",
               "_strongs": "00326"
            },
            {
               "strongs": "327",
               "greek": [
                  {
                     "_BETA": "A)NAZHTE/W",
                     "_unicode": "ἀναζητέω",
                     "_translit": "anazētéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ad-zay-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2212"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to search out",
               "kjv_def": ":--seek.",
               "_strongs": "00327"
            },
            {
               "strongs": "328",
               "greek": [
                  {
                     "_BETA": "A)NAZW/NNUMI",
                     "_unicode": "ἀναζώννυμι",
                     "_translit": "anazṓnnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ad-zone'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2224"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to gird afresh",
               "kjv_def": ":--gird up.",
               "_strongs": "00328"
            },
            {
               "strongs": "329",
               "greek": [
                  {
                     "_BETA": "A)NAZWPURE/W",
                     "_unicode": "ἀναζωπυρέω",
                     "_translit": "anazōpyréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ad-zo-poor-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2226"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4442"
                     }
                  ],
                  "__text": "from \n and a compound of the base of \n and \n;"
               },
               "strongs_def": "to\n re-enkindle",
               "kjv_def": ":--stir up.",
               "_strongs": "00329"
            },
            {
               "strongs": "330",
               "greek": [
                  {
                     "_BETA": "A)NAQA/LLW",
                     "_unicode": "ἀναθάλλω",
                     "_translit": "anathállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ath-al'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "QA/LLW",
                        "_unicode": "θάλλω",
                        "_translit": "thállō"
                     }
                  ],
                  "__text": "from \n and \n (to flourish);"
               },
               "strongs_def": "to revive",
               "kjv_def": ":--flourish again.",
               "_strongs": "00330"
            },
            {
               "strongs": "331",
               "greek": [
                  {
                     "_BETA": "A)NA/QEMA",
                     "_unicode": "ἀνάθεμα",
                     "_translit": "anáthema"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ath'-em-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "394"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a (religious) ban or (concretely) excommunicated (thing or\n person)",
               "kjv_def": ":--accused, anathema, curse, X great.",
               "_strongs": "00331"
            },
            {
               "strongs": "332",
               "greek": [
                  {
                     "_BETA": "A)NAQEMATI/ZW",
                     "_unicode": "ἀναθεματίζω",
                     "_translit": "anathematízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ath-em-at-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "331"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to declare or vow under penalty of execration",
               "kjv_def": ":--(bind under\n a) curse, bind with an oath.",
               "_strongs": "00332"
            },
            {
               "strongs": "333",
               "greek": [
                  {
                     "_BETA": "A)NAQEWRE/W",
                     "_unicode": "ἀναθεωρέω",
                     "_translit": "anatheōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ath-eh-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2334"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to look again (i.e. attentively) at (literally or\n figuratively)",
               "kjv_def": ":--behold, consider.",
               "_strongs": "00333"
            },
            {
               "strongs": "334",
               "greek": [
                  {
                     "_BETA": "A)NA/QHMA",
                     "_unicode": "ἀνάθημα",
                     "_translit": "anáthēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ath'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "394"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "331"
                     }
                  ],
                  "__text": "from \n (like \n, but in a good sense);"
               },
               "strongs_def": "a votive offering",
               "kjv_def": ":--gift.",
               "_strongs": "00334"
            },
            {
               "strongs": "335",
               "greek": [
                  {
                     "_BETA": "A)NAI/DEIA",
                     "_unicode": "ἀναίδεια",
                     "_translit": "anaídeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ah'-ee-die-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "427"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "127"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle (compare \n)) and \n;"
               },
               "strongs_def": "impudence, i.e. (by implication) importunity",
               "kjv_def": ":--importunity.",
               "_strongs": "00335"
            },
            {
               "strongs": "336",
               "greek": [
                  {
                     "_BETA": "A)NAI/RESIS",
                     "_unicode": "ἀναίρεσις",
                     "_translit": "anaíresis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ah'-ee-res-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "337"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(the act of) killing",
               "kjv_def": ":--death.",
               "_strongs": "00336"
            },
            {
               "strongs": "337",
               "greek": [
                  {
                     "_BETA": "A)NAIRE/W",
                     "_unicode": "ἀναιρέω",
                     "_translit": "anairéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ahee-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n and (the active of) \n;"
               },
               "strongs_def": "to take up, i.e. adopt; by\n implication, to take away (violently), i.e. abolish, murder",
               "kjv_def": ":--put to\n death, kill, slay, take away, take up.",
               "_strongs": "00337"
            },
            {
               "strongs": "338",
               "greek": [
                  {
                     "_BETA": "A)NAI/TIOS",
                     "_unicode": "ἀναίτιος",
                     "_translit": "anaítios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ah'-ee-tee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "159"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "156"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n (in the sense of \n);"
               },
               "strongs_def": "innocent",
               "kjv_def": ":--blameless, guiltless.",
               "_strongs": "00338"
            },
            {
               "strongs": "339",
               "greek": [
                  {
                     "_BETA": "A)NAKAQI/ZW",
                     "_unicode": "ἀνακαθίζω",
                     "_translit": "anakathízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-ath-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2523"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "properly, to set up, i.e. (reflexively) to sit\n up",
               "kjv_def": ":--sit up.",
               "_strongs": "00339"
            },
            {
               "strongs": "340",
               "greek": [
                  {
                     "_BETA": "A)NAKAINI/ZW",
                     "_unicode": "ἀνακαινίζω",
                     "_translit": "anakainízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-ahee-nid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2537"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to restore",
               "kjv_def": ":--renew.",
               "_strongs": "00340"
            },
            {
               "strongs": "341",
               "greek": [
                  {
                     "_BETA": "A)NAKAINO/W",
                     "_unicode": "ἀνακαινόω",
                     "_translit": "anakainóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-ahee-no'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2537"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to renovate",
               "kjv_def": ":--renew.",
               "_strongs": "00341"
            },
            {
               "strongs": "342",
               "greek": [
                  {
                     "_BETA": "A)NAKAI/NWSIS",
                     "_unicode": "ἀνακαίνωσις",
                     "_translit": "anakaínōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-ah'-ee-no-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "341"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "renovation",
               "kjv_def": ":--renewing.",
               "_strongs": "00342"
            },
            {
               "strongs": "343",
               "greek": [
                  {
                     "_BETA": "A)NAKALU/PTW",
                     "_unicode": "ἀνακαλύπτω",
                     "_translit": "anakalýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-al-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n (in the sense of reversal) and \n;"
               },
               "strongs_def": "to unveil",
               "kjv_def": ":--open,\n (un-)taken away.",
               "_strongs": "00343"
            },
            {
               "strongs": "344",
               "greek": [
                  {
                     "_BETA": "A)NAKA/MPTW",
                     "_unicode": "ἀνακάμπτω",
                     "_translit": "anakámptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-amp'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2578"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to turn back",
               "kjv_def": ":--(re-)turn.",
               "_strongs": "00344"
            },
            {
               "strongs": "345",
               "greek": [
                  {
                     "_BETA": "A)NAKEI=MAI",
                     "_unicode": "ἀνακεῖμαι",
                     "_translit": "anakeîmai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-i'-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to recline (as a corpse or at a meal)",
               "kjv_def": ":--guest,\n lean, lie, sit (down, at meat), at the table.",
               "_strongs": "00345"
            },
            {
               "strongs": "346",
               "greek": [
                  {
                     "_BETA": "A)NAKEFALAI/OMAI",
                     "_unicode": "ἀνακεφαλαίομαι",
                     "_translit": "anakephalaíomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-ef-al-ah'-ee-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2775"
                     }
                  ],
                  "__text": "from \n and \n (in its original sense);"
               },
               "strongs_def": "to sum up",
               "kjv_def": ":--briefly\n comprehend, gather together in one.",
               "_strongs": "00346"
            },
            {
               "strongs": "347",
               "greek": [
                  {
                     "_BETA": "A)NAKLI/NW",
                     "_unicode": "ἀνακλίνω",
                     "_translit": "anaklínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-lee'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lean back",
               "kjv_def": ":--lay, (make) sit down.",
               "_strongs": "00347"
            },
            {
               "strongs": "348",
               "greek": [
                  {
                     "_BETA": "A)NAKO/PTW",
                     "_unicode": "ἀνακόπτω",
                     "_translit": "anakóptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-op'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to beat back, i.e. check",
               "kjv_def": ":--hinder.",
               "_strongs": "00348"
            },
            {
               "strongs": "349",
               "greek": [
                  {
                     "_BETA": "A)NAKRA/ZW",
                     "_unicode": "ἀνακράζω",
                     "_translit": "anakrázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-rad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2896"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to scream up (aloud)",
               "kjv_def": ":--cry out.",
               "_strongs": "00349"
            },
            {
               "strongs": "350",
               "greek": [
                  {
                     "_BETA": "A)NAKRI/NW",
                     "_unicode": "ἀνακρίνω",
                     "_translit": "anakrínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-ree'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "properly, to scrutinize, i.e. (by implication)\n investigate, interrogate, determine",
               "kjv_def": ":--ask, question, discern, examine,\n judge, search.",
               "_strongs": "00350"
            },
            {
               "strongs": "351",
               "greek": [
                  {
                     "_BETA": "A)NA/KRISIS",
                     "_unicode": "ἀνάκρισις",
                     "_translit": "anákrisis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak'-ree-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "350"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a (judicial) investigation",
               "kjv_def": ":--examination.",
               "_strongs": "00351"
            },
            {
               "strongs": "352",
               "greek": [
                  {
                     "_BETA": "A)NAKU/PTW",
                     "_unicode": "ἀνακύπτω",
                     "_translit": "anakýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ak-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2955"
                     }
                  ],
                  "__text": "from \n (in the sense of reversal) and \n;"
               },
               "strongs_def": "to unbend, i.e. rise;\n figuratively, be elated",
               "kjv_def": ":--lift up, look up.",
               "_strongs": "00352"
            },
            {
               "strongs": "353",
               "greek": [
                  {
                     "_BETA": "A)NALAMBA/NW",
                     "_unicode": "ἀναλαμβάνω",
                     "_translit": "analambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-al-am-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take up",
               "kjv_def": ":--receive up, take (in, unto, up).",
               "_strongs": "00353"
            },
            {
               "strongs": "354",
               "greek": [
                  {
                     "_BETA": "A)NA/LHYIS",
                     "_unicode": "ἀνάληψις",
                     "_translit": "análēpsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-al'-ape-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "353"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "ascension",
               "kjv_def": ":--taking up.",
               "_strongs": "00354"
            },
            {
               "strongs": "355",
               "greek": [
                  {
                     "_BETA": "A)NALI/SKW",
                     "_unicode": "ἀναλίσκω",
                     "_translit": "analískō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-al-is'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n and a form of the alternate of \n;"
               },
               "strongs_def": "properly, to use up, i.e.\n destroy",
               "kjv_def": ":--consume.",
               "_strongs": "00355"
            },
            {
               "strongs": "356",
               "greek": [
                  {
                     "_BETA": "A)NALOGI/A",
                     "_unicode": "ἀναλογία",
                     "_translit": "analogía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-al-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "proportion",
               "kjv_def": ":--proportion.",
               "_strongs": "00356"
            },
            {
               "strongs": "357",
               "greek": [
                  {
                     "_BETA": "A)NALOGI/ZOMAI",
                     "_unicode": "ἀναλογίζομαι",
                     "_translit": "analogízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-al-og-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "356"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to estimate, i.e. (figuratively)\n contemplate",
               "kjv_def": ":--consider.",
               "_strongs": "00357"
            },
            {
               "strongs": "358",
               "greek": [
                  {
                     "_BETA": "A)/NALOS",
                     "_unicode": "ἄναλος",
                     "_translit": "ánalos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-al-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "saltless, i.e. insipid",
               "kjv_def": ":--X\n lose saltness.",
               "_strongs": "00358"
            },
            {
               "strongs": "359",
               "greek": [
                  {
                     "_BETA": "A)NA/LUSIS",
                     "_unicode": "ἀνάλυσις",
                     "_translit": "análysis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-al'-oo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "360"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "departure",
               "kjv_def": ":--departure.",
               "_strongs": "00359"
            },
            {
               "strongs": "360",
               "greek": [
                  {
                     "_BETA": "A)NALU/W",
                     "_unicode": "ἀναλύω",
                     "_translit": "analýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-al-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to break up, i.e. depart (literally or\n figuratively)",
               "kjv_def": ":--depart, return.",
               "_strongs": "00360"
            },
            {
               "strongs": "361",
               "greek": [
                  {
                     "_BETA": "A)NAMA/RTHTOS",
                     "_unicode": "ἀναμάρτητος",
                     "_translit": "anamártētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-am-ar'-tay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "264"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "sinless",
               "kjv_def": ":--that is without sin.",
               "_strongs": "00361"
            },
            {
               "strongs": "362",
               "greek": [
                  {
                     "_BETA": "A)NAME/NW",
                     "_unicode": "ἀναμένω",
                     "_translit": "anaménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-am-en'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to await",
               "kjv_def": ":--wait for.",
               "_strongs": "00362"
            },
            {
               "strongs": "363",
               "greek": [
                  {
                     "_BETA": "A)NAMIMNH/SKW",
                     "_unicode": "ἀναμιμνήσκω",
                     "_translit": "anamimnḗskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-am-im-nace'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3403"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to remind; (reflexively) to recollect",
               "kjv_def": ":--call to\n mind, (bring to , call to, put in), remember(-brance).",
               "_strongs": "00363"
            },
            {
               "strongs": "364",
               "greek": [
                  {
                     "_BETA": "A)NA/MNHSIS",
                     "_unicode": "ἀνάμνησις",
                     "_translit": "anámnēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-am'-nay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "363"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "recollection",
               "kjv_def": ":--remembrance (again).",
               "_strongs": "00364"
            },
            {
               "strongs": "365",
               "greek": [
                  {
                     "_BETA": "A)NANEO/W",
                     "_unicode": "ἀνανεόω",
                     "_translit": "ananeóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-an-neh-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to renovate, i.e. reform",
               "kjv_def": ":--renew.",
               "_strongs": "00365"
            },
            {
               "strongs": "366",
               "greek": [
                  {
                     "_BETA": "A)NANH/FW",
                     "_unicode": "ἀνανήφω",
                     "_translit": "ananḗphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-an-ay'-fo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3525"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to become sober again, i.e. (figuratively) regain\n (one's) senses",
               "kjv_def": ":--recover self.",
               "_strongs": "00366"
            },
            {
               "strongs": "367",
               "greek": [
                  {
                     "_BETA": "*)ANANI/AS",
                     "_unicode": "Ἀνανίας",
                     "_translit": "Ananías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-an-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02608"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Ananias, the name of three\n Israelites",
               "kjv_def": ":--Ananias.",
               "_strongs": "00367"
            },
            {
               "strongs": "368",
               "greek": [
                  {
                     "_BETA": "A)NANTI/R)R(HTOS",
                     "_unicode": "ἀναντίῤῥητος",
                     "_translit": "anantírrhētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-an-tir'-hray-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of a\n compound of \n and \n;"
               },
               "strongs_def": "indisputable",
               "kjv_def": ":--cannot be spoken against.",
               "_strongs": "00368"
            },
            {
               "strongs": "369",
               "greek": [
                  {
                     "_BETA": "A)NANTIR)R(H/TWS",
                     "_unicode": "ἀναντιῤῥήτως",
                     "_translit": "anantirrhḗtōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-an-tir-hray'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "368"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "promptly",
               "kjv_def": ":--without gainsaying.",
               "_strongs": "00369"
            },
            {
               "strongs": "370",
               "greek": [
                  {
                     "_BETA": "A)NA/CIOS",
                     "_unicode": "ἀνάξιος",
                     "_translit": "anáxios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ax'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "514"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unfit",
               "kjv_def": ":--unworthy.",
               "_strongs": "00370"
            },
            {
               "strongs": "371",
               "greek": [
                  {
                     "_BETA": "A)NACI/WS",
                     "_unicode": "ἀναξίως",
                     "_translit": "anaxíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ax-ee'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "370"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "irreverently",
               "kjv_def": ":--unworthily.",
               "_strongs": "00371"
            },
            {
               "strongs": "372",
               "greek": [
                  {
                     "_BETA": "A)NA/PAUSIS",
                     "_unicode": "ἀνάπαυσις",
                     "_translit": "anápausis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap'-ow-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "373"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "intermission; by implication, recreation",
               "kjv_def": ":--rest.",
               "_strongs": "00372"
            },
            {
               "strongs": "373",
               "greek": [
                  {
                     "_BETA": "A)NAPAU/W",
                     "_unicode": "ἀναπαύω",
                     "_translit": "anapaúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap-ow'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3973"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(reflexively) to repose (literally or figuratively\n (be exempt), remain); by implication, to refresh",
               "kjv_def": ":--take ease, refresh,\n (give, take) rest.",
               "_strongs": "00373"
            },
            {
               "strongs": "374",
               "greek": [
                  {
                     "_BETA": "A)NAPEI/QW",
                     "_unicode": "ἀναπείθω",
                     "_translit": "anapeíthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap-i'-tho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to incite",
               "kjv_def": ":--persuade.",
               "_strongs": "00374"
            },
            {
               "strongs": "375",
               "greek": [
                  {
                     "_BETA": "A)NAPE/MPW",
                     "_unicode": "ἀναπέμπω",
                     "_translit": "anapémpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap-em'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3992"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to send up or back",
               "kjv_def": ":--send (again).",
               "_strongs": "00375"
            },
            {
               "strongs": "376",
               "greek": [
                  {
                     "_BETA": "A)NA/PHROS",
                     "_unicode": "ἀνάπηρος",
                     "_translit": "anápēros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap'-ay-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "PH=ROS",
                        "_unicode": "πῆρος",
                        "_translit": "pēros"
                     }
                  ],
                  "__text": "from \n (in the sense of intensity) and \n (maimed);"
               },
               "strongs_def": "crippled",
               "kjv_def": ":--maimed.",
               "_strongs": "00376"
            },
            {
               "strongs": "377",
               "greek": [
                  {
                     "_BETA": "A)NAPI/PTW",
                     "_unicode": "ἀναπίπτω",
                     "_translit": "anapíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap-ip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fall back, i.e. lie down, lean back",
               "kjv_def": ":--lean, sit\n down (to meat).",
               "_strongs": "00377"
            },
            {
               "strongs": "378",
               "greek": [
                  {
                     "_BETA": "A)NAPLHRO/W",
                     "_unicode": "ἀναπληρόω",
                     "_translit": "anaplēróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap-lay-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4137"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to complete; by implication, to occupy, supply;\n figuratively, to accomplish (by coincidence ot obedience)",
               "kjv_def": ":--fill up,\n fulfill, occupy, supply.",
               "_strongs": "00378"
            },
            {
               "strongs": "379",
               "greek": [
                  {
                     "_BETA": "A)NAPOLO/GHTOS",
                     "_unicode": "ἀναπολόγητος",
                     "_translit": "anapológētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap-ol-og'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "626"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "indefensible",
               "kjv_def": ":--without an excuse, inexcusable.",
               "_strongs": "00379"
            },
            {
               "strongs": "380",
               "greek": [
                  {
                     "_BETA": "A)NAPTU/SSW",
                     "_unicode": "ἀναπτύσσω",
                     "_translit": "anaptýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap-toos'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4428"
                     }
                  ],
                  "__text": "from \n (in the sense of reversal) and \n;"
               },
               "strongs_def": "to unroll (a scroll or\n volume)",
               "kjv_def": ":--open.",
               "_strongs": "00380"
            },
            {
               "strongs": "381",
               "greek": [
                  {
                     "_BETA": "A)NA/PTW",
                     "_unicode": "ἀνάπτω",
                     "_translit": "anáptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "681"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to enkindle",
               "kjv_def": ":--kindle, light.",
               "_strongs": "00381"
            },
            {
               "strongs": "382",
               "greek": [
                  {
                     "_BETA": "A)NARI/QMHTOS",
                     "_unicode": "ἀναρίθμητος",
                     "_translit": "anaríthmētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ar-ith'-may-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "705"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unnumbered,\n i.e. without number",
               "kjv_def": ":--innumerable.",
               "_strongs": "00382"
            },
            {
               "strongs": "383",
               "greek": [
                  {
                     "_BETA": "A)NASEI/W",
                     "_unicode": "ἀνασείω",
                     "_translit": "anaseíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-as-i'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4579"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "figuratively, to excite",
               "kjv_def": ":--move, stir up.",
               "_strongs": "00383"
            },
            {
               "strongs": "384",
               "greek": [
                  {
                     "_BETA": "A)NASKEUA/ZW",
                     "_unicode": "ἀνασκευάζω",
                     "_translit": "anaskeuázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ask-yoo-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4632"
                     }
                  ],
                  "__text": "from \n (in the sense of reversal) and a derivative of \n;"
               },
               "strongs_def": "properly, to pack up (baggage), i.e. (by implication, and\n figuratively) to upset",
               "kjv_def": ":--subvert.",
               "_strongs": "00384"
            },
            {
               "strongs": "385",
               "greek": [
                  {
                     "_BETA": "A)NASPA/W",
                     "_unicode": "ἀνασπάω",
                     "_translit": "anaspáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-as-pah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4685"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take up or extricate",
               "kjv_def": ":--draw up, pull out.",
               "_strongs": "00385"
            },
            {
               "strongs": "386",
               "greek": [
                  {
                     "_BETA": "A)NA/STASIS",
                     "_unicode": "ἀνάστασις",
                     "_translit": "anástasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-as'-tas-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "450"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a standing up again, i.e. (literally) a resurrection from\n death (individual, genitive case or by implication, (its author)), or\n (figuratively) a (moral) recovery (of spiritual truth)",
               "kjv_def": ":--raised to\n life again, resurrection, rise from the dead, that should rise, rising\n again.",
               "_strongs": "00386"
            },
            {
               "strongs": "387",
               "greek": [
                  {
                     "_BETA": "A)NASTATO/W",
                     "_unicode": "ἀναστατόω",
                     "_translit": "anastatóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-as-tat-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "450"
                     }
                  ],
                  "__text": "from a derivative of \n (in the sense of removal);"
               },
               "strongs_def": "properly, to drive\n out of home, i.e. (by implication) to disturb (literally or\n figuratively)",
               "kjv_def": ":--trouble, turn upside down, make an uproar.",
               "_strongs": "00387"
            },
            {
               "strongs": "388",
               "greek": [
                  {
                     "_BETA": "A)NASTAURO/W",
                     "_unicode": "ἀνασταυρόω",
                     "_translit": "anastauróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-as-tow-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4717"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to recrucify (figuratively)",
               "kjv_def": ":--crucify afresh.",
               "_strongs": "00388"
            },
            {
               "strongs": "389",
               "greek": [
                  {
                     "_BETA": "A)NASTENA/ZW",
                     "_unicode": "ἀναστενάζω",
                     "_translit": "anastenázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-as-ten-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4727"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sigh deeply",
               "kjv_def": ":--sigh deeply.",
               "_strongs": "00389"
            },
            {
               "strongs": "390",
               "greek": [
                  {
                     "_BETA": "A)NASTRE/FW",
                     "_unicode": "ἀναστρέφω",
                     "_translit": "anastréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-as-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to overturn; also to return; by implication, to\n busy oneself, i.e. remain, live",
               "kjv_def": ":--abide, behave self, have\n conversation, live, overthrow, pass, return, be used.",
               "_strongs": "00390"
            },
            {
               "strongs": "391",
               "greek": [
                  {
                     "_BETA": "A)NASTROFH/",
                     "_unicode": "ἀναστροφή",
                     "_translit": "anastrophḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-as-trof-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "390"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "behavior",
               "kjv_def": ":--conversation.",
               "_strongs": "00391"
            },
            {
               "strongs": "392",
               "greek": [
                  {
                     "_BETA": "A)NATA/SSOMAI",
                     "_unicode": "ἀνατάσσομαι",
                     "_translit": "anatássomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-at-as'-som-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to arrange",
               "kjv_def": ":--set in order.",
               "_strongs": "00392"
            },
            {
               "strongs": "393",
               "greek": [
                  {
                     "_BETA": "A)NATE/LLW",
                     "_unicode": "ἀνατέλλω",
                     "_translit": "anatéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-at-el'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to (cause to) arise",
               "kjv_def": ":--(a-, make to)\n rise, at the rising of, spring (up), be up.",
               "_strongs": "00393"
            },
            {
               "strongs": "394",
               "greek": [
                  {
                     "_BETA": "A)NATI/QEMAI",
                     "_unicode": "ἀνατίθεμαι",
                     "_translit": "anatíthemai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-at-ith'-em-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to set forth (for oneself), i.e\n propound",
               "kjv_def": ":--communicate, declare.",
               "_strongs": "00394"
            },
            {
               "strongs": "395",
               "greek": [
                  {
                     "_BETA": "A)NATOLH/",
                     "_unicode": "ἀνατολή",
                     "_translit": "anatolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-at-ol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "393"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a rising of light, i.e. dawn (figuratively); by implication,\n the east (also in plural)",
               "kjv_def": ":--dayspring, east, rising.",
               "_strongs": "00395"
            },
            {
               "strongs": "396",
               "greek": [
                  {
                     "_BETA": "A)NATRE/PW",
                     "_unicode": "ἀνατρέπω",
                     "_translit": "anatrépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-at-rep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to overturn (figuratively)",
               "kjv_def": ":--overthrow,\n subvert.",
               "_strongs": "00396"
            },
            {
               "strongs": "397",
               "greek": [
                  {
                     "_BETA": "A)NATRE/FW",
                     "_unicode": "ἀνατρέφω",
                     "_translit": "anatréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-at-ref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rear (physically or mentally)",
               "kjv_def": ":--bring up,\n nourish (up).",
               "_strongs": "00397"
            },
            {
               "strongs": "398",
               "greek": [
                  {
                     "_BETA": "A)NAFAI/NW",
                     "_unicode": "ἀναφαίνω",
                     "_translit": "anaphaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-af-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to show, i.e. (reflexively) appear, or (passively)\n to have pointed out",
               "kjv_def": ":--(should) appear, discover.",
               "_strongs": "00398"
            },
            {
               "strongs": "399",
               "greek": [
                  {
                     "_BETA": "A)NAFE/RW",
                     "_unicode": "ἀναφέρω",
                     "_translit": "anaphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-af-er'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take up (literally or figuratively)",
               "kjv_def": ":--bear,\n bring (carry, lead) up, offer (up).",
               "_strongs": "00399"
            },
            {
               "strongs": "400",
               "greek": [
                  {
                     "_BETA": "A)NAFWNE/W",
                     "_unicode": "ἀναφωνέω",
                     "_translit": "anaphōnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-af-o-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5455"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exclaim",
               "kjv_def": ":--speak out.",
               "_strongs": "00400"
            },
            {
               "strongs": "401",
               "greek": [
                  {
                     "_BETA": "A)NA/XUSIS",
                     "_unicode": "ἀνάχυσις",
                     "_translit": "anáchysis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-akh'-oo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "XE/W",
                        "_unicode": "χέω",
                        "_translit": "chéō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to pour);"
               },
               "strongs_def": "properly, effusion, i.e.\n (figuratively) license",
               "kjv_def": ":--excess.",
               "_strongs": "00401"
            },
            {
               "strongs": "402",
               "greek": [
                  {
                     "_BETA": "A)NAXWRE/W",
                     "_unicode": "ἀναχωρέω",
                     "_translit": "anachōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-akh-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5562"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to retire",
               "kjv_def": ":--depart, give place, go (turn) aside,\n withdraw self.",
               "_strongs": "00402"
            },
            {
               "strongs": "403",
               "greek": [
                  {
                     "_BETA": "A)NA/YUCIS",
                     "_unicode": "ἀνάψυξις",
                     "_translit": "anápsyxis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-aps'-ook-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "404"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a recovery of breath, i.e. (figuratively)\n revival",
               "kjv_def": ":--revival.",
               "_strongs": "00403"
            },
            {
               "strongs": "404",
               "greek": [
                  {
                     "_BETA": "A)NAYU/XW",
                     "_unicode": "ἀναψύχω",
                     "_translit": "anapsýchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-aps-oo'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5594"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "properly, to cool off, i.e. (figuratively)\n relieve",
               "kjv_def": ":--refresh.",
               "_strongs": "00404"
            },
            {
               "strongs": "405",
               "greek": [
                  {
                     "_BETA": "A)NDRAPODISTH/S",
                     "_unicode": "ἀνδραποδιστής",
                     "_translit": "andrapodistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-drap-od-is-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "from a derivative of a compound of \n and \n;"
               },
               "strongs_def": "an enslaver (as\n bringing men to his feet)",
               "kjv_def": ":--menstealer.",
               "_strongs": "00405"
            },
            {
               "strongs": "406",
               "greek": [
                  {
                     "_BETA": "*)ANDRE/AS",
                     "_unicode": "Ἀνδρέας",
                     "_translit": "Andréas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-dreh'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "manly; Andreas, an Israelite",
               "kjv_def": ":--Andrew.",
               "_strongs": "00406"
            },
            {
               "strongs": "407",
               "greek": [
                  {
                     "_BETA": "A)NDRI/ZOMAI",
                     "_unicode": "ἀνδρίζομαι",
                     "_translit": "andrízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-drid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to act manly",
               "kjv_def": ":--quit like men.",
               "_strongs": "00407"
            },
            {
               "strongs": "408",
               "greek": [
                  {
                     "_BETA": "*)ANDRO/NIKOS",
                     "_unicode": "Ἀνδρόνικος",
                     "_translit": "Andrónikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-dron'-ee-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3534"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "man of victory; Andronicos, an\n Israelite",
               "kjv_def": ":--Adronicus.",
               "_strongs": "00408"
            },
            {
               "strongs": "409",
               "greek": [
                  {
                     "_BETA": "A)NDROFO/NOS",
                     "_unicode": "ἀνδροφόνος",
                     "_translit": "androphónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-drof-on'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5408"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a murderer",
               "kjv_def": ":--manslayer.",
               "_strongs": "00409"
            },
            {
               "strongs": "410",
               "greek": [
                  {
                     "_BETA": "A)NE/GKLHTOS",
                     "_unicode": "ἀνέγκλητος",
                     "_translit": "anénklētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-eng'-klay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1458"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unaccused,\n i.e. (by implication) irreproachable",
               "kjv_def": ":--blameless.",
               "_strongs": "00410"
            },
            {
               "strongs": "411",
               "greek": [
                  {
                     "_BETA": "A)NEKDIH/GHTOS",
                     "_unicode": "ἀνεκδιήγητος",
                     "_translit": "anekdiḗgētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ek-dee-ay'-gay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1555"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "not\n expounded in full, i.e. indescribable",
               "kjv_def": ":--unspeakable.",
               "_strongs": "00411"
            },
            {
               "strongs": "412",
               "greek": [
                  {
                     "_BETA": "A)NEKLA/LHTOS",
                     "_unicode": "ἀνεκλάλητος",
                     "_translit": "aneklálētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ek-lal'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1583"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "not\n spoken out, i.e. (by implication) unutterable",
               "kjv_def": ":--unspeakable.",
               "_strongs": "00412"
            },
            {
               "strongs": "413",
               "greek": [
                  {
                     "_BETA": "A)NE/KLEIPTOS",
                     "_unicode": "ἀνέκλειπτος",
                     "_translit": "anékleiptos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ek'-lipe-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1587"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "not\n left out, i.e. (by implication) inexhaustible",
               "kjv_def": ":--that faileth not.",
               "_strongs": "00413"
            },
            {
               "strongs": "414",
               "greek": [
                  {
                     "_BETA": "A)NEKTO/TEROS",
                     "_unicode": "ἀνεκτότερος",
                     "_translit": "anektóteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ek-tot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "430"
                     }
                  ],
                  "__text": "comparative of a derivative of \n;"
               },
               "strongs_def": "more endurable",
               "kjv_def": ":--more tolerable.",
               "_strongs": "00414"
            },
            {
               "strongs": "415",
               "greek": [
                  {
                     "_BETA": "A)NELEH/MWN",
                     "_unicode": "ἀνελεήμων",
                     "_translit": "aneleḗmōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-eleh-ay'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1655"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "merciless",
               "kjv_def": ":--unmerciful.",
               "_strongs": "00415"
            },
            {
               "strongs": "416",
               "greek": [
                  {
                     "_BETA": "A)NEMI/ZW",
                     "_unicode": "ἀνεμίζω",
                     "_translit": "anemízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-em-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "417"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to toss with the wind",
               "kjv_def": ":--drive with the wind.",
               "_strongs": "00416"
            },
            {
               "strongs": "417",
               "greek": [
                  {
                     "_BETA": "A)/NEMOS",
                     "_unicode": "ἄνεμος",
                     "_translit": "ánemos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-em-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "wind; (plural) by implication, (the four)\n quarters (of the earth)",
               "kjv_def": ":--wind.",
               "_strongs": "00417"
            },
            {
               "strongs": "418",
               "greek": [
                  {
                     "_BETA": "A)NE/NDEKTOS",
                     "_unicode": "ἀνένδεκτος",
                     "_translit": "anéndektos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-en'-dek-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1735"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of the same as \n;"
               },
               "strongs_def": "unadmitted, i.e. (by implication) not supposable",
               "kjv_def": ":--impossible.",
               "_strongs": "00418"
            },
            {
               "strongs": "419",
               "greek": [
                  {
                     "_BETA": "A)NECEREU/NHTOS",
                     "_unicode": "ἀνεξερεύνητος",
                     "_translit": "anexereúnētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ex-er-yoo'-nay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1830"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "not\n searched out, i.e. (by implication) inscrutable",
               "kjv_def": ":--unsearchable.",
               "_strongs": "00419"
            },
            {
               "strongs": "420",
               "greek": [
                  {
                     "_BETA": "A)NECI/KAKOS",
                     "_unicode": "ἀνεξίκακος",
                     "_translit": "anexíkakos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ex-ik'-ak-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "430"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "enduring of ill, i.e. forbearing",
               "kjv_def": ":--patient.",
               "_strongs": "00420"
            },
            {
               "strongs": "421",
               "greek": [
                  {
                     "_BETA": "A)NECIXNI/ASTOS",
                     "_unicode": "ἀνεξιχνίαστος",
                     "_translit": "anexichníastos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ex-ikh-nee'-as-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2487"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of a\n compound of \n and a derivative of \n;"
               },
               "strongs_def": "not tracked out, i.e. (by\n implication) untraceable",
               "kjv_def": ":--past finding out; unsearchable.",
               "_strongs": "00421"
            },
            {
               "strongs": "422",
               "greek": [
                  {
                     "_BETA": "A)NEPAI/SXUNTOS",
                     "_unicode": "ἀνεπαίσχυντος",
                     "_translit": "anepaíschyntos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ep-ah'-ee-skhoon-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "153"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of a\n compound of \n and \n;"
               },
               "strongs_def": "not ashamed, i.e. irreprehensible:",
               "kjv_def": "--that\n needeth not to be ashamed.",
               "_strongs": "00422"
            },
            {
               "strongs": "423",
               "greek": [
                  {
                     "_BETA": "A)NEPI/LHPTOS",
                     "_unicode": "ἀνεπίληπτος",
                     "_translit": "anepílēptos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ep-eel'-ape-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1949"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "not\n arrested, i.e. (by implication) inculpable",
               "kjv_def": ":--blameless, unrebukeable.",
               "_strongs": "00423"
            },
            {
               "strongs": "424",
               "greek": [
                  {
                     "_BETA": "A)NE/RXOMAI",
                     "_unicode": "ἀνέρχομαι",
                     "_translit": "anérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-erkh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to ascend",
               "kjv_def": ":--go up.",
               "_strongs": "00424"
            },
            {
               "strongs": "425",
               "greek": [
                  {
                     "_BETA": "A)/NESIS",
                     "_unicode": "ἄνεσις",
                     "_translit": "ánesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "447"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "relaxation or (figuratively) relief",
               "kjv_def": ":--eased, liberty, rest.",
               "_strongs": "00425"
            },
            {
               "strongs": "426",
               "greek": [
                  {
                     "_BETA": "A)NETA/ZW",
                     "_unicode": "ἀνετάζω",
                     "_translit": "anetázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-et-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "E)TA/ZW",
                        "_unicode": "ἐτάζω",
                        "_translit": "etázō"
                     }
                  ],
                  "__text": "from \n and \n (to test);"
               },
               "strongs_def": "to investigate (judicially)",
               "kjv_def": ":--(should\n have) examined(-d).",
               "_strongs": "00426"
            },
            {
               "strongs": "427",
               "greek": [
                  {
                     "_BETA": "A)/NEU",
                     "_unicode": "ἄνευ",
                     "_translit": "áneu"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-yoo"
                  }
               ],
               "strongs_derivation": "a primary particle;",
               "strongs_def": "without",
               "kjv_def": ":--without.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1"
                  }
               ],
               "_strongs": "00427",
               "__text": "Compare \n."
            },
            {
               "strongs": "428",
               "greek": [
                  {
                     "_BETA": "A)NEU/QETOS",
                     "_unicode": "ἀνεύθετος",
                     "_translit": "aneúthetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-yoo'-the-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2111"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "not well set, i.e.\n inconvenient",
               "kjv_def": ":--not commodious.",
               "_strongs": "00428"
            },
            {
               "strongs": "429",
               "greek": [
                  {
                     "_BETA": "A)NEURI/SKW",
                     "_unicode": "ἀνευρίσκω",
                     "_translit": "aneurískō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-yoo-ris'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2147"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to find out",
               "kjv_def": ":--find.",
               "_strongs": "00429"
            },
            {
               "strongs": "430",
               "greek": [
                  {
                     "_BETA": "A)NE/XOMAI",
                     "_unicode": "ἀνέχομαι",
                     "_translit": "anéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to hold oneself up against, i.e.\n (figuratively) put up with",
               "kjv_def": ":--bear with, endure, forbear, suffer.",
               "_strongs": "00430"
            },
            {
               "strongs": "431",
               "greek": [
                  {
                     "_BETA": "A)NEYIO/S",
                     "_unicode": "ἀνεψιός",
                     "_translit": "anepsiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-eps'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "NE/POS",
                        "_unicode": "νέπος",
                        "_translit": "népos"
                     }
                  ],
                  "__text": "from \n (as a particle of union) and an obsolete \n (a brood);"
               },
               "strongs_def": "properly, akin, i.e. (specially) a cousin",
               "kjv_def": ":--sister's son.",
               "_strongs": "00431"
            },
            {
               "strongs": "432",
               "greek": [
                  {
                     "_BETA": "A)/NHQON",
                     "_unicode": "ἄνηθον",
                     "_translit": "ánēthon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-ay-thon"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "dill",
               "kjv_def": ":--anise.",
               "_strongs": "00432"
            },
            {
               "strongs": "433",
               "greek": [
                  {
                     "_BETA": "A)NH/KW",
                     "_unicode": "ἀνήκω",
                     "_translit": "anḗkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ay'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2240"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to attain to, i.e. (figuratively) be\n proper",
               "kjv_def": ":--convenient, be fit.",
               "_strongs": "00433"
            },
            {
               "strongs": "434",
               "greek": [
                  {
                     "_BETA": "A)NH/MEROS",
                     "_unicode": "ἀνήμερος",
                     "_translit": "anḗmeros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ay'-mer-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "H(/MEROS",
                        "_unicode": "ἥμερος",
                        "_translit": "hḗmeros"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n (lame);"
               },
               "strongs_def": "savage",
               "kjv_def": ":--fierce.",
               "_strongs": "00434"
            },
            {
               "strongs": "435",
               "greek": [
                  {
                     "_BETA": "A)NH/R",
                     "_unicode": "ἀνήρ",
                     "_translit": "anḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-ayr"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "444"
                     }
                  ],
                  "__text": "a primary word (compare \n);"
               },
               "strongs_def": "a man (properly as an individual\n male)",
               "kjv_def": ":--fellow, husband, man, sir.",
               "_strongs": "00435"
            },
            {
               "strongs": "436",
               "greek": [
                  {
                     "_BETA": "A)NQI/STHMI",
                     "_unicode": "ἀνθίστημι",
                     "_translit": "anthístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand against, i.e. oppose",
               "kjv_def": ":--resist, withstand.",
               "_strongs": "00436"
            },
            {
               "strongs": "437",
               "greek": [
                  {
                     "_BETA": "A)NQOMOLOGE/OMAI",
                     "_unicode": "ἀνθομολογέομαι",
                     "_translit": "anthomologéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth-om-ol-og-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3670"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to confess in turn, i.e.\n respond in praise",
               "kjv_def": ":--give thanks.",
               "_strongs": "00437"
            },
            {
               "strongs": "438",
               "greek": [
                  {
                     "_BETA": "A)/NQOS",
                     "_unicode": "ἄνθος",
                     "_translit": "ánthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth'-os"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "a blossom",
               "kjv_def": ":--flower.",
               "_strongs": "00438"
            },
            {
               "strongs": "439",
               "greek": [
                  {
                     "_BETA": "A)NQRAKIA/",
                     "_unicode": "ἀνθρακιά",
                     "_translit": "anthrakiá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth-rak-ee-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "440"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a bed of burning coals",
               "kjv_def": ":--fire of coals.",
               "_strongs": "00439"
            },
            {
               "strongs": "440",
               "greek": [
                  {
                     "_BETA": "A)/NQRAC",
                     "_unicode": "ἄνθραξ",
                     "_translit": "ánthrax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth'-rax"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a live coal",
               "kjv_def": ":--coal of fire.",
               "_strongs": "00440"
            },
            {
               "strongs": "441",
               "greek": [
                  {
                     "_BETA": "A)NQRWPA/RESKOS",
                     "_unicode": "ἀνθρωπάρεσκος",
                     "_translit": "anthrōpáreskos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth-ro-par'-es-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "444"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "700"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "man-courting, i.e. fawning",
               "kjv_def": ":--men-pleaser.",
               "_strongs": "00441"
            },
            {
               "strongs": "442",
               "greek": [
                  {
                     "_BETA": "A)NQRW/PINOS",
                     "_unicode": "ἀνθρώπινος",
                     "_translit": "anthrṓpinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth-ro'-pee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "444"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "human",
               "kjv_def": ":--human, common to man, man(-kind), (man-)kind, men's,\n after the manner of men.",
               "_strongs": "00442"
            },
            {
               "strongs": "443",
               "greek": [
                  {
                     "_BETA": "A)NQRWPOKTO/NOS",
                     "_unicode": "ἀνθρωποκτόνος",
                     "_translit": "anthrōpoktónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth-ro-pok-ton'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "444"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KTEI/NW",
                        "_unicode": "κτείνω",
                        "_translit": "kteínō"
                     }
                  ],
                  "__text": "from \n and \n(to kill);"
               },
               "strongs_def": "a manslayer",
               "kjv_def": ":--murderer.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5406"
                  }
               ],
               "_strongs": "00443",
               "__text": "Compare \n."
            },
            {
               "strongs": "444",
               "greek": [
                  {
                     "_BETA": "A)/NQRWPOS",
                     "_unicode": "ἄνθρωπος",
                     "_translit": "ánthrōpos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth'-ro-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "W)/Y",
                        "_unicode": "ὤψ",
                        "_translit": "ṓps"
                     }
                  ],
                  "__text": "from \n and \n (the countenance; from \n);"
               },
               "strongs_def": "man-faced, i.e. a human\n being",
               "kjv_def": ":--certain, man.",
               "_strongs": "00444"
            },
            {
               "strongs": "445",
               "greek": [
                  {
                     "_BETA": "A)NQUPATEU/W",
                     "_unicode": "ἀνθυπατεύω",
                     "_translit": "anthypateúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth-oo-pat-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "446"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to act as proconsul",
               "kjv_def": ":--be the deputy.",
               "_strongs": "00445"
            },
            {
               "strongs": "446",
               "greek": [
                  {
                     "_BETA": "A)NQU/PATOS",
                     "_unicode": "ἀνθύπατος",
                     "_translit": "anthýpatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "anth-oo'-pat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     }
                  ],
                  "__text": "from \n and a superlative of \n;"
               },
               "strongs_def": "instead of the highest officer,\n i.e. (specially) a Roman proconsul",
               "kjv_def": ":--deputy.",
               "_strongs": "00446"
            },
            {
               "strongs": "447",
               "greek": [
                  {
                     "_BETA": "A)NI/HMI",
                     "_unicode": "ἀνίημι",
                     "_translit": "aníēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ee'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "I(/HMI",
                        "_unicode": "ἵημι",
                        "_translit": "híēmi"
                     }
                  ],
                  "__text": "from \n and \n (to send);"
               },
               "strongs_def": "to let up, i.e. (literally) slacken or\n (figuratively) desert, desist from",
               "kjv_def": ":--forbear, leave, loose.",
               "_strongs": "00447"
            },
            {
               "strongs": "448",
               "greek": [
                  {
                     "_BETA": "A)NI/LEWS",
                     "_unicode": "ἀνίλεως",
                     "_translit": "aníleōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ee'-leh-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2436"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "inexorable",
               "kjv_def": ":--without mercy.",
               "_strongs": "00448"
            },
            {
               "strongs": "449",
               "greek": [
                  {
                     "_BETA": "A)/NIPTOS",
                     "_unicode": "ἄνιπτος",
                     "_translit": "ániptos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-ip-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3538"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "without ablution",
               "kjv_def": ":--unwashen.",
               "_strongs": "00449"
            },
            {
               "strongs": "450",
               "greek": [
                  {
                     "_BETA": "A)NI/STHMI",
                     "_unicode": "ἀνίστημι",
                     "_translit": "anístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand up (literal or figurative, transitive or\n intransitive)",
               "kjv_def": ":--arise, lift up, raise up (again), rise (again), stand\n up(-right).",
               "_strongs": "00450"
            },
            {
               "strongs": "451",
               "greek": [
                  {
                     "_BETA": "*)/ANNA",
                     "_unicode": "Ἄννα",
                     "_translit": "Ánna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02584"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Anna, an Israelitess",
               "kjv_def": ":--Anna.",
               "_strongs": "00451"
            },
            {
               "strongs": "452",
               "greek": [
                  {
                     "_BETA": "*)/ANNAS",
                     "_unicode": "Ἄννας",
                     "_translit": "Ánnas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-nas"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02608"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "367"
                     }
                  ],
                  "__text": "Annas (i.e. \n), an Israelite"
               },
               "kjv_def": ":--Annas.",
               "_strongs": "00452"
            },
            {
               "strongs": "453",
               "greek": [
                  {
                     "_BETA": "A)NO/HTOS",
                     "_unicode": "ἀνόητος",
                     "_translit": "anóētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-o'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unintelligent; by implication, sensual",
               "kjv_def": ":--fool(-ish), unwise.",
               "_strongs": "00453"
            },
            {
               "strongs": "454",
               "greek": [
                  {
                     "_BETA": "A)/NOIA",
                     "_unicode": "ἄνοια",
                     "_translit": "ánoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-oy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and \n;"
               },
               "strongs_def": "stupidity; by\n implication, rage",
               "kjv_def": ":--folly, madness.",
               "_strongs": "00454"
            },
            {
               "strongs": "455",
               "greek": [
                  {
                     "_BETA": "A)NOI/GW",
                     "_unicode": "ἀνοίγω",
                     "_translit": "anoígō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-oy'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "OI)/GW",
                        "_unicode": "οἴγω",
                        "_translit": "oígō"
                     }
                  ],
                  "__text": "from \n and \n (to open);"
               },
               "strongs_def": "to open up (literally or figuratively, in\n various applications)",
               "kjv_def": ":--open.",
               "_strongs": "00455"
            },
            {
               "strongs": "456",
               "greek": [
                  {
                     "_BETA": "A)NOIKODOME/W",
                     "_unicode": "ἀνοικοδομέω",
                     "_translit": "anoikodoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-oy-kod-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3618"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rebuild",
               "kjv_def": ":--build again.",
               "_strongs": "00456"
            },
            {
               "strongs": "457",
               "greek": [
                  {
                     "_BETA": "A)/NOICIS",
                     "_unicode": "ἄνοιξις",
                     "_translit": "ánoixis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-oix-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "455"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "opening (throat)",
               "kjv_def": ":--X open.",
               "_strongs": "00457"
            },
            {
               "strongs": "458",
               "greek": [
                  {
                     "_BETA": "A)NOMI/A",
                     "_unicode": "ἀνομία",
                     "_translit": "anomía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-om-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "459"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "illegality, i.e. violation of law or (genitive case)\n wickedness",
               "kjv_def": ":--iniquity, X transgress(-ion of) the law, unrighteousness.",
               "_strongs": "00458"
            },
            {
               "strongs": "459",
               "greek": [
                  {
                     "_BETA": "A)/NOMOS",
                     "_unicode": "ἄνομος",
                     "_translit": "ánomos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-om-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "lawless, i.e. (negatively)\n not subject to (the Jewish) law; (by implication, a Gentile), or\n (positively) wicked",
               "kjv_def": ":--without law, lawless, transgressor, unlawful,\n wicked.",
               "_strongs": "00459"
            },
            {
               "strongs": "460",
               "greek": [
                  {
                     "_BETA": "A)NO/MWS",
                     "_unicode": "ἀνόμως",
                     "_translit": "anómōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-om'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "459"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "lawlessly, i.e. (specially) not amenable to (the\n Jewish) law",
               "kjv_def": ":--without law.",
               "_strongs": "00460"
            },
            {
               "strongs": "461",
               "greek": [
                  {
                     "_BETA": "A)NORQO/W",
                     "_unicode": "ἀνορθόω",
                     "_translit": "anorthóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-orth-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3717"
                     }
                  ],
                  "__text": "from \n and a derivative of the base of \n;"
               },
               "strongs_def": "to straighten up",
               "kjv_def": ":--lift\n (set) up, make straight.",
               "_strongs": "00461"
            },
            {
               "strongs": "462",
               "greek": [
                  {
                     "_BETA": "A)NO/SIOS",
                     "_unicode": "ἀνόσιος",
                     "_translit": "anósios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-os'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3741"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "wicked",
               "kjv_def": ":--unholy.",
               "_strongs": "00462"
            },
            {
               "strongs": "463",
               "greek": [
                  {
                     "_BETA": "A)NOXH/",
                     "_unicode": "ἀνοχή",
                     "_translit": "anochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-okh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "430"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "self-restraint, i.e. tolerance",
               "kjv_def": ":--forbearance.",
               "_strongs": "00463"
            },
            {
               "strongs": "464",
               "greek": [
                  {
                     "_BETA": "A)NTAGWNI/ZOMAI",
                     "_unicode": "ἀνταγωνίζομαι",
                     "_translit": "antagōnízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tag-o-nid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "75"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to struggle against (figuratively)\n (\"antagonize\")",
               "kjv_def": ":--strive against.",
               "_strongs": "00464"
            },
            {
               "strongs": "465",
               "greek": [
                  {
                     "_BETA": "A)NTA/LLAGMA",
                     "_unicode": "ἀντάλλαγμα",
                     "_translit": "antállagma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tal'-ag-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "236"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "an equivalent or ransom",
               "kjv_def": ":--in exchange.",
               "_strongs": "00465"
            },
            {
               "strongs": "466",
               "greek": [
                  {
                     "_BETA": "A)NTANAPLHRO/W",
                     "_unicode": "ἀνταναπληρόω",
                     "_translit": "antanaplēróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tan-ap-lay-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "378"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to supplement",
               "kjv_def": ":--fill up.",
               "_strongs": "00466"
            },
            {
               "strongs": "467",
               "greek": [
                  {
                     "_BETA": "A)NTAPODI/DWMI",
                     "_unicode": "ἀνταποδίδωμι",
                     "_translit": "antapodídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tap-od-ee'-do-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "591"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to requite (good or evil)",
               "kjv_def": ":--recompense, render,\n repay.",
               "_strongs": "00467"
            },
            {
               "strongs": "468",
               "greek": [
                  {
                     "_BETA": "A)NTAPO/DOMA",
                     "_unicode": "ἀνταπόδομα",
                     "_translit": "antapódoma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tap-od'-om-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "467"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a requital (properly, the thing)",
               "kjv_def": ":--recompense.",
               "_strongs": "00468"
            },
            {
               "strongs": "469",
               "greek": [
                  {
                     "_BETA": "A)NTAPO/DOSIS",
                     "_unicode": "ἀνταπόδοσις",
                     "_translit": "antapódosis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tap-od'-os-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "467"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "requital (properly, the act)",
               "kjv_def": ":--reward.",
               "_strongs": "00469"
            },
            {
               "strongs": "470",
               "greek": [
                  {
                     "_BETA": "A)NTAPOKRI/NOMAI",
                     "_unicode": "ἀνταποκρίνομαι",
                     "_translit": "antapokrínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tap-ok-ree'-nom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "611"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to contradict or dispute",
               "kjv_def": ":--answer again, reply\n against.",
               "_strongs": "00470"
            },
            {
               "strongs": "471",
               "greek": [
                  {
                     "_BETA": "A)NTE/PW",
                     "_unicode": "ἀντέπω",
                     "_translit": "antépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2036"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to refute or deny",
               "kjv_def": ":--gainsay, say against.",
               "_strongs": "00471"
            },
            {
               "strongs": "472",
               "greek": [
                  {
                     "_BETA": "A)NTE/XOMAI",
                     "_unicode": "ἀντέχομαι",
                     "_translit": "antéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to hold oneself opposite to,\n i.e. (by implication) adhere to; by extension to care for",
               "kjv_def": ":--hold fast,\n hold to, support.",
               "_strongs": "00472"
            },
            {
               "strongs": "473",
               "greek": [
                  {
                     "_BETA": "A)NTI/",
                     "_unicode": "ἀντί",
                     "_translit": "antí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee'"
                  }
               ],
               "strongs_derivation": "a primary particle;",
               "strongs_def": "opposite, i.e. instead or because of (rarely in\n addition to)",
               "kjv_def": ":--for, in the room of.",
               "_strongs": "00473",
               "__text": "Often used in composition to\n denote contrast, requital, substitution, correspondence, etc."
            },
            {
               "strongs": "474",
               "greek": [
                  {
                     "_BETA": "A)NTIBA/LLW",
                     "_unicode": "ἀντιβάλλω",
                     "_translit": "antibállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-bal'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bandy",
               "kjv_def": ":--have.",
               "_strongs": "00474"
            },
            {
               "strongs": "475",
               "greek": [
                  {
                     "_BETA": "A)NTIDIATI/QEMAI",
                     "_unicode": "ἀντιδιατίθεμαι",
                     "_translit": "antidiatíthemai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-dee-at-eeth'-em-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1303"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to set oneself opposite, i.e. be \n disputatious",
               "kjv_def": ":--that oppose themselves.",
               "_strongs": "00475"
            },
            {
               "strongs": "476",
               "greek": [
                  {
                     "_BETA": "A)NTI/DIKOS",
                     "_unicode": "ἀντίδικος",
                     "_translit": "antídikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tid'-ee-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an opponent (in a lawsuit); specially, Satan (as\n the arch-enemy)",
               "kjv_def": ":--adversary.",
               "_strongs": "00476"
            },
            {
               "strongs": "477",
               "greek": [
                  {
                     "_BETA": "A)NTI/QESIS",
                     "_unicode": "ἀντίθεσις",
                     "_translit": "antíthesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tith'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "opposition, i.e. a conflict (of\n theories)",
               "kjv_def": ":--opposition.",
               "_strongs": "00477"
            },
            {
               "strongs": "478",
               "greek": [
                  {
                     "_BETA": "A)NTIKAQI/STHMI",
                     "_unicode": "ἀντικαθίστημι",
                     "_translit": "antikathístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-kath-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2525"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to set down (troops) against, i.e.\n withstand",
               "kjv_def": ":--resist.",
               "_strongs": "00478"
            },
            {
               "strongs": "479",
               "greek": [
                  {
                     "_BETA": "A)NTIKALE/W",
                     "_unicode": "ἀντικαλέω",
                     "_translit": "antikaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-kal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to invite in return",
               "kjv_def": ":--bid again.",
               "_strongs": "00479"
            },
            {
               "strongs": "480",
               "greek": [
                  {
                     "_BETA": "A)NTI/KEIMAI",
                     "_unicode": "ἀντίκειμαι",
                     "_translit": "antíkeimai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tik'-i-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lie opposite, i.e. be adverse (figuratively,\n repugnant) to",
               "kjv_def": ":--adversary, be contrary, oppose.",
               "_strongs": "00480"
            },
            {
               "strongs": "481",
               "greek": [
                  {
                     "_BETA": "A)NTIKRU/",
                     "_unicode": "ἀντικρύ",
                     "_translit": "antikrý"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-kroo'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     }
                  ],
                  "__text": "prolonged from \n;"
               },
               "strongs_def": "opposite",
               "kjv_def": ":--over against.",
               "_strongs": "00481"
            },
            {
               "strongs": "482",
               "greek": [
                  {
                     "_BETA": "A)NTILAMBA/NOMAI",
                     "_unicode": "ἀντιλαμβάνομαι",
                     "_translit": "antilambánomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-lam-ban'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to take hold of in turn, i.e.\n succor; also to participate",
               "kjv_def": ":--help, partaker, support.",
               "_strongs": "00482"
            },
            {
               "strongs": "483",
               "greek": [
                  {
                     "_BETA": "A)NTILE/GW",
                     "_unicode": "ἀντιλέγω",
                     "_translit": "antilégō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-til'-eg-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to dispute, refuse",
               "kjv_def": ":--answer again, contradict,\n deny, gainsay(-er), speak against.",
               "_strongs": "00483"
            },
            {
               "strongs": "484",
               "greek": [
                  {
                     "_BETA": "A)NTI/LHYIS",
                     "_unicode": "ἀντίληψις",
                     "_translit": "antílēpsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-til'-ape-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "482"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "relief",
               "kjv_def": ":--help.",
               "_strongs": "00484"
            },
            {
               "strongs": "485",
               "greek": [
                  {
                     "_BETA": "A)NTILOGI/A",
                     "_unicode": "ἀντιλογία",
                     "_translit": "antilogía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-log-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "483"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "dispute, disobedience",
               "kjv_def": ":--contradiction,\n gainsaying, strife.",
               "_strongs": "00485"
            },
            {
               "strongs": "486",
               "greek": [
                  {
                     "_BETA": "A)NTILOIDORE/W",
                     "_unicode": "ἀντιλοιδορέω",
                     "_translit": "antiloidoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-loy-dor-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3058"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rail in reply",
               "kjv_def": ":--revile again.",
               "_strongs": "00486"
            },
            {
               "strongs": "487",
               "greek": [
                  {
                     "_BETA": "A)NTI/LUTRON",
                     "_unicode": "ἀντίλυτρον",
                     "_translit": "antílytron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-til'-oo-tron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3083"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a redemption-price",
               "kjv_def": ":--ransom.",
               "_strongs": "00487"
            },
            {
               "strongs": "488",
               "greek": [
                  {
                     "_BETA": "A)NTIMETRE/W",
                     "_unicode": "ἀντιμετρέω",
                     "_translit": "antimetréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-met-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3354"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to mete in return",
               "kjv_def": ":--measure again.",
               "_strongs": "00488"
            },
            {
               "strongs": "489",
               "greek": [
                  {
                     "_BETA": "A)NTIMISQI/A",
                     "_unicode": "ἀντιμισθία",
                     "_translit": "antimisthía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-mis-thee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3408"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "requital,\n correspondence",
               "kjv_def": ":--recompense.",
               "_strongs": "00489"
            },
            {
               "strongs": "490",
               "greek": [
                  {
                     "_BETA": "*)ANTIO/XEIA",
                     "_unicode": "Ἀντιόχεια",
                     "_translit": "Antiócheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-okh'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)ANTI/OXUS",
                        "_unicode": "Ἀντίοχυς",
                        "_translit": "Antíochys"
                     }
                  ],
                  "__text": "from \n (a Syrian king);"
               },
               "strongs_def": "Antiochia, a place in Syria",
               "kjv_def": ":--Antioch.",
               "_strongs": "00490"
            },
            {
               "strongs": "491",
               "greek": [
                  {
                     "_BETA": "*)ANTIOXEU/S",
                     "_unicode": "Ἀντιοχεύς",
                     "_translit": "Antiocheús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-okh-yoos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "490"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an Antiochian or inhabitant of Antiochia",
               "kjv_def": ":--of Antioch.",
               "_strongs": "00491"
            },
            {
               "strongs": "492",
               "greek": [
                  {
                     "_BETA": "A)NTIPARE/RXOMAI",
                     "_unicode": "ἀντιπαρέρχομαι",
                     "_translit": "antiparérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-par-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3928"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to go along opposite",
               "kjv_def": ":--pass by on the other side.",
               "_strongs": "00492"
            },
            {
               "strongs": "493",
               "greek": [
                  {
                     "_BETA": "*)ANTI/PAS",
                     "_unicode": "Ἀντίπας",
                     "_translit": "Antípas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee'-pas"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     }
                  ],
                  "__text": "contracted for a compound of \n and a derivative of \n;"
               },
               "strongs_def": "Antipas, a\n Christian",
               "kjv_def": ":--Antipas.",
               "_strongs": "00493"
            },
            {
               "strongs": "494",
               "greek": [
                  {
                     "_BETA": "*)ANTIPATRI/S",
                     "_unicode": "Ἀντιπατρίς",
                     "_translit": "Antipatrís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tip-at-rece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "493"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "Antipatris, a place in Palestine",
               "kjv_def": ":--Antipatris.",
               "_strongs": "00494"
            },
            {
               "strongs": "495",
               "greek": [
                  {
                     "_BETA": "A)NTIPE/RAN",
                     "_unicode": "ἀντιπέραν",
                     "_translit": "antipéran"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-per'-an"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "on the opposite side",
               "kjv_def": ":--over against.",
               "_strongs": "00495"
            },
            {
               "strongs": "496",
               "greek": [
                  {
                     "_BETA": "A)NTIPI/PTW",
                     "_unicode": "ἀντιπίπτω",
                     "_translit": "antipíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-pip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to oppose",
               "kjv_def": ":--resist.",
               "_strongs": "00496"
            },
            {
               "strongs": "497",
               "greek": [
                  {
                     "_BETA": "A)NTISTRATEU/OMAI",
                     "_unicode": "ἀντιστρατεύομαι",
                     "_translit": "antistrateúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-strat-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4754"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(figuratively) to attack, i.e. (by implication)\n destroy",
               "kjv_def": ":--war against.",
               "_strongs": "00497"
            },
            {
               "strongs": "498",
               "greek": [
                  {
                     "_BETA": "A)NTITA/SSOMAI",
                     "_unicode": "ἀντιτάσσομαι",
                     "_translit": "antitássomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee-tas'-som-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to range oneself against, i.e.\n oppose",
               "kjv_def": ":--oppose themselves, resist.",
               "_strongs": "00498"
            },
            {
               "strongs": "499",
               "greek": [
                  {
                     "_BETA": "A)NTI/TUPON",
                     "_unicode": "ἀντίτυπον",
                     "_translit": "antítypon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-teet'-oo-pon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5179"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n;"
               },
               "strongs_def": "corresponding (\"antitype\"), i.e.\n a representative, counterpart",
               "kjv_def": ":--(like) figure (whereunto).",
               "_strongs": "00499"
            },
            {
               "strongs": "500",
               "greek": [
                  {
                     "_BETA": "A)NTI/XRISTOS",
                     "_unicode": "ἀντίχριστος",
                     "_translit": "antíchristos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-tee'-khris-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5547"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an opponent of the Messiah",
               "kjv_def": ":--antichrist.",
               "_strongs": "00500"
            },
            {
               "strongs": "501",
               "greek": [
                  {
                     "_BETA": "A)NTLE/W",
                     "_unicode": "ἀντλέω",
                     "_translit": "antléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ant-leh-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/NTLOS",
                        "_unicode": "ἄντλος",
                        "_translit": "ántlos"
                     }
                  ],
                  "__text": "from \n (the hold of a ship);"
               },
               "strongs_def": "to bale up (properly, bilge water),\n i.e. dip water (with a bucket, pitcher, etc.)",
               "kjv_def": ":--draw (out).",
               "_strongs": "00501"
            },
            {
               "strongs": "502",
               "greek": [
                  {
                     "_BETA": "A)/NTLHMA",
                     "_unicode": "ἄντλημα",
                     "_translit": "ántlēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ant'-lay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "501"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a baling-vessel",
               "kjv_def": ":--thing to draw with.",
               "_strongs": "00502"
            },
            {
               "strongs": "503",
               "greek": [
                  {
                     "_BETA": "A)NTOFQALME/W",
                     "_unicode": "ἀντοφθαλμέω",
                     "_translit": "antophthalméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ant-of-thal-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3788"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to face",
               "kjv_def": ":--bear up into.",
               "_strongs": "00503"
            },
            {
               "strongs": "504",
               "greek": [
                  {
                     "_BETA": "A)/NUDROS",
                     "_unicode": "ἄνυδρος",
                     "_translit": "ánydros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-oo-dros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5204"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "waterless, i.e. dry",
               "kjv_def": ":--dry,\n without water.",
               "_strongs": "00504"
            },
            {
               "strongs": "505",
               "greek": [
                  {
                     "_BETA": "A)NUPO/KRITOS",
                     "_unicode": "ἀνυπόκριτος",
                     "_translit": "anypókritos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-oo-pok'-ree-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5271"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "undissembled, i.e. sincere",
               "kjv_def": ":--without dissimulation (hypocrisy),\n unfeigned.",
               "_strongs": "00505"
            },
            {
               "strongs": "506",
               "greek": [
                  {
                     "_BETA": "A)NUPO/TAKTOS",
                     "_unicode": "ἀνυπότακτος",
                     "_translit": "anypótaktos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-oo-pot'-ak-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5293"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "unsubdued, i.e. insubordinate (in fact or temper)",
               "kjv_def": ":--disobedient, that\n is not put under, unruly.",
               "_strongs": "00506"
            },
            {
               "strongs": "507",
               "greek": [
                  {
                     "_BETA": "A)/NW",
                     "_unicode": "ἄνω",
                     "_translit": "ánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "upward or on the top",
               "kjv_def": ":--above, brim, high, up.",
               "_strongs": "00507"
            },
            {
               "strongs": "508",
               "greek": [
                  {
                     "_BETA": "A)NW/GEON",
                     "_unicode": "ἀνώγεον",
                     "_translit": "anṓgeon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-ogue'-eh-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "507"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1093"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "above the ground, i.e. (properly) the second floor\n of a building; used for a dome or a balcony on the upper story",
               "kjv_def": ":--upper\n room.",
               "_strongs": "00508"
            },
            {
               "strongs": "509",
               "greek": [
                  {
                     "_BETA": "A)/NWQEN",
                     "_unicode": "ἄνωθεν",
                     "_translit": "ánōthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an'-o-then"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "507"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "from above; by analogy, from the first; by implication,\n anew",
               "kjv_def": ":--from above, again, from the beginning (very first), the top.",
               "_strongs": "00509"
            },
            {
               "strongs": "510",
               "greek": [
                  {
                     "_BETA": "A)NWTERIKO/S",
                     "_unicode": "ἀνωτερικός",
                     "_translit": "anōterikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-o-ter-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "511"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "superior, i.e. (locally) more remote",
               "kjv_def": ":--upper.",
               "_strongs": "00510"
            },
            {
               "strongs": "511",
               "greek": [
                  {
                     "_BETA": "A)NW/TEROS",
                     "_unicode": "ἀνώτερος",
                     "_translit": "anṓteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-o'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "507"
                     }
                  ],
                  "__text": "comparative degree of \n;"
               },
               "strongs_def": "upper, i.e. (neuter as adverb) to a more\n conspicuous place, in a former part of the book",
               "kjv_def": ":--above, higher.",
               "_strongs": "00511"
            },
            {
               "strongs": "512",
               "greek": [
                  {
                     "_BETA": "A)NWFELH/S",
                     "_unicode": "ἀνωφελής",
                     "_translit": "anōphelḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "an-o-fel'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5624"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and the base of \n;"
               },
               "strongs_def": "useless or\n (neuter) inutility",
               "kjv_def": ":--unprofitable(-ness).",
               "_strongs": "00512"
            },
            {
               "strongs": "513",
               "greek": [
                  {
                     "_BETA": "A)CI/NH",
                     "_unicode": "ἀξίνη",
                     "_translit": "axínē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ax-ee'-nay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/GNUMI",
                        "_unicode": "ἄγνυμι",
                        "_translit": "ágnymi"
                     }
                  ],
                  "__text": "probably from \n (to break;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "compare \n); an axe"
               },
               "kjv_def": ":--axe.",
               "_strongs": "00513"
            },
            {
               "strongs": "514",
               "greek": [
                  {
                     "_BETA": "A)/CIOS",
                     "_unicode": "ἄξιος",
                     "_translit": "áxios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ax'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "deserving, comparable or suitable (as if drawing\n praise)",
               "kjv_def": ":--due reward, meet, (un-)worthy.",
               "_strongs": "00514"
            },
            {
               "strongs": "515",
               "greek": [
                  {
                     "_BETA": "A)CIO/W",
                     "_unicode": "ἀξιόω",
                     "_translit": "axióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ax-ee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "514"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to deem entitled or fit",
               "kjv_def": ":--desire, think good, count (think)\n worthy.",
               "_strongs": "00515"
            },
            {
               "strongs": "516",
               "greek": [
                  {
                     "_BETA": "A)CI/WS",
                     "_unicode": "ἀξίως",
                     "_translit": "axíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ax-ee'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "514"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "appropriately",
               "kjv_def": ":--as becometh, after a godly sort,\n worthily(-thy).",
               "_strongs": "00516"
            },
            {
               "strongs": "517",
               "greek": [
                  {
                     "_BETA": "A)O/RATOS",
                     "_unicode": "ἀόρατος",
                     "_translit": "aóratos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ah-or'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3707"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "invisible",
               "kjv_def": ":--invisible\n (thing).",
               "_strongs": "00517"
            },
            {
               "strongs": "518",
               "greek": [
                  {
                     "_BETA": "A)PAGGE/LLW",
                     "_unicode": "ἀπαγγέλλω",
                     "_translit": "apangéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ang-el'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to announce",
               "kjv_def": ":--bring word (again),\n declare, report, shew (again), tell.",
               "_strongs": "00518"
            },
            {
               "strongs": "519",
               "greek": [
                  {
                     "_BETA": "A)PA/GXOMAI",
                     "_unicode": "ἀπάγχομαι",
                     "_translit": "apánchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ang'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)/GXW",
                        "_unicode": "ἄγχω",
                        "_translit": "ánchō"
                     }
                  ],
                  "__text": "from \n and \n (to choke; akin to the base of \n);"
               },
               "strongs_def": "to strangle\n oneself off (i.e. to death)",
               "kjv_def": ":--hang himself.",
               "_strongs": "00519"
            },
            {
               "strongs": "520",
               "greek": [
                  {
                     "_BETA": "A)PA/GW",
                     "_unicode": "ἀπάγω",
                     "_translit": "apágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take off (in various senses)",
               "kjv_def": ":--bring, carry away,\n lead (away), put to death, take away.",
               "_strongs": "00520"
            },
            {
               "strongs": "521",
               "greek": [
                  {
                     "_BETA": "A)PAI/DEUTOS",
                     "_unicode": "ἀπαίδευτος",
                     "_translit": "apaídeutos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ah'-ee-dyoo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3811"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "uninstructed, i.e. (figuratively) stupid",
               "kjv_def": ":--unlearned.",
               "_strongs": "00521"
            },
            {
               "strongs": "522",
               "greek": [
                  {
                     "_BETA": "A)PAI/RW",
                     "_unicode": "ἀπαίρω",
                     "_translit": "apaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ah'-ee-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lift off, i.e. remove",
               "kjv_def": ":--take (away).",
               "_strongs": "00522"
            },
            {
               "strongs": "523",
               "greek": [
                  {
                     "_BETA": "A)PAITE/W",
                     "_unicode": "ἀπαιτέω",
                     "_translit": "apaitéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ah'-ee-teh-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to demand back",
               "kjv_def": ":--ask again, require.",
               "_strongs": "00523"
            },
            {
               "strongs": "524",
               "greek": [
                  {
                     "_BETA": "A)PALGE/W",
                     "_unicode": "ἀπαλγέω",
                     "_translit": "apalgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-alg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)LGE/W",
                        "_unicode": "ἀλγέω",
                        "_translit": "algéō"
                     }
                  ],
                  "__text": "from \n and \n (to smart);"
               },
               "strongs_def": "to grieve out, i.e. become\n apathetic",
               "kjv_def": ":--be past feeling.",
               "_strongs": "00524"
            },
            {
               "strongs": "525",
               "greek": [
                  {
                     "_BETA": "A)PALLA/SSW",
                     "_unicode": "ἀπαλλάσσω",
                     "_translit": "apallássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-al-las'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "236"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to change away, i.e. release, (reflexively)\n remove",
               "kjv_def": ":--deliver, depart.",
               "_strongs": "00525"
            },
            {
               "strongs": "526",
               "greek": [
                  {
                     "_BETA": "A)PALLOTRIO/W",
                     "_unicode": "ἀπαλλοτριόω",
                     "_translit": "apallotrióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-al-lot-ree-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "245"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to estrange away, i.e. (passively\n and figuratively) to be non-participant",
               "kjv_def": ":-- alienate, be alien.",
               "_strongs": "00526"
            },
            {
               "strongs": "527",
               "greek": [
                  {
                     "_BETA": "A)PALO/S",
                     "_unicode": "ἀπαλός",
                     "_translit": "apalós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-al-os'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "soft",
               "kjv_def": ":--tender.",
               "_strongs": "00527"
            },
            {
               "strongs": "528",
               "greek": [
                  {
                     "_BETA": "A)PANTA/W",
                     "_unicode": "ἀπαντάω",
                     "_translit": "apantáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-an-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to meet away, i.e. encounter",
               "kjv_def": ":--meet.",
               "_strongs": "00528"
            },
            {
               "strongs": "529",
               "greek": [
                  {
                     "_BETA": "A)PA/NTHSIS",
                     "_unicode": "ἀπάντησις",
                     "_translit": "apántēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-an'-tay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "528"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a (friendly) encounter",
               "kjv_def": ":--meet.",
               "_strongs": "00529"
            },
            {
               "strongs": "530",
               "greek": [
                  {
                     "_BETA": "A(/PAC",
                     "_unicode": "ἅπαξ",
                     "_translit": "hápax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hap'-ax"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "537"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "one (or a single) time (numerically or\n conclusively)",
               "kjv_def": ":--once.",
               "_strongs": "00530"
            },
            {
               "strongs": "531",
               "greek": [
                  {
                     "_BETA": "A)PARA/BATOS",
                     "_unicode": "ἀπαράβατος",
                     "_translit": "aparábatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ar-ab'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3845"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "not passing\n away, i.e. untransferable (perpetual)",
               "kjv_def": ":-- unchangeable.",
               "_strongs": "00531"
            },
            {
               "strongs": "532",
               "greek": [
                  {
                     "_BETA": "A)PARASKEU/ASTOS",
                     "_unicode": "ἀπαρασκεύαστος",
                     "_translit": "aparaskeúastos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ar-ask-yoo'-as-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3903"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unready",
               "kjv_def": ":--unprepared.",
               "_strongs": "00532"
            },
            {
               "strongs": "533",
               "greek": [
                  {
                     "_BETA": "A)PARNE/OMAI",
                     "_unicode": "ἀπαρνέομαι",
                     "_translit": "aparnéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ar-neh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "720"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to deny utterly, i.e. disown, abstain",
               "kjv_def": ":--deny.",
               "_strongs": "00533"
            },
            {
               "strongs": "534",
               "greek": [
                  {
                     "_BETA": "A)PA/RTI",
                     "_unicode": "ἀπάρτι",
                     "_translit": "apárti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ar'-tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "737"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "from now, i.e. henceforth (already)",
               "kjv_def": ":--from\n henceforth.",
               "_strongs": "00534"
            },
            {
               "strongs": "535",
               "greek": [
                  {
                     "_BETA": "A)PARTISMO/S",
                     "_unicode": "ἀπαρτισμός",
                     "_translit": "apartismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ar-tis-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "534"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "completion",
               "kjv_def": ":--finishing.",
               "_strongs": "00535"
            },
            {
               "strongs": "536",
               "greek": [
                  {
                     "_BETA": "A)PARXH/",
                     "_unicode": "ἀπαρχή",
                     "_translit": "aparchḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ar-khay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "756"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a beginning of sacrifice, i.e. the\n (Jewish) first-fruit (figuratively)",
               "kjv_def": ":--first-fruits.",
               "_strongs": "00536"
            },
            {
               "strongs": "537",
               "greek": [
                  {
                     "_BETA": "A(/PAS",
                     "_unicode": "ἅπας",
                     "_translit": "hápas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hap'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     }
                  ],
                  "__text": "from \n (as a particle of union) and \n;"
               },
               "strongs_def": "absolutely all or (singular)\n every one",
               "kjv_def": ":--all (things), every (one), whole.",
               "_strongs": "00537"
            },
            {
               "strongs": "538",
               "greek": [
                  {
                     "_BETA": "A)PATA/W",
                     "_unicode": "ἀπατάω",
                     "_translit": "apatáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-at-ah'-o"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "to cheat, i.e. delude",
               "kjv_def": ":--deceive.",
               "_strongs": "00538"
            },
            {
               "strongs": "539",
               "greek": [
                  {
                     "_BETA": "A)PA/TH",
                     "_unicode": "ἀπάτη",
                     "_translit": "apátē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-at'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "538"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "delusion",
               "kjv_def": ":--deceit(-ful, -fulness), deceivableness(-ving).",
               "_strongs": "00539"
            },
            {
               "strongs": "540",
               "greek": [
                  {
                     "_BETA": "A)PA/TWR",
                     "_unicode": "ἀπάτωρ",
                     "_translit": "apátōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-at'-ore"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "fatherless, i.e. of\n unrecorded paternity",
               "kjv_def": ":--without father.",
               "_strongs": "00540"
            },
            {
               "strongs": "541",
               "greek": [
                  {
                     "_BETA": "A)PAU/GASMA",
                     "_unicode": "ἀπαύγασμα",
                     "_translit": "apaúgasma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ow'-gas-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "826"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "an off-flash, i.e.\n effulgence",
               "kjv_def": ":--brightness.",
               "_strongs": "00541"
            },
            {
               "strongs": "542",
               "greek": [
                  {
                     "_BETA": "A)PEI/DW",
                     "_unicode": "ἀπείδω",
                     "_translit": "apeídō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-i'-do"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "from \n and the same as \n;"
               },
               "strongs_def": "to see fully",
               "kjv_def": ":--see.",
               "_strongs": "00542"
            },
            {
               "strongs": "543",
               "greek": [
                  {
                     "_BETA": "A)PEI/QEIA",
                     "_unicode": "ἀπείθεια",
                     "_translit": "apeítheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-i'-thi-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "545"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "disbelief (obstinate and rebellious)",
               "kjv_def": ":--disobedience,\n unbelief.",
               "_strongs": "00543"
            },
            {
               "strongs": "544",
               "greek": [
                  {
                     "_BETA": "A)PEIQE/W",
                     "_unicode": "ἀπειθέω",
                     "_translit": "apeithéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-i-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "545"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to disbelieve (wilfully and perversely)",
               "kjv_def": ":--not believe,\n disobedient, obey not, unbelieving.",
               "_strongs": "00544"
            },
            {
               "strongs": "545",
               "greek": [
                  {
                     "_BETA": "A)PEIQH/S",
                     "_unicode": "ἀπειθής",
                     "_translit": "apeithḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-i-thace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unpersuadable, i.e.\n contumacious",
               "kjv_def": ":--disobedient.",
               "_strongs": "00545"
            },
            {
               "strongs": "546",
               "greek": [
                  {
                     "_BETA": "A)PEILE/W",
                     "_unicode": "ἀπειλέω",
                     "_translit": "apeiléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-i-leh'-o"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "to menace; by implication, to\n forbid",
               "kjv_def": ":--threaten.",
               "_strongs": "00546"
            },
            {
               "strongs": "547",
               "greek": [
                  {
                     "_BETA": "A)PEILH/",
                     "_unicode": "ἀπειλή",
                     "_translit": "apeilḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-i-lay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "546"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a menace",
               "kjv_def": ":--X straitly, threatening.",
               "_strongs": "00547"
            },
            {
               "strongs": "548",
               "greek": [
                  {
                     "_BETA": "A)/PEIMI",
                     "_unicode": "ἄπειμι",
                     "_translit": "ápeimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be away",
               "kjv_def": ":--be absent.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "549"
                  }
               ],
               "_strongs": "00548",
               "__text": "Compare \n."
            },
            {
               "strongs": "549",
               "greek": [
                  {
                     "_BETA": "A)/PEIMI",
                     "_unicode": "ἄπειμι",
                     "_translit": "ápeimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "from \n and \n (to go);"
               },
               "strongs_def": "to go away",
               "kjv_def": ":--go.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "548"
                  }
               ],
               "_strongs": "00549",
               "__text": "Compare \n."
            },
            {
               "strongs": "550",
               "greek": [
                  {
                     "_BETA": "A)PEIPO/MHN",
                     "_unicode": "ἀπειπόμην",
                     "_translit": "apeipómēn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-i-pom'-ane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2036"
                     }
                  ],
                  "__text": "reflexive past of a compound of \n and \n;"
               },
               "strongs_def": "to say off for oneself,\n i.e. disown",
               "kjv_def": ":--renounce.",
               "_strongs": "00550"
            },
            {
               "strongs": "551",
               "greek": [
                  {
                     "_BETA": "A)PEI/RASTOS",
                     "_unicode": "ἀπείραστος",
                     "_translit": "apeírastos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-i'-ras-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3987"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "untried, i.e. not temptable",
               "kjv_def": ":--not to be tempted.",
               "_strongs": "00551"
            },
            {
               "strongs": "552",
               "greek": [
                  {
                     "_BETA": "A)/PEIROS",
                     "_unicode": "ἄπειρος",
                     "_translit": "ápeiros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap'-i-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3984"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "inexperienced, i.e.\n ignorant",
               "kjv_def": ":--unskilful.",
               "_strongs": "00552"
            },
            {
               "strongs": "553",
               "greek": [
                  {
                     "_BETA": "A)PEKDE/XOMAI",
                     "_unicode": "ἀπεκδέχομαι",
                     "_translit": "apekdéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ek-dekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1551"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to expect fully",
               "kjv_def": ":--look (wait) for.",
               "_strongs": "00553"
            },
            {
               "strongs": "554",
               "greek": [
                  {
                     "_BETA": "A)PEKDU/OMAI",
                     "_unicode": "ἀπεκδύομαι",
                     "_translit": "apekdýomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ek-doo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1562"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to divest wholly oneself, or (for\n oneself) despoil",
               "kjv_def": ":--put off, spoil.",
               "_strongs": "00554"
            },
            {
               "strongs": "555",
               "greek": [
                  {
                     "_BETA": "A)PE/KDUSIS",
                     "_unicode": "ἀπέκδυσις",
                     "_translit": "apékdysis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ek'-doo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "554"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "divestment",
               "kjv_def": ":--putting off.",
               "_strongs": "00555"
            },
            {
               "strongs": "556",
               "greek": [
                  {
                     "_BETA": "A)PELAU/NW",
                     "_unicode": "ἀπελαύνω",
                     "_translit": "apelaúnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-el-ow'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1643"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to dismiss",
               "kjv_def": ":--drive.",
               "_strongs": "00556"
            },
            {
               "strongs": "557",
               "greek": [
                  {
                     "_BETA": "A)PELEGMO/S",
                     "_unicode": "ἀπελεγμός",
                     "_translit": "apelegmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-el-eg-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1651"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "refutation, i.e. (by implication)\n contempt",
               "kjv_def": ":--nought.",
               "_strongs": "00557"
            },
            {
               "strongs": "558",
               "greek": [
                  {
                     "_BETA": "A)PELEU/QEROS",
                     "_unicode": "ἀπελεύθερος",
                     "_translit": "apeleútheros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-el-yoo'-ther-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1658"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "one freed away, i.e. a freedman",
               "kjv_def": ":--freeman.",
               "_strongs": "00558"
            },
            {
               "strongs": "559",
               "greek": [
                  {
                     "_BETA": "*)APELLH=S",
                     "_unicode": "Ἀπελλῆς",
                     "_translit": "Apellēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-el-lace'"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Apelles, a Christian",
               "kjv_def": ":--Apelles.",
               "_strongs": "00559"
            },
            {
               "strongs": "560",
               "greek": [
                  {
                     "_BETA": "A)PELPI/ZW",
                     "_unicode": "ἀπελπίζω",
                     "_translit": "apelpízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-el-pid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1679"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hope out, i.e. fully expect",
               "kjv_def": ":--hope for again.",
               "_strongs": "00560"
            },
            {
               "strongs": "561",
               "greek": [
                  {
                     "_BETA": "A)PE/NANTI",
                     "_unicode": "ἀπέναντι",
                     "_translit": "apénanti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-en'-an-tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1725"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "from in front, i.e. opposite, before or\n against",
               "kjv_def": ":--before, contrary, over against, in the presence of.",
               "_strongs": "00561"
            },
            {
               "strongs": "562",
               "greek": [
                  {
                     "_BETA": "A)PE/RANTOS",
                     "_unicode": "ἀπέραντος",
                     "_translit": "apérantos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-er'-an-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a secondary derivative of \n;"
               },
               "strongs_def": "unfinished, i.e. (by implication) interminable",
               "kjv_def": ":--endless.",
               "_strongs": "00562"
            },
            {
               "strongs": "563",
               "greek": [
                  {
                     "_BETA": "A)PERISPA/STWS",
                     "_unicode": "ἀπερισπάστως",
                     "_translit": "aperispástōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-er-is-pas-toce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4049"
                     }
                  ],
                  "__text": "adverb from a compound of \n (as a negative particle) and a presumed\n derivative of \n;"
               },
               "strongs_def": "undistractedly, i.e. free from (domestic)\n solicitude",
               "kjv_def": ":--without distraction.",
               "_strongs": "00563"
            },
            {
               "strongs": "564",
               "greek": [
                  {
                     "_BETA": "A)PERI/TMHTOS",
                     "_unicode": "ἀπερίτμητος",
                     "_translit": "aperítmētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-er-eet'-may-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4059"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "uncircumcised (figuratively)",
               "kjv_def": ":--uncircumcised.",
               "_strongs": "00564"
            },
            {
               "strongs": "565",
               "greek": [
                  {
                     "_BETA": "A)PE/RXOMAI",
                     "_unicode": "ἀπέρχομαι",
                     "_translit": "apérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-erkh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to go off (i.e. depart), aside (i.e. apart) or\n behind (i.e. follow), literally or figuratively",
               "kjv_def": ":--come, depart, go\n (aside, away, back, out, … ways), pass away, be past.",
               "_strongs": "00565"
            },
            {
               "strongs": "566",
               "greek": [
                  {
                     "_BETA": "A)PE/XEI",
                     "_unicode": "ἀπέχει",
                     "_translit": "apéchei"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ekh'-i"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "568"
                     }
                  ],
                  "__text": "third person singular present indicative active of \n used\n impersonally;"
               },
               "strongs_def": "it is sufficient",
               "kjv_def": ":--it is enough.",
               "_strongs": "00566"
            },
            {
               "strongs": "567",
               "greek": [
                  {
                     "_BETA": "A)PE/XOMAI",
                     "_unicode": "ἀπέχομαι",
                     "_translit": "apéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "568"
                     }
                  ],
                  "__text": "middle voice (reflexively) of \n;"
               },
               "strongs_def": "to hold oneself off, i.e.\n refrain",
               "kjv_def": ":--abstain.",
               "_strongs": "00567"
            },
            {
               "strongs": "568",
               "greek": [
                  {
                     "_BETA": "A)PE/XW",
                     "_unicode": "ἀπέχω",
                     "_translit": "apéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(actively) to have out, i.e. receive in full;\n (intransitively) to keep (oneself) away, i.e. be distant (literally or\n figuratively)",
               "kjv_def": ":--be, have, receive.",
               "_strongs": "00568"
            },
            {
               "strongs": "569",
               "greek": [
                  {
                     "_BETA": "A)PISTE/W",
                     "_unicode": "ἀπιστέω",
                     "_translit": "apistéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-is-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "571"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be unbelieving, i.e. (transitively) disbelieve, or (by\n implication) disobey",
               "kjv_def": ":--believe not.",
               "_strongs": "00569"
            },
            {
               "strongs": "570",
               "greek": [
                  {
                     "_BETA": "A)PISTI/A",
                     "_unicode": "ἀπιστία",
                     "_translit": "apistía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-is-tee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "571"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "faithlessness, i.e. (negatively) disbelief (lack of\n Christian faith), or (positively) unfaithfulness\n (disobedience)",
               "kjv_def": ":--unbelief.",
               "_strongs": "00570"
            },
            {
               "strongs": "571",
               "greek": [
                  {
                     "_BETA": "A)/PISTOS",
                     "_unicode": "ἄπιστος",
                     "_translit": "ápistos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap'-is-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4103"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "(actively) disbelieving,\n i.e. without Christian faith (specially, a heathen); (passively)\n untrustworthy (person), or incredible (thing)",
               "kjv_def": ":--that believeth not,\n faithless, incredible thing, infidel, unbeliever(-ing).",
               "_strongs": "00571"
            },
            {
               "strongs": "572",
               "greek": [
                  {
                     "_BETA": "A(PLO/THS",
                     "_unicode": "ἁπλότης",
                     "_translit": "haplótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hap-lot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "573"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "singleness, i.e. (subjectively) sincerity (without\n dissimulation or self-seeking), or (objectively) generosity (copious\n bestowal)",
               "kjv_def": ":--bountifulness, liberal(-ity), simplicity, singleness.",
               "_strongs": "00572"
            },
            {
               "strongs": "573",
               "greek": [
                  {
                     "_BETA": "A(PLOU=S",
                     "_unicode": "ἁπλοῦς",
                     "_translit": "haploûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hap-looce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4120"
                     }
                  ],
                  "__text": "probably from \n (as a particle of union) and the base of \n;"
               },
               "strongs_def": "properly, folded together, i.e. single (figuratively, clear)",
               "kjv_def": ":--single.",
               "_strongs": "00573"
            },
            {
               "strongs": "574",
               "greek": [
                  {
                     "_BETA": "A(PLW=S",
                     "_unicode": "ἁπλῶς",
                     "_translit": "haplōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hap-loce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "573"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "572"
                     }
                  ],
                  "__text": "adverb from \n (in the objective sense of \n);"
               },
               "strongs_def": "bountifully;",
               "kjv_def": "--liberally.",
               "_strongs": "00574"
            },
            {
               "strongs": "575",
               "greek": [
                  {
                     "_BETA": "A)PO/",
                     "_unicode": "ἀπό",
                     "_translit": "apó"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "apo'"
                  }
               ],
               "strongs_derivation": "a primary particle;",
               "strongs_def": "\"off,\" i.e. away (from something near), in various\n senses (of place, time, or relation; literal or figurative)",
               "kjv_def": ":--(X\n here-)after, ago, at, because of, before, by (the space of), for(-th),\n from, in, (out) of, off, (up-)on(-ce), since, with.",
               "_strongs": "00575",
               "__text": "In composition (as\n a prefix) it usually denotes separation, departure, cessation,\n completion, reversal, etc."
            },
            {
               "strongs": "576",
               "greek": [
                  {
                     "_BETA": "A)POBAI/NW",
                     "_unicode": "ἀποβαίνω",
                     "_translit": "apobaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ob-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "literally, to disembark; figuratively,\n to eventuate",
               "kjv_def": ":--become, go out, turn.",
               "_strongs": "00576"
            },
            {
               "strongs": "577",
               "greek": [
                  {
                     "_BETA": "A)POBA/LLW",
                     "_unicode": "ἀποβάλλω",
                     "_translit": "apobállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ob-al'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw off; figuratively, to lose",
               "kjv_def": ":--cast away.",
               "_strongs": "00577"
            },
            {
               "strongs": "578",
               "greek": [
                  {
                     "_BETA": "A)POBLE/PW",
                     "_unicode": "ἀποβλέπω",
                     "_translit": "apoblépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ob-lep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to look away from everything else, i.e.\n (figuratively) intently regard",
               "kjv_def": ":--have respect.",
               "_strongs": "00578"
            },
            {
               "strongs": "579",
               "greek": [
                  {
                     "_BETA": "A)PO/BLHTOS",
                     "_unicode": "ἀπόβλητος",
                     "_translit": "apóblētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ob'-lay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "577"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cast off, i.e. (figuratively) such as to be rejected",
               "kjv_def": ":--be\n refused.",
               "_strongs": "00579"
            },
            {
               "strongs": "580",
               "greek": [
                  {
                     "_BETA": "A)POBOLH/",
                     "_unicode": "ἀποβολή",
                     "_translit": "apobolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ob-ol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "577"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "rejection; figuratively, loss",
               "kjv_def": ":--casting away, loss.",
               "_strongs": "00580"
            },
            {
               "strongs": "581",
               "greek": [
                  {
                     "_BETA": "A)POGENO/MENOS",
                     "_unicode": "ἀπογενόμενος",
                     "_translit": "apogenómenos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-og-en-om'-en-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "past participle of a compound of \n and \n;"
               },
               "strongs_def": "absent, i.e. deceased\n (figuratively, renounced)",
               "kjv_def": ":--being dead.",
               "_strongs": "00581"
            },
            {
               "strongs": "582",
               "greek": [
                  {
                     "_BETA": "A)POGRAFH/",
                     "_unicode": "ἀπογραφή",
                     "_translit": "apographḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-og-raf-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "583"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an enrollment; by implication, an assessment",
               "kjv_def": ":--taxing.",
               "_strongs": "00582"
            },
            {
               "strongs": "583",
               "greek": [
                  {
                     "_BETA": "A)POGRA/FW",
                     "_unicode": "ἀπογράφω",
                     "_translit": "apográphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-og-raf'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to write off (a copy or list), i.e. enrol",
               "kjv_def": ":--tax,\n write.",
               "_strongs": "00583"
            },
            {
               "strongs": "584",
               "greek": [
                  {
                     "_BETA": "A)PODEI/KNUMI",
                     "_unicode": "ἀποδείκνυμι",
                     "_translit": "apodeíknymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od-ike'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1166"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to show off, i.e. exhibit; figuratively, to\n demonstrate, i.e. accredit",
               "kjv_def": ":--(ap-)prove, set forth, shew.",
               "_strongs": "00584"
            },
            {
               "strongs": "585",
               "greek": [
                  {
                     "_BETA": "A)PO/DEICIS",
                     "_unicode": "ἀπόδειξις",
                     "_translit": "apódeixis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od'-ike-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "584"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "manifestation",
               "kjv_def": ":--demonstration.",
               "_strongs": "00585"
            },
            {
               "strongs": "586",
               "greek": [
                  {
                     "_BETA": "A)PODEKATO/W",
                     "_unicode": "ἀποδεκατόω",
                     "_translit": "apodekatóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od-ek-at-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1183"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tithe (as debtor or creditor)",
               "kjv_def": ":--(give, pay,\n take) tithe.",
               "_strongs": "00586"
            },
            {
               "strongs": "587",
               "greek": [
                  {
                     "_BETA": "A)PO/DEKTOS",
                     "_unicode": "ἀπόδεκτος",
                     "_translit": "apódektos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od'-ek-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "588"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "accepted, i.e. agreeable",
               "kjv_def": ":--acceptable.",
               "_strongs": "00587"
            },
            {
               "strongs": "588",
               "greek": [
                  {
                     "_BETA": "A)PODE/XOMAI",
                     "_unicode": "ἀποδέχομαι",
                     "_translit": "apodéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od-ekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take fully, i.e. welcome (persons), approve\n (things)",
               "kjv_def": ":--accept, receive (gladly).",
               "_strongs": "00588"
            },
            {
               "strongs": "589",
               "greek": [
                  {
                     "_BETA": "A)PODHME/W",
                     "_unicode": "ἀποδημέω",
                     "_translit": "apodēméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od-ay-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "590"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to go abroad, i.e. visit a foreign land",
               "kjv_def": ":--go (travel) into a\n far country, journey.",
               "_strongs": "00589"
            },
            {
               "strongs": "590",
               "greek": [
                  {
                     "_BETA": "A)PO/DHMOS",
                     "_unicode": "ἀπόδημος",
                     "_translit": "apódēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od'-ay-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "absent from one's own people, i.e. a foreign\n traveller",
               "kjv_def": ":--taking a far journey.",
               "_strongs": "00590"
            },
            {
               "strongs": "591",
               "greek": [
                  {
                     "_BETA": "A)PODI/DWMI",
                     "_unicode": "ἀποδίδωμι",
                     "_translit": "apodídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od-eed'-o-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give away, i.e. up, over, back, etc. (in various\n applications)",
               "kjv_def": ":--deliver (again), give (again), (re-)pay(-ment be\n made), perform, recompense, render, requite, restore, reward, sell,\n yield.",
               "_strongs": "00591"
            },
            {
               "strongs": "592",
               "greek": [
                  {
                     "_BETA": "A)PODIORI/ZW",
                     "_unicode": "ἀποδιορίζω",
                     "_translit": "apodiorízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od-ee-or-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3724"
                     }
                  ],
                  "__text": "from \n and a compound of \n and \n;"
               },
               "strongs_def": "to disjoin (by a boundary,\n figuratively, a party)",
               "kjv_def": ":--separate.",
               "_strongs": "00592"
            },
            {
               "strongs": "593",
               "greek": [
                  {
                     "_BETA": "A)PODOKIMA/ZW",
                     "_unicode": "ἀποδοκιμάζω",
                     "_translit": "apodokimázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od-ok-ee-mad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1381"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to disapprove, i.e. (by implication) to\n repudiate",
               "kjv_def": ":--disallow, reject.",
               "_strongs": "00593"
            },
            {
               "strongs": "594",
               "greek": [
                  {
                     "_BETA": "A)PODOXH/",
                     "_unicode": "ἀποδοχή",
                     "_translit": "apodochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-od-okh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "588"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "acceptance",
               "kjv_def": ":--acceptation.",
               "_strongs": "00594"
            },
            {
               "strongs": "595",
               "greek": [
                  {
                     "_BETA": "A)PO/QESIS",
                     "_unicode": "ἀπόθεσις",
                     "_translit": "apóthesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-oth'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "659"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a laying aside (literally or figuratively)",
               "kjv_def": ":--putting away\n (off).",
               "_strongs": "00595"
            },
            {
               "strongs": "596",
               "greek": [
                  {
                     "_BETA": "A)POQH/KH",
                     "_unicode": "ἀποθήκη",
                     "_translit": "apothḗkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-oth-ay'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "659"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a repository, i.e. granary",
               "kjv_def": ":--barn, garner.",
               "_strongs": "00596"
            },
            {
               "strongs": "597",
               "greek": [
                  {
                     "_BETA": "A)POQHSAURI/ZW",
                     "_unicode": "ἀποθησαυρίζω",
                     "_translit": "apothēsaurízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-oth-ay-sow-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2343"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to treasure away",
               "kjv_def": ":--lay up in store.",
               "_strongs": "00597"
            },
            {
               "strongs": "598",
               "greek": [
                  {
                     "_BETA": "A)POQLI/BW",
                     "_unicode": "ἀποθλίβω",
                     "_translit": "apothlíbō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-oth-lee'-bo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2346"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to crowd (from every side)",
               "kjv_def": ":--press.",
               "_strongs": "00598"
            },
            {
               "strongs": "599",
               "greek": [
                  {
                     "_BETA": "A)POQNH/SKW",
                     "_unicode": "ἀποθνήσκω",
                     "_translit": "apothnḗskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-oth-nace'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2348"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to die off (literally or figuratively)",
               "kjv_def": ":--be dead,\n death, die, lie a-dying, be slain (X with).",
               "_strongs": "00599"
            },
            {
               "strongs": "600",
               "greek": [
                  {
                     "_BETA": "A)POKAQI/STHMI",
                     "_unicode": "ἀποκαθίστημι",
                     "_translit": "apokathístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-ath-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2525"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reconstitute (in health, home or\n organization)",
               "kjv_def": ":--restore (again).",
               "_strongs": "00600"
            },
            {
               "strongs": "601",
               "greek": [
                  {
                     "_BETA": "A)POKALU/PTW",
                     "_unicode": "ἀποκαλύπτω",
                     "_translit": "apokalýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-al-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take off the cover, i.e. disclose",
               "kjv_def": ":--reveal.",
               "_strongs": "00601"
            },
            {
               "strongs": "602",
               "greek": [
                  {
                     "_BETA": "A)POKA/LUYIS",
                     "_unicode": "ἀποκάλυψις",
                     "_translit": "apokálypsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-al'-oop-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "601"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "disclosure",
               "kjv_def": ":--appearing, coming, lighten, manifestation, be\n revealed, revelation.",
               "_strongs": "00602"
            },
            {
               "strongs": "603",
               "greek": [
                  {
                     "_BETA": "A)POKARADOKI/A",
                     "_unicode": "ἀποκαραδοκία",
                     "_translit": "apokaradokía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-ar-ad-ok-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1380"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KA/RA",
                        "_unicode": "κάρα",
                        "_translit": "kára"
                     }
                  ],
                  "__text": "from a compound of \n and a compound of \n (the head) and \n\n (in the sense of watching);"
               },
               "strongs_def": "intense anticipation",
               "kjv_def": ":--earnest\n expectation.",
               "_strongs": "00603"
            },
            {
               "strongs": "604",
               "greek": [
                  {
                     "_BETA": "A)POKATALLA/SSW",
                     "_unicode": "ἀποκαταλλάσσω",
                     "_translit": "apokatallássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-at-al-las'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2644"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reconcile fully",
               "kjv_def": ":--reconcile.",
               "_strongs": "00604"
            },
            {
               "strongs": "605",
               "greek": [
                  {
                     "_BETA": "A)POKATA/STASIS",
                     "_unicode": "ἀποκατάστασις",
                     "_translit": "apokatástasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-at-as'-tas-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "600"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "reconstitution",
               "kjv_def": ":--restitution.",
               "_strongs": "00605"
            },
            {
               "strongs": "606",
               "greek": [
                  {
                     "_BETA": "A)PO/KEIMAI",
                     "_unicode": "ἀπόκειμαι",
                     "_translit": "apókeimai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok'-i-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be reserved; figuratively, to await",
               "kjv_def": ":--be\n appointed, (be) laid up.",
               "_strongs": "00606"
            },
            {
               "strongs": "607",
               "greek": [
                  {
                     "_BETA": "A)POKEFALI/ZW",
                     "_unicode": "ἀποκεφαλίζω",
                     "_translit": "apokephalízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-ef-al-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2776"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to decapitate",
               "kjv_def": ":--behead.",
               "_strongs": "00607"
            },
            {
               "strongs": "608",
               "greek": [
                  {
                     "_BETA": "A)POKLEI/W",
                     "_unicode": "ἀποκλείω",
                     "_translit": "apokleíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-li'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2808"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to close fully",
               "kjv_def": ":--shut up.",
               "_strongs": "00608"
            },
            {
               "strongs": "609",
               "greek": [
                  {
                     "_BETA": "A)POKO/PTW",
                     "_unicode": "ἀποκόπτω",
                     "_translit": "apokóptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-op'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to amputate; reflexively (by irony) to mutilate\n (the privy parts)",
               "kjv_def": ":--cut off.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2699"
                  }
               ],
               "_strongs": "00609",
               "__text": "Compare \n."
            },
            {
               "strongs": "610",
               "greek": [
                  {
                     "_BETA": "A)PO/KRIMA",
                     "_unicode": "ἀπόκριμα",
                     "_translit": "apókrima"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok'-ree-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "611"
                     }
                  ],
                  "__text": "from \n (in its original sense of judging);"
               },
               "strongs_def": "a judicial\n decision",
               "kjv_def": ":--sentence.",
               "_strongs": "00610"
            },
            {
               "strongs": "611",
               "greek": [
                  {
                     "_BETA": "A)POKRI/NOMAI",
                     "_unicode": "ἀποκρίνομαι",
                     "_translit": "apokrínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-ree'-nom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KRI/NW",
                        "_unicode": "κρίνω",
                        "_translit": "krínō"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06030"
                     }
                  ],
                  "__text": "to conclude for oneself, i.e. (by implication) to\n respond; by Hebraism (compare \n) to begin to speak (where an\n address is expected)"
               },
               "kjv_def": ":--answer.",
               "_strongs": "00611"
            },
            {
               "strongs": "612",
               "greek": [
                  {
                     "_BETA": "A)PO/KRISIS",
                     "_unicode": "ἀπόκρισις",
                     "_translit": "apókrisis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok'-ree-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "611"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a response",
               "kjv_def": ":--answer.",
               "_strongs": "00612"
            },
            {
               "strongs": "613",
               "greek": [
                  {
                     "_BETA": "A)POKRU/PTW",
                     "_unicode": "ἀποκρύπτω",
                     "_translit": "apokrýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-roop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2928"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to conceal away (i.e. fully); figuratively, to keep\n secret",
               "kjv_def": ":--hide.",
               "_strongs": "00613"
            },
            {
               "strongs": "614",
               "greek": [
                  {
                     "_BETA": "A)PO/KRUFOS",
                     "_unicode": "ἀπόκρυφος",
                     "_translit": "apókryphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok'-roo-fos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "613"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "secret; by implication, treasured",
               "kjv_def": ":--hid, kept secret.",
               "_strongs": "00614"
            },
            {
               "strongs": "615",
               "greek": [
                  {
                     "_BETA": "A)POKTEI/NW",
                     "_unicode": "ἀποκτείνω",
                     "_translit": "apokteínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-ti'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KTEI/NW",
                        "_unicode": "κτείνω",
                        "_translit": "kteínō"
                     }
                  ],
                  "__text": "from \n and \n (to slay);"
               },
               "strongs_def": "to kill outright; figuratively, to\n destroy",
               "kjv_def": ":--put to death, kill, slay.",
               "_strongs": "00615"
            },
            {
               "strongs": "616",
               "greek": [
                  {
                     "_BETA": "A)POKUE/W",
                     "_unicode": "ἀποκυέω",
                     "_translit": "apokyéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-oo-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2949"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to breed forth, i.e. (by transference)\n to generate (figuratively)",
               "kjv_def": ":--beget, produce.",
               "_strongs": "00616"
            },
            {
               "strongs": "617",
               "greek": [
                  {
                     "_BETA": "A)POKULI/W",
                     "_unicode": "ἀποκυλίω",
                     "_translit": "apokylíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ok-oo-lee'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2947"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to roll away",
               "kjv_def": ":--roll away (back).",
               "_strongs": "00617"
            },
            {
               "strongs": "618",
               "greek": [
                  {
                     "_BETA": "A)POLAMBA/NW",
                     "_unicode": "ἀπολαμβάνω",
                     "_translit": "apolambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-am-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to receive (specially, in full, or as a host); also\n to take aside",
               "kjv_def": ":--receive, take.",
               "_strongs": "00618"
            },
            {
               "strongs": "619",
               "greek": [
                  {
                     "_BETA": "A)PO/LAUSIS",
                     "_unicode": "ἀπόλαυσις",
                     "_translit": "apólausis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol'-ow-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "LAU/W",
                        "_unicode": "λαύω",
                        "_translit": "laúō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to enjoy);"
               },
               "strongs_def": "full\n enjoyment",
               "kjv_def": ":--enjoy(-ment).",
               "_strongs": "00619"
            },
            {
               "strongs": "620",
               "greek": [
                  {
                     "_BETA": "A)POLEI/PW",
                     "_unicode": "ἀπολείπω",
                     "_translit": "apoleípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-ipe'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to leave behind (passively, remain); by\n implication, to forsake",
               "kjv_def": ":--leave, remain.",
               "_strongs": "00620"
            },
            {
               "strongs": "621",
               "greek": [
                  {
                     "_BETA": "A)POLEI/XW",
                     "_unicode": "ἀπολείχω",
                     "_translit": "apoleíchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-i'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "LEI/XW",
                        "_unicode": "λείχω",
                        "_translit": "leíchō"
                     }
                  ],
                  "__text": "from \n and \n (to \"lick\");"
               },
               "strongs_def": "to lick clean",
               "kjv_def": ":--lick.",
               "_strongs": "00621"
            },
            {
               "strongs": "622",
               "greek": [
                  {
                     "_BETA": "A)PO/LLUMI",
                     "_unicode": "ἀπόλλυμι",
                     "_translit": "apóllymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol'-loo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3639"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to destroy fully (reflexively, to\n perish, or lose), literally or figuratively",
               "kjv_def": ":--destroy, die, lose, mar,\n perish.",
               "_strongs": "00622"
            },
            {
               "strongs": "623",
               "greek": [
                  {
                     "_BETA": "*)APOLLU/WN",
                     "_unicode": "Ἀπολλύων",
                     "_translit": "Apollýōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-loo'-ohn"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "622"
                     }
                  ],
                  "__text": "active participle of \n;"
               },
               "strongs_def": "a destroyer (i.e. Satan)",
               "kjv_def": ":--Apollyon.",
               "_strongs": "00623"
            },
            {
               "strongs": "624",
               "greek": [
                  {
                     "_BETA": "*)APOLLWNI/A",
                     "_unicode": "Ἀπολλωνία",
                     "_translit": "Apollōnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-lo-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)APO/LLWN",
                        "_unicode": "Ἀπόλλων",
                        "_translit": "Apóllōn"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "622"
                     }
                  ],
                  "__text": "from the pagan deity \n (i.e. the sun; from \n);"
               },
               "strongs_def": "Apollonia, a\n place in Macedonia",
               "kjv_def": ":--Apollonia.",
               "_strongs": "00624"
            },
            {
               "strongs": "625",
               "greek": [
                  {
                     "_BETA": "*)APOLLW=S",
                     "_unicode": "Ἀπολλῶς",
                     "_translit": "Apollōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-loce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "624"
                     }
                  ],
                  "__text": "probably from the same as \n;"
               },
               "strongs_def": "Apollos, an Israelite",
               "kjv_def": ":--Apollos.",
               "_strongs": "00625"
            },
            {
               "strongs": "626",
               "greek": [
                  {
                     "_BETA": "A)POLOGE/OMAI",
                     "_unicode": "ἀπολογέομαι",
                     "_translit": "apologéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-og-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "middle voice from a compound of \n and \n;"
               },
               "strongs_def": "to give an account\n (legal plea) of oneself, i.e. exculpate (self)",
               "kjv_def": ":--answer (for self),\n make defence, excuse (self), speak for self.",
               "_strongs": "00626"
            },
            {
               "strongs": "627",
               "greek": [
                  {
                     "_BETA": "A)POLOGI/A",
                     "_unicode": "ἀπολογία",
                     "_translit": "apología"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "626"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a plea (\"apology\")",
               "kjv_def": ":--answer (for self), clearing\n of self, defence.",
               "_strongs": "00627"
            },
            {
               "strongs": "628",
               "greek": [
                  {
                     "_BETA": "A)POLOU/W",
                     "_unicode": "ἀπολούω",
                     "_translit": "apoloúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3068"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to wash fully, i.e. (figuratively) have remitted\n (reflexively)",
               "kjv_def": ":--wash (away).",
               "_strongs": "00628"
            },
            {
               "strongs": "629",
               "greek": [
                  {
                     "_BETA": "A)POLU/TRWSIS",
                     "_unicode": "ἀπολύτρωσις",
                     "_translit": "apolýtrōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-oo'-tro-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3083"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "(the act) ransom in full, i.e.\n (figuratively) riddance, or (specially) Christian\n salvation",
               "kjv_def": ":--deliverance, redemption.",
               "_strongs": "00629"
            },
            {
               "strongs": "630",
               "greek": [
                  {
                     "_BETA": "A)POLU/W",
                     "_unicode": "ἀπολύω",
                     "_translit": "apolýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ol-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to free fully, i.e. (literally) relieve, release,\n dismiss (reflexively, depart), or (figuratively) let die, pardon or\n (specially) divorce",
               "kjv_def": ":--(let) depart, dismiss, divorce, forgive, let go,\n loose, put (send) away, release, set at liberty.",
               "_strongs": "00630"
            },
            {
               "strongs": "631",
               "greek": [
                  {
                     "_BETA": "A)POMA/SSOMAI",
                     "_unicode": "ἀπομάσσομαι",
                     "_translit": "apomássomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-om-as'-som-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "MA/SSW",
                        "_unicode": "μάσσω",
                        "_translit": "mássō"
                     }
                  ],
                  "__text": "middle voice from \n and \n (to squeeze, knead, smear);"
               },
               "strongs_def": "to scrape\n away",
               "kjv_def": ":--wipe off.",
               "_strongs": "00631"
            },
            {
               "strongs": "632",
               "greek": [
                  {
                     "_BETA": "A)PONE/MW",
                     "_unicode": "ἀπονέμω",
                     "_translit": "aponémō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-on-em'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to apportion, i.e. bestow",
               "kjv_def": ":--give.",
               "_strongs": "00632"
            },
            {
               "strongs": "633",
               "greek": [
                  {
                     "_BETA": "A)PONI/PTW",
                     "_unicode": "ἀπονίπτω",
                     "_translit": "aponíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-on-ip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3538"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to wash off (reflexively, one's own hands\n symbolically)",
               "kjv_def": ":--wash.",
               "_strongs": "00633"
            },
            {
               "strongs": "634",
               "greek": [
                  {
                     "_BETA": "A)POPI/PTW",
                     "_unicode": "ἀποπίπτω",
                     "_translit": "apopíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-op-ip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fall off",
               "kjv_def": ":--fall.",
               "_strongs": "00634"
            },
            {
               "strongs": "635",
               "greek": [
                  {
                     "_BETA": "A)POPLANA/W",
                     "_unicode": "ἀποπλανάω",
                     "_translit": "apoplanáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-op-lan-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4105"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead astray (figuratively); passively, to stray\n (from truth)",
               "kjv_def": ":--err, seduce.",
               "_strongs": "00635"
            },
            {
               "strongs": "636",
               "greek": [
                  {
                     "_BETA": "A)POPLE/W",
                     "_unicode": "ἀποπλέω",
                     "_translit": "apopléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-op-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to set sail",
               "kjv_def": ":--sail away.",
               "_strongs": "00636"
            },
            {
               "strongs": "637",
               "greek": [
                  {
                     "_BETA": "A)POPLU/NW",
                     "_unicode": "ἀποπλύνω",
                     "_translit": "apoplýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-op-loo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4150"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rinse off",
               "kjv_def": ":--wash.",
               "_strongs": "00637"
            },
            {
               "strongs": "638",
               "greek": [
                  {
                     "_BETA": "A)POPNI/GW",
                     "_unicode": "ἀποπνίγω",
                     "_translit": "apopnígō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-op-nee'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4155"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stifle (by drowning or overgrowth)",
               "kjv_def": ":--choke.",
               "_strongs": "00638"
            },
            {
               "strongs": "639",
               "greek": [
                  {
                     "_BETA": "A)PORE/W",
                     "_unicode": "ἀπορέω",
                     "_translit": "aporéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-or-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and the base of \n;"
               },
               "strongs_def": "to\n have no way out, i.e. be at a loss (mentally)",
               "kjv_def": ":-- (stand in) doubt, be\n perplexed.",
               "_strongs": "00639"
            },
            {
               "strongs": "640",
               "greek": [
                  {
                     "_BETA": "A)PORI/A",
                     "_unicode": "ἀπορία",
                     "_translit": "aporía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-or-ee'-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "639"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a (state of) quandary",
               "kjv_def": ":--perplexity.",
               "_strongs": "00640"
            },
            {
               "strongs": "641",
               "greek": [
                  {
                     "_BETA": "A)POR)R(I/PTW",
                     "_unicode": "ἀποῤῥίπτω",
                     "_translit": "aporrhíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-or-hrip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4496"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hurl off, i.e. precipitate (oneself)",
               "kjv_def": ":--cast.",
               "_strongs": "00641"
            },
            {
               "strongs": "642",
               "greek": [
                  {
                     "_BETA": "A)PORFANI/ZW",
                     "_unicode": "ἀπορφανίζω",
                     "_translit": "aporphanízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-or-fan-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3737"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to bereave wholly, i.e.\n (figuratively) separate (from intercourse)",
               "kjv_def": ":--take.",
               "_strongs": "00642"
            },
            {
               "strongs": "643",
               "greek": [
                  {
                     "_BETA": "A)POSKEUA/ZW",
                     "_unicode": "ἀποσκευάζω",
                     "_translit": "aposkeuázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-osk-yoo-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4632"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to pack up (one's) baggage",
               "kjv_def": ":--take\n up… carriages.",
               "_strongs": "00643"
            },
            {
               "strongs": "644",
               "greek": [
                  {
                     "_BETA": "A)POSKI/ASMA",
                     "_unicode": "ἀποσκίασμα",
                     "_translit": "aposkíasma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-kee'-as-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4639"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "a shading off, i.e.\n obscuration",
               "kjv_def": ":--shadow.",
               "_strongs": "00644"
            },
            {
               "strongs": "645",
               "greek": [
                  {
                     "_BETA": "A)POSPA/W",
                     "_unicode": "ἀποσπάω",
                     "_translit": "apospáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-pah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4685"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to drag forth, i.e. (literally) unsheathe (a\n sword), or relatively (with a degree of force implied) retire\n (personally or factiously)",
               "kjv_def": ":--(with-)draw (away), after we were gotten\n from.",
               "_strongs": "00645"
            },
            {
               "strongs": "646",
               "greek": [
                  {
                     "_BETA": "A)POSTASI/A",
                     "_unicode": "ἀποστασία",
                     "_translit": "apostasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-tas-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "647"
                     }
                  ],
                  "__text": "feminine of the same as \n;"
               },
               "strongs_def": "defection from truth (properly, the\n state) (\"apostasy\")",
               "kjv_def": ":--falling away, forsake.",
               "_strongs": "00646"
            },
            {
               "strongs": "647",
               "greek": [
                  {
                     "_BETA": "A)POSTA/SION",
                     "_unicode": "ἀποστάσιον",
                     "_translit": "apostásion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-tas'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "868"
                     }
                  ],
                  "__text": "neuter of a (presumed) adjective from a derivative of \n;"
               },
               "strongs_def": "properly,\n something separative, i.e. (specially) divorce",
               "kjv_def": ":--(writing of)\n divorcement.",
               "_strongs": "00647"
            },
            {
               "strongs": "648",
               "greek": [
                  {
                     "_BETA": "A)POSTEGA/ZW",
                     "_unicode": "ἀποστεγάζω",
                     "_translit": "apostegázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-teg-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4721"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to unroof",
               "kjv_def": ":--uncover.",
               "_strongs": "00648"
            },
            {
               "strongs": "649",
               "greek": [
                  {
                     "_BETA": "A)POSTE/LLW",
                     "_unicode": "ἀποστέλλω",
                     "_translit": "apostéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-tel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4724"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "set apart, i.e. (by implication) to send out\n (properly, on a mission) literally or figuratively",
               "kjv_def": ":--put in, send\n (away, forth, out), set (at liberty).",
               "_strongs": "00649"
            },
            {
               "strongs": "650",
               "greek": [
                  {
                     "_BETA": "A)POSTERE/W",
                     "_unicode": "ἀποστερέω",
                     "_translit": "aposteréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-ter-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "STERE/W",
                        "_unicode": "στερέω",
                        "_translit": "steréō"
                     }
                  ],
                  "__text": "from \n and \n (to deprive);"
               },
               "strongs_def": "to despoil",
               "kjv_def": ":--defraud, destitute,\n kept back by fraud.",
               "_strongs": "00650"
            },
            {
               "strongs": "651",
               "greek": [
                  {
                     "_BETA": "A)POSTOLH/",
                     "_unicode": "ἀποστολή",
                     "_translit": "apostolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-tol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "649"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "commission, i.e. (specially) apostolate",
               "kjv_def": ":--apostleship.",
               "_strongs": "00651"
            },
            {
               "strongs": "652",
               "greek": [
                  {
                     "_BETA": "A)PO/STOLOS",
                     "_unicode": "ἀπόστολος",
                     "_translit": "apóstolos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os'-tol-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "649"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a delegate; specially, an ambassador of the Gospel;\n officially a commissioner of Christ (\"apostle\") (with miraculous\n powers)",
               "kjv_def": ":--apostle, messenger, he that is sent.",
               "_strongs": "00652"
            },
            {
               "strongs": "653",
               "greek": [
                  {
                     "_BETA": "A)POSTOMATI/ZW",
                     "_unicode": "ἀποστοματίζω",
                     "_translit": "apostomatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-tom-at-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4750"
                     }
                  ],
                  "__text": "from \n and a (presumed) derivative of \n;"
               },
               "strongs_def": "to speak off-hand\n (properly, dictate), i.e. to catechize (in an invidious\n manner)",
               "kjv_def": ":--provoke to speak.",
               "_strongs": "00653"
            },
            {
               "strongs": "654",
               "greek": [
                  {
                     "_BETA": "A)POSTRE/FW",
                     "_unicode": "ἀποστρέφω",
                     "_translit": "apostréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to turn away or back (literally or\n figuratively)",
               "kjv_def": ":--bring again, pervert, turn away (from).",
               "_strongs": "00654"
            },
            {
               "strongs": "655",
               "greek": [
                  {
                     "_BETA": "A)POSTUGE/W",
                     "_unicode": "ἀποστυγέω",
                     "_translit": "apostygéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-toog-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4767"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to detest utterly",
               "kjv_def": ":--abhor.",
               "_strongs": "00655"
            },
            {
               "strongs": "656",
               "greek": [
                  {
                     "_BETA": "A)POSUNA/GWGOS",
                     "_unicode": "ἀποσυνάγωγος",
                     "_translit": "aposynágōgos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-os-oon-ag'-o-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4864"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "excommunicated",
               "kjv_def": ":--(put) out of the synagogue(-s).",
               "_strongs": "00656"
            },
            {
               "strongs": "657",
               "greek": [
                  {
                     "_BETA": "A)POTA/SSOMAI",
                     "_unicode": "ἀποτάσσομαι",
                     "_translit": "apotássomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-as'-som-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "literally, to say adieu (by departing\n or dismissing); figuratively, to renounce",
               "kjv_def": ":--bid farewell, forsake,\n take leave, send away.",
               "_strongs": "00657"
            },
            {
               "strongs": "658",
               "greek": [
                  {
                     "_BETA": "A)POTELE/W",
                     "_unicode": "ἀποτελέω",
                     "_translit": "apoteléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-el-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5055"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to complete entirely, i.e. consummate",
               "kjv_def": ":--finish.",
               "_strongs": "00658"
            },
            {
               "strongs": "659",
               "greek": [
                  {
                     "_BETA": "A)POTI/QHMI",
                     "_unicode": "ἀποτίθημι",
                     "_translit": "apotíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-eeth'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to put away (literally or figuratively)",
               "kjv_def": ":--cast off,\n lay apart (aside, down), put away (off).",
               "_strongs": "00659"
            },
            {
               "strongs": "660",
               "greek": [
                  {
                     "_BETA": "A)POTINA/SSW",
                     "_unicode": "ἀποτινάσσω",
                     "_translit": "apotinássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-in-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TINA/SSW",
                        "_unicode": "τινάσσω",
                        "_translit": "tinássō"
                     }
                  ],
                  "__text": "from \n and \n (to jostle);"
               },
               "strongs_def": "to brush off",
               "kjv_def": ":--shake off.",
               "_strongs": "00660"
            },
            {
               "strongs": "661",
               "greek": [
                  {
                     "_BETA": "A)POTI/NW",
                     "_unicode": "ἀποτίνω",
                     "_translit": "apotínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-ee'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5099"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to pay in full",
               "kjv_def": ":--repay.",
               "_strongs": "00661"
            },
            {
               "strongs": "662",
               "greek": [
                  {
                     "_BETA": "A)POTOLMA/W",
                     "_unicode": "ἀποτολμάω",
                     "_translit": "apotolmáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-ol-mah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5111"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to venture plainly",
               "kjv_def": ":--be very bold.",
               "_strongs": "00662"
            },
            {
               "strongs": "663",
               "greek": [
                  {
                     "_BETA": "A)POTOMI/A",
                     "_unicode": "ἀποτομία",
                     "_translit": "apotomía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-om-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "664"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "(figuratively) decisiveness, i.e.\n rigor",
               "kjv_def": ":--severity.",
               "_strongs": "00663"
            },
            {
               "strongs": "664",
               "greek": [
                  {
                     "_BETA": "A)POTO/MWS",
                     "_unicode": "ἀποτόμως",
                     "_translit": "apotómōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-om'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TE/MNW",
                        "_unicode": "τέμνω",
                        "_translit": "témnō"
                     }
                  ],
                  "__text": "adverb from a derivative of a comparative of \n and \n (to cut);"
               },
               "strongs_def": "abruptly, i.e. peremptorily",
               "kjv_def": ":--sharply(-ness).",
               "_strongs": "00664"
            },
            {
               "strongs": "665",
               "greek": [
                  {
                     "_BETA": "A)POTRE/PW",
                     "_unicode": "ἀποτρέπω",
                     "_translit": "apotrépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ot-rep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to deflect, i.e. (reflexively)\n avoid",
               "kjv_def": ":--turn away.",
               "_strongs": "00665"
            },
            {
               "strongs": "666",
               "greek": [
                  {
                     "_BETA": "A)POUSI/A",
                     "_unicode": "ἀπουσία",
                     "_translit": "apousía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-oo-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "548"
                     }
                  ],
                  "__text": "from the participle of \n;"
               },
               "strongs_def": "a being away",
               "kjv_def": ":--absence.",
               "_strongs": "00666"
            },
            {
               "strongs": "667",
               "greek": [
                  {
                     "_BETA": "A)POFE/RW",
                     "_unicode": "ἀποφέρω",
                     "_translit": "apophérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-of-er'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear off (literally or relatively)",
               "kjv_def": ":--bring,\n carry (away).",
               "_strongs": "00667"
            },
            {
               "strongs": "668",
               "greek": [
                  {
                     "_BETA": "A)POFEU/GW",
                     "_unicode": "ἀποφεύγω",
                     "_translit": "apopheúgō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-of-yoo'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5343"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(figuratively) to escape",
               "kjv_def": ":--escape.",
               "_strongs": "00668"
            },
            {
               "strongs": "669",
               "greek": [
                  {
                     "_BETA": "A)POFQE/GGOMAI",
                     "_unicode": "ἀποφθέγγομαι",
                     "_translit": "apophthéngomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-of-theng'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5350"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to enunciate plainly, i.e. declare",
               "kjv_def": ":--say, speak\n forth, utterance.",
               "_strongs": "00669"
            },
            {
               "strongs": "670",
               "greek": [
                  {
                     "_BETA": "A)POFORTI/ZOMAI",
                     "_unicode": "ἀποφορτίζομαι",
                     "_translit": "apophortízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-of-or-tid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5412"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to unload",
               "kjv_def": ":--unlade.",
               "_strongs": "00670"
            },
            {
               "strongs": "671",
               "greek": [
                  {
                     "_BETA": "A)PO/XRHSIS",
                     "_unicode": "ἀπόχρησις",
                     "_translit": "apóchrēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-okh'-ray-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "the act of using up, i.e.\n consumption",
               "kjv_def": ":--using.",
               "_strongs": "00671"
            },
            {
               "strongs": "672",
               "greek": [
                  {
                     "_BETA": "A)POXWRE/W",
                     "_unicode": "ἀποχωρέω",
                     "_translit": "apochōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-okh-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5562"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to go away",
               "kjv_def": ":--depart.",
               "_strongs": "00672"
            },
            {
               "strongs": "673",
               "greek": [
                  {
                     "_BETA": "A)POXWRI/ZW",
                     "_unicode": "ἀποχωρίζω",
                     "_translit": "apochōrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-okh-o-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5563"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rend apart; reflexively, to separate",
               "kjv_def": ":--depart\n (asunder).",
               "_strongs": "00673"
            },
            {
               "strongs": "674",
               "greek": [
                  {
                     "_BETA": "A)POYU/XW",
                     "_unicode": "ἀποψύχω",
                     "_translit": "apopsýchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ops-oo'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5594"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to breathe out, i.e. faint",
               "kjv_def": ":--hearts failing.",
               "_strongs": "00674"
            },
            {
               "strongs": "675",
               "greek": [
                  {
                     "_BETA": "*)/APPIOS",
                     "_unicode": "Ἄππιος",
                     "_translit": "Áppios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap'-pee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "(in the genitive, i.e. possessive case) of Appius,\n the name of a Roman",
               "kjv_def": ":--Appii.",
               "_strongs": "00675"
            },
            {
               "strongs": "676",
               "greek": [
                  {
                     "_BETA": "A)PRO/SITOS",
                     "_unicode": "ἀπρόσιτος",
                     "_translit": "aprósitos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ros'-ee-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of a compound of\n \n and \n (to go);"
               },
               "strongs_def": "inaccessible",
               "kjv_def": ":--which no man can approach.",
               "_strongs": "00676"
            },
            {
               "strongs": "677",
               "greek": [
                  {
                     "_BETA": "A)PRO/SKOPOS",
                     "_unicode": "ἀπρόσκοπος",
                     "_translit": "apróskopos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ros'-kop-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4350"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "actively, inoffensive, i.e. not leading into sin; passively,\n faultless, i.e. not led into sin",
               "kjv_def": ":--none (void of, without) offence.",
               "_strongs": "00677"
            },
            {
               "strongs": "678",
               "greek": [
                  {
                     "_BETA": "A)PROSWPOLH/PTWS",
                     "_unicode": "ἀπροσωπολήπτως",
                     "_translit": "aprosōpolḗptōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-ros-o-pol-ape'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4383"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4381"
                     }
                  ],
                  "__text": "adverb from a compound of \n (as a negative particle) and a presumed\n derivative of a presumed compound of \n and \n (compare \n);"
               },
               "strongs_def": "in\n a way not accepting the person, i.e. impartially",
               "kjv_def": ":--without respect of\n persons.",
               "_strongs": "00678"
            },
            {
               "strongs": "679",
               "greek": [
                  {
                     "_BETA": "A)/PTAISTOS",
                     "_unicode": "ἄπταιστος",
                     "_translit": "áptaistos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-tah'-ee-stos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4417"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "not\n stumbling, i.e. (figuratively) without sin",
               "kjv_def": ":--from falling.",
               "_strongs": "00679"
            },
            {
               "strongs": "680",
               "greek": [
                  {
                     "_BETA": "A(/PTOMAI",
                     "_unicode": "ἅπτομαι",
                     "_translit": "háptomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hap'-tom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "681"
                     }
                  ],
                  "__text": "reflexive of \n;"
               },
               "strongs_def": "properly, to attach oneself to, i.e. to touch (in\n many implied relations)",
               "kjv_def": ":--touch.",
               "_strongs": "00680"
            },
            {
               "strongs": "681",
               "greek": [
                  {
                     "_BETA": "A(/PTW",
                     "_unicode": "ἅπτω",
                     "_translit": "háptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hap'-to"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "properly, to fasten to, i.e. (specially) to set on\n fire",
               "kjv_def": ":--kindle, light.",
               "_strongs": "00681"
            },
            {
               "strongs": "682",
               "greek": [
                  {
                     "_BETA": "*)APFI/A",
                     "_unicode": "Ἀπφία",
                     "_translit": "Apphía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-fee'-a"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Apphia, a woman of Collosæ",
               "kjv_def": ":--Apphia.",
               "_strongs": "00682"
            },
            {
               "strongs": "683",
               "greek": [
                  {
                     "_BETA": "A)PWQE/OMAI",
                     "_unicode": "ἀπωθέομαι",
                     "_translit": "apōthéomai"
                  },
                  {
                     "_BETA": "A)PW/QOMAI",
                     "_unicode": "ἀπώθομαι",
                     "_translit": "apṓthomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-o-theh'-om-ahee"
                  },
                  {
                     "_strongs": "ap-o'-thom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "W)QE/W",
                        "_unicode": "ὠθέω",
                        "_translit": "ōthéō"
                     },
                     {
                        "_BETA": "W)/QW",
                        "_unicode": "ὤθω",
                        "_translit": "ṓthō"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n or \n (to shove);"
               },
               "strongs_def": "to push\n off, figuratively, to reject",
               "kjv_def": ":--cast away, put away (from), thrust away\n (from).",
               "_strongs": "00683",
               "__text": "or"
            },
            {
               "strongs": "684",
               "greek": [
                  {
                     "_BETA": "A)PW/LEIA",
                     "_unicode": "ἀπώλεια",
                     "_translit": "apṓleia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap-o'-li-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "622"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "ruin or loss (physical, spiritual\n or eternal)",
               "kjv_def": ":--damnable(-nation), destruction, die, perdition, X\n perish, pernicious ways, waste.",
               "_strongs": "00684"
            },
            {
               "strongs": "685",
               "greek": [
                  {
                     "_BETA": "A)RA/",
                     "_unicode": "ἀρά",
                     "_translit": "ará"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "properly, prayer (as lifted to Heaven), i.e. (by\n implication) imprecation",
               "kjv_def": ":--curse.",
               "_strongs": "00685"
            },
            {
               "strongs": "686",
               "greek": [
                  {
                     "_BETA": "A)/RA",
                     "_unicode": "ἄρα",
                     "_translit": "ára"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "probably from \n (through the idea of drawing a conclusion);"
               },
               "strongs_def": "a\n particle denoting an inference more or less decisive (as\n follows)",
               "kjv_def": ":--haply, (what) manner (of man), no doubt, perhaps, so be,\n then, therefore, truly, wherefore.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1065"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3767"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1487"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "687"
                  }
               ],
               "_strongs": "00686",
               "__text": "Often used in connection with other\n particles, especially \n or \n (after) or \n (before). Compare\n also \n."
            },
            {
               "strongs": "687",
               "greek": [
                  {
                     "_BETA": "A)=RA",
                     "_unicode": "ἆρα",
                     "_translit": "âra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "686"
                     }
                  ],
                  "__text": "a form of \n, denoting an interrogation to which a negative answer is\n presumed"
               },
               "kjv_def": ":--therefore.",
               "_strongs": "00687"
            },
            {
               "strongs": "688",
               "greek": [
                  {
                     "_BETA": "*)ARABI/A",
                     "_unicode": "Ἀραβία",
                     "_translit": "Arabía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-ab-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06152"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Arabia, a region of Asia",
               "kjv_def": ":--Arabia.",
               "_strongs": "00688"
            },
            {
               "strongs": "689",
               "greek": [
                  {
                     "_BETA": "*)ARA/M",
                     "_unicode": "Ἀράμ",
                     "_translit": "Arám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-am'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07410"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Aram (i.e. Ram), an Israelite",
               "kjv_def": ":--Aram.",
               "_strongs": "00689"
            },
            {
               "strongs": "690",
               "greek": [
                  {
                     "_BETA": "*)/ARAY",
                     "_unicode": "Ἄραψ",
                     "_translit": "Áraps"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-aps"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "688"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an Arab or native of Arabia",
               "kjv_def": ":--Arabian.",
               "_strongs": "00690"
            },
            {
               "strongs": "691",
               "greek": [
                  {
                     "_BETA": "A)RGE/W",
                     "_unicode": "ἀργέω",
                     "_translit": "argéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "arg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "692"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be idle, i.e. (figuratively) to delay",
               "kjv_def": ":--linger.",
               "_strongs": "00691"
            },
            {
               "strongs": "692",
               "greek": [
                  {
                     "_BETA": "A)RGO/S",
                     "_unicode": "ἀργός",
                     "_translit": "argós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "inactive, i.e. unemployed;\n (by implication) lazy, useless",
               "kjv_def": ":--barren, idle, slow.",
               "_strongs": "00692"
            },
            {
               "strongs": "693",
               "greek": [
                  {
                     "_BETA": "A)RGU/REOS",
                     "_unicode": "ἀργύρεος",
                     "_translit": "argýreos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-goo'-reh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "696"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "made of silver",
               "kjv_def": ":--(of) silver.",
               "_strongs": "00693"
            },
            {
               "strongs": "694",
               "greek": [
                  {
                     "_BETA": "A)RGU/RION",
                     "_unicode": "ἀργύριον",
                     "_translit": "argýrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-goo'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "696"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "silvery, i.e. (by implication)\n cash; specially, a silverling (i.e. drachma or shekel)",
               "kjv_def": ":--money, (piece\n of) silver (piece).",
               "_strongs": "00694"
            },
            {
               "strongs": "695",
               "greek": [
                  {
                     "_BETA": "A)RGUROKO/POS",
                     "_unicode": "ἀργυροκόπος",
                     "_translit": "argyrokópos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-goo-rok-op'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "696"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a beater (i.e. worker) of silver",
               "kjv_def": ":--silversmith.",
               "_strongs": "00695"
            },
            {
               "strongs": "696",
               "greek": [
                  {
                     "_BETA": "A)/RGUROS",
                     "_unicode": "ἄργυρος",
                     "_translit": "árgyros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-goo-ros"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)RGO/S",
                        "_unicode": "ἀργός",
                        "_translit": "argós"
                     }
                  ],
                  "__text": "from \n (shining);"
               },
               "strongs_def": "silver (the metal, in the articles or\n coin)",
               "kjv_def": ":--silver.",
               "_strongs": "00696"
            },
            {
               "strongs": "697",
               "greek": [
                  {
                     "_BETA": "*)/AREIOS *PA/GOS",
                     "_unicode": "Ἄρειος Πάγος",
                     "_translit": "Áreios Págos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-i-os pag'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)/ARHS",
                        "_unicode": "Ἄρης",
                        "_translit": "Árēs"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4078"
                     }
                  ],
                  "__text": "from \n (the name of the Greek deity of war) and a derivative of\n \n;"
               },
               "strongs_def": "rock of Ares, a place in Athens",
               "kjv_def": ":--Areopagus, Mars' Hill.",
               "_strongs": "00697"
            },
            {
               "strongs": "698",
               "greek": [
                  {
                     "_BETA": "*)AREOPAGI/THS",
                     "_unicode": "Ἀρεοπαγίτης",
                     "_translit": "Areopagítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-eh-op-ag-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "697"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an Areopagite or member of the court held on Mars'\n Hill",
               "kjv_def": ":--Areopagite.",
               "_strongs": "00698"
            },
            {
               "strongs": "699",
               "greek": [
                  {
                     "_BETA": "A)RESKEI/A",
                     "_unicode": "ἀρεσκεία",
                     "_translit": "areskeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-es'-ki-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "700"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "complaisance",
               "kjv_def": ":--pleasing.",
               "_strongs": "00699"
            },
            {
               "strongs": "700",
               "greek": [
                  {
                     "_BETA": "A)RE/SKW",
                     "_unicode": "ἀρέσκω",
                     "_translit": "aréskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-es'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "probably from \n (through the idea of exciting emotion);"
               },
               "strongs_def": "to be\n agreeable (or by implication, to seek to be so)",
               "kjv_def": ":--please.",
               "_strongs": "00700"
            },
            {
               "strongs": "701",
               "greek": [
                  {
                     "_BETA": "A)RESTO/S",
                     "_unicode": "ἀρεστός",
                     "_translit": "arestós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-es-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "700"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "agreeable; by implication, fit",
               "kjv_def": ":--(things that) please(-ing),\n reason.",
               "_strongs": "00701"
            },
            {
               "strongs": "702",
               "greek": [
                  {
                     "_BETA": "*)ARE/TAS",
                     "_unicode": "Ἀρέτας",
                     "_translit": "Arétas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-et'-as"
                  }
               ],
               "strongs_derivation": "of foreign origin;",
               "strongs_def": "Aretas, an Arabian",
               "kjv_def": ":--Aretas.",
               "_strongs": "00702"
            },
            {
               "strongs": "703",
               "greek": [
                  {
                     "_BETA": "A)RE/TH",
                     "_unicode": "ἀρέτη",
                     "_translit": "arétē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-et'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "730"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "properly, manliness (valor), i.e. excellence\n (intrinsic or attributed)",
               "kjv_def": ":--praise, virtue.",
               "_strongs": "00703"
            },
            {
               "strongs": "704",
               "greek": [
                  {
                     "_BETA": "A)RH/N",
                     "_unicode": "ἀρήν",
                     "_translit": "arḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-ane'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "730"
                     }
                  ],
                  "__text": "perhaps the same as \n;"
               },
               "strongs_def": "a lamb (as a male)",
               "kjv_def": ":--lamb.",
               "_strongs": "00704"
            },
            {
               "strongs": "705",
               "greek": [
                  {
                     "_BETA": "A)RIQME/W",
                     "_unicode": "ἀριθμέω",
                     "_translit": "arithméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-ith-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "706"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to enumerate or count",
               "kjv_def": ":--number.",
               "_strongs": "00705"
            },
            {
               "strongs": "706",
               "greek": [
                  {
                     "_BETA": "A)RIQMO/S",
                     "_unicode": "ἀριθμός",
                     "_translit": "arithmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-ith-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a number (as reckoned up)",
               "kjv_def": ":--number.",
               "_strongs": "00706"
            },
            {
               "strongs": "707",
               "greek": [
                  {
                     "_BETA": "*)ARIMAQAI/A",
                     "_unicode": "Ἀριμαθαία",
                     "_translit": "Arimathaía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-ee-math-ah'-ee-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07414"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Arimathæa (or Ramah), a place in\n Palestine",
               "kjv_def": ":--Arimathæa.",
               "_strongs": "00707"
            },
            {
               "strongs": "708",
               "greek": [
                  {
                     "_BETA": "*)ARI/STARXOS",
                     "_unicode": "Ἀρίσταρχος",
                     "_translit": "Arístarchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-is'-tar-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "712"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from the same as \n and \n;"
               },
               "strongs_def": "best ruling; Aristarchus, a\n Macedonian",
               "kjv_def": ":--Aristarchus.",
               "_strongs": "00708"
            },
            {
               "strongs": "709",
               "greek": [
                  {
                     "_BETA": "A)RISTA/W",
                     "_unicode": "ἀριστάω",
                     "_translit": "aristáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-is-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "712"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to take the principle meal",
               "kjv_def": ":--dine.",
               "_strongs": "00709"
            },
            {
               "strongs": "710",
               "greek": [
                  {
                     "_BETA": "A)RISTERO/S",
                     "_unicode": "ἀριστερός",
                     "_translit": "aristerós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-is-ter-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "712"
                     }
                  ],
                  "__text": "apparently a comparative of the same as \n;"
               },
               "strongs_def": "the left hand (as\n second-best)",
               "kjv_def": ":--left (hand).",
               "_strongs": "00710"
            },
            {
               "strongs": "711",
               "greek": [
                  {
                     "_BETA": "*)ARISTO/BOULOS",
                     "_unicode": "Ἀριστόβουλος",
                     "_translit": "Aristóboulos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-is-tob'-oo-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "712"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1012"
                     }
                  ],
                  "__text": "from the same as \n and \n;"
               },
               "strongs_def": "best counselling; Aristoboulus, a\n Christian",
               "kjv_def": ":--Aristobulus.",
               "_strongs": "00711"
            },
            {
               "strongs": "712",
               "greek": [
                  {
                     "_BETA": "A)/RISTON",
                     "_unicode": "ἄριστον",
                     "_translit": "áriston"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-is-ton"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "730"
                     }
                  ],
                  "__text": "apparently neuter of a superlative from the same as \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "H)=RI",
                        "_unicode": "ἦρι",
                        "_translit": "ēri"
                     }
                  ],
                  "__text": "the best meal\n (or breakfast; perhaps from \n (\"early\")), i.e. luncheon"
               },
               "kjv_def": ":--dinner.",
               "_strongs": "00712"
            },
            {
               "strongs": "713",
               "greek": [
                  {
                     "_BETA": "A)RKETO/S",
                     "_unicode": "ἀρκετός",
                     "_translit": "arketós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-ket-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "714"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "satisfactory",
               "kjv_def": ":--enough, suffice (-ient).",
               "_strongs": "00713"
            },
            {
               "strongs": "714",
               "greek": [
                  {
                     "_BETA": "A)RKE/W",
                     "_unicode": "ἀρκέω",
                     "_translit": "arkéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "apparently a primary verb (but probably akin to \n through the idea\n of raising a barrier);"
               },
               "strongs_def": "properly, to ward off, i.e. (by implication) to\n avail (figuratively, be satisfactory)",
               "kjv_def": ":--be content, be enough,\n suffice, be sufficient.",
               "_strongs": "00714"
            },
            {
               "strongs": "715",
               "greek": [
                  {
                     "_BETA": "A)/RKTOS",
                     "_unicode": "ἄρκτος",
                     "_translit": "árktos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ark'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "714"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "a bear (as obstructing by ferocity)",
               "kjv_def": ":--bear.",
               "_strongs": "00715"
            },
            {
               "strongs": "716",
               "greek": [
                  {
                     "_BETA": "A(/RMA",
                     "_unicode": "ἅρμα",
                     "_translit": "hárma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "har'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "__text": "probably from \n (perhaps with \n (as a particle of union) prefixed);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "719"
                     }
                  ],
                  "__text": "a chariot (as raised or fitted together (compare \n))"
               },
               "kjv_def": ":--chariot.",
               "_strongs": "00716"
            },
            {
               "strongs": "717",
               "greek": [
                  {
                     "_BETA": "*)ARMAGEDDW/N",
                     "_unicode": "Ἀρμαγεδδών",
                     "_translit": "Armageddṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-mag-ed-dohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02022"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "04023"
                     }
                  ],
                  "__text": "of Hebrew origin (\n and \n);"
               },
               "strongs_def": "Armageddon (or Har-Meggiddon), a\n symbolic name",
               "kjv_def": ":--Armageddon.",
               "_strongs": "00717"
            },
            {
               "strongs": "718",
               "greek": [
                  {
                     "_BETA": "A(RMO/ZW",
                     "_unicode": "ἁρμόζω",
                     "_translit": "harmózō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "har-mod'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "719"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to joint, i.e. (figuratively) to woo (reflexively, to\n betroth)",
               "kjv_def": ":--espouse.",
               "_strongs": "00718"
            },
            {
               "strongs": "719",
               "greek": [
                  {
                     "_BETA": "A(RMO/S",
                     "_unicode": "ἁρμός",
                     "_translit": "harmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "har-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "716"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "an articulation (of the body)",
               "kjv_def": ":--joint.",
               "_strongs": "00719"
            },
            {
               "strongs": "720",
               "greek": [
                  {
                     "_BETA": "A)RNE/OMAI",
                     "_unicode": "ἀρνέομαι",
                     "_translit": "arnéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-neh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     }
                  ],
                  "__text": "perhaps from \n (as a negative particle) and the middle voice of \n;"
               },
               "strongs_def": "to contradict, i.e. disavow, reject, abnegate",
               "kjv_def": ":--deny, refuse.",
               "_strongs": "00720"
            },
            {
               "strongs": "721",
               "greek": [
                  {
                     "_BETA": "A)RNI/ON",
                     "_unicode": "ἀρνίον",
                     "_translit": "arníon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-nee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "704"
                     }
                  ],
                  "__text": "diminutive from \n;"
               },
               "strongs_def": "a lambkin",
               "kjv_def": ":--lamb.",
               "_strongs": "00721"
            },
            {
               "strongs": "722",
               "greek": [
                  {
                     "_BETA": "A)ROTRIO/W",
                     "_unicode": "ἀροτριόω",
                     "_translit": "arotrióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-ot-ree-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "723"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to plow",
               "kjv_def": ":--plough.",
               "_strongs": "00722"
            },
            {
               "strongs": "723",
               "greek": [
                  {
                     "_BETA": "A)/ROTRON",
                     "_unicode": "ἄροτρον",
                     "_translit": "árotron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-ot-ron"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)RO/W",
                        "_unicode": "ἀρόω",
                        "_translit": "aróō"
                     }
                  ],
                  "__text": "from \n (to till);"
               },
               "strongs_def": "a plow",
               "kjv_def": ":--plough.",
               "_strongs": "00723"
            },
            {
               "strongs": "724",
               "greek": [
                  {
                     "_BETA": "A(RPAGH/",
                     "_unicode": "ἁρπαγή",
                     "_translit": "harpagḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "har-pag-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "726"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pillage (properly abstract)",
               "kjv_def": ":--extortion, ravening, spoiling.",
               "_strongs": "00724"
            },
            {
               "strongs": "725",
               "greek": [
                  {
                     "_BETA": "A(RPAGMO/S",
                     "_unicode": "ἁρπαγμός",
                     "_translit": "harpagmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "har-pag-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "726"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "plunder (properly concrete)",
               "kjv_def": ":--robbery.",
               "_strongs": "00725"
            },
            {
               "strongs": "726",
               "greek": [
                  {
                     "_BETA": "A(RPA/ZW",
                     "_unicode": "ἁρπάζω",
                     "_translit": "harpázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "har-pad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to seize (in various applications)",
               "kjv_def": ":--catch\n (away, up), pluck, pull, take (by force).",
               "_strongs": "00726"
            },
            {
               "strongs": "727",
               "greek": [
                  {
                     "_BETA": "A(/RPAC",
                     "_unicode": "ἅρπαξ",
                     "_translit": "hárpax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "har'-pax"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "726"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "rapacious",
               "kjv_def": ":--extortion, ravening.",
               "_strongs": "00727"
            },
            {
               "strongs": "728",
               "greek": [
                  {
                     "_BETA": "A)R)R(ABW/N",
                     "_unicode": "ἀῤῥαβών",
                     "_translit": "arrhabṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-hrab-ohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06162"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "a pledge, i.e. part of the purchase-money or\n property given in advance as security for the rest",
               "kjv_def": ":--earnest.",
               "_strongs": "00728"
            },
            {
               "strongs": "729",
               "greek": [
                  {
                     "_BETA": "A)/R)R(AFOS",
                     "_unicode": "ἄῤῥαφος",
                     "_translit": "árrhaphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-hhraf-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4476"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of the same\n as \n;"
               },
               "strongs_def": "unsewed, i.e. of a single piece",
               "kjv_def": ":--without seam.",
               "_strongs": "00729"
            },
            {
               "strongs": "730",
               "greek": [
                  {
                     "_BETA": "A)/R)R(HN",
                     "_unicode": "ἄῤῥην",
                     "_translit": "árrhēn"
                  },
                  {
                     "_BETA": "A)/RSHN",
                     "_unicode": "ἄρσην",
                     "_translit": "ársēn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-hrane"
                  },
                  {
                     "_strongs": "ar'-sane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "male (as stronger for lifting)",
               "kjv_def": ":--male, man.",
               "_strongs": "00730",
               "__text": "or"
            },
            {
               "strongs": "731",
               "greek": [
                  {
                     "_BETA": "A)/R)R(HTOS",
                     "_unicode": "ἄῤῥητος",
                     "_translit": "árrhētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-hray-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4490"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and the same as \n;"
               },
               "strongs_def": "unsaid, i.e. (by\n implication) inexpressible",
               "kjv_def": ":--unspeakable.",
               "_strongs": "00731"
            },
            {
               "strongs": "732",
               "greek": [
                  {
                     "_BETA": "A)/R)R(WSTOS",
                     "_unicode": "ἄῤῥωστος",
                     "_translit": "árrhōstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-hroce-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4517"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "infirm",
               "kjv_def": ":--sick (folk, -ly).",
               "_strongs": "00732"
            },
            {
               "strongs": "733",
               "greek": [
                  {
                     "_BETA": "A)RSENOKOI/THS",
                     "_unicode": "ἀρσενοκοίτης",
                     "_translit": "arsenokoítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-sen-ok-oy'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "730"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2845"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a sodomite",
               "kjv_def": ":--abuser of (that defile) self with\n mankind.",
               "_strongs": "00733"
            },
            {
               "strongs": "734",
               "greek": [
                  {
                     "_BETA": "*)ARTEMA/S",
                     "_unicode": "Ἀρτεμάς",
                     "_translit": "Artemás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-tem-as'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "735"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1435"
                     }
                  ],
                  "__text": "contracted from a compound of \n and \n;"
               },
               "strongs_def": "gift of Artemis; Artemas\n (or Artemidorus), a Christian",
               "kjv_def": ":--Artemas.",
               "_strongs": "00734"
            },
            {
               "strongs": "735",
               "greek": [
                  {
                     "_BETA": "*)/ARTEMIS",
                     "_unicode": "Ἄρτεμις",
                     "_translit": "Ártemis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-tem-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "736"
                     }
                  ],
                  "__text": "probably from the same as \n;"
               },
               "strongs_def": "prompt; Artemis, the name of a Grecian\n goddess borrowed by the Asiatics for one of their deities",
               "kjv_def": ":--Diana.",
               "_strongs": "00735"
            },
            {
               "strongs": "736",
               "greek": [
                  {
                     "_BETA": "A)RTE/MWN",
                     "_unicode": "ἀρτέμων",
                     "_translit": "artémōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-tem'-ohn"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "737"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "740"
                     }
                  ],
                  "__text": "properly, something ready (or else more\n remotely from \n (compare \n); something hung up), i.e. (specially)\n the topsail (rather foresail or jib) of a vessel"
               },
               "kjv_def": ":--mainsail.",
               "_strongs": "00736"
            },
            {
               "strongs": "737",
               "greek": [
                  {
                     "_BETA": "A)/RTI",
                     "_unicode": "ἄρτι",
                     "_translit": "árti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "740"
                     }
                  ],
                  "__text": "adverb from a derivative of \n (compare \n) through the idea of\n suspension;"
               },
               "strongs_def": "just now",
               "kjv_def": ":--this day (hour), hence(-forth), here(-after),\n hither(-to), (even) now, (this) present.",
               "_strongs": "00737"
            },
            {
               "strongs": "738",
               "greek": [
                  {
                     "_BETA": "A)RTIGE/NNHTOS",
                     "_unicode": "ἀρτιγέννητος",
                     "_translit": "artigénnētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-teeg-en'-nay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "737"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1084"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "just born, i.e. (figuratively) a young\n convert",
               "kjv_def": ":--new born.",
               "_strongs": "00738"
            },
            {
               "strongs": "739",
               "greek": [
                  {
                     "_BETA": "A)/RTIOS",
                     "_unicode": "ἄρτιος",
                     "_translit": "ártios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-tee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "737"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fresh, i.e. (by implication) complete",
               "kjv_def": ":--perfect.",
               "_strongs": "00739"
            },
            {
               "strongs": "740",
               "greek": [
                  {
                     "_BETA": "A)/RTOS",
                     "_unicode": "ἄρτος",
                     "_translit": "ártos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "bread (as raised) or a loaf",
               "kjv_def": ":--(shew-)bread, loaf.",
               "_strongs": "00740"
            },
            {
               "strongs": "741",
               "greek": [
                  {
                     "_BETA": "A)RTU/W",
                     "_unicode": "ἀρτύω",
                     "_translit": "artýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-too'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "to prepare, i.e. spice (with\n stimulating condiments)",
               "kjv_def": ":--season.",
               "_strongs": "00741"
            },
            {
               "strongs": "742",
               "greek": [
                  {
                     "_BETA": "*)ARFACA/D",
                     "_unicode": "Ἀρφαξάδ",
                     "_translit": "Arphaxád"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-fax-ad'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0775"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Arphaxad, a post-diluvian\n patriarch",
               "kjv_def": ":--Arphaxad.",
               "_strongs": "00742"
            },
            {
               "strongs": "743",
               "greek": [
                  {
                     "_BETA": "A)RXA/GGELOS",
                     "_unicode": "ἀρχάγγελος",
                     "_translit": "archángelos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khang'-el-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a chief angel",
               "kjv_def": ":--archangel.",
               "_strongs": "00743"
            },
            {
               "strongs": "744",
               "greek": [
                  {
                     "_BETA": "A)RXAI=OS",
                     "_unicode": "ἀρχαῖος",
                     "_translit": "archaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "original or primeval",
               "kjv_def": ":--(them of) old (time).",
               "_strongs": "00744"
            },
            {
               "strongs": "745",
               "greek": [
                  {
                     "_BETA": "*)ARXE/LAOS",
                     "_unicode": "Ἀρχέλαος",
                     "_translit": "Archélaos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khel'-ah-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2994"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "people-ruling; Archelaus, a Jewish\n king",
               "kjv_def": ":--Archelaus.",
               "_strongs": "00745"
            },
            {
               "strongs": "746",
               "greek": [
                  {
                     "_BETA": "A)RXH/",
                     "_unicode": "ἀρχή",
                     "_translit": "archḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "756"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(properly abstract) a commencement, or (concretely) chief\n (in various applications of order, time, place, or rank)",
               "kjv_def": ":--beginning,\n corner, (at the, the) first (estate), magistrate, power, principality,\n principle, rule.",
               "_strongs": "00746"
            },
            {
               "strongs": "747",
               "greek": [
                  {
                     "_BETA": "A)RXHGO/S",
                     "_unicode": "ἀρχηγός",
                     "_translit": "archēgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khay-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a chief leader",
               "kjv_def": ":--author, captain, prince.",
               "_strongs": "00747"
            },
            {
               "strongs": "748",
               "greek": [
                  {
                     "_BETA": "A)RXIERATIKO/S",
                     "_unicode": "ἀρχιερατικός",
                     "_translit": "archieratikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khee-er-at-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2413"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "high-priestly",
               "kjv_def": ":--of the high-priest.",
               "_strongs": "00748"
            },
            {
               "strongs": "749",
               "greek": [
                  {
                     "_BETA": "A)RXIEREU/S",
                     "_unicode": "ἀρχιερεύς",
                     "_translit": "archiereús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khee-er-yuce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2409"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the high-priest (literally, of the Jews, typically,\n Christ); by extension a chief priest",
               "kjv_def": ":--chief (high) priest, chief of\n the priests.",
               "_strongs": "00749"
            },
            {
               "strongs": "750",
               "greek": [
                  {
                     "_BETA": "A)RXIPOI/MHN",
                     "_unicode": "ἀρχιποίμην",
                     "_translit": "archipoímēn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khee-poy'-mane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4166"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a head shepherd",
               "kjv_def": ":--chief shepherd.",
               "_strongs": "00750"
            },
            {
               "strongs": "751",
               "greek": [
                  {
                     "_BETA": "*)/ARXIPPOS",
                     "_unicode": "Ἄρχιππος",
                     "_translit": "Árchippos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-khip-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2462"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "horse-ruler; Archippus, a Christian",
               "kjv_def": ":--Archippus.",
               "_strongs": "00751"
            },
            {
               "strongs": "752",
               "greek": [
                  {
                     "_BETA": "A)RXISUNA/GWGOS",
                     "_unicode": "ἀρχισυνάγωγος",
                     "_translit": "archisynágōgos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khee-soon-ag'-o-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4864"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "director of the synagogue services",
               "kjv_def": ":--(chief) ruler\n of the synagogue.",
               "_strongs": "00752"
            },
            {
               "strongs": "753",
               "greek": [
                  {
                     "_BETA": "A)RXITE/KTWN",
                     "_unicode": "ἀρχιτέκτων",
                     "_translit": "architéktōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khee-tek'-tone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5045"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a chief constructor, i.e.\n \"architect\"",
               "kjv_def": ":--masterbuilder.",
               "_strongs": "00753"
            },
            {
               "strongs": "754",
               "greek": [
                  {
                     "_BETA": "A)RXITELW/NHS",
                     "_unicode": "ἀρχιτελώνης",
                     "_translit": "architelṓnēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khee-tel-o'-nace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5057"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a principle tax-gatherer",
               "kjv_def": ":--chief among the\n publicans.",
               "_strongs": "00754"
            },
            {
               "strongs": "755",
               "greek": [
                  {
                     "_BETA": "A)RXITRI/KLINOS",
                     "_unicode": "ἀρχιτρίκλινος",
                     "_translit": "architríklinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar-khee-tree'-klee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from \n and a compound of \n and \n (a dinner-bed, because\n composed of three couches);"
               },
               "strongs_def": "director of the entertainment",
               "kjv_def": ":--governor\n (ruler) of the feast.",
               "_strongs": "00755"
            },
            {
               "strongs": "756",
               "greek": [
                  {
                     "_BETA": "A)/RXOMAI",
                     "_unicode": "ἄρχομαι",
                     "_translit": "árchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "middle voice of \n (through the implication, of precedence);"
               },
               "strongs_def": "to\n commence (in order of time)",
               "kjv_def": ":--(rehearse from the) begin(-ning).",
               "_strongs": "00756"
            },
            {
               "strongs": "757",
               "greek": [
                  {
                     "_BETA": "A)/RXW",
                     "_unicode": "ἄρχω",
                     "_translit": "árchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-kho"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to be first (in political rank or power)",
               "kjv_def": ":--reign\n (rule) over.",
               "_strongs": "00757"
            },
            {
               "strongs": "758",
               "greek": [
                  {
                     "_BETA": "A)/RXWN",
                     "_unicode": "ἄρχων",
                     "_translit": "árchōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-khone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "present participle of \n;"
               },
               "strongs_def": "a first (in rank or power)",
               "kjv_def": ":--chief (ruler),\n magistrate, prince, ruler.",
               "_strongs": "00758"
            },
            {
               "strongs": "759",
               "greek": [
                  {
                     "_BETA": "A)/RWMA",
                     "_unicode": "ἄρωμα",
                     "_translit": "árōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ar'-o-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from \n (in the sense of sending off scent);"
               },
               "strongs_def": "an aromatic",
               "kjv_def": ":--(sweet)\n spice.",
               "_strongs": "00759"
            },
            {
               "strongs": "760",
               "greek": [
                  {
                     "_BETA": "*)ASA/",
                     "_unicode": "Ἀσά",
                     "_translit": "Asá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0609"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Asa, an Israelite",
               "kjv_def": ":--Asa.",
               "_strongs": "00760"
            },
            {
               "strongs": "761",
               "greek": [
                  {
                     "_BETA": "A)SA/LEUTOS",
                     "_unicode": "ἀσάλευτος",
                     "_translit": "asáleutos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-al'-yoo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4531"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unshaken,\n i.e. (by implication) immovable (figuratively)",
               "kjv_def": ":--which cannot be\n moved, unmovable.",
               "_strongs": "00761"
            },
            {
               "strongs": "762",
               "greek": [
                  {
                     "_BETA": "A)/SBESTOS",
                     "_unicode": "ἄσβεστος",
                     "_translit": "ásbestos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-bes-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4570"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "not\n extinguished, i.e. (by implication) perpetual",
               "kjv_def": ":--not to be quenched,\n unquenchable.",
               "_strongs": "00762"
            },
            {
               "strongs": "763",
               "greek": [
                  {
                     "_BETA": "A)SE/BEIA",
                     "_unicode": "ἀσέβεια",
                     "_translit": "asébeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-eb'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "765"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "impiety, i.e. (by implication)\n wickedness",
               "kjv_def": ":--ungodly(-liness).",
               "_strongs": "00763"
            },
            {
               "strongs": "764",
               "greek": [
                  {
                     "_BETA": "A)SEBE/W",
                     "_unicode": "ἀσεβέω",
                     "_translit": "asebéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-eb-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "765"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be (by implied act) impious or wicked",
               "kjv_def": ":--commit (live,\n that after should live) ungodly.",
               "_strongs": "00764"
            },
            {
               "strongs": "765",
               "greek": [
                  {
                     "_BETA": "A)SEBH/S",
                     "_unicode": "ἀσεβής",
                     "_translit": "asebḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-eb-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4576"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "irreverent, i.e. (by extension) impious or wicked",
               "kjv_def": ":-- ungodly (man).",
               "_strongs": "00765"
            },
            {
               "strongs": "766",
               "greek": [
                  {
                     "_BETA": "A)SE/LGEIA",
                     "_unicode": "ἀσέλγεια",
                     "_translit": "asélgeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-elg'-i-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "SELGH/S",
                        "_unicode": "σελγής",
                        "_translit": "selgḗs"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and a presumed\n \n (of uncertain derivation, but apparently meaning\n continent);"
               },
               "strongs_def": "licentiousness (sometimes including other\n vices)",
               "kjv_def": ":--filthy, lasciviousness, wantonness.",
               "_strongs": "00766"
            },
            {
               "strongs": "767",
               "greek": [
                  {
                     "_BETA": "A)/SHMOS",
                     "_unicode": "ἄσημος",
                     "_translit": "ásēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-ay-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4591"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and the base of \n;"
               },
               "strongs_def": "unmarked, i.e.\n (figuratively) ignoble",
               "kjv_def": ":--mean.",
               "_strongs": "00767"
            },
            {
               "strongs": "768",
               "greek": [
                  {
                     "_BETA": "*)ASH/R",
                     "_unicode": "Ἀσήρ",
                     "_translit": "Asḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-ayr'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0836"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Aser (i.e. Asher), an Israelite tribe",
               "kjv_def": ":--Aser.",
               "_strongs": "00768"
            },
            {
               "strongs": "769",
               "greek": [
                  {
                     "_BETA": "A)SQE/NEIA",
                     "_unicode": "ἀσθένεια",
                     "_translit": "asthéneia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-then'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "772"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "feebleness (of mind or body); by implication, malady;\n morally, frailty",
               "kjv_def": ":--disease, infirmity, sickness, weakness.",
               "_strongs": "00769"
            },
            {
               "strongs": "770",
               "greek": [
                  {
                     "_BETA": "A)SQENE/W",
                     "_unicode": "ἀσθενέω",
                     "_translit": "asthenéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-then-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "772"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be feeble (in any sense)",
               "kjv_def": ":--be diseased, impotent folk\n (man), (be) sick, (be, be made) weak.",
               "_strongs": "00770"
            },
            {
               "strongs": "771",
               "greek": [
                  {
                     "_BETA": "A)SQE/NHMA",
                     "_unicode": "ἀσθένημα",
                     "_translit": "asthénēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-then'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "770"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a scruple of conscience",
               "kjv_def": ":--infirmity.",
               "_strongs": "00771"
            },
            {
               "strongs": "772",
               "greek": [
                  {
                     "_BETA": "A)SQENH/S",
                     "_unicode": "ἀσθενής",
                     "_translit": "asthenḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-then-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4599"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and the base of \n;"
               },
               "strongs_def": "strengthless (in\n various applications, literal, figurative and moral)",
               "kjv_def": ":--more feeble,\n impotent, sick, without strength, weak(-er, -ness, thing).",
               "_strongs": "00772"
            },
            {
               "strongs": "773",
               "greek": [
                  {
                     "_BETA": "*)ASI/A",
                     "_unicode": "Ἀσία",
                     "_translit": "Asía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-ee'-ah"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Asia, i.e. Asia Minor, or (usually) only its\n western shore",
               "kjv_def": ":--Asia.",
               "_strongs": "00773"
            },
            {
               "strongs": "774",
               "greek": [
                  {
                     "_BETA": "*)ASIANO/S",
                     "_unicode": "Ἀσιανός",
                     "_translit": "Asianós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-ee-an-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "773"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an Asian (i.e. Asiatic) or an inhabitant of Asia",
               "kjv_def": ":--of Asia.",
               "_strongs": "00774"
            },
            {
               "strongs": "775",
               "greek": [
                  {
                     "_BETA": "*)ASIA/RXHS",
                     "_unicode": "Ἀσιάρχης",
                     "_translit": "Asiárchēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-ee-ar'-khace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "773"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an Asiarch or president of the public festivities in\n a city of Asia Minor",
               "kjv_def": ":--chief of Asia.",
               "_strongs": "00775"
            },
            {
               "strongs": "776",
               "greek": [
                  {
                     "_BETA": "A)SITI/A",
                     "_unicode": "ἀσιτία",
                     "_translit": "asitía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-ee-tee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "777"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fasting (the state)",
               "kjv_def": ":--abstinence.",
               "_strongs": "00776"
            },
            {
               "strongs": "777",
               "greek": [
                  {
                     "_BETA": "A)/SITOS",
                     "_unicode": "ἄσιτος",
                     "_translit": "ásitos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-ee-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4621"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "without (taking)\n food",
               "kjv_def": ":--fasting.",
               "_strongs": "00777"
            },
            {
               "strongs": "778",
               "greek": [
                  {
                     "_BETA": "A)SKE/W",
                     "_unicode": "ἀσκέω",
                     "_translit": "askéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4632"
                     }
                  ],
                  "__text": "probably from the same as \n;"
               },
               "strongs_def": "to elaborate, i.e. (figuratively)\n train (by implication, strive)",
               "kjv_def": ":--exercise.",
               "_strongs": "00778"
            },
            {
               "strongs": "779",
               "greek": [
                  {
                     "_BETA": "A)SKO/S",
                     "_unicode": "ἀσκός",
                     "_translit": "askós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "778"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a leathern (or skin) bag used as a\n bottle",
               "kjv_def": ":--bottle.",
               "_strongs": "00779"
            },
            {
               "strongs": "780",
               "greek": [
                  {
                     "_BETA": "A)SME/NWS",
                     "_unicode": "ἀσμένως",
                     "_translit": "asménōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-men'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2237"
                     }
                  ],
                  "__text": "adverb from a derivative of the base of \n;"
               },
               "strongs_def": "with pleasure",
               "kjv_def": ":--gladly.",
               "_strongs": "00780"
            },
            {
               "strongs": "781",
               "greek": [
                  {
                     "_BETA": "A)/SOFOS",
                     "_unicode": "ἄσοφος",
                     "_translit": "ásophos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-of-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4680"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unwise",
               "kjv_def": ":--fool.",
               "_strongs": "00781"
            },
            {
               "strongs": "782",
               "greek": [
                  {
                     "_BETA": "A)SPA/ZOMAI",
                     "_unicode": "ἀσπάζομαι",
                     "_translit": "aspázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-pad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4685"
                     }
                  ],
                  "__text": "from \n (as a particle of union) and a presumed form of \n;"
               },
               "strongs_def": "to enfold\n in the arms, i.e. (by implication) to salute, (figuratively) to\n welcome",
               "kjv_def": ":--embrace, greet, salute, take leave.",
               "_strongs": "00782"
            },
            {
               "strongs": "783",
               "greek": [
                  {
                     "_BETA": "A)SPASMO/S",
                     "_unicode": "ἀσπασμός",
                     "_translit": "aspasmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-pas-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "782"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a greeting (in person or by letter)",
               "kjv_def": ":--greeting, salutation.",
               "_strongs": "00783"
            },
            {
               "strongs": "784",
               "greek": [
                  {
                     "_BETA": "A)/SPILOS",
                     "_unicode": "ἄσπιλος",
                     "_translit": "áspilos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-pee-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4695"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unblemished (physically or\n morally)",
               "kjv_def": ":--without spot, unspotted.",
               "_strongs": "00784"
            },
            {
               "strongs": "785",
               "greek": [
                  {
                     "_BETA": "A)SPI/S",
                     "_unicode": "ἀσπίς",
                     "_translit": "aspís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-pece'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a buckler (or round shield); used of a\n serpent (as coiling itself), probably the \"asp\"",
               "kjv_def": ":--asp.",
               "_strongs": "00785"
            },
            {
               "strongs": "786",
               "greek": [
                  {
                     "_BETA": "A)/SPONDOS",
                     "_unicode": "ἄσπονδος",
                     "_translit": "áspondos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-pon-dos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4689"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "literally,\n without libation (which usually accompanied a treaty), i.e. (by\n implication) truceless",
               "kjv_def": ":--implacable, truce-breaker.",
               "_strongs": "00786"
            },
            {
               "strongs": "787",
               "greek": [
                  {
                     "_BETA": "A)SSA/RION",
                     "_unicode": "ἀσσάριον",
                     "_translit": "assárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-sar'-ee-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "an assarius or as, a Roman coin",
               "kjv_def": ":--farthing.",
               "_strongs": "00787"
            },
            {
               "strongs": "788",
               "greek": [
                  {
                     "_BETA": "A)=SSON",
                     "_unicode": "ἆσσον",
                     "_translit": "âsson"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-son"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1451"
                     }
                  ],
                  "__text": "neuter comparative of the base of \n;"
               },
               "strongs_def": "more nearly, i.e. very\n near",
               "kjv_def": ":--close.",
               "_strongs": "00788"
            },
            {
               "strongs": "789",
               "greek": [
                  {
                     "_BETA": "*)/ASSOS",
                     "_unicode": "Ἄσσος",
                     "_translit": "Ássos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-sos"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Assus, a city of Asia MInor",
               "kjv_def": ":--Assos.",
               "_strongs": "00789"
            },
            {
               "strongs": "790",
               "greek": [
                  {
                     "_BETA": "A)STATE/W",
                     "_unicode": "ἀστατέω",
                     "_translit": "astatéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-tat-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "to be\n non-stationary, i.e. (figuratively) homeless",
               "kjv_def": ":--have no certain\n dwelling-place.",
               "_strongs": "00790"
            },
            {
               "strongs": "791",
               "greek": [
                  {
                     "_BETA": "A)STEI=OS",
                     "_unicode": "ἀστεῖος",
                     "_translit": "asteîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-ti'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/STU",
                        "_unicode": "ἄστυ",
                        "_translit": "ásty"
                     }
                  ],
                  "__text": "from \n (a city);"
               },
               "strongs_def": "urbane, i.e. (by implication) handsome",
               "kjv_def": ":--fair.",
               "_strongs": "00791"
            },
            {
               "strongs": "792",
               "greek": [
                  {
                     "_BETA": "A)STH/R",
                     "_unicode": "ἀστήρ",
                     "_translit": "astḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-tare'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4766"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "a star (as strown over the sky),\n literally or figuratively",
               "kjv_def": ":--star.",
               "_strongs": "00792"
            },
            {
               "strongs": "793",
               "greek": [
                  {
                     "_BETA": "A)STH/RIKTOS",
                     "_unicode": "ἀστήρικτος",
                     "_translit": "astḗriktos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-tay'-rik-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4741"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "unfixed, i.e. (figuratively) vacillating",
               "kjv_def": ":--unstable.",
               "_strongs": "00793"
            },
            {
               "strongs": "794",
               "greek": [
                  {
                     "_BETA": "A)/STORGOS",
                     "_unicode": "ἄστοργος",
                     "_translit": "ástorgos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-tor-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "STE/RGW",
                        "_unicode": "στέργω",
                        "_translit": "stérgō"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of\n \n (to cherish affectionately);"
               },
               "strongs_def": "hard-hearted towards\n kindred",
               "kjv_def": ":--without natural affection.",
               "_strongs": "00794"
            },
            {
               "strongs": "795",
               "greek": [
                  {
                     "_BETA": "A)STOXE/W",
                     "_unicode": "ἀστοχέω",
                     "_translit": "astochéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-tokh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "STOI/XOS",
                        "_unicode": "στοίχος",
                        "_translit": "stoíchos"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and \n (an aim);"
               },
               "strongs_def": "to miss the mark, i.e. (figuratively) deviate from truth",
               "kjv_def": ":--err,\n swerve.",
               "_strongs": "00795"
            },
            {
               "strongs": "796",
               "greek": [
                  {
                     "_BETA": "A)STRAPH/",
                     "_unicode": "ἀστραπή",
                     "_translit": "astrapḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-trap-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "797"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "lightning; by analogy, glare",
               "kjv_def": ":--lightning, bright shining.",
               "_strongs": "00796"
            },
            {
               "strongs": "797",
               "greek": [
                  {
                     "_BETA": "A)STRA/PTW",
                     "_unicode": "ἀστράπτω",
                     "_translit": "astráptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-trap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "792"
                     }
                  ],
                  "__text": "probably from  \n;"
               },
               "strongs_def": "to flash as lightning",
               "kjv_def": ":--lighten, shine.",
               "_strongs": "00797"
            },
            {
               "strongs": "798",
               "greek": [
                  {
                     "_BETA": "A)/STRON",
                     "_unicode": "ἄστρον",
                     "_translit": "ástron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as'-tron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "792"
                     }
                  ],
                  "__text": "neuter from \n;"
               },
               "strongs_def": "properly, a constellation; put for a single star\n (natural or artificial)",
               "kjv_def": ":--star.",
               "_strongs": "00798"
            },
            {
               "strongs": "799",
               "greek": [
                  {
                     "_BETA": "*)ASU/GKRITOS",
                     "_unicode": "Ἀσύγκριτος",
                     "_translit": "Asýnkritos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-oong'-kree-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4793"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "incomparable; Asyncritus, a Christian",
               "kjv_def": ":--Asyncritos.",
               "_strongs": "00799"
            },
            {
               "strongs": "800",
               "greek": [
                  {
                     "_BETA": "A)SU/MFWNOS",
                     "_unicode": "ἀσύμφωνος",
                     "_translit": "asýmphōnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-oom'-fo-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4859"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "inharmonious\n (figuratively)",
               "kjv_def": ":--agree not.",
               "_strongs": "00800"
            },
            {
               "strongs": "801",
               "greek": [
                  {
                     "_BETA": "A)SU/NETOS",
                     "_unicode": "ἀσύνετος",
                     "_translit": "asýnetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-oon'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4908"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unintelligent; by\n implication, wicked",
               "kjv_def": ":--foolish, without understanding.",
               "_strongs": "00801"
            },
            {
               "strongs": "802",
               "greek": [
                  {
                     "_BETA": "A)SU/NQETOS",
                     "_unicode": "ἀσύνθετος",
                     "_translit": "asýnthetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-oon'-thet-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4934"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "properly,\n not agreed, i.e. treacherous to compacts",
               "kjv_def": ":-- covenant-breaker.",
               "_strongs": "00802"
            },
            {
               "strongs": "803",
               "greek": [
                  {
                     "_BETA": "A)SFA/LEIA",
                     "_unicode": "ἀσφάλεια",
                     "_translit": "aspháleia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-fal'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "804"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "security (literally or figuratively)",
               "kjv_def": ":--certainty, safety.",
               "_strongs": "00803"
            },
            {
               "strongs": "804",
               "greek": [
                  {
                     "_BETA": "A)SFALH/S",
                     "_unicode": "ἀσφαλής",
                     "_translit": "asphalḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-fal-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "SFA/LLW",
                        "_unicode": "σφάλλω",
                        "_translit": "sphállō"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n (to \"fail\");"
               },
               "strongs_def": "secure\n (literally or figuratively)",
               "kjv_def": ":--certain(-ty), safe, sure.",
               "_strongs": "00804"
            },
            {
               "strongs": "805",
               "greek": [
                  {
                     "_BETA": "A)SFALI/ZW",
                     "_unicode": "ἀσφαλίζω",
                     "_translit": "asphalízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-fal-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "804"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render secure",
               "kjv_def": ":--make fast (sure).",
               "_strongs": "00805"
            },
            {
               "strongs": "806",
               "greek": [
                  {
                     "_BETA": "A)SFALW=S",
                     "_unicode": "ἀσφαλῶς",
                     "_translit": "asphalōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-fal-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "804"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "securely (literally or figuratively)",
               "kjv_def": ":--assuredly,\n safely.",
               "_strongs": "00806"
            },
            {
               "strongs": "807",
               "greek": [
                  {
                     "_BETA": "A)SXHMONE/W",
                     "_unicode": "ἀσχημονέω",
                     "_translit": "aschēmonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-kay-mon-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "809"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be (i.e. act) unbecoming",
               "kjv_def": ":--behave self uncomely\n (unseemly).",
               "_strongs": "00807"
            },
            {
               "strongs": "808",
               "greek": [
                  {
                     "_BETA": "A)SXHMOSU/NH",
                     "_unicode": "ἀσχημοσύνη",
                     "_translit": "aschēmosýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-kay-mos-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "809"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an indecency; by implication, the pudenda",
               "kjv_def": ":--shame, that\n which is unseemly.",
               "_strongs": "00808"
            },
            {
               "strongs": "809",
               "greek": [
                  {
                     "_BETA": "A)SXH/MWN",
                     "_unicode": "ἀσχήμων",
                     "_translit": "aschḗmōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-kay'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4976"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n (in\n the sense of its congener \n);"
               },
               "strongs_def": "properly, shapeless, i.e.\n (figuratively) inelegant",
               "kjv_def": ":--uncomely.",
               "_strongs": "00809"
            },
            {
               "strongs": "810",
               "greek": [
                  {
                     "_BETA": "A)SWTI/A",
                     "_unicode": "ἀσωτία",
                     "_translit": "asōtía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-o-tee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4982"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and a presumed\n derivative of \n;"
               },
               "strongs_def": "properly, unsavedness, i.e. (by implication)\n profligacy",
               "kjv_def": ":--excess, riot.",
               "_strongs": "00810"
            },
            {
               "strongs": "811",
               "greek": [
                  {
                     "_BETA": "A)SW/TWS",
                     "_unicode": "ἀσώτως",
                     "_translit": "asṓtōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "as-o'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "810"
                     }
                  ],
                  "__text": "adverb from the same as \n;"
               },
               "strongs_def": "dissolutely",
               "kjv_def": ":--riotous.",
               "_strongs": "00811"
            },
            {
               "strongs": "812",
               "greek": [
                  {
                     "_BETA": "A)TAKTE/W",
                     "_unicode": "ἀτακτέω",
                     "_translit": "ataktéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at-ak-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "813"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be (i.e. act) irregular",
               "kjv_def": ":--behave self disorderly.",
               "_strongs": "00812"
            },
            {
               "strongs": "813",
               "greek": [
                  {
                     "_BETA": "A)/TAKTOS",
                     "_unicode": "ἄτακτος",
                     "_translit": "átaktos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at'-ak-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "unarranged,\n i.e. (by implication) insubordinate (religiously)",
               "kjv_def": ":--unruly.",
               "_strongs": "00813"
            },
            {
               "strongs": "814",
               "greek": [
                  {
                     "_BETA": "A)TA/KTWS",
                     "_unicode": "ἀτάκτως",
                     "_translit": "atáktōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at-ak'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "813"
                     }
                  ],
                  "__text": "adverb from \n, irregularly (morally)"
               },
               "kjv_def": ":--disorderly.",
               "_strongs": "00814"
            },
            {
               "strongs": "815",
               "greek": [
                  {
                     "_BETA": "A)/TEKNOS",
                     "_unicode": "ἄτεκνος",
                     "_translit": "áteknos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at'-ek-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5043"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "childless",
               "kjv_def": ":--childless,\n without children.",
               "_strongs": "00815"
            },
            {
               "strongs": "816",
               "greek": [
                  {
                     "_BETA": "A)TENI/ZW",
                     "_unicode": "ἀτενίζω",
                     "_translit": "atenízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at-en-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TEI/NW",
                        "_unicode": "τείνω",
                        "_translit": "teínō"
                     }
                  ],
                  "__text": "from a compound of \n (as a particle of union) and \n (to stretch);"
               },
               "strongs_def": "to gaze intently",
               "kjv_def": ":--behold earnestly (stedfastly), fasten (eyes), look\n (earnestly, stedfastly, up stedfastly), set eyes.",
               "_strongs": "00816"
            },
            {
               "strongs": "817",
               "greek": [
                  {
                     "_BETA": "A)/TER",
                     "_unicode": "ἄτερ",
                     "_translit": "áter"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at'-er"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "427"
                     }
                  ],
                  "__text": "a particle probably akin to \n;"
               },
               "strongs_def": "aloof, i.e. apart from (literally or\n figuratively)",
               "kjv_def": ":--in the absence of, without.",
               "_strongs": "00817"
            },
            {
               "strongs": "818",
               "greek": [
                  {
                     "_BETA": "A)TIMA/ZW",
                     "_unicode": "ἀτιμάζω",
                     "_translit": "atimázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at-im-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "820"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render infamous, i.e. (by implication) contemn or\n maltreat",
               "kjv_def": ":--despise, dishonour, suffer shame, entreat shamefully.",
               "_strongs": "00818"
            },
            {
               "strongs": "819",
               "greek": [
                  {
                     "_BETA": "A)TIMI/A",
                     "_unicode": "ἀτιμία",
                     "_translit": "atimía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at-ee-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "820"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "infamy, i.e. (subjectively) comparative indignity,\n (objectively) disgrace",
               "kjv_def": ":--dishonour, reproach, shame, vile.",
               "_strongs": "00819"
            },
            {
               "strongs": "820",
               "greek": [
                  {
                     "_BETA": "A)/TIMOS",
                     "_unicode": "ἄτιμος",
                     "_translit": "átimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "(negatively) unhonoured or\n (positively) dishonoured",
               "kjv_def": ":--despised, without honour, less honourable\n (comparative degree).",
               "_strongs": "00820"
            },
            {
               "strongs": "821",
               "greek": [
                  {
                     "_BETA": "A)TIMO/W",
                     "_unicode": "ἀτιμόω",
                     "_translit": "atimóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at-ee-mo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "820"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "818"
                     }
                  ],
                  "__text": "used like \n, to maltreat"
               },
               "kjv_def": ":--handle shamefully.",
               "_strongs": "00821"
            },
            {
               "strongs": "822",
               "greek": [
                  {
                     "_BETA": "A)TMI/S",
                     "_unicode": "ἀτμίς",
                     "_translit": "atmís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at-mece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "mist",
               "kjv_def": ":--vapour.",
               "_strongs": "00822"
            },
            {
               "strongs": "823",
               "greek": [
                  {
                     "_BETA": "A)/TOMOS",
                     "_unicode": "ἄτομος",
                     "_translit": "átomos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at'-om-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5114"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and the base of \n;"
               },
               "strongs_def": "uncut, i.e. (by\n implication) indivisible (an \"atom\" of time)",
               "kjv_def": ":-- moment.",
               "_strongs": "00823"
            },
            {
               "strongs": "824",
               "greek": [
                  {
                     "_BETA": "A)/TOPOS",
                     "_unicode": "ἄτοπος",
                     "_translit": "átopos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at'-op-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5117"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "out of place, i.e.\n (figuratively) improper, injurious, wicked",
               "kjv_def": ":--amiss, harm,\n unreasonable.",
               "_strongs": "00824"
            },
            {
               "strongs": "825",
               "greek": [
                  {
                     "_BETA": "*)ATTA/LEIA",
                     "_unicode": "Ἀττάλεια",
                     "_translit": "Attáleia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "at-tal'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)/ATTALOS",
                        "_unicode": "Ἄτταλος",
                        "_translit": "Áttalos"
                     }
                  ],
                  "__text": "from \n (a king of Pergamus);"
               },
               "strongs_def": "Attaleia, a place in\n Pamphylia",
               "kjv_def": ":--Attalia.",
               "_strongs": "00825"
            },
            {
               "strongs": "826",
               "greek": [
                  {
                     "_BETA": "AU)GA/ZW",
                     "_unicode": "αὐγάζω",
                     "_translit": "augázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-gad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "827"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to beam forth (figuratively)",
               "kjv_def": ":--shine.",
               "_strongs": "00826"
            },
            {
               "strongs": "827",
               "greek": [
                  {
                     "_BETA": "AU)GH/",
                     "_unicode": "αὐγή",
                     "_translit": "augḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "owg'-ay"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a ray of light, i.e. (by implication)\n radiance, dawn",
               "kjv_def": ":--break of day.",
               "_strongs": "00827"
            },
            {
               "strongs": "828",
               "greek": [
                  {
                     "_BETA": "*AU)GOU=STOS",
                     "_unicode": "Αὐγοῦστος",
                     "_translit": "Augoûstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow'-goos-tos"
                  }
               ],
               "strongs_derivation": {
                  "latin": "august",
                  "__text": "from Latin (\"\n\");"
               },
               "strongs_def": "Augustus, a title of the Roman\n emperor",
               "kjv_def": ":--Augustus.",
               "_strongs": "00828"
            },
            {
               "strongs": "829",
               "greek": [
                  {
                     "_BETA": "AU)QA/DHS",
                     "_unicode": "αὐθάδης",
                     "_translit": "authádēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-thad'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2237"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "self-pleasing, i.e.\n arrogant",
               "kjv_def": ":--self-willed.",
               "_strongs": "00829"
            },
            {
               "strongs": "830",
               "greek": [
                  {
                     "_BETA": "AU)QAI/RETOS",
                     "_unicode": "αὐθαίρετος",
                     "_translit": "authaíretos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-thah'-ee-ret-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "140"
                     }
                  ],
                  "__text": "from \n and the same as \n;"
               },
               "strongs_def": "self-chosen, i.e. (by implication)\n voluntary",
               "kjv_def": ":--of own accord, willing of self.",
               "_strongs": "00830"
            },
            {
               "strongs": "831",
               "greek": [
                  {
                     "_BETA": "AU)QENTE/W",
                     "_unicode": "αὐθεντέω",
                     "_translit": "authentéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-then-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "E(/NTHS",
                        "_unicode": "ἕντης",
                        "_translit": "héntēs"
                     }
                  ],
                  "__text": "from a compound of \n and an obsolete \n (a worker);"
               },
               "strongs_def": "to act of\n oneself, i.e. (figuratively) dominate",
               "kjv_def": ":--usurp authority over.",
               "_strongs": "00831"
            },
            {
               "strongs": "832",
               "greek": [
                  {
                     "_BETA": "AU)LE/W",
                     "_unicode": "αὐλέω",
                     "_translit": "auléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "836"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to play the flute",
               "kjv_def": ":--pipe.",
               "_strongs": "00832"
            },
            {
               "strongs": "833",
               "greek": [
                  {
                     "_BETA": "AU)LH/",
                     "_unicode": "αὐλή",
                     "_translit": "aulḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-lay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a yard (as open to the wind); by implication, a\n mansion",
               "kjv_def": ":--court, (sheep-)fold, hall, palace.",
               "_strongs": "00833"
            },
            {
               "strongs": "834",
               "greek": [
                  {
                     "_BETA": "AU)LHTH/S",
                     "_unicode": "αὐλητής",
                     "_translit": "aulētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-lay-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "832"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a flute-player",
               "kjv_def": ":--minstrel, piper.",
               "_strongs": "00834"
            },
            {
               "strongs": "835",
               "greek": [
                  {
                     "_BETA": "AU)LI/ZOMAI",
                     "_unicode": "αὐλίζομαι",
                     "_translit": "aulízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-lid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "833"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to pass the night (properly, in the open\n air)",
               "kjv_def": ":--abide, lodge.",
               "_strongs": "00835"
            },
            {
               "strongs": "836",
               "greek": [
                  {
                     "_BETA": "AU)LO/S",
                     "_unicode": "αὐλός",
                     "_translit": "aulós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-los'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a flute (as blown)",
               "kjv_def": ":--pipe.",
               "_strongs": "00836"
            },
            {
               "strongs": "837",
               "greek": [
                  {
                     "_BETA": "AU)CA/NW",
                     "_unicode": "αὐξάνω",
                     "_translit": "auxánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "owx-an'-o"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb;",
               "strongs_def": "to grow (\"wax\"), i.e. enlarge\n (literal or figurative, active or passive)",
               "kjv_def": ":--grow (up), (give the)\n increase.",
               "_strongs": "00837"
            },
            {
               "strongs": "838",
               "greek": [
                  {
                     "_BETA": "AU)/CHSIS",
                     "_unicode": "αὔξησις",
                     "_translit": "aúxēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "owx'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "837"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "growth",
               "kjv_def": ":--increase.",
               "_strongs": "00838"
            },
            {
               "strongs": "839",
               "greek": [
                  {
                     "_BETA": "AU)/RION",
                     "_unicode": "αὔριον",
                     "_translit": "aúrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from a derivative of the same as \n (meaning a breeze, i.e. the\n morning air);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "properly, fresh, i.e. (adverb with ellipsis of \n)\n to-morrow"
               },
               "kjv_def": ":--(to-)morrow, next day.",
               "_strongs": "00839"
            },
            {
               "strongs": "840",
               "greek": [
                  {
                     "_BETA": "AU)STHRO/S",
                     "_unicode": "αὐστηρός",
                     "_translit": "austērós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-stay-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from a (presumed) derivative of the same as \n (meaning blown);"
               },
               "strongs_def": "rough\n (properly as a gale), i.e. (figuratively) severe",
               "kjv_def": ":--austere.",
               "_strongs": "00840"
            },
            {
               "strongs": "841",
               "greek": [
                  {
                     "_BETA": "AU)TA/RKEIA",
                     "_unicode": "αὐτάρκεια",
                     "_translit": "autárkeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-tar'-ki-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "842"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "self-satisfaction, i.e. (abstractly) contentedness, or\n (concretely) a competence",
               "kjv_def": ":--contentment, sufficiency.",
               "_strongs": "00841"
            },
            {
               "strongs": "842",
               "greek": [
                  {
                     "_BETA": "AU)TA/RKHS",
                     "_unicode": "αὐτάρκης",
                     "_translit": "autárkēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-tar'-kace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "714"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "self-complacent, i.e. contented",
               "kjv_def": ":--content.",
               "_strongs": "00842"
            },
            {
               "strongs": "843",
               "greek": [
                  {
                     "_BETA": "AU)TOKATA/KRITOS",
                     "_unicode": "αὐτοκατάκριτος",
                     "_translit": "autokatákritos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-tok-at-ak'-ree-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2632"
                     }
                  ],
                  "__text": "from \n and a derivative or \n;"
               },
               "strongs_def": "self-condemned",
               "kjv_def": ":--condemned of self.",
               "_strongs": "00843"
            },
            {
               "strongs": "844",
               "greek": [
                  {
                     "_BETA": "AU)TO/MATOS",
                     "_unicode": "αὐτόματος",
                     "_translit": "autómatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-tom'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3155"
                     }
                  ],
                  "__text": "from \n and the same as \n;"
               },
               "strongs_def": "self-moved (\"automatic\"), i.e.\n spontaneous",
               "kjv_def": ":--of own accord, of self.",
               "_strongs": "00844"
            },
            {
               "strongs": "845",
               "greek": [
                  {
                     "_BETA": "AU)TO/PTHS",
                     "_unicode": "αὐτόπτης",
                     "_translit": "autóptēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-top'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "self-seeing, i.e. an eye-witness",
               "kjv_def": ":--eye-witness.",
               "_strongs": "00845"
            },
            {
               "strongs": "846",
               "greek": [
                  {
                     "_BETA": "AU)TO/S",
                     "_unicode": "αὐτός",
                     "_translit": "autós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-tos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "AU)=",
                        "_unicode": "αὖ",
                        "_translit": "aû"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from the particle \n (perhaps akin to the base of \n through the idea\n of a baffling wind) (backward);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1438"
                     }
                  ],
                  "__text": "the reflexive pronoun self, used\n (alone or in the compound \n) of the third person , and (with the\n proper personal pronoun) of the other persons"
               },
               "kjv_def": ":--her, it(-self), one,\n the other, (mine) own, said, (self-), the) same, ((him-, my-, thy-\n )self, (your-)selves, she, that, their(-s), them(-selves), there(-at,\n - by, -in, -into, -of, -on, -with), they, (these) things, this (man),\n those, together, very, which.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "848"
                  }
               ],
               "_strongs": "00846",
               "__text": "Compare \n."
            },
            {
               "strongs": "847",
               "greek": [
                  {
                     "_BETA": "AU)TOU=",
                     "_unicode": "αὐτοῦ",
                     "_translit": "autoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-too'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "__text": "genitive (i.e. possessive) of \n, used as an adverb of location;"
               },
               "strongs_def": "properly, belonging to the same spot, i.e. in this (or that)\n place",
               "kjv_def": ":--(t-)here.",
               "_strongs": "00847"
            },
            {
               "strongs": "848",
               "greek": [
                  {
                     "_BETA": "AU(TOU=",
                     "_unicode": "αὑτοῦ",
                     "_translit": "hautoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "how-too'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1438"
                     }
                  ],
                  "__text": "contracted for \n;"
               },
               "strongs_def": "self (in some oblique case or reflexive\n relation)",
               "kjv_def": ":--her (own), (of) him(-self), his (own), of it, thee, their\n (own), them(-selves), they.",
               "_strongs": "00848"
            },
            {
               "strongs": "849",
               "greek": [
                  {
                     "_BETA": "AU)TO/XEIR",
                     "_unicode": "αὐτόχειρ",
                     "_translit": "autócheir"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ow-tokh'-ire"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "self-handed, i.e. doing personally",
               "kjv_def": ":--with … own\n hands.",
               "_strongs": "00849"
            },
            {
               "strongs": "850",
               "greek": [
                  {
                     "_BETA": "AU)XMHRO/S",
                     "_unicode": "αὐχμηρός",
                     "_translit": "auchmērós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "owkh-may-ros'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "AU)XMO/S",
                        "_unicode": "αὐχμός",
                        "_translit": "auchmós"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from \n (probably from a base akin to that of \n) (dust, as\n dried by wind);"
               },
               "strongs_def": "properly, dirty, i.e. (by implication) obscure",
               "kjv_def": ":--dark.",
               "_strongs": "00850"
            },
            {
               "strongs": "851",
               "greek": [
                  {
                     "_BETA": "A)FAIRE/W",
                     "_unicode": "ἀφαιρέω",
                     "_translit": "aphairéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-ahee-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to remove (literally or figuratively)",
               "kjv_def": ":--cut (smite)\n off, take away.",
               "_strongs": "00851"
            },
            {
               "strongs": "852",
               "greek": [
                  {
                     "_BETA": "A)FANH/S",
                     "_unicode": "ἀφανής",
                     "_translit": "aphanḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-an-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "non-apparent",
               "kjv_def": ":--that is not\n manifest.",
               "_strongs": "00852"
            },
            {
               "strongs": "853",
               "greek": [
                  {
                     "_BETA": "A)FANI/ZW",
                     "_unicode": "ἀφανίζω",
                     "_translit": "aphanízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-an-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "852"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render unapparent, i.e. (actively) consume (becloud), or\n (passively) disappear (be destroyed)",
               "kjv_def": ":-- corrupt, disfigure, perish,\n vanish away.",
               "_strongs": "00853"
            },
            {
               "strongs": "854",
               "greek": [
                  {
                     "_BETA": "A)FANISMO/S",
                     "_unicode": "ἀφανισμός",
                     "_translit": "aphanismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-an-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "853"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "disappearance, i.e. (figuratively) abrogation",
               "kjv_def": ":--vanish away.",
               "_strongs": "00854"
            },
            {
               "strongs": "855",
               "greek": [
                  {
                     "_BETA": "A)/FANTOS",
                     "_unicode": "ἄφαντος",
                     "_translit": "áphantos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af'-an-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "non-manifested, i.e. invisible",
               "kjv_def": ":--vanished out of sight.",
               "_strongs": "00855"
            },
            {
               "strongs": "856",
               "greek": [
                  {
                     "_BETA": "A)FEDRW/N",
                     "_unicode": "ἀφεδρών",
                     "_translit": "aphedrṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-ed-rone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n;"
               },
               "strongs_def": "a place of sitting apart,\n i.e. a privy",
               "kjv_def": ":--draught.",
               "_strongs": "00856"
            },
            {
               "strongs": "857",
               "greek": [
                  {
                     "_BETA": "A)FEIDI/A",
                     "_unicode": "ἀφειδία",
                     "_translit": "apheidía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-i-dee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5339"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and \n;"
               },
               "strongs_def": "unsparingness,\n i.e. austerity (asceticism)",
               "kjv_def": ":--neglecting.",
               "_strongs": "00857"
            },
            {
               "strongs": "858",
               "greek": [
                  {
                     "_BETA": "A)FELO/THS",
                     "_unicode": "ἀφελότης",
                     "_translit": "aphelótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-el-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "FE/LLOS",
                        "_unicode": "φέλλος",
                        "_translit": "phéllos"
                     }
                  ],
                  "__text": "from a compound of \n (as a negative particle) and \n (in the\n sense of a stone as stubbing the foot);"
               },
               "strongs_def": "smoothness, i.e.\n (figuratively) simplicity",
               "kjv_def": ":--singleness.",
               "_strongs": "00858"
            },
            {
               "strongs": "859",
               "greek": [
                  {
                     "_BETA": "A)/FESIS",
                     "_unicode": "ἄφεσις",
                     "_translit": "áphesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "863"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "freedom; (figuratively) pardon",
               "kjv_def": ":--deliverance, forgiveness,\n liberty, remission.",
               "_strongs": "00859"
            },
            {
               "strongs": "860",
               "greek": [
                  {
                     "_BETA": "A(FH/",
                     "_unicode": "ἁφή",
                     "_translit": "haphḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "haf-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "680"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "probably a ligament (as fastening)",
               "kjv_def": ":--joint.",
               "_strongs": "00860"
            },
            {
               "strongs": "861",
               "greek": [
                  {
                     "_BETA": "A)FQARSI/A",
                     "_unicode": "ἀφθαρσία",
                     "_translit": "aphtharsía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-thar-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "862"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "incorruptibility; genitive, unending existence;\n (figuratively) genuineness",
               "kjv_def": ":--immortality, incorruption, sincerity.",
               "_strongs": "00861"
            },
            {
               "strongs": "862",
               "greek": [
                  {
                     "_BETA": "A)/FQARTOS",
                     "_unicode": "ἄφθαρτος",
                     "_translit": "áphthartos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af'-thar-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5351"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n;"
               },
               "strongs_def": "undecaying\n (in essence or continuance)",
               "kjv_def": ":--not (in-, un-)corruptible, immortal.",
               "_strongs": "00862"
            },
            {
               "strongs": "863",
               "greek": [
                  {
                     "_BETA": "A)FI/HMI",
                     "_unicode": "ἀφίημι",
                     "_translit": "aphíēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-ee'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "I(/HMI",
                        "_unicode": "ἵημι",
                        "_translit": "híēmi"
                     },
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "from \n and \n (to send; an intensive form of \n, to go);"
               },
               "strongs_def": "to\n send forth, in various applications (as follow)",
               "kjv_def": ":--cry, forgive,\n forsake, lay aside, leave, let (alone, be, go, have), omit, put (send)\n away, remit, suffer, yield up.",
               "_strongs": "00863"
            },
            {
               "strongs": "864",
               "greek": [
                  {
                     "_BETA": "A)FIKNE/OMAI",
                     "_unicode": "ἀφικνέομαι",
                     "_translit": "aphiknéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-ik-neh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2425"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to go (i.e. spread) forth (by\n rumor)",
               "kjv_def": ":--come abroad.",
               "_strongs": "00864"
            },
            {
               "strongs": "865",
               "greek": [
                  {
                     "_BETA": "A)FILA/GAQOS",
                     "_unicode": "ἀφιλάγαθος",
                     "_translit": "aphilágathos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-il-ag'-ath-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5358"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "hostile to virtue",
               "kjv_def": ":--despiser\n of those that are good.",
               "_strongs": "00865"
            },
            {
               "strongs": "866",
               "greek": [
                  {
                     "_BETA": "A)FILA/RGUROS",
                     "_unicode": "ἀφιλάργυρος",
                     "_translit": "aphilárgyros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-il-ar'-goo-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5366"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unavaricious",
               "kjv_def": ":--without\n covetousness, not greedy of filthy lucre.",
               "_strongs": "00866"
            },
            {
               "strongs": "867",
               "greek": [
                  {
                     "_BETA": "A)/FICIS",
                     "_unicode": "ἄφιξις",
                     "_translit": "áphixis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af'-ix-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "864"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, arrival, i.e. (by implication)\n departure",
               "kjv_def": ":--departing.",
               "_strongs": "00867"
            },
            {
               "strongs": "868",
               "greek": [
                  {
                     "_BETA": "A)FI/STHMI",
                     "_unicode": "ἀφίστημι",
                     "_translit": "aphístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to remove, i.e. (actively) instigate to revolt;\n usually (reflexively) to desist, desert, etc.",
               "kjv_def": ":--depart, draw (fall)\n away, refrain, withdraw self.",
               "_strongs": "00868"
            },
            {
               "strongs": "869",
               "greek": [
                  {
                     "_BETA": "A)/FNW",
                     "_unicode": "ἄφνω",
                     "_translit": "áphnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "852"
                     }
                  ],
                  "__text": "adverb from \n (contraction);"
               },
               "strongs_def": "unawares, i.e. unexpectedly",
               "kjv_def": ":--suddenly.",
               "_strongs": "00869"
            },
            {
               "strongs": "870",
               "greek": [
                  {
                     "_BETA": "A)FO/BWS",
                     "_unicode": "ἀφόβως",
                     "_translit": "aphóbōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-ob'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5401"
                     }
                  ],
                  "__text": "adverb from a compound of \n (as a negative particle) and \n;"
               },
               "strongs_def": "fearlessly",
               "kjv_def": ":--without fear.",
               "_strongs": "00870"
            },
            {
               "strongs": "871",
               "greek": [
                  {
                     "_BETA": "A)FOMOIO/W",
                     "_unicode": "ἀφομοιόω",
                     "_translit": "aphomoióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-om-oy-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3666"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to assimilate closely",
               "kjv_def": ":--make like.",
               "_strongs": "00871"
            },
            {
               "strongs": "872",
               "greek": [
                  {
                     "_BETA": "A)FORA/W",
                     "_unicode": "ἀφοράω",
                     "_translit": "aphoráō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-or-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to consider attentively",
               "kjv_def": ":--look.",
               "_strongs": "00872"
            },
            {
               "strongs": "873",
               "greek": [
                  {
                     "_BETA": "A)FORI/ZW",
                     "_unicode": "ἀφορίζω",
                     "_translit": "aphorízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-or-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3724"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to set off by boundary, i.e. (figuratively) limit,\n exclude, appoint, etc.",
               "kjv_def": ":--divide, separate, sever.",
               "_strongs": "00873"
            },
            {
               "strongs": "874",
               "greek": [
                  {
                     "_BETA": "A)FORMH/",
                     "_unicode": "ἀφορμή",
                     "_translit": "aphormḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-or-may'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3729"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a starting-point, i.e. (figuratively)\n an opportunity",
               "kjv_def": ":--occasion.",
               "_strongs": "00874"
            },
            {
               "strongs": "875",
               "greek": [
                  {
                     "_BETA": "A)FRI/ZW",
                     "_unicode": "ἀφρίζω",
                     "_translit": "aphrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "876"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to froth at the mouth (in epilepsy)",
               "kjv_def": ":--foam.",
               "_strongs": "00875"
            },
            {
               "strongs": "876",
               "greek": [
                  {
                     "_BETA": "A)FRO/S",
                     "_unicode": "ἀφρός",
                     "_translit": "aphrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-ros'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "froth, i.e. slaver",
               "kjv_def": ":--foaming.",
               "_strongs": "00876"
            },
            {
               "strongs": "877",
               "greek": [
                  {
                     "_BETA": "A)FROSU/NH",
                     "_unicode": "ἀφροσύνη",
                     "_translit": "aphrosýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-ros-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "878"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "senselessness, i.e. (euphemistically) egotism; (morally)\n recklessness",
               "kjv_def": ":--folly, foolishly(-ness).",
               "_strongs": "00877"
            },
            {
               "strongs": "878",
               "greek": [
                  {
                     "_BETA": "A)/FRWN",
                     "_unicode": "ἄφρων",
                     "_translit": "áphrōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af'-rone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "properly, mindless, i.e.\n stupid, (by implication) ignorant, (specially) egotistic,\n (practically) rash, or (morally) unbelieving",
               "kjv_def": ":--fool(-ish), unwise.",
               "_strongs": "00878"
            },
            {
               "strongs": "879",
               "greek": [
                  {
                     "_BETA": "A)FUPNO/W",
                     "_unicode": "ἀφυπνόω",
                     "_translit": "aphypnóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af-oop-no'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5258"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "properly, to become awake, i.e. (by\n implication) to drop (off) in slumber",
               "kjv_def": ":--fall asleep.",
               "_strongs": "00879"
            },
            {
               "strongs": "880",
               "greek": [
                  {
                     "_BETA": "A)/FWNOS",
                     "_unicode": "ἄφωνος",
                     "_translit": "áphōnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "af'-o-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5456"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "voiceless, i.e. mute (by\n nature or choice); figuratively, unmeaning",
               "kjv_def": ":--dumb, without\n signification.",
               "_strongs": "00880"
            },
            {
               "strongs": "881",
               "greek": [
                  {
                     "_BETA": "*)AXA/Z",
                     "_unicode": "Ἀχάζ",
                     "_translit": "Acház"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh-adz'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0271"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Achaz, an Israelite",
               "kjv_def": ":--Achaz.",
               "_strongs": "00881"
            },
            {
               "strongs": "882",
               "greek": [
                  {
                     "_BETA": "*)AXAI/+A",
                     "_unicode": "Ἀχαΐα",
                     "_translit": "Achaḯa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ach-ah-ee'-ah"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Achaia (i.e. Greece), a country of\n Europe",
               "kjv_def": ":--Achaia.",
               "_strongs": "00882"
            },
            {
               "strongs": "883",
               "greek": [
                  {
                     "_BETA": "*)AXAI+KO/S",
                     "_unicode": "Ἀχαϊκός",
                     "_translit": "Achaïkós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ach-ah-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "882"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an Achaian; Achaicus, a Christian",
               "kjv_def": ":--Achaicus.",
               "_strongs": "00883"
            },
            {
               "strongs": "884",
               "greek": [
                  {
                     "_BETA": "A)XA/RISTOS",
                     "_unicode": "ἀχάριστος",
                     "_translit": "acháristos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ach-ar'-is-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5483"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a presumed derivative of \n;"
               },
               "strongs_def": "thankless, i.e. ungrateful",
               "kjv_def": ":--unthankful.",
               "_strongs": "00884"
            },
            {
               "strongs": "885",
               "greek": [
                  {
                     "_BETA": "*)AXEI/M",
                     "_unicode": "Ἀχείμ",
                     "_translit": "Acheím"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh-ime'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03137"
                     }
                  ],
                  "__text": "probably of Hebrew origin (compare \n);"
               },
               "strongs_def": "Achim, an Israelite",
               "kjv_def": ":--Achim.",
               "_strongs": "00885"
            },
            {
               "strongs": "886",
               "greek": [
                  {
                     "_BETA": "A)XEIROPOI/HTOS",
                     "_unicode": "ἀχειροποίητος",
                     "_translit": "acheiropoíētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh-i-rop-oy'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5499"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "unmanufactured, i.e.\n inartificial",
               "kjv_def": ":--made without (not made with) hands.",
               "_strongs": "00886"
            },
            {
               "strongs": "887",
               "greek": [
                  {
                     "_BETA": "A)XLU/S",
                     "_unicode": "ἀχλύς",
                     "_translit": "achlýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh-looce'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "dimness of sight, i.e. (probably) a\n cataract",
               "kjv_def": ":--mist.",
               "_strongs": "00887"
            },
            {
               "strongs": "888",
               "greek": [
                  {
                     "_BETA": "A)XREI=OS",
                     "_unicode": "ἀχρεῖος",
                     "_translit": "achreîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh-ri'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5534"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5532"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and a derivative of \n (compare\n \n);"
               },
               "strongs_def": "useless, i.e. (euphemistically) unmeritorious",
               "kjv_def": ":--unprofitable.",
               "_strongs": "00888"
            },
            {
               "strongs": "889",
               "greek": [
                  {
                     "_BETA": "A)XREIO/W",
                     "_unicode": "ἀχρειόω",
                     "_translit": "achreióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh-ri-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "888"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render useless, i.e. spoil",
               "kjv_def": ":--become unprofitable.",
               "_strongs": "00889"
            },
            {
               "strongs": "890",
               "greek": [
                  {
                     "_BETA": "A)/XRHSTOS",
                     "_unicode": "ἄχρηστος",
                     "_translit": "áchrēstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh'-race-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5543"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "inefficient, i.e. (by\n implication) detrimental",
               "kjv_def": ":--unprofitable.",
               "_strongs": "00890"
            },
            {
               "strongs": "891",
               "greek": [
                  {
                     "_BETA": "A)/XRI",
                     "_unicode": "ἄχρι",
                     "_translit": "áchri"
                  },
                  {
                     "_BETA": "A)/XRIS",
                     "_unicode": "ἄχρις",
                     "_translit": "áchris"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh'-ree"
                  },
                  {
                     "_strongs": "akh'-rece"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "206"
                     }
                  ],
                  "__text": "akin to \n (through the idea of a terminus);"
               },
               "strongs_def": "(of\n time) until or (of place) up to",
               "kjv_def": ":--as far as, for, in(-to), till,\n (even, un-)to, until, while.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3360"
                  }
               ],
               "_strongs": "00891",
               "__text": "or \n  \n; \n Compare \n."
            },
            {
               "strongs": "892",
               "greek": [
                  {
                     "_BETA": "A)/XURON",
                     "_unicode": "ἄχυρον",
                     "_translit": "áchyron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "akh'-oo-ron"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "XE/W",
                        "_unicode": "χέω",
                        "_translit": "chéō"
                     }
                  ],
                  "__text": "perhaps remotely from \n (to shed forth);"
               },
               "strongs_def": "chaff (as\n diffusive)",
               "kjv_def": ":--chaff.",
               "_strongs": "00892"
            },
            {
               "strongs": "893",
               "greek": [
                  {
                     "_BETA": "A)YEUDH/S",
                     "_unicode": "ἀψευδής",
                     "_translit": "apseudḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "aps-yoo-dace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5579"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "veracious",
               "kjv_def": ":--that cannot lie.",
               "_strongs": "00893"
            },
            {
               "strongs": "894",
               "greek": [
                  {
                     "_BETA": "A)/YINQOS",
                     "_unicode": "ἄψινθος",
                     "_translit": "ápsinthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap'-sin-thos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "wormwood (as a type of bitterness, i.e.\n (figuratively) calamity)",
               "kjv_def": ":--wormwood.",
               "_strongs": "00894"
            },
            {
               "strongs": "895",
               "greek": [
                  {
                     "_BETA": "A)/YUXOS",
                     "_unicode": "ἄψυχος",
                     "_translit": "ápsychos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ap'-soo-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5590"
                     }
                  ],
                  "__text": "from \n (as a negative particle) and \n;"
               },
               "strongs_def": "lifeless, i.e. inanimate\n (mechanical)",
               "kjv_def": ":--without life.",
               "_strongs": "00895"
            },
            {
               "strongs": "896",
               "greek": [
                  {
                     "_BETA": "*BA/AL",
                     "_unicode": "Βάαλ",
                     "_translit": "Báal"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bah'-al"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01168"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Baal, a Phœnician deity (used as a symbol of\n idolatry)",
               "kjv_def": ":--Baal.",
               "_strongs": "00896"
            },
            {
               "strongs": "897",
               "greek": [
                  {
                     "_BETA": "*BABULW/N",
                     "_unicode": "Βαβυλών",
                     "_translit": "Babylṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bab-oo-lone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0894"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Babylon, the capitol of Chaldæa (literally or\n figuratively (as a type of tyranny))",
               "kjv_def": ":-- Babylon.",
               "_strongs": "00897"
            },
            {
               "strongs": "898",
               "greek": [
                  {
                     "_BETA": "BAQMO/S",
                     "_unicode": "βαθμός",
                     "_translit": "bathmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bath-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "899"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a step, i.e. (figuratively) grade (of\n dignity)",
               "kjv_def": ":--degree.",
               "_strongs": "00898"
            },
            {
               "strongs": "899",
               "greek": [
                  {
                     "_BETA": "BA/QOS",
                     "_unicode": "βάθος",
                     "_translit": "báthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bath'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "901"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "profundity, i.e. (by implication) extent;\n (figuratively) mystery",
               "kjv_def": ":--deep(-ness, things), depth.",
               "_strongs": "00899"
            },
            {
               "strongs": "900",
               "greek": [
                  {
                     "_BETA": "BAQU/NW",
                     "_unicode": "βαθύνω",
                     "_translit": "bathýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bath-oo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "901"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to deepen",
               "kjv_def": ":--deep.",
               "_strongs": "00900"
            },
            {
               "strongs": "901",
               "greek": [
                  {
                     "_BETA": "BAQU/S",
                     "_unicode": "βαθύς",
                     "_translit": "bathýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bath-oos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "profound (as going down), literally or\n figuratively",
               "kjv_def": ":--deep, very early.",
               "_strongs": "00901"
            },
            {
               "strongs": "902",
               "greek": [
                  {
                     "_BETA": "BAI/+ON",
                     "_unicode": "βαΐον",
                     "_translit": "baḯon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bah-ee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "a diminutive of a derivative probably of the base of \n;"
               },
               "strongs_def": "a palm twig\n (as going out far)",
               "kjv_def": ":--branch.",
               "_strongs": "00902"
            },
            {
               "strongs": "903",
               "greek": [
                  {
                     "_BETA": "*BALAA/M",
                     "_unicode": "Βαλαάμ",
                     "_translit": "Balaám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bal-ah-am'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01109"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Balaam, a Mesopotamian (symbolic of a false\n teacher)",
               "kjv_def": ":--Balaam.",
               "_strongs": "00903"
            },
            {
               "strongs": "904",
               "greek": [
                  {
                     "_BETA": "*BALA/K",
                     "_unicode": "Βαλάκ",
                     "_translit": "Balák"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bal-ak'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01111"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Balak, a Moabite",
               "kjv_def": ":--Balac.",
               "_strongs": "00904"
            },
            {
               "strongs": "905",
               "greek": [
                  {
                     "_BETA": "BALA/NTION",
                     "_unicode": "βαλάντιον",
                     "_translit": "balántion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bal-an'-tee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "probably remotely from \n (as a depository);"
               },
               "strongs_def": "a pouch (for\n money)",
               "kjv_def": ":--bag, purse.",
               "_strongs": "00905"
            },
            {
               "strongs": "906",
               "greek": [
                  {
                     "_BETA": "BA/LLW",
                     "_unicode": "βάλλω",
                     "_translit": "bállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bal'-lo"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to throw (in various applications, more or less\n violent or intense)",
               "kjv_def": ":--arise, cast (out), X dung, lay, lie, pour, put\n (up), send, strike, throw (down), thrust.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4496"
                  }
               ],
               "_strongs": "00906",
               "__text": "Compare \n."
            },
            {
               "strongs": "907",
               "greek": [
                  {
                     "_BETA": "BAPTI/ZW",
                     "_unicode": "βαπτίζω",
                     "_translit": "baptízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bap-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "911"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to immerse, submerge; to make whelmed (i.e.\n fully wet); used only (in the New Testament) of ceremonial ablution,\n especially (technically) of the ordinance of Christian\n baptism",
               "kjv_def": ":--Baptist, baptize, wash.",
               "_strongs": "00907"
            },
            {
               "strongs": "908",
               "greek": [
                  {
                     "_BETA": "BA/PTISMA",
                     "_unicode": "βάπτισμα",
                     "_translit": "báptisma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bap'-tis-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "907"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "baptism (technically or figuratively)",
               "kjv_def": ":--baptism.",
               "_strongs": "00908"
            },
            {
               "strongs": "909",
               "greek": [
                  {
                     "_BETA": "BAPTISMO/S",
                     "_unicode": "βαπτισμός",
                     "_translit": "baptismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bap-tis-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "907"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "ablution (ceremonial or Christian)",
               "kjv_def": ":--baptism, washing.",
               "_strongs": "00909"
            },
            {
               "strongs": "910",
               "greek": [
                  {
                     "_BETA": "*BAPTISTH/S",
                     "_unicode": "Βαπτιστής",
                     "_translit": "Baptistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bap-tis-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "907"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a baptizer, as an epithet of Christ's forerunner",
               "kjv_def": ":--Baptist.",
               "_strongs": "00910"
            },
            {
               "strongs": "911",
               "greek": [
                  {
                     "_BETA": "BA/PTW",
                     "_unicode": "βάπτω",
                     "_translit": "báptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bap'-to"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to whelm, i.e. cover wholly with a fluid; in the New\n Testament only in a qualified or special sense, i.e. (literally) to\n moisten (a part of one's person), or (by implication) to stain (as\n with dye)",
               "kjv_def": ":--dip.",
               "_strongs": "00911"
            },
            {
               "strongs": "912",
               "greek": [
                  {
                     "_BETA": "*BARABBA=S",
                     "_unicode": "Βαραββᾶς",
                     "_translit": "Barabbâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-ab-bas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01347"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "05"
                     }
                  ],
                  "__text": "of Chaldee origin (\n and \n);"
               },
               "strongs_def": "son of Abba; Bar-abbas, an\n Israelite",
               "kjv_def": ":--Barabbas.",
               "_strongs": "00912"
            },
            {
               "strongs": "913",
               "greek": [
                  {
                     "_BETA": "*BARA/K",
                     "_unicode": "Βαράκ",
                     "_translit": "Barák"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-ak'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01301"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Barak, an Israelite",
               "kjv_def": ":--Barak.",
               "_strongs": "00913"
            },
            {
               "strongs": "914",
               "greek": [
                  {
                     "_BETA": "*BARAXI/AS",
                     "_unicode": "Βαραχίας",
                     "_translit": "Barachías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-akh-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01296"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Barachias (i.e. Berechijah), an\n Israelite",
               "kjv_def": ":--Barachias.",
               "_strongs": "00914"
            },
            {
               "strongs": "915",
               "greek": [
                  {
                     "_BETA": "BA/RBAROS",
                     "_unicode": "βάρβαρος",
                     "_translit": "bárbaros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar'-bar-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a foreigner (i.e.\n non-Greek)",
               "kjv_def": ":--barbarian(-rous).",
               "_strongs": "00915"
            },
            {
               "strongs": "916",
               "greek": [
                  {
                     "_BETA": "BARE/W",
                     "_unicode": "βαρέω",
                     "_translit": "baréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "926"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to weigh down (figuratively)",
               "kjv_def": ":--burden, charge, heavy, press.",
               "_strongs": "00916"
            },
            {
               "strongs": "917",
               "greek": [
                  {
                     "_BETA": "BARE/WS",
                     "_unicode": "βαρέως",
                     "_translit": "baréōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-eh'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "926"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "heavily (figuratively)",
               "kjv_def": ":--dull.",
               "_strongs": "00917"
            },
            {
               "strongs": "918",
               "greek": [
                  {
                     "_BETA": "*BARQOLOMAI=OS",
                     "_unicode": "Βαρθολομαῖος",
                     "_translit": "Bartholomaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-thol-om-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01247"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "08526"
                     }
                  ],
                  "__text": "of Chaldee origin (\n and \n);"
               },
               "strongs_def": "son of Tolmai; Bar-tholomæus, a\n Christian apostle",
               "kjv_def": ":--Bartholomeus.",
               "_strongs": "00918"
            },
            {
               "strongs": "919",
               "greek": [
                  {
                     "_BETA": "*BARIHSOU=S",
                     "_unicode": "Βαριησοῦς",
                     "_translit": "Bariēsoûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-ee-ay-sooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01247"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "03091"
                     }
                  ],
                  "__text": "of Chaldee origin (\n and \n);"
               },
               "strongs_def": "son of Jesus (or Joshua);\n Bar-jesus, an Israelite",
               "kjv_def": ":--Barjesus.",
               "_strongs": "00919"
            },
            {
               "strongs": "920",
               "greek": [
                  {
                     "_BETA": "*BARIWNA=S",
                     "_unicode": "Βαριωνᾶς",
                     "_translit": "Bariōnâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-ee-oo-nas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01247"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "03124"
                     }
                  ],
                  "__text": "of Chaldee origin (\n and \n);"
               },
               "strongs_def": "son of Jonas (or Jonah); Bar-jonas,\n an Israelite",
               "kjv_def": ":--Bar-jona.",
               "_strongs": "00920"
            },
            {
               "strongs": "921",
               "greek": [
                  {
                     "_BETA": "*BARNA/BAS",
                     "_unicode": "Βαρνάβας",
                     "_translit": "Barnábas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-nab'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01247"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "05029"
                     }
                  ],
                  "__text": "of Chaldee origin (\n and \n);"
               },
               "strongs_def": "son of Nabas (i.e. prophecy);\n Barnabas, an Israelite",
               "kjv_def": ":--Barnabas.",
               "_strongs": "00921"
            },
            {
               "strongs": "922",
               "greek": [
                  {
                     "_BETA": "BA/ROS",
                     "_unicode": "βάρος",
                     "_translit": "báros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "899"
                     }
                  ],
                  "__text": "probably from the same as \n (through the notion of going down;\n compare \n);"
               },
               "strongs_def": "weight; in the New Testament only, figuratively, a load,\n abundance, authority",
               "kjv_def": ":--burden(-some), weight.",
               "_strongs": "00922"
            },
            {
               "strongs": "923",
               "greek": [
                  {
                     "_BETA": "*BARSABA=S",
                     "_unicode": "Βαρσαβᾶς",
                     "_translit": "Barsabâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-sab-as'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01247"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "06634"
                     }
                  ],
                  "__text": "of Chaldee origin (\n and probably \n);"
               },
               "strongs_def": "son of Sabas (or Tsaba);\n Bar-sabas, the name of two Israelites",
               "kjv_def": ":--Barsabas.",
               "_strongs": "00923"
            },
            {
               "strongs": "924",
               "greek": [
                  {
                     "_BETA": "*BARTIMAI=OS",
                     "_unicode": "Βαρτιμαῖος",
                     "_translit": "Bartimaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-tim-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01247"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "02931"
                     }
                  ],
                  "__text": "of Chaldee origin (\n and \n);"
               },
               "strongs_def": "son of Timæus (or the unclean);\n Bar-timæus, an Israelite",
               "kjv_def": ":--Bartimæus.",
               "_strongs": "00924"
            },
            {
               "strongs": "925",
               "greek": [
                  {
                     "_BETA": "BARU/NW",
                     "_unicode": "βαρύνω",
                     "_translit": "barýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-oo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "926"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to burden (figuratively)",
               "kjv_def": ":--overcharge.",
               "_strongs": "00925"
            },
            {
               "strongs": "926",
               "greek": [
                  {
                     "_BETA": "BARU/S",
                     "_unicode": "βαρύς",
                     "_translit": "barýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-ooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "922"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "weighty, i.e. (fig) burdensome,\n grave",
               "kjv_def": ":--grievous, heavy, weightier.",
               "_strongs": "00926"
            },
            {
               "strongs": "927",
               "greek": [
                  {
                     "_BETA": "BARU/TIMOS",
                     "_unicode": "βαρύτιμος",
                     "_translit": "barýtimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bar-oo'-tim-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "926"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "highly valuable",
               "kjv_def": ":--very precious.",
               "_strongs": "00927"
            },
            {
               "strongs": "928",
               "greek": [
                  {
                     "_BETA": "BASANI/ZW",
                     "_unicode": "βασανίζω",
                     "_translit": "basanízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-an-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "931"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to torture",
               "kjv_def": ":--pain, toil, torment, toss, vex.",
               "_strongs": "00928"
            },
            {
               "strongs": "929",
               "greek": [
                  {
                     "_BETA": "BASANISMO/S",
                     "_unicode": "βασανισμός",
                     "_translit": "basanismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-an-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "928"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "torture",
               "kjv_def": ":--torment.",
               "_strongs": "00929"
            },
            {
               "strongs": "930",
               "greek": [
                  {
                     "_BETA": "BASANISTH/S",
                     "_unicode": "βασανιστής",
                     "_translit": "basanistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-an-is-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "928"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a torturer",
               "kjv_def": ":--tormentor.",
               "_strongs": "00930"
            },
            {
               "strongs": "931",
               "greek": [
                  {
                     "_BETA": "BA/SANOS",
                     "_unicode": "βάσανος",
                     "_translit": "básanos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas'-an-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "perhaps remotely from the same as \n (through the notion of going to\n the bottom);"
               },
               "strongs_def": "a touch-stone, i.e. (by analogy) torture",
               "kjv_def": ":--torment.",
               "_strongs": "00931"
            },
            {
               "strongs": "932",
               "greek": [
                  {
                     "_BETA": "BASILEI/A",
                     "_unicode": "βασιλεία",
                     "_translit": "basileía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-il-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "935"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, royalty, i.e. (abstractly) rule, or (concretely) a\n realm (literally or figuratively)",
               "kjv_def": ":--kingdom,\n + reign.",
               "_strongs": "00932"
            },
            {
               "strongs": "933",
               "greek": [
                  {
                     "_BETA": "BASI/LEION",
                     "_unicode": "βασίλειον",
                     "_translit": "basíleion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-il'-i-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "934"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": "a palace",
               "kjv_def": ":--king's court.",
               "_strongs": "00933"
            },
            {
               "strongs": "934",
               "greek": [
                  {
                     "_BETA": "BASI/LEIOS",
                     "_unicode": "βασίλειος",
                     "_translit": "basíleios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-il'-i-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "935"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "kingly (in nature)",
               "kjv_def": ":--royal.",
               "_strongs": "00934"
            },
            {
               "strongs": "935",
               "greek": [
                  {
                     "_BETA": "BASILEU/S",
                     "_unicode": "βασιλεύς",
                     "_translit": "basileús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-il-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "probably from \n (through the notion of a foundation of power);"
               },
               "strongs_def": "a\n sovereign (abstractly, relatively, or figuratively)",
               "kjv_def": ":--king.",
               "_strongs": "00935"
            },
            {
               "strongs": "936",
               "greek": [
                  {
                     "_BETA": "BASILEU/W",
                     "_unicode": "βασιλεύω",
                     "_translit": "basileúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-il-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "935"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to rule (literally or figuratively)",
               "kjv_def": ":--king, reign.",
               "_strongs": "00936"
            },
            {
               "strongs": "937",
               "greek": [
                  {
                     "_BETA": "BASILIKO/S",
                     "_unicode": "βασιλικός",
                     "_translit": "basilikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-il-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "935"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "regal (in relation), i.e. (literally) belonging to (or\n befitting) the sovereign (as land, dress, or a courtier), or\n (figuratively) preeminent",
               "kjv_def": ":--king's, nobleman, royal.",
               "_strongs": "00937"
            },
            {
               "strongs": "938",
               "greek": [
                  {
                     "_BETA": "BASI/LISSA",
                     "_unicode": "βασίλισσα",
                     "_translit": "basílissa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-il'-is-sah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "936"
                     }
                  ],
                  "__text": "feminine from \n;"
               },
               "strongs_def": "a queen",
               "kjv_def": ":--queen.",
               "_strongs": "00938"
            },
            {
               "strongs": "939",
               "greek": [
                  {
                     "_BETA": "BA/SIS",
                     "_unicode": "βάσις",
                     "_translit": "básis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas'-ece"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "BAI/NW",
                        "_unicode": "βαίνω",
                        "_translit": "baínō"
                     }
                  ],
                  "__text": "from \n (to walk);"
               },
               "strongs_def": "a pace (\"base\"), i.e. (by implication) the\n foot",
               "kjv_def": ":--foot.",
               "_strongs": "00939"
            },
            {
               "strongs": "940",
               "greek": [
                  {
                     "_BETA": "BASKAI/NW",
                     "_unicode": "βασκαίνω",
                     "_translit": "baskaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-kah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5335"
                     }
                  ],
                  "__text": "akin to \n;"
               },
               "strongs_def": "to malign, i.e. (by extension) to fascinate (by false\n representations)",
               "kjv_def": ":--bewitch.",
               "_strongs": "00940"
            },
            {
               "strongs": "941",
               "greek": [
                  {
                     "_BETA": "BASTA/ZW",
                     "_unicode": "βαστάζω",
                     "_translit": "bastázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bas-tad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "perhaps remotely derived from the base of \n (through the idea of\n removal);"
               },
               "strongs_def": "to lift, literally or figuratively (endure, declare,\n sustain, receive, etc.)",
               "kjv_def": ":--bear, carry, take up.",
               "_strongs": "00941"
            },
            {
               "strongs": "942",
               "greek": [
                  {
                     "_BETA": "BA/TOS",
                     "_unicode": "βάτος",
                     "_translit": "bátos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bat'-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a brier shrub",
               "kjv_def": ":--bramble, bush.",
               "_strongs": "00942"
            },
            {
               "strongs": "943",
               "greek": [
                  {
                     "_BETA": "BA/TOS",
                     "_unicode": "βάτος",
                     "_translit": "bátos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bat'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01324"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "a bath, or measure for liquids",
               "kjv_def": ":--measure.",
               "_strongs": "00943"
            },
            {
               "strongs": "944",
               "greek": [
                  {
                     "_BETA": "BA/TRAXOS",
                     "_unicode": "βάτραχος",
                     "_translit": "bátrachos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bat'-rakh-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a frog",
               "kjv_def": ":--frog.",
               "_strongs": "00944"
            },
            {
               "strongs": "945",
               "greek": [
                  {
                     "_BETA": "BATTOLOGE/W",
                     "_unicode": "βαττολογέω",
                     "_translit": "battologéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bat-tol-og-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*BA/TTOS",
                        "_unicode": "Βάττος",
                        "_translit": "Báttos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n (a proverbial stammerer) and \n;"
               },
               "strongs_def": "to stutter, i.e. (by\n implication) to prate tediously",
               "kjv_def": ":--use vain repetitions.",
               "_strongs": "00945"
            },
            {
               "strongs": "946",
               "greek": [
                  {
                     "_BETA": "BDE/LUGMA",
                     "_unicode": "βδέλυγμα",
                     "_translit": "bdélygma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bdel'-oog-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "948"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a detestation, i.e. (specially) idolatry",
               "kjv_def": ":--abomination.",
               "_strongs": "00946"
            },
            {
               "strongs": "947",
               "greek": [
                  {
                     "_BETA": "BDELUKTO/S",
                     "_unicode": "βδελυκτός",
                     "_translit": "bdelyktós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bdel-ook-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "948"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "detestable, i.e. (specially) idolatrous",
               "kjv_def": ":--abominable.",
               "_strongs": "00947"
            },
            {
               "strongs": "948",
               "greek": [
                  {
                     "_BETA": "BDELU/SSW",
                     "_unicode": "βδελύσσω",
                     "_translit": "bdelýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bdel-oos'-so"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "BDE/W",
                        "_unicode": "βδέω",
                        "_translit": "bdéō"
                     }
                  ],
                  "__text": "from a (presumed) derivative of \n (to stink);"
               },
               "strongs_def": "to be disgusted, i.e.\n (by implication) detest (especially of idolatry)",
               "kjv_def": ":--abhor, abominable.",
               "_strongs": "00948"
            },
            {
               "strongs": "949",
               "greek": [
                  {
                     "_BETA": "BE/BAIOS",
                     "_unicode": "βέβαιος",
                     "_translit": "bébaios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "beb'-ah-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from the base of \n (through the idea of basality);"
               },
               "strongs_def": "stable (literally\n or figuratively)",
               "kjv_def": ":--firm, of force, stedfast, sure.",
               "_strongs": "00949"
            },
            {
               "strongs": "950",
               "greek": [
                  {
                     "_BETA": "BEBAIO/W",
                     "_unicode": "βεβαιόω",
                     "_translit": "bebaióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "beb-ah-yo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "949"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to stabilitate (figuratively)",
               "kjv_def": ":--confirm, (e-)stablish.",
               "_strongs": "00950"
            },
            {
               "strongs": "951",
               "greek": [
                  {
                     "_BETA": "BEBAI/WSIS",
                     "_unicode": "βεβαίωσις",
                     "_translit": "bebaíōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "beb-ah'-yo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "950"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "stabiliment",
               "kjv_def": ":--confirmation.",
               "_strongs": "00951"
            },
            {
               "strongs": "952",
               "greek": [
                  {
                     "_BETA": "BE/BHLOS",
                     "_unicode": "βέβηλος",
                     "_translit": "bébēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "beb'-ay-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "BHLO/S",
                        "_unicode": "βηλός",
                        "_translit": "bēlós"
                     }
                  ],
                  "__text": "from the base of \n and \n (a threshold);"
               },
               "strongs_def": "accessible (as by\n crossing the door-way), i.e. (by implication, of Jewish notions)\n heathenish, wicked",
               "kjv_def": ":--profane (person).",
               "_strongs": "00952"
            },
            {
               "strongs": "953",
               "greek": [
                  {
                     "_BETA": "BEBHLO/W",
                     "_unicode": "βεβηλόω",
                     "_translit": "bebēlóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "beb-ay-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "952"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to desecrate",
               "kjv_def": ":--profane.",
               "_strongs": "00953"
            },
            {
               "strongs": "954",
               "greek": [
                  {
                     "_BETA": "*BEELZEBOU/L",
                     "_unicode": "Βεελζεβούλ",
                     "_translit": "Beelzeboúl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "beh-el-zeb-ool'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01176"
                     }
                  ],
                  "__text": "of Chaldee origin (by parody on \n);"
               },
               "strongs_def": "dung-god; Beelzebul, a name of\n Satan",
               "kjv_def": ":--Beelzebub.",
               "_strongs": "00954"
            },
            {
               "strongs": "955",
               "greek": [
                  {
                     "_BETA": "*BELI/AL",
                     "_unicode": "Βελίαλ",
                     "_translit": "Belíal"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bel-ee'-al"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01100"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "worthlessness; Belial, as an epithet of\n Satan",
               "kjv_def": ":--Belial.",
               "_strongs": "00955"
            },
            {
               "strongs": "956",
               "greek": [
                  {
                     "_BETA": "BE/LOS",
                     "_unicode": "βέλος",
                     "_translit": "bélos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bel'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a missile, i.e. spear or arrow",
               "kjv_def": ":--dart.",
               "_strongs": "00956"
            },
            {
               "strongs": "957",
               "greek": [
                  {
                     "_BETA": "BELTI/ON",
                     "_unicode": "βελτίον",
                     "_translit": "beltíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bel-tee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "18"
                     }
                  ],
                  "__text": "neuter of a compound of a derivative of \n (used for the comparative\n of \n);"
               },
               "strongs_def": "better",
               "kjv_def": ":--very well.",
               "_strongs": "00957"
            },
            {
               "strongs": "958",
               "greek": [
                  {
                     "_BETA": "*BENIAMI/N",
                     "_unicode": "Βενιαμίν",
                     "_translit": "Beniamín"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ben-ee-am-een'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01144"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Benjamin, an Israelite",
               "kjv_def": ":--Benjamin.",
               "_strongs": "00958"
            },
            {
               "strongs": "959",
               "greek": [
                  {
                     "_BETA": "*BERNI/KH",
                     "_unicode": "Βερνίκη",
                     "_translit": "Berníkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ber-nee'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3529"
                     }
                  ],
                  "__text": "from a provincial form of \n and \n;"
               },
               "strongs_def": "victorious; Bernice, a member\n of the Herodian family",
               "kjv_def": ":--Bernice.",
               "_strongs": "00959"
            },
            {
               "strongs": "960",
               "greek": [
                  {
                     "_BETA": "*BE/ROIA",
                     "_unicode": "Βέροια",
                     "_translit": "Béroia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ber'-oy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "perhaps a provincial from a derivative of \n (Perœa, i.e. the\n region beyond the coast-line);"
               },
               "strongs_def": "Berœa, a place in Macedonia",
               "kjv_def": ":--Berea.",
               "_strongs": "00960"
            },
            {
               "strongs": "961",
               "greek": [
                  {
                     "_BETA": "*BEROIAI=OS",
                     "_unicode": "Βεροιαῖος",
                     "_translit": "Beroiaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ber-oy-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "960"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Berœoean or native of Berœa",
               "kjv_def": ":--of Berea.",
               "_strongs": "00961"
            },
            {
               "strongs": "962",
               "greek": [
                  {
                     "_BETA": "*BHQABARA/",
                     "_unicode": "Βηθαβαρά",
                     "_translit": "Bēthabará"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bay-thab-ar-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01004"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "05679"
                     }
                  ],
                  "__text": "of Hebrew origin (\n and \n);"
               },
               "strongs_def": "ferry-house; Bethabara (i.e.\n Bethabarah), a place on the Jordan",
               "kjv_def": ":--Bethabara.",
               "_strongs": "00962"
            },
            {
               "strongs": "963",
               "greek": [
                  {
                     "_BETA": "*BHQANI/A",
                     "_unicode": "Βηθανία",
                     "_translit": "Bēthanía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bay-than-ee'-ah"
                  }
               ],
               "strongs_derivation": "of Chaldee origin;",
               "strongs_def": "date-house; Beth-any, a place in\n Palestine",
               "kjv_def": ":--Bethany.",
               "_strongs": "00963"
            },
            {
               "strongs": "964",
               "greek": [
                  {
                     "_BETA": "*BHQESDA/",
                     "_unicode": "Βηθεσδά",
                     "_translit": "Bēthesdá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bay-thes-dah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01004"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "02617"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n and \n);"
               },
               "strongs_def": "house of kindness;\n Beth-esda, a pool in Jerusalem",
               "kjv_def": ":--Bethesda.",
               "_strongs": "00964"
            },
            {
               "strongs": "965",
               "greek": [
                  {
                     "_BETA": "*BHQLEE/M",
                     "_unicode": "Βηθλεέμ",
                     "_translit": "Bēthleém"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bayth-leh-em'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01036"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Bethleem (i.e. Beth-lechem), a place in\n Palestine",
               "kjv_def": ":--Bethlehem.",
               "_strongs": "00965"
            },
            {
               "strongs": "966",
               "greek": [
                  {
                     "_BETA": "*BHQSAI+DA/",
                     "_unicode": "Βηθσαϊδά",
                     "_translit": "Bēthsaïdá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bayth-sahee-dah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01004"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "06719"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n and \n);"
               },
               "strongs_def": "fishing-house; Bethsaida, a\n place in Palestine",
               "kjv_def": ":--Bethsaida.",
               "_strongs": "00966"
            },
            {
               "strongs": "967",
               "greek": [
                  {
                     "_BETA": "*BHQFAGH/",
                     "_unicode": "Βηθφαγή",
                     "_translit": "Bēthphagḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bayth-fag-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01004"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "06291"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n and \n);"
               },
               "strongs_def": "fig-house; Beth-phage, a\n place in Palestine",
               "kjv_def": ":--Bethphage.",
               "_strongs": "00967"
            },
            {
               "strongs": "968",
               "greek": [
                  {
                     "_BETA": "BH=MA",
                     "_unicode": "βῆμα",
                     "_translit": "bēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bay'-ma"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a step, i.e. foot-breath; by implication, a\n rostrum, i.e. a tribunal",
               "kjv_def": ":--judgment-seat, set (foot) on, throne.",
               "_strongs": "00968"
            },
            {
               "strongs": "969",
               "greek": [
                  {
                     "_BETA": "BH/RULLOS",
                     "_unicode": "βήρυλλος",
                     "_translit": "bḗryllos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bay'-rool-los"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a \"beryl\"",
               "kjv_def": ":--beryl.",
               "_strongs": "00969"
            },
            {
               "strongs": "970",
               "greek": [
                  {
                     "_BETA": "BI/A",
                     "_unicode": "βία",
                     "_translit": "bía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "979"
                     }
                  ],
                  "__text": "probably akin to \n (through the idea of vital activity);"
               },
               "strongs_def": "force",
               "kjv_def": ":--violence.",
               "_strongs": "00970"
            },
            {
               "strongs": "971",
               "greek": [
                  {
                     "_BETA": "BIA/ZW",
                     "_unicode": "βιάζω",
                     "_translit": "biázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "970"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to force, i.e. (reflexively) to crowd oneself (into), or\n (passively) to be seized",
               "kjv_def": ":--press, suffer violence.",
               "_strongs": "00971"
            },
            {
               "strongs": "972",
               "greek": [
                  {
                     "_BETA": "BI/AIOS",
                     "_unicode": "βίαιος",
                     "_translit": "bíaios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee'-ah-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "970"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "violent",
               "kjv_def": ":--mighty.",
               "_strongs": "00972"
            },
            {
               "strongs": "973",
               "greek": [
                  {
                     "_BETA": "BIASTH/S",
                     "_unicode": "βιαστής",
                     "_translit": "biastḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee-as-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "971"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a forcer, i.e. (figuratively) energetic",
               "kjv_def": ":--violent.",
               "_strongs": "00973"
            },
            {
               "strongs": "974",
               "greek": [
                  {
                     "_BETA": "BIBLIARI/DION",
                     "_unicode": "βιβλιαρίδιον",
                     "_translit": "bibliarídion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bib-lee-ar-id'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "975"
                     }
                  ],
                  "__text": "a diminutive of \n;"
               },
               "strongs_def": "a booklet",
               "kjv_def": ":--little book.",
               "_strongs": "00974"
            },
            {
               "strongs": "975",
               "greek": [
                  {
                     "_BETA": "BIBLI/ON",
                     "_unicode": "βιβλίον",
                     "_translit": "biblíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bib-lee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "976"
                     }
                  ],
                  "__text": "a diminutive of \n;"
               },
               "strongs_def": "a roll",
               "kjv_def": ":--bill, book, scroll, writing.",
               "_strongs": "00975"
            },
            {
               "strongs": "976",
               "greek": [
                  {
                     "_BETA": "BI/BLOS",
                     "_unicode": "βίβλος",
                     "_translit": "bíblos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bib'-los"
                  }
               ],
               "strongs_derivation": "properly, the inner bark of the papyrus plant, i.e. (by implication) a\n sheet or scroll of writing",
               "kjv_def": ":--book.",
               "_strongs": "00976"
            },
            {
               "strongs": "977",
               "greek": [
                  {
                     "_BETA": "BIBRW/SKW",
                     "_unicode": "βιβρώσκω",
                     "_translit": "bibrṓskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bib-ro'-sko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1006"
                     }
                  ],
                  "__text": "a reduplicated and prolonged form of an obsolete primary verb (perhaps\n causative of \n);"
               },
               "strongs_def": "to eat",
               "kjv_def": ":--eat.",
               "_strongs": "00977"
            },
            {
               "strongs": "978",
               "greek": [
                  {
                     "_BETA": "*BIQUNI/A",
                     "_unicode": "Βιθυνία",
                     "_translit": "Bithynía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee-thoo-nee'-ah"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Bithynia, a region of Asia",
               "kjv_def": ":--Bithynia.",
               "_strongs": "00978"
            },
            {
               "strongs": "979",
               "greek": [
                  {
                     "_BETA": "BI/OS",
                     "_unicode": "βίος",
                     "_translit": "bíos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee'-os"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "life, i.e. (literally) the present state of existence;\n by implication, the means of livelihood",
               "kjv_def": ":--good, life, living.",
               "_strongs": "00979"
            },
            {
               "strongs": "980",
               "greek": [
                  {
                     "_BETA": "BIO/W",
                     "_unicode": "βιόω",
                     "_translit": "bióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "979"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to spend existence",
               "kjv_def": ":--live.",
               "_strongs": "00980"
            },
            {
               "strongs": "981",
               "greek": [
                  {
                     "_BETA": "BI/WSIS",
                     "_unicode": "βίωσις",
                     "_translit": "bíōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee'-o-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "980"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "living (properly, the act, by implication, the\n mode)",
               "kjv_def": ":--manner of life.",
               "_strongs": "00981"
            },
            {
               "strongs": "982",
               "greek": [
                  {
                     "_BETA": "BIWTIKO/S",
                     "_unicode": "βιωτικός",
                     "_translit": "biōtikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bee-o-tee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "980"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "relating to the present existence",
               "kjv_def": ":--of\n (pertaining to, things that pertain to) this life.",
               "_strongs": "00982"
            },
            {
               "strongs": "983",
               "greek": [
                  {
                     "_BETA": "BLABERO/S",
                     "_unicode": "βλαβερός",
                     "_translit": "blaberós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blab-er-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "984"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "injurious",
               "kjv_def": ":--hurtful.",
               "_strongs": "00983"
            },
            {
               "strongs": "984",
               "greek": [
                  {
                     "_BETA": "BLA/PTW",
                     "_unicode": "βλάπτω",
                     "_translit": "bláptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blap'-to"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "properly, to hinder, i.e. (by implication) to\n injure",
               "kjv_def": ":--hurt.",
               "_strongs": "00984"
            },
            {
               "strongs": "985",
               "greek": [
                  {
                     "_BETA": "BLASTA/NW",
                     "_unicode": "βλαστάνω",
                     "_translit": "blastánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blas-tan'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "BLASTO/S",
                        "_unicode": "βλαστός",
                        "_translit": "blastós"
                     }
                  ],
                  "__text": "from \n (a sprout);"
               },
               "strongs_def": "to germinate; by implication, to yield\n fruit",
               "kjv_def": ":--bring forth, bud, spring (up).",
               "_strongs": "00985"
            },
            {
               "strongs": "986",
               "greek": [
                  {
                     "_BETA": "*BLA/STOS",
                     "_unicode": "Βλάστος",
                     "_translit": "Blástos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blas'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "985"
                     }
                  ],
                  "__text": "perhaps the same as the base of \n;"
               },
               "strongs_def": "Blastus, an officer of Herod\n Agrippa",
               "kjv_def": ":--Blastus.",
               "_strongs": "00986"
            },
            {
               "strongs": "987",
               "greek": [
                  {
                     "_BETA": "BLASFHME/W",
                     "_unicode": "βλασφημέω",
                     "_translit": "blasphēméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blas-fay-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "989"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to vilify; specially, to speak impiously",
               "kjv_def": ":--(speak)\n blaspheme(-er, -mously, -my), defame, rail on, revile, speak evil.",
               "_strongs": "00987"
            },
            {
               "strongs": "988",
               "greek": [
                  {
                     "_BETA": "BLASFHMI/A",
                     "_unicode": "βλασφημία",
                     "_translit": "blasphēmía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blas-fay-me'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "989"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "vilification (especially against God)",
               "kjv_def": ":--blasphemy, evil\n speaking, railing.",
               "_strongs": "00988"
            },
            {
               "strongs": "989",
               "greek": [
                  {
                     "_BETA": "BLA/SFHMOS",
                     "_unicode": "βλάσφημος",
                     "_translit": "blásphēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blas'-fay-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "984"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5345"
                     }
                  ],
                  "__text": "from a derivative of \n and \n;"
               },
               "strongs_def": "scurrilious, i.e. calumnious\n (against men), or (specially) impious (against\n God)",
               "kjv_def": ":--blasphemer(-mous), railing.",
               "_strongs": "00989"
            },
            {
               "strongs": "990",
               "greek": [
                  {
                     "_BETA": "BLE/MMA",
                     "_unicode": "βλέμμα",
                     "_translit": "blémma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blem'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "vision (properly concrete; by implication,\n abstract)",
               "kjv_def": ":--seeing.",
               "_strongs": "00990"
            },
            {
               "strongs": "991",
               "greek": [
                  {
                     "_BETA": "BLE/PW",
                     "_unicode": "βλέπω",
                     "_translit": "blépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blep'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to look at (literally or figuratively)",
               "kjv_def": ":--behold,\n beware, lie, look (on, to), perceive, regard, see, sight, take heed.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3700"
                  }
               ],
               "_strongs": "00991",
               "__text": "Compare \n."
            },
            {
               "strongs": "992",
               "greek": [
                  {
                     "_BETA": "BLHTE/OS",
                     "_unicode": "βλητέος",
                     "_translit": "blētéos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "blay-teh'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fit to be cast (i.e. applied)",
               "kjv_def": ":--must be put.",
               "_strongs": "00992"
            },
            {
               "strongs": "993",
               "greek": [
                  {
                     "_BETA": "*BOANERGE/S",
                     "_unicode": "Βοανεργές",
                     "_translit": "Boanergés"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bo-an-erg-es'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01123"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "07266"
                     }
                  ],
                  "__text": "of Chaldee origin (\n and \n);"
               },
               "strongs_def": "sons of commotion; Boanerges, an\n epithet of two of the apostles",
               "kjv_def": ":--Boanerges.",
               "_strongs": "00993"
            },
            {
               "strongs": "994",
               "greek": [
                  {
                     "_BETA": "BOA/W",
                     "_unicode": "βοάω",
                     "_translit": "boáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bo-ah'-o"
                  }
               ],
               "strongs_derivation": "apparently a prolonged form of a primary verb;",
               "strongs_def": "to halloo, i.e. shout\n (for help or in a tumultuous way)",
               "kjv_def": ":--cry.",
               "_strongs": "00994"
            },
            {
               "strongs": "995",
               "greek": [
                  {
                     "_BETA": "BOH/",
                     "_unicode": "βοή",
                     "_translit": "boḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bo-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "994"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a halloo, i.e. call (for aid, etc.)",
               "kjv_def": ":--cry.",
               "_strongs": "00995"
            },
            {
               "strongs": "996",
               "greek": [
                  {
                     "_BETA": "BOH/QEIA",
                     "_unicode": "βοήθεια",
                     "_translit": "boḗtheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bo-ay'-thi-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "998"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "aid; specially, a rope or chain for frapping a\n vessel",
               "kjv_def": ":--help.",
               "_strongs": "00996"
            },
            {
               "strongs": "997",
               "greek": [
                  {
                     "_BETA": "BOHQE/W",
                     "_unicode": "βοηθέω",
                     "_translit": "boēthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bo-ay-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "998"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to aid or relieve",
               "kjv_def": ":--help, succor.",
               "_strongs": "00997"
            },
            {
               "strongs": "998",
               "greek": [
                  {
                     "_BETA": "BOHQO/S",
                     "_unicode": "βοηθός",
                     "_translit": "boēthós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bo-ay-thos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "995"
                     }
                  ],
                  "__text": "from \n and theo (to run);"
               },
               "strongs_def": "a succorer",
               "kjv_def": ":--helper.",
               "_strongs": "00998"
            },
            {
               "strongs": "999",
               "greek": [
                  {
                     "_BETA": "BO/QUNOS",
                     "_unicode": "βόθυνος",
                     "_translit": "bóthynos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "both'-oo-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "900"
                     }
                  ],
                  "__text": "akin to \n;"
               },
               "strongs_def": "a hole (in the ground); specially, a cistern",
               "kjv_def": ":--ditch,\n pit.",
               "_strongs": "00999"
            },
            {
               "strongs": "1000",
               "greek": [
                  {
                     "_BETA": "BOLH/",
                     "_unicode": "βολή",
                     "_translit": "bolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a throw (as a measure of distance)",
               "kjv_def": ":--cast.",
               "_strongs": "01000"
            },
            {
               "strongs": "1001",
               "greek": [
                  {
                     "_BETA": "BOLI/ZW",
                     "_unicode": "βολίζω",
                     "_translit": "bolízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bol-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1002"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to heave the lead",
               "kjv_def": ":--sound.",
               "_strongs": "01001"
            },
            {
               "strongs": "1002",
               "greek": [
                  {
                     "_BETA": "BOLI/S",
                     "_unicode": "βολίς",
                     "_translit": "bolís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bol-ece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a missile, i.e. javelin",
               "kjv_def": ":--dart.",
               "_strongs": "01002"
            },
            {
               "strongs": "1003",
               "greek": [
                  {
                     "_BETA": "*BOO/Z",
                     "_unicode": "Βοόζ",
                     "_translit": "Boóz"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bo-oz'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01162"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Booz, (i.e. Boaz), an Israelite",
               "kjv_def": ":--Booz.",
               "_strongs": "01003"
            },
            {
               "strongs": "1004",
               "greek": [
                  {
                     "_BETA": "BO/RBOROS",
                     "_unicode": "βόρβορος",
                     "_translit": "bórboros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bor'-bor-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "mud",
               "kjv_def": ":--mire.",
               "_strongs": "01004"
            },
            {
               "strongs": "1005",
               "greek": [
                  {
                     "_BETA": "BOR)R(A=S",
                     "_unicode": "βοῤῥᾶς",
                     "_translit": "borrhâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bor-hras'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "the north (properly, wind)",
               "kjv_def": ":--north.",
               "_strongs": "01005"
            },
            {
               "strongs": "1006",
               "greek": [
                  {
                     "_BETA": "BO/SKW",
                     "_unicode": "βόσκω",
                     "_translit": "bóskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bos'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "977"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1016"
                     }
                  ],
                  "__text": "a prolonged form of a primary verb (compare \n, \n);"
               },
               "strongs_def": "to pasture; by\n extension to, fodder; reflexively, to graze",
               "kjv_def": ":--feed, keep.",
               "_strongs": "01006"
            },
            {
               "strongs": "1007",
               "greek": [
                  {
                     "_BETA": "*BOSO/R",
                     "_unicode": "Βοσόρ",
                     "_translit": "Bosór"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bos-or'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01160"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Bosor (i.e. Beor), a Moabite",
               "kjv_def": ":--Bosor.",
               "_strongs": "01007"
            },
            {
               "strongs": "1008",
               "greek": [
                  {
                     "_BETA": "BOTA/NH",
                     "_unicode": "βοτάνη",
                     "_translit": "botánē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bot-an'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1006"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "herbage (as if for grazing)",
               "kjv_def": ":--herb.",
               "_strongs": "01008"
            },
            {
               "strongs": "1009",
               "greek": [
                  {
                     "_BETA": "BO/TRUS",
                     "_unicode": "βότρυς",
                     "_translit": "bótrys"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bot'-rooce"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a bunch (of grapes)",
               "kjv_def": ":--(vine) cluster (of the\n vine).",
               "_strongs": "01009"
            },
            {
               "strongs": "1010",
               "greek": [
                  {
                     "_BETA": "BOULEUTH/S",
                     "_unicode": "βουλευτής",
                     "_translit": "bouleutḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bool-yoo-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1011"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an adviser, i.e. (specially) a councillor or member of the\n Jewish Sanhedrin",
               "kjv_def": ":--counsellor.",
               "_strongs": "01010"
            },
            {
               "strongs": "1011",
               "greek": [
                  {
                     "_BETA": "BOULEU/W",
                     "_unicode": "βουλεύω",
                     "_translit": "bouleúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bool-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1012"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to advise, i.e. (reflexively) deliberate, or (by\n implication) resolve",
               "kjv_def": ":--consult, take counsel, determine, be minded,\n purpose.",
               "_strongs": "01011"
            },
            {
               "strongs": "1012",
               "greek": [
                  {
                     "_BETA": "BOULH/",
                     "_unicode": "βουλή",
                     "_translit": "boulḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boo-lay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1014"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "volition, i.e. (objectively) advice, or (by implication)\n purpose",
               "kjv_def": ":--+ advise, counsel, will.",
               "_strongs": "01012"
            },
            {
               "strongs": "1013",
               "greek": [
                  {
                     "_BETA": "BOU/LHMA",
                     "_unicode": "βούλημα",
                     "_translit": "boúlēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boo'-lay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1014"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a resolve",
               "kjv_def": ":--purpose, will.",
               "_strongs": "01013"
            },
            {
               "strongs": "1014",
               "greek": [
                  {
                     "_BETA": "BOU/LOMAI",
                     "_unicode": "βούλομαι",
                     "_translit": "boúlomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boo'-lom-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of a primary verb;",
               "strongs_def": "to \"will,\" i.e. (reflexively) be\n willing",
               "kjv_def": ":--be disposed, minded, intend, list, (be, of own) will (-ing).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2309"
                  }
               ],
               "_strongs": "01014",
               "__text": "Compare \n."
            },
            {
               "strongs": "1015",
               "greek": [
                  {
                     "_BETA": "BOUNO/S",
                     "_unicode": "βουνός",
                     "_translit": "bounós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boo-nos'"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "a hillock",
               "kjv_def": ":--hill.",
               "_strongs": "01015"
            },
            {
               "strongs": "1016",
               "greek": [
                  {
                     "_BETA": "BOU=S",
                     "_unicode": "βοῦς",
                     "_translit": "boûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "booce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1006"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "an ox (as grazing), i.e. an animal of\n that species (\"beef\")",
               "kjv_def": ":--ox.",
               "_strongs": "01016"
            },
            {
               "strongs": "1017",
               "greek": [
                  {
                     "_BETA": "BRABEI=ON",
                     "_unicode": "βραβεῖον",
                     "_translit": "brabeîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brab-i'-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "BRABEU/S",
                        "_unicode": "βραβεύς",
                        "_translit": "brabeús"
                     }
                  ],
                  "__text": "from \n (an umpire of uncertain derivation);"
               },
               "strongs_def": "an award (of\n arbitration), i.e. (specially) a prize in the public games",
               "kjv_def": ":--prize.",
               "_strongs": "01017"
            },
            {
               "strongs": "1018",
               "greek": [
                  {
                     "_BETA": "BRABEU/W",
                     "_unicode": "βραβεύω",
                     "_translit": "brabeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brab-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1017"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to arbitrate, i.e. (genitive case) to govern\n (figuratively, prevail)",
               "kjv_def": ":--rule.",
               "_strongs": "01018"
            },
            {
               "strongs": "1019",
               "greek": [
                  {
                     "_BETA": "BRADU/NW",
                     "_unicode": "βραδύνω",
                     "_translit": "bradýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brad-oo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1021"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to delay",
               "kjv_def": ":--be slack, tarry.",
               "_strongs": "01019"
            },
            {
               "strongs": "1020",
               "greek": [
                  {
                     "_BETA": "BRADUPLOE/W",
                     "_unicode": "βραδυπλοέω",
                     "_translit": "bradyploéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brad-oo-plo-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1021"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n and a prolonged form of \n;"
               },
               "strongs_def": "to sail slowly",
               "kjv_def": ":--sail slowly.",
               "_strongs": "01020"
            },
            {
               "strongs": "1021",
               "greek": [
                  {
                     "_BETA": "BRADU/S",
                     "_unicode": "βραδύς",
                     "_translit": "bradýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brad-ooce'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "slow; figuratively, dull",
               "kjv_def": ":--slow.",
               "_strongs": "01021"
            },
            {
               "strongs": "1022",
               "greek": [
                  {
                     "_BETA": "BRADU/THS",
                     "_unicode": "βραδύτης",
                     "_translit": "bradýtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brad-oo'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1021"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "tardiness",
               "kjv_def": ":--slackness.",
               "_strongs": "01022"
            },
            {
               "strongs": "1023",
               "greek": [
                  {
                     "_BETA": "BRAXI/WN",
                     "_unicode": "βραχίων",
                     "_translit": "brachíōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brakh-ee'-own"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1024"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "BRA/SSW",
                        "_unicode": "βράσσω",
                        "_translit": "brássō"
                     }
                  ],
                  "__text": "properly, comparative of \n, but apparently in the sense of\n \n (to wield);"
               },
               "strongs_def": "the arm, i.e. (figuratively)\n strength",
               "kjv_def": ":--arm.",
               "_strongs": "01023"
            },
            {
               "strongs": "1024",
               "greek": [
                  {
                     "_BETA": "BRAXU/S",
                     "_unicode": "βραχύς",
                     "_translit": "brachýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brakh-ooce'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "short (of time, place, quantity, or\n number)",
               "kjv_def": ":--few words, little (space, while).",
               "_strongs": "01024"
            },
            {
               "strongs": "1025",
               "greek": [
                  {
                     "_BETA": "BRE/FOS",
                     "_unicode": "βρέφος",
                     "_translit": "bréphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bref'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "an infant (properly, unborn) literally or\n figuratively",
               "kjv_def": ":--babe, (young) child, infant.",
               "_strongs": "01025"
            },
            {
               "strongs": "1026",
               "greek": [
                  {
                     "_BETA": "BRE/XW",
                     "_unicode": "βρέχω",
                     "_translit": "bréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brekh'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to moisten (especially by a shower)",
               "kjv_def": ":--(send) rain,\n wash.",
               "_strongs": "01026"
            },
            {
               "strongs": "1027",
               "greek": [
                  {
                     "_BETA": "BRONTH/",
                     "_unicode": "βροντή",
                     "_translit": "brontḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bron-tay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "BRE/MW",
                        "_unicode": "βρέμω",
                        "_translit": "brémō"
                     }
                  ],
                  "__text": "akin to \n (to roar);"
               },
               "strongs_def": "thunder",
               "kjv_def": ":--thunder(-ing).",
               "_strongs": "01027"
            },
            {
               "strongs": "1028",
               "greek": [
                  {
                     "_BETA": "BROXH/",
                     "_unicode": "βροχή",
                     "_translit": "brochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brokh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1026"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "rain",
               "kjv_def": ":--rain.",
               "_strongs": "01028"
            },
            {
               "strongs": "1029",
               "greek": [
                  {
                     "_BETA": "BRO/XOS",
                     "_unicode": "βρόχος",
                     "_translit": "bróchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "brokh'-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a noose",
               "kjv_def": ":--snare.",
               "_strongs": "01029"
            },
            {
               "strongs": "1030",
               "greek": [
                  {
                     "_BETA": "BRUGMO/S",
                     "_unicode": "βρυγμός",
                     "_translit": "brygmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "broog-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1031"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a grating (of the teeth)",
               "kjv_def": ":--gnashing.",
               "_strongs": "01030"
            },
            {
               "strongs": "1031",
               "greek": [
                  {
                     "_BETA": "BRU/XW",
                     "_unicode": "βρύχω",
                     "_translit": "brýchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "broo'-kho"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to grate the teeth (in pain or rage)",
               "kjv_def": ":--gnash.",
               "_strongs": "01031"
            },
            {
               "strongs": "1032",
               "greek": [
                  {
                     "_BETA": "BRU/W",
                     "_unicode": "βρύω",
                     "_translit": "brýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "broo'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to swell out, i.e. (by implication) to gush",
               "kjv_def": ":--send\n forth.",
               "_strongs": "01032"
            },
            {
               "strongs": "1033",
               "greek": [
                  {
                     "_BETA": "BRW=MA",
                     "_unicode": "βρῶμα",
                     "_translit": "brōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bro'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "977"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "food (literally or figuratively), especially\n (ceremonially) articles allowed or forbidden by the Jewish law",
               "kjv_def": ":--meat,\n victuals.",
               "_strongs": "01033"
            },
            {
               "strongs": "1034",
               "greek": [
                  {
                     "_BETA": "BRW/SIMOS",
                     "_unicode": "βρώσιμος",
                     "_translit": "brṓsimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bro'-sim-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1035"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "eatable",
               "kjv_def": ":--meat.",
               "_strongs": "01034"
            },
            {
               "strongs": "1035",
               "greek": [
                  {
                     "_BETA": "BRW=SIS",
                     "_unicode": "βρῶσις",
                     "_translit": "brōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bro'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "977"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "(abstractly) eating (literally or figuratively);\n by extension (concretely) food (literally or figuratively)",
               "kjv_def": ":--eating,\n food, meat.",
               "_strongs": "01035"
            },
            {
               "strongs": "1036",
               "greek": [
                  {
                     "_BETA": "BUQI/ZW",
                     "_unicode": "βυθίζω",
                     "_translit": "bythízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boo-thid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1037"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to sink; by implication, to drown",
               "kjv_def": ":--begin to sink, drown.",
               "_strongs": "01036"
            },
            {
               "strongs": "1037",
               "greek": [
                  {
                     "_BETA": "BUQO/S",
                     "_unicode": "βυθός",
                     "_translit": "bythós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boo-thos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "899"
                     }
                  ],
                  "__text": "a variation of \n;"
               },
               "strongs_def": "depth, i.e. (by implication) the sea",
               "kjv_def": ":--deep.",
               "_strongs": "01037"
            },
            {
               "strongs": "1038",
               "greek": [
                  {
                     "_BETA": "BURSEU/S",
                     "_unicode": "βυρσεύς",
                     "_translit": "byrseús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boorce-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "BU/RSA",
                        "_unicode": "βύρσα",
                        "_translit": "býrsa"
                     }
                  ],
                  "__text": "from \n (a hide);"
               },
               "strongs_def": "a tanner",
               "kjv_def": ":--tanner.",
               "_strongs": "01038"
            },
            {
               "strongs": "1039",
               "greek": [
                  {
                     "_BETA": "BU/SSINOS",
                     "_unicode": "βύσσινος",
                     "_translit": "býssinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boos'-see-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1040"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "made of linen (neuter a linen cloth)",
               "kjv_def": ":--fine linen.",
               "_strongs": "01039"
            },
            {
               "strongs": "1040",
               "greek": [
                  {
                     "_BETA": "BU/SSOS",
                     "_unicode": "βύσσος",
                     "_translit": "býssos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "boos'-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0948"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "white linen",
               "kjv_def": ":--fine linen.",
               "_strongs": "01040"
            },
            {
               "strongs": "1041",
               "greek": [
                  {
                     "_BETA": "BWMO/S",
                     "_unicode": "βωμός",
                     "_translit": "bōmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "bo'-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "properly, a stand, i.e. (specially) an\n altar",
               "kjv_def": ":--altar.",
               "_strongs": "01041"
            },
            {
               "strongs": "1042",
               "greek": [
                  {
                     "_BETA": "GABBAQA/",
                     "_unicode": "γαββαθά",
                     "_translit": "gabbathá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gab-bath-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01355"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "the knoll; gabbatha, a vernacular\n term for the Roman tribunal in Jerusalem",
               "kjv_def": ":-- Gabbatha.",
               "_strongs": "01042"
            },
            {
               "strongs": "1043",
               "greek": [
                  {
                     "_BETA": "*GABRIH/L",
                     "_unicode": "Γαβριήλ",
                     "_translit": "Gabriḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gab-ree-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01403"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Gabriel, an archangel",
               "kjv_def": ":--Gabriel.",
               "_strongs": "01043"
            },
            {
               "strongs": "1044",
               "greek": [
                  {
                     "_BETA": "GA/GGRAINA",
                     "_unicode": "γάγγραινα",
                     "_translit": "gángraina"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gang'-grahee-nah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "GRAI/NW",
                        "_unicode": "γραίνω",
                        "_translit": "graínō"
                     }
                  ],
                  "__text": "from \n (to gnaw);"
               },
               "strongs_def": "an ulcer (\"gangrene\")",
               "kjv_def": ":--canker.",
               "_strongs": "01044"
            },
            {
               "strongs": "1045",
               "greek": [
                  {
                     "_BETA": "*GA/D",
                     "_unicode": "Γάδ",
                     "_translit": "Gád"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gad"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01410"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Gad, a tribe of Israelites",
               "kjv_def": ":--Gad.",
               "_strongs": "01045"
            },
            {
               "strongs": "1046",
               "greek": [
                  {
                     "_BETA": "*GADARHNO/S",
                     "_unicode": "Γαδαρηνός",
                     "_translit": "Gadarēnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gad-ar-ay-nos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*GADARA/",
                        "_unicode": "Γαδαρά",
                        "_translit": "Gadará"
                     }
                  ],
                  "__text": "from \n (a town east of the Jordan);"
               },
               "strongs_def": "a Gadarene or inhabitant of\n Gadara",
               "kjv_def": ":--Gadarene.",
               "_strongs": "01046"
            },
            {
               "strongs": "1047",
               "greek": [
                  {
                     "_BETA": "GA/ZA",
                     "_unicode": "γάζα",
                     "_translit": "gáza"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gad'-zah"
                  }
               ],
               "strongs_derivation": "of foreign origin;",
               "strongs_def": "a treasure",
               "kjv_def": ":--treasure.",
               "_strongs": "01047"
            },
            {
               "strongs": "1048",
               "greek": [
                  {
                     "_BETA": "*GA/ZA",
                     "_unicode": "Γάζα",
                     "_translit": "Gáza"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gad'-zah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05804"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Gazah (i.e. Azzah), a place in\n Palestine",
               "kjv_def": ":--Gaza.",
               "_strongs": "01048"
            },
            {
               "strongs": "1049",
               "greek": [
                  {
                     "_BETA": "GAZOFULA/KION",
                     "_unicode": "γαζοφυλάκιον",
                     "_translit": "gazophylákion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gad-zof-oo-lak'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1047"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5438"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a treasure-house, i.e. a court in the temple for\n the collection-boxes",
               "kjv_def": ":--treasury.",
               "_strongs": "01049"
            },
            {
               "strongs": "1050",
               "greek": [
                  {
                     "_BETA": "*GA/I+OS",
                     "_unicode": "Γάϊος",
                     "_translit": "Gáïos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gah'-ee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Gaius (i.e. Caius), a Christian",
               "kjv_def": ":--Gaius.",
               "_strongs": "01050"
            },
            {
               "strongs": "1051",
               "greek": [
                  {
                     "_BETA": "GA/LA",
                     "_unicode": "γάλα",
                     "_translit": "gála"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gal'-ah"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "milk (figuratively)",
               "kjv_def": ":--milk.",
               "_strongs": "01051"
            },
            {
               "strongs": "1052",
               "greek": [
                  {
                     "_BETA": "*GALA/THS",
                     "_unicode": "Γαλάτης",
                     "_translit": "Galátēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gal-at'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1053"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Galatian or inhabitant of Galatia",
               "kjv_def": ":--Galatian.",
               "_strongs": "01052"
            },
            {
               "strongs": "1053",
               "greek": [
                  {
                     "_BETA": "*GALATI/A",
                     "_unicode": "Γαλατία",
                     "_translit": "Galatía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gal-at-ee'-ah"
                  }
               ],
               "strongs_derivation": "of foreign origin;",
               "strongs_def": "Galatia, a region of Asia",
               "kjv_def": ":--Galatia.",
               "_strongs": "01053"
            },
            {
               "strongs": "1054",
               "greek": [
                  {
                     "_BETA": "*GALATIKO/S",
                     "_unicode": "Γαλατικός",
                     "_translit": "Galatikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gal-at-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1053"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Galatic or relating to Galatia",
               "kjv_def": ":--of Galatia.",
               "_strongs": "01054"
            },
            {
               "strongs": "1055",
               "greek": [
                  {
                     "_BETA": "GALH/NH",
                     "_unicode": "γαλήνη",
                     "_translit": "galḗnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gal-ay'-nay"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "tranquillity",
               "kjv_def": ":--calm.",
               "_strongs": "01055"
            },
            {
               "strongs": "1056",
               "greek": [
                  {
                     "_BETA": "*GALILAI/A",
                     "_unicode": "Γαλιλαία",
                     "_translit": "Galilaía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gal-il-ah'-yah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01551"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Galilæa (i.e. the heathen circle), a region\n of Palestine",
               "kjv_def": ":--Galilee.",
               "_strongs": "01056"
            },
            {
               "strongs": "1057",
               "greek": [
                  {
                     "_BETA": "*GALILAI=OS",
                     "_unicode": "Γαλιλαῖος",
                     "_translit": "Galilaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gal-ee-lah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1056"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Galilean or belonging to Galilea",
               "kjv_def": ":--Galilean, of Galilee.",
               "_strongs": "01057"
            },
            {
               "strongs": "1058",
               "greek": [
                  {
                     "_BETA": "*GALLI/WN",
                     "_unicode": "Γαλλίων",
                     "_translit": "Gallíōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gal-lee'-own"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Gallion (i.e. Gallio), a Roman officer",
               "kjv_def": ":--Gallio.",
               "_strongs": "01058"
            },
            {
               "strongs": "1059",
               "greek": [
                  {
                     "_BETA": "*GAMALIH/L",
                     "_unicode": "Γαμαλιήλ",
                     "_translit": "Gamaliḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gam-al-ee-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01583"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Gamaliel (i.e. Gamliel), an\n Israelite",
               "kjv_def": ":--Gamaliel.",
               "_strongs": "01059"
            },
            {
               "strongs": "1060",
               "greek": [
                  {
                     "_BETA": "GAME/W",
                     "_unicode": "γαμέω",
                     "_translit": "gaméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gam-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1062"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to wed (of either sex)",
               "kjv_def": ":--marry (a wife).",
               "_strongs": "01060"
            },
            {
               "strongs": "1061",
               "greek": [
                  {
                     "_BETA": "GAMI/SKW",
                     "_unicode": "γαμίσκω",
                     "_translit": "gamískō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gam-is'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1062"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to espouse (a daughter to a husband)",
               "kjv_def": ":--give in marriage.",
               "_strongs": "01061"
            },
            {
               "strongs": "1062",
               "greek": [
                  {
                     "_BETA": "GA/MOS",
                     "_unicode": "γάμος",
                     "_translit": "gámos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gam'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "nuptials",
               "kjv_def": ":--marriage, wedding.",
               "_strongs": "01062"
            },
            {
               "strongs": "1063",
               "greek": [
                  {
                     "_BETA": "GA/R",
                     "_unicode": "γάρ",
                     "_translit": "gár"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gar"
                  }
               ],
               "strongs_derivation": "a primary particle;",
               "strongs_def": "properly, assigning a reason (used in argument,\n explanation or intensification; often with other particles)",
               "kjv_def": ":--and, as,\n because (that), but, even, for, indeed, no doubt, seeing, then,\n therefore, verily, what, why, yet.",
               "_strongs": "01063"
            },
            {
               "strongs": "1064",
               "greek": [
                  {
                     "_BETA": "GASTH/R",
                     "_unicode": "γαστήρ",
                     "_translit": "gastḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gas-tare'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "the stomach; by analogy, the matrix;\n figuratively, a gourmand",
               "kjv_def": ":--belly, + with child, womb.",
               "_strongs": "01064"
            },
            {
               "strongs": "1065",
               "greek": [
                  {
                     "_BETA": "GE/",
                     "_unicode": "γέ",
                     "_translit": "gé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gheh"
                  }
               ],
               "strongs_derivation": "a primary particle of emphasis or qualification (often used with other\n particles prefixed)",
               "kjv_def": ":--and besides, doubtless, at least, yet.",
               "_strongs": "01065"
            },
            {
               "strongs": "1066",
               "greek": [
                  {
                     "_BETA": "*GEDEW/N",
                     "_unicode": "Γεδεών",
                     "_translit": "Gedeṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghed-eh-own'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01439"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Gedeon (i.e. Gid(e)on), an Israelite",
               "kjv_def": ":--Gedeon\n (in the King James Version).",
               "_strongs": "01066"
            },
            {
               "strongs": "1067",
               "greek": [
                  {
                     "_BETA": "GE/ENNA",
                     "_unicode": "γέεννα",
                     "_translit": "géenna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gheh'-en-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01516"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "02011"
                     }
                  ],
                  "__text": "of Hebrew origin (\n and \n);"
               },
               "strongs_def": "valley of (the son of) Hinnom;\n ge-henna (or Ge-Hinnom), a valley of Jerusalem, used (figuratively) as\n a name for the place (or state) of everlasting punishment",
               "kjv_def": ":--hell.",
               "_strongs": "01067"
            },
            {
               "strongs": "1068",
               "greek": [
                  {
                     "_BETA": "*GEQSHMANH=",
                     "_unicode": "Γεθσημανῆ",
                     "_translit": "Gethsēmanē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gheth-say-man-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01660"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "08081"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n and \n);"
               },
               "strongs_def": "oil-press; Gethsemane, a\n garden near Jerusalem",
               "kjv_def": ":--Gethsemane.",
               "_strongs": "01068"
            },
            {
               "strongs": "1069",
               "greek": [
                  {
                     "_BETA": "GEI/TWN",
                     "_unicode": "γείτων",
                     "_translit": "geítōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghi'-tone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1093"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a neighbour (as adjoining one's ground); by implication, a\n friend",
               "kjv_def": ":--neighbour.",
               "_strongs": "01069"
            },
            {
               "strongs": "1070",
               "greek": [
                  {
                     "_BETA": "GELA/W",
                     "_unicode": "γελάω",
                     "_translit": "geláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghel-ah'-o"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to laugh (as a sign of joy or\n satisfaction)",
               "kjv_def": ":--laugh.",
               "_strongs": "01070"
            },
            {
               "strongs": "1071",
               "greek": [
                  {
                     "_BETA": "GE/LWS",
                     "_unicode": "γέλως",
                     "_translit": "gélōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghel'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1070"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "laughter (as a mark of gratification)",
               "kjv_def": ":--laughter.",
               "_strongs": "01071"
            },
            {
               "strongs": "1072",
               "greek": [
                  {
                     "_BETA": "GEMI/ZW",
                     "_unicode": "γεμίζω",
                     "_translit": "gemízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghem-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1073"
                     }
                  ],
                  "__text": "transitive from \n;"
               },
               "strongs_def": "to fill entirely",
               "kjv_def": ":--fill (be) full.",
               "_strongs": "01072"
            },
            {
               "strongs": "1073",
               "greek": [
                  {
                     "_BETA": "GE/MW",
                     "_unicode": "γέμω",
                     "_translit": "gémō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghem'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to swell out, i.e. be full",
               "kjv_def": ":--be full.",
               "_strongs": "01073"
            },
            {
               "strongs": "1074",
               "greek": [
                  {
                     "_BETA": "GENEA/",
                     "_unicode": "γενεά",
                     "_translit": "geneá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen-eh-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1085"
                     }
                  ],
                  "__text": "from (a presumed derivative of) \n;"
               },
               "strongs_def": "a generation; by implication, an\n age (the period or the persons)",
               "kjv_def": ":--age, generation, nation, time.",
               "_strongs": "01074"
            },
            {
               "strongs": "1075",
               "greek": [
                  {
                     "_BETA": "GENEALOGE/W",
                     "_unicode": "γενεαλογέω",
                     "_translit": "genealogéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen-eh-al-og-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1074"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reckon by generations, i.e. trace in\n genealogy",
               "kjv_def": ":--count by descent.",
               "_strongs": "01075"
            },
            {
               "strongs": "1076",
               "greek": [
                  {
                     "_BETA": "GENEALOGI/A",
                     "_unicode": "γενεαλογία",
                     "_translit": "genealogía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen-eh-al-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1075"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "tracing by generations, i.e.\n \"genealogy\"",
               "kjv_def": ":--genealogy.",
               "_strongs": "01076"
            },
            {
               "strongs": "1077",
               "greek": [
                  {
                     "_BETA": "GENE/SIA",
                     "_unicode": "γενέσια",
                     "_translit": "genésia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen-es'-ee-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1078"
                     }
                  ],
                  "__text": "neuter plural of a derivative of \n;"
               },
               "strongs_def": "birthday ceremonies",
               "kjv_def": ":--birthday.",
               "_strongs": "01077"
            },
            {
               "strongs": "1078",
               "greek": [
                  {
                     "_BETA": "GE/NESIS",
                     "_unicode": "γένεσις",
                     "_translit": "génesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1074"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "nativity; figuratively, nature",
               "kjv_def": ":--generation,\n nature(-ral).",
               "_strongs": "01078"
            },
            {
               "strongs": "1079",
               "greek": [
                  {
                     "_BETA": "GENETH/",
                     "_unicode": "γενετή",
                     "_translit": "genetḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen-et-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1074"
                     }
                  ],
                  "__text": "feminine of a presumed derivative of the base of \n;"
               },
               "strongs_def": "birth",
               "kjv_def": ":--birth.",
               "_strongs": "01079"
            },
            {
               "strongs": "1080",
               "greek": [
                  {
                     "_BETA": "GENNA/W",
                     "_unicode": "γεννάω",
                     "_translit": "gennáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen-nah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1085"
                     }
                  ],
                  "__text": "from a variation of \n;"
               },
               "strongs_def": "to procreate (properly, of the father, but\n by extension of the mother); figuratively, to regenerate",
               "kjv_def": ":--bear,\n beget, be born, bring forth, conceive, be delivered of, gender, make,\n spring.",
               "_strongs": "01080"
            },
            {
               "strongs": "1081",
               "greek": [
                  {
                     "_BETA": "GE/NNHMA",
                     "_unicode": "γέννημα",
                     "_translit": "génnēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen'-nay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1080"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "offspring; by analogy, produce (literally or\n figuratively)",
               "kjv_def": ":--fruit, generation.",
               "_strongs": "01081"
            },
            {
               "strongs": "1082",
               "greek": [
                  {
                     "_BETA": "*GENNHSARE/T",
                     "_unicode": "Γεννησαρέτ",
                     "_translit": "Gennēsarét"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen-nay-sar-et'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03672"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "Gennesaret (i.e. Kinnereth), a lake\n and plain in Palestine",
               "kjv_def": ":--Gennesaret.",
               "_strongs": "01082"
            },
            {
               "strongs": "1083",
               "greek": [
                  {
                     "_BETA": "GE/NNHSIS",
                     "_unicode": "γέννησις",
                     "_translit": "génnēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen'-nay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1080"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "nativity",
               "kjv_def": ":--birth.",
               "_strongs": "01083"
            },
            {
               "strongs": "1084",
               "greek": [
                  {
                     "_BETA": "GENNHTO/S",
                     "_unicode": "γεννητός",
                     "_translit": "gennētós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen-nay-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1080"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "born",
               "kjv_def": ":--they that are born.",
               "_strongs": "01084"
            },
            {
               "strongs": "1085",
               "greek": [
                  {
                     "_BETA": "GE/NOS",
                     "_unicode": "γένος",
                     "_translit": "génos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghen'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "\"kin\" (abstract or concrete, literal or figurative,\n individual or collective)",
               "kjv_def": ":--born, country(-man), diversity,\n generation, kind(-red), nation, offspring, stock.",
               "_strongs": "01085"
            },
            {
               "strongs": "1086",
               "greek": [
                  {
                     "_BETA": "*GERGESHNO/S",
                     "_unicode": "Γεργεσηνός",
                     "_translit": "Gergesēnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gher-ghes-ay-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01622"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "a Gergesene (i.e. Girgashite) or one of the\n aborigines of Palestine",
               "kjv_def": ":--Gergesene.",
               "_strongs": "01086"
            },
            {
               "strongs": "1087",
               "greek": [
                  {
                     "_BETA": "GEROUSI/A",
                     "_unicode": "γερουσία",
                     "_translit": "gerousía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gher-oo-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1088"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the eldership, i.e. (collectively) the Jewish\n Sanhedrin",
               "kjv_def": ":--senate.",
               "_strongs": "01087"
            },
            {
               "strongs": "1088",
               "greek": [
                  {
                     "_BETA": "GE/RWN",
                     "_unicode": "γέρων",
                     "_translit": "gérōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gher'-own"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1094"
                     }
                  ],
                  "__text": "of uncertain affinity (compare \n);"
               },
               "strongs_def": "aged",
               "kjv_def": ":--old.",
               "_strongs": "01088"
            },
            {
               "strongs": "1089",
               "greek": [
                  {
                     "_BETA": "GEU/OMAI",
                     "_unicode": "γεύομαι",
                     "_translit": "geúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghyoo'-om-ahee"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to taste; by implication, to eat; figuratively, to\n experience (good or ill)",
               "kjv_def": ":--eat, taste.",
               "_strongs": "01089"
            },
            {
               "strongs": "1090",
               "greek": [
                  {
                     "_BETA": "GEWRGE/W",
                     "_unicode": "γεωργέω",
                     "_translit": "geōrgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gheh-or-gheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1092"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to till (the soil)",
               "kjv_def": ":--dress.",
               "_strongs": "01090"
            },
            {
               "strongs": "1091",
               "greek": [
                  {
                     "_BETA": "GEW/RGION",
                     "_unicode": "γεώργιον",
                     "_translit": "geṓrgion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gheh-ore'-ghee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1092"
                     }
                  ],
                  "__text": "neuter of a (presumed) derivative of \n;"
               },
               "strongs_def": "cultivable, i.e. a\n farm",
               "kjv_def": ":--husbandry.",
               "_strongs": "01091"
            },
            {
               "strongs": "1092",
               "greek": [
                  {
                     "_BETA": "GEWRGO/S",
                     "_unicode": "γεωργός",
                     "_translit": "geōrgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gheh-ore-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1093"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "a land-worker, i.e.\n farmer",
               "kjv_def": ":--husbandman.",
               "_strongs": "01092"
            },
            {
               "strongs": "1093",
               "greek": [
                  {
                     "_BETA": "GH=",
                     "_unicode": "γῆ",
                     "_translit": "gē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghay"
                  }
               ],
               "strongs_derivation": "contracted from a primary word;",
               "strongs_def": "soil; by extension a region, or the\n solid part or the whole of the terrene globe (including the occupants\n in each application)",
               "kjv_def": ":--country, earth(-ly), ground, land, world.",
               "_strongs": "01093"
            },
            {
               "strongs": "1094",
               "greek": [
                  {
                     "_BETA": "GH=RAS",
                     "_unicode": "γῆρας",
                     "_translit": "gēras"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghay'-ras"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1088"
                     }
                  ],
                  "__text": "akin to \n;"
               },
               "strongs_def": "senility",
               "kjv_def": ":--old age.",
               "_strongs": "01094"
            },
            {
               "strongs": "1095",
               "greek": [
                  {
                     "_BETA": "GHRA/SKW",
                     "_unicode": "γηράσκω",
                     "_translit": "gēráskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghay-ras'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1094"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be senescent",
               "kjv_def": ":--be (wax) old.",
               "_strongs": "01095"
            },
            {
               "strongs": "1096",
               "greek": [
                  {
                     "_BETA": "GI/NOMAI",
                     "_unicode": "γίνομαι",
                     "_translit": "gínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghin'-om-ahee"
                  }
               ],
               "strongs_derivation": "a prolongation and middle voice form of a primary verb;",
               "strongs_def": "to cause to be\n (\"gen\"-erate), i.e. (reflexively) to become (come into being), used\n with great latitude (literal, figurative, intensive, etc.)",
               "kjv_def": ":--arise, be\n assembled, be(-come, -fall, -have self), be brought (to pass), (be)\n come (to pass), continue, be divided, draw, be ended, fall, be\n finished, follow, be found, be fulfilled, + God forbid, grow, happen,\n have, be kept, be made, be married, be ordained to be, partake, pass,\n be performed, be published, require, seem, be showed, X soon as it\n was, sound, be taken, be turned, use, wax, will, would, be wrought.",
               "_strongs": "01096"
            },
            {
               "strongs": "1097",
               "greek": [
                  {
                     "_BETA": "GINW/SKW",
                     "_unicode": "γινώσκω",
                     "_translit": "ginṓskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ghin-oce'-ko"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb;",
               "strongs_def": "to \"know\" (absolutely) in a great\n variety of applications and with many implications (as follow, with\n others not thus clearly expressed)",
               "kjv_def": ":--allow, be aware (of), feel,\n (have) know(-ledge), perceived, be resolved, can speak, be sure,\n understand.",
               "_strongs": "01097"
            },
            {
               "strongs": "1098",
               "greek": [
                  {
                     "_BETA": "GLEU=KOS",
                     "_unicode": "γλεῦκος",
                     "_translit": "gleûkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "glyoo'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1099"
                     }
                  ],
                  "__text": "akin to \n;"
               },
               "strongs_def": "sweet wine, i.e. (properly) must (fresh juice), but used\n of the more saccharine (and therefore highly inebriating) fermented\n wine",
               "kjv_def": ":--new wine.",
               "_strongs": "01098"
            },
            {
               "strongs": "1099",
               "greek": [
                  {
                     "_BETA": "GLUKU/S",
                     "_unicode": "γλυκύς",
                     "_translit": "glykýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gloo-koos'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "sweet (i.e. not bitter nor salt)",
               "kjv_def": ":--sweet,\n fresh.",
               "_strongs": "01099"
            },
            {
               "strongs": "1100",
               "greek": [
                  {
                     "_BETA": "GLW=SSA",
                     "_unicode": "γλῶσσα",
                     "_translit": "glōssa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gloce-sah'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "the tongue; by implication, a language\n (specially, one naturally unacquired)",
               "kjv_def": ":--tongue.",
               "_strongs": "01100"
            },
            {
               "strongs": "1101",
               "greek": [
                  {
                     "_BETA": "GLWSSO/KOMON",
                     "_unicode": "γλωσσόκομον",
                     "_translit": "glōssókomon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gloce-sok'-om-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1100"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2889"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "properly, a case (to keep mouthpieces\n of wind-instruments in) i.e. (by extension) a casket or (specially)\n purse",
               "kjv_def": ":--bag.",
               "_strongs": "01101"
            },
            {
               "strongs": "1102",
               "greek": [
                  {
                     "_BETA": "GNAFEU/S",
                     "_unicode": "γναφεύς",
                     "_translit": "gnapheús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gnaf-yuce'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KNA/PTW",
                        "_unicode": "κνάπτω",
                        "_translit": "knáptō"
                     }
                  ],
                  "__text": "by variation for a derivative from \n (to tease cloth);"
               },
               "strongs_def": "a\n cloth-dresser",
               "kjv_def": ":--fuller.",
               "_strongs": "01102"
            },
            {
               "strongs": "1103",
               "greek": [
                  {
                     "_BETA": "GNH/SIOS",
                     "_unicode": "γνήσιος",
                     "_translit": "gnḗsios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gnay'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1077"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "legitimate (of birth), i.e. genuine",
               "kjv_def": ":--own,\n sincerity, true.",
               "_strongs": "01103"
            },
            {
               "strongs": "1104",
               "greek": [
                  {
                     "_BETA": "GNHSI/WS",
                     "_unicode": "γνησίως",
                     "_translit": "gnēsíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gnay-see'-ose"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1103"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "genuinely, i.e. really",
               "kjv_def": ":--naturally.",
               "_strongs": "01104"
            },
            {
               "strongs": "1105",
               "greek": [
                  {
                     "_BETA": "GNO/FOS",
                     "_unicode": "γνόφος",
                     "_translit": "gnóphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gnof'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3509"
                     }
                  ],
                  "__text": "akin to \n;"
               },
               "strongs_def": "gloom (as of a storm)",
               "kjv_def": ":--blackness.",
               "_strongs": "01105"
            },
            {
               "strongs": "1106",
               "greek": [
                  {
                     "_BETA": "GNW/MH",
                     "_unicode": "γνώμη",
                     "_translit": "gnṓmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gno'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cognition, i.e. (subjectively) opinion, or (objectively)\n resolve (counsel, consent, etc.)",
               "kjv_def": ":--advice, + agree, judgment, mind,\n purpose, will.",
               "_strongs": "01106"
            },
            {
               "strongs": "1107",
               "greek": [
                  {
                     "_BETA": "GNWRI/ZW",
                     "_unicode": "γνωρίζω",
                     "_translit": "gnōrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gno-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to make known; subjectively, to\n know",
               "kjv_def": ":--certify, declare, make known, give to understand, do to wit,\n wot.",
               "_strongs": "01107"
            },
            {
               "strongs": "1108",
               "greek": [
                  {
                     "_BETA": "GNW=SIS",
                     "_unicode": "γνῶσις",
                     "_translit": "gnōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gno'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "knowing (the act), i.e. (by implication)\n knowledge",
               "kjv_def": ":--knowledge, science.",
               "_strongs": "01108"
            },
            {
               "strongs": "1109",
               "greek": [
                  {
                     "_BETA": "GNW/STHS",
                     "_unicode": "γνώστης",
                     "_translit": "gnṓstēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gnoce'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a knower",
               "kjv_def": ":--expert.",
               "_strongs": "01109"
            },
            {
               "strongs": "1110",
               "greek": [
                  {
                     "_BETA": "GNWSTO/S",
                     "_unicode": "γνωστός",
                     "_translit": "gnōstós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gnoce-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "well-known",
               "kjv_def": ":--acquaintance, (which may be) known, notable.",
               "_strongs": "01110"
            },
            {
               "strongs": "1111",
               "greek": [
                  {
                     "_BETA": "GOGGU/ZW",
                     "_unicode": "γογγύζω",
                     "_translit": "gongýzō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gong-good'-zo"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "to grumble",
               "kjv_def": ":--murmur.",
               "_strongs": "01111"
            },
            {
               "strongs": "1112",
               "greek": [
                  {
                     "_BETA": "GOGGUSMO/S",
                     "_unicode": "γογγυσμός",
                     "_translit": "gongysmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gong-goos-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1111"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a grumbling",
               "kjv_def": ":--grudging, murmuring.",
               "_strongs": "01112"
            },
            {
               "strongs": "1113",
               "greek": [
                  {
                     "_BETA": "GOGGUSTH/S",
                     "_unicode": "γογγυστής",
                     "_translit": "gongystḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gong-goos-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1111"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a grumbler",
               "kjv_def": ":--murmurer.",
               "_strongs": "01113"
            },
            {
               "strongs": "1114",
               "greek": [
                  {
                     "_BETA": "GO/HS",
                     "_unicode": "γόης",
                     "_translit": "góēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "go'-ace"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "GOA/W",
                        "_unicode": "γοάω",
                        "_translit": "goáō"
                     }
                  ],
                  "__text": "from \n (to wail);"
               },
               "strongs_def": "properly, a wizard (as muttering spells), i.e.\n (by implication) an imposter",
               "kjv_def": ":--seducer.",
               "_strongs": "01114"
            },
            {
               "strongs": "1115",
               "greek": [
                  {
                     "_BETA": "*GOLGOQA=",
                     "_unicode": "Γολγοθᾶ",
                     "_translit": "Golgothâ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gol-goth-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01538"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "the skull; Golgotha, a knoll near\n Jerusalem",
               "kjv_def": ":--Golgotha.",
               "_strongs": "01115"
            },
            {
               "strongs": "1116",
               "greek": [
                  {
                     "_BETA": "*GO/MOR)R(A",
                     "_unicode": "Γόμοῤῥα",
                     "_translit": "Gómorrha"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gom'-or-hrhah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06017"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Gomorrha (i.e. Amorah), a place near the Dead\n Sea",
               "kjv_def": ":--Gomorrha.",
               "_strongs": "01116"
            },
            {
               "strongs": "1117",
               "greek": [
                  {
                     "_BETA": "GO/MOS",
                     "_unicode": "γόμος",
                     "_translit": "gómos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gom'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1073"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a load (as filling), i.e. (specially) a cargo, or (by\n extension) wares",
               "kjv_def": ":--burden, merchandise.",
               "_strongs": "01117"
            },
            {
               "strongs": "1118",
               "greek": [
                  {
                     "_BETA": "GONEU/S",
                     "_unicode": "γονεύς",
                     "_translit": "goneús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gon-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a parent",
               "kjv_def": ":--parent.",
               "_strongs": "01118"
            },
            {
               "strongs": "1119",
               "greek": [
                  {
                     "_BETA": "GO/NU",
                     "_unicode": "γόνυ",
                     "_translit": "góny"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gon-oo'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "the \"knee\"",
               "kjv_def": ":--knee(X -l).",
               "_strongs": "01119"
            },
            {
               "strongs": "1120",
               "greek": [
                  {
                     "_BETA": "GONUPETE/W",
                     "_unicode": "γονυπετέω",
                     "_translit": "gonypetéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gon-oo-pet-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1119"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from a compound of \n and the alternate of \n;"
               },
               "strongs_def": "to fall on the\n knee",
               "kjv_def": ":--bow the knee, kneel down.",
               "_strongs": "01120"
            },
            {
               "strongs": "1121",
               "greek": [
                  {
                     "_BETA": "GRA/MMA",
                     "_unicode": "γράμμα",
                     "_translit": "grámma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gram'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a writing, i.e. a letter, note, epistle, book, etc.; plural\n learning",
               "kjv_def": ":--bill, learning, letter, scripture, writing, written.",
               "_strongs": "01121"
            },
            {
               "strongs": "1122",
               "greek": [
                  {
                     "_BETA": "GRAMMATEU/S",
                     "_unicode": "γραμματεύς",
                     "_translit": "grammateús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gram-mat-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1121"
                     }
                  ],
                  "__text": "from \n. a writer, i.e. (professionally) scribe or\n secretary"
               },
               "kjv_def": ":--scribe, town-clerk.",
               "_strongs": "01122"
            },
            {
               "strongs": "1123",
               "greek": [
                  {
                     "_BETA": "GRAPTO/S",
                     "_unicode": "γραπτός",
                     "_translit": "graptós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "grap-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inscribed (figuratively)",
               "kjv_def": ":--written.",
               "_strongs": "01123"
            },
            {
               "strongs": "1124",
               "greek": [
                  {
                     "_BETA": "GRAFH/",
                     "_unicode": "γραφή",
                     "_translit": "graphḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "graf-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a document, i.e. holy Writ (or its contents or a statement in\n it)",
               "kjv_def": ":--scripture.",
               "_strongs": "01124"
            },
            {
               "strongs": "1125",
               "greek": [
                  {
                     "_BETA": "GRA/FW",
                     "_unicode": "γράφω",
                     "_translit": "gráphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "graf'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to \"grave\", especially to write; figuratively, to\n describe",
               "kjv_def": ":--describe, write(-ing, -ten).",
               "_strongs": "01125"
            },
            {
               "strongs": "1126",
               "greek": [
                  {
                     "_BETA": "GRAW/DHS",
                     "_unicode": "γραώδης",
                     "_translit": "graṓdēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "grah-o'-dace"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "GRAU/S",
                        "_unicode": "γραύς",
                        "_translit": "graús"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1491"
                     }
                  ],
                  "__text": "from \n (an old woman) and \n;"
               },
               "strongs_def": "crone-like, i.e. silly",
               "kjv_def": ":--old\n wives'.",
               "_strongs": "01126"
            },
            {
               "strongs": "1127",
               "greek": [
                  {
                     "_BETA": "GRHGOREU/W",
                     "_unicode": "γρηγορεύω",
                     "_translit": "grēgoreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gray-gor-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1453"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to keep awake, i.e. watch (literally or figuratively)",
               "kjv_def": ":--be\n vigilant, wake, (be) watch(-ful).",
               "_strongs": "01127"
            },
            {
               "strongs": "1128",
               "greek": [
                  {
                     "_BETA": "GUMNA/ZW",
                     "_unicode": "γυμνάζω",
                     "_translit": "gymnázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "goom-nad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1131"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to practise naked (in the games), i.e. train\n (figuratively)",
               "kjv_def": ":--exercise.",
               "_strongs": "01128"
            },
            {
               "strongs": "1129",
               "greek": [
                  {
                     "_BETA": "GUMNASI/A",
                     "_unicode": "γυμνασία",
                     "_translit": "gymnasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "goom-nas-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1128"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "training, i.e. (figuratively) asceticism",
               "kjv_def": ":--exercise.",
               "_strongs": "01129"
            },
            {
               "strongs": "1130",
               "greek": [
                  {
                     "_BETA": "GUMNHTEU/W",
                     "_unicode": "γυμνητεύω",
                     "_translit": "gymnēteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "goom-nayt-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1131"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to strip, i.e. (reflexively) go poorly\n clad",
               "kjv_def": ":--be naked.",
               "_strongs": "01130"
            },
            {
               "strongs": "1131",
               "greek": [
                  {
                     "_BETA": "GUMNO/S",
                     "_unicode": "γυμνός",
                     "_translit": "gymnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "goom-nos'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "nude (absolute or relative, literal or\n figurative)",
               "kjv_def": ":--naked.",
               "_strongs": "01131"
            },
            {
               "strongs": "1132",
               "greek": [
                  {
                     "_BETA": "GUMNO/THS",
                     "_unicode": "γυμνότης",
                     "_translit": "gymnótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "goom-not'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1131"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "nudity (absolute or comparative)",
               "kjv_def": ":--nakedness.",
               "_strongs": "01132"
            },
            {
               "strongs": "1133",
               "greek": [
                  {
                     "_BETA": "GUNAIKA/RION",
                     "_unicode": "γυναικάριον",
                     "_translit": "gynaikárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "goo-nahee-kar'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1135"
                     }
                  ],
                  "__text": "a diminutive from \n;"
               },
               "strongs_def": "a little (i.e. foolish) woman",
               "kjv_def": ":--silly woman.",
               "_strongs": "01133"
            },
            {
               "strongs": "1134",
               "greek": [
                  {
                     "_BETA": "GUNAIKEI=OS",
                     "_unicode": "γυναικεῖος",
                     "_translit": "gynaikeîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "goo-nahee-ki'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1135"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "feminine",
               "kjv_def": ":--wife.",
               "_strongs": "01134"
            },
            {
               "strongs": "1135",
               "greek": [
                  {
                     "_BETA": "GUNH/",
                     "_unicode": "γυνή",
                     "_translit": "gynḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "goo-nay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "a woman; specially, a wife",
               "kjv_def": ":--wife,\n woman.",
               "_strongs": "01135"
            },
            {
               "strongs": "1136",
               "greek": [
                  {
                     "_BETA": "*GW/G",
                     "_unicode": "Γώγ",
                     "_translit": "Gṓg"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "gogue"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01463"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Gog, a symbolic name for some future\n Antichrist",
               "kjv_def": ":--Gog.",
               "_strongs": "01136"
            },
            {
               "strongs": "1137",
               "greek": [
                  {
                     "_BETA": "GWNI/A",
                     "_unicode": "γωνία",
                     "_translit": "gōnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "go-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1119"
                     }
                  ],
                  "__text": "probably akin to \n;"
               },
               "strongs_def": "an angle",
               "kjv_def": ":--corner, quarter.",
               "_strongs": "01137"
            },
            {
               "strongs": "1138",
               "greek": [
                  {
                     "_BETA": "*DABI/D",
                     "_unicode": "Δαβίδ",
                     "_translit": "Dabíd"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dab-eed'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01732"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Dabid (i.e. David), the Israelite\n king",
               "kjv_def": ":--David.",
               "_strongs": "01138"
            },
            {
               "strongs": "1139",
               "greek": [
                  {
                     "_BETA": "DAIMONI/ZOMAI",
                     "_unicode": "δαιμονίζομαι",
                     "_translit": "daimonízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dahee-mon-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1142"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to be exercised by a dæmon",
               "kjv_def": ":--have a (be vexed\n with, be possessed with) devil(-s).",
               "_strongs": "01139"
            },
            {
               "strongs": "1140",
               "greek": [
                  {
                     "_BETA": "DAIMO/NION",
                     "_unicode": "δαιμόνιον",
                     "_translit": "daimónion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dahee-mon'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1142"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "a dæmonic being; by extension a\n deity",
               "kjv_def": ":--devil, god.",
               "_strongs": "01140"
            },
            {
               "strongs": "1141",
               "greek": [
                  {
                     "_BETA": "DAIMONIW/DHS",
                     "_unicode": "δαιμονιώδης",
                     "_translit": "daimoniṓdēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dahee-mon-ee-o'-dace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1140"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "dæmon-like",
               "kjv_def": ":--devilish.",
               "_strongs": "01141"
            },
            {
               "strongs": "1142",
               "greek": [
                  {
                     "_BETA": "DAI/MWN",
                     "_unicode": "δαίμων",
                     "_translit": "daímōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dah'-ee-mown"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DAI/W",
                        "_unicode": "δαίω",
                        "_translit": "daíō"
                     }
                  ],
                  "__text": "from \n (to distribute fortunes);"
               },
               "strongs_def": "a dæmon or supernatural spirit (of\n a bad nature)",
               "kjv_def": ":--devil.",
               "_strongs": "01142"
            },
            {
               "strongs": "1143",
               "greek": [
                  {
                     "_BETA": "DA/KNW",
                     "_unicode": "δάκνω",
                     "_translit": "dáknō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dak'-no"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary root;",
               "strongs_def": "to bite, i.e. (figuratively)\n thwart",
               "kjv_def": ":--bite.",
               "_strongs": "01143"
            },
            {
               "strongs": "1144",
               "greek": [
                  {
                     "_BETA": "DA/KRU",
                     "_unicode": "δάκρυ",
                     "_translit": "dákry"
                  },
                  {
                     "_BETA": "DA/KRUON",
                     "_unicode": "δάκρυον",
                     "_translit": "dákryon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dak'-roo"
                  },
                  {
                     "_strongs": "dak'-roo-on"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a tear",
               "kjv_def": ":--tear.",
               "_strongs": "01144",
               "__text": "or"
            },
            {
               "strongs": "1145",
               "greek": [
                  {
                     "_BETA": "DAKRU/W",
                     "_unicode": "δακρύω",
                     "_translit": "dakrýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dak-roo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1144"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to shed tears",
               "kjv_def": ":--weep.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2799"
                  }
               ],
               "_strongs": "01145",
               "__text": "Compare \n."
            },
            {
               "strongs": "1146",
               "greek": [
                  {
                     "_BETA": "DAKTU/LIOS",
                     "_unicode": "δακτύλιος",
                     "_translit": "daktýlios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dak-too'-lee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1147"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a finger-ring",
               "kjv_def": ":--ring.",
               "_strongs": "01146"
            },
            {
               "strongs": "1147",
               "greek": [
                  {
                     "_BETA": "DA/KTULOS",
                     "_unicode": "δάκτυλος",
                     "_translit": "dáktylos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dak'-too-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "a finger",
               "kjv_def": ":--finger.",
               "_strongs": "01147"
            },
            {
               "strongs": "1148",
               "greek": [
                  {
                     "_BETA": "*DALMANOUQA/",
                     "_unicode": "Δαλμανουθά",
                     "_translit": "Dalmanouthá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dal-man-oo-thah'"
                  }
               ],
               "strongs_derivation": "probably of Chaldee origin;",
               "strongs_def": "Dalmanutha, a place in\n Palestine",
               "kjv_def": ":--Dalmanutha.",
               "_strongs": "01148"
            },
            {
               "strongs": "1149",
               "greek": [
                  {
                     "_BETA": "*DALMATI/A",
                     "_unicode": "Δαλματία",
                     "_translit": "Dalmatía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dal-mat-ee'-ah"
                  }
               ],
               "strongs_derivation": "probably of foreign derivation;",
               "strongs_def": "Dalmatia, a region of\n Europe",
               "kjv_def": ":--Dalmatia.",
               "_strongs": "01149"
            },
            {
               "strongs": "1150",
               "greek": [
                  {
                     "_BETA": "DAMA/ZW",
                     "_unicode": "δαμάζω",
                     "_translit": "damázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dam-ad'-zo"
                  }
               ],
               "strongs_derivation": "a variation of an obsolete primary of the same meaning;",
               "strongs_def": "to\n tame",
               "kjv_def": ":--tame.",
               "_strongs": "01150"
            },
            {
               "strongs": "1151",
               "greek": [
                  {
                     "_BETA": "DA/MALIS",
                     "_unicode": "δάμαλις",
                     "_translit": "dámalis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dam'-al-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1150"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "a heifer (as tame)",
               "kjv_def": ":--heifer.",
               "_strongs": "01151"
            },
            {
               "strongs": "1152",
               "greek": [
                  {
                     "_BETA": "*DA/MARIS",
                     "_unicode": "Δάμαρις",
                     "_translit": "Dámaris"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dam'-ar-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1150"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "perhaps gentle; Damaris, an Athenian\n woman",
               "kjv_def": ":--Damaris.",
               "_strongs": "01152"
            },
            {
               "strongs": "1153",
               "greek": [
                  {
                     "_BETA": "*DAMASKHNO/S",
                     "_unicode": "Δαμασκηνός",
                     "_translit": "Damaskēnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dam-as-kay-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1154"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Damascene or inhabitant of Damascus",
               "kjv_def": ":--Damascene.",
               "_strongs": "01153"
            },
            {
               "strongs": "1154",
               "greek": [
                  {
                     "_BETA": "*DAMASKO/S",
                     "_unicode": "Δαμασκός",
                     "_translit": "Damaskós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dam-as-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01834"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Damascus, a city of Syria",
               "kjv_def": ":--Damascus.",
               "_strongs": "01154"
            },
            {
               "strongs": "1155",
               "greek": [
                  {
                     "_BETA": "DANEI/ZW",
                     "_unicode": "δανείζω",
                     "_translit": "daneízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dan-ide'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1156"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to loan on interest; reflexively, to borrow",
               "kjv_def": ":--borrow, lend.",
               "_strongs": "01155"
            },
            {
               "strongs": "1156",
               "greek": [
                  {
                     "_BETA": "DA/NEION",
                     "_unicode": "δάνειον",
                     "_translit": "dáneion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dan'-i-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DA/NOS",
                        "_unicode": "δάνος",
                        "_translit": "dános"
                     }
                  ],
                  "__text": "from \n (a gift);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "probably akin to the base of \n; a loan"
               },
               "kjv_def": ":--debt.",
               "_strongs": "01156"
            },
            {
               "strongs": "1157",
               "greek": [
                  {
                     "_BETA": "DANEISTH/S",
                     "_unicode": "δανειστής",
                     "_translit": "daneistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dan-ice-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1155"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a lender",
               "kjv_def": ":--creditor.",
               "_strongs": "01157"
            },
            {
               "strongs": "1158",
               "greek": [
                  {
                     "_BETA": "*DANIH/L",
                     "_unicode": "Δανιήλ",
                     "_translit": "Daniḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dan-ee-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01840"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Daniel, an Israelite",
               "kjv_def": ":--Daniel.",
               "_strongs": "01158"
            },
            {
               "strongs": "1159",
               "greek": [
                  {
                     "_BETA": "DAPANA/W",
                     "_unicode": "δαπανάω",
                     "_translit": "dapanáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dap-an-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1160"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to expend, i.e. (in a good sense) to incur cost, or (in a\n bad one) to waste",
               "kjv_def": ":--be at charges, consume, spend.",
               "_strongs": "01159"
            },
            {
               "strongs": "1160",
               "greek": [
                  {
                     "_BETA": "DAPA/NH",
                     "_unicode": "δαπάνη",
                     "_translit": "dapánē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dap-an'-ay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DA/PTW",
                        "_unicode": "δάπτω",
                        "_translit": "dáptō"
                     }
                  ],
                  "__text": "from \n (to devour);"
               },
               "strongs_def": "expense (as consuming)",
               "kjv_def": ":--cost.",
               "_strongs": "01160"
            },
            {
               "strongs": "1161",
               "greek": [
                  {
                     "_BETA": "DE/",
                     "_unicode": "δέ",
                     "_translit": "dé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "deh"
                  }
               ],
               "strongs_derivation": "a primary particle (adversative or continuative);",
               "strongs_def": "but, and,\n etc.",
               "kjv_def": ":--also, and, but, moreover, now (often unexpressed in English).",
               "_strongs": "01161"
            },
            {
               "strongs": "1162",
               "greek": [
                  {
                     "_BETA": "DE/HSIS",
                     "_unicode": "δέησις",
                     "_translit": "déēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "deh'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1189"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a petition",
               "kjv_def": ":--prayer, request, supplication.",
               "_strongs": "01162"
            },
            {
               "strongs": "1163",
               "greek": [
                  {
                     "_BETA": "DEI=",
                     "_unicode": "δεῖ",
                     "_translit": "deî"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "die"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "3rd person singular active present of \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "DE/ON",
                        "_unicode": "δέον",
                        "_translit": "déon"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "deh-on'"
                     }
                  ],
                  "__text": "also \n \n; neuter\n active participle of the same; both used impersonally; it is (was,\n etc.) necessary (as binding)"
               },
               "kjv_def": ":--behoved, be meet, must (needs), (be)\n need(-ful), ought, should.",
               "_strongs": "01163"
            },
            {
               "strongs": "1164",
               "greek": [
                  {
                     "_BETA": "DEI=GMA",
                     "_unicode": "δεῖγμα",
                     "_translit": "deîgma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "digh'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1166"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a specimen (as shown)",
               "kjv_def": ":--example.",
               "_strongs": "01164"
            },
            {
               "strongs": "1165",
               "greek": [
                  {
                     "_BETA": "DEIGMATI/ZW",
                     "_unicode": "δειγματίζω",
                     "_translit": "deigmatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "digh-mat-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1164"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to exhibit",
               "kjv_def": ":--make a shew.",
               "_strongs": "01165"
            },
            {
               "strongs": "1166",
               "greek": [
                  {
                     "_BETA": "DEIKNU/W",
                     "_unicode": "δεικνύω",
                     "_translit": "deiknýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dike-noo'-o"
                  }
               ],
               "strongs_derivation": "a prolonged form of an obsolete primary of the same meaning;",
               "strongs_def": "to show\n (literally or figuratively)",
               "kjv_def": ":--shew.",
               "_strongs": "01166"
            },
            {
               "strongs": "1167",
               "greek": [
                  {
                     "_BETA": "DEILI/A",
                     "_unicode": "δειλία",
                     "_translit": "deilía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "di-lee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1169"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "timidity",
               "kjv_def": ":--fear.",
               "_strongs": "01167"
            },
            {
               "strongs": "1168",
               "greek": [
                  {
                     "_BETA": "DEILIA/W",
                     "_unicode": "δειλιάω",
                     "_translit": "deiliáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "di-lee-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1167"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be timid",
               "kjv_def": ":--be afraid.",
               "_strongs": "01168"
            },
            {
               "strongs": "1169",
               "greek": [
                  {
                     "_BETA": "DEILO/S",
                     "_unicode": "δειλός",
                     "_translit": "deilós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "di-los'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DEO/S",
                        "_unicode": "δεός",
                        "_translit": "deós"
                     }
                  ],
                  "__text": "from \n (dread);"
               },
               "strongs_def": "timid, i.e. (by implication) faithless",
               "kjv_def": ":--fearful.",
               "_strongs": "01169"
            },
            {
               "strongs": "1170",
               "greek": [
                  {
                     "_BETA": "DEI=NA",
                     "_unicode": "δεῖνα",
                     "_translit": "deîna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "di'-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1171"
                     }
                  ],
                  "__text": "probably from the same as \n (through the idea of forgetting the\n name as fearful, i.e. strange);"
               },
               "strongs_def": "so and so (when the person is not\n specified)",
               "kjv_def": ":--such a man.",
               "_strongs": "01170"
            },
            {
               "strongs": "1171",
               "greek": [
                  {
                     "_BETA": "DEINW=S",
                     "_unicode": "δεινῶς",
                     "_translit": "deinōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "di-noce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1169"
                     }
                  ],
                  "__text": "adverb from a derivative of the same as \n;"
               },
               "strongs_def": "terribly, i.e.\n excessively",
               "kjv_def": ":--grievously, vehemently.",
               "_strongs": "01171"
            },
            {
               "strongs": "1172",
               "greek": [
                  {
                     "_BETA": "DEIPNE/W",
                     "_unicode": "δειπνέω",
                     "_translit": "deipnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dipe-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1173"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to dine, i.e. take the principle (or evening) meal",
               "kjv_def": ":--sup (X\n -er).",
               "_strongs": "01172"
            },
            {
               "strongs": "1173",
               "greek": [
                  {
                     "_BETA": "DEI=PNON",
                     "_unicode": "δεῖπνον",
                     "_translit": "deîpnon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dipe'-non"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1160"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "dinner, i.e. the chief meal (usually in the\n evening)",
               "kjv_def": ":--feast, supper.",
               "_strongs": "01173"
            },
            {
               "strongs": "1174",
               "greek": [
                  {
                     "_BETA": "DEISIDAIMONE/STEROS",
                     "_unicode": "δεισιδαιμονέστερος",
                     "_translit": "deisidaimonésteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dice-ee-dahee-mon-es'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1169"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1142"
                     }
                  ],
                  "__text": "the compound of a derivative of the base of \n and \n;"
               },
               "strongs_def": "more\n religious than others",
               "kjv_def": ":--too superstitious.",
               "_strongs": "01174"
            },
            {
               "strongs": "1175",
               "greek": [
                  {
                     "_BETA": "DEISIDAIMONI/A",
                     "_unicode": "δεισιδαιμονία",
                     "_translit": "deisidaimonía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dice-ee-dahee-mon-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1174"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "religion",
               "kjv_def": ":--superstition.",
               "_strongs": "01175"
            },
            {
               "strongs": "1176",
               "greek": [
                  {
                     "_BETA": "DE/KA",
                     "_unicode": "δέκα",
                     "_translit": "déka"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek'-ah"
                  }
               ],
               "strongs_derivation": "a primary number;",
               "strongs_def": "ten",
               "kjv_def": ":--(eight-)een, ten.",
               "_strongs": "01176"
            },
            {
               "strongs": "1177",
               "greek": [
                  {
                     "_BETA": "DEKADU/O",
                     "_unicode": "δεκαδύο",
                     "_translit": "dekadýo"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek-ad-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1417"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "two and ten, i.e. twelve",
               "kjv_def": ":--twelve.",
               "_strongs": "01177"
            },
            {
               "strongs": "1178",
               "greek": [
                  {
                     "_BETA": "DEKAPE/NTE",
                     "_unicode": "δεκαπέντε",
                     "_translit": "dekapénte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek-ap-en'-teh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4002"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "ten and five, i.e. fifteen",
               "kjv_def": ":--fifteen.",
               "_strongs": "01178"
            },
            {
               "strongs": "1179",
               "greek": [
                  {
                     "_BETA": "*DEKA/POLIS",
                     "_unicode": "Δεκάπολις",
                     "_translit": "Dekápolis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek-ap'-ol-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the ten-city region; the Decapolis, a district in\n Syria",
               "kjv_def": ":--Decapolis.",
               "_strongs": "01179"
            },
            {
               "strongs": "1180",
               "greek": [
                  {
                     "_BETA": "DEKATE/SSARES",
                     "_unicode": "δεκατέσσαρες",
                     "_translit": "dekatéssares"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek-at-es'-sar-es"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "ten and four, i.e. fourteen",
               "kjv_def": ":--fourteen.",
               "_strongs": "01180"
            },
            {
               "strongs": "1181",
               "greek": [
                  {
                     "_BETA": "DEKA/TH",
                     "_unicode": "δεκάτη",
                     "_translit": "dekátē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek-at'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1182"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a tenth, i.e. as a percentage or (technically)\n tithe",
               "kjv_def": ":--tenth (part), tithe.",
               "_strongs": "01181"
            },
            {
               "strongs": "1182",
               "greek": [
                  {
                     "_BETA": "DE/KATOS",
                     "_unicode": "δέκατος",
                     "_translit": "dékatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     }
                  ],
                  "__text": "ordinal from \n;"
               },
               "strongs_def": "tenth",
               "kjv_def": ":--tenth.",
               "_strongs": "01182"
            },
            {
               "strongs": "1183",
               "greek": [
                  {
                     "_BETA": "DEKATO/W",
                     "_unicode": "δεκατόω",
                     "_translit": "dekatóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek-at-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1181"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to tithe, i.e. to give or take a tenth",
               "kjv_def": ":--pay (receive)\n tithes.",
               "_strongs": "01183"
            },
            {
               "strongs": "1184",
               "greek": [
                  {
                     "_BETA": "DEKTO/S",
                     "_unicode": "δεκτός",
                     "_translit": "dektós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dek-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "approved; (figuratively) propitious",
               "kjv_def": ":-- accepted(-table).",
               "_strongs": "01184"
            },
            {
               "strongs": "1185",
               "greek": [
                  {
                     "_BETA": "DELEA/ZW",
                     "_unicode": "δελεάζω",
                     "_translit": "deleázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "del-eh-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1388"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "to entrap, i.e. (figuratively) delude",
               "kjv_def": ":--allure,\n beguile, entice.",
               "_strongs": "01185"
            },
            {
               "strongs": "1186",
               "greek": [
                  {
                     "_BETA": "DE/NDRON",
                     "_unicode": "δένδρον",
                     "_translit": "déndron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "den'-dron"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DRU/S",
                        "_unicode": "δρύς",
                        "_translit": "drýs"
                     }
                  ],
                  "__text": "probably from \n (an oak);"
               },
               "strongs_def": "a tree",
               "kjv_def": ":--tree.",
               "_strongs": "01186"
            },
            {
               "strongs": "1187",
               "greek": [
                  {
                     "_BETA": "DECIOLA/BOS",
                     "_unicode": "δεξιολάβος",
                     "_translit": "dexiolábos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dex-ee-ol-ab'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1188"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a guardsman (as if taking the right) or\n light-armed soldier",
               "kjv_def": ":--spearman.",
               "_strongs": "01187"
            },
            {
               "strongs": "1188",
               "greek": [
                  {
                     "_BETA": "DECIO/S",
                     "_unicode": "δεξιός",
                     "_translit": "dexiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dex-ee-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the right side or (feminine) hand (as that which usually\n takes)",
               "kjv_def": ":--right (hand, side).",
               "_strongs": "01188"
            },
            {
               "strongs": "1189",
               "greek": [
                  {
                     "_BETA": "DE/OMAI",
                     "_unicode": "δέομαι",
                     "_translit": "déomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "deh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "middle voice of \n;"
               },
               "strongs_def": "to beg (as binding oneself), i.e.\n petition",
               "kjv_def": ":--beseech, pray (to), make request.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4441"
                  }
               ],
               "_strongs": "01189",
               "__text": "Compare \n."
            },
            {
               "strongs": "1190",
               "greek": [
                  {
                     "_BETA": "*DERBAI=OS",
                     "_unicode": "Δερβαῖος",
                     "_translit": "Derbaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "der-bah'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1191"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Derbæan or inhabitant of Derbe",
               "kjv_def": ":--of Derbe.",
               "_strongs": "01190"
            },
            {
               "strongs": "1191",
               "greek": [
                  {
                     "_BETA": "*DE/RBH",
                     "_unicode": "Δέρβη",
                     "_translit": "Dérbē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "der-bay'"
                  }
               ],
               "strongs_derivation": "of foreign origin;",
               "strongs_def": "Derbe, a place in Asia Minor",
               "kjv_def": ":--Derbe.",
               "_strongs": "01191"
            },
            {
               "strongs": "1192",
               "greek": [
                  {
                     "_BETA": "DE/RMA",
                     "_unicode": "δέρμα",
                     "_translit": "dérma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "der'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1194"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a hide",
               "kjv_def": ":--skin.",
               "_strongs": "01192"
            },
            {
               "strongs": "1193",
               "greek": [
                  {
                     "_BETA": "DERMA/TINOS",
                     "_unicode": "δερμάτινος",
                     "_translit": "dermátinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "der-mat'-ee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1192"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "made of hide",
               "kjv_def": ":--leathern, of a skin.",
               "_strongs": "01193"
            },
            {
               "strongs": "1194",
               "greek": [
                  {
                     "_BETA": "DE/RW",
                     "_unicode": "δέρω",
                     "_translit": "dérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "der'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "properly, to flay, i.e. (by implication) to scourge,\n or (by analogy) to thrash",
               "kjv_def": ":--beat, smite.",
               "_strongs": "01194"
            },
            {
               "strongs": "1195",
               "greek": [
                  {
                     "_BETA": "DESMEU/W",
                     "_unicode": "δεσμεύω",
                     "_translit": "desmeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des-myoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1196"
                     }
                  ],
                  "__text": "from a (presumed) derivative of \n;"
               },
               "strongs_def": "to be a binder (captor), i.e. to\n enchain (a prisoner), to tie on (a load)",
               "kjv_def": ":-- bind.",
               "_strongs": "01195"
            },
            {
               "strongs": "1196",
               "greek": [
                  {
                     "_BETA": "DESME/W",
                     "_unicode": "δεσμέω",
                     "_translit": "desméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1199"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to tie, i.e. shackle",
               "kjv_def": ":--bind.",
               "_strongs": "01196"
            },
            {
               "strongs": "1197",
               "greek": [
                  {
                     "_BETA": "DE/SMH",
                     "_unicode": "δέσμη",
                     "_translit": "désmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des-may'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1196"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a bundle",
               "kjv_def": ":--bundle.",
               "_strongs": "01197"
            },
            {
               "strongs": "1198",
               "greek": [
                  {
                     "_BETA": "DE/SMIOS",
                     "_unicode": "δέσμιος",
                     "_translit": "désmios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des'-mee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1199"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a captive (as bound)",
               "kjv_def": ":--in bonds, prisoner.",
               "_strongs": "01198"
            },
            {
               "strongs": "1199",
               "greek": [
                  {
                     "_BETA": "DESMO/N",
                     "_unicode": "δεσμόν",
                     "_translit": "desmón"
                  },
                  {
                     "_BETA": "DESMO/S",
                     "_unicode": "δεσμός",
                     "_translit": "desmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des-mon'"
                  },
                  {
                     "_strongs": "des-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "neuter and masculine respectively from \n;"
               },
               "strongs_def": "a band, i.e. ligament (of\n the body) or shackle (of a prisoner); figuratively, an impediment or\n disability",
               "kjv_def": ":--band, bond, chain, string.",
               "_strongs": "01199",
               "__text": "or"
            },
            {
               "strongs": "1200",
               "greek": [
                  {
                     "_BETA": "DESMOFU/LAC",
                     "_unicode": "δεσμοφύλαξ",
                     "_translit": "desmophýlax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des-mof-oo'-lax"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1199"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5441"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a jailer (as guarding the prisoners)",
               "kjv_def": ":--jailor,\n keeper of the prison.",
               "_strongs": "01200"
            },
            {
               "strongs": "1201",
               "greek": [
                  {
                     "_BETA": "DESMWTH/RION",
                     "_unicode": "δεσμωτήριον",
                     "_translit": "desmōtḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des-mo-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1199"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1196"
                     }
                  ],
                  "__text": "from a derivative of \n (equivalent to \n);"
               },
               "strongs_def": "a place of bondage,\n i.e. a dungeon",
               "kjv_def": ":--prison.",
               "_strongs": "01201"
            },
            {
               "strongs": "1202",
               "greek": [
                  {
                     "_BETA": "DESMW/THS",
                     "_unicode": "δεσμώτης",
                     "_translit": "desmṓtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des-mo'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1201"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "(passively) a captive",
               "kjv_def": ":--prisoner.",
               "_strongs": "01202"
            },
            {
               "strongs": "1203",
               "greek": [
                  {
                     "_BETA": "DESPO/THS",
                     "_unicode": "δεσπότης",
                     "_translit": "despótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "des-pot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "PO/SIS",
                        "_unicode": "πόσις",
                        "_translit": "pósis"
                     }
                  ],
                  "__text": "perhaps from \n and \n (a husband);"
               },
               "strongs_def": "an absolute ruler\n (\"despot\")",
               "kjv_def": ":--Lord, master.",
               "_strongs": "01203"
            },
            {
               "strongs": "1204",
               "greek": [
                  {
                     "_BETA": "DEU=RO",
                     "_unicode": "δεῦρο",
                     "_translit": "deûro"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dyoo'-ro"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "here; used also imperative hither!; and of\n time, hitherto",
               "kjv_def": ":--come (hither), hither(-to).",
               "_strongs": "01204"
            },
            {
               "strongs": "1205",
               "greek": [
                  {
                     "_BETA": "DEU=TE",
                     "_unicode": "δεῦτε",
                     "_translit": "deûte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dyoo'-teh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1204"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "from \n and an imperative form of \n (to go);"
               },
               "strongs_def": "come hither!",
               "kjv_def": ":--come,\n X follow.",
               "_strongs": "01205"
            },
            {
               "strongs": "1206",
               "greek": [
                  {
                     "_BETA": "DEUTERAI=OS",
                     "_unicode": "δευτεραῖος",
                     "_translit": "deuteraîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dyoo-ter-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1208"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "secondary, i.e. (specially) on the second day",
               "kjv_def": ":--next day.",
               "_strongs": "01206"
            },
            {
               "strongs": "1207",
               "greek": [
                  {
                     "_BETA": "DEUTERO/PRWTOS",
                     "_unicode": "δευτερόπρωτος",
                     "_translit": "deuteróprōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dyoo-ter-op'-ro-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1208"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4413"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "second-first, i.e. (specially) a designation of\n the Sabbath immediately after the Paschal week (being the second after\n Passover day, and the first of the seven Sabbaths intervening before\n Pentecost)",
               "kjv_def": ":--second … after the first.",
               "_strongs": "01207"
            },
            {
               "strongs": "1208",
               "greek": [
                  {
                     "_BETA": "DEU/TEROS",
                     "_unicode": "δεύτερος",
                     "_translit": "deúteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dyoo'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1417"
                     }
                  ],
                  "__text": "as the comparative of \n;"
               },
               "strongs_def": "(ordinal) second (in time, place, or rank;\n also adverb)",
               "kjv_def": ":--afterward, again, second(-arily, time).",
               "_strongs": "01208"
            },
            {
               "strongs": "1209",
               "greek": [
                  {
                     "_BETA": "DE/XOMAI",
                     "_unicode": "δέχομαι",
                     "_translit": "déchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dekh'-om-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of a primary verb;",
               "strongs_def": "to receive (in various applications,\n literally or figuratively)",
               "kjv_def": ":--accept, receive, take.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2983"
                  }
               ],
               "_strongs": "01209",
               "__text": "Compare \n."
            },
            {
               "strongs": "1210",
               "greek": [
                  {
                     "_BETA": "DE/W",
                     "_unicode": "δέω",
                     "_translit": "déō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "deh'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to bind (in various applications, literally or\n figuratively)",
               "kjv_def": ":--bind, be in bonds, knit, tie, wind.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1163"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1189"
                  }
               ],
               "_strongs": "01210",
               "__text": "See also \n,\n \n."
            },
            {
               "strongs": "1211",
               "greek": [
                  {
                     "_BETA": "DH/",
                     "_unicode": "δή",
                     "_translit": "dḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1161"
                     }
                  ],
                  "__text": "probably akin to \n;"
               },
               "strongs_def": "a particle of emphasis or explicitness; now,\n then, etc.",
               "kjv_def": ":--also, and, doubtless, now, therefore.",
               "_strongs": "01211"
            },
            {
               "strongs": "1212",
               "greek": [
                  {
                     "_BETA": "DH=LOS",
                     "_unicode": "δῆλος",
                     "_translit": "dēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day'-los"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "clear",
               "kjv_def": ":--+ bewray, certain, evident, manifest.",
               "_strongs": "01212"
            },
            {
               "strongs": "1213",
               "greek": [
                  {
                     "_BETA": "DHLO/W",
                     "_unicode": "δηλόω",
                     "_translit": "dēlóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1212"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make plain (by words)",
               "kjv_def": ":--declare, shew, signify.",
               "_strongs": "01213"
            },
            {
               "strongs": "1214",
               "greek": [
                  {
                     "_BETA": "*DHMA=S",
                     "_unicode": "Δημᾶς",
                     "_translit": "Dēmâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day-mas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1216"
                     }
                  ],
                  "__text": "probably for \n;"
               },
               "strongs_def": "Demas, a Christian",
               "kjv_def": ":--Demas.",
               "_strongs": "01214"
            },
            {
               "strongs": "1215",
               "greek": [
                  {
                     "_BETA": "DHMHGORE/W",
                     "_unicode": "δημηγορέω",
                     "_translit": "dēmēgoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day-may-gor-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be a people-gatherer, i.e. to\n address a public assembly",
               "kjv_def": ":--make an oration.",
               "_strongs": "01215"
            },
            {
               "strongs": "1216",
               "greek": [
                  {
                     "_BETA": "*DHMH/TRIOS",
                     "_unicode": "Δημήτριος",
                     "_translit": "Dēmḗtrios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day-may'-tree-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*DHMH/THR",
                        "_unicode": "Δημήτηρ",
                        "_translit": "Dēmḗtēr"
                     }
                  ],
                  "__text": "from \n (Ceres);"
               },
               "strongs_def": "Demetrius, the name of an Ephesian and of a\n Christian",
               "kjv_def": ":--Demetrius.",
               "_strongs": "01216"
            },
            {
               "strongs": "1217",
               "greek": [
                  {
                     "_BETA": "DHMIOURGO/S",
                     "_unicode": "δημιουργός",
                     "_translit": "dēmiourgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day-me-oor-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a worker for the people, i.e. mechanic (spoken of\n the Creator)",
               "kjv_def": ":--maker.",
               "_strongs": "01217"
            },
            {
               "strongs": "1218",
               "greek": [
                  {
                     "_BETA": "DH=MOS",
                     "_unicode": "δῆμος",
                     "_translit": "dēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day'-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the public (as bound together socially)",
               "kjv_def": ":--people.",
               "_strongs": "01218"
            },
            {
               "strongs": "1219",
               "greek": [
                  {
                     "_BETA": "DHMO/SIOS",
                     "_unicode": "δημόσιος",
                     "_translit": "dēmósios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day-mos'ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "public; (feminine singular dative case as adverb) in\n public",
               "kjv_def": ":--common, openly, publickly.",
               "_strongs": "01219"
            },
            {
               "strongs": "1220",
               "greek": [
                  {
                     "_BETA": "DHNA/RION",
                     "_unicode": "δηνάριον",
                     "_translit": "dēnárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day-nar'-ee-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a denarius (or ten asses)",
               "kjv_def": ":--pence, penny(-worth).",
               "_strongs": "01220"
            },
            {
               "strongs": "1221",
               "greek": [
                  {
                     "_BETA": "DH/POTE",
                     "_unicode": "δήποτε",
                     "_translit": "dḗpote"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day'-pot-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1211"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a particle of generalization; indeed, at any\n time",
               "kjv_def": ":--(what-)soever.",
               "_strongs": "01221"
            },
            {
               "strongs": "1222",
               "greek": [
                  {
                     "_BETA": "DH/POU",
                     "_unicode": "δήπου",
                     "_translit": "dḗpou"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "day'-poo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1211"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4225"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a particle of asseveration; indeed\n doubtless",
               "kjv_def": ":--verily.",
               "_strongs": "01222"
            },
            {
               "strongs": "1223",
               "greek": [
                  {
                     "_BETA": "DIA/",
                     "_unicode": "διά",
                     "_translit": "diá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ah'"
                  }
               ],
               "strongs_derivation": "a primary preposition denoting the channel of an act;",
               "strongs_def": "through (in very\n wide applications, local, causal, or occasional)",
               "kjv_def": ":--after, always,\n among, at, to avoid, because of (that), briefly, by, for (cause) …\n fore, from, in, by occasion of, of, by reason of, for sake, that,\n thereby, therefore, X though, through(-out), to, wherefore, with\n (-in).",
               "_strongs": "01223",
               "__text": "In composition it retains the same general importance."
            },
            {
               "strongs": "1224",
               "greek": [
                  {
                     "_BETA": "DIABAI/NW",
                     "_unicode": "διαβαίνω",
                     "_translit": "diabaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ab-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to cross",
               "kjv_def": ":--come over, pass (through).",
               "_strongs": "01224"
            },
            {
               "strongs": "1225",
               "greek": [
                  {
                     "_BETA": "DIABA/LLW",
                     "_unicode": "διαβάλλω",
                     "_translit": "diabállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ab-al'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(figuratively) to traduce",
               "kjv_def": ":--accuse.",
               "_strongs": "01225"
            },
            {
               "strongs": "1226",
               "greek": [
                  {
                     "_BETA": "DIABEBAIO/OMAI",
                     "_unicode": "διαβεβαιόομαι",
                     "_translit": "diabebaióomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ab-eb-ahee-o'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "950"
                     }
                  ],
                  "__text": "middle voice of a compound of \n and \n;"
               },
               "strongs_def": "to confirm thoroughly (by\n words), i.e. asseverate",
               "kjv_def": ":--affirm constantly.",
               "_strongs": "01226"
            },
            {
               "strongs": "1227",
               "greek": [
                  {
                     "_BETA": "DIABLE/PW",
                     "_unicode": "διαβλέπω",
                     "_translit": "diablépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ab-lep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to look through, i.e. recover full vision",
               "kjv_def": ":--see\n clearly.",
               "_strongs": "01227"
            },
            {
               "strongs": "1228",
               "greek": [
                  {
                     "_BETA": "DIA/BOLOS",
                     "_unicode": "διάβολος",
                     "_translit": "diábolos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ab'-ol-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1225"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07854"
                     }
                  ],
                  "__text": "a traducer; specially, Satan (compare \n)"
               },
               "kjv_def": ":--false\n accuser, devil, slanderer.",
               "_strongs": "01228"
            },
            {
               "strongs": "1229",
               "greek": [
                  {
                     "_BETA": "DIAGGE/LLW",
                     "_unicode": "διαγγέλλω",
                     "_translit": "diangéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "de-ang-gel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to herald thoroughly",
               "kjv_def": ":--declare, preach,\n signify.",
               "_strongs": "01229"
            },
            {
               "strongs": "1230",
               "greek": [
                  {
                     "_BETA": "DIAGI/NOMAI",
                     "_unicode": "διαγίνομαι",
                     "_translit": "diagínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ag-in'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to elapse meanwhile",
               "kjv_def": ":--X after, be past, be spent.",
               "_strongs": "01230"
            },
            {
               "strongs": "1231",
               "greek": [
                  {
                     "_BETA": "DIAGINW/SKW",
                     "_unicode": "διαγινώσκω",
                     "_translit": "diaginṓskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ag-in-o'-sko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to know thoroughly, i.e. ascertain\n exactly",
               "kjv_def": ":--(would) enquire, know the uttermost.",
               "_strongs": "01231"
            },
            {
               "strongs": "1232",
               "greek": [
                  {
                     "_BETA": "DIAGNWRI/ZW",
                     "_unicode": "διαγνωρίζω",
                     "_translit": "diagnōrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ag-no-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1123"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1107"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tell abroad",
               "kjv_def": ":--make known.",
               "_strongs": "01232"
            },
            {
               "strongs": "1233",
               "greek": [
                  {
                     "_BETA": "DIA/GNWSIS",
                     "_unicode": "διάγνωσις",
                     "_translit": "diágnōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ag'-no-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1231"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(magisterial) examination (\"diagnosis\")",
               "kjv_def": ":--hearing.",
               "_strongs": "01233"
            },
            {
               "strongs": "1234",
               "greek": [
                  {
                     "_BETA": "DIAGOGGU/ZW",
                     "_unicode": "διαγογγύζω",
                     "_translit": "diagongýzō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ag-ong-good'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1111"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to complain throughout a crowd",
               "kjv_def": ":--murmur.",
               "_strongs": "01234"
            },
            {
               "strongs": "1235",
               "greek": [
                  {
                     "_BETA": "DIAGRHGORE/W",
                     "_unicode": "διαγρηγορέω",
                     "_translit": "diagrēgoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ag-ray-gor-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1127"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to waken thoroughly",
               "kjv_def": ":--be awake.",
               "_strongs": "01235"
            },
            {
               "strongs": "1236",
               "greek": [
                  {
                     "_BETA": "DIA/GW",
                     "_unicode": "διάγω",
                     "_translit": "diágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to pass time or life",
               "kjv_def": ":--lead life, living.",
               "_strongs": "01236"
            },
            {
               "strongs": "1237",
               "greek": [
                  {
                     "_BETA": "DIADE/XOMAI",
                     "_unicode": "διαδέχομαι",
                     "_translit": "diadéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ad-ekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to receive in turn, i.e. (figuratively) succeed\n to",
               "kjv_def": ":--come after.",
               "_strongs": "01237"
            },
            {
               "strongs": "1238",
               "greek": [
                  {
                     "_BETA": "DIA/DHMA",
                     "_unicode": "διάδημα",
                     "_translit": "diádēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ad'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a \"diadem\" (as bound about the\n head)",
               "kjv_def": ":--crown.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4735"
                  }
               ],
               "_strongs": "01238",
               "__text": "Compare \n."
            },
            {
               "strongs": "1239",
               "greek": [
                  {
                     "_BETA": "DIADI/DWMI",
                     "_unicode": "διαδίδωμι",
                     "_translit": "diadídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ad-id'-o-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give throughout a crowd, i.e. deal out; also to\n deliver over (as to a successor)",
               "kjv_def": ":--(make) distribute(-ion), divide,\n give.",
               "_strongs": "01239"
            },
            {
               "strongs": "1240",
               "greek": [
                  {
                     "_BETA": "DIA/DOXOS",
                     "_unicode": "διάδοχος",
                     "_translit": "diádochos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ad'-okh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1237"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a successor in office",
               "kjv_def": ":--room.",
               "_strongs": "01240"
            },
            {
               "strongs": "1241",
               "greek": [
                  {
                     "_BETA": "DIAZW/NNUMI",
                     "_unicode": "διαζώννυμι",
                     "_translit": "diazṓnnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-az-own'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2224"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to gird tightly",
               "kjv_def": ":--gird.",
               "_strongs": "01241"
            },
            {
               "strongs": "1242",
               "greek": [
                  {
                     "_BETA": "DIAQH/KH",
                     "_unicode": "διαθήκη",
                     "_translit": "diathḗkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ath-ay'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1303"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a disposition, i.e. (specially) a contract\n (especially a devisory will)",
               "kjv_def": ":--covenant, testament.",
               "_strongs": "01242"
            },
            {
               "strongs": "1243",
               "greek": [
                  {
                     "_BETA": "DIAI/RESIS",
                     "_unicode": "διαίρεσις",
                     "_translit": "diaíresis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ah'-ee-res-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1244"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a distinction or (concretely) variety",
               "kjv_def": ":--difference,\n diversity.",
               "_strongs": "01243"
            },
            {
               "strongs": "1244",
               "greek": [
                  {
                     "_BETA": "DIAIRE/W",
                     "_unicode": "διαιρέω",
                     "_translit": "diairéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ahee-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to separate, i.e. distribute",
               "kjv_def": ":--divide.",
               "_strongs": "01244"
            },
            {
               "strongs": "1245",
               "greek": [
                  {
                     "_BETA": "DIAKAQARI/ZW",
                     "_unicode": "διακαθαρίζω",
                     "_translit": "diakatharízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak-ath-ar-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2511"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to cleanse perfectly, i.e. (specially)\n winnow",
               "kjv_def": ":--thoroughly purge.",
               "_strongs": "01245"
            },
            {
               "strongs": "1246",
               "greek": [
                  {
                     "_BETA": "DIAKATELE/GXOMAI",
                     "_unicode": "διακατελέγχομαι",
                     "_translit": "diakatelénchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak-at-el-eng'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1651"
                     }
                  ],
                  "__text": "middle voice from \n and a compound of \n and \n;"
               },
               "strongs_def": "to prove\n downright, i.e. confute",
               "kjv_def": ":--convince.",
               "_strongs": "01246"
            },
            {
               "strongs": "1247",
               "greek": [
                  {
                     "_BETA": "DIAKONE/W",
                     "_unicode": "διακονέω",
                     "_translit": "diakonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak-on-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1249"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be an attendant, i.e. wait upon (menially or as a host,\n friend, or (figuratively) teacher); technically, to act as a Christian\n deacon",
               "kjv_def": ":--(ad-)minister (unto), serve, use the office of a deacon.",
               "_strongs": "01247"
            },
            {
               "strongs": "1248",
               "greek": [
                  {
                     "_BETA": "DIAKONI/A",
                     "_unicode": "διακονία",
                     "_translit": "diakonía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak-on-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1249"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "attendance (as a servant, etc.); figuratively\n (eleemosynary) aid, (official) service (especially of the Christian\n teacher, or technically of the diaconate)",
               "kjv_def": ":--(ad-)minister(-ing,\n -tration, -try), office, relief, service(-ing).",
               "_strongs": "01248"
            },
            {
               "strongs": "1249",
               "greek": [
                  {
                     "_BETA": "DIA/KONOS",
                     "_unicode": "διάκονος",
                     "_translit": "diákonos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak'-on-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DIA/KW",
                        "_unicode": "διάκω",
                        "_translit": "diákō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1377"
                     }
                  ],
                  "__text": "probably from an obsolete \n (to run on errands; compare \n);"
               },
               "strongs_def": "an\n attendant, i.e. (genitive case) a waiter (at table or in other menial\n duties); specially, a Christian teacher and pastor (technically, a\n deacon or deaconess)",
               "kjv_def": ":--deacon, minister, servant.",
               "_strongs": "01249"
            },
            {
               "strongs": "1250",
               "greek": [
                  {
                     "_BETA": "DIAKO/SIOI",
                     "_unicode": "διακόσιοι",
                     "_translit": "diakósioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak-os'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1540"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "two hundred",
               "kjv_def": ":--two hundred.",
               "_strongs": "01250"
            },
            {
               "strongs": "1251",
               "greek": [
                  {
                     "_BETA": "DIAKOU/OMAI",
                     "_unicode": "διακούομαι",
                     "_translit": "diakoúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak-oo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "191"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to hear throughout, i.e. patiently\n listen (to a prisoner's plea)",
               "kjv_def": ":--hear.",
               "_strongs": "01251"
            },
            {
               "strongs": "1252",
               "greek": [
                  {
                     "_BETA": "DIAKRI/NW",
                     "_unicode": "διακρίνω",
                     "_translit": "diakrínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak-ree'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to separate thoroughly, i.e. (literally and\n reflexively) to withdraw from, or (by implication) oppose;\n figuratively, to discriminate (by implication, decide), or\n (reflexively) hesitate",
               "kjv_def": ":--contend, make (to) differ(-ence), discern,\n doubt, judge, be partial, stagger, waver.",
               "_strongs": "01252"
            },
            {
               "strongs": "1253",
               "greek": [
                  {
                     "_BETA": "DIA/KRISIS",
                     "_unicode": "διάκρισις",
                     "_translit": "diákrisis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak'-ree-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1252"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "judicial estimation",
               "kjv_def": ":--discern(-ing), disputation.",
               "_strongs": "01253"
            },
            {
               "strongs": "1254",
               "greek": [
                  {
                     "_BETA": "DIAKWLU/W",
                     "_unicode": "διακωλύω",
                     "_translit": "diakōlýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ak-o-loo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2967"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hinder altogether, i.e. utterly\n prohibit",
               "kjv_def": ":--forbid.",
               "_strongs": "01254"
            },
            {
               "strongs": "1255",
               "greek": [
                  {
                     "_BETA": "DIALALE/W",
                     "_unicode": "διαλαλέω",
                     "_translit": "dialaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-al-al-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to talk throughout a company, i.e. converse or\n (genitive case) publish",
               "kjv_def": ":--commune, noise abroad.",
               "_strongs": "01255"
            },
            {
               "strongs": "1256",
               "greek": [
                  {
                     "_BETA": "DIALE/GOMAI",
                     "_unicode": "διαλέγομαι",
                     "_translit": "dialégomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-al-eg'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to say thoroughly, i.e. discuss (in\n argument or exhortation)",
               "kjv_def": ":--dispute, preach (unto), reason (with),\n speak.",
               "_strongs": "01256"
            },
            {
               "strongs": "1257",
               "greek": [
                  {
                     "_BETA": "DIALEI/PW",
                     "_unicode": "διαλείπω",
                     "_translit": "dialeípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-al-i'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to leave off in the middle, i.e. intermit",
               "kjv_def": ":--cease.",
               "_strongs": "01257"
            },
            {
               "strongs": "1258",
               "greek": [
                  {
                     "_BETA": "DIA/LEKTOS",
                     "_unicode": "διάλεκτος",
                     "_translit": "diálektos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-al'-ek-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1256"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a (mode of) discourse, i.e. \"dialect\"",
               "kjv_def": ":--language, tongue.",
               "_strongs": "01258"
            },
            {
               "strongs": "1259",
               "greek": [
                  {
                     "_BETA": "DIALLA/SSW",
                     "_unicode": "διαλλάσσω",
                     "_translit": "diallássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-al-las'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "236"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to change thoroughly, i.e. (mentally) to\n conciliate",
               "kjv_def": ":--reconcile.",
               "_strongs": "01259"
            },
            {
               "strongs": "1260",
               "greek": [
                  {
                     "_BETA": "DIALOGI/ZOMAI",
                     "_unicode": "διαλογίζομαι",
                     "_translit": "dialogízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-al-og-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3049"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reckon thoroughly, i.e. (genitive case) to\n deliberate (by reflection or discussion)",
               "kjv_def": ":--cast in mind, consider,\n dispute, muse, reason, think.",
               "_strongs": "01260"
            },
            {
               "strongs": "1261",
               "greek": [
                  {
                     "_BETA": "DIALOGISMO/S",
                     "_unicode": "διαλογισμός",
                     "_translit": "dialogismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-al-og-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1260"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "discussion, i.e. (internal) consideration (by implication,\n purpose), or (external) debate",
               "kjv_def": ":--dispute, doubtful(-ing), imagination,\n reasoning, thought.",
               "_strongs": "01261"
            },
            {
               "strongs": "1262",
               "greek": [
                  {
                     "_BETA": "DIALU/W",
                     "_unicode": "διαλύω",
                     "_translit": "dialýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-al-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to dissolve utterly",
               "kjv_def": ":--scatter.",
               "_strongs": "01262"
            },
            {
               "strongs": "1263",
               "greek": [
                  {
                     "_BETA": "DIAMARTU/ROMAI",
                     "_unicode": "διαμαρτύρομαι",
                     "_translit": "diamartýromai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-am-ar-too'-rom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3140"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to attest or protest earnestly, or (by\n implication) hortatively",
               "kjv_def": ":--charge, testify (unto), witness.",
               "_strongs": "01263"
            },
            {
               "strongs": "1264",
               "greek": [
                  {
                     "_BETA": "DIAMA/XOMAI",
                     "_unicode": "διαμάχομαι",
                     "_translit": "diamáchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-am-akh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3164"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fight fiercely (in altercation)",
               "kjv_def": ":--strive.",
               "_strongs": "01264"
            },
            {
               "strongs": "1265",
               "greek": [
                  {
                     "_BETA": "DIAME/NW",
                     "_unicode": "διαμένω",
                     "_translit": "diaménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-am-en'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stay constantly (in being or\n relation)",
               "kjv_def": ":--continue, remain.",
               "_strongs": "01265"
            },
            {
               "strongs": "1266",
               "greek": [
                  {
                     "_BETA": "DIAMERI/ZW",
                     "_unicode": "διαμερίζω",
                     "_translit": "diamerízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-am-er-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3307"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to partition thoroughly (literally in\n distribution, figuratively in dissension)",
               "kjv_def": ":--cloven, divide, part.",
               "_strongs": "01266"
            },
            {
               "strongs": "1267",
               "greek": [
                  {
                     "_BETA": "DIAMERISMO/S",
                     "_unicode": "διαμερισμός",
                     "_translit": "diamerismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-am-er-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1266"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "disunion (of opinion and conduct)",
               "kjv_def": ":--division.",
               "_strongs": "01267"
            },
            {
               "strongs": "1268",
               "greek": [
                  {
                     "_BETA": "DIANE/MW",
                     "_unicode": "διανέμω",
                     "_translit": "dianémō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-an-em'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to distribute, i.e. (of information)\n to disseminate",
               "kjv_def": ":--spread.",
               "_strongs": "01268"
            },
            {
               "strongs": "1269",
               "greek": [
                  {
                     "_BETA": "DIANEU/W",
                     "_unicode": "διανεύω",
                     "_translit": "dianeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-an-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3506"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to nod (or express by signs) across an intervening\n space",
               "kjv_def": ":--beckon.",
               "_strongs": "01269"
            },
            {
               "strongs": "1270",
               "greek": [
                  {
                     "_BETA": "DIANO/HMA",
                     "_unicode": "διανόημα",
                     "_translit": "dianóēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-an-o'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "something thought through, i.e. a\n sentiment",
               "kjv_def": ":--thought.",
               "_strongs": "01270"
            },
            {
               "strongs": "1271",
               "greek": [
                  {
                     "_BETA": "DIA/NOIA",
                     "_unicode": "διάνοια",
                     "_translit": "diánoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-an'-oy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "deep thought, properly, the faculty (mind or its\n disposition), by implication, its exercise",
               "kjv_def": ":-- imagination, mind,\n understanding.",
               "_strongs": "01271"
            },
            {
               "strongs": "1272",
               "greek": [
                  {
                     "_BETA": "DIANOI/GW",
                     "_unicode": "διανοίγω",
                     "_translit": "dianoígō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-an-oy'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "455"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to open thoroughly, literally (as a first-born) or\n figuratively (to expound)",
               "kjv_def": ":--open.",
               "_strongs": "01272"
            },
            {
               "strongs": "1273",
               "greek": [
                  {
                     "_BETA": "DIANUKTEREU/W",
                     "_unicode": "διανυκτερεύω",
                     "_translit": "dianyktereúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-an-ook-ter-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3571"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to sit up the whole\n night",
               "kjv_def": ":--continue all night.",
               "_strongs": "01273"
            },
            {
               "strongs": "1274",
               "greek": [
                  {
                     "_BETA": "DIANU/W",
                     "_unicode": "διανύω",
                     "_translit": "dianýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-an-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)NU/W",
                        "_unicode": "ἀνύω",
                        "_translit": "anýō"
                     }
                  ],
                  "__text": "from \n and \n (to effect);"
               },
               "strongs_def": "to accomplish thoroughly",
               "kjv_def": ":--finish.",
               "_strongs": "01274"
            },
            {
               "strongs": "1275",
               "greek": [
                  {
                     "_BETA": "DIAPANTO/S",
                     "_unicode": "διαπαντός",
                     "_translit": "diapantós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ap-an-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     }
                  ],
                  "__text": "from \n and the genitive case of \n;"
               },
               "strongs_def": "through all time, i.e.\n (adverbially) constantly",
               "kjv_def": ":--alway(-s), continually.",
               "_strongs": "01275"
            },
            {
               "strongs": "1276",
               "greek": [
                  {
                     "_BETA": "DIAPERA/W",
                     "_unicode": "διαπεράω",
                     "_translit": "diaperáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ap-er-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from \n and a derivative of the base of \n;"
               },
               "strongs_def": "to cross entirely",
               "kjv_def": ":--go\n over, pass (over), sail over.",
               "_strongs": "01276"
            },
            {
               "strongs": "1277",
               "greek": [
                  {
                     "_BETA": "DIAPLE/W",
                     "_unicode": "διαπλέω",
                     "_translit": "diapléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ap-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sail through",
               "kjv_def": ":--sail over.",
               "_strongs": "01277"
            },
            {
               "strongs": "1278",
               "greek": [
                  {
                     "_BETA": "DIAPONE/W",
                     "_unicode": "διαπονέω",
                     "_translit": "diaponéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ap-on-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4192"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to toil through, i.e. (passively)\n be worried",
               "kjv_def": ":--be grieved.",
               "_strongs": "01278"
            },
            {
               "strongs": "1279",
               "greek": [
                  {
                     "_BETA": "DIAPOREU/OMAI",
                     "_unicode": "διαπορεύομαι",
                     "_translit": "diaporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ap-or-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to travel through",
               "kjv_def": ":--go through, journey in, pass\n by.",
               "_strongs": "01279"
            },
            {
               "strongs": "1280",
               "greek": [
                  {
                     "_BETA": "DIAPORE/W",
                     "_unicode": "διαπορέω",
                     "_translit": "diaporéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ap-or-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "639"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be thoroughly nonplussed",
               "kjv_def": ":--(be in) doubt, be\n (much) perplexed.",
               "_strongs": "01280"
            },
            {
               "strongs": "1281",
               "greek": [
                  {
                     "_BETA": "DIAPRAGMATEU/OMAI",
                     "_unicode": "διαπραγματεύομαι",
                     "_translit": "diapragmateúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ap-rag-mat-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4231"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to thoroughly occupy oneself, i.e. (transitively\n and by implication) to earn in business",
               "kjv_def": ":--gain by trading.",
               "_strongs": "01281"
            },
            {
               "strongs": "1282",
               "greek": [
                  {
                     "_BETA": "DIAPRI/W",
                     "_unicode": "διαπρίω",
                     "_translit": "diapríō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ap-ree'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4249"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to saw asunder, i.e. (figuratively) to\n exasperate",
               "kjv_def": ":--cut (to the heart).",
               "_strongs": "01282"
            },
            {
               "strongs": "1283",
               "greek": [
                  {
                     "_BETA": "DIARPA/ZW",
                     "_unicode": "διαρπάζω",
                     "_translit": "diarpázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ar-pad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "726"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to seize asunder, i.e. plunder",
               "kjv_def": ":--spoil.",
               "_strongs": "01283"
            },
            {
               "strongs": "1284",
               "greek": [
                  {
                     "_BETA": "DIAR)R(H/SSW",
                     "_unicode": "διαῤῥήσσω",
                     "_translit": "diarrhḗssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ar-hrayce'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tear asunder",
               "kjv_def": ":--break, rend.",
               "_strongs": "01284"
            },
            {
               "strongs": "1285",
               "greek": [
                  {
                     "_BETA": "DIASAFE/W",
                     "_unicode": "διασαφέω",
                     "_translit": "diasaphéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-af-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "SAFH/S",
                        "_unicode": "σαφής",
                        "_translit": "saphḗs"
                     }
                  ],
                  "__text": "from \n and \n (clear);"
               },
               "strongs_def": "to clear thoroughly, i.e. (figuratively)\n declare",
               "kjv_def": ":--tell unto.",
               "_strongs": "01285"
            },
            {
               "strongs": "1286",
               "greek": [
                  {
                     "_BETA": "DIASEI/W",
                     "_unicode": "διασείω",
                     "_translit": "diaseíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-i'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4579"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to shake thoroughly, i.e. (figuratively) to\n intimidate",
               "kjv_def": ":--do violence to.",
               "_strongs": "01286"
            },
            {
               "strongs": "1287",
               "greek": [
                  {
                     "_BETA": "DIASKORPI/ZW",
                     "_unicode": "διασκορπίζω",
                     "_translit": "diaskorpízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-kor-pid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4650"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to dissipate, i.e. (genitive case) to rout or\n separate; specially, to winnow; figuratively, to squander",
               "kjv_def": ":--disperse,\n scatter (abroad), strew, waste.",
               "_strongs": "01287"
            },
            {
               "strongs": "1288",
               "greek": [
                  {
                     "_BETA": "DIASPA/W",
                     "_unicode": "διασπάω",
                     "_translit": "diaspáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-pah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4685"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to draw apart, i.e. sever or dismember",
               "kjv_def": ":--pluck\n asunder, pull in pieces.",
               "_strongs": "01288"
            },
            {
               "strongs": "1289",
               "greek": [
                  {
                     "_BETA": "DIASPEI/RW",
                     "_unicode": "διασπείρω",
                     "_translit": "diaspeírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-pi'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4687"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sow throughout, i.e. (figuratively) distribute\n in foreign lands",
               "kjv_def": ":--scatter abroad.",
               "_strongs": "01289"
            },
            {
               "strongs": "1290",
               "greek": [
                  {
                     "_BETA": "DIASPORA/",
                     "_unicode": "διασπορά",
                     "_translit": "diasporá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-por-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1289"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "dispersion, i.e. (specially and concretely) the (converted)\n Israelite resident in Gentile countries",
               "kjv_def": ":--(which are) scattered\n (abroad).",
               "_strongs": "01290"
            },
            {
               "strongs": "1291",
               "greek": [
                  {
                     "_BETA": "DIASTE/LLOMAI",
                     "_unicode": "διαστέλλομαι",
                     "_translit": "diastéllomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-tel'-lom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4724"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to set (oneself) apart (figuratively,\n distinguish), i.e. (by implication) to enjoin",
               "kjv_def": ":--charge, that which was\n (give) commanded(-ment).",
               "_strongs": "01291"
            },
            {
               "strongs": "1292",
               "greek": [
                  {
                     "_BETA": "DIA/STHMA",
                     "_unicode": "διάστημα",
                     "_translit": "diástēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as'-tay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1339"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an interval",
               "kjv_def": ":--space.",
               "_strongs": "01292"
            },
            {
               "strongs": "1293",
               "greek": [
                  {
                     "_BETA": "DIASTOLH/",
                     "_unicode": "διαστολή",
                     "_translit": "diastolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-tol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1291"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a variation",
               "kjv_def": ":--difference, distinction.",
               "_strongs": "01293"
            },
            {
               "strongs": "1294",
               "greek": [
                  {
                     "_BETA": "DIASTRE/FW",
                     "_unicode": "διαστρέφω",
                     "_translit": "diastréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to distort, i.e. (figuratively) misinterpret, or\n (morally) corrupt",
               "kjv_def": ":--perverse(-rt), turn away.",
               "_strongs": "01294"
            },
            {
               "strongs": "1295",
               "greek": [
                  {
                     "_BETA": "DIASW/ZW",
                     "_unicode": "διασώζω",
                     "_translit": "diasṓzō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-as-odze'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4982"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to save thoroughly, i.e. (by implication or\n analogy) to cure, preserve, rescue, etc.",
               "kjv_def": ":--bring safe, escape (safe),\n heal, make perfectly whole, save.",
               "_strongs": "01295"
            },
            {
               "strongs": "1296",
               "greek": [
                  {
                     "_BETA": "DIATAGH/",
                     "_unicode": "διαταγή",
                     "_translit": "diatagḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-ag-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1299"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "arrangement, i.e. institution",
               "kjv_def": ":--instrumentality.",
               "_strongs": "01296"
            },
            {
               "strongs": "1297",
               "greek": [
                  {
                     "_BETA": "DIA/TAGMA",
                     "_unicode": "διάταγμα",
                     "_translit": "diátagma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at'-ag-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1299"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an arrangement, i.e. (authoritative) edict",
               "kjv_def": ":--commandment.",
               "_strongs": "01297"
            },
            {
               "strongs": "1298",
               "greek": [
                  {
                     "_BETA": "DIATARA/SSW",
                     "_unicode": "διαταράσσω",
                     "_translit": "diatarássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-ar-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5015"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to disturb wholly, i.e. agitate (with\n alarm)",
               "kjv_def": ":--trouble.",
               "_strongs": "01298"
            },
            {
               "strongs": "1299",
               "greek": [
                  {
                     "_BETA": "DIATA/SSW",
                     "_unicode": "διατάσσω",
                     "_translit": "diatássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to arrange thoroughly, i.e. (specially) institute,\n prescribe, etc.",
               "kjv_def": ":--appoint, command, give, (set in) order, ordain.",
               "_strongs": "01299"
            },
            {
               "strongs": "1300",
               "greek": [
                  {
                     "_BETA": "DIATELE/W",
                     "_unicode": "διατελέω",
                     "_translit": "diateléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-el-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5055"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to accomplish thoroughly, i.e. (subjectively) to\n persist",
               "kjv_def": ":--continue.",
               "_strongs": "01300"
            },
            {
               "strongs": "1301",
               "greek": [
                  {
                     "_BETA": "DIATHRE/W",
                     "_unicode": "διατηρέω",
                     "_translit": "diatēréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-ay-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5083"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to watch thoroughly, i.e. (positively and\n transitively) to observe strictly, or (negatively and reflexively) to\n avoid wholly",
               "kjv_def": ":--keep.",
               "_strongs": "01301"
            },
            {
               "strongs": "1302",
               "greek": [
                  {
                     "_BETA": "DIATI/",
                     "_unicode": "διατί",
                     "_translit": "diatí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-ee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5101"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "through what cause ?, i.e. why?",
               "kjv_def": ":--wherefore, why.",
               "_strongs": "01302"
            },
            {
               "strongs": "1303",
               "greek": [
                  {
                     "_BETA": "DIATI/QEMAI",
                     "_unicode": "διατίθεμαι",
                     "_translit": "diatíthemai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-ith'-em-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to put apart, i.e. (figuratively)\n dispose (by assignment, compact, or bequest)",
               "kjv_def": ":--appoint, make,\n testator.",
               "_strongs": "01303"
            },
            {
               "strongs": "1304",
               "greek": [
                  {
                     "_BETA": "DIATRI/BW",
                     "_unicode": "διατρίβω",
                     "_translit": "diatríbō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-ree'-bo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5147"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to wear through (time), i.e.\n remain",
               "kjv_def": ":--abide, be, continue, tarry.",
               "_strongs": "01304"
            },
            {
               "strongs": "1305",
               "greek": [
                  {
                     "_BETA": "DIATROFH/",
                     "_unicode": "διατροφή",
                     "_translit": "diatrophḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-at-rof-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "nourishment",
               "kjv_def": ":--food.",
               "_strongs": "01305"
            },
            {
               "strongs": "1306",
               "greek": [
                  {
                     "_BETA": "DIAUGA/ZW",
                     "_unicode": "διαυγάζω",
                     "_translit": "diaugázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ow-gad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "826"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to glimmer through, i.e. break (as day)",
               "kjv_def": ":--dawn.",
               "_strongs": "01306"
            },
            {
               "strongs": "1307",
               "greek": [
                  {
                     "_BETA": "DIAFANH/S",
                     "_unicode": "διαφανής",
                     "_translit": "diaphanḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-af-an-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "appearing through, i.e.\n \"diaphanous\"",
               "kjv_def": ":--transparent.",
               "_strongs": "01307"
            },
            {
               "strongs": "1308",
               "greek": [
                  {
                     "_BETA": "DIAFE/RW",
                     "_unicode": "διαφέρω",
                     "_translit": "diaphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-af-er'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear through, i.e. (literally) transport;\n usually to bear apart, i.e. (objectively) to toss about (figuratively,\n report); subjectively, to \"differ\", or (by implication) surpass",
               "kjv_def": ":--be\n better, carry, differ from, drive up and down, be (more) excellent,\n make matter, publish, be of more value.",
               "_strongs": "01308"
            },
            {
               "strongs": "1309",
               "greek": [
                  {
                     "_BETA": "DIAFEU/GW",
                     "_unicode": "διαφεύγω",
                     "_translit": "diapheúgō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-af-yoo'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5343"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to flee through, i.e. escape",
               "kjv_def": ":--escape.",
               "_strongs": "01309"
            },
            {
               "strongs": "1310",
               "greek": [
                  {
                     "_BETA": "DIAFHMI/ZW",
                     "_unicode": "διαφημίζω",
                     "_translit": "diaphēmízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-af-ay-mid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5345"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to report thoroughly, i.e.\n divulgate",
               "kjv_def": ":--blaze abroad, commonly report, spread abroad, fame.",
               "_strongs": "01310"
            },
            {
               "strongs": "1311",
               "greek": [
                  {
                     "_BETA": "DIAFQEI/RW",
                     "_unicode": "διαφθείρω",
                     "_translit": "diaphtheírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-af-thi'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1225"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5351"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rot thoroughly, i.e. (by implication) to ruin\n (passively, decay utterly, figuratively, pervert)",
               "kjv_def": ":--corrupt, destroy,\n perish.",
               "_strongs": "01311"
            },
            {
               "strongs": "1312",
               "greek": [
                  {
                     "_BETA": "DIAFQORA/",
                     "_unicode": "διαφθορά",
                     "_translit": "diaphthorá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-af-thor-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1311"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "decay",
               "kjv_def": ":--corruption.",
               "_strongs": "01312"
            },
            {
               "strongs": "1313",
               "greek": [
                  {
                     "_BETA": "DIA/FOROS",
                     "_unicode": "διάφορος",
                     "_translit": "diáphoros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-af'-or-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1308"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "varying; also surpassing",
               "kjv_def": ":--differing, divers, more\n excellent.",
               "_strongs": "01313"
            },
            {
               "strongs": "1314",
               "greek": [
                  {
                     "_BETA": "DIAFULA/SSW",
                     "_unicode": "διαφυλάσσω",
                     "_translit": "diaphylássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-af-oo-las'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5442"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to guard thoroughly, i.e. protect",
               "kjv_def": ":--keep.",
               "_strongs": "01314"
            },
            {
               "strongs": "1315",
               "greek": [
                  {
                     "_BETA": "DIAXEIRI/ZOMAI",
                     "_unicode": "διαχειρίζομαι",
                     "_translit": "diacheirízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-akh-i-rid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to handle thoroughly, i.e. lay\n violent hands upon",
               "kjv_def": ":--kill, slay.",
               "_strongs": "01315"
            },
            {
               "strongs": "1316",
               "greek": [
                  {
                     "_BETA": "DIAXWRI/ZOMAI",
                     "_unicode": "διαχωρίζομαι",
                     "_translit": "diachōrízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-akh-o-rid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5563"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to remove (oneself) wholly,\n i.e. retire",
               "kjv_def": ":--depart.",
               "_strongs": "01316"
            },
            {
               "strongs": "1317",
               "greek": [
                  {
                     "_BETA": "DIDAKTIKO/S",
                     "_unicode": "διδακτικός",
                     "_translit": "didaktikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did-ak-tik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1318"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "instructive (\"didactic\")",
               "kjv_def": ":--apt to teach.",
               "_strongs": "01317"
            },
            {
               "strongs": "1318",
               "greek": [
                  {
                     "_BETA": "DIDAKTO/S",
                     "_unicode": "διδακτός",
                     "_translit": "didaktós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did-ak-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1321"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(subjectively) instructed, or (objectively) communicated by\n teaching",
               "kjv_def": ":--taught, which … teacheth.",
               "_strongs": "01318"
            },
            {
               "strongs": "1319",
               "greek": [
                  {
                     "_BETA": "DIDASKALI/A",
                     "_unicode": "διδασκαλία",
                     "_translit": "didaskalía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did-as-kal-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1320"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "instruction (the function or the information)",
               "kjv_def": ":--doctrine,\n learning, teaching.",
               "_strongs": "01319"
            },
            {
               "strongs": "1320",
               "greek": [
                  {
                     "_BETA": "DIDA/SKALOS",
                     "_unicode": "διδάσκαλος",
                     "_translit": "didáskalos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did-as'-kal-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1321"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an instructor (genitive case or specially)",
               "kjv_def": ":--doctor,\n master, teacher.",
               "_strongs": "01320"
            },
            {
               "strongs": "1321",
               "greek": [
                  {
                     "_BETA": "DIDA/SKW",
                     "_unicode": "διδάσκω",
                     "_translit": "didáskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did-as'-ko"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DA/W",
                        "_unicode": "δάω",
                        "_translit": "dáō"
                     }
                  ],
                  "__text": "a prolonged (causative) form of a primary verb \n (to learn);"
               },
               "strongs_def": "to\n teach (in the same broad application)",
               "kjv_def": ":--teach.",
               "_strongs": "01321"
            },
            {
               "strongs": "1322",
               "greek": [
                  {
                     "_BETA": "DIDAXH/",
                     "_unicode": "διδαχή",
                     "_translit": "didachḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did-akh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1321"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "instruction (the act or the matter)",
               "kjv_def": ":--doctrine, hath been\n taught.",
               "_strongs": "01322"
            },
            {
               "strongs": "1323",
               "greek": [
                  {
                     "_BETA": "DI/DRAXMON",
                     "_unicode": "δίδραχμον",
                     "_translit": "dídrachmon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did'-rakh-mon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1406"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a double drachma (didrachm)",
               "kjv_def": ":--tribute.",
               "_strongs": "01323"
            },
            {
               "strongs": "1324",
               "greek": [
                  {
                     "_BETA": "*DI/DUMOS",
                     "_unicode": "Δίδυμος",
                     "_translit": "Dídymos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did'-oo-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     }
                  ],
                  "__text": "prolongation from \n;"
               },
               "strongs_def": "double, i.e. twin; Didymus, a\n Christian",
               "kjv_def": ":--Didymus.",
               "_strongs": "01324"
            },
            {
               "strongs": "1325",
               "greek": [
                  {
                     "_BETA": "DI/DWMI",
                     "_unicode": "δίδωμι",
                     "_translit": "dídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "did'-o-mee"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb (which is used as an alternative in\n most of the tenses);",
               "strongs_def": "to give (used in a very wide application,\n properly, or by implication, literally or figuratively; greatly\n modified by the connection)",
               "kjv_def": ":--adventure, bestow, bring forth, commit,\n deliver (up), give, grant, hinder, make, minister, number, offer, have\n power, put, receive, set, shew, smite (+ with the hand), strike (+\n with the palm of the hand), suffer, take, utter, yield.",
               "_strongs": "01325"
            },
            {
               "strongs": "1326",
               "greek": [
                  {
                     "_BETA": "DIEGEI/RW",
                     "_unicode": "διεγείρω",
                     "_translit": "diegeírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-eg-i'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1453"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to wake fully; i.e. arouse (literally or\n figuratively)",
               "kjv_def": ":--arise, awake, raise, stir up.",
               "_strongs": "01326"
            },
            {
               "strongs": "1327",
               "greek": [
                  {
                     "_BETA": "DIE/CODOS",
                     "_unicode": "διέξοδος",
                     "_translit": "diéxodos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ex'-od-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1841"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an outlet through, i.e. probably an open square\n (from which roads diverge)",
               "kjv_def": ":--highway.",
               "_strongs": "01327"
            },
            {
               "strongs": "1328",
               "greek": [
                  {
                     "_BETA": "DIERMHNEUTH/S",
                     "_unicode": "διερμηνευτής",
                     "_translit": "diermēneutḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-er-main-yoo-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1329"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an explainer",
               "kjv_def": ":--interpreter.",
               "_strongs": "01328"
            },
            {
               "strongs": "1329",
               "greek": [
                  {
                     "_BETA": "DIERMHNEU/W",
                     "_unicode": "διερμηνεύω",
                     "_translit": "diermēneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-er-main-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2059"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to explain thoroughly, by implication, to\n translate",
               "kjv_def": ":--expound, interpret(-ation).",
               "_strongs": "01329"
            },
            {
               "strongs": "1330",
               "greek": [
                  {
                     "_BETA": "DIE/RXOMAI",
                     "_unicode": "διέρχομαι",
                     "_translit": "diérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to traverse (literally)",
               "kjv_def": ":--come, depart, go (about,\n abroad, everywhere, over, through, throughout), pass (by, over,\n through, throughout), pierce through, travel, walk through.",
               "_strongs": "01330"
            },
            {
               "strongs": "1331",
               "greek": [
                  {
                     "_BETA": "DIERWTA/W",
                     "_unicode": "διερωτάω",
                     "_translit": "dierōtáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-er-o-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2065"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to question throughout, i.e. ascertain by\n interrogation",
               "kjv_def": ":--make enquiry for.",
               "_strongs": "01331"
            },
            {
               "strongs": "1332",
               "greek": [
                  {
                     "_BETA": "DIETH/S",
                     "_unicode": "διετής",
                     "_translit": "dietḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-et-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2094"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "of two years (in age)",
               "kjv_def": ":--two years old.",
               "_strongs": "01332"
            },
            {
               "strongs": "1333",
               "greek": [
                  {
                     "_BETA": "DIETI/A",
                     "_unicode": "διετία",
                     "_translit": "dietía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-et-ee'-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1332"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a space of two years (biennium)",
               "kjv_def": ":--two years.",
               "_strongs": "01333"
            },
            {
               "strongs": "1334",
               "greek": [
                  {
                     "_BETA": "DIHGE/OMAI",
                     "_unicode": "διηγέομαι",
                     "_translit": "diēgéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ayg-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2233"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to relate fully",
               "kjv_def": ":--declare, shew, tell.",
               "_strongs": "01334"
            },
            {
               "strongs": "1335",
               "greek": [
                  {
                     "_BETA": "DIH/GESIS",
                     "_unicode": "διήγεσις",
                     "_translit": "diḗgesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ayg'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1334"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a recital",
               "kjv_def": ":--declaration.",
               "_strongs": "01335"
            },
            {
               "strongs": "1336",
               "greek": [
                  {
                     "_BETA": "DIHNEKH/S",
                     "_unicode": "διηνεκής",
                     "_translit": "diēnekḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ay-nek-es'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "neuter of a compound of \n and a derivative of an alternate of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     }
                  ],
                  "__text": "carried through, i.e. (adverbially with \n and \n prefixed)\n perpetually"
               },
               "kjv_def": ":--+ continually, for ever.",
               "_strongs": "01336"
            },
            {
               "strongs": "1337",
               "greek": [
                  {
                     "_BETA": "DIQA/LASSOS",
                     "_unicode": "διθάλασσος",
                     "_translit": "dithálassos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-thal'-as-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2281"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "having two seas, i.e. a sound with a double\n outlet",
               "kjv_def": ":--where two seas meet.",
               "_strongs": "01337"
            },
            {
               "strongs": "1338",
               "greek": [
                  {
                     "_BETA": "DII+KNE/OMAI",
                     "_unicode": "διϊκνέομαι",
                     "_translit": "diïknéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ik-neh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2425"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to reach through, i.e.\n penetrate",
               "kjv_def": ":--pierce.",
               "_strongs": "01338"
            },
            {
               "strongs": "1339",
               "greek": [
                  {
                     "_BETA": "DII/+STHMI",
                     "_unicode": "διΐστημι",
                     "_translit": "diḯstēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand apart, i.e. (reflexively) to remove,\n intervene",
               "kjv_def": ":--go further, be parted, after the space of.",
               "_strongs": "01339"
            },
            {
               "strongs": "1340",
               "greek": [
                  {
                     "_BETA": "DII+SXURI/ZOMAI",
                     "_unicode": "διϊσχυρίζομαι",
                     "_translit": "diïschyrízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-is-khoo-rid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2478"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to stout it through, i.e.\n asservate",
               "kjv_def": ":--confidently (constantly) affirm.",
               "_strongs": "01340"
            },
            {
               "strongs": "1341",
               "greek": [
                  {
                     "_BETA": "DIKAIOKRISI/A",
                     "_unicode": "δικαιοκρισία",
                     "_translit": "dikaiokrisía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik-ah-yok-ris-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1342"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2920"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a just sentence",
               "kjv_def": ":--righteous judgment.",
               "_strongs": "01341"
            },
            {
               "strongs": "1342",
               "greek": [
                  {
                     "_BETA": "DI/KAIOS",
                     "_unicode": "δίκαιος",
                     "_translit": "díkaios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik'-ah-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "equitable (in character or act); by implication, innocent,\n holy (absolutely or relatively)",
               "kjv_def": ":--just, meet, right(-eous).",
               "_strongs": "01342"
            },
            {
               "strongs": "1343",
               "greek": [
                  {
                     "_BETA": "DIKAIOSU/NH",
                     "_unicode": "δικαιοσύνη",
                     "_translit": "dikaiosýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik-ah-yos-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1342"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "equity (of character or act); specially (Christian)\n justification",
               "kjv_def": ":--righteousness.",
               "_strongs": "01343"
            },
            {
               "strongs": "1344",
               "greek": [
                  {
                     "_BETA": "DIKAIO/W",
                     "_unicode": "δικαιόω",
                     "_translit": "dikaióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik-ah-yo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1342"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render (i.e. show or regard as) just or innocent",
               "kjv_def": ":--free,\n justify(-ier), be righteous.",
               "_strongs": "01344"
            },
            {
               "strongs": "1345",
               "greek": [
                  {
                     "_BETA": "DIKAI/WMA",
                     "_unicode": "δικαίωμα",
                     "_translit": "dikaíōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik-ah'-yo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1344"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an equitable deed; by implication, a statute or\n decision",
               "kjv_def": ":--judgment, justification, ordinance, righteousness.",
               "_strongs": "01345"
            },
            {
               "strongs": "1346",
               "greek": [
                  {
                     "_BETA": "DIKAI/WS",
                     "_unicode": "δικαίως",
                     "_translit": "dikaíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik-ah'-yoce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1342"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "equitably",
               "kjv_def": ":--justly, (to) righteously(-ness).",
               "_strongs": "01346"
            },
            {
               "strongs": "1347",
               "greek": [
                  {
                     "_BETA": "DIKAI/WSIS",
                     "_unicode": "δικαίωσις",
                     "_translit": "dikaíōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik-ah'-yo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1344"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "aquittal (for Christ's sake)",
               "kjv_def": ":--justification.",
               "_strongs": "01347"
            },
            {
               "strongs": "1348",
               "greek": [
                  {
                     "_BETA": "DIKASTH/S",
                     "_unicode": "δικαστής",
                     "_translit": "dikastḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik-as-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a judger",
               "kjv_def": ":--judge.",
               "_strongs": "01348"
            },
            {
               "strongs": "1349",
               "greek": [
                  {
                     "_BETA": "DI/KH",
                     "_unicode": "δίκη",
                     "_translit": "díkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1166"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "right (as self-evident), i.e. justice (the\n principle, a decision, or its execution)",
               "kjv_def": ":--judgment, punish,\n vengeance.",
               "_strongs": "01349"
            },
            {
               "strongs": "1350",
               "greek": [
                  {
                     "_BETA": "DI/KTUON",
                     "_unicode": "δίκτυον",
                     "_translit": "díktyon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dik'-too-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DI/KW",
                        "_unicode": "δίκω",
                        "_translit": "díkō"
                     }
                  ],
                  "__text": "probably from a primary verb \n (to cast);"
               },
               "strongs_def": "a seine (for\n fishing)",
               "kjv_def": ":--net.",
               "_strongs": "01350"
            },
            {
               "strongs": "1351",
               "greek": [
                  {
                     "_BETA": "DI/LOGOS",
                     "_unicode": "δίλογος",
                     "_translit": "dílogos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dil'-og-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "equivocal, i.e. telling a different\n story",
               "kjv_def": ":--double-tongued.",
               "_strongs": "01351"
            },
            {
               "strongs": "1352",
               "greek": [
                  {
                     "_BETA": "DIO/",
                     "_unicode": "διό",
                     "_translit": "dió"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-o'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "through which thing, i.e. consequently",
               "kjv_def": ":--for which\n cause, therefore, wherefore.",
               "_strongs": "01352"
            },
            {
               "strongs": "1353",
               "greek": [
                  {
                     "_BETA": "DIODEU/W",
                     "_unicode": "διοδεύω",
                     "_translit": "diodeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-od-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3593"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to travel through",
               "kjv_def": ":--go throughout, pass through.",
               "_strongs": "01353"
            },
            {
               "strongs": "1354",
               "greek": [
                  {
                     "_BETA": "*DIONU/SIOS",
                     "_unicode": "Διονύσιος",
                     "_translit": "Dionýsios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-on-oo'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*DIO/NUSOS",
                        "_unicode": "Διόνυσος",
                        "_translit": "Diónysos"
                     }
                  ],
                  "__text": "from \n (Bacchus);"
               },
               "strongs_def": "reveller; Dionysius, an Athenian",
               "kjv_def": ":--Dionysius.",
               "_strongs": "01354"
            },
            {
               "strongs": "1355",
               "greek": [
                  {
                     "_BETA": "DIO/PER",
                     "_unicode": "διόπερ",
                     "_translit": "dióper"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-op'-er"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1352"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "on which very account",
               "kjv_def": ":--wherefore.",
               "_strongs": "01355"
            },
            {
               "strongs": "1356",
               "greek": [
                  {
                     "_BETA": "DIOPETH/S",
                     "_unicode": "διοπετής",
                     "_translit": "diopetḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-op-et'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2203"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from the alternate of \n and the alternate of \n;"
               },
               "strongs_def": "sky-fallen (i.e.\n an aerolite)",
               "kjv_def": ":--which fell down from Jupiter.",
               "_strongs": "01356"
            },
            {
               "strongs": "1357",
               "greek": [
                  {
                     "_BETA": "DIO/RQWSIS",
                     "_unicode": "διόρθωσις",
                     "_translit": "diórthōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-or'-tho-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3717"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n, meaning to\n straighten thoroughly;"
               },
               "strongs_def": "rectification, i.e. (specially) the Messianic\n restauration",
               "kjv_def": ":--reformation.",
               "_strongs": "01357"
            },
            {
               "strongs": "1358",
               "greek": [
                  {
                     "_BETA": "DIORU/SSW",
                     "_unicode": "διορύσσω",
                     "_translit": "diorýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-or-oos'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3736"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to penetrate burglariously",
               "kjv_def": ":--break through (up).",
               "_strongs": "01358"
            },
            {
               "strongs": "1359",
               "greek": [
                  {
                     "_BETA": "*DIO/SKOUROI",
                     "_unicode": "Διόσκουροι",
                     "_translit": "Dióskouroi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-os'-koo-roy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2203"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2877"
                     }
                  ],
                  "__text": "from the alternate of \n and a form of the base of \n;"
               },
               "strongs_def": "sons of\n Jupiter, i.e. the twins Dioscuri",
               "kjv_def": ":--Castor and Pollux.",
               "_strongs": "01359"
            },
            {
               "strongs": "1360",
               "greek": [
                  {
                     "_BETA": "DIO/TI",
                     "_unicode": "διότι",
                     "_translit": "dióti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ot'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3754"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "on the very account that, or inasmuch as",
               "kjv_def": ":--because\n (that), for, therefore.",
               "_strongs": "01360"
            },
            {
               "strongs": "1361",
               "greek": [
                  {
                     "_BETA": "*DIOTREFH/S",
                     "_unicode": "Διοτρεφής",
                     "_translit": "Diotrephḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ot-ref-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2203"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from the alternate of \n and \n;"
               },
               "strongs_def": "Jove-nourished; Diotrephes, an\n opponent of Christianity",
               "kjv_def": ":--Diotrephes.",
               "_strongs": "01361"
            },
            {
               "strongs": "1362",
               "greek": [
                  {
                     "_BETA": "DIPLOU=S",
                     "_unicode": "διπλοῦς",
                     "_translit": "diploûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dip-looce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4119"
                     }
                  ],
                  "__text": "from \n and (probably) the base of \n;"
               },
               "strongs_def": "two-fold",
               "kjv_def": ":--double, two-fold\n more.",
               "_strongs": "01362"
            },
            {
               "strongs": "1363",
               "greek": [
                  {
                     "_BETA": "DIPLO/W",
                     "_unicode": "διπλόω",
                     "_translit": "diplóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dip-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1362"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render two-fold",
               "kjv_def": ":--double.",
               "_strongs": "01363"
            },
            {
               "strongs": "1364",
               "greek": [
                  {
                     "_BETA": "DI/S",
                     "_unicode": "δίς",
                     "_translit": "dís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dece"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1417"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "twice",
               "kjv_def": ":--again, twice.",
               "_strongs": "01364"
            },
            {
               "strongs": "1365",
               "greek": [
                  {
                     "_BETA": "DISTA/ZW",
                     "_unicode": "διστάζω",
                     "_translit": "distázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dis-tad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, to duplicate, i.e. (mentally) to waver (in\n opinion)",
               "kjv_def": ":--doubt.",
               "_strongs": "01365"
            },
            {
               "strongs": "1366",
               "greek": [
                  {
                     "_BETA": "DI/STOMOS",
                     "_unicode": "δίστομος",
                     "_translit": "dístomos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dis'-tom-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4750"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "double-edged",
               "kjv_def": ":--with two edges, two-edged.",
               "_strongs": "01366"
            },
            {
               "strongs": "1367",
               "greek": [
                  {
                     "_BETA": "DISXI/LIOI",
                     "_unicode": "δισχίλιοι",
                     "_translit": "dischílioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dis-khil'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5507"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "two thousand",
               "kjv_def": ":--two thousand.",
               "_strongs": "01367"
            },
            {
               "strongs": "1368",
               "greek": [
                  {
                     "_BETA": "DIU+LI/ZW",
                     "_unicode": "διϋλίζω",
                     "_translit": "diÿlízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-oo-lid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "U(LI/ZW",
                        "_unicode": "ὑλίζω",
                        "_translit": "hylízō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "hoo-lid'-zo"
                     }
                  ],
                  "__text": "from \n and \n \n (to filter);"
               },
               "strongs_def": "to strain out",
               "kjv_def": ":--strain\n at (probably by misprint).",
               "_strongs": "01368"
            },
            {
               "strongs": "1369",
               "greek": [
                  {
                     "_BETA": "DIXA/ZW",
                     "_unicode": "διχάζω",
                     "_translit": "dicházō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-khad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to make apart, i.e. sunder (figuratively,\n alienate)",
               "kjv_def": ":--set at variance.",
               "_strongs": "01369"
            },
            {
               "strongs": "1370",
               "greek": [
                  {
                     "_BETA": "DIXOSTASI/A",
                     "_unicode": "διχοστασία",
                     "_translit": "dichostasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-khos-tas-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4714"
                     }
                  ],
                  "__text": "from a derivative of \n and \n;"
               },
               "strongs_def": "disunion, i.e. (figuratively)\n dissension",
               "kjv_def": ":--division, sedition.",
               "_strongs": "01370"
            },
            {
               "strongs": "1371",
               "greek": [
                  {
                     "_BETA": "DIXOTOME/W",
                     "_unicode": "διχοτομέω",
                     "_translit": "dichotoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-khot-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TE/MNW",
                        "_unicode": "τέμνω",
                        "_translit": "témnō"
                     }
                  ],
                  "__text": "from a compound of a derivative of \n and a derivative of\n \n (to cut);"
               },
               "strongs_def": "to bisect, i.e. (by extension) to flog\n severely",
               "kjv_def": ":--cut asunder (in sunder).",
               "_strongs": "01371"
            },
            {
               "strongs": "1372",
               "greek": [
                  {
                     "_BETA": "DIYA/W",
                     "_unicode": "διψάω",
                     "_translit": "dipsáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dip-sah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1373"
                     }
                  ],
                  "__text": "from a variation of \n;"
               },
               "strongs_def": "to thirst for (literally or\n figuratively)",
               "kjv_def": ":--(be, be a-)thirst(-y).",
               "_strongs": "01372"
            },
            {
               "strongs": "1373",
               "greek": [
                  {
                     "_BETA": "DI/YOS",
                     "_unicode": "δίψος",
                     "_translit": "dípsos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dip'-sos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "thirst",
               "kjv_def": ":--thirst.",
               "_strongs": "01373"
            },
            {
               "strongs": "1374",
               "greek": [
                  {
                     "_BETA": "DI/YUXOS",
                     "_unicode": "δίψυχος",
                     "_translit": "dípsychos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dip'-soo-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1364"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5590"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "two-spirited, i.e. vacillating (in opinion or\n purpose)",
               "kjv_def": ":--double minded.",
               "_strongs": "01374"
            },
            {
               "strongs": "1375",
               "greek": [
                  {
                     "_BETA": "DIWGMO/S",
                     "_unicode": "διωγμός",
                     "_translit": "diōgmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-ogue-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1377"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "persecution",
               "kjv_def": ":--persecution.",
               "_strongs": "01375"
            },
            {
               "strongs": "1376",
               "greek": [
                  {
                     "_BETA": "DIW/KTHS",
                     "_unicode": "διώκτης",
                     "_translit": "diṓktēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-oke'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1377"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a persecutor",
               "kjv_def": ":--persecutor.",
               "_strongs": "01376"
            },
            {
               "strongs": "1377",
               "greek": [
                  {
                     "_BETA": "DIW/KW",
                     "_unicode": "διώκω",
                     "_translit": "diṓkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dee-o'-ko"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DI/W",
                        "_unicode": "δίω",
                        "_translit": "díō"
                     }
                  ],
                  "__text": "a prolonged (and causative) form of a primary verb \n (to flee;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1169"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1249"
                     }
                  ],
                  "__text": "compare the base of \n and \n); to pursue (literally or\n figuratively); by implication, to persecute"
               },
               "kjv_def": ":--ensue, follow (after),\n given to, (suffer) persecute(-ion), press forward.",
               "_strongs": "01377"
            },
            {
               "strongs": "1378",
               "greek": [
                  {
                     "_BETA": "DO/GMA",
                     "_unicode": "δόγμα",
                     "_translit": "dógma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dog'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1380"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a law (civil, ceremonial or\n ecclesiastical)",
               "kjv_def": ":--decree, ordinance.",
               "_strongs": "01378"
            },
            {
               "strongs": "1379",
               "greek": [
                  {
                     "_BETA": "DOGMATI/ZW",
                     "_unicode": "δογματίζω",
                     "_translit": "dogmatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dog-mat-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1378"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to prescribe by statute, i.e. (reflexively) to submit to,\n ceremonially rule",
               "kjv_def": ":--be subject to ordinances.",
               "_strongs": "01379"
            },
            {
               "strongs": "1380",
               "greek": [
                  {
                     "_BETA": "DOKE/W",
                     "_unicode": "δοκέω",
                     "_translit": "dokéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dok-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DO/KW",
                        "_unicode": "δόκω",
                        "_translit": "dókō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "dok'-o"
                     }
                  ],
                  "__text": "a prolonged form of a primary verb, \n \n (used only in an\n alternate in certain tenses;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1166"
                     }
                  ],
                  "__text": "compare the base of \n) of the same\n meaning; to think; by implication, to seem (truthfully or\n uncertainly)"
               },
               "kjv_def": ":--be accounted, (of own) please(-ure), be of reputation,\n seem (good), suppose, think, trow.",
               "_strongs": "01380"
            },
            {
               "strongs": "1381",
               "greek": [
                  {
                     "_BETA": "DOKIMA/ZW",
                     "_unicode": "δοκιμάζω",
                     "_translit": "dokimázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dok-im-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1384"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to test (literally or figuratively); by implication, to\n approve",
               "kjv_def": ":--allow, discern, examine, X like, (ap-)prove, try.",
               "_strongs": "01381"
            },
            {
               "strongs": "1382",
               "greek": [
                  {
                     "_BETA": "DOKIMH/",
                     "_unicode": "δοκιμή",
                     "_translit": "dokimḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dok-ee-may'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1384"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "test (abstractly or concretely); by\n implication, trustiness",
               "kjv_def": ":--experience(-riment), proof, trial.",
               "_strongs": "01382"
            },
            {
               "strongs": "1383",
               "greek": [
                  {
                     "_BETA": "DOKI/MION",
                     "_unicode": "δοκίμιον",
                     "_translit": "dokímion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dok-im'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1382"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a testing; by implication,\n trustworthiness",
               "kjv_def": ":--trial, trying.",
               "_strongs": "01383"
            },
            {
               "strongs": "1384",
               "greek": [
                  {
                     "_BETA": "DO/KIMOS",
                     "_unicode": "δόκιμος",
                     "_translit": "dókimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dok'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1380"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, acceptable (current after assayal), i.e.\n approved",
               "kjv_def": ":--approved, tried.",
               "_strongs": "01384"
            },
            {
               "strongs": "1385",
               "greek": [
                  {
                     "_BETA": "DOKO/S",
                     "_unicode": "δοκός",
                     "_translit": "dokós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dok-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n (through the idea of holding up);"
               },
               "strongs_def": "a stick of timber",
               "kjv_def": ":--beam.",
               "_strongs": "01385"
            },
            {
               "strongs": "1386",
               "greek": [
                  {
                     "_BETA": "DO/LIOS",
                     "_unicode": "δόλιος",
                     "_translit": "dólios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dol'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1388"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "guileful",
               "kjv_def": ":--deceitful.",
               "_strongs": "01386"
            },
            {
               "strongs": "1387",
               "greek": [
                  {
                     "_BETA": "DOLIO/W",
                     "_unicode": "δολιόω",
                     "_translit": "dolióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dol-ee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1386"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be guileful",
               "kjv_def": ":--use deceit.",
               "_strongs": "01387"
            },
            {
               "strongs": "1388",
               "greek": [
                  {
                     "_BETA": "DO/LOS",
                     "_unicode": "δόλος",
                     "_translit": "dólos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dol'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DE/LLW",
                        "_unicode": "δέλλω",
                        "_translit": "déllō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1185"
                     }
                  ],
                  "__text": "from an obsolete primary verb, \n (probably meaning to decoy;\n compare \n);"
               },
               "strongs_def": "a trick (bait), i.e. (figuratively) wile",
               "kjv_def": ":--craft,\n deceit, guile, subtilty.",
               "_strongs": "01388"
            },
            {
               "strongs": "1389",
               "greek": [
                  {
                     "_BETA": "DOLO/W",
                     "_unicode": "δολόω",
                     "_translit": "dolóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dol-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1388"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to ensnare, i.e. (figuratively) adulterate",
               "kjv_def": ":--handle\n deceitfully.",
               "_strongs": "01389"
            },
            {
               "strongs": "1390",
               "greek": [
                  {
                     "_BETA": "DO/MA",
                     "_unicode": "δόμα",
                     "_translit": "dóma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dom'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a present",
               "kjv_def": ":--gift.",
               "_strongs": "01390"
            },
            {
               "strongs": "1391",
               "greek": [
                  {
                     "_BETA": "DO/CA",
                     "_unicode": "δόξα",
                     "_translit": "dóxa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dox'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1380"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "glory (as very apparent), in a wide application\n (literal or figurative, objective or subjective)",
               "kjv_def": ":--dignity,\n glory(-ious), honour, praise, worship.",
               "_strongs": "01391"
            },
            {
               "strongs": "1392",
               "greek": [
                  {
                     "_BETA": "DOCA/ZW",
                     "_unicode": "δοξάζω",
                     "_translit": "doxázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dox-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1391"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render (or esteem) glorious (in a wide\n application)",
               "kjv_def": ":--(make) glorify(-ious), full of (have) glory, honour,\n magnify.",
               "_strongs": "01392"
            },
            {
               "strongs": "1393",
               "greek": [
                  {
                     "_BETA": "*DORKA/S",
                     "_unicode": "Δορκάς",
                     "_translit": "Dorkás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dor-kas'"
                  }
               ],
               "strongs_def": "gazelle; Dorcas, a Christian woman",
               "kjv_def": ":--Dorcas.",
               "_strongs": "01393"
            },
            {
               "strongs": "1394",
               "greek": [
                  {
                     "_BETA": "DO/SIS",
                     "_unicode": "δόσις",
                     "_translit": "dósis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dos'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a giving; by implication, (concretely) a\n gift",
               "kjv_def": ":--gift, giving.",
               "_strongs": "01394"
            },
            {
               "strongs": "1395",
               "greek": [
                  {
                     "_BETA": "DO/THS",
                     "_unicode": "δότης",
                     "_translit": "dótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a giver",
               "kjv_def": ":--giver.",
               "_strongs": "01395"
            },
            {
               "strongs": "1396",
               "greek": [
                  {
                     "_BETA": "DOULAGWGE/W",
                     "_unicode": "δουλαγωγέω",
                     "_translit": "doulagōgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo-lag-ogue-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1401"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from a presumed compound of \n and \n;"
               },
               "strongs_def": "to be a slave-driver, i.e. to\n enslave (figuratively, subdue)",
               "kjv_def": ":--bring into subjection.",
               "_strongs": "01396"
            },
            {
               "strongs": "1397",
               "greek": [
                  {
                     "_BETA": "DOULEI/A",
                     "_unicode": "δουλεία",
                     "_translit": "douleía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo-li'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1398"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "slavery (ceremonially or figuratively)",
               "kjv_def": ":--bondage.",
               "_strongs": "01397"
            },
            {
               "strongs": "1398",
               "greek": [
                  {
                     "_BETA": "DOULEU/W",
                     "_unicode": "δουλεύω",
                     "_translit": "douleúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dool-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1401"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a slave to (literal or figurative, involuntary or\n voluntary)",
               "kjv_def": ":--be in bondage, (do) serve(-ice).",
               "_strongs": "01398"
            },
            {
               "strongs": "1399",
               "greek": [
                  {
                     "_BETA": "DOU/LH",
                     "_unicode": "δούλη",
                     "_translit": "doúlē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo'-lay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1401"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a female slave (involuntarily or\n voluntarily)",
               "kjv_def": ":--handmaid(-en).",
               "_strongs": "01399"
            },
            {
               "strongs": "1400",
               "greek": [
                  {
                     "_BETA": "DOU=LON",
                     "_unicode": "δοῦλον",
                     "_translit": "doûlon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo'-lon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1401"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": "subservient",
               "kjv_def": ":--servant.",
               "_strongs": "01400"
            },
            {
               "strongs": "1401",
               "greek": [
                  {
                     "_BETA": "DOU=LOS",
                     "_unicode": "δοῦλος",
                     "_translit": "doûlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo'-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a slave (literal or figurative, involuntary or voluntary;\n frequently, therefore in a qualified sense of subjection or\n subserviency)",
               "kjv_def": ":--bond(-man), servant.",
               "_strongs": "01401"
            },
            {
               "strongs": "1402",
               "greek": [
                  {
                     "_BETA": "DOULO/W",
                     "_unicode": "δουλόω",
                     "_translit": "doulóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1401"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to enslave (literally or figuratively)",
               "kjv_def": ":--bring into (be\n under) bondage, X given, become (make) servant.",
               "_strongs": "01402"
            },
            {
               "strongs": "1403",
               "greek": [
                  {
                     "_BETA": "DOXH/",
                     "_unicode": "δοχή",
                     "_translit": "dochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dokh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a reception, i.e. convivial entertainment",
               "kjv_def": ":--feast.",
               "_strongs": "01403"
            },
            {
               "strongs": "1404",
               "greek": [
                  {
                     "_BETA": "DRA/KWN",
                     "_unicode": "δράκων",
                     "_translit": "drákōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "drak'-own"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DE/RKOMAI",
                        "_unicode": "δέρκομαι",
                        "_translit": "dérkomai"
                     }
                  ],
                  "__text": "probably from an alternate form of \n (to look);"
               },
               "strongs_def": "a fabulous kind\n of serpent (perhaps as supposed to fascinate)",
               "kjv_def": ":--dragon.",
               "_strongs": "01404"
            },
            {
               "strongs": "1405",
               "greek": [
                  {
                     "_BETA": "DRA/SSOMAI",
                     "_unicode": "δράσσομαι",
                     "_translit": "drássomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dras'-som-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1404"
                     }
                  ],
                  "__text": "perhaps akin to the base of \n (through the idea of capturing);"
               },
               "strongs_def": "to\n grasp, i.e. (figuratively) entrap",
               "kjv_def": ":--take.",
               "_strongs": "01405"
            },
            {
               "strongs": "1406",
               "greek": [
                  {
                     "_BETA": "DRAXMH/",
                     "_unicode": "δραχμή",
                     "_translit": "drachmḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "drakh-may'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1405"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a drachma or (silver) coin (as handled)",
               "kjv_def": ":--piece (of\n silver).",
               "_strongs": "01406"
            },
            {
               "strongs": "1407",
               "greek": [
                  {
                     "_BETA": "DRE/PANON",
                     "_unicode": "δρέπανον",
                     "_translit": "drépanon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "drep'-an-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DRE/PW",
                        "_unicode": "δρέπω",
                        "_translit": "drépō"
                     }
                  ],
                  "__text": "from \n (to pluck);"
               },
               "strongs_def": "a gathering hook (especially for\n harvesting)",
               "kjv_def": ":--sickle.",
               "_strongs": "01407"
            },
            {
               "strongs": "1408",
               "greek": [
                  {
                     "_BETA": "DRO/MOS",
                     "_unicode": "δρόμος",
                     "_translit": "drómos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "drom'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "a race, i.e. (figuratively)\n career",
               "kjv_def": ":--course.",
               "_strongs": "01408"
            },
            {
               "strongs": "1409",
               "greek": [
                  {
                     "_BETA": "*DROU/SILLA",
                     "_unicode": "Δρούσιλλα",
                     "_translit": "Droúsilla"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "droo'-sil-lah"
                  }
               ],
               "strongs_derivation": "a feminine diminutive of Drusus (a Roman name);",
               "strongs_def": "Drusilla, a member of\n the Herodian family",
               "kjv_def": ":--Drusilla.",
               "_strongs": "01409"
            },
            {
               "strongs": "1410",
               "greek": [
                  {
                     "_BETA": "DU/NAMAI",
                     "_unicode": "δύναμαι",
                     "_translit": "dýnamai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo'-nam-ahee"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to be able or possible",
               "kjv_def": ":--be able, can (do, +\n -not), could, may, might, be possible, be of power.",
               "_strongs": "01410"
            },
            {
               "strongs": "1411",
               "greek": [
                  {
                     "_BETA": "DU/NAMIS",
                     "_unicode": "δύναμις",
                     "_translit": "dýnamis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo'-nam-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1410"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "force (literally or figuratively); specially, miraculous\n power (usually by implication, a miracle itself)",
               "kjv_def": ":--ability, abundance,\n meaning, might(-ily, -y, -y deed), (worker of) miracle(-s), power,\n strength, violence, mighty (wonderful) work.",
               "_strongs": "01411"
            },
            {
               "strongs": "1412",
               "greek": [
                  {
                     "_BETA": "DUNAMO/W",
                     "_unicode": "δυναμόω",
                     "_translit": "dynamóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo-nam-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1411"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to enable",
               "kjv_def": ":--strengthen.",
               "_strongs": "01412"
            },
            {
               "strongs": "1413",
               "greek": [
                  {
                     "_BETA": "DUNA/STHS",
                     "_unicode": "δυνάστης",
                     "_translit": "dynástēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo-nas'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1410"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a ruler or officer",
               "kjv_def": ":--of great authority, mighty, potentate.",
               "_strongs": "01413"
            },
            {
               "strongs": "1414",
               "greek": [
                  {
                     "_BETA": "DUNATE/W",
                     "_unicode": "δυνατέω",
                     "_translit": "dynatéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo-nat-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1415"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be efficient (figuratively)",
               "kjv_def": ":--be mighty.",
               "_strongs": "01414"
            },
            {
               "strongs": "1415",
               "greek": [
                  {
                     "_BETA": "DUNATO/S",
                     "_unicode": "δυνατός",
                     "_translit": "dynatós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo-nat-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1410"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "powerful or capable (literally or figuratively); neuter\n possible",
               "kjv_def": ":--able, could, (that is) mighty (man), possible, power,\n strong.",
               "_strongs": "01415"
            },
            {
               "strongs": "1416",
               "greek": [
                  {
                     "_BETA": "DU/NW",
                     "_unicode": "δύνω",
                     "_translit": "dýnō"
                  },
                  {
                     "_BETA": "DU=MI",
                     "_unicode": "δῦμι",
                     "_translit": "dŷmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo'-no"
                  },
                  {
                     "_strongs": "doo'-mee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DU/O",
                        "_unicode": "δύο",
                        "_translit": "dýo"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "doo'-o"
                     }
                  ],
                  "__text": "prolonged forms of an obsolete primary\n      \n  \n (to sink);"
               },
               "strongs_def": "to go \"down\"",
               "kjv_def": ":--set.",
               "_strongs": "01416",
               "__text": "or"
            },
            {
               "strongs": "1417",
               "greek": [
                  {
                     "_BETA": "DU/O",
                     "_unicode": "δύο",
                     "_translit": "dýo"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo'-o"
                  }
               ],
               "strongs_derivation": "a primary numeral;",
               "strongs_def": "\"two\"",
               "kjv_def": ":--both, twain, two.",
               "_strongs": "01417"
            },
            {
               "strongs": "1418",
               "greek": [
                  {
                     "_BETA": "DUS-",
                     "_unicode": "δυσ‐",
                     "_translit": "dys-"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doos"
                  }
               ],
               "strongs_derivation": "a primary inseparable particle of uncertain derivation;",
               "strongs_def": "used only in\n composition as a prefix; hard, i.e. with difficulty",
               "kjv_def": ":--+ hard, +\n grievous, etc.",
               "_strongs": "01418"
            },
            {
               "strongs": "1419",
               "greek": [
                  {
                     "_BETA": "DUSBA/STAKTOS",
                     "_unicode": "δυσβάστακτος",
                     "_translit": "dysbástaktos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doos-bas'-tak-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1418"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "941"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "oppressive",
               "kjv_def": ":--grievous to be borne.",
               "_strongs": "01419"
            },
            {
               "strongs": "1420",
               "greek": [
                  {
                     "_BETA": "DUSENTERI/A",
                     "_unicode": "δυσεντερία",
                     "_translit": "dysentería"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doos-en-ter-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1418"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1787"
                     }
                  ],
                  "__text": "from \n and a compound of \n (meaning a bowel);"
               },
               "strongs_def": "a\n \"dysentery\"",
               "kjv_def": ":--bloody flux.",
               "_strongs": "01420"
            },
            {
               "strongs": "1421",
               "greek": [
                  {
                     "_BETA": "DUSERMH/NEUTOS",
                     "_unicode": "δυσερμήνευτος",
                     "_translit": "dysermḗneutos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doos-er-mane'-yoo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1418"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2059"
                     }
                  ],
                  "__text": "from \n and a presumed derivative of \n;"
               },
               "strongs_def": "difficult of\n explanation",
               "kjv_def": ":--hard to be uttered.",
               "_strongs": "01421"
            },
            {
               "strongs": "1422",
               "greek": [
                  {
                     "_BETA": "DU/SKOLOS",
                     "_unicode": "δύσκολος",
                     "_translit": "dýskolos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doo'-kol-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1418"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KO/LON",
                        "_unicode": "κόλον",
                        "_translit": "kólon"
                     }
                  ],
                  "__text": "from \n and \n (food);"
               },
               "strongs_def": "properly, fastidious about eating\n (peevish), i.e. (genitive case) impracticable",
               "kjv_def": ":--hard.",
               "_strongs": "01422"
            },
            {
               "strongs": "1423",
               "greek": [
                  {
                     "_BETA": "DUSKO/LWS",
                     "_unicode": "δυσκόλως",
                     "_translit": "dyskólōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doos-kol'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1422"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "impracticably",
               "kjv_def": ":--hardly.",
               "_strongs": "01423"
            },
            {
               "strongs": "1424",
               "greek": [
                  {
                     "_BETA": "DUSMH/",
                     "_unicode": "δυσμή",
                     "_translit": "dysmḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doos-may'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1416"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the sun-set, i.e. (by implication) the western\n region",
               "kjv_def": ":--west.",
               "_strongs": "01424"
            },
            {
               "strongs": "1425",
               "greek": [
                  {
                     "_BETA": "DUSNO/HTOS",
                     "_unicode": "δυσνόητος",
                     "_translit": "dysnóētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doos-no'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1418"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "difficult of perception",
               "kjv_def": ":--hard to\n be understood.",
               "_strongs": "01425"
            },
            {
               "strongs": "1426",
               "greek": [
                  {
                     "_BETA": "DUSFHMI/A",
                     "_unicode": "δυσφημία",
                     "_translit": "dysphēmía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "doos-fay-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1418"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5345"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "defamation",
               "kjv_def": ":--evil report.",
               "_strongs": "01426"
            },
            {
               "strongs": "1427",
               "greek": [
                  {
                     "_BETA": "DW/DEKA",
                     "_unicode": "δώδεκα",
                     "_translit": "dṓdeka"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do'-dek-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1417"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "two and ten, i.e. a dozen",
               "kjv_def": ":--twelve.",
               "_strongs": "01427"
            },
            {
               "strongs": "1428",
               "greek": [
                  {
                     "_BETA": "DWDE/KATOS",
                     "_unicode": "δωδέκατος",
                     "_translit": "dōdékatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do-dek'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1427"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "twelfth",
               "kjv_def": ":--twelfth.",
               "_strongs": "01428"
            },
            {
               "strongs": "1429",
               "greek": [
                  {
                     "_BETA": "DWDEKA/FULON",
                     "_unicode": "δωδεκάφυλον",
                     "_translit": "dōdekáphylon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do-dek-af'-oo-lon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1427"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5443"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the commonwealth of Israel",
               "kjv_def": ":--twelve tribes.",
               "_strongs": "01429"
            },
            {
               "strongs": "1430",
               "greek": [
                  {
                     "_BETA": "DW=MA",
                     "_unicode": "δῶμα",
                     "_translit": "dōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do'-mah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "DE/MW",
                        "_unicode": "δέμω",
                        "_translit": "démō"
                     }
                  ],
                  "__text": "from \n (to build);"
               },
               "strongs_def": "properly, an edifice, i.e. (specially) a\n roof",
               "kjv_def": ":--housetop.",
               "_strongs": "01430"
            },
            {
               "strongs": "1431",
               "greek": [
                  {
                     "_BETA": "DWREA/",
                     "_unicode": "δωρεά",
                     "_translit": "dōreá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do-reh-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1435"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a gratuity",
               "kjv_def": ":--gift.",
               "_strongs": "01431"
            },
            {
               "strongs": "1432",
               "greek": [
                  {
                     "_BETA": "DWREA/N",
                     "_unicode": "δωρεάν",
                     "_translit": "dōreán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do-reh-an'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1431"
                     }
                  ],
                  "__text": "accusative case of \n as adverb;"
               },
               "strongs_def": "gratuitously (literally or\n figuratively)",
               "kjv_def": ":--without a cause, freely, for naught, in vain.",
               "_strongs": "01432"
            },
            {
               "strongs": "1433",
               "greek": [
                  {
                     "_BETA": "DWRE/OMAI",
                     "_unicode": "δωρέομαι",
                     "_translit": "dōréomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do-reh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1435"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to bestow gratuitously",
               "kjv_def": ":--give.",
               "_strongs": "01433"
            },
            {
               "strongs": "1434",
               "greek": [
                  {
                     "_BETA": "DW/RHMA",
                     "_unicode": "δώρημα",
                     "_translit": "dṓrēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do'-ray-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1433"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a bestowment",
               "kjv_def": ":--gift.",
               "_strongs": "01434"
            },
            {
               "strongs": "1435",
               "greek": [
                  {
                     "_BETA": "DW=RON",
                     "_unicode": "δῶρον",
                     "_translit": "dōron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "do'-ron"
                  }
               ],
               "strongs_def": "a present; specially, a sacrifice",
               "kjv_def": ":--gift, offering.",
               "_strongs": "01435"
            },
            {
               "strongs": "1436",
               "greek": [
                  {
                     "_BETA": "E)/A",
                     "_unicode": "ἔα",
                     "_translit": "éa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eh'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1439"
                     }
                  ],
                  "__text": "apparent imperative of \n;"
               },
               "strongs_def": "properly, let it be, i.e. (as\n interjection) aha!",
               "kjv_def": ":--let alone.",
               "_strongs": "01436"
            },
            {
               "strongs": "1437",
               "greek": [
                  {
                     "_BETA": "E)A/N",
                     "_unicode": "ἐάν",
                     "_translit": "eán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eh-an'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "302"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a conditional particle; in case that, provided,\n etc.; often used in connection with other particles to denote\n indefiniteness or uncertainty",
               "kjv_def": ":--before, but, except, (and) if, (if)\n so, (what-, whither-)soever, though, when (-soever), whether (or), to\n whom, (who-)so(-ever).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3361"
                  }
               ],
               "_strongs": "01437",
               "__text": "See \n."
            },
            {
               "strongs": "1438",
               "greek": [
                  {
                     "_BETA": "E(AUTOU=",
                     "_unicode": "ἑαυτοῦ",
                     "_translit": "heautoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heh-ow-too'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "__text": "from a reflexive pronoun otherwise obsolete and the genitive case\n (dative case or accusative case) of \n;"
               },
               "strongs_def": "him- (her-, it-, them-, also\n (in conjunction with the personal pronoun of the other persons) my-,\n thy-, our-, your-) self (selves), etc.",
               "kjv_def": ":--alone, her (own, -self), (he)\n himself, his (own), itself, one (to) another, our (thine)\n own(-selves), + that she had, their (own, own selves), (of)\n them(-selves), they, thyself, you, your (own, own conceits, own\n selves, -selves).",
               "_strongs": "01438"
            },
            {
               "strongs": "1439",
               "greek": [
                  {
                     "_BETA": "E)A/W",
                     "_unicode": "ἐάω",
                     "_translit": "eáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eh-ah'-o"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to let be, i.e. permit or leave alone",
               "kjv_def": ":--commit,\n leave, let (alone), suffer.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1436"
                  }
               ],
               "_strongs": "01439",
               "__text": "See also \n."
            },
            {
               "strongs": "1440",
               "greek": [
                  {
                     "_BETA": "E(BDOMH/KONTA",
                     "_unicode": "ἑβδομήκοντα",
                     "_translit": "hebdomḗkonta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heb-dom-ay'-kon-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1442"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     }
                  ],
                  "__text": "from \n and a modified form of \n;"
               },
               "strongs_def": "seventy",
               "kjv_def": ":--seventy, three score\n and ten.",
               "_strongs": "01440"
            },
            {
               "strongs": "1441",
               "greek": [
                  {
                     "_BETA": "E(BDOMHKONTA/KIS",
                     "_unicode": "ἑβδομηκοντάκις",
                     "_translit": "hebdomēkontákis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heb-dom-ay-kon-tak-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1440"
                     }
                  ],
                  "__text": "multiple adverb from \n;"
               },
               "strongs_def": "seventy times",
               "kjv_def": ":--seventy times.",
               "_strongs": "01441"
            },
            {
               "strongs": "1442",
               "greek": [
                  {
                     "_BETA": "E(/BDOMOS",
                     "_unicode": "ἕβδομος",
                     "_translit": "hébdomos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heb'-dom-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2033"
                     }
                  ],
                  "__text": "ordinal from \n;"
               },
               "strongs_def": "seventh",
               "kjv_def": ":--seventh.",
               "_strongs": "01442"
            },
            {
               "strongs": "1443",
               "greek": [
                  {
                     "_BETA": "*)EBE/R",
                     "_unicode": "Ἐβέρ",
                     "_translit": "Ebér"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eb-er'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05677"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Eber, a patriarch",
               "kjv_def": ":--Eber.",
               "_strongs": "01443"
            },
            {
               "strongs": "1444",
               "greek": [
                  {
                     "_BETA": "*(EBRAI+KO/S",
                     "_unicode": "Ἑβραϊκός",
                     "_translit": "Hebraïkós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heb-rah-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1443"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Hebraic or the Jewish language",
               "kjv_def": ":--Hebrew.",
               "_strongs": "01444"
            },
            {
               "strongs": "1445",
               "greek": [
                  {
                     "_BETA": "*(EBRAI=OS",
                     "_unicode": "Ἑβραῖος",
                     "_translit": "Hebraîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heb-rah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1443"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Hebræan (i.e. Hebrew) or Jew",
               "kjv_def": ":--Hebrew.",
               "_strongs": "01445"
            },
            {
               "strongs": "1446",
               "greek": [
                  {
                     "_BETA": "*(EBRAI/+S",
                     "_unicode": "Ἑβραΐς",
                     "_translit": "Hebraḯs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heb-rah-is'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1443"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the Hebraistic (Hebrew) or Jewish (Chaldee)\n language",
               "kjv_def": ":--Hebrew.",
               "_strongs": "01446"
            },
            {
               "strongs": "1447",
               "greek": [
                  {
                     "_BETA": "*(EBRAI+STI/",
                     "_unicode": "Ἑβραϊστί",
                     "_translit": "Hebraïstí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heb-rah-is-tee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1446"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "Hebraistically or in the Jewish (Chaldee)\n language",
               "kjv_def": ":--in (the) Hebrew (tongue).",
               "_strongs": "01447"
            },
            {
               "strongs": "1448",
               "greek": [
                  {
                     "_BETA": "E)GGI/ZW",
                     "_unicode": "ἐγγίζω",
                     "_translit": "engízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1451"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make near, i.e. (reflexively) approach",
               "kjv_def": ":--approach, be at\n hand, come (draw) near, be (come, draw) nigh.",
               "_strongs": "01448"
            },
            {
               "strongs": "1449",
               "greek": [
                  {
                     "_BETA": "E)GGRA/FW",
                     "_unicode": "ἐγγράφω",
                     "_translit": "engráphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-graf'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to \"engrave\", i.e. inscribe",
               "kjv_def": ":--write (in).",
               "_strongs": "01449"
            },
            {
               "strongs": "1450",
               "greek": [
                  {
                     "_BETA": "E)/GGUOS",
                     "_unicode": "ἔγγυος",
                     "_translit": "éngyos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng'-goo-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "GUI=ON",
                        "_unicode": "γυῖον",
                        "_translit": "guîon"
                     }
                  ],
                  "__text": "from \n and \n (a limb);"
               },
               "strongs_def": "pledged (as if articulated by a member),\n i.e. a bondsman",
               "kjv_def": ":--surety.",
               "_strongs": "01450"
            },
            {
               "strongs": "1451",
               "greek": [
                  {
                     "_BETA": "E)GGU/S",
                     "_unicode": "ἐγγύς",
                     "_translit": "engýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-goos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A)/GXW",
                        "_unicode": "ἄγχω",
                        "_translit": "ánchō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "__text": "from a primary verb \n (to squeeze or throttle; akin to the base of\n \n);"
               },
               "strongs_def": "near (literally or figuratively, of place or time)",
               "kjv_def": ":--from , at\n hand, near, nigh (at hand, unto), ready.",
               "_strongs": "01451"
            },
            {
               "strongs": "1452",
               "greek": [
                  {
                     "_BETA": "E)GGU/TERON",
                     "_unicode": "ἐγγύτερον",
                     "_translit": "engýteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-goo'-ter-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1451"
                     }
                  ],
                  "__text": "neuter of the comparative of \n;"
               },
               "strongs_def": "nearer",
               "kjv_def": ":--nearer.",
               "_strongs": "01452"
            },
            {
               "strongs": "1453",
               "greek": [
                  {
                     "_BETA": "E)GEI/RW",
                     "_unicode": "ἐγείρω",
                     "_translit": "egeírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eg-i'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "__text": "probably akin to the base of \n (through the idea of collecting one's\n faculties);"
               },
               "strongs_def": "to waken (transitively or intransitively), i.e. rouse\n (literally, from sleep, from sitting or lying, from disease, from\n death; or figuratively, from obscurity, inactivity, ruins,\n nonexistence)",
               "kjv_def": ":--awake, lift (up), raise (again, up), rear up, (a-)rise\n (again, up), stand, take up.",
               "_strongs": "01453"
            },
            {
               "strongs": "1454",
               "greek": [
                  {
                     "_BETA": "E)/GERSIS",
                     "_unicode": "ἔγερσις",
                     "_translit": "égersis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eg'-er-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1453"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a resurgence (from death)",
               "kjv_def": ":--resurrection.",
               "_strongs": "01454"
            },
            {
               "strongs": "1455",
               "greek": [
                  {
                     "_BETA": "E)GKA/QETOS",
                     "_unicode": "ἐγκάθετος",
                     "_translit": "enkáthetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kath'-et-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2524"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "subinduced, i.e. surreptitiously\n suborned as a lier-in-wait",
               "kjv_def": ":--spy.",
               "_strongs": "01455"
            },
            {
               "strongs": "1456",
               "greek": [
                  {
                     "_BETA": "E)GKAI/NIA",
                     "_unicode": "ἐγκαίνια",
                     "_translit": "enkaínia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kah'-ee-nee-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2537"
                     }
                  ],
                  "__text": "neuter plural of a presumed compound from \n and \n;"
               },
               "strongs_def": "innovatives,\n i.e. (specially) renewal (of religious services after the Antiochian\n interruption)",
               "kjv_def": ":--dedication.",
               "_strongs": "01456"
            },
            {
               "strongs": "1457",
               "greek": [
                  {
                     "_BETA": "E)GKAINI/ZW",
                     "_unicode": "ἐγκαινίζω",
                     "_translit": "enkainízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kahee-nid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1456"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to renew, i.e. inaugurate",
               "kjv_def": ":--consecrate, dedicate.",
               "_strongs": "01457"
            },
            {
               "strongs": "1458",
               "greek": [
                  {
                     "_BETA": "E)GKALE/W",
                     "_unicode": "ἐγκαλέω",
                     "_translit": "enkaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to call in (as a debt or demand), i.e. bring to\n account (charge, criminate, etc.)",
               "kjv_def": ":--accuse, call in question, implead,\n lay to the charge.",
               "_strongs": "01458"
            },
            {
               "strongs": "1459",
               "greek": [
                  {
                     "_BETA": "E)GKATALEI/PW",
                     "_unicode": "ἐγκαταλείπω",
                     "_translit": "enkataleípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kat-al-i'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2641"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to leave behind in some place, i.e. (in a good\n sense) let remain over, or (in a bad sense) to desert",
               "kjv_def": ":--forsake,\n leave.",
               "_strongs": "01459"
            },
            {
               "strongs": "1460",
               "greek": [
                  {
                     "_BETA": "E)GKATOIKE/W",
                     "_unicode": "ἐγκατοικέω",
                     "_translit": "enkatoikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kat-oy-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2730"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to settle down in a place, i.e. reside",
               "kjv_def": ":--dwell\n among.",
               "_strongs": "01460"
            },
            {
               "strongs": "1461",
               "greek": [
                  {
                     "_BETA": "E)GKENTRI/ZW",
                     "_unicode": "ἐγκεντρίζω",
                     "_translit": "enkentrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-ken-trid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2759"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to prick in, i.e. ingraft",
               "kjv_def": ":--graff\n in(-to).",
               "_strongs": "01461"
            },
            {
               "strongs": "1462",
               "greek": [
                  {
                     "_BETA": "E)/GKLHMA",
                     "_unicode": "ἔγκλημα",
                     "_translit": "énklēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng'-klay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1458"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an accusation, i.e. offence alleged",
               "kjv_def": ":--crime laid against,\n laid to charge.",
               "_strongs": "01462"
            },
            {
               "strongs": "1463",
               "greek": [
                  {
                     "_BETA": "E)GKOMBO/OMAI",
                     "_unicode": "ἐγκομβόομαι",
                     "_translit": "enkombóomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kom-bo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KOMBO/W",
                        "_unicode": "κομβόω",
                        "_translit": "kombóō"
                     }
                  ],
                  "__text": "middle voice from \n and \n (to gird);"
               },
               "strongs_def": "to engirdle oneself (for\n labor), i.e. figuratively (the apron as being a badge of servitude) to\n wear (in token of mutual deference)",
               "kjv_def": ":--be clothed with.",
               "_strongs": "01463"
            },
            {
               "strongs": "1464",
               "greek": [
                  {
                     "_BETA": "E)GKOPH/",
                     "_unicode": "ἐγκοπή",
                     "_translit": "enkopḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kop-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1465"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a hindrance",
               "kjv_def": ":--X hinder.",
               "_strongs": "01464"
            },
            {
               "strongs": "1465",
               "greek": [
                  {
                     "_BETA": "E)GKO/PTW",
                     "_unicode": "ἐγκόπτω",
                     "_translit": "enkóptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to cut into, i.e. (figuratively) impede,\n detain",
               "kjv_def": ":--hinder, be tedious unto.",
               "_strongs": "01465"
            },
            {
               "strongs": "1466",
               "greek": [
                  {
                     "_BETA": "E)GKRA/TEIA",
                     "_unicode": "ἐγκράτεια",
                     "_translit": "enkráteia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-krat'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1468"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "self-control (especially continence)",
               "kjv_def": ":--temperance.",
               "_strongs": "01466"
            },
            {
               "strongs": "1467",
               "greek": [
                  {
                     "_BETA": "E)GKRATEU/OMAI",
                     "_unicode": "ἐγκρατεύομαι",
                     "_translit": "enkrateúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-krat-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1468"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to exercise self-restraint (in diet and\n chastity)",
               "kjv_def": ":--can(-not) contain, be temperate.",
               "_strongs": "01467"
            },
            {
               "strongs": "1468",
               "greek": [
                  {
                     "_BETA": "E)GKRATH/S",
                     "_unicode": "ἐγκρατής",
                     "_translit": "enkratḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-krat-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "strong in a thing (masterful), i.e. (figuratively\n and reflexively) self-controlled (in appetite, etc.)",
               "kjv_def": ":--temperate.",
               "_strongs": "01468"
            },
            {
               "strongs": "1469",
               "greek": [
                  {
                     "_BETA": "E)GKRI/NW",
                     "_unicode": "ἐγκρίνω",
                     "_translit": "enkrínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kree'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to judge in, i.e. count among",
               "kjv_def": ":--make of the\n number.",
               "_strongs": "01469"
            },
            {
               "strongs": "1470",
               "greek": [
                  {
                     "_BETA": "E)GKRU/PTW",
                     "_unicode": "ἐγκρύπτω",
                     "_translit": "enkrýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-kroop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2928"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to conceal in, i.e. incorporate with",
               "kjv_def": ":--hid in.",
               "_strongs": "01470"
            },
            {
               "strongs": "1471",
               "greek": [
                  {
                     "_BETA": "E)/GKUOS",
                     "_unicode": "ἔγκυος",
                     "_translit": "énkyos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng'-koo-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2949"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "swelling inside, i.e. pregnant",
               "kjv_def": ":--great\n with child.",
               "_strongs": "01471"
            },
            {
               "strongs": "1472",
               "greek": [
                  {
                     "_BETA": "E)GXRI/W",
                     "_unicode": "ἐγχρίω",
                     "_translit": "enchríō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eng-khree'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5548"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rub in (oil), i.e. besmear",
               "kjv_def": ":--anoint.",
               "_strongs": "01472"
            },
            {
               "strongs": "1473",
               "greek": [
                  {
                     "_BETA": "E)GW/",
                     "_unicode": "ἐγώ",
                     "_translit": "egṓ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eg-o'"
                  }
               ],
               "strongs_derivation": "a primary pronoun of the first person I (only expressed when\n emphatic)",
               "kjv_def": ":--I, me.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1691"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1698"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1700"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2248"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2249"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2254"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2257"
                  }
               ],
               "_strongs": "01473",
               "__text": "For the other cases and the plural see \n, \n,\n \n, \n, \n, \n, \n, etc."
            },
            {
               "strongs": "1474",
               "greek": [
                  {
                     "_BETA": "E)DAFI/ZW",
                     "_unicode": "ἐδαφίζω",
                     "_translit": "edaphízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ed-af-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1475"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to raze",
               "kjv_def": ":--lay even with the ground.",
               "_strongs": "01474"
            },
            {
               "strongs": "1475",
               "greek": [
                  {
                     "_BETA": "E)/DAFOS",
                     "_unicode": "ἔδαφος",
                     "_translit": "édaphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ed'-af-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a basis (bottom), i.e. the soil",
               "kjv_def": ":--ground.",
               "_strongs": "01475"
            },
            {
               "strongs": "1476",
               "greek": [
                  {
                     "_BETA": "E(DRAI=OS",
                     "_unicode": "ἑδραῖος",
                     "_translit": "hedraîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hed-rah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E(/ZOMAI",
                        "_unicode": "ἕζομαι",
                        "_translit": "hézomai"
                     }
                  ],
                  "__text": "from a derivative of \n (to sit);"
               },
               "strongs_def": "sedentary, i.e. (by\n implication) immovable",
               "kjv_def": ":--settled, stedfast.",
               "_strongs": "01476"
            },
            {
               "strongs": "1477",
               "greek": [
                  {
                     "_BETA": "E(DRAI/WMA",
                     "_unicode": "ἑδραίωμα",
                     "_translit": "hedraíōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hed-rah'-yo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a support, i.e. (figuratively)\n basis",
               "kjv_def": ":--ground.",
               "_strongs": "01477"
            },
            {
               "strongs": "1478",
               "greek": [
                  {
                     "_BETA": "*)EZEKI/AS",
                     "_unicode": "Ἐζεκίας",
                     "_translit": "Ezekías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ed-zek-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02396"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Ezekias (i.e. Hezekeiah), an\n Israelite",
               "kjv_def": ":--Ezekias.",
               "_strongs": "01478"
            },
            {
               "strongs": "1479",
               "greek": [
                  {
                     "_BETA": "E)QELOQRHSKEI/A",
                     "_unicode": "ἐθελοθρησκεία",
                     "_translit": "ethelothrēskeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eth-el-oth-race-ki'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2309"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2356"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "voluntary (arbitrary and unwarranted) piety, i.e.\n sanctimony",
               "kjv_def": ":--will worship.",
               "_strongs": "01479"
            },
            {
               "strongs": "1480",
               "greek": [
                  {
                     "_BETA": "E)QI/ZW",
                     "_unicode": "ἐθίζω",
                     "_translit": "ethízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eth-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1485"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to accustom, i.e. (neuter passive participle)\n customary",
               "kjv_def": ":--custom.",
               "_strongs": "01480"
            },
            {
               "strongs": "1481",
               "greek": [
                  {
                     "_BETA": "E)QNA/RXHS",
                     "_unicode": "ἐθνάρχης",
                     "_translit": "ethnárchēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eth-nar'-khace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1484"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "746"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the governor (not king) of a district",
               "kjv_def": ":--ethnarch.",
               "_strongs": "01481"
            },
            {
               "strongs": "1482",
               "greek": [
                  {
                     "_BETA": "E)QNIKO/S",
                     "_unicode": "ἐθνικός",
                     "_translit": "ethnikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eth-nee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1484"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "national (\"ethnic\"), i.e. (specially) a Gentile",
               "kjv_def": ":--heathen\n (man).",
               "_strongs": "01482"
            },
            {
               "strongs": "1483",
               "greek": [
                  {
                     "_BETA": "E)QNIKW=S",
                     "_unicode": "ἐθνικῶς",
                     "_translit": "ethnikōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eth-nee-koce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1482"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "as a Gentile",
               "kjv_def": ":--after the manner of Gentiles.",
               "_strongs": "01483"
            },
            {
               "strongs": "1484",
               "greek": [
                  {
                     "_BETA": "E)/QNOS",
                     "_unicode": "ἔθνος",
                     "_translit": "éthnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eth'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1486"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "a race (as of the same habit), i.e. a tribe;\n specially, a foreign (non-Jewish) one (usually, by implication,\n pagan)",
               "kjv_def": ":--Gentile, heathen, nation, people.",
               "_strongs": "01484"
            },
            {
               "strongs": "1485",
               "greek": [
                  {
                     "_BETA": "E)/QOS",
                     "_unicode": "ἔθος",
                     "_translit": "éthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eth'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1486"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a usage (prescribed by habit or law)",
               "kjv_def": ":--custom, manner, be\n wont.",
               "_strongs": "01485"
            },
            {
               "strongs": "1486",
               "greek": [
                  {
                     "_BETA": "E)/QW",
                     "_unicode": "ἔθω",
                     "_translit": "éthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eth'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to be used (by habit or conventionality); neuter\n perfect participle usage",
               "kjv_def": ":--be custom (manner, wont).",
               "_strongs": "01486"
            },
            {
               "strongs": "1487",
               "greek": [
                  {
                     "_BETA": "EI)",
                     "_unicode": "εἰ",
                     "_translit": "ei"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i"
                  }
               ],
               "strongs_derivation": "a primary particle of conditionality;",
               "strongs_def": "if, whether, that,\n etc.",
               "kjv_def": ":--forasmuch as, if, that, (al-)though, whether.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1489"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1490"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1499"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1508"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1509"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1512"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1513"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1536"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1537"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1437"
                  }
               ],
               "_strongs": "01487",
               "__text": "Often used in\n connection or composition with other particles, especially as in \n,\n \n, \n, \n, \n, \n, \n, \n, \n. See also \n."
            },
            {
               "strongs": "1488",
               "greek": [
                  {
                     "_BETA": "EI)=",
                     "_unicode": "εἶ",
                     "_translit": "eî"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "second person singular present of \n;"
               },
               "strongs_def": "thou art",
               "kjv_def": ":--art, be.",
               "_strongs": "01488"
            },
            {
               "strongs": "1489",
               "greek": [
                  {
                     "_BETA": "EI)/GE",
                     "_unicode": "εἴγε",
                     "_translit": "eíge"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-gheh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1065"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "if indeed, seeing that, unless, (with negative)\n otherwise",
               "kjv_def": ":--if (so be that, yet).",
               "_strongs": "01489"
            },
            {
               "strongs": "1490",
               "greek": [
                  {
                     "_BETA": "EI) DE\\ MH/[1GE]1",
                     "_unicode": "εἰ δὲ μή(γε)",
                     "_translit": "ei dè mḗ(ge)"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i deh may'-(gheh)"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1161"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1065"
                     }
                  ],
                  "__text": "from \n, \n, and \n (sometimes with \n added);"
               },
               "strongs_def": "but if\n not",
               "kjv_def": ":--(or) else, if (not, otherwise), otherwise.",
               "_strongs": "01490"
            },
            {
               "strongs": "1491",
               "greek": [
                  {
                     "_BETA": "EI)=DOS",
                     "_unicode": "εἶδος",
                     "_translit": "eîdos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-dos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a view, i.e. form (literally or figuratively)",
               "kjv_def": ":--appearance,\n fashion, shape, sight.",
               "_strongs": "01491"
            },
            {
               "strongs": "1492",
               "greek": [
                  {
                     "_BETA": "EI)/DW",
                     "_unicode": "εἴδω",
                     "_translit": "eídō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-do"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "used only in certain past tenses, the others being\n borrowed from the equivalent \n and \n; properly, to see\n (literally or figuratively); by implication, (in the perfect tense\n only) to know"
               },
               "kjv_def": ":--be aware, behold, X can (+ not tell), consider, (have)\n know(-ledge), look (on), perceive, see, be sure, tell, understand,\n wish, wot.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3700"
                  }
               ],
               "_strongs": "01492",
               "__text": "Compare \n."
            },
            {
               "strongs": "1493",
               "greek": [
                  {
                     "_BETA": "EI)DWLEI=ON",
                     "_unicode": "εἰδωλεῖον",
                     "_translit": "eidōleîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-do-li'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1497"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "an image-fane",
               "kjv_def": ":--idol's\n temple.",
               "_strongs": "01493"
            },
            {
               "strongs": "1494",
               "greek": [
                  {
                     "_BETA": "EI)DWLO/QUTON",
                     "_unicode": "εἰδωλόθυτον",
                     "_translit": "eidōlóthyton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-do-loth'-oo-ton"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1497"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2380"
                     }
                  ],
                  "__text": "neuter of a compound of \n and a presumed derivative of \n;"
               },
               "strongs_def": "an\n image-sacrifice, i.e. part of an idolatrous offering",
               "kjv_def": ":--(meat, thing\n that is) offered (in sacrifice, sacrificed) to (unto) idols.",
               "_strongs": "01494"
            },
            {
               "strongs": "1495",
               "greek": [
                  {
                     "_BETA": "EI)DWLOLATREI/A",
                     "_unicode": "εἰδωλολατρεία",
                     "_translit": "eidōlolatreía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-do-lol-at-ri'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1497"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2999"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "image-worship (literally or\n figuratively)",
               "kjv_def": ":--idolatry.",
               "_strongs": "01495"
            },
            {
               "strongs": "1496",
               "greek": [
                  {
                     "_BETA": "EI)DWLOLA/TRHS",
                     "_unicode": "εἰδωλολάτρης",
                     "_translit": "eidōlolátrēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-do-lol-at'-race"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1497"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3000"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "an image- (servant or) worshipper\n (literally or figuratively)",
               "kjv_def": ":--idolater.",
               "_strongs": "01496"
            },
            {
               "strongs": "1497",
               "greek": [
                  {
                     "_BETA": "EI)/DWLON",
                     "_unicode": "εἴδωλον",
                     "_translit": "eídōlon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-do-lon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1491"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an image (i.e. for worship); by implication, a heathen god,\n or (plural) the worship of such",
               "kjv_def": ":--idol.",
               "_strongs": "01497"
            },
            {
               "strongs": "1498",
               "greek": [
                  {
                     "_BETA": "EI)/HN",
                     "_unicode": "εἴην",
                     "_translit": "eíēn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-ane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "optative (i.e. English subjunctive) present of \n (including the\n other person);"
               },
               "strongs_def": "might (could, would, or should) be",
               "kjv_def": ":--mean, + perish,\n should be, was, were.",
               "_strongs": "01498"
            },
            {
               "strongs": "1499",
               "greek": [
                  {
                     "_BETA": "EI) KAI/",
                     "_unicode": "εἰ καί",
                     "_translit": "ei kaí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i kahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "if also (or even)",
               "kjv_def": ":--if (that), though.",
               "_strongs": "01499"
            },
            {
               "strongs": "1500",
               "greek": [
                  {
                     "_BETA": "EI)KH=",
                     "_unicode": "εἰκῆ",
                     "_translit": "eikē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-kay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1502"
                     }
                  ],
                  "__text": "probably from \n (through the idea of failure);"
               },
               "strongs_def": "idly, i.e. without\n reason (or effect)",
               "kjv_def": ":--without a cause, (in) vain(-ly).",
               "_strongs": "01500"
            },
            {
               "strongs": "1501",
               "greek": [
                  {
                     "_BETA": "EI)/KOSI",
                     "_unicode": "εἴκοσι",
                     "_translit": "eíkosi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-kos-ee"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a score",
               "kjv_def": ":--twenty.",
               "_strongs": "01501"
            },
            {
               "strongs": "1502",
               "greek": [
                  {
                     "_BETA": "EI)/KW",
                     "_unicode": "εἴκω",
                     "_translit": "eíkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-ko"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "properly, to be weak, i.e. yield",
               "kjv_def": ":--give\n place.",
               "_strongs": "01502"
            },
            {
               "strongs": "1503",
               "greek": [
                  {
                     "_BETA": "EI)/KW",
                     "_unicode": "εἴκω",
                     "_translit": "eíkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1502"
                     }
                  ],
                  "__text": "apparently a primary verb (perhaps akin to \n through the idea of\n faintness as a copy);"
               },
               "strongs_def": "to resemble",
               "kjv_def": ":--be like.",
               "_strongs": "01503"
            },
            {
               "strongs": "1504",
               "greek": [
                  {
                     "_BETA": "EI)KW/N",
                     "_unicode": "εἰκών",
                     "_translit": "eikṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-kone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1503"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a likeness, i.e. (literally) statue, profile, or\n (figuratively) representation, resemblance",
               "kjv_def": ":--image.",
               "_strongs": "01504"
            },
            {
               "strongs": "1505",
               "greek": [
                  {
                     "_BETA": "EI)LIKRI/NEIA",
                     "_unicode": "εἰλικρίνεια",
                     "_translit": "eilikríneia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-lik-ree'-ni-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1506"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "clearness, i.e. (by implication) purity\n (figuratively)",
               "kjv_def": ":--sincerity.",
               "_strongs": "01505"
            },
            {
               "strongs": "1506",
               "greek": [
                  {
                     "_BETA": "EI)LIKRINH/S",
                     "_unicode": "εἰλικρινής",
                     "_translit": "eilikrinḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-lik-ree-nace'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "EI(/LH",
                        "_unicode": "εἵλη",
                        "_translit": "heílē"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n (the sun's ray) and \n;"
               },
               "strongs_def": "judged by sunlight, i.e. tested\n as genuine (figuratively)",
               "kjv_def": ":--pure, sincere.",
               "_strongs": "01506"
            },
            {
               "strongs": "1507",
               "greek": [
                  {
                     "_BETA": "EI(LI/SSW",
                     "_unicode": "εἱλίσσω",
                     "_translit": "heilíssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hi-lis'-so"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "EI(/LW",
                        "_unicode": "εἵλω",
                        "_translit": "heílō"
                     }
                  ],
                  "__text": "a prolonged form of a primary but defective verb \n (of the same\n meaning);"
               },
               "strongs_def": "to coil or wrap",
               "kjv_def": ":--roll together.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1667"
                  }
               ],
               "_strongs": "01507",
               "__text": "See also \n."
            },
            {
               "strongs": "1508",
               "greek": [
                  {
                     "_BETA": "EI) MH/",
                     "_unicode": "εἰ μή",
                     "_translit": "ei mḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "if not",
               "kjv_def": ":--but, except (that), if not, more than,\n save (only) that, saving, till.",
               "_strongs": "01508"
            },
            {
               "strongs": "1509",
               "greek": [
                  {
                     "_BETA": "EI) MH/ TI",
                     "_unicode": "εἰ μή τι",
                     "_translit": "ei mḗ ti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i may tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1508"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5100"
                     }
                  ],
                  "__text": "from \n and the neuter of \n;"
               },
               "strongs_def": "if not somewhat",
               "kjv_def": ":--except.",
               "_strongs": "01509"
            },
            {
               "strongs": "1510",
               "greek": [
                  {
                     "_BETA": "EI)MI/",
                     "_unicode": "εἰμί",
                     "_translit": "eimí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-mee'"
                  }
               ],
               "strongs_derivation": "the first person singular present indicative; a prolonged form of a\n primary and defective verb;",
               "strongs_def": "I exist (used only when emphatic)",
               "kjv_def": ":--am,\n have been, X it is I, was.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1488"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1498"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1511"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "1526"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2258"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2071"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2070"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2075"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2076"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2771"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2468"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "5600"
                  }
               ],
               "_strongs": "01510",
               "__text": "See also \n, \n, \n, \n, \n,\n \n, \n, \n, \n, \n, \n, \n."
            },
            {
               "strongs": "1511",
               "greek": [
                  {
                     "_BETA": "EI)=NAI",
                     "_unicode": "εἶναι",
                     "_translit": "eînai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-nahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "present infinitive from \n;"
               },
               "strongs_def": "to exist",
               "kjv_def": ":--am, was.",
               "_strongs": "01511",
               "__text": "come, is, X lust\n after, X please well, there is, to be, was."
            },
            {
               "strongs": "1512",
               "greek": [
                  {
                     "_BETA": "EI)/ PER",
                     "_unicode": "εἴ περ",
                     "_translit": "eí per"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i per"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "if perhaps",
               "kjv_def": ":--if so be (that), seeing, though.",
               "_strongs": "01512"
            },
            {
               "strongs": "1513",
               "greek": [
                  {
                     "_BETA": "EI)/ PWS",
                     "_unicode": "εἴ πως",
                     "_translit": "eí pōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i poce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4458"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "if somehow",
               "kjv_def": ":--if by any means.",
               "_strongs": "01513"
            },
            {
               "strongs": "1514",
               "greek": [
                  {
                     "_BETA": "EI)RHNEU/W",
                     "_unicode": "εἰρηνεύω",
                     "_translit": "eirēneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-rane-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1515"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be (act) peaceful",
               "kjv_def": ":--be at (have, live in) peace, live\n peaceably.",
               "_strongs": "01514"
            },
            {
               "strongs": "1515",
               "greek": [
                  {
                     "_BETA": "EI)RH/NH",
                     "_unicode": "εἰρήνη",
                     "_translit": "eirḗnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-ray'-nay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "EI)/RW",
                        "_unicode": "εἴρω",
                        "_translit": "eírō"
                     }
                  ],
                  "__text": "probably from a primary verb \n (to join);"
               },
               "strongs_def": "peace (literally or\n figuratively); by implication, prosperity",
               "kjv_def": ":--one, peace, quietness,\n rest, + set at one again.",
               "_strongs": "01515"
            },
            {
               "strongs": "1516",
               "greek": [
                  {
                     "_BETA": "EI)RHNIKO/S",
                     "_unicode": "εἰρηνικός",
                     "_translit": "eirēnikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-ray-nee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1515"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pacific; by implication, salutary",
               "kjv_def": ":--peaceable.",
               "_strongs": "01516"
            },
            {
               "strongs": "1517",
               "greek": [
                  {
                     "_BETA": "EI)RHNOPOIE/W",
                     "_unicode": "εἰρηνοποιέω",
                     "_translit": "eirēnopoiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-ray-nop-oy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1518"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a peace-maker, i.e. (figuratively) to\n harmonize",
               "kjv_def": ":--make peace.",
               "_strongs": "01517"
            },
            {
               "strongs": "1518",
               "greek": [
                  {
                     "_BETA": "EI)RHNOPOIO/S",
                     "_unicode": "εἰρηνοποιός",
                     "_translit": "eirēnopoiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-ray-nop-oy-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1515"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "pacificatory, i.e. (subjectively)\n peaceable",
               "kjv_def": ":--peacemaker.",
               "_strongs": "01518"
            },
            {
               "strongs": "1519",
               "greek": [
                  {
                     "_BETA": "EI)S",
                     "_unicode": "εἰς",
                     "_translit": "eis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice"
                  }
               ],
               "strongs_derivation": "a primary preposition;",
               "strongs_def": "to or into (indicating the point reached or\n entered), of place, time, or (figuratively) purpose (result, etc.);\n also in adverbial phrases",
               "kjv_def": ":--(abundant-)ly, against, among, as, at,\n (back-)ward, before, by, concerning, + continual, + far more\n exceeding, for (intent, purpose), fore,\n + forth, in (among, at, unto, -so much that, -to), to the\n intent that, + of one mind, + never, of, (up-)on, + perish, + set at\n one again, (so) that, therefore(-unto), throughout, til, to (be, the\n end, -ward), (here-)until(-to), …ward, (where-)fore, with.",
               "_strongs": "01519",
               "__text": "Often\n used in composition with the same general import, but only with verbs\n (etc.) expressing motion (literally or figuratively)."
            },
            {
               "strongs": "1520",
               "greek": [
                  {
                     "_BETA": "EI(=S",
                     "_unicode": "εἷς",
                     "_translit": "heîs"
                  },
                  {
                     "_BETA": "E(/N",
                     "_unicode": "ἕν",
                     "_translit": "hén"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hice"
                  }
               ],
               "strongs_derivation": "a primary numeral;",
               "strongs_def": "one",
               "kjv_def": ":--a(-n, -ny,\n certain), + abundantly, man, one (another), only, other, some.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1527"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3367"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3391"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3762"
                  }
               ],
               "_strongs": "01520",
               "__text": "(including the neuter (etc.) \n);\n\n \n See\n also \n, \n, \n, \n."
            },
            {
               "strongs": "1521",
               "greek": [
                  {
                     "_BETA": "EI)SA/GW",
                     "_unicode": "εἰσάγω",
                     "_translit": "eiságō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to introduce (literally or figuratively)",
               "kjv_def": ":--bring\n in(-to), (+ was to) lead into.",
               "_strongs": "01521"
            },
            {
               "strongs": "1522",
               "greek": [
                  {
                     "_BETA": "EI)SAKOU/W",
                     "_unicode": "εἰσακούω",
                     "_translit": "eisakoúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-ak-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "191"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to listen to",
               "kjv_def": ":--hear.",
               "_strongs": "01522"
            },
            {
               "strongs": "1523",
               "greek": [
                  {
                     "_BETA": "EI)SDE/XOMAI",
                     "_unicode": "εἰσδέχομαι",
                     "_translit": "eisdéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-dekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take into one's favor",
               "kjv_def": ":--receive.",
               "_strongs": "01523"
            },
            {
               "strongs": "1524",
               "greek": [
                  {
                     "_BETA": "EI)/SEIMI",
                     "_unicode": "εἴσειμι",
                     "_translit": "eíseimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "from \n and \n (to go);"
               },
               "strongs_def": "to enter",
               "kjv_def": ":--enter (go) into.",
               "_strongs": "01524"
            },
            {
               "strongs": "1525",
               "greek": [
                  {
                     "_BETA": "EI)SE/RXOMAI",
                     "_unicode": "εἰσέρχομαι",
                     "_translit": "eisérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to enter (literally or figuratively)",
               "kjv_def": ":--X arise,\n come (in, into), enter in(-to), go in (through).",
               "_strongs": "01525"
            },
            {
               "strongs": "1526",
               "greek": [
                  {
                     "_BETA": "EI)SI/",
                     "_unicode": "εἰσί",
                     "_translit": "eisí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i-see'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "3rd person plural present indicative of \n;"
               },
               "strongs_def": "they are",
               "kjv_def": ":--agree, are,\n be, dure, X is, were.",
               "_strongs": "01526"
            },
            {
               "strongs": "1527",
               "greek": [
                  {
                     "_BETA": "EI(=S KAQ' EI(=S",
                     "_unicode": "εἷς καθ’ εἷς",
                     "_translit": "heîs kath’ heîs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hice kath hice"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1520"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "__text": "from \n repeated with \n inserted;"
               },
               "strongs_def": "severally",
               "kjv_def": ":--one by one.",
               "_strongs": "01527"
            },
            {
               "strongs": "1528",
               "greek": [
                  {
                     "_BETA": "EI)SKALE/W",
                     "_unicode": "εἰσκαλέω",
                     "_translit": "eiskaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-kal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to invite in",
               "kjv_def": ":--call in.",
               "_strongs": "01528"
            },
            {
               "strongs": "1529",
               "greek": [
                  {
                     "_BETA": "EI)/SODOS",
                     "_unicode": "εἴσοδος",
                     "_translit": "eísodos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice'-od-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an entrance (literally or figuratively)",
               "kjv_def": ":--coming,\n enter(-ing) in (to).",
               "_strongs": "01529"
            },
            {
               "strongs": "1530",
               "greek": [
                  {
                     "_BETA": "EI)SPHDA/W",
                     "_unicode": "εἰσπηδάω",
                     "_translit": "eispēdáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-pay-dah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "PHDA/W",
                        "_unicode": "πηδάω",
                        "_translit": "pēdáō"
                     }
                  ],
                  "__text": "from \n and \n (to leap);"
               },
               "strongs_def": "to rush in",
               "kjv_def": ":--run (spring) in.",
               "_strongs": "01530"
            },
            {
               "strongs": "1531",
               "greek": [
                  {
                     "_BETA": "EI)SPOREU/OMAI",
                     "_unicode": "εἰσπορεύομαι",
                     "_translit": "eisporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-por-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to enter (literally or figuratively)",
               "kjv_def": ":--come\n (enter) in, go into.",
               "_strongs": "01531"
            },
            {
               "strongs": "1532",
               "greek": [
                  {
                     "_BETA": "EI)STRE/XW",
                     "_unicode": "εἰστρέχω",
                     "_translit": "eistréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-trekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hasten inward",
               "kjv_def": ":--run in.",
               "_strongs": "01532"
            },
            {
               "strongs": "1533",
               "greek": [
                  {
                     "_BETA": "EI)SFE/RW",
                     "_unicode": "εἰσφέρω",
                     "_translit": "eisphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ice-fer'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to carry inward (literally or\n figuratively)",
               "kjv_def": ":--bring (in), lead into.",
               "_strongs": "01533"
            },
            {
               "strongs": "1534",
               "greek": [
                  {
                     "_BETA": "EI)=TA",
                     "_unicode": "εἶτα",
                     "_translit": "eîta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-tah"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a particle of succession (in time or logical\n enumeration), then, moreover",
               "kjv_def": ":--after that(-ward), furthermore, then.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1899"
                  }
               ],
               "_strongs": "01534",
               "__text": "See also \n."
            },
            {
               "strongs": "1535",
               "greek": [
                  {
                     "_BETA": "EI)/TE",
                     "_unicode": "εἴτε",
                     "_translit": "eíte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i'-teh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5037"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "if too",
               "kjv_def": ":--if, or, whether.",
               "_strongs": "01535"
            },
            {
               "strongs": "1536",
               "greek": [
                  {
                     "_BETA": "EI)/ TIS",
                     "_unicode": "εἴ τις",
                     "_translit": "eí tis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "i tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5100"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "if any",
               "kjv_def": ":--he that, if a(-ny) man('s thing, from\n any, ought), whether any, whosoever.",
               "_strongs": "01536"
            },
            {
               "strongs": "1537",
               "greek": [
                  {
                     "_BETA": "E)K",
                     "_unicode": "ἐκ",
                     "_translit": "ek"
                  },
                  {
                     "_BETA": "E)C",
                     "_unicode": "ἐξ",
                     "_translit": "ex"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek"
                  },
                  {
                     "_strongs": "ex"
                  }
               ],
               "strongs_derivation": "a primary preposition denoting origin (the point whence action or\n motion proceeds), from, out (of place, time, or cause;",
               "strongs_def": "literal or\n figurative; direct or remote)",
               "kjv_def": ":--after, among, X are, at,\n betwixt(-yond), by (the means of), exceedingly, (+ abundantly above),\n for(- th), from (among, forth, up), + grudgingly, + heartily, X\n heavenly, X hereby, + very highly, in, …ly, (because, by reason) of,\n off (from), on, out among (from, of), over, since, X thenceforth,\n through,\n X unto, X vehemently, with(-out).",
               "_strongs": "01537",
               "__text": "or \n  \n\n\n \n Often used in composition,\n with the same general import; often of completion."
            },
            {
               "strongs": "1538",
               "greek": [
                  {
                     "_BETA": "E(/KASTOS",
                     "_unicode": "ἕκαστος",
                     "_translit": "hékastos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek'-as-tos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E(/KAS",
                        "_unicode": "ἕκας",
                        "_translit": "hékas"
                     }
                  ],
                  "__text": "as if a superlative of \n (afar);"
               },
               "strongs_def": "each or every",
               "kjv_def": ":--any, both, each\n (one), every (man, one, woman), particularly.",
               "_strongs": "01538"
            },
            {
               "strongs": "1539",
               "greek": [
                  {
                     "_BETA": "E(KA/STOTE",
                     "_unicode": "ἑκάστοτε",
                     "_translit": "hekástote"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek-as'-tot-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1538"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5119"
                     }
                  ],
                  "__text": "as if from \n and \n;"
               },
               "strongs_def": "at every time",
               "kjv_def": ":--always.",
               "_strongs": "01539"
            },
            {
               "strongs": "1540",
               "greek": [
                  {
                     "_BETA": "E(KATO/N",
                     "_unicode": "ἑκατόν",
                     "_translit": "hekatón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek-at-on'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a hundred",
               "kjv_def": ":--hundred.",
               "_strongs": "01540"
            },
            {
               "strongs": "1541",
               "greek": [
                  {
                     "_BETA": "E(KATONTAE/THS",
                     "_unicode": "ἑκατονταέτης",
                     "_translit": "hekatontaétēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek-at-on-tah-et'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1540"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2094"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "centenarian",
               "kjv_def": ":--hundred years old.",
               "_strongs": "01541"
            },
            {
               "strongs": "1542",
               "greek": [
                  {
                     "_BETA": "E(KATONTAPLASI/WN",
                     "_unicode": "ἑκατονταπλασίων",
                     "_translit": "hekatontaplasíōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek-at-on-ta-plah-sec'-own"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1540"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4111"
                     }
                  ],
                  "__text": "from \n and a presumed derivative of \n;"
               },
               "strongs_def": "a hundred\n times",
               "kjv_def": ":--hundredfold.",
               "_strongs": "01542"
            },
            {
               "strongs": "1543",
               "greek": [
                  {
                     "_BETA": "E(KATONTA/RXHS",
                     "_unicode": "ἑκατοντάρχης",
                     "_translit": "hekatontárchēs"
                  },
                  {
                     "_BETA": "E(KATO/NTARXOS",
                     "_unicode": "ἑκατόνταρχος",
                     "_translit": "hekatóntarchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek-at-on-tar'-khace"
                  },
                  {
                     "_strongs": "hek-at-on'-tar-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1540"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the captain of one hundred men",
               "kjv_def": ":--centurion.",
               "_strongs": "01543",
               "__text": "or"
            },
            {
               "strongs": "1544",
               "greek": [
                  {
                     "_BETA": "E)KBA/LLW",
                     "_unicode": "ἐκβάλλω",
                     "_translit": "ekbállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-bal'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to eject (literally or figuratively)",
               "kjv_def": ":--bring forth,\n cast (forth, out), drive (out), expel, leave, pluck (pull, take,\n thrust) out, put forth (out), send away (forth, out).",
               "_strongs": "01544"
            },
            {
               "strongs": "1545",
               "greek": [
                  {
                     "_BETA": "E)/KBASIS",
                     "_unicode": "ἔκβασις",
                     "_translit": "ékbasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-bas-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n (meaning to go out);"
               },
               "strongs_def": "an\n exit (literally or figuratively)",
               "kjv_def": ":--end, way to escape.",
               "_strongs": "01545"
            },
            {
               "strongs": "1546",
               "greek": [
                  {
                     "_BETA": "E)KBOLH/",
                     "_unicode": "ἐκβολή",
                     "_translit": "ekbolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-bol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1544"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "ejection, i.e. (specially) a throwing overboard of the\n cargo",
               "kjv_def": ":--+ lighten the ship.",
               "_strongs": "01546"
            },
            {
               "strongs": "1547",
               "greek": [
                  {
                     "_BETA": "E)KGAMI/ZW",
                     "_unicode": "ἐκγαμίζω",
                     "_translit": "ekgamízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-gam-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1061"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1548"
                     }
                  ],
                  "__text": "from \n and a form of \n (compare \n);"
               },
               "strongs_def": "to marry off a\n daughter",
               "kjv_def": ":--give in marriage.",
               "_strongs": "01547"
            },
            {
               "strongs": "1548",
               "greek": [
                  {
                     "_BETA": "E)KGAMI/SKW",
                     "_unicode": "ἐκγαμίσκω",
                     "_translit": "ekgamískō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-gam-is'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1061"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the same as 1547",
               "kjv_def": ":--give in marriage.",
               "_strongs": "01548"
            },
            {
               "strongs": "1549",
               "greek": [
                  {
                     "_BETA": "E)/KGONON",
                     "_unicode": "ἔκγονον",
                     "_translit": "ékgonon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-gon-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "neuter of a derivative of a compound of \n and \n;"
               },
               "strongs_def": "a descendant,\n i.e. (specially) grandchild",
               "kjv_def": ":--nephew.",
               "_strongs": "01549"
            },
            {
               "strongs": "1550",
               "greek": [
                  {
                     "_BETA": "E)KDAPANA/W",
                     "_unicode": "ἐκδαπανάω",
                     "_translit": "ekdapanáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-dap-an-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1159"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to expend (wholly), i.e. (figuratively)\n exhaust",
               "kjv_def": ":--spend.",
               "_strongs": "01550"
            },
            {
               "strongs": "1551",
               "greek": [
                  {
                     "_BETA": "E)KDE/XOMAI",
                     "_unicode": "ἐκδέχομαι",
                     "_translit": "ekdéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-dekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to accept from some source, i.e. (by implication)\n to await",
               "kjv_def": ":--expect, look (tarry) for, wait (for).",
               "_strongs": "01551"
            },
            {
               "strongs": "1552",
               "greek": [
                  {
                     "_BETA": "E)/KDHLOS",
                     "_unicode": "ἔκδηλος",
                     "_translit": "ékdēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-day-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1212"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "wholly evident",
               "kjv_def": ":--manifest.",
               "_strongs": "01552"
            },
            {
               "strongs": "1553",
               "greek": [
                  {
                     "_BETA": "E)KDHME/W",
                     "_unicode": "ἐκδημέω",
                     "_translit": "ekdēméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-day-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to emigrate, i.e. (figuratively)\n vacate or quit",
               "kjv_def": ":--be absent.",
               "_strongs": "01553"
            },
            {
               "strongs": "1554",
               "greek": [
                  {
                     "_BETA": "E)KDI/DWMI",
                     "_unicode": "ἐκδίδωμι",
                     "_translit": "ekdídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-did-o'-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give forth, i.e. (specially) to lease",
               "kjv_def": ":--let\n forth (out).",
               "_strongs": "01554"
            },
            {
               "strongs": "1555",
               "greek": [
                  {
                     "_BETA": "E)KDIHGE/OMAI",
                     "_unicode": "ἐκδιηγέομαι",
                     "_translit": "ekdiēgéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-dee-ayg-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1223"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2233"
                     }
                  ],
                  "__text": "from \n and a compound of \n and \n;"
               },
               "strongs_def": "to narrate through\n wholly",
               "kjv_def": ":--declare.",
               "_strongs": "01555"
            },
            {
               "strongs": "1556",
               "greek": [
                  {
                     "_BETA": "E)KDIKE/W",
                     "_unicode": "ἐκδικέω",
                     "_translit": "ekdikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-dik-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1558"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to vindicate, retaliate, punish",
               "kjv_def": ":--a (re-)venge.",
               "_strongs": "01556"
            },
            {
               "strongs": "1557",
               "greek": [
                  {
                     "_BETA": "E)KDI/KHSIS",
                     "_unicode": "ἐκδίκησις",
                     "_translit": "ekdíkēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-dik'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1556"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "vindication, retribution",
               "kjv_def": ":--(a-, re-)venge(-ance),\n punishment.",
               "_strongs": "01557"
            },
            {
               "strongs": "1558",
               "greek": [
                  {
                     "_BETA": "E)/KDIKOS",
                     "_unicode": "ἔκδικος",
                     "_translit": "ékdikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-dik-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "carrying justice out, i.e. a punisher",
               "kjv_def": ":--a\n (re-)venger.",
               "_strongs": "01558"
            },
            {
               "strongs": "1559",
               "greek": [
                  {
                     "_BETA": "E)KDIW/KW",
                     "_unicode": "ἐκδιώκω",
                     "_translit": "ekdiṓkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-dee-o'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1377"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to pursue out, i.e. expel or persecute\n implacably",
               "kjv_def": ":--persecute.",
               "_strongs": "01559"
            },
            {
               "strongs": "1560",
               "greek": [
                  {
                     "_BETA": "E)/KDOTOS",
                     "_unicode": "ἔκδοτος",
                     "_translit": "ékdotos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-dot-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "given out or over, i.e.\n surrendered",
               "kjv_def": ":--delivered.",
               "_strongs": "01560"
            },
            {
               "strongs": "1561",
               "greek": [
                  {
                     "_BETA": "E)KDOXH/",
                     "_unicode": "ἐκδοχή",
                     "_translit": "ekdochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-dokh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1551"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "expectation",
               "kjv_def": ":--looking for.",
               "_strongs": "01561"
            },
            {
               "strongs": "1562",
               "greek": [
                  {
                     "_BETA": "E)KDU/W",
                     "_unicode": "ἐκδύω",
                     "_translit": "ekdýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-doo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1416"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to cause to sink out of, i.e.\n (specially as of clothing) to divest",
               "kjv_def": ":--strip, take off from, unclothe.",
               "_strongs": "01562"
            },
            {
               "strongs": "1563",
               "greek": [
                  {
                     "_BETA": "E)KEI=",
                     "_unicode": "ἐκεῖ",
                     "_translit": "ekeî"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-i'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "there; by extension, thither",
               "kjv_def": ":--there,\n thither(-ward), (to) yonder (place).",
               "_strongs": "01563"
            },
            {
               "strongs": "1564",
               "greek": [
                  {
                     "_BETA": "E)KEI=QEN",
                     "_unicode": "ἐκεῖθεν",
                     "_translit": "ekeîthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-i'-then"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1563"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "thence",
               "kjv_def": ":--from that place, (from) thence, there.",
               "_strongs": "01564"
            },
            {
               "strongs": "1565",
               "greek": [
                  {
                     "_BETA": "E)KEI=NOS",
                     "_unicode": "ἐκεῖνος",
                     "_translit": "ekeînos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-i'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1563"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "that one (or (neuter) thing); often intensified by the\n article prefixed",
               "kjv_def": ":--he, it, the other (same), selfsame, that (same,\n very), X their, X them, they, this, those.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3778"
                  }
               ],
               "_strongs": "01565",
               "__text": "See also \n."
            },
            {
               "strongs": "1566",
               "greek": [
                  {
                     "_BETA": "E)KEI=SE",
                     "_unicode": "ἐκεῖσε",
                     "_translit": "ekeîse"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-i'-seh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1563"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "thither",
               "kjv_def": ":--there.",
               "_strongs": "01566"
            },
            {
               "strongs": "1567",
               "greek": [
                  {
                     "_BETA": "E)KZHTE/W",
                     "_unicode": "ἐκζητέω",
                     "_translit": "ekzētéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-zay-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2212"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to search out, i.e. (figuratively)investigate,\n crave, demand, (by Hebraism) worship",
               "kjv_def": ":--en- (re-)quire, seek after\n (carefully, diligently).",
               "_strongs": "01567"
            },
            {
               "strongs": "1568",
               "greek": [
                  {
                     "_BETA": "E)KQAMBE/W",
                     "_unicode": "ἐκθαμβέω",
                     "_translit": "ekthambéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-tham-beh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1569"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to astonish utterly",
               "kjv_def": ":--affright, greatly (sore) amaze.",
               "_strongs": "01568"
            },
            {
               "strongs": "1569",
               "greek": [
                  {
                     "_BETA": "E)/KQAMBOS",
                     "_unicode": "ἔκθαμβος",
                     "_translit": "ékthambos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-tham-bos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2285"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "utterly astounded",
               "kjv_def": ":--greatly wondering.",
               "_strongs": "01569"
            },
            {
               "strongs": "1570",
               "greek": [
                  {
                     "_BETA": "E)/KQETOS",
                     "_unicode": "ἔκθετος",
                     "_translit": "ékthetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-thet-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "put out, i.e. exposed to\n perish",
               "kjv_def": ":--cast out.",
               "_strongs": "01570"
            },
            {
               "strongs": "1571",
               "greek": [
                  {
                     "_BETA": "E)KKAQAI/RW",
                     "_unicode": "ἐκκαθαίρω",
                     "_translit": "ekkathaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kath-ah'-ee-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2508"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to cleanse thoroughly",
               "kjv_def": ":--purge (out).",
               "_strongs": "01571"
            },
            {
               "strongs": "1572",
               "greek": [
                  {
                     "_BETA": "E)KKAI/W",
                     "_unicode": "ἐκκαίω",
                     "_translit": "ekkaíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kah'-yo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2545"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to inflame deeply",
               "kjv_def": ":--burn.",
               "_strongs": "01572"
            },
            {
               "strongs": "1573",
               "greek": [
                  {
                     "_BETA": "E)KKAKE/W",
                     "_unicode": "ἐκκακέω",
                     "_translit": "ekkakéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kak-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be (bad or) weak, i.e. (by implication) to fail\n (in heart)",
               "kjv_def": ":--faint, be weary.",
               "_strongs": "01573"
            },
            {
               "strongs": "1574",
               "greek": [
                  {
                     "_BETA": "E)KKENTE/W",
                     "_unicode": "ἐκκεντέω",
                     "_translit": "ekkentéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-ken-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2759"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to transfix",
               "kjv_def": ":--pierce.",
               "_strongs": "01574"
            },
            {
               "strongs": "1575",
               "greek": [
                  {
                     "_BETA": "E)KKLA/W",
                     "_unicode": "ἐκκλάω",
                     "_translit": "ekkláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-klah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2806"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exscind",
               "kjv_def": ":--break off.",
               "_strongs": "01575"
            },
            {
               "strongs": "1576",
               "greek": [
                  {
                     "_BETA": "E)KKLEI/W",
                     "_unicode": "ἐκκλείω",
                     "_translit": "ekkleíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kli'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2808"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to shut out (literally or figuratively)",
               "kjv_def": ":--exclude.",
               "_strongs": "01576"
            },
            {
               "strongs": "1577",
               "greek": [
                  {
                     "_BETA": "E)KKLHSI/A",
                     "_unicode": "ἐκκλησία",
                     "_translit": "ekklēsía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-klay-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "a calling out, i.e.\n (concretely) a popular meeting, especially a religious congregation\n (Jewish synagogue, or Christian community of members on earth or\n saints in heaven or both)",
               "kjv_def": ":--assembly, church.",
               "_strongs": "01577"
            },
            {
               "strongs": "1578",
               "greek": [
                  {
                     "_BETA": "E)KKLI/NW",
                     "_unicode": "ἐκκλίνω",
                     "_translit": "ekklínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-klee'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to deviate, i.e. (absolutely) to shun (literally\n or figuratively), or (relatively) to decline (from piety)",
               "kjv_def": ":--avoid,\n eschew, go out of the way.",
               "_strongs": "01578"
            },
            {
               "strongs": "1579",
               "greek": [
                  {
                     "_BETA": "E)KKOLUMBA/W",
                     "_unicode": "ἐκκολυμβάω",
                     "_translit": "ekkolymbáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kol-oom-bah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2860"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to escape by swimming",
               "kjv_def": ":--swim out.",
               "_strongs": "01579"
            },
            {
               "strongs": "1580",
               "greek": [
                  {
                     "_BETA": "E)KKOMI/ZW",
                     "_unicode": "ἐκκομίζω",
                     "_translit": "ekkomízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kom-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2865"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear forth (to burial)",
               "kjv_def": ":--carry out.",
               "_strongs": "01580"
            },
            {
               "strongs": "1581",
               "greek": [
                  {
                     "_BETA": "E)KKO/PTW",
                     "_unicode": "ἐκκόπτω",
                     "_translit": "ekkóptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exscind; figuratively, to frustrate",
               "kjv_def": ":--cut down\n (off, out), hew down, hinder.",
               "_strongs": "01581"
            },
            {
               "strongs": "1582",
               "greek": [
                  {
                     "_BETA": "E)KKRE/MAMAI",
                     "_unicode": "ἐκκρέμαμαι",
                     "_translit": "ekkrémamai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-krem'-am-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2910"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to hang upon the lips of a speaker,\n i.e. listen closely",
               "kjv_def": ":--be very attentive.",
               "_strongs": "01582"
            },
            {
               "strongs": "1583",
               "greek": [
                  {
                     "_BETA": "E)KLALE/W",
                     "_unicode": "ἐκλαλέω",
                     "_translit": "eklaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-lal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to divulge",
               "kjv_def": ":--tell.",
               "_strongs": "01583"
            },
            {
               "strongs": "1584",
               "greek": [
                  {
                     "_BETA": "E)KLA/MPW",
                     "_unicode": "ἐκλάμπω",
                     "_translit": "eklámpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-lam'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2989"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be resplendent",
               "kjv_def": ":--shine forth.",
               "_strongs": "01584"
            },
            {
               "strongs": "1585",
               "greek": [
                  {
                     "_BETA": "E)KLANQA/NOMAI",
                     "_unicode": "ἐκλανθάνομαι",
                     "_translit": "eklanthánomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-lan-than'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2990"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to be utterly oblivious of",
               "kjv_def": ":--forget.",
               "_strongs": "01585"
            },
            {
               "strongs": "1586",
               "greek": [
                  {
                     "_BETA": "E)KLE/GOMAI",
                     "_unicode": "ἐκλέγομαι",
                     "_translit": "eklégomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-leg'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "middle voice from \n and \n (in its primary sense);"
               },
               "strongs_def": "to\n select",
               "kjv_def": ":--make choice, choose (out), chosen.",
               "_strongs": "01586"
            },
            {
               "strongs": "1587",
               "greek": [
                  {
                     "_BETA": "E)KLEI/PW",
                     "_unicode": "ἐκλείπω",
                     "_translit": "ekleípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-li'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to omit, i.e. (by implication) cease (die)",
               "kjv_def": ":--fail.",
               "_strongs": "01587"
            },
            {
               "strongs": "1588",
               "greek": [
                  {
                     "_BETA": "E)KLEKTO/S",
                     "_unicode": "ἐκλεκτός",
                     "_translit": "eklektós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-lek-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1586"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "select; by implication, favorite",
               "kjv_def": ":--chosen, elect.",
               "_strongs": "01588"
            },
            {
               "strongs": "1589",
               "greek": [
                  {
                     "_BETA": "E)KLOGH/",
                     "_unicode": "ἐκλογή",
                     "_translit": "eklogḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-log-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1586"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(divine) selection (abstractly or concretely)",
               "kjv_def": ":--chosen,\n election.",
               "_strongs": "01589"
            },
            {
               "strongs": "1590",
               "greek": [
                  {
                     "_BETA": "E)KLU/W",
                     "_unicode": "ἐκλύω",
                     "_translit": "eklýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-loo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to relax (literally or figuratively)",
               "kjv_def": ":--faint.",
               "_strongs": "01590"
            },
            {
               "strongs": "1591",
               "greek": [
                  {
                     "_BETA": "E)KMA/SSW",
                     "_unicode": "ἐκμάσσω",
                     "_translit": "ekmássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-mas'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3145"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to knead out, i.e. (by analogy) to\n wipe dry",
               "kjv_def": ":--wipe.",
               "_strongs": "01591"
            },
            {
               "strongs": "1592",
               "greek": [
                  {
                     "_BETA": "E)KMUKTHRI/ZW",
                     "_unicode": "ἐκμυκτηρίζω",
                     "_translit": "ekmyktērízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-mook-ter-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3456"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sneer outright at",
               "kjv_def": ":--deride.",
               "_strongs": "01592"
            },
            {
               "strongs": "1593",
               "greek": [
                  {
                     "_BETA": "E)KNEU/W",
                     "_unicode": "ἐκνεύω",
                     "_translit": "ekneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-nyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3506"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(by analogy) to slip off, i.e. quietly\n withdraw",
               "kjv_def": ":--convey self away.",
               "_strongs": "01593"
            },
            {
               "strongs": "1594",
               "greek": [
                  {
                     "_BETA": "E)KNH/FW",
                     "_unicode": "ἐκνήφω",
                     "_translit": "eknḗphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-nay'-fo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3525"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(figuratively) to rouse (oneself) out of\n stupor",
               "kjv_def": ":--awake.",
               "_strongs": "01594"
            },
            {
               "strongs": "1595",
               "greek": [
                  {
                     "_BETA": "E(KOU/SION",
                     "_unicode": "ἑκούσιον",
                     "_translit": "hekoúsion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek-oo'-see-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1635"
                     }
                  ],
                  "__text": "neuter of a derivative from \n;"
               },
               "strongs_def": "voluntariness",
               "kjv_def": ":--willingly.",
               "_strongs": "01595"
            },
            {
               "strongs": "1596",
               "greek": [
                  {
                     "_BETA": "E(KOUSI/WS",
                     "_unicode": "ἑκουσίως",
                     "_translit": "hekousíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek-oo-see'-ose"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1595"
                     }
                  ],
                  "__text": "adverb from the same as \n;"
               },
               "strongs_def": "voluntarily",
               "kjv_def": ":--wilfully, willingly.",
               "_strongs": "01596"
            },
            {
               "strongs": "1597",
               "greek": [
                  {
                     "_BETA": "E)/KPALAI",
                     "_unicode": "ἔκπαλαι",
                     "_translit": "ékpalai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eh'-pal-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3819"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "long ago, for a long while",
               "kjv_def": ":--of a long time, of\n old.",
               "_strongs": "01597"
            },
            {
               "strongs": "1598",
               "greek": [
                  {
                     "_BETA": "E)KPEIRA/ZW",
                     "_unicode": "ἐκπειράζω",
                     "_translit": "ekpeirázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-pi-rad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3985"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to test thoroughly",
               "kjv_def": ":--tempt.",
               "_strongs": "01598"
            },
            {
               "strongs": "1599",
               "greek": [
                  {
                     "_BETA": "E)KPE/MPW",
                     "_unicode": "ἐκπέμπω",
                     "_translit": "ekpémpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-pem'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3992"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to despatch",
               "kjv_def": ":--send away (forth).",
               "_strongs": "01599"
            },
            {
               "strongs": "1600",
               "greek": [
                  {
                     "_BETA": "E)KPETA/NNUMI",
                     "_unicode": "ἐκπετάννυμι",
                     "_translit": "ekpetánnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-pet-an'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4072"
                     }
                  ],
                  "__text": "from \n and a form of \n;"
               },
               "strongs_def": "to fly out, i.e. (by analogy) to\n extend",
               "kjv_def": ":--stretch forth.",
               "_strongs": "01600"
            },
            {
               "strongs": "1601",
               "greek": [
                  {
                     "_BETA": "E)KPI/PTW",
                     "_unicode": "ἐκπίπτω",
                     "_translit": "ekpíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-pip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to drop away; specially, be driven out of one's\n course; figuratively, to lose, become inefficient",
               "kjv_def": ":--be cast, fail,\n fall (away, off), take none effect.",
               "_strongs": "01601"
            },
            {
               "strongs": "1602",
               "greek": [
                  {
                     "_BETA": "E)KPLE/W",
                     "_unicode": "ἐκπλέω",
                     "_translit": "ekpléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-pleh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to depart by ship",
               "kjv_def": ":--sail (away, thence).",
               "_strongs": "01602"
            },
            {
               "strongs": "1603",
               "greek": [
                  {
                     "_BETA": "E)KPLHRO/W",
                     "_unicode": "ἐκπληρόω",
                     "_translit": "ekplēróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-play-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4137"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to accomplish entirely",
               "kjv_def": ":--fulfill.",
               "_strongs": "01603"
            },
            {
               "strongs": "1604",
               "greek": [
                  {
                     "_BETA": "E)KPLH/RWSIS",
                     "_unicode": "ἐκπλήρωσις",
                     "_translit": "ekplḗrōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-play'-ro-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1603"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "completion",
               "kjv_def": ":--accomplishment.",
               "_strongs": "01604"
            },
            {
               "strongs": "1605",
               "greek": [
                  {
                     "_BETA": "E)KPLH/SSW",
                     "_unicode": "ἐκπλήσσω",
                     "_translit": "ekplḗssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-place'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4141"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to strike with astonishment",
               "kjv_def": ":--amaze, astonish.",
               "_strongs": "01605"
            },
            {
               "strongs": "1606",
               "greek": [
                  {
                     "_BETA": "E)KPNE/W",
                     "_unicode": "ἐκπνέω",
                     "_translit": "ekpnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-pneh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4154"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to expire",
               "kjv_def": ":--give up the ghost.",
               "_strongs": "01606"
            },
            {
               "strongs": "1607",
               "greek": [
                  {
                     "_BETA": "E)KPOREU/OMAI",
                     "_unicode": "ἐκπορεύομαι",
                     "_translit": "ekporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-por-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to depart, be discharged, proceed, project",
               "kjv_def": ":--come\n (forth, out of), depart, go (forth, out), issue, proceed (out of).",
               "_strongs": "01607"
            },
            {
               "strongs": "1608",
               "greek": [
                  {
                     "_BETA": "E)KPORNEU/W",
                     "_unicode": "ἐκπορνεύω",
                     "_translit": "ekporneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-porn-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4203"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be utterly unchaste",
               "kjv_def": ":--give self over to\n fornication.",
               "_strongs": "01608"
            },
            {
               "strongs": "1609",
               "greek": [
                  {
                     "_BETA": "E)KPTU/W",
                     "_unicode": "ἐκπτύω",
                     "_translit": "ekptýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-ptoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4429"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to spit out, i.e. (figuratively) spurn",
               "kjv_def": ":--reject.",
               "_strongs": "01609"
            },
            {
               "strongs": "1610",
               "greek": [
                  {
                     "_BETA": "E)KRIZO/W",
                     "_unicode": "ἐκριζόω",
                     "_translit": "ekrizóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-rid-zo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4492"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to uproot",
               "kjv_def": ":--pluck up by the root, root up.",
               "_strongs": "01610"
            },
            {
               "strongs": "1611",
               "greek": [
                  {
                     "_BETA": "E)/KSTASIS",
                     "_unicode": "ἔκστασις",
                     "_translit": "ékstasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-stas-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1839"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a displacement of the mind, i.e. bewilderment,\n \"ecstasy\"",
               "kjv_def": ":--+ be amazed, amazement, astonishment, trance.",
               "_strongs": "01611"
            },
            {
               "strongs": "1612",
               "greek": [
                  {
                     "_BETA": "E)KSTRE/FW",
                     "_unicode": "ἐκστρέφω",
                     "_translit": "ekstréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-stref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to pervert (figuratively)",
               "kjv_def": ":--subvert.",
               "_strongs": "01612"
            },
            {
               "strongs": "1613",
               "greek": [
                  {
                     "_BETA": "E)KTARA/SSW",
                     "_unicode": "ἐκταράσσω",
                     "_translit": "ektarássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-tar-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5015"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to disturb wholly",
               "kjv_def": ":--exceedingly trouble.",
               "_strongs": "01613"
            },
            {
               "strongs": "1614",
               "greek": [
                  {
                     "_BETA": "E)KTEI/NW",
                     "_unicode": "ἐκτείνω",
                     "_translit": "ekteínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-ti'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "__text": "from \n and teino (to stretch);"
               },
               "strongs_def": "to extend",
               "kjv_def": ":--cast, put forth, stretch\n forth (out).",
               "_strongs": "01614"
            },
            {
               "strongs": "1615",
               "greek": [
                  {
                     "_BETA": "E)KTELE/W",
                     "_unicode": "ἐκτελέω",
                     "_translit": "ekteléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-tel-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5055"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to complete fully",
               "kjv_def": ":--finish.",
               "_strongs": "01615"
            },
            {
               "strongs": "1616",
               "greek": [
                  {
                     "_BETA": "E)KTE/NEIA",
                     "_unicode": "ἐκτένεια",
                     "_translit": "ekténeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-ten'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1618"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "intentness",
               "kjv_def": ":--X instantly.",
               "_strongs": "01616"
            },
            {
               "strongs": "1617",
               "greek": [
                  {
                     "_BETA": "E)KTENE/STERON",
                     "_unicode": "ἐκτενέστερον",
                     "_translit": "ektenésteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-ten-es'-ter-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1618"
                     }
                  ],
                  "__text": "neuter of the comparative of \n;"
               },
               "strongs_def": "more intently",
               "kjv_def": ":--more earnestly.",
               "_strongs": "01617"
            },
            {
               "strongs": "1618",
               "greek": [
                  {
                     "_BETA": "E)KTENH/S",
                     "_unicode": "ἐκτενής",
                     "_translit": "ektenḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-ten-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1614"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "intent",
               "kjv_def": ":--without ceasing, fervent.",
               "_strongs": "01618"
            },
            {
               "strongs": "1619",
               "greek": [
                  {
                     "_BETA": "E)KTENW=S",
                     "_unicode": "ἐκτενῶς",
                     "_translit": "ektenōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-ten-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1618"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "intently",
               "kjv_def": ":--fervently.",
               "_strongs": "01619"
            },
            {
               "strongs": "1620",
               "greek": [
                  {
                     "_BETA": "E)KTI/QHMI",
                     "_unicode": "ἐκτίθημι",
                     "_translit": "ektíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-tith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to expose; figuratively, to declare",
               "kjv_def": ":--cast out,\n expound.",
               "_strongs": "01620"
            },
            {
               "strongs": "1621",
               "greek": [
                  {
                     "_BETA": "E)KTINA/SSW",
                     "_unicode": "ἐκτινάσσω",
                     "_translit": "ektinássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-tin-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "__text": "from \n and tinasso (to swing);"
               },
               "strongs_def": "to shake violently",
               "kjv_def": ":--shake (off).",
               "_strongs": "01621"
            },
            {
               "strongs": "1622",
               "greek": [
                  {
                     "_BETA": "E)KTO/S",
                     "_unicode": "ἐκτός",
                     "_translit": "ektós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the exterior; figuratively (as a preposition) aside from,\n besides",
               "kjv_def": ":--but, except(-ed), other than, out of, outside, unless,\n without.",
               "_strongs": "01622"
            },
            {
               "strongs": "1623",
               "greek": [
                  {
                     "_BETA": "E(/KTOS",
                     "_unicode": "ἕκτος",
                     "_translit": "héktos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1803"
                     }
                  ],
                  "__text": "ordinal from \n;"
               },
               "strongs_def": "sixth",
               "kjv_def": ":--sixth.",
               "_strongs": "01623"
            },
            {
               "strongs": "1624",
               "greek": [
                  {
                     "_BETA": "E)KTRE/PW",
                     "_unicode": "ἐκτρέπω",
                     "_translit": "ektrépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-trep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to deflect, i.e. turn away (literally\n or figuratively)",
               "kjv_def": ":--avoid, turn (aside, out of the way).",
               "_strongs": "01624"
            },
            {
               "strongs": "1625",
               "greek": [
                  {
                     "_BETA": "E)KTRE/FW",
                     "_unicode": "ἐκτρέφω",
                     "_translit": "ektréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rear up to maturity, i.e. (genitive case) to\n cherish or train",
               "kjv_def": ":--bring up, nourish.",
               "_strongs": "01625"
            },
            {
               "strongs": "1626",
               "greek": [
                  {
                     "_BETA": "E)/KTRWMA",
                     "_unicode": "ἔκτρωμα",
                     "_translit": "éktrōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-tro-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TITRW/SKW",
                        "_unicode": "τιτρώσκω",
                        "_translit": "titrṓskō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to wound);"
               },
               "strongs_def": "a miscarriage\n (abortion), i.e. (by analogy) untimely birth",
               "kjv_def": ":--born out of due time.",
               "_strongs": "01626"
            },
            {
               "strongs": "1627",
               "greek": [
                  {
                     "_BETA": "E)KFE/RW",
                     "_unicode": "ἐκφέρω",
                     "_translit": "ekphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-fer'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear out (literally or figuratively)",
               "kjv_def": ":--bear,\n bring forth, carry forth (out).",
               "_strongs": "01627"
            },
            {
               "strongs": "1628",
               "greek": [
                  {
                     "_BETA": "E)KFEU/GW",
                     "_unicode": "ἐκφεύγω",
                     "_translit": "ekpheúgō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-fyoo'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5343"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to flee out",
               "kjv_def": ":--escape, flee.",
               "_strongs": "01628"
            },
            {
               "strongs": "1629",
               "greek": [
                  {
                     "_BETA": "E)KFOBE/W",
                     "_unicode": "ἐκφοβέω",
                     "_translit": "ekphobéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-fob-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5399"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to frighten utterly",
               "kjv_def": ":--terrify.",
               "_strongs": "01629"
            },
            {
               "strongs": "1630",
               "greek": [
                  {
                     "_BETA": "E)/KFOBOS",
                     "_unicode": "ἔκφοβος",
                     "_translit": "ékphobos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek'-fob-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5401"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "frightened out of one's wits",
               "kjv_def": ":-- sore afraid,\n exceedingly fear.",
               "_strongs": "01630"
            },
            {
               "strongs": "1631",
               "greek": [
                  {
                     "_BETA": "E)KFU/W",
                     "_unicode": "ἐκφύω",
                     "_translit": "ekphýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-foo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sprout up",
               "kjv_def": ":--put forth.",
               "_strongs": "01631"
            },
            {
               "strongs": "1632",
               "greek": [
                  {
                     "_BETA": "E)KXE/W",
                     "_unicode": "ἐκχέω",
                     "_translit": "ekchéō"
                  },
                  {
                     "_BETA": "E)KXU/NW",
                     "_unicode": "ἐκχύνω",
                     "_translit": "ekchýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kheh'-o"
                  },
                  {
                     "_strongs": "ek-khoo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "XE/W",
                        "_unicode": "χέω",
                        "_translit": "chéō"
                     }
                  ],
                  "__text": "from \n and \n (to pour);"
               },
               "strongs_def": "to pour forth; figuratively, to\n bestow",
               "kjv_def": ":--gush (pour) out, run greedily (out), shed (abroad, forth),\n spill.",
               "_strongs": "01632",
               "__text": ",     or (by variation)"
            },
            {
               "strongs": "1633",
               "greek": [
                  {
                     "_BETA": "E)KXWRE/W",
                     "_unicode": "ἐκχωρέω",
                     "_translit": "ekchōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-kho-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5562"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to depart",
               "kjv_def": ":--depart out.",
               "_strongs": "01633"
            },
            {
               "strongs": "1634",
               "greek": [
                  {
                     "_BETA": "E)KYU/XW",
                     "_unicode": "ἐκψύχω",
                     "_translit": "ekpsýchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ek-psoo'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5594"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to expire",
               "kjv_def": ":--give (yield) up the ghost.",
               "_strongs": "01634"
            },
            {
               "strongs": "1635",
               "greek": [
                  {
                     "_BETA": "E(KW/N",
                     "_unicode": "ἑκών",
                     "_translit": "hekṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hek-own'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "voluntary",
               "kjv_def": ":--willingly.",
               "_strongs": "01635"
            },
            {
               "strongs": "1636",
               "greek": [
                  {
                     "_BETA": "E)LAI/A",
                     "_unicode": "ἐλαία",
                     "_translit": "elaía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-ah'-yah"
                  }
               ],
               "strongs_derivation": "feminine of a presumed derivative from an obsolete primary;",
               "strongs_def": "an olive\n (the tree or the fruit)",
               "kjv_def": ":--olive (berry, tree).",
               "_strongs": "01636"
            },
            {
               "strongs": "1637",
               "greek": [
                  {
                     "_BETA": "E)/LAION",
                     "_unicode": "ἔλαιον",
                     "_translit": "élaion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el'-ah-yon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1636"
                     }
                  ],
                  "__text": "neuter of the same as \n;"
               },
               "strongs_def": "olive oil",
               "kjv_def": ":--oil.",
               "_strongs": "01637"
            },
            {
               "strongs": "1638",
               "greek": [
                  {
                     "_BETA": "E)LAIW/N",
                     "_unicode": "ἐλαιών",
                     "_translit": "elaiṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-ah-yone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1636"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an olive-orchard, i.e. (specially) the Mount of\n Olives",
               "kjv_def": ":--Olivet.",
               "_strongs": "01638"
            },
            {
               "strongs": "1639",
               "greek": [
                  {
                     "_BETA": "*)ELAMI/THS",
                     "_unicode": "Ἐλαμίτης",
                     "_translit": "Elamítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-am-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05867"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "an Elamite or Persian",
               "kjv_def": ":--Elamite.",
               "_strongs": "01639"
            },
            {
               "strongs": "1640",
               "greek": [
                  {
                     "_BETA": "E)LA/SSWN",
                     "_unicode": "ἐλάσσων",
                     "_translit": "elássōn"
                  },
                  {
                     "_BETA": "E)LA/TTWN",
                     "_unicode": "ἐλάττων",
                     "_translit": "eláttōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-as'-sone"
                  },
                  {
                     "_strongs": "el-at-tone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1646"
                     }
                  ],
                  "__text": "comparative of the same as \n;"
               },
               "strongs_def": "smaller (in size, quantity, age or\n quality)",
               "kjv_def": ":--less, under, worse, younger.",
               "_strongs": "01640",
               "__text": "or"
            },
            {
               "strongs": "1641",
               "greek": [
                  {
                     "_BETA": "E)LATTONE/W",
                     "_unicode": "ἐλαττονέω",
                     "_translit": "elattonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-at-ton-eh-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1640"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to diminish, i.e. fall short",
               "kjv_def": ":--have lack.",
               "_strongs": "01641"
            },
            {
               "strongs": "1642",
               "greek": [
                  {
                     "_BETA": "E)LATTO/W",
                     "_unicode": "ἐλαττόω",
                     "_translit": "elattóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-at-to'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1640"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to lessen (in rank or influence)",
               "kjv_def": ":--decrease, make lower.",
               "_strongs": "01642"
            },
            {
               "strongs": "1643",
               "greek": [
                  {
                     "_BETA": "E)LAU/NW",
                     "_unicode": "ἐλαύνω",
                     "_translit": "elaúnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-ow'-no"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb (obsolete except in certain tenses\n as an alternative of this) of uncertain affinity;",
               "strongs_def": "to push (as wind,\n oars or dæmonical power)",
               "kjv_def": ":--carry, drive, row.",
               "_strongs": "01643"
            },
            {
               "strongs": "1644",
               "greek": [
                  {
                     "_BETA": "E)LAFRI/A",
                     "_unicode": "ἐλαφρία",
                     "_translit": "elaphría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-af-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1645"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "levity (figuratively), i.e. fickleness",
               "kjv_def": ":--lightness.",
               "_strongs": "01644"
            },
            {
               "strongs": "1645",
               "greek": [
                  {
                     "_BETA": "E)LAFRO/S",
                     "_unicode": "ἐλαφρός",
                     "_translit": "elaphrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-af-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1643"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1640"
                     }
                  ],
                  "__text": "probably akin to \n and the base of \n;"
               },
               "strongs_def": "light, i.e. easy",
               "kjv_def": ":--light.",
               "_strongs": "01645"
            },
            {
               "strongs": "1646",
               "greek": [
                  {
                     "_BETA": "E)LA/XISTOS",
                     "_unicode": "ἐλάχιστος",
                     "_translit": "eláchistos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-akh'-is-tos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)/LAXUS",
                        "_unicode": "ἔλαχυς",
                        "_translit": "élachys"
                     }
                  ],
                  "__text": "superlative of \n (short);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3398"
                     }
                  ],
                  "__text": "used as equivalent to \n; least (in\n size, amount, dignity, etc.)"
               },
               "kjv_def": ":--least, very little (small), smallest.",
               "_strongs": "01646"
            },
            {
               "strongs": "1647",
               "greek": [
                  {
                     "_BETA": "E)LAXISTO/TEROS",
                     "_unicode": "ἐλαχιστότερος",
                     "_translit": "elachistóteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-akh-is-tot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1646"
                     }
                  ],
                  "__text": "comparative of \n;"
               },
               "strongs_def": "far less",
               "kjv_def": ":--less than the least.",
               "_strongs": "01647"
            },
            {
               "strongs": "1648",
               "greek": [
                  {
                     "_BETA": "*)ELEA/ZAR",
                     "_unicode": "Ἐλεάζαρ",
                     "_translit": "Eleázar"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-eh-ad'-zar"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0499"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Eleazar, an Israelite",
               "kjv_def": ":--Eleazar.",
               "_strongs": "01648"
            },
            {
               "strongs": "1649",
               "greek": [
                  {
                     "_BETA": "E)/LEGCIS",
                     "_unicode": "ἔλεγξις",
                     "_translit": "élenxis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el'-eng-xis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1651"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "refutation, i.e. reproof",
               "kjv_def": ":--rebuke.",
               "_strongs": "01649"
            },
            {
               "strongs": "1650",
               "greek": [
                  {
                     "_BETA": "E)/LEGXOS",
                     "_unicode": "ἔλεγχος",
                     "_translit": "élenchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el'-eng-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1651"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "proof, conviction",
               "kjv_def": ":--evidence, reproof.",
               "_strongs": "01650"
            },
            {
               "strongs": "1651",
               "greek": [
                  {
                     "_BETA": "E)LE/GXW",
                     "_unicode": "ἐλέγχω",
                     "_translit": "elénchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-eng'-kho"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to confute, admonish",
               "kjv_def": ":--convict, convince, tell\n a fault, rebuke, reprove.",
               "_strongs": "01651"
            },
            {
               "strongs": "1652",
               "greek": [
                  {
                     "_BETA": "E)LEEINO/S",
                     "_unicode": "ἐλεεινός",
                     "_translit": "eleeinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-eh-i-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1656"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pitiable",
               "kjv_def": ":--miserable.",
               "_strongs": "01652"
            },
            {
               "strongs": "1653",
               "greek": [
                  {
                     "_BETA": "E)LEE/W",
                     "_unicode": "ἐλεέω",
                     "_translit": "eleéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-eh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1656"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to compassionate (by word or deed, specially, by divine\n grace)",
               "kjv_def": ":--have compassion (pity on), have (obtain, receive, shew) mercy\n (on).",
               "_strongs": "01653"
            },
            {
               "strongs": "1654",
               "greek": [
                  {
                     "_BETA": "E)LEHMOSU/NH",
                     "_unicode": "ἐλεημοσύνη",
                     "_translit": "eleēmosýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-eh-ay-mos-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1656"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "compassionateness, i.e. (as exercised towards the poor)\n beneficence, or (concretely) a benefaction",
               "kjv_def": ":--alms(-deeds).",
               "_strongs": "01654"
            },
            {
               "strongs": "1655",
               "greek": [
                  {
                     "_BETA": "E)LEH/MWN",
                     "_unicode": "ἐλεήμων",
                     "_translit": "eleḗmōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-eh-ay'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1653"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "compassionate (actively)",
               "kjv_def": ":--merciful.",
               "_strongs": "01655"
            },
            {
               "strongs": "1656",
               "greek": [
                  {
                     "_BETA": "E)/LEOS",
                     "_unicode": "ἔλεος",
                     "_translit": "éleos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el'-eh-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "compassion (human or divine, especially\n active)",
               "kjv_def": ":--(+ tender) mercy.",
               "_strongs": "01656"
            },
            {
               "strongs": "1657",
               "greek": [
                  {
                     "_BETA": "E)LEUQERI/A",
                     "_unicode": "ἐλευθερία",
                     "_translit": "eleuthería"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-yoo-ther-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1658"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "freedom (legitimate or licentious, chiefly moral or\n ceremonial)",
               "kjv_def": ":--liberty.",
               "_strongs": "01657"
            },
            {
               "strongs": "1658",
               "greek": [
                  {
                     "_BETA": "E)LEU/QEROS",
                     "_unicode": "ἐλεύθερος",
                     "_translit": "eleútheros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-yoo'-ther-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "probably from the alternate of \n;"
               },
               "strongs_def": "unrestrained (to go at pleasure),\n i.e. (as a citizen) not a slave (whether freeborn or manumitted), or\n (genitive case) exempt (from obligation or liability)",
               "kjv_def": ":--free (man,\n woman), at liberty.",
               "_strongs": "01658"
            },
            {
               "strongs": "1659",
               "greek": [
                  {
                     "_BETA": "E)LEUQERO/W",
                     "_unicode": "ἐλευθερόω",
                     "_translit": "eleutheróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-yoo-ther-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1658"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to liberate, i.e. (figuratively) to exempt (from moral,\n ceremonial or mortal liability)",
               "kjv_def": ":--deliver, make free.",
               "_strongs": "01659"
            },
            {
               "strongs": "1660",
               "greek": [
                  {
                     "_BETA": "E)/LEUSIS",
                     "_unicode": "ἔλευσις",
                     "_translit": "éleusis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el'-yoo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "an advent",
               "kjv_def": ":--coming.",
               "_strongs": "01660"
            },
            {
               "strongs": "1661",
               "greek": [
                  {
                     "_BETA": "E)LEFA/NTINOS",
                     "_unicode": "ἐλεφάντινος",
                     "_translit": "elephántinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-ef-an'-tee-nos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)/LEFAS",
                        "_unicode": "ἔλεφας",
                        "_translit": "élephas"
                     }
                  ],
                  "__text": "from \n (an \"elephant\");"
               },
               "strongs_def": "elephantine, i.e. (by implication)\n composed of ivory",
               "kjv_def": ":--of ivory.",
               "_strongs": "01661"
            },
            {
               "strongs": "1662",
               "greek": [
                  {
                     "_BETA": "*)ELIAKEI/M",
                     "_unicode": "Ἐλιακείμ",
                     "_translit": "Eliakeím"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-ee-ak-ime'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0471"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Eliakim, an Israelite",
               "kjv_def": ":--Eliakim.",
               "_strongs": "01662"
            },
            {
               "strongs": "1663",
               "greek": [
                  {
                     "_BETA": "*)ELIE/ZER",
                     "_unicode": "Ἐλιέζερ",
                     "_translit": "Eliézer"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-ee-ed'-zer"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0461"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Eliezer, an Israelite",
               "kjv_def": ":--Eliezer.",
               "_strongs": "01663"
            },
            {
               "strongs": "1664",
               "greek": [
                  {
                     "_BETA": "*)ELIOU/D",
                     "_unicode": "Ἐλιούδ",
                     "_translit": "Elioúd"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-ee-ood'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0410"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "01935"
                     }
                  ],
                  "__text": "of Hebrew origin (\n and \n);"
               },
               "strongs_def": "God of majesty; Eliud, an\n Israelite",
               "kjv_def": ":--Eliud.",
               "_strongs": "01664"
            },
            {
               "strongs": "1665",
               "greek": [
                  {
                     "_BETA": "*)ELISA/BET",
                     "_unicode": "Ἐλισάβετ",
                     "_translit": "Elisábet"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-ee-sab'-et"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0472"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Elisabet, an Israelitess",
               "kjv_def": ":--Elisabeth.",
               "_strongs": "01665"
            },
            {
               "strongs": "1666",
               "greek": [
                  {
                     "_BETA": "*)ELISSAI=OS",
                     "_unicode": "Ἐλισσαῖος",
                     "_translit": "Elissaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-is-sah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0477"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Elissæus, an Israelite",
               "kjv_def": ":--Elissæus.",
               "_strongs": "01666"
            },
            {
               "strongs": "1667",
               "greek": [
                  {
                     "_BETA": "E(LI/SSW",
                     "_unicode": "ἑλίσσω",
                     "_translit": "helíssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel-is'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1507"
                     }
                  ],
                  "__text": "a form of \n;"
               },
               "strongs_def": "to coil or wrap",
               "kjv_def": ":--fold up.",
               "_strongs": "01667"
            },
            {
               "strongs": "1668",
               "greek": [
                  {
                     "_BETA": "E(/LKOS",
                     "_unicode": "ἕλκος",
                     "_translit": "hélkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1670"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "an ulcer (as if drawn together)",
               "kjv_def": ":--sore.",
               "_strongs": "01668"
            },
            {
               "strongs": "1669",
               "greek": [
                  {
                     "_BETA": "E(LKO/W",
                     "_unicode": "ἑλκόω",
                     "_translit": "helkóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel-ko'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1668"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to cause to ulcerate, i.e. (passively) be ulcerous",
               "kjv_def": ":--full\n of sores.",
               "_strongs": "01669"
            },
            {
               "strongs": "1670",
               "greek": [
                  {
                     "_BETA": "E(LKU/W",
                     "_unicode": "ἑλκύω",
                     "_translit": "helkýō"
                  },
                  {
                     "_BETA": "E(/LKW",
                     "_unicode": "ἕλκω",
                     "_translit": "hélkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel-koo'-o"
                  },
                  {
                     "_strongs": "hel'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "probably akin to \n;"
               },
               "strongs_def": "to drag (literally or\n figuratively)",
               "kjv_def": ":--draw.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1667"
                  }
               ],
               "_strongs": "01670",
               "__text": "or \n  \n; \n\n \n Compare \n."
            },
            {
               "strongs": "1671",
               "greek": [
                  {
                     "_BETA": "*(ELLA/S",
                     "_unicode": "Ἑλλάς",
                     "_translit": "Hellás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel-las'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "Hellas (or Greece), a country of\n Europe",
               "kjv_def": ":--Greece.",
               "_strongs": "01671"
            },
            {
               "strongs": "1672",
               "greek": [
                  {
                     "_BETA": "*(/ELLHN",
                     "_unicode": "Ἕλλην",
                     "_translit": "Héllēn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel'-lane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1671"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Hellen (Grecian) or inhabitant of Hellas; by extension a\n Greek-speaking person, especially a non-Jew",
               "kjv_def": ":-- Gentile, Greek.",
               "_strongs": "01672"
            },
            {
               "strongs": "1673",
               "greek": [
                  {
                     "_BETA": "*(ELLHNIKO/S",
                     "_unicode": "Ἑλληνικός",
                     "_translit": "Hellēnikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel-lay-nee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1672"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Hellenic, i.e. Grecian (in language)",
               "kjv_def": ":--Greek.",
               "_strongs": "01673"
            },
            {
               "strongs": "1674",
               "greek": [
                  {
                     "_BETA": "*(ELLHNI/S",
                     "_unicode": "Ἑλληνίς",
                     "_translit": "Hellēnís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel-lay-nis'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1672"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a Grecian (i.e. non-Jewish) woman",
               "kjv_def": ":--Greek.",
               "_strongs": "01674"
            },
            {
               "strongs": "1675",
               "greek": [
                  {
                     "_BETA": "*(ELLHNISTH/S",
                     "_unicode": "Ἑλληνιστής",
                     "_translit": "Hellēnistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel-lay-nis-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1672"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a Hellenist or Greek-speaking\n Jew",
               "kjv_def": ":--Grecian.",
               "_strongs": "01675"
            },
            {
               "strongs": "1676",
               "greek": [
                  {
                     "_BETA": "*(ELLHNISTI/",
                     "_unicode": "Ἑλληνιστί",
                     "_translit": "Hellēnistí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hel-lay-nis-tee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1675"
                     }
                  ],
                  "__text": "adverb from the same as \n;"
               },
               "strongs_def": "Hellenistically, i.e. in the Grecian\n language",
               "kjv_def": ":--Greek.",
               "_strongs": "01676"
            },
            {
               "strongs": "1677",
               "greek": [
                  {
                     "_BETA": "E)LLOGE/W",
                     "_unicode": "ἐλλογέω",
                     "_translit": "ellogéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-log-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n and \n (in the sense of account);"
               },
               "strongs_def": "to reckon in, i.e.\n attribute",
               "kjv_def": ":--impute, put on account.",
               "_strongs": "01677"
            },
            {
               "strongs": "1678",
               "greek": [
                  {
                     "_BETA": "*)ELMWDA/M",
                     "_unicode": "Ἐλμωδάμ",
                     "_translit": "Elmōdám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-mo-dam'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0486"
                     }
                  ],
                  "__text": "of Hebrew origin (perhaps for \n);"
               },
               "strongs_def": "Elmodam, an Israelite",
               "kjv_def": ":--Elmodam.",
               "_strongs": "01678"
            },
            {
               "strongs": "1679",
               "greek": [
                  {
                     "_BETA": "E)LPI/ZW",
                     "_unicode": "ἐλπίζω",
                     "_translit": "elpízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-pid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1680"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to expect or confide",
               "kjv_def": ":--(have, thing) hope(-d) (for), trust.",
               "_strongs": "01679"
            },
            {
               "strongs": "1680",
               "greek": [
                  {
                     "_BETA": "E)LPI/S",
                     "_unicode": "ἐλπίς",
                     "_translit": "elpís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-pece'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)/LPW",
                        "_unicode": "ἔλπω",
                        "_translit": "élpō"
                     }
                  ],
                  "__text": "from a primary \n (to anticipate, usually with pleasure);"
               },
               "strongs_def": "expectation (abstractly or concretely) or confidence",
               "kjv_def": ":--faith, hope.",
               "_strongs": "01680"
            },
            {
               "strongs": "1681",
               "greek": [
                  {
                     "_BETA": "*)ELU/MAS",
                     "_unicode": "Ἐλύμας",
                     "_translit": "Elýmas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-oo'-mas"
                  }
               ],
               "strongs_derivation": "of foreign origin;",
               "strongs_def": "Elymas, a wizard",
               "kjv_def": ":--Elymas.",
               "_strongs": "01681"
            },
            {
               "strongs": "1682",
               "greek": [
                  {
                     "_BETA": "E)LOI/+",
                     "_unicode": "ἐλοΐ",
                     "_translit": "eloḯ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "el-o-ee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0426"
                     }
                  ],
                  "__text": "of Chaldean origin (\n with pronominal suffix) my God"
               },
               "kjv_def": ":--Eloi.",
               "_strongs": "01682"
            },
            {
               "strongs": "1683",
               "greek": [
                  {
                     "_BETA": "E)MAUTOU=",
                     "_unicode": "ἐμαυτοῦ",
                     "_translit": "emautoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-ow-too'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1700"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "__text": "genitive case compound of \n and \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "E)MAUTW=|",
                        "_unicode": "ἐμαυτῷ",
                        "_translit": "emautōi"
                     },
                     {
                        "_BETA": "E)MAUTO/N",
                        "_unicode": "ἐμαυτόν",
                        "_translit": "emautón"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "em-ow-to'"
                     },
                     {
                        "_strongs": "em-ow-ton'"
                     }
                  ],
                  "__text": "of myself\n\n so likewise the dative case\n      \n  \n,\n\n and accusative case"
               },
               "kjv_def": ":--me, mine own (self), myself.",
               "_strongs": "01683"
            },
            {
               "strongs": "1684",
               "greek": [
                  {
                     "_BETA": "E)MBAI/NW",
                     "_unicode": "ἐμβαίνω",
                     "_translit": "embaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-ba'-hee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to walk on, i.e. embark (aboard a\n vessel), reach (a pool)",
               "kjv_def": ":--come (get) into, enter (into), go (up) into,\n step in, take ship.",
               "_strongs": "01684"
            },
            {
               "strongs": "1685",
               "greek": [
                  {
                     "_BETA": "E)MBA/LLW",
                     "_unicode": "ἐμβάλλω",
                     "_translit": "embállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-bal'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw on, i.e. (figuratively) subject to\n (eternal punishment)",
               "kjv_def": ":--cast into.",
               "_strongs": "01685"
            },
            {
               "strongs": "1686",
               "greek": [
                  {
                     "_BETA": "E)MBA/PTW",
                     "_unicode": "ἐμβάπτω",
                     "_translit": "embáptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-bap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "911"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to whelm on, i.e. wet (a part of the person, etc.)\n by contact with a fluid",
               "kjv_def": ":--dip.",
               "_strongs": "01686"
            },
            {
               "strongs": "1687",
               "greek": [
                  {
                     "_BETA": "E)MBATEU/W",
                     "_unicode": "ἐμβατεύω",
                     "_translit": "embateúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-bat-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and a presumed derivative of the base of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1684"
                     }
                  ],
                  "__text": "equivalent to\n \n; to intrude on (figuratively)"
               },
               "kjv_def": ":--intrude into.",
               "_strongs": "01687"
            },
            {
               "strongs": "1688",
               "greek": [
                  {
                     "_BETA": "E)MBIBA/ZW",
                     "_unicode": "ἐμβιβάζω",
                     "_translit": "embibázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-bib-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1684"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "BIBA/ZW",
                        "_unicode": "βιβάζω",
                        "_translit": "bibázō"
                     }
                  ],
                  "__text": "from \n and \n (to mount; causative of \n);"
               },
               "strongs_def": "to place on, i.e.\n transfer (aboard a vessel)",
               "kjv_def": ":--put in.",
               "_strongs": "01688"
            },
            {
               "strongs": "1689",
               "greek": [
                  {
                     "_BETA": "E)MBLE/PW",
                     "_unicode": "ἐμβλέπω",
                     "_translit": "emblépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-blep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to look on, i.e. (relatively) to observe fixedly,\n or (absolutely) to discern clearly",
               "kjv_def": ":--behold, gaze up, look upon,\n (could) see.",
               "_strongs": "01689"
            },
            {
               "strongs": "1690",
               "greek": [
                  {
                     "_BETA": "E)MBRIMA/OMAI",
                     "_unicode": "ἐμβριμάομαι",
                     "_translit": "embrimáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-brim-ah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "BRIMA/OMAI",
                        "_unicode": "βριμάομαι",
                        "_translit": "brimáomai"
                     }
                  ],
                  "__text": "from \n and \n (to snort with anger);"
               },
               "strongs_def": "to have indignation on,\n i.e. (transitively) to blame, (intransitively) to sigh with chagrin,\n (specially) to sternly enjoin",
               "kjv_def": ":--straitly charge, groan, murmur\n against.",
               "_strongs": "01690"
            },
            {
               "strongs": "1691",
               "greek": [
                  {
                     "_BETA": "E)ME/",
                     "_unicode": "ἐμέ",
                     "_translit": "emé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-eh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3165"
                     }
                  ],
                  "__text": "a prolonged form of \n;"
               },
               "strongs_def": "me",
               "kjv_def": ":--I, me, my(-self).",
               "_strongs": "01691"
            },
            {
               "strongs": "1692",
               "greek": [
                  {
                     "_BETA": "E)ME/W",
                     "_unicode": "ἐμέω",
                     "_translit": "eméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-eh'-o"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to vomit",
               "kjv_def": ":--(will) spue.",
               "_strongs": "01692"
            },
            {
               "strongs": "1693",
               "greek": [
                  {
                     "_BETA": "E)MMAI/NOMAI",
                     "_unicode": "ἐμμαίνομαι",
                     "_translit": "emmaínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-mah'-ee-nom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3105"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rave on, i.e. rage at",
               "kjv_def": ":--be mad against.",
               "_strongs": "01693"
            },
            {
               "strongs": "1694",
               "greek": [
                  {
                     "_BETA": "*)EMMANOUH/L",
                     "_unicode": "Ἐμμανουήλ",
                     "_translit": "Emmanouḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-man-oo-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06005"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "God with us; Emmanuel, a name of\n Christ",
               "kjv_def": ":--Emmanuel.",
               "_strongs": "01694"
            },
            {
               "strongs": "1695",
               "greek": [
                  {
                     "_BETA": "*)EMMAOU/S",
                     "_unicode": "Ἐμμαούς",
                     "_translit": "Emmaoús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-mah-ooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03222"
                     }
                  ],
                  "__text": "probably of Hebrew origin (compare \n);"
               },
               "strongs_def": "Emmaus, a place in\n Palestine",
               "kjv_def": ":--Emmaus.",
               "_strongs": "01695"
            },
            {
               "strongs": "1696",
               "greek": [
                  {
                     "_BETA": "E)MME/NW",
                     "_unicode": "ἐμμένω",
                     "_translit": "emménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-men'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stay in the same place, i.e. (figuratively)\n persevere",
               "kjv_def": ":--continue.",
               "_strongs": "01696"
            },
            {
               "strongs": "1697",
               "greek": [
                  {
                     "_BETA": "*)EMMO/R",
                     "_unicode": "Ἐμμόρ",
                     "_translit": "Emmór"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-mor'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02544"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Emmor (i.e. Chamor), a Canaanite",
               "kjv_def": ":--Emmor.",
               "_strongs": "01697"
            },
            {
               "strongs": "1698",
               "greek": [
                  {
                     "_BETA": "E)MOI/",
                     "_unicode": "ἐμοί",
                     "_translit": "emoí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-oy'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3427"
                     }
                  ],
                  "__text": "a prolonged form of \n;"
               },
               "strongs_def": "to me",
               "kjv_def": ":--I, me, mine, my.",
               "_strongs": "01698"
            },
            {
               "strongs": "1699",
               "greek": [
                  {
                     "_BETA": "E)MO/S",
                     "_unicode": "ἐμός",
                     "_translit": "emós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1473"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1698"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1700"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1691"
                     }
                  ],
                  "__text": "from the oblique cases of \n (\n, \n, \n);"
               },
               "strongs_def": "my",
               "kjv_def": ":--of me, mine\n (own), my.",
               "_strongs": "01699"
            },
            {
               "strongs": "1700",
               "greek": [
                  {
                     "_BETA": "E)MOU=",
                     "_unicode": "ἐμοῦ",
                     "_translit": "emoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-oo'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3449"
                     }
                  ],
                  "__text": "a prolonged form of \n;"
               },
               "strongs_def": "of me",
               "kjv_def": ":--me, mine, my.",
               "_strongs": "01700"
            },
            {
               "strongs": "1701",
               "greek": [
                  {
                     "_BETA": "E)MPAIGMO/S",
                     "_unicode": "ἐμπαιγμός",
                     "_translit": "empaigmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "emp-aheeg-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1702"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "derision",
               "kjv_def": ":--mocking.",
               "_strongs": "01701"
            },
            {
               "strongs": "1702",
               "greek": [
                  {
                     "_BETA": "E)MPAI/ZW",
                     "_unicode": "ἐμπαίζω",
                     "_translit": "empaízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "emp-aheed'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3815"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to jeer at, i.e. deride",
               "kjv_def": ":--mock.",
               "_strongs": "01702"
            },
            {
               "strongs": "1703",
               "greek": [
                  {
                     "_BETA": "E)MPAI/KTHS",
                     "_unicode": "ἐμπαίκτης",
                     "_translit": "empaíktēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "emp-aheek-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1702"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a derider, i.e. (by implication) a false teacher",
               "kjv_def": ":--mocker,\n scoffer.",
               "_strongs": "01703"
            },
            {
               "strongs": "1704",
               "greek": [
                  {
                     "_BETA": "E)MPERIPATE/W",
                     "_unicode": "ἐμπεριπατέω",
                     "_translit": "emperipatéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-per-ee-pat-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4043"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to perambulate on a place, i.e. (figuratively) to\n be occupied among persons",
               "kjv_def": ":--walk in.",
               "_strongs": "01704"
            },
            {
               "strongs": "1705",
               "greek": [
                  {
                     "_BETA": "E)MPI/PLHMI",
                     "_unicode": "ἐμπίπλημι",
                     "_translit": "empíplēmi"
                  },
                  {
                     "_BETA": "E)MPLH/QW",
                     "_unicode": "ἐμπλήθω",
                     "_translit": "emplḗthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-pip'-lay-mee"
                  },
                  {
                     "_strongs": "em-play'-tho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4118"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to fill in (up), i.e. (by implication)\n to satisfy (literally or figuratively)",
               "kjv_def": ":--fill.",
               "_strongs": "01705",
               "__text": "or"
            },
            {
               "strongs": "1706",
               "greek": [
                  {
                     "_BETA": "E)MPI/PTW",
                     "_unicode": "ἐμπίπτω",
                     "_translit": "empíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-pip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fall on, i.e. (literally) to be entrapped by,\n or (figuratively) be overwhelmed with",
               "kjv_def": ":--fall among (into).",
               "_strongs": "01706"
            },
            {
               "strongs": "1707",
               "greek": [
                  {
                     "_BETA": "E)MPLE/KW",
                     "_unicode": "ἐμπλέκω",
                     "_translit": "emplékō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-plek'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4120"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to entwine, i.e. (figuratively) involve\n with",
               "kjv_def": ":--entangle (in, self with).",
               "_strongs": "01707"
            },
            {
               "strongs": "1708",
               "greek": [
                  {
                     "_BETA": "E)MPLOKH/",
                     "_unicode": "ἐμπλοκή",
                     "_translit": "emplokḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-plok-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1707"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "elaborate braiding of the hair",
               "kjv_def": ":--plaiting.",
               "_strongs": "01708"
            },
            {
               "strongs": "1709",
               "greek": [
                  {
                     "_BETA": "E)MPNE/W",
                     "_unicode": "ἐμπνέω",
                     "_translit": "empnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "emp-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4154"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to inhale, i.e. (figuratively) to be animated by\n (bent upon)",
               "kjv_def": ":--breathe.",
               "_strongs": "01709"
            },
            {
               "strongs": "1710",
               "greek": [
                  {
                     "_BETA": "E)MPOREU/OMAI",
                     "_unicode": "ἐμπορεύομαι",
                     "_translit": "emporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-por-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to travel in (a country as a pedlar), i.e. (by\n implication) to trade",
               "kjv_def": ":--buy and sell, make merchandise.",
               "_strongs": "01710"
            },
            {
               "strongs": "1711",
               "greek": [
                  {
                     "_BETA": "E)MPORI/A",
                     "_unicode": "ἐμπορία",
                     "_translit": "emporía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-por-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1713"
                     }
                  ],
                  "__text": "feminine from \n;"
               },
               "strongs_def": "traffic",
               "kjv_def": ":--merchandise.",
               "_strongs": "01711"
            },
            {
               "strongs": "1712",
               "greek": [
                  {
                     "_BETA": "E)MPO/RION",
                     "_unicode": "ἐμπόριον",
                     "_translit": "empórion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-por'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1713"
                     }
                  ],
                  "__text": "neuter from \n;"
               },
               "strongs_def": "a mart (\"emporium\")",
               "kjv_def": ":--merchandise.",
               "_strongs": "01712"
            },
            {
               "strongs": "1713",
               "greek": [
                  {
                     "_BETA": "E)/MPOROS",
                     "_unicode": "ἔμπορος",
                     "_translit": "émporos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em'-por-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "a (wholesale) tradesman",
               "kjv_def": ":--merchant.",
               "_strongs": "01713"
            },
            {
               "strongs": "1714",
               "greek": [
                  {
                     "_BETA": "E)MPRH/QW",
                     "_unicode": "ἐμπρήθω",
                     "_translit": "emprḗthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-pray'-tho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "PRH/QW",
                        "_unicode": "πρήθω",
                        "_translit": "prḗthō"
                     }
                  ],
                  "__text": "from \n and \n (to blow a flame);"
               },
               "strongs_def": "to enkindle, i.e. set on\n fire",
               "kjv_def": ":--burn up.",
               "_strongs": "01714"
            },
            {
               "strongs": "1715",
               "greek": [
                  {
                     "_BETA": "E)/MPROSQEN",
                     "_unicode": "ἔμπροσθεν",
                     "_translit": "émprosthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em'-pros-then"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "in front of (in place (literally or figuratively)\n or time)",
               "kjv_def": ":--against, at, before, (in presence, sight) of.",
               "_strongs": "01715"
            },
            {
               "strongs": "1716",
               "greek": [
                  {
                     "_BETA": "E)MPTU/W",
                     "_unicode": "ἐμπτύω",
                     "_translit": "emptýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "emp-too'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4429"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to spit at or on",
               "kjv_def": ":--spit (upon).",
               "_strongs": "01716"
            },
            {
               "strongs": "1717",
               "greek": [
                  {
                     "_BETA": "E)MFANH/S",
                     "_unicode": "ἐμφανής",
                     "_translit": "emphanḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-fan-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "apparent in self",
               "kjv_def": ":--manifest, openly.",
               "_strongs": "01717"
            },
            {
               "strongs": "1718",
               "greek": [
                  {
                     "_BETA": "E)MFANI/ZW",
                     "_unicode": "ἐμφανίζω",
                     "_translit": "emphanízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-fan-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1717"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to exhibit (in person) or disclose (by words)",
               "kjv_def": ":--appear,\n declare (plainly), inform, (will) manifest, shew, signify.",
               "_strongs": "01718"
            },
            {
               "strongs": "1719",
               "greek": [
                  {
                     "_BETA": "E)/MFOBOS",
                     "_unicode": "ἔμφοβος",
                     "_translit": "émphobos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em'-fob-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5401"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "in fear, i.e. alarmed",
               "kjv_def": ":--affrighted, afraid,\n tremble.",
               "_strongs": "01719"
            },
            {
               "strongs": "1720",
               "greek": [
                  {
                     "_BETA": "E)MFUSA/W",
                     "_unicode": "ἐμφυσάω",
                     "_translit": "emphysáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em-foo-sah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "FUSA/W",
                        "_unicode": "φυσάω",
                        "_translit": "physáō"
                     }
                  ],
                  "__text": "from \n and \n (to puff) (compare \n);"
               },
               "strongs_def": "to blow at or\n on",
               "kjv_def": ":--breathe on.",
               "_strongs": "01720"
            },
            {
               "strongs": "1721",
               "greek": [
                  {
                     "_BETA": "E)/MFUTOS",
                     "_unicode": "ἔμφυτος",
                     "_translit": "émphytos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "em'-foo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "implanted\n (figuratively)",
               "kjv_def": ":--engrafted.",
               "_strongs": "01721"
            },
            {
               "strongs": "1722",
               "greek": [
                  {
                     "_BETA": "E)N",
                     "_unicode": "ἐν",
                     "_translit": "en"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "__text": "a primary preposition denoting (fixed) position (in place, time or\n state), and (by implication) instrumentality (medially or\n constructively), i.e. a relation of rest (intermediate between \n\n and \n);"
               },
               "strongs_def": "\"in,\" at, (up-)on, by, etc.",
               "kjv_def": ":--about, after, against, +\n almost, X altogether, among, X as, at, before, between, (here-)by (+\n all means), for (… sake of), + give self wholly to, (here-)in(-to,\n -wardly), X mightily, (because) of, (up-)on, (open-)ly, X outwardly,\n one, X quickly,\n X shortly, (speedi-)ly, X that, X there(-in, -on),\n through(-out), (un-)to(-ward), under, when, where(-with), while,\n with(-in).",
               "_strongs": "01722",
               "__text": "Often used in compounds, with substantially the same\n import; rarely with verbs of motion, and then not to indicate\n direction, except (elliptically) by a separate (and different)\n preposition."
            },
            {
               "strongs": "1723",
               "greek": [
                  {
                     "_BETA": "E)NAGKALI/ZOMAI",
                     "_unicode": "ἐναγκαλίζομαι",
                     "_translit": "enankalízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-ang-kal-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to take in one's arms, i.e.\n embrace",
               "kjv_def": ":--take up in arms.",
               "_strongs": "01723"
            },
            {
               "strongs": "1724",
               "greek": [
                  {
                     "_BETA": "E)NA/LIOS",
                     "_unicode": "ἐνάλιος",
                     "_translit": "enálios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-al'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "in the sea, i.e. marine",
               "kjv_def": ":--thing in the sea.",
               "_strongs": "01724"
            },
            {
               "strongs": "1725",
               "greek": [
                  {
                     "_BETA": "E)/NANTI",
                     "_unicode": "ἔναντι",
                     "_translit": "énanti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-an-tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "in front (i.e. figuratively, presence) of",
               "kjv_def": ":--before.",
               "_strongs": "01725"
            },
            {
               "strongs": "1726",
               "greek": [
                  {
                     "_BETA": "E)NANTI/ON",
                     "_unicode": "ἐναντίον",
                     "_translit": "enantíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-an-tee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1727"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": "(adverbially) in the presence (view) of",
               "kjv_def": ":--before, in\n the presence of.",
               "_strongs": "01726"
            },
            {
               "strongs": "1727",
               "greek": [
                  {
                     "_BETA": "E)NANTI/OS",
                     "_unicode": "ἐναντίος",
                     "_translit": "enantíos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-an-tee'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1725"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "opposite; figuratively, antagonistic",
               "kjv_def": ":--(over) against,\n contrary.",
               "_strongs": "01727"
            },
            {
               "strongs": "1728",
               "greek": [
                  {
                     "_BETA": "E)NA/RXOMAI",
                     "_unicode": "ἐνάρχομαι",
                     "_translit": "enárchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-ar'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "756"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to commence on",
               "kjv_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": ":--rule (by mistake for \n)."
               },
               "_strongs": "01728"
            },
            {
               "strongs": "1729",
               "greek": [
                  {
                     "_BETA": "E)NDEH/S",
                     "_unicode": "ἐνδεής",
                     "_translit": "endeḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-deh-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "from a compound of \n and \n (in the sense of lacking);"
               },
               "strongs_def": "deficient\n in",
               "kjv_def": ":--lacking.",
               "_strongs": "01729"
            },
            {
               "strongs": "1730",
               "greek": [
                  {
                     "_BETA": "E)/NDEIGMA",
                     "_unicode": "ἔνδειγμα",
                     "_translit": "éndeigma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-dighe-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1731"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an indication (concretely)",
               "kjv_def": ":--manifest token.",
               "_strongs": "01730"
            },
            {
               "strongs": "1731",
               "greek": [
                  {
                     "_BETA": "E)NDEI/KNUMI",
                     "_unicode": "ἐνδείκνυμι",
                     "_translit": "endeíknymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-dike'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1166"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to indicate (by word or act)",
               "kjv_def": ":--do, show (forth).",
               "_strongs": "01731"
            },
            {
               "strongs": "1732",
               "greek": [
                  {
                     "_BETA": "E)/NDEICIS",
                     "_unicode": "ἔνδειξις",
                     "_translit": "éndeixis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-dike-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1731"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "indication (abstractly)",
               "kjv_def": ":--declare, evident token, proof.",
               "_strongs": "01732"
            },
            {
               "strongs": "1733",
               "greek": [
                  {
                     "_BETA": "E(/NDEKA",
                     "_unicode": "ἕνδεκα",
                     "_translit": "héndeka"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hen'-dek-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1520"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1176"
                     }
                  ],
                  "__text": "from (the neuter of) \n and \n;"
               },
               "strongs_def": "one and ten, i.e. eleven",
               "kjv_def": ":--eleven.",
               "_strongs": "01733"
            },
            {
               "strongs": "1734",
               "greek": [
                  {
                     "_BETA": "E(NDE/KATOS",
                     "_unicode": "ἑνδέκατος",
                     "_translit": "hendékatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hen-dek'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1733"
                     }
                  ],
                  "__text": "ordinal from \n;"
               },
               "strongs_def": "eleventh",
               "kjv_def": ":--eleventh.",
               "_strongs": "01734"
            },
            {
               "strongs": "1735",
               "greek": [
                  {
                     "_BETA": "E)NDE/XETAI",
                     "_unicode": "ἐνδέχεται",
                     "_translit": "endéchetai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-dekh'-et-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "third person singular present of a compound of \n and \n;"
               },
               "strongs_def": "(impersonally) it is accepted in, i.e. admitted (possible)",
               "kjv_def": ":--can (+\n not) be.",
               "_strongs": "01735"
            },
            {
               "strongs": "1736",
               "greek": [
                  {
                     "_BETA": "E)NDHME/W",
                     "_unicode": "ἐνδημέω",
                     "_translit": "endēméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-day-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be in one's own country, i.e.\n home (figuratively)",
               "kjv_def": ":--be at home (present).",
               "_strongs": "01736"
            },
            {
               "strongs": "1737",
               "greek": [
                  {
                     "_BETA": "E)NDIDU/SKW",
                     "_unicode": "ἐνδιδύσκω",
                     "_translit": "endidýskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-did-oos'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1746"
                     }
                  ],
                  "__text": "a prolonged form of \n;"
               },
               "strongs_def": "to invest (with a garment)",
               "kjv_def": ":--clothe in,\n wear.",
               "_strongs": "01737"
            },
            {
               "strongs": "1738",
               "greek": [
                  {
                     "_BETA": "E)/NDIKOS",
                     "_unicode": "ἔνδικος",
                     "_translit": "éndikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-dee-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "in the right, i.e. equitable",
               "kjv_def": ":--just.",
               "_strongs": "01738"
            },
            {
               "strongs": "1739",
               "greek": [
                  {
                     "_BETA": "E)NDO/MHSIS",
                     "_unicode": "ἐνδόμησις",
                     "_translit": "endómēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-dom'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of the base of \n;"
               },
               "strongs_def": "a\n housing in (residence), i.e. structure",
               "kjv_def": ":--building.",
               "_strongs": "01739"
            },
            {
               "strongs": "1740",
               "greek": [
                  {
                     "_BETA": "E)NDOCA/ZW",
                     "_unicode": "ἐνδοξάζω",
                     "_translit": "endoxázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-dox-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1741"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to glorify",
               "kjv_def": ":--glorify.",
               "_strongs": "01740"
            },
            {
               "strongs": "1741",
               "greek": [
                  {
                     "_BETA": "E)/NDOCOS",
                     "_unicode": "ἔνδοξος",
                     "_translit": "éndoxos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-dox-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1391"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "in glory, i.e. splendid, (figuratively)\n noble",
               "kjv_def": ":--glorious, gorgeous(-ly), honourable.",
               "_strongs": "01741"
            },
            {
               "strongs": "1742",
               "greek": [
                  {
                     "_BETA": "E)/NDUMA",
                     "_unicode": "ἔνδυμα",
                     "_translit": "éndyma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-doo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1746"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "apparel (especially the outer robe)",
               "kjv_def": ":--clothing, garment,\n raiment.",
               "_strongs": "01742"
            },
            {
               "strongs": "1743",
               "greek": [
                  {
                     "_BETA": "E)NDUNAMO/W",
                     "_unicode": "ἐνδυναμόω",
                     "_translit": "endynamóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-doo-nam-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1412"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to empower",
               "kjv_def": ":--enable, (increase in) strength(-en),\n be (make) strong.",
               "_strongs": "01743"
            },
            {
               "strongs": "1744",
               "greek": [
                  {
                     "_BETA": "E)NDU/NW",
                     "_unicode": "ἐνδύνω",
                     "_translit": "endýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-doo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1772"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1416"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1746"
                     }
                  ],
                  "__text": "to sink (by implication, wrap (compare \n) on,\n i.e. (figuratively) sneak"
               },
               "kjv_def": ":--creep.",
               "_strongs": "01744"
            },
            {
               "strongs": "1745",
               "greek": [
                  {
                     "_BETA": "E)/NDUSIS",
                     "_unicode": "ἔνδυσις",
                     "_translit": "éndysis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-doo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1746"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "investment with clothing",
               "kjv_def": ":--putting on.",
               "_strongs": "01745"
            },
            {
               "strongs": "1746",
               "greek": [
                  {
                     "_BETA": "E)NDU/W",
                     "_unicode": "ἐνδύω",
                     "_translit": "endýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-doo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1416"
                     }
                  ],
                  "__text": "from \n and \n (in the sense of sinking into a garment);"
               },
               "strongs_def": "to invest\n with clothing (literally or figuratively)",
               "kjv_def": ":--array, clothe (with),\n endue, have (put) on.",
               "_strongs": "01746"
            },
            {
               "strongs": "1747",
               "greek": [
                  {
                     "_BETA": "E)NE/DRA",
                     "_unicode": "ἐνέδρα",
                     "_translit": "enédra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-ed'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "feminine from \n and the base of \n;"
               },
               "strongs_def": "an ambuscade, i.e.\n (figuratively) murderous purpose",
               "kjv_def": ":--lay wait.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1749"
                  }
               ],
               "_strongs": "01747",
               "__text": "See also \n."
            },
            {
               "strongs": "1748",
               "greek": [
                  {
                     "_BETA": "E)NEDREU/W",
                     "_unicode": "ἐνεδρεύω",
                     "_translit": "enedreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-ed-ryoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1747"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to lurk, i.e. (figuratively) plot assassination",
               "kjv_def": ":--lay wait\n for.",
               "_strongs": "01748"
            },
            {
               "strongs": "1749",
               "greek": [
                  {
                     "_BETA": "E)/NEDRON",
                     "_unicode": "ἔνεδρον",
                     "_translit": "énedron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-ed-ron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1747"
                     }
                  ],
                  "__text": "neuter of the same as \n;"
               },
               "strongs_def": "an ambush, i.e. (figuratively) murderous\n design",
               "kjv_def": ":--lying in wait.",
               "_strongs": "01749"
            },
            {
               "strongs": "1750",
               "greek": [
                  {
                     "_BETA": "E)NEILE/W",
                     "_unicode": "ἐνειλέω",
                     "_translit": "eneiléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-i-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1772"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1507"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to enwrap",
               "kjv_def": ":--wrap in.",
               "_strongs": "01750"
            },
            {
               "strongs": "1751",
               "greek": [
                  {
                     "_BETA": "E)/NEIMI",
                     "_unicode": "ἔνειμι",
                     "_translit": "éneimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1772"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be within (neuter participle plural)",
               "kjv_def": ":--such\n things as … have.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1762"
                  }
               ],
               "_strongs": "01751",
               "__text": "See also \n."
            },
            {
               "strongs": "1752",
               "greek": [
                  {
                     "_BETA": "E(/NEKA",
                     "_unicode": "ἕνεκα",
                     "_translit": "héneka"
                  },
                  {
                     "_BETA": "E(/NEKEN",
                     "_unicode": "ἕνεκεν",
                     "_translit": "héneken"
                  },
                  {
                     "_BETA": "EI(/NEKEN",
                     "_unicode": "εἵνεκεν",
                     "_translit": "heíneken"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hen'-ek-ah"
                  },
                  {
                     "_strongs": "hen'-ek-en"
                  },
                  {
                     "_strongs": "hi'-nek-en"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "on account of",
               "kjv_def": ":--because, for (cause, sake),\n (where-)fore, by reason of, that.",
               "_strongs": "01752",
               "__text": "or \n  \n\n  or"
            },
            {
               "strongs": "1753",
               "greek": [
                  {
                     "_BETA": "E)NE/RGEIA",
                     "_unicode": "ἐνέργεια",
                     "_translit": "enérgeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-erg'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1756"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "efficiency (\"energy\")",
               "kjv_def": ":--operation, strong, (effectual)\n working.",
               "_strongs": "01753"
            },
            {
               "strongs": "1754",
               "greek": [
                  {
                     "_BETA": "E)NERGE/W",
                     "_unicode": "ἐνεργέω",
                     "_translit": "energéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-erg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1756"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be active, efficient",
               "kjv_def": ":--do, (be) effectual (fervent), be\n mighty in, shew forth self, work (effectually in).",
               "_strongs": "01754"
            },
            {
               "strongs": "1755",
               "greek": [
                  {
                     "_BETA": "E)NE/RGHMA",
                     "_unicode": "ἐνέργημα",
                     "_translit": "enérgēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-erg'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1754"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an effect",
               "kjv_def": ":--operation, working.",
               "_strongs": "01755"
            },
            {
               "strongs": "1756",
               "greek": [
                  {
                     "_BETA": "E)NERGH/S",
                     "_unicode": "ἐνεργής",
                     "_translit": "energḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-er-gace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "active, operative",
               "kjv_def": ":--effectual, powerful.",
               "_strongs": "01756"
            },
            {
               "strongs": "1757",
               "greek": [
                  {
                     "_BETA": "E)NEULOGE/W",
                     "_unicode": "ἐνευλογέω",
                     "_translit": "eneulogéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-yoo-log-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2127"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to confer a benefit on",
               "kjv_def": ":--bless.",
               "_strongs": "01757"
            },
            {
               "strongs": "1758",
               "greek": [
                  {
                     "_BETA": "E)NE/XW",
                     "_unicode": "ἐνέχω",
                     "_translit": "enéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hold in or upon, i.e. ensnare; by implication,\n to keep a grudge",
               "kjv_def": ":--entangle with, have a quarrel against, urge.",
               "_strongs": "01758"
            },
            {
               "strongs": "1759",
               "greek": [
                  {
                     "_BETA": "E)NQA/DE",
                     "_unicode": "ἐνθάδε",
                     "_translit": "entháde"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-thad'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     }
                  ],
                  "__text": "from a prolonged form of \n;"
               },
               "strongs_def": "properly, within, i.e. (of place) here,\n hither",
               "kjv_def": ":--(t-)here, hither.",
               "_strongs": "01759"
            },
            {
               "strongs": "1760",
               "greek": [
                  {
                     "_BETA": "E)NQUME/OMAI",
                     "_unicode": "ἐνθυμέομαι",
                     "_translit": "enthyméomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-thoo-meh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be inspirited, i.e.\n ponder",
               "kjv_def": ":--think.",
               "_strongs": "01760"
            },
            {
               "strongs": "1761",
               "greek": [
                  {
                     "_BETA": "E)NQU/MHSIS",
                     "_unicode": "ἐνθύμησις",
                     "_translit": "enthýmēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-thoo'-may-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1760"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "deliberation",
               "kjv_def": ":--device, thought.",
               "_strongs": "01761"
            },
            {
               "strongs": "1762",
               "greek": [
                  {
                     "_BETA": "E)/NI",
                     "_unicode": "ἔνι",
                     "_translit": "éni"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1751"
                     }
                  ],
                  "__text": "contraction for the third person singular present indicative of \n;"
               },
               "strongs_def": "impersonally, there is in or among",
               "kjv_def": ":--be, (there) is.",
               "_strongs": "01762"
            },
            {
               "strongs": "1763",
               "greek": [
                  {
                     "_BETA": "E)NIAUTO/S",
                     "_unicode": "ἐνιαυτός",
                     "_translit": "eniautós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-ee-ow-tos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)/NOS",
                        "_unicode": "ἔνος",
                        "_translit": "énos"
                     }
                  ],
                  "__text": "prolongation from a primary \n (a year);"
               },
               "strongs_def": "a year",
               "kjv_def": ":--year.",
               "_strongs": "01763"
            },
            {
               "strongs": "1764",
               "greek": [
                  {
                     "_BETA": "E)NI/STHMI",
                     "_unicode": "ἐνίστημι",
                     "_translit": "enístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to place on hand, i.e. (reflexively) impend,\n (participle) be instant",
               "kjv_def": ":--come, be at hand, present.",
               "_strongs": "01764"
            },
            {
               "strongs": "1765",
               "greek": [
                  {
                     "_BETA": "E)NISXU/W",
                     "_unicode": "ἐνισχύω",
                     "_translit": "enischýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-is-khoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2480"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to invigorate (transitively or\n reflexively)",
               "kjv_def": ":--strengthen.",
               "_strongs": "01765"
            },
            {
               "strongs": "1766",
               "greek": [
                  {
                     "_BETA": "E)/NNATOS",
                     "_unicode": "ἔννατος",
                     "_translit": "énnatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-nat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1767"
                     }
                  ],
                  "__text": "ordinal from \n;"
               },
               "strongs_def": "ninth",
               "kjv_def": ":--ninth.",
               "_strongs": "01766"
            },
            {
               "strongs": "1767",
               "greek": [
                  {
                     "_BETA": "E)NNE/A",
                     "_unicode": "ἐννέα",
                     "_translit": "ennéa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-neh'-ah"
                  }
               ],
               "strongs_derivation": "a primary number;",
               "strongs_def": "nine",
               "kjv_def": ":--nine.",
               "_strongs": "01767"
            },
            {
               "strongs": "1768",
               "greek": [
                  {
                     "_BETA": "E)NNENHKONTAENNE/A",
                     "_unicode": "ἐννενηκονταεννέα",
                     "_translit": "ennenēkontaennéa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-nen-ay-kon-tah-en-neh'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1767"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1767"
                     }
                  ],
                  "__text": "from a (tenth) multiple of \n and \n itself;"
               },
               "strongs_def": "ninety-nine",
               "kjv_def": ":--ninety\n and nine.",
               "_strongs": "01768"
            },
            {
               "strongs": "1769",
               "greek": [
                  {
                     "_BETA": "E)NNEO/S",
                     "_unicode": "ἐννεός",
                     "_translit": "enneós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-neh-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1770"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "dumb (as making signs), i.e. silent from\n astonishment",
               "kjv_def": ":--speechless.",
               "_strongs": "01769"
            },
            {
               "strongs": "1770",
               "greek": [
                  {
                     "_BETA": "E)NNEU/W",
                     "_unicode": "ἐννεύω",
                     "_translit": "enneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-nyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3506"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to nod at, i.e. beckon or communicate by\n gesture",
               "kjv_def": ":--make signs.",
               "_strongs": "01770"
            },
            {
               "strongs": "1771",
               "greek": [
                  {
                     "_BETA": "E)/NNOIA",
                     "_unicode": "ἔννοια",
                     "_translit": "énnoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-noy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "thoughtfulness, i.e. moral\n understanding",
               "kjv_def": ":--intent, mind.",
               "_strongs": "01771"
            },
            {
               "strongs": "1772",
               "greek": [
                  {
                     "_BETA": "E)/NNOMOS",
                     "_unicode": "ἔννομος",
                     "_translit": "énnomos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-nom-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(subjectively) legal, or (objectively) subject\n to",
               "kjv_def": ":--lawful, under law.",
               "_strongs": "01772"
            },
            {
               "strongs": "1773",
               "greek": [
                  {
                     "_BETA": "E)/NNUXON",
                     "_unicode": "ἔννυχον",
                     "_translit": "énnychon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-noo-khon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3571"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n;"
               },
               "strongs_def": "(adverbially) by night",
               "kjv_def": ":--before\n day.",
               "_strongs": "01773"
            },
            {
               "strongs": "1774",
               "greek": [
                  {
                     "_BETA": "E)NOIKE/W",
                     "_unicode": "ἐνοικέω",
                     "_translit": "enoikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-oy-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to inhabit (figuratively)",
               "kjv_def": ":--dwell in.",
               "_strongs": "01774"
            },
            {
               "strongs": "1775",
               "greek": [
                  {
                     "_BETA": "E(NO/THS",
                     "_unicode": "ἑνότης",
                     "_translit": "henótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hen-ot-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1520"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "oneness, i.e. (figuratively) unanimity",
               "kjv_def": ":--unity.",
               "_strongs": "01775"
            },
            {
               "strongs": "1776",
               "greek": [
                  {
                     "_BETA": "E)NOXLE/W",
                     "_unicode": "ἐνοχλέω",
                     "_translit": "enochléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-okh-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3791"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to crowd in, i.e. (figuratively) to\n annoy",
               "kjv_def": ":--trouble.",
               "_strongs": "01776"
            },
            {
               "strongs": "1777",
               "greek": [
                  {
                     "_BETA": "E)/NOXOS",
                     "_unicode": "ἔνοχος",
                     "_translit": "énochos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-okh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1758"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "liable to (a condition, penalty or imputation)",
               "kjv_def": ":--in danger\n of, guilty of, subject to.",
               "_strongs": "01777"
            },
            {
               "strongs": "1778",
               "greek": [
                  {
                     "_BETA": "E)/NTALMA",
                     "_unicode": "ἔνταλμα",
                     "_translit": "éntalma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-tal-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1781"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an injunction, i.e. religious precept",
               "kjv_def": ":--commandment.",
               "_strongs": "01778"
            },
            {
               "strongs": "1779",
               "greek": [
                  {
                     "_BETA": "E)NTAFIA/ZW",
                     "_unicode": "ἐνταφιάζω",
                     "_translit": "entaphiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-taf-ee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5028"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to inswathe with cerements for\n interment",
               "kjv_def": ":--bury.",
               "_strongs": "01779"
            },
            {
               "strongs": "1780",
               "greek": [
                  {
                     "_BETA": "E)NTAFIASMO/S",
                     "_unicode": "ἐνταφιασμός",
                     "_translit": "entaphiasmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-taf-ee-as-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1779"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "preparation for interment",
               "kjv_def": ":--burying.",
               "_strongs": "01780"
            },
            {
               "strongs": "1781",
               "greek": [
                  {
                     "_BETA": "E)NTE/LLOMAI",
                     "_unicode": "ἐντέλλομαι",
                     "_translit": "entéllomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-tel'-lom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to enjoin",
               "kjv_def": ":--(give) charge, (give)\n command(-ments), injoin.",
               "_strongs": "01781"
            },
            {
               "strongs": "1782",
               "greek": [
                  {
                     "_BETA": "E)NTEU=QEN",
                     "_unicode": "ἐντεῦθεν",
                     "_translit": "enteûthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ent-yoo'-then"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1759"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "hence (literally or figuratively); (repeated)\n on both sides",
               "kjv_def": ":--(from) hence, on either side.",
               "_strongs": "01782"
            },
            {
               "strongs": "1783",
               "greek": [
                  {
                     "_BETA": "E)/NTEUCIS",
                     "_unicode": "ἔντευξις",
                     "_translit": "énteuxis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ent'-yook-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1793"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an interview, i.e. (specially) supplication",
               "kjv_def": ":--intercession,\n prayer.",
               "_strongs": "01783"
            },
            {
               "strongs": "1784",
               "greek": [
                  {
                     "_BETA": "E)/NTIMOS",
                     "_unicode": "ἔντιμος",
                     "_translit": "éntimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-tee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "valued (figuratively)",
               "kjv_def": ":--dear, more honourable,\n precious, in reputation.",
               "_strongs": "01784"
            },
            {
               "strongs": "1785",
               "greek": [
                  {
                     "_BETA": "E)NTOLH/",
                     "_unicode": "ἐντολή",
                     "_translit": "entolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-tol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1781"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "injunction, i.e. an authoritative\n prescription",
               "kjv_def": ":--commandment, precept.",
               "_strongs": "01785"
            },
            {
               "strongs": "1786",
               "greek": [
                  {
                     "_BETA": "E)NTO/PIOS",
                     "_unicode": "ἐντόπιος",
                     "_translit": "entópios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-top'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5117"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a resident",
               "kjv_def": ":--of that place.",
               "_strongs": "01786"
            },
            {
               "strongs": "1787",
               "greek": [
                  {
                     "_BETA": "E)NTO/S",
                     "_unicode": "ἐντός",
                     "_translit": "entós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inside (adverb or noun)",
               "kjv_def": ":--within.",
               "_strongs": "01787"
            },
            {
               "strongs": "1788",
               "greek": [
                  {
                     "_BETA": "E)NTRE/PW",
                     "_unicode": "ἐντρέπω",
                     "_translit": "entrépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-trep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to invert, i.e. (figuratively and\n reflexively) in a good sense, to respect; or in a bad one, to\n confound",
               "kjv_def": ":--regard, (give) reference, shame.",
               "_strongs": "01788"
            },
            {
               "strongs": "1789",
               "greek": [
                  {
                     "_BETA": "E)NTRE/FW",
                     "_unicode": "ἐντρέφω",
                     "_translit": "entréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(figuratively) to educate",
               "kjv_def": ":--nourish up in.",
               "_strongs": "01789"
            },
            {
               "strongs": "1790",
               "greek": [
                  {
                     "_BETA": "E)/NTROMOS",
                     "_unicode": "ἔντρομος",
                     "_translit": "éntromos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en'-trom-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5156"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "terrified",
               "kjv_def": ":--X quake, X trembled.",
               "_strongs": "01790"
            },
            {
               "strongs": "1791",
               "greek": [
                  {
                     "_BETA": "E)NTROPH/",
                     "_unicode": "ἐντροπή",
                     "_translit": "entropḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-trop-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1788"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "confusion",
               "kjv_def": ":--shame.",
               "_strongs": "01791"
            },
            {
               "strongs": "1792",
               "greek": [
                  {
                     "_BETA": "E)NTRUFA/W",
                     "_unicode": "ἐντρυφάω",
                     "_translit": "entrypháō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-troo-fah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5171"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to revel in",
               "kjv_def": ":--sporting selves.",
               "_strongs": "01792"
            },
            {
               "strongs": "1793",
               "greek": [
                  {
                     "_BETA": "E)NTUGXA/NW",
                     "_unicode": "ἐντυγχάνω",
                     "_translit": "entynchánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-toong-khan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5177"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to chance upon, i.e. (by implication) confer with;\n by extension to entreat (in favor or against)",
               "kjv_def": ":--deal with, make\n intercession.",
               "_strongs": "01793"
            },
            {
               "strongs": "1794",
               "greek": [
                  {
                     "_BETA": "E)NTULI/SSW",
                     "_unicode": "ἐντυλίσσω",
                     "_translit": "entylíssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-too-lis'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1507"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TULI/SSW",
                        "_unicode": "τυλίσσω",
                        "_translit": "tylíssō"
                     }
                  ],
                  "__text": "from \n and \n (to twist; probably akin to \n);"
               },
               "strongs_def": "to entwine,\n i.e. wind up in",
               "kjv_def": ":--wrap in (together).",
               "_strongs": "01794"
            },
            {
               "strongs": "1795",
               "greek": [
                  {
                     "_BETA": "E)NTUPO/W",
                     "_unicode": "ἐντυπόω",
                     "_translit": "entypóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-too-po'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5179"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to enstamp, i.e.\n engrave",
               "kjv_def": ":--engrave.",
               "_strongs": "01795"
            },
            {
               "strongs": "1796",
               "greek": [
                  {
                     "_BETA": "E)NUBRI/ZW",
                     "_unicode": "ἐνυβρίζω",
                     "_translit": "enybrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-oo-brid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5195"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to insult",
               "kjv_def": ":--do despite unto.",
               "_strongs": "01796"
            },
            {
               "strongs": "1797",
               "greek": [
                  {
                     "_BETA": "E)NUPNIA/ZOMAI",
                     "_unicode": "ἐνυπνιάζομαι",
                     "_translit": "enypniázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-oop-nee-ad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1798"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to dream",
               "kjv_def": ":--dream(-er).",
               "_strongs": "01797"
            },
            {
               "strongs": "1798",
               "greek": [
                  {
                     "_BETA": "E)NU/PNION",
                     "_unicode": "ἐνύπνιον",
                     "_translit": "enýpnion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-oop'-nee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5258"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "something seen in sleep, i.e. a dream (vision in a\n dream)",
               "kjv_def": ":--dream.",
               "_strongs": "01798"
            },
            {
               "strongs": "1799",
               "greek": [
                  {
                     "_BETA": "E)NW/PION",
                     "_unicode": "ἐνώπιον",
                     "_translit": "enṓpion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-o'-pee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "neuter of a compound of \n and a derivative of \n;"
               },
               "strongs_def": "in the face of\n (literally or figuratively)",
               "kjv_def": ":--before, in the presence (sight) of, to.",
               "_strongs": "01799"
            },
            {
               "strongs": "1800",
               "greek": [
                  {
                     "_BETA": "*)ENW/S",
                     "_unicode": "Ἐνώς",
                     "_translit": "Enṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0583"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Enos (i.e. Enosh), a patriarch",
               "kjv_def": ":--Enos.",
               "_strongs": "01800"
            },
            {
               "strongs": "1801",
               "greek": [
                  {
                     "_BETA": "E)NWTI/ZOMAI",
                     "_unicode": "ἐνωτίζομαι",
                     "_translit": "enōtízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-o-tid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3775"
                     }
                  ],
                  "__text": "middle voice from a compound of \n and \n;"
               },
               "strongs_def": "to take in one's ear,\n i.e. to listen",
               "kjv_def": ":--hearken.",
               "_strongs": "01801"
            },
            {
               "strongs": "1802",
               "greek": [
                  {
                     "_BETA": "*)ENW/X",
                     "_unicode": "Ἐνώχ",
                     "_translit": "Enṓch"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "en-oke'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02585"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Enoch (i.e. Chanok), an antediluvian",
               "kjv_def": ":--Enoch.",
               "_strongs": "01802"
            },
            {
               "strongs": "1803",
               "greek": [
                  {
                     "_BETA": "E(/C",
                     "_unicode": "ἕξ",
                     "_translit": "héx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hex"
                  }
               ],
               "strongs_derivation": "a primary numeral;",
               "strongs_def": "six",
               "kjv_def": ":--six.",
               "_strongs": "01803"
            },
            {
               "strongs": "1804",
               "greek": [
                  {
                     "_BETA": "E)CAGGE/LLW",
                     "_unicode": "ἐξαγγέλλω",
                     "_translit": "exangéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ang-el'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to publish, i.e. celebrate",
               "kjv_def": ":--shew forth.",
               "_strongs": "01804"
            },
            {
               "strongs": "1805",
               "greek": [
                  {
                     "_BETA": "E)CAGORA/ZW",
                     "_unicode": "ἐξαγοράζω",
                     "_translit": "exagorázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ag-or-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "59"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to buy up, i.e. ransom; figuratively, to rescue from\n loss (improve opportunity)",
               "kjv_def": ":--redeem.",
               "_strongs": "01805"
            },
            {
               "strongs": "1806",
               "greek": [
                  {
                     "_BETA": "E)CA/GW",
                     "_unicode": "ἐξάγω",
                     "_translit": "exágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead forth",
               "kjv_def": ":--bring forth (out), fetch (lead) out.",
               "_strongs": "01806"
            },
            {
               "strongs": "1807",
               "greek": [
                  {
                     "_BETA": "E)CAIRE/W",
                     "_unicode": "ἐξαιρέω",
                     "_translit": "exairéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ahee-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "actively, to tear out; middle voice, to select;\n figuratively, to release",
               "kjv_def": ":--deliver, pluck out, rescue.",
               "_strongs": "01807"
            },
            {
               "strongs": "1808",
               "greek": [
                  {
                     "_BETA": "E)CAI/RW",
                     "_unicode": "ἐξαίρω",
                     "_translit": "exaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ah'-ee-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to remove",
               "kjv_def": ":--put (take) away.",
               "_strongs": "01808"
            },
            {
               "strongs": "1809",
               "greek": [
                  {
                     "_BETA": "E)CAITE/OMAI",
                     "_unicode": "ἐξαιτέομαι",
                     "_translit": "exaitéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ahee-teh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to demand (for trial)",
               "kjv_def": ":--desire.",
               "_strongs": "01809"
            },
            {
               "strongs": "1810",
               "greek": [
                  {
                     "_BETA": "E)CAI/FNHS",
                     "_unicode": "ἐξαίφνης",
                     "_translit": "exaíphnēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ah'-eef-nace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "160"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "of a sudden (unexpectedly)",
               "kjv_def": ":--suddenly.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1819"
                  }
               ],
               "_strongs": "01810",
               "__text": "Compare \n."
            },
            {
               "strongs": "1811",
               "greek": [
                  {
                     "_BETA": "E)CAKOLOUQE/W",
                     "_unicode": "ἐξακολουθέω",
                     "_translit": "exakolouthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ak-ol-oo-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "190"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to follow out, i.e. (figuratively) to imitate,\n obey, yield to",
               "kjv_def": ":--follow.",
               "_strongs": "01811"
            },
            {
               "strongs": "1812",
               "greek": [
                  {
                     "_BETA": "E(CAKO/SIOI",
                     "_unicode": "ἑξακόσιοι",
                     "_translit": "hexakósioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hex-ak-os'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1803"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1540"
                     }
                  ],
                  "__text": "plural ordinal from \n and \n;"
               },
               "strongs_def": "six hundred",
               "kjv_def": ":--six hundred.",
               "_strongs": "01812"
            },
            {
               "strongs": "1813",
               "greek": [
                  {
                     "_BETA": "E)CALEI/FW",
                     "_unicode": "ἐξαλείφω",
                     "_translit": "exaleíphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-al-i'-fo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to smear out, i.e. obliterate (erase tears,\n figuratively, pardon sin)",
               "kjv_def": ":--blot out, wipe away.",
               "_strongs": "01813"
            },
            {
               "strongs": "1814",
               "greek": [
                  {
                     "_BETA": "E)CA/LLOMAI",
                     "_unicode": "ἐξάλλομαι",
                     "_translit": "exállomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-al'-lom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "242"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to spring forth",
               "kjv_def": ":--leap up.",
               "_strongs": "01814"
            },
            {
               "strongs": "1815",
               "greek": [
                  {
                     "_BETA": "E)CANA/STASIS",
                     "_unicode": "ἐξανάστασις",
                     "_translit": "exanástasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-an-as'-tas-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1817"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a rising from death",
               "kjv_def": ":--resurrection.",
               "_strongs": "01815"
            },
            {
               "strongs": "1816",
               "greek": [
                  {
                     "_BETA": "E)CANATE/LLW",
                     "_unicode": "ἐξανατέλλω",
                     "_translit": "exanatéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-an-at-el'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "393"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to start up out of the ground, i.e.\n germinate",
               "kjv_def": ":--spring up.",
               "_strongs": "01816"
            },
            {
               "strongs": "1817",
               "greek": [
                  {
                     "_BETA": "E)CANI/STHMI",
                     "_unicode": "ἐξανίστημι",
                     "_translit": "exanístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-an-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "450"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "objectively, to produce, i.e. (figuratively) beget;\n subjectively, to arise, i.e. (figuratively) object",
               "kjv_def": ":--raise (rise) up.",
               "_strongs": "01817"
            },
            {
               "strongs": "1818",
               "greek": [
                  {
                     "_BETA": "E)CAPATA/W",
                     "_unicode": "ἐξαπατάω",
                     "_translit": "exapatáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ap-at-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "538"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to seduce wholly",
               "kjv_def": ":--beguile, deceive.",
               "_strongs": "01818"
            },
            {
               "strongs": "1819",
               "greek": [
                  {
                     "_BETA": "E)CA/PINA",
                     "_unicode": "ἐξάπινα",
                     "_translit": "exápina"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ap'-ee-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "160"
                     }
                  ],
                  "__text": "from \n and a derivative of the same as \n;"
               },
               "strongs_def": "of a sudden, i.e.\n unexpectedly",
               "kjv_def": ":--suddenly.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1810"
                  }
               ],
               "_strongs": "01819",
               "__text": "Compare \n."
            },
            {
               "strongs": "1820",
               "greek": [
                  {
                     "_BETA": "E)CAPORE/OMAI",
                     "_unicode": "ἐξαπορέομαι",
                     "_translit": "exaporéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ap-or-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "639"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to be utterly at a loss, i.e.\n despond",
               "kjv_def": ":--(in) despair.",
               "_strongs": "01820"
            },
            {
               "strongs": "1821",
               "greek": [
                  {
                     "_BETA": "E)CAPOSTE/LLW",
                     "_unicode": "ἐξαποστέλλω",
                     "_translit": "exapostéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ap-os-tel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "649"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to send away forth, i.e. (on a mission) to\n despatch, or (peremptorily) to dismiss",
               "kjv_def": ":--send (away, forth, out).",
               "_strongs": "01821"
            },
            {
               "strongs": "1822",
               "greek": [
                  {
                     "_BETA": "E)CARTI/ZW",
                     "_unicode": "ἐξαρτίζω",
                     "_translit": "exartízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ar-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "739"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to finish out (time); figuratively,\n to equip fully (a teacher)",
               "kjv_def": ":--accomplish, thoroughly furnish.",
               "_strongs": "01822"
            },
            {
               "strongs": "1823",
               "greek": [
                  {
                     "_BETA": "E)CASTRA/PTW",
                     "_unicode": "ἐξαστράπτω",
                     "_translit": "exastráptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-as-trap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "797"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lighten forth, i.e. (figuratively) to be radiant\n (of very white garments)",
               "kjv_def": ":--glistening.",
               "_strongs": "01823"
            },
            {
               "strongs": "1824",
               "greek": [
                  {
                     "_BETA": "E)CAUTH=S",
                     "_unicode": "ἐξαυτῆς",
                     "_translit": "exautēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ow'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5610"
                     }
                  ],
                  "__text": "from \n and the genitive case singular feminine of \n (\n being\n understood);"
               },
               "strongs_def": "from that hour, i.e. instantly",
               "kjv_def": ":--by and by, immediately,\n presently, straightway.",
               "_strongs": "01824"
            },
            {
               "strongs": "1825",
               "greek": [
                  {
                     "_BETA": "E)CEGEI/RW",
                     "_unicode": "ἐξεγείρω",
                     "_translit": "exegeírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-eg-i'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1453"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rouse fully, i.e. (figuratively) to resuscitate\n (from death), release (from infliction)",
               "kjv_def": ":--raise up.",
               "_strongs": "01825"
            },
            {
               "strongs": "1826",
               "greek": [
                  {
                     "_BETA": "E)/CEIMI",
                     "_unicode": "ἔξειμι",
                     "_translit": "éxeimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "from \n and \n (to go);"
               },
               "strongs_def": "to issue, i.e. leave (a place), escape (to\n the shore)",
               "kjv_def": ":--depart, get (to land), go out.",
               "_strongs": "01826"
            },
            {
               "strongs": "1827",
               "greek": [
                  {
                     "_BETA": "E)CELE/GXW",
                     "_unicode": "ἐξελέγχω",
                     "_translit": "exelénchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-el-eng'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1651"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to convict fully, i.e. (by implication) to\n punish",
               "kjv_def": ":--convince.",
               "_strongs": "01827"
            },
            {
               "strongs": "1828",
               "greek": [
                  {
                     "_BETA": "E)CE/LKW",
                     "_unicode": "ἐξέλκω",
                     "_translit": "exélkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-el'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1670"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to drag forth, i.e. (figuratively) to entice (to\n sin)",
               "kjv_def": ":--draw away.",
               "_strongs": "01828"
            },
            {
               "strongs": "1829",
               "greek": [
                  {
                     "_BETA": "E)CE/RAMA",
                     "_unicode": "ἐξέραμα",
                     "_translit": "exérama"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-er'-am-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "E)RA/W",
                        "_unicode": "ἐράω",
                        "_translit": "eráō"
                     }
                  ],
                  "__text": "from a compound of \n and a presumed \n (to spue);"
               },
               "strongs_def": "vomit, i.e.\n food disgorged",
               "kjv_def": ":--vomit.",
               "_strongs": "01829"
            },
            {
               "strongs": "1830",
               "greek": [
                  {
                     "_BETA": "E)CEREUNA/W",
                     "_unicode": "ἐξερευνάω",
                     "_translit": "exereunáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-er-yoo-nah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2045"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to explore (figuratively)",
               "kjv_def": ":--search diligently.",
               "_strongs": "01830"
            },
            {
               "strongs": "1831",
               "greek": [
                  {
                     "_BETA": "E)CE/RXOMAI",
                     "_unicode": "ἐξέρχομαι",
                     "_translit": "exérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to issue (literally or figuratively)",
               "kjv_def": ":--come\n (forth, out), depart (out of), escape, get out, go (abroad, away,\n forth, out, thence), proceed (forth), spread abroad.",
               "_strongs": "01831"
            },
            {
               "strongs": "1832",
               "greek": [
                  {
                     "_BETA": "E)/CESTI",
                     "_unicode": "ἔξεστι",
                     "_translit": "éxesti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex'-es-tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "third person singular present indicative of a compound of \n and\n \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "E)CO/N",
                        "_unicode": "ἐξόν",
                        "_translit": "exón"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "ex-on'"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "so also\n      \n  \n\n neuter present participle of the same (with or without some form of\n \n expressed); impersonally, it is right (through the figurative\n idea of being out in public)"
               },
               "kjv_def": ":--be lawful, let,\n X may(-est).",
               "_strongs": "01832"
            },
            {
               "strongs": "1833",
               "greek": [
                  {
                     "_BETA": "E)CETA/ZW",
                     "_unicode": "ἐξετάζω",
                     "_translit": "exetázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-et-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "E)TA/ZW",
                        "_unicode": "ἐτάζω",
                        "_translit": "etázō"
                     }
                  ],
                  "__text": "from \n and \n (to examine);"
               },
               "strongs_def": "to test thoroughly (by questions),\n i.e. ascertain or interrogate",
               "kjv_def": ":--ask, enquire, search.",
               "_strongs": "01833"
            },
            {
               "strongs": "1834",
               "greek": [
                  {
                     "_BETA": "E)CHGE/OMAI",
                     "_unicode": "ἐξηγέομαι",
                     "_translit": "exēgéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ayg-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2233"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to consider out (aloud), i.e. rehearse,\n unfold",
               "kjv_def": ":--declare, tell.",
               "_strongs": "01834"
            },
            {
               "strongs": "1835",
               "greek": [
                  {
                     "_BETA": "E(CH/KONTA",
                     "_unicode": "ἑξήκοντα",
                     "_translit": "hexḗkonta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hex-ay'-kon-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1803"
                     }
                  ],
                  "__text": "the tenth multiple of \n;"
               },
               "strongs_def": "sixty",
               "kjv_def": ":--sixty(-fold), threescore.",
               "_strongs": "01835"
            },
            {
               "strongs": "1836",
               "greek": [
                  {
                     "_BETA": "E(CH=S",
                     "_unicode": "ἑξῆς",
                     "_translit": "hexēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hex-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n (in the sense of taking hold of, i.e. adjoining);"
               },
               "strongs_def": "successive",
               "kjv_def": ":--after, following, X morrow, next.",
               "_strongs": "01836"
            },
            {
               "strongs": "1837",
               "greek": [
                  {
                     "_BETA": "E)CHXE/OMAI",
                     "_unicode": "ἐξηχέομαι",
                     "_translit": "exēchéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ay-kheh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2278"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to \"echo\" forth, i.e. resound (be\n generally reported)",
               "kjv_def": ":--sound forth.",
               "_strongs": "01837"
            },
            {
               "strongs": "1838",
               "greek": [
                  {
                     "_BETA": "E(/CIS",
                     "_unicode": "ἕξις",
                     "_translit": "héxis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hex'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "habit, i.e. (by implication) practice",
               "kjv_def": ":--use.",
               "_strongs": "01838"
            },
            {
               "strongs": "1839",
               "greek": [
                  {
                     "_BETA": "E)CI/STHMI",
                     "_unicode": "ἐξίστημι",
                     "_translit": "exístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to put (stand) out of wits, i.e. astound, or\n (reflexively) become astounded, insane",
               "kjv_def": ":--amaze, be (make) astonished,\n be beside self (selves), bewitch, wonder.",
               "_strongs": "01839"
            },
            {
               "strongs": "1840",
               "greek": [
                  {
                     "_BETA": "E)CISXU/W",
                     "_unicode": "ἐξισχύω",
                     "_translit": "exischýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-is-khoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2480"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to have full strength, i.e. be entirely\n competent",
               "kjv_def": ":--be able.",
               "_strongs": "01840"
            },
            {
               "strongs": "1841",
               "greek": [
                  {
                     "_BETA": "E)/CODOS",
                     "_unicode": "ἔξοδος",
                     "_translit": "éxodos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex'-od-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an exit, i.e. (figuratively) death",
               "kjv_def": ":--decease,\n departing.",
               "_strongs": "01841"
            },
            {
               "strongs": "1842",
               "greek": [
                  {
                     "_BETA": "E)COLOQREU/W",
                     "_unicode": "ἐξολοθρεύω",
                     "_translit": "exolothreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-ol-oth-ryoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3645"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to extirpate",
               "kjv_def": ":--destroy.",
               "_strongs": "01842"
            },
            {
               "strongs": "1843",
               "greek": [
                  {
                     "_BETA": "E)COMOLOGE/W",
                     "_unicode": "ἐξομολογέω",
                     "_translit": "exomologéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-om-ol-og-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3670"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to acknowledge or (by implication, of assent)\n agree fully",
               "kjv_def": ":--confess, profess, promise.",
               "_strongs": "01843"
            },
            {
               "strongs": "1844",
               "greek": [
                  {
                     "_BETA": "E)CORKI/ZW",
                     "_unicode": "ἐξορκίζω",
                     "_translit": "exorkízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-or-kid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3726"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exact an oath, i.e. conjure",
               "kjv_def": ":--adjure.",
               "_strongs": "01844"
            },
            {
               "strongs": "1845",
               "greek": [
                  {
                     "_BETA": "E)CORKISTH/S",
                     "_unicode": "ἐξορκιστής",
                     "_translit": "exorkistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-or-kis-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1844"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "one that binds by an oath (or spell), i.e. (by implication)\n an \"exorcist\" (conjurer)",
               "kjv_def": ":--exorcist.",
               "_strongs": "01845"
            },
            {
               "strongs": "1846",
               "greek": [
                  {
                     "_BETA": "E)CORU/SSW",
                     "_unicode": "ἐξορύσσω",
                     "_translit": "exorýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-or-oos'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3736"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to dig out, i.e. (by extension) to extract (an\n eye), remove (roofing)",
               "kjv_def": ":--break up, pluck out.",
               "_strongs": "01846"
            },
            {
               "strongs": "1847",
               "greek": [
                  {
                     "_BETA": "E)COUDENO/W",
                     "_unicode": "ἐξουδενόω",
                     "_translit": "exoudenóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-oo-den-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3762"
                     }
                  ],
                  "__text": "from \n and a derivative of the neuter of \n;"
               },
               "strongs_def": "to make utterly\n nothing of, i.e. despise",
               "kjv_def": ":--set at nought.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1848"
                  }
               ],
               "_strongs": "01847",
               "__text": "See also \n."
            },
            {
               "strongs": "1848",
               "greek": [
                  {
                     "_BETA": "E)COUQENE/W",
                     "_unicode": "ἐξουθενέω",
                     "_translit": "exouthenéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-oo-then-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1847"
                     }
                  ],
                  "__text": "a variation of \n and meaning the same"
               },
               "kjv_def": ":--contemptible, despise,\n least esteemed, set at nought.",
               "_strongs": "01848"
            },
            {
               "strongs": "1849",
               "greek": [
                  {
                     "_BETA": "E)COUSI/A",
                     "_unicode": "ἐξουσία",
                     "_translit": "exousía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-oo-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1832"
                     }
                  ],
                  "__text": "from \n (in the sense of ability);"
               },
               "strongs_def": "privilege, i.e. (subjectively)\n force, capacity, competency, freedom, or (objectively) mastery\n (concretely, magistrate, superhuman, potentate, token of control),\n delegated influence",
               "kjv_def": ":--authority, jurisdiction, liberty, power, right,\n strength.",
               "_strongs": "01849"
            },
            {
               "strongs": "1850",
               "greek": [
                  {
                     "_BETA": "E)COUSIA/ZW",
                     "_unicode": "ἐξουσιάζω",
                     "_translit": "exousiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-oo-see-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1849"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to control",
               "kjv_def": ":--exercise authority upon, bring under the\n (have) power of.",
               "_strongs": "01850"
            },
            {
               "strongs": "1851",
               "greek": [
                  {
                     "_BETA": "E)COXH/",
                     "_unicode": "ἐξοχή",
                     "_translit": "exochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-okh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from a compound of \n and \n (meaning to stand out);"
               },
               "strongs_def": "prominence\n (figuratively)",
               "kjv_def": ":--principal.",
               "_strongs": "01851"
            },
            {
               "strongs": "1852",
               "greek": [
                  {
                     "_BETA": "E)CUPNI/ZW",
                     "_unicode": "ἐξυπνίζω",
                     "_translit": "exypnízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-oop-nid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1853"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to waken",
               "kjv_def": ":--awake out of sleep.",
               "_strongs": "01852"
            },
            {
               "strongs": "1853",
               "greek": [
                  {
                     "_BETA": "E)/CUPNOS",
                     "_unicode": "ἔξυπνος",
                     "_translit": "éxypnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex'-oop-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5258"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "awake",
               "kjv_def": ":--X out of sleep.",
               "_strongs": "01853"
            },
            {
               "strongs": "1854",
               "greek": [
                  {
                     "_BETA": "E)/CW",
                     "_unicode": "ἔξω",
                     "_translit": "éxō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "out(-side, of doors), literally or\n figuratively",
               "kjv_def": ":--away, forth, (with-)out (of, -ward), strange.",
               "_strongs": "01854"
            },
            {
               "strongs": "1855",
               "greek": [
                  {
                     "_BETA": "E)/CWQEN",
                     "_unicode": "ἔξωθεν",
                     "_translit": "éxōthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex'-o-then"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1854"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "external(-ly)",
               "kjv_def": ":--out(-side, -ward, - wardly), (from)\n without.",
               "_strongs": "01855"
            },
            {
               "strongs": "1856",
               "greek": [
                  {
                     "_BETA": "E)CWQE/W",
                     "_unicode": "ἐξωθέω",
                     "_translit": "exōthéō"
                  },
                  {
                     "_BETA": "E)CW/QW",
                     "_unicode": "ἐξώθω",
                     "_translit": "exṓthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-o-theh'-o"
                  },
                  {
                     "_strongs": "ex-o'-tho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "W)QE/W",
                        "_unicode": "ὠθέω",
                        "_translit": "ōthéō"
                     }
                  ],
                  "__text": "from \n and \n (to push);"
               },
               "strongs_def": "to expel; by implication, to\n propel",
               "kjv_def": ":--drive out, thrust in.",
               "_strongs": "01856",
               "__text": "or"
            },
            {
               "strongs": "1857",
               "greek": [
                  {
                     "_BETA": "E)CW/TEROS",
                     "_unicode": "ἐξώτερος",
                     "_translit": "exṓteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ex-o'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1854"
                     }
                  ],
                  "__text": "comparative of \n;"
               },
               "strongs_def": "exterior",
               "kjv_def": ":--outer.",
               "_strongs": "01857"
            },
            {
               "strongs": "1858",
               "greek": [
                  {
                     "_BETA": "E(ORTA/ZW",
                     "_unicode": "ἑορτάζω",
                     "_translit": "heortázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heh-or-tad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1859"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to observe a festival",
               "kjv_def": ":--keep the feast.",
               "_strongs": "01858"
            },
            {
               "strongs": "1859",
               "greek": [
                  {
                     "_BETA": "E(ORTH/",
                     "_unicode": "ἑορτή",
                     "_translit": "heortḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heh-or-tay'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a festival",
               "kjv_def": ":--feast, holyday.",
               "_strongs": "01859"
            },
            {
               "strongs": "1860",
               "greek": [
                  {
                     "_BETA": "E)PAGGELI/A",
                     "_unicode": "ἐπαγγελία",
                     "_translit": "epangelía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ang-el-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1861"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an announcement (for information, assent or pledge;\n especially a divine assurance of good)",
               "kjv_def": ":--message, promise.",
               "_strongs": "01860"
            },
            {
               "strongs": "1861",
               "greek": [
                  {
                     "_BETA": "E)PAGGE/LLW",
                     "_unicode": "ἐπαγγέλλω",
                     "_translit": "epangéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ang-el'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to announce upon (reflexively), i.e. (by\n implication) to engage to do something, to assert something respecting\n oneself",
               "kjv_def": ":--profess, (make) promise.",
               "_strongs": "01861"
            },
            {
               "strongs": "1862",
               "greek": [
                  {
                     "_BETA": "E)PA/GGELMA",
                     "_unicode": "ἐπάγγελμα",
                     "_translit": "epángelma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ang'-el-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1861"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a self-committal (by assurance of conferring some\n good)",
               "kjv_def": ":--promise.",
               "_strongs": "01862"
            },
            {
               "strongs": "1863",
               "greek": [
                  {
                     "_BETA": "E)PA/GW",
                     "_unicode": "ἐπάγω",
                     "_translit": "epágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to superinduce, i.e. inflict (an evil), charge (a\n crime)",
               "kjv_def": ":--bring upon.",
               "_strongs": "01863"
            },
            {
               "strongs": "1864",
               "greek": [
                  {
                     "_BETA": "E)PAGWNI/ZOMAI",
                     "_unicode": "ἐπαγωνίζομαι",
                     "_translit": "epagōnízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ag-o-nid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "75"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to struggle for",
               "kjv_def": ":--earnestly contend for.",
               "_strongs": "01864"
            },
            {
               "strongs": "1865",
               "greek": [
                  {
                     "_BETA": "E)PAQROI/ZW",
                     "_unicode": "ἐπαθροίζω",
                     "_translit": "epathroízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ath-roid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)QROI/ZW",
                        "_unicode": "ἀθροίζω",
                        "_translit": "athroízō"
                     }
                  ],
                  "__text": "from \n and \n (to assemble);"
               },
               "strongs_def": "to accumulate",
               "kjv_def": ":--gather thick\n together.",
               "_strongs": "01865"
            },
            {
               "strongs": "1866",
               "greek": [
                  {
                     "_BETA": "*)EPAI/NETOS",
                     "_unicode": "Ἐπαίνετος",
                     "_translit": "Epaínetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-a'-hee-net-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1867"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "praised; Epænetus, a Christian",
               "kjv_def": ":--Epenetus.",
               "_strongs": "01866"
            },
            {
               "strongs": "1867",
               "greek": [
                  {
                     "_BETA": "E)PAINE/W",
                     "_unicode": "ἐπαινέω",
                     "_translit": "epainéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ahee-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "134"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to applaud",
               "kjv_def": ":--commend, laud, praise.",
               "_strongs": "01867"
            },
            {
               "strongs": "1868",
               "greek": [
                  {
                     "_BETA": "E)/PAINOS",
                     "_unicode": "ἔπαινος",
                     "_translit": "épainos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep'-ahee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "134"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "laudation; concretely, a commendable\n thing",
               "kjv_def": ":--praise.",
               "_strongs": "01868"
            },
            {
               "strongs": "1869",
               "greek": [
                  {
                     "_BETA": "E)PAI/RW",
                     "_unicode": "ἐπαίρω",
                     "_translit": "epaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ahee'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to raise up (literally or figuratively)",
               "kjv_def": ":--exalt\n self, poise (lift, take) up.",
               "_strongs": "01869"
            },
            {
               "strongs": "1870",
               "greek": [
                  {
                     "_BETA": "E)PAISXU/NOMAI",
                     "_unicode": "ἐπαισχύνομαι",
                     "_translit": "epaischýnomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ahee-skhoo'-nom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "153"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to feel shame for something",
               "kjv_def": ":--be ashamed.",
               "_strongs": "01870"
            },
            {
               "strongs": "1871",
               "greek": [
                  {
                     "_BETA": "E)PAITE/W",
                     "_unicode": "ἐπαιτέω",
                     "_translit": "epaitéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ahee-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to ask for",
               "kjv_def": ":--beg.",
               "_strongs": "01871"
            },
            {
               "strongs": "1872",
               "greek": [
                  {
                     "_BETA": "E)PAKOLOUQE/W",
                     "_unicode": "ἐπακολουθέω",
                     "_translit": "epakolouthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ak-ol-oo-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "190"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to accompany",
               "kjv_def": ":--follow (after).",
               "_strongs": "01872"
            },
            {
               "strongs": "1873",
               "greek": [
                  {
                     "_BETA": "E)PAKOU/W",
                     "_unicode": "ἐπακούω",
                     "_translit": "epakoúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ak-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "191"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hearken (favorably) to",
               "kjv_def": ":--hear.",
               "_strongs": "01873"
            },
            {
               "strongs": "1874",
               "greek": [
                  {
                     "_BETA": "E)PAKROA/OMAI",
                     "_unicode": "ἐπακροάομαι",
                     "_translit": "epakroáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ak-ro-ah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "202"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to listen (intently) to",
               "kjv_def": ":--hear.",
               "_strongs": "01874"
            },
            {
               "strongs": "1875",
               "greek": [
                  {
                     "_BETA": "E)PA/N",
                     "_unicode": "ἐπάν",
                     "_translit": "epán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "302"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a particle of indefinite contemporaneousness;\n whenever, as soon as",
               "kjv_def": ":--when.",
               "_strongs": "01875"
            },
            {
               "strongs": "1876",
               "greek": [
                  {
                     "_BETA": "E)PA/NAGKES",
                     "_unicode": "ἐπάναγκες",
                     "_translit": "epánankes"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an'-ang-kes"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "318"
                     }
                  ],
                  "__text": "neuter of a presumed compound of \n and \n;"
               },
               "strongs_def": "(adverbially) on\n necessity, i.e. necessarily",
               "kjv_def": ":--necessary.",
               "_strongs": "01876"
            },
            {
               "strongs": "1877",
               "greek": [
                  {
                     "_BETA": "E)PANA/GW",
                     "_unicode": "ἐπανάγω",
                     "_translit": "epanágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "321"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead up on, i.e. (technical) to put out (to\n sea); (intransitively) to return",
               "kjv_def": ":--launch (thrust) out, return.",
               "_strongs": "01877"
            },
            {
               "strongs": "1878",
               "greek": [
                  {
                     "_BETA": "E)PANAMIMNH/SKW",
                     "_unicode": "ἐπαναμιμνήσκω",
                     "_translit": "epanamimnḗskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an-ah-mim-nace'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "363"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to remind of",
               "kjv_def": ":--put in mind.",
               "_strongs": "01878"
            },
            {
               "strongs": "1879",
               "greek": [
                  {
                     "_BETA": "E)PANAPAU/OMAI",
                     "_unicode": "ἐπαναπαύομαι",
                     "_translit": "epanapaúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an-ah-pow'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "373"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to settle on; literally (remain) or\n figuratively (rely)",
               "kjv_def": ":--rest in (upon).",
               "_strongs": "01879"
            },
            {
               "strongs": "1880",
               "greek": [
                  {
                     "_BETA": "E)PANE/RXOMAI",
                     "_unicode": "ἐπανέρχομαι",
                     "_translit": "epanérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "424"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to come up on, i.e. return",
               "kjv_def": ":--come again, return.",
               "_strongs": "01880"
            },
            {
               "strongs": "1881",
               "greek": [
                  {
                     "_BETA": "E)PANI/STAMAI",
                     "_unicode": "ἐπανίσταμαι",
                     "_translit": "epanístamai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an-is'-tam-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "450"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to stand up on, i.e. (figuratively) to\n attack",
               "kjv_def": ":--rise up against.",
               "_strongs": "01881"
            },
            {
               "strongs": "1882",
               "greek": [
                  {
                     "_BETA": "E)PANO/RQWSIS",
                     "_unicode": "ἐπανόρθωσις",
                     "_translit": "epanórthōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an-or'-tho-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "461"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a straightening up again, i.e.\n (figuratively) rectification (reformation)",
               "kjv_def": ":-- correction.",
               "_strongs": "01882"
            },
            {
               "strongs": "1883",
               "greek": [
                  {
                     "_BETA": "E)PA/NW",
                     "_unicode": "ἐπάνω",
                     "_translit": "epánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-an'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "507"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "up above, i.e. over or on (of place, amount, rank,\n etc.)",
               "kjv_def": ":--above, more than, (up-)on, over.",
               "_strongs": "01883"
            },
            {
               "strongs": "1884",
               "greek": [
                  {
                     "_BETA": "E)PARKE/W",
                     "_unicode": "ἐπαρκέω",
                     "_translit": "eparkéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ar-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "714"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to avail for, i.e. help",
               "kjv_def": ":--relieve.",
               "_strongs": "01884"
            },
            {
               "strongs": "1885",
               "greek": [
                  {
                     "_BETA": "E)PARXI/A",
                     "_unicode": "ἐπαρχία",
                     "_translit": "eparchía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ar-khee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from a compound of \n and \n (meaning a governor of a district,\n \"eparch\");"
               },
               "strongs_def": "a special region of government, i.e. a Roman\n præfecture",
               "kjv_def": ":--province.",
               "_strongs": "01885"
            },
            {
               "strongs": "1886",
               "greek": [
                  {
                     "_BETA": "E)/PAULIS",
                     "_unicode": "ἔπαυλις",
                     "_translit": "épaulis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep'-ow-lis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "833"
                     }
                  ],
                  "__text": "from \n and an equivalent of \n;"
               },
               "strongs_def": "a hut over the head, i.e. a\n dwelling",
               "kjv_def": ":--habitation.",
               "_strongs": "01886"
            },
            {
               "strongs": "1887",
               "greek": [
                  {
                     "_BETA": "E)PAU/RION",
                     "_unicode": "ἐπαύριον",
                     "_translit": "epaúrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ow'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "839"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "occurring on the succeeding day, i.e. (\n being\n implied) to-morrow"
               },
               "kjv_def": ":--day following, morrow, next day (after).",
               "_strongs": "01887"
            },
            {
               "strongs": "1888",
               "greek": [
                  {
                     "_BETA": "E)PAUTOFW/RW|",
                     "_unicode": "ἐπαυτοφώρῳ",
                     "_translit": "epautophṓrōi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ow-tof-o'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "FW/R",
                        "_unicode": "φώρ",
                        "_translit": "phṓr"
                     }
                  ],
                  "__text": "from \n and \n and (the dative case singular of) a derivative of\n \n (a thief);"
               },
               "strongs_def": "in theft itself, i.e. (by analogy) in actual\n crime",
               "kjv_def": ":--in the very act.",
               "_strongs": "01888"
            },
            {
               "strongs": "1889",
               "greek": [
                  {
                     "_BETA": "*)EPAFRA=S",
                     "_unicode": "Ἐπαφρᾶς",
                     "_translit": "Epaphrâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-af-ras'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1891"
                     }
                  ],
                  "__text": "contracted from \n;"
               },
               "strongs_def": "Epaphras, a Christian",
               "kjv_def": ":--Epaphras.",
               "_strongs": "01889"
            },
            {
               "strongs": "1890",
               "greek": [
                  {
                     "_BETA": "E)PAFRI/ZW",
                     "_unicode": "ἐπαφρίζω",
                     "_translit": "epaphrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-af-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to foam upon, i.e. (figuratively) to exhibit (a\n vile passion)",
               "kjv_def": ":--foam out.",
               "_strongs": "01890"
            },
            {
               "strongs": "1891",
               "greek": [
                  {
                     "_BETA": "*)EPAFRO/DITOS",
                     "_unicode": "Ἐπαφρόδιτος",
                     "_translit": "Epaphróditos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-af-rod'-ee-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "*)AFRODI/TH",
                        "_unicode": "Ἀφροδίτη",
                        "_translit": "Aphrodítē"
                     }
                  ],
                  "__text": "from \n (in the sense of devoted to) and \n (Venus);"
               },
               "strongs_def": "Epaphroditus, a Christian",
               "kjv_def": ":--Epaphroditus.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1889"
                  }
               ],
               "_strongs": "01891",
               "__text": "Compare \n."
            },
            {
               "strongs": "1892",
               "greek": [
                  {
                     "_BETA": "E)PEGEI/RW",
                     "_unicode": "ἐπεγείρω",
                     "_translit": "epegeírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-eg-i'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1453"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rouse upon, i.e. (figuratively) to excite\n against",
               "kjv_def": ":--raise, stir up.",
               "_strongs": "01892"
            },
            {
               "strongs": "1893",
               "greek": [
                  {
                     "_BETA": "E)PEI/",
                     "_unicode": "ἐπεί",
                     "_translit": "epeí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-i'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "thereupon, i.e. since (of time or\n cause)",
               "kjv_def": ":--because, else, for that (then, -asmuch as), otherwise, seeing\n that, since, when.",
               "_strongs": "01893"
            },
            {
               "strongs": "1894",
               "greek": [
                  {
                     "_BETA": "E)PEIDH/",
                     "_unicode": "ἐπειδή",
                     "_translit": "epeidḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-i-day'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1893"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1211"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "since now, i.e. (of time) when, or (of cause)\n whereas",
               "kjv_def": ":--after that, because, for (that, -asmuch as), seeing, since.",
               "_strongs": "01894"
            },
            {
               "strongs": "1895",
               "greek": [
                  {
                     "_BETA": "E)PEIDH/PER",
                     "_unicode": "ἐπειδήπερ",
                     "_translit": "epeidḗper"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-i-day'-per"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1894"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "since indeed (of cause)",
               "kjv_def": ":--forasmuch.",
               "_strongs": "01895"
            },
            {
               "strongs": "1896",
               "greek": [
                  {
                     "_BETA": "E)PEI=DON",
                     "_unicode": "ἐπεῖδον",
                     "_translit": "epeîdon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-i'-don"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "and other moods and persons of the same tense; from \n and \n;"
               },
               "strongs_def": "to\n regard (favorably or otherwise)",
               "kjv_def": ":--behold, look upon.",
               "_strongs": "01896"
            },
            {
               "strongs": "1897",
               "greek": [
                  {
                     "_BETA": "E)PEI/PER",
                     "_unicode": "ἐπείπερ",
                     "_translit": "epeíper"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-i'-per"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1893"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "since indeed (of cause)",
               "kjv_def": ":--seeing.",
               "_strongs": "01897"
            },
            {
               "strongs": "1898",
               "greek": [
                  {
                     "_BETA": "E)PEISAGWGH/",
                     "_unicode": "ἐπεισαγωγή",
                     "_translit": "epeisagōgḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ice-ag-o-gay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1521"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a superintroduction",
               "kjv_def": ":--bringing in.",
               "_strongs": "01898"
            },
            {
               "strongs": "1899",
               "greek": [
                  {
                     "_BETA": "E)/PEITA",
                     "_unicode": "ἔπειτα",
                     "_translit": "épeita"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep'-i-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1534"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "thereafter",
               "kjv_def": ":--after that(-ward), then.",
               "_strongs": "01899"
            },
            {
               "strongs": "1900",
               "greek": [
                  {
                     "_BETA": "E)PE/KEINA",
                     "_unicode": "ἐπέκεινα",
                     "_translit": "epékeina"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ek'-i-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1565"
                     }
                  ],
                  "__text": "from \n and (the accusative case plural neuter of) \n;"
               },
               "strongs_def": "upon those\n parts of, i.e. on the further side of",
               "kjv_def": ":--beyond.",
               "_strongs": "01900"
            },
            {
               "strongs": "1901",
               "greek": [
                  {
                     "_BETA": "E)PEKTEI/NOMAI",
                     "_unicode": "ἐπεκτείνομαι",
                     "_translit": "epekteínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ek-ti'-nom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1614"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to stretch (oneself) forward\n upon",
               "kjv_def": ":--reach forth.",
               "_strongs": "01901"
            },
            {
               "strongs": "1902",
               "greek": [
                  {
                     "_BETA": "E)PENDU/OMAI",
                     "_unicode": "ἐπενδύομαι",
                     "_translit": "ependýomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-en-doo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1746"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to invest upon oneself",
               "kjv_def": ":--be clothed\n upon.",
               "_strongs": "01902"
            },
            {
               "strongs": "1903",
               "greek": [
                  {
                     "_BETA": "E)PENDU/THS",
                     "_unicode": "ἐπενδύτης",
                     "_translit": "ependýtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-en-doo'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1902"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a wrapper, i.e. outer garment",
               "kjv_def": ":--fisher's coat.",
               "_strongs": "01903"
            },
            {
               "strongs": "1904",
               "greek": [
                  {
                     "_BETA": "E)PE/RXOMAI",
                     "_unicode": "ἐπέρχομαι",
                     "_translit": "epérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to supervene, i.e. arrive, occur, impend, attack,\n (figuratively) influence",
               "kjv_def": ":--come (in, upon).",
               "_strongs": "01904"
            },
            {
               "strongs": "1905",
               "greek": [
                  {
                     "_BETA": "E)PERWTA/W",
                     "_unicode": "ἐπερωτάω",
                     "_translit": "eperōtáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-er-o-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2065"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to ask for, i.e. inquire, seek",
               "kjv_def": ":--ask (after,\n questions), demand, desire, question.",
               "_strongs": "01905"
            },
            {
               "strongs": "1906",
               "greek": [
                  {
                     "_BETA": "E)PERW/THMA",
                     "_unicode": "ἐπερώτημα",
                     "_translit": "eperṓtēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-er-o'-tay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1905"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an inquiry",
               "kjv_def": ":--answer.",
               "_strongs": "01906"
            },
            {
               "strongs": "1907",
               "greek": [
                  {
                     "_BETA": "E)PE/XW",
                     "_unicode": "ἐπέχω",
                     "_translit": "epéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "to hold upon, i.e. (by implication) to retain; (by\n extension) to detain; (with implication, of \n) to pay attention\n to"
               },
               "kjv_def": ":--give (take) heed unto, hold forth, mark, stay.",
               "_strongs": "01907"
            },
            {
               "strongs": "1908",
               "greek": [
                  {
                     "_BETA": "E)PHREA/ZW",
                     "_unicode": "ἐπηρεάζω",
                     "_translit": "epēreázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ay-reh-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)REIA/",
                        "_unicode": "ἀρειά",
                        "_translit": "areiá"
                     }
                  ],
                  "__text": "from a compound of \n and (probably) \n (threats);"
               },
               "strongs_def": "to insult,\n slander",
               "kjv_def": ":--use despitefully, falsely accuse.",
               "_strongs": "01908"
            },
            {
               "strongs": "1909",
               "greek": [
                  {
                     "_BETA": "E)PI/",
                     "_unicode": "ἐπί",
                     "_translit": "epí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee'"
                  }
               ],
               "strongs_derivation": "a primary preposition;",
               "strongs_def": "properly, meaning superimposition (of time,\n place, order, etc.), as a relation of distribution (with the genitive\n case), i.e. over, upon, etc.; of rest (with the dative case) at, on,\n etc.; of direction (with the accusative case) towards, upon,\n etc.",
               "kjv_def": ":--about (the times), above, after, against, among, as long as\n (touching), at, beside, X have charge of, (be-, (where-))fore, in (a\n place, as much as, the time of, -to), (because) of, (up-)on (behalf\n of), over, (by, for) the space of, through(-out), (un-)to(-ward),\n with.",
               "_strongs": "01909",
               "__text": "In compounds it retains essentially the same import, at, upon,\n etc. (literally or figuratively)."
            },
            {
               "strongs": "1910",
               "greek": [
                  {
                     "_BETA": "E)PIBAI/NW",
                     "_unicode": "ἐπιβαίνω",
                     "_translit": "epibaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-bah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to walk upon, i.e. mount, ascend,\n embark, arrive",
               "kjv_def": ":--come (into), enter into, go abroad, sit upon, take\n ship.",
               "_strongs": "01910"
            },
            {
               "strongs": "1911",
               "greek": [
                  {
                     "_BETA": "E)PIBA/LLW",
                     "_unicode": "ἐπιβάλλω",
                     "_translit": "epibállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-bal'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1438"
                     }
                  ],
                  "__text": "to throw upon (literal or figurative, transitive or\n reflexive; usually with more or less force); specially (with \n\n implied) to reflect; impersonally, to belong to"
               },
               "kjv_def": ":--beat into, cast\n (up-)on, fall, lay (on), put (unto), stretch forth, think on.",
               "_strongs": "01911"
            },
            {
               "strongs": "1912",
               "greek": [
                  {
                     "_BETA": "E)PIBARE/W",
                     "_unicode": "ἐπιβαρέω",
                     "_translit": "epibaréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-bar-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "916"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be heavy upon, i.e. (pecuniarily) to be\n expensive to; figuratively, to be severe towards",
               "kjv_def": ":--be chargeable to,\n overcharge.",
               "_strongs": "01912"
            },
            {
               "strongs": "1913",
               "greek": [
                  {
                     "_BETA": "E)PIBIBA/ZW",
                     "_unicode": "ἐπιβιβάζω",
                     "_translit": "epibibázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-bee-bad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "307"
                     }
                  ],
                  "__text": "from \n and a reduplicated derivative of the base of \n (compare\n \n);"
               },
               "strongs_def": "to cause to mount (an animal)",
               "kjv_def": ":--set on.",
               "_strongs": "01913"
            },
            {
               "strongs": "1914",
               "greek": [
                  {
                     "_BETA": "E)PIBLE/PW",
                     "_unicode": "ἐπιβλέπω",
                     "_translit": "epiblépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-blep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to gaze at (with favor, pity or partiality)",
               "kjv_def": ":--look\n upon, regard, have respect to.",
               "_strongs": "01914"
            },
            {
               "strongs": "1915",
               "greek": [
                  {
                     "_BETA": "E)PI/BLHMA",
                     "_unicode": "ἐπίβλημα",
                     "_translit": "epíblēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ib'-lay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1911"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a patch",
               "kjv_def": ":--piece.",
               "_strongs": "01915"
            },
            {
               "strongs": "1916",
               "greek": [
                  {
                     "_BETA": "E)PIBOA/W",
                     "_unicode": "ἐπιβοάω",
                     "_translit": "epiboáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-bo-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "994"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exclaim against",
               "kjv_def": ":--cry.",
               "_strongs": "01916"
            },
            {
               "strongs": "1917",
               "greek": [
                  {
                     "_BETA": "E)PIBOULH/",
                     "_unicode": "ἐπιβουλή",
                     "_translit": "epiboulḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-boo-lay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1014"
                     }
                  ],
                  "__text": "from a presumed compound of \n and \n;"
               },
               "strongs_def": "a plan against someone,\n i.e. a plot",
               "kjv_def": ":--laying (lying) in wait.",
               "_strongs": "01917"
            },
            {
               "strongs": "1918",
               "greek": [
                  {
                     "_BETA": "E)PIGAMBREU/W",
                     "_unicode": "ἐπιγαμβρεύω",
                     "_translit": "epigambreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-gam-bryoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1062"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to form affinity with, i.e.\n (specially) in a levirate way",
               "kjv_def": ":--marry.",
               "_strongs": "01918"
            },
            {
               "strongs": "1919",
               "greek": [
                  {
                     "_BETA": "E)PI/GEIOS",
                     "_unicode": "ἐπίγειος",
                     "_translit": "epígeios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ig'-i-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1093"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "worldly (physically or morally)",
               "kjv_def": ":--earthly, in\n earth, terrestrial.",
               "_strongs": "01919"
            },
            {
               "strongs": "1920",
               "greek": [
                  {
                     "_BETA": "E)PIGI/NOMAI",
                     "_unicode": "ἐπιγίνομαι",
                     "_translit": "epigínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ig-in'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to arrive upon, i.e. spring up (as a wind)",
               "kjv_def": ":--blow.",
               "_strongs": "01920"
            },
            {
               "strongs": "1921",
               "greek": [
                  {
                     "_BETA": "E)PIGINW/SKW",
                     "_unicode": "ἐπιγινώσκω",
                     "_translit": "epiginṓskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ig-in-oce'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to know upon some mark, i.e. recognize; by\n implication, to become fully acquainted with, to acknowledge",
               "kjv_def": ":--(ac-,\n have, take)know(-ledge, well), perceive.",
               "_strongs": "01921"
            },
            {
               "strongs": "1922",
               "greek": [
                  {
                     "_BETA": "E)PI/GNWSIS",
                     "_unicode": "ἐπίγνωσις",
                     "_translit": "epígnōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ig'-no-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1921"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "recognition, i.e. (by implication) full discernment,\n acknowledgement",
               "kjv_def": ":--(ac-)knowledge(-ing, - ment).",
               "_strongs": "01922"
            },
            {
               "strongs": "1923",
               "greek": [
                  {
                     "_BETA": "E)PIGRAFH/",
                     "_unicode": "ἐπιγραφή",
                     "_translit": "epigraphḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ig-raf-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1924"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an inscription",
               "kjv_def": ":--superscription.",
               "_strongs": "01923"
            },
            {
               "strongs": "1924",
               "greek": [
                  {
                     "_BETA": "E)PIGRA/FW",
                     "_unicode": "ἐπιγράφω",
                     "_translit": "epigráphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-graf'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to inscribe (physically or\n mentally)",
               "kjv_def": ":--inscription, write in (over, thereon).",
               "_strongs": "01924"
            },
            {
               "strongs": "1925",
               "greek": [
                  {
                     "_BETA": "E)PIDEI/KNUMI",
                     "_unicode": "ἐπιδείκνυμι",
                     "_translit": "epideíknymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-dike'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1166"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exhibit (physically or mentally)",
               "kjv_def": ":--shew.",
               "_strongs": "01925"
            },
            {
               "strongs": "1926",
               "greek": [
                  {
                     "_BETA": "E)PIDE/XOMAI",
                     "_unicode": "ἐπιδέχομαι",
                     "_translit": "epidéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-dekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to admit (as a guest or (figuratively)\n teacher)",
               "kjv_def": ":--receive.",
               "_strongs": "01926"
            },
            {
               "strongs": "1927",
               "greek": [
                  {
                     "_BETA": "E)PIDHME/W",
                     "_unicode": "ἐπιδημέω",
                     "_translit": "epidēméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-day-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to make oneself at home, i.e. (by\n extension) to reside (in a foreign country)",
               "kjv_def": ":--(be) dwelling (which\n were) there, stranger.",
               "_strongs": "01927"
            },
            {
               "strongs": "1928",
               "greek": [
                  {
                     "_BETA": "E)PIDIATA/SSOMAI",
                     "_unicode": "ἐπιδιατάσσομαι",
                     "_translit": "epidiatássomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-dee-ah-tas'-som-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1299"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to appoint besides, i.e. supplement\n (as a codicil)",
               "kjv_def": ":--add to.",
               "_strongs": "01928"
            },
            {
               "strongs": "1929",
               "greek": [
                  {
                     "_BETA": "E)PIDI/DWMI",
                     "_unicode": "ἐπιδίδωμι",
                     "_translit": "epidídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-did'-o-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give over (by hand or surrender)",
               "kjv_def": ":--deliver\n unto, give, let (+ (her drive)), offer.",
               "_strongs": "01929"
            },
            {
               "strongs": "1930",
               "greek": [
                  {
                     "_BETA": "E)PIDIORQO/W",
                     "_unicode": "ἐπιδιορθόω",
                     "_translit": "epidiorthóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-dee-or-tho'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3717"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to straighten further, i.e.\n (figuratively) arrange additionally",
               "kjv_def": ":--set in order.",
               "_strongs": "01930"
            },
            {
               "strongs": "1931",
               "greek": [
                  {
                     "_BETA": "E)PIDU/W",
                     "_unicode": "ἐπιδύω",
                     "_translit": "epidýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-doo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1416"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to set fully (as the sun)",
               "kjv_def": ":--go down.",
               "_strongs": "01931"
            },
            {
               "strongs": "1932",
               "greek": [
                  {
                     "_BETA": "E)PIEI/KEIA",
                     "_unicode": "ἐπιείκεια",
                     "_translit": "epieíkeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-i'-ki-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1933"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "suitableness, i.e. (by implication) equity,\n mildness",
               "kjv_def": ":--clemency, gentleness.",
               "_strongs": "01932"
            },
            {
               "strongs": "1933",
               "greek": [
                  {
                     "_BETA": "E)PIEIKH/S",
                     "_unicode": "ἐπιεικής",
                     "_translit": "epieikḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-i-kace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1503"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "appropriate, i.e. (by implication) mild",
               "kjv_def": ":--gentle,\n moderation, patient.",
               "_strongs": "01933"
            },
            {
               "strongs": "1934",
               "greek": [
                  {
                     "_BETA": "E)PIZHTE/W",
                     "_unicode": "ἐπιζητέω",
                     "_translit": "epizētéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-eed-zay-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2212"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to search (inquire) for; intensively, to demand,\n to crave",
               "kjv_def": ":--desire, enquire, seek (after, for).",
               "_strongs": "01934"
            },
            {
               "strongs": "1935",
               "greek": [
                  {
                     "_BETA": "E)PIQANA/TIOS",
                     "_unicode": "ἐπιθανάτιος",
                     "_translit": "epithanátios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-than-at'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2288"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "doomed to death",
               "kjv_def": ":--appointed to death.",
               "_strongs": "01935"
            },
            {
               "strongs": "1936",
               "greek": [
                  {
                     "_BETA": "E)PI/QESIS",
                     "_unicode": "ἐπίθεσις",
                     "_translit": "epíthesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ith'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2007"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an imposition (of hands officially)",
               "kjv_def": ":--laying (putting) on.",
               "_strongs": "01936"
            },
            {
               "strongs": "1937",
               "greek": [
                  {
                     "_BETA": "E)PIQUME/W",
                     "_unicode": "ἐπιθυμέω",
                     "_translit": "epithyméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-thoo-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to set the heart upon, i.e. long for (rightfully\n or otherwise)",
               "kjv_def": ":--covet, desire, would fain, lust (after).",
               "_strongs": "01937"
            },
            {
               "strongs": "1938",
               "greek": [
                  {
                     "_BETA": "E)PIQUMHTH/S",
                     "_unicode": "ἐπιθυμητής",
                     "_translit": "epithymētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-thoo-may-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1937"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a craver",
               "kjv_def": ":--+ lust after.",
               "_strongs": "01938"
            },
            {
               "strongs": "1939",
               "greek": [
                  {
                     "_BETA": "E)PIQUMI/A",
                     "_unicode": "ἐπιθυμία",
                     "_translit": "epithymía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-thoo-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1937"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a longing (especially for what is\n forbidden)",
               "kjv_def": ":--concupiscence, desire, lust (after).",
               "_strongs": "01939"
            },
            {
               "strongs": "1940",
               "greek": [
                  {
                     "_BETA": "E)PIKAQI/ZW",
                     "_unicode": "ἐπικαθίζω",
                     "_translit": "epikathízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-kath-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2523"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to seat upon",
               "kjv_def": ":--set on.",
               "_strongs": "01940"
            },
            {
               "strongs": "1941",
               "greek": [
                  {
                     "_BETA": "E)PIKALE/OMAI",
                     "_unicode": "ἐπικαλέομαι",
                     "_translit": "epikaléomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-kal-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to entitle; by implication, to invoke\n (for aid, worship, testimony, decision, etc.)",
               "kjv_def": ":--appeal (unto), call\n (on, upon), surname.",
               "_strongs": "01941"
            },
            {
               "strongs": "1942",
               "greek": [
                  {
                     "_BETA": "E)PIKA/LUMA",
                     "_unicode": "ἐπικάλυμα",
                     "_translit": "epikályma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-kal'-oo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1943"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a covering, i.e. (figuratively) pretext",
               "kjv_def": ":--cloke.",
               "_strongs": "01942"
            },
            {
               "strongs": "1943",
               "greek": [
                  {
                     "_BETA": "E)PIKALU/PTW",
                     "_unicode": "ἐπικαλύπτω",
                     "_translit": "epikalýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-kal-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to conceal, i.e. (figuratively) forgive",
               "kjv_def": ":--cover.",
               "_strongs": "01943"
            },
            {
               "strongs": "1944",
               "greek": [
                  {
                     "_BETA": "E)PIKATA/RATOS",
                     "_unicode": "ἐπικατάρατος",
                     "_translit": "epikatáratos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-kat-ar'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2672"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "imprecated, i.e.\n execrable",
               "kjv_def": ":--accursed.",
               "_strongs": "01944"
            },
            {
               "strongs": "1945",
               "greek": [
                  {
                     "_BETA": "E)PI/KEIMAI",
                     "_unicode": "ἐπίκειμαι",
                     "_translit": "epíkeimai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ik'-i-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rest upon (literally or figuratively)",
               "kjv_def": ":--impose,\n be instant, (be) laid (there-, up-)on, (when) lay (on), lie (on),\n press upon.",
               "_strongs": "01945"
            },
            {
               "strongs": "1946",
               "greek": [
                  {
                     "_BETA": "*)EPIKOU/REIOS",
                     "_unicode": "Ἐπικούρειος",
                     "_translit": "Epikoúreios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-koo'-ri-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)EPI/KOUROS",
                        "_unicode": "Ἐπίκουρος",
                        "_translit": "Epíkouros"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1947"
                     }
                  ],
                  "__text": "from \n (compare \n) (a noted philosopher);"
               },
               "strongs_def": "an Epicurean or\n follower of Epicurus",
               "kjv_def": ":--Epicurean.",
               "_strongs": "01946"
            },
            {
               "strongs": "1947",
               "greek": [
                  {
                     "_BETA": "E)PIKOURI/A",
                     "_unicode": "ἐπικουρία",
                     "_translit": "epikouría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-koo-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2877"
                     }
                  ],
                  "__text": "from a compound of \n and a (prolonged) form of the base of \n (in\n the sense of servant);"
               },
               "strongs_def": "assistance",
               "kjv_def": ":--help.",
               "_strongs": "01947"
            },
            {
               "strongs": "1948",
               "greek": [
                  {
                     "_BETA": "E)PIKRI/NW",
                     "_unicode": "ἐπικρίνω",
                     "_translit": "epikrínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-kree'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to adjudge",
               "kjv_def": ":--give sentence.",
               "_strongs": "01948"
            },
            {
               "strongs": "1949",
               "greek": [
                  {
                     "_BETA": "E)PILAMBA/NOMAI",
                     "_unicode": "ἐπιλαμβάνομαι",
                     "_translit": "epilambánomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-lam-ban'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to seize (for help, injury,\n attainment, or any other purpose; literally or figuratively)",
               "kjv_def": ":--catch,\n lay hold (up-)on, take (by, hold of, on).",
               "_strongs": "01949"
            },
            {
               "strongs": "1950",
               "greek": [
                  {
                     "_BETA": "E)PILANQA/NOMAI",
                     "_unicode": "ἐπιλανθάνομαι",
                     "_translit": "epilanthánomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-lan-than'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2990"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to lose out of mind; by implication,\n to neglect",
               "kjv_def": ":--(be) forget(-ful of).",
               "_strongs": "01950"
            },
            {
               "strongs": "1951",
               "greek": [
                  {
                     "_BETA": "E)PILE/GOMAI",
                     "_unicode": "ἐπιλέγομαι",
                     "_translit": "epilégomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-leg'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to surname, select",
               "kjv_def": ":--call, choose.",
               "_strongs": "01951"
            },
            {
               "strongs": "1952",
               "greek": [
                  {
                     "_BETA": "E)PILEI/PW",
                     "_unicode": "ἐπιλείπω",
                     "_translit": "epileípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-li'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to leave upon, i.e. (figuratively) to be\n insufficient for",
               "kjv_def": ":--fail.",
               "_strongs": "01952"
            },
            {
               "strongs": "1953",
               "greek": [
                  {
                     "_BETA": "E)PILHSMONH/",
                     "_unicode": "ἐπιλησμονή",
                     "_translit": "epilēsmonḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-lace-mon-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1950"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "negligence",
               "kjv_def": ":--X forgetful.",
               "_strongs": "01953"
            },
            {
               "strongs": "1954",
               "greek": [
                  {
                     "_BETA": "E)PI/LOIPOS",
                     "_unicode": "ἐπίλοιπος",
                     "_translit": "epíloipos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-il'-oy-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3062"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "left over, i.e. remaining",
               "kjv_def": ":--rest.",
               "_strongs": "01954"
            },
            {
               "strongs": "1955",
               "greek": [
                  {
                     "_BETA": "E)PI/LUSIS",
                     "_unicode": "ἐπίλυσις",
                     "_translit": "epílysis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-il'-oo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1956"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "explanation, i.e. application",
               "kjv_def": ":--interpretation.",
               "_strongs": "01955"
            },
            {
               "strongs": "1956",
               "greek": [
                  {
                     "_BETA": "E)PILU/W",
                     "_unicode": "ἐπιλύω",
                     "_translit": "epilýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-loo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to solve further, i.e. (figuratively) to explain,\n decide",
               "kjv_def": ":--determine, expound.",
               "_strongs": "01956"
            },
            {
               "strongs": "1957",
               "greek": [
                  {
                     "_BETA": "E)PIMARTURE/W",
                     "_unicode": "ἐπιμαρτυρέω",
                     "_translit": "epimartyréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-mar-too-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3140"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to attest further, i.e. corroborate",
               "kjv_def": ":--testify.",
               "_strongs": "01957"
            },
            {
               "strongs": "1958",
               "greek": [
                  {
                     "_BETA": "E)PIME/LEIA",
                     "_unicode": "ἐπιμέλεια",
                     "_translit": "epiméleia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-mel'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1959"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "carefulness, i.e. kind attention (hospitality)",
               "kjv_def": ":--+ refresh\n self.",
               "_strongs": "01958"
            },
            {
               "strongs": "1959",
               "greek": [
                  {
                     "_BETA": "E)PIMELE/OMAI",
                     "_unicode": "ἐπιμελέομαι",
                     "_translit": "epimeléomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-mel-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3199"
                     }
                  ],
                  "__text": "middle voice from \n and the same as \n;"
               },
               "strongs_def": "to care for (physically\n or otherwise)",
               "kjv_def": ":--take care of.",
               "_strongs": "01959"
            },
            {
               "strongs": "1960",
               "greek": [
                  {
                     "_BETA": "E)PIMELW=S",
                     "_unicode": "ἐπιμελῶς",
                     "_translit": "epimelōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-mel-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1959"
                     }
                  ],
                  "__text": "adverb from a derivative of \n;"
               },
               "strongs_def": "carefully",
               "kjv_def": ":--diligently.",
               "_strongs": "01960"
            },
            {
               "strongs": "1961",
               "greek": [
                  {
                     "_BETA": "E)PIME/NW",
                     "_unicode": "ἐπιμένω",
                     "_translit": "epiménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-men'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stay over, i.e. remain (figuratively,\n persevere)",
               "kjv_def": ":--abide (in), continue (in), tarry.",
               "_strongs": "01961"
            },
            {
               "strongs": "1962",
               "greek": [
                  {
                     "_BETA": "E)PINEU/W",
                     "_unicode": "ἐπινεύω",
                     "_translit": "epineúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-een-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3506"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to nod at, i.e. (by implication) to\n assent",
               "kjv_def": ":--consent.",
               "_strongs": "01962"
            },
            {
               "strongs": "1963",
               "greek": [
                  {
                     "_BETA": "E)PI/NOIA",
                     "_unicode": "ἐπίνοια",
                     "_translit": "epínoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-in'-oy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "attention of the mind, i.e. (by implication)\n purpose",
               "kjv_def": ":--thought.",
               "_strongs": "01963"
            },
            {
               "strongs": "1964",
               "greek": [
                  {
                     "_BETA": "E)PIORKE/W",
                     "_unicode": "ἐπιορκέω",
                     "_translit": "epiorkéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-or-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1965"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to commit perjury",
               "kjv_def": ":--forswear self.",
               "_strongs": "01964"
            },
            {
               "strongs": "1965",
               "greek": [
                  {
                     "_BETA": "E)PI/ORKOS",
                     "_unicode": "ἐπίορκος",
                     "_translit": "epíorkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee'-or-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3727"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "on oath, i.e. (falsely) a forswearer",
               "kjv_def": ":--perjured\n person.",
               "_strongs": "01965"
            },
            {
               "strongs": "1966",
               "greek": [
                  {
                     "_BETA": "E)PIOU=SA",
                     "_unicode": "ἐπιοῦσα",
                     "_translit": "epioûsa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-oo'-sah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "feminine singular participle of a compound of \n and\n \n (to go);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3571"
                     }
                  ],
                  "__text": "supervening, i.e. (\n or \n being expressed\n or implied) the ensuing day or night"
               },
               "kjv_def": ":--following, next.",
               "_strongs": "01966"
            },
            {
               "strongs": "1967",
               "greek": [
                  {
                     "_BETA": "E)PIOU/SIOS",
                     "_unicode": "ἐπιούσιος",
                     "_translit": "epioúsios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-oo'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1966"
                     }
                  ],
                  "__text": "perhaps from the same as \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "tomorrow's; but more probably from \n\n and a derivative of the present participle feminine of \n; for\n subsistence, i.e. needful"
               },
               "kjv_def": ":--daily.",
               "_strongs": "01967"
            },
            {
               "strongs": "1968",
               "greek": [
                  {
                     "_BETA": "E)PIPI/PTW",
                     "_unicode": "ἐπιπίπτω",
                     "_translit": "epipíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-pip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to embrace (with affection) or seize (with more or\n less violence; literally or figuratively)",
               "kjv_def": ":--fall into (on, upon) lie\n on, press upon.",
               "_strongs": "01968"
            },
            {
               "strongs": "1969",
               "greek": [
                  {
                     "_BETA": "E)PIPLH/SSW",
                     "_unicode": "ἐπιπλήσσω",
                     "_translit": "epiplḗssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-place'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4141"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to chastise, i.e. (with words) to\n upbraid",
               "kjv_def": ":--rebuke.",
               "_strongs": "01969"
            },
            {
               "strongs": "1970",
               "greek": [
                  {
                     "_BETA": "E)PIPNI/GW",
                     "_unicode": "ἐπιπνίγω",
                     "_translit": "epipnígō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-pnee'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4155"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throttle upon, i.e. (figuratively)\n overgrow",
               "kjv_def": ":--choke.",
               "_strongs": "01970"
            },
            {
               "strongs": "1971",
               "greek": [
                  {
                     "_BETA": "E)PIPOQE/W",
                     "_unicode": "ἐπιποθέω",
                     "_translit": "epipothéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-poth-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     }
                  ],
                  "__text": "from \n and potheo (to yearn);"
               },
               "strongs_def": "to dote upon, i.e. intensely crave\n possession (lawfully or wrongfully)",
               "kjv_def": ":--(earnestly) desire (greatly),\n (greatly) long (after), lust.",
               "_strongs": "01971"
            },
            {
               "strongs": "1972",
               "greek": [
                  {
                     "_BETA": "E)PIPO/QHSIS",
                     "_unicode": "ἐπιπόθησις",
                     "_translit": "epipóthēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-poth'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1971"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a longing for",
               "kjv_def": ":--earnest (vehement) desire.",
               "_strongs": "01972"
            },
            {
               "strongs": "1973",
               "greek": [
                  {
                     "_BETA": "E)PIPO/QHTOS",
                     "_unicode": "ἐπιπόθητος",
                     "_translit": "epipóthētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-poth'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1971"
                     }
                  ],
                  "__text": "from \n and a derivative of the latter part of \n;"
               },
               "strongs_def": "yearned upon,\n i.e. greatly loved",
               "kjv_def": ":--longed for.",
               "_strongs": "01973"
            },
            {
               "strongs": "1974",
               "greek": [
                  {
                     "_BETA": "E)PIPOQI/A",
                     "_unicode": "ἐπιποθία",
                     "_translit": "epipothía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-poth-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1971"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "intense longing",
               "kjv_def": ":--great desire.",
               "_strongs": "01974"
            },
            {
               "strongs": "1975",
               "greek": [
                  {
                     "_BETA": "E)PIPOREU/OMAI",
                     "_unicode": "ἐπιπορεύομαι",
                     "_translit": "epiporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-por-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to journey further, i.e. travel on (reach)",
               "kjv_def": ":--come.",
               "_strongs": "01975"
            },
            {
               "strongs": "1976",
               "greek": [
                  {
                     "_BETA": "E)PIR)R(A/PTW",
                     "_unicode": "ἐπιῤῥάπτω",
                     "_translit": "epirrháptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ir-hrap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4476"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to stitch upon, i.e. fasten with the\n needle",
               "kjv_def": ":--sew on.",
               "_strongs": "01976"
            },
            {
               "strongs": "1977",
               "greek": [
                  {
                     "_BETA": "E)PIR)R(I/PTW",
                     "_unicode": "ἐπιῤῥίπτω",
                     "_translit": "epirrhíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ir-hrip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4496"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw upon (literally or figuratively)",
               "kjv_def": ":--cast\n upon.",
               "_strongs": "01977"
            },
            {
               "strongs": "1978",
               "greek": [
                  {
                     "_BETA": "E)PI/SHMOS",
                     "_unicode": "ἐπίσημος",
                     "_translit": "epísēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-is'-ay-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4591"
                     }
                  ],
                  "__text": "from \n and some form of the base of \n;"
               },
               "strongs_def": "remarkable, i.e.\n (figuratively) eminent",
               "kjv_def": ":--notable, of note.",
               "_strongs": "01978"
            },
            {
               "strongs": "1979",
               "greek": [
                  {
                     "_BETA": "E)PISITISMO/S",
                     "_unicode": "ἐπισιτισμός",
                     "_translit": "episitismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-sit-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4621"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "a provisioning, i.e.\n (concretely) food",
               "kjv_def": ":--victuals.",
               "_strongs": "01979"
            },
            {
               "strongs": "1980",
               "greek": [
                  {
                     "_BETA": "E)PISKE/PTOMAI",
                     "_unicode": "ἐπισκέπτομαι",
                     "_translit": "episképtomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-skep'-tom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4649"
                     }
                  ],
                  "__text": "middle voice from \n and the base of \n;"
               },
               "strongs_def": "to inspect, i.e. (by\n implication) to select; by extension, to go to see, relieve",
               "kjv_def": ":--look\n out, visit.",
               "_strongs": "01980"
            },
            {
               "strongs": "1981",
               "greek": [
                  {
                     "_BETA": "E)PISKHNO/W",
                     "_unicode": "ἐπισκηνόω",
                     "_translit": "episkēnóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-skay-no'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4637"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tent upon, i.e. (figuratively) abide with",
               "kjv_def": ":--rest upon.",
               "_strongs": "01981"
            },
            {
               "strongs": "1982",
               "greek": [
                  {
                     "_BETA": "E)PISKIA/ZW",
                     "_unicode": "ἐπισκιάζω",
                     "_translit": "episkiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-skee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4639"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to cast a shade upon, i.e. (by\n analogy) to envelop in a haze of brilliancy; figuratively, to invest\n with preternatural influence",
               "kjv_def": ":--overshadow.",
               "_strongs": "01982"
            },
            {
               "strongs": "1983",
               "greek": [
                  {
                     "_BETA": "E)PISKOPE/W",
                     "_unicode": "ἐπισκοπέω",
                     "_translit": "episkopéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-skop-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4648"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to oversee; by implication, to beware",
               "kjv_def": ":--look\n diligently, take the oversight.",
               "_strongs": "01983"
            },
            {
               "strongs": "1984",
               "greek": [
                  {
                     "_BETA": "E)PISKOPH/",
                     "_unicode": "ἐπισκοπή",
                     "_translit": "episkopḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-is-kop-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1980"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inspection (for relief); by implication, superintendence;\n specially, the Christian \"episcopate\"",
               "kjv_def": ":--the office of a \"bishop\",\n bishoprick, visitation.",
               "_strongs": "01984"
            },
            {
               "strongs": "1985",
               "greek": [
                  {
                     "_BETA": "E)PI/SKOPOS",
                     "_unicode": "ἐπίσκοπος",
                     "_translit": "epískopos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-is'-kop-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4649"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1983"
                     }
                  ],
                  "__text": "from \n and \n (in the sense of \n);"
               },
               "strongs_def": "a superintendent, i.e.\n Christian officer in genitive case charge of a (or the) church\n (literally or figuratively)",
               "kjv_def": ":--bishop, overseer.",
               "_strongs": "01985"
            },
            {
               "strongs": "1986",
               "greek": [
                  {
                     "_BETA": "E)PISPA/OMAI",
                     "_unicode": "ἐπισπάομαι",
                     "_translit": "epispáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-spah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4685"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "203"
                     }
                  ],
                  "__text": "to draw over, i.e. (with \n implied) efface the\n mark of circumcision (by recovering with the foreskin)"
               },
               "kjv_def": ":--become\n uncircumcised.",
               "_strongs": "01986"
            },
            {
               "strongs": "1987",
               "greek": [
                  {
                     "_BETA": "E)PI/STAMAI",
                     "_unicode": "ἐπίσταμαι",
                     "_translit": "epístamai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-is'-tam-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2186"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "apparently a middle voice of \n (with \n implied);"
               },
               "strongs_def": "to put the mind\n upon, i.e. comprehend, or be acquainted with",
               "kjv_def": ":--know, understand.",
               "_strongs": "01987"
            },
            {
               "strongs": "1988",
               "greek": [
                  {
                     "_BETA": "E)PISTA/THS",
                     "_unicode": "ἐπιστάτης",
                     "_translit": "epistátēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-is-tat'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and a presumed derivative of \n;"
               },
               "strongs_def": "an appointee over, i.e.\n commander (teacher)",
               "kjv_def": ":--master.",
               "_strongs": "01988"
            },
            {
               "strongs": "1989",
               "greek": [
                  {
                     "_BETA": "E)PISTE/LLW",
                     "_unicode": "ἐπιστέλλω",
                     "_translit": "epistéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-stel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4724"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to enjoin (by writing), i.e. (genitive case) to\n communicate by letter (for any purpose)",
               "kjv_def": ":--write (a letter, unto).",
               "_strongs": "01989"
            },
            {
               "strongs": "1990",
               "greek": [
                  {
                     "_BETA": "E)PISTH/MWN",
                     "_unicode": "ἐπιστήμων",
                     "_translit": "epistḗmōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-stay'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1987"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "intelligent",
               "kjv_def": ":--endued with knowledge.",
               "_strongs": "01990"
            },
            {
               "strongs": "1991",
               "greek": [
                  {
                     "_BETA": "E)PISTHRI/ZW",
                     "_unicode": "ἐπιστηρίζω",
                     "_translit": "epistērízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-stay-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4741"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to support further, i.e. reestablish",
               "kjv_def": ":--confirm,\n strengthen.",
               "_strongs": "01991"
            },
            {
               "strongs": "1992",
               "greek": [
                  {
                     "_BETA": "E)PISTOLH/",
                     "_unicode": "ἐπιστολή",
                     "_translit": "epistolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-is-tol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1989"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a written message",
               "kjv_def": ":--\"epistle,\" letter.",
               "_strongs": "01992"
            },
            {
               "strongs": "1993",
               "greek": [
                  {
                     "_BETA": "E)PISTOMI/ZW",
                     "_unicode": "ἐπιστομίζω",
                     "_translit": "epistomízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-stom-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4750"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to put something over the mouth, i.e.\n (figuratively) to silence",
               "kjv_def": ":--stop mouths.",
               "_strongs": "01993"
            },
            {
               "strongs": "1994",
               "greek": [
                  {
                     "_BETA": "E)PISTRE/FW",
                     "_unicode": "ἐπιστρέφω",
                     "_translit": "epistréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-stref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to revert (literally, figuratively or\n morally)",
               "kjv_def": ":--come (go) again, convert, (re-)turn (about, again).",
               "_strongs": "01994"
            },
            {
               "strongs": "1995",
               "greek": [
                  {
                     "_BETA": "E)PISTROFH/",
                     "_unicode": "ἐπιστροφή",
                     "_translit": "epistrophḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-is-trof-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1994"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "reversion, i.e. morally, revolution",
               "kjv_def": ":--conversion.",
               "_strongs": "01995"
            },
            {
               "strongs": "1996",
               "greek": [
                  {
                     "_BETA": "E)PISUNA/GW",
                     "_unicode": "ἐπισυνάγω",
                     "_translit": "episynágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-soon-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4863"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to collect upon the same place",
               "kjv_def": ":--gather\n (together).",
               "_strongs": "01996"
            },
            {
               "strongs": "1997",
               "greek": [
                  {
                     "_BETA": "E)PISUNAGWGH/",
                     "_unicode": "ἐπισυναγωγή",
                     "_translit": "episynagōgḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-soon-ag-o-gay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1996"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a complete collection; especially a Christian meeting (for\n worship)",
               "kjv_def": ":--assembling (gathering) together.",
               "_strongs": "01997"
            },
            {
               "strongs": "1998",
               "greek": [
                  {
                     "_BETA": "E)PISUNTRE/XW",
                     "_unicode": "ἐπισυντρέχω",
                     "_translit": "episyntréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-soon-trekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4936"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hasten together upon one place (or a particular\n occasion)",
               "kjv_def": ":--come running together.",
               "_strongs": "01998"
            },
            {
               "strongs": "1999",
               "greek": [
                  {
                     "_BETA": "E)PISU/STASIS",
                     "_unicode": "ἐπισύστασις",
                     "_translit": "episýstasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-soo'-stas-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4921"
                     }
                  ],
                  "__text": "from the middle voice of a compound of \n and \n;"
               },
               "strongs_def": "a conspiracy,\n i.e. concourse (riotous or friendly)",
               "kjv_def": ":--that which cometh upon, +\n raising up.",
               "_strongs": "01999"
            },
            {
               "strongs": "2000",
               "greek": [
                  {
                     "_BETA": "E)PISFALH/S",
                     "_unicode": "ἐπισφαλής",
                     "_translit": "episphalḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-sfal-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "SFA/LLW",
                        "_unicode": "σφάλλω",
                        "_translit": "sphállō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to trip);"
               },
               "strongs_def": "figuratively,\n insecure",
               "kjv_def": ":--dangerous.",
               "_strongs": "02000"
            },
            {
               "strongs": "2001",
               "greek": [
                  {
                     "_BETA": "E)PISXU/W",
                     "_unicode": "ἐπισχύω",
                     "_translit": "epischýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-is-khoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2480"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to avail further, i.e. (figuratively) insist\n stoutly",
               "kjv_def": ":--be the more fierce.",
               "_strongs": "02001"
            },
            {
               "strongs": "2002",
               "greek": [
                  {
                     "_BETA": "E)PISWREU/W",
                     "_unicode": "ἐπισωρεύω",
                     "_translit": "episōreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-so-ryoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4987"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to accumulate further, i.e. (figuratively) seek\n additionally",
               "kjv_def": ":--heap.",
               "_strongs": "02002"
            },
            {
               "strongs": "2003",
               "greek": [
                  {
                     "_BETA": "E)PITAGH/",
                     "_unicode": "ἐπιταγή",
                     "_translit": "epitagḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-tag-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2004"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an injunction or decree; by implication,\n authoritativeness",
               "kjv_def": ":--authority, commandment.",
               "_strongs": "02003"
            },
            {
               "strongs": "2004",
               "greek": [
                  {
                     "_BETA": "E)PITA/SSW",
                     "_unicode": "ἐπιτάσσω",
                     "_translit": "epitássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-tas'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to arrange upon, i.e. order",
               "kjv_def": ":--charge, command,\n injoin.",
               "_strongs": "02004"
            },
            {
               "strongs": "2005",
               "greek": [
                  {
                     "_BETA": "E)PITELE/W",
                     "_unicode": "ἐπιτελέω",
                     "_translit": "epiteléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-tel-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5055"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fulfill further (or completely), i.e. execute;\n by implication, to terminate, undergo",
               "kjv_def": ":--accomplish, do, finish, (make)\n (perfect), perform(X -ance).",
               "_strongs": "02005"
            },
            {
               "strongs": "2006",
               "greek": [
                  {
                     "_BETA": "E)PITH/DEIOS",
                     "_unicode": "ἐπιτήδειος",
                     "_translit": "epitḗdeios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-tay'-di-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)PITHDE/S",
                        "_unicode": "ἐπιτηδές",
                        "_translit": "epitēdés"
                     }
                  ],
                  "__text": "from \n (enough);"
               },
               "strongs_def": "serviceable, i.e. (by implication)\n requisite",
               "kjv_def": ":--things which are needful.",
               "_strongs": "02006"
            },
            {
               "strongs": "2007",
               "greek": [
                  {
                     "_BETA": "E)PITI/QHMI",
                     "_unicode": "ἐπιτίθημι",
                     "_translit": "epitíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-tith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to impose (in a friendly or hostile sense)",
               "kjv_def": ":--add\n unto, lade, lay upon, put (up) on, set on (up),\n + surname, X wound.",
               "_strongs": "02007"
            },
            {
               "strongs": "2008",
               "greek": [
                  {
                     "_BETA": "E)PITIMA/W",
                     "_unicode": "ἐπιτιμάω",
                     "_translit": "epitimáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-tee-mah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5091"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tax upon, i.e. censure or admonish; by\n implication, forbid",
               "kjv_def": ":--(straitly) charge, rebuke.",
               "_strongs": "02008"
            },
            {
               "strongs": "2009",
               "greek": [
                  {
                     "_BETA": "E)PITIMI/A",
                     "_unicode": "ἐπιτιμία",
                     "_translit": "epitimía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-tee-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2008"
                     }
                  ],
                  "__text": "properly, esteem, i.e. citizenship;\n used (in the sense of \n) of a penalty"
               },
               "kjv_def": ":--punishment.",
               "_strongs": "02009"
            },
            {
               "strongs": "2010",
               "greek": [
                  {
                     "_BETA": "E)PITRE/PW",
                     "_unicode": "ἐπιτρέπω",
                     "_translit": "epitrépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-trep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to turn over (transfer), i.e.\n allow",
               "kjv_def": ":--give leave (liberty, license), let, permit, suffer.",
               "_strongs": "02010"
            },
            {
               "strongs": "2011",
               "greek": [
                  {
                     "_BETA": "E)PITROPH/",
                     "_unicode": "ἐπιτροπή",
                     "_translit": "epitropḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-trop-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2010"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "permission, i.e. (by implication) full power",
               "kjv_def": ":--commission.",
               "_strongs": "02011"
            },
            {
               "strongs": "2012",
               "greek": [
                  {
                     "_BETA": "E)PI/TROPOS",
                     "_unicode": "ἐπίτροπος",
                     "_translit": "epítropos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-it'-rop-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5158"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2011"
                     }
                  ],
                  "__text": "from \n and \n (in the sense of \n);"
               },
               "strongs_def": "a commissioner, i.e.\n domestic manager, guardian",
               "kjv_def": ":--steward, tutor.",
               "_strongs": "02012"
            },
            {
               "strongs": "2013",
               "greek": [
                  {
                     "_BETA": "E)PITUGXA/NW",
                     "_unicode": "ἐπιτυγχάνω",
                     "_translit": "epitynchánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-toong-khan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5177"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to chance upon, i.e. (by implication) to\n attain",
               "kjv_def": ":--obtain.",
               "_strongs": "02013"
            },
            {
               "strongs": "2014",
               "greek": [
                  {
                     "_BETA": "E)PIFAI/NW",
                     "_unicode": "ἐπιφαίνω",
                     "_translit": "epiphaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-fah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to shine upon, i.e. become (literally) visible or\n (figuratively) known",
               "kjv_def": ":--appear, give light.",
               "_strongs": "02014"
            },
            {
               "strongs": "2015",
               "greek": [
                  {
                     "_BETA": "E)PIFA/NEIA",
                     "_unicode": "ἐπιφάνεια",
                     "_translit": "epipháneia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-if-an'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2016"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a manifestation, i.e. (specially) the advent of Christ\n (past or future)",
               "kjv_def": ":--appearing, brightness.",
               "_strongs": "02015"
            },
            {
               "strongs": "2016",
               "greek": [
                  {
                     "_BETA": "E)PIFANH/S",
                     "_unicode": "ἐπιφανής",
                     "_translit": "epiphanḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-if-an-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2014"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "conspicuous, i.e. (figuratively) memorable",
               "kjv_def": ":--notable.",
               "_strongs": "02016"
            },
            {
               "strongs": "2017",
               "greek": [
                  {
                     "_BETA": "E)PIFAU/W",
                     "_unicode": "ἐπιφαύω",
                     "_translit": "epiphaúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-fow'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2014"
                     }
                  ],
                  "__text": "a form of \n;"
               },
               "strongs_def": "to illuminate (figuratively)",
               "kjv_def": ":--give light.",
               "_strongs": "02017"
            },
            {
               "strongs": "2018",
               "greek": [
                  {
                     "_BETA": "E)PIFE/RW",
                     "_unicode": "ἐπιφέρω",
                     "_translit": "epiphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-fer'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear upon (or further), i.e. adduce (personally\n or judicially (accuse, inflict)), superinduce",
               "kjv_def": ":--add, bring (against),\n take.",
               "_strongs": "02018"
            },
            {
               "strongs": "2019",
               "greek": [
                  {
                     "_BETA": "E)PIFWNE/W",
                     "_unicode": "ἐπιφωνέω",
                     "_translit": "epiphōnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-fo-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5455"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to call at something, i.e. exclaim",
               "kjv_def": ":--cry\n (against), give a shout.",
               "_strongs": "02019"
            },
            {
               "strongs": "2020",
               "greek": [
                  {
                     "_BETA": "E)PIFW/SKW",
                     "_unicode": "ἐπιφώσκω",
                     "_translit": "epiphṓskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-foce'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2017"
                     }
                  ],
                  "__text": "a form of \n;"
               },
               "strongs_def": "to begin to grow light",
               "kjv_def": ":--begin to dawn, X draw on.",
               "_strongs": "02020"
            },
            {
               "strongs": "2021",
               "greek": [
                  {
                     "_BETA": "E)PIXEIRE/W",
                     "_unicode": "ἐπιχειρέω",
                     "_translit": "epicheiréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-khi-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to put the hand upon, i.e. undertake",
               "kjv_def": ":--go about,\n take in hand (upon).",
               "_strongs": "02021"
            },
            {
               "strongs": "2022",
               "greek": [
                  {
                     "_BETA": "E)PIXE/W",
                     "_unicode": "ἐπιχέω",
                     "_translit": "epichéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "XE/W",
                        "_unicode": "χέω",
                        "_translit": "chéō"
                     }
                  ],
                  "__text": "from \n and \n (to pour);"
               },
               "kjv_def": "--to pour upon:--pour in.",
               "_strongs": "02022"
            },
            {
               "strongs": "2023",
               "greek": [
                  {
                     "_BETA": "E)PIXORHGE/W",
                     "_unicode": "ἐπιχορηγέω",
                     "_translit": "epichorēgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-khor-ayg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5524"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to furnish besides, i.e. fully supply,\n (figuratively) aid or contribute",
               "kjv_def": ":--add, minister (nourishment, unto).",
               "_strongs": "02023"
            },
            {
               "strongs": "2024",
               "greek": [
                  {
                     "_BETA": "E)PIXORHGI/A",
                     "_unicode": "ἐπιχορηγία",
                     "_translit": "epichorēgía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-khor-ayg-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2023"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "contribution",
               "kjv_def": ":--supply.",
               "_strongs": "02024"
            },
            {
               "strongs": "2025",
               "greek": [
                  {
                     "_BETA": "E)PIXRI/W",
                     "_unicode": "ἐπιχρίω",
                     "_translit": "epichríō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ee-khree'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5548"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to smear over",
               "kjv_def": ":--anoint.",
               "_strongs": "02025"
            },
            {
               "strongs": "2026",
               "greek": [
                  {
                     "_BETA": "E)POIKODOME/W",
                     "_unicode": "ἐποικοδομέω",
                     "_translit": "epoikodoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-oy-kod-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3618"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to build upon, i.e. (figuratively) to rear\n up",
               "kjv_def": ":--build thereon (thereupon, on, upon).",
               "_strongs": "02026"
            },
            {
               "strongs": "2027",
               "greek": [
                  {
                     "_BETA": "E)POKE/LLW",
                     "_unicode": "ἐποκέλλω",
                     "_translit": "epokéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-ok-el'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "O)KE/LLW",
                        "_unicode": "ὀκέλλω",
                        "_translit": "okéllō"
                     }
                  ],
                  "__text": "from \n and \n (to urge);"
               },
               "strongs_def": "to drive upon the shore, i.e. to beach\n a vessel",
               "kjv_def": ":--run aground.",
               "_strongs": "02027"
            },
            {
               "strongs": "2028",
               "greek": [
                  {
                     "_BETA": "E)PONOMA/ZW",
                     "_unicode": "ἐπονομάζω",
                     "_translit": "eponomázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-on-om-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3687"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to name further, i.e. denominate",
               "kjv_def": ":--call.",
               "_strongs": "02028"
            },
            {
               "strongs": "2029",
               "greek": [
                  {
                     "_BETA": "E)POPTEU/W",
                     "_unicode": "ἐποπτεύω",
                     "_translit": "epopteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-opt-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to inspect, i.e. watch",
               "kjv_def": ":--behold.",
               "_strongs": "02029"
            },
            {
               "strongs": "2030",
               "greek": [
                  {
                     "_BETA": "E)PO/PTHS",
                     "_unicode": "ἐπόπτης",
                     "_translit": "epóptēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-op'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n and a presumed derivative of \n;"
               },
               "strongs_def": "a\n looker-on",
               "kjv_def": ":--eye-witness.",
               "_strongs": "02030"
            },
            {
               "strongs": "2031",
               "greek": [
                  {
                     "_BETA": "E)/POS",
                     "_unicode": "ἔπος",
                     "_translit": "épos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2036"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a word",
               "kjv_def": ":--X say.",
               "_strongs": "02031"
            },
            {
               "strongs": "2032",
               "greek": [
                  {
                     "_BETA": "E)POURA/NIOS",
                     "_unicode": "ἐπουράνιος",
                     "_translit": "epouránios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep-oo-ran'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3772"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "above the sky",
               "kjv_def": ":--celestial, (in) heaven(-ly), high.",
               "_strongs": "02032"
            },
            {
               "strongs": "2033",
               "greek": [
                  {
                     "_BETA": "E(PTA/",
                     "_unicode": "ἑπτά",
                     "_translit": "heptá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hep-tah'"
                  }
               ],
               "strongs_derivation": "a primary number;",
               "strongs_def": "seven",
               "kjv_def": ":--seven.",
               "_strongs": "02033"
            },
            {
               "strongs": "2034",
               "greek": [
                  {
                     "_BETA": "E(PTA/KIS",
                     "_unicode": "ἑπτάκις",
                     "_translit": "heptákis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hep-tak-is'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2033"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "seven times",
               "kjv_def": ":--seven times.",
               "_strongs": "02034"
            },
            {
               "strongs": "2035",
               "greek": [
                  {
                     "_BETA": "E(PTAKISXI/LIOI",
                     "_unicode": "ἑπτακισχίλιοι",
                     "_translit": "heptakischílioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hep-tak-is-khil'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2034"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5507"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "seven times a thousand",
               "kjv_def": ":--seven thousand.",
               "_strongs": "02035"
            },
            {
               "strongs": "2036",
               "greek": [
                  {
                     "_BETA": "E)/PW",
                     "_unicode": "ἔπω",
                     "_translit": "épō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2046"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     }
                  ],
                  "__text": "a primary verb (used only in the definite past tense, the others being\n borrowed from \n, \n, and \n);"
               },
               "strongs_def": "to speak or say (by word or\n writing)",
               "kjv_def": ":--answer, bid, bring word, call, command, grant, say (on),\n speak, tell.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3004"
                  }
               ],
               "_strongs": "02036",
               "__text": "Compare \n."
            },
            {
               "strongs": "2037",
               "greek": [
                  {
                     "_BETA": "*)/ERASTOS",
                     "_unicode": "Ἔραστος",
                     "_translit": "Érastos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er'-as-tos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)RA/W",
                        "_unicode": "ἐράω",
                        "_translit": "eráō"
                     }
                  ],
                  "__text": "from \n (to love);"
               },
               "strongs_def": "beloved; Erastus, a Christian",
               "kjv_def": ":--Erastus.",
               "_strongs": "02037"
            },
            {
               "strongs": "2038",
               "greek": [
                  {
                     "_BETA": "E)RGA/ZOMAI",
                     "_unicode": "ἐργάζομαι",
                     "_translit": "ergázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-gad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to toil (as a task, occupation, etc.), (by\n implication) effect, be engaged in or with, etc.",
               "kjv_def": ":--commit, do, labor\n for, minister about, trade (by), work.",
               "_strongs": "02038"
            },
            {
               "strongs": "2039",
               "greek": [
                  {
                     "_BETA": "E)RGASI/A",
                     "_unicode": "ἐργασία",
                     "_translit": "ergasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-gas-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2040"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "occupation; by implication, profit, pains",
               "kjv_def": ":--craft,\n diligence, gain, work.",
               "_strongs": "02039"
            },
            {
               "strongs": "2040",
               "greek": [
                  {
                     "_BETA": "E)RGA/THS",
                     "_unicode": "ἐργάτης",
                     "_translit": "ergátēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-gat'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a toiler; figuratively, a teacher",
               "kjv_def": ":--labourer, worker(-men).",
               "_strongs": "02040"
            },
            {
               "strongs": "2041",
               "greek": [
                  {
                     "_BETA": "E)/RGON",
                     "_unicode": "ἔργον",
                     "_translit": "érgon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er'-gon"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)/RGW",
                        "_unicode": "ἔργω",
                        "_translit": "érgō"
                     }
                  ],
                  "__text": "from a primary (but obsolete) \n (to work);"
               },
               "strongs_def": "toil (as an effort or\n occupation); by implication, an act",
               "kjv_def": ":--deed, doing, labour, work.",
               "_strongs": "02041"
            },
            {
               "strongs": "2042",
               "greek": [
                  {
                     "_BETA": "E)REQI/ZW",
                     "_unicode": "ἐρεθίζω",
                     "_translit": "erethízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-eth-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2054"
                     }
                  ],
                  "__text": "from a presumed prolonged form of \n;"
               },
               "strongs_def": "to stimulate (especially to\n anger)",
               "kjv_def": ":--provoke.",
               "_strongs": "02042"
            },
            {
               "strongs": "2043",
               "greek": [
                  {
                     "_BETA": "E)REI/DW",
                     "_unicode": "ἐρείδω",
                     "_translit": "ereídō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-i'-do"
                  }
               ],
               "strongs_derivation": "of obscure affinity;",
               "strongs_def": "to prop, i.e. (reflexively) get fast",
               "kjv_def": ":--stick\n fast.",
               "_strongs": "02043"
            },
            {
               "strongs": "2044",
               "greek": [
                  {
                     "_BETA": "E)REU/GOMAI",
                     "_unicode": "ἐρεύγομαι",
                     "_translit": "ereúgomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-yoog'-om-ahee"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to belch, i.e. (figuratively) to speak\n out",
               "kjv_def": ":--utter.",
               "_strongs": "02044"
            },
            {
               "strongs": "2045",
               "greek": [
                  {
                     "_BETA": "E)REUNA/W",
                     "_unicode": "ἐρευνάω",
                     "_translit": "ereunáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-yoo-nah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2046"
                     }
                  ],
                  "__text": "apparently from \n (through the idea of inquiry);"
               },
               "strongs_def": "to seek, i.e.\n (figuratively) to investigate",
               "kjv_def": ":--search.",
               "_strongs": "02045"
            },
            {
               "strongs": "2046",
               "greek": [
                  {
                     "_BETA": "E)RE/W",
                     "_unicode": "ἐρέω",
                     "_translit": "eréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     }
                  ],
                  "__text": "probably a fuller form of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2036"
                     }
                  ],
                  "__text": "an alternate for \n in certain\n tenses; to utter, i.e. speak or say"
               },
               "kjv_def": ":--call, say, speak (of), tell.",
               "_strongs": "02046"
            },
            {
               "strongs": "2047",
               "greek": [
                  {
                     "_BETA": "E)RHMI/A",
                     "_unicode": "ἐρημία",
                     "_translit": "erēmía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-ay-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2048"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "solitude (concretely)",
               "kjv_def": ":--desert, wilderness.",
               "_strongs": "02047"
            },
            {
               "strongs": "2048",
               "greek": [
                  {
                     "_BETA": "E)/RHMOS",
                     "_unicode": "ἔρημος",
                     "_translit": "érēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er'-ay-mos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "lonesome, i.e. (by implication) waste (usually\n as a noun, \n being implied)"
               },
               "kjv_def": ":--desert, desolate, solitary,\n wilderness.",
               "_strongs": "02048"
            },
            {
               "strongs": "2049",
               "greek": [
                  {
                     "_BETA": "E)RHMO/W",
                     "_unicode": "ἐρημόω",
                     "_translit": "erēmóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-ay-mo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2048"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to lay waste (literally or figuratively)",
               "kjv_def": ":--(bring to, make)\n desolate(-ion), come to nought.",
               "_strongs": "02049"
            },
            {
               "strongs": "2050",
               "greek": [
                  {
                     "_BETA": "E)RH/MWSIS",
                     "_unicode": "ἐρήμωσις",
                     "_translit": "erḗmōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-ay'-mo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2049"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "despoliation",
               "kjv_def": ":--desolation.",
               "_strongs": "02050"
            },
            {
               "strongs": "2051",
               "greek": [
                  {
                     "_BETA": "E)RI/ZW",
                     "_unicode": "ἐρίζω",
                     "_translit": "erízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2054"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to wrangle",
               "kjv_def": ":--strive.",
               "_strongs": "02051"
            },
            {
               "strongs": "2052",
               "greek": [
                  {
                     "_BETA": "E)RIQEI/A",
                     "_unicode": "ἐριθεία",
                     "_translit": "eritheía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-ith-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2042"
                     }
                  ],
                  "__text": "perhaps as the same as \n;"
               },
               "strongs_def": "properly, intrigue, i.e. (by implication)\n faction",
               "kjv_def": ":--contention(-ious), strife.",
               "_strongs": "02052"
            },
            {
               "strongs": "2053",
               "greek": [
                  {
                     "_BETA": "E)/RION",
                     "_unicode": "ἔριον",
                     "_translit": "érion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er'-ee-on"
                  }
               ],
               "strongs_derivation": "of obscure affinity;",
               "strongs_def": "wool",
               "kjv_def": ":--wool.",
               "_strongs": "02053"
            },
            {
               "strongs": "2054",
               "greek": [
                  {
                     "_BETA": "E)/RIS",
                     "_unicode": "ἔρις",
                     "_translit": "éris"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er'-is"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a quarrel, i.e. (by implication)\n wrangling",
               "kjv_def": ":--contention, debate, strife, variance.",
               "_strongs": "02054"
            },
            {
               "strongs": "2055",
               "greek": [
                  {
                     "_BETA": "E)RI/FION",
                     "_unicode": "ἐρίφιον",
                     "_translit": "eríphion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-if'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2056"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a kidling, i.e. (genitive case) goat (symbolically, wicked\n person)",
               "kjv_def": ":--goat.",
               "_strongs": "02055"
            },
            {
               "strongs": "2056",
               "greek": [
                  {
                     "_BETA": "E)/RIFOS",
                     "_unicode": "ἔριφος",
                     "_translit": "ériphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er'-if-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2053"
                     }
                  ],
                  "__text": "perhaps from the same as \n (through the idea of hairiness);"
               },
               "strongs_def": "a kid\n or (genitive case) goat",
               "kjv_def": ":--goat, kid.",
               "_strongs": "02056"
            },
            {
               "strongs": "2057",
               "greek": [
                  {
                     "_BETA": "*(ERMA=S",
                     "_unicode": "Ἑρμᾶς",
                     "_translit": "Hermâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "her-mas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2060"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "Hermas, a Christian",
               "kjv_def": ":--Hermas.",
               "_strongs": "02057"
            },
            {
               "strongs": "2058",
               "greek": [
                  {
                     "_BETA": "E(RMHNEI/A",
                     "_unicode": "ἑρμηνεία",
                     "_translit": "hermēneía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "her-may-ni'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2059"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "translation",
               "kjv_def": ":--interpretation.",
               "_strongs": "02058"
            },
            {
               "strongs": "2059",
               "greek": [
                  {
                     "_BETA": "E(RMHNEU/W",
                     "_unicode": "ἑρμηνεύω",
                     "_translit": "hermēneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "her-mayn-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2060"
                     }
                  ],
                  "__text": "from a presumed derivative of \n (as the god of language);"
               },
               "strongs_def": "to\n translate",
               "kjv_def": ":--interpret.",
               "_strongs": "02059"
            },
            {
               "strongs": "2060",
               "greek": [
                  {
                     "_BETA": "*(ERMH=S",
                     "_unicode": "Ἑρμῆς",
                     "_translit": "Hermēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "her-mace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2046"
                     }
                  ],
                  "__text": "perhaps from \n;"
               },
               "strongs_def": "Hermes, the name of the messenger of the Greek\n deities; also of a Christian",
               "kjv_def": ":--Hermes, Mercury.",
               "_strongs": "02060"
            },
            {
               "strongs": "2061",
               "greek": [
                  {
                     "_BETA": "*(ERMOGE/NHS",
                     "_unicode": "Ἑρμογένης",
                     "_translit": "Hermogénēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "her-mog-en'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2060"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "born of Hermes; Hermogenes, an apostate\n Christian",
               "kjv_def": ":--Hermogenes.",
               "_strongs": "02061"
            },
            {
               "strongs": "2062",
               "greek": [
                  {
                     "_BETA": "E(RPETO/N",
                     "_unicode": "ἑρπετόν",
                     "_translit": "herpetón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "her-pet-on'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E(/RPW",
                        "_unicode": "ἕρπω",
                        "_translit": "hérpō"
                     }
                  ],
                  "__text": "neuter of a derivative of \n (to creep);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07431"
                     }
                  ],
                  "__text": "a reptile, i.e. (by\n Hebraism (compare \n)) a small animal"
               },
               "kjv_def": ":--creeping thing, serpent.",
               "_strongs": "02062"
            },
            {
               "strongs": "2063",
               "greek": [
                  {
                     "_BETA": "E)RUQRO/S",
                     "_unicode": "ἐρυθρός",
                     "_translit": "erythrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-oo-thros'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2281"
                     }
                  ],
                  "__text": "red, i.e. (with \n) the Red Sea"
               },
               "kjv_def": ":--red.",
               "_strongs": "02063"
            },
            {
               "strongs": "2064",
               "greek": [
                  {
                     "_BETA": "E)/RXOMAI",
                     "_unicode": "ἔρχομαι",
                     "_translit": "érchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)LEU/QOMAI",
                        "_unicode": "ἐλεύθομαι",
                        "_translit": "eleúthomai"
                     },
                     {
                        "_BETA": "E)/LQW",
                        "_unicode": "ἔλθω",
                        "_translit": "élthō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "el-yoo'-thom-ahee"
                     },
                     {
                        "_strongs": "el'-tho"
                     }
                  ],
                  "__text": "middle voice of a primary verb \n\n (used only in the present and imperfect tenses, the others being \n supplied by a kindred (middle voice)\n       \n      \n  \n,    or (active)\n      \n  \n,\n       \n which do not otherwise occur);"
               },
               "strongs_def": "to come or go (in a great variety of applications, literally and \n figuratively)",
               "kjv_def": ":--accompany, appear, bring, come, enter, fall out, go,\n grow, X light, X next, pass, resort, be set.",
               "_strongs": "02064"
            },
            {
               "strongs": "2065",
               "greek": [
                  {
                     "_BETA": "E)RWTA/W",
                     "_unicode": "ἐρωτάω",
                     "_translit": "erōtáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "er-o-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2046"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2045"
                     }
                  ],
                  "__text": "apparently from \n (compare \n);"
               },
               "strongs_def": "to interrogate; by implication,\n to request",
               "kjv_def": ":--ask, beseech, desire, intreat, pray.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4441"
                  }
               ],
               "_strongs": "02065",
               "__text": "Compare \n."
            },
            {
               "strongs": "2066",
               "greek": [
                  {
                     "_BETA": "E)SQH/S",
                     "_unicode": "ἐσθής",
                     "_translit": "esthḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-thace'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E(/NNUMI",
                        "_unicode": "ἕννυμι",
                        "_translit": "hénnymi"
                     }
                  ],
                  "__text": "from \n (to clothe);"
               },
               "strongs_def": "dress",
               "kjv_def": ":--apparel, clothing, raiment, robe.",
               "_strongs": "02066"
            },
            {
               "strongs": "2067",
               "greek": [
                  {
                     "_BETA": "E)/SQHSIS",
                     "_unicode": "ἔσθησις",
                     "_translit": "ésthēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es'-thay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2066"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "clothing (concretely)",
               "kjv_def": ":--government.",
               "_strongs": "02067"
            },
            {
               "strongs": "2068",
               "greek": [
                  {
                     "_BETA": "E)SQI/W",
                     "_unicode": "ἐσθίω",
                     "_translit": "esthíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-thee'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)/DW",
                        "_unicode": "ἔδω",
                        "_translit": "édō"
                     }
                  ],
                  "__text": "strengthened for a primary \n (to eat);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5315"
                     }
                  ],
                  "__text": "used only in certain tenses,\n the rest being supplied by \n; to eat (usually literal)"
               },
               "kjv_def": ":--devour,\n eat, live.",
               "_strongs": "02068"
            },
            {
               "strongs": "2069",
               "greek": [
                  {
                     "_BETA": "*)ESLI/",
                     "_unicode": "Ἐσλί",
                     "_translit": "Eslí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-lee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0454"
                     }
                  ],
                  "__text": "of Hebrew origin (probably for \n);"
               },
               "strongs_def": "Esli, an Israelite",
               "kjv_def": ":--Esli.",
               "_strongs": "02069"
            },
            {
               "strongs": "2070",
               "greek": [
                  {
                     "_BETA": "E)SME/N",
                     "_unicode": "ἐσμέν",
                     "_translit": "esmén"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-men'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "first person plural indicative of \n;"
               },
               "strongs_def": "we are",
               "kjv_def": ":--are, be, have our\n being, X have hope, + (the gospel) was (preached unto) us.",
               "_strongs": "02070"
            },
            {
               "strongs": "2071",
               "greek": [
                  {
                     "_BETA": "E)/SOMAI",
                     "_unicode": "ἔσομαι",
                     "_translit": "ésomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "future of \n;"
               },
               "strongs_def": "will be",
               "kjv_def": ":--shall (should) be (have), (shall) come (to\n pass), X may have, X fall, what would follow, X live long, X sojourn.",
               "_strongs": "02071"
            },
            {
               "strongs": "2072",
               "greek": [
                  {
                     "_BETA": "E)/SOPTRON",
                     "_unicode": "ἔσοπτρον",
                     "_translit": "ésoptron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es'-op-tron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n and a presumed derivative of \n;"
               },
               "strongs_def": "a mirror (for looking\n into)",
               "kjv_def": ":--glass.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2734"
                  }
               ],
               "_strongs": "02072",
               "__text": "Compare \n."
            },
            {
               "strongs": "2073",
               "greek": [
                  {
                     "_BETA": "E(SPE/RA",
                     "_unicode": "ἑσπέρα",
                     "_translit": "hespéra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hes-per'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5610"
                     }
                  ],
                  "__text": "feminine of an adjective hesperos (evening); the eve (\n being\n implied)"
               },
               "kjv_def": ":--evening(-tide).",
               "_strongs": "02073"
            },
            {
               "strongs": "2074",
               "greek": [
                  {
                     "_BETA": "*)ESRW/M",
                     "_unicode": "Ἐσρώμ",
                     "_translit": "Esrṓm"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-rome"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02696"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Esrom (i.e. Chetsron), an Israelite",
               "kjv_def": ":--Esrom.",
               "_strongs": "02074"
            },
            {
               "strongs": "2075",
               "greek": [
                  {
                     "_BETA": "E)STE/",
                     "_unicode": "ἐστέ",
                     "_translit": "esté"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-teh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "second person plural present indicative of \n;"
               },
               "strongs_def": "ye are",
               "kjv_def": ":--be, have\n been, belong.",
               "_strongs": "02075"
            },
            {
               "strongs": "2076",
               "greek": [
                  {
                     "_BETA": "E)STI/",
                     "_unicode": "ἐστί",
                     "_translit": "estí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-tee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "third person singular present indicative of \n;"
               },
               "strongs_def": "he (she or it) is;\n also (with neuter plural) they are",
               "kjv_def": ":--are, be(-long), call, X\n can(-not), come, consisteth, X dure for a while, + follow, X have,\n (that) is (to say), make, meaneth, X must needs, + profit, +\n remaineth, + wrestle.",
               "_strongs": "02076"
            },
            {
               "strongs": "2077",
               "greek": [
                  {
                     "_BETA": "E)/STW",
                     "_unicode": "ἔστω",
                     "_translit": "éstō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "second person singular present imperative of \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "E)/STWSAN",
                        "_unicode": "ἔστωσαν",
                        "_translit": "éstōsan"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "es'-to-san"
                     }
                  ],
                  "__text": "be thou; \n\n also  \n  \n, third person of the same;\n\n let them be"
               },
               "kjv_def": ":--be.",
               "_strongs": "02077"
            },
            {
               "strongs": "2078",
               "greek": [
                  {
                     "_BETA": "E)/SXATOS",
                     "_unicode": "ἔσχατος",
                     "_translit": "éschatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es'-khat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "a superlative probably from \n (in the sense of contiguity);"
               },
               "strongs_def": "farthest, final (of place or time)",
               "kjv_def": ":--ends of, last, latter end,\n lowest, uttermost.",
               "_strongs": "02078"
            },
            {
               "strongs": "2079",
               "greek": [
                  {
                     "_BETA": "E)SXA/TWS",
                     "_unicode": "ἐσχάτως",
                     "_translit": "eschátōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-khat'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2078"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "finally, i.e. (with \n) at the extremity of\n life"
               },
               "kjv_def": ":--point of death.",
               "_strongs": "02079"
            },
            {
               "strongs": "2080",
               "greek": [
                  {
                     "_BETA": "E)/SW",
                     "_unicode": "ἔσω",
                     "_translit": "ésō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inside (as preposition or adjective)",
               "kjv_def": ":-- (with-)in(-ner,\n -to, -ward).",
               "_strongs": "02080"
            },
            {
               "strongs": "2081",
               "greek": [
                  {
                     "_BETA": "E)/SWQEN",
                     "_unicode": "ἔσωθεν",
                     "_translit": "ésōthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es'-o-then"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2080"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2080"
                     }
                  ],
                  "__text": "from inside; also used as equivalent to \n\n (inside)"
               },
               "kjv_def": ":--inward(-ly), (from) within, without.",
               "_strongs": "02081"
            },
            {
               "strongs": "2082",
               "greek": [
                  {
                     "_BETA": "E)SW/TEROS",
                     "_unicode": "ἐσώτερος",
                     "_translit": "esṓteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-o'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2080"
                     }
                  ],
                  "__text": "comparative of \n;"
               },
               "strongs_def": "interior",
               "kjv_def": ":--inner, within.",
               "_strongs": "02082"
            },
            {
               "strongs": "2083",
               "greek": [
                  {
                     "_BETA": "E(TAI=ROS",
                     "_unicode": "ἑταῖρος",
                     "_translit": "hetaîros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het-ah'-ee-ros"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)/THS",
                        "_unicode": "ἔτης",
                        "_translit": "étēs"
                     }
                  ],
                  "__text": "from \n (a clansman);"
               },
               "strongs_def": "a comrade",
               "kjv_def": ":--fellow, friend.",
               "_strongs": "02083"
            },
            {
               "strongs": "2084",
               "greek": [
                  {
                     "_BETA": "E(TERO/GLWSSOS",
                     "_unicode": "ἑτερόγλωσσος",
                     "_translit": "heteróglōssos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het-er-og'-loce-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2087"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1100"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "other- tongued, i.e. a foreigner",
               "kjv_def": ":--man of other\n tongue.",
               "_strongs": "02084"
            },
            {
               "strongs": "2085",
               "greek": [
                  {
                     "_BETA": "E(TERODIDASKALE/W",
                     "_unicode": "ἑτεροδιδασκαλέω",
                     "_translit": "heterodidaskaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het-er-od-id-as-kal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2087"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1320"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to instruct differently",
               "kjv_def": ":--teach other\n doctrine(-wise).",
               "_strongs": "02085"
            },
            {
               "strongs": "2086",
               "greek": [
                  {
                     "_BETA": "E(TEROZUGE/W",
                     "_unicode": "ἑτεροζυγέω",
                     "_translit": "heterozygéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het-er-od-zoog-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2087"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2218"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to yoke up differently, i.e.\n (figuratively) to associate discordantly",
               "kjv_def": ":--unequally yoke together\n with.",
               "_strongs": "02086"
            },
            {
               "strongs": "2087",
               "greek": [
                  {
                     "_BETA": "E(/TEROS",
                     "_unicode": "ἕτερος",
                     "_translit": "héteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het'-er-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "(an-, the) other or different",
               "kjv_def": ":--altered, else,\n next (day), one, (an-)other, some, strange.",
               "_strongs": "02087"
            },
            {
               "strongs": "2088",
               "greek": [
                  {
                     "_BETA": "E(TE/RWS",
                     "_unicode": "ἑτέρως",
                     "_translit": "hetérōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het-er'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2087"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "differently",
               "kjv_def": ":--otherwise.",
               "_strongs": "02088"
            },
            {
               "strongs": "2089",
               "greek": [
                  {
                     "_BETA": "E)/TI",
                     "_unicode": "ἔτι",
                     "_translit": "éti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "et'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2094"
                     }
                  ],
                  "__text": "perhaps akin to \n;"
               },
               "strongs_def": "\"yet,\" still (of time or degree)",
               "kjv_def": ":--after that,\n also, ever, (any) further, (t-)henceforth (more), hereafter, (any)\n longer, (any) more(-one), now, still, yet.",
               "_strongs": "02089"
            },
            {
               "strongs": "2090",
               "greek": [
                  {
                     "_BETA": "E(TOIMA/ZW",
                     "_unicode": "ἑτοιμάζω",
                     "_translit": "hetoimázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het-oy-mad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2092"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to prepare",
               "kjv_def": ":--prepare, provide, make ready.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2680"
                  }
               ],
               "_strongs": "02090",
               "__text": "Compare \n."
            },
            {
               "strongs": "2091",
               "greek": [
                  {
                     "_BETA": "E(TOIMASI/A",
                     "_unicode": "ἑτοιμασία",
                     "_translit": "hetoimasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het-oy-mas-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2090"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "preparation",
               "kjv_def": ":--preparation.",
               "_strongs": "02091"
            },
            {
               "strongs": "2092",
               "greek": [
                  {
                     "_BETA": "E(/TOIMOS",
                     "_unicode": "ἕτοιμος",
                     "_translit": "hétoimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het-oy'-mos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)TEO/S",
                        "_unicode": "ἐτεός",
                        "_translit": "eteós"
                     }
                  ],
                  "__text": "from an old noun \n (fitness);"
               },
               "strongs_def": "adjusted, i.e. ready",
               "kjv_def": ":--prepared,\n (made) ready(-iness, to our hand).",
               "_strongs": "02092"
            },
            {
               "strongs": "2093",
               "greek": [
                  {
                     "_BETA": "E(TOI/MWS",
                     "_unicode": "ἑτοίμως",
                     "_translit": "hetoímōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "het'-oy-moce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2092"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "in readiness",
               "kjv_def": ":--ready.",
               "_strongs": "02093"
            },
            {
               "strongs": "2094",
               "greek": [
                  {
                     "_BETA": "E)/TOS",
                     "_unicode": "ἔτος",
                     "_translit": "étos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "et'-os"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a year",
               "kjv_def": ":--year.",
               "_strongs": "02094"
            },
            {
               "strongs": "2095",
               "greek": [
                  {
                     "_BETA": "EU)=",
                     "_unicode": "εὖ",
                     "_translit": "eû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "EU)=S",
                        "_unicode": "εὖς",
                        "_translit": "eûs"
                     }
                  ],
                  "__text": "neuter of a primary \n (good);"
               },
               "strongs_def": "(adverbially) well",
               "kjv_def": ":--good, well\n (done).",
               "_strongs": "02095"
            },
            {
               "strongs": "2096",
               "greek": [
                  {
                     "_BETA": "*EU)=A",
                     "_unicode": "Εὖα",
                     "_translit": "Eûa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02332"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Eua (or Eva, i.e. Chavvah), the first\n woman",
               "kjv_def": ":--Eve.",
               "_strongs": "02096"
            },
            {
               "strongs": "2097",
               "greek": [
                  {
                     "_BETA": "EU)AGGELI/ZW",
                     "_unicode": "εὐαγγελίζω",
                     "_translit": "euangelízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-ang-ghel-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to announce good news (\"evangelize\") especially the\n gospel",
               "kjv_def": ":--declare, bring (declare, show) glad (good) tidings, preach\n (the gospel).",
               "_strongs": "02097"
            },
            {
               "strongs": "2098",
               "greek": [
                  {
                     "_BETA": "EU)AGGE/LION",
                     "_unicode": "εὐαγγέλιον",
                     "_translit": "euangélion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-ang-ghel'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2097"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a good message, i.e. the gospel",
               "kjv_def": ":--gospel.",
               "_strongs": "02098"
            },
            {
               "strongs": "2099",
               "greek": [
                  {
                     "_BETA": "EU)AGGELISTH/S",
                     "_unicode": "εὐαγγελιστής",
                     "_translit": "euangelistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-ang-ghel-is-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2097"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a preacher of the gospel",
               "kjv_def": ":--evangelist.",
               "_strongs": "02099"
            },
            {
               "strongs": "2100",
               "greek": [
                  {
                     "_BETA": "EU)ARESTE/W",
                     "_unicode": "εὐαρεστέω",
                     "_translit": "euarestéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-ar-es-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2101"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to gratify entirely",
               "kjv_def": ":--please (well).",
               "_strongs": "02100"
            },
            {
               "strongs": "2101",
               "greek": [
                  {
                     "_BETA": "EU)A/RESTOS",
                     "_unicode": "εὐάρεστος",
                     "_translit": "euárestos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-ar'-es-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "701"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fully agreeable",
               "kjv_def": ":--acceptable(-ted), wellpleasing.",
               "_strongs": "02101"
            },
            {
               "strongs": "2102",
               "greek": [
                  {
                     "_BETA": "EU)ARE/STWS",
                     "_unicode": "εὐαρέστως",
                     "_translit": "euaréstōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-ar-es'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2101"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "quite agreeably",
               "kjv_def": ":--acceptably, + please well.",
               "_strongs": "02102"
            },
            {
               "strongs": "2103",
               "greek": [
                  {
                     "_BETA": "*EU)/BOULOS",
                     "_unicode": "Εὔβουλος",
                     "_translit": "Eúboulos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-boo-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1014"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "good-willer; Eubulus, a Christian",
               "kjv_def": ":--Eubulus.",
               "_strongs": "02103"
            },
            {
               "strongs": "2104",
               "greek": [
                  {
                     "_BETA": "EU)GENH/S",
                     "_unicode": "εὐγενής",
                     "_translit": "eugenḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoog-en'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "well born, i.e. (literally) high in rank, or\n (figuratively) generous",
               "kjv_def": ":--more noble, nobleman.",
               "_strongs": "02104"
            },
            {
               "strongs": "2105",
               "greek": [
                  {
                     "_BETA": "EU)DI/A",
                     "_unicode": "εὐδία",
                     "_translit": "eudía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-dee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2203"
                     }
                  ],
                  "__text": "feminine from \n and the alternate of \n (as the god of the\n weather);"
               },
               "strongs_def": "a clear sky, i.e. fine weather",
               "kjv_def": ":--fair weather.",
               "_strongs": "02105"
            },
            {
               "strongs": "2106",
               "greek": [
                  {
                     "_BETA": "EU)DOKE/W",
                     "_unicode": "εὐδοκέω",
                     "_translit": "eudokéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-dok-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1380"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to think well of, i.e. approve (an act);\n specially, to approbate (a person or thing)",
               "kjv_def": ":--think good, (be well)\n please(-d), be the good (have, take) pleasure, be willing.",
               "_strongs": "02106"
            },
            {
               "strongs": "2107",
               "greek": [
                  {
                     "_BETA": "EU)DOKI/A",
                     "_unicode": "εὐδοκία",
                     "_translit": "eudokía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-dok-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1380"
                     }
                  ],
                  "__text": "from a presumed compound of \n and the base of \n;"
               },
               "strongs_def": "satisfaction,\n i.e. (subjectively) delight, or (objectively) kindness, wish,\n purpose",
               "kjv_def": ":--desire, good pleasure (will), X seem good.",
               "_strongs": "02107"
            },
            {
               "strongs": "2108",
               "greek": [
                  {
                     "_BETA": "EU)ERGESI/A",
                     "_unicode": "εὐεργεσία",
                     "_translit": "euergesía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-erg-es-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2110"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "beneficence (genitive case or specially)",
               "kjv_def": ":--benefit, good\n deed done.",
               "_strongs": "02108"
            },
            {
               "strongs": "2109",
               "greek": [
                  {
                     "_BETA": "EU)ERGETE/W",
                     "_unicode": "εὐεργετέω",
                     "_translit": "euergetéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-erg-et-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2110"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be philanthropic",
               "kjv_def": ":--do good.",
               "_strongs": "02109"
            },
            {
               "strongs": "2110",
               "greek": [
                  {
                     "_BETA": "EU)ERGE/THS",
                     "_unicode": "εὐεργέτης",
                     "_translit": "euergétēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-erg-et'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "a worker of good, i.e. (specially) a\n philanthropist",
               "kjv_def": ":--benefactor.",
               "_strongs": "02110"
            },
            {
               "strongs": "2111",
               "greek": [
                  {
                     "_BETA": "EU)/QETOS",
                     "_unicode": "εὔθετος",
                     "_translit": "eúthetos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-thet-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "well placed, i.e. (figuratively)\n appropriate",
               "kjv_def": ":--fit, meet.",
               "_strongs": "02111"
            },
            {
               "strongs": "2112",
               "greek": [
                  {
                     "_BETA": "EU)QE/WS",
                     "_unicode": "εὐθέως",
                     "_translit": "euthéōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-theh'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2117"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "directly, i.e. at once or soon",
               "kjv_def": ":--anon, as soon as,\n forthwith, immediately, shortly, straightway.",
               "_strongs": "02112"
            },
            {
               "strongs": "2113",
               "greek": [
                  {
                     "_BETA": "EU)QUDROME/W",
                     "_unicode": "εὐθυδρομέω",
                     "_translit": "euthydroméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-thoo-drom-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2117"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1408"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lay a straight course, i.e. sail\n direct",
               "kjv_def": ":--(come) with a straight course.",
               "_strongs": "02113"
            },
            {
               "strongs": "2114",
               "greek": [
                  {
                     "_BETA": "EU)QUME/W",
                     "_unicode": "εὐθυμέω",
                     "_translit": "euthyméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-thoo-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2115"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to cheer up, i.e. (intransitively) be cheerful; neuter\n comparative (adverbially) more cheerfully",
               "kjv_def": ":--be of good cheer (merry).",
               "_strongs": "02114"
            },
            {
               "strongs": "2115",
               "greek": [
                  {
                     "_BETA": "EU)/QUMOS",
                     "_unicode": "εὔθυμος",
                     "_translit": "eúthymos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-thoo-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "in fine spirits, i.e. cheerful",
               "kjv_def": ":--of good cheer,\n the more cheerfully.",
               "_strongs": "02115"
            },
            {
               "strongs": "2116",
               "greek": [
                  {
                     "_BETA": "EU)QU/NW",
                     "_unicode": "εὐθύνω",
                     "_translit": "euthýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-thoo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2117"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to straighten (level); technically, to steer",
               "kjv_def": ":--governor,\n make straight.",
               "_strongs": "02116"
            },
            {
               "strongs": "2117",
               "greek": [
                  {
                     "_BETA": "EU)QU/S",
                     "_unicode": "εὐθύς",
                     "_translit": "euthýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-thoos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "perhaps from \n and \n;"
               },
               "strongs_def": "straight, i.e. (literally) level, or\n (figuratively) true; adverbially (of time) at once",
               "kjv_def": ":--anon, by and by,\n forthwith, immediately, straightway.",
               "_strongs": "02117"
            },
            {
               "strongs": "2118",
               "greek": [
                  {
                     "_BETA": "EU)QU/THS",
                     "_unicode": "εὐθύτης",
                     "_translit": "euthýtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-thoo'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2117"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "rectitude",
               "kjv_def": ":--righteousness.",
               "_strongs": "02118"
            },
            {
               "strongs": "2119",
               "greek": [
                  {
                     "_BETA": "EU)KAIRE/W",
                     "_unicode": "εὐκαιρέω",
                     "_translit": "eukairéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-kahee-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2121"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to have good time, i.e. opportunity or leisure",
               "kjv_def": ":--have\n leisure (convenient time), spend time.",
               "_strongs": "02119"
            },
            {
               "strongs": "2120",
               "greek": [
                  {
                     "_BETA": "EU)KAIRI/A",
                     "_unicode": "εὐκαιρία",
                     "_translit": "eukairía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-kahee-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2121"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a favorable occasion",
               "kjv_def": ":--opportunity.",
               "_strongs": "02120"
            },
            {
               "strongs": "2121",
               "greek": [
                  {
                     "_BETA": "EU)/KAIROS",
                     "_unicode": "εὔκαιρος",
                     "_translit": "eúkairos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-kahee-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2540"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "well-timed, i.e. opportune",
               "kjv_def": ":--convenient, in time\n of need.",
               "_strongs": "02121"
            },
            {
               "strongs": "2122",
               "greek": [
                  {
                     "_BETA": "EU)KAI/RWS",
                     "_unicode": "εὐκαίρως",
                     "_translit": "eukaírōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-kah'-ee-roce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2121"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "opportunely",
               "kjv_def": ":--conveniently, in season.",
               "_strongs": "02122"
            },
            {
               "strongs": "2123",
               "greek": [
                  {
                     "_BETA": "EU)KOPW/TEROS",
                     "_unicode": "εὐκοπώτερος",
                     "_translit": "eukopṓteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-kop-o'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2873"
                     }
                  ],
                  "__text": "comparative of a compound of \n and \n;"
               },
               "strongs_def": "better for toil, i.e. more\n facile",
               "kjv_def": ":--easier.",
               "_strongs": "02123"
            },
            {
               "strongs": "2124",
               "greek": [
                  {
                     "_BETA": "EU)LA/BEIA",
                     "_unicode": "εὐλάβεια",
                     "_translit": "eulábeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-lab'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2126"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, caution, i.e. (religiously) reverence (piety); by\n implication, dread (concretely)",
               "kjv_def": ":--fear(-ed).",
               "_strongs": "02124"
            },
            {
               "strongs": "2125",
               "greek": [
                  {
                     "_BETA": "EU)LABE/OMAI",
                     "_unicode": "εὐλαβέομαι",
                     "_translit": "eulabéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-lab-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2126"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to be circumspect, i.e. (by implication) to be\n apprehensive; religiously, to reverence",
               "kjv_def": ":--(moved with) fear.",
               "_strongs": "02125"
            },
            {
               "strongs": "2126",
               "greek": [
                  {
                     "_BETA": "EU)LABH/S",
                     "_unicode": "εὐλαβής",
                     "_translit": "eulabḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-lab-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "taking well (carefully), i.e. circumspect\n (religiously, pious)",
               "kjv_def": ":--devout.",
               "_strongs": "02126"
            },
            {
               "strongs": "2127",
               "greek": [
                  {
                     "_BETA": "EU)LOGE/W",
                     "_unicode": "εὐλογέω",
                     "_translit": "eulogéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-log-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to speak well of, i.e. (religiously)\n to bless (thank or invoke a benediction upon, prosper)",
               "kjv_def": ":--bless,\n praise.",
               "_strongs": "02127"
            },
            {
               "strongs": "2128",
               "greek": [
                  {
                     "_BETA": "EU)LOGHTO/S",
                     "_unicode": "εὐλογητός",
                     "_translit": "eulogētós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-log-ay-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2127"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "adorable",
               "kjv_def": ":--blessed.",
               "_strongs": "02128"
            },
            {
               "strongs": "2129",
               "greek": [
                  {
                     "_BETA": "EU)LOGI/A",
                     "_unicode": "εὐλογία",
                     "_translit": "eulogía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-log-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2127"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "fine speaking, i.e. elegance of language;\n commendation (\"eulogy\"), i.e. (reverentially) adoration; religiously,\n benediction; by implication, consecration; by extension, benefit or\n largess",
               "kjv_def": ":--blessing (a matter of) bounty (X -tifully), fair speech.",
               "_strongs": "02129"
            },
            {
               "strongs": "2130",
               "greek": [
                  {
                     "_BETA": "EU)META/DOTOS",
                     "_unicode": "εὐμετάδοτος",
                     "_translit": "eumetádotos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-met-ad'-ot-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3330"
                     }
                  ],
                  "__text": "from \n and a presumed derivative of \n;"
               },
               "strongs_def": "good at imparting, i.e.\n liberal",
               "kjv_def": ":--ready to distribute.",
               "_strongs": "02130"
            },
            {
               "strongs": "2131",
               "greek": [
                  {
                     "_BETA": "*EU)NI/KH",
                     "_unicode": "Εὐνίκη",
                     "_translit": "Euníkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-nee'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3529"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "victorious; Eunice, a Jewess",
               "kjv_def": ":--Eunice.",
               "_strongs": "02131"
            },
            {
               "strongs": "2132",
               "greek": [
                  {
                     "_BETA": "EU)NOE/W",
                     "_unicode": "εὐνοέω",
                     "_translit": "eunoéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-no-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be well- minded, i.e.\n reconcile",
               "kjv_def": ":--agree.",
               "_strongs": "02132"
            },
            {
               "strongs": "2133",
               "greek": [
                  {
                     "_BETA": "EU)/NOIA",
                     "_unicode": "εὔνοια",
                     "_translit": "eúnoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-noy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2132"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "kindness; euphemistically, conjugal\n duty",
               "kjv_def": ":--benevolence, good will.",
               "_strongs": "02133"
            },
            {
               "strongs": "2134",
               "greek": [
                  {
                     "_BETA": "EU)NOUXI/ZW",
                     "_unicode": "εὐνουχίζω",
                     "_translit": "eunouchízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-noo-khid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2135"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to castrate (figuratively, live unmarried)",
               "kjv_def": ":--make…eunuch.",
               "_strongs": "02134"
            },
            {
               "strongs": "2135",
               "greek": [
                  {
                     "_BETA": "EU)NOU=XOS",
                     "_unicode": "εὐνοῦχος",
                     "_translit": "eunoûchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-noo'-khos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "EU)NH/",
                        "_unicode": "εὐνή",
                        "_translit": "eunḗ"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n (a bed) and \n;"
               },
               "strongs_def": "a castrated person (such being employed in\n Oriental bed-chambers); by extension an impotent or unmarried man; by\n implication, a chamberlain (state-officer)",
               "kjv_def": ":--eunuch.",
               "_strongs": "02135"
            },
            {
               "strongs": "2136",
               "greek": [
                  {
                     "_BETA": "*EU)ODI/A",
                     "_unicode": "Εὐοδία",
                     "_translit": "Euodía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-od-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2137"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "fine travelling; Euodia, a Christian\n woman",
               "kjv_def": ":--Euodias.",
               "_strongs": "02136"
            },
            {
               "strongs": "2137",
               "greek": [
                  {
                     "_BETA": "EU)ODO/W",
                     "_unicode": "εὐοδόω",
                     "_translit": "euodóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-od-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to help on the road, i.e.\n (passively) succeed in reaching; figuratively, to succeed in business\n affairs",
               "kjv_def": ":--(have a) prosper(-ous journey).",
               "_strongs": "02137"
            },
            {
               "strongs": "2138",
               "greek": [
                  {
                     "_BETA": "EU)PEIQH/S",
                     "_unicode": "εὐπειθής",
                     "_translit": "eupeithḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-pi-thace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "good for persuasion, i.e. (intransitively)\n complaint",
               "kjv_def": ":--easy to be intreated.",
               "_strongs": "02138"
            },
            {
               "strongs": "2139",
               "greek": [
                  {
                     "_BETA": "EU)PERI/STATOS",
                     "_unicode": "εὐπερίστατος",
                     "_translit": "euperístatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-per-is'-tat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and a derivative of a presumed compound of \n and \n;"
               },
               "strongs_def": "well standing around, i.e. (a competitor) thwarting (a racer) in every\n direction (figuratively, of sin in genitive case)",
               "kjv_def": ":--which doth so\n easily beset.",
               "_strongs": "02139"
            },
            {
               "strongs": "2140",
               "greek": [
                  {
                     "_BETA": "EU)POII/+A",
                     "_unicode": "εὐποιΐα",
                     "_translit": "eupoiḯa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-poy-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "well-doing, i.e. beneficence",
               "kjv_def": ":--to do\n good.",
               "_strongs": "02140"
            },
            {
               "strongs": "2141",
               "greek": [
                  {
                     "_BETA": "EU)PORE/W",
                     "_unicode": "εὐπορέω",
                     "_translit": "euporéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-por-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2090"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4197"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n;"
               },
               "strongs_def": "(intransitively) to be\n good for passing through, i.e. (figuratively) have pecuniary\n means",
               "kjv_def": ":--ability.",
               "_strongs": "02141"
            },
            {
               "strongs": "2142",
               "greek": [
                  {
                     "_BETA": "EU)PORI/A",
                     "_unicode": "εὐπορία",
                     "_translit": "euporía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-por-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2141"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "pecuniary resources",
               "kjv_def": ":--wealth.",
               "_strongs": "02142"
            },
            {
               "strongs": "2143",
               "greek": [
                  {
                     "_BETA": "EU)PRE/PEIA",
                     "_unicode": "εὐπρέπεια",
                     "_translit": "euprépeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-prep'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4241"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "good suitableness, i.e.\n gracefulness",
               "kjv_def": ":--grace.",
               "_strongs": "02143"
            },
            {
               "strongs": "2144",
               "greek": [
                  {
                     "_BETA": "EU)PRO/SDEKTOS",
                     "_unicode": "εὐπρόσδεκτος",
                     "_translit": "euprósdektos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-pros'-dek-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4327"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "well-received, i.e. approved,\n favorable",
               "kjv_def": ":--acceptable(-ted).",
               "_strongs": "02144"
            },
            {
               "strongs": "2145",
               "greek": [
                  {
                     "_BETA": "EU)PRO/SEDROS",
                     "_unicode": "εὐπρόσεδρος",
                     "_translit": "euprósedros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-pros'-ed-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4332"
                     }
                  ],
                  "__text": "from \n and the same as \n;"
               },
               "strongs_def": "sitting well towards, i.e.\n (figuratively) assiduous (neuter, diligent service)",
               "kjv_def": ":--X attend upon.",
               "_strongs": "02145"
            },
            {
               "strongs": "2146",
               "greek": [
                  {
                     "_BETA": "EU)PROSWPE/W",
                     "_unicode": "εὐπροσωπέω",
                     "_translit": "euprosōpéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-pros-o-peh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4383"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be of good countenance, i.e.\n (figuratively) to make a display",
               "kjv_def": ":--make a fair show.",
               "_strongs": "02146"
            },
            {
               "strongs": "2147",
               "greek": [
                  {
                     "_BETA": "EU(RI/SKW",
                     "_unicode": "εὑρίσκω",
                     "_translit": "heurískō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hyoo-ris'-ko"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "EU(/RW",
                        "_unicode": "εὕρω",
                        "_translit": "heúrō"
                     },
                     {
                        "_BETA": "EU(RE/W",
                        "_unicode": "εὑρέω",
                        "_translit": "heuréō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "hyoo'-ro"
                     },
                     {
                        "_strongs": "hyoo-reh'-o"
                     }
                  ],
                  "__text": "a prolonged form of a primary\n       \n      \n  \n,      which \n                                (together with another cognate form)\n       \n      \n  \n    is used for it in all the tenses\n                                except the present and imperfect;"
               },
               "strongs_def": "to find (literally or figuratively)",
               "kjv_def": ":--find, get, obtain, perceive,\n see.",
               "_strongs": "02147",
               "__text": ","
            },
            {
               "strongs": "2148",
               "greek": [
                  {
                     "_BETA": "*EU)ROKLU/DWN",
                     "_unicode": "Εὐροκλύδων",
                     "_translit": "Euroklýdōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-rok-loo'-dohn"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*EU)=ROS",
                        "_unicode": "Εὖρος",
                        "_translit": "Eûros"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2830"
                     }
                  ],
                  "__text": "from \n (the east wind) and \n;"
               },
               "strongs_def": "a storm from the East (or\n southeast), i.e. (in modern phrase) a Levanter",
               "kjv_def": ":--Euroklydon.",
               "_strongs": "02148"
            },
            {
               "strongs": "2149",
               "greek": [
                  {
                     "_BETA": "EU)RU/XWROS",
                     "_unicode": "εὐρύχωρος",
                     "_translit": "eurýchōros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-roo'-kho-ros"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "EU)RU/S",
                        "_unicode": "εὐρύς",
                        "_translit": "eurýs"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "from \n (wide) and \n;"
               },
               "strongs_def": "spacious",
               "kjv_def": ":--broad.",
               "_strongs": "02149"
            },
            {
               "strongs": "2150",
               "greek": [
                  {
                     "_BETA": "EU)SE/BEIA",
                     "_unicode": "εὐσέβεια",
                     "_translit": "eusébeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-seb'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2152"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "piety; specially, the gospel scheme",
               "kjv_def": ":--godliness, holiness.",
               "_strongs": "02150"
            },
            {
               "strongs": "2151",
               "greek": [
                  {
                     "_BETA": "EU)SEBE/W",
                     "_unicode": "εὐσεβέω",
                     "_translit": "eusebéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-seb-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2152"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be pious, i.e. (towards God) to worship, or (towards\n parents) to respect (support)",
               "kjv_def": ":--show piety, worship.",
               "_strongs": "02151"
            },
            {
               "strongs": "2152",
               "greek": [
                  {
                     "_BETA": "EU)SEBH/S",
                     "_unicode": "εὐσεβής",
                     "_translit": "eusebḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-seb-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4576"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "well-reverent, i.e. pious",
               "kjv_def": ":--devout, godly.",
               "_strongs": "02152"
            },
            {
               "strongs": "2153",
               "greek": [
                  {
                     "_BETA": "EU)SEBW=S",
                     "_unicode": "εὐσεβῶς",
                     "_translit": "eusebōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-seb-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2152"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "piously",
               "kjv_def": ":--godly.",
               "_strongs": "02153"
            },
            {
               "strongs": "2154",
               "greek": [
                  {
                     "_BETA": "EU)/SHMOS",
                     "_unicode": "εὔσημος",
                     "_translit": "eúsēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-say-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4591"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "well indicated, i.e. (figuratively)\n significant",
               "kjv_def": ":--easy to be understood.",
               "_strongs": "02154"
            },
            {
               "strongs": "2155",
               "greek": [
                  {
                     "_BETA": "EU)/SPLAGXNOS",
                     "_unicode": "εὔσπλαγχνος",
                     "_translit": "eúsplanchnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-splangkh-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4698"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "well compassioned, i.e. sympathetic",
               "kjv_def": ":--pitiful,\n tender-hearted.",
               "_strongs": "02155"
            },
            {
               "strongs": "2156",
               "greek": [
                  {
                     "_BETA": "EU)SXHMO/NWS",
                     "_unicode": "εὐσχημόνως",
                     "_translit": "euschēmónōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-skhay-mon'-ose"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2158"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "decorously",
               "kjv_def": ":--decently, honestly.",
               "_strongs": "02156"
            },
            {
               "strongs": "2157",
               "greek": [
                  {
                     "_BETA": "EU)SXHMOSU/NH",
                     "_unicode": "εὐσχημοσύνη",
                     "_translit": "euschēmosýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-skhay-mos-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2158"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "decorousness",
               "kjv_def": ":--comeliness.",
               "_strongs": "02157"
            },
            {
               "strongs": "2158",
               "greek": [
                  {
                     "_BETA": "EU)SXH/MWN",
                     "_unicode": "εὐσχήμων",
                     "_translit": "euschḗmōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-skhay'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4976"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "well-formed, i.e. (figuratively) decorous, noble\n (in rank)",
               "kjv_def": ":--comely, honourable.",
               "_strongs": "02158"
            },
            {
               "strongs": "2159",
               "greek": [
                  {
                     "_BETA": "EU)TO/NWS",
                     "_unicode": "εὐτόνως",
                     "_translit": "eutónōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-ton'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TEI/NW",
                        "_unicode": "τείνω",
                        "_translit": "teínō"
                     }
                  ],
                  "__text": "adverb from a compound of \n and a derivative of \n (to stretch);"
               },
               "strongs_def": "in a well-strung manner, i.e. (figuratively) intensely (in a good\n sense, cogently; in a bad one, fiercely)",
               "kjv_def": ":--mightily, vehemently.",
               "_strongs": "02159"
            },
            {
               "strongs": "2160",
               "greek": [
                  {
                     "_BETA": "EU)TRAPELI/A",
                     "_unicode": "εὐτραπελία",
                     "_translit": "eutrapelía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-trap-el-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of the base of \n (meaning\n well-turned, i.e. ready at repartee, jocose);"
               },
               "strongs_def": "witticism, i.e. (in a\n vulgar sense) ribaldry",
               "kjv_def": ":--jesting.",
               "_strongs": "02160"
            },
            {
               "strongs": "2161",
               "greek": [
                  {
                     "_BETA": "*EU)/TUXOS",
                     "_unicode": "Εὔτυχος",
                     "_translit": "Eútychos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-too-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5177"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "well- fated, i.e. fortunate;\n Eutychus, a young man",
               "kjv_def": ":--Eutychus.",
               "_strongs": "02161"
            },
            {
               "strongs": "2162",
               "greek": [
                  {
                     "_BETA": "EU)FHMI/A",
                     "_unicode": "εὐφημία",
                     "_translit": "euphēmía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-fay-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2163"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "good language (\"euphemy\"), i.e. praise (repute)",
               "kjv_def": ":--good\n report.",
               "_strongs": "02162"
            },
            {
               "strongs": "2163",
               "greek": [
                  {
                     "_BETA": "EU)/FHMOS",
                     "_unicode": "εὔφημος",
                     "_translit": "eúphēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-fay-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5345"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "well spoken of, i.e. reputable",
               "kjv_def": ":--of good report.",
               "_strongs": "02163"
            },
            {
               "strongs": "2164",
               "greek": [
                  {
                     "_BETA": "EU)FORE/W",
                     "_unicode": "εὐφορέω",
                     "_translit": "euphoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-for-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5409"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear well, i.e. be fertile",
               "kjv_def": ":--bring forth\n abundantly.",
               "_strongs": "02164"
            },
            {
               "strongs": "2165",
               "greek": [
                  {
                     "_BETA": "EU)FRAI/NW",
                     "_unicode": "εὐφραίνω",
                     "_translit": "euphraínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-frah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to put (middle voice or passively, be) in a good\n frame of mind, i.e. rejoice",
               "kjv_def": ":--fare, make glad, be (make) merry,\n rejoice.",
               "_strongs": "02165"
            },
            {
               "strongs": "2166",
               "greek": [
                  {
                     "_BETA": "*EU)FRA/THS",
                     "_unicode": "Εὐφράτης",
                     "_translit": "Euphrátēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-frat'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06578"
                     }
                  ],
                  "__text": "of foreign origin (compare \n);"
               },
               "strongs_def": "Euphrates, a river of\n Asia",
               "kjv_def": ":--Euphrates.",
               "_strongs": "02166"
            },
            {
               "strongs": "2167",
               "greek": [
                  {
                     "_BETA": "EU)FROSU/NH",
                     "_unicode": "εὐφροσύνη",
                     "_translit": "euphrosýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-fros-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2165"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "joyfulness",
               "kjv_def": ":--gladness, joy.",
               "_strongs": "02167"
            },
            {
               "strongs": "2168",
               "greek": [
                  {
                     "_BETA": "EU)XARISTE/W",
                     "_unicode": "εὐχαριστέω",
                     "_translit": "eucharistéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-khar-is-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2170"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be grateful, i.e. (actively) to express gratitude\n (towards); specially, to say grace at a meal",
               "kjv_def": ":--(give) thank(-ful, -s).",
               "_strongs": "02168"
            },
            {
               "strongs": "2169",
               "greek": [
                  {
                     "_BETA": "EU)XARISTI/A",
                     "_unicode": "εὐχαριστία",
                     "_translit": "eucharistía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-khar-is-tee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2170"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "gratitude; actively, grateful language (to God, as an act\n of worship)",
               "kjv_def": ":--thankfulness, (giving of) thanks(-giving).",
               "_strongs": "02169"
            },
            {
               "strongs": "2170",
               "greek": [
                  {
                     "_BETA": "EU)XA/RISTOS",
                     "_unicode": "εὐχάριστος",
                     "_translit": "eucháristos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-khar'-is-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5483"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "well favored, i.e. (by\n implication) grateful",
               "kjv_def": ":--thankful.",
               "_strongs": "02170"
            },
            {
               "strongs": "2171",
               "greek": [
                  {
                     "_BETA": "EU)XH/",
                     "_unicode": "εὐχή",
                     "_translit": "euchḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-khay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2172"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a wish, expressed as a petition to God, or in\n votive obligation",
               "kjv_def": ":--prayer, vow.",
               "_strongs": "02171"
            },
            {
               "strongs": "2172",
               "greek": [
                  {
                     "_BETA": "EU)/XOMAI",
                     "_unicode": "εὔχομαι",
                     "_translit": "eúchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-khom-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of a primary verb;",
               "strongs_def": "to wish; by implication, to pray to\n God",
               "kjv_def": ":--pray, will, wish.",
               "_strongs": "02172"
            },
            {
               "strongs": "2173",
               "greek": [
                  {
                     "_BETA": "EU)/XRHSTOS",
                     "_unicode": "εὔχρηστος",
                     "_translit": "eúchrēstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo'-khrays-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5543"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "easily used, i.e. useful",
               "kjv_def": ":--profitable, meet for\n use.",
               "_strongs": "02173"
            },
            {
               "strongs": "2174",
               "greek": [
                  {
                     "_BETA": "EU)YUXE/W",
                     "_unicode": "εὐψυχέω",
                     "_translit": "eupsychéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-psoo-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5590"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be in good spirits, i.e. feel\n encouraged",
               "kjv_def": ":--be of good comfort.",
               "_strongs": "02174"
            },
            {
               "strongs": "2175",
               "greek": [
                  {
                     "_BETA": "EU)WDI/A",
                     "_unicode": "εὐωδία",
                     "_translit": "euōdía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-o-dee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3605"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "good-scentedness,\n i.e. fragrance",
               "kjv_def": ":--sweet savour (smell, -smelling).",
               "_strongs": "02175"
            },
            {
               "strongs": "2176",
               "greek": [
                  {
                     "_BETA": "EU)W/NUMOS",
                     "_unicode": "εὐώνυμος",
                     "_translit": "euṓnymos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "yoo-o'-noo-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3686"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "properly, well-named (good-omened), i.e. the left\n (which was the lucky side among the pagan Greeks); neuter as\n adverbial, at the left hand",
               "kjv_def": ":--(on the) left.",
               "_strongs": "02176"
            },
            {
               "strongs": "2177",
               "greek": [
                  {
                     "_BETA": "E)FA/LLOMAI",
                     "_unicode": "ἐφάλλομαι",
                     "_translit": "ephállomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-al'-lom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "242"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to spring upon",
               "kjv_def": ":--leap on.",
               "_strongs": "02177"
            },
            {
               "strongs": "2178",
               "greek": [
                  {
                     "_BETA": "E)FA/PAC",
                     "_unicode": "ἐφάπαξ",
                     "_translit": "ephápax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-ap'-ax"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "530"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "upon one occasion (only)",
               "kjv_def": ":--(at) once (for all).",
               "_strongs": "02178"
            },
            {
               "strongs": "2179",
               "greek": [
                  {
                     "_BETA": "*)EFESI=NOS",
                     "_unicode": "Ἐφεσῖνος",
                     "_translit": "Ephesînos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-es-ee'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2181"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Ephesine, or situated at Ephesus",
               "kjv_def": ":--of Ephesus.",
               "_strongs": "02179"
            },
            {
               "strongs": "2180",
               "greek": [
                  {
                     "_BETA": "*)EFE/SIOS",
                     "_unicode": "Ἐφέσιος",
                     "_translit": "Ephésios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-es'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2181"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an Ephesian or inhabitant of Ephesus",
               "kjv_def": ":--Ephesian, of\n Ephesus.",
               "_strongs": "02180"
            },
            {
               "strongs": "2181",
               "greek": [
                  {
                     "_BETA": "*)/EFESOS",
                     "_unicode": "Ἔφεσος",
                     "_translit": "Éphesos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef'-es-os"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Ephesus, a city of Asia Minor",
               "kjv_def": ":--Ephesus.",
               "_strongs": "02181"
            },
            {
               "strongs": "2182",
               "greek": [
                  {
                     "_BETA": "E)FEURETH/S",
                     "_unicode": "ἐφευρετής",
                     "_translit": "epheuretḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-yoo-ret'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2147"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a discoverer, i.e.\n contriver",
               "kjv_def": ":--inventor.",
               "_strongs": "02182"
            },
            {
               "strongs": "2183",
               "greek": [
                  {
                     "_BETA": "E)FHMERI/A",
                     "_unicode": "ἐφημερία",
                     "_translit": "ephēmería"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-ay-mer-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2184"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "diurnality, i.e. (specially) the quotidian rotation or\n class of the Jewish priests' service at the Temple, as distributed by\n families",
               "kjv_def": ":--course.",
               "_strongs": "02183"
            },
            {
               "strongs": "2184",
               "greek": [
                  {
                     "_BETA": "E)FH/MEROS",
                     "_unicode": "ἐφήμερος",
                     "_translit": "ephḗmeros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-ay'-mer-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "for a day (\"ephemeral\"), i.e. diurnal",
               "kjv_def": ":--daily.",
               "_strongs": "02184"
            },
            {
               "strongs": "2185",
               "greek": [
                  {
                     "_BETA": "E)FIKNE/OMAI",
                     "_unicode": "ἐφικνέομαι",
                     "_translit": "ephiknéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-ik-neh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2240"
                     }
                  ],
                  "__text": "from \n and a cognate of \n;"
               },
               "strongs_def": "to arrive upon, i.e. extend\n to",
               "kjv_def": ":--reach.",
               "_strongs": "02185"
            },
            {
               "strongs": "2186",
               "greek": [
                  {
                     "_BETA": "E)FI/STHMI",
                     "_unicode": "ἐφίστημι",
                     "_translit": "ephístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1909"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand upon, i.e. be present (in various\n applications, friendly or otherwise, usually literal);",
               "kjv_def": "--assault, come\n (in, to, unto, upon), be at hand (instant), present, stand (before,\n by, over).",
               "_strongs": "02186"
            },
            {
               "strongs": "2187",
               "greek": [
                  {
                     "_BETA": "*)EFRAI/M",
                     "_unicode": "Ἐφραίμ",
                     "_translit": "Ephraím"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-rah-im'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0669"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "06085"
                     }
                  ],
                  "__text": "of Hebrew origin (\n or better \n);"
               },
               "strongs_def": "Ephraim, a place in\n Palestine",
               "kjv_def": ":--Ephraim.",
               "_strongs": "02187"
            },
            {
               "strongs": "2188",
               "greek": [
                  {
                     "_BETA": "E)FFAQA/",
                     "_unicode": "ἐφφαθά",
                     "_translit": "ephphathá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ef-fath-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06606"
                     }
                  ],
                  "__text": "of Chaldee origin (\n);"
               },
               "strongs_def": "be opened!",
               "kjv_def": ":--Ephphatha.",
               "_strongs": "02188"
            },
            {
               "strongs": "2189",
               "greek": [
                  {
                     "_BETA": "E)/XQRA",
                     "_unicode": "ἔχθρα",
                     "_translit": "échthra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ekh'-thrah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2190"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "hostility; by implication, a reason for\n opposition",
               "kjv_def": ":--enmity, hatred.",
               "_strongs": "02189"
            },
            {
               "strongs": "2190",
               "greek": [
                  {
                     "_BETA": "E)XQRO/S",
                     "_unicode": "ἐχθρός",
                     "_translit": "echthrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ech-thros'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E)/XQW",
                        "_unicode": "ἔχθω",
                        "_translit": "échthō"
                     }
                  ],
                  "__text": "from a primary \n (to hate);"
               },
               "strongs_def": "hateful (passively, odious, or\n actively, hostile); usually as a noun, an adversary (especially\n Satan)",
               "kjv_def": ":--enemy, foe.",
               "_strongs": "02190"
            },
            {
               "strongs": "2191",
               "greek": [
                  {
                     "_BETA": "E)/XIDNA",
                     "_unicode": "ἔχιδνα",
                     "_translit": "échidna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ekh'-id-nah"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "an adder or other poisonous snake (literally or\n figuratively)",
               "kjv_def": ":--viper.",
               "_strongs": "02191"
            },
            {
               "strongs": "2192",
               "greek": [
                  {
                     "_BETA": "E)/XW",
                     "_unicode": "ἔχω",
                     "_translit": "échō"
                  },
                  {
                     "_BETA": "SXE/W",
                     "_unicode": "σχέω",
                     "_translit": "schéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ekh'-o"
                  },
                  {
                     "_strongs": "skheh'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to hold (used in very various applications, literally\n or figuratively, direct or remote; such as possession; ability,\n contiuity, relation, or condition)",
               "kjv_def": ":--be (able, X hold, possessed\n with), accompany, + begin to amend, can(+ -not), X conceive, count,\n diseased, do + eat, + enjoy, + fear, following, have, hold, keep, +\n lack, + go to law, lie, + must needs, + of necessity, + need, next, +\n recover, + reign, + rest, + return, X sick, take for, + tremble, +\n uncircumcised, use.",
               "_strongs": "02192",
               "__text": ",    including an alternate form\n      \n  \n;  (used in certain tenses only)"
            },
            {
               "strongs": "2193",
               "greek": [
                  {
                     "_BETA": "E(/WS",
                     "_unicode": "ἕως",
                     "_translit": "héōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "heh'-oce"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a conjunction, preposition and adverb of\n continuance, until (of time and place)",
               "kjv_def": ":--even (until, unto), (as) far\n (as), how long, (un-)til(-l), (hither-, un-, up) to, while(-s).",
               "_strongs": "02193"
            },
            {
               "strongs": "2194",
               "greek": [
                  {
                     "_BETA": "*ZABOULW/N",
                     "_unicode": "Ζαβουλών",
                     "_translit": "Zaboulṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzab-oo-lone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02074"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Zabulon (i.e. Zebulon), a region of\n Palestine",
               "kjv_def": ":--Zabulon.",
               "_strongs": "02194"
            },
            {
               "strongs": "2195",
               "greek": [
                  {
                     "_BETA": "*ZAKXAI=OS",
                     "_unicode": "Ζακχαῖος",
                     "_translit": "Zakchaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzak-chah'-ee-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02140"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "Zacchæus, an Israelite",
               "kjv_def": ":--Zacchæus.",
               "_strongs": "02195"
            },
            {
               "strongs": "2196",
               "greek": [
                  {
                     "_BETA": "*ZARA/",
                     "_unicode": "Ζαρά",
                     "_translit": "Zará"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzar-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02226"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Zara, (i.e. Zerach), an Israelite",
               "kjv_def": ":--Zara.",
               "_strongs": "02196"
            },
            {
               "strongs": "2197",
               "greek": [
                  {
                     "_BETA": "*ZAXARI/AS",
                     "_unicode": "Ζαχαρίας",
                     "_translit": "Zacharías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzakh-ar-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02148"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Zacharias (i.e. Zechariah), the name of two\n Israelites",
               "kjv_def": ":--Zacharias.",
               "_strongs": "02197"
            },
            {
               "strongs": "2198",
               "greek": [
                  {
                     "_BETA": "ZA/W",
                     "_unicode": "ζάω",
                     "_translit": "záō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzah'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to live (literally or figuratively)",
               "kjv_def": ":--life(-time),\n (a-)live(-ly), quick.",
               "_strongs": "02198"
            },
            {
               "strongs": "2199",
               "greek": [
                  {
                     "_BETA": "*ZEBEDAI=OS",
                     "_unicode": "Ζεβεδαῖος",
                     "_translit": "Zebedaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzeb-ed-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02067"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "Zebedæus, an Israelite",
               "kjv_def": ":--Zebedee.",
               "_strongs": "02199"
            },
            {
               "strongs": "2200",
               "greek": [
                  {
                     "_BETA": "ZESTO/S",
                     "_unicode": "ζεστός",
                     "_translit": "zestós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzes-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2204"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "boiled, i.e. (by implication) calid (figuratively,\n fervent)",
               "kjv_def": ":--hot.",
               "_strongs": "02200"
            },
            {
               "strongs": "2201",
               "greek": [
                  {
                     "_BETA": "ZEU=GOS",
                     "_unicode": "ζεῦγος",
                     "_translit": "zeûgos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzyoo'-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2218"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a couple, i.e. a team (of oxen yoked together)\n or brace (of birds tied together)",
               "kjv_def": ":--yoke, pair.",
               "_strongs": "02201"
            },
            {
               "strongs": "2202",
               "greek": [
                  {
                     "_BETA": "ZEUKTHRI/A",
                     "_unicode": "ζευκτηρία",
                     "_translit": "zeuktēría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzook-tay-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2218"
                     }
                  ],
                  "__text": "feminine of a derivative (at the second stage) from the same as \n;"
               },
               "strongs_def": "a fastening (tiller-rope)",
               "kjv_def": ":--band.",
               "_strongs": "02202"
            },
            {
               "strongs": "2203",
               "greek": [
                  {
                     "_BETA": "*ZEU/S",
                     "_unicode": "Ζεύς",
                     "_translit": "Zeús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzyooce"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "*DI/S",
                        "_unicode": "Δίς",
                        "_translit": "Dís"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "deece"
                     }
                  ],
                  "__text": "in the oblique cases there is used instead of\n it a (probably cognate) name\n\n      \n  \n, which is otherwise obsolete;\n       \n Zeus or Dis (among the Latins, Jupiter or Jove), the supreme deity of\n the Greeks"
               },
               "kjv_def": ":--Jupiter.",
               "_strongs": "02203"
            },
            {
               "strongs": "2204",
               "greek": [
                  {
                     "_BETA": "ZE/W",
                     "_unicode": "ζέω",
                     "_translit": "zéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzeh'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to be hot (boil, of liquids; or glow, of solids), i.e.\n (figuratively) be fervid (earnest)",
               "kjv_def": ":--be fervent.",
               "_strongs": "02204"
            },
            {
               "strongs": "2205",
               "greek": [
                  {
                     "_BETA": "ZH=LOS",
                     "_unicode": "ζῆλος",
                     "_translit": "zēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay'-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2204"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, heat, i.e. (figuratively) \"zeal\" (in a favorable\n sense, ardor; in an unfavorable one, jealousy, as of a husband\n (figuratively, of God), or an enemy, malice)",
               "kjv_def": ":--emulation, envy(-ing),\n fervent mind, indignation, jealousy, zeal.",
               "_strongs": "02205"
            },
            {
               "strongs": "2206",
               "greek": [
                  {
                     "_BETA": "ZHLO/W",
                     "_unicode": "ζηλόω",
                     "_translit": "zēlóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2205"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to have warmth of feeling for or against",
               "kjv_def": ":--affect, covet\n (earnestly), (have) desire, (move with) envy, be jealous over, (be)\n zealous(-ly affect).",
               "_strongs": "02206"
            },
            {
               "strongs": "2207",
               "greek": [
                  {
                     "_BETA": "ZHLWTH/S",
                     "_unicode": "ζηλωτής",
                     "_translit": "zēlōtḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay-lo-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2206"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a \"zealot\"",
               "kjv_def": ":--zealous.",
               "_strongs": "02207"
            },
            {
               "strongs": "2208",
               "greek": [
                  {
                     "_BETA": "*ZHLWTH/S",
                     "_unicode": "Ζηλωτής",
                     "_translit": "Zēlōtḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay-lo-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2207"
                     }
                  ],
                  "__text": "the same as \n;"
               },
               "strongs_def": "a Zealot, i.e. (specially) partisan for Jewish\n political independence",
               "kjv_def": ":--Zelotes.",
               "_strongs": "02208"
            },
            {
               "strongs": "2209",
               "greek": [
                  {
                     "_BETA": "ZHMI/A",
                     "_unicode": "ζημία",
                     "_translit": "zēmía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1150"
                     }
                  ],
                  "__text": "probably akin to the base of \n (through the idea of violence);"
               },
               "strongs_def": "detriment",
               "kjv_def": ":--damage, loss.",
               "_strongs": "02209"
            },
            {
               "strongs": "2210",
               "greek": [
                  {
                     "_BETA": "ZHMIO/W",
                     "_unicode": "ζημιόω",
                     "_translit": "zēmióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay-mee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2209"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to injure, i.e. (reflexively or passively) to experience\n detriment",
               "kjv_def": ":--be cast away, receive damage, lose, suffer loss.",
               "_strongs": "02210"
            },
            {
               "strongs": "2211",
               "greek": [
                  {
                     "_BETA": "*ZHNA=S",
                     "_unicode": "Ζηνᾶς",
                     "_translit": "Zēnâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay-nas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2203"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1435"
                     }
                  ],
                  "__text": "probably contracted from a poetic form of \n and \n;"
               },
               "strongs_def": "Jove-given;\n Zenas, a Christian",
               "kjv_def": ":--Zenas.",
               "_strongs": "02211"
            },
            {
               "strongs": "2212",
               "greek": [
                  {
                     "_BETA": "ZHTE/W",
                     "_unicode": "ζητέω",
                     "_translit": "zētéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay-teh'-o"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to seek (literally or figuratively); specially,\n (by Hebraism) to worship (God), or (in a bad sense) to plot (against\n life)",
               "kjv_def": ":--be (go) about, desire, endeavour, enquire (for), require, (X\n will) seek (after, for, means).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4441"
                  }
               ],
               "_strongs": "02212",
               "__text": "Compare \n."
            },
            {
               "strongs": "2213",
               "greek": [
                  {
                     "_BETA": "ZH/THMA",
                     "_unicode": "ζήτημα",
                     "_translit": "zḗtēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay'-tay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2212"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a search (properly concretely), i.e. (in words) a\n debate",
               "kjv_def": ":--question.",
               "_strongs": "02213"
            },
            {
               "strongs": "2214",
               "greek": [
                  {
                     "_BETA": "ZH/THSIS",
                     "_unicode": "ζήτησις",
                     "_translit": "zḗtēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzay'-tay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2212"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a searching (properly, the act), i.e. a dispute or its\n theme",
               "kjv_def": ":--question.",
               "_strongs": "02214"
            },
            {
               "strongs": "2215",
               "greek": [
                  {
                     "_BETA": "ZIZA/NION",
                     "_unicode": "ζιζάνιον",
                     "_translit": "zizánion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dziz-an'-ee-on"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "darnel or false grain",
               "kjv_def": ":--tares.",
               "_strongs": "02215"
            },
            {
               "strongs": "2216",
               "greek": [
                  {
                     "_BETA": "*ZOROBA/BEL",
                     "_unicode": "Ζοροβάβελ",
                     "_translit": "Zorobábel"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzor-ob-ab'-el"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02216"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Zorobabel (i.e. Zerubbabel), an\n Israelite",
               "kjv_def": ":--Zorobabel.",
               "_strongs": "02216"
            },
            {
               "strongs": "2217",
               "greek": [
                  {
                     "_BETA": "ZO/FOS",
                     "_unicode": "ζόφος",
                     "_translit": "zóphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzof'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3509"
                     }
                  ],
                  "__text": "akin to the base of \n;"
               },
               "strongs_def": "gloom (as shrouding like a\n cloud)",
               "kjv_def": ":--blackness, darkness, mist.",
               "_strongs": "02217"
            },
            {
               "strongs": "2218",
               "greek": [
                  {
                     "_BETA": "ZUGO/S",
                     "_unicode": "ζυγός",
                     "_translit": "zygós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzoo-gos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "ZEU/GNUMI",
                        "_unicode": "ζεύγνυμι",
                        "_translit": "zeúgnymi"
                     }
                  ],
                  "__text": "from the root of \n (to join, especially by a \"yoke\");"
               },
               "strongs_def": "a\n coupling, i.e. (figuratively) servitude (a law or obligation); also\n (literally) the beam of the balance (as connecting the scales)",
               "kjv_def": ":--pair\n of balances, yoke.",
               "_strongs": "02218"
            },
            {
               "strongs": "2219",
               "greek": [
                  {
                     "_BETA": "ZU/MH",
                     "_unicode": "ζύμη",
                     "_translit": "zýmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzoo'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2204"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "ferment (as if boiling up)",
               "kjv_def": ":--leaven.",
               "_strongs": "02219"
            },
            {
               "strongs": "2220",
               "greek": [
                  {
                     "_BETA": "ZUMO/W",
                     "_unicode": "ζυμόω",
                     "_translit": "zymóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzoo-mo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2219"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to cause to ferment",
               "kjv_def": ":--leaven.",
               "_strongs": "02220"
            },
            {
               "strongs": "2221",
               "greek": [
                  {
                     "_BETA": "ZWGRE/W",
                     "_unicode": "ζωγρέω",
                     "_translit": "zōgréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzogue-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2226"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "64"
                     }
                  ],
                  "__text": "from the same as \n and \n;"
               },
               "strongs_def": "to take alive (make a prisoner of war),\n i.e. (figuratively) to capture or ensnare",
               "kjv_def": ":--take captive, catch.",
               "_strongs": "02221"
            },
            {
               "strongs": "2222",
               "greek": [
                  {
                     "_BETA": "ZWH/",
                     "_unicode": "ζωή",
                     "_translit": "zōḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzo-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2198"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "life (literally or figuratively)",
               "kjv_def": ":--life(-time).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5590"
                  }
               ],
               "_strongs": "02222",
               "__text": "Compare\n \n."
            },
            {
               "strongs": "2223",
               "greek": [
                  {
                     "_BETA": "ZW/NH",
                     "_unicode": "ζώνη",
                     "_translit": "zṓnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2218"
                     }
                  ],
                  "__text": "probably akin to the base of \n;"
               },
               "strongs_def": "a belt; by implication, a\n pocket",
               "kjv_def": ":--girdle, purse.",
               "_strongs": "02223"
            },
            {
               "strongs": "2224",
               "greek": [
                  {
                     "_BETA": "ZW/NNUMI",
                     "_unicode": "ζώννυμι",
                     "_translit": "zṓnnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzone'-noo-mi"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2223"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to bind about (especially with a belt)",
               "kjv_def": ":--gird.",
               "_strongs": "02224"
            },
            {
               "strongs": "2225",
               "greek": [
                  {
                     "_BETA": "ZWOGONE/W",
                     "_unicode": "ζωογονέω",
                     "_translit": "zōogonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzo-og-on-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2226"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from the same as \n and a derivative of \n;"
               },
               "strongs_def": "to engender alive,\n i.e. (by analogy) to rescue (passively, be saved) from death",
               "kjv_def": ":--live,\n preserve.",
               "_strongs": "02225"
            },
            {
               "strongs": "2226",
               "greek": [
                  {
                     "_BETA": "ZW=ON",
                     "_unicode": "ζῶον",
                     "_translit": "zōon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzo'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2198"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "a live thing, i.e. an animal",
               "kjv_def": ":--beast.",
               "_strongs": "02226"
            },
            {
               "strongs": "2227",
               "greek": [
                  {
                     "_BETA": "ZWOPOIE/W",
                     "_unicode": "ζωοποιέω",
                     "_translit": "zōopoiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "dzo-op-oy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2226"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from the same as \n and \n;"
               },
               "strongs_def": "to (re-)vitalize (literally or\n figuratively)",
               "kjv_def": ":--make alive, give life, quicken.",
               "_strongs": "02227"
            },
            {
               "strongs": "2228",
               "greek": [
                  {
                     "_BETA": "H)/",
                     "_unicode": "ἤ",
                     "_translit": "ḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay"
                  }
               ],
               "strongs_derivation": "a primary particle of distinction between two connected terms;",
               "strongs_def": "disjunctive, or; comparative, than",
               "kjv_def": ":--and, but (either), (n-)either,\n except it be, (n-)or (else), rather, save, than, that, what, yea.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2235"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2260"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "2273"
                  }
               ],
               "_strongs": "02228",
               "__text": "Often used in connection with other particles. Compare especially\n \n, \n, \n."
            },
            {
               "strongs": "2229",
               "greek": [
                  {
                     "_BETA": "H)=",
                     "_unicode": "ἦ",
                     "_translit": "ē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3303"
                     }
                  ],
                  "__text": "an adverb of confirmation; perhaps intensive of \n; used only (in\n the New Testament) before \n;"
               },
               "strongs_def": "assuredly",
               "kjv_def": ":--surely.",
               "_strongs": "02229"
            },
            {
               "strongs": "2230",
               "greek": [
                  {
                     "_BETA": "H(GEMONEU/W",
                     "_unicode": "ἡγεμονεύω",
                     "_translit": "hēgemoneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hayg-em-on-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2232"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to act as ruler",
               "kjv_def": ":--be governor.",
               "_strongs": "02230"
            },
            {
               "strongs": "2231",
               "greek": [
                  {
                     "_BETA": "H(GEMONI/A",
                     "_unicode": "ἡγεμονία",
                     "_translit": "hēgemonía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hayg-em-on-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2232"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "government, i.e. (in time) official term",
               "kjv_def": ":--reign.",
               "_strongs": "02231"
            },
            {
               "strongs": "2232",
               "greek": [
                  {
                     "_BETA": "H(GEMW/N",
                     "_unicode": "ἡγεμών",
                     "_translit": "hēgemṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hayg-em-ohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2233"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a leader, i.e. chief person (or figuratively, place) of a\n province",
               "kjv_def": ":--governor, prince, ruler.",
               "_strongs": "02232"
            },
            {
               "strongs": "2233",
               "greek": [
                  {
                     "_BETA": "H(GE/OMAI",
                     "_unicode": "ἡγέομαι",
                     "_translit": "hēgéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hayg-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "middle voice of a (presumed) strengthened form of \n;"
               },
               "strongs_def": "to lead, i.e.\n command (with official authority); figuratively, to deem, i.e.\n consider",
               "kjv_def": ":--account, (be) chief, count, esteem, governor, judge, have\n the rule over, suppose, think.",
               "_strongs": "02233"
            },
            {
               "strongs": "2234",
               "greek": [
                  {
                     "_BETA": "H(DE/WS",
                     "_unicode": "ἡδέως",
                     "_translit": "hēdéōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-deh'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2237"
                     }
                  ],
                  "__text": "adverb from a derivative of the base of \n;"
               },
               "strongs_def": "sweetly, i.e.\n (figuratively) with pleasure",
               "kjv_def": ":--gladly.",
               "_strongs": "02234"
            },
            {
               "strongs": "2235",
               "greek": [
                  {
                     "_BETA": "H)/DH",
                     "_unicode": "ἤδη",
                     "_translit": "ḗdē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-day"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2229"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1211"
                     }
                  ],
                  "__text": "apparently from \n (or possibly \n) and \n;"
               },
               "strongs_def": "even now",
               "kjv_def": ":--already,\n (even) now (already), by this time.",
               "_strongs": "02235"
            },
            {
               "strongs": "2236",
               "greek": [
                  {
                     "_BETA": "H(/DISTA",
                     "_unicode": "ἥδιστα",
                     "_translit": "hḗdista"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay'-dis-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2234"
                     }
                  ],
                  "__text": "neuter plural of the superlative of the same as \n;"
               },
               "strongs_def": "with great\n pleasure",
               "kjv_def": ":--most (very) gladly.",
               "_strongs": "02236"
            },
            {
               "strongs": "2237",
               "greek": [
                  {
                     "_BETA": "H(DONH/",
                     "_unicode": "ἡδονή",
                     "_translit": "hēdonḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-don-ay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "A(NDA/NW",
                        "_unicode": "ἁνδάνω",
                        "_translit": "handánō"
                     }
                  ],
                  "__text": "from \n (to please);"
               },
               "strongs_def": "sensual delight; by implication,\n desire",
               "kjv_def": ":--lust, pleasure.",
               "_strongs": "02237"
            },
            {
               "strongs": "2238",
               "greek": [
                  {
                     "_BETA": "H(DU/OSMON",
                     "_unicode": "ἡδύοσμον",
                     "_translit": "hēdýosmon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-doo'-os-mon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2234"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3744"
                     }
                  ],
                  "__text": "neuter of the compound of the same as \n and \n;"
               },
               "strongs_def": "a sweet-scented\n plant, i.e. mint",
               "kjv_def": ":--mint.",
               "_strongs": "02238"
            },
            {
               "strongs": "2239",
               "greek": [
                  {
                     "_BETA": "H)=QOS",
                     "_unicode": "ἦθος",
                     "_translit": "ēthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-thos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1485"
                     }
                  ],
                  "__text": "a strengthened form of \n;"
               },
               "strongs_def": "usage, i.e. (plural) moral\n habits",
               "kjv_def": ":--manners.",
               "_strongs": "02239"
            },
            {
               "strongs": "2240",
               "greek": [
                  {
                     "_BETA": "H(/KW",
                     "_unicode": "ἥκω",
                     "_translit": "hḗkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay'-ko"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to arrive, i.e. be present (literally or\n figuratively)",
               "kjv_def": ":--come.",
               "_strongs": "02240"
            },
            {
               "strongs": "2241",
               "greek": [
                  {
                     "_BETA": "H)LI/",
                     "_unicode": "ἠλί",
                     "_translit": "ēlí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay-lee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0410"
                     }
                  ],
                  "__text": "of Hebrew origin (\n with pronominal suffix);"
               },
               "strongs_def": "my God",
               "kjv_def": ":-- Eli.",
               "_strongs": "02241"
            },
            {
               "strongs": "2242",
               "greek": [
                  {
                     "_BETA": "*(HLI/",
                     "_unicode": "Ἡλί",
                     "_translit": "Hēlí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-lee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05941"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Heli (i.e. Eli), an Israelite",
               "kjv_def": ":--Heli.",
               "_strongs": "02242"
            },
            {
               "strongs": "2243",
               "greek": [
                  {
                     "_BETA": "*(HLI/AS",
                     "_unicode": "Ἡλίας",
                     "_translit": "Hēlías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-lee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0452"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Helias (i.e. Elijah), an Israelite",
               "kjv_def": ":--Elias.",
               "_strongs": "02243"
            },
            {
               "strongs": "2244",
               "greek": [
                  {
                     "_BETA": "H(LIKI/A",
                     "_unicode": "ἡλικία",
                     "_translit": "hēlikía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-lik-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2245"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "maturity (in years or size)",
               "kjv_def": ":--age, stature.",
               "_strongs": "02244"
            },
            {
               "strongs": "2245",
               "greek": [
                  {
                     "_BETA": "H(LI/KOS",
                     "_unicode": "ἡλίκος",
                     "_translit": "hēlíkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-lee'-kos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "H(=LIC",
                        "_unicode": "ἧλιξ",
                        "_translit": "hēlix"
                     }
                  ],
                  "__text": "from \n (a comrade, i.e. one of the same age);"
               },
               "strongs_def": "as big as, i.e.\n (interjectively) how much",
               "kjv_def": ":--how (what) great.",
               "_strongs": "02245"
            },
            {
               "strongs": "2246",
               "greek": [
                  {
                     "_BETA": "H(/LIOS",
                     "_unicode": "ἥλιος",
                     "_translit": "hḗlios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay'-lee-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E(/LH",
                        "_unicode": "ἕλη",
                        "_translit": "hélē"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n (a ray; perhaps akin to the alternate of \n);"
               },
               "strongs_def": "the sun; by\n implication, light",
               "kjv_def": ":--+ east, sun.",
               "_strongs": "02246"
            },
            {
               "strongs": "2247",
               "greek": [
                  {
                     "_BETA": "H(=LOS",
                     "_unicode": "ἧλος",
                     "_translit": "hēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay'-los"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a stud, i.e. spike",
               "kjv_def": ":--nail.",
               "_strongs": "02247"
            },
            {
               "strongs": "2248",
               "greek": [
                  {
                     "_BETA": "H(MA=S",
                     "_unicode": "ἡμᾶς",
                     "_translit": "hēmâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-mas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1473"
                     }
                  ],
                  "__text": "accusative case plural of \n;"
               },
               "strongs_def": "us",
               "kjv_def": ":--our, us, we.",
               "_strongs": "02248"
            },
            {
               "strongs": "2249",
               "greek": [
                  {
                     "_BETA": "H(MEI=S",
                     "_unicode": "ἡμεῖς",
                     "_translit": "hēmeîs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-mice'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1473"
                     }
                  ],
                  "__text": "nominative plural of \n;"
               },
               "strongs_def": "we (only used when emphatic)",
               "kjv_def": ":--us, we\n (ourselves).",
               "_strongs": "02249"
            },
            {
               "strongs": "2250",
               "greek": [
                  {
                     "_BETA": "H(ME/RA",
                     "_unicode": "ἡμέρα",
                     "_translit": "hēméra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-mer'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5610"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "H(=MAI",
                        "_unicode": "ἧμαι",
                        "_translit": "hēmai"
                     }
                  ],
                  "__text": "feminine (with \n implied) of a derivative of \n (to sit; akin to\n the base of \n) meaning tame, i.e. gentle;"
               },
               "strongs_def": "day, i.e. (literally) the\n time space between dawn and dark, or the whole 24 hours (but several\n days were usually reckoned by the Jews as inclusive of the parts of\n both extremes); figuratively, a period (always defined more or less\n clearly by the context)",
               "kjv_def": ":--age, + alway, (mid-)day (by day, (-ly)), +\n for ever, judgment, (day) time, while, years.",
               "_strongs": "02250"
            },
            {
               "strongs": "2251",
               "greek": [
                  {
                     "_BETA": "H(ME/TEROS",
                     "_unicode": "ἡμέτερος",
                     "_translit": "hēméteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-met'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2349"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "our",
               "kjv_def": ":--our, your (by a different reading).",
               "_strongs": "02251"
            },
            {
               "strongs": "2252",
               "greek": [
                  {
                     "_BETA": "H)/MHN",
                     "_unicode": "ἤμην",
                     "_translit": "ḗmēn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-mane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2258"
                     }
                  ],
                  "__text": "a prolonged form of \n;"
               },
               "strongs_def": "I was",
               "kjv_def": ":--be, was.",
               "_strongs": "02252",
               "__text": "(Sometimes unexpressed)."
            },
            {
               "strongs": "2253",
               "greek": [
                  {
                     "_BETA": "H(MIQANH/S",
                     "_unicode": "ἡμιθανής",
                     "_translit": "hēmithanḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-mee-than-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2255"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2348"
                     }
                  ],
                  "__text": "from a presumed compound of the base of \n and \n;"
               },
               "strongs_def": "half dead, i.e.\n entirely exhausted",
               "kjv_def": ":--half dead.",
               "_strongs": "02253"
            },
            {
               "strongs": "2254",
               "greek": [
                  {
                     "_BETA": "H(MI=N",
                     "_unicode": "ἡμῖν",
                     "_translit": "hēmîn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-meen'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1473"
                     }
                  ],
                  "__text": "dative case plural of \n;"
               },
               "strongs_def": "to (or for, with, by) us",
               "kjv_def": ":--our, (for) us,\n we.",
               "_strongs": "02254"
            },
            {
               "strongs": "2255",
               "greek": [
                  {
                     "_BETA": "H(/MISU",
                     "_unicode": "ἥμισυ",
                     "_translit": "hḗmisy"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay'-mee-soo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "260"
                     }
                  ],
                  "__text": "neuter of a derivative from an inseparable prefix akin to \n (through\n the idea of partition involved in connection) and meaning semi-;"
               },
               "strongs_def": "(as\n noun) half",
               "kjv_def": ":--half.",
               "_strongs": "02255"
            },
            {
               "strongs": "2256",
               "greek": [
                  {
                     "_BETA": "H(MIW/RION",
                     "_unicode": "ἡμιώριον",
                     "_translit": "hēmiṓrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-mee-o'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2255"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5610"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "a half-hour",
               "kjv_def": ":--half an hour.",
               "_strongs": "02256"
            },
            {
               "strongs": "2257",
               "greek": [
                  {
                     "_BETA": "H(MW=N",
                     "_unicode": "ἡμῶν",
                     "_translit": "hēmōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-mone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1473"
                     }
                  ],
                  "__text": "genitive case plural of \n;"
               },
               "strongs_def": "of (or from) us",
               "kjv_def": ":--our (company), us, we.",
               "_strongs": "02257"
            },
            {
               "strongs": "2258",
               "greek": [
                  {
                     "_BETA": "H)=N",
                     "_unicode": "ἦν",
                     "_translit": "ēn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "imperfect of \n;"
               },
               "strongs_def": "I (thou, etc.) was (wast or were)",
               "kjv_def": ":--+ agree, be, X\n have (+ charge of), hold, use, was(-t), were.",
               "_strongs": "02258"
            },
            {
               "strongs": "2259",
               "greek": [
                  {
                     "_BETA": "H(NI/KA",
                     "_unicode": "ἡνίκα",
                     "_translit": "hēníka"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-nee'-kah"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "at which time",
               "kjv_def": ":--when.",
               "_strongs": "02259"
            },
            {
               "strongs": "2260",
               "greek": [
                  {
                     "_BETA": "H)/PER",
                     "_unicode": "ἤπερ",
                     "_translit": "ḗper"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-per"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "than at all (or than perhaps, than indeed)",
               "kjv_def": ":--than.",
               "_strongs": "02260"
            },
            {
               "strongs": "2261",
               "greek": [
                  {
                     "_BETA": "H)/PIOS",
                     "_unicode": "ἤπιος",
                     "_translit": "ḗpios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-pee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2031"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "properly, affable, i.e. mild or kind",
               "kjv_def": ":--gentle.",
               "_strongs": "02261"
            },
            {
               "strongs": "2262",
               "greek": [
                  {
                     "_BETA": "*)/HR",
                     "_unicode": "Ἤρ",
                     "_translit": "Ḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ayr"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06147"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Er, an Israelite",
               "kjv_def": ":--Er.",
               "_strongs": "02262"
            },
            {
               "strongs": "2263",
               "greek": [
                  {
                     "_BETA": "H)/REMOS",
                     "_unicode": "ἤρεμος",
                     "_translit": "ḗremos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-rem-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2048"
                     }
                  ],
                  "__text": "perhaps by transposition from \n (through the idea of stillness);"
               },
               "strongs_def": "tranquil",
               "kjv_def": ":--quiet.",
               "_strongs": "02263"
            },
            {
               "strongs": "2264",
               "greek": [
                  {
                     "_BETA": "*(HRW/DHS",
                     "_unicode": "Ἡρώδης",
                     "_translit": "Hērṓdēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-ro'-dace"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "H(/RWS",
                        "_unicode": "ἥρως",
                        "_translit": "hḗrōs"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1491"
                     }
                  ],
                  "__text": "compound of \n (a \"hero\") and \n;"
               },
               "strongs_def": "heroic; Herod, the name of four\n Jewish kings",
               "kjv_def": ":--Herod.",
               "_strongs": "02264"
            },
            {
               "strongs": "2265",
               "greek": [
                  {
                     "_BETA": "*(HRWDIANOI/",
                     "_unicode": "Ἡρωδιανοί",
                     "_translit": "Hērōdianoí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-ro-dee-an-oy'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2264"
                     }
                  ],
                  "__text": "plural of a derivative of \n;"
               },
               "strongs_def": "Herodians, i.e. partisans of\n Herod",
               "kjv_def": ":--Herodians.",
               "_strongs": "02265"
            },
            {
               "strongs": "2266",
               "greek": [
                  {
                     "_BETA": "*(HRWDIA/S",
                     "_unicode": "Ἡρωδιάς",
                     "_translit": "Hērōdiás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-ro-dee-as'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2264"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Herodias, a woman of the Heodian family",
               "kjv_def": ":--Herodias.",
               "_strongs": "02266"
            },
            {
               "strongs": "2267",
               "greek": [
                  {
                     "_BETA": "*(HRWDI/WN",
                     "_unicode": "Ἡρωδίων",
                     "_translit": "Hērōdíōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-ro-dee'-ohn"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2264"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Herodion, a Christian",
               "kjv_def": ":--Herodion.",
               "_strongs": "02267"
            },
            {
               "strongs": "2268",
               "greek": [
                  {
                     "_BETA": "*(HSAI/+AS",
                     "_unicode": "Ἡσαΐας",
                     "_translit": "Hēsaḯas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-sah-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03470"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Hesaias (i.e. Jeshajah), an\n Israelite",
               "kjv_def": ":--Esaias.",
               "_strongs": "02268"
            },
            {
               "strongs": "2269",
               "greek": [
                  {
                     "_BETA": "*)HSAU=",
                     "_unicode": "Ἠσαῦ",
                     "_translit": "Ēsaû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay-sow'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06215"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Esau, an Edomite",
               "kjv_def": ":--Esau.",
               "_strongs": "02269"
            },
            {
               "strongs": "2270",
               "greek": [
                  {
                     "_BETA": "H(SUXA/ZW",
                     "_unicode": "ἡσυχάζω",
                     "_translit": "hēsycházō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-soo-khad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2272"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to keep still (intransitively), i.e. refrain\n from labor, meddlesomeness or speech",
               "kjv_def": ":--cease, hold peace, be quiet,\n rest.",
               "_strongs": "02270"
            },
            {
               "strongs": "2271",
               "greek": [
                  {
                     "_BETA": "H(SUXI/A",
                     "_unicode": "ἡσυχία",
                     "_translit": "hēsychía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-soo-khee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2272"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "(as noun) stillness, i.e. desistance from bustle or\n language",
               "kjv_def": ":--quietness, silence.",
               "_strongs": "02271"
            },
            {
               "strongs": "2272",
               "greek": [
                  {
                     "_BETA": "H(SU/XIOS",
                     "_unicode": "ἡσύχιος",
                     "_translit": "hēsýchios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hay-soo'-khee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "a prolonged form of a compound probably of a derivative of the base of\n \n and perhaps \n;"
               },
               "strongs_def": "properly, keeping one's seat (sedentary), i.e.\n (by implication) still (undisturbed, undisturbing)",
               "kjv_def": ":--peaceable, quiet.",
               "_strongs": "02272"
            },
            {
               "strongs": "2273",
               "greek": [
                  {
                     "_BETA": "H)/TOI",
                     "_unicode": "ἤτοι",
                     "_translit": "ḗtoi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-toy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5104"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "either indeed",
               "kjv_def": ":--whether.",
               "_strongs": "02273"
            },
            {
               "strongs": "2274",
               "greek": [
                  {
                     "_BETA": "H(TTA/W",
                     "_unicode": "ἡττάω",
                     "_translit": "hēttáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hayt-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2276"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to make worse, i.e. vanquish (literally or\n figuratively); by implication, to rate lower",
               "kjv_def": ":--be inferior, overcome.",
               "_strongs": "02274"
            },
            {
               "strongs": "2275",
               "greek": [
                  {
                     "_BETA": "H(/TTHMA",
                     "_unicode": "ἥττημα",
                     "_translit": "hḗttēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hayt'-tay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2274"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deterioration, i.e. (objectively) failure or\n (subjectively) loss",
               "kjv_def": ":--diminishing, fault.",
               "_strongs": "02275"
            },
            {
               "strongs": "2276",
               "greek": [
                  {
                     "_BETA": "H(/TTON",
                     "_unicode": "ἥττον",
                     "_translit": "hḗtton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hate'-ton"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "H(=KA",
                        "_unicode": "ἧκα",
                        "_translit": "hēka"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     }
                  ],
                  "__text": "neuter of comparative of \n (slightly) used for that of \n;"
               },
               "strongs_def": "worse\n (as noun); by implication, less (as adverb)",
               "kjv_def": ":--less, worse.",
               "_strongs": "02276"
            },
            {
               "strongs": "2277",
               "greek": [
                  {
                     "_BETA": "H)/TW",
                     "_unicode": "ἤτω",
                     "_translit": "ḗtō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "third person singular imperative of \n;"
               },
               "strongs_def": "let him (or it) be",
               "kjv_def": ":--let …\n be.",
               "_strongs": "02277"
            },
            {
               "strongs": "2278",
               "greek": [
                  {
                     "_BETA": "H)XE/W",
                     "_unicode": "ἠχέω",
                     "_translit": "ēchéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2279"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make a loud noise, i.e. reverberate",
               "kjv_def": ":--roar, sound.",
               "_strongs": "02278"
            },
            {
               "strongs": "2279",
               "greek": [
                  {
                     "_BETA": "H)=XOS",
                     "_unicode": "ἦχος",
                     "_translit": "ēchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ay'-khos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a loud or confused noise (\"echo\"), i.e. roar;\n figuratively, a rumor",
               "kjv_def": ":--fame, sound.",
               "_strongs": "02279"
            },
            {
               "strongs": "2280",
               "greek": [
                  {
                     "_BETA": "*QADDAI=OS",
                     "_unicode": "Θαδδαῖος",
                     "_translit": "Thaddaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thad-dah'-yos"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Thaddæus, one of the Apostles",
               "kjv_def": ":--Thaddæus.",
               "_strongs": "02280"
            },
            {
               "strongs": "2281",
               "greek": [
                  {
                     "_BETA": "QA/LASSA",
                     "_unicode": "θάλασσα",
                     "_translit": "thálassa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thal'-as-sah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "probably prolonged from \n;"
               },
               "strongs_def": "the sea (genitive case or\n specially)",
               "kjv_def": ":--sea.",
               "_strongs": "02281"
            },
            {
               "strongs": "2282",
               "greek": [
                  {
                     "_BETA": "QA/LPW",
                     "_unicode": "θάλπω",
                     "_translit": "thálpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thal'-po"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QA/LLW",
                        "_unicode": "θάλλω",
                        "_translit": "thállō"
                     }
                  ],
                  "__text": "probably akin to \n (to warm);"
               },
               "strongs_def": "to brood, i.e. (figuratively) to\n foster",
               "kjv_def": ":--cherish.",
               "_strongs": "02282"
            },
            {
               "strongs": "2283",
               "greek": [
                  {
                     "_BETA": "*QA/MAR",
                     "_unicode": "Θάμαρ",
                     "_translit": "Thámar"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tham'-ar"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08559"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Thamar (i.e. Tamar), an Israelitess",
               "kjv_def": ":--Thamar.",
               "_strongs": "02283"
            },
            {
               "strongs": "2284",
               "greek": [
                  {
                     "_BETA": "QAMBE/W",
                     "_unicode": "θαμβέω",
                     "_translit": "thambéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tham-beh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2285"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to stupefy (with surprise), i.e. astound",
               "kjv_def": ":--amaze, astonish.",
               "_strongs": "02284"
            },
            {
               "strongs": "2285",
               "greek": [
                  {
                     "_BETA": "QA/MBOS",
                     "_unicode": "θάμβος",
                     "_translit": "thámbos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tham'-bos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TA/FW",
                        "_unicode": "τάφω",
                        "_translit": "táphō"
                     }
                  ],
                  "__text": "akin to an obsolete \n (to dumbfound);"
               },
               "strongs_def": "stupefaction (by surprise),\n i.e. astonishment",
               "kjv_def": ":--X amazed, + astonished, wonder.",
               "_strongs": "02285"
            },
            {
               "strongs": "2286",
               "greek": [
                  {
                     "_BETA": "QANA/SIMOS",
                     "_unicode": "θανάσιμος",
                     "_translit": "thanásimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "than-as'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2288"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fatal, i.e. poisonous",
               "kjv_def": ":--deadly.",
               "_strongs": "02286"
            },
            {
               "strongs": "2287",
               "greek": [
                  {
                     "_BETA": "QANATH/FOROS",
                     "_unicode": "θανατήφορος",
                     "_translit": "thanatḗphoros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "than-at-ay'-for-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2288"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from (the feminine form of) \n and \n;"
               },
               "strongs_def": "death-bearing, i.e.\n fatal",
               "kjv_def": ":--deadly.",
               "_strongs": "02287"
            },
            {
               "strongs": "2288",
               "greek": [
                  {
                     "_BETA": "QA/NATOS",
                     "_unicode": "θάνατος",
                     "_translit": "thánatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "than'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2348"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(properly, an adjective used as a noun) death (literally or\n figuratively)",
               "kjv_def": ":--X deadly, (be…) death.",
               "_strongs": "02288"
            },
            {
               "strongs": "2289",
               "greek": [
                  {
                     "_BETA": "QANATO/W",
                     "_unicode": "θανατόω",
                     "_translit": "thanatóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "than-at-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2288"
                     }
                  ],
                  "__text": "from \n to kill (literally or figuratively)"
               },
               "kjv_def": ":--become dead, (cause to\n be) put to death, kill, mortify.",
               "_strongs": "02289"
            },
            {
               "strongs": "2290",
               "greek": [
                  {
                     "_BETA": "QA/PTW",
                     "_unicode": "θάπτω",
                     "_translit": "tháptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thap'-to"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to celebrate funeral rites, i.e. inter",
               "kjv_def": ":--bury.",
               "_strongs": "02290"
            },
            {
               "strongs": "2291",
               "greek": [
                  {
                     "_BETA": "*QA/RA",
                     "_unicode": "Θάρα",
                     "_translit": "Thára"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thar'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08646"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Thara (i.e. Terach), the father of\n Abraham",
               "kjv_def": ":--Thara.",
               "_strongs": "02291"
            },
            {
               "strongs": "2292",
               "greek": [
                  {
                     "_BETA": "QAR)R(E/W",
                     "_unicode": "θαῤῥέω",
                     "_translit": "tharrhéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thar-hreh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2293"
                     }
                  ],
                  "__text": "another form for \n;"
               },
               "strongs_def": "to exercise courage",
               "kjv_def": ":--be bold, X boldly, have\n confidence, be confident.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5111"
                  }
               ],
               "_strongs": "02292",
               "__text": "Compare \n."
            },
            {
               "strongs": "2293",
               "greek": [
                  {
                     "_BETA": "QARSE/W",
                     "_unicode": "θαρσέω",
                     "_translit": "tharséō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thar-seh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2294"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to have courage",
               "kjv_def": ":--be of good cheer (comfort).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2292"
                  }
               ],
               "_strongs": "02293",
               "__text": "Compare \n."
            },
            {
               "strongs": "2294",
               "greek": [
                  {
                     "_BETA": "QA/RSOS",
                     "_unicode": "θάρσος",
                     "_translit": "thársos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thar'-sos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QRA/SOS",
                        "_unicode": "θράσος",
                        "_translit": "thrásos"
                     }
                  ],
                  "__text": "akin (by transposition) to \n (daring);"
               },
               "strongs_def": "boldness\n (subjectively)",
               "kjv_def": ":--courage.",
               "_strongs": "02294"
            },
            {
               "strongs": "2295",
               "greek": [
                  {
                     "_BETA": "QAU=MA",
                     "_unicode": "θαῦμα",
                     "_translit": "thaûma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thos'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2300"
                     }
                  ],
                  "__text": "apparently from a form of \n;"
               },
               "strongs_def": "wonder (properly concrete; but by\n implication, abstract)",
               "kjv_def": ":--admiration.",
               "_strongs": "02295"
            },
            {
               "strongs": "2296",
               "greek": [
                  {
                     "_BETA": "QAUMA/ZW",
                     "_unicode": "θαυμάζω",
                     "_translit": "thaumázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thou-mad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2295"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to wonder; by implication, to admire",
               "kjv_def": ":--admire, have in\n admiration, marvel, wonder.",
               "_strongs": "02296"
            },
            {
               "strongs": "2297",
               "greek": [
                  {
                     "_BETA": "QAUMA/SIOS",
                     "_unicode": "θαυμάσιος",
                     "_translit": "thaumásios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thow-mas'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2295"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "wondrous, i.e. (neuter as noun) a miracle",
               "kjv_def": ":--wonderful\n thing.",
               "_strongs": "02297"
            },
            {
               "strongs": "2298",
               "greek": [
                  {
                     "_BETA": "QAUMASTO/S",
                     "_unicode": "θαυμαστός",
                     "_translit": "thaumastós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thow-mas-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2296"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "wondered at, i.e. (by implication)\n wonderful",
               "kjv_def": ":--marvel(-lous).",
               "_strongs": "02298"
            },
            {
               "strongs": "2299",
               "greek": [
                  {
                     "_BETA": "QEA/",
                     "_unicode": "θεά",
                     "_translit": "theá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a female deity",
               "kjv_def": ":--goddess.",
               "_strongs": "02299"
            },
            {
               "strongs": "2300",
               "greek": [
                  {
                     "_BETA": "QEA/OMAI",
                     "_unicode": "θεάομαι",
                     "_translit": "theáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-ah'-om-ahee"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb;",
               "strongs_def": "to look closely at, i.e. (by\n implication) perceive (literally or figuratively); by extension to\n visit",
               "kjv_def": ":--behold, look (upon), see.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3700"
                  }
               ],
               "_strongs": "02300",
               "__text": "Compare \n."
            },
            {
               "strongs": "2301",
               "greek": [
                  {
                     "_BETA": "QEATRI/ZW",
                     "_unicode": "θεατρίζω",
                     "_translit": "theatrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-at-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2302"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to expose as a spectacle",
               "kjv_def": ":--make a gazing stock.",
               "_strongs": "02301"
            },
            {
               "strongs": "2302",
               "greek": [
                  {
                     "_BETA": "QE/ATRON",
                     "_unicode": "θέατρον",
                     "_translit": "théatron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh'-at-ron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2300"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a place for public show (\"theatre\"), i.e. general\n audience-room; by implication, a show itself\n (figuratively)",
               "kjv_def": ":--spectacle, theatre.",
               "_strongs": "02302"
            },
            {
               "strongs": "2303",
               "greek": [
                  {
                     "_BETA": "QEI=ON",
                     "_unicode": "θεῖον",
                     "_translit": "theîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thi'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2304"
                     }
                  ],
                  "__text": "probably neuter of \n (in its original sense of flashing);"
               },
               "strongs_def": "sulphur",
               "kjv_def": ":--brimstone.",
               "_strongs": "02303"
            },
            {
               "strongs": "2304",
               "greek": [
                  {
                     "_BETA": "QEI=OS",
                     "_unicode": "θεῖος",
                     "_translit": "theîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thi'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "godlike (neuter as noun, divinity)",
               "kjv_def": ":-- divine, godhead.",
               "_strongs": "02304"
            },
            {
               "strongs": "2305",
               "greek": [
                  {
                     "_BETA": "QEIO/THS",
                     "_unicode": "θειότης",
                     "_translit": "theiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thi-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2304"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "divinity (abstractly)",
               "kjv_def": ":--godhead.",
               "_strongs": "02305"
            },
            {
               "strongs": "2306",
               "greek": [
                  {
                     "_BETA": "QEIW/DHS",
                     "_unicode": "θειώδης",
                     "_translit": "theiṓdēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thi-o'-dace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2303"
                     }
                  ],
                  "__text": "from \n and 1491;"
               },
               "strongs_def": "sulphur-like, i.e. sulphurous",
               "kjv_def": ":--brimstone.",
               "_strongs": "02306"
            },
            {
               "strongs": "2307",
               "greek": [
                  {
                     "_BETA": "QE/LHMA",
                     "_unicode": "θέλημα",
                     "_translit": "thélēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thel'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2309"
                     }
                  ],
                  "__text": "from the prolonged form of \n;"
               },
               "strongs_def": "a determination (properly, the\n thing), i.e. (actively) choice (specially, purpose, decree;\n abstractly, volition) or (passively) inclination",
               "kjv_def": ":-- desire, pleasure,\n will.",
               "_strongs": "02307"
            },
            {
               "strongs": "2308",
               "greek": [
                  {
                     "_BETA": "QE/LHSIS",
                     "_unicode": "θέλησις",
                     "_translit": "thélēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thel'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2309"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "determination (properly, the act), i.e. option",
               "kjv_def": ":--will.",
               "_strongs": "02308"
            },
            {
               "strongs": "2309",
               "greek": [
                  {
                     "_BETA": "QE/LW",
                     "_unicode": "θέλω",
                     "_translit": "thélō"
                  },
                  {
                     "_BETA": "E)QE/LW",
                     "_unicode": "ἐθέλω",
                     "_translit": "ethélō"
                  },
                  {
                     "_BETA": "QELE/W",
                     "_unicode": "θελέω",
                     "_translit": "theléō"
                  },
                  {
                     "_BETA": "E)QELE/W",
                     "_unicode": "ἐθελέω",
                     "_translit": "etheléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thel'-o"
                  },
                  {
                     "_strongs": "eth-el'-o"
                  },
                  {
                     "_strongs": "thel-eh'-o"
                  },
                  {
                     "_strongs": "eth-el-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "apparently strengthened from the alternate form of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1014"
                     }
                  ],
                  "__text": "to determine\n (as an active option from subjective impulse; whereas \n properly\n denotes rather a passive acquiescence in objective considerations),\n i.e. choose or prefer (literally or figuratively); by implication, to\n wish, i.e. be inclined to (sometimes adverbially, gladly);\n impersonally for the future tense, to be about to; by Hebraism, to\n delight in"
               },
               "kjv_def": ":--desire, be disposed (forward), intend, list, love, mean,\n please, have rather, (be) will (have, -ling, - ling(-ly)).",
               "_strongs": "02309",
               "__text": "or \n  \n,    in certain tenses\n      \n  \n,\n  and \n  \n, which are otherwise obsolete"
            },
            {
               "strongs": "2310",
               "greek": [
                  {
                     "_BETA": "QEME/LIOS",
                     "_unicode": "θεμέλιος",
                     "_translit": "themélios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "them-el'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "something put down, i.e. a substruction (of\n a building, etc.), (literally or figuratively)",
               "kjv_def": ":--foundation.",
               "_strongs": "02310"
            },
            {
               "strongs": "2311",
               "greek": [
                  {
                     "_BETA": "QEMELIO/W",
                     "_unicode": "θεμελιόω",
                     "_translit": "themelióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "them-el-ee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2310"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to lay a basis for, i.e. (literally) erect, or\n (figuratively) consolidate",
               "kjv_def": ":--(lay the) found(- ation), ground, settle.",
               "_strongs": "02311"
            },
            {
               "strongs": "2312",
               "greek": [
                  {
                     "_BETA": "QEODI/DAKTOS",
                     "_unicode": "θεοδίδακτος",
                     "_translit": "theodídaktos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-od-id'-ak-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1321"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "divinely instructed",
               "kjv_def": ":--taught of God.",
               "_strongs": "02312"
            },
            {
               "strongs": "2313",
               "greek": [
                  {
                     "_BETA": "QEOMAXE/W",
                     "_unicode": "θεομαχέω",
                     "_translit": "theomachéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-o-makh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2314"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to resist deity",
               "kjv_def": ":--fight against God.",
               "_strongs": "02313"
            },
            {
               "strongs": "2314",
               "greek": [
                  {
                     "_BETA": "QEOMA/XOS",
                     "_unicode": "θεομάχος",
                     "_translit": "theomáchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-om'-akh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3164"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an opponent of deity",
               "kjv_def": ":--to fight against God.",
               "_strongs": "02314"
            },
            {
               "strongs": "2315",
               "greek": [
                  {
                     "_BETA": "QEO/PNEUSTOS",
                     "_unicode": "θεόπνευστος",
                     "_translit": "theópneustos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-op'-nyoo-stos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4154"
                     }
                  ],
                  "__text": "from \n and a presumed derivative of \n;"
               },
               "strongs_def": "divinely breathed\n in",
               "kjv_def": ":--given by inspiration of God.",
               "_strongs": "02315"
            },
            {
               "strongs": "2316",
               "greek": [
                  {
                     "_BETA": "QEO/S",
                     "_unicode": "θεός",
                     "_translit": "theós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     }
                  ],
                  "__text": "a deity, especially (with \n) the supreme\n Divinity; figuratively, a magistrate; by Hebraism, very"
               },
               "kjv_def": ":--X exceeding,\n God, god(-ly, -ward).",
               "_strongs": "02316"
            },
            {
               "strongs": "2317",
               "greek": [
                  {
                     "_BETA": "QEOSE/BEIA",
                     "_unicode": "θεοσέβεια",
                     "_translit": "theosébeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-os-eb'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2318"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "devoutness, i.e. piety",
               "kjv_def": ":--godliness.",
               "_strongs": "02317"
            },
            {
               "strongs": "2318",
               "greek": [
                  {
                     "_BETA": "QEOSEBH/S",
                     "_unicode": "θεοσεβής",
                     "_translit": "theosebḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-os-eb-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4576"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "reverent of God, i.e. pious",
               "kjv_def": ":--worshipper of God.",
               "_strongs": "02318"
            },
            {
               "strongs": "2319",
               "greek": [
                  {
                     "_BETA": "QEOSTUGH/S",
                     "_unicode": "θεοστυγής",
                     "_translit": "theostygḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-os-too-gace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4767"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "hateful to God, i.e. impious",
               "kjv_def": ":--hater\n of God.",
               "_strongs": "02319"
            },
            {
               "strongs": "2320",
               "greek": [
                  {
                     "_BETA": "QEO/THS",
                     "_unicode": "θεότης",
                     "_translit": "theótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "divinity (abstractly)",
               "kjv_def": ":--godhead.",
               "_strongs": "02320"
            },
            {
               "strongs": "2321",
               "greek": [
                  {
                     "_BETA": "*QEO/FILOS",
                     "_unicode": "Θεόφιλος",
                     "_translit": "Theóphilos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-of'-il-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "friend of God; Theophilus, a\n Christian",
               "kjv_def": ":--Theophilus.",
               "_strongs": "02321"
            },
            {
               "strongs": "2322",
               "greek": [
                  {
                     "_BETA": "QERAPEI/A",
                     "_unicode": "θεραπεία",
                     "_translit": "therapeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther-ap-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2323"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "attendance (specially, medical, i.e. cure); figuratively\n and collectively, domestics",
               "kjv_def": ":--healing, household.",
               "_strongs": "02322"
            },
            {
               "strongs": "2323",
               "greek": [
                  {
                     "_BETA": "QERAPEU/W",
                     "_unicode": "θεραπεύω",
                     "_translit": "therapeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther-ap-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2324"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to wait upon menially, i.e. (figuratively) to\n adore (God), or (specially) to relieve (of disease)",
               "kjv_def": ":--cure, heal,\n worship.",
               "_strongs": "02323"
            },
            {
               "strongs": "2324",
               "greek": [
                  {
                     "_BETA": "QERA/PWN",
                     "_unicode": "θεράπων",
                     "_translit": "therápōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther-ap'-ohn"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2330"
                     }
                  ],
                  "__text": "apparently a participle from an otherwise obsolete derivative of the\n base of \n;"
               },
               "strongs_def": "a menial attendant (as if cherishing)",
               "kjv_def": ":--servant.",
               "_strongs": "02324"
            },
            {
               "strongs": "2325",
               "greek": [
                  {
                     "_BETA": "QERI/ZW",
                     "_unicode": "θερίζω",
                     "_translit": "therízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2330"
                     }
                  ],
                  "__text": "from \n (in the sense of the crop);"
               },
               "strongs_def": "to harvest",
               "kjv_def": ":--reap.",
               "_strongs": "02325"
            },
            {
               "strongs": "2326",
               "greek": [
                  {
                     "_BETA": "QERISMO/S",
                     "_unicode": "θερισμός",
                     "_translit": "therismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2325"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "reaping, i.e. the crop",
               "kjv_def": ":--harvest.",
               "_strongs": "02326"
            },
            {
               "strongs": "2327",
               "greek": [
                  {
                     "_BETA": "QERISTH/S",
                     "_unicode": "θεριστής",
                     "_translit": "theristḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther-is-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2325"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a harvester",
               "kjv_def": ":--reaper.",
               "_strongs": "02327"
            },
            {
               "strongs": "2328",
               "greek": [
                  {
                     "_BETA": "QERMAI/NW",
                     "_unicode": "θερμαίνω",
                     "_translit": "thermaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther-mah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2329"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to heat (oneself)",
               "kjv_def": ":--(be) warm(-ed, self).",
               "_strongs": "02328"
            },
            {
               "strongs": "2329",
               "greek": [
                  {
                     "_BETA": "QE/RMH",
                     "_unicode": "θέρμη",
                     "_translit": "thérmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2330"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "warmth",
               "kjv_def": ":--heat.",
               "_strongs": "02329"
            },
            {
               "strongs": "2330",
               "greek": [
                  {
                     "_BETA": "QE/ROS",
                     "_unicode": "θέρος",
                     "_translit": "théros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ther'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QE/RW",
                        "_unicode": "θέρω",
                        "_translit": "thérō"
                     }
                  ],
                  "__text": "from a primary \n (to heat);"
               },
               "strongs_def": "properly, heat, i.e. summer",
               "kjv_def": ":--summer.",
               "_strongs": "02330"
            },
            {
               "strongs": "2331",
               "greek": [
                  {
                     "_BETA": "*QESSALONIKEU/S",
                     "_unicode": "Θεσσαλονικεύς",
                     "_translit": "Thessalonikeús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thes-sal-on-ik-yoos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2332"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Thessalonican, i.e. inhabitant of\n Thessalonice",
               "kjv_def": ":--Thessalonian.",
               "_strongs": "02331"
            },
            {
               "strongs": "2332",
               "greek": [
                  {
                     "_BETA": "*QESSALONI/KH",
                     "_unicode": "Θεσσαλονίκη",
                     "_translit": "Thessaloníkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thes-sal-on-ee'-kay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*QESSALO/S",
                        "_unicode": "Θεσσαλός",
                        "_translit": "Thessalós"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3529"
                     }
                  ],
                  "__text": "from \n (a Thessalian) and \n;"
               },
               "strongs_def": "Thessalonice, a place in Asia\n Minor",
               "kjv_def": ":--Thessalonica.",
               "_strongs": "02332"
            },
            {
               "strongs": "2333",
               "greek": [
                  {
                     "_BETA": "*QEUDA=S",
                     "_unicode": "Θευδᾶς",
                     "_translit": "Theudâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thyoo-das'"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Theudas, an Israelite",
               "kjv_def": ":--Theudas.",
               "_strongs": "02333"
            },
            {
               "strongs": "2334",
               "greek": [
                  {
                     "_BETA": "QEWRE/W",
                     "_unicode": "θεωρέω",
                     "_translit": "theōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2300"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "from a derivative of \n (perhaps by addition of \n);"
               },
               "strongs_def": "to be a\n spectator of, i.e. discern, (literally, figuratively (experience) or\n intensively (acknowledge))",
               "kjv_def": ":--behold, consider, look on, perceive, see.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3700"
                  }
               ],
               "_strongs": "02334",
               "__text": "Compare \n."
            },
            {
               "strongs": "2335",
               "greek": [
                  {
                     "_BETA": "QEWRI/A",
                     "_unicode": "θεωρία",
                     "_translit": "theōría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "theh-o-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2334"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "spectatorship, i.e. (concretely) a\n spectacle",
               "kjv_def": ":--sight.",
               "_strongs": "02335"
            },
            {
               "strongs": "2336",
               "greek": [
                  {
                     "_BETA": "QH/KH",
                     "_unicode": "θήκη",
                     "_translit": "thḗkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a receptacle, i.e. scabbard",
               "kjv_def": ":--sheath.",
               "_strongs": "02336"
            },
            {
               "strongs": "2337",
               "greek": [
                  {
                     "_BETA": "QHLA/ZW",
                     "_unicode": "θηλάζω",
                     "_translit": "thēlázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay-lad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QHLH/",
                        "_unicode": "θηλή",
                        "_translit": "thēlḗ"
                     }
                  ],
                  "__text": "from \n (the nipple);"
               },
               "strongs_def": "to suckle, (by implication) to suck",
               "kjv_def": ":--(give)\n suck(-ling).",
               "_strongs": "02337"
            },
            {
               "strongs": "2338",
               "greek": [
                  {
                     "_BETA": "QH=LUS",
                     "_unicode": "θῆλυς",
                     "_translit": "thēlys"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay'-loos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2337"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "female",
               "kjv_def": ":--female, woman.",
               "_strongs": "02338"
            },
            {
               "strongs": "2339",
               "greek": [
                  {
                     "_BETA": "QH/RA",
                     "_unicode": "θήρα",
                     "_translit": "thḗra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay'-rah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QH/R",
                        "_unicode": "θήρ",
                        "_translit": "thḗr"
                     }
                  ],
                  "__text": "from \n (a wild animal, as game);"
               },
               "strongs_def": "hunting, i.e. (figuratively)\n destruction",
               "kjv_def": ":--trap.",
               "_strongs": "02339"
            },
            {
               "strongs": "2340",
               "greek": [
                  {
                     "_BETA": "QHREU/W",
                     "_unicode": "θηρεύω",
                     "_translit": "thēreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay-ryoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2339"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to hunt (an animal), i.e. (figuratively) to carp\n at",
               "kjv_def": ":--catch.",
               "_strongs": "02340"
            },
            {
               "strongs": "2341",
               "greek": [
                  {
                     "_BETA": "QHRIOMAXE/W",
                     "_unicode": "θηριομαχέω",
                     "_translit": "thēriomachéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay-ree-om-akh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2342"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3164"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be a beast-fighter (in the\n gladiatorial show), i.e. (figuratively) to encounter (furious\n men)",
               "kjv_def": ":--fight with wild beasts.",
               "_strongs": "02341"
            },
            {
               "strongs": "2342",
               "greek": [
                  {
                     "_BETA": "QHRI/ON",
                     "_unicode": "θηρίον",
                     "_translit": "thēríon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay-ree'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2339"
                     }
                  ],
                  "__text": "diminutive from the same as \n;"
               },
               "strongs_def": "a dangerous animal",
               "kjv_def": ":--(venomous,\n wild) beast.",
               "_strongs": "02342"
            },
            {
               "strongs": "2343",
               "greek": [
                  {
                     "_BETA": "QHSAURI/ZW",
                     "_unicode": "θησαυρίζω",
                     "_translit": "thēsaurízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay-sow-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2344"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to amass or reserve (literally or figuratively)",
               "kjv_def": ":--lay up\n (treasure), (keep) in store, (heap) treasure (together, up).",
               "_strongs": "02343"
            },
            {
               "strongs": "2344",
               "greek": [
                  {
                     "_BETA": "QHSAURO/S",
                     "_unicode": "θησαυρός",
                     "_translit": "thēsaurós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thay-sow-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deposit, i.e. wealth (literally or\n figuratively)",
               "kjv_def": ":--treasure.",
               "_strongs": "02344"
            },
            {
               "strongs": "2345",
               "greek": [
                  {
                     "_BETA": "QIGGA/NW",
                     "_unicode": "θιγγάνω",
                     "_translit": "thingánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thing-gan'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QI/GW",
                        "_unicode": "θίγω",
                        "_translit": "thígō"
                     }
                  ],
                  "__text": "a prolonged form of an obsolete primary \n (to finger);"
               },
               "strongs_def": "to\n manipulate, i.e. have to do with; by implication, to injure",
               "kjv_def": ":--handle,\n touch.",
               "_strongs": "02345"
            },
            {
               "strongs": "2346",
               "greek": [
                  {
                     "_BETA": "QLI/BW",
                     "_unicode": "θλίβω",
                     "_translit": "thlíbō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thlee'-bo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5147"
                     }
                  ],
                  "__text": "akin to the base of \n;"
               },
               "strongs_def": "to crowd (literally or\n figuratively)",
               "kjv_def": ":--afflict, narrow, throng, suffer tribulation, trouble.",
               "_strongs": "02346"
            },
            {
               "strongs": "2347",
               "greek": [
                  {
                     "_BETA": "QLI=YIS",
                     "_unicode": "θλῖψις",
                     "_translit": "thlîpsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thlip'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2346"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pressure (literally or figuratively)",
               "kjv_def": ":--afflicted(-tion),\n anguish, burdened, persecution, tribulation, trouble.",
               "_strongs": "02347"
            },
            {
               "strongs": "2348",
               "greek": [
                  {
                     "_BETA": "QNH/SKW",
                     "_unicode": "θνήσκω",
                     "_translit": "thnḗskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thnay'-sko"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QA/NW",
                        "_unicode": "θάνω",
                        "_translit": "thánō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "than'-o"
                     }
                  ],
                  "__text": "a strengthened form of a simpler primary \n \n (which is used\n for it only in certain tenses);"
               },
               "strongs_def": "to die (literally or\n figuratively)",
               "kjv_def": ":--be dead, die.",
               "_strongs": "02348"
            },
            {
               "strongs": "2349",
               "greek": [
                  {
                     "_BETA": "QNHTO/S",
                     "_unicode": "θνητός",
                     "_translit": "thnētós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thnay-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2348"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "liable to die",
               "kjv_def": ":--mortal(-ity).",
               "_strongs": "02349"
            },
            {
               "strongs": "2350",
               "greek": [
                  {
                     "_BETA": "QORUBE/W",
                     "_unicode": "θορυβέω",
                     "_translit": "thorybéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thor-oo-beh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2351"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be in tumult, i.e. disturb, clamor",
               "kjv_def": ":--make ado (a noise),\n trouble self, set on an uproar.",
               "_strongs": "02350"
            },
            {
               "strongs": "2351",
               "greek": [
                  {
                     "_BETA": "QO/RUBOS",
                     "_unicode": "θόρυβος",
                     "_translit": "thórybos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thor'-oo-bos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2360"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a disturbance",
               "kjv_def": ":--tumult, uproar.",
               "_strongs": "02351"
            },
            {
               "strongs": "2352",
               "greek": [
                  {
                     "_BETA": "QRAU/W",
                     "_unicode": "θραύω",
                     "_translit": "thraúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "throw'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to crush",
               "kjv_def": ":--bruise.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4486"
                  }
               ],
               "_strongs": "02352",
               "__text": "Compare \n."
            },
            {
               "strongs": "2353",
               "greek": [
                  {
                     "_BETA": "QRE/MMA",
                     "_unicode": "θρέμμα",
                     "_translit": "thrémma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "threm'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "stock (as raised on a farm)",
               "kjv_def": ":--cattle.",
               "_strongs": "02353"
            },
            {
               "strongs": "2354",
               "greek": [
                  {
                     "_BETA": "QRHNE/W",
                     "_unicode": "θρηνέω",
                     "_translit": "thrēnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thray-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2355"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to bewail",
               "kjv_def": ":--lament, mourn.",
               "_strongs": "02354"
            },
            {
               "strongs": "2355",
               "greek": [
                  {
                     "_BETA": "QRH=NOS",
                     "_unicode": "θρῆνος",
                     "_translit": "thrēnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thray'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2360"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "wailing",
               "kjv_def": ":--lamentation.",
               "_strongs": "02355"
            },
            {
               "strongs": "2356",
               "greek": [
                  {
                     "_BETA": "QRHSKEI/A",
                     "_unicode": "θρησκεία",
                     "_translit": "thrēskeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thrace-ki'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2357"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "ceremonial observance",
               "kjv_def": ":--religion,\n worshipping.",
               "_strongs": "02356"
            },
            {
               "strongs": "2357",
               "greek": [
                  {
                     "_BETA": "QRHSKO/S",
                     "_unicode": "θρησκός",
                     "_translit": "thrēskós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thrace'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2360"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "ceremonious in worship (as\n demonstrative), i.e. pious",
               "kjv_def": ":--religious.",
               "_strongs": "02357"
            },
            {
               "strongs": "2358",
               "greek": [
                  {
                     "_BETA": "QRIAMBEU/W",
                     "_unicode": "θριαμβεύω",
                     "_translit": "thriambeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "three-am-byoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2360"
                     }
                  ],
                  "__text": "from a prolonged compound of the base of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "680"
                     }
                  ],
                  "__text": "and a derivative of \n\n (meaning a noisy iambus, sung in honor of Bacchus); to make an\n acclamatory procession, i.e. (figuratively) to conquer or (by\n Hebraism) to give victory"
               },
               "kjv_def": ":--(cause) to triumph (over).",
               "_strongs": "02358"
            },
            {
               "strongs": "2359",
               "greek": [
                  {
                     "_BETA": "QRI/C",
                     "_unicode": "θρίξ",
                     "_translit": "thríx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "threeks"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TRIXO/S",
                        "_unicode": "τριχός",
                        "_translit": "trichós"
                     }
                  ],
                  "__text": "genitive case \n, etc.;"
               },
               "strongs_def": "of uncertain derivation; hair",
               "kjv_def": ":--hair.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2864"
                  }
               ],
               "_strongs": "02359",
               "__text": "Compare \n."
            },
            {
               "strongs": "2360",
               "greek": [
                  {
                     "_BETA": "QROE/W",
                     "_unicode": "θροέω",
                     "_translit": "throéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thro-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QRE/OMAI",
                        "_unicode": "θρέομαι",
                        "_translit": "thréomai"
                     }
                  ],
                  "__text": "from \n to wail;"
               },
               "strongs_def": "to clamor, i.e. (by implication) to\n frighten",
               "kjv_def": ":--trouble.",
               "_strongs": "02360"
            },
            {
               "strongs": "2361",
               "greek": [
                  {
                     "_BETA": "QRO/MBOS",
                     "_unicode": "θρόμβος",
                     "_translit": "thrómbos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "throm'-bos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "perhaps from \n (in the sense of thickening);"
               },
               "strongs_def": "a clot",
               "kjv_def": ":--great drop.",
               "_strongs": "02361"
            },
            {
               "strongs": "2362",
               "greek": [
                  {
                     "_BETA": "QRO/NOS",
                     "_unicode": "θρόνος",
                     "_translit": "thrónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thron'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QRA/W",
                        "_unicode": "θράω",
                        "_translit": "thráō"
                     }
                  ],
                  "__text": "from \n (to sit);"
               },
               "strongs_def": "a stately seat (\"throne\"); by implication, power\n or (concretely) a potentate",
               "kjv_def": ":--seat, throne.",
               "_strongs": "02362"
            },
            {
               "strongs": "2363",
               "greek": [
                  {
                     "_BETA": "*QUA/TEIRA",
                     "_unicode": "Θυάτειρα",
                     "_translit": "Thyáteira"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-at'-i-rah"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Thyatira, a place in Asia Minor",
               "kjv_def": ":--Thyatira.",
               "_strongs": "02363"
            },
            {
               "strongs": "2364",
               "greek": [
                  {
                     "_BETA": "QUGA/THR",
                     "_unicode": "θυγάτηρ",
                     "_translit": "thygátēr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-gat'-air"
                  }
               ],
               "strongs_derivation": "apparently a primary word (compare \"daughter\");",
               "strongs_def": "a female child, or (by\n Hebraism) descendant (or inhabitant)",
               "kjv_def": ":--daughter.",
               "_strongs": "02364"
            },
            {
               "strongs": "2365",
               "greek": [
                  {
                     "_BETA": "QUGA/TRION",
                     "_unicode": "θυγάτριον",
                     "_translit": "thygátrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-gat'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2364"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a daughterling",
               "kjv_def": ":--little (young) daughter.",
               "_strongs": "02365"
            },
            {
               "strongs": "2366",
               "greek": [
                  {
                     "_BETA": "QU/ELLA",
                     "_unicode": "θύελλα",
                     "_translit": "thýella"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo'-el-lah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2380"
                     }
                  ],
                  "__text": "from \n (in the sense of blowing) a storm"
               },
               "kjv_def": ":--tempest.",
               "_strongs": "02366"
            },
            {
               "strongs": "2367",
               "greek": [
                  {
                     "_BETA": "QU/I+NOS",
                     "_unicode": "θύϊνος",
                     "_translit": "thýïnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo'-ee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2380"
                     }
                  ],
                  "__text": "from a derivative of \n (in the sense of blowing; denoting a certain\n fragrant tree);"
               },
               "strongs_def": "made of citron-wood",
               "kjv_def": ":--thyine.",
               "_strongs": "02367"
            },
            {
               "strongs": "2368",
               "greek": [
                  {
                     "_BETA": "QUMI/AMA",
                     "_unicode": "θυμίαμα",
                     "_translit": "thymíama"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-mee'-am-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2370"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an aroma, i.e. fragrant powder burnt in religious service;\n by implication, the burning itself",
               "kjv_def": ":--incense, odour.",
               "_strongs": "02368"
            },
            {
               "strongs": "2369",
               "greek": [
                  {
                     "_BETA": "QUMIASTH/RION",
                     "_unicode": "θυμιαστήριον",
                     "_translit": "thymiastḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-mee-as-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2370"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a place of fumigation, i.e. the alter of\n incense (in the Temple)",
               "kjv_def": ":--censer.",
               "_strongs": "02369"
            },
            {
               "strongs": "2370",
               "greek": [
                  {
                     "_BETA": "QUMIA/W",
                     "_unicode": "θυμιάω",
                     "_translit": "thymiáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-mee-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2380"
                     }
                  ],
                  "__text": "from a derivative of \n (in the sense of smoking);"
               },
               "strongs_def": "to fumigate, i.e.\n offer aromatic fumes",
               "kjv_def": ":--burn incense.",
               "_strongs": "02370"
            },
            {
               "strongs": "2371",
               "greek": [
                  {
                     "_BETA": "QUMOMAXE/W",
                     "_unicode": "θυμομαχέω",
                     "_translit": "thymomachéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-mom-akh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3164"
                     }
                  ],
                  "__text": "from a presumed compound of \n and \n;"
               },
               "strongs_def": "to be in a furious fight,\n i.e. (figuratively) to be exasperated",
               "kjv_def": ":--be highly displeased.",
               "_strongs": "02371"
            },
            {
               "strongs": "2372",
               "greek": [
                  {
                     "_BETA": "QUMO/S",
                     "_unicode": "θυμός",
                     "_translit": "thymós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2380"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "passion (as if breathing hard)",
               "kjv_def": ":--fierceness, indignation,\n wrath.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5590"
                  }
               ],
               "_strongs": "02372",
               "__text": "Compare \n."
            },
            {
               "strongs": "2373",
               "greek": [
                  {
                     "_BETA": "QUMO/W",
                     "_unicode": "θυμόω",
                     "_translit": "thymóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tho-mo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to put in a passion, i.e. enrage",
               "kjv_def": ":--be wroth.",
               "_strongs": "02373"
            },
            {
               "strongs": "2374",
               "greek": [
                  {
                     "_BETA": "QU/RA",
                     "_unicode": "θύρα",
                     "_translit": "thýra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo'-rah"
                  }
               ],
               "strongs_derivation": "apparently a primary word (compare \"door\");",
               "strongs_def": "a portal or entrance (the\n opening or the closure, literally or figuratively)",
               "kjv_def": ":--door, gate.",
               "_strongs": "02374"
            },
            {
               "strongs": "2375",
               "greek": [
                  {
                     "_BETA": "QUREO/S",
                     "_unicode": "θυρεός",
                     "_translit": "thyreós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-reh-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2374"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a large shield (as door-shaped)",
               "kjv_def": ":--shield.",
               "_strongs": "02375"
            },
            {
               "strongs": "2376",
               "greek": [
                  {
                     "_BETA": "QURI/S",
                     "_unicode": "θυρίς",
                     "_translit": "thyrís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-rece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2374"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an aperture, i.e. window",
               "kjv_def": ":--window.",
               "_strongs": "02376"
            },
            {
               "strongs": "2377",
               "greek": [
                  {
                     "_BETA": "QURWRO/S",
                     "_unicode": "θυρωρός",
                     "_translit": "thyrōrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-ro-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2374"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "OU)=ROS",
                        "_unicode": "οὖρος",
                        "_translit": "oûros"
                     }
                  ],
                  "__text": "from \n and \n (a watcher);"
               },
               "strongs_def": "a gate- warden",
               "kjv_def": ":--that kept the door,\n porter.",
               "_strongs": "02377"
            },
            {
               "strongs": "2378",
               "greek": [
                  {
                     "_BETA": "QUSI/A",
                     "_unicode": "θυσία",
                     "_translit": "thysía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2380"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sacrifice (the act or the victim, literally or\n figuratively)",
               "kjv_def": ":--sacrifice.",
               "_strongs": "02378"
            },
            {
               "strongs": "2379",
               "greek": [
                  {
                     "_BETA": "QUSIASTH/RION",
                     "_unicode": "θυσιαστήριον",
                     "_translit": "thysiastḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo-see-as-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2378"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a place of sacrifice, i.e. an altar\n (special or genitive case, literal or figurative)",
               "kjv_def": ":--altar.",
               "_strongs": "02379"
            },
            {
               "strongs": "2380",
               "greek": [
                  {
                     "_BETA": "QU/W",
                     "_unicode": "θύω",
                     "_translit": "thýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "thoo'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "properly, to rush (breathe hard, blow, smoke), i.e.\n (by implication) to sacrifice (properly, by fire, but genitive case);\n by extension to immolate (slaughter for any purpose)",
               "kjv_def": ":--kill, (do)\n sacrifice, slay.",
               "_strongs": "02380"
            },
            {
               "strongs": "2381",
               "greek": [
                  {
                     "_BETA": "*QWMA=S",
                     "_unicode": "Θωμᾶς",
                     "_translit": "Thōmâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tho-mas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08380"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "the twin; Thomas, a\n Christian",
               "kjv_def": ":--Thomas.",
               "_strongs": "02381"
            },
            {
               "strongs": "2382",
               "greek": [
                  {
                     "_BETA": "QW/RAC",
                     "_unicode": "θώραξ",
                     "_translit": "thṓrax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tho'-rax"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "the chest (\"thorax\"), i.e. (by implication) a\n corslet",
               "kjv_def": ":--breast-plate.",
               "_strongs": "02382"
            },
            {
               "strongs": "2383",
               "greek": [
                  {
                     "_BETA": "*)IA/EIROS",
                     "_unicode": "Ἰάειρος",
                     "_translit": "Iáeiros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ah'-i-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02971"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jairus (i.e. Jair), an Israelite",
               "kjv_def": ":--Jairus.",
               "_strongs": "02383"
            },
            {
               "strongs": "2384",
               "greek": [
                  {
                     "_BETA": "*)IAKW/B",
                     "_unicode": "Ἰακώβ",
                     "_translit": "Iakṓb"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ak-obe'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03290"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jacob (i.e. Ja`akob), the progenitor of the\n Israelites",
               "kjv_def": ":--also an Israelite:--Jacob.",
               "_strongs": "02384"
            },
            {
               "strongs": "2385",
               "greek": [
                  {
                     "_BETA": "*)IA/KWBOS",
                     "_unicode": "Ἰάκωβος",
                     "_translit": "Iákōbos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ak'-o-bos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2384"
                     }
                  ],
                  "__text": "the same as \n Græcized;"
               },
               "strongs_def": "Jacobus, the name of three\n Israelites",
               "kjv_def": ":--James.",
               "_strongs": "02385"
            },
            {
               "strongs": "2386",
               "greek": [
                  {
                     "_BETA": "I)/AMA",
                     "_unicode": "ἴαμα",
                     "_translit": "íama"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee'-am-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2390"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a cure (the effect)",
               "kjv_def": ":--healing.",
               "_strongs": "02386"
            },
            {
               "strongs": "2387",
               "greek": [
                  {
                     "_BETA": "*)IAMBRH=S",
                     "_unicode": "Ἰαμβρῆς",
                     "_translit": "Iambrēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-am-brace'"
                  }
               ],
               "strongs_derivation": "of Egyptian origin;",
               "strongs_def": "Jambres, an Egyptian",
               "kjv_def": ":--Jambres.",
               "_strongs": "02387"
            },
            {
               "strongs": "2388",
               "greek": [
                  {
                     "_BETA": "*)IANNA/",
                     "_unicode": "Ἰαννά",
                     "_translit": "Ianná"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-an-nah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03238"
                     }
                  ],
                  "__text": "probably of Hebrew origin (compare \n);"
               },
               "strongs_def": "Janna, an Israelite",
               "kjv_def": ":--Janna.",
               "_strongs": "02388"
            },
            {
               "strongs": "2389",
               "greek": [
                  {
                     "_BETA": "*)IANNH=S",
                     "_unicode": "Ἰαννῆς",
                     "_translit": "Iannēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-an-nace'"
                  }
               ],
               "strongs_derivation": "of Egyptian origin;",
               "strongs_def": "Jannes, an Egyptian",
               "kjv_def": ":--Jannes.",
               "_strongs": "02389"
            },
            {
               "strongs": "2390",
               "greek": [
                  {
                     "_BETA": "I)A/OMAI",
                     "_unicode": "ἰάομαι",
                     "_translit": "iáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ah'-om-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of apparently a primary verb;",
               "strongs_def": "to cure (literally or\n figuratively)",
               "kjv_def": ":--heal, make whole.",
               "_strongs": "02390"
            },
            {
               "strongs": "2391",
               "greek": [
                  {
                     "_BETA": "*)IA/RED",
                     "_unicode": "Ἰάρεδ",
                     "_translit": "Iáred"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ar'-ed"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03382"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jared (i.e. Jered), an antediluvian",
               "kjv_def": ":--Jared.",
               "_strongs": "02391"
            },
            {
               "strongs": "2392",
               "greek": [
                  {
                     "_BETA": "I)/ASIS",
                     "_unicode": "ἴασις",
                     "_translit": "íasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee'-as-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2390"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "curing (the act)",
               "kjv_def": ":--cure, heal(-ing).",
               "_strongs": "02392"
            },
            {
               "strongs": "2393",
               "greek": [
                  {
                     "_BETA": "I)/ASPIS",
                     "_unicode": "ἴασπις",
                     "_translit": "íaspis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee'-as-pis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03471"
                     }
                  ],
                  "__text": "probably of foreign origin (see \n);"
               },
               "strongs_def": "\"jasper\", a gem",
               "kjv_def": ":--jasper.",
               "_strongs": "02393"
            },
            {
               "strongs": "2394",
               "greek": [
                  {
                     "_BETA": "*)IA/SWN",
                     "_unicode": "Ἰάσων",
                     "_translit": "Iásōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-as'-oan"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2390"
                     }
                  ],
                  "__text": "future active participle masculine of \n;"
               },
               "strongs_def": "about to cure; Jason, a\n Christian",
               "kjv_def": ":--Jason.",
               "_strongs": "02394"
            },
            {
               "strongs": "2395",
               "greek": [
                  {
                     "_BETA": "I)ATRO/S",
                     "_unicode": "ἰατρός",
                     "_translit": "iatrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-at-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2390"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a physician",
               "kjv_def": ":--physician.",
               "_strongs": "02395"
            },
            {
               "strongs": "2396",
               "greek": [
                  {
                     "_BETA": "I)/DE",
                     "_unicode": "ἴδε",
                     "_translit": "íde"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "id'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "second person singular imperative active of \n;"
               },
               "strongs_def": "used as an\n interjection to denote surprise; lo!",
               "kjv_def": ":--behold, lo, see.",
               "_strongs": "02396"
            },
            {
               "strongs": "2397",
               "greek": [
                  {
                     "_BETA": "I)DE/A",
                     "_unicode": "ἰδέα",
                     "_translit": "idéa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "id-eh'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sight (compare figuratively \"idea\"), i.e.\n aspect",
               "kjv_def": ":--countenance.",
               "_strongs": "02397"
            },
            {
               "strongs": "2398",
               "greek": [
                  {
                     "_BETA": "I)/DIOS",
                     "_unicode": "ἴδιος",
                     "_translit": "ídios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "id'-ee-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "pertaining to self, i.e. one's own; by\n implication, private or separate",
               "kjv_def": ":--X his acquaintance, when they were\n alone, apart, aside, due, his (own, proper, several), home, (her, our,\n thine, your) own (business), private(-ly), proper, severally, their\n (own).",
               "_strongs": "02398"
            },
            {
               "strongs": "2399",
               "greek": [
                  {
                     "_BETA": "I)DIW/THS",
                     "_unicode": "ἰδιώτης",
                     "_translit": "idiṓtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "id-ee-o'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2398"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a private person, i.e. (by implication) an ignoramus\n (compare \"idiot\")",
               "kjv_def": ":--ignorant, rude, unlearned.",
               "_strongs": "02399"
            },
            {
               "strongs": "2400",
               "greek": [
                  {
                     "_BETA": "I)DOU/",
                     "_unicode": "ἰδού",
                     "_translit": "idoú"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "id-oo'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "second person singular imperative middle voice of \n;"
               },
               "strongs_def": "used as\n imperative lo!;",
               "kjv_def": "--behold, lo, see.",
               "_strongs": "02400"
            },
            {
               "strongs": "2401",
               "greek": [
                  {
                     "_BETA": "*)IDOUMAI/A",
                     "_unicode": "Ἰδουμαία",
                     "_translit": "Idoumaía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "id-oo-mah'-yah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0123"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Idumæa (i.e. Edom), a region East (and South)\n of Palestine",
               "kjv_def": ":--Idumæa.",
               "_strongs": "02401"
            },
            {
               "strongs": "2402",
               "greek": [
                  {
                     "_BETA": "I(DRW/S",
                     "_unicode": "ἱδρώς",
                     "_translit": "hidrṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hid-roce'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "I)/DOS",
                        "_unicode": "ἴδος",
                        "_translit": "ídos"
                     }
                  ],
                  "__text": "a strengthened form of a primary \n (sweat): perspiration"
               },
               "kjv_def": ":--sweat.",
               "_strongs": "02402"
            },
            {
               "strongs": "2403",
               "greek": [
                  {
                     "_BETA": "*)IEZABH/L",
                     "_unicode": "Ἰεζαβήλ",
                     "_translit": "Iezabḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ed-zab-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0348"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jezabel (i.e. Jezebel), a Tyrian woman (used\n as a synonym of a termagant or false teacher)",
               "kjv_def": ":--Jezabel.",
               "_strongs": "02403"
            },
            {
               "strongs": "2404",
               "greek": [
                  {
                     "_BETA": "*(IERA/POLIS",
                     "_unicode": "Ἱεράπολις",
                     "_translit": "Hierápolis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-ap'-ol-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2413"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "holy city; Hierapolis, a place in Asia\n Minor",
               "kjv_def": ":--Hierapolis.",
               "_strongs": "02404"
            },
            {
               "strongs": "2405",
               "greek": [
                  {
                     "_BETA": "I(ERATEI/A",
                     "_unicode": "ἱερατεία",
                     "_translit": "hierateía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-at-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2407"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "priestliness, i.e. the sacerdotal function",
               "kjv_def": ":--office of the\n priesthood, priest's office.",
               "_strongs": "02405"
            },
            {
               "strongs": "2406",
               "greek": [
                  {
                     "_BETA": "I(ERA/TEUMA",
                     "_unicode": "ἱεράτευμα",
                     "_translit": "hieráteuma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-at'-yoo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2407"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the priestly fraternity, i.e. sacerdotal order\n (figuratively)",
               "kjv_def": ":--priesthood.",
               "_strongs": "02406"
            },
            {
               "strongs": "2407",
               "greek": [
                  {
                     "_BETA": "I(ERATEU/W",
                     "_unicode": "ἱερατεύω",
                     "_translit": "hierateúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-at-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2409"
                     }
                  ],
                  "__text": "prolongation from \n;"
               },
               "strongs_def": "to be a priest, i.e. perform his\n functions",
               "kjv_def": ":--execute the priest's office.",
               "_strongs": "02407"
            },
            {
               "strongs": "2408",
               "greek": [
                  {
                     "_BETA": "*(IEREMI/AS",
                     "_unicode": "Ἱερεμίας",
                     "_translit": "Hieremías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-em-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03414"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Hieremias (i.e. Jermijah), an\n Israelite",
               "kjv_def": ":--Jeremiah.",
               "_strongs": "02408"
            },
            {
               "strongs": "2409",
               "greek": [
                  {
                     "_BETA": "I(EREU/S",
                     "_unicode": "ἱερεύς",
                     "_translit": "hiereús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2413"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a priest (literally or figuratively)",
               "kjv_def": ":--(high) priest.",
               "_strongs": "02409"
            },
            {
               "strongs": "2410",
               "greek": [
                  {
                     "_BETA": "*(IERIXW/",
                     "_unicode": "Ἱεριχώ",
                     "_translit": "Hierichṓ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-ee-kho'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03405"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jericho, a place in Palestine",
               "kjv_def": ":--Jericho.",
               "_strongs": "02410"
            },
            {
               "strongs": "2411",
               "greek": [
                  {
                     "_BETA": "I(ERO/N",
                     "_unicode": "ἱερόν",
                     "_translit": "hierón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-on'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2413"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3485"
                     }
                  ],
                  "__text": "a sacred place, i.e. the entire precincts (whereas\n \n denotes the central sanctuary itself) of the Temple (at Jerusalem\n or elsewhere)"
               },
               "kjv_def": ":--temple.",
               "_strongs": "02411"
            },
            {
               "strongs": "2412",
               "greek": [
                  {
                     "_BETA": "I(EROPREPH/S",
                     "_unicode": "ἱεροπρεπής",
                     "_translit": "hieroprepḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-op-rep-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2413"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4241"
                     }
                  ],
                  "__text": "from \n and the same as \n;"
               },
               "strongs_def": "reverent",
               "kjv_def": ":--as becometh holiness.",
               "_strongs": "02412"
            },
            {
               "strongs": "2413",
               "greek": [
                  {
                     "_BETA": "I(ERO/S",
                     "_unicode": "ἱερός",
                     "_translit": "hierós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-os'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "sacred",
               "kjv_def": ":--holy.",
               "_strongs": "02413"
            },
            {
               "strongs": "2414",
               "greek": [
                  {
                     "_BETA": "*(IEROSO/LUMA",
                     "_unicode": "Ἱεροσόλυμα",
                     "_translit": "Hierosólyma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-os-ol'-oo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03389"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Hierosolyma (i.e. Jerushalaim), the capitol\n of Palestine",
               "kjv_def": ":--Jerusalem.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2419"
                  }
               ],
               "_strongs": "02414",
               "__text": "Compare \n."
            },
            {
               "strongs": "2415",
               "greek": [
                  {
                     "_BETA": "*(IEROSOLUMI/THS",
                     "_unicode": "Ἱεροσολυμίτης",
                     "_translit": "Hierosolymítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-os-ol-oo-mee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2414"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Hierosolymite, i.e. inhabitant of Hierosolyma",
               "kjv_def": ":--of\n Jerusalem.",
               "_strongs": "02415"
            },
            {
               "strongs": "2416",
               "greek": [
                  {
                     "_BETA": "I(EROSULE/W",
                     "_unicode": "ἱεροσυλέω",
                     "_translit": "hierosyléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-os-ool-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2417"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a temple-robber (figuratively)",
               "kjv_def": ":--commit sacrilege.",
               "_strongs": "02416"
            },
            {
               "strongs": "2417",
               "greek": [
                  {
                     "_BETA": "I(ERO/SULOS",
                     "_unicode": "ἱερόσυλος",
                     "_translit": "hierósylos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-os'-oo-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2411"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4813"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a temple-despoiler",
               "kjv_def": ":--robber of churches.",
               "_strongs": "02417"
            },
            {
               "strongs": "2418",
               "greek": [
                  {
                     "_BETA": "I(EROURGE/W",
                     "_unicode": "ἱερουργέω",
                     "_translit": "hierourgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-oorg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2411"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n;"
               },
               "strongs_def": "to be a temple-worker,\n i.e. officiate as a priest (figuratively)",
               "kjv_def": ":--minister.",
               "_strongs": "02418"
            },
            {
               "strongs": "2419",
               "greek": [
                  {
                     "_BETA": "*(IEROUSALH/M",
                     "_unicode": "Ἱερουσαλήμ",
                     "_translit": "Hierousalḗm"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-oo-sal-ame'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03389"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Hierusalem (i.e. Jerushalem), the capitol of\n Palestine",
               "kjv_def": ":--Jerusalem.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2414"
                  }
               ],
               "_strongs": "02419",
               "__text": "Compare \n."
            },
            {
               "strongs": "2420",
               "greek": [
                  {
                     "_BETA": "I(ERWSU/NH",
                     "_unicode": "ἱερωσύνη",
                     "_translit": "hierōsýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-er-o-soo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2413"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sacredness, i.e. (by implication) the priestly\n office",
               "kjv_def": ":--priesthood.",
               "_strongs": "02420"
            },
            {
               "strongs": "2421",
               "greek": [
                  {
                     "_BETA": "*)IESSAI/",
                     "_unicode": "Ἰεσσαί",
                     "_translit": "Iessaí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "es-es-sah'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03448"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jessæ (i.e. Jishai), an Israelite",
               "kjv_def": ":--Jesse.",
               "_strongs": "02421"
            },
            {
               "strongs": "2422",
               "greek": [
                  {
                     "_BETA": "*)IEFQA/E",
                     "_unicode": "Ἰεφθάε",
                     "_translit": "Iephtháe"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ef-thah'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03316"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jephthaë (i.e. Jiphtach), an\n Israelite",
               "kjv_def": ":--Jephthah.",
               "_strongs": "02422"
            },
            {
               "strongs": "2423",
               "greek": [
                  {
                     "_BETA": "*)IEXONI/AS",
                     "_unicode": "Ἰεχονίας",
                     "_translit": "Iechonías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ekh-on-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03204"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jechonias (i.e. Jekonjah), an\n Israelite",
               "kjv_def": ":--Jechonias.",
               "_strongs": "02423"
            },
            {
               "strongs": "2424",
               "greek": [
                  {
                     "_BETA": "*)IHSOU=S",
                     "_unicode": "Ἰησοῦς",
                     "_translit": "Iēsoûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ay-sooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03091"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jesus (i.e. Jehoshua), the name of our Lord\n and two (three) other Israelites",
               "kjv_def": ":--Jesus.",
               "_strongs": "02424"
            },
            {
               "strongs": "2425",
               "greek": [
                  {
                     "_BETA": "I(KANO/S",
                     "_unicode": "ἱκανός",
                     "_translit": "hikanós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hik-an-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "I(/KW",
                        "_unicode": "ἵκω",
                        "_translit": "híkō"
                     },
                     {
                        "_BETA": "I(KA/NW",
                        "_unicode": "ἱκάνω",
                        "_translit": "hikánō"
                     },
                     {
                        "_BETA": "I(KNE/OMAI",
                        "_unicode": "ἱκνέομαι",
                        "_translit": "hiknéomai"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2240"
                     }
                  ],
                  "__text": "from \n (\n or \n, akin to \n) (to arrive);"
               },
               "strongs_def": "competent\n (as if coming in season), i.e. ample (in amount) or fit (in\n character)",
               "kjv_def": ":--able, + content, enough, good, great, large, long\n (while), many, meet, much, security, sore, sufficient, worthy.",
               "_strongs": "02425"
            },
            {
               "strongs": "2426",
               "greek": [
                  {
                     "_BETA": "I(KANO/THS",
                     "_unicode": "ἱκανότης",
                     "_translit": "hikanótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hik-an-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2425"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "ability",
               "kjv_def": ":--sufficiency.",
               "_strongs": "02426"
            },
            {
               "strongs": "2427",
               "greek": [
                  {
                     "_BETA": "I(KANO/W",
                     "_unicode": "ἱκανόω",
                     "_translit": "hikanóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hik-an-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2425"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to enable, i.e. qualify",
               "kjv_def": ":--make able (meet).",
               "_strongs": "02427"
            },
            {
               "strongs": "2428",
               "greek": [
                  {
                     "_BETA": "I(KETHRI/A",
                     "_unicode": "ἱκετηρία",
                     "_translit": "hiketēría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hik-et-ay-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2425"
                     }
                  ],
                  "__text": "from a derivative of the base of \n (through the idea of approaching\n for a favor);"
               },
               "strongs_def": "intreaty",
               "kjv_def": ":--supplication.",
               "_strongs": "02428"
            },
            {
               "strongs": "2429",
               "greek": [
                  {
                     "_BETA": "I(KMA/S",
                     "_unicode": "ἱκμάς",
                     "_translit": "hikmás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hik-mas'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "dampness",
               "kjv_def": ":--moisture.",
               "_strongs": "02429"
            },
            {
               "strongs": "2430",
               "greek": [
                  {
                     "_BETA": "*)IKO/NION",
                     "_unicode": "Ἰκόνιον",
                     "_translit": "Ikónion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-kon'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1504"
                     }
                  ],
                  "__text": "perhaps from \n;"
               },
               "strongs_def": "image-like; Iconium, a place in Asia\n Minor",
               "kjv_def": ":--Iconium.",
               "_strongs": "02430"
            },
            {
               "strongs": "2431",
               "greek": [
                  {
                     "_BETA": "I(LARO/S",
                     "_unicode": "ἱλαρός",
                     "_translit": "hilarós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hil-ar-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2436"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "propitious or merry (\"hilarious\"), i.e. prompt\n or willing",
               "kjv_def": ":--cheerful.",
               "_strongs": "02431"
            },
            {
               "strongs": "2432",
               "greek": [
                  {
                     "_BETA": "I(LARO/THS",
                     "_unicode": "ἱλαρότης",
                     "_translit": "hilarótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hil-ar-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2431"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "alacrity",
               "kjv_def": ":--cheerfulness.",
               "_strongs": "02432"
            },
            {
               "strongs": "2433",
               "greek": [
                  {
                     "_BETA": "I(LA/SKOMAI",
                     "_unicode": "ἱλάσκομαι",
                     "_translit": "hiláskomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hil-as'-kom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2436"
                     }
                  ],
                  "__text": "middle voice from the same as \n;"
               },
               "strongs_def": "to conciliate, i.e. (transitively)\n to atone for (sin), or (intransitively) be propitious",
               "kjv_def": ":--be merciful,\n make reconciliation for.",
               "_strongs": "02433"
            },
            {
               "strongs": "2434",
               "greek": [
                  {
                     "_BETA": "I(LASMO/S",
                     "_unicode": "ἱλασμός",
                     "_translit": "hilasmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hil-as-mos'"
                  }
               ],
               "strongs_def": "atonement, i.e. (concretely) an expiator",
               "kjv_def": ":--propitiation.",
               "_strongs": "02434"
            },
            {
               "strongs": "2435",
               "greek": [
                  {
                     "_BETA": "I(LASTH/RION",
                     "_unicode": "ἱλαστήριον",
                     "_translit": "hilastḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hil-as-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2433"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "an expiatory (place or thing), i.e.\n (concretely) an atoning victim, or (specially) the lid of the Ark (in\n the Temple)",
               "kjv_def": ":--mercyseat, propitiation.",
               "_strongs": "02435"
            },
            {
               "strongs": "2436",
               "greek": [
                  {
                     "_BETA": "I(/LEWS",
                     "_unicode": "ἵλεως",
                     "_translit": "híleōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hil'-eh-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "perhaps from the alternate form of \n;"
               },
               "strongs_def": "cheerful (as attractive), i.e.\n propitious; adverbially (by Hebraism) God be gracious!, i.e. (in\n averting some calamity) far be it",
               "kjv_def": ":--be it far, merciful.",
               "_strongs": "02436"
            },
            {
               "strongs": "2437",
               "greek": [
                  {
                     "_BETA": "*)ILLURIKO/N",
                     "_unicode": "Ἰλλυρικόν",
                     "_translit": "Illyrikón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "il-loo-ree-kon'"
                  }
               ],
               "strongs_derivation": "neuter of an adjective from a name of uncertain derivation;",
               "strongs_def": "(the)\n Illyrican (shore), i.e. (as a name itself) Illyricum, a region of\n Europe",
               "kjv_def": ":--Illyricum.",
               "_strongs": "02437"
            },
            {
               "strongs": "2438",
               "greek": [
                  {
                     "_BETA": "I(MA/S",
                     "_unicode": "ἱμάς",
                     "_translit": "himás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hee-mas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "260"
                     }
                  ],
                  "__text": "perhaps from the same as \n;"
               },
               "strongs_def": "a strap, i.e. (specially) the tie (of a\n sandal) or the lash (of a scourge)",
               "kjv_def": ":--latchet, thong.",
               "_strongs": "02438"
            },
            {
               "strongs": "2439",
               "greek": [
                  {
                     "_BETA": "I(MATI/ZW",
                     "_unicode": "ἱματίζω",
                     "_translit": "himatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "him-at-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2440"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to dress",
               "kjv_def": ":--clothe.",
               "_strongs": "02439"
            },
            {
               "strongs": "2440",
               "greek": [
                  {
                     "_BETA": "I(MA/TION",
                     "_unicode": "ἱμάτιον",
                     "_translit": "himátion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "him-at'-ee-on"
                  }
               ],
               "strongs_derivation": "neuter of a presumed derivative of ennumi (to put on);",
               "strongs_def": "a dress (inner\n or outer)",
               "kjv_def": ":--apparel, cloke, clothes, garment, raiment, robe, vesture.",
               "_strongs": "02440"
            },
            {
               "strongs": "2441",
               "greek": [
                  {
                     "_BETA": "I(MATISMO/S",
                     "_unicode": "ἱματισμός",
                     "_translit": "himatismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "him-at-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2439"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "clothing",
               "kjv_def": ":--apparel (X -led), array, raiment, vesture.",
               "_strongs": "02441"
            },
            {
               "strongs": "2442",
               "greek": [
                  {
                     "_BETA": "I(MEI/ROMAI",
                     "_unicode": "ἱμείρομαι",
                     "_translit": "himeíromai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "him-i'-rom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "I(/MEROS",
                        "_unicode": "ἵμερος",
                        "_translit": "hímeros"
                     }
                  ],
                  "__text": "middle voice from \n (a yearning;"
               },
               "strongs_def": "of uncertain affinity); to long\n for",
               "kjv_def": ":--be affectionately desirous.",
               "_strongs": "02442"
            },
            {
               "strongs": "2443",
               "greek": [
                  {
                     "_BETA": "I(/NA",
                     "_unicode": "ἵνα",
                     "_translit": "hína"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hin'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1438"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     }
                  ],
                  "__text": "probably from the same as the former part of \n (through the\n demonstrative idea; compare \n);"
               },
               "strongs_def": "in order that (denoting the purpose\n or the result)",
               "kjv_def": ":--albeit, because, to the intent (that), lest, so as,\n (so) that, (for) to.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3363"
                  }
               ],
               "_strongs": "02443",
               "__text": "Compare \n."
            },
            {
               "strongs": "2444",
               "greek": [
                  {
                     "_BETA": "I(NATI/",
                     "_unicode": "ἱνατί",
                     "_translit": "hinatí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hin-at-ee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2443"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5101"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "for what reason ?, i.e. why?",
               "kjv_def": ":--wherefore, why.",
               "_strongs": "02444"
            },
            {
               "strongs": "2445",
               "greek": [
                  {
                     "_BETA": "*)IO/PPH",
                     "_unicode": "Ἰόππη",
                     "_translit": "Ióppē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-op'-pay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03305"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Joppe (i.e. Japho), a place in\n Palestine",
               "kjv_def": ":--Joppa.",
               "_strongs": "02445"
            },
            {
               "strongs": "2446",
               "greek": [
                  {
                     "_BETA": "*)IORDA/NHS",
                     "_unicode": "Ἰορδάνης",
                     "_translit": "Iordánēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-or-dan'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03383"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "the Jordanes (i.e. Jarden), a river of\n Palestine",
               "kjv_def": ":--Jordan.",
               "_strongs": "02446"
            },
            {
               "strongs": "2447",
               "greek": [
                  {
                     "_BETA": "I)O/S",
                     "_unicode": "ἰός",
                     "_translit": "iós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     },
                     {
                        "_BETA": "I(/HMI",
                        "_unicode": "ἵημι",
                        "_translit": "híēmi"
                     }
                  ],
                  "__text": "perhaps from \n (to go) or \n (to send);"
               },
               "strongs_def": "rust (as if emitted by\n metals); also venom (as emitted by serpents)",
               "kjv_def": ":--poison, rust.",
               "_strongs": "02447"
            },
            {
               "strongs": "2448",
               "greek": [
                  {
                     "_BETA": "*)IOUDA/",
                     "_unicode": "Ἰουδά",
                     "_translit": "Ioudá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-dah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03063"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "03194"
                     }
                  ],
                  "__text": "of Hebrew origin (\n or perhaps \n);"
               },
               "strongs_def": "Judah (i.e. Jehudah or\n Juttah), a part of (or place in) Palestine",
               "kjv_def": ":--Judah.",
               "_strongs": "02448"
            },
            {
               "strongs": "2449",
               "greek": [
                  {
                     "_BETA": "*)IOUDAI/A",
                     "_unicode": "Ἰουδαία",
                     "_translit": "Ioudaía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-dah'-yah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2453"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1093"
                     }
                  ],
                  "__text": "feminine of \n (with \n implied);"
               },
               "strongs_def": "the Judæan land (i.e. Judæa),\n a region of Palestine",
               "kjv_def": ":--Judæa.",
               "_strongs": "02449"
            },
            {
               "strongs": "2450",
               "greek": [
                  {
                     "_BETA": "*)IOUDAI/+ZW",
                     "_unicode": "Ἰουδαΐζω",
                     "_translit": "Ioudaḯzō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-dah-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2453"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to become a Judæan, i.e. \"Judaize\"",
               "kjv_def": ":--live as the Jews.",
               "_strongs": "02450"
            },
            {
               "strongs": "2451",
               "greek": [
                  {
                     "_BETA": "*)IOUDAI+KO/S",
                     "_unicode": "Ἰουδαϊκός",
                     "_translit": "Ioudaïkós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-dah-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2453"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Judaïc, i.e. resembling a Judæan",
               "kjv_def": ":--Jewish.",
               "_strongs": "02451"
            },
            {
               "strongs": "2452",
               "greek": [
                  {
                     "_BETA": "*)IOUDAI+KW=S",
                     "_unicode": "Ἰουδαϊκῶς",
                     "_translit": "Ioudaïkōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-dah-ee-koce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2451"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "Judaïcally or in a manner resembling a Judæan",
               "kjv_def": ":--as\n do the Jews.",
               "_strongs": "02452"
            },
            {
               "strongs": "2453",
               "greek": [
                  {
                     "_BETA": "*)IOUDAI=OS",
                     "_unicode": "Ἰουδαῖος",
                     "_translit": "Ioudaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-dah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2448"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2455"
                     }
                  ],
                  "__text": "from \n (in the sense of \n as a country);"
               },
               "strongs_def": "Judæan, i.e. belonging\n to Jehudah",
               "kjv_def": ":--Jew(-ess), of Judæa.",
               "_strongs": "02453"
            },
            {
               "strongs": "2454",
               "greek": [
                  {
                     "_BETA": "*)IOUDAI+SMO/S",
                     "_unicode": "Ἰουδαϊσμός",
                     "_translit": "Ioudaïsmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-dah-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2450"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "\"Judaism\", i.e. the Jewish faith and usages",
               "kjv_def": ":--Jews'\n religion.",
               "_strongs": "02454"
            },
            {
               "strongs": "2455",
               "greek": [
                  {
                     "_BETA": "*)IOU/DAS",
                     "_unicode": "Ἰούδας",
                     "_translit": "Ioúdas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-das'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03063"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Judas (i.e. Jehudah), the name of ten\n Israelites; also of the posterity of one of them and its\n region",
               "kjv_def": ":--Juda(-h, -s); Jude.",
               "_strongs": "02455"
            },
            {
               "strongs": "2456",
               "greek": [
                  {
                     "_BETA": "*)IOULI/A",
                     "_unicode": "Ἰουλία",
                     "_translit": "Ioulía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-lee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2457"
                     }
                  ],
                  "__text": "feminine of the same as \n;"
               },
               "strongs_def": "Julia, a Christian woman",
               "kjv_def": ":--Julia.",
               "_strongs": "02456"
            },
            {
               "strongs": "2457",
               "greek": [
                  {
                     "_BETA": "*)IOU/LIOS",
                     "_unicode": "Ἰούλιος",
                     "_translit": "Ioúlios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo'-lee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Julius, a centurion",
               "kjv_def": ":--Julius.",
               "_strongs": "02457"
            },
            {
               "strongs": "2458",
               "greek": [
                  {
                     "_BETA": "*)IOUNIA=S",
                     "_unicode": "Ἰουνιᾶς",
                     "_translit": "Iouniâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-oo-nee'-as"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Junias, a Christian",
               "kjv_def": ":--Junias.",
               "_strongs": "02458"
            },
            {
               "strongs": "2459",
               "greek": [
                  {
                     "_BETA": "*)IOU=STOS",
                     "_unicode": "Ἰοῦστος",
                     "_translit": "Ioûstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-ooce'-tos"
                  }
               ],
               "strongs_derivation": "of Latin origin (\"just\");",
               "strongs_def": "Justus, the name of three\n Christian",
               "kjv_def": ":--Justus.",
               "_strongs": "02459"
            },
            {
               "strongs": "2460",
               "greek": [
                  {
                     "_BETA": "I(PPEU/S",
                     "_unicode": "ἱππεύς",
                     "_translit": "hippeús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hip-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2462"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an equestrian, i.e. member of a cavalry corps",
               "kjv_def": ":--horseman.",
               "_strongs": "02460"
            },
            {
               "strongs": "2461",
               "greek": [
                  {
                     "_BETA": "I(PPIKO/N",
                     "_unicode": "ἱππικόν",
                     "_translit": "hippikón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hip-pee-kon'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2462"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "the cavalry force",
               "kjv_def": ":--horse(-men).",
               "_strongs": "02461"
            },
            {
               "strongs": "2462",
               "greek": [
                  {
                     "_BETA": "I(/PPOS",
                     "_unicode": "ἵππος",
                     "_translit": "híppos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hip'-pos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a horse",
               "kjv_def": ":--horse.",
               "_strongs": "02462"
            },
            {
               "strongs": "2463",
               "greek": [
                  {
                     "_BETA": "I)=RIS",
                     "_unicode": "ἶρις",
                     "_translit": "îris"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee'-ris"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2046"
                     }
                  ],
                  "__text": "perhaps from \n (as a symbol of the female messenger of the pagan\n deities);"
               },
               "strongs_def": "a rainbow (\"iris\")",
               "kjv_def": ":--rainbow.",
               "_strongs": "02463"
            },
            {
               "strongs": "2464",
               "greek": [
                  {
                     "_BETA": "*)ISAA/K",
                     "_unicode": "Ἰσαάκ",
                     "_translit": "Isaák"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-sah-ak'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03327"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Isaac (i.e. Jitschak), the son of\n Abraham",
               "kjv_def": ":--Isaac.",
               "_strongs": "02464"
            },
            {
               "strongs": "2465",
               "greek": [
                  {
                     "_BETA": "I)SA/GGELOS",
                     "_unicode": "ἰσάγγελος",
                     "_translit": "isángelos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-sang'-el-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2470"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "like an angel, i.e. angelic",
               "kjv_def": ":--equal unto the angels.",
               "_strongs": "02465"
            },
            {
               "strongs": "2466",
               "greek": [
                  {
                     "_BETA": "*)ISAXA/R",
                     "_unicode": "Ἰσαχάρ",
                     "_translit": "Isachár"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-sakh-ar'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03485"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Isachar (i.e. Jissaskar), a son of Jacob\n (figuratively, his descendant)",
               "kjv_def": ":--Issachar.",
               "_strongs": "02466"
            },
            {
               "strongs": "2467",
               "greek": [
                  {
                     "_BETA": "I)/SHMI",
                     "_unicode": "ἴσημι",
                     "_translit": "ísēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "is'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "assumed by some as the base of certain irregular forms of \n;"
               },
               "strongs_def": "to\n know",
               "kjv_def": ":--know.",
               "_strongs": "02467"
            },
            {
               "strongs": "2468",
               "greek": [
                  {
                     "_BETA": "I)/SQI",
                     "_unicode": "ἴσθι",
                     "_translit": "ísthi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "is'-thee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "second person imperative present of \n;"
               },
               "strongs_def": "be thou",
               "kjv_def": ":--+ agree, be, X\n give thyself wholly to.",
               "_strongs": "02468"
            },
            {
               "strongs": "2469",
               "greek": [
                  {
                     "_BETA": "*)ISKARIW/THS",
                     "_unicode": "Ἰσκαριώτης",
                     "_translit": "Iskariṓtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "is-kar-ee-o'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0377"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "07149"
                     }
                  ],
                  "__text": "of Hebrew origin (probably \n and \n);"
               },
               "strongs_def": "inhabitant of Kerioth;\n Iscariotes (i.e. Keriothite), an epithet of Judas the\n traitor",
               "kjv_def": ":--Iscariot.",
               "_strongs": "02469"
            },
            {
               "strongs": "2470",
               "greek": [
                  {
                     "_BETA": "I)/SOS",
                     "_unicode": "ἴσος",
                     "_translit": "ísos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee'-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "probably from \n (through the idea of seeming);"
               },
               "strongs_def": "similar (in amount\n and kind)",
               "kjv_def": ":--+ agree, as much, equal, like.",
               "_strongs": "02470"
            },
            {
               "strongs": "2471",
               "greek": [
                  {
                     "_BETA": "I)SO/THS",
                     "_unicode": "ἰσότης",
                     "_translit": "isótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-sot'-ace"
                  }
               ],
               "strongs_def": "likeness (in condition or proportion); by implication,\n equity",
               "kjv_def": ":--equal(-ity).",
               "_strongs": "02471"
            },
            {
               "strongs": "2472",
               "greek": [
                  {
                     "_BETA": "I)SO/TIMOS",
                     "_unicode": "ἰσότιμος",
                     "_translit": "isótimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-sot'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2470"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "of equal value or honor",
               "kjv_def": ":--like precious.",
               "_strongs": "02472"
            },
            {
               "strongs": "2473",
               "greek": [
                  {
                     "_BETA": "I)SO/YUXOS",
                     "_unicode": "ἰσόψυχος",
                     "_translit": "isópsychos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-sop'-soo-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2470"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5590"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "of similar spirit",
               "kjv_def": ":--likeminded.",
               "_strongs": "02473"
            },
            {
               "strongs": "2474",
               "greek": [
                  {
                     "_BETA": "*)ISRAH/L",
                     "_unicode": "Ἰσραήλ",
                     "_translit": "Israḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "is-rah-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03478"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Israel (i.e. Jisrael), the adopted name of\n Jacob, including his descendants (literally or figuratively)",
               "kjv_def": ":--Israel.",
               "_strongs": "02474"
            },
            {
               "strongs": "2475",
               "greek": [
                  {
                     "_BETA": "*)ISRAHLI/THS",
                     "_unicode": "Ἰσραηλίτης",
                     "_translit": "Israēlítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "is-rah-ale-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2474"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an \"Israelite\", i.e. descendant of Israel (literally or\n figuratively)",
               "kjv_def": ":--Israelite.",
               "_strongs": "02475"
            },
            {
               "strongs": "2476",
               "greek": [
                  {
                     "_BETA": "I(/STHMI",
                     "_unicode": "ἵστημι",
                     "_translit": "hístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "his'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STA/W",
                        "_unicode": "στάω",
                        "_translit": "stáō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "stah'-o"
                     }
                  ],
                  "__text": "a prolonged form of a primary \n \n (of the same meaning, and\n used for it in certain tenses);"
               },
               "strongs_def": "to stand (transitively or\n intransitively), used in various applications (literally or\n figuratively)",
               "kjv_def": ":--abide, appoint, bring, continue, covenant, establish,\n hold up, lay, present, set (up), stanch, stand (by, forth, still, up).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5087"
                  }
               ],
               "_strongs": "02476",
               "__text": "Compare \n."
            },
            {
               "strongs": "2477",
               "greek": [
                  {
                     "_BETA": "I(STORE/W",
                     "_unicode": "ἱστορέω",
                     "_translit": "historéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "his-tor-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to be knowing (learned), i.e. (by\n implication) to visit for information (interview)",
               "kjv_def": ":--see.",
               "_strongs": "02477"
            },
            {
               "strongs": "2478",
               "greek": [
                  {
                     "_BETA": "I)SXURO/S",
                     "_unicode": "ἰσχυρός",
                     "_translit": "ischyrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "is-khoo-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2479"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "forcible (literally or figuratively)",
               "kjv_def": ":--boisterous,\n mighty(-ier), powerful, strong(-er, man), valiant.",
               "_strongs": "02478"
            },
            {
               "strongs": "2479",
               "greek": [
                  {
                     "_BETA": "I)SXU/S",
                     "_unicode": "ἰσχύς",
                     "_translit": "ischýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "is-khoos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "I)S",
                        "_unicode": "ἰς",
                        "_translit": "is"
                     }
                  ],
                  "__text": "from a derivative of \n (force;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "E)/SXON",
                        "_unicode": "ἔσχον",
                        "_translit": "éschon"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "compare \n, a form of \n);\n forcefulness (literally or figuratively)"
               },
               "kjv_def": ":--ability, might(-ily),\n power, strength.",
               "_strongs": "02479"
            },
            {
               "strongs": "2480",
               "greek": [
                  {
                     "_BETA": "I)SXU/W",
                     "_unicode": "ἰσχύω",
                     "_translit": "ischýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "is-khoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2479"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to have (or exercise) force (literally or\n figuratively)",
               "kjv_def": ":--be able, avail, can do(-not), could, be good, might,\n prevail, be of strength, be whole, + much work.",
               "_strongs": "02480"
            },
            {
               "strongs": "2481",
               "greek": [
                  {
                     "_BETA": "I)/SWS",
                     "_unicode": "ἴσως",
                     "_translit": "ísōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee'-soce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2470"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "likely, i.e. perhaps",
               "kjv_def": ":--it may be.",
               "_strongs": "02481"
            },
            {
               "strongs": "2482",
               "greek": [
                  {
                     "_BETA": "*)ITALI/A",
                     "_unicode": "Ἰταλία",
                     "_translit": "Italía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-tal-ee'-ah"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Italia, a region of Europe",
               "kjv_def": ":--Italy.",
               "_strongs": "02482"
            },
            {
               "strongs": "2483",
               "greek": [
                  {
                     "_BETA": "*)ITALIKO/S",
                     "_unicode": "Ἰταλικός",
                     "_translit": "Italikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-tal-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2482"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Italic, i.e. belonging to Italia",
               "kjv_def": ":--Italian.",
               "_strongs": "02483"
            },
            {
               "strongs": "2484",
               "greek": [
                  {
                     "_BETA": "*)ITOURAI/+A",
                     "_unicode": "Ἰτουραΐα",
                     "_translit": "Itouraḯa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-too-rah'-yah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03195"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Ituræa (i.e. Jetur), a region of\n Palestine",
               "kjv_def": ":--Ituræa.",
               "_strongs": "02484"
            },
            {
               "strongs": "2485",
               "greek": [
                  {
                     "_BETA": "I)XQU/DION",
                     "_unicode": "ἰχθύδιον",
                     "_translit": "ichthýdion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ikh-thoo'-dee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2486"
                     }
                  ],
                  "__text": "diminutive from \n;"
               },
               "strongs_def": "a petty fish",
               "kjv_def": ":--little (small) fish.",
               "_strongs": "02485"
            },
            {
               "strongs": "2486",
               "greek": [
                  {
                     "_BETA": "I)XQU/S",
                     "_unicode": "ἰχθύς",
                     "_translit": "ichthýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ikh-thoos'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a fish",
               "kjv_def": ":--fish.",
               "_strongs": "02486"
            },
            {
               "strongs": "2487",
               "greek": [
                  {
                     "_BETA": "I)/XNOS",
                     "_unicode": "ἴχνος",
                     "_translit": "íchnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ikh'-nos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "I)KNE/OMAI",
                        "_unicode": "ἰκνέομαι",
                        "_translit": "iknéomai"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2240"
                     }
                  ],
                  "__text": "from \n (to arrive; compare \n);"
               },
               "strongs_def": "a track\n (figuratively)",
               "kjv_def": ":--step.",
               "_strongs": "02487"
            },
            {
               "strongs": "2488",
               "greek": [
                  {
                     "_BETA": "*)IWA/QAM",
                     "_unicode": "Ἰωάθαμ",
                     "_translit": "Iōátham"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-ath'-am"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03147"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Joatham (i.e. Jotham), an\n Israelite",
               "kjv_def": ":--Joatham.",
               "_strongs": "02488"
            },
            {
               "strongs": "2489",
               "greek": [
                  {
                     "_BETA": "*)IWA/NNA",
                     "_unicode": "Ἰωάννα",
                     "_translit": "Iōánna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-an'-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2491"
                     }
                  ],
                  "__text": "feminine of the same as \n;"
               },
               "strongs_def": "Joanna, a Christian",
               "kjv_def": ":--Joanna.",
               "_strongs": "02489"
            },
            {
               "strongs": "2490",
               "greek": [
                  {
                     "_BETA": "*)IWANNA=S",
                     "_unicode": "Ἰωαννᾶς",
                     "_translit": "Iōannâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-an-nas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2491"
                     }
                  ],
                  "__text": "a form of \n;"
               },
               "strongs_def": "Joannas, an Israelite",
               "kjv_def": ":--Joannas.",
               "_strongs": "02490"
            },
            {
               "strongs": "2491",
               "greek": [
                  {
                     "_BETA": "*)IWA/NNHS",
                     "_unicode": "Ἰωάννης",
                     "_translit": "Iōánnēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-an'-nace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03110"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Joannes (i.e. Jochanan), the name of four\n Israelites",
               "kjv_def": ":--John.",
               "_strongs": "02491"
            },
            {
               "strongs": "2492",
               "greek": [
                  {
                     "_BETA": "*)IW/B",
                     "_unicode": "Ἰώβ",
                     "_translit": "Iṓb"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-obe'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0347"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Job (i.e. Ijob), a patriarch",
               "kjv_def": ":--Job.",
               "_strongs": "02492"
            },
            {
               "strongs": "2493",
               "greek": [
                  {
                     "_BETA": "*)IWH/L",
                     "_unicode": "Ἰωήλ",
                     "_translit": "Iōḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03100"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Joel, an Israelite",
               "kjv_def": ":--Joel.",
               "_strongs": "02493"
            },
            {
               "strongs": "2494",
               "greek": [
                  {
                     "_BETA": "*)IWNA/N",
                     "_unicode": "Ἰωνάν",
                     "_translit": "Iōnán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-nan'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2491"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2495"
                     }
                  ],
                  "__text": "probably for \n or \n;"
               },
               "strongs_def": "Jonan, an Israelite",
               "kjv_def": ":--Jonan.",
               "_strongs": "02494"
            },
            {
               "strongs": "2495",
               "greek": [
                  {
                     "_BETA": "*)IWNA=S",
                     "_unicode": "Ἰωνᾶς",
                     "_translit": "Iōnâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-nas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03124"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Jonas (i.e. Jonah), the name of two\n Israelites",
               "kjv_def": ":--Jonas.",
               "_strongs": "02495"
            },
            {
               "strongs": "2496",
               "greek": [
                  {
                     "_BETA": "*)IWRA/M",
                     "_unicode": "Ἰωράμ",
                     "_translit": "Iōrám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-ram'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03141"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Joram, an Israelite",
               "kjv_def": ":--Joram.",
               "_strongs": "02496"
            },
            {
               "strongs": "2497",
               "greek": [
                  {
                     "_BETA": "*)IWREI/M",
                     "_unicode": "Ἰωρείμ",
                     "_translit": "Iōreím"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-rime'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2496"
                     }
                  ],
                  "__text": "perhaps for \n;"
               },
               "strongs_def": "Jorim, an Israelite",
               "kjv_def": ":--Jorim.",
               "_strongs": "02497"
            },
            {
               "strongs": "2498",
               "greek": [
                  {
                     "_BETA": "*)IWSAFA/T",
                     "_unicode": "Ἰωσαφάτ",
                     "_translit": "Iōsaphát"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-saf-at'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03092"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Josaphat (i.e. Jehoshaphat), an\n Israelite",
               "kjv_def": ":--Josaphat.",
               "_strongs": "02498"
            },
            {
               "strongs": "2499",
               "greek": [
                  {
                     "_BETA": "*)IWSH/",
                     "_unicode": "Ἰωσή",
                     "_translit": "Iōsḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-say'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2500"
                     }
                  ],
                  "__text": "genitive case of \n;"
               },
               "strongs_def": "Jose, an Israelite",
               "kjv_def": ":--Jose.",
               "_strongs": "02499"
            },
            {
               "strongs": "2500",
               "greek": [
                  {
                     "_BETA": "*)IWSH=S",
                     "_unicode": "Ἰωσῆς",
                     "_translit": "Iōsēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-sace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2501"
                     }
                  ],
                  "__text": "perhaps for \n;"
               },
               "strongs_def": "Joses, the name of two Israelites",
               "kjv_def": ":--Joses.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2499"
                  }
               ],
               "_strongs": "02500",
               "__text": "Compare\n \n."
            },
            {
               "strongs": "2501",
               "greek": [
                  {
                     "_BETA": "*)IWSH/F",
                     "_unicode": "Ἰωσήφ",
                     "_translit": "Iōsḗph"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-safe'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03130"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Joseph, the name of seven\n Israelites",
               "kjv_def": ":--Joseph.",
               "_strongs": "02501"
            },
            {
               "strongs": "2502",
               "greek": [
                  {
                     "_BETA": "*)IWSI/AS",
                     "_unicode": "Ἰωσίας",
                     "_translit": "Iōsías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o-see'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02977"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Josias (i.e. Joshiah), an Israelite",
               "kjv_def": ":--Josias.",
               "_strongs": "02502"
            },
            {
               "strongs": "2503",
               "greek": [
                  {
                     "_BETA": "I)W=TA",
                     "_unicode": "ἰῶτα",
                     "_translit": "iōta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ee-o'-tah"
                  }
               ],
               "strongs_derivation": "of Hebrew origin (the tenth letter of the Hebrew alphabet);",
               "strongs_def": "\"iota\",\n the name of the eighth letter of the Greek alphabet, put\n (figuratively) for a very small part of anything",
               "kjv_def": ":--jot.",
               "_strongs": "02503"
            },
            {
               "strongs": "2504",
               "greek": [
                  {
                     "_BETA": "KA)GW/",
                     "_unicode": "κἀγώ",
                     "_translit": "kagṓ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kag-o'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1473"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "KA)MOI/",
                        "_unicode": "κἀμοί",
                        "_translit": "kamoí"
                     },
                     {
                        "_BETA": "KA)ME/",
                        "_unicode": "κἀμέ",
                        "_translit": "kamé"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "kam-oy'"
                     },
                     {
                        "_strongs": "kam-eh'"
                     }
                  ],
                  "__text": "so also the dative case\n  \n      \n  \n,  and accusative case\n      \n  \n\n       \n and (or also, even, etc.) I, (to) me"
               },
               "kjv_def": ":--(and, even, even so, so) I \n (also, in like wise), both me, me also.",
               "_strongs": "02504"
            },
            {
               "strongs": "2505",
               "greek": [
                  {
                     "_BETA": "KAQA/",
                     "_unicode": "καθά",
                     "_translit": "kathá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "from \n and the neuter plural of \n;"
               },
               "strongs_def": "according to which things,\n i.e. just as",
               "kjv_def": ":--as.",
               "_strongs": "02505"
            },
            {
               "strongs": "2506",
               "greek": [
                  {
                     "_BETA": "KAQAI/RESIS",
                     "_unicode": "καθαίρεσις",
                     "_translit": "kathaíresis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ah'-ee-res-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2507"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "demolition; figuratively, extinction",
               "kjv_def": ":--destruction, pulling\n down.",
               "_strongs": "02506"
            },
            {
               "strongs": "2507",
               "greek": [
                  {
                     "_BETA": "KAQAIRE/W",
                     "_unicode": "καθαιρέω",
                     "_translit": "kathairéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ahee-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to lower (or with\n violence) demolish (literally or figuratively)",
               "kjv_def": ":--cast (pull, put,\n take) down, destroy.",
               "_strongs": "02507"
            },
            {
               "strongs": "2508",
               "greek": [
                  {
                     "_BETA": "KAQAI/RW",
                     "_unicode": "καθαίρω",
                     "_translit": "kathaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ah'-ee-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2513"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to cleanse, i.e. (specially) to prune; figuratively, to\n expiate",
               "kjv_def": ":--purge.",
               "_strongs": "02508"
            },
            {
               "strongs": "2509",
               "greek": [
                  {
                     "_BETA": "KAQA/PER",
                     "_unicode": "καθάπερ",
                     "_translit": "katháper"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ap'-er"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2505"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "exactly as",
               "kjv_def": ":--(even, as well) as.",
               "_strongs": "02509"
            },
            {
               "strongs": "2510",
               "greek": [
                  {
                     "_BETA": "KAQA/PTW",
                     "_unicode": "καθάπτω",
                     "_translit": "katháptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "680"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to seize upon",
               "kjv_def": ":--fasten on.",
               "_strongs": "02510"
            },
            {
               "strongs": "2511",
               "greek": [
                  {
                     "_BETA": "KAQARI/ZW",
                     "_unicode": "καθαρίζω",
                     "_translit": "katharízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ar-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2513"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to cleanse (literally or figuratively)",
               "kjv_def": ":--(make) clean(-se),\n purge, purify.",
               "_strongs": "02511"
            },
            {
               "strongs": "2512",
               "greek": [
                  {
                     "_BETA": "KAQARISMO/S",
                     "_unicode": "καθαρισμός",
                     "_translit": "katharismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ar-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2511"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a washing off, i.e. (ceremonially) ablution, (morally)\n expiation",
               "kjv_def": ":--cleansing, + purge, purification(-fying).",
               "_strongs": "02512"
            },
            {
               "strongs": "2513",
               "greek": [
                  {
                     "_BETA": "KAQARO/S",
                     "_unicode": "καθαρός",
                     "_translit": "katharós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ar-os'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "clean (literally or figuratively)",
               "kjv_def": ":--clean,\n clear, pure.",
               "_strongs": "02513"
            },
            {
               "strongs": "2514",
               "greek": [
                  {
                     "_BETA": "KAQARO/THS",
                     "_unicode": "καθαρότης",
                     "_translit": "katharótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ar-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2513"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cleanness (ceremonially)",
               "kjv_def": ":--purification.",
               "_strongs": "02514"
            },
            {
               "strongs": "2515",
               "greek": [
                  {
                     "_BETA": "KAQE/DRA",
                     "_unicode": "καθέδρα",
                     "_translit": "kathédra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ed'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "from \n and the same as \n;"
               },
               "strongs_def": "a bench (literally or\n figuratively)",
               "kjv_def": ":--seat.",
               "_strongs": "02515"
            },
            {
               "strongs": "2516",
               "greek": [
                  {
                     "_BETA": "KAQE/ZOMAI",
                     "_unicode": "καθέζομαι",
                     "_translit": "kathézomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ed'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to sit down",
               "kjv_def": ":--sit.",
               "_strongs": "02516"
            },
            {
               "strongs": "2517",
               "greek": [
                  {
                     "_BETA": "KAQECH=S",
                     "_unicode": "καθεξῆς",
                     "_translit": "kathexēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ex-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1836"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "thereafter, i.e. consecutively; as a noun (by\n ellipsis of noun) a subsequent person or time",
               "kjv_def": ":--after(-ward), by (in)\n order.",
               "_strongs": "02517"
            },
            {
               "strongs": "2518",
               "greek": [
                  {
                     "_BETA": "KAQEU/DW",
                     "_unicode": "καθεύδω",
                     "_translit": "katheúdō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-yoo'-do"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EU(/DW",
                        "_unicode": "εὕδω",
                        "_translit": "heúdō"
                     }
                  ],
                  "__text": "from \n and \n (to sleep);"
               },
               "strongs_def": "to lie down to rest, i.e. (by\n implication) to fall asleep (literally or figuratively)",
               "kjv_def": ":--(be\n a-)sleep.",
               "_strongs": "02518"
            },
            {
               "strongs": "2519",
               "greek": [
                  {
                     "_BETA": "KAQHGHTH/S",
                     "_unicode": "καθηγητής",
                     "_translit": "kathēgētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ayg-ay-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2233"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a guide, i.e. (figuratively) a\n teacher",
               "kjv_def": ":--master.",
               "_strongs": "02519"
            },
            {
               "strongs": "2520",
               "greek": [
                  {
                     "_BETA": "KAQH/KW",
                     "_unicode": "καθήκω",
                     "_translit": "kathḗkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ay'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2240"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reach to, i.e. (neuter of present active\n participle, figuratively as adjective) becoming",
               "kjv_def": ":-- convenient, fit.",
               "_strongs": "02520"
            },
            {
               "strongs": "2521",
               "greek": [
                  {
                     "_BETA": "KA/QHMAI",
                     "_unicode": "κάθημαι",
                     "_translit": "káthēmai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath'-ay-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "H(=MAI",
                        "_unicode": "ἧμαι",
                        "_translit": "hēmai"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "and \n (to sit; akin to the base of \n); to sit down;\n figuratively, to remain, reside"
               },
               "kjv_def": ":--dwell, sit (by, down).",
               "_strongs": "02521"
            },
            {
               "strongs": "2522",
               "greek": [
                  {
                     "_BETA": "KAQHMERINO/S",
                     "_unicode": "καθημερινός",
                     "_translit": "kathēmerinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ay-mer-ee-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "quotidian",
               "kjv_def": ":--daily.",
               "_strongs": "02522"
            },
            {
               "strongs": "2523",
               "greek": [
                  {
                     "_BETA": "KAQI/ZW",
                     "_unicode": "καθίζω",
                     "_translit": "kathízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2516"
                     }
                  ],
                  "__text": "another (active) form for \n;"
               },
               "strongs_def": "to seat down, i.e. set (figuratively,\n appoint); intransitively, to sit (down); figuratively, to settle\n (hover, dwell)",
               "kjv_def": ":--continue, set, sit (down), tarry.",
               "_strongs": "02523"
            },
            {
               "strongs": "2524",
               "greek": [
                  {
                     "_BETA": "KAQI/HMI",
                     "_unicode": "καθίημι",
                     "_translit": "kathíēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ee'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "I(/HMI",
                        "_unicode": "ἵημι",
                        "_translit": "híēmi"
                     }
                  ],
                  "__text": "and \n (to send); to lower"
               },
               "kjv_def": ":--let down.",
               "_strongs": "02524"
            },
            {
               "strongs": "2525",
               "greek": [
                  {
                     "_BETA": "KAQI/STHMI",
                     "_unicode": "καθίστημι",
                     "_translit": "kathístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to place down (permanently), i.e. (figuratively)\n to designate, constitute, convoy",
               "kjv_def": ":--appoint, be, conduct, make, ordain,\n set.",
               "_strongs": "02525"
            },
            {
               "strongs": "2526",
               "greek": [
                  {
                     "_BETA": "KAQO/",
                     "_unicode": "καθό",
                     "_translit": "kathó"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-o'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "according to which thing, i.e. precisely as, in\n proportion as",
               "kjv_def": ":--according to that, (inasmuch) as.",
               "_strongs": "02526"
            },
            {
               "strongs": "2527",
               "greek": [
                  {
                     "_BETA": "KAQO/LOU",
                     "_unicode": "καθόλου",
                     "_translit": "kathólou"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ol'-oo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3650"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "on the whole, i.e. entirely",
               "kjv_def": ":--at all.",
               "_strongs": "02527"
            },
            {
               "strongs": "2528",
               "greek": [
                  {
                     "_BETA": "KAQOPLI/ZW",
                     "_unicode": "καθοπλίζω",
                     "_translit": "kathoplízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-op-lid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3695"
                     }
                  ],
                  "__text": "and \n; to equip fully with armor"
               },
               "kjv_def": ":--arm.",
               "_strongs": "02528"
            },
            {
               "strongs": "2529",
               "greek": [
                  {
                     "_BETA": "KAQORA/W",
                     "_unicode": "καθοράω",
                     "_translit": "kathoráō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-or-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to behold fully, i.e. (figuratively) distinctly\n apprehend",
               "kjv_def": ":--clearly see.",
               "_strongs": "02529"
            },
            {
               "strongs": "2530",
               "greek": [
                  {
                     "_BETA": "KAQO/TI",
                     "_unicode": "καθότι",
                     "_translit": "kathóti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-ot'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5100"
                     }
                  ],
                  "__text": "and \n and \n; according to which certain thing, i.e.\n as far (or inasmuch) as"
               },
               "kjv_def": ":--(according, forasmuch) as, because (that).",
               "_strongs": "02530"
            },
            {
               "strongs": "2531",
               "greek": [
                  {
                     "_BETA": "KAQW/S",
                     "_unicode": "καθώς",
                     "_translit": "kathṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kath-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5613"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "just (or inasmuch) as, that",
               "kjv_def": ":--according to,\n (according, even) as, how, when.",
               "_strongs": "02531"
            },
            {
               "strongs": "2532",
               "greek": [
                  {
                     "_BETA": "KAI/",
                     "_unicode": "καί",
                     "_translit": "kaí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kahee"
                  }
               ],
               "strongs_derivation": "apparently, a primary particle, having a copulative and sometimes also\n a cumulative force;",
               "strongs_def": "and, also, even, so then, too, etc.; often used in\n connection (or composition) with other particles or small words",
               "kjv_def": ":--and,\n also, both, but, even, for, if, or, so, that, then, therefore, when,\n yet.",
               "_strongs": "02532"
            },
            {
               "strongs": "2533",
               "greek": [
                  {
                     "_BETA": "*KAI+A/FAS",
                     "_unicode": "Καϊάφας",
                     "_translit": "Kaïáphas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah-ee-af'-as"
                  }
               ],
               "strongs_derivation": "of Chaldee origin;",
               "strongs_def": "the dell; Caiaphas (i.e. Cajepha), an\n Israelite",
               "kjv_def": ":--Caiaphas.",
               "_strongs": "02533"
            },
            {
               "strongs": "2534",
               "greek": [
                  {
                     "_BETA": "KAI/GE",
                     "_unicode": "καίγε",
                     "_translit": "kaíge"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah'-ee-gheh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1065"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "and at least (or even, indeed)",
               "kjv_def": ":--and, at least.",
               "_strongs": "02534"
            },
            {
               "strongs": "2535",
               "greek": [
                  {
                     "_BETA": "*KA/I+N",
                     "_unicode": "Κάϊν",
                     "_translit": "Káïn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah'-in"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07014"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Cain, (i.e. Cajin), the son of Adam",
               "kjv_def": ":--Cain.",
               "_strongs": "02535"
            },
            {
               "strongs": "2536",
               "greek": [
                  {
                     "_BETA": "*KAI+NA/N",
                     "_unicode": "Καϊνάν",
                     "_translit": "Kaïnán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah-ee-nan'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07018"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Cainan (i.e. Kenan), the name of two\n patriarchs",
               "kjv_def": ":--Cainan.",
               "_strongs": "02536"
            },
            {
               "strongs": "2537",
               "greek": [
                  {
                     "_BETA": "KAINO/S",
                     "_unicode": "καινός",
                     "_translit": "kainós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kahee-nos'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     }
                  ],
                  "__text": "new (especially in freshness; while \n is\n properly so with respect to age"
               },
               "kjv_def": ":--new.",
               "_strongs": "02537"
            },
            {
               "strongs": "2538",
               "greek": [
                  {
                     "_BETA": "KAINO/THS",
                     "_unicode": "καινότης",
                     "_translit": "kainótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kahee-not'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2537"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "renewal (figuratively)",
               "kjv_def": ":--newness.",
               "_strongs": "02538"
            },
            {
               "strongs": "2539",
               "greek": [
                  {
                     "_BETA": "KAI/PER",
                     "_unicode": "καίπερ",
                     "_translit": "kaíper"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah'-ee-per"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "and indeed, i.e. nevertheless or\n notwithstanding",
               "kjv_def": ":--and yet, although.",
               "_strongs": "02539"
            },
            {
               "strongs": "2540",
               "greek": [
                  {
                     "_BETA": "KAIRO/S",
                     "_unicode": "καιρός",
                     "_translit": "kairós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kahee-ros'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "an occasion, i.e. set or proper time",
               "kjv_def": ":--X\n always, opportunity, (convenient, due) season, (due, short, while)\n time, a while.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5550"
                  }
               ],
               "_strongs": "02540",
               "__text": "Compare \n."
            },
            {
               "strongs": "2541",
               "greek": [
                  {
                     "_BETA": "*KAI=SAR",
                     "_unicode": "Καῖσαρ",
                     "_translit": "Kaîsar"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah'-ee-sar"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Cæsar, a title of the Roman emperor",
               "kjv_def": ":--Cæsar.",
               "_strongs": "02541"
            },
            {
               "strongs": "2542",
               "greek": [
                  {
                     "_BETA": "*KAISA/REIA",
                     "_unicode": "Καισάρεια",
                     "_translit": "Kaisáreia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kahee-sar'-i-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2541"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Cæsaria, the name of two places in Palestine",
               "kjv_def": ":--Cæsarea.",
               "_strongs": "02542"
            },
            {
               "strongs": "2543",
               "greek": [
                  {
                     "_BETA": "KAI/TOI",
                     "_unicode": "καίτοι",
                     "_translit": "kaítoi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah'-ee-toy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5104"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "and yet, i.e. nevertheless",
               "kjv_def": ":--although.",
               "_strongs": "02543"
            },
            {
               "strongs": "2544",
               "greek": [
                  {
                     "_BETA": "KAI/TOIGE",
                     "_unicode": "καίτοιγε",
                     "_translit": "kaítoige"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah'-ee-toyg-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2543"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1065"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "and yet indeed, i.e. although\n really",
               "kjv_def": ":--nevertheless, though.",
               "_strongs": "02544"
            },
            {
               "strongs": "2545",
               "greek": [
                  {
                     "_BETA": "KAI/W",
                     "_unicode": "καίω",
                     "_translit": "kaíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kah'-yo"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to set on fire, i.e. kindle or (by\n implication) consume",
               "kjv_def": ":--burn, light.",
               "_strongs": "02545"
            },
            {
               "strongs": "2546",
               "greek": [
                  {
                     "_BETA": "KA)KEI=",
                     "_unicode": "κἀκεῖ",
                     "_translit": "kakeî"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-i'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1563"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "likewise in that place",
               "kjv_def": ":--and there, there\n (thither) also.",
               "_strongs": "02546"
            },
            {
               "strongs": "2547",
               "greek": [
                  {
                     "_BETA": "KA)KEI=QEN",
                     "_unicode": "κἀκεῖθεν",
                     "_translit": "kakeîthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-i'-then"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1564"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "likewise from that place (or time)",
               "kjv_def": ":--and afterward\n (from) (thence), thence also.",
               "_strongs": "02547"
            },
            {
               "strongs": "2548",
               "greek": [
                  {
                     "_BETA": "KA)KEI=NOS",
                     "_unicode": "κἀκεῖνος",
                     "_translit": "kakeînos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-i'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1565"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "likewise that (or those)",
               "kjv_def": ":--and him (other, them),\n even he, him also, them (also), (and) they.",
               "_strongs": "02548"
            },
            {
               "strongs": "2549",
               "greek": [
                  {
                     "_BETA": "KAKI/A",
                     "_unicode": "κακία",
                     "_translit": "kakía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "badness, i.e. (subjectively) depravity, or (actively)\n malignity, or (passively) trouble",
               "kjv_def": ":--evil, malice(-iousness),\n naughtiness, wickedness.",
               "_strongs": "02549"
            },
            {
               "strongs": "2550",
               "greek": [
                  {
                     "_BETA": "KAKOH/QEIA",
                     "_unicode": "κακοήθεια",
                     "_translit": "kakoḗtheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-o-ay'-thi-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2239"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "bad character, i.e. (specially)\n mischievousness",
               "kjv_def": ":--malignity.",
               "_strongs": "02550"
            },
            {
               "strongs": "2551",
               "greek": [
                  {
                     "_BETA": "KAKOLOGE/W",
                     "_unicode": "κακολογέω",
                     "_translit": "kakologéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-ol-og-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to revile",
               "kjv_def": ":--curse, speak evil of.",
               "_strongs": "02551"
            },
            {
               "strongs": "2552",
               "greek": [
                  {
                     "_BETA": "KAKOPA/QEIA",
                     "_unicode": "κακοπάθεια",
                     "_translit": "kakopátheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-op-ath'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3806"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "hardship",
               "kjv_def": ":--suffering affliction.",
               "_strongs": "02552"
            },
            {
               "strongs": "2553",
               "greek": [
                  {
                     "_BETA": "KAKOPAQE/W",
                     "_unicode": "κακοπαθέω",
                     "_translit": "kakopathéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-op-ath-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2552"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to undergo hardship",
               "kjv_def": ":--be afflicted, endure\n afflictions (hardness), suffer trouble.",
               "_strongs": "02553"
            },
            {
               "strongs": "2554",
               "greek": [
                  {
                     "_BETA": "KAKOPOIE/W",
                     "_unicode": "κακοποιέω",
                     "_translit": "kakopoiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-op-oy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2555"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a bad-doer, i.e. (objectively) to injure, or\n (genitive) to sin",
               "kjv_def": ":--do(ing) evil.",
               "_strongs": "02554"
            },
            {
               "strongs": "2555",
               "greek": [
                  {
                     "_BETA": "KAKOPOIO/S",
                     "_unicode": "κακοποιός",
                     "_translit": "kakopoiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-op-oy-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a bad-doer; (specially), a criminal",
               "kjv_def": ":--evil-doer,\n malefactor.",
               "_strongs": "02555"
            },
            {
               "strongs": "2556",
               "greek": [
                  {
                     "_BETA": "KAKO/S",
                     "_unicode": "κακός",
                     "_translit": "kakós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-os'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4190"
                     }
                  ],
                  "__text": "worthless (intrinsically, such; whereas\n \n properly refers to effects), i.e. (subjectively) depraved, or\n (objectively) injurious"
               },
               "kjv_def": ":--bad, evil, harm, ill, noisome, wicked.",
               "_strongs": "02556"
            },
            {
               "strongs": "2557",
               "greek": [
                  {
                     "_BETA": "KAKOU=RGOS",
                     "_unicode": "κακοῦργος",
                     "_translit": "kakoûrgos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-oor'-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "a wrong-doer, i.e.\n criminal",
               "kjv_def": ":--evil-doer, malefactor.",
               "_strongs": "02557"
            },
            {
               "strongs": "2558",
               "greek": [
                  {
                     "_BETA": "KAKOUXE/W",
                     "_unicode": "κακουχέω",
                     "_translit": "kakouchéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-oo-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from a presumed compound of \n and \n;"
               },
               "strongs_def": "to maltreat",
               "kjv_def": ":--which suffer\n adversity, torment.",
               "_strongs": "02558"
            },
            {
               "strongs": "2559",
               "greek": [
                  {
                     "_BETA": "KAKO/W",
                     "_unicode": "κακόω",
                     "_translit": "kakóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to injure; figuratively, to exasperate",
               "kjv_def": ":--make evil\n affected, entreat evil, harm, hurt, vex.",
               "_strongs": "02559"
            },
            {
               "strongs": "2560",
               "greek": [
                  {
                     "_BETA": "KAKW=S",
                     "_unicode": "κακῶς",
                     "_translit": "kakōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "badly (physically or morally)",
               "kjv_def": ":--amiss, diseased, evil,\n grievously, miserably, sick, sore.",
               "_strongs": "02560"
            },
            {
               "strongs": "2561",
               "greek": [
                  {
                     "_BETA": "KA/KWSIS",
                     "_unicode": "κάκωσις",
                     "_translit": "kákōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kak'-o-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2559"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "maltreatment",
               "kjv_def": ":--affliction.",
               "_strongs": "02561"
            },
            {
               "strongs": "2562",
               "greek": [
                  {
                     "_BETA": "KALA/MH",
                     "_unicode": "καλάμη",
                     "_translit": "kalámē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-am'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2563"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a stalk of grain, i.e. (collectively)\n stubble",
               "kjv_def": ":--stubble.",
               "_strongs": "02562"
            },
            {
               "strongs": "2563",
               "greek": [
                  {
                     "_BETA": "KA/LAMOS",
                     "_unicode": "κάλαμος",
                     "_translit": "kálamos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal'-am-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a reed (the plant or its stem, or that of a\n similar plant); by implication, a pen",
               "kjv_def": ":--pen, reed.",
               "_strongs": "02563"
            },
            {
               "strongs": "2564",
               "greek": [
                  {
                     "_BETA": "KALE/W",
                     "_unicode": "καλέω",
                     "_translit": "kaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2753"
                     }
                  ],
                  "__text": "akin to the base of \n;"
               },
               "strongs_def": "to \"call\" (properly, aloud, but used in a\n variety of applications, directly or otherwise)",
               "kjv_def": ":--bid, call (forth),\n (whose, whose sur-)name (was (called)).",
               "_strongs": "02564"
            },
            {
               "strongs": "2565",
               "greek": [
                  {
                     "_BETA": "KALLIE/LAIOS",
                     "_unicode": "καλλιέλαιος",
                     "_translit": "kalliélaios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-le-el'-ah-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2566"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1636"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "a cultivated olive tree, i.e. a\n domesticated or improved one",
               "kjv_def": ":--good olive tree.",
               "_strongs": "02565"
            },
            {
               "strongs": "2566",
               "greek": [
                  {
                     "_BETA": "KALLI/ON",
                     "_unicode": "καλλίον",
                     "_translit": "kallíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-lee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2570"
                     }
                  ],
                  "__text": "neuter of the (irregular) comparative of \n;"
               },
               "strongs_def": "(adverbially) better\n than many",
               "kjv_def": ":--very well.",
               "_strongs": "02566"
            },
            {
               "strongs": "2567",
               "greek": [
                  {
                     "_BETA": "KALODIDA/SKALOS",
                     "_unicode": "καλοδιδάσκαλος",
                     "_translit": "kalodidáskalos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-od-id-as'-kal-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2570"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1320"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a teacher of the right",
               "kjv_def": ":--teacher of good things.",
               "_strongs": "02567"
            },
            {
               "strongs": "2568",
               "greek": [
                  {
                     "_BETA": "*KALOI\\ *LIME/NES",
                     "_unicode": "Καλοὶ Λιμένες",
                     "_translit": "Kaloì Liménes"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-oy' lee-men'-es"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2570"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3040"
                     }
                  ],
                  "__text": "plural of \n and \n;"
               },
               "strongs_def": "Good Harbors, i.e. Fairhaven, a bay of\n Crete",
               "kjv_def": ":--fair havens.",
               "_strongs": "02568"
            },
            {
               "strongs": "2569",
               "greek": [
                  {
                     "_BETA": "KALOPOIE/W",
                     "_unicode": "καλοποιέω",
                     "_translit": "kalopoiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-op-oy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2570"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to do well, i.e. live virtuously",
               "kjv_def": ":--well doing.",
               "_strongs": "02569"
            },
            {
               "strongs": "2570",
               "greek": [
                  {
                     "_BETA": "KALO/S",
                     "_unicode": "καλός",
                     "_translit": "kalós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-os'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "18"
                     }
                  ],
                  "__text": "properly, beautiful, but chiefly (figuratively)\n good (literally or morally), i.e. valuable or virtuous (for appearance\n or use, and thus distinguished from \n, which is properly\n intrinsic)"
               },
               "kjv_def": ":--X better, fair, good(-ly), honest, meet, well, worthy.",
               "_strongs": "02570"
            },
            {
               "strongs": "2571",
               "greek": [
                  {
                     "_BETA": "KA/LUMA",
                     "_unicode": "κάλυμα",
                     "_translit": "kályma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal'-oo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a cover, i.e. veil",
               "kjv_def": ":--vail.",
               "_strongs": "02571"
            },
            {
               "strongs": "2572",
               "greek": [
                  {
                     "_BETA": "KALU/PTW",
                     "_unicode": "καλύπτω",
                     "_translit": "kalýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2813"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2928"
                     }
                  ],
                  "__text": "akin to \n and \n;"
               },
               "strongs_def": "to cover up (literally or\n figuratively)",
               "kjv_def": ":--cover, hide.",
               "_strongs": "02572"
            },
            {
               "strongs": "2573",
               "greek": [
                  {
                     "_BETA": "KALW=S",
                     "_unicode": "καλῶς",
                     "_translit": "kalōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kal-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2570"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "well (usually morally)",
               "kjv_def": ":--(in a) good (place),\n honestly, + recover, (full) well.",
               "_strongs": "02573"
            },
            {
               "strongs": "2574",
               "greek": [
                  {
                     "_BETA": "KA/MHLOS",
                     "_unicode": "κάμηλος",
                     "_translit": "kámēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kam'-ay-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01581"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "a \"camel\"",
               "kjv_def": ":--camel.",
               "_strongs": "02574"
            },
            {
               "strongs": "2575",
               "greek": [
                  {
                     "_BETA": "KA/MINOS",
                     "_unicode": "κάμινος",
                     "_translit": "káminos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kam'-ee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2545"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "a furnace",
               "kjv_def": ":--furnace.",
               "_strongs": "02575"
            },
            {
               "strongs": "2576",
               "greek": [
                  {
                     "_BETA": "KAMMU/W",
                     "_unicode": "καμμύω",
                     "_translit": "kammýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kam-moo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3466"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n;"
               },
               "strongs_def": "to shut down, i.e. close\n the eyes",
               "kjv_def": ":--close.",
               "_strongs": "02576"
            },
            {
               "strongs": "2577",
               "greek": [
                  {
                     "_BETA": "KA/MNW",
                     "_unicode": "κάμνω",
                     "_translit": "kámnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kam'-no"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "properly, to toil, i.e. (by implication) to\n tire (figuratively, faint, sicken)",
               "kjv_def": ":--faint, sick, be wearied.",
               "_strongs": "02577"
            },
            {
               "strongs": "2578",
               "greek": [
                  {
                     "_BETA": "KA/MPTW",
                     "_unicode": "κάμπτω",
                     "_translit": "kámptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kamp'-to"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to bend",
               "kjv_def": ":--bow.",
               "_strongs": "02578"
            },
            {
               "strongs": "2579",
               "greek": [
                  {
                     "_BETA": "KA)/N",
                     "_unicode": "κἄν",
                     "_translit": "kán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kan"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1437"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "and (or even) if",
               "kjv_def": ":--and (also) if (so much as), if\n but, at the least, though, yet.",
               "_strongs": "02579"
            },
            {
               "strongs": "2580",
               "greek": [
                  {
                     "_BETA": "*KANA=",
                     "_unicode": "Κανᾶ",
                     "_translit": "Kanâ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kan-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07071"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "Cana, a place in Palestine",
               "kjv_def": ":--Cana.",
               "_strongs": "02580"
            },
            {
               "strongs": "2581",
               "greek": [
                  {
                     "_BETA": "*KANANI/THS",
                     "_unicode": "Κανανίτης",
                     "_translit": "Kananítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kan-an-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07067"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "zealous; Cananites, an\n epithet",
               "kjv_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5477"
                     }
                  ],
                  "__text": ":--Canaanite (by mistake for a derivative from \n)."
               },
               "_strongs": "02581"
            },
            {
               "strongs": "2582",
               "greek": [
                  {
                     "_BETA": "*KANDA/KH",
                     "_unicode": "Κανδάκη",
                     "_translit": "Kandákē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kan-dak'-ay"
                  }
               ],
               "strongs_derivation": "of foreign origin;",
               "strongs_def": "Candacè, an Egyptian queen",
               "kjv_def": ":--Candace.",
               "_strongs": "02582"
            },
            {
               "strongs": "2583",
               "greek": [
                  {
                     "_BETA": "KANW/N",
                     "_unicode": "κανών",
                     "_translit": "kanṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kan-ohn'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KA/NH",
                        "_unicode": "κάνη",
                        "_translit": "kánē"
                     }
                  ],
                  "__text": "from \n (a straight reed, i.e. rod);"
               },
               "strongs_def": "a rule (\"canon\"), i.e.\n (figuratively) a standard (of faith and practice); by implication, a\n boundary, i.e. (figuratively) a sphere (of activity)",
               "kjv_def": ":--line, rule.",
               "_strongs": "02583"
            },
            {
               "strongs": "2584",
               "greek": [
                  {
                     "_BETA": "*KAPERNAOU/M",
                     "_unicode": "Καπερναούμ",
                     "_translit": "Kapernaoúm"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "cap-er-nah-oom'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03723"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "05151"
                     }
                  ],
                  "__text": "of Hebrew origin (probably \n and \n);"
               },
               "strongs_def": "Capernaum (i.e.\n Caphanachum), a place in Palestine",
               "kjv_def": ":--Capernaum.",
               "_strongs": "02584"
            },
            {
               "strongs": "2585",
               "greek": [
                  {
                     "_BETA": "KAPHLEU/W",
                     "_unicode": "καπηλεύω",
                     "_translit": "kapēleúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kap-ale-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KA/PHLOS",
                        "_unicode": "κάπηλος",
                        "_translit": "kápēlos"
                     }
                  ],
                  "__text": "from \n (a huckster);"
               },
               "strongs_def": "to retail, i.e. (by implication) to\n adulterate (figuratively)",
               "kjv_def": ":--corrupt.",
               "_strongs": "02585"
            },
            {
               "strongs": "2586",
               "greek": [
                  {
                     "_BETA": "KAPNO/S",
                     "_unicode": "καπνός",
                     "_translit": "kapnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kap-nos'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "smoke",
               "kjv_def": ":--smoke.",
               "_strongs": "02586"
            },
            {
               "strongs": "2587",
               "greek": [
                  {
                     "_BETA": "*KAPPADOKI/A",
                     "_unicode": "Καππαδοκία",
                     "_translit": "Kappadokía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kap-pad-ok-ee'-ah"
                  }
               ],
               "strongs_derivation": "of foreign origin;",
               "strongs_def": "Cappadocia, a region of Asia Minor",
               "kjv_def": ":--Cappadocia.",
               "_strongs": "02587"
            },
            {
               "strongs": "2588",
               "greek": [
                  {
                     "_BETA": "KARDI/A",
                     "_unicode": "καρδία",
                     "_translit": "kardía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kar-dee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KA/R",
                        "_unicode": "κάρ",
                        "_translit": "kár"
                     }
                  ],
                  "latin": "cor",
                  "__text": "prolonged from a primary \n (Latin \n, \"heart\");"
               },
               "strongs_def": "the heart, i.e.\n (figuratively) the thoughts or feelings (mind); also (by analogy) the\n middle",
               "kjv_def": ":--(+ broken-)heart(-ed).",
               "_strongs": "02588"
            },
            {
               "strongs": "2589",
               "greek": [
                  {
                     "_BETA": "KARDIOGNW/STHS",
                     "_unicode": "καρδιογνώστης",
                     "_translit": "kardiognṓstēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kar-dee-og-noce'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a heart-knower",
               "kjv_def": ":--which knowest the hearts.",
               "_strongs": "02589"
            },
            {
               "strongs": "2590",
               "greek": [
                  {
                     "_BETA": "KARPO/S",
                     "_unicode": "καρπός",
                     "_translit": "karpós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kar-pos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "726"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "fruit (as plucked), literally or\n figuratively",
               "kjv_def": ":--fruit.",
               "_strongs": "02590"
            },
            {
               "strongs": "2591",
               "greek": [
                  {
                     "_BETA": "*KA/RPOS",
                     "_unicode": "Κάρπος",
                     "_translit": "Kárpos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kar'-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2590"
                     }
                  ],
                  "__text": "perhaps for \n;"
               },
               "strongs_def": "Carpus, probably a Christian",
               "kjv_def": ":--Carpus.",
               "_strongs": "02591"
            },
            {
               "strongs": "2592",
               "greek": [
                  {
                     "_BETA": "KARPOFORE/W",
                     "_unicode": "καρποφορέω",
                     "_translit": "karpophoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kar-pof-or-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2593"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be fertile (literally or figuratively)",
               "kjv_def": ":--be (bear, bring\n forth) fruit(-ful).",
               "_strongs": "02592"
            },
            {
               "strongs": "2593",
               "greek": [
                  {
                     "_BETA": "KARPOFO/ROS",
                     "_unicode": "καρποφόρος",
                     "_translit": "karpophóros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kar-pof-or'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2590"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fruitbearing (figuratively)",
               "kjv_def": ":--fruitful.",
               "_strongs": "02593"
            },
            {
               "strongs": "2594",
               "greek": [
                  {
                     "_BETA": "KARTERE/W",
                     "_unicode": "καρτερέω",
                     "_translit": "karteréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kar-ter-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "from a derivative of \n (transposed);"
               },
               "strongs_def": "to be strong, i.e.\n (figuratively) steadfast (patient)",
               "kjv_def": ":--endure.",
               "_strongs": "02594"
            },
            {
               "strongs": "2595",
               "greek": [
                  {
                     "_BETA": "KA/RFOS",
                     "_unicode": "κάρφος",
                     "_translit": "kárphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kar'-fos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KA/RFW",
                        "_unicode": "κάρφω",
                        "_translit": "kárphō"
                     }
                  ],
                  "__text": "from \n (to wither);"
               },
               "strongs_def": "a dry twig or straw",
               "kjv_def": ":--mote.",
               "_strongs": "02595"
            },
            {
               "strongs": "2596",
               "greek": [
                  {
                     "_BETA": "KATA/",
                     "_unicode": "κατά",
                     "_translit": "katá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ah'"
                  }
               ],
               "strongs_derivation": "a primary particle;",
               "strongs_def": "(prepositionally) down (in place or time), in\n varied relations (according to the case (genitive, dative or\n accusative) with which it is joined)",
               "kjv_def": ":--about, according as (to),\n after, against, (when they were) X alone, among, and, X apart, (even,\n like) as (concerning, pertaining to touching), X aside, at, before,\n beyond, by, to the charge of, (charita-)bly, concerning, + covered,\n (dai-)ly, down, every, (+ far more) exceeding, X more excellent, for,\n from … to, godly, in(-asmuch, divers, every, -to, respect of), …\n by, after the manner of, + by any means, beyond (out of) measure, X\n mightily, more, X natural, of (up-)on (X part), out (of every), over\n against, (+ your) X own, + particularly, so, through(-oughout,\n -oughout every), thus, (un-)to(-gether, -ward), X uttermost,\n where(-by), with.",
               "_strongs": "02596",
               "__text": "In composition it retains many of these\n applications, and frequently denotes opposition, distribution, or\n intensity."
            },
            {
               "strongs": "2597",
               "greek": [
                  {
                     "_BETA": "KATABAI/NW",
                     "_unicode": "καταβαίνω",
                     "_translit": "katabaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ab-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to descend (literally or\n figuratively)",
               "kjv_def": ":--come (get, go, step) down, fall (down).",
               "_strongs": "02597"
            },
            {
               "strongs": "2598",
               "greek": [
                  {
                     "_BETA": "KATABA/LLW",
                     "_unicode": "καταβάλλω",
                     "_translit": "katabállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ab-al'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw down",
               "kjv_def": ":--cast down, lay.",
               "_strongs": "02598"
            },
            {
               "strongs": "2599",
               "greek": [
                  {
                     "_BETA": "KATABARE/W",
                     "_unicode": "καταβαρέω",
                     "_translit": "katabaréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ab-ar-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "916"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to impose upon",
               "kjv_def": ":--burden.",
               "_strongs": "02599"
            },
            {
               "strongs": "2600",
               "greek": [
                  {
                     "_BETA": "KATA/BASIS",
                     "_unicode": "κατάβασις",
                     "_translit": "katábasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ab'-as-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2597"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a declivity",
               "kjv_def": ":--descent.",
               "_strongs": "02600"
            },
            {
               "strongs": "2601",
               "greek": [
                  {
                     "_BETA": "KATABIBA/ZW",
                     "_unicode": "καταβιβάζω",
                     "_translit": "katabibázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ab-ib-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and a derivative of the base of \n;"
               },
               "strongs_def": "to cause to go down,\n i.e. precipitate",
               "kjv_def": ":--bring (thrust) down.",
               "_strongs": "02601"
            },
            {
               "strongs": "2602",
               "greek": [
                  {
                     "_BETA": "KATABOLH/",
                     "_unicode": "καταβολή",
                     "_translit": "katabolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ab-ol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2598"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deposition, i.e. founding; figuratively,\n conception",
               "kjv_def": ":--conceive, foundation.",
               "_strongs": "02602"
            },
            {
               "strongs": "2603",
               "greek": [
                  {
                     "_BETA": "KATABRABEU/W",
                     "_unicode": "καταβραβεύω",
                     "_translit": "katabrabeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ab-rab-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1018"
                     }
                  ],
                  "__text": "from \n and \n (in its original sense);"
               },
               "strongs_def": "to award the price\n against, i.e. (figuratively) to defraud (of salvation)",
               "kjv_def": ":--beguile of\n reward.",
               "_strongs": "02603"
            },
            {
               "strongs": "2604",
               "greek": [
                  {
                     "_BETA": "KATAGGELEU/S",
                     "_unicode": "καταγγελεύς",
                     "_translit": "katangeleús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ang-gel-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2605"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a proclaimer",
               "kjv_def": ":--setter forth.",
               "_strongs": "02604"
            },
            {
               "strongs": "2605",
               "greek": [
                  {
                     "_BETA": "KATAGGE/LLW",
                     "_unicode": "καταγγέλλω",
                     "_translit": "katangéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ang-gel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to proclaim, promulgate",
               "kjv_def": ":--declare,\n preach, shew, speak of, teach.",
               "_strongs": "02605"
            },
            {
               "strongs": "2606",
               "greek": [
                  {
                     "_BETA": "KATAGELA/W",
                     "_unicode": "καταγελάω",
                     "_translit": "katageláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ag-el-ah'-o"
                  }
               ],
               "strongs_def": "to laugh down, i.e. deride",
               "kjv_def": ":--laugh to scorn.",
               "_strongs": "02606"
            },
            {
               "strongs": "2607",
               "greek": [
                  {
                     "_BETA": "KATAGINW/SKW",
                     "_unicode": "καταγινώσκω",
                     "_translit": "kataginṓskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ag-in-o'-sko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to note against, i.e. find fault with",
               "kjv_def": ":--blame,\n condemn.",
               "_strongs": "02607"
            },
            {
               "strongs": "2608",
               "greek": [
                  {
                     "_BETA": "KATA/GNUMI",
                     "_unicode": "κατάγνυμι",
                     "_translit": "katágnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ag'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to rend in pieces, i.e. crack\n apart",
               "kjv_def": ":--break.",
               "_strongs": "02608"
            },
            {
               "strongs": "2609",
               "greek": [
                  {
                     "_BETA": "KATA/GW",
                     "_unicode": "κατάγω",
                     "_translit": "katágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead down; specially, to moor a vessel",
               "kjv_def": ":--bring\n (down, forth), (bring to) land, touch.",
               "_strongs": "02609"
            },
            {
               "strongs": "2610",
               "greek": [
                  {
                     "_BETA": "KATAGWNI/ZOMAI",
                     "_unicode": "καταγωνίζομαι",
                     "_translit": "katagōnízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ag-o-nid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "75"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to struggle against, i.e. (by implication) to\n overcome",
               "kjv_def": ":--subdue.",
               "_strongs": "02610"
            },
            {
               "strongs": "2611",
               "greek": [
                  {
                     "_BETA": "KATADE/W",
                     "_unicode": "καταδέω",
                     "_translit": "katadéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ad-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tie down, i.e. bandage (a wound)",
               "kjv_def": ":--bind up.",
               "_strongs": "02611"
            },
            {
               "strongs": "2612",
               "greek": [
                  {
                     "_BETA": "KATA/DHLOS",
                     "_unicode": "κατάδηλος",
                     "_translit": "katádēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ad'-ay-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1212"
                     }
                  ],
                  "__text": "from \n intensive and \n;"
               },
               "strongs_def": "manifest",
               "kjv_def": ":--far more evident.",
               "_strongs": "02612"
            },
            {
               "strongs": "2613",
               "greek": [
                  {
                     "_BETA": "KATADIKA/ZW",
                     "_unicode": "καταδικάζω",
                     "_translit": "katadikázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ad-ik-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to adjudge against, i.e. pronounce\n guilty",
               "kjv_def": ":--condemn.",
               "_strongs": "02613"
            },
            {
               "strongs": "2614",
               "greek": [
                  {
                     "_BETA": "KATADIW/KW",
                     "_unicode": "καταδιώκω",
                     "_translit": "katadiṓkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ad-ee-o'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1377"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hunt down, i.e. search for",
               "kjv_def": ":--follow after.",
               "_strongs": "02614"
            },
            {
               "strongs": "2615",
               "greek": [
                  {
                     "_BETA": "KATADOULO/W",
                     "_unicode": "καταδουλόω",
                     "_translit": "katadoulóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ad-oo-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1402"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to enslave utterly",
               "kjv_def": ":--bring into bondage.",
               "_strongs": "02615"
            },
            {
               "strongs": "2616",
               "greek": [
                  {
                     "_BETA": "KATADUNASTEU/W",
                     "_unicode": "καταδυναστεύω",
                     "_translit": "katadynasteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ad-oo-nas-tyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1413"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to exercise dominion against, i.e.\n oppress",
               "kjv_def": ":--oppress.",
               "_strongs": "02616"
            },
            {
               "strongs": "2617",
               "greek": [
                  {
                     "_BETA": "KATAISXU/NW",
                     "_unicode": "καταισχύνω",
                     "_translit": "kataischýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ahee-skhoo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "153"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to shame down, i.e. disgrace or (by implication)\n put to the blush",
               "kjv_def": ":--confound, dishonour, (be a-, make a-)shame(-d).",
               "_strongs": "02617"
            },
            {
               "strongs": "2618",
               "greek": [
                  {
                     "_BETA": "KATAKAI/W",
                     "_unicode": "κατακαίω",
                     "_translit": "katakaíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-ah'-ee-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2545"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to burn down (to the ground), i.e. consume\n wholly",
               "kjv_def": ":--burn (up, utterly).",
               "_strongs": "02618"
            },
            {
               "strongs": "2619",
               "greek": [
                  {
                     "_BETA": "KATAKALU/PTW",
                     "_unicode": "κατακαλύπτω",
                     "_translit": "katakalýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-al-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to cover wholly, i.e. veil",
               "kjv_def": ":--cover, hide.",
               "_strongs": "02619"
            },
            {
               "strongs": "2620",
               "greek": [
                  {
                     "_BETA": "KATAKAUXA/OMAI",
                     "_unicode": "κατακαυχάομαι",
                     "_translit": "katakaucháomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-ow-khah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2744"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exult against (i.e. over)",
               "kjv_def": ":--boast (against),\n glory, rejoice against.",
               "_strongs": "02620"
            },
            {
               "strongs": "2621",
               "greek": [
                  {
                     "_BETA": "KATA/KEIMAI",
                     "_unicode": "κατάκειμαι",
                     "_translit": "katákeimai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak'-i-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lie down, i.e. (by implication) be sick;\n specially, to recline at a meal",
               "kjv_def": ":--keep, lie, sit at meat (down).",
               "_strongs": "02621"
            },
            {
               "strongs": "2622",
               "greek": [
                  {
                     "_BETA": "KATAKLA/W",
                     "_unicode": "κατακλάω",
                     "_translit": "katakláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-lah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2806"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to break down, i.e. divide",
               "kjv_def": ":--break.",
               "_strongs": "02622"
            },
            {
               "strongs": "2623",
               "greek": [
                  {
                     "_BETA": "KATAKLEI/W",
                     "_unicode": "κατακλείω",
                     "_translit": "katakleíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-li'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2808"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to shut down (in a dungeon), i.e.\n incarcerate",
               "kjv_def": ":--shut up.",
               "_strongs": "02623"
            },
            {
               "strongs": "2624",
               "greek": [
                  {
                     "_BETA": "KATAKLHRODOTE/W",
                     "_unicode": "κατακληροδοτέω",
                     "_translit": "kataklērodotéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-lay-rod-ot-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2819"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and a derivative of a compound of \n and \n;"
               },
               "strongs_def": "to be a\n giver of lots to each, i.e. (by implication) to apportion an\n estate",
               "kjv_def": ":--divide by lot.",
               "_strongs": "02624"
            },
            {
               "strongs": "2625",
               "greek": [
                  {
                     "_BETA": "KATAKLI/NW",
                     "_unicode": "κατακλίνω",
                     "_translit": "kataklínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-lee'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to recline down, i.e. (specially) to take a place\n at table",
               "kjv_def": ":--(make) sit down (at meat).",
               "_strongs": "02625"
            },
            {
               "strongs": "2626",
               "greek": [
                  {
                     "_BETA": "KATAKLU/ZW",
                     "_unicode": "κατακλύζω",
                     "_translit": "kataklýzō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-lood'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2830"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to dash (wash) down, i.e. (by\n implication) to deluge",
               "kjv_def": ":--overflow.",
               "_strongs": "02626"
            },
            {
               "strongs": "2627",
               "greek": [
                  {
                     "_BETA": "KATAKLUSMO/S",
                     "_unicode": "κατακλυσμός",
                     "_translit": "kataklysmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-looce-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2626"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an inundation",
               "kjv_def": ":--flood.",
               "_strongs": "02627"
            },
            {
               "strongs": "2628",
               "greek": [
                  {
                     "_BETA": "KATAKOLOUQE/W",
                     "_unicode": "κατακολουθέω",
                     "_translit": "katakolouthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-ol-oo-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "190"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to accompany closely",
               "kjv_def": ":--follow (after).",
               "_strongs": "02628"
            },
            {
               "strongs": "2629",
               "greek": [
                  {
                     "_BETA": "KATAKO/PTW",
                     "_unicode": "κατακόπτω",
                     "_translit": "katakóptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-op'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to chop down, i.e. mangle",
               "kjv_def": ":--cut.",
               "_strongs": "02629"
            },
            {
               "strongs": "2630",
               "greek": [
                  {
                     "_BETA": "KATAKRHMNI/ZW",
                     "_unicode": "κατακρημνίζω",
                     "_translit": "katakrēmnízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-rame-nid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2911"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to precipitate down",
               "kjv_def": ":--cast down\n headlong.",
               "_strongs": "02630"
            },
            {
               "strongs": "2631",
               "greek": [
                  {
                     "_BETA": "KATA/KRIMA",
                     "_unicode": "κατάκριμα",
                     "_translit": "katákrima"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak'-ree-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2632"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an adverse sentence (the verdict)",
               "kjv_def": ":--condemnation.",
               "_strongs": "02631"
            },
            {
               "strongs": "2632",
               "greek": [
                  {
                     "_BETA": "KATAKRI/NW",
                     "_unicode": "κατακρίνω",
                     "_translit": "katakrínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-ree'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to judge against, i.e. sentence",
               "kjv_def": ":--condemn, damn.",
               "_strongs": "02632"
            },
            {
               "strongs": "2633",
               "greek": [
                  {
                     "_BETA": "KATA/KRISIS",
                     "_unicode": "κατάκρισις",
                     "_translit": "katákrisis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak'-ree-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2632"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sentencing adversely (the act)",
               "kjv_def": ":--condemn(-ation).",
               "_strongs": "02633"
            },
            {
               "strongs": "2634",
               "greek": [
                  {
                     "_BETA": "KATAKURIEU/W",
                     "_unicode": "κατακυριεύω",
                     "_translit": "katakyrieúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ak-oo-ree-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2961"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lord against, i.e. control,\n subjugate",
               "kjv_def": ":--exercise dominion over (lordship), be lord over, overcome.",
               "_strongs": "02634"
            },
            {
               "strongs": "2635",
               "greek": [
                  {
                     "_BETA": "KATALALE/W",
                     "_unicode": "καταλαλέω",
                     "_translit": "katalaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-al-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2637"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a traducer, i.e. to slander",
               "kjv_def": ":--speak against (evil\n of).",
               "_strongs": "02635"
            },
            {
               "strongs": "2636",
               "greek": [
                  {
                     "_BETA": "KATALALI/A",
                     "_unicode": "καταλαλία",
                     "_translit": "katalalía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-al-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2637"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "defamation",
               "kjv_def": ":--backbiting, evil speaking.",
               "_strongs": "02636"
            },
            {
               "strongs": "2637",
               "greek": [
                  {
                     "_BETA": "KATA/LALOS",
                     "_unicode": "κατάλαλος",
                     "_translit": "katálalos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al'-al-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "talkative against, i.e. a\n slanderer",
               "kjv_def": ":--backbiter.",
               "_strongs": "02637"
            },
            {
               "strongs": "2638",
               "greek": [
                  {
                     "_BETA": "KATALAMBA/NW",
                     "_unicode": "καταλαμβάνω",
                     "_translit": "katalambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-am-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take eagerly, i.e. seize, possess, etc.\n (literally or figuratively)",
               "kjv_def": ":--apprehend, attain, come upon,\n comprehend, find, obtain, perceive, (over-)take.",
               "_strongs": "02638"
            },
            {
               "strongs": "2639",
               "greek": [
                  {
                     "_BETA": "KATALE/GW",
                     "_unicode": "καταλέγω",
                     "_translit": "katalégō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-eg'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and \n (in its original meaning);"
               },
               "strongs_def": "to lay down, i.e.\n (figuratively) to enrol",
               "kjv_def": ":--take into the number.",
               "_strongs": "02639"
            },
            {
               "strongs": "2640",
               "greek": [
                  {
                     "_BETA": "KATA/LEIMMA",
                     "_unicode": "κατάλειμμα",
                     "_translit": "katáleimma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al'-ime-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2641"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a remainder, i.e. (by implication) a few",
               "kjv_def": ":--remnant.",
               "_strongs": "02640"
            },
            {
               "strongs": "2641",
               "greek": [
                  {
                     "_BETA": "KATALEI/PW",
                     "_unicode": "καταλείπω",
                     "_translit": "kataleípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-i'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to leave down, i.e. behind; by implication, to\n abandon, have remaining",
               "kjv_def": ":--forsake, leave, reserve.",
               "_strongs": "02641"
            },
            {
               "strongs": "2642",
               "greek": [
                  {
                     "_BETA": "KATALIQA/ZW",
                     "_unicode": "καταλιθάζω",
                     "_translit": "katalitházō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-ith-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3034"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stone down, i.e. to death",
               "kjv_def": ":--stone.",
               "_strongs": "02642"
            },
            {
               "strongs": "2643",
               "greek": [
                  {
                     "_BETA": "KATALLAGH/",
                     "_unicode": "καταλλαγή",
                     "_translit": "katallagḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-lag-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2644"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "exchange (figuratively, adjustment), i.e. restoration to\n (the divine) favor",
               "kjv_def": ":--atonement, reconciliation(-ing).",
               "_strongs": "02643"
            },
            {
               "strongs": "2644",
               "greek": [
                  {
                     "_BETA": "KATALLA/SSW",
                     "_unicode": "καταλλάσσω",
                     "_translit": "katallássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-las'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "236"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to change mutually, i.e. (figuratively) to compound\n a difference",
               "kjv_def": ":--reconcile.",
               "_strongs": "02644"
            },
            {
               "strongs": "2645",
               "greek": [
                  {
                     "_BETA": "KATA/LOIPOS",
                     "_unicode": "κατάλοιπος",
                     "_translit": "katáloipos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al'-oy-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3062"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "left down (behind), i.e remaining (plural the\n rest)",
               "kjv_def": ":--residue.",
               "_strongs": "02645"
            },
            {
               "strongs": "2646",
               "greek": [
                  {
                     "_BETA": "KATA/LUMA",
                     "_unicode": "κατάλυμα",
                     "_translit": "katályma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al'-oo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2647"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a dissolution (breaking up of a journey), i.e.\n (by implication) a lodging-place",
               "kjv_def": ":-- guestchamber, inn.",
               "_strongs": "02646"
            },
            {
               "strongs": "2647",
               "greek": [
                  {
                     "_BETA": "KATALU/W",
                     "_unicode": "καταλύω",
                     "_translit": "katalýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-al-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2646"
                     }
                  ],
                  "__text": "to loosen down (disintegrate), i.e. (by\n implication) to demolish (literally or figuratively); specially\n (compare \n) to halt for the night"
               },
               "kjv_def": ":--destroy, dissolve, be guest,\n lodge, come to nought, overthrow, throw down.",
               "_strongs": "02647"
            },
            {
               "strongs": "2648",
               "greek": [
                  {
                     "_BETA": "KATAMANQA/NW",
                     "_unicode": "καταμανθάνω",
                     "_translit": "katamanthánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-am-an-than'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3129"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to learn thoroughly, i.e. (by implication) to note\n carefully",
               "kjv_def": ":--consider.",
               "_strongs": "02648"
            },
            {
               "strongs": "2649",
               "greek": [
                  {
                     "_BETA": "KATAMARTURE/W",
                     "_unicode": "καταμαρτυρέω",
                     "_translit": "katamartyréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-am-ar-too-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3140"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to testify against",
               "kjv_def": ":--witness against.",
               "_strongs": "02649"
            },
            {
               "strongs": "2650",
               "greek": [
                  {
                     "_BETA": "KATAME/NW",
                     "_unicode": "καταμένω",
                     "_translit": "kataménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-am-en'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stay fully, i.e. reside",
               "kjv_def": ":--abide.",
               "_strongs": "02650"
            },
            {
               "strongs": "2651",
               "greek": [
                  {
                     "_BETA": "KATAMO/NAS",
                     "_unicode": "καταμόνας",
                     "_translit": "katamónas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-am-on'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3441"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "from \n and accusative case plural feminine of \n (with \n\n implied);"
               },
               "strongs_def": "according to sole places, i.e. (adverbially)\n separately",
               "kjv_def": ":--alone.",
               "_strongs": "02651"
            },
            {
               "strongs": "2652",
               "greek": [
                  {
                     "_BETA": "KATANA/QEMA",
                     "_unicode": "κατανάθεμα",
                     "_translit": "katanáthema"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an-ath'-em-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "331"
                     }
                  ],
                  "__text": "from \n (intensive) and \n;"
               },
               "strongs_def": "an imprecation",
               "kjv_def": ":--curse.",
               "_strongs": "02652"
            },
            {
               "strongs": "2653",
               "greek": [
                  {
                     "_BETA": "KATANAQEMATI/ZW",
                     "_unicode": "καταναθεματίζω",
                     "_translit": "katanathematízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an-ath-em-at-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "332"
                     }
                  ],
                  "__text": "from \n (intensive) and \n;"
               },
               "strongs_def": "to imprecate",
               "kjv_def": ":--curse.",
               "_strongs": "02653"
            },
            {
               "strongs": "2654",
               "greek": [
                  {
                     "_BETA": "KATANALI/SKW",
                     "_unicode": "καταναλίσκω",
                     "_translit": "katanalískō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an-al-is'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "355"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to consume utterly",
               "kjv_def": ":--consume.",
               "_strongs": "02654"
            },
            {
               "strongs": "2655",
               "greek": [
                  {
                     "_BETA": "KATANARKA/W",
                     "_unicode": "καταναρκάω",
                     "_translit": "katanarkáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an-ar-kah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "NARKA/W",
                        "_unicode": "ναρκάω",
                        "_translit": "narkáō"
                     }
                  ],
                  "__text": "from \n and \n (to be numb);"
               },
               "strongs_def": "to grow utterly torpid, i.e. (by\n implication) slothful (figuratively, expensive)",
               "kjv_def": ":--be burdensome\n (chargeable).",
               "_strongs": "02655"
            },
            {
               "strongs": "2656",
               "greek": [
                  {
                     "_BETA": "KATANEU/W",
                     "_unicode": "κατανεύω",
                     "_translit": "kataneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3506"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to nod down (towards), i.e. (by analogy) to make\n signs to",
               "kjv_def": ":--beckon.",
               "_strongs": "02656"
            },
            {
               "strongs": "2657",
               "greek": [
                  {
                     "_BETA": "KATANOE/W",
                     "_unicode": "κατανοέω",
                     "_translit": "katanoéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an-o-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to observe fully",
               "kjv_def": ":--behold, consider, discover,\n perceive.",
               "_strongs": "02657"
            },
            {
               "strongs": "2658",
               "greek": [
                  {
                     "_BETA": "KATANTA/W",
                     "_unicode": "καταντάω",
                     "_translit": "katantáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to meet against, i.e. arrive at\n (literally or figuratively)",
               "kjv_def": ":--attain, come.",
               "_strongs": "02658"
            },
            {
               "strongs": "2659",
               "greek": [
                  {
                     "_BETA": "KATA/NUCIS",
                     "_unicode": "κατάνυξις",
                     "_translit": "katányxis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an'-oox-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2660"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3506"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3571"
                     }
                  ],
                  "__text": "a prickling (sensation, as of the limbs asleep), i.e. (by\n implication, (perhaps by some confusion with \n or even with \n))\n stupor (lethargy)"
               },
               "kjv_def": ":--slumber.",
               "_strongs": "02659"
            },
            {
               "strongs": "2660",
               "greek": [
                  {
                     "_BETA": "KATANU/SSW",
                     "_unicode": "κατανύσσω",
                     "_translit": "katanýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-an-oos'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3572"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to pierce thoroughly, i.e. (figuratively) to\n agitate violently (\"sting to the quick\")",
               "kjv_def": ":--prick.",
               "_strongs": "02660"
            },
            {
               "strongs": "2661",
               "greek": [
                  {
                     "_BETA": "KATACIO/W",
                     "_unicode": "καταξιόω",
                     "_translit": "kataxióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ax-ee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "515"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to deem entirely deserving",
               "kjv_def": ":--(ac-)count worthy.",
               "_strongs": "02661"
            },
            {
               "strongs": "2662",
               "greek": [
                  {
                     "_BETA": "KATAPATE/W",
                     "_unicode": "καταπατέω",
                     "_translit": "katapatéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-at-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3961"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to trample down; figuratively, to reject with\n disdain",
               "kjv_def": ":--trample, tread (down, underfoot).",
               "_strongs": "02662"
            },
            {
               "strongs": "2663",
               "greek": [
                  {
                     "_BETA": "KATA/PAUSIS",
                     "_unicode": "κατάπαυσις",
                     "_translit": "katápausis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap'-ow-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2664"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "reposing down, i.e. (by Hebraism) abode",
               "kjv_def": ":--rest.",
               "_strongs": "02663"
            },
            {
               "strongs": "2664",
               "greek": [
                  {
                     "_BETA": "KATAPAU/W",
                     "_unicode": "καταπαύω",
                     "_translit": "katapaúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-ow'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3973"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to settle down, i.e. (literally) to colonize, or\n (figuratively) to (cause to) desist",
               "kjv_def": ":--cease, (give) rest(-rain).",
               "_strongs": "02664"
            },
            {
               "strongs": "2665",
               "greek": [
                  {
                     "_BETA": "KATAPE/TASMA",
                     "_unicode": "καταπέτασμα",
                     "_translit": "katapétasma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-et'-as-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4072"
                     }
                  ],
                  "__text": "from a compound of \n and a congener of \n;"
               },
               "strongs_def": "something spread\n thoroughly, i.e. (specially) the door screen (to the Most Holy Place)\n in the Jewish Temple",
               "kjv_def": ":--vail.",
               "_strongs": "02665"
            },
            {
               "strongs": "2666",
               "greek": [
                  {
                     "_BETA": "KATAPI/NW",
                     "_unicode": "καταπίνω",
                     "_translit": "katapínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-ee'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to drink down, i.e. gulp entire (literally or\n figuratively)",
               "kjv_def": ":--devour, drown, swallow (up).",
               "_strongs": "02666"
            },
            {
               "strongs": "2667",
               "greek": [
                  {
                     "_BETA": "KATAPI/PTW",
                     "_unicode": "καταπίπτω",
                     "_translit": "katapíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-ip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fall down",
               "kjv_def": ":--fall (down).",
               "_strongs": "02667"
            },
            {
               "strongs": "2668",
               "greek": [
                  {
                     "_BETA": "KATAPLE/W",
                     "_unicode": "καταπλέω",
                     "_translit": "katapléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sail down upon a place, i.e. to land\n at",
               "kjv_def": ":--arrive.",
               "_strongs": "02668"
            },
            {
               "strongs": "2669",
               "greek": [
                  {
                     "_BETA": "KATAPONE/W",
                     "_unicode": "καταπονέω",
                     "_translit": "kataponéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-on-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4192"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to labor down, i.e. wear with toil\n (figuratively, harass)",
               "kjv_def": ":--oppress, vex.",
               "_strongs": "02669"
            },
            {
               "strongs": "2670",
               "greek": [
                  {
                     "_BETA": "KATAPONTI/ZW",
                     "_unicode": "καταποντίζω",
                     "_translit": "katapontízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-on-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4195"
                     }
                  ],
                  "__text": "from \n and a derivative of the same as \n;"
               },
               "strongs_def": "to plunge down, i.e.\n submerge",
               "kjv_def": ":--drown, sink.",
               "_strongs": "02670"
            },
            {
               "strongs": "2671",
               "greek": [
                  {
                     "_BETA": "KATA/RA",
                     "_unicode": "κατάρα",
                     "_translit": "katára"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ar'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "685"
                     }
                  ],
                  "__text": "from \n (intensive) and \n;"
               },
               "strongs_def": "imprecation, execration",
               "kjv_def": ":--curse(-d,\n ing).",
               "_strongs": "02671"
            },
            {
               "strongs": "2672",
               "greek": [
                  {
                     "_BETA": "KATARA/OMAI",
                     "_unicode": "καταράομαι",
                     "_translit": "kataráomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ar-ah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2671"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to execrate; by analogy, to doom",
               "kjv_def": ":--curse.",
               "_strongs": "02672"
            },
            {
               "strongs": "2673",
               "greek": [
                  {
                     "_BETA": "KATARGE/W",
                     "_unicode": "καταργέω",
                     "_translit": "katargéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-arg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "691"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be (render) entirely idle (useless), literally\n or figuratively",
               "kjv_def": ":--abolish, cease, cumber, deliver, destroy, do away,\n become (make) of no (none, without) effect, fail, loose, bring (come)\n to nought, put away (down), vanish away, make void.",
               "_strongs": "02673"
            },
            {
               "strongs": "2674",
               "greek": [
                  {
                     "_BETA": "KATARIQME/W",
                     "_unicode": "καταριθμέω",
                     "_translit": "katarithméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ar-ith-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "705"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reckon among",
               "kjv_def": ":--number with.",
               "_strongs": "02674"
            },
            {
               "strongs": "2675",
               "greek": [
                  {
                     "_BETA": "KATARTI/ZW",
                     "_unicode": "καταρτίζω",
                     "_translit": "katartízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ar-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "739"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to complete thoroughly, i.e. repair\n (literally or figuratively) or adjust",
               "kjv_def": ":--fit, frame, mend, (make)\n perfect(-ly join together), prepare, restore.",
               "_strongs": "02675"
            },
            {
               "strongs": "2676",
               "greek": [
                  {
                     "_BETA": "KATA/RTISIS",
                     "_unicode": "κατάρτισις",
                     "_translit": "katártisis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ar'-tis-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2675"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "thorough equipment (subjectively)",
               "kjv_def": ":--perfection.",
               "_strongs": "02676"
            },
            {
               "strongs": "2677",
               "greek": [
                  {
                     "_BETA": "KATARTISMO/S",
                     "_unicode": "καταρτισμός",
                     "_translit": "katartismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ar-tis-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2675"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "complete furnishing (objectively)",
               "kjv_def": ":--perfecting.",
               "_strongs": "02677"
            },
            {
               "strongs": "2678",
               "greek": [
                  {
                     "_BETA": "KATASEI/W",
                     "_unicode": "κατασείω",
                     "_translit": "kataseíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-i'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4579"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sway downward, i.e. make a signal",
               "kjv_def": ":--beckon.",
               "_strongs": "02678"
            },
            {
               "strongs": "2679",
               "greek": [
                  {
                     "_BETA": "KATASKA/PTW",
                     "_unicode": "κατασκάπτω",
                     "_translit": "kataskáptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-kap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4626"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to undermine, i.e. (by implication) destroy",
               "kjv_def": ":--dig\n down, ruin.",
               "_strongs": "02679"
            },
            {
               "strongs": "2680",
               "greek": [
                  {
                     "_BETA": "KATASKEUA/ZW",
                     "_unicode": "κατασκευάζω",
                     "_translit": "kataskeuázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ask-yoo-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4632"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2090"
                     }
                  ],
                  "__text": "to prepare thoroughly (properly,\n by external equipment; whereas \n refers rather to internal\n fitness); by implication, to construct, create"
               },
               "kjv_def": ":--build, make, ordain,\n prepare.",
               "_strongs": "02680"
            },
            {
               "strongs": "2681",
               "greek": [
                  {
                     "_BETA": "KATASKHNO/W",
                     "_unicode": "κατασκηνόω",
                     "_translit": "kataskēnóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-kay-no'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4637"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to camp down, i.e. haunt; figuratively, to\n remain",
               "kjv_def": ":--lodge, rest.",
               "_strongs": "02681"
            },
            {
               "strongs": "2682",
               "greek": [
                  {
                     "_BETA": "KATASKH/NWSIS",
                     "_unicode": "κατασκήνωσις",
                     "_translit": "kataskḗnōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-kay'-no-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2681"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an encamping, i.e. (figuratively) a perch",
               "kjv_def": ":--nest.",
               "_strongs": "02682"
            },
            {
               "strongs": "2683",
               "greek": [
                  {
                     "_BETA": "KATASKIA/ZW",
                     "_unicode": "κατασκιάζω",
                     "_translit": "kataskiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-kee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4639"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to overshade, i.e. cover",
               "kjv_def": ":--shadow.",
               "_strongs": "02683"
            },
            {
               "strongs": "2684",
               "greek": [
                  {
                     "_BETA": "KATASKOPE/W",
                     "_unicode": "κατασκοπέω",
                     "_translit": "kataskopéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-kop-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2685"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a sentinel, i.e. to inspect insidiously",
               "kjv_def": ":--spy out.",
               "_strongs": "02684"
            },
            {
               "strongs": "2685",
               "greek": [
                  {
                     "_BETA": "KATA/SKOPOS",
                     "_unicode": "κατάσκοπος",
                     "_translit": "katáskopos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as'-kop-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4649"
                     }
                  ],
                  "__text": "from \n (intensive) and \n (in the sense of a watcher);"
               },
               "strongs_def": "a\n reconnoiterer",
               "kjv_def": ":--spy.",
               "_strongs": "02685"
            },
            {
               "strongs": "2686",
               "greek": [
                  {
                     "_BETA": "KATASOFI/ZOMAI",
                     "_unicode": "κατασοφίζομαι",
                     "_translit": "katasophízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-of-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4679"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to be crafty against, i.e.\n circumvent",
               "kjv_def": ":--deal subtilly with.",
               "_strongs": "02686"
            },
            {
               "strongs": "2687",
               "greek": [
                  {
                     "_BETA": "KATASTE/LLW",
                     "_unicode": "καταστέλλω",
                     "_translit": "katastéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-tel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4724"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to put down, i.e. quell",
               "kjv_def": ":--appease, quiet.",
               "_strongs": "02687"
            },
            {
               "strongs": "2688",
               "greek": [
                  {
                     "_BETA": "KATA/STHMA",
                     "_unicode": "κατάστημα",
                     "_translit": "katástēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as'-tay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2525"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a position or condition, i.e. (subjectively)\n demeanor",
               "kjv_def": ":--behaviour.",
               "_strongs": "02688"
            },
            {
               "strongs": "2689",
               "greek": [
                  {
                     "_BETA": "KATASTOLH/",
                     "_unicode": "καταστολή",
                     "_translit": "katastolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-tol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2687"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deposit, i.e. (specially) costume",
               "kjv_def": ":--apparel.",
               "_strongs": "02689"
            },
            {
               "strongs": "2690",
               "greek": [
                  {
                     "_BETA": "KATASTRE/FW",
                     "_unicode": "καταστρέφω",
                     "_translit": "katastréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to turn upside down, i.e. upset",
               "kjv_def": ":--overthrow.",
               "_strongs": "02690"
            },
            {
               "strongs": "2691",
               "greek": [
                  {
                     "_BETA": "KATASTRHNIA/W",
                     "_unicode": "καταστρηνιάω",
                     "_translit": "katastrēniáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-tray-nee-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4763"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to become voluptuous against",
               "kjv_def": ":--begin to wax wanton\n against.",
               "_strongs": "02691"
            },
            {
               "strongs": "2692",
               "greek": [
                  {
                     "_BETA": "KATASTROFH/",
                     "_unicode": "καταστροφή",
                     "_translit": "katastrophḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-trof-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2690"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an overturn (\"catastrophe\"), i.e. demolition; figuratively,\n apostasy",
               "kjv_def": ":--overthrow, subverting.",
               "_strongs": "02692"
            },
            {
               "strongs": "2693",
               "greek": [
                  {
                     "_BETA": "KATASTRW/NNUMI",
                     "_unicode": "καταστρώννυμι",
                     "_translit": "katastrṓnnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-trone'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4766"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to strew down, i.e. (by implication) to prostrate\n (slay)",
               "kjv_def": ":--overthrow.",
               "_strongs": "02693"
            },
            {
               "strongs": "2694",
               "greek": [
                  {
                     "_BETA": "KATASU/RW",
                     "_unicode": "κατασύρω",
                     "_translit": "katasýrō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-oo'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4951"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to drag down, i.e. arrest judicially",
               "kjv_def": ":--hale.",
               "_strongs": "02694"
            },
            {
               "strongs": "2695",
               "greek": [
                  {
                     "_BETA": "KATASFA/TTW",
                     "_unicode": "κατασφάττω",
                     "_translit": "kataspháttō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-fat'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4969"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to kill down, i.e. slaughter",
               "kjv_def": ":--slay.",
               "_strongs": "02695"
            },
            {
               "strongs": "2696",
               "greek": [
                  {
                     "_BETA": "KATASFRAGI/ZW",
                     "_unicode": "κατασφραγίζω",
                     "_translit": "katasphragízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as-frag-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4972"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to seal closely",
               "kjv_def": ":--seal.",
               "_strongs": "02696"
            },
            {
               "strongs": "2697",
               "greek": [
                  {
                     "_BETA": "KATA/SXESIS",
                     "_unicode": "κατάσχεσις",
                     "_translit": "katáschesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-as'-khes-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2722"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a holding down, i.e. occupancy",
               "kjv_def": ":--possession.",
               "_strongs": "02697"
            },
            {
               "strongs": "2698",
               "greek": [
                  {
                     "_BETA": "KATATI/QHMI",
                     "_unicode": "κατατίθημι",
                     "_translit": "katatíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-at-ith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to place down, i.e. deposit (literally or\n figuratively)",
               "kjv_def": ":--do, lay, shew.",
               "_strongs": "02698"
            },
            {
               "strongs": "2699",
               "greek": [
                  {
                     "_BETA": "KATATOMH/",
                     "_unicode": "κατατομή",
                     "_translit": "katatomḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-at-om-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TE/MNW",
                        "_unicode": "τέμνω",
                        "_translit": "témnō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to cut);"
               },
               "strongs_def": "a cutting down (off), i.e.\n mutilation (ironically)",
               "kjv_def": ":--concision.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "609"
                  }
               ],
               "_strongs": "02699",
               "__text": "Compare \n."
            },
            {
               "strongs": "2700",
               "greek": [
                  {
                     "_BETA": "KATATOCEU/W",
                     "_unicode": "κατατοξεύω",
                     "_translit": "katatoxeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-at-ox-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5115"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to shoot down with an arrow or\n other missile",
               "kjv_def": ":--thrust through.",
               "_strongs": "02700"
            },
            {
               "strongs": "2701",
               "greek": [
                  {
                     "_BETA": "KATATRE/XW",
                     "_unicode": "κατατρέχω",
                     "_translit": "katatréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-at-rekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to run down, i.e. hasten from a tower",
               "kjv_def": ":--run down.",
               "_strongs": "02701"
            },
            {
               "strongs": "2702",
               "greek": [
                  {
                     "_BETA": "KATAFE/RW",
                     "_unicode": "καταφέρω",
                     "_translit": "kataphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-af-er'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to bear down, i.e.\n (figuratively) overcome (with drowsiness); specially, to cast a\n vote",
               "kjv_def": ":--fall, give, sink down.",
               "_strongs": "02702"
            },
            {
               "strongs": "2703",
               "greek": [
                  {
                     "_BETA": "KATAFEU/GW",
                     "_unicode": "καταφεύγω",
                     "_translit": "katapheúgō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-af-yoo'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5343"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to flee down (away)",
               "kjv_def": ":--flee.",
               "_strongs": "02703"
            },
            {
               "strongs": "2704",
               "greek": [
                  {
                     "_BETA": "KATAFQEI/RW",
                     "_unicode": "καταφθείρω",
                     "_translit": "kataphtheírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-af-thi'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5351"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to spoil entirely, i.e. (literally) to destroy; or\n (figuratively) to deprave;",
               "kjv_def": "--corrupt, utterly perish.",
               "_strongs": "02704"
            },
            {
               "strongs": "2705",
               "greek": [
                  {
                     "_BETA": "KATAFILE/W",
                     "_unicode": "καταφιλέω",
                     "_translit": "kataphiléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-af-ee-leh'-o"
                  }
               ],
               "strongs_derivation": "from 2596 and 5368;",
               "strongs_def": "to kiss earnestly",
               "kjv_def": ":--kiss.",
               "_strongs": "02705"
            },
            {
               "strongs": "2706",
               "greek": [
                  {
                     "_BETA": "KATAFRONE/W",
                     "_unicode": "καταφρονέω",
                     "_translit": "kataphronéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-af-ron-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5426"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to think against, i.e. disesteem",
               "kjv_def": ":--despise.",
               "_strongs": "02706"
            },
            {
               "strongs": "2707",
               "greek": [
                  {
                     "_BETA": "KATAFRONTH/S",
                     "_unicode": "καταφροντής",
                     "_translit": "kataphrontḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-af-ron-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2706"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a contemner",
               "kjv_def": ":--despiser.",
               "_strongs": "02707"
            },
            {
               "strongs": "2708",
               "greek": [
                  {
                     "_BETA": "KATAXE/W",
                     "_unicode": "καταχέω",
                     "_translit": "katachéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-akh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "__text": "from \n and cheo (to pour);"
               },
               "strongs_def": "to pour down (out)",
               "kjv_def": ":--pour.",
               "_strongs": "02708"
            },
            {
               "strongs": "2709",
               "greek": [
                  {
                     "_BETA": "KATAXQO/NIOS",
                     "_unicode": "καταχθόνιος",
                     "_translit": "katachthónios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-akh-thon'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "XQW/N",
                        "_unicode": "χθών",
                        "_translit": "chthṓn"
                     }
                  ],
                  "__text": "from \n and \n (the ground);"
               },
               "strongs_def": "subterranean, i.e. infernal\n (belonging to the world of departed spirits)",
               "kjv_def": ":--under the earth.",
               "_strongs": "02709"
            },
            {
               "strongs": "2710",
               "greek": [
                  {
                     "_BETA": "KATAXRA/OMAI",
                     "_unicode": "καταχράομαι",
                     "_translit": "katachráomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-akh-rah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to overuse, i.e. misuse",
               "kjv_def": ":--abuse.",
               "_strongs": "02710"
            },
            {
               "strongs": "2711",
               "greek": [
                  {
                     "_BETA": "KATAYU/XW",
                     "_unicode": "καταψύχω",
                     "_translit": "katapsýchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ap-soo'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5594"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to cool down (off), i.e. refresh",
               "kjv_def": ":--cool.",
               "_strongs": "02711"
            },
            {
               "strongs": "2712",
               "greek": [
                  {
                     "_BETA": "KATEI/DWLOS",
                     "_unicode": "κατείδωλος",
                     "_translit": "kateídōlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-i'-do-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1497"
                     }
                  ],
                  "__text": "from \n (intensively) and \n;"
               },
               "strongs_def": "utterly idolatrous",
               "kjv_def": ":--wholly given to\n idolatry.",
               "_strongs": "02712"
            },
            {
               "strongs": "2713",
               "greek": [
                  {
                     "_BETA": "KATE/NANTI",
                     "_unicode": "κατέναντι",
                     "_translit": "katénanti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-en'-an-tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1725"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "directly opposite",
               "kjv_def": ":--before, over against.",
               "_strongs": "02713"
            },
            {
               "strongs": "2714",
               "greek": [
                  {
                     "_BETA": "KATENW/PION",
                     "_unicode": "κατενώπιον",
                     "_translit": "katenṓpion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-en-o'-pee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1799"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "directly in front of",
               "kjv_def": ":--before (the presence of),\n in the sight of.",
               "_strongs": "02714"
            },
            {
               "strongs": "2715",
               "greek": [
                  {
                     "_BETA": "KATECOUSIA/ZW",
                     "_unicode": "κατεξουσιάζω",
                     "_translit": "katexousiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ex-oo-see-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1850"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to have (wield) full privilege over",
               "kjv_def": ":--exercise\n authority.",
               "_strongs": "02715"
            },
            {
               "strongs": "2716",
               "greek": [
                  {
                     "_BETA": "KATERGA/ZOMAI",
                     "_unicode": "κατεργάζομαι",
                     "_translit": "katergázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-er-gad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2038"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to work fully, i.e. accomplish; by implication, to\n finish, fashion",
               "kjv_def": ":--cause, to (deed), perform, work (out).",
               "_strongs": "02716"
            },
            {
               "strongs": "2717",
               "_strongs": "02717",
               "__text": "Not Used"
            },
            {
               "strongs": "2718",
               "greek": [
                  {
                     "_BETA": "KATE/RXOMAI",
                     "_unicode": "κατέρχομαι",
                     "_translit": "katérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to come (or go) down\n (literally or figuratively)",
               "kjv_def": ":--come (down), depart, descend, go down,\n land.",
               "_strongs": "02718"
            },
            {
               "strongs": "2719",
               "greek": [
                  {
                     "_BETA": "KATESQI/W",
                     "_unicode": "κατεσθίω",
                     "_translit": "katesthíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-es-thee'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2068"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to eat down, i.e. devour\n (literally or figuratively)",
               "kjv_def": ":--devour.",
               "_strongs": "02719"
            },
            {
               "strongs": "2720",
               "greek": [
                  {
                     "_BETA": "KATEUQU/NW",
                     "_unicode": "κατευθύνω",
                     "_translit": "kateuthýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-yoo-thoo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2116"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to straighten fully, i.e. (figuratively)\n direct",
               "kjv_def": ":--guide, direct.",
               "_strongs": "02720"
            },
            {
               "strongs": "2721",
               "greek": [
                  {
                     "_BETA": "KATEFI/STHMI",
                     "_unicode": "κατεφίστημι",
                     "_translit": "katephístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ef-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2186"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand over against, i.e. rush upon\n (assault)",
               "kjv_def": ":--make insurrection against.",
               "_strongs": "02721"
            },
            {
               "strongs": "2722",
               "greek": [
                  {
                     "_BETA": "KATE/XW",
                     "_unicode": "κατέχω",
                     "_translit": "katéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hold down (fast), in various applications\n (literally or figuratively)",
               "kjv_def": ":--have, hold (fast), keep (in memory),\n let, X make toward, possess, retain, seize on, stay, take, withhold.",
               "_strongs": "02722"
            },
            {
               "strongs": "2723",
               "greek": [
                  {
                     "_BETA": "KATHGORE/W",
                     "_unicode": "κατηγορέω",
                     "_translit": "katēgoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ay-gor-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2725"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a plaintiff, i.e. to charge with some\n offence",
               "kjv_def": ":--accuse, object.",
               "_strongs": "02723"
            },
            {
               "strongs": "2724",
               "greek": [
                  {
                     "_BETA": "KATHGORI/A",
                     "_unicode": "κατηγορία",
                     "_translit": "katēgoría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ay-gor-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2725"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a complaint (\"category\"), i.e. criminal charge",
               "kjv_def": ":--accusation\n (X -ed).",
               "_strongs": "02724"
            },
            {
               "strongs": "2725",
               "greek": [
                  {
                     "_BETA": "KATH/GOROS",
                     "_unicode": "κατήγορος",
                     "_translit": "katḗgoros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ay'-gor-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "against one in the assembly, i.e. a complainant at\n law; specially, Satan",
               "kjv_def": ":--accuser.",
               "_strongs": "02725"
            },
            {
               "strongs": "2726",
               "greek": [
                  {
                     "_BETA": "KATH/FEIA",
                     "_unicode": "κατήφεια",
                     "_translit": "katḗpheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ay'-fi-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from a compound of \n and perhaps a derivative of the base of \n\n (meaning downcast in look);"
               },
               "strongs_def": "demureness, i.e. (by implication)\n sadness",
               "kjv_def": ":--heaviness.",
               "_strongs": "02726"
            },
            {
               "strongs": "2727",
               "greek": [
                  {
                     "_BETA": "KATHXE/W",
                     "_unicode": "κατηχέω",
                     "_translit": "katēchéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ay-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2279"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sound down into the ears, i.e. (by implication)\n to indoctrinate (\"catechize\") or (genitive case) to apprise\n of",
               "kjv_def": ":--inform, instruct, teach.",
               "_strongs": "02727"
            },
            {
               "strongs": "2728",
               "greek": [
                  {
                     "_BETA": "KATIO/W",
                     "_unicode": "κατιόω",
                     "_translit": "katióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-ee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2447"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to rust down, i.e.\n corrode",
               "kjv_def": ":--canker.",
               "_strongs": "02728"
            },
            {
               "strongs": "2729",
               "greek": [
                  {
                     "_BETA": "KATISXU/W",
                     "_unicode": "κατισχύω",
                     "_translit": "katischýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-is-khoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2480"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to overpower",
               "kjv_def": ":--prevail (against).",
               "_strongs": "02729"
            },
            {
               "strongs": "2730",
               "greek": [
                  {
                     "_BETA": "KATOIKE/W",
                     "_unicode": "κατοικέω",
                     "_translit": "katoikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-oy-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to house permanently, i.e. reside (literally or\n figuratively)",
               "kjv_def": ":--dwell(-er), inhabitant(-ter).",
               "_strongs": "02730"
            },
            {
               "strongs": "2731",
               "greek": [
                  {
                     "_BETA": "KATOI/KHSIS",
                     "_unicode": "κατοίκησις",
                     "_translit": "katoíkēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-oy'-kay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2730"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "residence (properly, the act; but by implication,\n concretely, the mansion)",
               "kjv_def": ":--dwelling.",
               "_strongs": "02731"
            },
            {
               "strongs": "2732",
               "greek": [
                  {
                     "_BETA": "KATOIKHTH/RION",
                     "_unicode": "κατοικητήριον",
                     "_translit": "katoikētḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-oy-kay-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2730"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a dwelling-place",
               "kjv_def": ":--habitation.",
               "_strongs": "02732"
            },
            {
               "strongs": "2733",
               "greek": [
                  {
                     "_BETA": "KATOIKI/A",
                     "_unicode": "κατοικία",
                     "_translit": "katoikía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-oy-kee'-ah"
                  }
               ],
               "strongs_def": "residence (properly, the condition; but by implication, the\n abode itself)",
               "kjv_def": ":--habitation.",
               "_strongs": "02733"
            },
            {
               "strongs": "2734",
               "greek": [
                  {
                     "_BETA": "KATOPTRI/ZOMAI",
                     "_unicode": "κατοπτρίζομαι",
                     "_translit": "katoptrízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-op-trid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2072"
                     }
                  ],
                  "__text": "middle voice from a compound of \n and a derivative of \n (compare\n \n);"
               },
               "strongs_def": "to mirror oneself, i.e. to see reflected\n (figuratively)",
               "kjv_def": ":--behold as in a glass.",
               "_strongs": "02734"
            },
            {
               "strongs": "2735",
               "greek": [
                  {
                     "_BETA": "KATO/RQWMA",
                     "_unicode": "κατόρθωμα",
                     "_translit": "katórthōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-or'-tho-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3717"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1357"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n (compare \n);"
               },
               "strongs_def": "something made fully upright, i.e. (figuratively) rectification\n (specially, good public administration)",
               "kjv_def": ":--very worthy deed.",
               "_strongs": "02735"
            },
            {
               "strongs": "2736",
               "greek": [
                  {
                     "_BETA": "KA/TW",
                     "_unicode": "κάτω",
                     "_translit": "kátō"
                  },
                  {
                     "_BETA": "KATWTE/RW",
                     "_unicode": "κατωτέρω",
                     "_translit": "katōtérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat'-o"
                  },
                  {
                     "_strongs": "kat-o-ter'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2737"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "__text": "(compare \n); adverb from \n;"
               },
               "strongs_def": "downwards",
               "kjv_def": ":--beneath, bottom, down,\n under.",
               "_strongs": "02736",
               "__text": ";       also (compare)"
            },
            {
               "strongs": "2737",
               "greek": [
                  {
                     "_BETA": "KATW/TEROS",
                     "_unicode": "κατώτερος",
                     "_translit": "katṓteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kat-o'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2736"
                     }
                  ],
                  "__text": "comparative from \n;"
               },
               "strongs_def": "inferior (locally, of Hades)",
               "kjv_def": ":--lower.",
               "_strongs": "02737"
            },
            {
               "strongs": "2738",
               "greek": [
                  {
                     "_BETA": "KAU=MA",
                     "_unicode": "καῦμα",
                     "_translit": "kaûma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2545"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a burn (concretely), but used (abstractly) of a\n glow",
               "kjv_def": ":--heat.",
               "_strongs": "02738"
            },
            {
               "strongs": "2739",
               "greek": [
                  {
                     "_BETA": "KAUMATI/ZW",
                     "_unicode": "καυματίζω",
                     "_translit": "kaumatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow-mat-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2738"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to burn",
               "kjv_def": ":--scorch.",
               "_strongs": "02739"
            },
            {
               "strongs": "2740",
               "greek": [
                  {
                     "_BETA": "KAU=SIS",
                     "_unicode": "καῦσις",
                     "_translit": "kaûsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2545"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "burning (the act)",
               "kjv_def": ":--be burned.",
               "_strongs": "02740"
            },
            {
               "strongs": "2741",
               "greek": [
                  {
                     "_BETA": "KAUSO/W",
                     "_unicode": "καυσόω",
                     "_translit": "kausóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow-so'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2740"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to set on fire",
               "kjv_def": ":--fervent heat.",
               "_strongs": "02741"
            },
            {
               "strongs": "2742",
               "greek": [
                  {
                     "_BETA": "KAU/SWN",
                     "_unicode": "καύσων",
                     "_translit": "kaúsōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow'-sone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2741"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a glare",
               "kjv_def": ":--(burning) heat.",
               "_strongs": "02742"
            },
            {
               "strongs": "2743",
               "greek": [
                  {
                     "_BETA": "KAUTHRIA/ZW",
                     "_unicode": "καυτηριάζω",
                     "_translit": "kautēriázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow-tay-ree-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2545"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to brand (\"cauterize\"), i.e. (by\n implication) to render unsensitive (figuratively)",
               "kjv_def": ":--sear with a hot\n iron.",
               "_strongs": "02743"
            },
            {
               "strongs": "2744",
               "greek": [
                  {
                     "_BETA": "KAUXA/OMAI",
                     "_unicode": "καυχάομαι",
                     "_translit": "kaucháomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow-khah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "AU)XE/W",
                        "_unicode": "αὐχέω",
                        "_translit": "auchéō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2172"
                     }
                  ],
                  "__text": "from some (obsolete) base akin to that of \n (to boast) and \n;"
               },
               "strongs_def": "to vaunt (in a good or a bad sense)",
               "kjv_def": ":--(make) boast, glory, joy,\n rejoice.",
               "_strongs": "02744"
            },
            {
               "strongs": "2745",
               "greek": [
                  {
                     "_BETA": "KAU/XHMA",
                     "_unicode": "καύχημα",
                     "_translit": "kaúchēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow'-khay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2744"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a boast (properly, the object; by implication, the act) in\n a good or a bad sense",
               "kjv_def": ":--boasting, (whereof) to glory (of), glorying,\n rejoice(-ing).",
               "_strongs": "02745"
            },
            {
               "strongs": "2746",
               "greek": [
                  {
                     "_BETA": "KAU/XHSIS",
                     "_unicode": "καύχησις",
                     "_translit": "kaúchēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kow'-khay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2744"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "boasting (properly, the act; by implication, the object),\n in a good or a bad sense",
               "kjv_def": ":--boasting, whereof I may glory, glorying,\n rejoicing.",
               "_strongs": "02746"
            },
            {
               "strongs": "2747",
               "greek": [
                  {
                     "_BETA": "*KEGXREAI/",
                     "_unicode": "Κεγχρεαί",
                     "_translit": "Kenchreaí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "keng-khreh-a'-hee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KE/GXROS",
                        "_unicode": "κέγχρος",
                        "_translit": "kénchros"
                     }
                  ],
                  "__text": "probably from \n (millet);"
               },
               "strongs_def": "Cenchreæ, a port of\n Corinth",
               "kjv_def": ":--Cencrea.",
               "_strongs": "02747"
            },
            {
               "strongs": "2748",
               "greek": [
                  {
                     "_BETA": "*KEDRW/N",
                     "_unicode": "Κεδρών",
                     "_translit": "Kedrṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ked-rone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06939"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Cedron (i.e. Kidron), a brook near\n Jerusalem",
               "kjv_def": ":--Cedron.",
               "_strongs": "02748"
            },
            {
               "strongs": "2749",
               "greek": [
                  {
                     "_BETA": "KEI=MAI",
                     "_unicode": "κεῖμαι",
                     "_translit": "keîmai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ki'-mahee"
                  }
               ],
               "strongs_derivation": "middle voice of a primary verb;",
               "strongs_def": "to lie outstretched (literally or\n figuratively)",
               "kjv_def": ":--be (appointed, laid up, made, set), lay, lie.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5087"
                  }
               ],
               "_strongs": "02749",
               "__text": "Compare\n \n."
            },
            {
               "strongs": "2750",
               "greek": [
                  {
                     "_BETA": "KEIRI/A",
                     "_unicode": "κειρία",
                     "_translit": "keiría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ki-ree'-ah"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a swathe, i.e. winding-sheet",
               "kjv_def": ":--graveclothes.",
               "_strongs": "02750"
            },
            {
               "strongs": "2751",
               "greek": [
                  {
                     "_BETA": "KEI/RW",
                     "_unicode": "κείρω",
                     "_translit": "keírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ki'-ro"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to shear",
               "kjv_def": ":--shear(-er).",
               "_strongs": "02751"
            },
            {
               "strongs": "2752",
               "greek": [
                  {
                     "_BETA": "KE/LEUMA",
                     "_unicode": "κέλευμα",
                     "_translit": "kéleuma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kel'-yoo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2753"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a cry of incitement",
               "kjv_def": ":--shout.",
               "_strongs": "02752"
            },
            {
               "strongs": "2753",
               "greek": [
                  {
                     "_BETA": "KELEU/W",
                     "_unicode": "κελεύω",
                     "_translit": "keleúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kel-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KE/LLW",
                        "_unicode": "κέλλω",
                        "_translit": "kéllō"
                     }
                  ],
                  "__text": "from a primary \n (to urge on);"
               },
               "strongs_def": "\"hail\"; to incite by word, i.e.\n order",
               "kjv_def": ":--bid, (at, give) command(-ment).",
               "_strongs": "02753"
            },
            {
               "strongs": "2754",
               "greek": [
                  {
                     "_BETA": "KENODOCI/A",
                     "_unicode": "κενοδοξία",
                     "_translit": "kenodoxía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ken-od-ox-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2755"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "empty glorying, i.e. self-conceit",
               "kjv_def": ":--vain-glory.",
               "_strongs": "02754"
            },
            {
               "strongs": "2755",
               "greek": [
                  {
                     "_BETA": "KENO/DOCOS",
                     "_unicode": "κενόδοξος",
                     "_translit": "kenódoxos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ken-od'-ox-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1391"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "vainly glorifying, i.e. self-conceited",
               "kjv_def": ":--desirous\n of vain-glory.",
               "_strongs": "02755"
            },
            {
               "strongs": "2756",
               "greek": [
                  {
                     "_BETA": "KENO/S",
                     "_unicode": "κενός",
                     "_translit": "kenós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ken-os'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "empty (literally or figuratively)",
               "kjv_def": ":--empty,\n (in) vain.",
               "_strongs": "02756"
            },
            {
               "strongs": "2757",
               "greek": [
                  {
                     "_BETA": "KENOFWNI/A",
                     "_unicode": "κενοφωνία",
                     "_translit": "kenophōnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ken-of-o-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5456"
                     }
                  ],
                  "__text": "from a presumed compound of \n and \n;"
               },
               "strongs_def": "empty sounding, i.e.\n fruitless discussion",
               "kjv_def": ":--vain.",
               "_strongs": "02757"
            },
            {
               "strongs": "2758",
               "greek": [
                  {
                     "_BETA": "KENO/W",
                     "_unicode": "κενόω",
                     "_translit": "kenóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ken-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2756"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make empty, i.e. (figuratively) to abase, neutralize,\n falsify",
               "kjv_def": ":--make (of none effect, of no reputation, void), be in vain.",
               "_strongs": "02758"
            },
            {
               "strongs": "2759",
               "greek": [
                  {
                     "_BETA": "KE/NTRON",
                     "_unicode": "κέντρον",
                     "_translit": "kéntron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ken'-tron"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KENTE/W",
                        "_unicode": "κεντέω",
                        "_translit": "kentéō"
                     }
                  ],
                  "__text": "from \n (to prick);"
               },
               "strongs_def": "a point (\"centre\"), i.e. a sting\n (figuratively, poison) or goad (figuratively, divine impulse)",
               "kjv_def": ":--prick,\n sting.",
               "_strongs": "02759"
            },
            {
               "strongs": "2760",
               "greek": [
                  {
                     "_BETA": "KENTURI/WN",
                     "_unicode": "κεντυρίων",
                     "_translit": "kentyríōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ken-too-ree'-ohn"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a centurion, i.e. captain of one hundred\n soldiers",
               "kjv_def": ":--centurion.",
               "_strongs": "02760"
            },
            {
               "strongs": "2761",
               "greek": [
                  {
                     "_BETA": "KENW=S",
                     "_unicode": "κενῶς",
                     "_translit": "kenōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ken-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2756"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "vainly, i.e. to no purpose",
               "kjv_def": ":--in vain.",
               "_strongs": "02761"
            },
            {
               "strongs": "2762",
               "greek": [
                  {
                     "_BETA": "KERAI/A",
                     "_unicode": "κεραία",
                     "_translit": "keraía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker-ah'-yah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2768"
                     }
                  ],
                  "__text": "feminine of a presumed derivative of the base of \n;"
               },
               "strongs_def": "something\n horn-like, i.e. (specially) the apex of a Hebrew letter (figuratively,\n the least particle)",
               "kjv_def": ":--tittle.",
               "_strongs": "02762"
            },
            {
               "strongs": "2763",
               "greek": [
                  {
                     "_BETA": "KERAMEU/S",
                     "_unicode": "κεραμεύς",
                     "_translit": "kerameús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker-am-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2766"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a potter",
               "kjv_def": ":--potter.",
               "_strongs": "02763"
            },
            {
               "strongs": "2764",
               "greek": [
                  {
                     "_BETA": "KERAMIKO/S",
                     "_unicode": "κεραμικός",
                     "_translit": "keramikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker-am-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2766"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "made of clay, i.e. earthen",
               "kjv_def": ":--of a potter.",
               "_strongs": "02764"
            },
            {
               "strongs": "2765",
               "greek": [
                  {
                     "_BETA": "KERA/MION",
                     "_unicode": "κεράμιον",
                     "_translit": "kerámion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker-am'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2766"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "an earthenware vessel, i.e.\n jar",
               "kjv_def": ":--pitcher.",
               "_strongs": "02765"
            },
            {
               "strongs": "2766",
               "greek": [
                  {
                     "_BETA": "KE/RAMOS",
                     "_unicode": "κέραμος",
                     "_translit": "kéramos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker'-am-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2767"
                     }
                  ],
                  "__text": "probably from the base of \n (through the idea of mixing clay and\n water);"
               },
               "strongs_def": "earthenware, i.e. a tile (by analogy, a thin roof or\n awning)",
               "kjv_def": ":--tiling.",
               "_strongs": "02766"
            },
            {
               "strongs": "2767",
               "greek": [
                  {
                     "_BETA": "KERA/NNUMI",
                     "_unicode": "κεράννυμι",
                     "_translit": "keránnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker-an'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KERA/W",
                        "_unicode": "κεράω",
                        "_translit": "keráō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "ker-ah'-o"
                     }
                  ],
                  "__text": "prolonged form of a more primary \n \n (which is used in\n certain tenses);"
               },
               "strongs_def": "to mingle, i.e. (by implication) to pour out (for\n drinking)",
               "kjv_def": ":--fill, pour out.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3396"
                  }
               ],
               "_strongs": "02767",
               "__text": "Compare \n."
            },
            {
               "strongs": "2768",
               "greek": [
                  {
                     "_BETA": "KE/RAS",
                     "_unicode": "κέρας",
                     "_translit": "kéras"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker'-as"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KA/R",
                        "_unicode": "κάρ",
                        "_translit": "kár"
                     }
                  ],
                  "__text": "from a primary \n (the hair of the head);"
               },
               "strongs_def": "a horn (literally or\n figuratively)",
               "kjv_def": ":--horn.",
               "_strongs": "02768"
            },
            {
               "strongs": "2769",
               "greek": [
                  {
                     "_BETA": "KERA/TION",
                     "_unicode": "κεράτιον",
                     "_translit": "kerátion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker-at'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2768"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "something horned, i.e.\n (specially) the pod of the carob-tree",
               "kjv_def": ":--husk.",
               "_strongs": "02769"
            },
            {
               "strongs": "2770",
               "greek": [
                  {
                     "_BETA": "KERDAI/NW",
                     "_unicode": "κερδαίνω",
                     "_translit": "kerdaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker-dah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2771"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to gain (literally or figuratively)",
               "kjv_def": ":--(get) gain, win.",
               "_strongs": "02770"
            },
            {
               "strongs": "2771",
               "greek": [
                  {
                     "_BETA": "KE/RDOS",
                     "_unicode": "κέρδος",
                     "_translit": "kérdos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker'-dos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "gain (pecuniary or genitive case)",
               "kjv_def": ":--gain,\n lucre.",
               "_strongs": "02771"
            },
            {
               "strongs": "2772",
               "greek": [
                  {
                     "_BETA": "KE/RMA",
                     "_unicode": "κέρμα",
                     "_translit": "kérma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2751"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a clipping (bit), i.e. (specially) a coin",
               "kjv_def": ":--money.",
               "_strongs": "02772"
            },
            {
               "strongs": "2773",
               "greek": [
                  {
                     "_BETA": "KERMATISTH/S",
                     "_unicode": "κερματιστής",
                     "_translit": "kermatistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ker-mat-is-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2772"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a handler of coins, i.e.\n money-broker",
               "kjv_def": ":--changer of money.",
               "_strongs": "02773"
            },
            {
               "strongs": "2774",
               "greek": [
                  {
                     "_BETA": "KEFA/LAION",
                     "_unicode": "κεφάλαιον",
                     "_translit": "kephálaion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kef-al'-ah-yon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2776"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "a principal thing, i.e. main point;\n specially, an amount (of money)",
               "kjv_def": ":--sum.",
               "_strongs": "02774"
            },
            {
               "strongs": "2775",
               "greek": [
                  {
                     "_BETA": "KEFALAIO/W",
                     "_unicode": "κεφαλαιόω",
                     "_translit": "kephalaióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kef-al-ahee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2774"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "(specially) to strike on the head",
               "kjv_def": ":--wound in\n the head.",
               "_strongs": "02775"
            },
            {
               "strongs": "2776",
               "greek": [
                  {
                     "_BETA": "KEFALH/",
                     "_unicode": "κεφαλή",
                     "_translit": "kephalḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kef-al-ay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KA/PTW",
                        "_unicode": "κάπτω",
                        "_translit": "káptō"
                     }
                  ],
                  "__text": "from the primary \n (in the sense of seizing);"
               },
               "strongs_def": "the head (as the\n part most readily taken hold of), literally or figuratively",
               "kjv_def": ":--head.",
               "_strongs": "02776"
            },
            {
               "strongs": "2777",
               "greek": [
                  {
                     "_BETA": "KEFALI/S",
                     "_unicode": "κεφαλίς",
                     "_translit": "kephalís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kef-al-is'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2776"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, a knob, i.e. (by implication) a roll (by\n extension from the end of a stick on which the manuscript was\n rolled)",
               "kjv_def": ":--volume.",
               "_strongs": "02777"
            },
            {
               "strongs": "2778",
               "greek": [
                  {
                     "_BETA": "KH=NSOS",
                     "_unicode": "κῆνσος",
                     "_translit": "kēnsos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kane'-sos"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "properly, an enrollment (\"census\"), i.e. (by\n implication) a tax",
               "kjv_def": ":--tribute.",
               "_strongs": "02778"
            },
            {
               "strongs": "2779",
               "greek": [
                  {
                     "_BETA": "KH=POS",
                     "_unicode": "κῆπος",
                     "_translit": "kēpos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kay'-pos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a garden",
               "kjv_def": ":--garden.",
               "_strongs": "02779"
            },
            {
               "strongs": "2780",
               "greek": [
                  {
                     "_BETA": "KHPOURO/S",
                     "_unicode": "κηπουρός",
                     "_translit": "kēpourós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kay-poo-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2779"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "OU)=ROS",
                        "_unicode": "οὖρος",
                        "_translit": "oûros"
                     }
                  ],
                  "__text": "from \n and \n (a warden);"
               },
               "strongs_def": "a garden-keeper, i.e.\n gardener",
               "kjv_def": ":--gardener.",
               "_strongs": "02780"
            },
            {
               "strongs": "2781",
               "greek": [
                  {
                     "_BETA": "KHRI/ON",
                     "_unicode": "κηρίον",
                     "_translit": "kēríon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kay-ree'-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KHO/S",
                        "_unicode": "κηός",
                        "_translit": "kēós"
                     }
                  ],
                  "__text": "diminutive from \n (wax);"
               },
               "strongs_def": "a cell for honey, i.e. (collectively) the\n comb",
               "kjv_def": ":--(honey-)comb.",
               "_strongs": "02781"
            },
            {
               "strongs": "2782",
               "greek": [
                  {
                     "_BETA": "KH/RUGMA",
                     "_unicode": "κήρυγμα",
                     "_translit": "kḗrygma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kay'-roog-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2784"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a proclamation (especially of the gospel; by implication,\n the gospel itself)",
               "kjv_def": ":--preaching.",
               "_strongs": "02782"
            },
            {
               "strongs": "2783",
               "greek": [
                  {
                     "_BETA": "KH=RUC",
                     "_unicode": "κῆρυξ",
                     "_translit": "kēryx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kay'-roox"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2784"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a herald, i.e. of divine truth (especially of the\n gospel)",
               "kjv_def": ":--preacher.",
               "_strongs": "02783"
            },
            {
               "strongs": "2784",
               "greek": [
                  {
                     "_BETA": "KHRU/SSW",
                     "_unicode": "κηρύσσω",
                     "_translit": "kērýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kay-roos'-so"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to herald (as a public crier), especially\n divine truth (the gospel)",
               "kjv_def": ":--preacher(-er), proclaim, publish.",
               "_strongs": "02784"
            },
            {
               "strongs": "2785",
               "greek": [
                  {
                     "_BETA": "KH=TOS",
                     "_unicode": "κῆτος",
                     "_translit": "kētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kay'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5490"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "a huge fish (as gaping for\n prey)",
               "kjv_def": ":--whale.",
               "_strongs": "02785"
            },
            {
               "strongs": "2786",
               "greek": [
                  {
                     "_BETA": "*KHFA=S",
                     "_unicode": "Κηφᾶς",
                     "_translit": "Kēphâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kay-fas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03710"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "the Rock; Cephas (i.e. Kepha), a\n surname of Peter",
               "kjv_def": ":--Cephas.",
               "_strongs": "02786"
            },
            {
               "strongs": "2787",
               "greek": [
                  {
                     "_BETA": "KIBWTO/S",
                     "_unicode": "κιβωτός",
                     "_translit": "kibōtós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kib-o-tos'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a box, i.e. the sacred ark and that of\n Noah",
               "kjv_def": ":--ark.",
               "_strongs": "02787"
            },
            {
               "strongs": "2788",
               "greek": [
                  {
                     "_BETA": "KIQA/RA",
                     "_unicode": "κιθάρα",
                     "_translit": "kithára"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kith-ar'-ah"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a lyre",
               "kjv_def": ":--harp.",
               "_strongs": "02788"
            },
            {
               "strongs": "2789",
               "greek": [
                  {
                     "_BETA": "KIQARI/ZW",
                     "_unicode": "κιθαρίζω",
                     "_translit": "kitharízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kith-ar-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2788"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to play on a lyre",
               "kjv_def": ":--harp.",
               "_strongs": "02789"
            },
            {
               "strongs": "2790",
               "greek": [
                  {
                     "_BETA": "KIQARW|DO/S",
                     "_unicode": "κιθαρῳδός",
                     "_translit": "kitharōidós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kith-ar-o'-dos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2788"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5603"
                     }
                  ],
                  "__text": "from \n and a derivative of the same as \n;"
               },
               "strongs_def": "a\n lyre-singer(-player), i.e. harpist",
               "kjv_def": ":--harper.",
               "_strongs": "02790"
            },
            {
               "strongs": "2791",
               "greek": [
                  {
                     "_BETA": "*KILIKI/A",
                     "_unicode": "Κιλικία",
                     "_translit": "Kilikía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kil-ik-ee'-ah"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Cilicia, a region of Asia Minor",
               "kjv_def": ":--Cilicia.",
               "_strongs": "02791"
            },
            {
               "strongs": "2792",
               "greek": [
                  {
                     "_BETA": "KINA/MWMON",
                     "_unicode": "κινάμωμον",
                     "_translit": "kinámōmon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kin-am'-o-mon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07076"
                     }
                  ],
                  "__text": "of foreign origin (compare \n);"
               },
               "strongs_def": "cinnamon",
               "kjv_def": ":--cinnamon.",
               "_strongs": "02792"
            },
            {
               "strongs": "2793",
               "greek": [
                  {
                     "_BETA": "KINDUNEU/W",
                     "_unicode": "κινδυνεύω",
                     "_translit": "kindyneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kin-doon-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2794"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to undergo peril",
               "kjv_def": ":--be in danger, be (stand) in jeopardy.",
               "_strongs": "02793"
            },
            {
               "strongs": "2794",
               "greek": [
                  {
                     "_BETA": "KI/NDUNOS",
                     "_unicode": "κίνδυνος",
                     "_translit": "kíndynos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kin'-doo-nos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "danger",
               "kjv_def": ":--peril.",
               "_strongs": "02794"
            },
            {
               "strongs": "2795",
               "greek": [
                  {
                     "_BETA": "KINE/W",
                     "_unicode": "κινέω",
                     "_translit": "kinéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kin-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KI/W",
                        "_unicode": "κίω",
                        "_translit": "kíō"
                     },
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "from \n (poetic for \n, to go);"
               },
               "strongs_def": "to stir (transitively), literally\n or figuratively",
               "kjv_def": ":--(re-)move(-r), way.",
               "_strongs": "02795"
            },
            {
               "strongs": "2796",
               "greek": [
                  {
                     "_BETA": "KI/NHSIS",
                     "_unicode": "κίνησις",
                     "_translit": "kínēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kin'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2795"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a stirring",
               "kjv_def": ":--moving.",
               "_strongs": "02796"
            },
            {
               "strongs": "2797",
               "greek": [
                  {
                     "_BETA": "*KI/S",
                     "_unicode": "Κίς",
                     "_translit": "Kís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07027"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Cis (i.e. Kish), an Israelite",
               "kjv_def": ":--Cis.",
               "_strongs": "02797"
            },
            {
               "strongs": "2798",
               "greek": [
                  {
                     "_BETA": "KLA/DOS",
                     "_unicode": "κλάδος",
                     "_translit": "kládos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klad'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2806"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a twig or bough (as if broken off)",
               "kjv_def": ":--branch.",
               "_strongs": "02798"
            },
            {
               "strongs": "2799",
               "greek": [
                  {
                     "_BETA": "KLAI/W",
                     "_unicode": "κλαίω",
                     "_translit": "klaíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klah'-yo"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to sob, i.e. wail aloud (whereas 1145 is rather\n to cry silently)",
               "kjv_def": ":--bewail, weep.",
               "_strongs": "02799"
            },
            {
               "strongs": "2800",
               "greek": [
                  {
                     "_BETA": "KLA/SIS",
                     "_unicode": "κλάσις",
                     "_translit": "klásis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klas'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2806"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fracture (the act)",
               "kjv_def": ":--breaking.",
               "_strongs": "02800"
            },
            {
               "strongs": "2801",
               "greek": [
                  {
                     "_BETA": "KLA/SMA",
                     "_unicode": "κλάσμα",
                     "_translit": "klásma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klas'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2806"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a piece (bit)",
               "kjv_def": ":--broken, fragment.",
               "_strongs": "02801"
            },
            {
               "strongs": "2802",
               "greek": [
                  {
                     "_BETA": "*KLAU/DH",
                     "_unicode": "Κλαύδη",
                     "_translit": "Klaúdē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klow'-day"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Claude, an island near Crete",
               "kjv_def": ":--Clauda.",
               "_strongs": "02802"
            },
            {
               "strongs": "2803",
               "greek": [
                  {
                     "_BETA": "*KLAUDI/A",
                     "_unicode": "Κλαυδία",
                     "_translit": "Klaudía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klow-dee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2804"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "Claudia, a Christian woman",
               "kjv_def": ":--Claudia.",
               "_strongs": "02803"
            },
            {
               "strongs": "2804",
               "greek": [
                  {
                     "_BETA": "*KLAU/DIOS",
                     "_unicode": "Κλαύδιος",
                     "_translit": "Klaúdios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klow'-dee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Claudius, the name of two Romans",
               "kjv_def": ":--Claudius.",
               "_strongs": "02804"
            },
            {
               "strongs": "2805",
               "greek": [
                  {
                     "_BETA": "KLAUQMO/S",
                     "_unicode": "κλαυθμός",
                     "_translit": "klauthmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klowth-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2799"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "lamentation",
               "kjv_def": ":--wailing, weeping, X wept.",
               "_strongs": "02805"
            },
            {
               "strongs": "2806",
               "greek": [
                  {
                     "_BETA": "KLA/W",
                     "_unicode": "κλάω",
                     "_translit": "kláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klah'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to break (specially, of bread)",
               "kjv_def": ":--break.",
               "_strongs": "02806"
            },
            {
               "strongs": "2807",
               "greek": [
                  {
                     "_BETA": "KLEI/S",
                     "_unicode": "κλείς",
                     "_translit": "kleís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klice"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2808"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a key (as shutting a lock), literally or\n figuratively",
               "kjv_def": ":--key.",
               "_strongs": "02807"
            },
            {
               "strongs": "2808",
               "greek": [
                  {
                     "_BETA": "KLEI/W",
                     "_unicode": "κλείω",
                     "_translit": "kleíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kli'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to close (literally or figuratively)",
               "kjv_def": ":--shut (up).",
               "_strongs": "02808"
            },
            {
               "strongs": "2809",
               "greek": [
                  {
                     "_BETA": "KLE/MMA",
                     "_unicode": "κλέμμα",
                     "_translit": "klémma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klem'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2813"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "stealing (properly, the thing stolen, but used of the\n act)",
               "kjv_def": ":--theft.",
               "_strongs": "02809"
            },
            {
               "strongs": "2810",
               "greek": [
                  {
                     "_BETA": "*KLEO/PAS",
                     "_unicode": "Κλεόπας",
                     "_translit": "Kleópas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kleh-op'-as"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*KLEO/PATROS",
                        "_unicode": "Κλεόπατρος",
                        "_translit": "Kleópatros"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2811"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     }
                  ],
                  "__text": "probably contracted from \n (compound of \n and \n);"
               },
               "strongs_def": "Cleopas, a Christian",
               "kjv_def": ":--Cleopas.",
               "_strongs": "02810"
            },
            {
               "strongs": "2811",
               "greek": [
                  {
                     "_BETA": "KLE/OS",
                     "_unicode": "κλέος",
                     "_translit": "kléos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kleh'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from a shorter form of \n;"
               },
               "strongs_def": "renown (as if being called)",
               "kjv_def": ":--glory.",
               "_strongs": "02811"
            },
            {
               "strongs": "2812",
               "greek": [
                  {
                     "_BETA": "KLE/PTHS",
                     "_unicode": "κλέπτης",
                     "_translit": "kléptēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klep'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2813"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a stealer (literally or figuratively)",
               "kjv_def": ":--thief.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3027"
                  }
               ],
               "_strongs": "02812",
               "__text": "Compare\n \n."
            },
            {
               "strongs": "2813",
               "greek": [
                  {
                     "_BETA": "KLE/PTW",
                     "_unicode": "κλέπτω",
                     "_translit": "kléptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klep'-to"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to filch",
               "kjv_def": ":--steal.",
               "_strongs": "02813"
            },
            {
               "strongs": "2814",
               "greek": [
                  {
                     "_BETA": "KLH=MA",
                     "_unicode": "κλῆμα",
                     "_translit": "klēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kaly'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2806"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a limb or shoot (as if broken off)",
               "kjv_def": ":--branch.",
               "_strongs": "02814"
            },
            {
               "strongs": "2815",
               "greek": [
                  {
                     "_BETA": "*KLH/MHS",
                     "_unicode": "Κλήμης",
                     "_translit": "Klḗmēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klay'-mace"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "merciful; Clemes (i.e. Clemens), a\n Christian",
               "kjv_def": ":--Clement.",
               "_strongs": "02815"
            },
            {
               "strongs": "2816",
               "greek": [
                  {
                     "_BETA": "KLHRONOME/W",
                     "_unicode": "κληρονομέω",
                     "_translit": "klēronoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klay-ron-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2818"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be an heir to (literally or figuratively)",
               "kjv_def": ":--be heir,\n (obtain by) inherit(-ance).",
               "_strongs": "02816"
            },
            {
               "strongs": "2817",
               "greek": [
                  {
                     "_BETA": "KLHRONOMI/A",
                     "_unicode": "κληρονομία",
                     "_translit": "klēronomía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klay-ron-om-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2818"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "heirship, i.e. (concretely) a patrimony or (genitive case)\n a possession",
               "kjv_def": ":--inheritance.",
               "_strongs": "02817"
            },
            {
               "strongs": "2818",
               "greek": [
                  {
                     "_BETA": "KLHRONO/MOS",
                     "_unicode": "κληρονόμος",
                     "_translit": "klēronómos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klay-ron-om'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2819"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from \n and the base of \n (in its original sense of partitioning,\n i.e. (reflexively) getting by apportionment);"
               },
               "strongs_def": "a sharer by lot, i.e.\n inheritor (literally or figuratively); by implication, a\n possessor",
               "kjv_def": ":--heir.",
               "_strongs": "02818"
            },
            {
               "strongs": "2819",
               "greek": [
                  {
                     "_BETA": "KLH=ROS",
                     "_unicode": "κλῆρος",
                     "_translit": "klēros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klay'-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2806"
                     }
                  ],
                  "__text": "probably from \n (through the idea of using bits of wood, etc., for\n the purpose;"
               },
               "strongs_def": "a die (for drawing chances); by implication, a portion\n (as if so secured); by extension, an acquisition (especially a\n patrimony, figuratively)",
               "kjv_def": ":--heritage, inheritance, lot, part.",
               "_strongs": "02819"
            },
            {
               "strongs": "2820",
               "greek": [
                  {
                     "_BETA": "KLHRO/W",
                     "_unicode": "κληρόω",
                     "_translit": "klēróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klay-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2819"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to allot, i.e. (figuratively) to assign (a\n privilege)",
               "kjv_def": ":--obtain an inheritance.",
               "_strongs": "02820"
            },
            {
               "strongs": "2821",
               "greek": [
                  {
                     "_BETA": "KLH=SIS",
                     "_unicode": "κλῆσις",
                     "_translit": "klēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klay'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from a shorter form of \n;"
               },
               "strongs_def": "an invitation (figuratively)",
               "kjv_def": ":--calling.",
               "_strongs": "02821"
            },
            {
               "strongs": "2822",
               "greek": [
                  {
                     "_BETA": "KLHTO/S",
                     "_unicode": "κλητός",
                     "_translit": "klētós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klay-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2821"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "invited, i.e. appointed, or (specially), a\n saint",
               "kjv_def": ":--called.",
               "_strongs": "02822"
            },
            {
               "strongs": "2823",
               "greek": [
                  {
                     "_BETA": "KLI/BANOS",
                     "_unicode": "κλίβανος",
                     "_translit": "klíbanos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klib'-an-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "an earthen pot used for baking in",
               "kjv_def": ":--oven.",
               "_strongs": "02823"
            },
            {
               "strongs": "2824",
               "greek": [
                  {
                     "_BETA": "KLI/MA",
                     "_unicode": "κλίμα",
                     "_translit": "klíma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klee'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a slope, i.e. (specially) a \"clime\" or tract of\n country",
               "kjv_def": ":--part, region.",
               "_strongs": "02824"
            },
            {
               "strongs": "2825",
               "greek": [
                  {
                     "_BETA": "KLI/NH",
                     "_unicode": "κλίνη",
                     "_translit": "klínē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klee'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a couch (for sleep, sickness, sitting or eating)",
               "kjv_def": ":--bed,\n table.",
               "_strongs": "02825"
            },
            {
               "strongs": "2826",
               "greek": [
                  {
                     "_BETA": "KLINI/DION",
                     "_unicode": "κλινίδιον",
                     "_translit": "klinídion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klin-id'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2825"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a pallet or little\n couch",
               "kjv_def": ":--bed.",
               "_strongs": "02826"
            },
            {
               "strongs": "2827",
               "greek": [
                  {
                     "_BETA": "KLI/NW",
                     "_unicode": "κλίνω",
                     "_translit": "klínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klee'-no"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to slant or slope, i.e. incline or recline (literally\n or figuratively)",
               "kjv_def": ":--bow (down), be far spent, lay, turn to flight, wear\n away.",
               "_strongs": "02827"
            },
            {
               "strongs": "2828",
               "greek": [
                  {
                     "_BETA": "KLISI/A",
                     "_unicode": "κλισία",
                     "_translit": "klisía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klee-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "properly, reclination, i.e. (concretely and\n specially), a party at a meal",
               "kjv_def": ":--company.",
               "_strongs": "02828"
            },
            {
               "strongs": "2829",
               "greek": [
                  {
                     "_BETA": "KLOPH/",
                     "_unicode": "κλοπή",
                     "_translit": "klopḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klop-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2813"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "stealing",
               "kjv_def": ":--theft.",
               "_strongs": "02829"
            },
            {
               "strongs": "2830",
               "greek": [
                  {
                     "_BETA": "KLU/DWN",
                     "_unicode": "κλύδων",
                     "_translit": "klýdōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kloo'-dohn"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KLU/ZW",
                        "_unicode": "κλύζω",
                        "_translit": "klýzō"
                     }
                  ],
                  "__text": "from \n (to billow or dash over);"
               },
               "strongs_def": "a surge of the sea (literally or\n figuratively)",
               "kjv_def": ":--raging, wave.",
               "_strongs": "02830"
            },
            {
               "strongs": "2831",
               "greek": [
                  {
                     "_BETA": "KLUDWNI/ZOMAI",
                     "_unicode": "κλυδωνίζομαι",
                     "_translit": "klydōnízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kloo-do-nid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2830"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to surge, i.e. (figuratively) to\n fluctuate",
               "kjv_def": ":--toss to and fro.",
               "_strongs": "02831"
            },
            {
               "strongs": "2832",
               "greek": [
                  {
                     "_BETA": "*KLWPA=S",
                     "_unicode": "Κλωπᾶς",
                     "_translit": "Klōpâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "klo-pas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0256"
                     }
                  ],
                  "__text": "of Chaldee origin (corresponding to \n);"
               },
               "strongs_def": "Clopas, an\n Israelite",
               "kjv_def": ":--Cleophas.",
               "_strongs": "02832"
            },
            {
               "strongs": "2833",
               "greek": [
                  {
                     "_BETA": "KNH/QW",
                     "_unicode": "κνήθω",
                     "_translit": "knḗthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "knay'-tho"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KNA/W",
                        "_unicode": "κνάω",
                        "_translit": "knáō"
                     }
                  ],
                  "__text": "from a primary \n (to scrape);"
               },
               "strongs_def": "to scratch, i.e. (by implication) to\n tickle",
               "kjv_def": ":--X itching.",
               "_strongs": "02833"
            },
            {
               "strongs": "2834",
               "greek": [
                  {
                     "_BETA": "*KNI/DOS",
                     "_unicode": "Κνίδος",
                     "_translit": "Knídos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "knee'-dos"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Cnidus, a place in Asia Minor",
               "kjv_def": ":--Cnidus.",
               "_strongs": "02834"
            },
            {
               "strongs": "2835",
               "greek": [
                  {
                     "_BETA": "KODRA/NTHS",
                     "_unicode": "κοδράντης",
                     "_translit": "kodrántēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kod-ran'-tace"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a quadrans, i.e. the fourth part of an as",
               "kjv_def": ":--farthing.",
               "_strongs": "02835"
            },
            {
               "strongs": "2836",
               "greek": [
                  {
                     "_BETA": "KOILI/A",
                     "_unicode": "κοιλία",
                     "_translit": "koilía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-lee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KOI=LOS",
                        "_unicode": "κοῖλος",
                        "_translit": "koîlos"
                     }
                  ],
                  "__text": "from \n (\"hollow\");"
               },
               "strongs_def": "a cavity, i.e. (especially) the abdomen; by\n implication, the matrix; figuratively, the heart",
               "kjv_def": ":--belly, womb.",
               "_strongs": "02836"
            },
            {
               "strongs": "2837",
               "greek": [
                  {
                     "_BETA": "KOIMA/W",
                     "_unicode": "κοιμάω",
                     "_translit": "koimáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-mah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to put to sleep, i.e. (passively or reflexively) to\n slumber; figuratively, to decease",
               "kjv_def": ":--(be a-, fall a-, fall on) sleep,\n be dead.",
               "_strongs": "02837"
            },
            {
               "strongs": "2838",
               "greek": [
                  {
                     "_BETA": "KOI/MHSIS",
                     "_unicode": "κοίμησις",
                     "_translit": "koímēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy'-may-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2837"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sleeping, i.e. (by implication) repose",
               "kjv_def": ":--taking of rest.",
               "_strongs": "02838"
            },
            {
               "strongs": "2839",
               "greek": [
                  {
                     "_BETA": "KOINO/S",
                     "_unicode": "κοινός",
                     "_translit": "koinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "common, i.e. (literally) shared by all or several,\n or (ceremonially) profane",
               "kjv_def": ":--common, defiled, unclean, unholy.",
               "_strongs": "02839"
            },
            {
               "strongs": "2840",
               "greek": [
                  {
                     "_BETA": "KOINO/W",
                     "_unicode": "κοινόω",
                     "_translit": "koinóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-no'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2839"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make (or consider) profane (ceremonially)",
               "kjv_def": ":--call common,\n defile, pollute, unclean.",
               "_strongs": "02840"
            },
            {
               "strongs": "2841",
               "greek": [
                  {
                     "_BETA": "KOINWNE/W",
                     "_unicode": "κοινωνέω",
                     "_translit": "koinōnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-no-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2844"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to share with others (objectively or\n subjectively)",
               "kjv_def": ":--communicate, distribute, be partaker.",
               "_strongs": "02841"
            },
            {
               "strongs": "2842",
               "greek": [
                  {
                     "_BETA": "KOINWNI/A",
                     "_unicode": "κοινωνία",
                     "_translit": "koinōnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-nohn-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2844"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "partnership, i.e. (literally) participation, or (social)\n intercourse, or (pecuniary) benefaction",
               "kjv_def": ":--(to) communicate(-ation),\n communion, (contri-)distribution, fellowship.",
               "_strongs": "02842"
            },
            {
               "strongs": "2843",
               "greek": [
                  {
                     "_BETA": "KOINWNIKO/S",
                     "_unicode": "κοινωνικός",
                     "_translit": "koinōnikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-no-nee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2844"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "communicative, i.e. (pecuniarily) liberal",
               "kjv_def": ":--willing to\n communicate.",
               "_strongs": "02843"
            },
            {
               "strongs": "2844",
               "greek": [
                  {
                     "_BETA": "KOINWNO/S",
                     "_unicode": "κοινωνός",
                     "_translit": "koinōnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-no-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2839"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sharer, i.e. associate",
               "kjv_def": ":--companion, X fellowship,\n partaker, partner.",
               "_strongs": "02844"
            },
            {
               "strongs": "2845",
               "greek": [
                  {
                     "_BETA": "KOI/TH",
                     "_unicode": "κοίτη",
                     "_translit": "koítē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy'-tay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a couch; by extension, cohabitation; by implication, the\n male sperm",
               "kjv_def": ":--bed, chambering, X conceive.",
               "_strongs": "02845"
            },
            {
               "strongs": "2846",
               "greek": [
                  {
                     "_BETA": "KOITW/N",
                     "_unicode": "κοιτών",
                     "_translit": "koitṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koy-tone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2845"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a bedroom",
               "kjv_def": ":--+ chamberlain.",
               "_strongs": "02846"
            },
            {
               "strongs": "2847",
               "greek": [
                  {
                     "_BETA": "KO/KKINOS",
                     "_unicode": "κόκκινος",
                     "_translit": "kókkinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kok'-kee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2848"
                     }
                  ],
                  "__text": "from \n (from the kernel-shape of the insect);"
               },
               "strongs_def": "crimson-colored",
               "kjv_def": ":--scarlet (colour, coloured).",
               "_strongs": "02847"
            },
            {
               "strongs": "2848",
               "greek": [
                  {
                     "_BETA": "KO/KKOS",
                     "_unicode": "κόκκος",
                     "_translit": "kókkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kok'-kos"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a kernel of seed",
               "kjv_def": ":--corn, grain.",
               "_strongs": "02848"
            },
            {
               "strongs": "2849",
               "greek": [
                  {
                     "_BETA": "KOLA/ZW",
                     "_unicode": "κολάζω",
                     "_translit": "kolázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KO/LOS",
                        "_unicode": "κόλος",
                        "_translit": "kólos"
                     }
                  ],
                  "__text": "from \n (dwarf);"
               },
               "strongs_def": "properly, to curtail, i.e. (figuratively) to\n chastise (or reserve for infliction)",
               "kjv_def": ":--punish.",
               "_strongs": "02849"
            },
            {
               "strongs": "2850",
               "greek": [
                  {
                     "_BETA": "KOLAKEI/A",
                     "_unicode": "κολακεία",
                     "_translit": "kolakeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-ak-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KO/LAC",
                        "_unicode": "κόλαξ",
                        "_translit": "kólax"
                     }
                  ],
                  "__text": "from a derivative of \n (a fawner);"
               },
               "strongs_def": "flattery",
               "kjv_def": ":-- X flattering.",
               "_strongs": "02850"
            },
            {
               "strongs": "2851",
               "greek": [
                  {
                     "_BETA": "KO/LASIS",
                     "_unicode": "κόλασις",
                     "_translit": "kólasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol'-as-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2849"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "penal infliction",
               "kjv_def": ":--punishment, torment.",
               "_strongs": "02851"
            },
            {
               "strongs": "2852",
               "greek": [
                  {
                     "_BETA": "KOLAFI/ZW",
                     "_unicode": "κολαφίζω",
                     "_translit": "kolaphízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-af-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2849"
                     }
                  ],
                  "__text": "from a derivative of the base of \n;"
               },
               "strongs_def": "to rap with the fist",
               "kjv_def": ":--buffet.",
               "_strongs": "02852"
            },
            {
               "strongs": "2853",
               "greek": [
                  {
                     "_BETA": "KOLLA/W",
                     "_unicode": "κολλάω",
                     "_translit": "kolláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-lah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KO/LLA",
                        "_unicode": "κόλλα",
                        "_translit": "kólla"
                     }
                  ],
                  "__text": "from \n (\"glue\");"
               },
               "strongs_def": "to glue, i.e. (passively or reflexively) to stick\n (figuratively)",
               "kjv_def": ":--cleave, join (self), keep company.",
               "_strongs": "02853"
            },
            {
               "strongs": "2854",
               "greek": [
                  {
                     "_BETA": "KOLLOU/RION",
                     "_unicode": "κολλούριον",
                     "_translit": "kolloúrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-loo'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KOLLU/RA",
                        "_unicode": "κολλύρα",
                        "_translit": "kollýra"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2853"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n (a cake; prob akin to the\n base of \n);"
               },
               "strongs_def": "properly, a poultice (as made of or in the form of\n crackers), i.e. (by analogy) a plaster",
               "kjv_def": ":-- eyesalve.",
               "_strongs": "02854"
            },
            {
               "strongs": "2855",
               "greek": [
                  {
                     "_BETA": "KOLLUBISTH/S",
                     "_unicode": "κολλυβιστής",
                     "_translit": "kollybistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-loo-bis-tace'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KO/LLUBOS",
                        "_unicode": "κόλλυβος",
                        "_translit": "kóllybos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2854"
                     }
                  ],
                  "__text": "from a presumed derivative of \n (a small coin; probably akin to\n \n);"
               },
               "strongs_def": "a coin-dealer",
               "kjv_def": ":--(money-)changer.",
               "_strongs": "02855"
            },
            {
               "strongs": "2856",
               "greek": [
                  {
                     "_BETA": "KOLOBO/W",
                     "_unicode": "κολοβόω",
                     "_translit": "kolobóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-ob-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2849"
                     }
                  ],
                  "__text": "from a derivative of the base of \n;"
               },
               "strongs_def": "to dock, i.e. (figuratively)\n abridge",
               "kjv_def": ":--shorten.",
               "_strongs": "02856"
            },
            {
               "strongs": "2857",
               "greek": [
                  {
                     "_BETA": "*KOLOSSAI/",
                     "_unicode": "Κολοσσαί",
                     "_translit": "Kolossaí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-os-sah'-ee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KOLOSSO/S",
                        "_unicode": "κολοσσός",
                        "_translit": "kolossós"
                     }
                  ],
                  "__text": "apparently feminine plural of \n (\"colossal\");"
               },
               "strongs_def": "Colossæ, a place\n in Asia Minor",
               "kjv_def": ":--Colosse.",
               "_strongs": "02857"
            },
            {
               "strongs": "2858",
               "greek": [
                  {
                     "_BETA": "*KOLOSSAEU/S",
                     "_unicode": "Κολοσσαεύς",
                     "_translit": "Kolossaeús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-os-sayoos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2857"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Colossæan, (i.e. inhabitant of Colossæ",
               "kjv_def": ":--Colossian.",
               "_strongs": "02858"
            },
            {
               "strongs": "2859",
               "greek": [
                  {
                     "_BETA": "KO/LPOS",
                     "_unicode": "κόλπος",
                     "_translit": "kólpos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol'-pos"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "the bosom; by analogy, a bay",
               "kjv_def": ":--bosom,\n creek.",
               "_strongs": "02859"
            },
            {
               "strongs": "2860",
               "greek": [
                  {
                     "_BETA": "KOLUMBA/W",
                     "_unicode": "κολυμβάω",
                     "_translit": "kolymbáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-oom-bah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KO/LUMBOS",
                        "_unicode": "κόλυμβος",
                        "_translit": "kólymbos"
                     }
                  ],
                  "__text": "from \n (a diver);"
               },
               "strongs_def": "to plunge into water",
               "kjv_def": ":--swim.",
               "_strongs": "02860"
            },
            {
               "strongs": "2861",
               "greek": [
                  {
                     "_BETA": "KOLUMBH/QRA",
                     "_unicode": "κολυμβήθρα",
                     "_translit": "kolymbḗthra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-oom-bay'-thrah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2860"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a diving-place, i.e. pond for bathing (or swimming)",
               "kjv_def": ":--pool.",
               "_strongs": "02861"
            },
            {
               "strongs": "2862",
               "greek": [
                  {
                     "_BETA": "KOLWNI/A",
                     "_unicode": "κολωνία",
                     "_translit": "kolōnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kol-o-nee'-ah"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a Roman \"colony\" for veterans",
               "kjv_def": ":--colony.",
               "_strongs": "02862"
            },
            {
               "strongs": "2863",
               "greek": [
                  {
                     "_BETA": "KOMA/W",
                     "_unicode": "κομάω",
                     "_translit": "komáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kom-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2864"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to wear tresses of hair",
               "kjv_def": ":--have long hair.",
               "_strongs": "02863"
            },
            {
               "strongs": "2864",
               "greek": [
                  {
                     "_BETA": "KO/MH",
                     "_unicode": "κόμη",
                     "_translit": "kómē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kom'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2865"
                     }
                  ],
                  "__text": "apparently from the same as \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2359"
                     }
                  ],
                  "__text": "the hair of the head (locks, as\n ornamental, and thus differing from \n; which properly denotes\n merely the scalp)"
               },
               "kjv_def": ":--hair.",
               "_strongs": "02864"
            },
            {
               "strongs": "2865",
               "greek": [
                  {
                     "_BETA": "KOMI/ZW",
                     "_unicode": "κομίζω",
                     "_translit": "komízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kom-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KOME/W",
                        "_unicode": "κομέω",
                        "_translit": "koméō"
                     }
                  ],
                  "__text": "from a primary \n (to tend, i.e. take care of);"
               },
               "strongs_def": "properly, to\n provide for, i.e. (by implication) to carry off (as if from harm;\n genitive case obtain)",
               "kjv_def": ":--bring, receive.",
               "_strongs": "02865"
            },
            {
               "strongs": "2866",
               "greek": [
                  {
                     "_BETA": "KOMYO/TERON",
                     "_unicode": "κομψότερον",
                     "_translit": "kompsóteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "komp-sot'-er-on"
                  }
               ],
               "strongs_derivation": "neuter comparative of a derivative of the base of 2865 (meaning,\n properly, well dressed, i.e. nice);",
               "strongs_def": "figuratively, convalescent",
               "kjv_def": ":--+\n began to amend.",
               "_strongs": "02866"
            },
            {
               "strongs": "2867",
               "greek": [
                  {
                     "_BETA": "KONIA/W",
                     "_unicode": "κονιάω",
                     "_translit": "koniáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kon-ee-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KONI/A",
                        "_unicode": "κονία",
                        "_translit": "konía"
                     }
                  ],
                  "__text": "from \n (dust; by analogy, lime);"
               },
               "strongs_def": "to whitewash",
               "kjv_def": ":--whiten.",
               "_strongs": "02867"
            },
            {
               "strongs": "2868",
               "greek": [
                  {
                     "_BETA": "KONIORTO/S",
                     "_unicode": "κονιορτός",
                     "_translit": "koniortós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kon-ee-or-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2867"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "O)/RNUMI",
                        "_unicode": "ὄρνυμι",
                        "_translit": "órnymi"
                     }
                  ],
                  "__text": "from the base of \n and \n (to \"rouse\");"
               },
               "strongs_def": "pulverulence (as blown\n about)",
               "kjv_def": ":--dust.",
               "_strongs": "02868"
            },
            {
               "strongs": "2869",
               "greek": [
                  {
                     "_BETA": "KOPA/ZW",
                     "_unicode": "κοπάζω",
                     "_translit": "kopázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kop-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2873"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to tire, i.e. (figuratively) to relax",
               "kjv_def": ":--cease.",
               "_strongs": "02869"
            },
            {
               "strongs": "2870",
               "greek": [
                  {
                     "_BETA": "KOPETO/S",
                     "_unicode": "κοπετός",
                     "_translit": "kopetós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kop-et-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "mourning (properly, by beating the breast)",
               "kjv_def": ":--lamentation.",
               "_strongs": "02870"
            },
            {
               "strongs": "2871",
               "greek": [
                  {
                     "_BETA": "KOPH/",
                     "_unicode": "κοπή",
                     "_translit": "kopḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kop-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cutting, i.e. carnage",
               "kjv_def": ":--slaughter.",
               "_strongs": "02871"
            },
            {
               "strongs": "2872",
               "greek": [
                  {
                     "_BETA": "KOPIA/W",
                     "_unicode": "κοπιάω",
                     "_translit": "kopiáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kop-ee-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2873"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to feel fatigue; by implication, to work\n hard",
               "kjv_def": ":--(bestow) labour, toil, be wearied.",
               "_strongs": "02872"
            },
            {
               "strongs": "2873",
               "greek": [
                  {
                     "_BETA": "KO/POS",
                     "_unicode": "κόπος",
                     "_translit": "kópos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kop'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a cut, i.e. (by analogy) toil (as reducing the strength),\n literally or figuratively; by implication, pains",
               "kjv_def": ":--labour, + trouble,\n weariness.",
               "_strongs": "02873"
            },
            {
               "strongs": "2874",
               "greek": [
                  {
                     "_BETA": "KOPRI/A",
                     "_unicode": "κοπρία",
                     "_translit": "kopría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kop-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KO/PROS",
                        "_unicode": "κόπρος",
                        "_translit": "kópros"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n (ordure; perhaps akin to \n);"
               },
               "strongs_def": "manure",
               "kjv_def": ":--dung(-hill).",
               "_strongs": "02874"
            },
            {
               "strongs": "2875",
               "greek": [
                  {
                     "_BETA": "KO/PTW",
                     "_unicode": "κόπτω",
                     "_translit": "kóptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kop'-to"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to \"chop\"; specially, to beat the breast in\n grief",
               "kjv_def": ":--cut down, lament, mourn, (be-)wail.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5114"
                  }
               ],
               "_strongs": "02875",
               "__text": "Compare the base of \n."
            },
            {
               "strongs": "2876",
               "greek": [
                  {
                     "_BETA": "KO/RAC",
                     "_unicode": "κόραξ",
                     "_translit": "kórax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor'-ax"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2880"
                     }
                  ],
                  "__text": "perhaps from \n;"
               },
               "strongs_def": "a crow (from its voracity)",
               "kjv_def": ":--raven.",
               "_strongs": "02876"
            },
            {
               "strongs": "2877",
               "greek": [
                  {
                     "_BETA": "KORA/SION",
                     "_unicode": "κοράσιον",
                     "_translit": "korásion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor-as'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KO/RH",
                        "_unicode": "κόρη",
                        "_translit": "kórē"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n (a maiden);"
               },
               "strongs_def": "a (little)\n girl",
               "kjv_def": ":--damsel, maid.",
               "_strongs": "02877"
            },
            {
               "strongs": "2878",
               "greek": [
                  {
                     "_BETA": "KORBA=N",
                     "_unicode": "κορβᾶν",
                     "_translit": "korbân"
                  },
                  {
                     "_BETA": "KORBANA=S",
                     "_unicode": "κορβανᾶς",
                     "_translit": "korbanâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor-ban'"
                  },
                  {
                     "_strongs": "kor-ban-as'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07133"
                     }
                  ],
                  "__text": "of Hebrew and Chaldee origin respectively (\n);"
               },
               "strongs_def": "a votive offering\n and the offering; a consecrated present (to the Temple fund); by\n extension (the latter term) the Treasury itself, i.e. the room where\n the contribution boxes stood",
               "kjv_def": ":--Corban, treasury.",
               "_strongs": "02878",
               "__text": "and"
            },
            {
               "strongs": "2879",
               "greek": [
                  {
                     "_BETA": "*KORE/",
                     "_unicode": "Κορέ",
                     "_translit": "Koré"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor-eh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07141"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Core (i.e. Korach), an Israelite",
               "kjv_def": ":--Core.",
               "_strongs": "02879"
            },
            {
               "strongs": "2880",
               "greek": [
                  {
                     "_BETA": "KORE/NNUMI",
                     "_unicode": "κορέννυμι",
                     "_translit": "korénnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor-en'-noo-mee"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to cram, i.e. glut or sate",
               "kjv_def": ":--eat enough, full.",
               "_strongs": "02880"
            },
            {
               "strongs": "2881",
               "greek": [
                  {
                     "_BETA": "*KORI/NQIOS",
                     "_unicode": "Κορίνθιος",
                     "_translit": "Korínthios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor-in'-thee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2882"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Corinthian, i.e. inhabitant of Corinth",
               "kjv_def": ":--Corinthian.",
               "_strongs": "02881"
            },
            {
               "strongs": "2882",
               "greek": [
                  {
                     "_BETA": "*KO/RINQOS",
                     "_unicode": "Κόρινθος",
                     "_translit": "Kórinthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor'-in-thos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Corinthus, a city of Greece",
               "kjv_def": ":--Corinth.",
               "_strongs": "02882"
            },
            {
               "strongs": "2883",
               "greek": [
                  {
                     "_BETA": "*KORNH/LIOS",
                     "_unicode": "Κορνήλιος",
                     "_translit": "Kornḗlios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor-nay'-lee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Cornelius, a Roman",
               "kjv_def": ":--Cornelius.",
               "_strongs": "02883"
            },
            {
               "strongs": "2884",
               "greek": [
                  {
                     "_BETA": "KO/ROS",
                     "_unicode": "κόρος",
                     "_translit": "kóros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kor'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03734"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "a cor, i.e. a specific measure",
               "kjv_def": ":--measure.",
               "_strongs": "02884"
            },
            {
               "strongs": "2885",
               "greek": [
                  {
                     "_BETA": "KOSME/W",
                     "_unicode": "κοσμέω",
                     "_translit": "kosméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kos-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2889"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to put in proper order, i.e. decorate (literally or\n figuratively); specially, to snuff (a wick)",
               "kjv_def": ":--adorn, garnish, trim.",
               "_strongs": "02885"
            },
            {
               "strongs": "2886",
               "greek": [
                  {
                     "_BETA": "KOSMIKO/S",
                     "_unicode": "κοσμικός",
                     "_translit": "kosmikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kos-mee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2889"
                     }
                  ],
                  "__text": "from \n (in its secondary sense);"
               },
               "strongs_def": "terrene (\"cosmic\"), literally\n (mundane) or figuratively (corrupt)",
               "kjv_def": ":--worldly.",
               "_strongs": "02886"
            },
            {
               "strongs": "2887",
               "greek": [
                  {
                     "_BETA": "KO/SMIOS",
                     "_unicode": "κόσμιος",
                     "_translit": "kósmios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kos'-mee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2889"
                     }
                  ],
                  "__text": "from \n (in its primary sense);"
               },
               "strongs_def": "orderly, i.e. decorous",
               "kjv_def": ":--of good\n behaviour, modest.",
               "_strongs": "02887"
            },
            {
               "strongs": "2888",
               "greek": [
                  {
                     "_BETA": "KOSMOKRA/TWR",
                     "_unicode": "κοσμοκράτωρ",
                     "_translit": "kosmokrátōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kos-mok-fat'-ore"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2889"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2902"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a world-ruler, an epithet of Satan",
               "kjv_def": ":--ruler.",
               "_strongs": "02888"
            },
            {
               "strongs": "2889",
               "greek": [
                  {
                     "_BETA": "KO/SMOS",
                     "_unicode": "κόσμος",
                     "_translit": "kósmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kos'-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2865"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "orderly arrangement, i.e. decoration;\n by implication, the world (in a wide or narrow sense, including its\n inhabitants, literally or figuratively (morally))",
               "kjv_def": ":--adorning, world.",
               "_strongs": "02889"
            },
            {
               "strongs": "2890",
               "greek": [
                  {
                     "_BETA": "*KOU/ARTOS",
                     "_unicode": "Κούαρτος",
                     "_translit": "Koúartos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-ar-tos"
                  }
               ],
               "strongs_derivation": "of Latin origin (fourth);",
               "strongs_def": "Quartus, a Christian",
               "kjv_def": ":--Quartus.",
               "_strongs": "02890"
            },
            {
               "strongs": "2891",
               "greek": [
                  {
                     "_BETA": "KOU=MI",
                     "_unicode": "κοῦμι",
                     "_translit": "koûmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06966"
                     }
                  ],
                  "__text": "of Chaldee origin (\n);"
               },
               "strongs_def": "cumi (i.e. rise!)",
               "kjv_def": ":--cumi.",
               "_strongs": "02891"
            },
            {
               "strongs": "2892",
               "greek": [
                  {
                     "_BETA": "KOUSTWDI/A",
                     "_unicode": "κουστωδία",
                     "_translit": "koustōdía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koos-to-dee'-ah"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "\"custody\", i.e. a Roman sentry",
               "kjv_def": ":--watch.",
               "_strongs": "02892"
            },
            {
               "strongs": "2893",
               "greek": [
                  {
                     "_BETA": "KOUFI/ZW",
                     "_unicode": "κουφίζω",
                     "_translit": "kouphízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-fid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KOU=FOS",
                        "_unicode": "κοῦφος",
                        "_translit": "koûphos"
                     }
                  ],
                  "__text": "from \n (light in weight);"
               },
               "strongs_def": "to unload",
               "kjv_def": ":--lighten.",
               "_strongs": "02893"
            },
            {
               "strongs": "2894",
               "greek": [
                  {
                     "_BETA": "KO/FINOS",
                     "_unicode": "κόφινος",
                     "_translit": "kóphinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kof'-ee-nos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a (small) basket",
               "kjv_def": ":--basket.",
               "_strongs": "02894"
            },
            {
               "strongs": "2895",
               "greek": [
                  {
                     "_BETA": "KRA/BBATOS",
                     "_unicode": "κράββατος",
                     "_translit": "krábbatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krab'-bat-os"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "a mattress",
               "kjv_def": ":--bed.",
               "_strongs": "02895"
            },
            {
               "strongs": "2896",
               "greek": [
                  {
                     "_BETA": "KRA/ZW",
                     "_unicode": "κράζω",
                     "_translit": "krázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krad'-zo"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "properly, to \"croak\" (as a raven) or scream, i.e.\n (genitive case) to call aloud (shriek, exclaim, intreat)",
               "kjv_def": ":--cry (out).",
               "_strongs": "02896"
            },
            {
               "strongs": "2897",
               "greek": [
                  {
                     "_BETA": "KRAIPA/LH",
                     "_unicode": "κραιπάλη",
                     "_translit": "kraipálē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krahee-pal'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "726"
                     }
                  ],
                  "__text": "probably from the same as \n;"
               },
               "strongs_def": "properly, a headache (as a seizure of\n pain) from drunkenness, i.e. (by implication) a debauch (by analogy, a\n glut)",
               "kjv_def": ":--surfeiting.",
               "_strongs": "02897"
            },
            {
               "strongs": "2898",
               "greek": [
                  {
                     "_BETA": "KRANI/ON",
                     "_unicode": "κρανίον",
                     "_translit": "kraníon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kran-ee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2768"
                     }
                  ],
                  "__text": "diminutive of a derivative of the base of \n;"
               },
               "strongs_def": "a skull\n (\"cranium\")",
               "kjv_def": ":--Calvary, skull.",
               "_strongs": "02898"
            },
            {
               "strongs": "2899",
               "greek": [
                  {
                     "_BETA": "KRA/SPEDON",
                     "_unicode": "κράσπεδον",
                     "_translit": "kráspedon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kras'-ped-on"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a margin, i.e. (specially), a fringe or\n tassel",
               "kjv_def": ":--border, hem.",
               "_strongs": "02899"
            },
            {
               "strongs": "2900",
               "greek": [
                  {
                     "_BETA": "KRATAIO/S",
                     "_unicode": "κραταιός",
                     "_translit": "krataiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krat-ah-yos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "powerful",
               "kjv_def": ":--mighty.",
               "_strongs": "02900"
            },
            {
               "strongs": "2901",
               "greek": [
                  {
                     "_BETA": "KRATAIO/W",
                     "_unicode": "κραταιόω",
                     "_translit": "krataióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krat-ah-yo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2900"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to empower, i.e. (passively) increase in vigor",
               "kjv_def": ":--be\n strengthened, be (wax) strong.",
               "_strongs": "02901"
            },
            {
               "strongs": "2902",
               "greek": [
                  {
                     "_BETA": "KRATE/W",
                     "_unicode": "κρατέω",
                     "_translit": "kratéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krat-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to use strength, i.e. seize or retain (literally or\n figuratively)",
               "kjv_def": ":--hold (by, fast), keep, lay hand (hold) on, obtain,\n retain, take (by).",
               "_strongs": "02902"
            },
            {
               "strongs": "2903",
               "greek": [
                  {
                     "_BETA": "KRA/TISTOS",
                     "_unicode": "κράτιστος",
                     "_translit": "krátistos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krat'-is-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "superlative of a derivative of \n;"
               },
               "strongs_def": "strongest, i.e. (in dignity) very\n honorable",
               "kjv_def": ":--most excellent (noble).",
               "_strongs": "02903"
            },
            {
               "strongs": "2904",
               "greek": [
                  {
                     "_BETA": "KRA/TOS",
                     "_unicode": "κράτος",
                     "_translit": "krátos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krat'-os"
                  }
               ],
               "strongs_derivation": "perhaps a primary word;",
               "strongs_def": "vigor (\"great\") (literally or\n figuratively)",
               "kjv_def": ":--dominion, might(-ily), power, strength.",
               "_strongs": "02904"
            },
            {
               "strongs": "2905",
               "greek": [
                  {
                     "_BETA": "KRAUGA/ZW",
                     "_unicode": "κραυγάζω",
                     "_translit": "kraugázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krow-gad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2906"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to clamor",
               "kjv_def": ":--cry out.",
               "_strongs": "02905"
            },
            {
               "strongs": "2906",
               "greek": [
                  {
                     "_BETA": "KRAUGH/",
                     "_unicode": "κραυγή",
                     "_translit": "kraugḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krow-gay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2896"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an outcry (in notification, tumult or grief)",
               "kjv_def": ":--clamour,\n cry(-ing).",
               "_strongs": "02906"
            },
            {
               "strongs": "2907",
               "greek": [
                  {
                     "_BETA": "KRE/AS",
                     "_unicode": "κρέας",
                     "_translit": "kréas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kreh'-as"
                  }
               ],
               "strongs_derivation": "perhaps a primary word;",
               "strongs_def": "(butcher's) meat",
               "kjv_def": ":--flesh.",
               "_strongs": "02907"
            },
            {
               "strongs": "2908",
               "greek": [
                  {
                     "_BETA": "KREI=SSON",
                     "_unicode": "κρεῖσσον",
                     "_translit": "kreîsson"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krice'-son"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2909"
                     }
                  ],
                  "__text": "neuter of an alternate form of \n;"
               },
               "strongs_def": "(as noun) better, i.e. greater\n advantage",
               "kjv_def": ":--better.",
               "_strongs": "02908"
            },
            {
               "strongs": "2909",
               "greek": [
                  {
                     "_BETA": "KREI/TTWN",
                     "_unicode": "κρείττων",
                     "_translit": "kreíttōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krite'-tohn"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "comparative of a derivative of \n;"
               },
               "strongs_def": "stronger, i.e. (figuratively)\n better, i.e. nobler",
               "kjv_def": ":--best, better.",
               "_strongs": "02909"
            },
            {
               "strongs": "2910",
               "greek": [
                  {
                     "_BETA": "KREMA/NNUMI",
                     "_unicode": "κρεμάννυμι",
                     "_translit": "kremánnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krem-an'-noo-mee"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb;",
               "strongs_def": "to hang",
               "kjv_def": ":--hang.",
               "_strongs": "02910"
            },
            {
               "strongs": "2911",
               "greek": [
                  {
                     "_BETA": "KRHMNO/S",
                     "_unicode": "κρημνός",
                     "_translit": "krēmnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krame-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2910"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "overhanging, i.e. a precipice",
               "kjv_def": ":--steep place.",
               "_strongs": "02911"
            },
            {
               "strongs": "2912",
               "greek": [
                  {
                     "_BETA": "*KRH/S",
                     "_unicode": "Κρής",
                     "_translit": "Krḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2914"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Cretan, i.e. inhabitant of Crete",
               "kjv_def": ":--Crete, Cretian.",
               "_strongs": "02912"
            },
            {
               "strongs": "2913",
               "greek": [
                  {
                     "_BETA": "*KRH/SKHS",
                     "_unicode": "Κρήσκης",
                     "_translit": "Krḗskēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krace'-kace"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "growing; Cresces (i.e. Crescens), a\n Christian",
               "kjv_def": ":--Crescens.",
               "_strongs": "02913"
            },
            {
               "strongs": "2914",
               "greek": [
                  {
                     "_BETA": "*KRH/TH",
                     "_unicode": "Κρήτη",
                     "_translit": "Krḗtē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kray'-tay"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Crete, an island in the\n Mediterranean",
               "kjv_def": ":--Crete.",
               "_strongs": "02914"
            },
            {
               "strongs": "2915",
               "greek": [
                  {
                     "_BETA": "KRIQH/",
                     "_unicode": "κριθή",
                     "_translit": "krithḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kree-thay'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "barley",
               "kjv_def": ":--barley.",
               "_strongs": "02915"
            },
            {
               "strongs": "2916",
               "greek": [
                  {
                     "_BETA": "KRI/QINOS",
                     "_unicode": "κρίθινος",
                     "_translit": "kríthinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kree'-thee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2915"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "consisting of barley",
               "kjv_def": ":--barley.",
               "_strongs": "02916"
            },
            {
               "strongs": "2917",
               "greek": [
                  {
                     "_BETA": "KRI/MA",
                     "_unicode": "κρίμα",
                     "_translit": "kríma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kree'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a decision (the function or the effect, for or against\n (\"crime\"))",
               "kjv_def": ":--avenge, condemned, condemnation, damnation, + go to law,\n judgment.",
               "_strongs": "02917"
            },
            {
               "strongs": "2918",
               "greek": [
                  {
                     "_BETA": "KRI/NON",
                     "_unicode": "κρίνον",
                     "_translit": "krínon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kree'-non"
                  }
               ],
               "strongs_derivation": "perhaps a prim word;",
               "strongs_def": "a lily",
               "kjv_def": ":--lily.",
               "_strongs": "02918"
            },
            {
               "strongs": "2919",
               "greek": [
                  {
                     "_BETA": "KRI/NW",
                     "_unicode": "κρίνω",
                     "_translit": "krínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kree'-no"
                  }
               ],
               "strongs_derivation": "properly, to distinguish, i.e. decide (mentally or judicially);",
               "strongs_def": "by\n implication, to try, condemn, punish",
               "kjv_def": ":--avenge, conclude, condemn,\n damn, decree, determine, esteem, judge, go to (sue at the) law,\n ordain, call in question, sentence to, think.",
               "_strongs": "02919"
            },
            {
               "strongs": "2920",
               "greek": [
                  {
                     "_BETA": "KRI/SIS",
                     "_unicode": "κρίσις",
                     "_translit": "krísis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kree'-sis"
                  }
               ],
               "strongs_def": "decision (subjectively or objectively, for or against); by\n extension, a tribunal; by implication, justice (especially, divine\n law)",
               "kjv_def": ":--accusation, condemnation, damnation, judgment.",
               "_strongs": "02920"
            },
            {
               "strongs": "2921",
               "greek": [
                  {
                     "_BETA": "*KRI/SPOS",
                     "_unicode": "Κρίσπος",
                     "_translit": "Kríspos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kris'-pos"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "\"crisp\"; Crispus, a Corinthian",
               "kjv_def": ":--Crispus.",
               "_strongs": "02921"
            },
            {
               "strongs": "2922",
               "greek": [
                  {
                     "_BETA": "KRITH/RION",
                     "_unicode": "κριτήριον",
                     "_translit": "kritḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kree-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2923"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a rule of judging\n (\"criterion\"), i.e. (by implication) a tribunal",
               "kjv_def": ":--to judge, judgment\n (seat).",
               "_strongs": "02922"
            },
            {
               "strongs": "2923",
               "greek": [
                  {
                     "_BETA": "KRITH/S",
                     "_unicode": "κριτής",
                     "_translit": "kritḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kree-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a judge (genitive case or specially)",
               "kjv_def": ":--judge.",
               "_strongs": "02923"
            },
            {
               "strongs": "2924",
               "greek": [
                  {
                     "_BETA": "KRITIKO/S",
                     "_unicode": "κριτικός",
                     "_translit": "kritikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "krit-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2923"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "decisive (\"critical\"), i.e. discriminative",
               "kjv_def": ":--discerner.",
               "_strongs": "02924"
            },
            {
               "strongs": "2925",
               "greek": [
                  {
                     "_BETA": "KROU/W",
                     "_unicode": "κρούω",
                     "_translit": "kroúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kroo'-o"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to rap",
               "kjv_def": ":--knock.",
               "_strongs": "02925"
            },
            {
               "strongs": "2926",
               "greek": [
                  {
                     "_BETA": "KRU/PTH",
                     "_unicode": "κρύπτη",
                     "_translit": "krýptē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kroop-tay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2927"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a hidden place, i.e. cellar (\"crypt\")",
               "kjv_def": ":--secret.",
               "_strongs": "02926"
            },
            {
               "strongs": "2927",
               "greek": [
                  {
                     "_BETA": "KRUPTO/S",
                     "_unicode": "κρυπτός",
                     "_translit": "kryptós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kroop-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2928"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "concealed, i.e. private",
               "kjv_def": ":--hid(-den), inward(-ly), secret.",
               "_strongs": "02927"
            },
            {
               "strongs": "2928",
               "greek": [
                  {
                     "_BETA": "KRU/PTW",
                     "_unicode": "κρύπτω",
                     "_translit": "krýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kroop'-to"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to conceal (properly, by covering)",
               "kjv_def": ":--hide (self), keep\n secret, secret(-ly).",
               "_strongs": "02928"
            },
            {
               "strongs": "2929",
               "greek": [
                  {
                     "_BETA": "KRUSTALLI/ZW",
                     "_unicode": "κρυσταλλίζω",
                     "_translit": "krystallízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kroos-tal-lid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2930"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make (i.e. intransitively, resemble) ice\n (\"crystallize\")",
               "kjv_def": ":--be clear as crystal.",
               "_strongs": "02929"
            },
            {
               "strongs": "2930",
               "greek": [
                  {
                     "_BETA": "KRU/STALLOS",
                     "_unicode": "κρύσταλλος",
                     "_translit": "krýstallos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kroos'-tal-los"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KRU/OS",
                        "_unicode": "κρύος",
                        "_translit": "krýos"
                     }
                  ],
                  "__text": "from a derivative of \n (frost);"
               },
               "strongs_def": "ice, i.e. (by analogy) rock\n \"crystal\"",
               "kjv_def": ":--crystal.",
               "_strongs": "02930"
            },
            {
               "strongs": "2931",
               "greek": [
                  {
                     "_BETA": "KRUFH=",
                     "_unicode": "κρυφῆ",
                     "_translit": "kryphē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kroo-fay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2928"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "privately",
               "kjv_def": ":--in secret.",
               "_strongs": "02931"
            },
            {
               "strongs": "2932",
               "greek": [
                  {
                     "_BETA": "KTA/OMAI",
                     "_unicode": "κτάομαι",
                     "_translit": "ktáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ktah'-om-ahee"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to get, i.e. acquire (by any means; own)",
               "kjv_def": ":--obtain,\n possess, provide, purchase.",
               "_strongs": "02932"
            },
            {
               "strongs": "2933",
               "greek": [
                  {
                     "_BETA": "KTH=MA",
                     "_unicode": "κτῆμα",
                     "_translit": "ktēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ktay'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2932"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an acquirement, i.e. estate",
               "kjv_def": ":--possession.",
               "_strongs": "02933"
            },
            {
               "strongs": "2934",
               "greek": [
                  {
                     "_BETA": "KTH=NOS",
                     "_unicode": "κτῆνος",
                     "_translit": "ktēnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ktay'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2932"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "property, i.e. (specially) a domestic animal",
               "kjv_def": ":--beast.",
               "_strongs": "02934"
            },
            {
               "strongs": "2935",
               "greek": [
                  {
                     "_BETA": "KTH/TWR",
                     "_unicode": "κτήτωρ",
                     "_translit": "ktḗtōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ktay'-tore"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2932"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an owner",
               "kjv_def": ":--possessor.",
               "_strongs": "02935"
            },
            {
               "strongs": "2936",
               "greek": [
                  {
                     "_BETA": "KTI/ZW",
                     "_unicode": "κτίζω",
                     "_translit": "ktízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ktid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2932"
                     }
                  ],
                  "__text": "probably akin to \n (through the idea of proprietorship of the\n manufacturer);"
               },
               "strongs_def": "to fabricate, i.e. found (form originally)",
               "kjv_def": ":--create,\n Creator, make.",
               "_strongs": "02936"
            },
            {
               "strongs": "2937",
               "greek": [
                  {
                     "_BETA": "KTI/SIS",
                     "_unicode": "κτίσις",
                     "_translit": "ktísis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ktis'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2936"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "original formation (properly, the act; by implication, the\n thing, literally or figuratively)",
               "kjv_def": ":--building, creation, creature,\n ordinance.",
               "_strongs": "02937"
            },
            {
               "strongs": "2938",
               "greek": [
                  {
                     "_BETA": "KTI/SMA",
                     "_unicode": "κτίσμα",
                     "_translit": "ktísma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ktis'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2936"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an original formation (concretely), i.e. product (created\n thing)",
               "kjv_def": ":--creature.",
               "_strongs": "02938"
            },
            {
               "strongs": "2939",
               "greek": [
                  {
                     "_BETA": "KTI/STHS",
                     "_unicode": "κτίστης",
                     "_translit": "ktístēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ktis-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2936"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a founder, i.e. God (as author of all things)",
               "kjv_def": ":--Creator.",
               "_strongs": "02939"
            },
            {
               "strongs": "2940",
               "greek": [
                  {
                     "_BETA": "KUBEI/A",
                     "_unicode": "κυβεία",
                     "_translit": "kybeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-bi'-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KU/BOS",
                        "_unicode": "κύβος",
                        "_translit": "kýbos"
                     }
                  ],
                  "__text": "from \n (a \"cube\", i.e. die for playing);"
               },
               "strongs_def": "gambling, i.e.\n (figuratively) artifice or fraud",
               "kjv_def": ":--sleight.",
               "_strongs": "02940"
            },
            {
               "strongs": "2941",
               "greek": [
                  {
                     "_BETA": "KUBE/RNHSIS",
                     "_unicode": "κυβέρνησις",
                     "_translit": "kybérnēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ber'-nay-sis"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KUBERNA/W",
                        "_unicode": "κυβερνάω",
                        "_translit": "kybernáō"
                     }
                  ],
                  "__text": "from \n (of Latin origin, to steer);"
               },
               "strongs_def": "pilotage, i.e.\n (figuratively) directorship (in the church)",
               "kjv_def": ":--government.",
               "_strongs": "02941"
            },
            {
               "strongs": "2942",
               "greek": [
                  {
                     "_BETA": "KUBERNH/THS",
                     "_unicode": "κυβερνήτης",
                     "_translit": "kybernḗtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ber-nay'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2941"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "helmsman, i.e. (by implication)\n captain",
               "kjv_def": ":--(ship) master.",
               "_strongs": "02942"
            },
            {
               "strongs": "2943",
               "greek": [
                  {
                     "_BETA": "KUKLO/QEN",
                     "_unicode": "κυκλόθεν",
                     "_translit": "kyklóthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-kloth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2945"
                     }
                  ],
                  "__text": "adverb from the same as \n;"
               },
               "strongs_def": "from the circle, i.e. all\n around",
               "kjv_def": ":--(round) about.",
               "_strongs": "02943"
            },
            {
               "strongs": "2944",
               "greek": [
                  {
                     "_BETA": "KUKLO/W",
                     "_unicode": "κυκλόω",
                     "_translit": "kyklóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-klo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2945"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to encircle, i.e. surround",
               "kjv_def": ":--compass (about),\n come (stand) round about.",
               "_strongs": "02944"
            },
            {
               "strongs": "2945",
               "greek": [
                  {
                     "_BETA": "KU/KLW|",
                     "_unicode": "κύκλῳ",
                     "_translit": "kýklōi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-klo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KU/KLOS",
                        "_unicode": "κύκλος",
                        "_translit": "kýklos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2947"
                     }
                  ],
                  "__text": "as if dative case of \n (a ring, \"cycle\"; akin to \n);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     }
                  ],
                  "__text": "i.e. in a\n circle (by implication, of \n), i.e. (adverbially) all\n around"
               },
               "kjv_def": ":--round about.",
               "_strongs": "02945"
            },
            {
               "strongs": "2946",
               "greek": [
                  {
                     "_BETA": "KU/LISMA",
                     "_unicode": "κύλισμα",
                     "_translit": "kýlisma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-lis-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2947"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a wallow (the effect of rolling), i.e. filth",
               "kjv_def": ":--wallowing.",
               "_strongs": "02946"
            },
            {
               "strongs": "2947",
               "greek": [
                  {
                     "_BETA": "KULIO/W",
                     "_unicode": "κυλιόω",
                     "_translit": "kylióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-lee-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2949"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2945"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1507"
                     }
                  ],
                  "__text": "from the base of \n (through the idea of circularity; compare \n,\n \n);"
               },
               "strongs_def": "to roll about",
               "kjv_def": ":--wallow.",
               "_strongs": "02947"
            },
            {
               "strongs": "2948",
               "greek": [
                  {
                     "_BETA": "KULLO/S",
                     "_unicode": "κυλλός",
                     "_translit": "kyllós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kool-los'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2947"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "rocking about, i.e. crippled (maimed, in feet\n or hands)",
               "kjv_def": ":--maimed.",
               "_strongs": "02948"
            },
            {
               "strongs": "2949",
               "greek": [
                  {
                     "_BETA": "KU=MA",
                     "_unicode": "κῦμα",
                     "_translit": "kŷma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-mah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KU/W",
                        "_unicode": "κύω",
                        "_translit": "kýō"
                     }
                  ],
                  "__text": "from \n (to swell (with young), i.e. bend, curve);"
               },
               "strongs_def": "a billow (as\n bursting or toppling)",
               "kjv_def": ":--wave.",
               "_strongs": "02949"
            },
            {
               "strongs": "2950",
               "greek": [
                  {
                     "_BETA": "KU/MBALON",
                     "_unicode": "κύμβαλον",
                     "_translit": "kýmbalon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koom'-bal-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2949"
                     }
                  ],
                  "__text": "from a derivative of the base of \n;"
               },
               "strongs_def": "a \"cymbal\" (as\n hollow)",
               "kjv_def": ":--cymbal.",
               "_strongs": "02950"
            },
            {
               "strongs": "2951",
               "greek": [
                  {
                     "_BETA": "KU/MINON",
                     "_unicode": "κύμινον",
                     "_translit": "kýminon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-min-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03646"
                     }
                  ],
                  "__text": "of foreign origin (compare \n);"
               },
               "strongs_def": "dill or fennel (\"cummin\")",
               "kjv_def": ":--cummin.",
               "_strongs": "02951"
            },
            {
               "strongs": "2952",
               "greek": [
                  {
                     "_BETA": "KUNA/RION",
                     "_unicode": "κυνάριον",
                     "_translit": "kynárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-nar'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2965"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a puppy",
               "kjv_def": ":--dog.",
               "_strongs": "02952"
            },
            {
               "strongs": "2953",
               "greek": [
                  {
                     "_BETA": "*KU/PRIOS",
                     "_unicode": "Κύπριος",
                     "_translit": "Kýprios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-pree-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2954"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Cyprian (Cypriot), i.e. inhabitant of Cyprus",
               "kjv_def": ":--of Cyprus.",
               "_strongs": "02953"
            },
            {
               "strongs": "2954",
               "greek": [
                  {
                     "_BETA": "*KU/PROS",
                     "_unicode": "Κύπρος",
                     "_translit": "Kýpros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-pros"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Cyprus, an island in the Mediterranean",
               "kjv_def": ":--Cyprus.",
               "_strongs": "02954"
            },
            {
               "strongs": "2955",
               "greek": [
                  {
                     "_BETA": "KU/PTW",
                     "_unicode": "κύπτω",
                     "_translit": "kýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2949"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "to bend forward",
               "kjv_def": ":--stoop (down).",
               "_strongs": "02955"
            },
            {
               "strongs": "2956",
               "greek": [
                  {
                     "_BETA": "*KURHNAI=OS",
                     "_unicode": "Κυρηναῖος",
                     "_translit": "Kyrēnaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ray-nah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2957"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "i.e. Cyrenæan, i.e. inhabitant of Cyrene",
               "kjv_def": ":--of Cyrene,\n Cyrenian.",
               "_strongs": "02956"
            },
            {
               "strongs": "2957",
               "greek": [
                  {
                     "_BETA": "*KURH/NH",
                     "_unicode": "Κυρήνη",
                     "_translit": "Kyrḗnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ray'-nay"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Cyrene, a region of Africa",
               "kjv_def": ":--Cyrene.",
               "_strongs": "02957"
            },
            {
               "strongs": "2958",
               "greek": [
                  {
                     "_BETA": "*KURH/NIOS",
                     "_unicode": "Κυρήνιος",
                     "_translit": "Kyrḗnios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ray'-nee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Cyrenius (i.e. Quirinus), a Roman",
               "kjv_def": ":--Cyrenius.",
               "_strongs": "02958"
            },
            {
               "strongs": "2959",
               "greek": [
                  {
                     "_BETA": "*KURI/A",
                     "_unicode": "Κυρία",
                     "_translit": "Kyría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2962"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "Cyria, a Christian woman",
               "kjv_def": ":--lady.",
               "_strongs": "02959"
            },
            {
               "strongs": "2960",
               "greek": [
                  {
                     "_BETA": "KURIAKO/S",
                     "_unicode": "κυριακός",
                     "_translit": "kyriakós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ree-ak-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2962"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "belonging to the Lord (Jehovah or Jesus)",
               "kjv_def": ":--Lord's.",
               "_strongs": "02960"
            },
            {
               "strongs": "2961",
               "greek": [
                  {
                     "_BETA": "KURIEU/W",
                     "_unicode": "κυριεύω",
                     "_translit": "kyrieúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko-ree-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2962"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to rule",
               "kjv_def": ":--have dominion over, lord, be lord of, exercise\n lordship over.",
               "_strongs": "02961"
            },
            {
               "strongs": "2962",
               "greek": [
                  {
                     "_BETA": "KU/RIOS",
                     "_unicode": "κύριος",
                     "_translit": "kýrios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-ree-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "KU=ROS",
                        "_unicode": "κῦρος",
                        "_translit": "kŷros"
                     }
                  ],
                  "__text": "from \n (supremacy);"
               },
               "strongs_def": "supreme in authority, i.e. (as noun)\n controller; by implication, Master (as a respectful title)",
               "kjv_def": ":-- God,\n Lord, master, Sir.",
               "_strongs": "02962"
            },
            {
               "strongs": "2963",
               "greek": [
                  {
                     "_BETA": "KURIO/THS",
                     "_unicode": "κυριότης",
                     "_translit": "kyriótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ree-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2962"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "mastery, i.e. (concretely and collectively)\n rulers",
               "kjv_def": ":--dominion, government.",
               "_strongs": "02963"
            },
            {
               "strongs": "2964",
               "greek": [
                  {
                     "_BETA": "KURO/W",
                     "_unicode": "κυρόω",
                     "_translit": "kyróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2962"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to make authoritative, i.e. ratify",
               "kjv_def": ":--confirm.",
               "_strongs": "02964"
            },
            {
               "strongs": "2965",
               "greek": [
                  {
                     "_BETA": "KU/WN",
                     "_unicode": "κύων",
                     "_translit": "kýōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koo'-ohn"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "a dog (\"hound\") (literally or figuratively)",
               "kjv_def": ":--dog.",
               "_strongs": "02965"
            },
            {
               "strongs": "2966",
               "greek": [
                  {
                     "_BETA": "KW=LON",
                     "_unicode": "κῶλον",
                     "_translit": "kōlon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko'-lon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2849"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a limb of the body (as if lopped)",
               "kjv_def": ":--carcase.",
               "_strongs": "02966"
            },
            {
               "strongs": "2967",
               "greek": [
                  {
                     "_BETA": "KWLU/W",
                     "_unicode": "κωλύω",
                     "_translit": "kōlýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko-loo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2849"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "to estop, i.e. prevent (by word or\n act)",
               "kjv_def": ":--forbid, hinder, keep from, let, not suffer, withstand.",
               "_strongs": "02967"
            },
            {
               "strongs": "2968",
               "greek": [
                  {
                     "_BETA": "KW/MH",
                     "_unicode": "κώμη",
                     "_translit": "kṓmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a hamlet (as if laid down)",
               "kjv_def": ":--town, village.",
               "_strongs": "02968"
            },
            {
               "strongs": "2969",
               "greek": [
                  {
                     "_BETA": "KWMO/POLIS",
                     "_unicode": "κωμόπολις",
                     "_translit": "kōmópolis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko-mop'-ol-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2968"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an unwalled city",
               "kjv_def": ":--town.",
               "_strongs": "02969"
            },
            {
               "strongs": "2970",
               "greek": [
                  {
                     "_BETA": "KW=MOS",
                     "_unicode": "κῶμος",
                     "_translit": "kōmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko'-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a carousal (as if letting loose)",
               "kjv_def": ":--revelling, rioting.",
               "_strongs": "02970"
            },
            {
               "strongs": "2971",
               "greek": [
                  {
                     "_BETA": "KW/NWY",
                     "_unicode": "κώνωψ",
                     "_translit": "kṓnōps"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko'-nopes"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2759"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "apparently a derivative of the base of \n and a derivative of \n;"
               },
               "strongs_def": "a mosquito (from its stinging proboscis)",
               "kjv_def": ":--gnat.",
               "_strongs": "02971"
            },
            {
               "strongs": "2972",
               "greek": [
                  {
                     "_BETA": "*KW/S",
                     "_unicode": "Κώς",
                     "_translit": "Kṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "koce"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Cos, an island in the Mediterranean",
               "kjv_def": ":--Cos.",
               "_strongs": "02972"
            },
            {
               "strongs": "2973",
               "greek": [
                  {
                     "_BETA": "*KWSA/M",
                     "_unicode": "Κωσάμ",
                     "_translit": "Kōsám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko-sam'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07081"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "Cosam (i.e. Kosam) an\n Israelite",
               "kjv_def": ":--Cosam.",
               "_strongs": "02973"
            },
            {
               "strongs": "2974",
               "greek": [
                  {
                     "_BETA": "KWFO/S",
                     "_unicode": "κωφός",
                     "_translit": "kōphós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ko-fos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "blunted, i.e. (figuratively) of hearing (deaf) or speech\n (dumb)",
               "kjv_def": ":--deaf, dumb, speechless.",
               "_strongs": "02974"
            },
            {
               "strongs": "2975",
               "greek": [
                  {
                     "_BETA": "LAGXA/NW",
                     "_unicode": "λαγχάνω",
                     "_translit": "lanchánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lang-khan'-o"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb, which is only used as an alternate\n in certain tenses;",
               "strongs_def": "to lot, i.e. determine (by implication, receive)\n especially by lot",
               "kjv_def": ":--his lot be, cast lots, obtain.",
               "_strongs": "02975"
            },
            {
               "strongs": "2976",
               "greek": [
                  {
                     "_BETA": "*LA/ZAROS",
                     "_unicode": "Λάζαρος",
                     "_translit": "Lázaros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lad'-zar-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0499"
                     }
                  ],
                  "__text": "probably of Hebrew origin (\n);"
               },
               "strongs_def": "Lazarus (i.e. Elazar), the name of\n two Israelites (one imaginary)",
               "kjv_def": ":--Lazarus.",
               "_strongs": "02976"
            },
            {
               "strongs": "2977",
               "greek": [
                  {
                     "_BETA": "LA/QRA",
                     "_unicode": "λάθρα",
                     "_translit": "láthra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lath'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2990"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "privately",
               "kjv_def": ":--privily, secretly.",
               "_strongs": "02977"
            },
            {
               "strongs": "2978",
               "greek": [
                  {
                     "_BETA": "LAI=LAY",
                     "_unicode": "λαῖλαψ",
                     "_translit": "laîlaps"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lah'-ee-laps"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a whirlwind (squall)",
               "kjv_def": ":--storm, tempest.",
               "_strongs": "02978"
            },
            {
               "strongs": "2979",
               "greek": [
                  {
                     "_BETA": "LAKTI/ZW",
                     "_unicode": "λακτίζω",
                     "_translit": "laktízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lak-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LA/C",
                        "_unicode": "λάξ",
                        "_translit": "láx"
                     }
                  ],
                  "__text": "from adverb \n (heelwise);"
               },
               "strongs_def": "to recalcitrate",
               "kjv_def": ":--kick.",
               "_strongs": "02979"
            },
            {
               "strongs": "2980",
               "greek": [
                  {
                     "_BETA": "LALE/W",
                     "_unicode": "λαλέω",
                     "_translit": "laléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lal-eh'-o"
                  }
               ],
               "strongs_derivation": "a prolonged form of an otherwise obsolete verb;",
               "strongs_def": "to talk, i.e. utter\n words",
               "kjv_def": ":--preach, say, speak (after), talk, tell, utter.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3004"
                  }
               ],
               "_strongs": "02980",
               "__text": "Compare \n."
            },
            {
               "strongs": "2981",
               "greek": [
                  {
                     "_BETA": "LALIA/",
                     "_unicode": "λαλιά",
                     "_translit": "laliá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lal-ee-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "talk",
               "kjv_def": ":--saying, speech.",
               "_strongs": "02981"
            },
            {
               "strongs": "2982",
               "greek": [
                  {
                     "_BETA": "LAMA/",
                     "_unicode": "λαμά",
                     "_translit": "lamá"
                  },
                  {
                     "_BETA": "LAMMA=",
                     "_unicode": "λαμμᾶ",
                     "_translit": "lammâ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lam-ah'"
                  },
                  {
                     "_strongs": "lam-mah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04100"
                     }
                  ],
                  "__text": "of Hebrew origin (\n with prepositional prefix);"
               },
               "strongs_def": "lama (i.e. why)",
               "kjv_def": ":--lama.",
               "_strongs": "02982",
               "__text": "or \n  \n;"
            },
            {
               "strongs": "2983",
               "greek": [
                  {
                     "_BETA": "LAMBA/NW",
                     "_unicode": "λαμβάνω",
                     "_translit": "lambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lam-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "a prolonged form of a primary verb, which is use only as an alternate\n in certain tenses; to take (in very many applications, literally and\n figuratively (properly objective or active, to get hold of; whereas\n \n is rather subjective or passive, to have offered to one;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "while\n \n is more violent, to seize or remove))"
               },
               "kjv_def": ":--accept, + be amazed,\n assay, attain, bring, X when I call, catch, come on (X unto), +\n forget, have, hold, obtain, receive (X after), take (away, up).",
               "_strongs": "02983"
            },
            {
               "strongs": "2984",
               "greek": [
                  {
                     "_BETA": "*LA/MEX",
                     "_unicode": "Λάμεχ",
                     "_translit": "Lámech"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lam'-ekh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03929"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Lamech (i.e. Lemek), a patriarch",
               "kjv_def": ":--Lamech.",
               "_strongs": "02984"
            },
            {
               "strongs": "2985",
               "greek": [
                  {
                     "_BETA": "LAMPA/S",
                     "_unicode": "λαμπάς",
                     "_translit": "lampás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lam-pas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2989"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a \"lamp\" or flambeau",
               "kjv_def": ":--lamp, light, torch.",
               "_strongs": "02985"
            },
            {
               "strongs": "2986",
               "greek": [
                  {
                     "_BETA": "LAMPRO/S",
                     "_unicode": "λαμπρός",
                     "_translit": "lamprós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lam-pros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2985"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "radiant; by analogy, limpid; figuratively,\n magnificent or sumptuous (in appearance)",
               "kjv_def": ":--bright, clear, gay, goodly,\n gorgeous, white.",
               "_strongs": "02986"
            },
            {
               "strongs": "2987",
               "greek": [
                  {
                     "_BETA": "LAMPRO/THS",
                     "_unicode": "λαμπρότης",
                     "_translit": "lamprótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lam-prot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2986"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "brilliancy",
               "kjv_def": ":--brightness.",
               "_strongs": "02987"
            },
            {
               "strongs": "2988",
               "greek": [
                  {
                     "_BETA": "LAMPRW=S",
                     "_unicode": "λαμπρῶς",
                     "_translit": "lamprōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lam-proce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2986"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "brilliantly, i.e. figuratively,\n luxuriously",
               "kjv_def": ":--sumptuously.",
               "_strongs": "02988"
            },
            {
               "strongs": "2989",
               "greek": [
                  {
                     "_BETA": "LA/MPW",
                     "_unicode": "λάμπω",
                     "_translit": "lámpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lam'-po"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to beam, i.e. radiate brilliancy (literally or\n figuratively)",
               "kjv_def": ":--give light, shine.",
               "_strongs": "02989"
            },
            {
               "strongs": "2990",
               "greek": [
                  {
                     "_BETA": "LANQA/NW",
                     "_unicode": "λανθάνω",
                     "_translit": "lanthánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lan-than'-o"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb, which is used only as an alternate\n in certain tenses;",
               "strongs_def": "to lie hid (literally or figuratively); often used\n adverbially, unwittingly",
               "kjv_def": ":--be hid, be ignorant of, unawares.",
               "_strongs": "02990"
            },
            {
               "strongs": "2991",
               "greek": [
                  {
                     "_BETA": "LACEUTO/S",
                     "_unicode": "λαξευτός",
                     "_translit": "laxeutós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lax-yoo-tos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LA=S",
                        "_unicode": "λᾶς",
                        "_translit": "lâs"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3584"
                     }
                  ],
                  "__text": "from a compound of \n (a stone) and the base of \n (in its original\n sense of scraping);"
               },
               "strongs_def": "rock-quarried",
               "kjv_def": ":--hewn in stone.",
               "_strongs": "02991"
            },
            {
               "strongs": "2992",
               "greek": [
                  {
                     "_BETA": "LAO/S",
                     "_unicode": "λαός",
                     "_translit": "laós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lah-os'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     }
                  ],
                  "__text": "a people (in general; thus differing from\n \n, which denotes one's own populace)"
               },
               "kjv_def": ":--people.",
               "_strongs": "02992"
            },
            {
               "strongs": "2993",
               "greek": [
                  {
                     "_BETA": "*LAODI/KEIA",
                     "_unicode": "Λαοδίκεια",
                     "_translit": "Laodíkeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lah-od-ik'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2992"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "Laodicia, a place in Asia\n Minor",
               "kjv_def": ":--Laodicea.",
               "_strongs": "02993"
            },
            {
               "strongs": "2994",
               "greek": [
                  {
                     "_BETA": "*LAODIKEU/S",
                     "_unicode": "Λαοδικεύς",
                     "_translit": "Laodikeús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lah-od-ik-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2993"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Laodicean, i.e. inhabitant of Laodicia",
               "kjv_def": ":--Laodicean.",
               "_strongs": "02994"
            },
            {
               "strongs": "2995",
               "greek": [
                  {
                     "_BETA": "LA/RUGC",
                     "_unicode": "λάρυγξ",
                     "_translit": "lárynx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lar'-oongks"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "the throat (\"larynx\")",
               "kjv_def": ":--throat.",
               "_strongs": "02995"
            },
            {
               "strongs": "2996",
               "greek": [
                  {
                     "_BETA": "*LASAI/A",
                     "_unicode": "Λασαία",
                     "_translit": "Lasaía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "las-ah'-yah"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Lasæa, a place in Crete",
               "kjv_def": ":--Lasea.",
               "_strongs": "02996"
            },
            {
               "strongs": "2997",
               "greek": [
                  {
                     "_BETA": "LA/SXW",
                     "_unicode": "λάσχω",
                     "_translit": "láschō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "las'-kho"
                  }
               ],
               "strongs_derivation": "a strengthened form of a primary verb, which only occurs in this and\n another prolonged form as alternate in certain tenses;",
               "strongs_def": "to crack open\n (from a fall)",
               "kjv_def": ":--burst asunder.",
               "_strongs": "02997"
            },
            {
               "strongs": "2998",
               "greek": [
                  {
                     "_BETA": "LATOME/W",
                     "_unicode": "λατομέω",
                     "_translit": "latoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lat-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2991"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5114"
                     }
                  ],
                  "__text": "from the same as the first part of \n and the base of \n;"
               },
               "strongs_def": "to\n quarry",
               "kjv_def": ":--hew.",
               "_strongs": "02998"
            },
            {
               "strongs": "2999",
               "greek": [
                  {
                     "_BETA": "LATREI/A",
                     "_unicode": "λατρεία",
                     "_translit": "latreía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lat-ri'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3000"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "ministration of God, i.e. worship",
               "kjv_def": ":--(divine) service.",
               "_strongs": "02999"
            },
            {
               "strongs": "3000",
               "greek": [
                  {
                     "_BETA": "LATREU/W",
                     "_unicode": "λατρεύω",
                     "_translit": "latreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lat-ryoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LA/TRIS",
                        "_unicode": "λάτρις",
                        "_translit": "látris"
                     }
                  ],
                  "__text": "from \n (a hired menial);"
               },
               "strongs_def": "to minister (to God), i.e. render\n religious homage",
               "kjv_def": ":--serve, do the service, worship(-per).",
               "_strongs": "03000"
            },
            {
               "strongs": "3001",
               "greek": [
                  {
                     "_BETA": "LA/XANON",
                     "_unicode": "λάχανον",
                     "_translit": "láchanon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lakh'-an-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LAXAI/NW",
                        "_unicode": "λαχαίνω",
                        "_translit": "lachaínō"
                     }
                  ],
                  "__text": "from \n (to dig);"
               },
               "strongs_def": "a vegetable",
               "kjv_def": ":--herb.",
               "_strongs": "03001"
            },
            {
               "strongs": "3002",
               "greek": [
                  {
                     "_BETA": "*LEBBAI=OS",
                     "_unicode": "Λεββαῖος",
                     "_translit": "Lebbaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "leb-bah'-yos"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Lebbæus, a Christian",
               "kjv_def": ":--Lebbæus.",
               "_strongs": "03002"
            },
            {
               "strongs": "3003",
               "greek": [
                  {
                     "_BETA": "LEGEW/N",
                     "_unicode": "λεγεών",
                     "_translit": "legeṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "leg-eh-ohn'"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a \"legion\", i.e. Roman regiment\n (figuratively)",
               "kjv_def": ":--legion.",
               "_strongs": "03003"
            },
            {
               "strongs": "3004",
               "greek": [
                  {
                     "_BETA": "LE/GW",
                     "_unicode": "λέγω",
                     "_translit": "légō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "leg'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2036"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "properly, to \"lay\" forth, i.e. (figuratively) relate\n (in words (usually of systematic or set discourse; whereas \n and\n \n generally refer to an individual expression or speech\n respectively; while \n is properly to break silence merely, and \n\n means an extended or random harangue)); by implication, to mean"
               },
               "kjv_def": ":--ask,\n bid, boast, call, describe, give out, name, put forth, say(-ing, on),\n shew, speak, tell, utter.",
               "_strongs": "03004"
            },
            {
               "strongs": "3005",
               "greek": [
                  {
                     "_BETA": "LEI=MMA",
                     "_unicode": "λεῖμμα",
                     "_translit": "leîmma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lime'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a remainder",
               "kjv_def": ":--remnant.",
               "_strongs": "03005"
            },
            {
               "strongs": "3006",
               "greek": [
                  {
                     "_BETA": "LEI=OS",
                     "_unicode": "λεῖος",
                     "_translit": "leîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "li'-os"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "smooth, i.e. \"level\"",
               "kjv_def": ":--smooth.",
               "_strongs": "03006"
            },
            {
               "strongs": "3007",
               "greek": [
                  {
                     "_BETA": "LEI/PW",
                     "_unicode": "λείπω",
                     "_translit": "leípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "li'-po"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to leave, i.e. (intransitively or passively) to fail\n or be absent",
               "kjv_def": ":--be destitute (wanting), lack.",
               "_strongs": "03007"
            },
            {
               "strongs": "3008",
               "greek": [
                  {
                     "_BETA": "LEITOURGE/W",
                     "_unicode": "λειτουργέω",
                     "_translit": "leitourgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "li-toorg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3011"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a public servant, i.e. (by analogy) to perform\n religious or charitable functions (worship, obey, relieve)",
               "kjv_def": ":--minister.",
               "_strongs": "03008"
            },
            {
               "strongs": "3009",
               "greek": [
                  {
                     "_BETA": "LEITOURGI/A",
                     "_unicode": "λειτουργία",
                     "_translit": "leitourgía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "li-toorg-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3008"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "public function (as priest (\"liturgy\") or\n almsgiver)",
               "kjv_def": ":--ministration(-try), service.",
               "_strongs": "03009"
            },
            {
               "strongs": "3010",
               "greek": [
                  {
                     "_BETA": "LEITOURGIKO/S",
                     "_unicode": "λειτουργικός",
                     "_translit": "leitourgikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "li-toorg-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3008"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "functional publicly (\"liturgic\"); i.e.\n beneficient",
               "kjv_def": ":--ministering.",
               "_strongs": "03010"
            },
            {
               "strongs": "3011",
               "greek": [
                  {
                     "_BETA": "LEITOURGO/S",
                     "_unicode": "λειτουργός",
                     "_translit": "leitourgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "li-toorg-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2992"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from a derivative of \n and \n;"
               },
               "strongs_def": "a public servant, i.e. a\n functionary in the Temple or Gospel, or (genitive case) a worshipper\n (of God) or benefactor (of man)",
               "kjv_def": ":--minister(-ed).",
               "_strongs": "03011"
            },
            {
               "strongs": "3012",
               "greek": [
                  {
                     "_BETA": "LE/NTION",
                     "_unicode": "λέντιον",
                     "_translit": "léntion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "len'-tee-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a \"linen\" cloth, i.e. apron",
               "kjv_def": ":--towel.",
               "_strongs": "03012"
            },
            {
               "strongs": "3013",
               "greek": [
                  {
                     "_BETA": "LEPI/S",
                     "_unicode": "λεπίς",
                     "_translit": "lepís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lep-is'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LE/PW",
                        "_unicode": "λέπω",
                        "_translit": "lépō"
                     }
                  ],
                  "__text": "from \n (to peel);"
               },
               "strongs_def": "a flake",
               "kjv_def": ":--scale.",
               "_strongs": "03013"
            },
            {
               "strongs": "3014",
               "greek": [
                  {
                     "_BETA": "LE/PRA",
                     "_unicode": "λέπρα",
                     "_translit": "lépra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lep'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3013"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "scaliness, i.e. \"leprosy\"",
               "kjv_def": ":--leprosy.",
               "_strongs": "03014"
            },
            {
               "strongs": "3015",
               "greek": [
                  {
                     "_BETA": "LEPRO/S",
                     "_unicode": "λεπρός",
                     "_translit": "leprós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lep-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3014"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "scaly, i.e. leprous (a leper)",
               "kjv_def": ":--leper.",
               "_strongs": "03015"
            },
            {
               "strongs": "3016",
               "greek": [
                  {
                     "_BETA": "LEPTO/N",
                     "_unicode": "λεπτόν",
                     "_translit": "leptón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lep-ton'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3013"
                     }
                  ],
                  "__text": "neuter of a derivative of the same as \n;"
               },
               "strongs_def": "something scaled (light),\n i.e. a small coin",
               "kjv_def": ":--mite.",
               "_strongs": "03016"
            },
            {
               "strongs": "3017",
               "greek": [
                  {
                     "_BETA": "*LEUI/+",
                     "_unicode": "Λευΐ",
                     "_translit": "Leuḯ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lyoo'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03878"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Levi, the name of three Israelites",
               "kjv_def": ":--Levi.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3018"
                  }
               ],
               "_strongs": "03017",
               "__text": "Compare \n."
            },
            {
               "strongs": "3018",
               "greek": [
                  {
                     "_BETA": "*LEUI/+S",
                     "_unicode": "Λευΐς",
                     "_translit": "Leuḯs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lyoo-is'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3017"
                     }
                  ],
                  "__text": "a form of \n;"
               },
               "strongs_def": "Lewis (i.e. Levi), a Christian",
               "kjv_def": ":--Levi.",
               "_strongs": "03018"
            },
            {
               "strongs": "3019",
               "greek": [
                  {
                     "_BETA": "*LEUI/+THS",
                     "_unicode": "Λευΐτης",
                     "_translit": "Leuḯtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lyoo-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3017"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Levite, i.e. descendant of Levi",
               "kjv_def": ":--Levite.",
               "_strongs": "03019"
            },
            {
               "strongs": "3020",
               "greek": [
                  {
                     "_BETA": "*LEUI+TIKO/S",
                     "_unicode": "Λευϊτικός",
                     "_translit": "Leuïtikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lyoo-it'-ee-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3019"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Levitic, i.e. relating to the Levites",
               "kjv_def": ":--Levitical.",
               "_strongs": "03020"
            },
            {
               "strongs": "3021",
               "greek": [
                  {
                     "_BETA": "LEUKAI/NW",
                     "_unicode": "λευκαίνω",
                     "_translit": "leukaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lyoo-kah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3022"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to whiten",
               "kjv_def": ":--make white, whiten.",
               "_strongs": "03021"
            },
            {
               "strongs": "3022",
               "greek": [
                  {
                     "_BETA": "LEUKO/S",
                     "_unicode": "λευκός",
                     "_translit": "leukós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lyoo-kos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LU/KH",
                        "_unicode": "λύκη",
                        "_translit": "lýkē"
                     }
                  ],
                  "__text": "from \n (\"light\");"
               },
               "strongs_def": "white",
               "kjv_def": ":--white.",
               "_strongs": "03022"
            },
            {
               "strongs": "3023",
               "greek": [
                  {
                     "_BETA": "LE/WN",
                     "_unicode": "λέων",
                     "_translit": "léōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "leh-ohn'"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "a \"lion\"",
               "kjv_def": ":--lion.",
               "_strongs": "03023"
            },
            {
               "strongs": "3024",
               "greek": [
                  {
                     "_BETA": "LH/QH",
                     "_unicode": "λήθη",
                     "_translit": "lḗthē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lay'-thay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2990"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "forgetfulness",
               "kjv_def": ":--+ forget.",
               "_strongs": "03024"
            },
            {
               "strongs": "3025",
               "greek": [
                  {
                     "_BETA": "LHNO/S",
                     "_unicode": "ληνός",
                     "_translit": "lēnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lay-nos'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a trough, i.e. wine-vat",
               "kjv_def": ":--winepress.",
               "_strongs": "03025"
            },
            {
               "strongs": "3026",
               "greek": [
                  {
                     "_BETA": "LH=ROS",
                     "_unicode": "λῆρος",
                     "_translit": "lēros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lay'-ros"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "twaddle, i.e. an incredible story",
               "kjv_def": ":--idle\n tale.",
               "_strongs": "03026"
            },
            {
               "strongs": "3027",
               "greek": [
                  {
                     "_BETA": "LH|STH/S",
                     "_unicode": "λῃστής",
                     "_translit": "lēistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lace-tace'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LHI/+ZOMAI",
                        "_unicode": "ληΐζομαι",
                        "_translit": "lēḯzomai"
                     }
                  ],
                  "__text": "from \n (to plunder);"
               },
               "strongs_def": "a brigand",
               "kjv_def": ":--robber, thief.",
               "_strongs": "03027"
            },
            {
               "strongs": "3028",
               "greek": [
                  {
                     "_BETA": "LH=MYIS",
                     "_unicode": "λῆμψις",
                     "_translit": "lēmpsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lape'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "receipt (the act)",
               "kjv_def": ":--receiving.",
               "_strongs": "03028"
            },
            {
               "strongs": "3029",
               "greek": [
                  {
                     "_BETA": "LI/AN",
                     "_unicode": "λίαν",
                     "_translit": "lían"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lee'-an"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "much (adverbially)",
               "kjv_def": ":--exceeding, great(-ly),\n sore, very (+ chiefest).",
               "_strongs": "03029"
            },
            {
               "strongs": "3030",
               "greek": [
                  {
                     "_BETA": "LI/BANOS",
                     "_unicode": "λίβανος",
                     "_translit": "líbanos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lib'-an-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03828"
                     }
                  ],
                  "__text": "of foreign origin (\n);"
               },
               "strongs_def": "the incense-tree, i.e. (by implication)\n incense itself",
               "kjv_def": ":--frankincense.",
               "_strongs": "03030"
            },
            {
               "strongs": "3031",
               "greek": [
                  {
                     "_BETA": "LIBANWTO/S",
                     "_unicode": "λιβανωτός",
                     "_translit": "libanōtós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lib-an-o-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3030"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "frankincense, i.e. (by extension) a censer for burning\n it",
               "kjv_def": ":--censer.",
               "_strongs": "03031"
            },
            {
               "strongs": "3032",
               "greek": [
                  {
                     "_BETA": "*LIBERTI=NOS",
                     "_unicode": "Λιβερτῖνος",
                     "_translit": "Libertînos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lib-er-tee'-nos"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a Roman freedman",
               "kjv_def": ":--Libertine.",
               "_strongs": "03032"
            },
            {
               "strongs": "3033",
               "greek": [
                  {
                     "_BETA": "*LIBU/H",
                     "_unicode": "Λιβύη",
                     "_translit": "Libýē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lib-oo'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3047"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "Libye, a region of Africa",
               "kjv_def": ":--Libya.",
               "_strongs": "03033"
            },
            {
               "strongs": "3034",
               "greek": [
                  {
                     "_BETA": "LIQA/ZW",
                     "_unicode": "λιθάζω",
                     "_translit": "litházō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lith-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3037"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to lapidate",
               "kjv_def": ":--stone.",
               "_strongs": "03034"
            },
            {
               "strongs": "3035",
               "greek": [
                  {
                     "_BETA": "LI/QINOS",
                     "_unicode": "λίθινος",
                     "_translit": "líthinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lith-ee'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3037"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "stony, i.e. made of stone",
               "kjv_def": ":--of stone.",
               "_strongs": "03035"
            },
            {
               "strongs": "3036",
               "greek": [
                  {
                     "_BETA": "LIQOBOLE/W",
                     "_unicode": "λιθοβολέω",
                     "_translit": "lithoboléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lith-ob-ol-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3037"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to throw stones, i.e.\n lapidate",
               "kjv_def": ":--stone, cast stones.",
               "_strongs": "03036"
            },
            {
               "strongs": "3037",
               "greek": [
                  {
                     "_BETA": "LI/QOS",
                     "_unicode": "λίθος",
                     "_translit": "líthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lee'-thos"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a stone (literally or\n figuratively)",
               "kjv_def": ":--(mill-, stumbling-)stone.",
               "_strongs": "03037"
            },
            {
               "strongs": "3038",
               "greek": [
                  {
                     "_BETA": "LIQO/STRWTOS",
                     "_unicode": "λιθόστρωτος",
                     "_translit": "lithóstrōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lith-os'-tro-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3037"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4766"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "stone-strewed, i.e. a tessellated\n mosaic on which the Roman tribunal was placed",
               "kjv_def": ":--Pavement.",
               "_strongs": "03038"
            },
            {
               "strongs": "3039",
               "greek": [
                  {
                     "_BETA": "LIKMA/W",
                     "_unicode": "λικμάω",
                     "_translit": "likmáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lik-mah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LIKMO/S",
                        "_unicode": "λικμός",
                        "_translit": "likmós"
                     },
                     {
                        "_BETA": "LI/KNON",
                        "_unicode": "λίκνον",
                        "_translit": "líknon"
                     }
                  ],
                  "__text": "from \n, the equivalent of \n (a winnowing fan or basket);"
               },
               "strongs_def": "to\n winnow, i.e. (by analogy), to triturate",
               "kjv_def": ":--grind to powder.",
               "_strongs": "03039"
            },
            {
               "strongs": "3040",
               "greek": [
                  {
                     "_BETA": "LIMH/N",
                     "_unicode": "λιμήν",
                     "_translit": "limḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lee-mane'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a harbor",
               "kjv_def": ":--haven.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2568"
                  }
               ],
               "_strongs": "03040",
               "__text": "Compare \n."
            },
            {
               "strongs": "3041",
               "greek": [
                  {
                     "_BETA": "LI/MNH",
                     "_unicode": "λίμνη",
                     "_translit": "límnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lim'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3040"
                     }
                  ],
                  "__text": "probably from \n (through the idea of nearness of shore);"
               },
               "strongs_def": "a pond\n (large or small)",
               "kjv_def": ":--lake.",
               "_strongs": "03041"
            },
            {
               "strongs": "3042",
               "greek": [
                  {
                     "_BETA": "LIMO/S",
                     "_unicode": "λιμός",
                     "_translit": "limós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lee-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "probably from \n (through the idea of destitution);"
               },
               "strongs_def": "a scarcity of\n food",
               "kjv_def": ":--dearth, famine, hunger.",
               "_strongs": "03042"
            },
            {
               "strongs": "3043",
               "greek": [
                  {
                     "_BETA": "LI/NON",
                     "_unicode": "λίνον",
                     "_translit": "línon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lee'-non"
                  }
               ],
               "strongs_derivation": "probably a primary word;",
               "strongs_def": "flax, i.e. (by implication) \"linen\"",
               "kjv_def": ":--linen.",
               "_strongs": "03043"
            },
            {
               "strongs": "3044",
               "greek": [
                  {
                     "_BETA": "*LI/NOS",
                     "_unicode": "Λίνος",
                     "_translit": "Línos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lee'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3043"
                     }
                  ],
                  "__text": "perhaps from \n;"
               },
               "strongs_def": "Linus, a Christian",
               "kjv_def": ":--Linus.",
               "_strongs": "03044"
            },
            {
               "strongs": "3045",
               "greek": [
                  {
                     "_BETA": "LIPARO/S",
                     "_unicode": "λιπαρός",
                     "_translit": "liparós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lip-ar-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LI/POS",
                        "_unicode": "λίπος",
                        "_translit": "lípos"
                     }
                  ],
                  "__text": "from \n (grease);"
               },
               "strongs_def": "fat, i.e. (figuratively) sumptuous",
               "kjv_def": ":--dainty.",
               "_strongs": "03045"
            },
            {
               "strongs": "3046",
               "greek": [
                  {
                     "_BETA": "LI/TRA",
                     "_unicode": "λίτρα",
                     "_translit": "lítra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lee'-trah"
                  }
               ],
               "strongs_derivation": "of Latin origin (libra);",
               "strongs_def": "a pound in weight",
               "kjv_def": ":--pound.",
               "_strongs": "03046"
            },
            {
               "strongs": "3047",
               "greek": [
                  {
                     "_BETA": "LI/Y",
                     "_unicode": "λίψ",
                     "_translit": "líps"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "leeps"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LEI/BW",
                        "_unicode": "λείβω",
                        "_translit": "leíbō"
                     }
                  ],
                  "__text": "probably from \n (to pour a \"libation\");"
               },
               "strongs_def": "the south(- west) wind (as\n bringing rain, i.e. (by extension) the south quarter)",
               "kjv_def": ":--southwest.",
               "_strongs": "03047"
            },
            {
               "strongs": "3048",
               "greek": [
                  {
                     "_BETA": "LOGI/A",
                     "_unicode": "λογία",
                     "_translit": "logía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n (in the commercial sense);"
               },
               "strongs_def": "a contribution",
               "kjv_def": ":--collection,\n gathering.",
               "_strongs": "03048"
            },
            {
               "strongs": "3049",
               "greek": [
                  {
                     "_BETA": "LOGI/ZOMAI",
                     "_unicode": "λογίζομαι",
                     "_translit": "logízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to take an inventory, i.e. estimate (literally\n or figuratively)",
               "kjv_def": ":--conclude, (ac-)count (of), + despise, esteem,\n impute, lay, number, reason, reckon, suppose, think (on).",
               "_strongs": "03049"
            },
            {
               "strongs": "3050",
               "greek": [
                  {
                     "_BETA": "LOGIKO/S",
                     "_unicode": "λογικός",
                     "_translit": "logikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "rational (\"logical\")",
               "kjv_def": ":--reasonable, of the word.",
               "_strongs": "03050"
            },
            {
               "strongs": "3051",
               "greek": [
                  {
                     "_BETA": "LO/GION",
                     "_unicode": "λόγιον",
                     "_translit": "lógion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3052"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": "an utterance (of God)",
               "kjv_def": ":--oracle.",
               "_strongs": "03051"
            },
            {
               "strongs": "3052",
               "greek": [
                  {
                     "_BETA": "LO/GIOS",
                     "_unicode": "λόγιος",
                     "_translit": "lógios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fluent, i.e. an orator",
               "kjv_def": ":--eloquent.",
               "_strongs": "03052"
            },
            {
               "strongs": "3053",
               "greek": [
                  {
                     "_BETA": "LOGISMO/S",
                     "_unicode": "λογισμός",
                     "_translit": "logismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3049"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "computation, i.e. (figuratively) reasoning (conscience,\n conceit)",
               "kjv_def": ":--imagination, thought.",
               "_strongs": "03053"
            },
            {
               "strongs": "3054",
               "greek": [
                  {
                     "_BETA": "LOGOMAXE/W",
                     "_unicode": "λογομαχέω",
                     "_translit": "logomachéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log-om-akh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3164"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be disputatious (on\n trifles)",
               "kjv_def": ":--strive about words.",
               "_strongs": "03054"
            },
            {
               "strongs": "3055",
               "greek": [
                  {
                     "_BETA": "LOGOMAXI/A",
                     "_unicode": "λογομαχία",
                     "_translit": "logomachía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log-om-akh-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3054"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "disputation about trifles\n (\"logomachy\")",
               "kjv_def": ":--strife of words.",
               "_strongs": "03055"
            },
            {
               "strongs": "3056",
               "greek": [
                  {
                     "_BETA": "LO/GOS",
                     "_unicode": "λόγος",
                     "_translit": "lógos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "log'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something said (including the thought); by implication, a\n topic (subject of discourse), also reasoning (the mental faculty) or\n motive; by extension, a computation; specially, (with the article in\n John) the Divine Expression (i.e. Christ)",
               "kjv_def": ":--account, cause,\n communication, X concerning, doctrine, fame, X have to do, intent,\n matter, mouth, preaching, question, reason, + reckon, remove,\n say(-ing), shew, X speaker, speech, talk, thing, + none of these\n things move me, tidings, treatise, utterance, word, work.",
               "_strongs": "03056"
            },
            {
               "strongs": "3057",
               "greek": [
                  {
                     "_BETA": "LO/GXH",
                     "_unicode": "λόγχη",
                     "_translit": "lónchē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "long'-khay"
                  }
               ],
               "strongs_derivation": "perhaps a primary word;",
               "strongs_def": "a \"lance\"",
               "kjv_def": ":--spear.",
               "_strongs": "03057"
            },
            {
               "strongs": "3058",
               "greek": [
                  {
                     "_BETA": "LOIDORE/W",
                     "_unicode": "λοιδορέω",
                     "_translit": "loidoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loy-dor-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3060"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to reproach, i.e. vilify",
               "kjv_def": ":--revile.",
               "_strongs": "03058"
            },
            {
               "strongs": "3059",
               "greek": [
                  {
                     "_BETA": "LOIDORI/A",
                     "_unicode": "λοιδορία",
                     "_translit": "loidoría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loy-dor-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3060"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "slander or vituperation",
               "kjv_def": ":--railing, reproach(-fully).",
               "_strongs": "03059"
            },
            {
               "strongs": "3060",
               "greek": [
                  {
                     "_BETA": "LOI/DOROS",
                     "_unicode": "λοίδορος",
                     "_translit": "loídoros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loy'-dor-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "LOIDO/S",
                        "_unicode": "λοιδός",
                        "_translit": "loidós"
                     }
                  ],
                  "__text": "from \n (mischief);"
               },
               "strongs_def": "abusive, i.e. a blackguard",
               "kjv_def": ":--railer, reviler.",
               "_strongs": "03060"
            },
            {
               "strongs": "3061",
               "greek": [
                  {
                     "_BETA": "LOIMO/S",
                     "_unicode": "λοιμός",
                     "_translit": "loimós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loy'-mos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a plague (literally, the disease, or\n figuratively, a pest)",
               "kjv_def": ":--pestilence(-t).",
               "_strongs": "03061"
            },
            {
               "strongs": "3062",
               "greek": [
                  {
                     "_BETA": "LOIPOI/",
                     "_unicode": "λοιποί",
                     "_translit": "loipoí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loy-poy'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "masculine plural of a derivative of \n;"
               },
               "strongs_def": "remaining ones",
               "kjv_def": ":--other,\n which remain, remnant, residue, rest.",
               "_strongs": "03062"
            },
            {
               "strongs": "3063",
               "greek": [
                  {
                     "_BETA": "LOIPO/N",
                     "_unicode": "λοιπόν",
                     "_translit": "loipón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loy-pon'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3062"
                     }
                  ],
                  "__text": "neuter singular of the same as \n;"
               },
               "strongs_def": "something remaining\n (adverbially)",
               "kjv_def": ":--besides, finally, furthermore, (from) henceforth,\n moreover, now, + it remaineth, then.",
               "_strongs": "03063"
            },
            {
               "strongs": "3064",
               "greek": [
                  {
                     "_BETA": "LOIPOU=",
                     "_unicode": "λοιποῦ",
                     "_translit": "loipoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loy-poo'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3062"
                     }
                  ],
                  "__text": "genitive case singular of the same as \n;"
               },
               "strongs_def": "remaining time",
               "kjv_def": ":--from\n henceforth.",
               "_strongs": "03064"
            },
            {
               "strongs": "3065",
               "greek": [
                  {
                     "_BETA": "*LOUKA=S",
                     "_unicode": "Λουκᾶς",
                     "_translit": "Loukâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-kas'"
                  }
               ],
               "strongs_derivation": {
                  "latin": "Lucanus",
                  "__text": "contracted from Latin \n;"
               },
               "strongs_def": "Lucas, a Christian",
               "kjv_def": ":--Lucas, Luke.",
               "_strongs": "03065"
            },
            {
               "strongs": "3066",
               "greek": [
                  {
                     "_BETA": "*LOU/KIOS",
                     "_unicode": "Λούκιος",
                     "_translit": "Loúkios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo'-kee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "illuminative; Lucius, a Christian",
               "kjv_def": ":--Lucius.",
               "_strongs": "03066"
            },
            {
               "strongs": "3067",
               "greek": [
                  {
                     "_BETA": "LOUTRO/N",
                     "_unicode": "λουτρόν",
                     "_translit": "loutrón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-tron'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3068"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a bath, i.e. (figuratively), baptism",
               "kjv_def": ":--washing.",
               "_strongs": "03067"
            },
            {
               "strongs": "3068",
               "greek": [
                  {
                     "_BETA": "LOU/W",
                     "_unicode": "λούω",
                     "_translit": "loúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3538"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4150"
                     }
                  ],
                  "__text": "to bathe (the whole person; whereas \n means to wet\n a part only, and \n to wash, cleanse garments exclusively)"
               },
               "kjv_def": ":--wash.",
               "_strongs": "03068"
            },
            {
               "strongs": "3069",
               "greek": [
                  {
                     "_BETA": "*LU/DDA",
                     "_unicode": "Λύδδα",
                     "_translit": "Lýdda"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lud'-dah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03850"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Lydda (i.e. Lod), a place in\n Palestine",
               "kjv_def": ":--Lydda.",
               "_strongs": "03069"
            },
            {
               "strongs": "3070",
               "greek": [
                  {
                     "_BETA": "*LUDI/A",
                     "_unicode": "Λυδία",
                     "_translit": "Lydía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-dee'-ah"
                  }
               ],
               "strongs_derivation": "properly, feminine of Ludios (of foreign origin) (a Lydian, in Asia\n Minor);",
               "strongs_def": "Lydia, a Christian woman",
               "kjv_def": ":--Lydia.",
               "_strongs": "03070"
            },
            {
               "strongs": "3071",
               "greek": [
                  {
                     "_BETA": "*LUKAONI/A",
                     "_unicode": "Λυκαονία",
                     "_translit": "Lykaonía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-kah-on-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3074"
                     }
                  ],
                  "__text": "perhaps remotely from \n;"
               },
               "strongs_def": "Lycaonia, a region of Asia\n Minor",
               "kjv_def": ":--Lycaonia.",
               "_strongs": "03071"
            },
            {
               "strongs": "3072",
               "greek": [
                  {
                     "_BETA": "*LUKAONISTI/",
                     "_unicode": "Λυκαονιστί",
                     "_translit": "Lykaonistí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-kah-on-is-tee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3071"
                     }
                  ],
                  "__text": "adverb from a derivative of \n;"
               },
               "strongs_def": "Lycaonistically, i.e. in the\n language of the Lycaonians",
               "kjv_def": ":--in the speech of Lycaonia.",
               "_strongs": "03072"
            },
            {
               "strongs": "3073",
               "greek": [
                  {
                     "_BETA": "*LUKI/A",
                     "_unicode": "Λυκία",
                     "_translit": "Lykía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-kee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3074"
                     }
                  ],
                  "__text": "probably remotely from \n;"
               },
               "strongs_def": "Lycia, a province of Asia Minor",
               "kjv_def": ":--Lycia.",
               "_strongs": "03073"
            },
            {
               "strongs": "3074",
               "greek": [
                  {
                     "_BETA": "LU/KOS",
                     "_unicode": "λύκος",
                     "_translit": "lýkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3022"
                     }
                  ],
                  "__text": "perhaps akin to the base of \n (from the whitish hair);"
               },
               "strongs_def": "a\n wolf",
               "kjv_def": ":--wolf.",
               "_strongs": "03074"
            },
            {
               "strongs": "3075",
               "greek": [
                  {
                     "_BETA": "LUMAI/NOMAI",
                     "_unicode": "λυμαίνομαι",
                     "_translit": "lymaínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-mah'-ee-nom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "middle voice from a probably derivative of \n (meaning filth);"
               },
               "strongs_def": "properly, to soil, i.e. (figuratively) insult (maltreat)",
               "kjv_def": ":--make havock\n of.",
               "_strongs": "03075"
            },
            {
               "strongs": "3076",
               "greek": [
                  {
                     "_BETA": "LUPE/W",
                     "_unicode": "λυπέω",
                     "_translit": "lypéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-peh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3077"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to distress; reflexively or passively, to be sad",
               "kjv_def": ":--cause\n grief, grieve, be in heaviness, (be) sorrow(-ful), be (make) sorry.",
               "_strongs": "03076"
            },
            {
               "strongs": "3077",
               "greek": [
                  {
                     "_BETA": "LU/PH",
                     "_unicode": "λύπη",
                     "_translit": "lýpē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo'-pay"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "sadness",
               "kjv_def": ":--grief, grievous, + grudgingly,\n heaviness, sorrow.",
               "_strongs": "03077"
            },
            {
               "strongs": "3078",
               "greek": [
                  {
                     "_BETA": "*LUSANI/AS",
                     "_unicode": "Λυσανίας",
                     "_translit": "Lysanías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-san-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3080"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)NI/A",
                        "_unicode": "ἀνία",
                        "_translit": "anía"
                     }
                  ],
                  "__text": "from \n and \n (trouble);"
               },
               "strongs_def": "grief-dispelling; Lysanias, a governor\n of Abilene",
               "kjv_def": ":--Lysanias.",
               "_strongs": "03078"
            },
            {
               "strongs": "3079",
               "greek": [
                  {
                     "_BETA": "*LUSI/AS",
                     "_unicode": "Λυσίας",
                     "_translit": "Lysías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-see'-as"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "Lysias, a Roman",
               "kjv_def": ":--Lysias.",
               "_strongs": "03079"
            },
            {
               "strongs": "3080",
               "greek": [
                  {
                     "_BETA": "LU/SIS",
                     "_unicode": "λύσις",
                     "_translit": "lýsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a loosening, i.e. (specially), divorce",
               "kjv_def": ":--to be loosed.",
               "_strongs": "03080"
            },
            {
               "strongs": "3081",
               "greek": [
                  {
                     "_BETA": "LUSITELEI=",
                     "_unicode": "λυσιτελεῖ",
                     "_translit": "lysiteleî"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-sit-el-i'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3080"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "third person singular present indicative active of a derivative of a\n compound of \n and \n;"
               },
               "strongs_def": "impersonally, it answers the purpose, i.e.\n is advantageous",
               "kjv_def": ":--it is better.",
               "_strongs": "03081"
            },
            {
               "strongs": "3082",
               "greek": [
                  {
                     "_BETA": "*LU/STRA",
                     "_unicode": "Λύστρα",
                     "_translit": "Lýstra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loos'-trah"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Lystra, a place in Asia Minor",
               "kjv_def": ":--Lystra.",
               "_strongs": "03082"
            },
            {
               "strongs": "3083",
               "greek": [
                  {
                     "_BETA": "LU/TRON",
                     "_unicode": "λύτρον",
                     "_translit": "lýtron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo'-tron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something to loosen with, i.e. a redemption price\n (figuratively, atonement)",
               "kjv_def": ":--ransom.",
               "_strongs": "03083"
            },
            {
               "strongs": "3084",
               "greek": [
                  {
                     "_BETA": "LUTRO/W",
                     "_unicode": "λυτρόω",
                     "_translit": "lytróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-tro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3083"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to ransom (literally or figuratively)",
               "kjv_def": ":--redeem.",
               "_strongs": "03084"
            },
            {
               "strongs": "3085",
               "greek": [
                  {
                     "_BETA": "LU/TRWSIS",
                     "_unicode": "λύτρωσις",
                     "_translit": "lýtrōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo'-tro-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3084"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a ransoming (figuratively)",
               "kjv_def": ":--+ redeemed, redemption.",
               "_strongs": "03085"
            },
            {
               "strongs": "3086",
               "greek": [
                  {
                     "_BETA": "LUTRWTH/S",
                     "_unicode": "λυτρωτής",
                     "_translit": "lytrōtḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo-tro-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3084"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a redeemer (figuratively)",
               "kjv_def": ":--deliverer.",
               "_strongs": "03086"
            },
            {
               "strongs": "3087",
               "greek": [
                  {
                     "_BETA": "LUXNI/A",
                     "_unicode": "λυχνία",
                     "_translit": "lychnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lookh-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3088"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a lamp-stand (literally or figuratively)",
               "kjv_def": ":--candlestick.",
               "_strongs": "03087"
            },
            {
               "strongs": "3088",
               "greek": [
                  {
                     "_BETA": "LU/XNOS",
                     "_unicode": "λύχνος",
                     "_translit": "lýchnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lookh'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3022"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a portable lamp or other illuminator (literally\n or figuratively)",
               "kjv_def": ":--candle, light.",
               "_strongs": "03088"
            },
            {
               "strongs": "3089",
               "greek": [
                  {
                     "_BETA": "LU/W",
                     "_unicode": "λύω",
                     "_translit": "lýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "loo'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to \"loosen\" (literally or figuratively)",
               "kjv_def": ":--break (up),\n destroy, dissolve, (un-)loose, melt, put off.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4486"
                  }
               ],
               "_strongs": "03089",
               "__text": "Compare \n."
            },
            {
               "strongs": "3090",
               "greek": [
                  {
                     "_BETA": "*LWI/+S",
                     "_unicode": "Λωΐς",
                     "_translit": "Lōḯs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lo-ece'"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Lois, a Christian woman",
               "kjv_def": ":--Lois.",
               "_strongs": "03090"
            },
            {
               "strongs": "3091",
               "greek": [
                  {
                     "_BETA": "*LW/T",
                     "_unicode": "Λώτ",
                     "_translit": "Lṓt"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "lote"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03876"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Lot, a patriarch",
               "kjv_def": ":--Lot.",
               "_strongs": "03091"
            },
            {
               "strongs": "3092",
               "greek": [
                  {
                     "_BETA": "*MAA/Q",
                     "_unicode": "Μαάθ",
                     "_translit": "Maáth"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mah-ath'"
                  }
               ],
               "strongs_derivation": "probably of Hebrew origin;",
               "strongs_def": "Maath, an Israelite",
               "kjv_def": ":--Maath.",
               "_strongs": "03092"
            },
            {
               "strongs": "3093",
               "greek": [
                  {
                     "_BETA": "*MAGDALA/",
                     "_unicode": "Μαγδαλά",
                     "_translit": "Magdalá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mag-dal-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04026"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "the tower; Magdala (i.e. Migdala), a\n place in Palestine",
               "kjv_def": ":--Magdala.",
               "_strongs": "03093"
            },
            {
               "strongs": "3094",
               "greek": [
                  {
                     "_BETA": "*MAGDALHNH/",
                     "_unicode": "Μαγδαληνή",
                     "_translit": "Magdalēnḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mag-dal-ay-nay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3093"
                     }
                  ],
                  "__text": "feminine of a derivative of \n;"
               },
               "strongs_def": "a female Magdalene, i.e. inhabitant\n of Magdala",
               "kjv_def": ":--Magdalene.",
               "_strongs": "03094"
            },
            {
               "strongs": "3095",
               "greek": [
                  {
                     "_BETA": "MAGEI/A",
                     "_unicode": "μαγεία",
                     "_translit": "mageía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mag-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3096"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "\"magic\"",
               "kjv_def": ":--sorcery.",
               "_strongs": "03095"
            },
            {
               "strongs": "3096",
               "greek": [
                  {
                     "_BETA": "MAGEU/W",
                     "_unicode": "μαγεύω",
                     "_translit": "mageúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mag-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3097"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to practice magic",
               "kjv_def": ":--use sorcery.",
               "_strongs": "03096"
            },
            {
               "strongs": "3097",
               "greek": [
                  {
                     "_BETA": "MA/GOS",
                     "_unicode": "μάγος",
                     "_translit": "mágos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mag'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07248"
                     }
                  ],
                  "__text": "of foreign origin (\n);"
               },
               "strongs_def": "a Magian, i.e. Oriental scientist; by\n implication, a magician",
               "kjv_def": ":--sorcerer, wise man.",
               "_strongs": "03097"
            },
            {
               "strongs": "3098",
               "greek": [
                  {
                     "_BETA": "*MAGW/G",
                     "_unicode": "Μαγώγ",
                     "_translit": "Magṓg"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mag-ogue'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04031"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Magog, a foreign nation, i.e. (figuratively)\n an Antichristian party",
               "kjv_def": ":--Magog.",
               "_strongs": "03098"
            },
            {
               "strongs": "3099",
               "greek": [
                  {
                     "_BETA": "*MADIA/N",
                     "_unicode": "Μαδιάν",
                     "_translit": "Madián"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mad-ee-on'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04080"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Madian (i.e. Midian), a region of\n Arabia",
               "kjv_def": ":--Madian.",
               "_strongs": "03099"
            },
            {
               "strongs": "3100",
               "greek": [
                  {
                     "_BETA": "MAQHTEU/W",
                     "_unicode": "μαθητεύω",
                     "_translit": "mathēteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "math-ayt-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3101"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "intransitively, to become a pupil; transitively, to\n disciple, i.e. enrol as scholar",
               "kjv_def": ":--be disciple, instruct, teach.",
               "_strongs": "03100"
            },
            {
               "strongs": "3101",
               "greek": [
                  {
                     "_BETA": "MAQHTH/S",
                     "_unicode": "μαθητής",
                     "_translit": "mathētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "math-ay-tes'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3129"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a learner, i.e. pupil",
               "kjv_def": ":--disciple.",
               "_strongs": "03101"
            },
            {
               "strongs": "3102",
               "greek": [
                  {
                     "_BETA": "MAQH/TRIA",
                     "_unicode": "μαθήτρια",
                     "_translit": "mathḗtria"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "math-ay'-tree-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3101"
                     }
                  ],
                  "__text": "feminine from \n;"
               },
               "strongs_def": "a female pupil",
               "kjv_def": ":--disciple.",
               "_strongs": "03102"
            },
            {
               "strongs": "3103",
               "greek": [
                  {
                     "_BETA": "*MAQOUSA/LA",
                     "_unicode": "Μαθουσάλα",
                     "_translit": "Mathousála"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "math-oo-sal'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04968"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Mathusala (i.e. Methushelach), an\n antediluvian",
               "kjv_def": ":--Mathusala.",
               "_strongs": "03103"
            },
            {
               "strongs": "3104",
               "greek": [
                  {
                     "_BETA": "*MAI+NA/N",
                     "_unicode": "Μαϊνάν",
                     "_translit": "Maïnán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mahee-nan'"
                  }
               ],
               "strongs_derivation": "probably of Hebrew origin;",
               "strongs_def": "Mainan, an Israelite",
               "kjv_def": ":--Mainan.",
               "_strongs": "03104"
            },
            {
               "strongs": "3105",
               "greek": [
                  {
                     "_BETA": "MAI/NOMAI",
                     "_unicode": "μαίνομαι",
                     "_translit": "maínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mah'-ee-nom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MA/W",
                        "_unicode": "μάω",
                        "_translit": "máō"
                     }
                  ],
                  "__text": "middle voice from a primary \n (to long for;"
               },
               "strongs_def": "through the idea of\n insensate craving); to rave as a \"maniac\"",
               "kjv_def": ":--be beside self (mad).",
               "_strongs": "03105"
            },
            {
               "strongs": "3106",
               "greek": [
                  {
                     "_BETA": "MAKARI/ZW",
                     "_unicode": "μακαρίζω",
                     "_translit": "makarízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-ar-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3107"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to beatify, i.e. pronounce (or esteem) fortunate",
               "kjv_def": ":--call\n blessed, count happy.",
               "_strongs": "03106"
            },
            {
               "strongs": "3107",
               "greek": [
                  {
                     "_BETA": "MAKA/RIOS",
                     "_unicode": "μακάριος",
                     "_translit": "makários"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-ar'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MA/KAR",
                        "_unicode": "μάκαρ",
                        "_translit": "mákar"
                     }
                  ],
                  "__text": "a prolonged form of the poetical \n (meaning the same);"
               },
               "strongs_def": "supremely\n blest; by extension, fortunate, well off",
               "kjv_def": ":-- blessed, happy(X -ier).",
               "_strongs": "03107"
            },
            {
               "strongs": "3108",
               "greek": [
                  {
                     "_BETA": "MAKARISMO/S",
                     "_unicode": "μακαρισμός",
                     "_translit": "makarismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-ar-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3106"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "beatification, i.e. attribution of good\n fortune",
               "kjv_def": ":--blessedness.",
               "_strongs": "03108"
            },
            {
               "strongs": "3109",
               "greek": [
                  {
                     "_BETA": "*MAKEDONI/A",
                     "_unicode": "Μακεδονία",
                     "_translit": "Makedonía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-ed-on-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3110"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Macedonia, a region of Greece",
               "kjv_def": ":--Macedonia.",
               "_strongs": "03109"
            },
            {
               "strongs": "3110",
               "greek": [
                  {
                     "_BETA": "*MAKEDW/N",
                     "_unicode": "Μακεδών",
                     "_translit": "Makedṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-ed'-ohn"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a Macedon (Macedonian), i.e. inhabitant of\n Macedonia",
               "kjv_def": ":--of Macedonia, Macedonian.",
               "_strongs": "03110"
            },
            {
               "strongs": "3111",
               "greek": [
                  {
                     "_BETA": "MA/KELLON",
                     "_unicode": "μάκελλον",
                     "_translit": "mákellon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak'-el-lon"
                  }
               ],
               "strongs_derivation": "of Latin origin (macellum);",
               "strongs_def": "a butcher's stall, meat market or\n provision-shop",
               "kjv_def": ":--shambles.",
               "_strongs": "03111"
            },
            {
               "strongs": "3112",
               "greek": [
                  {
                     "_BETA": "MAKRA/N",
                     "_unicode": "μακράν",
                     "_translit": "makrán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-ran'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3117"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     }
                  ],
                  "__text": "feminine accusative case singular of \n (\n being implied);"
               },
               "strongs_def": "at a\n distance (literally or figuratively)",
               "kjv_def": ":--(a-)far (off), good (great) way\n off.",
               "_strongs": "03112"
            },
            {
               "strongs": "3113",
               "greek": [
                  {
                     "_BETA": "MAKRO/QEN",
                     "_unicode": "μακρόθεν",
                     "_translit": "makróthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-roth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3117"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "from a distance or afar",
               "kjv_def": ":--afar off, from far.",
               "_strongs": "03113"
            },
            {
               "strongs": "3114",
               "greek": [
                  {
                     "_BETA": "MAKROQUME/W",
                     "_unicode": "μακροθυμέω",
                     "_translit": "makrothyméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-roth-oo-meh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3116"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to be long-spirited, i.e. (objectively)\n forbearing or (subjectively) patient",
               "kjv_def": ":--bear (suffer) long, be\n longsuffering, have (long) patience, be patient, patiently endure.",
               "_strongs": "03114"
            },
            {
               "strongs": "3115",
               "greek": [
                  {
                     "_BETA": "MAKROQUMI/A",
                     "_unicode": "μακροθυμία",
                     "_translit": "makrothymía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-roth-oo-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3116"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "longanimity, i.e. (objectively) forbearance or\n (subjectively) fortitude",
               "kjv_def": ":--longsuffering, patience.",
               "_strongs": "03115"
            },
            {
               "strongs": "3116",
               "greek": [
                  {
                     "_BETA": "MAKROQUMW/S",
                     "_unicode": "μακροθυμώς",
                     "_translit": "makrothymṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-roth-oo-moce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3117"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     }
                  ],
                  "__text": "adverb of a compound of \n and \n;"
               },
               "strongs_def": "with long (enduring) temper,\n i.e. leniently",
               "kjv_def": ":--patiently.",
               "_strongs": "03116"
            },
            {
               "strongs": "3117",
               "greek": [
                  {
                     "_BETA": "MAKRO/S",
                     "_unicode": "μακρός",
                     "_translit": "makrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3372"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "long (in place (distant) or time (neuter plural))",
               "kjv_def": ":--far,\n long.",
               "_strongs": "03117"
            },
            {
               "strongs": "3118",
               "greek": [
                  {
                     "_BETA": "MAKROXRO/NIOS",
                     "_unicode": "μακροχρόνιος",
                     "_translit": "makrochrónios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mak-rokh-ron'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3117"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5550"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "long-timed, i.e. long-lived",
               "kjv_def": ":--live long.",
               "_strongs": "03118"
            },
            {
               "strongs": "3119",
               "greek": [
                  {
                     "_BETA": "MALAKI/A",
                     "_unicode": "μαλακία",
                     "_translit": "malakía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mal-ak-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3120"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "softness, i.e. enervation (debility)",
               "kjv_def": ":--disease.",
               "_strongs": "03119"
            },
            {
               "strongs": "3120",
               "greek": [
                  {
                     "_BETA": "MALAKO/S",
                     "_unicode": "μαλακός",
                     "_translit": "malakós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mal-ak-os'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "soft, i.e. fine (clothing); figuratively, a\n catamite",
               "kjv_def": ":--effeminate, soft.",
               "_strongs": "03120"
            },
            {
               "strongs": "3121",
               "greek": [
                  {
                     "_BETA": "*MALELEH/L",
                     "_unicode": "Μαλελεήλ",
                     "_translit": "Maleleḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mal-el-eh-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04111"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Maleleel (i.e. Mahalalel), an\n antediluvian",
               "kjv_def": ":--Maleleel.",
               "_strongs": "03121"
            },
            {
               "strongs": "3122",
               "greek": [
                  {
                     "_BETA": "MA/LISTA",
                     "_unicode": "μάλιστα",
                     "_translit": "málista"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mal'-is-tah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MA/LA",
                        "_unicode": "μάλα",
                        "_translit": "mála"
                     }
                  ],
                  "__text": "neuter plural of the superlative of an apparently primary adverb \n\n (very);"
               },
               "strongs_def": "(adverbially) most (in the greatest degree) or\n particularly",
               "kjv_def": ":--chiefly, most of all, (e-)specially.",
               "_strongs": "03122"
            },
            {
               "strongs": "3123",
               "greek": [
                  {
                     "_BETA": "MA=LLON",
                     "_unicode": "μᾶλλον",
                     "_translit": "mâllon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mal'-lon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3122"
                     }
                  ],
                  "__text": "neuter of the comparative of the same as \n;"
               },
               "strongs_def": "(adverbially) more (in\n a greater degree) or rather",
               "kjv_def": ":--+ better, X far, (the) more (and more),\n (so) much (the more), rather.",
               "_strongs": "03123"
            },
            {
               "strongs": "3124",
               "greek": [
                  {
                     "_BETA": "*MA/LXOS",
                     "_unicode": "Μάλχος",
                     "_translit": "Málchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mal'-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04429"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Malchus, an Israelite",
               "kjv_def": ":--Malchus.",
               "_strongs": "03124"
            },
            {
               "strongs": "3125",
               "greek": [
                  {
                     "_BETA": "MA/MMH",
                     "_unicode": "μάμμη",
                     "_translit": "mámmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mam'-may"
                  }
               ],
               "strongs_derivation": "of natural origin (\"mammy\");",
               "strongs_def": "a grandmother",
               "kjv_def": ":--grandmother.",
               "_strongs": "03125"
            },
            {
               "strongs": "3126",
               "greek": [
                  {
                     "_BETA": "MAMMWNA=S",
                     "_unicode": "μαμμωνᾶς",
                     "_translit": "mammōnâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mam-mo-nas'"
                  }
               ],
               "strongs_derivation": "of Chaldee origin (confidence, i.e. wealth, personified);",
               "strongs_def": "mammonas,\n i.e. avarice (deified)",
               "kjv_def": ":--mammon.",
               "_strongs": "03126"
            },
            {
               "strongs": "3127",
               "greek": [
                  {
                     "_BETA": "*MANAH/N",
                     "_unicode": "Μαναήν",
                     "_translit": "Manaḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "man-ah-ane'"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Manaën, a Christian",
               "kjv_def": ":--Manaen.",
               "_strongs": "03127"
            },
            {
               "strongs": "3128",
               "greek": [
                  {
                     "_BETA": "*MANASSH=S",
                     "_unicode": "Μανασσῆς",
                     "_translit": "Manassēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "man-as-sace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04519"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Mannasses (i.e. Menashsheh), an\n Israelite",
               "kjv_def": ":--Manasses.",
               "_strongs": "03128"
            },
            {
               "strongs": "3129",
               "greek": [
                  {
                     "_BETA": "MANQA/NW",
                     "_unicode": "μανθάνω",
                     "_translit": "manthánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "man-than'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MAQE/W",
                        "_unicode": "μαθέω",
                        "_translit": "mathéō"
                     }
                  ],
                  "__text": "prolongation from a primary verb, another form of which,\n \n, is used as an alternate in certain tenses;"
               },
               "strongs_def": "to learn\n (in any way)",
               "kjv_def": ":--learn, understand.",
               "_strongs": "03129"
            },
            {
               "strongs": "3130",
               "greek": [
                  {
                     "_BETA": "MANI/A",
                     "_unicode": "μανία",
                     "_translit": "manía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "man-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3105"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "craziness",
               "kjv_def": ":--(+ make) X mad.",
               "_strongs": "03130"
            },
            {
               "strongs": "3131",
               "greek": [
                  {
                     "_BETA": "MA/NNA",
                     "_unicode": "μάννα",
                     "_translit": "mánna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "man'-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04478"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "manna (i.e. man), an edible gum",
               "kjv_def": ":--manna.",
               "_strongs": "03131"
            },
            {
               "strongs": "3132",
               "greek": [
                  {
                     "_BETA": "MANTEU/OMAI",
                     "_unicode": "μαντεύομαι",
                     "_translit": "manteúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mant-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3105"
                     }
                  ],
                  "__text": "from a derivative of \n (meaning a prophet, as supposed to rave\n through inspiration);"
               },
               "strongs_def": "to divine, i.e. utter spells (under pretense of\n foretelling",
               "kjv_def": ":--by soothsaying.",
               "_strongs": "03132"
            },
            {
               "strongs": "3133",
               "greek": [
                  {
                     "_BETA": "MARAI/NW",
                     "_unicode": "μαραίνω",
                     "_translit": "maraínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar-ah'-ee-no"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to extinguish (as fire), i.e. (figuratively and\n passively) to pass away",
               "kjv_def": ":--fade away.",
               "_strongs": "03133"
            },
            {
               "strongs": "3134",
               "greek": [
                  {
                     "_BETA": "MARA\\N A)QA/",
                     "_unicode": "μαρὰν ἀθά",
                     "_translit": "maràn athá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar'-an ath'-ah"
                  }
               ],
               "strongs_derivation": "of Chaldee origin (meaning our Lord has come);",
               "strongs_def": "maranatha, i.e. an\n exclamation of the approaching divine judgment",
               "kjv_def": ":--Maran-atha.",
               "_strongs": "03134"
            },
            {
               "strongs": "3135",
               "greek": [
                  {
                     "_BETA": "MARGARI/THS",
                     "_unicode": "μαργαρίτης",
                     "_translit": "margarítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar-gar-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MA/RGAROS",
                        "_unicode": "μάργαρος",
                        "_translit": "márgaros"
                     }
                  ],
                  "__text": "from \n (a pearl-oyster);"
               },
               "strongs_def": "a pearl",
               "kjv_def": ":--pearl.",
               "_strongs": "03135"
            },
            {
               "strongs": "3136",
               "greek": [
                  {
                     "_BETA": "*MA/RQA",
                     "_unicode": "Μάρθα",
                     "_translit": "Mártha"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar'-thah"
                  }
               ],
               "strongs_derivation": "probably of Chaldee origin (meaning mistress);",
               "strongs_def": "Martha, a Christian\n woman",
               "kjv_def": ":--Martha.",
               "_strongs": "03136"
            },
            {
               "strongs": "3137",
               "greek": [
                  {
                     "_BETA": "*MARI/A",
                     "_unicode": "Μαρία",
                     "_translit": "María"
                  },
                  {
                     "_BETA": "*MARIA/M",
                     "_unicode": "Μαριάμ",
                     "_translit": "Mariám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar-ee'-ah"
                  },
                  {
                     "_strongs": "mar-ee-am'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04813"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Maria or Mariam (i.e. Mirjam), the name of\n six Christian females",
               "kjv_def": ":-- Mary.",
               "_strongs": "03137",
               "__text": "or"
            },
            {
               "strongs": "3138",
               "greek": [
                  {
                     "_BETA": "*MA/RKOS",
                     "_unicode": "Μάρκος",
                     "_translit": "Márkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar'-kos"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Marcus, a Christian",
               "kjv_def": ":--Marcus, Mark.",
               "_strongs": "03138"
            },
            {
               "strongs": "3139",
               "greek": [
                  {
                     "_BETA": "MA/RMAROS",
                     "_unicode": "μάρμαρος",
                     "_translit": "mármaros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar'-mar-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MARMAI/RW",
                        "_unicode": "μαρμαίρω",
                        "_translit": "marmaírō"
                     }
                  ],
                  "__text": "from \n (to glisten);"
               },
               "strongs_def": "marble (as sparkling white)",
               "kjv_def": ":--marble.",
               "_strongs": "03139"
            },
            {
               "strongs": "3140",
               "greek": [
                  {
                     "_BETA": "MARTURE/W",
                     "_unicode": "μαρτυρέω",
                     "_translit": "martyréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar-too-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3144"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a witness, i.e. testify (literally or\n figuratively)",
               "kjv_def": ":--charge, give (evidence), bear record, have (obtain,\n of) good (honest) report, be well reported of, testify, give (have)\n testimony, (be, bear, give, obtain) witness.",
               "_strongs": "03140"
            },
            {
               "strongs": "3141",
               "greek": [
                  {
                     "_BETA": "MARTURI/A",
                     "_unicode": "μαρτυρία",
                     "_translit": "martyría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar-too-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3144"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "evidence given (judicially or genitive case)",
               "kjv_def": ":--record,\n report, testimony, witness.",
               "_strongs": "03141"
            },
            {
               "strongs": "3142",
               "greek": [
                  {
                     "_BETA": "MARTU/RION",
                     "_unicode": "μαρτύριον",
                     "_translit": "martýrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar-too'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3144"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "something evidential, i.e.\n (genitive case) evidence given or (specially), the Decalogue (in the\n sacred Tabernacle)",
               "kjv_def": ":--to be testified, testimony, witness.",
               "_strongs": "03142"
            },
            {
               "strongs": "3143",
               "greek": [
                  {
                     "_BETA": "MARTU/ROMAI",
                     "_unicode": "μαρτύρομαι",
                     "_translit": "martýromai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar-too'-rom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3144"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to be adduced as a witness, i.e.\n (figuratively) to obtest (in affirmation or exhortation)",
               "kjv_def": ":--take to\n record, testify.",
               "_strongs": "03143"
            },
            {
               "strongs": "3144",
               "greek": [
                  {
                     "_BETA": "MA/RTUS",
                     "_unicode": "μάρτυς",
                     "_translit": "mártys"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mar'-toos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a witness (literally (judicially) or\n figuratively (genitive case)); by analogy, a \"martyr\"",
               "kjv_def": ":-- martyr,\n record, witness.",
               "_strongs": "03144"
            },
            {
               "strongs": "3145",
               "greek": [
                  {
                     "_BETA": "MASSA/OMAI",
                     "_unicode": "μασσάομαι",
                     "_translit": "massáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mas-sah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MA/SSW",
                        "_unicode": "μάσσω",
                        "_translit": "mássō"
                     }
                  ],
                  "__text": "from a primary \n (to handle or squeeze);"
               },
               "strongs_def": "to chew",
               "kjv_def": ":--gnaw.",
               "_strongs": "03145"
            },
            {
               "strongs": "3146",
               "greek": [
                  {
                     "_BETA": "MASTIGO/W",
                     "_unicode": "μαστιγόω",
                     "_translit": "mastigóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mas-tig-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3148"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to flog (literally or figuratively)",
               "kjv_def": ":--scourge.",
               "_strongs": "03146"
            },
            {
               "strongs": "3147",
               "greek": [
                  {
                     "_BETA": "MASTI/ZW",
                     "_unicode": "μαστίζω",
                     "_translit": "mastízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mas-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3149"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to whip (literally)",
               "kjv_def": ":--scourge.",
               "_strongs": "03147"
            },
            {
               "strongs": "3148",
               "greek": [
                  {
                     "_BETA": "MA/STIC",
                     "_unicode": "μάστιξ",
                     "_translit": "mástix"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mas'-tix"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3145"
                     }
                  ],
                  "__text": "probably from the base of \n (through the idea of contact);"
               },
               "strongs_def": "a whip\n (literally, the Roman flagellum for criminals; figuratively, a\n disease)",
               "kjv_def": ":--plague, scourging.",
               "_strongs": "03148"
            },
            {
               "strongs": "3149",
               "greek": [
                  {
                     "_BETA": "MASTO/S",
                     "_unicode": "μαστός",
                     "_translit": "mastós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mas-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3145"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a (properly, female) breast (as if kneaded\n up)",
               "kjv_def": ":--pap.",
               "_strongs": "03149"
            },
            {
               "strongs": "3150",
               "greek": [
                  {
                     "_BETA": "MATAIOLOGI/A",
                     "_unicode": "ματαιολογία",
                     "_translit": "mataiología"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-ah-yol-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3151"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "random talk, i.e. babble",
               "kjv_def": ":--vain jangling.",
               "_strongs": "03150"
            },
            {
               "strongs": "3151",
               "greek": [
                  {
                     "_BETA": "MATAIOLO/GOS",
                     "_unicode": "ματαιολόγος",
                     "_translit": "mataiológos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-ah-yol-og'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3152"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an idle (i.e. senseless or mischievous) talker,\n i.e. a wrangler",
               "kjv_def": ":--vain talker.",
               "_strongs": "03151"
            },
            {
               "strongs": "3152",
               "greek": [
                  {
                     "_BETA": "MA/TAIOS",
                     "_unicode": "μάταιος",
                     "_translit": "mátaios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat'-ah-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3155"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "empty, i.e. (literally) profitless, or\n (specially), an idol",
               "kjv_def": ":--vain, vanity.",
               "_strongs": "03152"
            },
            {
               "strongs": "3153",
               "greek": [
                  {
                     "_BETA": "MATAIO/THS",
                     "_unicode": "ματαιότης",
                     "_translit": "mataiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-ah-yot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3152"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inutility; figuratively, transientness; morally,\n depravity",
               "kjv_def": ":--vanity.",
               "_strongs": "03153"
            },
            {
               "strongs": "3154",
               "greek": [
                  {
                     "_BETA": "MATAIO/W",
                     "_unicode": "ματαιόω",
                     "_translit": "mataióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-ah-yo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3152"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render (passively, become) foolish, i.e. (morally)\n wicked or (specially), idolatrous",
               "kjv_def": ":--become vain.",
               "_strongs": "03154"
            },
            {
               "strongs": "3155",
               "greek": [
                  {
                     "_BETA": "MA/THN",
                     "_unicode": "μάτην",
                     "_translit": "mátēn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat'-ane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3145"
                     }
                  ],
                  "__text": "accusative case of a derivative of the base of \n (through the idea\n of tentative manipulation, i.e. unsuccessful search, or else of\n punishment);"
               },
               "strongs_def": "folly, i.e. (adverbially) to no purpose",
               "kjv_def": ":--in vain.",
               "_strongs": "03155"
            },
            {
               "strongs": "3156",
               "greek": [
                  {
                     "_BETA": "*MATQAI=OS",
                     "_unicode": "Ματθαῖος",
                     "_translit": "Matthaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-thah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3161"
                     }
                  ],
                  "__text": "a shorter form of \n;"
               },
               "strongs_def": "Matthæus (i.e. Matthitjah), an Israelite and\n a Christian",
               "kjv_def": ":--Matthew.",
               "_strongs": "03156"
            },
            {
               "strongs": "3157",
               "greek": [
                  {
                     "_BETA": "*MATQA/N",
                     "_unicode": "Ματθάν",
                     "_translit": "Matthán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-than'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04977"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Matthan (i.e. Mattan), an\n Israelite",
               "kjv_def": ":--Matthan.",
               "_strongs": "03157"
            },
            {
               "strongs": "3158",
               "greek": [
                  {
                     "_BETA": "*MATQA/T",
                     "_unicode": "Ματθάτ",
                     "_translit": "Matthát"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-that'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3161"
                     }
                  ],
                  "__text": "probably a shortened form of \n;"
               },
               "strongs_def": "Matthat (i.e. Mattithjah), the name\n of two Israelites",
               "kjv_def": ":--Mathat.",
               "_strongs": "03158"
            },
            {
               "strongs": "3159",
               "greek": [
                  {
                     "_BETA": "*MATQI/AS",
                     "_unicode": "Ματθίας",
                     "_translit": "Matthías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-thee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3161"
                     }
                  ],
                  "__text": "apparently a shortened form of \n;"
               },
               "strongs_def": "Matthias (i.e. Mattithjah), an\n Israelite",
               "kjv_def": ":--Matthias.",
               "_strongs": "03159"
            },
            {
               "strongs": "3160",
               "greek": [
                  {
                     "_BETA": "*MATTAQA/",
                     "_unicode": "Ματταθά",
                     "_translit": "Mattathá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-tath-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3161"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "4992"
                     }
                  ],
                  "__text": "probably a shortened form of \n (compare \n);"
               },
               "strongs_def": "Mattatha (i.e.\n Mattithjah), an Israelite",
               "kjv_def": ":--Mattatha.",
               "_strongs": "03160"
            },
            {
               "strongs": "3161",
               "greek": [
                  {
                     "_BETA": "*MATTAQI/AS",
                     "_unicode": "Ματταθίας",
                     "_translit": "Mattathías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mat-tath-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04993"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Mattathias (i.e. Mattithjah), an Israelite\n and a Christian",
               "kjv_def": ":--Mattathias.",
               "_strongs": "03161"
            },
            {
               "strongs": "3162",
               "greek": [
                  {
                     "_BETA": "MA/XAIRA",
                     "_unicode": "μάχαιρα",
                     "_translit": "máchaira"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "makh'-ahee-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3163"
                     }
                  ],
                  "__text": "probably feminine of a presumed derivative of \n;"
               },
               "strongs_def": "a knife, i.e.\n dirk; figuratively, war, judicial punishment",
               "kjv_def": ":--sword.",
               "_strongs": "03162"
            },
            {
               "strongs": "3163",
               "greek": [
                  {
                     "_BETA": "MA/XH",
                     "_unicode": "μάχη",
                     "_translit": "máchē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "makh'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3164"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a battle, i.e. (figuratively) controversy",
               "kjv_def": ":--fighting,\n strive, striving.",
               "_strongs": "03163"
            },
            {
               "strongs": "3164",
               "greek": [
                  {
                     "_BETA": "MA/XOMAI",
                     "_unicode": "μάχομαι",
                     "_translit": "máchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "makh'-om-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of an apparently primary verb;",
               "strongs_def": "to war, i.e.\n (figuratively) to quarrel, dispute",
               "kjv_def": ":--fight, strive.",
               "_strongs": "03164"
            },
            {
               "strongs": "3165",
               "greek": [
                  {
                     "_BETA": "ME/",
                     "_unicode": "μέ",
                     "_translit": "mé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1691"
                     }
                  ],
                  "__text": "a shorter (and probably original) form of \n;"
               },
               "strongs_def": "me",
               "kjv_def": ":--I, me, my.",
               "_strongs": "03165"
            },
            {
               "strongs": "3166",
               "greek": [
                  {
                     "_BETA": "MEGALAUXE/W",
                     "_unicode": "μεγαλαυχέω",
                     "_translit": "megalauchéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg-al-ow-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "837"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2744"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "AU)XE/W",
                        "_unicode": "αὐχέω",
                        "_translit": "auchéō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to boast; akin to \n and \n);"
               },
               "strongs_def": "to talk big, i.e. be grandiloquent (arrogant, egotistic)",
               "kjv_def": ":--boast great\n things.",
               "_strongs": "03166"
            },
            {
               "strongs": "3167",
               "greek": [
                  {
                     "_BETA": "MEGALEI=OS",
                     "_unicode": "μεγαλεῖος",
                     "_translit": "megaleîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg-al-i'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "magnificent, i.e. (neuter, plural as noun) a conspicuous\n favor, or (subjectively) perfection",
               "kjv_def": ":--great things, wonderful works.",
               "_strongs": "03167"
            },
            {
               "strongs": "3168",
               "greek": [
                  {
                     "_BETA": "MEGALEIO/THS",
                     "_unicode": "μεγαλειότης",
                     "_translit": "megaleiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg-al-i-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3167"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "superbness, i.e. glory or splendor",
               "kjv_def": ":--magnificence, majesty,\n mighty power.",
               "_strongs": "03168"
            },
            {
               "strongs": "3169",
               "greek": [
                  {
                     "_BETA": "MEGALOPREPH/S",
                     "_unicode": "μεγαλοπρεπής",
                     "_translit": "megaloprepḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg-al-op-rep-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4241"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "befitting greatness or magnificence\n (majestic)",
               "kjv_def": ":--excellent.",
               "_strongs": "03169"
            },
            {
               "strongs": "3170",
               "greek": [
                  {
                     "_BETA": "MEGALU/NW",
                     "_unicode": "μεγαλύνω",
                     "_translit": "megalýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg-al-oo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make (or declare) great, i.e. increase or (figuratively)\n extol",
               "kjv_def": ":--enlarge, magnify, shew great.",
               "_strongs": "03170"
            },
            {
               "strongs": "3171",
               "greek": [
                  {
                     "_BETA": "MEGA/LWS",
                     "_unicode": "μεγάλως",
                     "_translit": "megálōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg-al'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "much",
               "kjv_def": ":--greatly.",
               "_strongs": "03171"
            },
            {
               "strongs": "3172",
               "greek": [
                  {
                     "_BETA": "MEGALWSU/NH",
                     "_unicode": "μεγαλωσύνη",
                     "_translit": "megalōsýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg-al-o-soo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "greatness, i.e. (figuratively) divinity (often God\n himself)",
               "kjv_def": ":--majesty.",
               "_strongs": "03172"
            },
            {
               "strongs": "3173",
               "greek": [
                  {
                     "_BETA": "ME/GAS",
                     "_unicode": "μέγας",
                     "_translit": "mégas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg'-as"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MEGA/LH",
                        "_unicode": "μεγάλη",
                        "_translit": "megálē"
                     },
                     {
                        "_BETA": "MEGA/LOI",
                        "_unicode": "μεγάλοι",
                        "_translit": "megáloi"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3176"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3187"
                     }
                  ],
                  "__text": "(including the prolonged forms, feminine \n, plural\n \n, etc.; compare also \n, \n);"
               },
               "strongs_def": "big (literally or\n figuratively, in a very wide application)",
               "kjv_def": ":--(+ fear) exceedingly,\n great(-est), high, large, loud, mighty, + (be) sore (afraid), strong,\n X to years.",
               "_strongs": "03173"
            },
            {
               "strongs": "3174",
               "greek": [
                  {
                     "_BETA": "ME/GEQOS",
                     "_unicode": "μέγεθος",
                     "_translit": "mégethos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg'-eth-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "magnitude (figuratively)",
               "kjv_def": ":--greatness.",
               "_strongs": "03174"
            },
            {
               "strongs": "3175",
               "greek": [
                  {
                     "_BETA": "MEGISTA=NES",
                     "_unicode": "μεγιστᾶνες",
                     "_translit": "megistânes"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg-is-tan'-es"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3176"
                     }
                  ],
                  "__text": "plural from \n;"
               },
               "strongs_def": "grandees",
               "kjv_def": ":--great men, lords.",
               "_strongs": "03175"
            },
            {
               "strongs": "3176",
               "greek": [
                  {
                     "_BETA": "ME/GISTOS",
                     "_unicode": "μέγιστος",
                     "_translit": "mégistos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meg'-is-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     }
                  ],
                  "__text": "superlative of \n;"
               },
               "strongs_def": "greatest or very great",
               "kjv_def": ":--exceeding great.",
               "_strongs": "03176"
            },
            {
               "strongs": "3177",
               "greek": [
                  {
                     "_BETA": "MEQERMHNEU/W",
                     "_unicode": "μεθερμηνεύω",
                     "_translit": "methermēneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meth-er-mane-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2059"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to explain over, i.e. translate",
               "kjv_def": ":--(by)\n interpret(-ation).",
               "_strongs": "03177"
            },
            {
               "strongs": "3178",
               "greek": [
                  {
                     "_BETA": "ME/QH",
                     "_unicode": "μέθη",
                     "_translit": "méthē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meth'-ay"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "an intoxicant, i.e. (by implication)\n intoxication",
               "kjv_def": ":--drunkenness.",
               "_strongs": "03178"
            },
            {
               "strongs": "3179",
               "greek": [
                  {
                     "_BETA": "MEQI/STHMI",
                     "_unicode": "μεθίστημι",
                     "_translit": "methístēmi"
                  },
                  {
                     "_BETA": "MEQISTA/NW",
                     "_unicode": "μεθιστάνω",
                     "_translit": "methistánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meth-is'-tay-mee"
                  },
                  {
                     "_strongs": "meth-is-tan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to transfer, i.e. carry away, depose or\n (figuratively) exchange, seduce",
               "kjv_def": ":--put out, remove, translate, turn\n away.",
               "_strongs": "03179",
               "__text": ", or (1 Cor. 13:2)"
            },
            {
               "strongs": "3180",
               "greek": [
                  {
                     "_BETA": "MEQODEI/A",
                     "_unicode": "μεθοδεία",
                     "_translit": "methodeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meth-od-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3593"
                     }
                  ],
                  "__text": "from a compound of \n and \n (compare \"method\");"
               },
               "strongs_def": "travelling over,\n i.e. travesty (trickery)",
               "kjv_def": ":--wile, lie in wait.",
               "_strongs": "03180"
            },
            {
               "strongs": "3181",
               "greek": [
                  {
                     "_BETA": "MEQO/RIOS",
                     "_unicode": "μεθόριος",
                     "_translit": "methórios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meth-or'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3725"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "bounded alongside, i.e. contiguous (neuter plural\n as noun, frontier)",
               "kjv_def": ":--border.",
               "_strongs": "03181"
            },
            {
               "strongs": "3182",
               "greek": [
                  {
                     "_BETA": "MEQU/SKW",
                     "_unicode": "μεθύσκω",
                     "_translit": "methýskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meth-oos'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3184"
                     }
                  ],
                  "__text": "a prolonged (transitive) form of \n;"
               },
               "strongs_def": "to intoxicate",
               "kjv_def": ":--be drunk(-en).",
               "_strongs": "03182"
            },
            {
               "strongs": "3183",
               "greek": [
                  {
                     "_BETA": "ME/QUSOS",
                     "_unicode": "μέθυσος",
                     "_translit": "méthysos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meth'-oo-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3184"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "tipsy, i.e. (as noun) a sot",
               "kjv_def": ":--drunkard.",
               "_strongs": "03183"
            },
            {
               "strongs": "3184",
               "greek": [
                  {
                     "_BETA": "MEQU/W",
                     "_unicode": "μεθύω",
                     "_translit": "methýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "meth-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3178"
                     }
                  ],
                  "__text": "from another form of \n;"
               },
               "strongs_def": "to drink to intoxication, i.e. get\n drunk",
               "kjv_def": ":--drink well, make (be) drunk(-en).",
               "_strongs": "03184"
            },
            {
               "strongs": "3185",
               "greek": [
                  {
                     "_BETA": "MEI=ZON",
                     "_unicode": "μεῖζον",
                     "_translit": "meîzon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mide'-zon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3187"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": "(adverbially) in greater degree",
               "kjv_def": ":--the more.",
               "_strongs": "03185"
            },
            {
               "strongs": "3186",
               "greek": [
                  {
                     "_BETA": "MEIZO/TEROS",
                     "_unicode": "μειζότερος",
                     "_translit": "meizóteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mide-zot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3187"
                     }
                  ],
                  "__text": "continued comparative of \n;"
               },
               "strongs_def": "still larger (figuratively)",
               "kjv_def": ":--greater.",
               "_strongs": "03186"
            },
            {
               "strongs": "3187",
               "greek": [
                  {
                     "_BETA": "MEI/ZWN",
                     "_unicode": "μείζων",
                     "_translit": "meízōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mide'-zone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     }
                  ],
                  "__text": "irregular comparative of \n;"
               },
               "strongs_def": "larger (literally or figuratively,\n specially, in age)",
               "kjv_def": ":--elder, greater(-est), more.",
               "_strongs": "03187"
            },
            {
               "strongs": "3188",
               "greek": [
                  {
                     "_BETA": "ME/LAN",
                     "_unicode": "μέλαν",
                     "_translit": "mélan"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel'-an"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3189"
                     }
                  ],
                  "__text": "neuter of \n as noun;"
               },
               "strongs_def": "ink",
               "kjv_def": ":--ink.",
               "_strongs": "03188"
            },
            {
               "strongs": "3189",
               "greek": [
                  {
                     "_BETA": "ME/LAS",
                     "_unicode": "μέλας",
                     "_translit": "mélas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel'-as"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "black",
               "kjv_def": ":--black.",
               "_strongs": "03189"
            },
            {
               "strongs": "3190",
               "greek": [
                  {
                     "_BETA": "*MELEA=S",
                     "_unicode": "Μελεᾶς",
                     "_translit": "Meleâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel-eh-as'"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Meleas, an Israelite",
               "kjv_def": ":--Meleas.",
               "_strongs": "03190"
            },
            {
               "strongs": "3191",
               "greek": [
                  {
                     "_BETA": "MELETA/W",
                     "_unicode": "μελετάω",
                     "_translit": "meletáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel-et-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3199"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "to take care of, i.e. (by\n implication) revolve in the mind",
               "kjv_def": ":--imagine, (pre-)meditate.",
               "_strongs": "03191"
            },
            {
               "strongs": "3192",
               "greek": [
                  {
                     "_BETA": "ME/LI",
                     "_unicode": "μέλι",
                     "_translit": "méli"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel'-ee"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "honey",
               "kjv_def": ":--honey.",
               "_strongs": "03192"
            },
            {
               "strongs": "3193",
               "greek": [
                  {
                     "_BETA": "MELI/SSIOS",
                     "_unicode": "μελίσσιος",
                     "_translit": "melíssios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel-is'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3192"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "relating to honey, i.e. bee (comb)",
               "kjv_def": ":--honeycomb.",
               "_strongs": "03193"
            },
            {
               "strongs": "3194",
               "greek": [
                  {
                     "_BETA": "*MELI/TH",
                     "_unicode": "Μελίτη",
                     "_translit": "Melítē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel-ee'-tay"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Melita, an island in the Mediterranean",
               "kjv_def": ":--Melita.",
               "_strongs": "03194"
            },
            {
               "strongs": "3195",
               "greek": [
                  {
                     "_BETA": "ME/LLW",
                     "_unicode": "μέλλω",
                     "_translit": "méllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3199"
                     }
                  ],
                  "__text": "a strengthened form of \n (through the idea of expectation);"
               },
               "strongs_def": "to\n intend, i.e. be about to be, do, or suffer something (of persons or\n things, especially events; in the sense of purpose, duty, necessity,\n probability, possibility, or hesitation)",
               "kjv_def": ":--about, after that, be\n (almost), (that which is, things, + which was for) to come, intend,\n was to (be), mean, mind, be at the point, (be) ready, + return, shall\n (begin), (which, that) should (after, afterwards, hereafter) tarry,\n which was for, will, would, be yet.",
               "_strongs": "03195"
            },
            {
               "strongs": "3196",
               "greek": [
                  {
                     "_BETA": "ME/LOS",
                     "_unicode": "μέλος",
                     "_translit": "mélos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a limb or part of the body",
               "kjv_def": ":--member.",
               "_strongs": "03196"
            },
            {
               "strongs": "3197",
               "greek": [
                  {
                     "_BETA": "*MELXI/",
                     "_unicode": "Μελχί",
                     "_translit": "Melchí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel-khee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04428"
                     }
                  ],
                  "__text": "of Hebrew origin (\n with pronominal suffix, my king);"
               },
               "strongs_def": "Melchi (i.e.\n Malki), the name of two Israelites",
               "kjv_def": ":--Melchi.",
               "_strongs": "03197"
            },
            {
               "strongs": "3198",
               "greek": [
                  {
                     "_BETA": "*MELXISEDE/K",
                     "_unicode": "Μελχισεδέκ",
                     "_translit": "Melchisedék"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel-khis-ed-ek'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04442"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Melchisedek (i.e. Malkitsedek), a\n patriarch",
               "kjv_def": ":--Melchisedec.",
               "_strongs": "03198"
            },
            {
               "strongs": "3199",
               "greek": [
                  {
                     "_BETA": "ME/LW",
                     "_unicode": "μέλω",
                     "_translit": "mélō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mel'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to be of interest to, i.e. to concern (only third\n person singular present indicative used impersonally, it\n matters)",
               "kjv_def": ":--(take) care.",
               "_strongs": "03199"
            },
            {
               "strongs": "3200",
               "greek": [
                  {
                     "_BETA": "MEMBRA/NA",
                     "_unicode": "μεμβράνα",
                     "_translit": "membrána"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mem-bran'-ah"
                  }
               ],
               "strongs_derivation": "of Latin origin (\"membrane\");",
               "strongs_def": "a (written) sheep-skin",
               "kjv_def": ":--parchment.",
               "_strongs": "03200"
            },
            {
               "strongs": "3201",
               "greek": [
                  {
                     "_BETA": "ME/MFOMAI",
                     "_unicode": "μέμφομαι",
                     "_translit": "mémphomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mem'-fom-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of an apparently primary verb;",
               "strongs_def": "to blame",
               "kjv_def": ":--find fault.",
               "_strongs": "03201"
            },
            {
               "strongs": "3202",
               "greek": [
                  {
                     "_BETA": "MEMYI/MOIROS",
                     "_unicode": "μεμψίμοιρος",
                     "_translit": "mempsímoiros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mem-psim'-oy-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3201"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3313"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "MOI=RA",
                        "_unicode": "μοῖρα",
                        "_translit": "moîra"
                     }
                  ],
                  "__text": "from a presumed derivative of \n and \n (fate; akin to the base\n of \n);"
               },
               "strongs_def": "blaming fate, i.e. querulous (discontented)",
               "kjv_def": ":--complainer.",
               "_strongs": "03202"
            },
            {
               "strongs": "3203",
               "_strongs": "03203",
               "__text": "Not Used"
            },
            {
               "strongs": "3204",
               "_strongs": "03204",
               "__text": "Not Used"
            },
            {
               "strongs": "3205",
               "_strongs": "03205",
               "__text": "Not Used"
            },
            {
               "strongs": "3206",
               "_strongs": "03206",
               "__text": "Not Used"
            },
            {
               "strongs": "3207",
               "_strongs": "03207",
               "__text": "Not Used"
            },
            {
               "strongs": "3208",
               "_strongs": "03208",
               "__text": "Not Used"
            },
            {
               "strongs": "3209",
               "_strongs": "03209",
               "__text": "Not Used"
            },
            {
               "strongs": "3210",
               "_strongs": "03210",
               "__text": "Not Used"
            },
            {
               "strongs": "3211",
               "_strongs": "03211",
               "__text": "Not Used"
            },
            {
               "strongs": "3212",
               "_strongs": "03212",
               "__text": "Not Used"
            },
            {
               "strongs": "3213",
               "_strongs": "03213",
               "__text": "Not Used"
            },
            {
               "strongs": "3214",
               "_strongs": "03214",
               "__text": "Not Used"
            },
            {
               "strongs": "3215",
               "_strongs": "03215",
               "__text": "Not Used"
            },
            {
               "strongs": "3216",
               "_strongs": "03216",
               "__text": "Not Used"
            },
            {
               "strongs": "3217",
               "_strongs": "03217",
               "__text": "Not Used"
            },
            {
               "strongs": "3218",
               "_strongs": "03218",
               "__text": "Not Used"
            },
            {
               "strongs": "3219",
               "_strongs": "03219",
               "__text": "Not Used"
            },
            {
               "strongs": "3220",
               "_strongs": "03220",
               "__text": "Not Used"
            },
            {
               "strongs": "3221",
               "_strongs": "03221",
               "__text": "Not Used"
            },
            {
               "strongs": "3222",
               "_strongs": "03222",
               "__text": "Not Used"
            },
            {
               "strongs": "3223",
               "_strongs": "03223",
               "__text": "Not Used"
            },
            {
               "strongs": "3224",
               "_strongs": "03224",
               "__text": "Not Used"
            },
            {
               "strongs": "3225",
               "_strongs": "03225",
               "__text": "Not Used"
            },
            {
               "strongs": "3226",
               "_strongs": "03226",
               "__text": "Not Used"
            },
            {
               "strongs": "3227",
               "_strongs": "03227",
               "__text": "Not Used"
            },
            {
               "strongs": "3228",
               "_strongs": "03228",
               "__text": "Not Used"
            },
            {
               "strongs": "3229",
               "_strongs": "03229",
               "__text": "Not Used"
            },
            {
               "strongs": "3230",
               "_strongs": "03230",
               "__text": "Not Used"
            },
            {
               "strongs": "3231",
               "_strongs": "03231",
               "__text": "Not Used"
            },
            {
               "strongs": "3232",
               "_strongs": "03232",
               "__text": "Not Used"
            },
            {
               "strongs": "3233",
               "_strongs": "03233",
               "__text": "Not Used"
            },
            {
               "strongs": "3234",
               "_strongs": "03234",
               "__text": "Not Used"
            },
            {
               "strongs": "3235",
               "_strongs": "03235",
               "__text": "Not Used"
            },
            {
               "strongs": "3236",
               "_strongs": "03236",
               "__text": "Not Used"
            },
            {
               "strongs": "3237",
               "_strongs": "03237",
               "__text": "Not Used"
            },
            {
               "strongs": "3238",
               "_strongs": "03238",
               "__text": "Not Used"
            },
            {
               "strongs": "3239",
               "_strongs": "03239",
               "__text": "Not Used"
            },
            {
               "strongs": "3240",
               "_strongs": "03240",
               "__text": "Not Used"
            },
            {
               "strongs": "3241",
               "_strongs": "03241",
               "__text": "Not Used"
            },
            {
               "strongs": "3242",
               "_strongs": "03242",
               "__text": "Not Used"
            },
            {
               "strongs": "3243",
               "_strongs": "03243",
               "__text": "Not Used"
            },
            {
               "strongs": "3244",
               "_strongs": "03244",
               "__text": "Not Used"
            },
            {
               "strongs": "3245",
               "_strongs": "03245",
               "__text": "Not Used"
            },
            {
               "strongs": "3246",
               "_strongs": "03246",
               "__text": "Not Used"
            },
            {
               "strongs": "3247",
               "_strongs": "03247",
               "__text": "Not Used"
            },
            {
               "strongs": "3248",
               "_strongs": "03248",
               "__text": "Not Used"
            },
            {
               "strongs": "3249",
               "_strongs": "03249",
               "__text": "Not Used"
            },
            {
               "strongs": "3250",
               "_strongs": "03250",
               "__text": "Not Used"
            },
            {
               "strongs": "3251",
               "_strongs": "03251",
               "__text": "Not Used"
            },
            {
               "strongs": "3252",
               "_strongs": "03252",
               "__text": "Not Used"
            },
            {
               "strongs": "3253",
               "_strongs": "03253",
               "__text": "Not Used"
            },
            {
               "strongs": "3254",
               "_strongs": "03254",
               "__text": "Not Used"
            },
            {
               "strongs": "3255",
               "_strongs": "03255",
               "__text": "Not Used"
            },
            {
               "strongs": "3256",
               "_strongs": "03256",
               "__text": "Not Used"
            },
            {
               "strongs": "3257",
               "_strongs": "03257",
               "__text": "Not Used"
            },
            {
               "strongs": "3258",
               "_strongs": "03258",
               "__text": "Not Used"
            },
            {
               "strongs": "3259",
               "_strongs": "03259",
               "__text": "Not Used"
            },
            {
               "strongs": "3260",
               "_strongs": "03260",
               "__text": "Not Used"
            },
            {
               "strongs": "3261",
               "_strongs": "03261",
               "__text": "Not Used"
            },
            {
               "strongs": "3262",
               "_strongs": "03262",
               "__text": "Not Used"
            },
            {
               "strongs": "3263",
               "_strongs": "03263",
               "__text": "Not Used"
            },
            {
               "strongs": "3264",
               "_strongs": "03264",
               "__text": "Not Used"
            },
            {
               "strongs": "3265",
               "_strongs": "03265",
               "__text": "Not Used"
            },
            {
               "strongs": "3266",
               "_strongs": "03266",
               "__text": "Not Used"
            },
            {
               "strongs": "3267",
               "_strongs": "03267",
               "__text": "Not Used"
            },
            {
               "strongs": "3268",
               "_strongs": "03268",
               "__text": "Not Used"
            },
            {
               "strongs": "3269",
               "_strongs": "03269",
               "__text": "Not Used"
            },
            {
               "strongs": "3270",
               "_strongs": "03270",
               "__text": "Not Used"
            },
            {
               "strongs": "3271",
               "_strongs": "03271",
               "__text": "Not Used"
            },
            {
               "strongs": "3272",
               "_strongs": "03272",
               "__text": "Not Used"
            },
            {
               "strongs": "3273",
               "_strongs": "03273",
               "__text": "Not Used"
            },
            {
               "strongs": "3274",
               "_strongs": "03274",
               "__text": "Not Used"
            },
            {
               "strongs": "3275",
               "_strongs": "03275",
               "__text": "Not Used"
            },
            {
               "strongs": "3276",
               "_strongs": "03276",
               "__text": "Not Used"
            },
            {
               "strongs": "3277",
               "_strongs": "03277",
               "__text": "Not Used"
            },
            {
               "strongs": "3278",
               "_strongs": "03278",
               "__text": "Not Used"
            },
            {
               "strongs": "3279",
               "_strongs": "03279",
               "__text": "Not Used"
            },
            {
               "strongs": "3280",
               "_strongs": "03280",
               "__text": "Not Used"
            },
            {
               "strongs": "3281",
               "_strongs": "03281",
               "__text": "Not Used"
            },
            {
               "strongs": "3282",
               "_strongs": "03282",
               "__text": "Not Used"
            },
            {
               "strongs": "3283",
               "_strongs": "03283",
               "__text": "Not Used"
            },
            {
               "strongs": "3284",
               "_strongs": "03284",
               "__text": "Not Used"
            },
            {
               "strongs": "3285",
               "_strongs": "03285",
               "__text": "Not Used"
            },
            {
               "strongs": "3286",
               "_strongs": "03286",
               "__text": "Not Used"
            },
            {
               "strongs": "3287",
               "_strongs": "03287",
               "__text": "Not Used"
            },
            {
               "strongs": "3288",
               "_strongs": "03288",
               "__text": "Not Used"
            },
            {
               "strongs": "3289",
               "_strongs": "03289",
               "__text": "Not Used"
            },
            {
               "strongs": "3290",
               "_strongs": "03290",
               "__text": "Not Used"
            },
            {
               "strongs": "3291",
               "_strongs": "03291",
               "__text": "Not Used"
            },
            {
               "strongs": "3292",
               "_strongs": "03292",
               "__text": "Not Used"
            },
            {
               "strongs": "3293",
               "_strongs": "03293",
               "__text": "Not Used"
            },
            {
               "strongs": "3294",
               "_strongs": "03294",
               "__text": "Not Used"
            },
            {
               "strongs": "3295",
               "_strongs": "03295",
               "__text": "Not Used"
            },
            {
               "strongs": "3296",
               "_strongs": "03296",
               "__text": "Not Used"
            },
            {
               "strongs": "3297",
               "_strongs": "03297",
               "__text": "Not Used"
            },
            {
               "strongs": "3298",
               "_strongs": "03298",
               "__text": "Not Used"
            },
            {
               "strongs": "3299",
               "_strongs": "03299",
               "__text": "Not Used"
            },
            {
               "strongs": "3300",
               "_strongs": "03300",
               "__text": "Not Used"
            },
            {
               "strongs": "3301",
               "_strongs": "03301",
               "__text": "Not Used"
            },
            {
               "strongs": "3302",
               "_strongs": "03302",
               "__text": "Not Used"
            },
            {
               "strongs": "3303",
               "greek": [
                  {
                     "_BETA": "ME/N",
                     "_unicode": "μέν",
                     "_translit": "mén"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "men"
                  }
               ],
               "strongs_derivation": "a primary particle;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1161"
                     }
                  ],
                  "__text": "properly, indicative of affirmation or concession\n (in fact); usually followed by a contrasted clause with \n (this\n one, the former, etc.)"
               },
               "kjv_def": ":--even, indeed, so, some, truly, verily.",
               "_strongs": "03303",
               "__text": "Often\n compounded with other particles in an intensive or asseverative sense."
            },
            {
               "strongs": "3304",
               "greek": [
                  {
                     "_BETA": "MENOU=NGE",
                     "_unicode": "μενοῦνγε",
                     "_translit": "menoûnge"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "men-oon'-geh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3767"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1065"
                     }
                  ],
                  "__text": "from \n and \n and \n;"
               },
               "strongs_def": "so then at least",
               "kjv_def": ":--nay but, yea doubtless\n (rather, verily).",
               "_strongs": "03304"
            },
            {
               "strongs": "3305",
               "greek": [
                  {
                     "_BETA": "ME/NTOI",
                     "_unicode": "μέντοι",
                     "_translit": "méntoi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "men'-toy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5104"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "indeed though, i.e. however",
               "kjv_def": ":--also, but, howbeit,\n nevertheless, yet.",
               "_strongs": "03305"
            },
            {
               "strongs": "3306",
               "greek": [
                  {
                     "_BETA": "ME/NW",
                     "_unicode": "μένω",
                     "_translit": "ménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "men'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to stay (in a given place, state, relation or\n expectancy)",
               "kjv_def": ":--abide, continue, dwell, endure, be present, remain,\n stand, tarry (for), X thine own.",
               "_strongs": "03306"
            },
            {
               "strongs": "3307",
               "greek": [
                  {
                     "_BETA": "MERI/ZW",
                     "_unicode": "μερίζω",
                     "_translit": "merízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mer-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3313"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to part, i.e. (literally) to apportion, bestow, share, or\n (figuratively) to disunite, differ",
               "kjv_def": ":--deal, be difference between,\n distribute, divide, give part.",
               "_strongs": "03307"
            },
            {
               "strongs": "3308",
               "greek": [
                  {
                     "_BETA": "ME/RIMNA",
                     "_unicode": "μέριμνα",
                     "_translit": "mérimna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mer'-im-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3307"
                     }
                  ],
                  "__text": "from \n (through the idea of distraction);"
               },
               "strongs_def": "solicitude",
               "kjv_def": ":--care.",
               "_strongs": "03308"
            },
            {
               "strongs": "3309",
               "greek": [
                  {
                     "_BETA": "MERIMNA/W",
                     "_unicode": "μεριμνάω",
                     "_translit": "merimnáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mer-im-nah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3308"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be anxious about",
               "kjv_def": ":--(be, have) care(-ful), take thought.",
               "_strongs": "03309"
            },
            {
               "strongs": "3310",
               "greek": [
                  {
                     "_BETA": "MERI/S",
                     "_unicode": "μερίς",
                     "_translit": "merís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mer-ece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3313"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a portion, i.e. province, share or (abstractly)\n participation",
               "kjv_def": ":--part (X -akers).",
               "_strongs": "03310"
            },
            {
               "strongs": "3311",
               "greek": [
                  {
                     "_BETA": "MERISMO/S",
                     "_unicode": "μερισμός",
                     "_translit": "merismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mer-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3307"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a separation or distribution",
               "kjv_def": ":--dividing asunder, gift.",
               "_strongs": "03311"
            },
            {
               "strongs": "3312",
               "greek": [
                  {
                     "_BETA": "MERISTH/S",
                     "_unicode": "μεριστής",
                     "_translit": "meristḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mer-is-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3307"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an apportioner (administrator)",
               "kjv_def": ":--divider.",
               "_strongs": "03312"
            },
            {
               "strongs": "3313",
               "greek": [
                  {
                     "_BETA": "ME/ROS",
                     "_unicode": "μέρος",
                     "_translit": "méros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mer'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MEI/ROMAI",
                        "_unicode": "μείρομαι",
                        "_translit": "meíromai"
                     }
                  ],
                  "__text": "from an obsolete but more primary form of \n (to get as a\n section or allotment);"
               },
               "strongs_def": "a division or share (literally or figuratively,\n in a wide application)",
               "kjv_def": ":--behalf, course, coast, craft, particular (+\n -ly), part (+ -ly), piece, portion, respect, side, some sort(-what).",
               "_strongs": "03313"
            },
            {
               "strongs": "3314",
               "greek": [
                  {
                     "_BETA": "MESHMBRI/A",
                     "_unicode": "μεσημβρία",
                     "_translit": "mesēmbría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-ame-bree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3319"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "midday; by implication, the south",
               "kjv_def": ":--noon, south.",
               "_strongs": "03314"
            },
            {
               "strongs": "3315",
               "greek": [
                  {
                     "_BETA": "MESITEU/W",
                     "_unicode": "μεσιτεύω",
                     "_translit": "mesiteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-it-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3316"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to interpose (as arbiter), i.e (by implication) to ratify\n (as surety)",
               "kjv_def": ":--confirm.",
               "_strongs": "03315"
            },
            {
               "strongs": "3316",
               "greek": [
                  {
                     "_BETA": "MESI/THS",
                     "_unicode": "μεσίτης",
                     "_translit": "mesítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3319"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a go-between, i.e. (simply) an internunciator, or (by\n implication) a reconciler (intercessor)",
               "kjv_def": ":--mediator.",
               "_strongs": "03316"
            },
            {
               "strongs": "3317",
               "greek": [
                  {
                     "_BETA": "MESONU/KTION",
                     "_unicode": "μεσονύκτιον",
                     "_translit": "mesonýktion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-on-ook'-tee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3319"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3571"
                     }
                  ],
                  "__text": "neuter of compound of \n and \n;"
               },
               "strongs_def": "midnight (especially as a\n watch)",
               "kjv_def": ":--midnight.",
               "_strongs": "03317"
            },
            {
               "strongs": "3318",
               "greek": [
                  {
                     "_BETA": "*MESOPOTAMI/A",
                     "_unicode": "Μεσοποταμία",
                     "_translit": "Mesopotamía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-op-ot-am-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3319"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4215"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0763"
                     }
                  ],
                  "__text": "Mesopotamia (as lying between the Euphrates and\n the Tigris; compare \n), a region of Asia"
               },
               "kjv_def": ":--Mesopotamia.",
               "_strongs": "03318"
            },
            {
               "strongs": "3319",
               "greek": [
                  {
                     "_BETA": "ME/SOS",
                     "_unicode": "μέσος",
                     "_translit": "mésos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "middle (as an adjective or (neuter) noun)",
               "kjv_def": ":--among, X before\n them, between, + forth, mid(-day, -night), midst, way.",
               "_strongs": "03319"
            },
            {
               "strongs": "3320",
               "greek": [
                  {
                     "_BETA": "MESO/TOIXON",
                     "_unicode": "μεσότοιχον",
                     "_translit": "mesótoichon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-ot'-oy-khon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3319"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5109"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a partition (figuratively)",
               "kjv_def": ":--middle wall.",
               "_strongs": "03320"
            },
            {
               "strongs": "3321",
               "greek": [
                  {
                     "_BETA": "MESOURA/NHMA",
                     "_unicode": "μεσουράνημα",
                     "_translit": "mesouránēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-oo-ran'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3319"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3772"
                     }
                  ],
                  "__text": "from a presumed compound of \n and \n;"
               },
               "strongs_def": "mid-sky",
               "kjv_def": ":--midst of heaven.",
               "_strongs": "03321"
            },
            {
               "strongs": "3322",
               "greek": [
                  {
                     "_BETA": "MESO/W",
                     "_unicode": "μεσόω",
                     "_translit": "mesóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3319"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to form the middle, i.e. (in point of time), to be half-way\n over",
               "kjv_def": ":--be about the midst.",
               "_strongs": "03322"
            },
            {
               "strongs": "3323",
               "greek": [
                  {
                     "_BETA": "*MESSI/AS",
                     "_unicode": "Μεσσίας",
                     "_translit": "Messías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-see'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04899"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "the Messias (i.e. Mashiach), or\n Christ",
               "kjv_def": ":--Messias.",
               "_strongs": "03323"
            },
            {
               "strongs": "3324",
               "greek": [
                  {
                     "_BETA": "MESTO/S",
                     "_unicode": "μεστός",
                     "_translit": "mestós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-tos'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "replete (literally or figuratively)",
               "kjv_def": ":--full.",
               "_strongs": "03324"
            },
            {
               "strongs": "3325",
               "greek": [
                  {
                     "_BETA": "MESTO/W",
                     "_unicode": "μεστόω",
                     "_translit": "mestóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mes-to'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3324"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to replenish, i.e. (by implication) to intoxicate",
               "kjv_def": ":--fill.",
               "_strongs": "03325"
            },
            {
               "strongs": "3326",
               "greek": [
                  {
                     "_BETA": "META/",
                     "_unicode": "μετά",
                     "_translit": "metá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ah'"
                  }
               ],
               "strongs_derivation": "a primary preposition (often used adverbially);",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "575"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "__text": "properly, denoting\n accompaniment; \"amid\" (local or causal); modified variously according\n to the case (genitive association, or accusative succession) with\n which it is joined; occupying an intermediate position between \n or\n \n and \n or \n; less intimate than \n and less close than\n \n)"
               },
               "kjv_def": ":--after(-ward), X that he again, against, among, X and,\n + follow, hence, hereafter, in, of, (up-)on, + our, X and\n setting, since, (un-)to, + together, when, with (+ -out).",
               "_strongs": "03326",
               "__text": "Often used\n in composition, in substantially the same relations of participation\n or proximity, and transfer or sequence."
            },
            {
               "strongs": "3327",
               "greek": [
                  {
                     "_BETA": "METABAI/NW",
                     "_unicode": "μεταβαίνω",
                     "_translit": "metabaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ab-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to change place",
               "kjv_def": ":--depart, go, pass,\n remove.",
               "_strongs": "03327"
            },
            {
               "strongs": "3328",
               "greek": [
                  {
                     "_BETA": "METABA/LLW",
                     "_unicode": "μεταβάλλω",
                     "_translit": "metabállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ab-al'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw over, i.e. (middle voice figuratively) to\n turn about in opinion",
               "kjv_def": ":--change mind.",
               "_strongs": "03328"
            },
            {
               "strongs": "3329",
               "greek": [
                  {
                     "_BETA": "META/GW",
                     "_unicode": "μετάγω",
                     "_translit": "metágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "718"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead over, i.e. transfer (direct)",
               "kjv_def": ":--turn about.",
               "_strongs": "03329"
            },
            {
               "strongs": "3330",
               "greek": [
                  {
                     "_BETA": "METADI/DWMI",
                     "_unicode": "μεταδίδωμι",
                     "_translit": "metadídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ad-id'-o-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give over, i.e. share",
               "kjv_def": ":--give, impart.",
               "_strongs": "03330"
            },
            {
               "strongs": "3331",
               "greek": [
                  {
                     "_BETA": "META/QESIS",
                     "_unicode": "μετάθεσις",
                     "_translit": "metáthesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ath'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3346"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "transposition, i.e. transferral (to heaven),\n disestablishment (of a law)",
               "kjv_def": ":--change, removing, translation.",
               "_strongs": "03331"
            },
            {
               "strongs": "3332",
               "greek": [
                  {
                     "_BETA": "METAI/RW",
                     "_unicode": "μεταίρω",
                     "_translit": "metaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ah'-ee-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to betake oneself, i.e. remove (locally)",
               "kjv_def": ":--depart.",
               "_strongs": "03332"
            },
            {
               "strongs": "3333",
               "greek": [
                  {
                     "_BETA": "METAKALE/W",
                     "_unicode": "μετακαλέω",
                     "_translit": "metakaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ak-al-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to call elsewhere, i.e. summon",
               "kjv_def": ":--call (for,\n hither).",
               "_strongs": "03333"
            },
            {
               "strongs": "3334",
               "greek": [
                  {
                     "_BETA": "METAKINE/W",
                     "_unicode": "μετακινέω",
                     "_translit": "metakinéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ak-ee-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2795"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stir to a place elsewhere, i.e. remove\n (figuratively)",
               "kjv_def": ":--move away.",
               "_strongs": "03334"
            },
            {
               "strongs": "3335",
               "greek": [
                  {
                     "_BETA": "METALAMBA/NW",
                     "_unicode": "μεταλαμβάνω",
                     "_translit": "metalambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-al-am-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to participate; genitive case, to accept (and\n use)",
               "kjv_def": ":--eat, have, be partaker, receive, take.",
               "_strongs": "03335"
            },
            {
               "strongs": "3336",
               "greek": [
                  {
                     "_BETA": "META/LHMYIS",
                     "_unicode": "μετάλημψις",
                     "_translit": "metálēmpsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-al'-ape-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3335"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "participation",
               "kjv_def": ":--taking.",
               "_strongs": "03336"
            },
            {
               "strongs": "3337",
               "greek": [
                  {
                     "_BETA": "METALLA/SSW",
                     "_unicode": "μεταλλάσσω",
                     "_translit": "metallássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-al-las'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "236"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exchange",
               "kjv_def": ":--change.",
               "_strongs": "03337"
            },
            {
               "strongs": "3338",
               "greek": [
                  {
                     "_BETA": "METAME/LLOMAI",
                     "_unicode": "μεταμέλλομαι",
                     "_translit": "metaméllomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-am-el'-lom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3199"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to care afterwards, i.e.\n regret",
               "kjv_def": ":--repent (self).",
               "_strongs": "03338"
            },
            {
               "strongs": "3339",
               "greek": [
                  {
                     "_BETA": "METAMORFO/W",
                     "_unicode": "μεταμορφόω",
                     "_translit": "metamorphóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-am-or-fo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3445"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to transform (literally or figuratively,\n \"metamorphose\")",
               "kjv_def": ":--change, transfigure, transform.",
               "_strongs": "03339"
            },
            {
               "strongs": "3340",
               "greek": [
                  {
                     "_BETA": "METANOE/W",
                     "_unicode": "μετανοέω",
                     "_translit": "metanoéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-an-o-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to think differently or afterwards, i.e.\n reconsider (morally, feel compunction)",
               "kjv_def": ":--repent.",
               "_strongs": "03340"
            },
            {
               "strongs": "3341",
               "greek": [
                  {
                     "_BETA": "META/NOIA",
                     "_unicode": "μετάνοια",
                     "_translit": "metánoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-an'-oy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3340"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(subjectively) compunction (for guilt, including\n reformation); by implication, reversal (of (another's)\n decision)",
               "kjv_def": ":--repentance.",
               "_strongs": "03341"
            },
            {
               "strongs": "3342",
               "greek": [
                  {
                     "_BETA": "METACU/",
                     "_unicode": "μεταξύ",
                     "_translit": "metaxý"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ax-oo'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "__text": "from \n and a form of \n;"
               },
               "strongs_def": "betwixt (of place or person); (of time)\n as adjective, intervening, or (by implication) adjoining",
               "kjv_def": ":--between,\n mean while, next.",
               "_strongs": "03342"
            },
            {
               "strongs": "3343",
               "greek": [
                  {
                     "_BETA": "METAPE/MPW",
                     "_unicode": "μεταπέμπω",
                     "_translit": "metapémpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ap-emp'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3992"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to send from elsewhere, i.e. (middle voice) to\n summon or invite",
               "kjv_def": ":--call (send) for.",
               "_strongs": "03343"
            },
            {
               "strongs": "3344",
               "greek": [
                  {
                     "_BETA": "METASTRE/FW",
                     "_unicode": "μεταστρέφω",
                     "_translit": "metastréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-as-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to turn across, i.e. transmute or (figuratively)\n corrupt",
               "kjv_def": ":--pervert, turn.",
               "_strongs": "03344"
            },
            {
               "strongs": "3345",
               "greek": [
                  {
                     "_BETA": "METASXHMATI/ZW",
                     "_unicode": "μετασχηματίζω",
                     "_translit": "metaschēmatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-askh-ay-mat-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4976"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to transfigure or disguise;\n figuratively, to apply (by accommodation)",
               "kjv_def": ":--transfer, transform\n (self).",
               "_strongs": "03345"
            },
            {
               "strongs": "3346",
               "greek": [
                  {
                     "_BETA": "METATI/QHMI",
                     "_unicode": "μετατίθημι",
                     "_translit": "metatíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-at-ith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to transfer, i.e. (literally) transport, (by\n implication) exchange, (reflexively) change sides, or (figuratively)\n pervert",
               "kjv_def": ":--carry over, change, remove, translate, turn.",
               "_strongs": "03346"
            },
            {
               "strongs": "3347",
               "greek": [
                  {
                     "_BETA": "METE/PEITA",
                     "_unicode": "μετέπειτα",
                     "_translit": "metépeita"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ep'-i-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1899"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "thereafter",
               "kjv_def": ":--afterward.",
               "_strongs": "03347"
            },
            {
               "strongs": "3348",
               "greek": [
                  {
                     "_BETA": "METE/XW",
                     "_unicode": "μετέχω",
                     "_translit": "metéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to share or participate; by implication, belong\n to, eat (or drink)",
               "kjv_def": ":--be partaker, pertain, take part, use.",
               "_strongs": "03348"
            },
            {
               "strongs": "3349",
               "greek": [
                  {
                     "_BETA": "METEWRI/ZW",
                     "_unicode": "μετεωρίζω",
                     "_translit": "meteōrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-eh-o-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "from a compound of \n and a collateral form of \n or perhaps rather\n \n (compare \"meteor\");"
               },
               "strongs_def": "to raise in mid-air, i.e. (figuratively)\n suspend (passively, fluctuate or be anxious)",
               "kjv_def": ":--be of doubtful mind.",
               "_strongs": "03349"
            },
            {
               "strongs": "3350",
               "greek": [
                  {
                     "_BETA": "METOIKESI/A",
                     "_unicode": "μετοικεσία",
                     "_translit": "metoikesía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-oy-kes-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     }
                  ],
                  "__text": "from a derivative of a compound of \n and \n;"
               },
               "strongs_def": "a change of abode,\n i.e. (specially), expatriation",
               "kjv_def": ":--X brought, carried(-ying) away\n (in-)to.",
               "_strongs": "03350"
            },
            {
               "strongs": "3351",
               "greek": [
                  {
                     "_BETA": "METOIKI/ZW",
                     "_unicode": "μετοικίζω",
                     "_translit": "metoikízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-oy-kid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3350"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to transfer as a settler or captive, i.e\n colonize or exile",
               "kjv_def": ":--carry away, remove into.",
               "_strongs": "03351"
            },
            {
               "strongs": "3352",
               "greek": [
                  {
                     "_BETA": "METOXH/",
                     "_unicode": "μετοχή",
                     "_translit": "metochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-okh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3348"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "participation, i.e. intercourse",
               "kjv_def": ":--fellowship.",
               "_strongs": "03352"
            },
            {
               "strongs": "3353",
               "greek": [
                  {
                     "_BETA": "ME/TOXOS",
                     "_unicode": "μέτοχος",
                     "_translit": "métochos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met'-okh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3348"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "participant, i.e. (as noun) a sharer; by implication, an\n associate",
               "kjv_def": ":--fellow, partaker, partner.",
               "_strongs": "03353"
            },
            {
               "strongs": "3354",
               "greek": [
                  {
                     "_BETA": "METRE/W",
                     "_unicode": "μετρέω",
                     "_translit": "metréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3358"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to measure (i.e. ascertain in size by a fixed standard); by\n implication, to admeasure (i.e. allot by rule)",
               "kjv_def": ":--figuratively, to\n estimate:--measure, mete.",
               "_strongs": "03354"
            },
            {
               "strongs": "3355",
               "greek": [
                  {
                     "_BETA": "METRHTH/S",
                     "_unicode": "μετρητής",
                     "_translit": "metrētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ray-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3354"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a measurer, i.e. (specially), a certain standard measure of\n capacity for liquids",
               "kjv_def": ":--firkin.",
               "_strongs": "03355"
            },
            {
               "strongs": "3356",
               "greek": [
                  {
                     "_BETA": "METRIOPAQE/W",
                     "_unicode": "μετριοπαθέω",
                     "_translit": "metriopathéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ree-op-ath-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3357"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3806"
                     }
                  ],
                  "__text": "from a compound of the base of \n and \n;"
               },
               "strongs_def": "to be moderate in\n passion, i.e. gentle (to treat indulgently)",
               "kjv_def": ":--have compassion.",
               "_strongs": "03356"
            },
            {
               "strongs": "3357",
               "greek": [
                  {
                     "_BETA": "METRI/WS",
                     "_unicode": "μετρίως",
                     "_translit": "metríōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met-ree'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3358"
                     }
                  ],
                  "__text": "adverb from a derivative of \n;"
               },
               "strongs_def": "moderately, i.e. slightly",
               "kjv_def": ":--a\n little.",
               "_strongs": "03357"
            },
            {
               "strongs": "3358",
               "greek": [
                  {
                     "_BETA": "ME/TRON",
                     "_unicode": "μέτρον",
                     "_translit": "métron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met'-ron"
                  }
               ],
               "strongs_derivation": "an apparently primary word;",
               "strongs_def": "a measure (\"metre\"), literally or\n figuratively; by implication, a limited portion (degree)",
               "kjv_def": ":-- measure.",
               "_strongs": "03358"
            },
            {
               "strongs": "3359",
               "greek": [
                  {
                     "_BETA": "ME/TWPON",
                     "_unicode": "μέτωπον",
                     "_translit": "métōpon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "met'-o-pon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     }
                  ],
                  "__text": "from \n and ops (the face);"
               },
               "strongs_def": "the forehead (as opposite the\n countenance)",
               "kjv_def": ":--forehead.",
               "_strongs": "03359"
            },
            {
               "strongs": "3360",
               "greek": [
                  {
                     "_BETA": "ME/XRI",
                     "_unicode": "μέχρι",
                     "_translit": "méchri"
                  },
                  {
                     "_BETA": "MEXRI/S",
                     "_unicode": "μεχρίς",
                     "_translit": "mechrís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mekh'-ree"
                  },
                  {
                     "_strongs": "mekh-ris'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3372"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "891"
                     }
                  ],
                  "__text": "as far as, i.e. up to a certain point (as a preposition, of\n extent (denoting the terminus, whereas \n refers especially to the\n space of time or place intervening) or conjunction)"
               },
               "kjv_def": ":--till, (un-)to,\n until.",
               "_strongs": "03360",
               "__text": "or"
            },
            {
               "strongs": "3361",
               "greek": [
                  {
                     "_BETA": "MH/",
                     "_unicode": "μή",
                     "_translit": "mḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     }
                  ],
                  "__text": "a primary particle of qualified negation (whereas \n expresses an\n absolute denial);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     }
                  ],
                  "__text": "(adverb) not, (conjunction) lest; also (as an\n interrogative implying a negative answer (whereas \n expects an\n affirmative one)) whether"
               },
               "kjv_def": ":--any but (that), X forbear, + God forbid, +\n lack, lest, neither, never, no (X wise in), none, nor, (can-)not,\n nothing, that not, un(-taken), without.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3362"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3363"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3364"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3372"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3373"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3375"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3378"
                  }
               ],
               "_strongs": "03361",
               "__text": "Often used in compounds in\n substantially the same relations. See also \n, \n, \n, \n,\n \n, \n, \n."
            },
            {
               "strongs": "3362",
               "greek": [
                  {
                     "_BETA": "E)A\\N MH/",
                     "_unicode": "ἐὰν μή",
                     "_translit": "eàn mḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "eh-an' may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1437"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     }
                  ],
                  "__text": "i.e. \n and \n;"
               },
               "strongs_def": "if not, i.e. unless",
               "kjv_def": ":--X before, but, except, if,\n no, (if, + whosoever) not.",
               "_strongs": "03362"
            },
            {
               "strongs": "3363",
               "greek": [
                  {
                     "_BETA": "I(/NA MH/",
                     "_unicode": "ἵνα μή",
                     "_translit": "hína mḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hin'-ah may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2443"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     }
                  ],
                  "__text": "i.e. \n and \n;"
               },
               "strongs_def": "in order (or so) that not",
               "kjv_def": ":--albeit not, lest,\n that, no(-t, (-thing)).",
               "_strongs": "03363"
            },
            {
               "strongs": "3364",
               "greek": [
                  {
                     "_BETA": "OU) MH/",
                     "_unicode": "οὐ μή",
                     "_translit": "ou mḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     }
                  ],
                  "__text": "i.e. \n and \n;"
               },
               "strongs_def": "a double negative strengthening the denial; not at\n all",
               "kjv_def": ":--any more, at all, by any (no) means, neither, never, no (at\n all), in no case (wise), nor ever, not (at all, in any wise).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3378"
                  }
               ],
               "_strongs": "03364",
               "__text": "Compare\n \n."
            },
            {
               "strongs": "3365",
               "greek": [
                  {
                     "_BETA": "MHDAMW=S",
                     "_unicode": "μηδαμῶς",
                     "_translit": "mēdamōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-dam-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)MO/S",
                        "_unicode": "ἀμός",
                        "_translit": "amós"
                     }
                  ],
                  "__text": "adverb from a compound of \n and \n (somebody);"
               },
               "strongs_def": "by no means",
               "kjv_def": ":--not\n so.",
               "_strongs": "03365"
            },
            {
               "strongs": "3366",
               "greek": [
                  {
                     "_BETA": "MHDE/",
                     "_unicode": "μηδέ",
                     "_translit": "mēdé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-deh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1161"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "but not, not even; in a continued negation,\n nor",
               "kjv_def": ":--neither, nor (yet), (no) not (once, so much as).",
               "_strongs": "03366"
            },
            {
               "strongs": "3367",
               "greek": [
                  {
                     "_BETA": "MHDEI/S",
                     "_unicode": "μηδείς",
                     "_translit": "mēdeís"
                  },
                  {
                     "_BETA": "MHDEMI/A",
                     "_unicode": "μηδεμία",
                     "_translit": "mēdemía"
                  },
                  {
                     "_BETA": "MHDE/N",
                     "_unicode": "μηδέν",
                     "_translit": "mēdén"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-dice'"
                  },
                  {
                     "_strongs": "may-dem-ee'-ah"
                  },
                  {
                     "_strongs": "may-den'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1520"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not even one (man, woman, thing)",
               "kjv_def": ":--any (man,\n thing), no (man), none, not (at all, any man, a whit), nothing,\n + without delay.",
               "_strongs": "03367",
               "__text": ", including the irregular feminine\n      \n  \n, and the neuter"
            },
            {
               "strongs": "3368",
               "greek": [
                  {
                     "_BETA": "MHDE/POTE",
                     "_unicode": "μηδέποτε",
                     "_translit": "mēdépote"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-dep'-ot-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3366"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not even ever",
               "kjv_def": ":--never.",
               "_strongs": "03368"
            },
            {
               "strongs": "3369",
               "greek": [
                  {
                     "_BETA": "MHDE/PW",
                     "_unicode": "μηδέπω",
                     "_translit": "mēdépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-dep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3366"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4452"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not even yet",
               "kjv_def": ":--not yet.",
               "_strongs": "03369"
            },
            {
               "strongs": "3370",
               "greek": [
                  {
                     "_BETA": "*MH=DOS",
                     "_unicode": "Μῆδος",
                     "_translit": "Mēdos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-dos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04074"
                     }
                  ],
                  "__text": "of foreign origin (compare \n);"
               },
               "strongs_def": "a Median, or inhabitant of\n Media",
               "kjv_def": ":--Mede.",
               "_strongs": "03370"
            },
            {
               "strongs": "3371",
               "greek": [
                  {
                     "_BETA": "MHKE/TI",
                     "_unicode": "μηκέτι",
                     "_translit": "mēkéti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-ket'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "no further",
               "kjv_def": ":--any longer, (not) henceforth,\n hereafter, no henceforward (longer, more, soon), not any more.",
               "_strongs": "03371"
            },
            {
               "strongs": "3372",
               "greek": [
                  {
                     "_BETA": "MH=KOS",
                     "_unicode": "μῆκος",
                     "_translit": "mēkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3173"
                     }
                  ],
                  "__text": "probably akin to \n;"
               },
               "strongs_def": "length (literally or figuratively)",
               "kjv_def": ":--length.",
               "_strongs": "03372"
            },
            {
               "strongs": "3373",
               "greek": [
                  {
                     "_BETA": "MHKU/NW",
                     "_unicode": "μηκύνω",
                     "_translit": "mēkýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-koo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3372"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to lengthen, i.e. (middle voice) to enlarge",
               "kjv_def": ":--grow up.",
               "_strongs": "03373"
            },
            {
               "strongs": "3374",
               "greek": [
                  {
                     "_BETA": "MHLWTH/",
                     "_unicode": "μηλωτή",
                     "_translit": "mēlōtḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-lo-tay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MH=LON",
                        "_unicode": "μῆλον",
                        "_translit": "mēlon"
                     }
                  ],
                  "__text": "from \n (a sheep);"
               },
               "strongs_def": "a sheep-skin",
               "kjv_def": ":--sheepskin.",
               "_strongs": "03374"
            },
            {
               "strongs": "3375",
               "greek": [
                  {
                     "_BETA": "MH/N",
                     "_unicode": "μήν",
                     "_translit": "mḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3303"
                     }
                  ],
                  "__text": "a stronger form of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2229"
                     }
                  ],
                  "__text": "a particle of affirmation (only with \n);\n assuredly"
               },
               "kjv_def": ":--+ surely.",
               "_strongs": "03375"
            },
            {
               "strongs": "3376",
               "greek": [
                  {
                     "_BETA": "MH/N",
                     "_unicode": "μήν",
                     "_translit": "mḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mane"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "a month",
               "kjv_def": ":--month.",
               "_strongs": "03376"
            },
            {
               "strongs": "3377",
               "greek": [
                  {
                     "_BETA": "MHNU/W",
                     "_unicode": "μηνύω",
                     "_translit": "mēnýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-noo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3145"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3415"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "MA/W",
                        "_unicode": "μάω",
                        "_translit": "máō"
                     }
                  ],
                  "__text": "probably from the same base as \n and \n (i.e. \n, to strive);"
               },
               "strongs_def": "to\n disclose (through the idea of mental effort and thus calling to mind),\n i.e. report, declare, intimate",
               "kjv_def": ":--shew, tell.",
               "_strongs": "03377"
            },
            {
               "strongs": "3378",
               "greek": [
                  {
                     "_BETA": "MH\\ OU)K",
                     "_unicode": "μὴ οὐκ",
                     "_translit": "mḕ ouk"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ouk"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     }
                  ],
                  "__text": "i.e. \n and \n;"
               },
               "strongs_def": "as interrogative and negative, is it not\n that?",
               "kjv_def": ":--neither (followed by no), + never, not.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3364"
                  }
               ],
               "_strongs": "03378",
               "__text": "may ook\n\n \n Compare \n."
            },
            {
               "strongs": "3379",
               "greek": [
                  {
                     "_BETA": "MH/POTE",
                     "_unicode": "μήποτε",
                     "_translit": "mḗpote"
                  },
                  {
                     "_BETA": "MH/ POTE",
                     "_unicode": "μή ποτε",
                     "_translit": "mḗ pote"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-pot-eh"
                  },
                  {
                     "_strongs": "may pot'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not ever; also if (or lest) ever (or perhaps)",
               "kjv_def": ":--if\n peradventure, lest (at any time, haply), not at all, whether or not.",
               "_strongs": "03379",
               "__text": "or"
            },
            {
               "strongs": "3380",
               "greek": [
                  {
                     "_BETA": "MH/PW",
                     "_unicode": "μήπω",
                     "_translit": "mḗpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4452"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not yet",
               "kjv_def": ":--not yet.",
               "_strongs": "03380"
            },
            {
               "strongs": "3381",
               "greek": [
                  {
                     "_BETA": "MH/PWS",
                     "_unicode": "μήπως",
                     "_translit": "mḗpōs"
                  },
                  {
                     "_BETA": "MH/ PWS",
                     "_unicode": "μή πως",
                     "_translit": "mḗ pōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-pos"
                  },
                  {
                     "_strongs": "may tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4458"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "lest somehow",
               "kjv_def": ":--lest (by any means, by some means,\n haply, perhaps).",
               "_strongs": "03381",
               "__text": "or"
            },
            {
               "strongs": "3382",
               "greek": [
                  {
                     "_BETA": "MHRO/S",
                     "_unicode": "μηρός",
                     "_translit": "mērós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-ros'"
                  }
               ],
               "strongs_derivation": "perhaps a primary word;",
               "strongs_def": "a thigh",
               "kjv_def": ":--thigh.",
               "_strongs": "03382"
            },
            {
               "strongs": "3383",
               "greek": [
                  {
                     "_BETA": "MH/TE",
                     "_unicode": "μήτε",
                     "_translit": "mḗte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-teh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5037"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not too, i.e. (in continued negation) neither or\n nor; also, not even",
               "kjv_def": ":--neither, (n-)or, so as much.",
               "_strongs": "03383"
            },
            {
               "strongs": "3384",
               "greek": [
                  {
                     "_BETA": "MH/THR",
                     "_unicode": "μήτηρ",
                     "_translit": "mḗtēr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-tare"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a \"mother\" (literally or figuratively,\n immediate or remote)",
               "kjv_def": ":--mother.",
               "_strongs": "03384"
            },
            {
               "strongs": "3385",
               "greek": [
                  {
                     "_BETA": "MH/TI",
                     "_unicode": "μήτι",
                     "_translit": "mḗti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5100"
                     }
                  ],
                  "__text": "from \n and the neuter of \n;"
               },
               "strongs_def": "whether at all",
               "kjv_def": ":--not (the particle\n usually not expressed, except by the form of the question).",
               "_strongs": "03385"
            },
            {
               "strongs": "3386",
               "greek": [
                  {
                     "_BETA": "MH/TIGE",
                     "_unicode": "μήτιγε",
                     "_translit": "mḗtige"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-tig-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3385"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1065"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not at all then, i.e. not to say (the rather\n still)",
               "kjv_def": ":--how much more.",
               "_strongs": "03386"
            },
            {
               "strongs": "3387",
               "greek": [
                  {
                     "_BETA": "MH/TIS",
                     "_unicode": "μήτις",
                     "_translit": "mḗtis"
                  },
                  {
                     "_BETA": "MH/ TIS",
                     "_unicode": "μή τις",
                     "_translit": "mḗ tis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-tis"
                  },
                  {
                     "_strongs": "may tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5100"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "whether any",
               "kjv_def": ":--any (sometimes unexpressed except by\n the simple interrogative form of the sentence).",
               "_strongs": "03387",
               "__text": "or"
            },
            {
               "strongs": "3388",
               "greek": [
                  {
                     "_BETA": "MH/TRA",
                     "_unicode": "μήτρα",
                     "_translit": "mḗtra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may'-trah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3384"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the matrix",
               "kjv_def": ":--womb.",
               "_strongs": "03388"
            },
            {
               "strongs": "3389",
               "greek": [
                  {
                     "_BETA": "MHTRALW/|AS",
                     "_unicode": "μητραλῴας",
                     "_translit": "mētralṓias"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-tral-o'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "257"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "a mother-thresher, i.e.\n matricide",
               "kjv_def": ":--murderer of mothers.",
               "_strongs": "03389"
            },
            {
               "strongs": "3390",
               "greek": [
                  {
                     "_BETA": "MHTRO/POLIS",
                     "_unicode": "μητρόπολις",
                     "_translit": "mētrópolis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "may-trop'-ol-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a mother city, i.e. \"metropolis\"",
               "kjv_def": ":--chiefest city.",
               "_strongs": "03390"
            },
            {
               "strongs": "3391",
               "greek": [
                  {
                     "_BETA": "MI/A",
                     "_unicode": "μία",
                     "_translit": "mía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1520"
                     }
                  ],
                  "__text": "irregular feminine of \n;"
               },
               "strongs_def": "one or first",
               "kjv_def": ":--a (certain), + agree,\n first, one, X other.",
               "_strongs": "03391"
            },
            {
               "strongs": "3392",
               "greek": [
                  {
                     "_BETA": "MIAI/NW",
                     "_unicode": "μιαίνω",
                     "_translit": "miaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "me-ah'-ee-no"
                  }
               ],
               "strongs_derivation": "perhaps a primary verb;",
               "strongs_def": "to sully or taint, i.e. contaminate\n (ceremonially or morally)",
               "kjv_def": ":--defile.",
               "_strongs": "03392"
            },
            {
               "strongs": "3393",
               "greek": [
                  {
                     "_BETA": "MI/ASMA",
                     "_unicode": "μίασμα",
                     "_translit": "míasma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mee'-as-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3392"
                     }
                  ],
                  "__text": "from \n (\"miasma\");"
               },
               "strongs_def": "(morally) foulness (properly, the\n effect)",
               "kjv_def": ":--pollution.",
               "_strongs": "03393"
            },
            {
               "strongs": "3394",
               "greek": [
                  {
                     "_BETA": "MIASMO/S",
                     "_unicode": "μιασμός",
                     "_translit": "miasmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mee-as-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3392"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(morally) contamination (properly, the act)",
               "kjv_def": ":--uncleanness.",
               "_strongs": "03394"
            },
            {
               "strongs": "3395",
               "greek": [
                  {
                     "_BETA": "MI/GMA",
                     "_unicode": "μίγμα",
                     "_translit": "mígma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mig'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3396"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a compound",
               "kjv_def": ":--mixture.",
               "_strongs": "03395"
            },
            {
               "strongs": "3396",
               "greek": [
                  {
                     "_BETA": "MI/GNUMI",
                     "_unicode": "μίγνυμι",
                     "_translit": "mígnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mig'-noo-mee"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to mix",
               "kjv_def": ":--mingle.",
               "_strongs": "03396"
            },
            {
               "strongs": "3397",
               "greek": [
                  {
                     "_BETA": "MIKRO/N",
                     "_unicode": "μικρόν",
                     "_translit": "mikrón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mik-ron'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3398"
                     }
                  ],
                  "__text": "masculine or neuter singular of \n (as noun);"
               },
               "strongs_def": "a small space of time\n or degree",
               "kjv_def": ":--a (little) (while).",
               "_strongs": "03397"
            },
            {
               "strongs": "3398",
               "greek": [
                  {
                     "_BETA": "MIKRO/S",
                     "_unicode": "μικρός",
                     "_translit": "mikrós"
                  },
                  {
                     "_BETA": "MIKRO/TEROS",
                     "_unicode": "μικρότερος",
                     "_translit": "mikróteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mik-ros'"
                  },
                  {
                     "_strongs": "mik-rot'-er-os"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "small (in size, quantity, number or\n (figuratively) dignity)",
               "kjv_def": ":--least, less, little, small.",
               "_strongs": "03398",
               "__text": ", including the comparative"
            },
            {
               "strongs": "3399",
               "greek": [
                  {
                     "_BETA": "*MI/LHTOS",
                     "_unicode": "Μίλητος",
                     "_translit": "Mílētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mil'-ay-tos"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Miletus, a city of Asia Minor",
               "kjv_def": ":--Miletus.",
               "_strongs": "03399"
            },
            {
               "strongs": "3400",
               "greek": [
                  {
                     "_BETA": "MI/LION",
                     "_unicode": "μίλιον",
                     "_translit": "mílion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mil'-ee-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a thousand paces, i.e. a \"mile\"",
               "kjv_def": ":--mile.",
               "_strongs": "03400"
            },
            {
               "strongs": "3401",
               "greek": [
                  {
                     "_BETA": "MIME/OMAI",
                     "_unicode": "μιμέομαι",
                     "_translit": "miméomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mim-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MI=MOS",
                        "_unicode": "μῖμος",
                        "_translit": "mîmos"
                     }
                  ],
                  "__text": "middle voice from \n (a \"mimic\");"
               },
               "strongs_def": "to imitate",
               "kjv_def": ":--follow.",
               "_strongs": "03401"
            },
            {
               "strongs": "3402",
               "greek": [
                  {
                     "_BETA": "MIMHTH/S",
                     "_unicode": "μιμητής",
                     "_translit": "mimētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mim-ay-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3401"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an imitator",
               "kjv_def": ":--follower.",
               "_strongs": "03402"
            },
            {
               "strongs": "3403",
               "greek": [
                  {
                     "_BETA": "MIMNH/SKW",
                     "_unicode": "μιμνήσκω",
                     "_translit": "mimnḗskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mim-nace'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3415"
                     }
                  ],
                  "__text": "a prolonged form of \n (from which some of the tenses are borrowed);"
               },
               "strongs_def": "to remind, i.e. (middle voice) to recall to mind",
               "kjv_def": ":--be mindful,\n remember.",
               "_strongs": "03403"
            },
            {
               "strongs": "3404",
               "greek": [
                  {
                     "_BETA": "MISE/W",
                     "_unicode": "μισέω",
                     "_translit": "miséō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mis-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MI=SOS",
                        "_unicode": "μῖσος",
                        "_translit": "mîsos"
                     }
                  ],
                  "__text": "from a primary \n (hatred);"
               },
               "strongs_def": "to detest (especially to persecute); by\n extension, to love less",
               "kjv_def": ":--hate(-ful).",
               "_strongs": "03404"
            },
            {
               "strongs": "3405",
               "greek": [
                  {
                     "_BETA": "MISQAPODOSI/A",
                     "_unicode": "μισθαποδοσία",
                     "_translit": "misthapodosía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mis-thap-od-os-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3406"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "requital (good or bad)",
               "kjv_def": ":--recompence of reward.",
               "_strongs": "03405"
            },
            {
               "strongs": "3406",
               "greek": [
                  {
                     "_BETA": "MISQAPODO/THS",
                     "_unicode": "μισθαποδότης",
                     "_translit": "misthapodótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mis-thap-od-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3409"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "591"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a renumerator",
               "kjv_def": ":--rewarder.",
               "_strongs": "03406"
            },
            {
               "strongs": "3407",
               "greek": [
                  {
                     "_BETA": "MI/SQIOS",
                     "_unicode": "μίσθιος",
                     "_translit": "místhios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mis'-thee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3408"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a wage-earner",
               "kjv_def": ":--hired servant.",
               "_strongs": "03407"
            },
            {
               "strongs": "3408",
               "greek": [
                  {
                     "_BETA": "MISQO/S",
                     "_unicode": "μισθός",
                     "_translit": "misthós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mis-thos'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "pay for service (literally or\n figuratively), good or bad",
               "kjv_def": ":--hire, reward, wages.",
               "_strongs": "03408"
            },
            {
               "strongs": "3409",
               "greek": [
                  {
                     "_BETA": "MISQO/W",
                     "_unicode": "μισθόω",
                     "_translit": "misthóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mis-tho'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3408"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to let out for wages, i.e. (middle voice) to hire",
               "kjv_def": ":--hire.",
               "_strongs": "03409"
            },
            {
               "strongs": "3410",
               "greek": [
                  {
                     "_BETA": "MI/SQWMA",
                     "_unicode": "μίσθωμα",
                     "_translit": "místhōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mis'-tho-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3409"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a rented building",
               "kjv_def": ":--hired house.",
               "_strongs": "03410"
            },
            {
               "strongs": "3411",
               "greek": [
                  {
                     "_BETA": "MISQWTO/S",
                     "_unicode": "μισθωτός",
                     "_translit": "misthōtós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mis-tho-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3409"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a wage-worker (good or bad)",
               "kjv_def": ":--hired servant, hireling.",
               "_strongs": "03411"
            },
            {
               "strongs": "3412",
               "greek": [
                  {
                     "_BETA": "*MITULH/NH",
                     "_unicode": "Μιτυλήνη",
                     "_translit": "Mitylḗnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mit-oo-lay'-nay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MUTILH/NH",
                        "_unicode": "μυτιλήνη",
                        "_translit": "mytilḗnē"
                     }
                  ],
                  "__text": "for \n (abounding in shellfish);"
               },
               "strongs_def": "Mitylene (or Mytilene), a town\n on the island of Lesbos",
               "kjv_def": ":--Mitylene.",
               "_strongs": "03412"
            },
            {
               "strongs": "3413",
               "greek": [
                  {
                     "_BETA": "*MIXAH/L",
                     "_unicode": "Μιχαήλ",
                     "_translit": "Michaḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mikh-ah-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04317"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Michael, an archangel",
               "kjv_def": ":--Michael.",
               "_strongs": "03413"
            },
            {
               "strongs": "3414",
               "greek": [
                  {
                     "_BETA": "MNA=",
                     "_unicode": "μνᾶ",
                     "_translit": "mnâ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnah"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a mna (i.e. mina), a certain weight",
               "kjv_def": ":-- pound.",
               "_strongs": "03414"
            },
            {
               "strongs": "3415",
               "greek": [
                  {
                     "_BETA": "MNA/OMAI",
                     "_unicode": "μνάομαι",
                     "_translit": "mnáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3145"
                     }
                  ],
                  "__text": "middle voice of a derivative of \n or perhaps of the base of \n\n (through the idea of fixture in the mind or of mental grasp);"
               },
               "strongs_def": "to bear\n in mind, i.e. recollect; by implication, to reward or punish",
               "kjv_def": ":--be\n mindful, remember, come (have) in remembrance.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3403"
                  }
               ],
               "_strongs": "03415",
               "__text": "Compare \n."
            },
            {
               "strongs": "3416",
               "greek": [
                  {
                     "_BETA": "*MNA/SWN",
                     "_unicode": "Μνάσων",
                     "_translit": "Mnásōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnah'-sohn"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Mnason, a Christian",
               "kjv_def": ":--Mnason.",
               "_strongs": "03416"
            },
            {
               "strongs": "3417",
               "greek": [
                  {
                     "_BETA": "MNEI/A",
                     "_unicode": "μνεία",
                     "_translit": "mneía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mni'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3415"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3403"
                     }
                  ],
                  "__text": "from \n or \n;"
               },
               "strongs_def": "recollection; by implication, recital",
               "kjv_def": ":--mention,\n remembrance.",
               "_strongs": "03417"
            },
            {
               "strongs": "3418",
               "greek": [
                  {
                     "_BETA": "MNH=MA",
                     "_unicode": "μνῆμα",
                     "_translit": "mnēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnay'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3415"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a memorial, i.e. sepulchral monument\n (burial-place)",
               "kjv_def": ":--grave, sepulchre, tomb.",
               "_strongs": "03418"
            },
            {
               "strongs": "3419",
               "greek": [
                  {
                     "_BETA": "MNHMEI=ON",
                     "_unicode": "μνημεῖον",
                     "_translit": "mnēmeîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnay-mi'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3420"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a remembrance, i.e. cenotaph (place of interment)",
               "kjv_def": ":--grave,\n sepulchre, tomb.",
               "_strongs": "03419"
            },
            {
               "strongs": "3420",
               "greek": [
                  {
                     "_BETA": "MNH/MH",
                     "_unicode": "μνήμη",
                     "_translit": "mnḗmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnay'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3403"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "memory",
               "kjv_def": ":--remembrance.",
               "_strongs": "03420"
            },
            {
               "strongs": "3421",
               "greek": [
                  {
                     "_BETA": "MNHMONEU/W",
                     "_unicode": "μνημονεύω",
                     "_translit": "mnēmoneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnay-mon-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3420"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to exercise memory, i.e. recollect; by\n implication, to punish; also to rehearse",
               "kjv_def": ":--make mention; be mindful,\n remember.",
               "_strongs": "03421"
            },
            {
               "strongs": "3422",
               "greek": [
                  {
                     "_BETA": "MNHMO/SUNON",
                     "_unicode": "μνημόσυνον",
                     "_translit": "mnēmósynon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnay-mos'-oo-non"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3421"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a reminder (memorandum), i.e. record",
               "kjv_def": ":--memorial.",
               "_strongs": "03422"
            },
            {
               "strongs": "3423",
               "greek": [
                  {
                     "_BETA": "MNHSTEU/W",
                     "_unicode": "μνηστεύω",
                     "_translit": "mnēsteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mnace-tyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3415"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to give a souvenir (engagement present),\n i.e. betroth",
               "kjv_def": ":--espouse.",
               "_strongs": "03423"
            },
            {
               "strongs": "3424",
               "greek": [
                  {
                     "_BETA": "MOGILA/LOS",
                     "_unicode": "μογιλάλος",
                     "_translit": "mogilálos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mog-il-al'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3425"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "hardly talking, i.e. dumb (tongue-tied)",
               "kjv_def": ":--having\n an impediment in his speech.",
               "_strongs": "03424"
            },
            {
               "strongs": "3425",
               "greek": [
                  {
                     "_BETA": "MO/GIS",
                     "_unicode": "μόγις",
                     "_translit": "mógis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mog'-is"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MO/GOS",
                        "_unicode": "μόγος",
                        "_translit": "mógos"
                     }
                  ],
                  "__text": "adverb from a primary \n (toil);"
               },
               "strongs_def": "with difficulty",
               "kjv_def": ":--hardly.",
               "_strongs": "03425"
            },
            {
               "strongs": "3426",
               "greek": [
                  {
                     "_BETA": "MO/DIOS",
                     "_unicode": "μόδιος",
                     "_translit": "módios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mod'-ee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a modius, i.e. certain measure for things dry (the\n quantity or the utensil)",
               "kjv_def": ":--bushel.",
               "_strongs": "03426"
            },
            {
               "strongs": "3427",
               "greek": [
                  {
                     "_BETA": "MOI/",
                     "_unicode": "μοί",
                     "_translit": "moí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1698"
                     }
                  ],
                  "__text": "the simpler form of \n;"
               },
               "strongs_def": "to me",
               "kjv_def": ":--I, me, mine, my.",
               "_strongs": "03427"
            },
            {
               "strongs": "3428",
               "greek": [
                  {
                     "_BETA": "MOIXALI/S",
                     "_unicode": "μοιχαλίς",
                     "_translit": "moichalís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moy-khal-is'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3432"
                     }
                  ],
                  "__text": "a prolonged form of the feminine of \n;"
               },
               "strongs_def": "an adulteress (literally or\n figuratively)",
               "kjv_def": ":--adulteress(-ous, -y).",
               "_strongs": "03428"
            },
            {
               "strongs": "3429",
               "greek": [
                  {
                     "_BETA": "MOIXA/W",
                     "_unicode": "μοιχάω",
                     "_translit": "moicháō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moy-khah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3432"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(middle voice) to commit adultery",
               "kjv_def": ":--commit adultery.",
               "_strongs": "03429"
            },
            {
               "strongs": "3430",
               "greek": [
                  {
                     "_BETA": "MOIXEI/A",
                     "_unicode": "μοιχεία",
                     "_translit": "moicheía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moy-khi'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3431"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "adultery",
               "kjv_def": ":--adultery.",
               "_strongs": "03430"
            },
            {
               "strongs": "3431",
               "greek": [
                  {
                     "_BETA": "MOIXEU/W",
                     "_unicode": "μοιχεύω",
                     "_translit": "moicheúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moy-khyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3432"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to commit adultery",
               "kjv_def": ":--commit adultery.",
               "_strongs": "03431"
            },
            {
               "strongs": "3432",
               "greek": [
                  {
                     "_BETA": "MOIXO/S",
                     "_unicode": "μοιχός",
                     "_translit": "moichós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moy-khos'"
                  }
               ],
               "strongs_derivation": "perhaps a primary word;",
               "strongs_def": "a (male) paramour; figuratively,\n apostate",
               "kjv_def": ":--adulterer.",
               "_strongs": "03432"
            },
            {
               "strongs": "3433",
               "greek": [
                  {
                     "_BETA": "MO/LIS",
                     "_unicode": "μόλις",
                     "_translit": "mólis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mol'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3425"
                     }
                  ],
                  "__text": "probably by variation for \n;"
               },
               "strongs_def": "with difficulty",
               "kjv_def": ":--hardly, scarce(-ly),\n + with much work.",
               "_strongs": "03433"
            },
            {
               "strongs": "3434",
               "greek": [
                  {
                     "_BETA": "*MOLO/X",
                     "_unicode": "Μολόχ",
                     "_translit": "Molóch"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mol-okh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04432"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Moloch (i.e. Molek), an idol",
               "kjv_def": ":--Moloch.",
               "_strongs": "03434"
            },
            {
               "strongs": "3435",
               "greek": [
                  {
                     "_BETA": "MOLU/NW",
                     "_unicode": "μολύνω",
                     "_translit": "molýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mol-oo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3189"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "to soil (figuratively)",
               "kjv_def": ":--defile.",
               "_strongs": "03435"
            },
            {
               "strongs": "3436",
               "greek": [
                  {
                     "_BETA": "MOLUSMO/S",
                     "_unicode": "μολυσμός",
                     "_translit": "molysmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mol-oos-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3435"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a stain; i.e. (figuratively) immorality",
               "kjv_def": ":--filthiness.",
               "_strongs": "03436"
            },
            {
               "strongs": "3437",
               "greek": [
                  {
                     "_BETA": "MOMFH/",
                     "_unicode": "μομφή",
                     "_translit": "momphḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mom-fay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3201"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "blame, i.e. (by implication), a fault",
               "kjv_def": ":--quarrel.",
               "_strongs": "03437"
            },
            {
               "strongs": "3438",
               "greek": [
                  {
                     "_BETA": "MONH/",
                     "_unicode": "μονή",
                     "_translit": "monḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mon-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a staying, i.e. residence (the act or the place)",
               "kjv_def": ":--abode,\n mansion.",
               "_strongs": "03438"
            },
            {
               "strongs": "3439",
               "greek": [
                  {
                     "_BETA": "MONOGENH/S",
                     "_unicode": "μονογενής",
                     "_translit": "monogenḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mon-og-en-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3441"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "only-born, i.e. sole",
               "kjv_def": ":--only (begotten, child).",
               "_strongs": "03439"
            },
            {
               "strongs": "3440",
               "greek": [
                  {
                     "_BETA": "MO/NON",
                     "_unicode": "μόνον",
                     "_translit": "mónon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mon'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3441"
                     }
                  ],
                  "__text": "neuter of \n as adverb;"
               },
               "strongs_def": "merely",
               "kjv_def": ":--alone, but, only.",
               "_strongs": "03440"
            },
            {
               "strongs": "3441",
               "greek": [
                  {
                     "_BETA": "MO/NOS",
                     "_unicode": "μόνος",
                     "_translit": "mónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mon'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "remaining, i.e. sole or single; by implication,\n mere",
               "kjv_def": ":--alone, only, by themselves.",
               "_strongs": "03441"
            },
            {
               "strongs": "3442",
               "greek": [
                  {
                     "_BETA": "MONO/FQALMOS",
                     "_unicode": "μονόφθαλμος",
                     "_translit": "monóphthalmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mon-of'-thal-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3441"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3788"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "one-eyed",
               "kjv_def": ":--with one eye.",
               "_strongs": "03442"
            },
            {
               "strongs": "3443",
               "greek": [
                  {
                     "_BETA": "MONO/W",
                     "_unicode": "μονόω",
                     "_translit": "monóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mon-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3441"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to isolate, i.e. bereave",
               "kjv_def": ":--be desolate.",
               "_strongs": "03443"
            },
            {
               "strongs": "3444",
               "greek": [
                  {
                     "_BETA": "MORFH/",
                     "_unicode": "μορφή",
                     "_translit": "morphḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mor-fay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3313"
                     }
                  ],
                  "__text": "perhaps from the base of \n (through the idea of adjustment of\n parts);"
               },
               "strongs_def": "shape; figuratively, nature",
               "kjv_def": ":--form.",
               "_strongs": "03444"
            },
            {
               "strongs": "3445",
               "greek": [
                  {
                     "_BETA": "MORFO/W",
                     "_unicode": "μορφόω",
                     "_translit": "morphóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mor-fo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3444"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to fashion (figuratively)",
               "kjv_def": ":--form.",
               "_strongs": "03445"
            },
            {
               "strongs": "3446",
               "greek": [
                  {
                     "_BETA": "MO/RFWSIS",
                     "_unicode": "μόρφωσις",
                     "_translit": "mórphōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mor'-fo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3445"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "formation, i.e. (by implication), appearance (semblance or\n (concretely) formula)",
               "kjv_def": ":--form.",
               "_strongs": "03446"
            },
            {
               "strongs": "3447",
               "greek": [
                  {
                     "_BETA": "MOSXOPOIE/W",
                     "_unicode": "μοσχοποιέω",
                     "_translit": "moschopoiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mos-khop-oy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3448"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fabricate the image of a bullock",
               "kjv_def": ":--make a calf.",
               "_strongs": "03447"
            },
            {
               "strongs": "3448",
               "greek": [
                  {
                     "_BETA": "MO/SXOS",
                     "_unicode": "μόσχος",
                     "_translit": "móschos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mos'-khos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O/SXOS",
                        "_unicode": "όσχος",
                        "_translit": "óschos"
                     }
                  ],
                  "__text": "probably strengthened for \n (a shoot);"
               },
               "strongs_def": "a young bullock",
               "kjv_def": ":--calf.",
               "_strongs": "03448"
            },
            {
               "strongs": "3449",
               "greek": [
                  {
                     "_BETA": "MO/XQOS",
                     "_unicode": "μόχθος",
                     "_translit": "móchthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mokh'-thos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3425"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "toil, i.e. (by implication)\n sadness",
               "kjv_def": ":--painfulness, travail.",
               "_strongs": "03449"
            },
            {
               "strongs": "3450",
               "greek": [
                  {
                     "_BETA": "MOU=",
                     "_unicode": "μοῦ",
                     "_translit": "moû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1700"
                     }
                  ],
                  "__text": "the simpler form of \n;"
               },
               "strongs_def": "of me",
               "kjv_def": ":--I, me, mine (own), my.",
               "_strongs": "03450"
            },
            {
               "strongs": "3451",
               "greek": [
                  {
                     "_BETA": "MOUSIKO/S",
                     "_unicode": "μουσικός",
                     "_translit": "mousikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-sik-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*MOU=SA",
                        "_unicode": "Μοῦσα",
                        "_translit": "Moûsa"
                     }
                  ],
                  "__text": "from \n (a Muse);"
               },
               "strongs_def": "\"musical\", i.e. (as noun) a minstrel",
               "kjv_def": ":--musician.",
               "_strongs": "03451"
            },
            {
               "strongs": "3452",
               "greek": [
                  {
                     "_BETA": "MUELO/S",
                     "_unicode": "μυελός",
                     "_translit": "myelós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-el-os'"
                  }
               ],
               "strongs_derivation": "perhaps a primary word;",
               "strongs_def": "the marrow",
               "kjv_def": ":--marrow.",
               "_strongs": "03452"
            },
            {
               "strongs": "3453",
               "greek": [
                  {
                     "_BETA": "MUE/W",
                     "_unicode": "μυέω",
                     "_translit": "myéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3466"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "to initiate, i.e. (by implication) to\n teach",
               "kjv_def": ":--instruct.",
               "_strongs": "03453"
            },
            {
               "strongs": "3454",
               "greek": [
                  {
                     "_BETA": "MU=QOS",
                     "_unicode": "μῦθος",
                     "_translit": "mŷthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo'-thos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3453"
                     }
                  ],
                  "__text": "perhaps from the same as \n (through the idea of tuition);"
               },
               "strongs_def": "a tale,\n i.e. fiction (\"myth\")",
               "kjv_def": ":--fable.",
               "_strongs": "03454"
            },
            {
               "strongs": "3455",
               "greek": [
                  {
                     "_BETA": "MUKA/OMAI",
                     "_unicode": "μυκάομαι",
                     "_translit": "mykáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-kah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MU/ZW",
                        "_unicode": "μύζω",
                        "_translit": "mýzō"
                     }
                  ],
                  "__text": "from a presumed derivative of \n ( to \"moo\");"
               },
               "strongs_def": "to bellow\n (roar)",
               "kjv_def": ":--roar.",
               "_strongs": "03455"
            },
            {
               "strongs": "3456",
               "greek": [
                  {
                     "_BETA": "MUKTHRI/ZW",
                     "_unicode": "μυκτηρίζω",
                     "_translit": "myktērízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mook-tay-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3455"
                     }
                  ],
                  "__text": "from a derivative of the base of \n (meaning snout, as that whence\n lowing proceeds);"
               },
               "strongs_def": "to make mouths at, i.e. ridicule",
               "kjv_def": ":--mock.",
               "_strongs": "03456"
            },
            {
               "strongs": "3457",
               "greek": [
                  {
                     "_BETA": "MULIKO/S",
                     "_unicode": "μυλικός",
                     "_translit": "mylikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-lee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3458"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "belonging to a mill",
               "kjv_def": ":--mill(-stone).",
               "_strongs": "03457"
            },
            {
               "strongs": "3458",
               "greek": [
                  {
                     "_BETA": "MU/LOS",
                     "_unicode": "μύλος",
                     "_translit": "mýlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo'-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3433"
                     }
                  ],
                  "__text": "probably ultimately from the base of \n (through the idea of\n hardship);"
               },
               "strongs_def": "a \"mill\", i.e. (by implication), a grinder\n (millstone)",
               "kjv_def": ":--millstone.",
               "_strongs": "03458"
            },
            {
               "strongs": "3459",
               "greek": [
                  {
                     "_BETA": "MU/LWN",
                     "_unicode": "μύλων",
                     "_translit": "mýlōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo'-lone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3458"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a mill-house",
               "kjv_def": ":--mill.",
               "_strongs": "03459"
            },
            {
               "strongs": "3460",
               "greek": [
                  {
                     "_BETA": "*MU/RA",
                     "_unicode": "Μύρα",
                     "_translit": "Mýra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo'-rah"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Myra, a place in Asia Minor",
               "kjv_def": ":--Myra.",
               "_strongs": "03460"
            },
            {
               "strongs": "3461",
               "greek": [
                  {
                     "_BETA": "MURIA/S",
                     "_unicode": "μυριάς",
                     "_translit": "myriás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-ree'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3463"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a ten-thousand; by extension, a \"myriad\" or indefinite\n number",
               "kjv_def": ":--ten thousand.",
               "_strongs": "03461"
            },
            {
               "strongs": "3462",
               "greek": [
                  {
                     "_BETA": "MURI/ZW",
                     "_unicode": "μυρίζω",
                     "_translit": "myrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3464"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to apply (perfumed) unguent to",
               "kjv_def": ":--anoint.",
               "_strongs": "03462"
            },
            {
               "strongs": "3463",
               "greek": [
                  {
                     "_BETA": "MU/RIOI",
                     "_unicode": "μύριοι",
                     "_translit": "mýrioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo'-ree-oi"
                  }
               ],
               "strongs_derivation": "plural of an apparently primary word (properly, meaning very many);",
               "strongs_def": "ten thousand; by extension, innumerably many",
               "kjv_def": ":--ten thousand.",
               "_strongs": "03463"
            },
            {
               "strongs": "3464",
               "greek": [
                  {
                     "_BETA": "MU/RON",
                     "_unicode": "μύρον",
                     "_translit": "mýron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo'-ron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04753"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4666"
                     }
                  ],
                  "__text": "probably of foreign origin (compare \n, \n);"
               },
               "strongs_def": "\"myrrh\", i.e. (by\n implication) perfumed oil",
               "kjv_def": ":--ointment.",
               "_strongs": "03464"
            },
            {
               "strongs": "3465",
               "greek": [
                  {
                     "_BETA": "*MUSI/A",
                     "_unicode": "Μυσία",
                     "_translit": "Mysía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-see'-ah"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Mysia, a region of Asia Minor",
               "kjv_def": ":--Mysia.",
               "_strongs": "03465"
            },
            {
               "strongs": "3466",
               "greek": [
                  {
                     "_BETA": "MUSTH/RION",
                     "_unicode": "μυστήριον",
                     "_translit": "mystḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moos-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MU/W",
                        "_unicode": "μύω",
                        "_translit": "mýō"
                     }
                  ],
                  "__text": "from a derivative of \n (to shut the mouth);"
               },
               "strongs_def": "a secret or \"mystery\"\n (through the idea of silence imposed by initiation into religious\n rites)",
               "kjv_def": ":--mystery.",
               "_strongs": "03466"
            },
            {
               "strongs": "3467",
               "greek": [
                  {
                     "_BETA": "MUWPA/ZW",
                     "_unicode": "μυωπάζω",
                     "_translit": "myōpázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moo-ope-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3466"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "W)/Y",
                        "_unicode": "ὤψ",
                        "_translit": "ṓps"
                     }
                  ],
                  "__text": "from a compound of the base of \n and \n (the face; from \n);"
               },
               "strongs_def": "to\n shut the eyes, i.e. blink (see indistinctly)",
               "kjv_def": ":-- cannot see far off.",
               "_strongs": "03467"
            },
            {
               "strongs": "3468",
               "greek": [
                  {
                     "_BETA": "MW/LWY",
                     "_unicode": "μώλωψ",
                     "_translit": "mṓlōps"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mo'-lopes"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "MW=LOS",
                        "_unicode": "μῶλος",
                        "_translit": "mōlos"
                     }
                  ],
                  "__text": "from \n (\"moil\";"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3433"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "W)/Y",
                        "_unicode": "ὤψ",
                        "_translit": "ṓps"
                     }
                  ],
                  "__text": "probably akin to the base of \n) and probably\n \n (the face; from \n); a mole (\"black eye\") or blow-mark"
               },
               "kjv_def": ":--stripe.",
               "_strongs": "03468"
            },
            {
               "strongs": "3469",
               "greek": [
                  {
                     "_BETA": "MWMA/OMAI",
                     "_unicode": "μωμάομαι",
                     "_translit": "mōmáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mo-mah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3470"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to carp at, i.e. censure (discredit)",
               "kjv_def": ":--blame.",
               "_strongs": "03469"
            },
            {
               "strongs": "3470",
               "greek": [
                  {
                     "_BETA": "MW=MOS",
                     "_unicode": "μῶμος",
                     "_translit": "mōmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mo'-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3201"
                     }
                  ],
                  "__text": "perhaps from \n;"
               },
               "strongs_def": "a flaw or blot, i.e. (figuratively) disgraceful\n person",
               "kjv_def": ":--blemish.",
               "_strongs": "03470"
            },
            {
               "strongs": "3471",
               "greek": [
                  {
                     "_BETA": "MWRAI/NW",
                     "_unicode": "μωραίνω",
                     "_translit": "mōraínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mo-rah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3474"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to become insipid; figuratively, to make (passively, act)\n as a simpleton",
               "kjv_def": ":--become fool, make foolish, lose savour.",
               "_strongs": "03471"
            },
            {
               "strongs": "3472",
               "greek": [
                  {
                     "_BETA": "MWRI/A",
                     "_unicode": "μωρία",
                     "_translit": "mōría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mo-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3474"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "silliness, i.e. absurdity",
               "kjv_def": ":--foolishness.",
               "_strongs": "03472"
            },
            {
               "strongs": "3473",
               "greek": [
                  {
                     "_BETA": "MWROLOGI/A",
                     "_unicode": "μωρολογία",
                     "_translit": "mōrología"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mo-rol-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3474"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "silly talk, i.e.\n buffoonery",
               "kjv_def": ":--foolish talking.",
               "_strongs": "03473"
            },
            {
               "strongs": "3474",
               "greek": [
                  {
                     "_BETA": "MWRO/S",
                     "_unicode": "μωρός",
                     "_translit": "mōrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "mo-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3466"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "dull or stupid (as if shut up), i.e.\n heedless, (morally) blockhead, (apparently) absurd",
               "kjv_def": ":--fool(-ish, X\n -ishness).",
               "_strongs": "03474"
            },
            {
               "strongs": "3475",
               "greek": [
                  {
                     "_BETA": "*MWSEU/S",
                     "_unicode": "Μωσεύς",
                     "_translit": "Mōseús"
                  },
                  {
                     "_BETA": "*MWSH=S",
                     "_unicode": "Μωσῆς",
                     "_translit": "Mōsēs"
                  },
                  {
                     "_BETA": "*MWU+SH=S",
                     "_unicode": "Μωϋσῆς",
                     "_translit": "Mōÿsēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "moce-yoos'"
                  },
                  {
                     "_strongs": "mo-sace'"
                  },
                  {
                     "_strongs": "mo-oo-sace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04872"
                     }
                  ],
                  "__text": "of Hebrew  origin; (\n);"
               },
               "strongs_def": "Moseus, Moses, or Mouses (i.e. Mosheh), the\n Hebrew lawgiver",
               "kjv_def": ":--Moses.",
               "_strongs": "03475",
               "__text": "or \n  \n,\n  or"
            },
            {
               "strongs": "3476",
               "greek": [
                  {
                     "_BETA": "*NAASSW/N",
                     "_unicode": "Ναασσών",
                     "_translit": "Naassṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nah-as-sone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05177"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Naasson (i.e. Nachshon), an\n Israelite",
               "kjv_def": ":--Naasson.",
               "_strongs": "03476"
            },
            {
               "strongs": "3477",
               "greek": [
                  {
                     "_BETA": "*NAGGAI/",
                     "_unicode": "Ναγγαί",
                     "_translit": "Nangaí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nang-gah'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05052"
                     }
                  ],
                  "__text": "probably of Hebrew origin (compare \n);"
               },
               "strongs_def": "Nangæ (i.e. perhaps\n Nogach), an Israelite",
               "kjv_def": ":--Nagge.",
               "_strongs": "03477"
            },
            {
               "strongs": "3478",
               "greek": [
                  {
                     "_BETA": "*NAZARE/Q",
                     "_unicode": "Ναζαρέθ",
                     "_translit": "Nazaréth"
                  },
                  {
                     "_BETA": "*NAZARE/T",
                     "_unicode": "Ναζαρέτ",
                     "_translit": "Nazarét"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nad-zar-eth'"
                  },
                  {
                     "_strongs": "nad-zar-et'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Nazareth or Nazaret,\n a place in Palestine",
               "kjv_def": ":--Nazareth.",
               "_strongs": "03478",
               "__text": "or \n  \n;"
            },
            {
               "strongs": "3479",
               "greek": [
                  {
                     "_BETA": "*NAZARHNO/S",
                     "_unicode": "Ναζαρηνός",
                     "_translit": "Nazarēnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nad-zar-ay-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3478"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Nazarene, i.e. inhabitant of Nazareth",
               "kjv_def": ":--of Nazareth.",
               "_strongs": "03479"
            },
            {
               "strongs": "3480",
               "greek": [
                  {
                     "_BETA": "*NAZWRAI=OS",
                     "_unicode": "Ναζωραῖος",
                     "_translit": "Nazōraîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nad-zo-rah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3478"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Nazoræan, i.e. inhabitant of Nazareth; by extension, a\n Christian",
               "kjv_def": ":--Nazarene, of Nazareth.",
               "_strongs": "03480"
            },
            {
               "strongs": "3481",
               "greek": [
                  {
                     "_BETA": "*NAQA/N",
                     "_unicode": "Ναθάν",
                     "_translit": "Nathán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nath-an'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05416"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Nathan, an Israelite",
               "kjv_def": ":--Nathan.",
               "_strongs": "03481"
            },
            {
               "strongs": "3482",
               "greek": [
                  {
                     "_BETA": "*NAQANAH/L",
                     "_unicode": "Ναθαναήλ",
                     "_translit": "Nathanaḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nath-an-ah-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05417"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Nathanaël (i.e. Nathanel), an Israelite and\n Christian",
               "kjv_def": ":--Nathanael.",
               "_strongs": "03482"
            },
            {
               "strongs": "3483",
               "greek": [
                  {
                     "_BETA": "NAI/",
                     "_unicode": "ναί",
                     "_translit": "naí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nahee"
                  }
               ],
               "strongs_derivation": "a primary particle of strong affirmation;",
               "strongs_def": "yes",
               "kjv_def": ":--even so, surely,\n truth, verily, yea, yes.",
               "_strongs": "03483"
            },
            {
               "strongs": "3484",
               "greek": [
                  {
                     "_BETA": "*NAI/+N",
                     "_unicode": "Ναΐν",
                     "_translit": "Naḯn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nah-in'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04999"
                     }
                  ],
                  "__text": "probably of Hebrew origin (compare \n);"
               },
               "strongs_def": "Nain, a place in\n Palestine",
               "kjv_def": ":--Nain.",
               "_strongs": "03484"
            },
            {
               "strongs": "3485",
               "greek": [
                  {
                     "_BETA": "NAO/S",
                     "_unicode": "ναός",
                     "_translit": "naós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nah-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NAI/W",
                        "_unicode": "ναίω",
                        "_translit": "naíō"
                     }
                  ],
                  "__text": "from a primary \n (to dwell);"
               },
               "strongs_def": "a fane, shrine, temple",
               "kjv_def": ":--shrine,\n temple.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2411"
                  }
               ],
               "_strongs": "03485",
               "__text": "Compare \n."
            },
            {
               "strongs": "3486",
               "greek": [
                  {
                     "_BETA": "*NAOU/M",
                     "_unicode": "Ναούμ",
                     "_translit": "Naoúm"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nah-oom'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05151"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Naum (i.e. Nachum), an Israelite",
               "kjv_def": ":--Naum.",
               "_strongs": "03486"
            },
            {
               "strongs": "3487",
               "greek": [
                  {
                     "_BETA": "NA/RDOS",
                     "_unicode": "νάρδος",
                     "_translit": "nárdos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nar'dos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05373"
                     }
                  ],
                  "__text": "of foreign origin (compare \n);"
               },
               "strongs_def": "\"nard\"",
               "kjv_def": ":--(spike-)nard.",
               "_strongs": "03487"
            },
            {
               "strongs": "3488",
               "greek": [
                  {
                     "_BETA": "*NA/RKISSOS",
                     "_unicode": "Νάρκισσος",
                     "_translit": "Nárkissos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nar'-kis-sos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NA/RKH",
                        "_unicode": "νάρκη",
                        "_translit": "nárkē"
                     }
                  ],
                  "__text": "a flower of the same name, from \n (stupefaction, as a \"narcotic\");"
               },
               "strongs_def": "Narcissus, a Roman",
               "kjv_def": ":--Narcissus.",
               "_strongs": "03488"
            },
            {
               "strongs": "3489",
               "greek": [
                  {
                     "_BETA": "NAUAGE/W",
                     "_unicode": "ναυαγέω",
                     "_translit": "nauagéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "now-ag-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3491"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be shipwrecked (stranded,\n \"navigate\"), literally or figuratively",
               "kjv_def": ":--make (suffer) shipwreck.",
               "_strongs": "03489"
            },
            {
               "strongs": "3490",
               "greek": [
                  {
                     "_BETA": "NAU/KLHROS",
                     "_unicode": "ναύκληρος",
                     "_translit": "naúklēros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "now'-klay-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3491"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2819"
                     }
                  ],
                  "__text": "from \n and \n (\"clerk\");"
               },
               "strongs_def": "a captain",
               "kjv_def": ":--owner of a ship.",
               "_strongs": "03490"
            },
            {
               "strongs": "3491",
               "greek": [
                  {
                     "_BETA": "NAU=S",
                     "_unicode": "ναῦς",
                     "_translit": "naûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nowce"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NA/W",
                        "_unicode": "νάω",
                        "_translit": "náō"
                     },
                     {
                        "_BETA": "NE/W",
                        "_unicode": "νέω",
                        "_translit": "néō"
                     }
                  ],
                  "__text": "from \n or \n (to float);"
               },
               "strongs_def": "a boat (of any size)",
               "kjv_def": ":--ship.",
               "_strongs": "03491"
            },
            {
               "strongs": "3492",
               "greek": [
                  {
                     "_BETA": "NAU/THS",
                     "_unicode": "ναύτης",
                     "_translit": "naútēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "now'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3491"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a boatman, i.e. seaman",
               "kjv_def": ":--sailor, shipman.",
               "_strongs": "03492"
            },
            {
               "strongs": "3493",
               "greek": [
                  {
                     "_BETA": "*NAXW/R",
                     "_unicode": "Ναχώρ",
                     "_translit": "Nachṓr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nakh-ore'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05152"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Nachor, the grandfather of Abraham",
               "kjv_def": ":--Nachor.",
               "_strongs": "03493"
            },
            {
               "strongs": "3494",
               "greek": [
                  {
                     "_BETA": "NEANI/AS",
                     "_unicode": "νεανίας",
                     "_translit": "neanías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-an-ee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a youth (up to about forty years)",
               "kjv_def": ":--young\n man.",
               "_strongs": "03494"
            },
            {
               "strongs": "3495",
               "greek": [
                  {
                     "_BETA": "NEANI/SKOS",
                     "_unicode": "νεανίσκος",
                     "_translit": "neanískos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-an-is'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3494"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a youth (under forty)",
               "kjv_def": ":--young man.",
               "_strongs": "03495"
            },
            {
               "strongs": "3496",
               "greek": [
                  {
                     "_BETA": "*NEA/POLIS",
                     "_unicode": "Νεάπολις",
                     "_translit": "Neápolis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-ap'-ol-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "new town; Neapolis, a place in\n Macedonia",
               "kjv_def": ":--Neapolis.",
               "_strongs": "03496"
            },
            {
               "strongs": "3497",
               "greek": [
                  {
                     "_BETA": "*NEEMA/N",
                     "_unicode": "Νεεμάν",
                     "_translit": "Neemán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-eh-man'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05283"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Neeman (i.e. Naaman), a Syrian",
               "kjv_def": ":--Naaman.",
               "_strongs": "03497"
            },
            {
               "strongs": "3498",
               "greek": [
                  {
                     "_BETA": "NEKRO/S",
                     "_unicode": "νεκρός",
                     "_translit": "nekrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nek-ros'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NE/KUS",
                        "_unicode": "νέκυς",
                        "_translit": "nékys"
                     }
                  ],
                  "__text": "from an apparently primary \n (a corpse);"
               },
               "strongs_def": "dead (literally or\n figuratively; also as noun)",
               "kjv_def": ":--dead.",
               "_strongs": "03498"
            },
            {
               "strongs": "3499",
               "greek": [
                  {
                     "_BETA": "NEKRO/W",
                     "_unicode": "νεκρόω",
                     "_translit": "nekróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nek-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3498"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to deaden, i.e. (figuratively) to subdue",
               "kjv_def": ":--be dead,\n mortify.",
               "_strongs": "03499"
            },
            {
               "strongs": "3500",
               "greek": [
                  {
                     "_BETA": "NE/KRWSIS",
                     "_unicode": "νέκρωσις",
                     "_translit": "nékrōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nek'-ro-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3499"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "decease; figuratively, impotency",
               "kjv_def": ":--deadness, dying.",
               "_strongs": "03500"
            },
            {
               "strongs": "3501",
               "greek": [
                  {
                     "_BETA": "NE/OS",
                     "_unicode": "νέος",
                     "_translit": "néos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NEO/TEROS",
                        "_unicode": "νεότερος",
                        "_translit": "neóteros"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "neh-o'-ter-os"
                     }
                  ],
                  "__text": "including the comparative \n \n; a primary word;"
               },
               "strongs_def": "\"new\", i.e. (of persons) youthful, or (of things) fresh; figuratively,\n regenerate",
               "kjv_def": ":--new, young.",
               "_strongs": "03501"
            },
            {
               "strongs": "3502",
               "greek": [
                  {
                     "_BETA": "NEOSSO/S",
                     "_unicode": "νεοσσός",
                     "_translit": "neossós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-os-sos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a youngling (nestling)",
               "kjv_def": ":--young.",
               "_strongs": "03502"
            },
            {
               "strongs": "3503",
               "greek": [
                  {
                     "_BETA": "NEO/THS",
                     "_unicode": "νεότης",
                     "_translit": "neótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "newness, i.e. youthfulness",
               "kjv_def": ":--youth.",
               "_strongs": "03503"
            },
            {
               "strongs": "3504",
               "greek": [
                  {
                     "_BETA": "NEO/FUTOS",
                     "_unicode": "νεόφυτος",
                     "_translit": "neóphytos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-of'-oo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "newly planted, i.e. (figuratively)\n a young convert (\"neophyte\")",
               "kjv_def": ":--novice.",
               "_strongs": "03504"
            },
            {
               "strongs": "3505",
               "greek": [
                  {
                     "_BETA": "*NE/RWN",
                     "_unicode": "Νέρων",
                     "_translit": "Nérōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ner'-ohn"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Neron (i.e. Nero), a Roman emperor",
               "kjv_def": ":--Nero.",
               "_strongs": "03505"
            },
            {
               "strongs": "3506",
               "greek": [
                  {
                     "_BETA": "NEU/W",
                     "_unicode": "νεύω",
                     "_translit": "neúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nyoo'-o"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to \"nod\", i.e. (by analogy),\n signal",
               "kjv_def": ":--beckon.",
               "_strongs": "03506"
            },
            {
               "strongs": "3507",
               "greek": [
                  {
                     "_BETA": "NEFE/LH",
                     "_unicode": "νεφέλη",
                     "_translit": "nephélē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nef-el'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3509"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, cloudiness, i.e. (concretely) a cloud",
               "kjv_def": ":--cloud.",
               "_strongs": "03507"
            },
            {
               "strongs": "3508",
               "greek": [
                  {
                     "_BETA": "*NEFQALEI/M",
                     "_unicode": "Νεφθαλείμ",
                     "_translit": "Nephthaleím"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nef-thal-ime'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05321"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Nephthaleim (i.e. Naphthali), a tribe in\n Palestine",
               "kjv_def": ":--Nephthalim.",
               "_strongs": "03508"
            },
            {
               "strongs": "3509",
               "greek": [
                  {
                     "_BETA": "NE/FOS",
                     "_unicode": "νέφος",
                     "_translit": "néphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nef'-os"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a cloud",
               "kjv_def": ":--cloud.",
               "_strongs": "03509"
            },
            {
               "strongs": "3510",
               "greek": [
                  {
                     "_BETA": "NEFRO/S",
                     "_unicode": "νεφρός",
                     "_translit": "nephrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nef-ros'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a kidney (plural), i.e. (figuratively) the\n inmost mind",
               "kjv_def": ":--reins.",
               "_strongs": "03510"
            },
            {
               "strongs": "3511",
               "greek": [
                  {
                     "_BETA": "NEWKO/ROS",
                     "_unicode": "νεωκόρος",
                     "_translit": "neōkóros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-o-kor'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3485"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KORE/W",
                        "_unicode": "κορέω",
                        "_translit": "koréō"
                     }
                  ],
                  "__text": "from a form of \n and \n (to sweep);"
               },
               "strongs_def": "a temple-servant, i.e. (by\n implication) a votary",
               "kjv_def": ":--worshipper.",
               "_strongs": "03511"
            },
            {
               "strongs": "3512",
               "greek": [
                  {
                     "_BETA": "NEWTERIKO/S",
                     "_unicode": "νεωτερικός",
                     "_translit": "neōterikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neh-o-ter'-ik-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     }
                  ],
                  "__text": "from the comparative of \n;"
               },
               "strongs_def": "appertaining to younger persons, i.e.\n juvenile",
               "kjv_def": ":--youthful.",
               "_strongs": "03512"
            },
            {
               "strongs": "3513",
               "greek": [
                  {
                     "_BETA": "NH/",
                     "_unicode": "νή",
                     "_translit": "nḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3483"
                     }
                  ],
                  "__text": "probably an intensive form of \n;"
               },
               "strongs_def": "a particle of attestation\n (accompanied by the object invoked or appealed to in confirmation); as\n sure as",
               "kjv_def": ":--I protest by.",
               "_strongs": "03513"
            },
            {
               "strongs": "3514",
               "greek": [
                  {
                     "_BETA": "NH/QW",
                     "_unicode": "νήθω",
                     "_translit": "nḗthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay'-tho"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NE/W",
                        "_unicode": "νέω",
                        "_translit": "néō"
                     }
                  ],
                  "__text": "from \n (of like meaning);"
               },
               "strongs_def": "to spin",
               "kjv_def": ":--spin.",
               "_strongs": "03514"
            },
            {
               "strongs": "3515",
               "greek": [
                  {
                     "_BETA": "NHPIA/ZW",
                     "_unicode": "νηπιάζω",
                     "_translit": "nēpiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay-pee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3516"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to act as a babe, i.e. (figuratively) innocently",
               "kjv_def": ":--be a\n child.",
               "_strongs": "03515"
            },
            {
               "strongs": "3516",
               "greek": [
                  {
                     "_BETA": "NH/PIOS",
                     "_unicode": "νήπιος",
                     "_translit": "nḗpios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay'-pee-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NH/-",
                        "_unicode": "νή‐",
                        "_translit": "nḗ-"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2031"
                     }
                  ],
                  "__text": "from an obsolete particle \n (implying negation) and \n;"
               },
               "strongs_def": "not\n speaking, i.e. an infant (minor); figuratively, a simple-minded\n person, an immature Christian",
               "kjv_def": ":--babe, child (+ -ish).",
               "_strongs": "03516"
            },
            {
               "strongs": "3517",
               "greek": [
                  {
                     "_BETA": "*NHREU/S",
                     "_unicode": "Νηρεύς",
                     "_translit": "Nēreús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nare-yoos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3491"
                     }
                  ],
                  "__text": "apparently from a derivative of the base of \n (meaning wet);"
               },
               "strongs_def": "Nereus, a Christian",
               "kjv_def": ":--Nereus.",
               "_strongs": "03517"
            },
            {
               "strongs": "3518",
               "greek": [
                  {
                     "_BETA": "*NHRI/",
                     "_unicode": "Νηρί",
                     "_translit": "Nērí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay-ree'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05374"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Neri (i.e. Nerijah), an Israelite",
               "kjv_def": ":--Neri.",
               "_strongs": "03518"
            },
            {
               "strongs": "3519",
               "greek": [
                  {
                     "_BETA": "NHSI/ON",
                     "_unicode": "νησίον",
                     "_translit": "nēsíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay-see'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3520"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "an islet",
               "kjv_def": ":--island.",
               "_strongs": "03519"
            },
            {
               "strongs": "3520",
               "greek": [
                  {
                     "_BETA": "NH=SOS",
                     "_unicode": "νῆσος",
                     "_translit": "nēsos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay'-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3491"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "an island",
               "kjv_def": ":--island, isle.",
               "_strongs": "03520"
            },
            {
               "strongs": "3521",
               "greek": [
                  {
                     "_BETA": "NHSTEI/A",
                     "_unicode": "νηστεία",
                     "_translit": "nēsteía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nace-ti'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3522"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "abstinence (from lack of food, or voluntary and religious);\n specially, the fast of the Day of Atonement",
               "kjv_def": ":-- fast(-ing).",
               "_strongs": "03521"
            },
            {
               "strongs": "3522",
               "greek": [
                  {
                     "_BETA": "NHSTEU/W",
                     "_unicode": "νηστεύω",
                     "_translit": "nēsteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nace-tyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3523"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to abstain from food (religiously)",
               "kjv_def": ":--fast.",
               "_strongs": "03522"
            },
            {
               "strongs": "3523",
               "greek": [
                  {
                     "_BETA": "NH=STIS",
                     "_unicode": "νῆστις",
                     "_translit": "nēstis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nace'-tis"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NH/-",
                        "_unicode": "νή‐",
                        "_translit": "nḗ-"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2068"
                     }
                  ],
                  "__text": "from the inseparable negative particle \n (not) and \n;"
               },
               "strongs_def": "not eating,\n i.e. abstinent from food (religiously)",
               "kjv_def": ":--fasting.",
               "_strongs": "03523"
            },
            {
               "strongs": "3524",
               "greek": [
                  {
                     "_BETA": "NHFA/LEOS",
                     "_unicode": "νηφάλεος",
                     "_translit": "nēpháleos"
                  },
                  {
                     "_BETA": "NHFA/LIOS",
                     "_unicode": "νηφάλιος",
                     "_translit": "nēphálios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay-fal'-eh-os"
                  },
                  {
                     "_strongs": "nay-fal'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3525"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sober, i.e. (figuratively) circumspect",
               "kjv_def": ":--sober.",
               "_strongs": "03524",
               "__text": ", or"
            },
            {
               "strongs": "3525",
               "greek": [
                  {
                     "_BETA": "NH/FW",
                     "_unicode": "νήφω",
                     "_translit": "nḗphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nay'-fo"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to abstain from wine (keep sober), i.e.\n (figuratively) be discreet",
               "kjv_def": ":--be sober, watch.",
               "_strongs": "03525"
            },
            {
               "strongs": "3526",
               "greek": [
                  {
                     "_BETA": "*NI/GER",
                     "_unicode": "Νίγερ",
                     "_translit": "Níger"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "neeg'-er"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "black; Niger, a Christian",
               "kjv_def": ":--Niger.",
               "_strongs": "03526"
            },
            {
               "strongs": "3527",
               "greek": [
                  {
                     "_BETA": "*NIKA/NWR",
                     "_unicode": "Νικάνωρ",
                     "_translit": "Nikánōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nik-an'-ore"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3528"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "victorious; Nicanor, a Christian",
               "kjv_def": ":--Nicanor.",
               "_strongs": "03527"
            },
            {
               "strongs": "3528",
               "greek": [
                  {
                     "_BETA": "NIKA/W",
                     "_unicode": "νικάω",
                     "_translit": "nikáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nik-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3529"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to subdue (literally or figuratively)",
               "kjv_def": ":--conquer, overcome,\n prevail, get the victory.",
               "_strongs": "03528"
            },
            {
               "strongs": "3529",
               "greek": [
                  {
                     "_BETA": "NI/KH",
                     "_unicode": "νίκη",
                     "_translit": "níkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nee'-kay"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "conquest (abstractly), i.e. (figuratively)\n the means of success",
               "kjv_def": ":--victory.",
               "_strongs": "03529"
            },
            {
               "strongs": "3530",
               "greek": [
                  {
                     "_BETA": "*NIKO/DHMOS",
                     "_unicode": "Νικόδημος",
                     "_translit": "Nikódēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nik-od'-ay-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3534"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "victorious among his people; Nicodemus, an\n Israelite",
               "kjv_def": ":--Nicodemus.",
               "_strongs": "03530"
            },
            {
               "strongs": "3531",
               "greek": [
                  {
                     "_BETA": "*NIKOLAI/+THS",
                     "_unicode": "Νικολαΐτης",
                     "_translit": "Nikolaḯtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nik-ol-ah-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3532"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Nicolaïte, i.e. adherent of Nicolaüs",
               "kjv_def": ":--Nicolaitane.",
               "_strongs": "03531"
            },
            {
               "strongs": "3532",
               "greek": [
                  {
                     "_BETA": "*NIKO/LAOS",
                     "_unicode": "Νικόλαος",
                     "_translit": "Nikólaos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nik-ol'-ah-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3534"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2992"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "victorious over the people; Nicolaüs, a\n heretic",
               "kjv_def": ":--Nicolaus.",
               "_strongs": "03532"
            },
            {
               "strongs": "3533",
               "greek": [
                  {
                     "_BETA": "*NIKO/POLIS",
                     "_unicode": "Νικόπολις",
                     "_translit": "Nikópolis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nik-op'-ol-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3534"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "victorious city; Nicopolis, a place in\n Macedonia",
               "kjv_def": ":--Nicopolis.",
               "_strongs": "03533"
            },
            {
               "strongs": "3534",
               "greek": [
                  {
                     "_BETA": "NI=KOS",
                     "_unicode": "νῖκος",
                     "_translit": "nîkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nee'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3529"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a conquest (concretely), i.e. (by implication)\n triumph",
               "kjv_def": ":--victory.",
               "_strongs": "03534"
            },
            {
               "strongs": "3535",
               "greek": [
                  {
                     "_BETA": "*NINEUI/+",
                     "_unicode": "Νινευΐ",
                     "_translit": "Nineuḯ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nin-yoo-ee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05210"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Ninevi (i.e. Nineveh), the capital of\n Assyria",
               "kjv_def": ":--Nineve.",
               "_strongs": "03535"
            },
            {
               "strongs": "3536",
               "greek": [
                  {
                     "_BETA": "*NINEUI/+THS",
                     "_unicode": "Νινευΐτης",
                     "_translit": "Nineuḯtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nin-yoo-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3535"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Ninevite, i.e. inhabitant of Nineveh",
               "kjv_def": ":--of Nineve,\n Ninevite.",
               "_strongs": "03536"
            },
            {
               "strongs": "3537",
               "greek": [
                  {
                     "_BETA": "NIPTH/R",
                     "_unicode": "νιπτήρ",
                     "_translit": "niptḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nip-tare'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3538"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a ewer",
               "kjv_def": ":--bason.",
               "_strongs": "03537"
            },
            {
               "strongs": "3538",
               "greek": [
                  {
                     "_BETA": "NI/PTW",
                     "_unicode": "νίπτω",
                     "_translit": "níptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nip'-to"
                  }
               ],
               "strongs_def": "to cleanse (especially the hands or the feet or the face);\n ceremonially, to perform ablution",
               "kjv_def": ":--wash.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3068"
                  }
               ],
               "_strongs": "03538",
               "__text": "Compare \n."
            },
            {
               "strongs": "3539",
               "greek": [
                  {
                     "_BETA": "NOIE/W",
                     "_unicode": "νοιέω",
                     "_translit": "noiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to exercise the mind (observe), i.e. (figuratively) to\n comprehend, heed",
               "kjv_def": ":--consider, perceive, think, understand.",
               "_strongs": "03539"
            },
            {
               "strongs": "3540",
               "greek": [
                  {
                     "_BETA": "NO/HMA",
                     "_unicode": "νόημα",
                     "_translit": "nóēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "no'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a perception, i.e. purpose, or (by implication) the\n intellect, disposition, itself",
               "kjv_def": ":--device, mind, thought.",
               "_strongs": "03540"
            },
            {
               "strongs": "3541",
               "greek": [
                  {
                     "_BETA": "NO/QOS",
                     "_unicode": "νόθος",
                     "_translit": "nóthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noth'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a spurious or illegitimate son",
               "kjv_def": ":--bastard.",
               "_strongs": "03541"
            },
            {
               "strongs": "3542",
               "greek": [
                  {
                     "_BETA": "NOMH/",
                     "_unicode": "νομή",
                     "_translit": "nomḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "feminine from the same as \n;"
               },
               "strongs_def": "pasture, i.e. (the act) feeding\n (figuratively, spreading of a gangrene), or (the food) pasturage",
               "kjv_def": ":--X\n eat, pasture.",
               "_strongs": "03542"
            },
            {
               "strongs": "3543",
               "greek": [
                  {
                     "_BETA": "NOMI/ZW",
                     "_unicode": "νομίζω",
                     "_translit": "nomízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, to do by law (usage), i.e. to accustom\n (passively, be usual); by extension, to deem or regard",
               "kjv_def": ":-- suppose,\n thing, be wont.",
               "_strongs": "03543"
            },
            {
               "strongs": "3544",
               "greek": [
                  {
                     "_BETA": "NOMIKO/S",
                     "_unicode": "νομικός",
                     "_translit": "nomikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "according (or pertaining) to law, i.e. legal\n (ceremonially); as noun, an expert in the (Mosaic) law",
               "kjv_def": ":--about the\n law, lawyer.",
               "_strongs": "03544"
            },
            {
               "strongs": "3545",
               "greek": [
                  {
                     "_BETA": "NOMI/MWS",
                     "_unicode": "νομίμως",
                     "_translit": "nomímōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom-im'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "adverb from a derivative of \n;"
               },
               "strongs_def": "legitimately (specially, agreeably\n to the rules of the lists)",
               "kjv_def": ":--lawfully.",
               "_strongs": "03545"
            },
            {
               "strongs": "3546",
               "greek": [
                  {
                     "_BETA": "NO/MISMA",
                     "_unicode": "νόμισμα",
                     "_translit": "nómisma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom'-is-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3543"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "latin": "numisma",
                  "__text": "what is reckoned as of value (after the Latin \n),\n i.e. current coin"
               },
               "kjv_def": ":--money.",
               "_strongs": "03546"
            },
            {
               "strongs": "3547",
               "greek": [
                  {
                     "_BETA": "NOMODIDA/SKALOS",
                     "_unicode": "νομοδιδάσκαλος",
                     "_translit": "nomodidáskalos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom-od-id-as'-kal-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1320"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an expounder of the (Jewish) law, i.e. a\n Rabbi",
               "kjv_def": ":--doctor (teacher) of the law.",
               "_strongs": "03547"
            },
            {
               "strongs": "3548",
               "greek": [
                  {
                     "_BETA": "NOMOQESI/A",
                     "_unicode": "νομοθεσία",
                     "_translit": "nomothesía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom-oth-es-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3550"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "legislation (specially, the institution of the Mosaic\n code)",
               "kjv_def": ":--giving of the law.",
               "_strongs": "03548"
            },
            {
               "strongs": "3549",
               "greek": [
                  {
                     "_BETA": "NOMOQETE/W",
                     "_unicode": "νομοθετέω",
                     "_translit": "nomothetéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom-oth-et-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3550"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to legislate, i.e. (passively) to have (the Mosaic)\n enactments injoined, be sanctioned (by them)",
               "kjv_def": ":--establish, receive the\n law.",
               "_strongs": "03549"
            },
            {
               "strongs": "3550",
               "greek": [
                  {
                     "_BETA": "NOMOQE/THS",
                     "_unicode": "νομοθέτης",
                     "_translit": "nomothétēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom-oth-et'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "a legislator",
               "kjv_def": ":--lawgiver.",
               "_strongs": "03550"
            },
            {
               "strongs": "3551",
               "greek": [
                  {
                     "_BETA": "NO/MOS",
                     "_unicode": "νόμος",
                     "_translit": "nómos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nom'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NE/MW",
                        "_unicode": "νέμω",
                        "_translit": "némō"
                     }
                  ],
                  "__text": "from a primary \n (to parcel out, especially food or grazing to\n animals);"
               },
               "strongs_def": "law (through the idea of prescriptive usage), genitive case\n (regulation), specially, (of Moses (including the volume); also of the\n Gospel), or figuratively (a principle)",
               "kjv_def": ":--law.",
               "_strongs": "03551"
            },
            {
               "strongs": "3552",
               "greek": [
                  {
                     "_BETA": "NOSE/W",
                     "_unicode": "νοσέω",
                     "_translit": "noséō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nos-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3554"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be sick, i.e. (by implication, of a diseased appetite)\n to hanker after (figuratively, to harp upon)",
               "kjv_def": ":--dote.",
               "_strongs": "03552"
            },
            {
               "strongs": "3553",
               "greek": [
                  {
                     "_BETA": "NO/SHMA",
                     "_unicode": "νόσημα",
                     "_translit": "nósēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nos'-ay-ma"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3552"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an ailment",
               "kjv_def": ":--disease.",
               "_strongs": "03553"
            },
            {
               "strongs": "3554",
               "greek": [
                  {
                     "_BETA": "NO/SOS",
                     "_unicode": "νόσος",
                     "_translit": "nósos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nos'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a malady (rarely figuratively, of moral\n disability)",
               "kjv_def": ":--disease, infirmity, sickness.",
               "_strongs": "03554"
            },
            {
               "strongs": "3555",
               "greek": [
                  {
                     "_BETA": "NOSSIA/",
                     "_unicode": "νοσσιά",
                     "_translit": "nossiá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nos-see-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3502"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a brood (of chickens)",
               "kjv_def": ":--brood.",
               "_strongs": "03555"
            },
            {
               "strongs": "3556",
               "greek": [
                  {
                     "_BETA": "NOSSI/ON",
                     "_unicode": "νοσσίον",
                     "_translit": "nossíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nos-see'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3502"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "a birdling",
               "kjv_def": ":--chicken.",
               "_strongs": "03556"
            },
            {
               "strongs": "3557",
               "greek": [
                  {
                     "_BETA": "NOSFI/ZOMAI",
                     "_unicode": "νοσφίζομαι",
                     "_translit": "nosphízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nos-fid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NOSFI/",
                        "_unicode": "νοσφί",
                        "_translit": "nosphí"
                     }
                  ],
                  "__text": "middle voice from \n (apart or clandestinely);"
               },
               "strongs_def": "to sequestrate for\n oneself, i.e. embezzle",
               "kjv_def": ":--keep back, purloin.",
               "_strongs": "03557"
            },
            {
               "strongs": "3558",
               "greek": [
                  {
                     "_BETA": "NO/TOS",
                     "_unicode": "νότος",
                     "_translit": "nótos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "not'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "the south(-west) wind; by extension, the\n southern quarter itself",
               "kjv_def": ":--south (wind).",
               "_strongs": "03558"
            },
            {
               "strongs": "3559",
               "greek": [
                  {
                     "_BETA": "NOUQESI/A",
                     "_unicode": "νουθεσία",
                     "_translit": "nouthesía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noo-thes-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "calling attention to, i.e. (by\n implication) mild rebuke or warning",
               "kjv_def": ":--admonition.",
               "_strongs": "03559"
            },
            {
               "strongs": "3560",
               "greek": [
                  {
                     "_BETA": "NOUQETE/W",
                     "_unicode": "νουθετέω",
                     "_translit": "nouthetéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noo-thet-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3559"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to put in mind, i.e. (by implication) to\n caution or reprove gently",
               "kjv_def": ":--admonish, warn.",
               "_strongs": "03560"
            },
            {
               "strongs": "3561",
               "greek": [
                  {
                     "_BETA": "NOUMHNI/A",
                     "_unicode": "νουμηνία",
                     "_translit": "noumēnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noo-may-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3501"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3376"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "feminine of a compound of \n and \n (as noun by implication, of\n \n);"
               },
               "strongs_def": "the festival of new moon",
               "kjv_def": ":--new moon.",
               "_strongs": "03561"
            },
            {
               "strongs": "3562",
               "greek": [
                  {
                     "_BETA": "NOUNEXW=S",
                     "_unicode": "νουνεχῶς",
                     "_translit": "nounechōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noon-ekh-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "adverb from a compound of the accusative case of \n and \n;"
               },
               "strongs_def": "in\n a mind-having way, i.e. prudently",
               "kjv_def": ":--discreetly.",
               "_strongs": "03562"
            },
            {
               "strongs": "3563",
               "greek": [
                  {
                     "_BETA": "NOU=S",
                     "_unicode": "νοῦς",
                     "_translit": "noûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nooce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "the intellect, i.e. mind (divine or\n human; in thought, feeling, or will); by implication, meaning",
               "kjv_def": ":--mind,\n understanding.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5590"
                  }
               ],
               "_strongs": "03563",
               "__text": "Compare \n."
            },
            {
               "strongs": "3564",
               "greek": [
                  {
                     "_BETA": "*NUMFA=S",
                     "_unicode": "Νυμφᾶς",
                     "_translit": "Nymphâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noom-fas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3565"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1435"
                     }
                  ],
                  "__text": "probably contracted for a compound of \n and \n;"
               },
               "strongs_def": "nymph-given (i.e.\n -born); Nymphas, a Christian",
               "kjv_def": ":--Nymphas.",
               "_strongs": "03564"
            },
            {
               "strongs": "3565",
               "greek": [
                  {
                     "_BETA": "NU/MFH",
                     "_unicode": "νύμφη",
                     "_translit": "nýmphē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noom-fay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "NU/PTW",
                        "_unicode": "νύπτω",
                        "_translit": "nýptō"
                     }
                  ],
                  "latin": "nupto",
                  "__text": "from a primary but obsolete verb \n (to veil as a bride; compare\n Latin \"\n,\" to marry);"
               },
               "strongs_def": "a young married woman (as veiled), including\n a betrothed girl; by implication, a son's wife",
               "kjv_def": ":--bride, daughter in\n law.",
               "_strongs": "03565"
            },
            {
               "strongs": "3566",
               "greek": [
                  {
                     "_BETA": "NUMFI/OS",
                     "_unicode": "νυμφίος",
                     "_translit": "nymphíos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noom-fee'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3565"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a bride-groom (literally or figuratively)",
               "kjv_def": ":--bridegroom.",
               "_strongs": "03566"
            },
            {
               "strongs": "3567",
               "greek": [
                  {
                     "_BETA": "NUMFW/N",
                     "_unicode": "νυμφών",
                     "_translit": "nymphṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noom-fohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3565"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the bridal room",
               "kjv_def": ":--bridechamber.",
               "_strongs": "03567"
            },
            {
               "strongs": "3568",
               "greek": [
                  {
                     "_BETA": "NU=N",
                     "_unicode": "νῦν",
                     "_translit": "nŷn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noon"
                  }
               ],
               "strongs_derivation": "a primary particle of present time;",
               "strongs_def": "\"now\" (as adverb of date, a\n transition or emphasis); also as noun or adjective present or\n immediate",
               "kjv_def": ":--henceforth, + hereafter, of late, soon, present, this\n (time).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3569"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3570"
                  }
               ],
               "_strongs": "03568",
               "__text": "See also \n, \n."
            },
            {
               "strongs": "3569",
               "greek": [
                  {
                     "_BETA": "TANU=N",
                     "_unicode": "τανῦν",
                     "_translit": "tanŷn"
                  },
                  {
                     "_BETA": "TA\\ NU=N",
                     "_unicode": "τὰ νῦν",
                     "_translit": "tà nŷn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tan-oon'"
                  },
                  {
                     "_strongs": "tah noon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3568"
                     }
                  ],
                  "__text": "from neuter plural of \n and \n;"
               },
               "strongs_def": "the things now, i.e.\n (adverbially) at present",
               "kjv_def": ":--(but) now.",
               "_strongs": "03569",
               "__text": "or"
            },
            {
               "strongs": "3570",
               "greek": [
                  {
                     "_BETA": "NUNI/",
                     "_unicode": "νυνί",
                     "_translit": "nyní"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noo-nee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3568"
                     }
                  ],
                  "__text": "a prolonged form of \n for emphasis;"
               },
               "strongs_def": "just now",
               "kjv_def": ":--now.",
               "_strongs": "03570"
            },
            {
               "strongs": "3571",
               "greek": [
                  {
                     "_BETA": "NU/C",
                     "_unicode": "νύξ",
                     "_translit": "nýx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noox"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "\"night\" (literally or figuratively)",
               "kjv_def": ":-- (mid-)night.",
               "_strongs": "03571"
            },
            {
               "strongs": "3572",
               "greek": [
                  {
                     "_BETA": "NU/SSW",
                     "_unicode": "νύσσω",
                     "_translit": "nýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noos'-so"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "to prick (\"nudge\")",
               "kjv_def": ":--pierce.",
               "_strongs": "03572"
            },
            {
               "strongs": "3573",
               "greek": [
                  {
                     "_BETA": "NUSTA/ZW",
                     "_unicode": "νυστάζω",
                     "_translit": "nystázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "noos-tad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3506"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "to nod, i.e. (by implication) to\n fall asleep; figuratively, to delay",
               "kjv_def": ":--slumber.",
               "_strongs": "03573"
            },
            {
               "strongs": "3574",
               "greek": [
                  {
                     "_BETA": "NUXQH/MERON",
                     "_unicode": "νυχθήμερον",
                     "_translit": "nychthḗmeron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "nookh-thay'-mer-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a day-and-night, i.e. full day of twenty-four\n hours",
               "kjv_def": ":--night and day.",
               "_strongs": "03574"
            },
            {
               "strongs": "3575",
               "greek": [
                  {
                     "_BETA": "*NW=E",
                     "_unicode": "Νῶε",
                     "_translit": "Nōe"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "no'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05146"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Noë, (i.e. Noäch), a patriarch",
               "kjv_def": ":--Noe.",
               "_strongs": "03575"
            },
            {
               "strongs": "3576",
               "greek": [
                  {
                     "_BETA": "NWQRO/S",
                     "_unicode": "νωθρός",
                     "_translit": "nōthrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "no-thros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3541"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "sluggish, i.e. (literally) lazy, or\n (figuratively) stupid",
               "kjv_def": ":--dull, slothful.",
               "_strongs": "03576"
            },
            {
               "strongs": "3577",
               "greek": [
                  {
                     "_BETA": "NW=TOS",
                     "_unicode": "νῶτος",
                     "_translit": "nōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "no'-tos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "the back",
               "kjv_def": ":--back.",
               "_strongs": "03577"
            },
            {
               "strongs": "3578",
               "greek": [
                  {
                     "_BETA": "CENI/A",
                     "_unicode": "ξενία",
                     "_translit": "xenía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xen-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3581"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "hospitality, i.e. (by implication) a place of\n entertainment",
               "kjv_def": ":--lodging.",
               "_strongs": "03578"
            },
            {
               "strongs": "3579",
               "greek": [
                  {
                     "_BETA": "CENI/ZW",
                     "_unicode": "ξενίζω",
                     "_translit": "xenízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xen-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3581"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a host (passively, a guest); by implication, be\n (make, appear) strange",
               "kjv_def": ":--entertain, lodge, (think it) strange.",
               "_strongs": "03579"
            },
            {
               "strongs": "3580",
               "greek": [
                  {
                     "_BETA": "CENODOXE/W",
                     "_unicode": "ξενοδοχέω",
                     "_translit": "xenodochéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xen-od-okh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3581"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be hospitable",
               "kjv_def": ":--lodge strangers.",
               "_strongs": "03580"
            },
            {
               "strongs": "3581",
               "greek": [
                  {
                     "_BETA": "CE/NOS",
                     "_unicode": "ξένος",
                     "_translit": "xénos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xen'-os"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "foreign (literally, alien, or figuratively,\n novel); by implication, a guest or (vice-versa) entertainer",
               "kjv_def": ":--host,\n strange(-r).",
               "_strongs": "03581"
            },
            {
               "strongs": "3582",
               "greek": [
                  {
                     "_BETA": "CE/STHS",
                     "_unicode": "ξέστης",
                     "_translit": "xéstēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xes'-tace"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "CE/W",
                        "_unicode": "ξέω",
                        "_translit": "xéō"
                     }
                  ],
                  "__text": "as if from \n (properly, to smooth;"
               },
               "strongs_def": {
                  "latin": "sextarius",
                  "__text": "by implication, (of friction) to\n boil or heat); a vessel (as fashioned or for cooking) (or perhaps by\n corruption from the Latin \n, the sixth of a modius, i.e. about\n a pint), i.e. (specially), a measure for liquids or solids, (by\n analogy, a pitcher)"
               },
               "kjv_def": ":--pot.",
               "_strongs": "03582"
            },
            {
               "strongs": "3583",
               "greek": [
                  {
                     "_BETA": "CHRAI/NW",
                     "_unicode": "ξηραίνω",
                     "_translit": "xēraínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xay-rah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3584"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to desiccate; by implication, to shrivel, to mature",
               "kjv_def": ":--dry\n up, pine away, be ripe, wither (away).",
               "_strongs": "03583"
            },
            {
               "strongs": "3584",
               "greek": [
                  {
                     "_BETA": "CHRO/S",
                     "_unicode": "ξηρός",
                     "_translit": "xērós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xay-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3582"
                     }
                  ],
                  "__text": "from the base of \n (through the idea of scorching);"
               },
               "strongs_def": "arid; by\n implication, shrunken, earth (as opposed to water)",
               "kjv_def": ":--dry land,\n withered.",
               "_strongs": "03584"
            },
            {
               "strongs": "3585",
               "greek": [
                  {
                     "_BETA": "CU/LINOS",
                     "_unicode": "ξύλινος",
                     "_translit": "xýlinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xoo'-lin-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3586"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "wooden",
               "kjv_def": ":--of wood.",
               "_strongs": "03585"
            },
            {
               "strongs": "3586",
               "greek": [
                  {
                     "_BETA": "CU/LON",
                     "_unicode": "ξύλον",
                     "_translit": "xýlon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xoo'-lon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3582"
                     }
                  ],
                  "__text": "from another form of the base of \n;"
               },
               "strongs_def": "timber (as fuel or material);\n by implication, a stick, club or tree or other wooden article or\n substance",
               "kjv_def": ":--staff, stocks, tree, wood.",
               "_strongs": "03586"
            },
            {
               "strongs": "3587",
               "greek": [
                  {
                     "_BETA": "CURA/W",
                     "_unicode": "ξυράω",
                     "_translit": "xyráō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "xoo-rah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3586"
                     }
                  ],
                  "__text": "from a derivative of the same as \n (meaning a razor);"
               },
               "strongs_def": "to shave or\n \"shear\" the hair",
               "kjv_def": ":--shave.",
               "_strongs": "03587"
            },
            {
               "strongs": "3588",
               "greek": [
                  {
                     "_BETA": "O(",
                     "_unicode": "ὁ",
                     "_translit": "ho"
                  },
                  {
                     "_BETA": "H(",
                     "_unicode": "ἡ",
                     "_translit": "hē"
                  },
                  {
                     "_BETA": "TO/",
                     "_unicode": "τό",
                     "_translit": "tó"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho"
                  },
                  {
                     "_strongs": "hay"
                  },
                  {
                     "_strongs": "to"
                  }
               ],
               "strongs_derivation": "the definite article;",
               "strongs_def": "the (sometimes to be\n supplied, at others omitted, in English idiom)",
               "kjv_def": ":--the, this, that, one,\n he, she, it, etc.",
               "_strongs": "03588",
               "__text": ", including the feminine\n      \n  \n, and the neuter\n      \n  \n\n\n in all their inflections;"
            },
            {
               "strongs": "3589",
               "greek": [
                  {
                     "_BETA": "O)GDOH/KONTA",
                     "_unicode": "ὀγδοήκοντα",
                     "_translit": "ogdoḗkonta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "og-do-ay'-kon-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3590"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "ten times eight",
               "kjv_def": ":--fourscore.",
               "_strongs": "03589"
            },
            {
               "strongs": "3590",
               "greek": [
                  {
                     "_BETA": "O)/GDOOS",
                     "_unicode": "ὄγδοος",
                     "_translit": "ógdoos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "og'-do-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3638"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the eighth",
               "kjv_def": ":--eighth.",
               "_strongs": "03590"
            },
            {
               "strongs": "3591",
               "greek": [
                  {
                     "_BETA": "O)/GKOS",
                     "_unicode": "ὄγκος",
                     "_translit": "ónkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ong'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "43"
                     }
                  ],
                  "__text": "probably from the same as \n;"
               },
               "strongs_def": "a mass (as bending or bulging by its\n load), i.e. burden (hindrance)",
               "kjv_def": ":--weight.",
               "_strongs": "03591"
            },
            {
               "strongs": "3592",
               "greek": [
                  {
                     "_BETA": "O(/DE",
                     "_unicode": "ὅδε",
                     "_translit": "hóde"
                  },
                  {
                     "_BETA": "H(/DE",
                     "_unicode": "ἥδε",
                     "_translit": "hḗde"
                  },
                  {
                     "_BETA": "TO/DE",
                     "_unicode": "τόδε",
                     "_translit": "tóde"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hod'-eh"
                  },
                  {
                     "_strongs": "hay'-deh"
                  },
                  {
                     "_strongs": "tod'-e"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1161"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the same, i.e. this or that one (plural these or\n those); often used as a personal pronoun",
               "kjv_def": ":--he, she, such, these, thus.",
               "_strongs": "03592",
               "__text": ", including the feminine\n      \n  \n, and the neuter"
            },
            {
               "strongs": "3593",
               "greek": [
                  {
                     "_BETA": "O(DEU/W",
                     "_unicode": "ὁδεύω",
                     "_translit": "hodeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hod-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to travel",
               "kjv_def": ":--journey.",
               "_strongs": "03593"
            },
            {
               "strongs": "3594",
               "greek": [
                  {
                     "_BETA": "O(DHGE/W",
                     "_unicode": "ὁδηγέω",
                     "_translit": "hodēgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hod-ayg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3595"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to show the way (literally or figuratively\n (teach))",
               "kjv_def": ":--guide, lead.",
               "_strongs": "03594"
            },
            {
               "strongs": "3595",
               "greek": [
                  {
                     "_BETA": "O(DHGO/S",
                     "_unicode": "ὁδηγός",
                     "_translit": "hodēgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hod-ayg-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2233"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a conductor (literally or figuratively\n (teacher))",
               "kjv_def": ":--guide, leader.",
               "_strongs": "03595"
            },
            {
               "strongs": "3596",
               "greek": [
                  {
                     "_BETA": "O(DOIPORE/W",
                     "_unicode": "ὁδοιπορέω",
                     "_translit": "hodoiporéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hod-oy-por-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be a wayfarer, i.e. travel",
               "kjv_def": ":--go\n on a journey.",
               "_strongs": "03596"
            },
            {
               "strongs": "3597",
               "greek": [
                  {
                     "_BETA": "O(DOIPORI/A",
                     "_unicode": "ὁδοιπορία",
                     "_translit": "hodoiporía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hod-oy-por-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3596"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "travel",
               "kjv_def": ":--journey(-ing).",
               "_strongs": "03597"
            },
            {
               "strongs": "3598",
               "greek": [
                  {
                     "_BETA": "O(DO/S",
                     "_unicode": "ὁδός",
                     "_translit": "hodós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hod-os'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a road; by implication, a progress (the\n route, act or distance); figuratively, a mode or means",
               "kjv_def": ":--journey,\n (high-)way.",
               "_strongs": "03598"
            },
            {
               "strongs": "3599",
               "greek": [
                  {
                     "_BETA": "O)DOU/S",
                     "_unicode": "ὀδούς",
                     "_translit": "odoús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "od-ooce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2068"
                     }
                  ],
                  "__text": "perhaps from the base of \n;"
               },
               "strongs_def": "a \"tooth\"",
               "kjv_def": ":--tooth.",
               "_strongs": "03599"
            },
            {
               "strongs": "3600",
               "greek": [
                  {
                     "_BETA": "O)DUNA/W",
                     "_unicode": "ὀδυνάω",
                     "_translit": "odynáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "od-oo-nah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3601"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to grieve",
               "kjv_def": ":--sorrow, torment.",
               "_strongs": "03600"
            },
            {
               "strongs": "3601",
               "greek": [
                  {
                     "_BETA": "O)DU/NH",
                     "_unicode": "ὀδύνη",
                     "_translit": "odýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "od-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1416"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "grief (as dejecting)",
               "kjv_def": ":--sorrow.",
               "_strongs": "03601"
            },
            {
               "strongs": "3602",
               "greek": [
                  {
                     "_BETA": "O)DURMO/S",
                     "_unicode": "ὀδυρμός",
                     "_translit": "odyrmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "od-oor-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1416"
                     }
                  ],
                  "__text": "from a derivative of the base of \n;"
               },
               "strongs_def": "moaning, i.e.\n lamentation",
               "kjv_def": ":--mourning.",
               "_strongs": "03602"
            },
            {
               "strongs": "3603",
               "greek": [
                  {
                     "_BETA": "O(/ E)STI",
                     "_unicode": "ὅ ἐστι",
                     "_translit": "hó esti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho es-tee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "from the neuter of \n and the third person singular present\n indicative of \n;"
               },
               "strongs_def": "which is",
               "kjv_def": ":--called, which is (make), that is (to\n say).",
               "_strongs": "03603"
            },
            {
               "strongs": "3604",
               "greek": [
                  {
                     "_BETA": "*)OZI/AS",
                     "_unicode": "Ὀζίας",
                     "_translit": "Ozías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "od-zee'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05818"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Ozias (i.e. Uzzijah), an Israelite",
               "kjv_def": ":--Ozias.",
               "_strongs": "03604"
            },
            {
               "strongs": "3605",
               "greek": [
                  {
                     "_BETA": "O)/ZW",
                     "_unicode": "ὄζω",
                     "_translit": "ózō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "od'-zo"
                  }
               ],
               "strongs_derivation": "a primary verb (in a strengthened form);",
               "strongs_def": "to scent (usually an ill\n \"odor\")",
               "kjv_def": ":--stink.",
               "_strongs": "03605"
            },
            {
               "strongs": "3606",
               "greek": [
                  {
                     "_BETA": "O(/QEN",
                     "_unicode": "ὅθεν",
                     "_translit": "hóthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "from \n with the directive enclitic of source;"
               },
               "strongs_def": "from which place or\n source or cause (adverb or conjunction)",
               "kjv_def": ":--from thence, (from) whence,\n where(-by, -fore, -upon).",
               "_strongs": "03606"
            },
            {
               "strongs": "3607",
               "greek": [
                  {
                     "_BETA": "O)QO/NH",
                     "_unicode": "ὀθόνη",
                     "_translit": "othónē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oth-on'-ay"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a linen cloth, i.e. (especially) a\n sail",
               "kjv_def": ":--sheet.",
               "_strongs": "03607"
            },
            {
               "strongs": "3608",
               "greek": [
                  {
                     "_BETA": "O)QO/NION",
                     "_unicode": "ὀθόνιον",
                     "_translit": "othónion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oth-on'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3607"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a linen bandage",
               "kjv_def": ":--linen\n clothes.",
               "_strongs": "03608"
            },
            {
               "strongs": "3609",
               "greek": [
                  {
                     "_BETA": "OI)KEI=OS",
                     "_unicode": "οἰκεῖος",
                     "_translit": "oikeîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-ki'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "domestic, i.e. (as noun), a relative, adherent",
               "kjv_def": ":--(those) of\n the (his own) house(-hold).",
               "_strongs": "03609"
            },
            {
               "strongs": "3610",
               "greek": [
                  {
                     "_BETA": "OI)KE/THS",
                     "_unicode": "οἰκέτης",
                     "_translit": "oikétēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-ket'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a fellow resident, i.e. menial domestic",
               "kjv_def": ":--(household)\n servant.",
               "_strongs": "03610"
            },
            {
               "strongs": "3611",
               "greek": [
                  {
                     "_BETA": "OI)KE/W",
                     "_unicode": "οἰκέω",
                     "_translit": "oikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to occupy a house, i.e. reside (figuratively, inhabit,\n remain, inhere); by implication, to cohabit",
               "kjv_def": ":--dwell.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3625"
                  }
               ],
               "_strongs": "03611",
               "__text": "See also \n."
            },
            {
               "strongs": "3612",
               "greek": [
                  {
                     "_BETA": "OI)/KHMA",
                     "_unicode": "οἴκημα",
                     "_translit": "oíkēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy'-kay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a tenement, i.e. (specially), a jail",
               "kjv_def": ":--prison.",
               "_strongs": "03612"
            },
            {
               "strongs": "3613",
               "greek": [
                  {
                     "_BETA": "OI)KHTH/RION",
                     "_unicode": "οἰκητήριον",
                     "_translit": "oikētḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kay-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3612"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n (equivalent to \n);"
               },
               "strongs_def": "a\n residence (literally or figuratively)",
               "kjv_def": ":--habitation, house.",
               "_strongs": "03613"
            },
            {
               "strongs": "3614",
               "greek": [
                  {
                     "_BETA": "OI)KI/A",
                     "_unicode": "οἰκία",
                     "_translit": "oikía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, residence (abstractly), but usually (concretely)\n an abode (literally or figuratively); by implication, a family\n (especially domestics)",
               "kjv_def": ":--home, house(-hold).",
               "_strongs": "03614"
            },
            {
               "strongs": "3615",
               "greek": [
                  {
                     "_BETA": "OI)KIAKO/S",
                     "_unicode": "οἰκιακός",
                     "_translit": "oikiakós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kee-ak-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3614"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "familiar, i.e. (as noun) relatives",
               "kjv_def": ":--they (them) of (his\n own) household.",
               "_strongs": "03615"
            },
            {
               "strongs": "3616",
               "greek": [
                  {
                     "_BETA": "OI)KODESPOTE/W",
                     "_unicode": "οἰκοδεσποτέω",
                     "_translit": "oikodespotéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kod-es-pot-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3617"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be the head of (i.e. rule) a family",
               "kjv_def": ":--guide the house.",
               "_strongs": "03616"
            },
            {
               "strongs": "3617",
               "greek": [
                  {
                     "_BETA": "OI)KODESPO/THS",
                     "_unicode": "οἰκοδεσπότης",
                     "_translit": "oikodespótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kod-es-pot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1203"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the head of a family",
               "kjv_def": ":--goodman (of the house),\n householder, master of the house.",
               "_strongs": "03617"
            },
            {
               "strongs": "3618",
               "greek": [
                  {
                     "_BETA": "OI)KODOME/W",
                     "_unicode": "οἰκοδομέω",
                     "_translit": "oikodoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kod-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3619"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to be a house-builder, i.e. construct or\n (figuratively) confirm",
               "kjv_def": ":--(be in) build(-er, -ing, up), edify,\n embolden.",
               "_strongs": "03618"
            },
            {
               "strongs": "3619",
               "greek": [
                  {
                     "_BETA": "OI)KODOMH/",
                     "_unicode": "οἰκοδομή",
                     "_translit": "oikodomḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kod-om-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1430"
                     }
                  ],
                  "__text": "feminine (abstract) of a compound of \n and the base of \n;"
               },
               "strongs_def": "architecture, i.e. (concretely) a structure; figuratively,\n confirmation",
               "kjv_def": ":--building, edify(-ication, -ing).",
               "_strongs": "03619"
            },
            {
               "strongs": "3620",
               "greek": [
                  {
                     "_BETA": "OI)KODOMI/A",
                     "_unicode": "οἰκοδομία",
                     "_translit": "oikodomía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kod-om-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3619"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "confirmation",
               "kjv_def": ":--edifying.",
               "_strongs": "03620"
            },
            {
               "strongs": "3621",
               "greek": [
                  {
                     "_BETA": "OI)KONOME/W",
                     "_unicode": "οἰκονομέω",
                     "_translit": "oikonoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kon-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3623"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to manage (a house, i.e. an estate)",
               "kjv_def": ":--be steward.",
               "_strongs": "03621"
            },
            {
               "strongs": "3622",
               "greek": [
                  {
                     "_BETA": "OI)KONOMI/A",
                     "_unicode": "οἰκονομία",
                     "_translit": "oikonomía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kon-om-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3623"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "administration (of a household or estate); specially, a\n (religious) \"economy\"",
               "kjv_def": ":--dispensation, stewardship.",
               "_strongs": "03622"
            },
            {
               "strongs": "3623",
               "greek": [
                  {
                     "_BETA": "OI)KONO/MOS",
                     "_unicode": "οἰκονόμος",
                     "_translit": "oikonómos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kon-om'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "a house-distributor (i.e. manager), or\n overseer, i.e. an employee in that capacity; by extension, a fiscal\n agent (treasurer); figuratively, a preacher (of the\n Gospel)",
               "kjv_def": ":--chamberlain, governor, steward.",
               "_strongs": "03623"
            },
            {
               "strongs": "3624",
               "greek": [
                  {
                     "_BETA": "OI)=KOS",
                     "_unicode": "οἶκος",
                     "_translit": "oîkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy'-kos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a dwelling (more or less extensive, literal or\n figurative); by implication, a family (more or less related, literally\n or figuratively)",
               "kjv_def": ":--home, house(-hold), temple.",
               "_strongs": "03624"
            },
            {
               "strongs": "3625",
               "greek": [
                  {
                     "_BETA": "OI)KOUME/NH",
                     "_unicode": "οἰκουμένη",
                     "_translit": "oikouménē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-kou-men'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1093"
                     }
                  ],
                  "__text": "feminine participle present passive of \n (as noun, by implication,\n of \n);"
               },
               "strongs_def": "land, i.e. the (terrene part of the) globe; specially, the\n Roman empire",
               "kjv_def": ":--earth, world.",
               "_strongs": "03625"
            },
            {
               "strongs": "3626",
               "greek": [
                  {
                     "_BETA": "OI)KOURO/S",
                     "_unicode": "οἰκουρός",
                     "_translit": "oikourós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-koo-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "OU)=ROS",
                        "_unicode": "οὖρος",
                        "_translit": "oûros"
                     }
                  ],
                  "__text": "from \n and \n (a guard; be \"ware\");"
               },
               "strongs_def": "a stayer at home, i.e.\n domestically inclined (a \"good housekeeper\")",
               "kjv_def": ":--keeper at home.",
               "_strongs": "03626"
            },
            {
               "strongs": "3627",
               "greek": [
                  {
                     "_BETA": "OI)KTEI/RW",
                     "_unicode": "οἰκτείρω",
                     "_translit": "oikteírō"
                  },
                  {
                     "_BETA": "OI)KTERE/W",
                     "_unicode": "οἰκτερέω",
                     "_translit": "oikteréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oyk-ti'-ro"
                  },
                  {
                     "_strongs": "oyk-ter-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "OI)=KTOS",
                        "_unicode": "οἶκτος",
                        "_translit": "oîktos"
                     }
                  ],
                  "__text": "from \n (pity);"
               },
               "strongs_def": "to exercise pity",
               "kjv_def": ":--have compassion on.",
               "_strongs": "03627",
               "__text": "also (in certain tenses) prolonged"
            },
            {
               "strongs": "3628",
               "greek": [
                  {
                     "_BETA": "OI)KTIRMO/S",
                     "_unicode": "οἰκτιρμός",
                     "_translit": "oiktirmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oyk-tir-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3627"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pity",
               "kjv_def": ":--mercy.",
               "_strongs": "03628"
            },
            {
               "strongs": "3629",
               "greek": [
                  {
                     "_BETA": "OI)KTI/RMWN",
                     "_unicode": "οἰκτίρμων",
                     "_translit": "oiktírmōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oyk-tir'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3627"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "compassionate",
               "kjv_def": ":--merciful, of tender mercy.",
               "_strongs": "03629"
            },
            {
               "strongs": "3630",
               "greek": [
                  {
                     "_BETA": "OI)NOPO/THS",
                     "_unicode": "οἰνοπότης",
                     "_translit": "oinopótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-nop-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3631"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from \n and a derivative of the alternate of \n;"
               },
               "strongs_def": "a\n tippler",
               "kjv_def": ":--winebibber.",
               "_strongs": "03630"
            },
            {
               "strongs": "3631",
               "greek": [
                  {
                     "_BETA": "OI)=NOS",
                     "_unicode": "οἶνος",
                     "_translit": "oînos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03196"
                     }
                  ],
                  "__text": "a primary word (or perhaps of Hebrew origin (\n));"
               },
               "strongs_def": "\"wine\" (literally\n or figuratively)",
               "kjv_def": ":--wine.",
               "_strongs": "03631"
            },
            {
               "strongs": "3632",
               "greek": [
                  {
                     "_BETA": "OI)NOFLUGI/A",
                     "_unicode": "οἰνοφλυγία",
                     "_translit": "oinophlygía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy-nof-loog-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3631"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5397"
                     }
                  ],
                  "__text": "from \n and a form of the base of \n;"
               },
               "strongs_def": "an overflow (or surplus) of\n wine, i.e. vinolency (drunkenness)",
               "kjv_def": ":--excess of wine.",
               "_strongs": "03632"
            },
            {
               "strongs": "3633",
               "greek": [
                  {
                     "_BETA": "OI)/OMAI",
                     "_unicode": "οἴομαι",
                     "_translit": "oíomai"
                  },
                  {
                     "_BETA": "OI)=MAI",
                     "_unicode": "οἶμαι",
                     "_translit": "oîmai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oy'-om-ahee"
                  },
                  {
                     "_strongs": "oy'-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3634"
                     }
                  ],
                  "__text": "middle voice apparently from \n;"
               },
               "strongs_def": "to make like (oneself), i.e.\n imagine (be of the opinion)",
               "kjv_def": ":--suppose, think.",
               "_strongs": "03633",
               "__text": ", or (shorter)"
            },
            {
               "strongs": "3634",
               "greek": [
                  {
                     "_BETA": "OI(=OS",
                     "_unicode": "οἷος",
                     "_translit": "hoîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoy'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3745"
                     }
                  ],
                  "__text": "probably akin to \n, \n, and \n;"
               },
               "strongs_def": "such or what sort of (as a\n correlation or exclamation); especially the neuter (adverbially) with\n negative, not so",
               "kjv_def": ":--so (as), such as, what (manner of), which.",
               "_strongs": "03634"
            },
            {
               "strongs": "3635",
               "greek": [
                  {
                     "_BETA": "O)KNE/W",
                     "_unicode": "ὀκνέω",
                     "_translit": "oknéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ok-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/KNOS",
                        "_unicode": "ὄκνος",
                        "_translit": "óknos"
                     }
                  ],
                  "__text": "from \n (hesitation);"
               },
               "strongs_def": "to be slow (figuratively, loath)",
               "kjv_def": ":--delay.",
               "_strongs": "03635"
            },
            {
               "strongs": "3636",
               "greek": [
                  {
                     "_BETA": "O)KNHRO/S",
                     "_unicode": "ὀκνηρός",
                     "_translit": "oknērós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ok-nay-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3635"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "tardy, i.e. indolent; (figuratively) irksome",
               "kjv_def": ":--grievous,\n slothful.",
               "_strongs": "03636"
            },
            {
               "strongs": "3637",
               "greek": [
                  {
                     "_BETA": "O)KTAH/MEROS",
                     "_unicode": "ὀκταήμερος",
                     "_translit": "oktaḗmeros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ok-tah-ay'-mer-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3638"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an eight-day old person or act",
               "kjv_def": ":--the eighth day.",
               "_strongs": "03637"
            },
            {
               "strongs": "3638",
               "greek": [
                  {
                     "_BETA": "O)KTW/",
                     "_unicode": "ὀκτώ",
                     "_translit": "oktṓ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ok-to'"
                  }
               ],
               "strongs_derivation": "a primary numeral;",
               "strongs_def": "\"eight\"",
               "kjv_def": ":--eight.",
               "_strongs": "03638"
            },
            {
               "strongs": "3639",
               "greek": [
                  {
                     "_BETA": "O)/LEQROS",
                     "_unicode": "ὄλεθρος",
                     "_translit": "ólethros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol'-eth-ros"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/LLUMI",
                        "_unicode": "ὄλλυμι",
                        "_translit": "óllymi"
                     }
                  ],
                  "__text": "from a primary \n (to destroy; a prolonged form);"
               },
               "strongs_def": "ruin, i.e.\n death, punishment",
               "kjv_def": ":--destruction.",
               "_strongs": "03639"
            },
            {
               "strongs": "3640",
               "greek": [
                  {
                     "_BETA": "O)LIGO/PISTOS",
                     "_unicode": "ὀλιγόπιστος",
                     "_translit": "oligópistos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol-ig-op'-is-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3641"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4102"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "incredulous, i.e. lacking confidence (in\n Christ)",
               "kjv_def": ":--of little faith.",
               "_strongs": "03640"
            },
            {
               "strongs": "3641",
               "greek": [
                  {
                     "_BETA": "O)LI/GOS",
                     "_unicode": "ὀλίγος",
                     "_translit": "olígos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol-ee'-gos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "puny (in extent, degree, number, duration or\n value); especially neuter (adverbially) somewhat",
               "kjv_def": ":--+ almost,\n brief(-ly), few, (a) little, + long, a season, short, small, a while.",
               "_strongs": "03641"
            },
            {
               "strongs": "3642",
               "greek": [
                  {
                     "_BETA": "O)LIGO/YUXOS",
                     "_unicode": "ὀλιγόψυχος",
                     "_translit": "oligópsychos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol-ig-op'-soo-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3641"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5590"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "little-spirited, i.e.\n faint-hearted",
               "kjv_def": ":--feebleminded.",
               "_strongs": "03642"
            },
            {
               "strongs": "3643",
               "greek": [
                  {
                     "_BETA": "O)LIGWRE/W",
                     "_unicode": "ὀλιγωρέω",
                     "_translit": "oligōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol-ig-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3641"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "W)/RA",
                        "_unicode": "ὤρα",
                        "_translit": "ṓra"
                     }
                  ],
                  "__text": "from a compound of \n and \n (\"care\");"
               },
               "strongs_def": "to have little regard for,\n i.e. to disesteem",
               "kjv_def": ":--despise.",
               "_strongs": "03643"
            },
            {
               "strongs": "3644",
               "greek": [
                  {
                     "_BETA": "O)LOQREUTH/S",
                     "_unicode": "ὀλοθρευτής",
                     "_translit": "olothreutḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol-oth-ryoo-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3645"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a ruiner, i.e. (specially), a venomous serpent",
               "kjv_def": ":--destroyer.",
               "_strongs": "03644"
            },
            {
               "strongs": "3645",
               "greek": [
                  {
                     "_BETA": "O)LOQREU/W",
                     "_unicode": "ὀλοθρεύω",
                     "_translit": "olothreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol-oth-ryoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3639"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to spoil, i.e. slay",
               "kjv_def": ":--destroy.",
               "_strongs": "03645"
            },
            {
               "strongs": "3646",
               "greek": [
                  {
                     "_BETA": "O(LOKAU/TWMA",
                     "_unicode": "ὁλοκαύτωμα",
                     "_translit": "holokaútōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hol-ok-ow'-to-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3650"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2545"
                     }
                  ],
                  "__text": "from a derivative of a compound of \n and a derivative of \n;"
               },
               "strongs_def": "a\n wholly-consumed sacrifice (\"holocaust\")",
               "kjv_def": ":--(whole) burnt offering.",
               "_strongs": "03646"
            },
            {
               "strongs": "3647",
               "greek": [
                  {
                     "_BETA": "O(LOKLHRI/A",
                     "_unicode": "ὁλοκληρία",
                     "_translit": "holoklēría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hol-ok-lay-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3648"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "integrity, i.e. physical wholeness",
               "kjv_def": ":--perfect soundness.",
               "_strongs": "03647"
            },
            {
               "strongs": "3648",
               "greek": [
                  {
                     "_BETA": "O(LO/KLHROS",
                     "_unicode": "ὁλόκληρος",
                     "_translit": "holóklēros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hol'-ok'-lay-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3650"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2819"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "complete in every part, i.e. perfectly sound (in\n body)",
               "kjv_def": ":--entire, whole.",
               "_strongs": "03648"
            },
            {
               "strongs": "3649",
               "greek": [
                  {
                     "_BETA": "O)LOLU/ZW",
                     "_unicode": "ὀλολύζω",
                     "_translit": "ololýzō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol-ol-odd'-zo"
                  }
               ],
               "strongs_derivation": "a reduplicated primary verb;",
               "strongs_def": "to \"howl\" or \"halloo\", i.e.\n shriek",
               "kjv_def": ":--howl.",
               "_strongs": "03649"
            },
            {
               "strongs": "3650",
               "greek": [
                  {
                     "_BETA": "O(/LOS",
                     "_unicode": "ὅλος",
                     "_translit": "hólos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hol'-os"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "\"whole\" or \"all\", i.e. complete (in extent, amount,\n time or degree), especially (neuter) as noun or adverb",
               "kjv_def": ":--all,\n altogether, every whit, + throughout, whole.",
               "_strongs": "03650"
            },
            {
               "strongs": "3651",
               "greek": [
                  {
                     "_BETA": "O(LOTELH/S",
                     "_unicode": "ὁλοτελής",
                     "_translit": "holotelḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hol-ot-el-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3650"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "complete to the end, i.e. absolutely\n perfect",
               "kjv_def": ":--wholly.",
               "_strongs": "03651"
            },
            {
               "strongs": "3652",
               "greek": [
                  {
                     "_BETA": "*)OLUMPA=S",
                     "_unicode": "Ὀλυμπᾶς",
                     "_translit": "Olympâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol-oom-pas'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*)OLUMPIO/DWROS",
                        "_unicode": "Ὀλυμπιόδωρος",
                        "_translit": "Olympiódōros"
                     }
                  ],
                  "__text": "probably a contraction from \n (Olympian-bestowed, i.e.\n heaven-descended);"
               },
               "strongs_def": "Olympas, a Christian",
               "kjv_def": ":--Olympas.",
               "_strongs": "03652"
            },
            {
               "strongs": "3653",
               "greek": [
                  {
                     "_BETA": "O)/LUNQOS",
                     "_unicode": "ὄλυνθος",
                     "_translit": "ólynthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ol'-oon-thos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "an unripe (because out of season)\n fig",
               "kjv_def": ":--untimely fig.",
               "_strongs": "03653"
            },
            {
               "strongs": "3654",
               "greek": [
                  {
                     "_BETA": "O(/LWS",
                     "_unicode": "ὅλως",
                     "_translit": "hólōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hol'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3650"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "completely, i.e. altogether; (by analogy),\n everywhere; (negatively) not by any means",
               "kjv_def": ":--at all, commonly, utterly.",
               "_strongs": "03654"
            },
            {
               "strongs": "3655",
               "greek": [
                  {
                     "_BETA": "O)/MBROS",
                     "_unicode": "ὄμβρος",
                     "_translit": "ómbros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "om'-bros"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a thunder storm",
               "kjv_def": ":--shower.",
               "_strongs": "03655"
            },
            {
               "strongs": "3656",
               "greek": [
                  {
                     "_BETA": "O(MILE/W",
                     "_unicode": "ὁμιλέω",
                     "_translit": "homiléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-il-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3658"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be in company with, i.e. (by implication) to\n converse",
               "kjv_def": ":--commune, talk.",
               "_strongs": "03656"
            },
            {
               "strongs": "3657",
               "greek": [
                  {
                     "_BETA": "O(MILI/A",
                     "_unicode": "ὁμιλία",
                     "_translit": "homilía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-il-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3658"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "companionship (\"homily\"), i.e. (by implication)\n intercourse",
               "kjv_def": ":--communication.",
               "_strongs": "03657"
            },
            {
               "strongs": "3658",
               "greek": [
                  {
                     "_BETA": "O(/MILOS",
                     "_unicode": "ὅμιλος",
                     "_translit": "hómilos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom'-il-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3674"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from the base of \n and a derivative of the alternate of \n\n (meaning a crowd);"
               },
               "strongs_def": "association together, i.e. a multitude",
               "kjv_def": ":--company.",
               "_strongs": "03658"
            },
            {
               "strongs": "3659",
               "greek": [
                  {
                     "_BETA": "O)/MMA",
                     "_unicode": "ὄμμα",
                     "_translit": "ómma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "om'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sight, i.e. (by implication) the eye",
               "kjv_def": ":--eye.",
               "_strongs": "03659"
            },
            {
               "strongs": "3660",
               "greek": [
                  {
                     "_BETA": "O)MNU/W",
                     "_unicode": "ὀμνύω",
                     "_translit": "omnýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "om-noo'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/MW",
                        "_unicode": "ὄμω",
                        "_translit": "ómō"
                     },
                     {
                        "_BETA": "O)MO/W",
                        "_unicode": "ὀμόω",
                        "_translit": "omóō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "om-o'-o"
                     }
                  ],
                  "__text": "a prolonged form of a primary,\n                         but obsolete \n, for which\n                         another prolonged form\n      \n  \n    is used in certain tenses;"
               },
               "strongs_def": "to swear, i.e. take (or declare on) oath",
               "kjv_def": ":--swear.",
               "_strongs": "03660",
               "__text": ";"
            },
            {
               "strongs": "3661",
               "greek": [
                  {
                     "_BETA": "O(MOQUMADO/N",
                     "_unicode": "ὁμοθυμαδόν",
                     "_translit": "homothymadón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oth-oo-mad-on'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3674"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     }
                  ],
                  "__text": "adverb from a compound of the base of \n and \n;"
               },
               "strongs_def": "unanimously",
               "kjv_def": ":--with one accord (mind).",
               "_strongs": "03661"
            },
            {
               "strongs": "3662",
               "greek": [
                  {
                     "_BETA": "O(MOIA/ZW",
                     "_unicode": "ὁμοιάζω",
                     "_translit": "homoiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oy-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3664"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to resemble",
               "kjv_def": ":--agree.",
               "_strongs": "03662"
            },
            {
               "strongs": "3663",
               "greek": [
                  {
                     "_BETA": "O(MOIOPAQH/S",
                     "_unicode": "ὁμοιοπαθής",
                     "_translit": "homoiopathḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oy-op-ath-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3664"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3958"
                     }
                  ],
                  "__text": "from \n and the alternate of \n;"
               },
               "strongs_def": "similarly affected",
               "kjv_def": ":--of (subject\n to) like passions.",
               "_strongs": "03663"
            },
            {
               "strongs": "3664",
               "greek": [
                  {
                     "_BETA": "O(/MOIOS",
                     "_unicode": "ὅμοιος",
                     "_translit": "hómoios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom'-oy-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3674"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "similar (in appearance or character)",
               "kjv_def": ":--like, +\n manner.",
               "_strongs": "03664"
            },
            {
               "strongs": "3665",
               "greek": [
                  {
                     "_BETA": "O(MOIO/THS",
                     "_unicode": "ὁμοιότης",
                     "_translit": "homoiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oy-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3664"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "resemblance",
               "kjv_def": ":--like as, similitude.",
               "_strongs": "03665"
            },
            {
               "strongs": "3666",
               "greek": [
                  {
                     "_BETA": "O(MOIO/W",
                     "_unicode": "ὁμοιόω",
                     "_translit": "homoióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oy-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3664"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to assimilate, i.e. compare; passively, to become\n similar",
               "kjv_def": ":--be (make) like, (in the) liken(-ess), resemble.",
               "_strongs": "03666"
            },
            {
               "strongs": "3667",
               "greek": [
                  {
                     "_BETA": "O(MOI/WMA",
                     "_unicode": "ὁμοίωμα",
                     "_translit": "homoíōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oy'-o-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3666"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a form; abstractly, resemblance",
               "kjv_def": ":--made like to, likeness,\n shape, similitude.",
               "_strongs": "03667"
            },
            {
               "strongs": "3668",
               "greek": [
                  {
                     "_BETA": "O(MOI/WS",
                     "_unicode": "ὁμοίως",
                     "_translit": "homoíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oy'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3664"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "similarly",
               "kjv_def": ":--likewise, so.",
               "_strongs": "03668"
            },
            {
               "strongs": "3669",
               "greek": [
                  {
                     "_BETA": "O(MOI/WSIS",
                     "_unicode": "ὁμοίωσις",
                     "_translit": "homoíōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oy'-o-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3666"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "assimilation, i.e. resemblance",
               "kjv_def": ":--similitude.",
               "_strongs": "03669"
            },
            {
               "strongs": "3670",
               "greek": [
                  {
                     "_BETA": "O(MOLOGE/W",
                     "_unicode": "ὁμολογέω",
                     "_translit": "homologéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-ol-og-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3674"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from a compound of the base of \n and \n;"
               },
               "strongs_def": "to assent, i.e.\n covenant, acknowledge",
               "kjv_def": ":--con- (pro-)fess, confession is made, give\n thanks, promise.",
               "_strongs": "03670"
            },
            {
               "strongs": "3671",
               "greek": [
                  {
                     "_BETA": "O(MOLOGI/A",
                     "_unicode": "ὁμολογία",
                     "_translit": "homología"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-ol-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3670"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "acknowledgment",
               "kjv_def": ":--con- (pro-)fession, professed.",
               "_strongs": "03671"
            },
            {
               "strongs": "3672",
               "greek": [
                  {
                     "_BETA": "O(MOLOGOUME/NWS",
                     "_unicode": "ὁμολογουμένως",
                     "_translit": "homologouménōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-ol-og-ow-men'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3670"
                     }
                  ],
                  "__text": "adverb of present passive participle of \n;"
               },
               "strongs_def": "confessedly",
               "kjv_def": ":--without\n controversy.",
               "_strongs": "03672"
            },
            {
               "strongs": "3673",
               "greek": [
                  {
                     "_BETA": "O(MO/TEXNOS",
                     "_unicode": "ὁμότεχνος",
                     "_translit": "homótechnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-ot'-ekh-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3674"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5078"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "a fellow-artificer",
               "kjv_def": ":--of the same\n craft.",
               "_strongs": "03673"
            },
            {
               "strongs": "3674",
               "greek": [
                  {
                     "_BETA": "O(MOU=",
                     "_unicode": "ὁμοῦ",
                     "_translit": "homoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-oo'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O(MO/S",
                        "_unicode": "ὁμός",
                        "_translit": "homós"
                     }
                  ],
                  "__text": "genitive case of \n (the same;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "260"
                     }
                  ],
                  "__text": "akin to \n) as adverb; at the same\n place or time"
               },
               "kjv_def": ":--together.",
               "_strongs": "03674"
            },
            {
               "strongs": "3675",
               "greek": [
                  {
                     "_BETA": "O(MO/FRWN",
                     "_unicode": "ὁμόφρων",
                     "_translit": "homóphrōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom-of'-rone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3674"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "like-minded, i.e. harmonious",
               "kjv_def": ":--of one\n mind.",
               "_strongs": "03675"
            },
            {
               "strongs": "3676",
               "greek": [
                  {
                     "_BETA": "O(/MWS",
                     "_unicode": "ὅμως",
                     "_translit": "hómōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hom'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3674"
                     }
                  ],
                  "__text": "adverb from the base of \n;"
               },
               "strongs_def": "at the same time, i.e. (conjunctionally)\n notwithstanding, yet still",
               "kjv_def": ":--and even, nevertheless, though but.",
               "_strongs": "03676"
            },
            {
               "strongs": "3677",
               "greek": [
                  {
                     "_BETA": "O)/NAR",
                     "_unicode": "ὄναρ",
                     "_translit": "ónar"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on'-ar"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a dream",
               "kjv_def": ":--dream.",
               "_strongs": "03677"
            },
            {
               "strongs": "3678",
               "greek": [
                  {
                     "_BETA": "O)NA/RION",
                     "_unicode": "ὀνάριον",
                     "_translit": "onárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on-ar'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3688"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a little ass",
               "kjv_def": ":--young ass.",
               "_strongs": "03678"
            },
            {
               "strongs": "3679",
               "greek": [
                  {
                     "_BETA": "O)NEIDI/ZW",
                     "_unicode": "ὀνειδίζω",
                     "_translit": "oneidízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on-i-did'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3681"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to defame, i.e. rail at, chide, taunt",
               "kjv_def": ":--cast in teeth,\n (suffer) reproach, revile, upbraid.",
               "_strongs": "03679"
            },
            {
               "strongs": "3680",
               "greek": [
                  {
                     "_BETA": "O)NEIDISMO/S",
                     "_unicode": "ὀνειδισμός",
                     "_translit": "oneidismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on-i-dis-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3679"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "contumely",
               "kjv_def": ":--reproach.",
               "_strongs": "03680"
            },
            {
               "strongs": "3681",
               "greek": [
                  {
                     "_BETA": "O)/NEIDOS",
                     "_unicode": "ὄνειδος",
                     "_translit": "óneidos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on'-i-dos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3686"
                     }
                  ],
                  "__text": "probably akin to the base of \n;"
               },
               "strongs_def": "notoriety, i.e. a taunt\n (disgrace)",
               "kjv_def": ":--reproach.",
               "_strongs": "03681"
            },
            {
               "strongs": "3682",
               "greek": [
                  {
                     "_BETA": "*)ONH/SIMOS",
                     "_unicode": "Ὀνήσιμος",
                     "_translit": "Onḗsimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on-ay'-sim-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3685"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "profitable; Onesimus, a Christian",
               "kjv_def": ":--Onesimus.",
               "_strongs": "03682"
            },
            {
               "strongs": "3683",
               "greek": [
                  {
                     "_BETA": "*)ONHSI/FOROS",
                     "_unicode": "Ὀνησίφορος",
                     "_translit": "Onēsíphoros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on-ay-sif'-or-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3685"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5411"
                     }
                  ],
                  "__text": "from a derivative of \n and \n;"
               },
               "strongs_def": "profit-bearer; Onesiphorus, a\n Christian",
               "kjv_def": ":--Onespiphorus.",
               "_strongs": "03683"
            },
            {
               "strongs": "3684",
               "greek": [
                  {
                     "_BETA": "O)NIKO/S",
                     "_unicode": "ὀνικός",
                     "_translit": "onikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3688"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "belonging to a ass, i.e. large (so as to be turned by a\n ass)",
               "kjv_def": ":--millstone.",
               "_strongs": "03684"
            },
            {
               "strongs": "3685",
               "greek": [
                  {
                     "_BETA": "O)NI/NHMI",
                     "_unicode": "ὀνίνημι",
                     "_translit": "onínēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on-in'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/NOMAI",
                        "_unicode": "ὄνομαι",
                        "_translit": "ónomai"
                     }
                  ],
                  "__text": "a prolonged form of an apparently primary verb (\n, to slur);"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "O)NA/W",
                        "_unicode": "ὀνάω",
                        "_translit": "onáō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3686"
                     }
                  ],
                  "__text": "for which another prolonged form (\n) is used as an alternate in\n some tenses (unless indeed it be identical with the base of \n\n through the idea of notoriety); to gratify, i.e. (middle voice) to\n derive pleasure or advantage from"
               },
               "kjv_def": ":--have joy.",
               "_strongs": "03685"
            },
            {
               "strongs": "3686",
               "greek": [
                  {
                     "_BETA": "O)/NOMA",
                     "_unicode": "ὄνομα",
                     "_translit": "ónoma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on'-om-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3685"
                     }
                  ],
                  "__text": "from a presumed derivative of the base of \n (compare \n);"
               },
               "strongs_def": "a\n \"name\" (literally or figuratively) (authority, character)",
               "kjv_def": ":--called, (+\n sur-)name(-d).",
               "_strongs": "03686"
            },
            {
               "strongs": "3687",
               "greek": [
                  {
                     "_BETA": "O)NOMA/ZW",
                     "_unicode": "ὀνομάζω",
                     "_translit": "onomázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on-om-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3686"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to name, i.e. assign an appellation; by extension, to\n utter, mention, profess",
               "kjv_def": ":--call, name.",
               "_strongs": "03687"
            },
            {
               "strongs": "3688",
               "greek": [
                  {
                     "_BETA": "O)/NOS",
                     "_unicode": "ὄνος",
                     "_translit": "ónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on'-os"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a donkey",
               "kjv_def": ":--an ass.",
               "_strongs": "03688"
            },
            {
               "strongs": "3689",
               "greek": [
                  {
                     "_BETA": "O)/NTWS",
                     "_unicode": "ὄντως",
                     "_translit": "óntōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "on'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5607"
                     }
                  ],
                  "__text": "adverb of the oblique cases of \n;"
               },
               "strongs_def": "really",
               "kjv_def": ":--certainly, clean,\n indeed, of a truth, verily.",
               "_strongs": "03689"
            },
            {
               "strongs": "3690",
               "greek": [
                  {
                     "_BETA": "O)/COS",
                     "_unicode": "ὄξος",
                     "_translit": "óxos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oz-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3691"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "vinegar, i.e. sour wine",
               "kjv_def": ":--vinegar.",
               "_strongs": "03690"
            },
            {
               "strongs": "3691",
               "greek": [
                  {
                     "_BETA": "O)CU/S",
                     "_unicode": "ὀξύς",
                     "_translit": "oxýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oz-oos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "188"
                     }
                  ],
                  "__text": "probably akin to the base of \n (\"acid\");"
               },
               "strongs_def": "keen; by analogy,\n rapid",
               "kjv_def": ":--sharp, swift.",
               "_strongs": "03691"
            },
            {
               "strongs": "3692",
               "greek": [
                  {
                     "_BETA": "O)PH/",
                     "_unicode": "ὀπή",
                     "_translit": "opḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "a hole (as if for light), i.e. cavern; by analogy,\n a spring (of water)",
               "kjv_def": ":--cave, place.",
               "_strongs": "03692"
            },
            {
               "strongs": "3693",
               "greek": [
                  {
                     "_BETA": "O)/PISQEN",
                     "_unicode": "ὄπισθεν",
                     "_translit": "ópisthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op'-is-then"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/PIS",
                        "_unicode": "ὄπις",
                        "_translit": "ópis"
                     }
                  ],
                  "__text": "from \n (regard;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n) with enclitic of source; from the rear\n (as a secure aspect), i.e. at the back (adverb and preposition of\n place or time)"
               },
               "kjv_def": ":--after, backside, behind.",
               "_strongs": "03693"
            },
            {
               "strongs": "3694",
               "greek": [
                  {
                     "_BETA": "O)PI/SW",
                     "_unicode": "ὀπίσω",
                     "_translit": "opísō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-is'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3693"
                     }
                  ],
                  "__text": "from the same as \n with enclitic of direction;"
               },
               "strongs_def": "to the back, i.e.\n aback (as adverb or preposition of time or place; or as noun)",
               "kjv_def": ":--after,\n back(-ward), (+ get) behind, + follow.",
               "_strongs": "03694"
            },
            {
               "strongs": "3695",
               "greek": [
                  {
                     "_BETA": "O(PLI/ZW",
                     "_unicode": "ὁπλίζω",
                     "_translit": "hoplízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hop-lid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3696"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to equip (with weapons (middle voice and\n figuratively))",
               "kjv_def": ":--arm self.",
               "_strongs": "03695"
            },
            {
               "strongs": "3696",
               "greek": [
                  {
                     "_BETA": "O(/PLON",
                     "_unicode": "ὅπλον",
                     "_translit": "hóplon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hop'-lon"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E(/PW",
                        "_unicode": "ἕπω",
                        "_translit": "hépō"
                     }
                  ],
                  "__text": "probably from a primary \n (to be busy about);"
               },
               "strongs_def": "an implement or\n utensil or tool (literally or figuratively, especially, offensive for\n war)",
               "kjv_def": ":--armour, instrument, weapon.",
               "_strongs": "03696"
            },
            {
               "strongs": "3697",
               "greek": [
                  {
                     "_BETA": "O(POI=OS",
                     "_unicode": "ὁποῖος",
                     "_translit": "hopoîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hop-oy'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4169"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5108"
                     }
                  ],
                  "__text": "of what kind that, i.e. how (as) great (excellent)\n (specially, as an indefinite correlative to the definite antecedent\n \n of quality)"
               },
               "kjv_def": ":--what manner (sort) of, such as whatsoever.",
               "_strongs": "03697"
            },
            {
               "strongs": "3698",
               "greek": [
                  {
                     "_BETA": "O(PO/TE",
                     "_unicode": "ὁπότε",
                     "_translit": "hopóte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hop-ot'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "what(-ever) then, i.e. (of time) as soon\n as",
               "kjv_def": ":--when.",
               "_strongs": "03698"
            },
            {
               "strongs": "3699",
               "greek": [
                  {
                     "_BETA": "O(/POU",
                     "_unicode": "ὅπου",
                     "_translit": "hópou"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hop'-oo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4225"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "what(-ever) where, i.e. at whichever spot",
               "kjv_def": ":--in\n what place, where(-as, -soever), whither (+ soever).",
               "_strongs": "03699"
            },
            {
               "strongs": "3700",
               "greek": [
                  {
                     "_BETA": "O)PTA/NOMAI",
                     "_unicode": "ὀπτάνομαι",
                     "_translit": "optánomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-tan'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/PTOMAI",
                        "_unicode": "ὄπτομαι",
                        "_translit": "óptomai"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "op'-tom-ahee"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "a (middle voice) prolonged form of the primary (middle voice)\n      \n  \n;    which is used for it in certain\n                                   tenses; and both as alternate of\n                                   \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2300"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2334"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4648"
                     }
                  ],
                  "__text": "to gaze (i.e. with wide-open eyes, as at something remarkable; and\n thus differing from \n, which denotes simply voluntary observation;\n and from \n, which expresses merely mechanical, passive or casual\n vision; while \n, and still more emphatically its intensive \n,\n signifies an earnest but more continued inspection; and \n a\n watching from a distance)"
               },
               "kjv_def": ":--appear, look, see, shew self.",
               "_strongs": "03700",
               "__text": ";"
            },
            {
               "strongs": "3701",
               "greek": [
                  {
                     "_BETA": "O)PTASI/A",
                     "_unicode": "ὀπτασία",
                     "_translit": "optasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-tas-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "visuality, i.e. (concretely) an\n apparition",
               "kjv_def": ":--vision.",
               "_strongs": "03701"
            },
            {
               "strongs": "3702",
               "greek": [
                  {
                     "_BETA": "O)PTO/S",
                     "_unicode": "ὀπτός",
                     "_translit": "optós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-tos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E(/PSW",
                        "_unicode": "ἕπσω",
                        "_translit": "hépsō"
                     }
                  ],
                  "__text": "from an obsolete verb akin to \n (to \"steep\");"
               },
               "strongs_def": "cooked, i.e.\n roasted",
               "kjv_def": ":--broiled.",
               "_strongs": "03702"
            },
            {
               "strongs": "3703",
               "greek": [
                  {
                     "_BETA": "O)PW/RA",
                     "_unicode": "ὀπώρα",
                     "_translit": "opṓra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-o'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3796"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5610"
                     }
                  ],
                  "__text": "apparently from the base of \n and \n;"
               },
               "strongs_def": "properly, even-tide of the\n (summer) season (dog-days), i.e. (by implication) ripe fruit",
               "kjv_def": ":--fruit.",
               "_strongs": "03703"
            },
            {
               "strongs": "3704",
               "greek": [
                  {
                     "_BETA": "O(/PWS",
                     "_unicode": "ὅπως",
                     "_translit": "hópōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hop'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4459"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "what(-ever) how, i.e. in the manner that (as\n adverb or conjunction of coincidence, intentional or\n actual)",
               "kjv_def": ":--because, how, (so) that, to, when.",
               "_strongs": "03704"
            },
            {
               "strongs": "3705",
               "greek": [
                  {
                     "_BETA": "O(/RAMA",
                     "_unicode": "ὅραμα",
                     "_translit": "hórama"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor'-am-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something gazed at, i.e. a spectacle (especially\n supernatural)",
               "kjv_def": ":--sight, vision.",
               "_strongs": "03705"
            },
            {
               "strongs": "3706",
               "greek": [
                  {
                     "_BETA": "O(/RASIS",
                     "_unicode": "ὅρασις",
                     "_translit": "hórasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor'-as-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the act of gazing, i.e. (externally) an aspect or\n (internally) an inspired appearance",
               "kjv_def": ":--sight, vision.",
               "_strongs": "03706"
            },
            {
               "strongs": "3707",
               "greek": [
                  {
                     "_BETA": "O(RATO/S",
                     "_unicode": "ὁρατός",
                     "_translit": "horatós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor-at-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "gazed at, i.e. (by implication) capable of being\n seen",
               "kjv_def": ":--visible.",
               "_strongs": "03707"
            },
            {
               "strongs": "3708",
               "greek": [
                  {
                     "_BETA": "O(RA/W",
                     "_unicode": "ὁράω",
                     "_translit": "horáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "properly, to stare at (compare \n), i.e. (by implication) to discern\n clearly (physically or mentally);"
               },
               "strongs_def": "by extension, to attend to; by\n Hebraism, to experience; passively, to appear",
               "kjv_def": ":--behold, perceive, see,\n take heed.",
               "_strongs": "03708"
            },
            {
               "strongs": "3709",
               "greek": [
                  {
                     "_BETA": "O)RGH/",
                     "_unicode": "ὀργή",
                     "_translit": "orgḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-gay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3713"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, desire (as a reaching forth or excitement of the\n mind), i.e. (by analogy), violent passion (ire, or (justifiable)\n abhorrence); by implication punishment",
               "kjv_def": ":--anger, indignation,\n vengeance, wrath.",
               "_strongs": "03709"
            },
            {
               "strongs": "3710",
               "greek": [
                  {
                     "_BETA": "O)RGI/ZW",
                     "_unicode": "ὀργίζω",
                     "_translit": "orgízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-gid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3709"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to provoke or enrage, i.e. (passively) become\n exasperated",
               "kjv_def": ":--be angry (wroth).",
               "_strongs": "03710"
            },
            {
               "strongs": "3711",
               "greek": [
                  {
                     "_BETA": "O)RGI/LOS",
                     "_unicode": "ὀργίλος",
                     "_translit": "orgílos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "org-ee'-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3709"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "irascible",
               "kjv_def": ":--soon angry.",
               "_strongs": "03711"
            },
            {
               "strongs": "3712",
               "greek": [
                  {
                     "_BETA": "O)RGUIA/",
                     "_unicode": "ὀργυιά",
                     "_translit": "orguiá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "org-wee-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3713"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a stretch of the arms, i.e. a fathom",
               "kjv_def": ":--fathom.",
               "_strongs": "03712"
            },
            {
               "strongs": "3713",
               "greek": [
                  {
                     "_BETA": "O)RE/GOMAI",
                     "_unicode": "ὀρέγομαι",
                     "_translit": "orégomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-eg'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3735"
                     }
                  ],
                  "__text": "middle voice of apparently a prolonged form of an obsolete primary\n (compare \n);"
               },
               "strongs_def": "to stretch oneself, i.e. reach out after (long\n for)",
               "kjv_def": ":--covet after, desire.",
               "_strongs": "03713"
            },
            {
               "strongs": "3714",
               "greek": [
                  {
                     "_BETA": "O)REINO/S",
                     "_unicode": "ὀρεινός",
                     "_translit": "oreinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-i-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3735"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "mountainous, i.e. (feminine by implication, of \n) the\n Highlands (of Judæa)"
               },
               "kjv_def": ":--hill country.",
               "_strongs": "03714"
            },
            {
               "strongs": "3715",
               "greek": [
                  {
                     "_BETA": "O)/RECIS",
                     "_unicode": "ὄρεξις",
                     "_translit": "órexis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or'-ex-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3713"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "excitement of the mind, i.e. longing after",
               "kjv_def": ":--lust.",
               "_strongs": "03715"
            },
            {
               "strongs": "3716",
               "greek": [
                  {
                     "_BETA": "O)RQOPODE/W",
                     "_unicode": "ὀρθοποδέω",
                     "_translit": "orthopodéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-thop-od-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3717"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be straight-footed, i.e.\n (figuratively) to go directly forward",
               "kjv_def": ":--walk uprightly.",
               "_strongs": "03716"
            },
            {
               "strongs": "3717",
               "greek": [
                  {
                     "_BETA": "O)RQO/S",
                     "_unicode": "ὀρθός",
                     "_translit": "orthós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-thos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3735"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "right (as rising), i.e.\n (perpendicularly) erect (figuratively, honest), or (horizontally)\n level or direct",
               "kjv_def": ":--straight, upright.",
               "_strongs": "03717"
            },
            {
               "strongs": "3718",
               "greek": [
                  {
                     "_BETA": "O)RQOTOME/W",
                     "_unicode": "ὀρθοτομέω",
                     "_translit": "orthotoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-thot-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3717"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5114"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n, to make a straight cut,\n i.e. (figuratively) to dissect (expound) correctly (the divine\n message)"
               },
               "kjv_def": ":--rightly divide.",
               "_strongs": "03718"
            },
            {
               "strongs": "3719",
               "greek": [
                  {
                     "_BETA": "O)RQRI/ZW",
                     "_unicode": "ὀρθρίζω",
                     "_translit": "orthrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-thrid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3722"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to use the dawn, i.e. (by implication) to repair\n betimes",
               "kjv_def": ":--come early in the morning.",
               "_strongs": "03719"
            },
            {
               "strongs": "3720",
               "greek": [
                  {
                     "_BETA": "O)RQRINO/S",
                     "_unicode": "ὀρθρινός",
                     "_translit": "orthrinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-thrin-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3722"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "relating to the dawn, i.e. matutinal (as an epithet of\n Venus, especially brilliant in the early day)",
               "kjv_def": ":--morning.",
               "_strongs": "03720"
            },
            {
               "strongs": "3721",
               "greek": [
                  {
                     "_BETA": "O)/RQRIOS",
                     "_unicode": "ὄρθριος",
                     "_translit": "órthrios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or'-three-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3722"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "in the dawn, i.e. up at day-break",
               "kjv_def": ":--early.",
               "_strongs": "03721"
            },
            {
               "strongs": "3722",
               "greek": [
                  {
                     "_BETA": "O)/RQROS",
                     "_unicode": "ὄρθρος",
                     "_translit": "órthros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or'-thros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3735"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "dawn (as sun-rise, rising of light); by\n extension, morn",
               "kjv_def": ":--early in the morning.",
               "_strongs": "03722"
            },
            {
               "strongs": "3723",
               "greek": [
                  {
                     "_BETA": "O)RQW=S",
                     "_unicode": "ὀρθῶς",
                     "_translit": "orthōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-thoce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3717"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "in a straight manner, i.e. (figuratively) correctly\n (also morally)",
               "kjv_def": ":--plain, right(-ly).",
               "_strongs": "03723"
            },
            {
               "strongs": "3724",
               "greek": [
                  {
                     "_BETA": "O(RI/ZW",
                     "_unicode": "ὁρίζω",
                     "_translit": "horízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3725"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to mark out or bound (\"horizon\"), i.e. (figuratively) to\n appoint, decree, specify",
               "kjv_def": ":--declare, determine, limit, ordain.",
               "_strongs": "03724"
            },
            {
               "strongs": "3725",
               "greek": [
                  {
                     "_BETA": "O(/RION",
                     "_unicode": "ὅριον",
                     "_translit": "hórion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O(/ROS",
                        "_unicode": "ὅρος",
                        "_translit": "hóros"
                     }
                  ],
                  "__text": "neuter of a derivative of an apparently primary \n (a bound or\n limit);"
               },
               "strongs_def": "a boundary-line, i.e. (by implication) a frontier\n (region)",
               "kjv_def": ":--border, coast.",
               "_strongs": "03725"
            },
            {
               "strongs": "3726",
               "greek": [
                  {
                     "_BETA": "O(RKI/ZW",
                     "_unicode": "ὁρκίζω",
                     "_translit": "horkízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor-kid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3727"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to put on oath, i.e. make swear; by analogy, to solemnly\n enjoin",
               "kjv_def": ":--adjure, charge.",
               "_strongs": "03726"
            },
            {
               "strongs": "3727",
               "greek": [
                  {
                     "_BETA": "O(/RKOS",
                     "_unicode": "ὅρκος",
                     "_translit": "hórkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor'-kos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "E(/RKOS",
                        "_unicode": "ἕρκος",
                        "_translit": "hérkos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3725"
                     }
                  ],
                  "__text": "from \n (a fence; perhaps akin to \n);"
               },
               "strongs_def": "a limit, i.e. (sacred)\n restraint (specially, an oath)",
               "kjv_def": ":--oath.",
               "_strongs": "03727"
            },
            {
               "strongs": "3728",
               "greek": [
                  {
                     "_BETA": "O(RKWMOSI/A",
                     "_unicode": "ὁρκωμοσία",
                     "_translit": "horkōmosía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor-ko-mos-ee'ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3727"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3660"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "asseveration on\n oath",
               "kjv_def": ":--oath.",
               "_strongs": "03728"
            },
            {
               "strongs": "3729",
               "greek": [
                  {
                     "_BETA": "O(RMA/W",
                     "_unicode": "ὁρμάω",
                     "_translit": "hormáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor-mah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3730"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to start, spur or urge on, i.e. (reflexively) to dash or\n plunge",
               "kjv_def": ":--run (violently), rush.",
               "_strongs": "03729"
            },
            {
               "strongs": "3730",
               "greek": [
                  {
                     "_BETA": "O(RMH/",
                     "_unicode": "ὁρμή",
                     "_translit": "hormḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor-may'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a violent impulse, i.e. onset",
               "kjv_def": ":--assault.",
               "_strongs": "03730"
            },
            {
               "strongs": "3731",
               "greek": [
                  {
                     "_BETA": "O(/RMHMA",
                     "_unicode": "ὅρμημα",
                     "_translit": "hórmēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor'-may-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3730"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an attack, i.e. (abstractly) precipitancy",
               "kjv_def": ":--violence.",
               "_strongs": "03731"
            },
            {
               "strongs": "3732",
               "greek": [
                  {
                     "_BETA": "O)/RNEON",
                     "_unicode": "ὄρνεον",
                     "_translit": "órneon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or'-neh-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3733"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a birdling",
               "kjv_def": ":--bird, fowl.",
               "_strongs": "03732"
            },
            {
               "strongs": "3733",
               "greek": [
                  {
                     "_BETA": "O)/RNIS",
                     "_unicode": "ὄρνις",
                     "_translit": "órnis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or'-nis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3735"
                     }
                  ],
                  "__text": "probably from a prolonged form of the base of \n;"
               },
               "strongs_def": "a bird (as rising\n in the air), i.e. (specially), a hen (or female domestic fowl)",
               "kjv_def": ":--hen.",
               "_strongs": "03733"
            },
            {
               "strongs": "3734",
               "greek": [
                  {
                     "_BETA": "O(ROQESI/A",
                     "_unicode": "ὁροθεσία",
                     "_translit": "horothesía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hor-oth-es-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3725"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from a compound of the base of \n and a derivative of \n;"
               },
               "strongs_def": "a\n limit-placing, i.e. (concretely) boundary-line",
               "kjv_def": ":--bound.",
               "_strongs": "03734"
            },
            {
               "strongs": "3735",
               "greek": [
                  {
                     "_BETA": "O)/ROS",
                     "_unicode": "ὄρος",
                     "_translit": "óros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/RW",
                        "_unicode": "ὄρω",
                        "_translit": "órō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3733"
                     }
                  ],
                  "__text": "probably from an obsolete \n (to rise or \"rear\"; perhaps akin to \n;\n compare \n);"
               },
               "strongs_def": "a mountain (as lifting itself above the plain)",
               "kjv_def": ":--hill,\n mount(-ain).",
               "_strongs": "03735"
            },
            {
               "strongs": "3736",
               "greek": [
                  {
                     "_BETA": "O)RU/SSW",
                     "_unicode": "ὀρύσσω",
                     "_translit": "orýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-oos'-so"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to \"burrow\" in the ground, i.e. dig",
               "kjv_def": ":--dig.",
               "_strongs": "03736"
            },
            {
               "strongs": "3737",
               "greek": [
                  {
                     "_BETA": "O)RFANO/S",
                     "_unicode": "ὀρφανός",
                     "_translit": "orphanós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-fan-os'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "bereaved (\"orphan\"), i.e.\n parentless",
               "kjv_def": ":--comfortless, fatherless.",
               "_strongs": "03737"
            },
            {
               "strongs": "3738",
               "greek": [
                  {
                     "_BETA": "O)RXE/OMAI",
                     "_unicode": "ὀρχέομαι",
                     "_translit": "orchéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "or-kheh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/RXOS",
                        "_unicode": "ὄρχος",
                        "_translit": "órchos"
                     }
                  ],
                  "__text": "middle voice from \n (a row or ring);"
               },
               "strongs_def": "to dance (from the ranklike\n or regular motion)",
               "kjv_def": ":--dance.",
               "_strongs": "03738"
            },
            {
               "strongs": "3739",
               "greek": [
                  {
                     "_BETA": "O(/S",
                     "_unicode": "ὅς",
                     "_translit": "hós"
                  },
                  {
                     "_BETA": "H(/",
                     "_unicode": "ἥ",
                     "_translit": "hḗ"
                  },
                  {
                     "_BETA": "O(/",
                     "_unicode": "ὅ",
                     "_translit": "hó"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hos"
                  },
                  {
                     "_strongs": "hay"
                  },
                  {
                     "_strongs": "ho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     }
                  ],
                  "__text": "probably a primary word (or perhaps a form of the article \n);"
               },
               "strongs_def": "the\n relatively (sometimes demonstrative) pronoun, who, which, what,\n that",
               "kjv_def": ":--one, (an-, the) other, some, that, what, which, who(-m, -se),\n etc.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3757"
                  }
               ],
               "_strongs": "03739",
               "__text": ", including feminine\n      \n  \n, and neuter\n      \n  \n\n\n \n See also \n."
            },
            {
               "strongs": "3740",
               "greek": [
                  {
                     "_BETA": "O(SA/KIS",
                     "_unicode": "ὁσάκις",
                     "_translit": "hosákis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hos-ak'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "multiple adverb from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "302"
                     }
                  ],
                  "__text": "how (i.e. with \n, so) many times as"
               },
               "kjv_def": ":--as\n oft(-en) as.",
               "_strongs": "03740"
            },
            {
               "strongs": "3741",
               "greek": [
                  {
                     "_BETA": "O(/SIOS",
                     "_unicode": "ὅσιος",
                     "_translit": "hósios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hos'-ee-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2413"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "40"
                     }
                  ],
                  "__text": "properly, right (by intrinsic or divine\n character; thus distinguished from 1342, which refers rather to human\n statutes and relations; from \n, which denotes formal consecration;\n and from \n, which relates to purity from defilement), i.e. hallowed\n (pious, sacred, sure)"
               },
               "kjv_def": ":--holy, mercy, shalt be.",
               "_strongs": "03741",
               "__text": "342"
            },
            {
               "strongs": "3742",
               "greek": [
                  {
                     "_BETA": "O(SIO/THS",
                     "_unicode": "ὁσιότης",
                     "_translit": "hosiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hos-ee-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3741"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "piety",
               "kjv_def": ":--holiness.",
               "_strongs": "03742"
            },
            {
               "strongs": "3743",
               "greek": [
                  {
                     "_BETA": "O(SI/WS",
                     "_unicode": "ὁσίως",
                     "_translit": "hosíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hos-ee-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3741"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "piously",
               "kjv_def": ":--holily.",
               "_strongs": "03743"
            },
            {
               "strongs": "3744",
               "greek": [
                  {
                     "_BETA": "O)SMH/",
                     "_unicode": "ὀσμή",
                     "_translit": "osmḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "os-may'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3605"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fragrance (literally or figuratively)",
               "kjv_def": ":--odour, savour.",
               "_strongs": "03744"
            },
            {
               "strongs": "3745",
               "greek": [
                  {
                     "_BETA": "O(/SOS",
                     "_unicode": "ὅσος",
                     "_translit": "hósos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hos'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "by reduplication from \n;"
               },
               "strongs_def": "as (much, great, long, etc.) as",
               "kjv_def": ":--all\n (that), as (long, many, much) (as), how great (many, much),\n (in-)asmuch as, so many as, that (ever), the more, those things, what\n (great, -soever), wheresoever, wherewithsoever, which, X while,\n who(-soever).",
               "_strongs": "03745"
            },
            {
               "strongs": "3746",
               "greek": [
                  {
                     "_BETA": "O(/SPER",
                     "_unicode": "ὅσπερ",
                     "_translit": "hósper"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hos'-per"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "who especially",
               "kjv_def": ":--whomsoever.",
               "_strongs": "03746"
            },
            {
               "strongs": "3747",
               "greek": [
                  {
                     "_BETA": "O)STE/ON",
                     "_unicode": "ὀστέον",
                     "_translit": "ostéon"
                  },
                  {
                     "_BETA": "O)STOU=N",
                     "_unicode": "ὀστοῦν",
                     "_translit": "ostoûn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "os-teh'-on"
                  },
                  {
                     "_strongs": "os-toon'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a bone",
               "kjv_def": ":--bone.",
               "_strongs": "03747",
               "__text": ", or contracted"
            },
            {
               "strongs": "3748",
               "greek": [
                  {
                     "_BETA": "O(/STIS",
                     "_unicode": "ὅστις",
                     "_translit": "hóstis"
                  },
                  {
                     "_BETA": "H(/TIS",
                     "_unicode": "ἥτις",
                     "_translit": "hḗtis"
                  },
                  {
                     "_BETA": "O(/TI",
                     "_unicode": "ὅτι",
                     "_translit": "hóti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hos'-tis"
                  },
                  {
                     "_strongs": "hay'-tis"
                  },
                  {
                     "_strongs": "hot'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5100"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "which some, i.e. any that; also (definite) which\n same",
               "kjv_def": ":--X and (they), (such) as, (they) that, in that they,\n what(-soever), whereas ye, (they) which, who(-soever).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3754"
                  }
               ],
               "_strongs": "03748",
               "__text": ", including the feminine\n      \n  \n, and the neuter\n      \n  \n\n\n \n Compare \n."
            },
            {
               "strongs": "3749",
               "greek": [
                  {
                     "_BETA": "O)STRA/KINOS",
                     "_unicode": "ὀστράκινος",
                     "_translit": "ostrákinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "os-tra'-kin-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)/STRAKON",
                        "_unicode": "ὄστρακον",
                        "_translit": "óstrakon"
                     }
                  ],
                  "__text": "from \n (\"oyster\") (a tile, i.e. terra cotta);"
               },
               "strongs_def": "earthen-ware,\n i.e. clayey; by implication, frail",
               "kjv_def": ":--of earth, earthen.",
               "_strongs": "03749"
            },
            {
               "strongs": "3750",
               "greek": [
                  {
                     "_BETA": "O)/SFRHSIS",
                     "_unicode": "ὄσφρησις",
                     "_translit": "ósphrēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "os'-fray-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3605"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "smell (the sense)",
               "kjv_def": ":--smelling.",
               "_strongs": "03750"
            },
            {
               "strongs": "3751",
               "greek": [
                  {
                     "_BETA": "O)SFU=S",
                     "_unicode": "ὀσφῦς",
                     "_translit": "osphŷs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "os-foos'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "the loin (externally), i.e. the hip; internally\n (by extension) procreative power",
               "kjv_def": ":--loin.",
               "_strongs": "03751"
            },
            {
               "strongs": "3752",
               "greek": [
                  {
                     "_BETA": "O(/TAN",
                     "_unicode": "ὅταν",
                     "_translit": "hótan"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hot'-an"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3753"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "302"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "whenever (implying hypothesis or more or less\n uncertainty); also causatively (conjunctionally) inasmuch as",
               "kjv_def": ":--as long\n (soon) as, that, + till, when(-soever), while.",
               "_strongs": "03752"
            },
            {
               "strongs": "3753",
               "greek": [
                  {
                     "_BETA": "O(/TE",
                     "_unicode": "ὅτε",
                     "_translit": "hóte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hot'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5037"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "at which (thing) too, i.e. when",
               "kjv_def": ":--after (that), as\n soon as, that, when, while.",
               "_strongs": "03753"
            },
            {
               "strongs": "3754",
               "greek": [
                  {
                     "_BETA": "O(/TI",
                     "_unicode": "ὅτι",
                     "_translit": "hóti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hot'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3748"
                     }
                  ],
                  "__text": "neuter of \n as conjunction;"
               },
               "strongs_def": "demonstrative, that (sometimes\n redundant); causative, because",
               "kjv_def": ":--as concerning that, as though,\n because (that), for (that), how (that), (in) that, though, why.",
               "_strongs": "03754"
            },
            {
               "strongs": "3755",
               "greek": [
                  {
                     "_BETA": "O(/TOU",
                     "_unicode": "ὅτου",
                     "_translit": "hótou"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hot'-oo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3748"
                     }
                  ],
                  "__text": "for the genitive case of \n (as adverb);"
               },
               "strongs_def": "during which same time,\n i.e. whilst",
               "kjv_def": ":--whiles.",
               "_strongs": "03755"
            },
            {
               "strongs": "3756",
               "greek": [
                  {
                     "_BETA": "OU)",
                     "_unicode": "οὐ",
                     "_translit": "ou"
                  },
                  {
                     "_BETA": "OU)K",
                     "_unicode": "οὐκ",
                     "_translit": "ouk"
                  },
                  {
                     "_BETA": "OU)X",
                     "_unicode": "οὐχ",
                     "_translit": "ouch"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo"
                  },
                  {
                     "_strongs": "ook"
                  },
                  {
                     "_strongs": "ookh"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3361"
                     }
                  ],
                  "__text": "the absolute negative (compare \n) adverb; no or\n not"
               },
               "kjv_def": ":--+ long, nay, neither, never, no (X man), none, (can-)not, +\n nothing, + special, un(-worthy), when, + without, + yet but.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3364"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3372"
                  }
               ],
               "_strongs": "03756",
               "__text": ", also (before a vowel)\n      \n  \n, and (before an aspirate)\n      \n  \n\n\n \n See also\n \n, \n."
            },
            {
               "strongs": "3757",
               "greek": [
                  {
                     "_BETA": "OU(=",
                     "_unicode": "οὗ",
                     "_translit": "hoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "genitive case of \n as adverb;"
               },
               "strongs_def": "at which place, i.e.\n where",
               "kjv_def": ":--where(-in), whither(-soever).",
               "_strongs": "03757"
            },
            {
               "strongs": "3758",
               "greek": [
                  {
                     "_BETA": "OU)A/",
                     "_unicode": "οὐά",
                     "_translit": "ouá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-ah'"
                  }
               ],
               "strongs_derivation": "a primary exclamation of surprise;",
               "strongs_def": "\"ah\"",
               "kjv_def": ":--ah.",
               "_strongs": "03758"
            },
            {
               "strongs": "3759",
               "greek": [
                  {
                     "_BETA": "OU)AI/",
                     "_unicode": "οὐαί",
                     "_translit": "ouaí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-ah'-ee"
                  }
               ],
               "strongs_derivation": "a primary exclamation of grief;",
               "strongs_def": "\"woe\"",
               "kjv_def": ":--alas, woe.",
               "_strongs": "03759"
            },
            {
               "strongs": "3760",
               "greek": [
                  {
                     "_BETA": "OU)DAMW=S",
                     "_unicode": "οὐδαμῶς",
                     "_translit": "oudamōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-dam-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3762"
                     }
                  ],
                  "__text": "adverb from (the feminine) of \n;"
               },
               "strongs_def": "by no means",
               "kjv_def": ":--not.",
               "_strongs": "03760"
            },
            {
               "strongs": "3761",
               "greek": [
                  {
                     "_BETA": "OU)DE/",
                     "_unicode": "οὐδέ",
                     "_translit": "oudé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-deh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1161"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not however, i.e. neither, nor, not even",
               "kjv_def": ":--neither\n (indeed), never, no (more, nor, not), nor (yet), (also, even, then)\n not (even, so much as), + nothing, so much as.",
               "_strongs": "03761"
            },
            {
               "strongs": "3762",
               "greek": [
                  {
                     "_BETA": "OU)DEI/S",
                     "_unicode": "οὐδείς",
                     "_translit": "oudeís"
                  },
                  {
                     "_BETA": "OU)DEMI/A",
                     "_unicode": "οὐδεμία",
                     "_translit": "oudemía"
                  },
                  {
                     "_BETA": "OU)DE/N",
                     "_unicode": "οὐδέν",
                     "_translit": "oudén"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-dice'"
                  },
                  {
                     "_strongs": "oo-dem-ee'-ah"
                  },
                  {
                     "_strongs": "oo-den'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3761"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1520"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not even one (man, woman or thing), i.e. none,\n nobody, nothing",
               "kjv_def": ":--any (man), aught, man, neither any (thing), never\n (man), no (man), none (+ of these things), not (any, at all, -thing),\n nought.",
               "_strongs": "03762",
               "__text": ", including feminine\n      \n  \n, and neuter"
            },
            {
               "strongs": "3763",
               "greek": [
                  {
                     "_BETA": "OU)DE/POTE",
                     "_unicode": "οὐδέποτε",
                     "_translit": "oudépote"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-dep'-ot-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3761"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not even at any time, i.e. never at all",
               "kjv_def": ":--neither\n at any time, never, nothing at any time.",
               "_strongs": "03763"
            },
            {
               "strongs": "3764",
               "greek": [
                  {
                     "_BETA": "OU)DE/PW",
                     "_unicode": "οὐδέπω",
                     "_translit": "oudépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-dep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3761"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4452"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not even yet",
               "kjv_def": ":--as yet not, never before (yet),\n (not) yet.",
               "_strongs": "03764"
            },
            {
               "strongs": "3765",
               "greek": [
                  {
                     "_BETA": "OU)KE/TI",
                     "_unicode": "οὐκέτι",
                     "_translit": "oukéti"
                  },
                  {
                     "_BETA": "OU)K E)/TI",
                     "_unicode": "οὐκ ἔτι",
                     "_translit": "ouk éti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ook-et'-ee"
                  },
                  {
                     "_strongs": "ook et'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not yet, no longer",
               "kjv_def": ":--after that (not), (not) any\n more, henceforth (hereafter) not, no longer (more), not as yet (now),\n now no more (not), yet (not).",
               "_strongs": "03765",
               "__text": ", also (separately)"
            },
            {
               "strongs": "3766",
               "greek": [
                  {
                     "_BETA": "OU)KOU=N",
                     "_unicode": "οὐκοῦν",
                     "_translit": "oukoûn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ook-oon'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3767"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "is it not therefore that, i.e. (affirmatively)\n hence or so",
               "kjv_def": ":--then.",
               "_strongs": "03766"
            },
            {
               "strongs": "3767",
               "greek": [
                  {
                     "_BETA": "OU)=N",
                     "_unicode": "οὖν",
                     "_translit": "oûn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oon"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "(adverbially) certainly, or\n (conjunctionally) accordingly",
               "kjv_def": ":--and (so, truly), but, now (then), so\n (likewise then), then, therefore, verily, wherefore.",
               "_strongs": "03767"
            },
            {
               "strongs": "3768",
               "greek": [
                  {
                     "_BETA": "OU)/PW",
                     "_unicode": "οὔπω",
                     "_translit": "oúpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4452"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not yet",
               "kjv_def": ":--hitherto not, (no…) as yet, not yet.",
               "_strongs": "03768"
            },
            {
               "strongs": "3769",
               "greek": [
                  {
                     "_BETA": "OU)RA/",
                     "_unicode": "οὐρά",
                     "_translit": "ourá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-rah'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a tail",
               "kjv_def": ":--tail.",
               "_strongs": "03769"
            },
            {
               "strongs": "3770",
               "greek": [
                  {
                     "_BETA": "OU)RA/NIOS",
                     "_unicode": "οὐράνιος",
                     "_translit": "ouránios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-ran'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3772"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "celestial, i.e. belonging to or coming from the\n sky",
               "kjv_def": ":--heavenly.",
               "_strongs": "03770"
            },
            {
               "strongs": "3771",
               "greek": [
                  {
                     "_BETA": "OU)RANO/QEN",
                     "_unicode": "οὐρανόθεν",
                     "_translit": "ouranóthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-ran-oth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3772"
                     }
                  ],
                  "__text": "from \n and the enclitic of source;"
               },
               "strongs_def": "from the sky",
               "kjv_def": ":--from heaven.",
               "_strongs": "03771"
            },
            {
               "strongs": "3772",
               "greek": [
                  {
                     "_BETA": "OU)RANO/S",
                     "_unicode": "οὐρανός",
                     "_translit": "ouranós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-ran-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3735"
                     }
                  ],
                  "__text": "perhaps from the same as \n (through the idea of elevation);"
               },
               "strongs_def": "the\n sky; by extension, heaven (as the abode of God); by implication,\n happiness, power, eternity; specially, the Gospel\n (Christianity)",
               "kjv_def": ":--air, heaven(-ly), sky.",
               "_strongs": "03772"
            },
            {
               "strongs": "3773",
               "greek": [
                  {
                     "_BETA": "*OU)RBANO/S",
                     "_unicode": "Οὐρβανός",
                     "_translit": "Ourbanós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oor-ban-os'"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Urbanus (of the city, \"urbane\"), a\n Christian",
               "kjv_def": ":--Urbanus.",
               "_strongs": "03773"
            },
            {
               "strongs": "3774",
               "greek": [
                  {
                     "_BETA": "*OU)RI/AS",
                     "_unicode": "Οὐρίας",
                     "_translit": "Ourías"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-ree'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0223"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Urias (i.e. Urijah), a Hittite",
               "kjv_def": ":--Urias.",
               "_strongs": "03774"
            },
            {
               "strongs": "3775",
               "greek": [
                  {
                     "_BETA": "OU)=S",
                     "_unicode": "οὖς",
                     "_translit": "oûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ooce"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "the ear (physically or mentally)",
               "kjv_def": ":--ear.",
               "_strongs": "03775"
            },
            {
               "strongs": "3776",
               "greek": [
                  {
                     "_BETA": "OU)SI/A",
                     "_unicode": "οὐσία",
                     "_translit": "ousía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5607"
                     }
                  ],
                  "__text": "from the feminine of \n;"
               },
               "strongs_def": "substance, i.e. property\n (possessions)",
               "kjv_def": ":--goods, substance.",
               "_strongs": "03776"
            },
            {
               "strongs": "3777",
               "greek": [
                  {
                     "_BETA": "OU)/TE",
                     "_unicode": "οὔτε",
                     "_translit": "oúte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo'-teh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5037"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "not too, i.e. neither or nor; by analogy, not\n even",
               "kjv_def": ":--neither, none, nor (yet), (no, yet) not, nothing.",
               "_strongs": "03777"
            },
            {
               "strongs": "3778",
               "greek": [
                  {
                     "_BETA": "OU(=TOS",
                     "_unicode": "οὗτος",
                     "_translit": "hoûtos"
                  },
                  {
                     "_BETA": "OU(=TOI",
                     "_unicode": "οὗτοι",
                     "_translit": "hoûtoi"
                  },
                  {
                     "_BETA": "AU(/TH",
                     "_unicode": "αὕτη",
                     "_translit": "haútē"
                  },
                  {
                     "_BETA": "AU(/TAI",
                     "_unicode": "αὕται",
                     "_translit": "haútai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo'-tos"
                  },
                  {
                     "_strongs": "hoo'-toy"
                  },
                  {
                     "_strongs": "how'-tay"
                  },
                  {
                     "_strongs": "how'-tahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "__text": "from the article \n and \n;"
               },
               "strongs_def": "the he (she or it), i.e. this or that\n (often with article repeated)",
               "kjv_def": ":--he (it was that), hereof, it, she,\n such as, the same, these, they, this (man, same, woman), which, who.",
               "_strongs": "03778",
               "__text": ", including nominative masculine plural\n      \n  \n, nominative feminine singular\n      \n  \n, and nominative feminine plural"
            },
            {
               "strongs": "3779",
               "greek": [
                  {
                     "_BETA": "OU(/TW",
                     "_unicode": "οὕτω",
                     "_translit": "hoútō"
                  },
                  {
                     "_BETA": "OU(/TWS",
                     "_unicode": "οὕτως",
                     "_translit": "hoútōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo'-to"
                  },
                  {
                     "_strongs": "hoo'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "in this way (referring to what precedes or\n follows)",
               "kjv_def": ":--after that, after (in) this manner, as, even (so), for all\n that, like(-wise), no more, on this fashion(-wise), so (in like\n manner), thus, what.",
               "_strongs": "03779",
               "__text": ", or (before a vowel"
            },
            {
               "strongs": "3780",
               "greek": [
                  {
                     "_BETA": "OU)XI/",
                     "_unicode": "οὐχί",
                     "_translit": "ouchí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oo-khee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     }
                  ],
                  "__text": "intensive of \n;"
               },
               "strongs_def": "not indeed",
               "kjv_def": ":--nay, not.",
               "_strongs": "03780"
            },
            {
               "strongs": "3781",
               "greek": [
                  {
                     "_BETA": "O)FEILE/THS",
                     "_unicode": "ὀφειλέτης",
                     "_translit": "opheilétēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of-i-let'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3784"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an ower, i.e. person indebted; figuratively, a delinquent;\n morally, a transgressor (against God)",
               "kjv_def": ":--debtor, which owed, sinner.",
               "_strongs": "03781"
            },
            {
               "strongs": "3782",
               "greek": [
                  {
                     "_BETA": "O)FEILH/",
                     "_unicode": "ὀφειλή",
                     "_translit": "opheilḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of-i-lay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3784"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "indebtedness, i.e. (concretely) a sum owed; figuratively,\n obligation, i.e. (conjugal) duty",
               "kjv_def": ":--debt, due.",
               "_strongs": "03782"
            },
            {
               "strongs": "3783",
               "greek": [
                  {
                     "_BETA": "O)FEI/LHMA",
                     "_unicode": "ὀφείλημα",
                     "_translit": "opheílēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of-i'-lay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3784"
                     }
                  ],
                  "__text": "from (the alternate of) \n;"
               },
               "strongs_def": "something owed, i.e. (figuratively) a\n due; morally, a fault",
               "kjv_def": ":--debt.",
               "_strongs": "03783"
            },
            {
               "strongs": "3784",
               "greek": [
                  {
                     "_BETA": "O)FEI/LW",
                     "_unicode": "ὀφείλω",
                     "_translit": "opheílō"
                  },
                  {
                     "_BETA": "O)FEILE/W",
                     "_unicode": "ὀφειλέω",
                     "_translit": "opheiléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of-i'-lo"
                  },
                  {
                     "_strongs": "of-i-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3786"
                     }
                  ],
                  "__text": "probably from the base of \n (through the idea of accruing);"
               },
               "strongs_def": "to owe\n (pecuniarily); figuratively, to be under obligation (ought, must,\n should); morally, to fail in duty",
               "kjv_def": ":--behove, be bound, (be) debt(-or),\n (be) due(-ty), be guilty (indebted), (must) need(-s), ought, owe,\n should.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3785"
                  }
               ],
               "_strongs": "03784",
               "__text": ", or (in certain tenses), its prolonged form\n      \n  \n\n\n \n See also \n."
            },
            {
               "strongs": "3785",
               "greek": [
                  {
                     "_BETA": "O)/FELON",
                     "_unicode": "ὄφελον",
                     "_translit": "óphelon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of'-el-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3784"
                     }
                  ],
                  "__text": "first person singular of a past tense of \n;"
               },
               "strongs_def": "I ought (wish), i.e.\n (interjection) oh that!",
               "kjv_def": ":--would (to God).",
               "_strongs": "03785"
            },
            {
               "strongs": "3786",
               "greek": [
                  {
                     "_BETA": "O)/FELOS",
                     "_unicode": "ὄφελος",
                     "_translit": "óphelos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of'-el-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "O)FE/LLW",
                        "_unicode": "ὀφέλλω",
                        "_translit": "ophéllō"
                     }
                  ],
                  "__text": "from \n (to heap up, i.e. accumulate or benefit);"
               },
               "strongs_def": "gain",
               "kjv_def": ":--advantageth, profit.",
               "_strongs": "03786"
            },
            {
               "strongs": "3787",
               "greek": [
                  {
                     "_BETA": "O)FQALMODOULEI/A",
                     "_unicode": "ὀφθαλμοδουλεία",
                     "_translit": "ophthalmodouleía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of-thal-mod-oo-li'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3788"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1397"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "sight-labor, i.e. that needs watching\n (remissness)",
               "kjv_def": ":--eye-service.",
               "_strongs": "03787"
            },
            {
               "strongs": "3788",
               "greek": [
                  {
                     "_BETA": "O)FQALMO/S",
                     "_unicode": "ὀφθαλμός",
                     "_translit": "ophthalmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of-thal-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the eye (literally or figuratively); by implication,\n vision; figuratively, envy (from the jealous side-glance)",
               "kjv_def": ":--eye,\n sight.",
               "_strongs": "03788"
            },
            {
               "strongs": "3789",
               "greek": [
                  {
                     "_BETA": "O)/FIS",
                     "_unicode": "ὄφις",
                     "_translit": "óphis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "probably from \n (through the idea of sharpness of vision);"
               },
               "strongs_def": "a snake,\n figuratively, (as a type of sly cunning) an artful malicious person,\n especially Satan",
               "kjv_def": ":--serpent.",
               "_strongs": "03789"
            },
            {
               "strongs": "3790",
               "greek": [
                  {
                     "_BETA": "O)FRU=S",
                     "_unicode": "ὀφρῦς",
                     "_translit": "ophrŷs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "of-roos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "perhaps from \n (through the idea of the shading or proximity to the\n organ of vision);"
               },
               "strongs_def": "the eye-\"brow\" or forehead, i.e. (figuratively) the\n brink of a precipice",
               "kjv_def": ":--brow.",
               "_strongs": "03790"
            },
            {
               "strongs": "3791",
               "greek": [
                  {
                     "_BETA": "O)XLE/W",
                     "_unicode": "ὀχλέω",
                     "_translit": "ochléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "okh-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3793"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to mob, i.e. (by implication) to harass",
               "kjv_def": ":--vex.",
               "_strongs": "03791"
            },
            {
               "strongs": "3792",
               "greek": [
                  {
                     "_BETA": "O)XLOPOIE/W",
                     "_unicode": "ὀχλοποιέω",
                     "_translit": "ochlopoiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "okh-lop-oy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3793"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to make a crowd, i.e. raise a public\n disturbance",
               "kjv_def": ":--gather a company.",
               "_strongs": "03792"
            },
            {
               "strongs": "3793",
               "greek": [
                  {
                     "_BETA": "O)/XLOS",
                     "_unicode": "ὄχλος",
                     "_translit": "óchlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "okh'los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from a derivative of \n (meaning a vehicle);"
               },
               "strongs_def": "a throng (as borne\n along); by implication, the rabble; by extension, a class of people;\n figuratively, a riot",
               "kjv_def": ":--company, multitude, number (of people), people,\n press.",
               "_strongs": "03793"
            },
            {
               "strongs": "3794",
               "greek": [
                  {
                     "_BETA": "O)XU/RWMA",
                     "_unicode": "ὀχύρωμα",
                     "_translit": "ochýrōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "okh-oo'-ro-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from a remote derivative of \n (meaning to fortify, through the idea\n of holding safely);"
               },
               "strongs_def": "a castle (figuratively, argument)",
               "kjv_def": ":--stronghold.",
               "_strongs": "03794"
            },
            {
               "strongs": "3795",
               "greek": [
                  {
                     "_BETA": "O)YA/RION",
                     "_unicode": "ὀψάριον",
                     "_translit": "opsárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-sar'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3702"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of the base of \n;"
               },
               "strongs_def": "a relish to other\n food (as if cooked sauce), i.e. (specially), fish (presumably salted\n and dried as a condiment)",
               "kjv_def": ":--fish.",
               "_strongs": "03795"
            },
            {
               "strongs": "3796",
               "greek": [
                  {
                     "_BETA": "O)YE/",
                     "_unicode": "ὀψέ",
                     "_translit": "opsé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-seh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3694"
                     }
                  ],
                  "__text": "from the same as \n (through the idea of backwardness);"
               },
               "strongs_def": "(adverbially) late in the day; by extension, after the close of the\n day",
               "kjv_def": ":--(at) even, in the end.",
               "_strongs": "03796"
            },
            {
               "strongs": "3797",
               "greek": [
                  {
                     "_BETA": "O)/YIMOS",
                     "_unicode": "ὄψιμος",
                     "_translit": "ópsimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op'-sim-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3796"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "later, i.e. vernal (showering)",
               "kjv_def": ":--latter.",
               "_strongs": "03797"
            },
            {
               "strongs": "3798",
               "greek": [
                  {
                     "_BETA": "O)/YIOS",
                     "_unicode": "ὄψιος",
                     "_translit": "ópsios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3796"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "late; feminine (as noun) afternoon (early eve) or nightfall\n (later eve)",
               "kjv_def": ":--even(-ing, (-tide)).",
               "_strongs": "03798"
            },
            {
               "strongs": "3799",
               "greek": [
                  {
                     "_BETA": "O)/YIS",
                     "_unicode": "ὄψις",
                     "_translit": "ópsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "properly, sight (the act), i.e. (by implication) the\n visage, an external show",
               "kjv_def": ":--appearance, countenance, face.",
               "_strongs": "03799"
            },
            {
               "strongs": "3800",
               "greek": [
                  {
                     "_BETA": "O)YW/NION",
                     "_unicode": "ὀψώνιον",
                     "_translit": "opsṓnion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "op-so'-nee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3795"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of the same as \n;"
               },
               "strongs_def": "rations for a\n soldier, i.e. (by extension) his stipend or pay",
               "kjv_def": ":-- wages.",
               "_strongs": "03800"
            },
            {
               "strongs": "3801",
               "greek": [
                  {
                     "_BETA": "O( W)\\N KAI/ O( H)=N KAI/ O( E)RXO/MENOS",
                     "_unicode": "ὁ ὢν καί ὁ ἦν καί ὁ ἐρχόμενος",
                     "_translit": "ho ṑn kaí ho ēn kaí ho erchómenos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho own kahee ho ane kahee ho er-khom'-en-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     }
                  ],
                  "__text": "a phrase combining \n with the present participle and imperfect of\n \n and the present participle of \n by means of \n;"
               },
               "strongs_def": "the one\n being and the one that was and the one coming, i.e. the Eternal, as a\n divine epithet of Christ",
               "kjv_def": ":--which art (is, was), and (which) wast (is,\n was), and art (is) to come (shalt be).",
               "_strongs": "03801"
            },
            {
               "strongs": "3802",
               "greek": [
                  {
                     "_BETA": "PAGIDEU/W",
                     "_unicode": "παγιδεύω",
                     "_translit": "pagideúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pag-id-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3803"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to ensnare (figuratively)",
               "kjv_def": ":--entangle.",
               "_strongs": "03802"
            },
            {
               "strongs": "3803",
               "greek": [
                  {
                     "_BETA": "PAGI/S",
                     "_unicode": "παγίς",
                     "_translit": "pagís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pag-ece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4078"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a trap (as fastened by a noose or notch); figuratively, a\n trick or statagem (temptation)",
               "kjv_def": ":--snare.",
               "_strongs": "03803"
            },
            {
               "strongs": "3804",
               "greek": [
                  {
                     "_BETA": "PA/QHMA",
                     "_unicode": "πάθημα",
                     "_translit": "páthēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "path'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3806"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "something undergone, i.e. hardship\n or pain; subjectively, an emotion or influence",
               "kjv_def": ":-- affection,\n affliction, motion, suffering.",
               "_strongs": "03804"
            },
            {
               "strongs": "3805",
               "greek": [
                  {
                     "_BETA": "PAQHTO/S",
                     "_unicode": "παθητός",
                     "_translit": "pathētós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "path-ay-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3804"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "liable (i.e. doomed) to experience\n pain",
               "kjv_def": ":--suffer.",
               "_strongs": "03805"
            },
            {
               "strongs": "3806",
               "greek": [
                  {
                     "_BETA": "PA/QOS",
                     "_unicode": "πάθος",
                     "_translit": "páthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "path'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3958"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "properly, suffering (\"pathos\"), i.e.\n (subjectively) a passion (especially concupiscence)",
               "kjv_def": ":-- (inordinate)\n affection, lust.",
               "_strongs": "03806"
            },
            {
               "strongs": "3807",
               "greek": [
                  {
                     "_BETA": "PAIDAGWGO/S",
                     "_unicode": "παιδαγωγός",
                     "_translit": "paidagōgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pahee-dag-o-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3816"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and a reduplicated form of \n;"
               },
               "strongs_def": "a boy-leader, i.e. a servant\n whose office it was to take the children to school; (by implication,\n (figuratively) a tutor (\"pædagogue\"))",
               "kjv_def": ":-- instructor, schoolmaster.",
               "_strongs": "03807"
            },
            {
               "strongs": "3808",
               "greek": [
                  {
                     "_BETA": "PAIDA/RION",
                     "_unicode": "παιδάριον",
                     "_translit": "paidárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pahee-dar'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3816"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a little boy",
               "kjv_def": ":--child, lad.",
               "_strongs": "03808"
            },
            {
               "strongs": "3809",
               "greek": [
                  {
                     "_BETA": "PAIDEI/A",
                     "_unicode": "παιδεία",
                     "_translit": "paideía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pahee-di'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3811"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "tutorage, i.e. education or training; by implication,\n disciplinary correction",
               "kjv_def": ":--chastening, chastisement, instruction,\n nurture.",
               "_strongs": "03809"
            },
            {
               "strongs": "3810",
               "greek": [
                  {
                     "_BETA": "PAIDEUTH/S",
                     "_unicode": "παιδευτής",
                     "_translit": "paideutḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pahee-dyoo-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3811"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a trainer, i.e. teacher or (by implication)\n discipliner",
               "kjv_def": ":--which corrected, instructor.",
               "_strongs": "03810"
            },
            {
               "strongs": "3811",
               "greek": [
                  {
                     "_BETA": "PAIDEU/W",
                     "_unicode": "παιδεύω",
                     "_translit": "paideúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pahee-dyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3816"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to train up a child, i.e. educate, or (by implication),\n discipline (by punishment)",
               "kjv_def": ":--chasten(-ise), instruct, learn, teach.",
               "_strongs": "03811"
            },
            {
               "strongs": "3812",
               "greek": [
                  {
                     "_BETA": "PAIDIO/QEN",
                     "_unicode": "παιδιόθεν",
                     "_translit": "paidióthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pahee-dee-oth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3813"
                     }
                  ],
                  "__text": "adverb (of source) from \n;"
               },
               "strongs_def": "from infancy",
               "kjv_def": ":--of a child.",
               "_strongs": "03812"
            },
            {
               "strongs": "3813",
               "greek": [
                  {
                     "_BETA": "PAIDI/ON",
                     "_unicode": "παιδίον",
                     "_translit": "paidíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pahee-dee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3816"
                     }
                  ],
                  "__text": "neuter diminutive of \n;"
               },
               "strongs_def": "a childling (of either sex), i.e.\n (properly), an infant, or (by extension) a half-grown boy or girl;\n figuratively, an immature Christian",
               "kjv_def": ":--(little, young) child, damsel.",
               "_strongs": "03813"
            },
            {
               "strongs": "3814",
               "greek": [
                  {
                     "_BETA": "PAIDI/SKH",
                     "_unicode": "παιδίσκη",
                     "_translit": "paidískē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pahee-dis'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3816"
                     }
                  ],
                  "__text": "feminine diminutive of \n;"
               },
               "strongs_def": "a girl, i.e. (specially), a female slave\n or servant",
               "kjv_def": ":--bondmaid(-woman), damsel, maid(-en).",
               "_strongs": "03814"
            },
            {
               "strongs": "3815",
               "greek": [
                  {
                     "_BETA": "PAI/ZW",
                     "_unicode": "παίζω",
                     "_translit": "paízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "paheed'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3816"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to sport (as a boy)",
               "kjv_def": ":--play.",
               "_strongs": "03815"
            },
            {
               "strongs": "3816",
               "greek": [
                  {
                     "_BETA": "PAI=S",
                     "_unicode": "παῖς",
                     "_translit": "paîs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "paheece"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3817"
                     }
                  ],
                  "__text": "perhaps from \n;"
               },
               "strongs_def": "a boy (as often beaten with impunity), or (by\n analogy), a girl, and (genitive case) a child; specially, a slave or\n servant (especially a minister to a king; and by eminence to\n God)",
               "kjv_def": ":--child, maid(-en), (man) servant, son, young man.",
               "_strongs": "03816"
            },
            {
               "strongs": "3817",
               "greek": [
                  {
                     "_BETA": "PAI/W",
                     "_unicode": "παίω",
                     "_translit": "paíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pah'-yo"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5180"
                     }
                  ],
                  "__text": "to hit (as if by a single blow and less violently than\n \n); specially, to sting (as a scorpion)"
               },
               "kjv_def": ":--smite, strike.",
               "_strongs": "03817"
            },
            {
               "strongs": "3818",
               "greek": [
                  {
                     "_BETA": "*PAKATIANH/",
                     "_unicode": "Πακατιανή",
                     "_translit": "Pakatianḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pak-at-ee-an-ay'"
                  }
               ],
               "strongs_derivation": "feminine of an adjective of uncertain derivation;",
               "strongs_def": "Pacatianian, a\n section of Phrygia",
               "kjv_def": ":--Pacatiana.",
               "_strongs": "03818"
            },
            {
               "strongs": "3819",
               "greek": [
                  {
                     "_BETA": "PA/LAI",
                     "_unicode": "πάλαι",
                     "_translit": "pálai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pal'-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3825"
                     }
                  ],
                  "__text": "probably another form for \n (through the idea of retrocession);"
               },
               "strongs_def": "(adverbially) formerly, or (by relatively) sometime since;\n (elliptically as adjective) ancient",
               "kjv_def": ":--any while, a great while ago,\n (of) old, in time past.",
               "_strongs": "03819"
            },
            {
               "strongs": "3820",
               "greek": [
                  {
                     "_BETA": "PALAIO/S",
                     "_unicode": "παλαιός",
                     "_translit": "palaiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pal-ah-yos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3819"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "antique, i.e. not recent, worn out",
               "kjv_def": ":--old.",
               "_strongs": "03820"
            },
            {
               "strongs": "3821",
               "greek": [
                  {
                     "_BETA": "PALAIO/THS",
                     "_unicode": "παλαιότης",
                     "_translit": "palaiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pal-ah-yot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3820"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "antiquatedness",
               "kjv_def": ":--oldness.",
               "_strongs": "03821"
            },
            {
               "strongs": "3822",
               "greek": [
                  {
                     "_BETA": "PALAIO/W",
                     "_unicode": "παλαιόω",
                     "_translit": "palaióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pal-ah-yo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3820"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make (passively, become) worn out, or declare\n obsolete",
               "kjv_def": ":--decay, make (wax) old.",
               "_strongs": "03822"
            },
            {
               "strongs": "3823",
               "greek": [
                  {
                     "_BETA": "PA/LH",
                     "_unicode": "πάλη",
                     "_translit": "pálē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pal'-ay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PA/LLW",
                        "_unicode": "πάλλω",
                        "_translit": "pállō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n (to vibrate; another form for \n);"
               },
               "strongs_def": "wrestling",
               "kjv_def": ":--+ wrestle.",
               "_strongs": "03823"
            },
            {
               "strongs": "3824",
               "greek": [
                  {
                     "_BETA": "PALIGGENESI/A",
                     "_unicode": "παλιγγενεσία",
                     "_translit": "palingenesía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pal-ing-ghen-es-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3825"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1078"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(spiritual) rebirth (the state or the act), i.e.\n (figuratively) spiritual renovation; specially, Messianic\n restoration",
               "kjv_def": ":--regeneration.",
               "_strongs": "03824"
            },
            {
               "strongs": "3825",
               "greek": [
                  {
                     "_BETA": "PA/LIN",
                     "_unicode": "πάλιν",
                     "_translit": "pálin"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pal'-in"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3823"
                     }
                  ],
                  "__text": "probably from the same as \n (through the idea of oscillatory\n repetition);"
               },
               "strongs_def": "(adverbially) anew, i.e. (of place) back, (of time) once\n more, or (conjunctionally) furthermore or on the other hand",
               "kjv_def": ":--again.",
               "_strongs": "03825"
            },
            {
               "strongs": "3826",
               "greek": [
                  {
                     "_BETA": "PAMPLHQEI/",
                     "_unicode": "παμπληθεί",
                     "_translit": "pamplētheí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pam-play-thi'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4128"
                     }
                  ],
                  "__text": "dative case (adverb) of a compound of \n and \n;"
               },
               "strongs_def": "in full\n multitude, i.e. concertedly or simultaneously",
               "kjv_def": ":--all at once.",
               "_strongs": "03826"
            },
            {
               "strongs": "3827",
               "greek": [
                  {
                     "_BETA": "PA/MPOLUS",
                     "_unicode": "πάμπολυς",
                     "_translit": "pámpolys"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pam-pol-ooce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "full many, i.e. immense",
               "kjv_def": ":--very great.",
               "_strongs": "03827"
            },
            {
               "strongs": "3828",
               "greek": [
                  {
                     "_BETA": "*PAMFULI/A",
                     "_unicode": "Παμφυλία",
                     "_translit": "Pamphylía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pam-fool-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4443"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "every-tribal, i.e. heterogeneous\n (\n being implied); Pamphylia, a region of Asia Minor"
               },
               "kjv_def": ":--Pamphylia.",
               "_strongs": "03828"
            },
            {
               "strongs": "3829",
               "greek": [
                  {
                     "_BETA": "PANDOXEI=ON",
                     "_unicode": "πανδοχεῖον",
                     "_translit": "pandocheîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-dokk-i'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "neuter of a presumed compound of \n and a derivative of \n;"
               },
               "strongs_def": "all-receptive, i.e. a public lodging-place (caravanserai or\n khan)",
               "kjv_def": ":--inn.",
               "_strongs": "03829"
            },
            {
               "strongs": "3830",
               "greek": [
                  {
                     "_BETA": "PANDOXEU/S",
                     "_unicode": "πανδοχεύς",
                     "_translit": "pandocheús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-dokh-yoos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3829"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "an innkeeper (warden of a caravanserai)",
               "kjv_def": ":--host.",
               "_strongs": "03830"
            },
            {
               "strongs": "3831",
               "greek": [
                  {
                     "_BETA": "PANH/GURIS",
                     "_unicode": "πανήγυρις",
                     "_translit": "panḗgyris"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-ay'-goo-ris"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "a mass-meeting, i.e. (figuratively)\n universal companionship",
               "kjv_def": ":--general assembly.",
               "_strongs": "03831"
            },
            {
               "strongs": "3832",
               "greek": [
                  {
                     "_BETA": "PANOIKI/",
                     "_unicode": "πανοικί",
                     "_translit": "panoikí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-oy-kee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     }
                  ],
                  "__text": "adverb from \n and \n;"
               },
               "strongs_def": "with the whole family",
               "kjv_def": ":--with all his house.",
               "_strongs": "03832"
            },
            {
               "strongs": "3833",
               "greek": [
                  {
                     "_BETA": "PANOPLI/A",
                     "_unicode": "πανοπλία",
                     "_translit": "panoplía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-op-lee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3696"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "full armor (\"panoply\")",
               "kjv_def": ":--all (whole)\n armour.",
               "_strongs": "03833"
            },
            {
               "strongs": "3834",
               "greek": [
                  {
                     "_BETA": "PANOURGI/A",
                     "_unicode": "πανουργία",
                     "_translit": "panourgía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-oorg-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3835"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "adroitness, i.e. (in a bad sense) trickery or\n sophistry",
               "kjv_def": ":--(cunning) craftiness, subtilty.",
               "_strongs": "03834"
            },
            {
               "strongs": "3835",
               "greek": [
                  {
                     "_BETA": "PANOU=RGOS",
                     "_unicode": "πανοῦργος",
                     "_translit": "panoûrgos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-oor'-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "all-working, i.e. adroit (shrewd)",
               "kjv_def": ":--crafty.",
               "_strongs": "03835"
            },
            {
               "strongs": "3836",
               "greek": [
                  {
                     "_BETA": "PANTAXO/QEN",
                     "_unicode": "πανταχόθεν",
                     "_translit": "pantachóthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-takh-oth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3837"
                     }
                  ],
                  "__text": "adverb (of source) from \n;"
               },
               "strongs_def": "from all directions",
               "kjv_def": ":--from every\n quarter.",
               "_strongs": "03836"
            },
            {
               "strongs": "3837",
               "greek": [
                  {
                     "_BETA": "PANTAXOU=",
                     "_unicode": "πανταχοῦ",
                     "_translit": "pantachoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-takh-oo'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     }
                  ],
                  "__text": "genitive case (as adverb of place) of a presumed derivative of \n;"
               },
               "strongs_def": "universally",
               "kjv_def": ":--in all places, everywhere.",
               "_strongs": "03837"
            },
            {
               "strongs": "3838",
               "greek": [
                  {
                     "_BETA": "PANTELH/S",
                     "_unicode": "παντελής",
                     "_translit": "pantelḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-tel-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "full-ended, i.e. entire (neuter as noun,\n completion)",
               "kjv_def": ":--+ in (no) wise, uttermost.",
               "_strongs": "03838"
            },
            {
               "strongs": "3839",
               "greek": [
                  {
                     "_BETA": "PA/NTH",
                     "_unicode": "πάντη",
                     "_translit": "pántē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan'-tay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     }
                  ],
                  "__text": "adverb (of manner) from \n;"
               },
               "strongs_def": "wholly",
               "kjv_def": ":--always.",
               "_strongs": "03839"
            },
            {
               "strongs": "3840",
               "greek": [
                  {
                     "_BETA": "PA/NTOQEN",
                     "_unicode": "πάντοθεν",
                     "_translit": "pántothen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-toth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     }
                  ],
                  "__text": "adverb (of source) from \n;"
               },
               "strongs_def": "from (i.e. on) all sides",
               "kjv_def": ":--on every\n side, round about.",
               "_strongs": "03840"
            },
            {
               "strongs": "3841",
               "greek": [
                  {
                     "_BETA": "PANTOKRA/TWR",
                     "_unicode": "παντοκράτωρ",
                     "_translit": "pantokrátōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan-tok-rat'-ore"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the all-ruling, i.e. God (as absolute and\n universal sovereign)",
               "kjv_def": ":--Almighty, Omnipotent.",
               "_strongs": "03841"
            },
            {
               "strongs": "3842",
               "greek": [
                  {
                     "_BETA": "PA/NTOTE",
                     "_unicode": "πάντοτε",
                     "_translit": "pántote"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan'-tot-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3753"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "every when, i.e. at all times",
               "kjv_def": ":--alway(-s),\n ever(-more).",
               "_strongs": "03842"
            },
            {
               "strongs": "3843",
               "greek": [
                  {
                     "_BETA": "PA/NTWS",
                     "_unicode": "πάντως",
                     "_translit": "pántōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pan'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "entirely; specially, at all events, (with negative,\n following) in no event",
               "kjv_def": ":--by all means, altogether, at all, needs, no\n doubt, in (no) wise, surely.",
               "_strongs": "03843"
            },
            {
               "strongs": "3844",
               "greek": [
                  {
                     "_BETA": "PARA/",
                     "_unicode": "παρά",
                     "_translit": "pará"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ah'"
                  }
               ],
               "strongs_derivation": "a primary preposition;",
               "strongs_def": "properly, near; i.e. (with genitive case) from\n beside (literally or figuratively), (with dative case) at (or in) the\n vicinity of (objectively or subjectively), (with accusative case) to\n the proximity with (local (especially beyond or opposed to) or causal\n (on account of)",
               "kjv_def": ":--above, against, among, at, before, by, contrary to,\n X friend, from, + give (such things as they), + that (she) had,\n X his, in, more than, nigh unto, (out) of, past, save,\n side…by, in the sight of, than, (there-)fore, with.",
               "_strongs": "03844",
               "__text": "In compounds it\n retains the same variety of application."
            },
            {
               "strongs": "3845",
               "greek": [
                  {
                     "_BETA": "PARABAI/NW",
                     "_unicode": "παραβαίνω",
                     "_translit": "parabaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ab-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to go contrary to, i.e. violate a\n command",
               "kjv_def": ":--(by) transgress(-ion).",
               "_strongs": "03845"
            },
            {
               "strongs": "3846",
               "greek": [
                  {
                     "_BETA": "PARABA/LLW",
                     "_unicode": "παραβάλλω",
                     "_translit": "parabállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ab-al'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw alongside, i.e. (reflexively) to reach a\n place, or (figuratively) to liken",
               "kjv_def": ":--arrive, compare.",
               "_strongs": "03846"
            },
            {
               "strongs": "3847",
               "greek": [
                  {
                     "_BETA": "PARA/BASIS",
                     "_unicode": "παράβασις",
                     "_translit": "parábasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ab'-as-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3845"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "violation",
               "kjv_def": ":--breaking, transgression.",
               "_strongs": "03847"
            },
            {
               "strongs": "3848",
               "greek": [
                  {
                     "_BETA": "PARABA/THS",
                     "_unicode": "παραβάτης",
                     "_translit": "parabátēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ab-at'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3845"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a violator",
               "kjv_def": ":--breaker, transgress(-or).",
               "_strongs": "03848"
            },
            {
               "strongs": "3849",
               "greek": [
                  {
                     "_BETA": "PARABIA/ZOMAI",
                     "_unicode": "παραβιάζομαι",
                     "_translit": "parabiázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ab-ee-ad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "971"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to force contrary to (nature),\n i.e. compel (by entreaty)",
               "kjv_def": ":--constrain.",
               "_strongs": "03849"
            },
            {
               "strongs": "3850",
               "greek": [
                  {
                     "_BETA": "PARABOLH/",
                     "_unicode": "παραβολή",
                     "_translit": "parabolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ab-ol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3846"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a similitude (\"parable\"), i.e. (symbolic) fictitious\n narrative (of common life conveying a moral), apothegm or\n adage",
               "kjv_def": ":--comparison, figure, parable, proverb.",
               "_strongs": "03850"
            },
            {
               "strongs": "3851",
               "greek": [
                  {
                     "_BETA": "PARABOULEU/OMAI",
                     "_unicode": "παραβουλεύομαι",
                     "_translit": "parabouleúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ab-ool-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1011"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to misconsult, i.e.\n disregard",
               "kjv_def": ":--not (to) regard(-ing).",
               "_strongs": "03851"
            },
            {
               "strongs": "3852",
               "greek": [
                  {
                     "_BETA": "PARAGGELI/A",
                     "_unicode": "παραγγελία",
                     "_translit": "parangelía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ang-gel-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3853"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a mandate",
               "kjv_def": ":--charge, command.",
               "_strongs": "03852"
            },
            {
               "strongs": "3853",
               "greek": [
                  {
                     "_BETA": "PARAGGE/LLW",
                     "_unicode": "παραγγέλλω",
                     "_translit": "parangéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ang-gel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "32"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to transmit a message, i.e. (by\n implication) to enjoin",
               "kjv_def": ":--(give in) charge, (give) command(-ment),\n declare.",
               "_strongs": "03853"
            },
            {
               "strongs": "3854",
               "greek": [
                  {
                     "_BETA": "PARAGI/NOMAI",
                     "_unicode": "παραγίνομαι",
                     "_translit": "paragínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ag-in'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to become near, i.e. approach (have arrived); by\n implication, to appear publicly",
               "kjv_def": ":--come, go, be present.",
               "_strongs": "03854"
            },
            {
               "strongs": "3855",
               "greek": [
                  {
                     "_BETA": "PARA/GW",
                     "_unicode": "παράγω",
                     "_translit": "parágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead near, i.e. (reflexively or intransitively)\n to go along or away",
               "kjv_def": ":--depart, pass (away, by, forth).",
               "_strongs": "03855"
            },
            {
               "strongs": "3856",
               "greek": [
                  {
                     "_BETA": "PARADEIGMATI/ZW",
                     "_unicode": "παραδειγματίζω",
                     "_translit": "paradeigmatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ad-igue-mat-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1165"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to show alongside (the public), i.e. expose to\n infamy",
               "kjv_def": ":--make a public example, put to an open shame.",
               "_strongs": "03856"
            },
            {
               "strongs": "3857",
               "greek": [
                  {
                     "_BETA": "PARA/DEISOS",
                     "_unicode": "παράδεισος",
                     "_translit": "parádeisos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ad'-i-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06508"
                     }
                  ],
                  "__text": "of Oriental origin (compare \n);"
               },
               "strongs_def": "a park, i.e. (specially), an Eden\n (place of future happiness, \"paradise\")",
               "kjv_def": ":--paradise.",
               "_strongs": "03857"
            },
            {
               "strongs": "3858",
               "greek": [
                  {
                     "_BETA": "PARADE/XOMAI",
                     "_unicode": "παραδέχομαι",
                     "_translit": "paradéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ad-ekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to accept near, i.e. admit or (by implication)\n delight in",
               "kjv_def": ":--receive.",
               "_strongs": "03858"
            },
            {
               "strongs": "3859",
               "greek": [
                  {
                     "_BETA": "PARADIATRIBH/",
                     "_unicode": "παραδιατριβή",
                     "_translit": "paradiatribḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ad-ee-at-ree-bay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1304"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "misemployment, i.e.\n meddlesomeness",
               "kjv_def": ":--perverse disputing.",
               "_strongs": "03859"
            },
            {
               "strongs": "3860",
               "greek": [
                  {
                     "_BETA": "PARADI/DWMI",
                     "_unicode": "παραδίδωμι",
                     "_translit": "paradídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ad-id'-o-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to surrender, i.e yield up, intrust,\n transmit",
               "kjv_def": ":--betray, bring forth, cast, commit, deliver (up), give\n (over, up), hazard, put in prison, recommend.",
               "_strongs": "03860"
            },
            {
               "strongs": "3861",
               "greek": [
                  {
                     "_BETA": "PARA/DOCOS",
                     "_unicode": "παράδοξος",
                     "_translit": "parádoxos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ad'-ox-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1391"
                     }
                  ],
                  "__text": "from \n and \n (in the sense of seeming);"
               },
               "strongs_def": "contrary to expectation,\n i.e. extraordinary (\"paradox\")",
               "kjv_def": ":--strange.",
               "_strongs": "03861"
            },
            {
               "strongs": "3862",
               "greek": [
                  {
                     "_BETA": "PARA/DOSIS",
                     "_unicode": "παράδοσις",
                     "_translit": "parádosis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ad'-os-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3860"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "transmission, i.e. (concretely) a precept; specially, the\n Jewish traditionary law",
               "kjv_def": ":--ordinance, tradition.",
               "_strongs": "03862"
            },
            {
               "strongs": "3863",
               "greek": [
                  {
                     "_BETA": "PARAZHLO/W",
                     "_unicode": "παραζηλόω",
                     "_translit": "parazēlóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ad-zay-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2206"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stimulate alongside, i.e. excite to\n rivalry",
               "kjv_def": ":--provoke to emulation (jealousy).",
               "_strongs": "03863"
            },
            {
               "strongs": "3864",
               "greek": [
                  {
                     "_BETA": "PARAQALA/SSIOS",
                     "_unicode": "παραθαλάσσιος",
                     "_translit": "parathalássios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ath-al-as'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2281"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "along the sea, i.e. maritime (lacustrine)",
               "kjv_def": ":--upon\n the sea coast.",
               "_strongs": "03864"
            },
            {
               "strongs": "3865",
               "greek": [
                  {
                     "_BETA": "PARAQEWRE/W",
                     "_unicode": "παραθεωρέω",
                     "_translit": "paratheōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ath-eh-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2334"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to overlook or disregard",
               "kjv_def": ":--neglect.",
               "_strongs": "03865"
            },
            {
               "strongs": "3866",
               "greek": [
                  {
                     "_BETA": "PARAQH/KH",
                     "_unicode": "παραθήκη",
                     "_translit": "parathḗkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ath-ay'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3908"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deposit, i.e. (figuratively) trust",
               "kjv_def": ":--committed unto.",
               "_strongs": "03866"
            },
            {
               "strongs": "3867",
               "greek": [
                  {
                     "_BETA": "PARAINE/W",
                     "_unicode": "παραινέω",
                     "_translit": "parainéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ahee-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "134"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to mispraise, i.e. recommend or advise (a different\n course)",
               "kjv_def": ":--admonish, exhort.",
               "_strongs": "03867"
            },
            {
               "strongs": "3868",
               "greek": [
                  {
                     "_BETA": "PARAITE/OMAI",
                     "_unicode": "παραιτέομαι",
                     "_translit": "paraitéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ahee-teh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n;"
               },
               "strongs_def": "to beg off, i.e. deprecate,\n decline, shun",
               "kjv_def": ":--avoid, (make) excuse, intreat, refuse, reject.",
               "_strongs": "03868"
            },
            {
               "strongs": "3869",
               "greek": [
                  {
                     "_BETA": "PARAKAQI/ZW",
                     "_unicode": "παρακαθίζω",
                     "_translit": "parakathízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak-ath-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2523"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sit down near",
               "kjv_def": ":--sit.",
               "_strongs": "03869"
            },
            {
               "strongs": "3870",
               "greek": [
                  {
                     "_BETA": "PARAKALE/W",
                     "_unicode": "παρακαλέω",
                     "_translit": "parakaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak-al-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to call near, i.e. invite, invoke (by imploration,\n hortation or consolation)",
               "kjv_def": ":--beseech, call for, (be of good) comfort,\n desire, (give) exhort(-ation), intreat, pray.",
               "_strongs": "03870"
            },
            {
               "strongs": "3871",
               "greek": [
                  {
                     "_BETA": "PARAKALU/PTW",
                     "_unicode": "παρακαλύπτω",
                     "_translit": "parakalýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak-al-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to cover alongside, i.e. veil\n (figuratively)",
               "kjv_def": ":--hide.",
               "_strongs": "03871"
            },
            {
               "strongs": "3872",
               "greek": [
                  {
                     "_BETA": "PARAKATAQH/KH",
                     "_unicode": "παρακαταθήκη",
                     "_translit": "parakatathḗkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak-at-ath-ay'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2698"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "something put down alongside, i.e. a\n deposit (sacred trust)",
               "kjv_def": ":--that (thing) which is committed (un-)to\n (trust).",
               "_strongs": "03872"
            },
            {
               "strongs": "3873",
               "greek": [
                  {
                     "_BETA": "PARA/KEIMAI",
                     "_unicode": "παράκειμαι",
                     "_translit": "parákeimai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak'-i-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lie near, i.e. be at hand (figuratively, be\n prompt or easy)",
               "kjv_def": ":--be present.",
               "_strongs": "03873"
            },
            {
               "strongs": "3874",
               "greek": [
                  {
                     "_BETA": "PARA/KLHSIS",
                     "_unicode": "παράκλησις",
                     "_translit": "paráklēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak'-lay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3870"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "imploration, hortation, solace",
               "kjv_def": ":--comfort, consolation,\n exhortation, intreaty.",
               "_strongs": "03874"
            },
            {
               "strongs": "3875",
               "greek": [
                  {
                     "_BETA": "PARA/KLHTOS",
                     "_unicode": "παράκλητος",
                     "_translit": "paráklētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak'-lay-tos"
                  }
               ],
               "strongs_def": "an intercessor, consoler",
               "kjv_def": ":--advocate, comforter.",
               "_strongs": "03875"
            },
            {
               "strongs": "3876",
               "greek": [
                  {
                     "_BETA": "PARAKOH/",
                     "_unicode": "παρακοή",
                     "_translit": "parakoḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak-o-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3878"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inattention, i.e. (by implication)\n disobedience",
               "kjv_def": ":--disobedience.",
               "_strongs": "03876"
            },
            {
               "strongs": "3877",
               "greek": [
                  {
                     "_BETA": "PARAKOLOUQE/W",
                     "_unicode": "παρακολουθέω",
                     "_translit": "parakolouthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak-ol-oo-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "190"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to follow near, i.e. (figuratively) attend (as a\n result), trace out, conform to",
               "kjv_def": ":--attain, follow, fully know, have\n understanding.",
               "_strongs": "03877"
            },
            {
               "strongs": "3878",
               "greek": [
                  {
                     "_BETA": "PARAKOU/W",
                     "_unicode": "παρακούω",
                     "_translit": "parakoúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "191"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to mishear, i.e. (by implication) to\n disobey",
               "kjv_def": ":--neglect to hear.",
               "_strongs": "03878"
            },
            {
               "strongs": "3879",
               "greek": [
                  {
                     "_BETA": "PARAKU/PTW",
                     "_unicode": "παρακύπτω",
                     "_translit": "parakýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ak-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2955"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bend beside, i.e. lean over (so as to peer\n within)",
               "kjv_def": ":--look (into), stoop down.",
               "_strongs": "03879"
            },
            {
               "strongs": "3880",
               "greek": [
                  {
                     "_BETA": "PARALAMBA/NW",
                     "_unicode": "παραλαμβάνω",
                     "_translit": "paralambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-al-am-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to receive near, i.e. associate with oneself (in\n any familiar or intimate act or relation); by analogy, to assume an\n office; figuratively, to learn",
               "kjv_def": ":--receive, take (unto, with).",
               "_strongs": "03880"
            },
            {
               "strongs": "3881",
               "greek": [
                  {
                     "_BETA": "PARALE/GOMAI",
                     "_unicode": "παραλέγομαι",
                     "_translit": "paralégomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-al-eg'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and the middle voice of \n (in its original sense);"
               },
               "strongs_def": "(specially), to lay one's course near, i.e. sail past",
               "kjv_def": ":--pass, sail by.",
               "_strongs": "03881"
            },
            {
               "strongs": "3882",
               "greek": [
                  {
                     "_BETA": "PARA/LIOS",
                     "_unicode": "παράλιος",
                     "_translit": "parálios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-al'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "251"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "beside the salt (sea), i.e. maritime",
               "kjv_def": ":--sea coast.",
               "_strongs": "03882"
            },
            {
               "strongs": "3883",
               "greek": [
                  {
                     "_BETA": "PARALLAGH/",
                     "_unicode": "παραλλαγή",
                     "_translit": "parallagḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-al-lag-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "236"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "transmutation (of phase or orbit),\n i.e. (figuratively) fickleness",
               "kjv_def": ":--variableness.",
               "_strongs": "03883"
            },
            {
               "strongs": "3884",
               "greek": [
                  {
                     "_BETA": "PARALOGI/ZOMAI",
                     "_unicode": "παραλογίζομαι",
                     "_translit": "paralogízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-al-og-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3049"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to misreckon, i.e. delude",
               "kjv_def": ":--beguile, deceive.",
               "_strongs": "03884"
            },
            {
               "strongs": "3885",
               "greek": [
                  {
                     "_BETA": "PARALUTIKO/S",
                     "_unicode": "παραλυτικός",
                     "_translit": "paralytikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-al-oo-tee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3886"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "as if dissolved, i.e. \"paralytic\"",
               "kjv_def": ":--that\n had (sick of) the palsy.",
               "_strongs": "03885"
            },
            {
               "strongs": "3886",
               "greek": [
                  {
                     "_BETA": "PARALU/W",
                     "_unicode": "παραλύω",
                     "_translit": "paralýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-al-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to loosen beside, i.e. relax (perfect passive\n participle, paralyzed or enfeebled)",
               "kjv_def": ":--feeble, sick of the (taken with)\n palsy.",
               "_strongs": "03886"
            },
            {
               "strongs": "3887",
               "greek": [
                  {
                     "_BETA": "PARAME/NW",
                     "_unicode": "παραμένω",
                     "_translit": "paraménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-am-en'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stay near, i.e. remain (literally, tarry; or\n figuratively, be permanent, persevere)",
               "kjv_def": ":--abide, continue.",
               "_strongs": "03887"
            },
            {
               "strongs": "3888",
               "greek": [
                  {
                     "_BETA": "PARAMUQE/OMAI",
                     "_unicode": "παραμυθέομαι",
                     "_translit": "paramythéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-am-oo-theh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3454"
                     }
                  ],
                  "__text": "from \n and the middle voice of a derivative of \n;"
               },
               "strongs_def": "to relate\n near, i.e. (by implication) encourage, console",
               "kjv_def": ":--comfort.",
               "_strongs": "03888"
            },
            {
               "strongs": "3889",
               "greek": [
                  {
                     "_BETA": "PARAMUQI/A",
                     "_unicode": "παραμυθία",
                     "_translit": "paramythía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-am-oo-thee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3888"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "consolation (properly, abstract)",
               "kjv_def": ":--comfort.",
               "_strongs": "03889"
            },
            {
               "strongs": "3890",
               "greek": [
                  {
                     "_BETA": "PARAMU/QION",
                     "_unicode": "παραμύθιον",
                     "_translit": "paramýthion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-am-oo'-thee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3889"
                     }
                  ],
                  "__text": "neuter of \n;"
               },
               "strongs_def": "consolation (properly, concretely)",
               "kjv_def": ":--comfort.",
               "_strongs": "03890"
            },
            {
               "strongs": "3891",
               "greek": [
                  {
                     "_BETA": "PARANOME/W",
                     "_unicode": "παρανομέω",
                     "_translit": "paranoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-an-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3551"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be opposed to law, i.e. to\n transgress",
               "kjv_def": ":--contrary to law.",
               "_strongs": "03891"
            },
            {
               "strongs": "3892",
               "greek": [
                  {
                     "_BETA": "PARANOMI/A",
                     "_unicode": "παρανομία",
                     "_translit": "paranomía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-an-om-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3891"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "transgression",
               "kjv_def": ":--iniquity.",
               "_strongs": "03892"
            },
            {
               "strongs": "3893",
               "greek": [
                  {
                     "_BETA": "PARAPIKRAI/NW",
                     "_unicode": "παραπικραίνω",
                     "_translit": "parapikraínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ap-ik-rah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to embitter alongside, i.e. (figuratively) to\n exasperate",
               "kjv_def": ":--provoke.",
               "_strongs": "03893"
            },
            {
               "strongs": "3894",
               "greek": [
                  {
                     "_BETA": "PARAPIKRASMO/S",
                     "_unicode": "παραπικρασμός",
                     "_translit": "parapikrasmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ap-ik-ras-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3893"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "irritation",
               "kjv_def": ":--provocation.",
               "_strongs": "03894"
            },
            {
               "strongs": "3895",
               "greek": [
                  {
                     "_BETA": "PARAPI/PTW",
                     "_unicode": "παραπίπτω",
                     "_translit": "parapíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ap-ip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fall aside, i.e. (figuratively) to\n apostatize",
               "kjv_def": ":--fall away.",
               "_strongs": "03895"
            },
            {
               "strongs": "3896",
               "greek": [
                  {
                     "_BETA": "PARAPLE/W",
                     "_unicode": "παραπλέω",
                     "_translit": "parapléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ap-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sail near",
               "kjv_def": ":--sail by.",
               "_strongs": "03896"
            },
            {
               "strongs": "3897",
               "greek": [
                  {
                     "_BETA": "PARAPLH/SION",
                     "_unicode": "παραπλήσιον",
                     "_translit": "paraplḗsion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ap-lay'-see-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4139"
                     }
                  ],
                  "__text": "neuter of a compound of \n and the base of \n (as adverb);"
               },
               "strongs_def": "close\n by, i.e. (figuratively) almost",
               "kjv_def": ":--nigh unto.",
               "_strongs": "03897"
            },
            {
               "strongs": "3898",
               "greek": [
                  {
                     "_BETA": "PARAPLHSI/WS",
                     "_unicode": "παραπλησίως",
                     "_translit": "paraplēsíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ap-lay-see'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3897"
                     }
                  ],
                  "__text": "adverb from the same as \n;"
               },
               "strongs_def": "in a manner near by, i.e. (figuratively)\n similarly",
               "kjv_def": ":--likewise.",
               "_strongs": "03898"
            },
            {
               "strongs": "3899",
               "greek": [
                  {
                     "_BETA": "PARAPOREU/OMAI",
                     "_unicode": "παραπορεύομαι",
                     "_translit": "paraporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ap-or-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to travel near",
               "kjv_def": ":--go, pass (by).",
               "_strongs": "03899"
            },
            {
               "strongs": "3900",
               "greek": [
                  {
                     "_BETA": "PARA/PTWMA",
                     "_unicode": "παράπτωμα",
                     "_translit": "paráptōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ap'-to-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3895"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a side-slip (lapse or deviation), i.e. (unintentional)\n error or (wilful) transgression",
               "kjv_def": ":--fall, fault, offence, sin, trespass.",
               "_strongs": "03900"
            },
            {
               "strongs": "3901",
               "greek": [
                  {
                     "_BETA": "PARAR)R(UE/W",
                     "_unicode": "παραῤῥυέω",
                     "_translit": "pararrhyéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ar-hroo-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4482"
                     }
                  ],
                  "__text": "from \n and the alternate of \n;"
               },
               "strongs_def": "to flow by, i.e. (figuratively)\n carelessly pass (miss)",
               "kjv_def": ":--let slip.",
               "_strongs": "03901"
            },
            {
               "strongs": "3902",
               "greek": [
                  {
                     "_BETA": "PARA/SHMOS",
                     "_unicode": "παράσημος",
                     "_translit": "parásēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-as'-ay-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4591"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "side-marked, i.e. labelled (with a\n badge (figure-head) of a ship)",
               "kjv_def": ":--sign.",
               "_strongs": "03902"
            },
            {
               "strongs": "3903",
               "greek": [
                  {
                     "_BETA": "PARASKEUA/ZW",
                     "_unicode": "παρασκευάζω",
                     "_translit": "paraskeuázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ask-yoo-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4632"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to furnish aside, i.e. get\n ready",
               "kjv_def": ":--prepare self, be (make) ready.",
               "_strongs": "03903"
            },
            {
               "strongs": "3904",
               "greek": [
                  {
                     "_BETA": "PARASKEUH/",
                     "_unicode": "παρασκευή",
                     "_translit": "paraskeuḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ask-yoo-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3903"
                     }
                  ],
                  "__text": "as if from \n;"
               },
               "strongs_def": "readiness",
               "kjv_def": ":--preparation.",
               "_strongs": "03904"
            },
            {
               "strongs": "3905",
               "greek": [
                  {
                     "_BETA": "PARATEI/NW",
                     "_unicode": "παρατείνω",
                     "_translit": "parateínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-at-i'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     }
                  ],
                  "__text": "from \n and teino (to stretch);"
               },
               "strongs_def": "to extend along, i.e. prolong (in\n point of time)",
               "kjv_def": ":--continue.",
               "_strongs": "03905"
            },
            {
               "strongs": "3906",
               "greek": [
                  {
                     "_BETA": "PARATHRE/W",
                     "_unicode": "παρατηρέω",
                     "_translit": "paratēréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-at-ay-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5083"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to inspect alongside, i.e. note insidiously or\n scrupulously",
               "kjv_def": ":--observe, watch.",
               "_strongs": "03906"
            },
            {
               "strongs": "3907",
               "greek": [
                  {
                     "_BETA": "PARATH/RHSIS",
                     "_unicode": "παρατήρησις",
                     "_translit": "paratḗrēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-at-ay'-ray-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3906"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inspection, i.e. ocular evidence",
               "kjv_def": ":--obervation.",
               "_strongs": "03907"
            },
            {
               "strongs": "3908",
               "greek": [
                  {
                     "_BETA": "PARATI/QHMI",
                     "_unicode": "παρατίθημι",
                     "_translit": "paratíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-at-ith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to place alongside, i.e. present (food, truth); by\n implication, to deposit (as a trust or for protection)",
               "kjv_def": ":--allege,\n commend, commit (the keeping of), put forth, set before.",
               "_strongs": "03908"
            },
            {
               "strongs": "3909",
               "greek": [
                  {
                     "_BETA": "PARATUGXA/NW",
                     "_unicode": "παρατυγχάνω",
                     "_translit": "paratynchánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-at-oong-khan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5177"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to chance near, i.e. fall in with",
               "kjv_def": ":--meet with.",
               "_strongs": "03909"
            },
            {
               "strongs": "3910",
               "greek": [
                  {
                     "_BETA": "PARAUTI/KA",
                     "_unicode": "παραυτίκα",
                     "_translit": "parautíka"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ow-tee'-kah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "at the very instant, i.e.\n momentary",
               "kjv_def": ":--but for a moment.",
               "_strongs": "03910"
            },
            {
               "strongs": "3911",
               "greek": [
                  {
                     "_BETA": "PARAFE/RW",
                     "_unicode": "παραφέρω",
                     "_translit": "paraphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-af-er'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate forms);"
               },
               "strongs_def": "to bear along or\n aside, i.e. carry off (literally or figuratively); by implication, to\n avert",
               "kjv_def": ":--remove, take away.",
               "_strongs": "03911"
            },
            {
               "strongs": "3912",
               "greek": [
                  {
                     "_BETA": "PARAFRONE/W",
                     "_unicode": "παραφρονέω",
                     "_translit": "paraphronéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-af-ron-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5426"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to misthink, i.e. be insane (silly)",
               "kjv_def": ":--as a fool.",
               "_strongs": "03912"
            },
            {
               "strongs": "3913",
               "greek": [
                  {
                     "_BETA": "PARAFRONI/A",
                     "_unicode": "παραφρονία",
                     "_translit": "paraphronía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-af-ron-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3912"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "insanity, i.e. foolhardiness",
               "kjv_def": ":--madness.",
               "_strongs": "03913"
            },
            {
               "strongs": "3914",
               "greek": [
                  {
                     "_BETA": "PARAXEIMA/ZW",
                     "_unicode": "παραχειμάζω",
                     "_translit": "paracheimázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-akh-i-mad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5492"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to winter near, i.e. stay with over the rainy\n season",
               "kjv_def": ":--winter.",
               "_strongs": "03914"
            },
            {
               "strongs": "3915",
               "greek": [
                  {
                     "_BETA": "PARAXEIMASI/A",
                     "_unicode": "παραχειμασία",
                     "_translit": "paracheimasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-akh-i-mas-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3914"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a wintering over",
               "kjv_def": ":--winter in.",
               "_strongs": "03915"
            },
            {
               "strongs": "3916",
               "greek": [
                  {
                     "_BETA": "PARAXRH=MA",
                     "_unicode": "παραχρῆμα",
                     "_translit": "parachrēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-akh-ray'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5536"
                     }
                  ],
                  "__text": "from \n and \n (in its original sense);"
               },
               "strongs_def": "at the thing itself, i.e.\n instantly",
               "kjv_def": ":--forthwith, immediately, presently, straightway, soon.",
               "_strongs": "03916"
            },
            {
               "strongs": "3917",
               "greek": [
                  {
                     "_BETA": "PA/RDALIS",
                     "_unicode": "πάρδαλις",
                     "_translit": "párdalis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par'-dal-is"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PA/RDOS",
                        "_unicode": "πάρδος",
                        "_translit": "párdos"
                     }
                  ],
                  "__text": "feminine of \n (a panther);"
               },
               "strongs_def": "a leopard",
               "kjv_def": ":--leopard.",
               "_strongs": "03917"
            },
            {
               "strongs": "3918",
               "greek": [
                  {
                     "_BETA": "PA/REIMI",
                     "_unicode": "πάρειμι",
                     "_translit": "páreimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "from \n and \n (including its various forms);"
               },
               "strongs_def": "to be near, i.e. at\n hand; neuter present participle (singular) time being, or (plural)\n property",
               "kjv_def": ":--come, X have, be here, + lack, (be here) present.",
               "_strongs": "03918"
            },
            {
               "strongs": "3919",
               "greek": [
                  {
                     "_BETA": "PAREISA/GW",
                     "_unicode": "παρεισάγω",
                     "_translit": "pareiságō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ice-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1521"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead in aside, i.e. introduce\n surreptitiously",
               "kjv_def": ":--privily bring in.",
               "_strongs": "03919"
            },
            {
               "strongs": "3920",
               "greek": [
                  {
                     "_BETA": "PAREI/SAKTOS",
                     "_unicode": "παρείσακτος",
                     "_translit": "pareísaktos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ice'-ak-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3919"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "smuggled in",
               "kjv_def": ":--unawares brought in.",
               "_strongs": "03920"
            },
            {
               "strongs": "3921",
               "greek": [
                  {
                     "_BETA": "PAREISDU/NW",
                     "_unicode": "παρεισδύνω",
                     "_translit": "pareisdýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ice-doo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1416"
                     }
                  ],
                  "__text": "from \n and a compound of \n and \n;"
               },
               "strongs_def": "to settle in alongside,\n i.e. lodge stealthily",
               "kjv_def": ":--creep in unawares.",
               "_strongs": "03921"
            },
            {
               "strongs": "3922",
               "greek": [
                  {
                     "_BETA": "PAREISE/RXOMAI",
                     "_unicode": "παρεισέρχομαι",
                     "_translit": "pareisérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ice-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1525"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to come in alongside, i.e. supervene additionally\n or steathily",
               "kjv_def": ":--come in privily, enter.",
               "_strongs": "03922"
            },
            {
               "strongs": "3923",
               "greek": [
                  {
                     "_BETA": "PAREISFE/RW",
                     "_unicode": "παρεισφέρω",
                     "_translit": "pareisphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ice-fer'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1533"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear in alongside, i.e. introduce\n simultaneously",
               "kjv_def": ":--give.",
               "_strongs": "03923"
            },
            {
               "strongs": "3924",
               "greek": [
                  {
                     "_BETA": "PAREKTO/S",
                     "_unicode": "παρεκτός",
                     "_translit": "parektós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ek-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1622"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "near outside, i.e. besides",
               "kjv_def": ":--except, saving,\n without.",
               "_strongs": "03924"
            },
            {
               "strongs": "3925",
               "greek": [
                  {
                     "_BETA": "PAREMBOLH/",
                     "_unicode": "παρεμβολή",
                     "_translit": "parembolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-em-bol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1685"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a throwing in beside\n (juxtaposition), i.e. (specially), battle-array, encampment or\n barracks (tower Antonia)",
               "kjv_def": ":--army, camp, castle.",
               "_strongs": "03925"
            },
            {
               "strongs": "3926",
               "greek": [
                  {
                     "_BETA": "PARENOXLE/W",
                     "_unicode": "παρενοχλέω",
                     "_translit": "parenochléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-en-okh-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1776"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to harass further, i.e. annoy",
               "kjv_def": ":--trouble.",
               "_strongs": "03926"
            },
            {
               "strongs": "3927",
               "greek": [
                  {
                     "_BETA": "PAREPI/DHMOS",
                     "_unicode": "παρεπίδημος",
                     "_translit": "parepídēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ep-id'-ay-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1927"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "an alien alongside, i.e. a resident\n foreigner",
               "kjv_def": ":--pilgrim, stranger.",
               "_strongs": "03927"
            },
            {
               "strongs": "3928",
               "greek": [
                  {
                     "_BETA": "PARE/RXOMAI",
                     "_unicode": "παρέρχομαι",
                     "_translit": "parérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to come near or aside, i.e. to approach (arrive),\n go by (or away), (figuratively) perish or neglect, (causative)\n avert",
               "kjv_def": ":--come (forth), go, pass (away, by, over), past, transgress.",
               "_strongs": "03928"
            },
            {
               "strongs": "3929",
               "greek": [
                  {
                     "_BETA": "PA/RESIS",
                     "_unicode": "πάρεσις",
                     "_translit": "páresis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2935"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "praetermission, i.e. toleration",
               "kjv_def": ":--remission.",
               "_strongs": "03929"
            },
            {
               "strongs": "3930",
               "greek": [
                  {
                     "_BETA": "PARE/XW",
                     "_unicode": "παρέχω",
                     "_translit": "paréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hold near, i.e. present, afford, exhibit,\n furnish occasion",
               "kjv_def": ":--bring, do, give, keep, minister, offer, shew, +\n trouble.",
               "_strongs": "03930"
            },
            {
               "strongs": "3931",
               "greek": [
                  {
                     "_BETA": "PARHGORI/A",
                     "_unicode": "παρηγορία",
                     "_translit": "parēgoría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ay-gor-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n (meaning to harangue an\n assembly);"
               },
               "strongs_def": "an address alongside, i.e. (specially),\n consolation",
               "kjv_def": ":--comfort.",
               "_strongs": "03931"
            },
            {
               "strongs": "3932",
               "greek": [
                  {
                     "_BETA": "PARQENI/A",
                     "_unicode": "παρθενία",
                     "_translit": "parthenía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-then-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3933"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "maidenhood",
               "kjv_def": ":--virginity.",
               "_strongs": "03932"
            },
            {
               "strongs": "3933",
               "greek": [
                  {
                     "_BETA": "PARQE/NOS",
                     "_unicode": "παρθένος",
                     "_translit": "parthénos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-then'-os"
                  }
               ],
               "strongs_derivation": "of unknown origin;",
               "strongs_def": "a maiden; by implication, an unmarried\n daughter",
               "kjv_def": ":--virgin.",
               "_strongs": "03933"
            },
            {
               "strongs": "3934",
               "greek": [
                  {
                     "_BETA": "*PA/RQOS",
                     "_unicode": "Πάρθος",
                     "_translit": "Párthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par'-thos"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "a Parthian, i.e. inhabitant of\n Parthia",
               "kjv_def": ":--Parthian.",
               "_strongs": "03934"
            },
            {
               "strongs": "3935",
               "greek": [
                  {
                     "_BETA": "PARI/HMI",
                     "_unicode": "παρίημι",
                     "_translit": "paríēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ee'-ay-mi"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     }
                  ],
                  "__text": "from \n and hiemi (to send);"
               },
               "strongs_def": "to let by, i.e. relax",
               "kjv_def": ":--hang down.",
               "_strongs": "03935"
            },
            {
               "strongs": "3936",
               "greek": [
                  {
                     "_BETA": "PARI/STHMI",
                     "_unicode": "παρίστημι",
                     "_translit": "parístēmi"
                  },
                  {
                     "_BETA": "PARISTA/NW",
                     "_unicode": "παριστάνω",
                     "_translit": "paristánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-is'-tay-mee"
                  },
                  {
                     "_strongs": "par-is-tan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand beside, i.e. (transitively) to exhibit,\n proffer, (specially), recommend, (figuratively) substantiate; or\n (intransitively) to be at hand (or ready), aid",
               "kjv_def": ":--assist, bring before,\n command, commend, give presently, present, prove, provide, shew, stand\n (before, by, here, up, with), yield.",
               "_strongs": "03936",
               "__text": ", or prolonged"
            },
            {
               "strongs": "3937",
               "greek": [
                  {
                     "_BETA": "*PARMENA=S",
                     "_unicode": "Παρμενᾶς",
                     "_translit": "Parmenâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-men-as'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*PARMENI/DHS",
                        "_unicode": "Παρμενίδης",
                        "_translit": "Parmenídēs"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "probably by contraction for \n (a derivative of a compound of\n \n and \n);"
               },
               "strongs_def": "constant; Parmenas, a Christian",
               "kjv_def": ":--Parmenas.",
               "_strongs": "03937"
            },
            {
               "strongs": "3938",
               "greek": [
                  {
                     "_BETA": "PA/RODOS",
                     "_unicode": "πάροδος",
                     "_translit": "párodos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par'-od-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a by-road, i.e. (actively) a route",
               "kjv_def": ":--way.",
               "_strongs": "03938"
            },
            {
               "strongs": "3939",
               "greek": [
                  {
                     "_BETA": "PAROIKE/W",
                     "_unicode": "παροικέω",
                     "_translit": "paroikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-oy-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to dwell near, i.e. reside as a\n foreigner",
               "kjv_def": ":--sojourn in, be a stranger.",
               "_strongs": "03939"
            },
            {
               "strongs": "3940",
               "greek": [
                  {
                     "_BETA": "PAROIKI/A",
                     "_unicode": "παροικία",
                     "_translit": "paroikía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-oy-kee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3941"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "foreign residence",
               "kjv_def": ":--sojourning, X as strangers.",
               "_strongs": "03940"
            },
            {
               "strongs": "3941",
               "greek": [
                  {
                     "_BETA": "PA/ROIKOS",
                     "_unicode": "πάροικος",
                     "_translit": "pároikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par'-oy-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "having a home near, i.e. (as noun) a by-dweller\n (alien resident)",
               "kjv_def": ":--foreigner, sojourn, stranger.",
               "_strongs": "03941"
            },
            {
               "strongs": "3942",
               "greek": [
                  {
                     "_BETA": "PAROIMI/A",
                     "_unicode": "παροιμία",
                     "_translit": "paroimía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-oy-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3633"
                     }
                  ],
                  "__text": "from a compound of \n and perhaps a derivative of \n;"
               },
               "strongs_def": "apparently a\n state alongside of supposition, i.e. (concretely) an adage; specially,\n an enigmatical or fictitious illustration",
               "kjv_def": ":--parable, proverb.",
               "_strongs": "03942"
            },
            {
               "strongs": "3943",
               "greek": [
                  {
                     "_BETA": "PA/ROINOS",
                     "_unicode": "πάροινος",
                     "_translit": "pároinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par'-oy-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3631"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "staying near wine, i.e. tippling (a toper)",
               "kjv_def": ":--given\n to wine.",
               "_strongs": "03943"
            },
            {
               "strongs": "3944",
               "greek": [
                  {
                     "_BETA": "PAROI/XOMAI",
                     "_unicode": "παροίχομαι",
                     "_translit": "paroíchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-oy'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "OI)/XOMAI",
                        "_unicode": "οἴχομαι",
                        "_translit": "oíchomai"
                     }
                  ],
                  "__text": "from \n and \n (to depart);"
               },
               "strongs_def": "to escape along, i.e. be\n gone",
               "kjv_def": ":--past.",
               "_strongs": "03944"
            },
            {
               "strongs": "3945",
               "greek": [
                  {
                     "_BETA": "PAROMOIA/ZW",
                     "_unicode": "παρομοιάζω",
                     "_translit": "paromoiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-om-oy-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3946"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to resemble",
               "kjv_def": ":--be like unto.",
               "_strongs": "03945"
            },
            {
               "strongs": "3946",
               "greek": [
                  {
                     "_BETA": "PARO/MOIOS",
                     "_unicode": "παρόμοιος",
                     "_translit": "parómoios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-om'-oy-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3664"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "alike nearly, i.e. similar",
               "kjv_def": ":--like.",
               "_strongs": "03946"
            },
            {
               "strongs": "3947",
               "greek": [
                  {
                     "_BETA": "PAROCU/NW",
                     "_unicode": "παροξύνω",
                     "_translit": "paroxýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ox-oo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3691"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to sharpen alongside, i.e.\n (figuratively) to exasperate",
               "kjv_def": ":--easily provoke, stir.",
               "_strongs": "03947"
            },
            {
               "strongs": "3948",
               "greek": [
                  {
                     "_BETA": "PAROCUSMO/S",
                     "_unicode": "παροξυσμός",
                     "_translit": "paroxysmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ox-oos-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3947"
                     }
                  ],
                  "__text": "from \n (\"paroxysm\");"
               },
               "strongs_def": "incitement (to good), or dispute (in\n anger)",
               "kjv_def": ":--contention, provoke unto.",
               "_strongs": "03948"
            },
            {
               "strongs": "3949",
               "greek": [
                  {
                     "_BETA": "PARORGI/ZW",
                     "_unicode": "παροργίζω",
                     "_translit": "parorgízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-org-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3710"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to anger alongside, i.e. enrage",
               "kjv_def": ":--anger, provoke\n to wrath.",
               "_strongs": "03949"
            },
            {
               "strongs": "3950",
               "greek": [
                  {
                     "_BETA": "PARORGISMO/S",
                     "_unicode": "παροργισμός",
                     "_translit": "parorgismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-org-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3949"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "rage",
               "kjv_def": ":--wrath.",
               "_strongs": "03950"
            },
            {
               "strongs": "3951",
               "greek": [
                  {
                     "_BETA": "PAROTRU/NW",
                     "_unicode": "παροτρύνω",
                     "_translit": "parotrýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-ot-roo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "O)TRU/NW",
                        "_unicode": "ὀτρύνω",
                        "_translit": "otrýnō"
                     }
                  ],
                  "__text": "from \n and \n (to spur);"
               },
               "strongs_def": "to urge along, i.e. stimulate (to\n hostility)",
               "kjv_def": ":--stir up.",
               "_strongs": "03951"
            },
            {
               "strongs": "3952",
               "greek": [
                  {
                     "_BETA": "PAROUSI/A",
                     "_unicode": "παρουσία",
                     "_translit": "parousía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-oo-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3918"
                     }
                  ],
                  "__text": "from the present participle of \n;"
               },
               "strongs_def": "a being near, i.e. advent (often,\n return; specially, of Christ to punish Jerusalem, or finally the\n wicked); (by implication) physically, aspect",
               "kjv_def": ":--coming, presence.",
               "_strongs": "03952"
            },
            {
               "strongs": "3953",
               "greek": [
                  {
                     "_BETA": "PAROYI/S",
                     "_unicode": "παροψίς",
                     "_translit": "paropsís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-op-sis'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3795"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "a side-dish (the\n receptacle)",
               "kjv_def": ":--platter.",
               "_strongs": "03953"
            },
            {
               "strongs": "3954",
               "greek": [
                  {
                     "_BETA": "PAR)R(HSI/A",
                     "_unicode": "παῤῥησία",
                     "_translit": "parrhēsía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-rhay-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3956"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "all out-spokenness, i.e.\n frankness, bluntness, publicity; by implication, assurance",
               "kjv_def": ":--bold (X\n -ly, -ness, -ness of speech), confidence,\n X freely, X openly, X plainly(-ness).",
               "_strongs": "03954"
            },
            {
               "strongs": "3955",
               "greek": [
                  {
                     "_BETA": "PAR)R(HSIA/ZOMAI",
                     "_unicode": "παῤῥησιάζομαι",
                     "_translit": "parrhēsiázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "par-hray-see-ad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3954"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to be frank in utterance, or confident in\n spirit and demeanor",
               "kjv_def": ":--be (wax) bold, (preach, speak) boldly.",
               "_strongs": "03955"
            },
            {
               "strongs": "3956",
               "greek": [
                  {
                     "_BETA": "PA=S",
                     "_unicode": "πᾶς",
                     "_translit": "pâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pas"
                  }
               ],
               "strongs_derivation": "including all the forms of declension; apparently a primary word;",
               "strongs_def": "all,\n any, every, the whole",
               "kjv_def": ":--all (manner of, means), alway(-s), any (one),\n X daily, + ever, every (one, way), as many as, + no(-thing), X\n thoroughly, whatsoever, whole, whosoever.",
               "_strongs": "03956"
            },
            {
               "strongs": "3957",
               "greek": [
                  {
                     "_BETA": "PA/SXA",
                     "_unicode": "πάσχα",
                     "_translit": "páscha"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pas'-khah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06453"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "the Passover (the meal, the day, the\n festival or the special sacrifices connected with it)",
               "kjv_def": ":--Easter,\n Passover.",
               "_strongs": "03957"
            },
            {
               "strongs": "3958",
               "greek": [
                  {
                     "_BETA": "PA/SXW",
                     "_unicode": "πάσχω",
                     "_translit": "páschō"
                  },
                  {
                     "_BETA": "PA/QW",
                     "_unicode": "πάθω",
                     "_translit": "páthō"
                  },
                  {
                     "_BETA": "PE/NQW",
                     "_unicode": "πένθω",
                     "_translit": "pénthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pas'-kho"
                  },
                  {
                     "_strongs": "path'-o"
                  },
                  {
                     "_strongs": "pen'-tho"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to experience a sensation or impression\n (usually painful)",
               "kjv_def": ":--feel, passion, suffer, vex.",
               "_strongs": "03958",
               "__text": ", including the forms\n      \n  \n,  and\n      \n  \n, used only in certain tenses for it"
            },
            {
               "strongs": "3959",
               "greek": [
                  {
                     "_BETA": "*PA/TARA",
                     "_unicode": "Πάταρα",
                     "_translit": "Pátara"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat'-ar-ah"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Patara, a place in Asia Minor",
               "kjv_def": ":--Patara.",
               "_strongs": "03959"
            },
            {
               "strongs": "3960",
               "greek": [
                  {
                     "_BETA": "PATA/SSW",
                     "_unicode": "πατάσσω",
                     "_translit": "patássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3817"
                     }
                  ],
                  "__text": "probably prolongation from \n;"
               },
               "strongs_def": "to knock (gently or with a weapon or\n fatally)",
               "kjv_def": ":--smite, strike.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5180"
                  }
               ],
               "_strongs": "03960",
               "__text": "Compare \n."
            },
            {
               "strongs": "3961",
               "greek": [
                  {
                     "_BETA": "PATE/W",
                     "_unicode": "πατέω",
                     "_translit": "patéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3817"
                     }
                  ],
                  "__text": "from a derivative probably of \n (meaning a \"path\");"
               },
               "strongs_def": "to trample\n (literally or figuratively)",
               "kjv_def": ":--tread (down, under foot).",
               "_strongs": "03961"
            },
            {
               "strongs": "3962",
               "greek": [
                  {
                     "_BETA": "PATH/R",
                     "_unicode": "πατήρ",
                     "_translit": "patḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-ayr'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a \"father\" (literally or figuratively, near\n or more remote)",
               "kjv_def": ":--father, parent.",
               "_strongs": "03962"
            },
            {
               "strongs": "3963",
               "greek": [
                  {
                     "_BETA": "*PA/TMOS",
                     "_unicode": "Πάτμος",
                     "_translit": "Pátmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat'-mos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Patmus, an islet in the\n Mediterranean",
               "kjv_def": ":--Patmos.",
               "_strongs": "03963"
            },
            {
               "strongs": "3964",
               "greek": [
                  {
                     "_BETA": "PATRALW/|AS",
                     "_unicode": "πατραλῴας",
                     "_translit": "patralṓias"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-ral-o'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3389"
                     }
                  ],
                  "__text": "from \n and the same as the latter part of \n;"
               },
               "strongs_def": "a\n parricide",
               "kjv_def": ":--murderer of fathers.",
               "_strongs": "03964"
            },
            {
               "strongs": "3965",
               "greek": [
                  {
                     "_BETA": "PATRIA/",
                     "_unicode": "πατριά",
                     "_translit": "patriá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-ree-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     }
                  ],
                  "__text": "as if feminine of a derivative of \n;"
               },
               "strongs_def": "paternal descent, i.e.\n (concretely) a group of families or a whole race (nation)",
               "kjv_def": ":--family,\n kindred, lineage.",
               "_strongs": "03965"
            },
            {
               "strongs": "3966",
               "greek": [
                  {
                     "_BETA": "PATRIA/RXHS",
                     "_unicode": "πατριάρχης",
                     "_translit": "patriárchēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-ree-arkh'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3965"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a progenitor (\"patriarch\")",
               "kjv_def": ":--patriarch.",
               "_strongs": "03966"
            },
            {
               "strongs": "3967",
               "greek": [
                  {
                     "_BETA": "PATRIKO/S",
                     "_unicode": "πατρικός",
                     "_translit": "patrikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-ree-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "paternal, i.e. ancestral",
               "kjv_def": ":--of fathers.",
               "_strongs": "03967"
            },
            {
               "strongs": "3968",
               "greek": [
                  {
                     "_BETA": "PATRI/S",
                     "_unicode": "πατρίς",
                     "_translit": "patrís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-rece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3902"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a father-land, i.e. native town; (figuratively) heavenly\n home",
               "kjv_def": ":--(own) country.",
               "_strongs": "03968"
            },
            {
               "strongs": "3969",
               "greek": [
                  {
                     "_BETA": "*PATROBA=S",
                     "_unicode": "Πατροβᾶς",
                     "_translit": "Patrobâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-rob'-as"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*PATRO/BIOS",
                        "_unicode": "Πατρόβιος",
                        "_translit": "Patróbios"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "979"
                     }
                  ],
                  "__text": "perhaps a contraction for \n (a compound of \n and \n);"
               },
               "strongs_def": "father's life; Patrobas, a Christian",
               "kjv_def": ":--Patrobas.",
               "_strongs": "03969"
            },
            {
               "strongs": "3970",
               "greek": [
                  {
                     "_BETA": "PATROPARA/DOTOS",
                     "_unicode": "πατροπαράδοτος",
                     "_translit": "patroparádotos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-rop-ar-ad'-ot-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3860"
                     }
                  ],
                  "__text": "from \n and a derivative of \n (in the sense of handing over or\n down);"
               },
               "strongs_def": "traditionary",
               "kjv_def": ":--received by tradition from fathers.",
               "_strongs": "03970"
            },
            {
               "strongs": "3971",
               "greek": [
                  {
                     "_BETA": "PATRW=|OS",
                     "_unicode": "πατρῷος",
                     "_translit": "patrōios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pat-ro'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "paternal, i.e. hereditary",
               "kjv_def": ":--of fathers.",
               "_strongs": "03971"
            },
            {
               "strongs": "3972",
               "greek": [
                  {
                     "_BETA": "*PAU=LOS",
                     "_unicode": "Παῦλος",
                     "_translit": "Paûlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pow'-los"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3973"
                     }
                  ],
                  "__text": "(little; but remotely from a derivative of \n,\n meaning the same); Paulus, the name of a Roman and of an\n apostle"
               },
               "kjv_def": ":--Paul, Paulus.",
               "_strongs": "03972"
            },
            {
               "strongs": "3973",
               "greek": [
                  {
                     "_BETA": "PAU/W",
                     "_unicode": "παύω",
                     "_translit": "paúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pow'-o"
                  }
               ],
               "strongs_derivation": "a primary verb (\"pause\");",
               "strongs_def": "to stop (transitively or intransitively),\n i.e. restrain, quit, desist, come to an end",
               "kjv_def": ":--cease, leave, refrain.",
               "_strongs": "03973"
            },
            {
               "strongs": "3974",
               "greek": [
                  {
                     "_BETA": "*PA/FOS",
                     "_unicode": "Πάφος",
                     "_translit": "Páphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "paf'-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Paphus, a place in Cyprus",
               "kjv_def": ":--Paphos.",
               "_strongs": "03974"
            },
            {
               "strongs": "3975",
               "greek": [
                  {
                     "_BETA": "PAXU/NW",
                     "_unicode": "παχύνω",
                     "_translit": "pachýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pakh-oo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4078"
                     }
                  ],
                  "__text": "from a derivative of \n (meaning thick);"
               },
               "strongs_def": "to thicken, i.e. (by\n implication) to fatten (figuratively, stupefy or render callous)",
               "kjv_def": ":--wax\n gross.",
               "_strongs": "03975"
            },
            {
               "strongs": "3976",
               "greek": [
                  {
                     "_BETA": "PE/DH",
                     "_unicode": "πέδη",
                     "_translit": "pédē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ped'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "ultimately from \n;"
               },
               "strongs_def": "a shackle for the feet",
               "kjv_def": ":--fetter.",
               "_strongs": "03976"
            },
            {
               "strongs": "3977",
               "greek": [
                  {
                     "_BETA": "PEDINO/S",
                     "_unicode": "πεδινός",
                     "_translit": "pedinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ped-ee-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "from a derivative of \n (meaning the ground);"
               },
               "strongs_def": "level (as easy for the\n feet)",
               "kjv_def": ":--plain.",
               "_strongs": "03977"
            },
            {
               "strongs": "3978",
               "greek": [
                  {
                     "_BETA": "PEZEU/W",
                     "_unicode": "πεζεύω",
                     "_translit": "pezeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ped-zyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3979"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to foot a journey, i.e. travel by land",
               "kjv_def": ":--go\n afoot.",
               "_strongs": "03978"
            },
            {
               "strongs": "3979",
               "greek": [
                  {
                     "_BETA": "PEZH=|",
                     "_unicode": "πεζῇ",
                     "_translit": "pezēi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ped-zay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "dative case feminine of a derivative of \n (as adverb);"
               },
               "strongs_def": "foot-wise,\n i.e. by walking",
               "kjv_def": ":--a- (on) foot.",
               "_strongs": "03979"
            },
            {
               "strongs": "3980",
               "greek": [
                  {
                     "_BETA": "PEIQARXE/W",
                     "_unicode": "πειθαρχέω",
                     "_translit": "peitharchéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pi-tharkh-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be persuaded by a ruler, i.e.\n (genitive case) to submit to authority; by analogy, to conform to\n advice",
               "kjv_def": ":--hearken, obey (magistrates).",
               "_strongs": "03980"
            },
            {
               "strongs": "3981",
               "greek": [
                  {
                     "_BETA": "PEIQO/S",
                     "_unicode": "πειθός",
                     "_translit": "peithós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pi-thos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "persuasive",
               "kjv_def": ":--enticing.",
               "_strongs": "03981"
            },
            {
               "strongs": "3982",
               "greek": [
                  {
                     "_BETA": "PEI/QW",
                     "_unicode": "πείθω",
                     "_translit": "peíthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pi'-tho"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to convince (by argument, true or false); by analogy,\n to pacify or conciliate (by other fair means); reflexively or\n passively, to assent (to evidence or authority), to rely (by inward\n certainty)",
               "kjv_def": ":--agree, assure, believe, have confidence, be (wax)\n conflent, make friend, obey, persuade, trust, yield.",
               "_strongs": "03982"
            },
            {
               "strongs": "3983",
               "greek": [
                  {
                     "_BETA": "PEINA/W",
                     "_unicode": "πεινάω",
                     "_translit": "peináō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pi-nah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3993"
                     }
                  ],
                  "__text": "from the same as \n (through the idea of pinching toil; \"pine\");"
               },
               "strongs_def": "to\n famish (absolutely or comparatively); figuratively, to crave",
               "kjv_def": ":--be an\n hungered.",
               "_strongs": "03983"
            },
            {
               "strongs": "3984",
               "greek": [
                  {
                     "_BETA": "PEI=RA",
                     "_unicode": "πεῖρα",
                     "_translit": "peîra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pi'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from the base of \n (through the idea of piercing);"
               },
               "strongs_def": "a test, i.e.\n attempt, experience",
               "kjv_def": ":--assaying, trial.",
               "_strongs": "03984"
            },
            {
               "strongs": "3985",
               "greek": [
                  {
                     "_BETA": "PEIRA/ZW",
                     "_unicode": "πειράζω",
                     "_translit": "peirázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pi-rad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3984"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to test (objectively), i.e. endeavor, scrutinize, entice,\n discipline",
               "kjv_def": ":--assay, examine, go about, prove, tempt(-er), try.",
               "_strongs": "03985"
            },
            {
               "strongs": "3986",
               "greek": [
                  {
                     "_BETA": "PEIRASMO/S",
                     "_unicode": "πειρασμός",
                     "_translit": "peirasmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pi-ras-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3985"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a putting to proof (by experiment (of good), experience (of\n evil), solicitation, discipline or provocation); by implication,\n adversity",
               "kjv_def": ":--temptation, X try.",
               "_strongs": "03986"
            },
            {
               "strongs": "3987",
               "greek": [
                  {
                     "_BETA": "PEIRA/W",
                     "_unicode": "πειράω",
                     "_translit": "peiráō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pi-rah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3984"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to test (subjectively), i.e. (reflexively) to\n attempt",
               "kjv_def": ":--assay.",
               "_strongs": "03987"
            },
            {
               "strongs": "3988",
               "greek": [
                  {
                     "_BETA": "PEISMONH/",
                     "_unicode": "πεισμονή",
                     "_translit": "peismonḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pice-mon-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "persuadableness, i.e.\n credulity",
               "kjv_def": ":--persuasion.",
               "_strongs": "03988"
            },
            {
               "strongs": "3989",
               "greek": [
                  {
                     "_BETA": "PE/LAGOS",
                     "_unicode": "πέλαγος",
                     "_translit": "pélagos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pel'-ag-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "deep or open sea, i.e. the main",
               "kjv_def": ":--depth, sea.",
               "_strongs": "03989"
            },
            {
               "strongs": "3990",
               "greek": [
                  {
                     "_BETA": "PELEKI/ZW",
                     "_unicode": "πελεκίζω",
                     "_translit": "pelekízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pel-ek-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4141"
                     }
                  ],
                  "__text": "from a derivative of \n (meaning an axe);"
               },
               "strongs_def": "to chop off (the head),\n i.e. truncate",
               "kjv_def": ":--behead.",
               "_strongs": "03990"
            },
            {
               "strongs": "3991",
               "greek": [
                  {
                     "_BETA": "PE/MPTOS",
                     "_unicode": "πέμπτος",
                     "_translit": "pémptos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pemp'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4002"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fifth",
               "kjv_def": ":--fifth.",
               "_strongs": "03991"
            },
            {
               "strongs": "3992",
               "greek": [
                  {
                     "_BETA": "PE/MPW",
                     "_unicode": "πέμπω",
                     "_translit": "pémpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pem'-po"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "I(/HMI",
                        "_unicode": "ἵημι",
                        "_translit": "híēmi"
                     },
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "latin": "terminus ad quem",
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4724"
                     }
                  ],
                  "__text": "to dispatch (from the subjective view or\n point of departure, whereas \n (as a stronger form of \n) refers\n rather to the objective point or \n, and \n denotes\n properly, the orderly motion involved), especially on a temporary\n errand; also to transmit, bestow, or wield"
               },
               "kjv_def": ":--send, thrust in.",
               "_strongs": "03992"
            },
            {
               "strongs": "3993",
               "greek": [
                  {
                     "_BETA": "PE/NHS",
                     "_unicode": "πένης",
                     "_translit": "pénēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen'-ace"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PE/NW",
                        "_unicode": "πένω",
                        "_translit": "pénō"
                     }
                  ],
                  "__text": "from a primary \n (to toil for daily subsistence);"
               },
               "strongs_def": "starving, i.e.\n indigent",
               "kjv_def": ":--poor.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4434"
                  }
               ],
               "_strongs": "03993",
               "__text": "Compare \n."
            },
            {
               "strongs": "3994",
               "greek": [
                  {
                     "_BETA": "PENQERA/",
                     "_unicode": "πενθερά",
                     "_translit": "pentherá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-ther-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3995"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a wife's mother",
               "kjv_def": ":--mother in law, wife's mother.",
               "_strongs": "03994"
            },
            {
               "strongs": "3995",
               "greek": [
                  {
                     "_BETA": "PENQERO/S",
                     "_unicode": "πενθερός",
                     "_translit": "pentherós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-ther-os'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a wife's father",
               "kjv_def": ":--father in law.",
               "_strongs": "03995"
            },
            {
               "strongs": "3996",
               "greek": [
                  {
                     "_BETA": "PENQE/W",
                     "_unicode": "πενθέω",
                     "_translit": "penthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3997"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to grieve (the feeling or the act)",
               "kjv_def": ":--mourn, (be-)wail.",
               "_strongs": "03996"
            },
            {
               "strongs": "3997",
               "greek": [
                  {
                     "_BETA": "PE/NQOS",
                     "_unicode": "πένθος",
                     "_translit": "pénthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen'-thos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3958"
                     }
                  ],
                  "__text": "strengthened from the alternate of \n;"
               },
               "strongs_def": "grief",
               "kjv_def": ":--mourning, sorrow.",
               "_strongs": "03997"
            },
            {
               "strongs": "3998",
               "greek": [
                  {
                     "_BETA": "PENIXRO/S",
                     "_unicode": "πενιχρός",
                     "_translit": "penichrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-tikh-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3993"
                     }
                  ],
                  "__text": "prolongation from the base of \n;"
               },
               "strongs_def": "necessitous",
               "kjv_def": ":--poor.",
               "_strongs": "03998"
            },
            {
               "strongs": "3999",
               "greek": [
                  {
                     "_BETA": "PENTA/KIS",
                     "_unicode": "πεντάκις",
                     "_translit": "pentákis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-tak-ece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4002"
                     }
                  ],
                  "__text": "multiplicative adverb from \n;"
               },
               "strongs_def": "five times",
               "kjv_def": ":--five times.",
               "_strongs": "03999"
            },
            {
               "strongs": "4000",
               "greek": [
                  {
                     "_BETA": "PENTAKISXI/LIOI",
                     "_unicode": "πεντακισχίλιοι",
                     "_translit": "pentakischílioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-tak-is-khil'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3999"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5507"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "five times a thousand",
               "kjv_def": ":--five thousand.",
               "_strongs": "04000"
            },
            {
               "strongs": "4001",
               "greek": [
                  {
                     "_BETA": "PENTAKO/SIOI",
                     "_unicode": "πεντακόσιοι",
                     "_translit": "pentakósioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-tak-os'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4002"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1540"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "five hundred",
               "kjv_def": ":--five hundred.",
               "_strongs": "04001"
            },
            {
               "strongs": "4002",
               "greek": [
                  {
                     "_BETA": "PE/NTE",
                     "_unicode": "πέντε",
                     "_translit": "pénte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen'-teh"
                  }
               ],
               "strongs_derivation": "a primary number;",
               "strongs_def": "\"five\"",
               "kjv_def": ":--five.",
               "_strongs": "04002"
            },
            {
               "strongs": "4003",
               "greek": [
                  {
                     "_BETA": "PENTEKAIDE/KATOS",
                     "_unicode": "πεντεκαιδέκατος",
                     "_translit": "pentekaidékatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-tek-ahee-dek'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4002"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1182"
                     }
                  ],
                  "__text": "from \n and \n and \n;"
               },
               "strongs_def": "five and tenth",
               "kjv_def": ":--fifteenth.",
               "_strongs": "04003"
            },
            {
               "strongs": "4004",
               "greek": [
                  {
                     "_BETA": "PENTH/KONTA",
                     "_unicode": "πεντήκοντα",
                     "_translit": "pentḗkonta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-tay'-kon-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4002"
                     }
                  ],
                  "__text": "multiplicative of \n;"
               },
               "strongs_def": "fifty",
               "kjv_def": ":--fifty.",
               "_strongs": "04004"
            },
            {
               "strongs": "4005",
               "greek": [
                  {
                     "_BETA": "PENTHKOSTH/",
                     "_unicode": "πεντηκοστή",
                     "_translit": "pentēkostḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pen-tay-kos-tay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4004"
                     }
                  ],
                  "__text": "feminine of the ordinal of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "fiftieth (\n being implied) from\n Passover, i.e. the festival of \"Pentecost\""
               },
               "kjv_def": ":--Pentecost.",
               "_strongs": "04005"
            },
            {
               "strongs": "4006",
               "greek": [
                  {
                     "_BETA": "PEPOI/QHSIS",
                     "_unicode": "πεποίθησις",
                     "_translit": "pepoíthēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pep-oy'-thay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3958"
                     }
                  ],
                  "__text": "from the perfect of the alternate of \n;"
               },
               "strongs_def": "reliance",
               "kjv_def": ":--confidence,\n trust.",
               "_strongs": "04006"
            },
            {
               "strongs": "4007",
               "greek": [
                  {
                     "_BETA": "PER",
                     "_unicode": "περ",
                     "_translit": "per"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "an enclitic particle significant of abundance\n (thoroughness), i.e. emphasis; much, very or ever",
               "kjv_def": ":--(whom-)soever.",
               "_strongs": "04007"
            },
            {
               "strongs": "4008",
               "greek": [
                  {
                     "_BETA": "PE/RAN",
                     "_unicode": "πέραν",
                     "_translit": "péran"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per'-an"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PEI/RW",
                        "_unicode": "πείρω",
                        "_translit": "peírō"
                     }
                  ],
                  "__text": "apparently accusative case of an obsolete derivative of \n (to\n \"pierce\");"
               },
               "strongs_def": "through (as adverb or preposition), i.e. across",
               "kjv_def": ":--beyond,\n farther (other) side, over.",
               "_strongs": "04008"
            },
            {
               "strongs": "4009",
               "greek": [
                  {
                     "_BETA": "PE/RAS",
                     "_unicode": "πέρας",
                     "_translit": "péras"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per'-as"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "an extremity",
               "kjv_def": ":--end, ut-(ter-)most part.",
               "_strongs": "04009"
            },
            {
               "strongs": "4010",
               "greek": [
                  {
                     "_BETA": "*PE/RGAMOS",
                     "_unicode": "Πέργαμος",
                     "_translit": "Pérgamos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per'-gam-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4444"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fortified; Pergamus, a place in Asia Minor",
               "kjv_def": ":--Pergamos.",
               "_strongs": "04010"
            },
            {
               "strongs": "4011",
               "greek": [
                  {
                     "_BETA": "*PE/RGH",
                     "_unicode": "Πέργη",
                     "_translit": "Pérgē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "perg'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4010"
                     }
                  ],
                  "__text": "probably from the same as \n;"
               },
               "strongs_def": "a tower; Perga, a place in Asia\n Minor",
               "kjv_def": ":--Perga.",
               "_strongs": "04011"
            },
            {
               "strongs": "4012",
               "greek": [
                  {
                     "_BETA": "PERI/",
                     "_unicode": "περί",
                     "_translit": "perí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "properly, through (all over), i.e. around;\n figuratively with respect to; used in various applications, of place,\n cause or time (with the genitive case denoting the subject or occasion\n or superlative point; with the accusative case the locality, circuit,\n matter, circumstance or general period)",
               "kjv_def": ":--(there-)about, above,\n against, at, on behalf of, X and his company, which concern, (as)\n concerning, for, X how it will go with, ((there-, where-)) of, on,\n over, pertaining (to), for sake, X (e-)state, (as) touching,\n (where-)by (in), with.",
               "_strongs": "04012",
               "__text": "In compounds, it retains substantially the\n same meaning of circuit (around), excess (beyond), or completeness\n (through)."
            },
            {
               "strongs": "4013",
               "greek": [
                  {
                     "_BETA": "PERIA/GW",
                     "_unicode": "περιάγω",
                     "_translit": "periágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take around (as a companion); reflexively, to\n walk around",
               "kjv_def": ":--compass, go (round) about, lead about.",
               "_strongs": "04013"
            },
            {
               "strongs": "4014",
               "greek": [
                  {
                     "_BETA": "PERIAIRE/W",
                     "_unicode": "περιαιρέω",
                     "_translit": "periairéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-ahee-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to remove all around,\n i.e. unveil, cast off (anchor); figuratively, to expiate",
               "kjv_def": ":--take away\n (up).",
               "_strongs": "04014"
            },
            {
               "strongs": "4015",
               "greek": [
                  {
                     "_BETA": "PERIASTRA/PTW",
                     "_unicode": "περιαστράπτω",
                     "_translit": "periastráptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-as-trap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "797"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to flash all around, i.e. envelop in light",
               "kjv_def": ":--shine\n round (about).",
               "_strongs": "04015"
            },
            {
               "strongs": "4016",
               "greek": [
                  {
                     "_BETA": "PERIBA/LLW",
                     "_unicode": "περιβάλλω",
                     "_translit": "peribállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-bal'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw all around, i.e. invest (with a palisade\n or with clothing)",
               "kjv_def": ":--array, cast about, clothe(-d me), put on.",
               "_strongs": "04016"
            },
            {
               "strongs": "4017",
               "greek": [
                  {
                     "_BETA": "PERIBLE/PW",
                     "_unicode": "περιβλέπω",
                     "_translit": "periblépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-blep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to look all around",
               "kjv_def": ":--look (round) about (on).",
               "_strongs": "04017"
            },
            {
               "strongs": "4018",
               "greek": [
                  {
                     "_BETA": "PERIBO/LAION",
                     "_unicode": "περιβόλαιον",
                     "_translit": "peribólaion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ib-ol'-ah-yon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4016"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "something thrown around one,\n i.e. a mantle, veil",
               "kjv_def": ":--covering, vesture.",
               "_strongs": "04018"
            },
            {
               "strongs": "4019",
               "greek": [
                  {
                     "_BETA": "PERIDE/W",
                     "_unicode": "περιδέω",
                     "_translit": "peridéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-deh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bind around one, i.e. enwrap",
               "kjv_def": ":--bind\n about.",
               "_strongs": "04019"
            },
            {
               "strongs": "4020",
               "greek": [
                  {
                     "_BETA": "PERIERGA/ZOMAI",
                     "_unicode": "περιεργάζομαι",
                     "_translit": "periergázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-er-gad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2038"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to work all around, i.e. bustle about\n (meddle)",
               "kjv_def": ":--be a busybody.",
               "_strongs": "04020"
            },
            {
               "strongs": "4021",
               "greek": [
                  {
                     "_BETA": "PERI/ERGOS",
                     "_unicode": "περίεργος",
                     "_translit": "períergos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee'-er-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "working all around, i.e. officious (meddlesome,\n neuter plural magic)",
               "kjv_def": ":--busybody, curious arts.",
               "_strongs": "04021"
            },
            {
               "strongs": "4022",
               "greek": [
                  {
                     "_BETA": "PERIE/RXOMAI",
                     "_unicode": "περιέρχομαι",
                     "_translit": "periérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to come all around, i.e.\n stroll, vacillate, veer",
               "kjv_def": ":--fetch a compass, vagabond, wandering about.",
               "_strongs": "04022"
            },
            {
               "strongs": "4023",
               "greek": [
                  {
                     "_BETA": "PERIE/XW",
                     "_unicode": "περιέχω",
                     "_translit": "periéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hold all around, i.e. include, clasp\n (figuratively)",
               "kjv_def": ":--+ astonished, contain, after (this manner).",
               "_strongs": "04023"
            },
            {
               "strongs": "4024",
               "greek": [
                  {
                     "_BETA": "PERIZW/NNUMI",
                     "_unicode": "περιζώννυμι",
                     "_translit": "perizṓnnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-id-zone'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2224"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to gird all around, i.e. (middle voice or passive)\n to fasten on one's belt (literally or figuratively)",
               "kjv_def": ":--gird (about,\n self).",
               "_strongs": "04024"
            },
            {
               "strongs": "4025",
               "greek": [
                  {
                     "_BETA": "PERI/QESIS",
                     "_unicode": "περίθεσις",
                     "_translit": "períthesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ith'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4060"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a putting all around, i.e. decorating oneself\n with",
               "kjv_def": ":--wearing.",
               "_strongs": "04025"
            },
            {
               "strongs": "4026",
               "greek": [
                  {
                     "_BETA": "PERII/+STHMI",
                     "_unicode": "περιΐστημι",
                     "_translit": "periḯstēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand all around, i.e. (near) to be a\n bystander, or (aloof) to keep away from",
               "kjv_def": ":--avoid, shun, stand by (round\n about).",
               "_strongs": "04026"
            },
            {
               "strongs": "4027",
               "greek": [
                  {
                     "_BETA": "PERIKA/QARMA",
                     "_unicode": "περικάθαρμα",
                     "_translit": "perikátharma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-kath'-ar-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2508"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "something cleaned off all around,\n i.e. refuse (figuratively)",
               "kjv_def": ":--filth.",
               "_strongs": "04027"
            },
            {
               "strongs": "4028",
               "greek": [
                  {
                     "_BETA": "PERIKALU/PTW",
                     "_unicode": "περικαλύπτω",
                     "_translit": "perikalýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-kal-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to cover all around, i.e. entirely (the face, a\n surface)",
               "kjv_def": ":--blindfold, cover, overlay.",
               "_strongs": "04028"
            },
            {
               "strongs": "4029",
               "greek": [
                  {
                     "_BETA": "PERI/KEIMAI",
                     "_unicode": "περίκειμαι",
                     "_translit": "períkeimai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ik'-i-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lie all around, i.e. inclose, encircle, hamper\n (literally or figuratively)",
               "kjv_def": ":--be bound (compassed) with, hang about.",
               "_strongs": "04029"
            },
            {
               "strongs": "4030",
               "greek": [
                  {
                     "_BETA": "PERIKEFALAI/A",
                     "_unicode": "περικεφαλαία",
                     "_translit": "perikephalaía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-kef-al-ah'-yah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2776"
                     }
                  ],
                  "__text": "feminine of a compound of \n and \n;"
               },
               "strongs_def": "encirclement of the head,\n i.e. a helmet",
               "kjv_def": ":--helmet.",
               "_strongs": "04030"
            },
            {
               "strongs": "4031",
               "greek": [
                  {
                     "_BETA": "PERIKRATH/S",
                     "_unicode": "περικρατής",
                     "_translit": "perikratḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-krat-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2904"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "strong all around, i.e. a master (manager)",
               "kjv_def": ":--+\n come by.",
               "_strongs": "04031"
            },
            {
               "strongs": "4032",
               "greek": [
                  {
                     "_BETA": "PERIKRU/PTW",
                     "_unicode": "περικρύπτω",
                     "_translit": "perikrýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-kroop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2928"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to conceal all around, i.e. entirely",
               "kjv_def": ":--hide.",
               "_strongs": "04032"
            },
            {
               "strongs": "4033",
               "greek": [
                  {
                     "_BETA": "PERIKUKLO/W",
                     "_unicode": "περικυκλόω",
                     "_translit": "perikyklóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-koo-klo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2944"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to encircle all around, i.e. blockade\n completely",
               "kjv_def": ":--compass round.",
               "_strongs": "04033"
            },
            {
               "strongs": "4034",
               "greek": [
                  {
                     "_BETA": "PERILA/MPW",
                     "_unicode": "περιλάμπω",
                     "_translit": "perilámpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-lam'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2989"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to illuminate all around, i.e. invest with a\n halo",
               "kjv_def": ":--shine round about.",
               "_strongs": "04034"
            },
            {
               "strongs": "4035",
               "greek": [
                  {
                     "_BETA": "PERILEI/PW",
                     "_unicode": "περιλείπω",
                     "_translit": "perileípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-li'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to leave all around, i.e. (passively)\n survive",
               "kjv_def": ":--remain.",
               "_strongs": "04035"
            },
            {
               "strongs": "4036",
               "greek": [
                  {
                     "_BETA": "PERI/LUPOS",
                     "_unicode": "περίλυπος",
                     "_translit": "perílypos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-il'-oo-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3077"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "grieved all around, i.e. intensely sad",
               "kjv_def": ":--exceeding\n (very) sorry(-owful).",
               "_strongs": "04036"
            },
            {
               "strongs": "4037",
               "greek": [
                  {
                     "_BETA": "PERIME/NW",
                     "_unicode": "περιμένω",
                     "_translit": "periménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-men'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stay around, i.e. await",
               "kjv_def": ":--wait for.",
               "_strongs": "04037"
            },
            {
               "strongs": "4038",
               "greek": [
                  {
                     "_BETA": "PE/RIC",
                     "_unicode": "πέριξ",
                     "_translit": "périx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per'-ix"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "all around, i.e. (as an adjective)\n circumjacent",
               "kjv_def": ":--round about.",
               "_strongs": "04038"
            },
            {
               "strongs": "4039",
               "greek": [
                  {
                     "_BETA": "PERIOIKE/W",
                     "_unicode": "περιοικέω",
                     "_translit": "perioikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-oy-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reside around, i.e. be a neighbor",
               "kjv_def": ":--dwell round\n about.",
               "_strongs": "04039"
            },
            {
               "strongs": "4040",
               "greek": [
                  {
                     "_BETA": "PERI/OIKOS",
                     "_unicode": "περίοικος",
                     "_translit": "períoikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee'-oy-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3624"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "housed around, i.e. neighboring (used elliptically\n as a noun)",
               "kjv_def": ":--neighbour.",
               "_strongs": "04040"
            },
            {
               "strongs": "4041",
               "greek": [
                  {
                     "_BETA": "PERIOU/SIOS",
                     "_unicode": "περιούσιος",
                     "_translit": "perioúsios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-oo'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "from the present participle feminine of a compound of 4012 and \n;"
               },
               "strongs_def": "being beyond usual, i.e. special (one's own)",
               "kjv_def": ":--peculiar.",
               "_strongs": "04041"
            },
            {
               "strongs": "4042",
               "greek": [
                  {
                     "_BETA": "PERIOXH/",
                     "_unicode": "περιοχή",
                     "_translit": "periochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-okh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4023"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a being held around, i.e. (concretely) a passage (of\n Scripture, as circumscribed)",
               "kjv_def": ":--place.",
               "_strongs": "04042"
            },
            {
               "strongs": "4043",
               "greek": [
                  {
                     "_BETA": "PERIPATE/W",
                     "_unicode": "περιπατέω",
                     "_translit": "peripatéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-pat-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3961"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tread all around, i.e. walk at large\n (especially as proof of ability); figuratively, to live, deport\n oneself, follow (as a companion or votary)",
               "kjv_def": ":--go, be occupied with,\n walk (about).",
               "_strongs": "04043"
            },
            {
               "strongs": "4044",
               "greek": [
                  {
                     "_BETA": "PERIPEI/RW",
                     "_unicode": "περιπείρω",
                     "_translit": "peripeírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-pi'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to penetrate entirely, i.e. transfix\n (figuratively)",
               "kjv_def": ":--pierce through.",
               "_strongs": "04044"
            },
            {
               "strongs": "4045",
               "greek": [
                  {
                     "_BETA": "PERIPI/PTW",
                     "_unicode": "περιπίπτω",
                     "_translit": "peripíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-pip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fall into something that is all around, i.e.\n light among or upon, be surrounded with",
               "kjv_def": ":--fall among (into).",
               "_strongs": "04045"
            },
            {
               "strongs": "4046",
               "greek": [
                  {
                     "_BETA": "PERIPOIE/OMAI",
                     "_unicode": "περιποιέομαι",
                     "_translit": "peripoiéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-poy-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to make around oneself, i.e. acquire\n (buy)",
               "kjv_def": ":--purchase.",
               "_strongs": "04046"
            },
            {
               "strongs": "4047",
               "greek": [
                  {
                     "_BETA": "PERIPOI/HSIS",
                     "_unicode": "περιποίησις",
                     "_translit": "peripoíēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-poy'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4046"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "acquisition (the act or the thing); by extension,\n preservation",
               "kjv_def": ":--obtain(-ing), peculiar, purchased, possession, saving.",
               "_strongs": "04047"
            },
            {
               "strongs": "4048",
               "greek": [
                  {
                     "_BETA": "PERIR)R(H/GNUMI",
                     "_unicode": "περιῤῥήγνυμι",
                     "_translit": "perirrhḗgnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ir-hrayg'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tear all around, i.e. completely away",
               "kjv_def": ":--rend\n off.",
               "_strongs": "04048"
            },
            {
               "strongs": "4049",
               "greek": [
                  {
                     "_BETA": "PERISPA/W",
                     "_unicode": "περισπάω",
                     "_translit": "perispáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-spah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4685"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to drag all around, i.e. (figuratively) to\n distract (with care)",
               "kjv_def": ":--cumber.",
               "_strongs": "04049"
            },
            {
               "strongs": "4050",
               "greek": [
                  {
                     "_BETA": "PERISSEI/A",
                     "_unicode": "περισσεία",
                     "_translit": "perisseía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is-si'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4052"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "surplusage, i.e. superabundance",
               "kjv_def": ":--abundance(-ant, (-ly)),\n superfluity.",
               "_strongs": "04050"
            },
            {
               "strongs": "4051",
               "greek": [
                  {
                     "_BETA": "PERI/SSEUMA",
                     "_unicode": "περίσσευμα",
                     "_translit": "perísseuma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is'-syoo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4052"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a surplus, or superabundance",
               "kjv_def": ":--abundance, that was left,\n over and above.",
               "_strongs": "04051"
            },
            {
               "strongs": "4052",
               "greek": [
                  {
                     "_BETA": "PERISSEU/W",
                     "_unicode": "περισσεύω",
                     "_translit": "perisseúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is-syoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4053"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to superabound (in quantity or quality), be in excess, be\n superfluous; also (transitively) to cause to superabound or\n excel",
               "kjv_def": ":--(make, more) abound, (have, have more) abundance (be more)\n abundant, be the better, enough and to spare, exceed, excel, increase,\n be left, redound, remain (over and above).",
               "_strongs": "04052"
            },
            {
               "strongs": "4053",
               "greek": [
                  {
                     "_BETA": "PERISSO/S",
                     "_unicode": "περισσός",
                     "_translit": "perissós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is-sos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     }
                  ],
                  "__text": "from \n (in the sense of beyond);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1537"
                     }
                  ],
                  "__text": "superabundant (in quantity) or\n superior (in quality); by implication, excessive; adverbially (with\n \n) violently; neuter (as noun) preeminence"
               },
               "kjv_def": ":--exceeding abundantly\n above, more abundantly, advantage, exceedingly, very highly, beyond\n measure, more, superfluous, vehement(-ly).",
               "_strongs": "04053"
            },
            {
               "strongs": "4054",
               "greek": [
                  {
                     "_BETA": "PERISSO/TERON",
                     "_unicode": "περισσότερον",
                     "_translit": "perissóteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is-sot'-er-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4055"
                     }
                  ],
                  "__text": "neuter of \n (as adverb);"
               },
               "strongs_def": "in a more superabundant way",
               "kjv_def": ":--more\n abundantly, a great deal, far more.",
               "_strongs": "04054"
            },
            {
               "strongs": "4055",
               "greek": [
                  {
                     "_BETA": "PERISSO/TEROS",
                     "_unicode": "περισσότερος",
                     "_translit": "perissóteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is-sot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4053"
                     }
                  ],
                  "__text": "comparative of \n;"
               },
               "strongs_def": "more superabundant (in number, degree or\n character)",
               "kjv_def": ":--more abundant, greater (much) more, overmuch.",
               "_strongs": "04055"
            },
            {
               "strongs": "4056",
               "greek": [
                  {
                     "_BETA": "PERISSOTE/RWS",
                     "_unicode": "περισσοτέρως",
                     "_translit": "perissotérōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is-sot-er'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4055"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "more superabundantly",
               "kjv_def": ":--more abundant(-ly),\n X the more earnest, (more) exceedingly, more frequent, much\n more, the rather.",
               "_strongs": "04056"
            },
            {
               "strongs": "4057",
               "greek": [
                  {
                     "_BETA": "PERISSW=S",
                     "_unicode": "περισσῶς",
                     "_translit": "perissōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is-soce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4053"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "superabundantly",
               "kjv_def": ":--exceedingly, out of measure, the\n more.",
               "_strongs": "04057"
            },
            {
               "strongs": "4058",
               "greek": [
                  {
                     "_BETA": "PERISTERA/",
                     "_unicode": "περιστερά",
                     "_translit": "peristerá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-is-ter-ah'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a pigeon",
               "kjv_def": ":--dove, pigeon.",
               "_strongs": "04058"
            },
            {
               "strongs": "4059",
               "greek": [
                  {
                     "_BETA": "PERITE/MNW",
                     "_unicode": "περιτέμνω",
                     "_translit": "peritémnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-tem'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5114"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to cut around, i.e. (specially) to\n circumcise",
               "kjv_def": ":--circumcise.",
               "_strongs": "04059"
            },
            {
               "strongs": "4060",
               "greek": [
                  {
                     "_BETA": "PERITI/QHMI",
                     "_unicode": "περιτίθημι",
                     "_translit": "peritíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-tith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to place around; by implication, to\n present",
               "kjv_def": ":--bestow upon, hedge round about, put about (on, upon), set\n about.",
               "_strongs": "04060"
            },
            {
               "strongs": "4061",
               "greek": [
                  {
                     "_BETA": "PERITOMH/",
                     "_unicode": "περιτομή",
                     "_translit": "peritomḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-it-om-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4059"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "circumcision (the rite, the condition or the people,\n literally or figuratively)",
               "kjv_def": ":--X circumcised, circumcision.",
               "_strongs": "04061"
            },
            {
               "strongs": "4062",
               "greek": [
                  {
                     "_BETA": "PERITRE/PW",
                     "_unicode": "περιτρέπω",
                     "_translit": "peritrépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-trep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to turn around, i.e. (mentally) to\n craze",
               "kjv_def": ":--+ make mad.",
               "_strongs": "04062"
            },
            {
               "strongs": "4063",
               "greek": [
                  {
                     "_BETA": "PERITRE/XW",
                     "_unicode": "περιτρέχω",
                     "_translit": "peritréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-trekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to run around, i.e.\n traverse",
               "kjv_def": ":--run through.",
               "_strongs": "04063"
            },
            {
               "strongs": "4064",
               "greek": [
                  {
                     "_BETA": "PERIFE/RW",
                     "_unicode": "περιφέρω",
                     "_translit": "periphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-fer'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to convey around, i.e. transport hither and\n thither",
               "kjv_def": ":--bear (carry) about.",
               "_strongs": "04064"
            },
            {
               "strongs": "4065",
               "greek": [
                  {
                     "_BETA": "PERIFRONE/W",
                     "_unicode": "περιφρονέω",
                     "_translit": "periphronéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ee-fron-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5426"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to think beyond, i.e. depreciate\n (contemn)",
               "kjv_def": ":--despise.",
               "_strongs": "04065"
            },
            {
               "strongs": "4066",
               "greek": [
                  {
                     "_BETA": "PERI/XWROS",
                     "_unicode": "περίχωρος",
                     "_translit": "períchōros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ikh'-o-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1093"
                     }
                  ],
                  "__text": "around the region, i.e. circumjacent (as noun,\n with \n implied vicinity)"
               },
               "kjv_def": ":--country (round) about, region (that\n lieth) round about.",
               "_strongs": "04066"
            },
            {
               "strongs": "4067",
               "greek": [
                  {
                     "_BETA": "PERI/YWMA",
                     "_unicode": "περίψωμα",
                     "_translit": "perípsōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-ip'-so-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "YA/W",
                        "_unicode": "ψάω",
                        "_translit": "psáō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to rub);"
               },
               "strongs_def": "something brushed all\n around, i.e. off-scrapings (figuratively, scum)",
               "kjv_def": ":--offscouring.",
               "_strongs": "04067"
            },
            {
               "strongs": "4068",
               "greek": [
                  {
                     "_BETA": "PERPEREU/OMAI",
                     "_unicode": "περπερεύομαι",
                     "_translit": "perpereúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-per-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PE/RPEROS",
                        "_unicode": "πέρπερος",
                        "_translit": "pérperos"
                     }
                  ],
                  "__text": "middle voice from \n (braggart;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "perhaps by reduplication of the\n base of \n); to boast"
               },
               "kjv_def": ":--vaunt itself.",
               "_strongs": "04068"
            },
            {
               "strongs": "4069",
               "greek": [
                  {
                     "_BETA": "*PERSI/S",
                     "_unicode": "Περσίς",
                     "_translit": "Persís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per-sece'"
                  }
               ],
               "strongs_def": "a Persian woman; Persis, a Christian female",
               "kjv_def": ":--Persis.",
               "_strongs": "04069"
            },
            {
               "strongs": "4070",
               "greek": [
                  {
                     "_BETA": "PE/RUSI",
                     "_unicode": "πέρυσι",
                     "_translit": "pérysi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "per'-oo-si"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4009"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "the by-gone, i.e. (as noun) last year",
               "kjv_def": ":--+ a year\n ago.",
               "_strongs": "04070"
            },
            {
               "strongs": "4071",
               "greek": [
                  {
                     "_BETA": "PETEINO/N",
                     "_unicode": "πετεινόν",
                     "_translit": "peteinón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pet-i-non'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4072"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "a flying animal, i.e. bird",
               "kjv_def": ":--bird,\n fowl.",
               "_strongs": "04071"
            },
            {
               "strongs": "4072",
               "greek": [
                  {
                     "_BETA": "PE/TOMAI",
                     "_unicode": "πέτομαι",
                     "_translit": "pétomai"
                  },
                  {
                     "_BETA": "PETA/OMAI",
                     "_unicode": "πετάομαι",
                     "_translit": "petáomai"
                  },
                  {
                     "_BETA": "PTA/OMAI",
                     "_unicode": "πτάομαι",
                     "_translit": "ptáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pet'-om-ahee"
                  },
                  {
                     "_strongs": "pet-ah'-om-ahee"
                  },
                  {
                     "_strongs": "ptah'-om-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of a primary verb;",
               "strongs_def": "to fly",
               "kjv_def": ":--fly(-ing).",
               "_strongs": "04072",
               "__text": ",    or prolongation\n      \n  \n, or contracted"
            },
            {
               "strongs": "4073",
               "greek": [
                  {
                     "_BETA": "PE/TRA",
                     "_unicode": "πέτρα",
                     "_translit": "pétra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pet'-ra"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4074"
                     }
                  ],
                  "__text": "feminine of the same as \n;"
               },
               "strongs_def": "a (mass of) rock (literally or\n figuratively)",
               "kjv_def": ":--rock.",
               "_strongs": "04073"
            },
            {
               "strongs": "4074",
               "greek": [
                  {
                     "_BETA": "*PE/TROS",
                     "_unicode": "Πέτρος",
                     "_translit": "Pétros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pet'-ros"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3037"
                     }
                  ],
                  "__text": "a (piece of) rock (larger than \n); as a\n name, Petrus, an apostle"
               },
               "kjv_def": ":--Peter, rock.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2786"
                  }
               ],
               "_strongs": "04074",
               "__text": "Compare \n."
            },
            {
               "strongs": "4075",
               "greek": [
                  {
                     "_BETA": "PETRW/DHS",
                     "_unicode": "πετρώδης",
                     "_translit": "petrṓdēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pet-ro'-dace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4073"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1491"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "rock-like, i.e. rocky",
               "kjv_def": ":--stony.",
               "_strongs": "04075"
            },
            {
               "strongs": "4076",
               "greek": [
                  {
                     "_BETA": "PH/GANON",
                     "_unicode": "πήγανον",
                     "_translit": "pḗganon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pay'-gan-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4078"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "rue (from its thick or fleshy leaves)",
               "kjv_def": ":--rue.",
               "_strongs": "04076"
            },
            {
               "strongs": "4077",
               "greek": [
                  {
                     "_BETA": "PHGH/",
                     "_unicode": "πηγή",
                     "_translit": "pēgḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pay-gay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4078"
                     }
                  ],
                  "__text": "probably from \n (through the idea of gushing plumply);"
               },
               "strongs_def": "a fount\n (literally or figuratively), i.e. source or supply (of water, blood,\n enjoyment) (not necessarily the original spring)",
               "kjv_def": ":--fountain, well.",
               "_strongs": "04077"
            },
            {
               "strongs": "4078",
               "greek": [
                  {
                     "_BETA": "PH/GNUMI",
                     "_unicode": "πήγνυμι",
                     "_translit": "pḗgnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "payg'-noo-mee"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb (which in its simpler form occurs\n only as an alternate in certain tenses);",
               "strongs_def": "to fix (\"peg\"), i.e.\n (specially) to set up (a tent)",
               "kjv_def": ":--pitch.",
               "_strongs": "04078"
            },
            {
               "strongs": "4079",
               "greek": [
                  {
                     "_BETA": "PHDA/LION",
                     "_unicode": "πηδάλιον",
                     "_translit": "pēdálion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pay-dal'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PHDO/N",
                        "_unicode": "πηδόν",
                        "_translit": "pēdón"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3976"
                     }
                  ],
                  "__text": "neuter of a (presumed) derivative of \n (the blade of an oar; from\n the same as \n);"
               },
               "strongs_def": "a \"pedal\", i.e. helm",
               "kjv_def": ":--rudder.",
               "_strongs": "04079"
            },
            {
               "strongs": "4080",
               "greek": [
                  {
                     "_BETA": "PHLI/KOS",
                     "_unicode": "πηλίκος",
                     "_translit": "pēlíkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pay-lee'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4225"
                     }
                  ],
                  "__text": "a quantitative form (the feminine) of the base of \n;"
               },
               "strongs_def": "how much (as\n an indefinite), i.e. in size or (figuratively) dignity",
               "kjv_def": ":--how great\n (large).",
               "_strongs": "04080"
            },
            {
               "strongs": "4081",
               "greek": [
                  {
                     "_BETA": "PHLO/S",
                     "_unicode": "πηλός",
                     "_translit": "pēlós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pay-los'"
                  }
               ],
               "strongs_derivation": "perhaps a primary word;",
               "strongs_def": "clay",
               "kjv_def": ":--clay.",
               "_strongs": "04081"
            },
            {
               "strongs": "4082",
               "greek": [
                  {
                     "_BETA": "PH/RA",
                     "_unicode": "πήρα",
                     "_translit": "pḗra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pay'-rah"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a wallet or leather pouch for food",
               "kjv_def": ":--scrip.",
               "_strongs": "04082"
            },
            {
               "strongs": "4083",
               "greek": [
                  {
                     "_BETA": "PH=XUS",
                     "_unicode": "πῆχυς",
                     "_translit": "pēchys"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pay'-khoos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "the fore-arm, i.e. (as a measure) a\n cubit",
               "kjv_def": ":--cubit.",
               "_strongs": "04083"
            },
            {
               "strongs": "4084",
               "greek": [
                  {
                     "_BETA": "PIA/ZW",
                     "_unicode": "πιάζω",
                     "_translit": "piázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "971"
                     }
                  ],
                  "__text": "probably another form of \n;"
               },
               "strongs_def": "to squeeze, i.e. seize (gently by the\n hand (press), or officially (arrest), or in hunting\n (capture))",
               "kjv_def": ":--apprehend, catch, lay hand on, take.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4085"
                  }
               ],
               "_strongs": "04084",
               "__text": "Compare \n."
            },
            {
               "strongs": "4085",
               "greek": [
                  {
                     "_BETA": "PIE/ZW",
                     "_unicode": "πιέζω",
                     "_translit": "piézō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pee-ed'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4084"
                     }
                  ],
                  "__text": "another form for \n;"
               },
               "strongs_def": "to pack",
               "kjv_def": ":--press down.",
               "_strongs": "04085"
            },
            {
               "strongs": "4086",
               "greek": [
                  {
                     "_BETA": "PIQANOLOGI/A",
                     "_unicode": "πιθανολογία",
                     "_translit": "pithanología"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pith-an-ol-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from a compound of a derivative of \n and \n;"
               },
               "strongs_def": "persuasive\n language",
               "kjv_def": ":--enticing words.",
               "_strongs": "04086"
            },
            {
               "strongs": "4087",
               "greek": [
                  {
                     "_BETA": "PIKRAI/NW",
                     "_unicode": "πικραίνω",
                     "_translit": "pikraínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pik-rah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4089"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to embitter (literally or figuratively)",
               "kjv_def": ":--be (make) bitter.",
               "_strongs": "04087"
            },
            {
               "strongs": "4088",
               "greek": [
                  {
                     "_BETA": "PIKRI/A",
                     "_unicode": "πικρία",
                     "_translit": "pikría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pik-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4089"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "acridity (especially poison), literally or\n figuratively",
               "kjv_def": ":--bitterness.",
               "_strongs": "04088"
            },
            {
               "strongs": "4089",
               "greek": [
                  {
                     "_BETA": "PIKRO/S",
                     "_unicode": "πικρός",
                     "_translit": "pikrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pik-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4078"
                     }
                  ],
                  "__text": "perhaps from \n (through the idea of piercing);"
               },
               "strongs_def": "sharp (pungent),\n i.e. acrid (literally or figuratively)",
               "kjv_def": ":--bitter.",
               "_strongs": "04089"
            },
            {
               "strongs": "4090",
               "greek": [
                  {
                     "_BETA": "PIKRW=S",
                     "_unicode": "πικρῶς",
                     "_translit": "pikrōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pik-roce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4089"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "bitterly, i.e. (figuratively) violently",
               "kjv_def": ":--bitterly.",
               "_strongs": "04090"
            },
            {
               "strongs": "4091",
               "greek": [
                  {
                     "_BETA": "*PILA=TOS",
                     "_unicode": "Πιλᾶτος",
                     "_translit": "Pilâtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pil-at'-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "close-pressed, i.e. firm; Pilatus, a Roman",
               "kjv_def": ":--Pilate.",
               "_strongs": "04091"
            },
            {
               "strongs": "4092",
               "greek": [
                  {
                     "_BETA": "PI/MPRHMI",
                     "_unicode": "πίμπρημι",
                     "_translit": "pímprēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pim'-pray-mee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PRE/W",
                        "_unicode": "πρέω",
                        "_translit": "préō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "preh'-o"
                     }
                  ],
                  "__text": "a reduplicated and prolonged form of a\n primary \n \n; which occurs only as an alternate in certain\n tenses);"
               },
               "strongs_def": "to fire, i.e. burn (figuratively and passively, become\n inflamed with fever)",
               "kjv_def": ":--be (X should have) swollen.",
               "_strongs": "04092",
               "__text": ";"
            },
            {
               "strongs": "4093",
               "greek": [
                  {
                     "_BETA": "PINAKI/DION",
                     "_unicode": "πινακίδιον",
                     "_translit": "pinakídion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pin-ak-id'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4094"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "a tablet (for writing on)",
               "kjv_def": ":--writing table.",
               "_strongs": "04093"
            },
            {
               "strongs": "4094",
               "greek": [
                  {
                     "_BETA": "PI/NAC",
                     "_unicode": "πίναξ",
                     "_translit": "pínax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pin'-ax"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4109"
                     }
                  ],
                  "__text": "apparently a form of \n;"
               },
               "strongs_def": "a plate",
               "kjv_def": ":--charger, platter.",
               "_strongs": "04094"
            },
            {
               "strongs": "4095",
               "greek": [
                  {
                     "_BETA": "PI/NW",
                     "_unicode": "πίνω",
                     "_translit": "pínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pee'-no"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PI/W",
                        "_unicode": "πίω",
                        "_translit": "píō"
                     },
                     {
                        "_BETA": "PO/W",
                        "_unicode": "πόω",
                        "_translit": "póō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "pee'-o"
                     },
                     {
                        "_strongs": "po'-o"
                     }
                  ],
                  "__text": "a prolonged form of\n      \n  \n;  which (together with another form)\n      \n  \n; occurs only as an alternate in certain tenses;"
               },
               "strongs_def": "to imbibe (literally or figuratively)",
               "kjv_def": ":--drink.",
               "_strongs": "04095",
               "__text": ";"
            },
            {
               "strongs": "4096",
               "greek": [
                  {
                     "_BETA": "PIO/THS",
                     "_unicode": "πιότης",
                     "_translit": "piótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pee-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PI/WN",
                        "_unicode": "πίων",
                        "_translit": "píōn"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from \n (fat; perhaps akin to the alternate of \n through the idea\n of repletion);"
               },
               "strongs_def": "plumpness, i.e. (by implication) richness\n (oiliness)",
               "kjv_def": ":--fatness.",
               "_strongs": "04096"
            },
            {
               "strongs": "4097",
               "greek": [
                  {
                     "_BETA": "PIPRA/SKW",
                     "_unicode": "πιπράσκω",
                     "_translit": "pipráskō"
                  },
                  {
                     "_BETA": "PRA/W",
                     "_unicode": "πράω",
                     "_translit": "práō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pip-ras'-ko"
                  },
                  {
                     "_strongs": "prah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PERA/W",
                        "_unicode": "περάω",
                        "_translit": "peráō"
                     }
                  ],
                  "__text": "contracted from \n (to traverse;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     }
                  ],
                  "__text": "from the base of \n); to traffic\n (by travelling), i.e. dispose of as merchandise or into slavery\n (literally or figuratively)"
               },
               "kjv_def": ":--sell.",
               "_strongs": "04097",
               "__text": ", a reduplicated and prolonged form of\n      \n  \n;     (which occurs only as an alternate in\n                               certain tenses)"
            },
            {
               "strongs": "4098",
               "greek": [
                  {
                     "_BETA": "PI/PTW",
                     "_unicode": "πίπτω",
                     "_translit": "píptō"
                  },
                  {
                     "_BETA": "PE/TW",
                     "_unicode": "πέτω",
                     "_translit": "pétō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pip'-to"
                  },
                  {
                     "_strongs": "pet'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4072"
                     }
                  ],
                  "__text": "probably akin to \n through the idea of alighting;"
               },
               "strongs_def": "to fall\n (literally or figuratively)",
               "kjv_def": ":--fail, fall (down), light on.",
               "_strongs": "04098",
               "__text": ",  a reduplicated and contracted form of\n      \n  \n;   (which occurs only as an alternate in certain\n                         tenses);"
            },
            {
               "strongs": "4099",
               "greek": [
                  {
                     "_BETA": "*PISIDI/A",
                     "_unicode": "Πισιδία",
                     "_translit": "Pisidía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pis-id-ee'-ah"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Pisidia, a region of Asia Minor",
               "kjv_def": ":--Pisidia.",
               "_strongs": "04099"
            },
            {
               "strongs": "4100",
               "greek": [
                  {
                     "_BETA": "PISTEU/W",
                     "_unicode": "πιστεύω",
                     "_translit": "pisteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pist-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4102"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to have faith (in, upon, or with respect to, a person or\n thing), i.e. credit; by implication, to entrust (especially one's\n spiritual well-being to Christ)",
               "kjv_def": ":--believe(-r), commit (to trust), put\n in trust with.",
               "_strongs": "04100"
            },
            {
               "strongs": "4101",
               "greek": [
                  {
                     "_BETA": "PISTIKO/S",
                     "_unicode": "πιστικός",
                     "_translit": "pistikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pis-tik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4102"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "trustworthy, i.e. genuine (unadulterated)",
               "kjv_def": ":--spike-(nard).",
               "_strongs": "04101"
            },
            {
               "strongs": "4102",
               "greek": [
                  {
                     "_BETA": "PI/STIS",
                     "_unicode": "πίστις",
                     "_translit": "pístis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pis'-tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "persuasion, i.e. credence; moral conviction (of religious\n truth, or the truthfulness of God or a religious teacher), especially\n reliance upon Christ for salvation; abstractly, constancy in such\n profession; by extension, the system of religious (Gospel) truth\n itself",
               "kjv_def": ":--assurance, belief, believe, faith, fidelity.",
               "_strongs": "04102"
            },
            {
               "strongs": "4103",
               "greek": [
                  {
                     "_BETA": "PISTO/S",
                     "_unicode": "πιστός",
                     "_translit": "pistós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pis-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3982"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "objectively, trustworthy; subjectively,\n trustful",
               "kjv_def": ":--believe(-ing, -r), faithful(-ly), sure, true.",
               "_strongs": "04103"
            },
            {
               "strongs": "4104",
               "greek": [
                  {
                     "_BETA": "PISTO/W",
                     "_unicode": "πιστόω",
                     "_translit": "pistóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pis-to'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4103"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to assure",
               "kjv_def": ":--assure of.",
               "_strongs": "04104"
            },
            {
               "strongs": "4105",
               "greek": [
                  {
                     "_BETA": "PLANA/W",
                     "_unicode": "πλανάω",
                     "_translit": "planáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plan-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4106"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to (properly, cause to) roam (from safety, truth, or\n virtue)",
               "kjv_def": ":--go astray, deceive, err, seduce, wander, be out of the way.",
               "_strongs": "04105"
            },
            {
               "strongs": "4106",
               "greek": [
                  {
                     "_BETA": "PLA/NH",
                     "_unicode": "πλάνη",
                     "_translit": "plánē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plan'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4108"
                     }
                  ],
                  "__text": "feminine of \n (as abstractly);"
               },
               "strongs_def": "objectively, fraudulence;\n subjectively, a straying from orthodoxy or piety",
               "kjv_def": ":--deceit, to deceive,\n delusion, error.",
               "_strongs": "04106"
            },
            {
               "strongs": "4107",
               "greek": [
                  {
                     "_BETA": "PLANH/THS",
                     "_unicode": "πλανήτης",
                     "_translit": "planḗtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plan-ay'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4108"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a rover (\"planet\"), i.e. (figuratively) an erratic\n teacher",
               "kjv_def": ":--wandering.",
               "_strongs": "04107"
            },
            {
               "strongs": "4108",
               "greek": [
                  {
                     "_BETA": "PLA/NOS",
                     "_unicode": "πλάνος",
                     "_translit": "plános"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plan'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "roving (as a tramp), i.e. (by implication) an\n impostor or misleader;",
               "kjv_def": "--deceiver, seducing.",
               "_strongs": "04108"
            },
            {
               "strongs": "4109",
               "greek": [
                  {
                     "_BETA": "PLA/C",
                     "_unicode": "πλάξ",
                     "_translit": "pláx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plax"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4111"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a moulding-board, i.e. flat surface (\"plate\", or tablet,\n literally or figuratively)",
               "kjv_def": ":--table.",
               "_strongs": "04109"
            },
            {
               "strongs": "4110",
               "greek": [
                  {
                     "_BETA": "PLA/SMA",
                     "_unicode": "πλάσμα",
                     "_translit": "plásma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plas'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4111"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something moulded",
               "kjv_def": ":--thing formed.",
               "_strongs": "04110"
            },
            {
               "strongs": "4111",
               "greek": [
                  {
                     "_BETA": "PLA/SSW",
                     "_unicode": "πλάσσω",
                     "_translit": "plássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plas'-so"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to mould, i.e. shape or fabricate",
               "kjv_def": ":--form.",
               "_strongs": "04111"
            },
            {
               "strongs": "4112",
               "greek": [
                  {
                     "_BETA": "PLASTO/S",
                     "_unicode": "πλαστός",
                     "_translit": "plastós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plas-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4111"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "moulded, i.e. (by implication) artificial or (figuratively)\n fictitious (false)",
               "kjv_def": ":--feigned.",
               "_strongs": "04112"
            },
            {
               "strongs": "4113",
               "greek": [
                  {
                     "_BETA": "PLATEI=A",
                     "_unicode": "πλατεῖα",
                     "_translit": "plateîa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plat-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4116"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a wide \"plat\" or \"place\", i.e. open square",
               "kjv_def": ":--street.",
               "_strongs": "04113"
            },
            {
               "strongs": "4114",
               "greek": [
                  {
                     "_BETA": "PLA/TOS",
                     "_unicode": "πλάτος",
                     "_translit": "plátos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plat'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4116"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "width",
               "kjv_def": ":--breadth.",
               "_strongs": "04114"
            },
            {
               "strongs": "4115",
               "greek": [
                  {
                     "_BETA": "PLATU/NW",
                     "_unicode": "πλατύνω",
                     "_translit": "platýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plat-oo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4116"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to widen (literally or figuratively)",
               "kjv_def": ":--make broad, enlarge.",
               "_strongs": "04115"
            },
            {
               "strongs": "4116",
               "greek": [
                  {
                     "_BETA": "PLATU/S",
                     "_unicode": "πλατύς",
                     "_translit": "platýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plat-oos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4111"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "spread out \"flat\" (\"plot\"), i.e. broad",
               "kjv_def": ":--wide.",
               "_strongs": "04116"
            },
            {
               "strongs": "4117",
               "greek": [
                  {
                     "_BETA": "PLE/GMA",
                     "_unicode": "πλέγμα",
                     "_translit": "plégma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pleg'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4120"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a plait (of hair)",
               "kjv_def": ":--broidered hair.",
               "_strongs": "04117"
            },
            {
               "strongs": "4118",
               "greek": [
                  {
                     "_BETA": "PLEI=STOS",
                     "_unicode": "πλεῖστος",
                     "_translit": "pleîstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plice'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     }
                  ],
                  "__text": "irregular superlative of \n;"
               },
               "strongs_def": "the largest number or very large",
               "kjv_def": ":--very\n great, most.",
               "_strongs": "04118"
            },
            {
               "strongs": "4119",
               "greek": [
                  {
                     "_BETA": "PLEI/WN",
                     "_unicode": "πλείων",
                     "_translit": "pleíōn"
                  },
                  {
                     "_BETA": "PLEI=ON",
                     "_unicode": "πλεῖον",
                     "_translit": "pleîon"
                  },
                  {
                     "_BETA": "PLE/ON",
                     "_unicode": "πλέον",
                     "_translit": "pléon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pli-own"
                  },
                  {
                     "_strongs": "pli'-on"
                  },
                  {
                     "_strongs": "pleh'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     }
                  ],
                  "__text": "comparative of \n;"
               },
               "strongs_def": "more in quantity, number, or quality; also (in\n plural) the major portion",
               "kjv_def": ":--X above, + exceed, more  excellent,\n further, (very) great(-er), long(-er), (very) many, greater (more)\n part, + yet but.",
               "_strongs": "04119",
               "__text": ", or neuter\n      \n  \n, or"
            },
            {
               "strongs": "4120",
               "greek": [
                  {
                     "_BETA": "PLE/KW",
                     "_unicode": "πλέκω",
                     "_translit": "plékō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plek'-o"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "to twine or braid",
               "kjv_def": ":--plait.",
               "_strongs": "04120"
            },
            {
               "strongs": "4121",
               "greek": [
                  {
                     "_BETA": "PLEONA/ZW",
                     "_unicode": "πλεονάζω",
                     "_translit": "pleonázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pleh-on-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4119"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to do, make or be more, i.e. increase (transitively or\n intransitively); by extension, to superabound",
               "kjv_def": ":--abound, abundant, make\n to increase, have over.",
               "_strongs": "04121"
            },
            {
               "strongs": "4122",
               "greek": [
                  {
                     "_BETA": "PLEONEKTE/W",
                     "_unicode": "πλεονεκτέω",
                     "_translit": "pleonektéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pleh-on-cek-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4123"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be covetous, i.e. (by implication) to over-reach",
               "kjv_def": ":--get\n an advantage, defraud, make a gain.",
               "_strongs": "04122"
            },
            {
               "strongs": "4123",
               "greek": [
                  {
                     "_BETA": "PLEONE/KTHS",
                     "_unicode": "πλεονέκτης",
                     "_translit": "pleonéktēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pleh-on-ek'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4119"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "holding (desiring) more, i.e. eager for gain\n (avaricious, hence a defrauder)",
               "kjv_def": ":--covetous.",
               "_strongs": "04123"
            },
            {
               "strongs": "4124",
               "greek": [
                  {
                     "_BETA": "PLEONECI/A",
                     "_unicode": "πλεονεξία",
                     "_translit": "pleonexía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pleh-on-ex-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4123"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "avarice, i.e. (by implication) fraudulency,\n extortion",
               "kjv_def": ":--covetous(-ness) practices, greediness.",
               "_strongs": "04124"
            },
            {
               "strongs": "4125",
               "greek": [
                  {
                     "_BETA": "PLEURA/",
                     "_unicode": "πλευρά",
                     "_translit": "pleurá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plyoo-rah'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a rib, i.e. (by extension) side",
               "kjv_def": ":--side.",
               "_strongs": "04125"
            },
            {
               "strongs": "4126",
               "greek": [
                  {
                     "_BETA": "PLE/W",
                     "_unicode": "πλέω",
                     "_translit": "pléō"
                  },
                  {
                     "_BETA": "PLEU/W",
                     "_unicode": "πλεύω",
                     "_translit": "pleúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pleh'-o"
                  },
                  {
                     "_strongs": "plyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4150"
                     }
                  ],
                  "__text": "probably a form of \n (through the idea of plunging through the\n water);"
               },
               "strongs_def": "to pass in a vessel",
               "kjv_def": ":--sail.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4130"
                  }
               ],
               "_strongs": "04126",
               "__text": ",   another form for\n      \n  \n;  which is used as an alternate in certain\n                        tenses;\n\n \n See also \n."
            },
            {
               "strongs": "4127",
               "greek": [
                  {
                     "_BETA": "PLHGH/",
                     "_unicode": "πληγή",
                     "_translit": "plēgḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play-gay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4141"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a stroke; by implication, a wound; figuratively, a\n calamity",
               "kjv_def": ":--plague, stripe, wound(-ed).",
               "_strongs": "04127"
            },
            {
               "strongs": "4128",
               "greek": [
                  {
                     "_BETA": "PLH=QOS",
                     "_unicode": "πλῆθος",
                     "_translit": "plēthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play'-thos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4130"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a fulness, i.e. a large number, throng, populace",
               "kjv_def": ":--bundle,\n company, multitude.",
               "_strongs": "04128"
            },
            {
               "strongs": "4129",
               "greek": [
                  {
                     "_BETA": "PLHQU/NW",
                     "_unicode": "πληθύνω",
                     "_translit": "plēthýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play-thoo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4128"
                     }
                  ],
                  "__text": "from another form of \n;"
               },
               "strongs_def": "to increase (transitively or\n intransitively)",
               "kjv_def": ":--abound, multiply.",
               "_strongs": "04129"
            },
            {
               "strongs": "4130",
               "greek": [
                  {
                     "_BETA": "PLH/QW",
                     "_unicode": "πλήθω",
                     "_translit": "plḗthō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play'-tho"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PLE/W",
                        "_unicode": "πλέω",
                        "_translit": "pléō"
                     },
                     {
                        "_BETA": "PI/MPLHMI",
                        "_unicode": "πίμπλημι",
                        "_translit": "pímplēmi"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "pleh'-o"
                     }
                  ],
                  "__text": "a prolonged form of a primary\n      \n  \n    (which appears only as an alternate in\n                          certain tenses and in the reduplicated form\n                          \n);"
               },
               "strongs_def": "to \"fill\" (literally or figuratively (imbue, influence, supply));\n specially, to fulfil (time)",
               "kjv_def": ":--accomplish, full (…come), furnish.",
               "_strongs": "04130",
               "__text": ";"
            },
            {
               "strongs": "4131",
               "greek": [
                  {
                     "_BETA": "PLH/KTHS",
                     "_unicode": "πλήκτης",
                     "_translit": "plḗktēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plake'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4141"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a smiter, i.e. pugnacious (quarrelsome)",
               "kjv_def": ":--striker.",
               "_strongs": "04131"
            },
            {
               "strongs": "4132",
               "greek": [
                  {
                     "_BETA": "PLH/MMURA",
                     "_unicode": "πλήμμυρα",
                     "_translit": "plḗmmyra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plame-moo'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4130"
                     }
                  ],
                  "__text": "prolonged from \n;"
               },
               "strongs_def": "flood-tide, i.e. (by analogy) a freshet",
               "kjv_def": ":--flood.",
               "_strongs": "04132"
            },
            {
               "strongs": "4133",
               "greek": [
                  {
                     "_BETA": "PLH/N",
                     "_unicode": "πλήν",
                     "_translit": "plḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plane"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4119"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "moreover (besides), i.e. albeit, save that, rather,\n yet",
               "kjv_def": ":--but (rather), except, nevertheless, notwithstanding, save, than.",
               "_strongs": "04133"
            },
            {
               "strongs": "4134",
               "greek": [
                  {
                     "_BETA": "PLH/RHS",
                     "_unicode": "πλήρης",
                     "_translit": "plḗrēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play'-race"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4130"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "replete, or covered over; by analogy, complete",
               "kjv_def": ":--full.",
               "_strongs": "04134"
            },
            {
               "strongs": "4135",
               "greek": [
                  {
                     "_BETA": "PLHROFORE/W",
                     "_unicode": "πληροφορέω",
                     "_translit": "plērophoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play-rof-or-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4134"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5409"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to carry out fully (in evidence), i.e. completely\n assure (or convince), entirely accomplish",
               "kjv_def": ":--most surely believe, fully\n know (persuade), make full proof of.",
               "_strongs": "04135"
            },
            {
               "strongs": "4136",
               "greek": [
                  {
                     "_BETA": "PLHROFORI/A",
                     "_unicode": "πληροφορία",
                     "_translit": "plērophoría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play-rof-or-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4135"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "entire confidence",
               "kjv_def": ":--(full) assurance.",
               "_strongs": "04136"
            },
            {
               "strongs": "4137",
               "greek": [
                  {
                     "_BETA": "PLHRO/W",
                     "_unicode": "πληρόω",
                     "_translit": "plēróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4134"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make replete, i.e. (literally) to cram (a net), level up\n (a hollow), or (figuratively) to furnish (or imbue, diffuse,\n influence), satisfy, execute (an office), finish (a period or task),\n verify (or coincide with a prediction), etc.",
               "kjv_def": ":--accomplish, X after,\n (be) complete, end, expire, fill (up), fulfil, (be, make) full (come),\n fully preach, perfect, supply.",
               "_strongs": "04137"
            },
            {
               "strongs": "4138",
               "greek": [
                  {
                     "_BETA": "PLH/RWMA",
                     "_unicode": "πλήρωμα",
                     "_translit": "plḗrōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play'-ro-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4137"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "repletion or completion, i.e. (subjectively) what fills (as\n contents, supplement, copiousness, multitude), or (objectively) what\n is filled (as container, performance, period)",
               "kjv_def": ":--which is put in to\n fill up, piece that filled up, fulfilling, full, fulness.",
               "_strongs": "04138"
            },
            {
               "strongs": "4139",
               "greek": [
                  {
                     "_BETA": "PLHSI/ON",
                     "_unicode": "πλησίον",
                     "_translit": "plēsíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "play-see'-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PE/LAS",
                        "_unicode": "πέλας",
                        "_translit": "pélas"
                     }
                  ],
                  "__text": "neuter of a derivative of \n (near);"
               },
               "strongs_def": "(adverbially) close by; as\n noun, a neighbor, i.e. fellow (as man, countryman, Christian or\n friend)",
               "kjv_def": ":--near, neighbour.",
               "_strongs": "04139"
            },
            {
               "strongs": "4140",
               "greek": [
                  {
                     "_BETA": "PLHSMONH/",
                     "_unicode": "πλησμονή",
                     "_translit": "plēsmonḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "place-mon-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4130"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "a filling up, i.e. (figuratively)\n gratification",
               "kjv_def": ":--satisfying.",
               "_strongs": "04140"
            },
            {
               "strongs": "4141",
               "greek": [
                  {
                     "_BETA": "PLH/SSW",
                     "_unicode": "πλήσσω",
                     "_translit": "plḗssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "place'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4111"
                     }
                  ],
                  "__text": "apparently another form of \n (through the idea of flattening out);"
               },
               "strongs_def": "to pound, i.e. (figuratively) to inflict with (calamity)",
               "kjv_def": ":--smite.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5180"
                  }
               ],
               "_strongs": "04141",
               "__text": "Compare \n."
            },
            {
               "strongs": "4142",
               "greek": [
                  {
                     "_BETA": "PLOIA/RION",
                     "_unicode": "πλοιάριον",
                     "_translit": "ploiárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ploy-ar'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4143"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a boat",
               "kjv_def": ":--boat, little (small)\n ship.",
               "_strongs": "04142"
            },
            {
               "strongs": "4143",
               "greek": [
                  {
                     "_BETA": "PLOI=ON",
                     "_unicode": "πλοῖον",
                     "_translit": "ploîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ploy'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sailer, i.e. vessel",
               "kjv_def": ":--ship(-ing).",
               "_strongs": "04143"
            },
            {
               "strongs": "4144",
               "greek": [
                  {
                     "_BETA": "PLO/OS",
                     "_unicode": "πλόος",
                     "_translit": "plóos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "plo'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sail, i.e. navigation",
               "kjv_def": ":--course, sailing, voyage.",
               "_strongs": "04144"
            },
            {
               "strongs": "4145",
               "greek": [
                  {
                     "_BETA": "PLOU/SIOS",
                     "_unicode": "πλούσιος",
                     "_translit": "ploúsios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ploo'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4149"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "wealthy; figuratively, abounding with",
               "kjv_def": ":--rich.",
               "_strongs": "04145"
            },
            {
               "strongs": "4146",
               "greek": [
                  {
                     "_BETA": "PLOUSI/WS",
                     "_unicode": "πλουσίως",
                     "_translit": "plousíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ploo-see'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4145"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "copiously",
               "kjv_def": ":--abundantly, richly.",
               "_strongs": "04146"
            },
            {
               "strongs": "4147",
               "greek": [
                  {
                     "_BETA": "PLOUTE/W",
                     "_unicode": "πλουτέω",
                     "_translit": "ploutéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ploo-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4148"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be (or become) wealthy (literally or figuratively)",
               "kjv_def": ":--be\n increased with goods, (be made, wax) rich.",
               "_strongs": "04147"
            },
            {
               "strongs": "4148",
               "greek": [
                  {
                     "_BETA": "PLOUTI/ZW",
                     "_unicode": "πλουτίζω",
                     "_translit": "ploutízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ploo-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4149"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make wealthy (figuratively)",
               "kjv_def": ":--en- (make) rich.",
               "_strongs": "04148"
            },
            {
               "strongs": "4149",
               "greek": [
                  {
                     "_BETA": "PLOU=TOS",
                     "_unicode": "πλοῦτος",
                     "_translit": "ploûtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ploo'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4130"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "wealth (as fulness), i.e. (literally) money,\n possessions, or (figuratively) abundance, richness, (specially),\n valuable bestowment",
               "kjv_def": ":--riches.",
               "_strongs": "04149"
            },
            {
               "strongs": "4150",
               "greek": [
                  {
                     "_BETA": "PLU/NW",
                     "_unicode": "πλύνω",
                     "_translit": "plýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ploo'-no"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PLU/W",
                        "_unicode": "πλύω",
                        "_translit": "plýō"
                     }
                  ],
                  "__text": "a prolonged form of an obsolete \n (to \"flow\");"
               },
               "strongs_def": "to \"plunge\", i.e.\n launder clothing",
               "kjv_def": ":--wash.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3068"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3538"
                  }
               ],
               "_strongs": "04150",
               "__text": "Compare \n, \n."
            },
            {
               "strongs": "4151",
               "greek": [
                  {
                     "_BETA": "PNEU=MA",
                     "_unicode": "πνεῦμα",
                     "_translit": "pneûma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pnyoo'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4154"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a current of air, i.e. breath (blast) or a breeze; by\n analogy or figuratively, a spirit, i.e. (human) the rational soul, (by\n implication) vital principle, mental disposition, etc., or\n (superhuman) an angel, demon, or (divine) God, Christ's spirit, the\n Holy Spirit",
               "kjv_def": ":--ghost, life, spirit(-ual, -ually), mind.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5590"
                  }
               ],
               "_strongs": "04151",
               "__text": "Compare \n."
            },
            {
               "strongs": "4152",
               "greek": [
                  {
                     "_BETA": "PNEUMATIKO/S",
                     "_unicode": "πνευματικός",
                     "_translit": "pneumatikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pnyoo-mat-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4151"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "non-carnal, i.e. (humanly) ethereal (as opposed to gross),\n or (dæmoniacally) a spirit (concretely), or (divinely) supernatural,\n regenerate, religious",
               "kjv_def": ":--spiritual.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5591"
                  }
               ],
               "_strongs": "04152",
               "__text": "Compare \n."
            },
            {
               "strongs": "4153",
               "greek": [
                  {
                     "_BETA": "PNEUMATIKW=S",
                     "_unicode": "πνευματικῶς",
                     "_translit": "pneumatikōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pnyoo-mat-ik-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4152"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "non-physically, i.e. divinely,\n figuratively",
               "kjv_def": ":--spiritually.",
               "_strongs": "04153"
            },
            {
               "strongs": "4154",
               "greek": [
                  {
                     "_BETA": "PNE/W",
                     "_unicode": "πνέω",
                     "_translit": "pnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pneh'-o"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "to breathe hard, i.e. breeze",
               "kjv_def": ":--blow.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5594"
                  }
               ],
               "_strongs": "04154",
               "__text": "Compare \n."
            },
            {
               "strongs": "4155",
               "greek": [
                  {
                     "_BETA": "PNI/GW",
                     "_unicode": "πνίγω",
                     "_translit": "pnígō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pnee'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4154"
                     }
                  ],
                  "__text": "strengthened from \n;"
               },
               "strongs_def": "to wheeze, i.e. (causative, by implication) to\n throttle or strangle (drown)",
               "kjv_def": ":--choke, take by the throat.",
               "_strongs": "04155"
            },
            {
               "strongs": "4156",
               "greek": [
                  {
                     "_BETA": "PNIKTO/S",
                     "_unicode": "πνικτός",
                     "_translit": "pniktós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pnik-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4155"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "throttled, i.e. (neuter concretely) an animal choked to\n death (not bled)",
               "kjv_def": ":--strangled.",
               "_strongs": "04156"
            },
            {
               "strongs": "4157",
               "greek": [
                  {
                     "_BETA": "PNOH/",
                     "_unicode": "πνοή",
                     "_translit": "pnoḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pno-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4154"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "respiration, a breeze",
               "kjv_def": ":--breath, wind.",
               "_strongs": "04157"
            },
            {
               "strongs": "4158",
               "greek": [
                  {
                     "_BETA": "PODH/RHS",
                     "_unicode": "ποδήρης",
                     "_translit": "podḗrēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pod-ay'-race"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "from \n and another element of uncertain affinity;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2066"
                     }
                  ],
                  "__text": "a dress (\n\n implied) reaching the ankles"
               },
               "kjv_def": ":--garment down to the foot.",
               "_strongs": "04158"
            },
            {
               "strongs": "4159",
               "greek": [
                  {
                     "_BETA": "PO/QEN",
                     "_unicode": "πόθεν",
                     "_translit": "póthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poth'-en"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4213"
                     }
                  ],
                  "__text": "from the base of \n with enclitic adverb of origin;"
               },
               "strongs_def": "from which (as\n interrogative) or what (as relative) place, state, source or\n cause",
               "kjv_def": ":--whence.",
               "_strongs": "04159"
            },
            {
               "strongs": "4160",
               "greek": [
                  {
                     "_BETA": "POIE/W",
                     "_unicode": "ποιέω",
                     "_translit": "poiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poy-eh'-o"
                  }
               ],
               "strongs_derivation": "apparently a prolonged form of an obsolete primary;",
               "strongs_def": "to make or do (in\n a very wide application, more or less direct)",
               "kjv_def": ":--abide, + agree,\n appoint, X avenge, + band together, be, bear, + bewray, bring (forth),\n cast out, cause, commit, + content, continue, deal, + without any\n delay, (would) do(-ing), execute, exercise, fulfil, gain, give, have,\n hold, X journeying, keep, + lay wait, + lighten the ship, make, X\n mean, + none of these things move me, observe, ordain, perform,\n provide, + have purged, purpose, put, + raising up, X secure, shew, X\n shoot out, spend, take, tarry, + transgress the law, work, yield.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4238"
                  }
               ],
               "_strongs": "04160",
               "__text": "Compare \n."
            },
            {
               "strongs": "4161",
               "greek": [
                  {
                     "_BETA": "POI/HMA",
                     "_unicode": "ποίημα",
                     "_translit": "poíēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poy'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a product, i.e. fabric (literally or figuratively)",
               "kjv_def": ":--thing\n that is made, workmanship.",
               "_strongs": "04161"
            },
            {
               "strongs": "4162",
               "greek": [
                  {
                     "_BETA": "POI/HSIS",
                     "_unicode": "ποίησις",
                     "_translit": "poíēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poy'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "action, i.e. performance (of the law)",
               "kjv_def": ":--deed.",
               "_strongs": "04162"
            },
            {
               "strongs": "4163",
               "greek": [
                  {
                     "_BETA": "POIHTH/S",
                     "_unicode": "ποιητής",
                     "_translit": "poiētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poy-ay-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a performer; specially, a \"poet\";",
               "kjv_def": "--doer, poet.",
               "_strongs": "04163"
            },
            {
               "strongs": "4164",
               "greek": [
                  {
                     "_BETA": "POIKI/LOS",
                     "_unicode": "ποικίλος",
                     "_translit": "poikílos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poy-kee'-los"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "motley, i.e. various in character",
               "kjv_def": ":--divers,\n manifold.",
               "_strongs": "04164"
            },
            {
               "strongs": "4165",
               "greek": [
                  {
                     "_BETA": "POIMAI/NW",
                     "_unicode": "ποιμαίνω",
                     "_translit": "poimaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poy-mah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4166"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to tend as a shepherd of (figuratively, superviser)",
               "kjv_def": ":--feed\n (cattle), rule.",
               "_strongs": "04165"
            },
            {
               "strongs": "4166",
               "greek": [
                  {
                     "_BETA": "POIMH/N",
                     "_unicode": "ποιμήν",
                     "_translit": "poimḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poy-mane'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a shepherd (literally or\n figuratively)",
               "kjv_def": ":--shepherd, pastor.",
               "_strongs": "04166"
            },
            {
               "strongs": "4167",
               "greek": [
                  {
                     "_BETA": "POI/MNH",
                     "_unicode": "ποίμνη",
                     "_translit": "poímnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poym'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4165"
                     }
                  ],
                  "__text": "contraction from \n;"
               },
               "strongs_def": "a flock (literally or figuratively)",
               "kjv_def": ":--flock,\n fold.",
               "_strongs": "04167"
            },
            {
               "strongs": "4168",
               "greek": [
                  {
                     "_BETA": "POI/MNION",
                     "_unicode": "ποίμνιον",
                     "_translit": "poímnion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poym'-nee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4167"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a flock, i.e. (figuratively)\n group (of believers)",
               "kjv_def": ":--flock.",
               "_strongs": "04168"
            },
            {
               "strongs": "4169",
               "greek": [
                  {
                     "_BETA": "POI=OS",
                     "_unicode": "ποῖος",
                     "_translit": "poîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poy'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4226"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3634"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "individualizing interrogative (of\n character) what sort of, or (of number) which one",
               "kjv_def": ":--what (manner of),\n which.",
               "_strongs": "04169"
            },
            {
               "strongs": "4170",
               "greek": [
                  {
                     "_BETA": "POLEME/W",
                     "_unicode": "πολεμέω",
                     "_translit": "poleméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-em-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4171"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be (engaged) in warfare, i.e. to battle (literally or\n figuratively)",
               "kjv_def": ":--fight, (make) war.",
               "_strongs": "04170"
            },
            {
               "strongs": "4171",
               "greek": [
                  {
                     "_BETA": "PO/LEMOS",
                     "_unicode": "πόλεμος",
                     "_translit": "pólemos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol'-em-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PE/LOMAI",
                        "_unicode": "πέλομαι",
                        "_translit": "pélomai"
                     }
                  ],
                  "__text": "from \n (to bustle);"
               },
               "strongs_def": "warfare (literally or figuratively; a single\n encounter or a series)",
               "kjv_def": ":--battle, fight, war.",
               "_strongs": "04171"
            },
            {
               "strongs": "4172",
               "greek": [
                  {
                     "_BETA": "PO/LIS",
                     "_unicode": "πόλις",
                     "_translit": "pólis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4171"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     }
                  ],
                  "__text": "probably from the same as \n, or perhaps from \n;"
               },
               "strongs_def": "a town\n (properly, with walls, of greater or less size)",
               "kjv_def": ":--city.",
               "_strongs": "04172"
            },
            {
               "strongs": "4173",
               "greek": [
                  {
                     "_BETA": "POLITA/RXHS",
                     "_unicode": "πολιτάρχης",
                     "_translit": "politárchēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-it-ar'-khace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a town-officer, i.e. magistrate",
               "kjv_def": ":--ruler of the\n city.",
               "_strongs": "04173"
            },
            {
               "strongs": "4174",
               "greek": [
                  {
                     "_BETA": "POLITEI/A",
                     "_unicode": "πολιτεία",
                     "_translit": "politeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-ee-ti'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4177"
                     }
                  ],
                  "__text": "from \n (\"polity\");"
               },
               "strongs_def": "citizenship; concretely, a\n community",
               "kjv_def": ":--commonwealth, freedom.",
               "_strongs": "04174"
            },
            {
               "strongs": "4175",
               "greek": [
                  {
                     "_BETA": "POLI/TEUMA",
                     "_unicode": "πολίτευμα",
                     "_translit": "políteuma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-it'-yoo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4176"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a community, i.e. (abstractly) citizenship\n (figuratively)",
               "kjv_def": ":--conversation.",
               "_strongs": "04175"
            },
            {
               "strongs": "4176",
               "greek": [
                  {
                     "_BETA": "POLITEU/OMAI",
                     "_unicode": "πολιτεύομαι",
                     "_translit": "politeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-it-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4177"
                     }
                  ],
                  "__text": "middle voice of a derivative of \n;"
               },
               "strongs_def": "to behave as a citizen\n (figuratively)",
               "kjv_def": ":--let conversation be, live.",
               "_strongs": "04176"
            },
            {
               "strongs": "4177",
               "greek": [
                  {
                     "_BETA": "POLI/THS",
                     "_unicode": "πολίτης",
                     "_translit": "polítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4172"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a townsman",
               "kjv_def": ":--citizen.",
               "_strongs": "04177"
            },
            {
               "strongs": "4178",
               "greek": [
                  {
                     "_BETA": "POLLA/KIS",
                     "_unicode": "πολλάκις",
                     "_translit": "pollákis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-lak'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     }
                  ],
                  "__text": "multiplicative adverb from \n;"
               },
               "strongs_def": "many times, i.e.\n frequently",
               "kjv_def": ":--oft(-en, -entimes, -times).",
               "_strongs": "04178"
            },
            {
               "strongs": "4179",
               "greek": [
                  {
                     "_BETA": "POLLAPLASI/WN",
                     "_unicode": "πολλαπλασίων",
                     "_translit": "pollaplasíōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-lap-las-ee'-ohn"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4120"
                     }
                  ],
                  "__text": "from \n and probably a derivative of \n;"
               },
               "strongs_def": "manifold, i.e. (neuter as\n noun) very much more",
               "kjv_def": ":--manifold more.",
               "_strongs": "04179"
            },
            {
               "strongs": "4180",
               "greek": [
                  {
                     "_BETA": "POLULOGI/A",
                     "_unicode": "πολυλογία",
                     "_translit": "polylogía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-oo-log-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "loquacity, i.e. prolixity",
               "kjv_def": ":--much\n speaking.",
               "_strongs": "04180"
            },
            {
               "strongs": "4181",
               "greek": [
                  {
                     "_BETA": "POLUMERW=S",
                     "_unicode": "πολυμερῶς",
                     "_translit": "polymerōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-oo-mer'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3313"
                     }
                  ],
                  "__text": "adverb from a compound of \n and \n;"
               },
               "strongs_def": "in many portions, i.e.\n variously as to time and agency (piecemeal)",
               "kjv_def": ":--at sundry times.",
               "_strongs": "04181"
            },
            {
               "strongs": "4182",
               "greek": [
                  {
                     "_BETA": "POLUPOI/KILOS",
                     "_unicode": "πολυποίκιλος",
                     "_translit": "polypoíkilos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-oo-poy'-kil-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4164"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "much variegated, i.e. multifarious",
               "kjv_def": ":--manifold.",
               "_strongs": "04182"
            },
            {
               "strongs": "4183",
               "greek": [
                  {
                     "_BETA": "POLU/S",
                     "_unicode": "πολύς",
                     "_translit": "polýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-oos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "POLLO/S",
                        "_unicode": "πολλός",
                        "_translit": "pollós"
                     }
                  ],
                  "__text": "including the forms from the alternate \n;"
               },
               "strongs_def": "(singular) much (in any\n respect) or (plural) many; neuter (singular) as adverbial, largely;\n neuter (plural) as adverb or noun often, mostly, largely",
               "kjv_def": ":--abundant, +\n altogether, common, + far (passed, spent), (+ be of a) great (age,\n deal, -ly, while), long, many, much, oft(-en (-times)), plenteous,\n sore, straitly.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4118"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "4119"
                  }
               ],
               "_strongs": "04183",
               "__text": "Compare \n, \n."
            },
            {
               "strongs": "4184",
               "greek": [
                  {
                     "_BETA": "POLU/SPLAGXNOS",
                     "_unicode": "πολύσπλαγχνος",
                     "_translit": "polýsplanchnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-oo'-splankh-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4698"
                     }
                  ],
                  "__text": "from \n and \n (figuratively);"
               },
               "strongs_def": "extremely compassionate",
               "kjv_def": ":--very\n pitiful.",
               "_strongs": "04184"
            },
            {
               "strongs": "4185",
               "greek": [
                  {
                     "_BETA": "POLUTELH/S",
                     "_unicode": "πολυτελής",
                     "_translit": "polytelḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-oo-tel-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "extremely expensive",
               "kjv_def": ":--costly, very precious, of\n great price.",
               "_strongs": "04185"
            },
            {
               "strongs": "4186",
               "greek": [
                  {
                     "_BETA": "POLU/TIMOS",
                     "_unicode": "πολύτιμος",
                     "_translit": "polýtimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-oot'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "extremely valuable",
               "kjv_def": ":--very costly, of great price.",
               "_strongs": "04186"
            },
            {
               "strongs": "4187",
               "greek": [
                  {
                     "_BETA": "POLUTRO/PWS",
                     "_unicode": "πολυτρόπως",
                     "_translit": "polytrópōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pol-oot-rop'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4183"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5158"
                     }
                  ],
                  "__text": "adverb from a compound of \n and \n;"
               },
               "strongs_def": "in many ways, i.e. variously\n as to method or form",
               "kjv_def": ":--in divers manners.",
               "_strongs": "04187"
            },
            {
               "strongs": "4188",
               "greek": [
                  {
                     "_BETA": "PO/MA",
                     "_unicode": "πόμα",
                     "_translit": "póma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pom'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "a beverage",
               "kjv_def": ":--drink.",
               "_strongs": "04188"
            },
            {
               "strongs": "4189",
               "greek": [
                  {
                     "_BETA": "PONHRI/A",
                     "_unicode": "πονηρία",
                     "_translit": "ponēría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pon-ay-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4190"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "depravity, i.e. (specially), malice; plural (concretely)\n plots, sins",
               "kjv_def": ":--iniquity, wickedness.",
               "_strongs": "04189"
            },
            {
               "strongs": "4190",
               "greek": [
                  {
                     "_BETA": "PONHRO/S",
                     "_unicode": "πονηρός",
                     "_translit": "ponērós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pon-ay-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4192"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4550"
                     }
                  ],
                  "__text": "hurtful, i.e. evil (properly, in effect or\n influence, and thus differing from \n, which refers rather to\n essential character, as well as from \n, which indicates degeneracy\n from original virtue); figuratively, calamitous; also (passively) ill,\n i.e. diseased; but especially (morally) culpable, i.e. derelict,\n vicious, facinorous; neuter (singular) mischief, malice, or (plural)\n guilt; masculine (singular) the devil, or (plural) sinners"
               },
               "kjv_def": ":--bad,\n evil, grievous, harm, lewd, malicious, wicked(-ness).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4191"
                  }
               ],
               "_strongs": "04190",
               "__text": "See also \n."
            },
            {
               "strongs": "4191",
               "greek": [
                  {
                     "_BETA": "PONHRO/TEROS",
                     "_unicode": "πονηρότερος",
                     "_translit": "ponēróteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pon-ay-rot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4190"
                     }
                  ],
                  "__text": "comparative of \n;"
               },
               "strongs_def": "more evil",
               "kjv_def": ":--more wicked.",
               "_strongs": "04191"
            },
            {
               "strongs": "4192",
               "greek": [
                  {
                     "_BETA": "PO/NOS",
                     "_unicode": "πόνος",
                     "_translit": "pónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pon'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3993"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "toil, i.e. (by implication) anguish",
               "kjv_def": ":--pain.",
               "_strongs": "04192"
            },
            {
               "strongs": "4193",
               "greek": [
                  {
                     "_BETA": "*PONTIKO/S",
                     "_unicode": "Ποντικός",
                     "_translit": "Pontikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pon-tik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4195"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Pontican, i.e. native of Pontus",
               "kjv_def": ":--born in Pontus.",
               "_strongs": "04193"
            },
            {
               "strongs": "4194",
               "greek": [
                  {
                     "_BETA": "*PO/NTIOS",
                     "_unicode": "Πόντιος",
                     "_translit": "Póntios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pon'-tee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "apparently bridged; Pontius, a Roman",
               "kjv_def": ":--Pontius.",
               "_strongs": "04194"
            },
            {
               "strongs": "4195",
               "greek": [
                  {
                     "_BETA": "*PO/NTOS",
                     "_unicode": "Πόντος",
                     "_translit": "Póntos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pon'-tos"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a sea; Pontus, a region of Asia Minor",
               "kjv_def": ":--Pontus.",
               "_strongs": "04195"
            },
            {
               "strongs": "4196",
               "greek": [
                  {
                     "_BETA": "*PO/PLIOS",
                     "_unicode": "Πόπλιος",
                     "_translit": "Póplios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pop'-lee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "apparently \"popular\"; Poplius (i.e. Publius), a\n Roman",
               "kjv_def": ":--Publius.",
               "_strongs": "04196"
            },
            {
               "strongs": "4197",
               "greek": [
                  {
                     "_BETA": "POREI/A",
                     "_unicode": "πορεία",
                     "_translit": "poreía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "travel (by land); figuratively (plural) proceedings, i.e.\n career",
               "kjv_def": ":--journey(-ing), ways.",
               "_strongs": "04197"
            },
            {
               "strongs": "4198",
               "greek": [
                  {
                     "_BETA": "POREU/OMAI",
                     "_unicode": "πορεύομαι",
                     "_translit": "poreúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3984"
                     }
                  ],
                  "__text": "middle voice from a derivative of the same as \n;"
               },
               "strongs_def": "to traverse, i.e.\n travel (literally or figuratively; especially to remove (figuratively,\n die), live, etc.);",
               "kjv_def": "--depart, go (away, forth, one's way, up), (make a,\n take a) journey, walk.",
               "_strongs": "04198"
            },
            {
               "strongs": "4199",
               "greek": [
                  {
                     "_BETA": "PORQE/W",
                     "_unicode": "πορθέω",
                     "_translit": "porthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PE/RQW",
                        "_unicode": "πέρθω",
                        "_translit": "pérthō"
                     }
                  ],
                  "__text": "prolongation from \n (to sack);"
               },
               "strongs_def": "to ravage\n (figuratively)",
               "kjv_def": ":--destroy, waste.",
               "_strongs": "04199"
            },
            {
               "strongs": "4200",
               "greek": [
                  {
                     "_BETA": "PORISMO/S",
                     "_unicode": "πορισμός",
                     "_translit": "porismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PO/ROS",
                        "_unicode": "πόρος",
                        "_translit": "póros"
                     }
                  ],
                  "__text": "from a derivative of \n (a way, i.e. means);"
               },
               "strongs_def": "furnishing\n (procuring), i.e. (by implication) money-getting (acquisition)",
               "kjv_def": ":--gain.",
               "_strongs": "04200"
            },
            {
               "strongs": "4201",
               "greek": [
                  {
                     "_BETA": "*PO/RKIOS",
                     "_unicode": "Πόρκιος",
                     "_translit": "Pórkios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por'-kee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "apparently swinish; Porcius, a Roman",
               "kjv_def": ":--Porcius.",
               "_strongs": "04201"
            },
            {
               "strongs": "4202",
               "greek": [
                  {
                     "_BETA": "PORNEI/A",
                     "_unicode": "πορνεία",
                     "_translit": "porneía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-ni'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4203"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "harlotry (including adultery and incest); figuratively,\n idolatry",
               "kjv_def": ":--fornication.",
               "_strongs": "04202"
            },
            {
               "strongs": "4203",
               "greek": [
                  {
                     "_BETA": "PORNEU/W",
                     "_unicode": "πορνεύω",
                     "_translit": "porneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "porn-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4204"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to act the harlot, i.e. (literally) indulge unlawful lust\n (of either sex), or (figuratively) practise idolatry",
               "kjv_def": ":--commit\n (fornication).",
               "_strongs": "04203"
            },
            {
               "strongs": "4204",
               "greek": [
                  {
                     "_BETA": "PO/RNH",
                     "_unicode": "πόρνη",
                     "_translit": "pórnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4205"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a strumpet; figuratively, an idolater",
               "kjv_def": ":--harlot,\n whore.",
               "_strongs": "04204"
            },
            {
               "strongs": "4205",
               "greek": [
                  {
                     "_BETA": "PO/RNOS",
                     "_unicode": "πόρνος",
                     "_translit": "pórnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por'-nos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PE/RNHMI",
                        "_unicode": "πέρνημι",
                        "_translit": "pérnēmi"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4097"
                     }
                  ],
                  "__text": "from \n (to sell; akin to the base of \n);"
               },
               "strongs_def": "a (male) prostitute\n (as venal), i.e. (by analogy) a debauchee (libertine)",
               "kjv_def": ":--fornicator,\n whoremonger.",
               "_strongs": "04205"
            },
            {
               "strongs": "4206",
               "greek": [
                  {
                     "_BETA": "PO/R)R(W",
                     "_unicode": "πόῤῥω",
                     "_translit": "pórrhō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por'-rho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "forwards, i.e. at a distance",
               "kjv_def": ":--far, a great way off.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4207"
                  }
               ],
               "_strongs": "04206",
               "__text": "See also \n."
            },
            {
               "strongs": "4207",
               "greek": [
                  {
                     "_BETA": "PO/R)R(WQEN",
                     "_unicode": "πόῤῥωθεν",
                     "_translit": "pórrhōthen"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por'-rho-then"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4206"
                     }
                  ],
                  "__text": "from \n with adverbial enclitic of source;"
               },
               "strongs_def": "from far, or (by\n implication) at a distance, i.e. distantly",
               "kjv_def": ":--afar off.",
               "_strongs": "04207"
            },
            {
               "strongs": "4208",
               "greek": [
                  {
                     "_BETA": "POR)R(WTE/RW",
                     "_unicode": "ποῤῥωτέρω",
                     "_translit": "porrhōtérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-rho-ter'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4206"
                     }
                  ],
                  "__text": "adverb comparative of \n;"
               },
               "strongs_def": "further, i.e. a greater\n distance",
               "kjv_def": ":--farther.",
               "_strongs": "04208"
            },
            {
               "strongs": "4209",
               "greek": [
                  {
                     "_BETA": "PORFU/RA",
                     "_unicode": "πορφύρα",
                     "_translit": "porphýra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-foo'-rah"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "the \"purple\" mussel, i.e. (by implication) the\n red-blue color itself, and finally a garment dyed with it",
               "kjv_def": ":--purple.",
               "_strongs": "04209"
            },
            {
               "strongs": "4210",
               "greek": [
                  {
                     "_BETA": "PORFUROU=S",
                     "_unicode": "πορφυροῦς",
                     "_translit": "porphyroûs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-foo-rooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4209"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "purpureal, i.e. bluish red",
               "kjv_def": ":--purple.",
               "_strongs": "04210"
            },
            {
               "strongs": "4211",
               "greek": [
                  {
                     "_BETA": "PORFURO/PWLIS",
                     "_unicode": "πορφυρόπωλις",
                     "_translit": "porphyrópōlis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "por-foo-rop'-o-lis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4209"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4453"
                     }
                  ],
                  "__text": "feminine of a compound of \n and \n;"
               },
               "strongs_def": "a female trader in purple\n cloth",
               "kjv_def": ":--seller of purple.",
               "_strongs": "04211"
            },
            {
               "strongs": "4212",
               "greek": [
                  {
                     "_BETA": "POSA/KIS",
                     "_unicode": "ποσάκις",
                     "_translit": "posákis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pos-ak'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4214"
                     }
                  ],
                  "__text": "multiplicative from \n;"
               },
               "strongs_def": "how many times",
               "kjv_def": ":--how oft(-en).",
               "_strongs": "04212"
            },
            {
               "strongs": "4213",
               "greek": [
                  {
                     "_BETA": "PO/SIS",
                     "_unicode": "πόσις",
                     "_translit": "pósis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pos'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "a drinking (the act), i.e. (concretely) a\n draught",
               "kjv_def": ":--drink.",
               "_strongs": "04213"
            },
            {
               "strongs": "4214",
               "greek": [
                  {
                     "_BETA": "PO/SOS",
                     "_unicode": "πόσος",
                     "_translit": "pósos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pos'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PO/S",
                        "_unicode": "πός",
                        "_translit": "pós"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "from an absolute \n (who, what) and \n;"
               },
               "strongs_def": "interrogative pronoun (of\n amount) how much (large, long or (plural) many)",
               "kjv_def": ":--how great (long,\n many), what.",
               "_strongs": "04214"
            },
            {
               "strongs": "4215",
               "greek": [
                  {
                     "_BETA": "POTAMO/S",
                     "_unicode": "ποταμός",
                     "_translit": "potamós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot-am-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4224"
                     }
                  ],
                  "__text": "probably from a derivative of the alternate of \n (compare \n);"
               },
               "strongs_def": "a\n current, brook or freshet (as drinkable), i.e. running water",
               "kjv_def": ":--flood,\n river, stream, water.",
               "_strongs": "04215"
            },
            {
               "strongs": "4216",
               "greek": [
                  {
                     "_BETA": "POTAMOFO/RHTOS",
                     "_unicode": "ποταμοφόρητος",
                     "_translit": "potamophórētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot-am-of-or'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4215"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5409"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "river-borne, i.e. overwhelmed by a\n stream",
               "kjv_def": ":--carried away of the flood.",
               "_strongs": "04216"
            },
            {
               "strongs": "4217",
               "greek": [
                  {
                     "_BETA": "POTAPO/S",
                     "_unicode": "ποταπός",
                     "_translit": "potapós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot-ap-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4219"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4226"
                     }
                  ],
                  "__text": "apparently from \n and the base of \n;"
               },
               "strongs_def": "interrogatively, whatever,\n i.e. of what possible sort",
               "kjv_def": ":--what (manner of).",
               "_strongs": "04217"
            },
            {
               "strongs": "4218",
               "greek": [
                  {
                     "_BETA": "POTE/",
                     "_unicode": "ποτέ",
                     "_translit": "poté"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot-eh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4225"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5037"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "indefinite adverb, at some time,\n ever",
               "kjv_def": ":--afore-(any, some-)time(-s), at length (the last), (+ n- )ever,\n in the old time, in time past, once, when.",
               "_strongs": "04218"
            },
            {
               "strongs": "4219",
               "greek": [
                  {
                     "_BETA": "PO/TE",
                     "_unicode": "πότε",
                     "_translit": "póte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4226"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5037"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "interrogative adverb, at what time",
               "kjv_def": ":--+\n how long, when.",
               "_strongs": "04219"
            },
            {
               "strongs": "4220",
               "greek": [
                  {
                     "_BETA": "PO/TERON",
                     "_unicode": "πότερον",
                     "_translit": "póteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot'-er-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4226"
                     }
                  ],
                  "__text": "neuter of a comparative of the base of \n;"
               },
               "strongs_def": "interrogative as adverb,\n which (of two), i.e. is it this or that",
               "kjv_def": ":--whether.",
               "_strongs": "04220"
            },
            {
               "strongs": "4221",
               "greek": [
                  {
                     "_BETA": "POTH/RION",
                     "_unicode": "ποτήριον",
                     "_translit": "potḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot-ay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "neuter of a derivative of the alternate of \n;"
               },
               "strongs_def": "a drinking-vessel; by\n extension, the contents thereof, i.e. a cupful (draught);\n figuratively, a lot or fate",
               "kjv_def": ":--cup.",
               "_strongs": "04221"
            },
            {
               "strongs": "4222",
               "greek": [
                  {
                     "_BETA": "POTI/ZW",
                     "_unicode": "ποτίζω",
                     "_translit": "potízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from a derivative of the alternate of \n;"
               },
               "strongs_def": "to furnish drink,\n irrigate",
               "kjv_def": ":--give (make) to drink, feed, water.",
               "_strongs": "04222"
            },
            {
               "strongs": "4223",
               "greek": [
                  {
                     "_BETA": "*POTI/OLOI",
                     "_unicode": "Ποτίολοι",
                     "_translit": "Potíoloi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot-ee'-ol-oy"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "little wells, i.e. mineral springs; Potioli (i.e.\n Puteoli), a place in Italy",
               "kjv_def": ":--Puteoli.",
               "_strongs": "04223"
            },
            {
               "strongs": "4224",
               "greek": [
                  {
                     "_BETA": "PO/TOS",
                     "_unicode": "πότος",
                     "_translit": "pótos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pot'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "a drinking-bout or carousal",
               "kjv_def": ":--banqueting.",
               "_strongs": "04224"
            },
            {
               "strongs": "4225",
               "greek": [
                  {
                     "_BETA": "POU/",
                     "_unicode": "πού",
                     "_translit": "poú"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PO/S",
                        "_unicode": "πός",
                        "_translit": "pós"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4214"
                     }
                  ],
                  "__text": "genitive case of an indefinite pronoun \n (some) otherwise obsolete\n (compare \n);"
               },
               "strongs_def": "as adverb of place, somewhere, i.e. nearly",
               "kjv_def": ":--about, a\n certain place.",
               "_strongs": "04225"
            },
            {
               "strongs": "4226",
               "greek": [
                  {
                     "_BETA": "POU=",
                     "_unicode": "ποῦ",
                     "_translit": "poû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PO/S",
                        "_unicode": "πός",
                        "_translit": "pós"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4225"
                     }
                  ],
                  "__text": "genitive case of an interrogative pronoun \n (what) otherwise\n obsolete (perhaps the same as \n used with the rising slide of\n inquiry);"
               },
               "strongs_def": "as adverb of place; at (by implication, to) what\n locality",
               "kjv_def": ":--where, whither.",
               "_strongs": "04226"
            },
            {
               "strongs": "4227",
               "greek": [
                  {
                     "_BETA": "*POU/DHS",
                     "_unicode": "Πούδης",
                     "_translit": "Poúdēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo'-dace"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "modest; Pudes (i.e. Pudens), a Christian",
               "kjv_def": ":--Pudens.",
               "_strongs": "04227"
            },
            {
               "strongs": "4228",
               "greek": [
                  {
                     "_BETA": "POU/S",
                     "_unicode": "πούς",
                     "_translit": "poús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pooce"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "a \"foot\" (figuratively or literally)",
               "kjv_def": ":--foot(-stool).",
               "_strongs": "04228"
            },
            {
               "strongs": "4229",
               "greek": [
                  {
                     "_BETA": "PRA=GMA",
                     "_unicode": "πρᾶγμα",
                     "_translit": "prâgma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prag'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4238"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deed; by implication, an affair; by extension, an object\n (material)",
               "kjv_def": ":--business, matter, thing, work.",
               "_strongs": "04229"
            },
            {
               "strongs": "4230",
               "greek": [
                  {
                     "_BETA": "PRAGMATEI/A",
                     "_unicode": "πραγματεία",
                     "_translit": "pragmateía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prag-mat-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4231"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a transaction, i.e. negotiation",
               "kjv_def": ":--affair.",
               "_strongs": "04230"
            },
            {
               "strongs": "4231",
               "greek": [
                  {
                     "_BETA": "PRAGMATEU/OMAI",
                     "_unicode": "πραγματεύομαι",
                     "_translit": "pragmateúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prag-mat-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4229"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to busy oneself with, i.e. to trade",
               "kjv_def": ":--occupy.",
               "_strongs": "04231"
            },
            {
               "strongs": "4232",
               "greek": [
                  {
                     "_BETA": "PRAITW/RION",
                     "_unicode": "πραιτώριον",
                     "_translit": "praitṓrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prahee-to'-ree-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "the prætorium or governor's courtroom (sometimes\n including the whole edifice and camp)",
               "kjv_def": ":--(common, judgment) hall (of\n judgment), palace, prætorium.",
               "_strongs": "04232"
            },
            {
               "strongs": "4233",
               "greek": [
                  {
                     "_BETA": "PRA/KTWR",
                     "_unicode": "πράκτωρ",
                     "_translit": "práktōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prak'-tor"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4238"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a practiser, i.e. (specially), an official\n collector",
               "kjv_def": ":--officer.",
               "_strongs": "04233"
            },
            {
               "strongs": "4234",
               "greek": [
                  {
                     "_BETA": "PRA=CIS",
                     "_unicode": "πρᾶξις",
                     "_translit": "prâxis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prax'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4238"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "practice, i.e. (concretely) an act; by extension, a\n function",
               "kjv_def": ":--deed, office, work.",
               "_strongs": "04234"
            },
            {
               "strongs": "4235",
               "greek": [
                  {
                     "_BETA": "PRA=|OS",
                     "_unicode": "πρᾷος",
                     "_translit": "prâios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prah'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4239"
                     }
                  ],
                  "__text": "a form of \n, used in certain parts;"
               },
               "strongs_def": "gentle, i.e. humble",
               "kjv_def": ":--meek.",
               "_strongs": "04235"
            },
            {
               "strongs": "4236",
               "greek": [
                  {
                     "_BETA": "PRA|O/THS",
                     "_unicode": "πρᾳότης",
                     "_translit": "praiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prah-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4235"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "gentleness, by implication, humility",
               "kjv_def": ":--meekness.",
               "_strongs": "04236"
            },
            {
               "strongs": "4237",
               "greek": [
                  {
                     "_BETA": "PRASIA/",
                     "_unicode": "πρασιά",
                     "_translit": "prasiá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pras-ee-ah'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PRA/SON",
                        "_unicode": "πράσον",
                        "_translit": "práson"
                     }
                  ],
                  "__text": "perhaps from \n (a leek, and so an onion-patch);"
               },
               "strongs_def": "a garden plot,\n i.e. (by implication, of regular beds) a row (repeated in plural by\n Hebraism, to indicate an arrangement)",
               "kjv_def": ":--in ranks.",
               "_strongs": "04237"
            },
            {
               "strongs": "4238",
               "greek": [
                  {
                     "_BETA": "PRA/SSW",
                     "_unicode": "πράσσω",
                     "_translit": "prássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pras'-so"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "to \"practise\", i.e. perform repeatedly or habitually\n (thus differing from \n, which properly refers to a single act); by\n implication, to execute, accomplish, etc.; specially, to collect\n (dues), fare (personally)"
               },
               "kjv_def": ":--commit, deeds, do, exact, keep, require,\n use arts.",
               "_strongs": "04238"
            },
            {
               "strongs": "4239",
               "greek": [
                  {
                     "_BETA": "PRAU/+S",
                     "_unicode": "πραΰς",
                     "_translit": "praÿs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prah-ooce'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "mild, i.e. (by implication) humble",
               "kjv_def": ":--meek.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4235"
                  }
               ],
               "_strongs": "04239",
               "__text": "See also \n."
            },
            {
               "strongs": "4240",
               "greek": [
                  {
                     "_BETA": "PRAU/+THS",
                     "_unicode": "πραΰτης",
                     "_translit": "praÿtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prah-oo'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4239"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "mildness, i.e. (by implication) humility",
               "kjv_def": ":--meekness.",
               "_strongs": "04240"
            },
            {
               "strongs": "4241",
               "greek": [
                  {
                     "_BETA": "PRE/PW",
                     "_unicode": "πρέπω",
                     "_translit": "prépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prep'-o"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to tower up (be conspicuous), i.e. (by\n implication) to be suitable or proper (third person singular present\n indicative, often used impersonally, it is fit or right)",
               "kjv_def": ":--become,\n comely.",
               "_strongs": "04241"
            },
            {
               "strongs": "4242",
               "greek": [
                  {
                     "_BETA": "PRESBEI/A",
                     "_unicode": "πρεσβεία",
                     "_translit": "presbeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pres-bi'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4243"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "seniority (eldership), i.e. (by implication) an embassy\n (concretely, ambassadors)",
               "kjv_def": ":--ambassage, message.",
               "_strongs": "04242"
            },
            {
               "strongs": "4243",
               "greek": [
                  {
                     "_BETA": "PRESBEU/W",
                     "_unicode": "πρεσβεύω",
                     "_translit": "presbeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pres-byoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4245"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "to be a senior, i.e. (by implication) act as a\n representative (figuratively, preacher)",
               "kjv_def": ":--be an ambassador.",
               "_strongs": "04243"
            },
            {
               "strongs": "4244",
               "greek": [
                  {
                     "_BETA": "PRESBUTE/RION",
                     "_unicode": "πρεσβυτέριον",
                     "_translit": "presbytérion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pres-boo-ter'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4245"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "the order of elders, i.e.\n (specially), Israelite Sanhedrin or Christian \"presbytery\"",
               "kjv_def": ":--(estate\n of) elder(-s), presbytery.",
               "_strongs": "04244"
            },
            {
               "strongs": "4245",
               "greek": [
                  {
                     "_BETA": "PRESBU/TEROS",
                     "_unicode": "πρεσβύτερος",
                     "_translit": "presbýteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pres-boo'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PRE/SBUS",
                        "_unicode": "πρέσβυς",
                        "_translit": "présbys"
                     }
                  ],
                  "__text": "compound of \n (elderly);"
               },
               "strongs_def": "older; as noun, a senior; specially,\n an Israelite Sanhedrist (also figuratively, member of the celestial\n council) or Christian \"presbyter\"",
               "kjv_def": ":-- elder(-est), old.",
               "_strongs": "04245"
            },
            {
               "strongs": "4246",
               "greek": [
                  {
                     "_BETA": "PRESBU/THS",
                     "_unicode": "πρεσβύτης",
                     "_translit": "presbýtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pres-boo'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4245"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "an old man",
               "kjv_def": ":--aged (man), old man.",
               "_strongs": "04246"
            },
            {
               "strongs": "4247",
               "greek": [
                  {
                     "_BETA": "PRESBU=TIS",
                     "_unicode": "πρεσβῦτις",
                     "_translit": "presbŷtis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pres-boo'-tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4246"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "an old woman",
               "kjv_def": ":--aged woman.",
               "_strongs": "04247"
            },
            {
               "strongs": "4248",
               "greek": [
                  {
                     "_BETA": "PRHNH/S",
                     "_unicode": "πρηνής",
                     "_translit": "prēnḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pray-nace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "leaning (falling) forward (\"prone\"), i.e. head\n foremost",
               "kjv_def": ":--headlong.",
               "_strongs": "04248"
            },
            {
               "strongs": "4249",
               "greek": [
                  {
                     "_BETA": "PRI/ZW",
                     "_unicode": "πρίζω",
                     "_translit": "prízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prid'-zo"
                  }
               ],
               "strongs_derivation": "a strengthened form of a primary prio (to saw);",
               "strongs_def": "to saw in two",
               "kjv_def": ":--saw\n asunder.",
               "_strongs": "04249"
            },
            {
               "strongs": "4250",
               "greek": [
                  {
                     "_BETA": "PRI/N",
                     "_unicode": "πρίν",
                     "_translit": "prín"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prin"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "prior, sooner",
               "kjv_def": ":--before (that), ere.",
               "_strongs": "04250"
            },
            {
               "strongs": "4251",
               "greek": [
                  {
                     "_BETA": "*PRI/SKA",
                     "_unicode": "Πρίσκα",
                     "_translit": "Príska"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pris'-kah"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "feminine of Priscus, ancient; Priska, a Christian\n woman",
               "kjv_def": ":--Prisca.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4252"
                  }
               ],
               "_strongs": "04251",
               "__text": "See also \n."
            },
            {
               "strongs": "4252",
               "greek": [
                  {
                     "_BETA": "*PRI/SKILLA",
                     "_unicode": "Πρίσκιλλα",
                     "_translit": "Prískilla"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pris'-cil-lah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4251"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "Priscilla (i.e. little Prisca), a Christian\n woman",
               "kjv_def": ":--Priscilla.",
               "_strongs": "04252"
            },
            {
               "strongs": "4253",
               "greek": [
                  {
                     "_BETA": "PRO/",
                     "_unicode": "πρό",
                     "_translit": "pró"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro"
                  }
               ],
               "strongs_derivation": "a primary preposition;",
               "strongs_def": "\"fore\", i.e. in front of, prior (figuratively,\n superior) to",
               "kjv_def": ":--above, ago, before, or ever.",
               "_strongs": "04253",
               "__text": "In the compounds, it\n retains the same significations."
            },
            {
               "strongs": "4254",
               "greek": [
                  {
                     "_BETA": "PROA/GW",
                     "_unicode": "προάγω",
                     "_translit": "proágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead forward (magisterially); intransitively, to\n precede (in place or time [particle  previous])",
               "kjv_def": ":--bring (forth,\n out), go before.",
               "_strongs": "04254"
            },
            {
               "strongs": "4255",
               "greek": [
                  {
                     "_BETA": "PROAIRE/OMAI",
                     "_unicode": "προαιρέομαι",
                     "_translit": "proairéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ahee-reh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to choose for oneself before another thing\n (prefer), i.e. (by implication) to propose (intend)",
               "kjv_def": ":--purpose.",
               "_strongs": "04255"
            },
            {
               "strongs": "4256",
               "greek": [
                  {
                     "_BETA": "PROAITIA/OMAI",
                     "_unicode": "προαιτιάομαι",
                     "_translit": "proaitiáomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ahee-tee-ah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "156"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to accuse already, i.e. previously\n charge",
               "kjv_def": ":--prove before.",
               "_strongs": "04256"
            },
            {
               "strongs": "4257",
               "greek": [
                  {
                     "_BETA": "PROAKOU/W",
                     "_unicode": "προακούω",
                     "_translit": "proakoúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ak-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "191"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hear already,i.e. anticipate",
               "kjv_def": ":--hear before.",
               "_strongs": "04257"
            },
            {
               "strongs": "4258",
               "greek": [
                  {
                     "_BETA": "PROAMARTA/NW",
                     "_unicode": "προαμαρτάνω",
                     "_translit": "proamartánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-am-ar-tan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "264"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sin previously (to conversion)",
               "kjv_def": ":--sin already,\n heretofore sin.",
               "_strongs": "04258"
            },
            {
               "strongs": "4259",
               "greek": [
                  {
                     "_BETA": "PROAU/LION",
                     "_unicode": "προαύλιον",
                     "_translit": "proaúlion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ow'-lee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "833"
                     }
                  ],
                  "__text": "neuter of a presumed compound of \n and \n;"
               },
               "strongs_def": "a forecourt, i.e.\n vestibule (alley-way)",
               "kjv_def": ":--porch.",
               "_strongs": "04259"
            },
            {
               "strongs": "4260",
               "greek": [
                  {
                     "_BETA": "PROBAI/NW",
                     "_unicode": "προβαίνω",
                     "_translit": "probaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prob-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to walk forward, i.e. advance\n (literally, or in years)",
               "kjv_def": ":--+ be of a great age, go farther (on), be\n well stricken.",
               "_strongs": "04260"
            },
            {
               "strongs": "4261",
               "greek": [
                  {
                     "_BETA": "PROBA/LLW",
                     "_unicode": "προβάλλω",
                     "_translit": "probállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prob-al'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw forward, i.e. push to the front,\n germinate",
               "kjv_def": ":--put forward, shoot forth.",
               "_strongs": "04261"
            },
            {
               "strongs": "4262",
               "greek": [
                  {
                     "_BETA": "PROBATIKO/S",
                     "_unicode": "προβατικός",
                     "_translit": "probatikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prob-at-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4263"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "relating to sheep, i.e. (a gate) through which they were\n led into Jerusalem",
               "kjv_def": ":--sheep (market).",
               "_strongs": "04262"
            },
            {
               "strongs": "4263",
               "greek": [
                  {
                     "_BETA": "PRO/BATON",
                     "_unicode": "πρόβατον",
                     "_translit": "próbaton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prob'-at-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4260"
                     }
                  ],
                  "__text": "probably neuter of a presumed derivative of \n;"
               },
               "strongs_def": "something that walks\n forward (a quadruped), i.e. (specially), a sheep (literally or\n figuratively)",
               "kjv_def": ":--sheep(-fold).",
               "_strongs": "04263"
            },
            {
               "strongs": "4264",
               "greek": [
                  {
                     "_BETA": "PROBIBA/ZW",
                     "_unicode": "προβιβάζω",
                     "_translit": "probibázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prob-ib-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "971"
                     }
                  ],
                  "__text": "from \n and a reduplicated form of \n;"
               },
               "strongs_def": "to force forward, i.e. bring\n to the front, instigate",
               "kjv_def": ":--draw, before instruct.",
               "_strongs": "04264"
            },
            {
               "strongs": "4265",
               "greek": [
                  {
                     "_BETA": "PROBLE/PW",
                     "_unicode": "προβλέπω",
                     "_translit": "problépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prob-lep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "991"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to look out beforehand, i.e. furnish in\n advance",
               "kjv_def": ":--provide.",
               "_strongs": "04265"
            },
            {
               "strongs": "4266",
               "greek": [
                  {
                     "_BETA": "PROGI/NOMAI",
                     "_unicode": "προγίνομαι",
                     "_translit": "progínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prog-in'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be already, i.e. have previousy transpired",
               "kjv_def": ":--be\n past.",
               "_strongs": "04266"
            },
            {
               "strongs": "4267",
               "greek": [
                  {
                     "_BETA": "PROGINW/SKW",
                     "_unicode": "προγινώσκω",
                     "_translit": "proginṓskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prog-in-oce'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to know beforehand, i.e. foresee",
               "kjv_def": ":--foreknow\n (ordain), know (before).",
               "_strongs": "04267"
            },
            {
               "strongs": "4268",
               "greek": [
                  {
                     "_BETA": "PRO/GNWSIS",
                     "_unicode": "πρόγνωσις",
                     "_translit": "prógnōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prog'-no-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4267"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "forethought",
               "kjv_def": ":--foreknowledge.",
               "_strongs": "04268"
            },
            {
               "strongs": "4269",
               "greek": [
                  {
                     "_BETA": "PRO/GONOS",
                     "_unicode": "πρόγονος",
                     "_translit": "prógonos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prog'-on-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4266"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an ancestor, (grand-)parent",
               "kjv_def": ":--forefather, parent.",
               "_strongs": "04269"
            },
            {
               "strongs": "4270",
               "greek": [
                  {
                     "_BETA": "PROGRA/FW",
                     "_unicode": "προγράφω",
                     "_translit": "prográphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prog-raf'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to write previously; figuratively, to announce,\n prescribe",
               "kjv_def": ":--before ordain, evidently set forth, write (afore,\n aforetime).",
               "_strongs": "04270"
            },
            {
               "strongs": "4271",
               "greek": [
                  {
                     "_BETA": "PRO/DHLOS",
                     "_unicode": "πρόδηλος",
                     "_translit": "pródēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prod'-ay-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1212"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "plain before all men, i.e. obvious",
               "kjv_def": ":--evident,\n manifest (open) beforehand.",
               "_strongs": "04271"
            },
            {
               "strongs": "4272",
               "greek": [
                  {
                     "_BETA": "PRODI/DWMI",
                     "_unicode": "προδίδωμι",
                     "_translit": "prodídōmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prod-id'-o-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1325"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give before the other party has given",
               "kjv_def": ":--first\n give.",
               "_strongs": "04272"
            },
            {
               "strongs": "4273",
               "greek": [
                  {
                     "_BETA": "PRODO/THS",
                     "_unicode": "προδότης",
                     "_translit": "prodótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prod-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4272"
                     }
                  ],
                  "__text": "from \n (in the sense of giving forward into another's (the enemy's)\n hands);"
               },
               "strongs_def": "a surrender",
               "kjv_def": ":--betrayer, traitor.",
               "_strongs": "04273"
            },
            {
               "strongs": "4274",
               "greek": [
                  {
                     "_BETA": "PRO/DROMOS",
                     "_unicode": "πρόδρομος",
                     "_translit": "pródromos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prod'-rom-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4390"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "a runner ahead, i.e. scout (figuratively,\n precursor)",
               "kjv_def": ":--forerunner.",
               "_strongs": "04274"
            },
            {
               "strongs": "4275",
               "greek": [
                  {
                     "_BETA": "PROEI/DW",
                     "_unicode": "προείδω",
                     "_translit": "proeídō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-i'-do"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "foresee",
               "kjv_def": ":--foresee, saw before.",
               "_strongs": "04275"
            },
            {
               "strongs": "4276",
               "greek": [
                  {
                     "_BETA": "PROELPI/ZW",
                     "_unicode": "προελπίζω",
                     "_translit": "proelpízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-el-pid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1679"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hope in advance of other confirmation",
               "kjv_def": ":--first\n trust.",
               "_strongs": "04276"
            },
            {
               "strongs": "4277",
               "greek": [
                  {
                     "_BETA": "PROE/PW",
                     "_unicode": "προέπω",
                     "_translit": "proépō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ep'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2036"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to say already, to predict",
               "kjv_def": ":--forewarn, say (speak,\n tell) before.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4280"
                  }
               ],
               "_strongs": "04277",
               "__text": "Compare \n."
            },
            {
               "strongs": "4278",
               "greek": [
                  {
                     "_BETA": "PROENA/RXOMAI",
                     "_unicode": "προενάρχομαι",
                     "_translit": "proenárchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-en-ar'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1728"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to commence already",
               "kjv_def": ":--begin (before).",
               "_strongs": "04278"
            },
            {
               "strongs": "4279",
               "greek": [
                  {
                     "_BETA": "PROEPAGGE/LLOMAI",
                     "_unicode": "προεπαγγέλλομαι",
                     "_translit": "proepangéllomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ep-ang-ghel'-lom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1861"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to promise of old",
               "kjv_def": ":--promise before.",
               "_strongs": "04279"
            },
            {
               "strongs": "4280",
               "greek": [
                  {
                     "_BETA": "PROERE/W",
                     "_unicode": "προερέω",
                     "_translit": "proeréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-er-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2046"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4277"
                     }
                  ],
                  "__text": "used as alternate of \n; to say already,\n predict"
               },
               "kjv_def": ":--foretell, say (speak, tell) before.",
               "_strongs": "04280"
            },
            {
               "strongs": "4281",
               "greek": [
                  {
                     "_BETA": "PROE/RXOMAI",
                     "_unicode": "προέρχομαι",
                     "_translit": "proérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to go onward, precede\n (in place or time)",
               "kjv_def": ":--go before (farther, forward), outgo, pass on.",
               "_strongs": "04281"
            },
            {
               "strongs": "4282",
               "greek": [
                  {
                     "_BETA": "PROETOIMA/ZW",
                     "_unicode": "προετοιμάζω",
                     "_translit": "proetoimázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-et-oy-mad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2090"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fit up in advance (literally or\n figuratively)",
               "kjv_def": ":--ordain before, prepare afore.",
               "_strongs": "04282"
            },
            {
               "strongs": "4283",
               "greek": [
                  {
                     "_BETA": "PROEUAGGELI/ZOMAI",
                     "_unicode": "προευαγγελίζομαι",
                     "_translit": "proeuangelízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-yoo-ang-ghel-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2097"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to announce glad news in\n advance",
               "kjv_def": ":--preach before the gospel.",
               "_strongs": "04283"
            },
            {
               "strongs": "4284",
               "greek": [
                  {
                     "_BETA": "PROE/XOMAI",
                     "_unicode": "προέχομαι",
                     "_translit": "proéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ekh-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to hold oneself before others, i.e.\n (figuratively) to excel",
               "kjv_def": ":--be better.",
               "_strongs": "04284"
            },
            {
               "strongs": "4285",
               "greek": [
                  {
                     "_BETA": "PROHGE/OMAI",
                     "_unicode": "προηγέομαι",
                     "_translit": "proēgéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ay-geh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2233"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead the way for others, i.e. show\n deference",
               "kjv_def": ":--prefer.",
               "_strongs": "04285"
            },
            {
               "strongs": "4286",
               "greek": [
                  {
                     "_BETA": "PRO/QESIS",
                     "_unicode": "πρόθεσις",
                     "_translit": "próthesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "proth'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4388"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a setting forth, i.e. (figuratively) proposal (intention);\n specially, the show-bread (in the Temple) as exposed before\n God",
               "kjv_def": ":--purpose, shew(-bread).",
               "_strongs": "04286"
            },
            {
               "strongs": "4287",
               "greek": [
                  {
                     "_BETA": "PROQE/SMIOS",
                     "_unicode": "προθέσμιος",
                     "_translit": "prothésmios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "proth-es'-mee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "fixed beforehand, i.e. (feminine\n with \n implied) a designated day"
               },
               "kjv_def": ":--time appointed.",
               "_strongs": "04287"
            },
            {
               "strongs": "4288",
               "greek": [
                  {
                     "_BETA": "PROQUMI/A",
                     "_unicode": "προθυμία",
                     "_translit": "prothymía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "proth-oo-mee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4289"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "predisposition, i.e. alacrity",
               "kjv_def": ":--forwardness of mind,\n readiness (of mind), ready (willing) mind.",
               "_strongs": "04288"
            },
            {
               "strongs": "4289",
               "greek": [
                  {
                     "_BETA": "PRO/QUMOS",
                     "_unicode": "πρόθυμος",
                     "_translit": "próthymos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "proth'-oo-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "forward in spirit, i.e. predisposed; neuter (as\n noun) alacrity",
               "kjv_def": ":--ready, willing.",
               "_strongs": "04289"
            },
            {
               "strongs": "4290",
               "greek": [
                  {
                     "_BETA": "PROQU/MWS",
                     "_unicode": "προθύμως",
                     "_translit": "prothýmōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "proth-oo'-moce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4289"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "with alacrity",
               "kjv_def": ":--willingly.",
               "_strongs": "04290"
            },
            {
               "strongs": "4291",
               "greek": [
                  {
                     "_BETA": "PROI/+STHMI",
                     "_unicode": "προΐστημι",
                     "_translit": "proḯstēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand before, i.e. (in rank) to preside, or (by\n implication) to practise",
               "kjv_def": ":--maintain, be over, rule.",
               "_strongs": "04291"
            },
            {
               "strongs": "4292",
               "greek": [
                  {
                     "_BETA": "PROKALE/OMAI",
                     "_unicode": "προκαλέομαι",
                     "_translit": "prokaléomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok-al-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to call forth to oneself (challenge),\n i.e. (by implication) to irritate",
               "kjv_def": ":--provoke.",
               "_strongs": "04292"
            },
            {
               "strongs": "4293",
               "greek": [
                  {
                     "_BETA": "PROKATAGGE/LLW",
                     "_unicode": "προκαταγγέλλω",
                     "_translit": "prokatangéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok-at-ang-ghel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2605"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to anounce beforehand, i.e. predict,\n promise",
               "kjv_def": ":--foretell, have notice, (shew) before.",
               "_strongs": "04293"
            },
            {
               "strongs": "4294",
               "greek": [
                  {
                     "_BETA": "PROKATARTI/ZW",
                     "_unicode": "προκαταρτίζω",
                     "_translit": "prokatartízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok-at-ar-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2675"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to prepare in advance",
               "kjv_def": ":--make up beforehand.",
               "_strongs": "04294"
            },
            {
               "strongs": "4295",
               "greek": [
                  {
                     "_BETA": "PRO/KEIMAI",
                     "_unicode": "πρόκειμαι",
                     "_translit": "prókeimai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok'-i-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lie before the view, i.e. (figuratively) to be\n present (to the mind), to stand forth (as an example or reward)",
               "kjv_def": ":--be\n first, set before (forth).",
               "_strongs": "04295"
            },
            {
               "strongs": "4296",
               "greek": [
                  {
                     "_BETA": "PROKHRU/SSW",
                     "_unicode": "προκηρύσσω",
                     "_translit": "prokērýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok-ay-rooce'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2784"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to herald (i.e. proclaim) in advance",
               "kjv_def": ":--before\n (first) preach.",
               "_strongs": "04296"
            },
            {
               "strongs": "4297",
               "greek": [
                  {
                     "_BETA": "PROKOPH/",
                     "_unicode": "προκοπή",
                     "_translit": "prokopḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok-op-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4298"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "progress, i.e. advancement (subjectively or\n objectively)",
               "kjv_def": ":--furtherance, profit.",
               "_strongs": "04297"
            },
            {
               "strongs": "4298",
               "greek": [
                  {
                     "_BETA": "PROKO/PTW",
                     "_unicode": "προκόπτω",
                     "_translit": "prokóptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok-op'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to drive forward (as if by beating), i.e.\n (figuratively and intransitively) to advance (in amount, to grow; in\n time, to be well along)",
               "kjv_def": ":--increase, proceed, profit, be far spent,\n wax.",
               "_strongs": "04298"
            },
            {
               "strongs": "4299",
               "greek": [
                  {
                     "_BETA": "PRO/KRIMA",
                     "_unicode": "πρόκριμα",
                     "_translit": "prókrima"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok'-ree-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a prejudgment (prejudice), i.e.\n prepossession",
               "kjv_def": ":--prefer one before another.",
               "_strongs": "04299"
            },
            {
               "strongs": "4300",
               "greek": [
                  {
                     "_BETA": "PROKURO/W",
                     "_unicode": "προκυρόω",
                     "_translit": "prokyróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prok-oo-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2964"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to ratify previously",
               "kjv_def": ":--confirm before.",
               "_strongs": "04300"
            },
            {
               "strongs": "4301",
               "greek": [
                  {
                     "_BETA": "PROLAMBA/NW",
                     "_unicode": "προλαμβάνω",
                     "_translit": "prolambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prol-am-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take in advance, i.e. (literally) eat before\n others have an opportunity; (figuratively) to anticipate,\n surprise",
               "kjv_def": ":--come aforehand, overtake, take before.",
               "_strongs": "04301"
            },
            {
               "strongs": "4302",
               "greek": [
                  {
                     "_BETA": "PROLE/GW",
                     "_unicode": "προλέγω",
                     "_translit": "prolégō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prol-eg'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to say beforehand, i.e. predict,\n forewarn",
               "kjv_def": ":--foretell, tell before.",
               "_strongs": "04302"
            },
            {
               "strongs": "4303",
               "greek": [
                  {
                     "_BETA": "PROMARTU/ROMAI",
                     "_unicode": "προμαρτύρομαι",
                     "_translit": "promartýromai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prom-ar-too'-rom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3143"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be a witness in advance i.e. predict",
               "kjv_def": ":--testify\n beforehand.",
               "_strongs": "04303"
            },
            {
               "strongs": "4304",
               "greek": [
                  {
                     "_BETA": "PROMELETA/W",
                     "_unicode": "προμελετάω",
                     "_translit": "promeletáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prom-el-et-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3191"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to premeditate",
               "kjv_def": ":--meditate before.",
               "_strongs": "04304"
            },
            {
               "strongs": "4305",
               "greek": [
                  {
                     "_BETA": "PROMERIMNA/W",
                     "_unicode": "προμεριμνάω",
                     "_translit": "promerimnáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prom-er-im-nah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3309"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to care (anxiously) in advance",
               "kjv_def": ":--take thought\n beforehand.",
               "_strongs": "04305"
            },
            {
               "strongs": "4306",
               "greek": [
                  {
                     "_BETA": "PRONOE/W",
                     "_unicode": "προνοέω",
                     "_translit": "pronoéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pron-o-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to consider in advance, i.e. look out for\n beforehand (actively, by way of maintenance for others; middle voice\n by way of circumspection for oneself)",
               "kjv_def": ":--provide (for).",
               "_strongs": "04306"
            },
            {
               "strongs": "4307",
               "greek": [
                  {
                     "_BETA": "PRO/NOIA",
                     "_unicode": "πρόνοια",
                     "_translit": "prónoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pron'-oy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4306"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "forethought, i.e. provident care or supply",
               "kjv_def": ":--providence,\n provision.",
               "_strongs": "04307"
            },
            {
               "strongs": "4308",
               "greek": [
                  {
                     "_BETA": "PROORA/W",
                     "_unicode": "προοράω",
                     "_translit": "prooráō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-or-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to behold in advance, i.e. (actively) to notice\n (another) previously, or (middle voice) to keep in (one's own)\n view",
               "kjv_def": ":--foresee, see before.",
               "_strongs": "04308"
            },
            {
               "strongs": "4309",
               "greek": [
                  {
                     "_BETA": "PROORI/ZW",
                     "_unicode": "προορίζω",
                     "_translit": "proorízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-or-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3724"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to limit in advance, i.e. (figuratively)\n predetermine",
               "kjv_def": ":--determine before, ordain, predestinate.",
               "_strongs": "04309"
            },
            {
               "strongs": "4310",
               "greek": [
                  {
                     "_BETA": "PROPA/SXW",
                     "_unicode": "προπάσχω",
                     "_translit": "propáschō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prop-as'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3958"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to undergo hardship previously",
               "kjv_def": ":--suffer before.",
               "_strongs": "04310"
            },
            {
               "strongs": "4311",
               "greek": [
                  {
                     "_BETA": "PROPE/MPW",
                     "_unicode": "προπέμπω",
                     "_translit": "propémpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prop-em'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3992"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to send forward, i.e. escort or aid in\n travel",
               "kjv_def": ":--accompany, bring (forward) on journey (way), conduct forth.",
               "_strongs": "04311"
            },
            {
               "strongs": "4312",
               "greek": [
                  {
                     "_BETA": "PROPETH/S",
                     "_unicode": "προπετής",
                     "_translit": "propetḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prop-et-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "falling forward, i.e. headlong\n (figuratively, precipitate)",
               "kjv_def": ":--heady, rash(-ly).",
               "_strongs": "04312"
            },
            {
               "strongs": "4313",
               "greek": [
                  {
                     "_BETA": "PROPOREU/OMAI",
                     "_unicode": "προπορεύομαι",
                     "_translit": "proporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prop-or-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to precede (as guide or herald)",
               "kjv_def": ":--go before.",
               "_strongs": "04313"
            },
            {
               "strongs": "4314",
               "greek": [
                  {
                     "_BETA": "PRO/S",
                     "_unicode": "πρός",
                     "_translit": "prós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "__text": "a strengthened form of \n;"
               },
               "strongs_def": "a preposition of direction; forward to,\n i.e. toward (with the genitive case, the side of, i.e. pertaining to;\n with the dative case, by the side of, i.e. near to; usually with the\n accusative case, the place, time, occasion, or respect, which is the\n destination of the relation, i.e. whither or for which it is\n predicated)",
               "kjv_def": ":--about, according to , against, among, at, because of,\n before, between, (where-)by, for, X at thy house, in, for intent, nigh\n unto, of, which pertain to, that, to (the end that), X together, to\n (you) -ward, unto, with(-in).",
               "_strongs": "04314",
               "__text": "In the compound case, it denotes\n essentially the same applications, namely, motion towards, accession\n to, or nearness at."
            },
            {
               "strongs": "4315",
               "greek": [
                  {
                     "_BETA": "PROSA/BBATON",
                     "_unicode": "προσάββατον",
                     "_translit": "prosábbaton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ab'-bat-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4521"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a fore-sabbath, i.e. the Sabbath-eve",
               "kjv_def": ":--day before\n the sabbath.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3904"
                  }
               ],
               "_strongs": "04315",
               "__text": "Compare \n."
            },
            {
               "strongs": "4316",
               "greek": [
                  {
                     "_BETA": "PROSAGOREU/W",
                     "_unicode": "προσαγορεύω",
                     "_translit": "prosagoreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ag-or-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "58"
                     }
                  ],
                  "__text": "from \n and a derivative of \n (mean to harangue);"
               },
               "strongs_def": "to address, i.e.\n salute by name",
               "kjv_def": ":--call.",
               "_strongs": "04316"
            },
            {
               "strongs": "4317",
               "greek": [
                  {
                     "_BETA": "PROSA/GW",
                     "_unicode": "προσάγω",
                     "_translit": "proságō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead towards, i.e. (transitively) to conduct near\n (summon, present), or (intransitively) to approach",
               "kjv_def": ":--bring, draw near.",
               "_strongs": "04317"
            },
            {
               "strongs": "4318",
               "greek": [
                  {
                     "_BETA": "PROSAGWGH/",
                     "_unicode": "προσαγωγή",
                     "_translit": "prosagōgḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ag-ogue-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4317"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "72"
                     }
                  ],
                  "__text": "from \n (compare \n);"
               },
               "strongs_def": "admission",
               "kjv_def": ":--access.",
               "_strongs": "04318"
            },
            {
               "strongs": "4319",
               "greek": [
                  {
                     "_BETA": "PROSAITE/W",
                     "_unicode": "προσαιτέω",
                     "_translit": "prosaitéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ahee-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to ask repeatedly (importune), i.e. solicit",
               "kjv_def": ":--beg.",
               "_strongs": "04319"
            },
            {
               "strongs": "4320",
               "greek": [
                  {
                     "_BETA": "PROSANABAI/NW",
                     "_unicode": "προσαναβαίνω",
                     "_translit": "prosanabaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-an-ab-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "305"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to ascend farther, i.e. be promoted (take an upper\n (more honorable) seat)",
               "kjv_def": ":--go up.",
               "_strongs": "04320"
            },
            {
               "strongs": "4321",
               "greek": [
                  {
                     "_BETA": "PROSANALI/SKW",
                     "_unicode": "προσαναλίσκω",
                     "_translit": "prosanalískō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-an-al-is'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "355"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to expend further",
               "kjv_def": ":--spend.",
               "_strongs": "04321"
            },
            {
               "strongs": "4322",
               "greek": [
                  {
                     "_BETA": "PROSANAPLHRO/W",
                     "_unicode": "προσαναπληρόω",
                     "_translit": "prosanaplēróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-an-ap-lay-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "378"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fill up further, i.e. furnish fully",
               "kjv_def": ":--supply.",
               "_strongs": "04322"
            },
            {
               "strongs": "4323",
               "greek": [
                  {
                     "_BETA": "PROSANATI/QHMI",
                     "_unicode": "προσανατίθημι",
                     "_translit": "prosanatíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-an-at-ith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "394"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lay up in addition, i.e. (middle voice and\n figuratively) to impart or (by implication) to consult",
               "kjv_def": ":--in conference\n add, confer.",
               "_strongs": "04323"
            },
            {
               "strongs": "4324",
               "greek": [
                  {
                     "_BETA": "PROSAPEILE/W",
                     "_unicode": "προσαπειλέω",
                     "_translit": "prosapeiléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ap-i-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "546"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to menace additionally",
               "kjv_def": ":--i.",
               "_strongs": "04324",
               "__text": "e. threaten further."
            },
            {
               "strongs": "4325",
               "greek": [
                  {
                     "_BETA": "PROSDAPANA/W",
                     "_unicode": "προσδαπανάω",
                     "_translit": "prosdapanáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-dap-an-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1159"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to expend additionally",
               "kjv_def": ":--spend more.",
               "_strongs": "04325"
            },
            {
               "strongs": "4326",
               "greek": [
                  {
                     "_BETA": "PROSDE/OMAI",
                     "_unicode": "προσδέομαι",
                     "_translit": "prosdéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-deh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1189"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to require additionally, i.e. want further",
               "kjv_def": ":--need.",
               "_strongs": "04326"
            },
            {
               "strongs": "4327",
               "greek": [
                  {
                     "_BETA": "PROSDE/XOMAI",
                     "_unicode": "προσδέχομαι",
                     "_translit": "prosdéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-dekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to admit (to intercourse, hospitality, credence,\n or (figuratively) endurance); by implication, to await (with\n confidence or patience)",
               "kjv_def": ":--accept, allow, look (wait) for, take.",
               "_strongs": "04327"
            },
            {
               "strongs": "4328",
               "greek": [
                  {
                     "_BETA": "PROSDOKA/W",
                     "_unicode": "προσδοκάω",
                     "_translit": "prosdokáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-dok-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     }
                  ],
                  "__text": "from \n and dokeuo (to watch);"
               },
               "strongs_def": "to anticipate (in thought, hope or\n fear); by implication, to await",
               "kjv_def": ":--(be in) expect(-ation), look (for),\n when looked, tarry, wait for.",
               "_strongs": "04328"
            },
            {
               "strongs": "4329",
               "greek": [
                  {
                     "_BETA": "PROSDOKI/A",
                     "_unicode": "προσδοκία",
                     "_translit": "prosdokía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-dok-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4328"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "apprehension (of evil); by implication, infliction\n anticipated",
               "kjv_def": ":--expectation, looking after.",
               "_strongs": "04329"
            },
            {
               "strongs": "4330",
               "greek": [
                  {
                     "_BETA": "PROSEA/W",
                     "_unicode": "προσεάω",
                     "_translit": "proseáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-eh-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1439"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to permit further progress",
               "kjv_def": ":--suffer.",
               "_strongs": "04330"
            },
            {
               "strongs": "4331",
               "greek": [
                  {
                     "_BETA": "PROSEGGI/ZW",
                     "_unicode": "προσεγγίζω",
                     "_translit": "prosengízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-eng-ghid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1448"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to approach near",
               "kjv_def": ":--come nigh.",
               "_strongs": "04331"
            },
            {
               "strongs": "4332",
               "greek": [
                  {
                     "_BETA": "PROSEDREU/W",
                     "_unicode": "προσεδρεύω",
                     "_translit": "prosedreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ed-ryoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n;"
               },
               "strongs_def": "to sit near, i.e. attend\n as a servant",
               "kjv_def": ":--wait at.",
               "_strongs": "04332"
            },
            {
               "strongs": "4333",
               "greek": [
                  {
                     "_BETA": "PROSERGA/ZOMAI",
                     "_unicode": "προσεργάζομαι",
                     "_translit": "prosergázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-er-gad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2038"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to work additionally, i.e. (by implication)\n acquire besides",
               "kjv_def": ":--gain.",
               "_strongs": "04333"
            },
            {
               "strongs": "4334",
               "greek": [
                  {
                     "_BETA": "PROSE/RXOMAI",
                     "_unicode": "προσέρχομαι",
                     "_translit": "prosérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to approach, i.e.\n (literally) come near, visit, or (figuratively) worship, assent\n to",
               "kjv_def": ":--(as soon as he) come (unto), come thereunto, consent, draw near,\n go (near, to, unto).",
               "_strongs": "04334"
            },
            {
               "strongs": "4335",
               "greek": [
                  {
                     "_BETA": "PROSEUXH/",
                     "_unicode": "προσευχή",
                     "_translit": "proseuchḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-yoo-khay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4336"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "prayer (worship); by implication, an oratory (chapel)",
               "kjv_def": ":--X\n pray earnestly, prayer.",
               "_strongs": "04335"
            },
            {
               "strongs": "4336",
               "greek": [
                  {
                     "_BETA": "PROSEU/XOMAI",
                     "_unicode": "προσεύχομαι",
                     "_translit": "proseúchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-yoo'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2172"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to pray to God, i.e. supplicate, worship",
               "kjv_def": ":--pray (X\n earnestly, for), make prayer.",
               "_strongs": "04336"
            },
            {
               "strongs": "4337",
               "greek": [
                  {
                     "_BETA": "PROSE/XW",
                     "_unicode": "προσέχω",
                     "_translit": "proséchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "(figuratively) to hold the mind (3563 implied)\n towards, i.e. pay attention to, be cautious about, apply oneself to,\n adhere to",
               "kjv_def": ":--(give) attend(-ance, -ance at, -ance to, unto), beware, be\n given to, give (take) heed (to unto); have regard.",
               "_strongs": "04337"
            },
            {
               "strongs": "4338",
               "greek": [
                  {
                     "_BETA": "PROSHLO/W",
                     "_unicode": "προσηλόω",
                     "_translit": "prosēlóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ay-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2247"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to peg to, i.e. spike fast",
               "kjv_def": ":--nail\n to.",
               "_strongs": "04338"
            },
            {
               "strongs": "4339",
               "greek": [
                  {
                     "_BETA": "PROSH/LUTOS",
                     "_unicode": "προσήλυτος",
                     "_translit": "prosḗlytos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-ay'-loo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4334"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "an arriver from a foreign region, i.e.\n (specially), an acceder (convert) to Judaism\n (\"proselyte\")",
               "kjv_def": ":--proselyte.",
               "_strongs": "04339"
            },
            {
               "strongs": "4340",
               "greek": [
                  {
                     "_BETA": "PRO/SKAIROS",
                     "_unicode": "πρόσκαιρος",
                     "_translit": "próskairos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros'-kahee-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2540"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "for the occasion only, i.e. temporary",
               "kjv_def": ":--dur-(eth)\n for awhile, endure for a time, for a season, temporal.",
               "_strongs": "04340"
            },
            {
               "strongs": "4341",
               "greek": [
                  {
                     "_BETA": "PROSKALE/OMAI",
                     "_unicode": "προσκαλέομαι",
                     "_translit": "proskaléomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-kal-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to call toward oneself, i.e. summon,\n invite",
               "kjv_def": ":--call (for, to, unto).",
               "_strongs": "04341"
            },
            {
               "strongs": "4342",
               "greek": [
                  {
                     "_BETA": "PROSKARTERE/W",
                     "_unicode": "προσκαρτερέω",
                     "_translit": "proskarteréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-kar-ter-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2594"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be earnest towards, i.e. (to a thing) to\n persevere, be constantly diligent, or (in a place) to attend\n assiduously all the exercises, or (to a person) to adhere closely to\n (as a servitor)",
               "kjv_def": ":--attend (give self) continually (upon), continue (in,\n instant in, with), wait on (continually).",
               "_strongs": "04342"
            },
            {
               "strongs": "4343",
               "greek": [
                  {
                     "_BETA": "PROSKARTE/RHSIS",
                     "_unicode": "προσκαρτέρησις",
                     "_translit": "proskartérēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-kar-ter'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4342"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "persistancy",
               "kjv_def": ":--perseverance.",
               "_strongs": "04343"
            },
            {
               "strongs": "4344",
               "greek": [
                  {
                     "_BETA": "PROSKEFA/LAION",
                     "_unicode": "προσκεφάλαιον",
                     "_translit": "proskephálaion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-kef-al'-ahee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2776"
                     }
                  ],
                  "__text": "neuter of a presumed compound of \n and \n;"
               },
               "strongs_def": "something for the\n head, i.e. a cushion",
               "kjv_def": ":--pillow.",
               "_strongs": "04344"
            },
            {
               "strongs": "4345",
               "greek": [
                  {
                     "_BETA": "PROSKLHRO/W",
                     "_unicode": "προσκληρόω",
                     "_translit": "prosklēróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-klay-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2820"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give a common lot to, i.e. (figuratively) to\n associate with",
               "kjv_def": ":--consort with.",
               "_strongs": "04345"
            },
            {
               "strongs": "4346",
               "greek": [
                  {
                     "_BETA": "PRO/SKLISIS",
                     "_unicode": "πρόσκλισις",
                     "_translit": "prósklisis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros'-klis-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2827"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a leaning towards, i.e.\n (figuratively) proclivity (favoritism)",
               "kjv_def": ":--partiality.",
               "_strongs": "04346"
            },
            {
               "strongs": "4347",
               "greek": [
                  {
                     "_BETA": "PROSKOLLA/W",
                     "_unicode": "προσκολλάω",
                     "_translit": "proskolláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-kol-lah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2853"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to glue to, i.e. (figuratively) to\n adhere",
               "kjv_def": ":--cleave, join (self).",
               "_strongs": "04347"
            },
            {
               "strongs": "4348",
               "greek": [
                  {
                     "_BETA": "PRO/SKOMMA",
                     "_unicode": "πρόσκομμα",
                     "_translit": "próskomma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros'-kom-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4350"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a stub, i.e. (figuratively) occasion of apostasy",
               "kjv_def": ":--offence,\n stumbling(-block, (-stone)).",
               "_strongs": "04348"
            },
            {
               "strongs": "4349",
               "greek": [
                  {
                     "_BETA": "PROSKOPH/",
                     "_unicode": "προσκοπή",
                     "_translit": "proskopḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-kop-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4350"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a stumbling, i.e. (figuratively and concretely) occasion of\n sin",
               "kjv_def": ":--offence.",
               "_strongs": "04349"
            },
            {
               "strongs": "4350",
               "greek": [
                  {
                     "_BETA": "PROSKO/PTW",
                     "_unicode": "προσκόπτω",
                     "_translit": "proskóptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-kop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to strike at, i.e. surge against (as water);\n specially, to stub on, i.e. trip up (literally or figuratively)",
               "kjv_def": ":--beat\n upon, dash, stumble (at).",
               "_strongs": "04350"
            },
            {
               "strongs": "4351",
               "greek": [
                  {
                     "_BETA": "PROSKULI/W",
                     "_unicode": "προσκυλίω",
                     "_translit": "proskylíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-koo-lee'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2947"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to roll towards, i.e. block against",
               "kjv_def": ":--roll (to).",
               "_strongs": "04351"
            },
            {
               "strongs": "4352",
               "greek": [
                  {
                     "_BETA": "PROSKUNE/W",
                     "_unicode": "προσκυνέω",
                     "_translit": "proskynéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-koo-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2965"
                     }
                  ],
                  "__text": "from \n and a probable derivative of \n (meaning to kiss, like a\n dog licking his master's hand);"
               },
               "strongs_def": "to fawn or crouch to, i.e. (literally\n or figuratively) prostrate oneself in homage (do reverence to,\n adore)",
               "kjv_def": ":--worship.",
               "_strongs": "04352"
            },
            {
               "strongs": "4353",
               "greek": [
                  {
                     "_BETA": "PROSKUNHTH/S",
                     "_unicode": "προσκυνητής",
                     "_translit": "proskynētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-koo-nay-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4352"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an adorer",
               "kjv_def": ":--worshipper.",
               "_strongs": "04353"
            },
            {
               "strongs": "4354",
               "greek": [
                  {
                     "_BETA": "PROSLALE/W",
                     "_unicode": "προσλαλέω",
                     "_translit": "proslaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-lal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to talk to, i.e. converse with",
               "kjv_def": ":--speak to (with).",
               "_strongs": "04354"
            },
            {
               "strongs": "4355",
               "greek": [
                  {
                     "_BETA": "PROSLAMBA/NW",
                     "_unicode": "προσλαμβάνω",
                     "_translit": "proslambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-lam-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take to oneself, i.e. use (food), lead (aside),\n admit (to friendship or hospitality)",
               "kjv_def": ":--receive, take (unto).",
               "_strongs": "04355"
            },
            {
               "strongs": "4356",
               "greek": [
                  {
                     "_BETA": "PRO/SLHYIS",
                     "_unicode": "πρόσληψις",
                     "_translit": "próslēpsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros'-lape-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4355"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "admission",
               "kjv_def": ":--receiving.",
               "_strongs": "04356"
            },
            {
               "strongs": "4357",
               "greek": [
                  {
                     "_BETA": "PROSME/NW",
                     "_unicode": "προσμένω",
                     "_translit": "prosménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-men'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stay further, i.e. remain in a place, with a\n person; figuratively, to adhere to, persevere in",
               "kjv_def": ":--abide still, be\n with, cleave unto, continue in (with).",
               "_strongs": "04357"
            },
            {
               "strongs": "4358",
               "greek": [
                  {
                     "_BETA": "PROSORMI/ZW",
                     "_unicode": "προσορμίζω",
                     "_translit": "prosormízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-or-mid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3730"
                     }
                  ],
                  "__text": "from \n and a derivative of the same as \n (meaning to tie\n (anchor) or lull);"
               },
               "strongs_def": "to moor to, i.e. (by implication) land at",
               "kjv_def": ":--draw to\n the shore.",
               "_strongs": "04358"
            },
            {
               "strongs": "4359",
               "greek": [
                  {
                     "_BETA": "PROSOFEI/LW",
                     "_unicode": "προσοφείλω",
                     "_translit": "prosopheílō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-of-i'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3784"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be indebted additionally",
               "kjv_def": ":--over besides.",
               "_strongs": "04359"
            },
            {
               "strongs": "4360",
               "greek": [
                  {
                     "_BETA": "PROSOXQI/ZW",
                     "_unicode": "προσοχθίζω",
                     "_translit": "prosochthízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-okh-thid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "O)XQE/W",
                        "_unicode": "ὀχθέω",
                        "_translit": "ochthéō"
                     }
                  ],
                  "__text": "from \n and a form of \n (to be vexed with something irksome);"
               },
               "strongs_def": "to feel indignant at",
               "kjv_def": ":--be grieved at.",
               "_strongs": "04360"
            },
            {
               "strongs": "4361",
               "greek": [
                  {
                     "_BETA": "PRO/SPEINOS",
                     "_unicode": "πρόσπεινος",
                     "_translit": "próspeinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros'-pi-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3983"
                     }
                  ],
                  "__text": "from \n and the same as \n;"
               },
               "strongs_def": "hungering further, i.e. intensely\n hungry",
               "kjv_def": ":--very hungry.",
               "_strongs": "04361"
            },
            {
               "strongs": "4362",
               "greek": [
                  {
                     "_BETA": "PROSPH/GNUMI",
                     "_unicode": "προσπήγνυμι",
                     "_translit": "prospḗgnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-payg'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4078"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fasten to, i.e. (specially), to impale (on a\n cross)",
               "kjv_def": ":--crucify.",
               "_strongs": "04362"
            },
            {
               "strongs": "4363",
               "greek": [
                  {
                     "_BETA": "PROSPI/PTW",
                     "_unicode": "προσπίπτω",
                     "_translit": "prospíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-pip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to fall towards, i.e. (gently) prostrate oneself\n (in supplication or homage), or (violently) to rush upon (in\n storm)",
               "kjv_def": ":--beat upon, fall (down) at (before).",
               "_strongs": "04363"
            },
            {
               "strongs": "4364",
               "greek": [
                  {
                     "_BETA": "PROSPOIE/OMAI",
                     "_unicode": "προσποιέομαι",
                     "_translit": "prospoiéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-poy-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to do forward for oneself, i.e.\n pretend (as if about to do a thing)",
               "kjv_def": ":--make as though.",
               "_strongs": "04364"
            },
            {
               "strongs": "4365",
               "greek": [
                  {
                     "_BETA": "PROSPOREU/OMAI",
                     "_unicode": "προσπορεύομαι",
                     "_translit": "prosporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-por-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4313"
                     }
                  ],
                  "__text": "to journey towards, i.e. approach (not the same as\n \n)"
               },
               "kjv_def": ":--go before.",
               "_strongs": "04365"
            },
            {
               "strongs": "4366",
               "greek": [
                  {
                     "_BETA": "PROSRH/GNUMI",
                     "_unicode": "προσρήγνυμι",
                     "_translit": "prosrḗgnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-rayg'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to tear towards, i.e. burst upon (as a tempest or\n flood)",
               "kjv_def": ":--beat vehemently against (upon).",
               "_strongs": "04366"
            },
            {
               "strongs": "4367",
               "greek": [
                  {
                     "_BETA": "PROSTA/SSW",
                     "_unicode": "προστάσσω",
                     "_translit": "prostássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-tas'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to arrange towards, i.e. (figuratively)\n enjoin",
               "kjv_def": ":--bid, command.",
               "_strongs": "04367"
            },
            {
               "strongs": "4368",
               "greek": [
                  {
                     "_BETA": "PROSTA/TIS",
                     "_unicode": "προστάτις",
                     "_translit": "prostátis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-tat'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4291"
                     }
                  ],
                  "__text": "feminine of a derivative of \n;"
               },
               "strongs_def": "a patroness, i.e.\n assistant",
               "kjv_def": ":--succourer.",
               "_strongs": "04368"
            },
            {
               "strongs": "4369",
               "greek": [
                  {
                     "_BETA": "PROSTI/QHMI",
                     "_unicode": "προστίθημι",
                     "_translit": "prostíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-tith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to place additionally, i.e. lay beside, annex,\n repeat",
               "kjv_def": ":--add, again, give more, increase, lay unto, proceed further,\n speak to any more.",
               "_strongs": "04369"
            },
            {
               "strongs": "4370",
               "greek": [
                  {
                     "_BETA": "PROSTRE/XW",
                     "_unicode": "προστρέχω",
                     "_translit": "prostréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-trekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to run towards, i.e.\n hasten to meet or join",
               "kjv_def": ":--run (thither to, to).",
               "_strongs": "04370"
            },
            {
               "strongs": "4371",
               "greek": [
                  {
                     "_BETA": "PROSFA/GION",
                     "_unicode": "προσφάγιον",
                     "_translit": "prosphágion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-fag'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5315"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of a compound of \n and \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3795"
                     }
                  ],
                  "__text": "something eaten in addition to bread, i.e. a relish (specially, fish;\n compare \n)"
               },
               "kjv_def": ":--meat.",
               "_strongs": "04371"
            },
            {
               "strongs": "4372",
               "greek": [
                  {
                     "_BETA": "PRO/SFATOS",
                     "_unicode": "πρόσφατος",
                     "_translit": "prósphatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros'-fat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4969"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "previously (recently) slain\n (fresh), i.e. (figuratively) lately made",
               "kjv_def": ":--new.",
               "_strongs": "04372"
            },
            {
               "strongs": "4373",
               "greek": [
                  {
                     "_BETA": "PROSFA/TWS",
                     "_unicode": "προσφάτως",
                     "_translit": "prosphátōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-fat'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4372"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "recently",
               "kjv_def": ":--lately.",
               "_strongs": "04373"
            },
            {
               "strongs": "4374",
               "greek": [
                  {
                     "_BETA": "PROSFE/RW",
                     "_unicode": "προσφέρω",
                     "_translit": "prosphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-fer'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to bear towards, i.e.\n lead to, tender (especially to God), treat",
               "kjv_def": ":--bring (to, unto), deal\n with, do, offer (unto, up), present unto, put to.",
               "_strongs": "04374"
            },
            {
               "strongs": "4375",
               "greek": [
                  {
                     "_BETA": "PROSFILH/S",
                     "_unicode": "προσφιλής",
                     "_translit": "prosphilḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-fee-lace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5368"
                     }
                  ],
                  "__text": "from a presumed compound of \n and \n;"
               },
               "strongs_def": "friendly towards, i.e.\n acceptable",
               "kjv_def": ":--lovely.",
               "_strongs": "04375"
            },
            {
               "strongs": "4376",
               "greek": [
                  {
                     "_BETA": "PROSFORA/",
                     "_unicode": "προσφορά",
                     "_translit": "prosphorá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-for-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4374"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "presentation; concretely, an oblation (bloodless) or\n sacrifice",
               "kjv_def": ":--offering (up).",
               "_strongs": "04376"
            },
            {
               "strongs": "4377",
               "greek": [
                  {
                     "_BETA": "PROSFWNE/W",
                     "_unicode": "προσφωνέω",
                     "_translit": "prosphōnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-fo-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5455"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sound towards, i.e. address, exclaim,\n summon",
               "kjv_def": ":--call unto, speak (un-)to.",
               "_strongs": "04377"
            },
            {
               "strongs": "4378",
               "greek": [
                  {
                     "_BETA": "PRO/SXUSIS",
                     "_unicode": "πρόσχυσις",
                     "_translit": "próschysis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros'-khoo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "XE/W",
                        "_unicode": "χέω",
                        "_translit": "chéō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to pour);"
               },
               "strongs_def": "a shedding forth, i.e.\n affusion",
               "kjv_def": ":--sprinkling.",
               "_strongs": "04378"
            },
            {
               "strongs": "4379",
               "greek": [
                  {
                     "_BETA": "PROSYAU/W",
                     "_unicode": "προσψαύω",
                     "_translit": "prospsaúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-psow'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "YAU/W",
                        "_unicode": "ψαύω",
                        "_translit": "psaúō"
                     }
                  ],
                  "__text": "from \n and \n (to touch);"
               },
               "strongs_def": "to impinge, i.e. lay a finger on (in\n order to relieve)",
               "kjv_def": ":--touch.",
               "_strongs": "04379"
            },
            {
               "strongs": "4380",
               "greek": [
                  {
                     "_BETA": "PROSWPOLHPTE/W",
                     "_unicode": "προσωποληπτέω",
                     "_translit": "prosōpolēptéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-o-pol-ape-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4381"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to favor an individual, i.e. show partiality",
               "kjv_def": ":--have respect\n to persons.",
               "_strongs": "04380"
            },
            {
               "strongs": "4381",
               "greek": [
                  {
                     "_BETA": "PROSWPOLH/PTHS",
                     "_unicode": "προσωπολήπτης",
                     "_translit": "prosōpolḗptēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-o-pol-ape'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4383"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "an accepter of a face (individual), i.e.\n (specially), one exhibiting partiality",
               "kjv_def": ":--respecter of persons.",
               "_strongs": "04381"
            },
            {
               "strongs": "4382",
               "greek": [
                  {
                     "_BETA": "PROSWPOLHYI/A",
                     "_unicode": "προσωποληψία",
                     "_translit": "prosōpolēpsía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros-o-pol-ape-see'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4381"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "partiality, i.e. favoritism",
               "kjv_def": ":--respect of persons.",
               "_strongs": "04382"
            },
            {
               "strongs": "4383",
               "greek": [
                  {
                     "_BETA": "PRO/SWPON",
                     "_unicode": "πρόσωπον",
                     "_translit": "prósōpon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pros'-o-pon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4314"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "W)/Y",
                        "_unicode": "ὤψ",
                        "_translit": "ṓps"
                     }
                  ],
                  "__text": "from \n and \n (the visage, from \n);"
               },
               "strongs_def": "the front (as being towards\n view), i.e. the countenance, aspect, appearance, surface; by\n implication, presence, person",
               "kjv_def": ":--(outward) appearance, X before,\n countenance, face, fashion, (men's) person, presence.",
               "_strongs": "04383"
            },
            {
               "strongs": "4384",
               "greek": [
                  {
                     "_BETA": "PROTA/SSW",
                     "_unicode": "προτάσσω",
                     "_translit": "protássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prot-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to pre-arrange, i.e. prescribe",
               "kjv_def": ":--before appoint.",
               "_strongs": "04384"
            },
            {
               "strongs": "4385",
               "greek": [
                  {
                     "_BETA": "PROTEI/NW",
                     "_unicode": "προτείνω",
                     "_translit": "proteínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prot-i'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TEI/NW",
                        "_unicode": "τείνω",
                        "_translit": "teínō"
                     }
                  ],
                  "__text": "from \n and \n (to stretch);"
               },
               "strongs_def": "to protend, i.e. tie prostrate (for\n scourging)",
               "kjv_def": ":--bind.",
               "_strongs": "04385"
            },
            {
               "strongs": "4386",
               "greek": [
                  {
                     "_BETA": "PRO/TERON",
                     "_unicode": "πρότερον",
                     "_translit": "próteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prot'-er-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4387"
                     }
                  ],
                  "__text": "neuter of \n as adverb (with or without the article);"
               },
               "strongs_def": "previously",
               "kjv_def": ":--before, (at the) first, former.",
               "_strongs": "04386"
            },
            {
               "strongs": "4387",
               "greek": [
                  {
                     "_BETA": "PRO/TEROS",
                     "_unicode": "πρότερος",
                     "_translit": "próteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "__text": "comparative of \n;"
               },
               "strongs_def": "prior or previous",
               "kjv_def": ":--former.",
               "_strongs": "04387"
            },
            {
               "strongs": "4388",
               "greek": [
                  {
                     "_BETA": "PROTI/QEMAI",
                     "_unicode": "προτίθεμαι",
                     "_translit": "protíthemai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prot-ith'-em-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to place before, i.e. (for oneself)\n to exhibit; (to oneself) to propose (determine)",
               "kjv_def": ":--purpose, set forth.",
               "_strongs": "04388"
            },
            {
               "strongs": "4389",
               "greek": [
                  {
                     "_BETA": "PROTRE/POMAI",
                     "_unicode": "προτρέπομαι",
                     "_translit": "protrépomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prot-rep'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "middle voice from \n and the base of \n;"
               },
               "strongs_def": "to turn forward for\n oneself, i.e. encourage",
               "kjv_def": ":--exhort.",
               "_strongs": "04389"
            },
            {
               "strongs": "4390",
               "greek": [
                  {
                     "_BETA": "PROTRE/XW",
                     "_unicode": "προτρέχω",
                     "_translit": "protréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prot-rekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to run forward, i.e.\n outstrip, precede",
               "kjv_def": ":--outrun, run before.",
               "_strongs": "04390"
            },
            {
               "strongs": "4391",
               "greek": [
                  {
                     "_BETA": "PROU+PA/RXW",
                     "_unicode": "προϋπάρχω",
                     "_translit": "proÿpárchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-oop-ar'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5225"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exist before, i.e. (adverbially) to be or do\n something previously",
               "kjv_def": ":--+ be before(-time).",
               "_strongs": "04391"
            },
            {
               "strongs": "4392",
               "greek": [
                  {
                     "_BETA": "PRO/FASIS",
                     "_unicode": "πρόφασις",
                     "_translit": "próphasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prof'-as-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "an outward showing, i.e.\n pretext",
               "kjv_def": ":--cloke, colour, pretence, show.",
               "_strongs": "04392"
            },
            {
               "strongs": "4393",
               "greek": [
                  {
                     "_BETA": "PROFE/RW",
                     "_unicode": "προφέρω",
                     "_translit": "prophérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prof-er'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear forward, i.e. produce",
               "kjv_def": ":--bring forth.",
               "_strongs": "04393"
            },
            {
               "strongs": "4394",
               "greek": [
                  {
                     "_BETA": "PROFHTEI/A",
                     "_unicode": "προφητεία",
                     "_translit": "prophēteía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prof-ay-ti'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4396"
                     }
                  ],
                  "__text": "from \n (\"prophecy\");"
               },
               "strongs_def": "prediction (scriptural or other)",
               "kjv_def": ":--prophecy,\n prophesying.",
               "_strongs": "04394"
            },
            {
               "strongs": "4395",
               "greek": [
                  {
                     "_BETA": "PROFHTEU/W",
                     "_unicode": "προφητεύω",
                     "_translit": "prophēteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prof-ate-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4396"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to foretell events, divine, speak under inspiration,\n exercise the prophetic office",
               "kjv_def": ":--prophesy.",
               "_strongs": "04395"
            },
            {
               "strongs": "4396",
               "greek": [
                  {
                     "_BETA": "PROFH/THS",
                     "_unicode": "προφήτης",
                     "_translit": "prophḗtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prof-ay'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a foreteller (\"prophet\"); by\n analogy, an inspired speaker; by extension, a poet",
               "kjv_def": ":--prophet.",
               "_strongs": "04396"
            },
            {
               "strongs": "4397",
               "greek": [
                  {
                     "_BETA": "PROFHTIKO/S",
                     "_unicode": "προφητικός",
                     "_translit": "prophētikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prof-ay-tik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4396"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pertaining to a foreteller (\"prophetic\")",
               "kjv_def": ":--of prophecy, of\n the prophets.",
               "_strongs": "04397"
            },
            {
               "strongs": "4398",
               "greek": [
                  {
                     "_BETA": "PROFH=TIS",
                     "_unicode": "προφῆτις",
                     "_translit": "prophētis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prof-ay'-tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4396"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a female foreteller or an inspired\n woman",
               "kjv_def": ":--prophetess.",
               "_strongs": "04398"
            },
            {
               "strongs": "4399",
               "greek": [
                  {
                     "_BETA": "PROFQA/NW",
                     "_unicode": "προφθάνω",
                     "_translit": "prophthánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prof-than'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5348"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to get an earlier start of, i.e.\n anticipate",
               "kjv_def": ":--prevent.",
               "_strongs": "04399"
            },
            {
               "strongs": "4400",
               "greek": [
                  {
                     "_BETA": "PROXEIRI/ZOMAI",
                     "_unicode": "προχειρίζομαι",
                     "_translit": "procheirízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prokh-i-rid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     }
                  ],
                  "__text": "middle voice from \n and a derivative of \n;"
               },
               "strongs_def": "to handle for oneself\n in advance, i.e. (figuratively) to purpose",
               "kjv_def": ":--choose, make.",
               "_strongs": "04400"
            },
            {
               "strongs": "4401",
               "greek": [
                  {
                     "_BETA": "PROXEIROTONE/W",
                     "_unicode": "προχειροτονέω",
                     "_translit": "procheirotonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prokh-i-rot-on-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5500"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to elect in advance",
               "kjv_def": ":--choose before.",
               "_strongs": "04401"
            },
            {
               "strongs": "4402",
               "greek": [
                  {
                     "_BETA": "*PRO/XOROS",
                     "_unicode": "Πρόχορος",
                     "_translit": "Próchoros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prokh'-or-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5525"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "before the dance; Prochorus, a\n Christian",
               "kjv_def": ":--Prochorus.",
               "_strongs": "04402"
            },
            {
               "strongs": "4403",
               "greek": [
                  {
                     "_BETA": "PRU/MNA",
                     "_unicode": "πρύμνα",
                     "_translit": "prýmna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "proom'-nah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PRUMNU/S",
                        "_unicode": "πρυμνύς",
                        "_translit": "prymnýs"
                     }
                  ],
                  "__text": "feminine of \n (hindmost);"
               },
               "strongs_def": "the stern of a ship",
               "kjv_def": ":--hinder part,\n stern.",
               "_strongs": "04403"
            },
            {
               "strongs": "4404",
               "greek": [
                  {
                     "_BETA": "PRWI/+",
                     "_unicode": "πρωΐ",
                     "_translit": "prōḯ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "at dawn; by implication, the day-break watch",
               "kjv_def": ":--early\n (in the morning), (in the) morning.",
               "_strongs": "04404"
            },
            {
               "strongs": "4405",
               "greek": [
                  {
                     "_BETA": "PRWI/+A",
                     "_unicode": "πρωΐα",
                     "_translit": "prōḯa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4404"
                     }
                  ],
                  "__text": "feminine of a derivative of \n as noun;"
               },
               "strongs_def": "day-dawn",
               "kjv_def": ":--early, morning.",
               "_strongs": "04405"
            },
            {
               "strongs": "4406",
               "greek": [
                  {
                     "_BETA": "PRW/I+MOS",
                     "_unicode": "πρώϊμος",
                     "_translit": "prṓïmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4404"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "dawning, i.e. (by analogy) autumnal (showering, the first\n of the rainy season)",
               "kjv_def": ":--early.",
               "_strongs": "04406"
            },
            {
               "strongs": "4407",
               "greek": [
                  {
                     "_BETA": "PRWI+NO/S",
                     "_unicode": "πρωϊνός",
                     "_translit": "prōïnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-ee-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4404"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pertaining to the dawn, i.e. matutinal",
               "kjv_def": ":--morning.",
               "_strongs": "04407"
            },
            {
               "strongs": "4408",
               "greek": [
                  {
                     "_BETA": "PRW=RA",
                     "_unicode": "πρῶρα",
                     "_translit": "prōra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro'-ra"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "__text": "feminine of a presumed derivative of \n as noun;"
               },
               "strongs_def": "the prow, i.e.\n forward part of a vessel",
               "kjv_def": ":--forepart(-ship).",
               "_strongs": "04408"
            },
            {
               "strongs": "4409",
               "greek": [
                  {
                     "_BETA": "PRWTEU/W",
                     "_unicode": "πρωτεύω",
                     "_translit": "prōteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "prote-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4413"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be first (in rank or influence)",
               "kjv_def": ":--have the preeminence.",
               "_strongs": "04409"
            },
            {
               "strongs": "4410",
               "greek": [
                  {
                     "_BETA": "PRWTOKAQEDRI/A",
                     "_unicode": "πρωτοκαθεδρία",
                     "_translit": "prōtokathedría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-tok-ath-ed-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4413"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2515"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a sitting first (in the front row), i.e.\n preeminence in council",
               "kjv_def": ":--chief (highest, uppermost) seat.",
               "_strongs": "04410"
            },
            {
               "strongs": "4411",
               "greek": [
                  {
                     "_BETA": "PRWTOKLISI/A",
                     "_unicode": "πρωτοκλισία",
                     "_translit": "prōtoklisía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-tok-lis-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4413"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2828"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a reclining first (in the place of honor) at the\n dinner-bed, i.e. preeminence at meals",
               "kjv_def": ":--chief (highest, uppermost)\n room.",
               "_strongs": "04411"
            },
            {
               "strongs": "4412",
               "greek": [
                  {
                     "_BETA": "PRW=TON",
                     "_unicode": "πρῶτον",
                     "_translit": "prōton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro'-ton"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4413"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     }
                  ],
                  "__text": "neuter of \n as adverb (with or without \n);"
               },
               "strongs_def": "firstly (in time,\n place, order, or importance)",
               "kjv_def": ":--before, at the beginning, chiefly (at,\n at the) first (of all).",
               "_strongs": "04412"
            },
            {
               "strongs": "4413",
               "greek": [
                  {
                     "_BETA": "PRW=TOS",
                     "_unicode": "πρῶτος",
                     "_translit": "prōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     }
                  ],
                  "__text": "contracted superlative of \n;"
               },
               "strongs_def": "foremost (in time, place, order or\n importance)",
               "kjv_def": ":--before, beginning, best, chief(-est), first (of all),\n former.",
               "_strongs": "04413"
            },
            {
               "strongs": "4414",
               "greek": [
                  {
                     "_BETA": "PRWTOSTA/THS",
                     "_unicode": "πρωτοστάτης",
                     "_translit": "prōtostátēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-tos-tat'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4413"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "one standing first in the ranks, i.e. a captain\n (champion)",
               "kjv_def": ":--ringleader.",
               "_strongs": "04414"
            },
            {
               "strongs": "4415",
               "greek": [
                  {
                     "_BETA": "PRWTOTO/KIA",
                     "_unicode": "πρωτοτόκια",
                     "_translit": "prōtotókia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-tot-ok'-ee-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4416"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "primogeniture (as a privilege)",
               "kjv_def": ":--birthright.",
               "_strongs": "04415"
            },
            {
               "strongs": "4416",
               "greek": [
                  {
                     "_BETA": "PRWTO/TOKOS",
                     "_unicode": "πρωτότοκος",
                     "_translit": "prōtótokos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pro-tot-ok'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4413"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5088"
                     }
                  ],
                  "__text": "from \n and the alternate of \n;"
               },
               "strongs_def": "first-born (usually as noun,\n literally or figuratively)",
               "kjv_def": ":--firstbegotten(-born).",
               "_strongs": "04416"
            },
            {
               "strongs": "4417",
               "greek": [
                  {
                     "_BETA": "PTAI/W",
                     "_unicode": "πταίω",
                     "_translit": "ptaíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ptah'-yo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "a form of \n;"
               },
               "strongs_def": "to trip, i.e. (figuratively) to err, sin, fail (of\n salvation)",
               "kjv_def": ":--fall, offend, stumble.",
               "_strongs": "04417"
            },
            {
               "strongs": "4418",
               "greek": [
                  {
                     "_BETA": "PTE/RNA",
                     "_unicode": "πτέρνα",
                     "_translit": "ptérna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pter'-nah"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "the heel (figuratively)",
               "kjv_def": ":--heel.",
               "_strongs": "04418"
            },
            {
               "strongs": "4419",
               "greek": [
                  {
                     "_BETA": "PTERU/GION",
                     "_unicode": "πτερύγιον",
                     "_translit": "pterýgion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pter-oog'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4420"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a winglet, i.e.\n (figuratively) extremity (top corner)",
               "kjv_def": ":--pinnacle.",
               "_strongs": "04419"
            },
            {
               "strongs": "4420",
               "greek": [
                  {
                     "_BETA": "PTE/RUC",
                     "_unicode": "πτέρυξ",
                     "_translit": "ptéryx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pter'-oox"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4072"
                     }
                  ],
                  "__text": "from a derivative of \n (meaning a feather);"
               },
               "strongs_def": "a wing",
               "kjv_def": ":--wing.",
               "_strongs": "04420"
            },
            {
               "strongs": "4421",
               "greek": [
                  {
                     "_BETA": "PTHNO/N",
                     "_unicode": "πτηνόν",
                     "_translit": "ptēnón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ptay-non'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4071"
                     }
                  ],
                  "__text": "contraction for \n;"
               },
               "strongs_def": "a bird",
               "kjv_def": ":--bird.",
               "_strongs": "04421"
            },
            {
               "strongs": "4422",
               "greek": [
                  {
                     "_BETA": "PTOE/W",
                     "_unicode": "πτοέω",
                     "_translit": "ptoéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pto-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4072"
                     }
                  ],
                  "__text": "probably akin to the alternate of \n (through the idea of causing to\n fall) or to \n (through that of causing to fly away);"
               },
               "strongs_def": "to\n scare",
               "kjv_def": ":--frighten.",
               "_strongs": "04422"
            },
            {
               "strongs": "4423",
               "greek": [
                  {
                     "_BETA": "PTO/HSIS",
                     "_unicode": "πτόησις",
                     "_translit": "ptóēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pto'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4422"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "alarm",
               "kjv_def": ":--amazement.",
               "_strongs": "04423"
            },
            {
               "strongs": "4424",
               "greek": [
                  {
                     "_BETA": "*PTOLEMAI/+S",
                     "_unicode": "Πτολεμαΐς",
                     "_translit": "Ptolemaḯs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ptol-em-ah-is'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*PTOLEMAI=OS",
                        "_unicode": "Πτολεμαῖος",
                        "_translit": "Ptolemaîos"
                     }
                  ],
                  "__text": "from \n (Ptolemy, after whom it was named);"
               },
               "strongs_def": "Ptolemais, a place\n in Palestine",
               "kjv_def": ":--Ptolemais.",
               "_strongs": "04424"
            },
            {
               "strongs": "4425",
               "greek": [
                  {
                     "_BETA": "PTU/ON",
                     "_unicode": "πτύον",
                     "_translit": "ptýon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ptoo'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4429"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a winnowing-fork (as scattering like spittle)",
               "kjv_def": ":--fan.",
               "_strongs": "04425"
            },
            {
               "strongs": "4426",
               "greek": [
                  {
                     "_BETA": "PTU/RW",
                     "_unicode": "πτύρω",
                     "_translit": "ptýrō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ptoo'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4429"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4422"
                     }
                  ],
                  "__text": "from a presumed derivative of \n (and thus akin to \n);"
               },
               "strongs_def": "to\n frighten",
               "kjv_def": ":--terrify.",
               "_strongs": "04426"
            },
            {
               "strongs": "4427",
               "greek": [
                  {
                     "_BETA": "PTU/SMA",
                     "_unicode": "πτύσμα",
                     "_translit": "ptýsma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ptoos'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4429"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "saliva",
               "kjv_def": ":--spittle.",
               "_strongs": "04427"
            },
            {
               "strongs": "4428",
               "greek": [
                  {
                     "_BETA": "PTU/SSW",
                     "_unicode": "πτύσσω",
                     "_translit": "ptýssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ptoos'-so"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PETA/NNUMI",
                        "_unicode": "πετάννυμι",
                        "_translit": "petánnymi"
                     }
                  ],
                  "__text": "probably akin to \n (to spread;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4072"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3961"
                     }
                  ],
                  "__text": "and thus apparently allied to\n \n through the idea of expansion, and to 4429 through that of\n flattening; compare \n); to fold, i.e. furl a scroll"
               },
               "kjv_def": ":--close.",
               "_strongs": "04428"
            },
            {
               "strongs": "4429",
               "greek": [
                  {
                     "_BETA": "PTU/W",
                     "_unicode": "πτύω",
                     "_translit": "ptýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ptoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4428"
                     }
                  ],
                  "__text": "a primary verb (compare \n);"
               },
               "strongs_def": "to spit",
               "kjv_def": ":--spit.",
               "_strongs": "04429"
            },
            {
               "strongs": "4430",
               "greek": [
                  {
                     "_BETA": "PTW=MA",
                     "_unicode": "πτῶμα",
                     "_translit": "ptōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pto'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "a ruin, i.e. (specially), lifeless body\n (corpse, carrion)",
               "kjv_def": ":--dead body, carcase, corpse.",
               "_strongs": "04430"
            },
            {
               "strongs": "4431",
               "greek": [
                  {
                     "_BETA": "PTW=SIS",
                     "_unicode": "πτῶσις",
                     "_translit": "ptōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pto'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "a crash, i.e. downfall (literally or\n figuratively)",
               "kjv_def": ":--fall.",
               "_strongs": "04431"
            },
            {
               "strongs": "4432",
               "greek": [
                  {
                     "_BETA": "PTWXEI/A",
                     "_unicode": "πτωχεία",
                     "_translit": "ptōcheía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pto-khi'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4433"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "beggary, i.e. indigence (literally or\n figuratively)",
               "kjv_def": ":--poverty.",
               "_strongs": "04432"
            },
            {
               "strongs": "4433",
               "greek": [
                  {
                     "_BETA": "PTWXEU/W",
                     "_unicode": "πτωχεύω",
                     "_translit": "ptōcheúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pto-khyoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4434"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a beggar, i.e. (by implication) to become indigent\n (figuratively)",
               "kjv_def": ":--become poor.",
               "_strongs": "04433"
            },
            {
               "strongs": "4434",
               "greek": [
                  {
                     "_BETA": "PTWXO/S",
                     "_unicode": "πτωχός",
                     "_translit": "ptōchós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pto-khos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PTW/SSW",
                        "_unicode": "πτώσσω",
                        "_translit": "ptṓssō"
                     }
                  ],
                  "__text": "from \n (to crouch);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4422"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4098"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3993"
                     }
                  ],
                  "__text": "akin to \n and the alternate of \n); a\n beggar (as cringing), i.e. pauper (strictly denoting absolute or\n public mendicancy, although also used in a qualified or relative\n sense; whereas \n properly means only straitened circumstances in\n private), literally (often as noun) or figuratively\n (distressed)"
               },
               "kjv_def": ":--beggar(-ly), poor.",
               "_strongs": "04434"
            },
            {
               "strongs": "4435",
               "greek": [
                  {
                     "_BETA": "PUGMH/",
                     "_unicode": "πυγμή",
                     "_translit": "pygmḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poog-may'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PU/C",
                        "_unicode": "πύξ",
                        "_translit": "pýx"
                     }
                  ],
                  "__text": "from a primary \n (the fist as a weapon);"
               },
               "strongs_def": "the clenched hand, i.e.\n (only in dative case as adverb) with the fist (hard scrubbing)",
               "kjv_def": ":--oft.",
               "_strongs": "04435"
            },
            {
               "strongs": "4436",
               "greek": [
                  {
                     "_BETA": "*PU/QWN",
                     "_unicode": "Πύθων",
                     "_translit": "Pýthōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo'-thone"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*PUQW/",
                        "_unicode": "Πυθώ",
                        "_translit": "Pythṓ"
                     }
                  ],
                  "__text": "from \n (the name of the region where Delphi, the seat of the\n famous oracle, was located);"
               },
               "strongs_def": "a Python, i.e. (by analogy, with the\n supposed diviner there) inspiration (soothsaying)",
               "kjv_def": ":-- divination.",
               "_strongs": "04436"
            },
            {
               "strongs": "4437",
               "greek": [
                  {
                     "_BETA": "PUKNO/S",
                     "_unicode": "πυκνός",
                     "_translit": "pyknós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pook-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4635"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "clasped (thick), i.e. (figuratively) frequent;\n neuter plural (as adverb) frequently",
               "kjv_def": ":--often(-er).",
               "_strongs": "04437"
            },
            {
               "strongs": "4438",
               "greek": [
                  {
                     "_BETA": "PUKTE/W",
                     "_unicode": "πυκτέω",
                     "_translit": "pyktéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pook-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4435"
                     }
                  ],
                  "__text": "from a derivative of the same as \n;"
               },
               "strongs_def": "to box (with the fist), i.e.\n contend (as a boxer) at the games (figuratively)",
               "kjv_def": ":--fight.",
               "_strongs": "04438"
            },
            {
               "strongs": "4439",
               "greek": [
                  {
                     "_BETA": "PU/LH",
                     "_unicode": "πύλη",
                     "_translit": "pýlē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo'-lay"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a gate, i.e. the leaf or wing of a folding\n entrance (literally or figuratively)",
               "kjv_def": ":--gate.",
               "_strongs": "04439"
            },
            {
               "strongs": "4440",
               "greek": [
                  {
                     "_BETA": "PULW/N",
                     "_unicode": "πυλών",
                     "_translit": "pylṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo-lone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4439"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a gate-way, door-way of a building or city; by implication,\n a portal or vestibule",
               "kjv_def": ":--gate, porch.",
               "_strongs": "04440"
            },
            {
               "strongs": "4441",
               "greek": [
                  {
                     "_BETA": "PUNQA/NOMAI",
                     "_unicode": "πυνθάνομαι",
                     "_translit": "pynthánomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poon-than'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PU/QW",
                        "_unicode": "πύθω",
                        "_translit": "pýthō"
                     }
                  ],
                  "__text": "middle voice prolonged from a primary \n (which occurs only as an\n alternate in certain tenses);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2065"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "154"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2212"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1189"
                     }
                  ],
                  "__text": "to question, i.e. ascertain by inquiry\n (as a matter of information merely; and thus differing from \n,\n which properly means a request as a favor; and from \n, which is\n strictly a demand for something due; as well as from \n, which\n implies a search for something hidden; and from \n, which involves\n the idea of urgent need); by implication, to learn (by casual\n intelligence)"
               },
               "kjv_def": ":--ask, demand, enquire, understand.",
               "_strongs": "04441"
            },
            {
               "strongs": "4442",
               "greek": [
                  {
                     "_BETA": "PU=R",
                     "_unicode": "πῦρ",
                     "_translit": "pŷr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poor"
                  }
               ],
               "strongs_derivation": "a primary word;",
               "strongs_def": "\"fire\" (literally or figuratively, specially,\n lightning)",
               "kjv_def": ":--fiery, fire.",
               "_strongs": "04442"
            },
            {
               "strongs": "4443",
               "greek": [
                  {
                     "_BETA": "PURA/",
                     "_unicode": "πυρά",
                     "_translit": "pyrá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo-rah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4442"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a fire (concretely)",
               "kjv_def": ":--fire.",
               "_strongs": "04443"
            },
            {
               "strongs": "4444",
               "greek": [
                  {
                     "_BETA": "PU/RGOS",
                     "_unicode": "πύργος",
                     "_translit": "pýrgos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poor'-gos"
                  }
               ],
               "strongs_derivation": "apparently a primary word (\"burgh\");",
               "strongs_def": "a tower or castle",
               "kjv_def": ":--tower.",
               "_strongs": "04444"
            },
            {
               "strongs": "4445",
               "greek": [
                  {
                     "_BETA": "PURE/SSW",
                     "_unicode": "πυρέσσω",
                     "_translit": "pyréssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo-res'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4443"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be on fire, i.e. (specially), to have a fever",
               "kjv_def": ":--be sick\n of a fever.",
               "_strongs": "04445"
            },
            {
               "strongs": "4446",
               "greek": [
                  {
                     "_BETA": "PURETO/S",
                     "_unicode": "πυρετός",
                     "_translit": "pyretós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo-ret-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4445"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inflamed, i.e. (by implication) feverish (as noun,\n fever)",
               "kjv_def": ":--fever.",
               "_strongs": "04446"
            },
            {
               "strongs": "4447",
               "greek": [
                  {
                     "_BETA": "PU/RINOS",
                     "_unicode": "πύρινος",
                     "_translit": "pýrinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo'-ree-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4443"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fiery, i.e. (by implication) flaming",
               "kjv_def": ":--of fire.",
               "_strongs": "04447"
            },
            {
               "strongs": "4448",
               "greek": [
                  {
                     "_BETA": "PURO/W",
                     "_unicode": "πυρόω",
                     "_translit": "pyróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4442"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to kindle, i.e. (passively) to be ignited, glow\n (literally), be refined (by implication), or (figuratively) to be\n inflamed (with anger, grief, lust)",
               "kjv_def": ":--burn, fiery, be on fire, try.",
               "_strongs": "04448"
            },
            {
               "strongs": "4449",
               "greek": [
                  {
                     "_BETA": "PUR)R(A/ZW",
                     "_unicode": "πυῤῥάζω",
                     "_translit": "pyrrházō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poor-hrad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4450"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to redden (intransitively)",
               "kjv_def": ":--be red.",
               "_strongs": "04449"
            },
            {
               "strongs": "4450",
               "greek": [
                  {
                     "_BETA": "PUR)R(O/S",
                     "_unicode": "πυῤῥός",
                     "_translit": "pyrrhós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poor-hros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4442"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fire-like, i.e. (specially), flame- colored",
               "kjv_def": ":--red.",
               "_strongs": "04450"
            },
            {
               "strongs": "4451",
               "greek": [
                  {
                     "_BETA": "PU/RWSIS",
                     "_unicode": "πύρωσις",
                     "_translit": "pýrōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poo'-ro-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4448"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "ignition, i.e. (specially), smelting (figuratively,\n conflagration, calamity as a test)",
               "kjv_def": ":--burning, trial.",
               "_strongs": "04451"
            },
            {
               "strongs": "4452",
               "greek": [
                  {
                     "_BETA": "-PW",
                     "_unicode": "‐πω",
                     "_translit": "-pō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4458"
                     }
                  ],
                  "__text": "another form of the base of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3369"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3380"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3764"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3768"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4455"
                     }
                  ],
                  "__text": "an enclitic particle of\n indefiniteness; yet, even; used only in the compounds. See \n,\n \n, \n, \n, \n."
               },
               "_strongs": "04452"
            },
            {
               "strongs": "4453",
               "greek": [
                  {
                     "_BETA": "PWLE/W",
                     "_unicode": "πωλέω",
                     "_translit": "pōléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "po-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PE/LOMAI",
                        "_unicode": "πέλομαι",
                        "_translit": "pélomai"
                     }
                  ],
                  "__text": "probably ultimately from \n (to be busy, to trade);"
               },
               "strongs_def": "to barter (as\n a pedlar), i.e. to sell",
               "kjv_def": ":--sell, whatever is sold.",
               "_strongs": "04453"
            },
            {
               "strongs": "4454",
               "greek": [
                  {
                     "_BETA": "PW=LOS",
                     "_unicode": "πῶλος",
                     "_translit": "pōlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "po'-los"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a \"foal\" or \"filly\", i.e. (specially), a\n young ass",
               "kjv_def": ":--colt.",
               "_strongs": "04454"
            },
            {
               "strongs": "4455",
               "greek": [
                  {
                     "_BETA": "PW/POTE",
                     "_unicode": "πώποτε",
                     "_translit": "pṓpote"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "po'-pot-e"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4452"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4218"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "at any time, i.e. (with negative particle) at no\n time",
               "kjv_def": ":--at any time, + never (…to any man),\n + yet, never man.",
               "_strongs": "04455"
            },
            {
               "strongs": "4456",
               "greek": [
                  {
                     "_BETA": "PWRO/W",
                     "_unicode": "πωρόω",
                     "_translit": "pōróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "po-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PW=ROS",
                        "_unicode": "πῶρος",
                        "_translit": "pōros"
                     }
                  ],
                  "__text": "apparently from \n (a kind of stone);"
               },
               "strongs_def": "to petrify, i.e.\n (figuratively) to indurate (render stupid or callous)",
               "kjv_def": ":-- blind,\n harden.",
               "_strongs": "04456"
            },
            {
               "strongs": "4457",
               "greek": [
                  {
                     "_BETA": "PW/RWSIS",
                     "_unicode": "πώρωσις",
                     "_translit": "pṓrōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "po'-ro-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4456"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "stupidity or callousness",
               "kjv_def": ":--blindness, hardness.",
               "_strongs": "04457"
            },
            {
               "strongs": "4458",
               "greek": [
                  {
                     "_BETA": "-PW/S",
                     "_unicode": "‐πώς",
                     "_translit": "-pṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4225"
                     }
                  ],
                  "__text": "adverb from the base of \n;"
               },
               "strongs_def": "an enclitic particle of indefiniteness\n of manner; somehow or anyhow; used only in composition",
               "kjv_def": ":--haply, by any\n (some) means, perhaps.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "1513"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3381"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "4459"
                  }
               ],
               "_strongs": "04458",
               "__text": "See \n, \n. Compare \n."
            },
            {
               "strongs": "4459",
               "greek": [
                  {
                     "_BETA": "PW=S",
                     "_unicode": "πῶς",
                     "_translit": "pōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "poce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4226"
                     }
                  ],
                  "__text": "adverb from the base of \n;"
               },
               "strongs_def": "an interrogative particle of manner; in\n what way? (sometimes the question is indirect, how?); also as\n exclamation, how much!",
               "kjv_def": ":--how, after (by) what manner (means), that.",
               "_strongs": "04459",
               "__text": "(Occasionally unexpressed in English)."
            },
            {
               "strongs": "4460",
               "greek": [
                  {
                     "_BETA": "*(RAA/B",
                     "_unicode": "Ῥαάβ",
                     "_translit": "Rhaáb"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrah-ab'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "7343"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Raab (i.e. Rachab), a Canaanitess",
               "kjv_def": ":--Rahab.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4477"
                  }
               ],
               "_strongs": "04460",
               "__text": "See also \n."
            },
            {
               "strongs": "4461",
               "greek": [
                  {
                     "_BETA": "R(ABBI/",
                     "_unicode": "ῥαββί",
                     "_translit": "rhabbí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrab-bee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07227"
                     }
                  ],
                  "__text": "of Hebrew origin (\n with pronominal suffix);"
               },
               "strongs_def": "my master, i.e Rabbi,\n as an official title of honor",
               "kjv_def": ":--Master, Rabbi.",
               "_strongs": "04461"
            },
            {
               "strongs": "4462",
               "greek": [
                  {
                     "_BETA": "R(ABBONI/",
                     "_unicode": "ῥαββονί",
                     "_translit": "rhabboní"
                  },
                  {
                     "_BETA": "R(ABBOUNI/",
                     "_unicode": "ῥαββουνί",
                     "_translit": "rhabbouní"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrab-bon-ee'"
                  },
                  {
                     "_strongs": "hrab-boo-nee'"
                  }
               ],
               "strongs_derivation": "of Chaldee origin;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4461"
                     }
                  ],
                  "__text": "corresponding to"
               },
               "kjv_def": ":--Lord, Rabboni.",
               "_strongs": "04462",
               "__text": ", or"
            },
            {
               "strongs": "4463",
               "greek": [
                  {
                     "_BETA": "R(ABDI/ZW",
                     "_unicode": "ῥαβδίζω",
                     "_translit": "rhabdízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrab-did'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4464"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to strike with a stick, i.e. bastinado",
               "kjv_def": ":--beat (with rods).",
               "_strongs": "04463"
            },
            {
               "strongs": "4464",
               "greek": [
                  {
                     "_BETA": "R(A/BDOS",
                     "_unicode": "ῥάβδος",
                     "_translit": "rhábdos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrab'-dos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4474"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a stick or wand (as a cudgel, a cane or a baton\n of royalty)",
               "kjv_def": ":--rod, sceptre, staff.",
               "_strongs": "04464"
            },
            {
               "strongs": "4465",
               "greek": [
                  {
                     "_BETA": "R(ABDOU=XOS",
                     "_unicode": "ῥαβδοῦχος",
                     "_translit": "rhabdoûchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrab-doo'-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4464"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": {
                  "latin": "fasces",
                  "__text": "a rod- (the Latin \n) holder, i.e. a Roman\n lictor (constable or executioner)"
               },
               "kjv_def": ":--serjeant.",
               "_strongs": "04465"
            },
            {
               "strongs": "4466",
               "greek": [
                  {
                     "_BETA": "*(RAGAU=",
                     "_unicode": "Ῥαγαῦ",
                     "_translit": "Rhagaû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrag-ow'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07466"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Ragau (i.e. Reu), a patriarch",
               "kjv_def": ":--Ragau.",
               "_strongs": "04466"
            },
            {
               "strongs": "4467",
               "greek": [
                  {
                     "_BETA": "R(A|DIOU/RGHMA",
                     "_unicode": "ῥᾳδιούργημα",
                     "_translit": "rhaidioúrgēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrad-ee-oorg'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "R(A/|DIOS",
                        "_unicode": "ῥᾴδιος",
                        "_translit": "rháidios"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from a compound of \n (easy, i.e. reckless) and \n;"
               },
               "strongs_def": "easy-going behavior, i.e. (by extension) a crime",
               "kjv_def": ":--lewdness.",
               "_strongs": "04467"
            },
            {
               "strongs": "4468",
               "greek": [
                  {
                     "_BETA": "R(A|DIOURGI/A",
                     "_unicode": "ῥᾳδιουργία",
                     "_translit": "rhaidiourgía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrad-ee-oorg-ee'-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4467"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "recklessness, i.e. (by extension)\n malignity",
               "kjv_def": ":--mischief.",
               "_strongs": "04468"
            },
            {
               "strongs": "4469",
               "greek": [
                  {
                     "_BETA": "R(AKA/",
                     "_unicode": "ῥακά",
                     "_translit": "rhaká"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "rhak-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07386"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "O empty one, i.e. thou worthless (as\n a term of utter vilification)",
               "kjv_def": ":--Raca.",
               "_strongs": "04469"
            },
            {
               "strongs": "4470",
               "greek": [
                  {
                     "_BETA": "R(A/KOS",
                     "_unicode": "ῥάκος",
                     "_translit": "rhákos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrak'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a \"rag,\" i.e. piece of cloth",
               "kjv_def": ":--cloth.",
               "_strongs": "04470"
            },
            {
               "strongs": "4471",
               "greek": [
                  {
                     "_BETA": "*(RAMA=",
                     "_unicode": "Ῥαμᾶ",
                     "_translit": "Rhamâ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hram-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07414"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Rama (i.e. Ramah), a place in\n Palestine",
               "kjv_def": ":--Rama.",
               "_strongs": "04471"
            },
            {
               "strongs": "4472",
               "greek": [
                  {
                     "_BETA": "R(ANTI/ZW",
                     "_unicode": "ῥαντίζω",
                     "_translit": "rhantízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hran-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "R(AI/NW",
                        "_unicode": "ῥαίνω",
                        "_translit": "rhaínō"
                     }
                  ],
                  "__text": "from a derivative of \n (to sprinkle);"
               },
               "strongs_def": "to render besprinkled, i.e.\n asperse (ceremonially or figuratively)",
               "kjv_def": ":-- sprinkle.",
               "_strongs": "04472"
            },
            {
               "strongs": "4473",
               "greek": [
                  {
                     "_BETA": "R(ANTISMO/S",
                     "_unicode": "ῥαντισμός",
                     "_translit": "rhantismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hran-tis-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4472"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "aspersion (ceremonially or figuratively)",
               "kjv_def": ":--sprinkling.",
               "_strongs": "04473"
            },
            {
               "strongs": "4474",
               "greek": [
                  {
                     "_BETA": "R(API/ZW",
                     "_unicode": "ῥαπίζω",
                     "_translit": "rhapízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrap-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "R(E/PW",
                        "_unicode": "ῥέπω",
                        "_translit": "rhépō"
                     }
                  ],
                  "__text": "from a derivative of a primary \n (to let fall, \"rap\");"
               },
               "strongs_def": "to\n slap",
               "kjv_def": ":--smite (with the palm of the hand).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5180"
                  }
               ],
               "_strongs": "04474",
               "__text": "Compare \n."
            },
            {
               "strongs": "4475",
               "greek": [
                  {
                     "_BETA": "R(A/PISMA",
                     "_unicode": "ῥάπισμα",
                     "_translit": "rhápisma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrap'-is-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4474"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a slap",
               "kjv_def": ":--(+ strike with the) palm of the hand, smite with\n the hand.",
               "_strongs": "04475"
            },
            {
               "strongs": "4476",
               "greek": [
                  {
                     "_BETA": "R(AFI/S",
                     "_unicode": "ῥαφίς",
                     "_translit": "rhaphís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hraf-ece'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "R(A/PTW",
                        "_unicode": "ῥάπτω",
                        "_translit": "rháptō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4474"
                     }
                  ],
                  "__text": "from a primary \n (to sew; perhaps rather akin to the base of \n\n through the idea of puncturing);"
               },
               "strongs_def": "a needle",
               "kjv_def": ":-- needle.",
               "_strongs": "04476"
            },
            {
               "strongs": "4477",
               "greek": [
                  {
                     "_BETA": "*(RAXA/B",
                     "_unicode": "Ῥαχάβ",
                     "_translit": "Rhacháb"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrakh-ab'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4460"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "Rachab, a Canaanitess",
               "kjv_def": ":--Rachab.",
               "_strongs": "04477"
            },
            {
               "strongs": "4478",
               "greek": [
                  {
                     "_BETA": "*(RAXH/L",
                     "_unicode": "Ῥαχήλ",
                     "_translit": "Rhachḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrakh-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07354"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Rachel, the wife of Jacob",
               "kjv_def": ":--Rachel.",
               "_strongs": "04478"
            },
            {
               "strongs": "4479",
               "greek": [
                  {
                     "_BETA": "*(REBE/KKA",
                     "_unicode": "Ῥεβέκκα",
                     "_translit": "Rhebékka"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hreb-bek'-kah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07259"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Rebecca (i.e. Ribkah), the wife of\n Isaac",
               "kjv_def": ":--Rebecca.",
               "_strongs": "04479"
            },
            {
               "strongs": "4480",
               "greek": [
                  {
                     "_BETA": "R(E/DA",
                     "_unicode": "ῥέδα",
                     "_translit": "rhéda"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hred'-ah"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a rheda, i.e. four-wheeled carriage (wagon for\n riding)",
               "kjv_def": ":--chariot.",
               "_strongs": "04480"
            },
            {
               "strongs": "4481",
               "greek": [
                  {
                     "_BETA": "*(REMFA/N",
                     "_unicode": "Ῥεμφάν",
                     "_translit": "Rhemphán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrem-fan'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03594"
                     }
                  ],
                  "__text": "by incorrect transliteration for a word of Hebrew origin (\n);"
               },
               "strongs_def": "Remphan (i.e. Kijun), an Egyptian idol",
               "kjv_def": ":--Remphan.",
               "_strongs": "04481"
            },
            {
               "strongs": "4482",
               "greek": [
                  {
                     "_BETA": "R(E/W",
                     "_unicode": "ῥέω",
                     "_translit": "rhéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hreh'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "R(EU/W",
                        "_unicode": "ῥεύω",
                        "_translit": "rheúō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "hryoo'-o"
                     }
                  ],
                  "__text": "for some tenses of which a prolonged form\n      \n  \n is used\n\n to flow (\"run\"; as water)"
               },
               "kjv_def": ":--flow.",
               "_strongs": "04482"
            },
            {
               "strongs": "4483",
               "greek": [
                  {
                     "_BETA": "R(E/W",
                     "_unicode": "ῥέω",
                     "_translit": "rhéō"
                  },
                  {
                     "_BETA": "E)RE/W",
                     "_unicode": "ἐρέω",
                     "_translit": "eréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hreh'-o"
                  },
                  {
                     "_strongs": "er-eh'-o"
                  }
               ],
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "2036"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "3004"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4482"
                     }
                  ],
                  "__text": "perhaps akin (or identical) with \n (through the idea of pouring\n forth);"
               },
               "strongs_def": "to utter, i.e. speak or say",
               "kjv_def": ":--command, make, say, speak (of).",
               "_strongs": "04483",
               "__text": ", for certain tenses of which a prolonged form\n      \n  \n is used; and both as alternate for \n\n\n \n\n Compare \n."
            },
            {
               "strongs": "4484",
               "greek": [
                  {
                     "_BETA": "*(RH/GION",
                     "_unicode": "Ῥήγιον",
                     "_translit": "Rhḗgion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrayg'-ee-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Rhegium, a place in Italy",
               "kjv_def": ":--Rhegium.",
               "_strongs": "04484"
            },
            {
               "strongs": "4485",
               "greek": [
                  {
                     "_BETA": "R(H=GMA",
                     "_unicode": "ῥῆγμα",
                     "_translit": "rhēgma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrayg'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something torn, i.e. a fragment (by implication and\n abstractly, a fall)",
               "kjv_def": ":--ruin.",
               "_strongs": "04485"
            },
            {
               "strongs": "4486",
               "greek": [
                  {
                     "_BETA": "R(H/GNUMI",
                     "_unicode": "ῥήγνυμι",
                     "_translit": "rhḗgnymi"
                  },
                  {
                     "_BETA": "R(H/SSW",
                     "_unicode": "ῥήσσω",
                     "_translit": "rhḗssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrayg'-noo-mee"
                  },
                  {
                     "_strongs": "hrace'-so"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "R(H/KW",
                        "_unicode": "ῥήκω",
                        "_translit": "rhḗkō"
                     },
                     {
                        "_BETA": "A)/GNUMI",
                        "_unicode": "ἄγνυμι",
                        "_translit": "ágnymi"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2608"
                     }
                  ],
                  "__text": "both prolonged forms of \n (which appears only in certain forms,\n and is itself probably a strengthened form of \n (see in \n));"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2608"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2352"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3089"
                     }
                  ],
                  "__text": "to\n \"break,\" \"wreck\" or \"crack\", i.e. (especially) to sunder (by\n separation of the parts; \n being its intensive (with the\n preposition in composition), and \n a shattering to minute\n fragments; but not a reduction to the constituent particles, like\n \n) or disrupt, lacerate; by implication, to convulse (with spasms);\n figuratively, to give vent to joyful emotions"
               },
               "kjv_def": ":--break (forth), burst,\n rend, tear.",
               "_strongs": "04486",
               "__text": "or"
            },
            {
               "strongs": "4487",
               "greek": [
                  {
                     "_BETA": "R(H=MA",
                     "_unicode": "ῥῆμα",
                     "_translit": "rhēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hray'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an utterance (individually, collectively or specially),; by\n implication, a matter or topic (especially of narration, command or\n dispute); with a negative naught whatever",
               "kjv_def": ":--+ evil, + nothing, saying,\n word.",
               "_strongs": "04487"
            },
            {
               "strongs": "4488",
               "greek": [
                  {
                     "_BETA": "*(RHSA/",
                     "_unicode": "Ῥησά",
                     "_translit": "Rhēsá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hray-sah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07509"
                     }
                  ],
                  "__text": "probably of Hebrew origin (apparently for \n);"
               },
               "strongs_def": "Resa (i.e. Rephajah),\n an Israelite",
               "kjv_def": ":--Rhesa.",
               "_strongs": "04488"
            },
            {
               "strongs": "4489",
               "greek": [
                  {
                     "_BETA": "R(H/TWR",
                     "_unicode": "ῥήτωρ",
                     "_translit": "rhḗtōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hray'-tore"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a speaker, i.e. (by implication) a forensic\n advocate",
               "kjv_def": ":--orator.",
               "_strongs": "04489"
            },
            {
               "strongs": "4490",
               "greek": [
                  {
                     "_BETA": "R(HTW=S",
                     "_unicode": "ῥητῶς",
                     "_translit": "rhētōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hray-toce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4483"
                     }
                  ],
                  "__text": "adverb from a derivative of \n;"
               },
               "strongs_def": "out-spokenly, i.e.\n distinctly",
               "kjv_def": ":--expressly.",
               "_strongs": "04490"
            },
            {
               "strongs": "4491",
               "greek": [
                  {
                     "_BETA": "R(I/ZA",
                     "_unicode": "ῥίζα",
                     "_translit": "rhíza"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrid'-zah"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a \"root\" (literally or\n figuratively)",
               "kjv_def": ":--root.",
               "_strongs": "04491"
            },
            {
               "strongs": "4492",
               "greek": [
                  {
                     "_BETA": "R(IZO/W",
                     "_unicode": "ῥιζόω",
                     "_translit": "rhizóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrid-zo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4491"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to root (figuratively, become stable)",
               "kjv_def": ":--root.",
               "_strongs": "04492"
            },
            {
               "strongs": "4493",
               "greek": [
                  {
                     "_BETA": "R(IPH/",
                     "_unicode": "ῥιπή",
                     "_translit": "rhipḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hree-pay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4496"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a jerk (of the eye, i.e. (by analogy) an\n instant)",
               "kjv_def": ":--twinkling.",
               "_strongs": "04493"
            },
            {
               "strongs": "4494",
               "greek": [
                  {
                     "_BETA": "R(IPI/ZW",
                     "_unicode": "ῥιπίζω",
                     "_translit": "rhipízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrip-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4496"
                     }
                  ],
                  "__text": "from a derivative of \n (meaning a fan or bellows);"
               },
               "strongs_def": "to breeze up,\n i.e. (by analogy) to agitate (into waves)",
               "kjv_def": ":--toss.",
               "_strongs": "04494"
            },
            {
               "strongs": "4495",
               "greek": [
                  {
                     "_BETA": "R(IPTE/W",
                     "_unicode": "ῥιπτέω",
                     "_translit": "rhiptéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrip-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4496"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to toss up",
               "kjv_def": ":--cast off.",
               "_strongs": "04495"
            },
            {
               "strongs": "4496",
               "greek": [
                  {
                     "_BETA": "R(I/PTW",
                     "_unicode": "ῥίπτω",
                     "_translit": "rhíptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrip'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4474"
                     }
                  ],
                  "__text": "a primary verb (perhaps rather akin to the base of \n, through the\n idea of sudden motion);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1614"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TEI/NW",
                        "_unicode": "τείνω",
                        "_translit": "teínō"
                     }
                  ],
                  "__text": "to fling (properly, with a quick toss, thus\n differing from \n, which denotes a deliberate hurl; and from \n\n (see in \n), which indicates an extended projection); by\n qualification, to deposit (as if a load); by extension, to\n disperse"
               },
               "kjv_def": ":--cast (down, out), scatter abroad, throw.",
               "_strongs": "04496"
            },
            {
               "strongs": "4497",
               "greek": [
                  {
                     "_BETA": "*(ROBOA/M",
                     "_unicode": "Ῥοβοάμ",
                     "_translit": "Rhoboám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrob-o-am'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07346"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Roboam (i.e. Rechobam), an\n Israelite",
               "kjv_def": ":--Roboam.",
               "_strongs": "04497"
            },
            {
               "strongs": "4498",
               "greek": [
                  {
                     "_BETA": "*(RO/DH",
                     "_unicode": "Ῥόδη",
                     "_translit": "Rhódē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrod'-ay"
                  }
               ],
               "strongs_derivation": "probably for rhode (a rose);",
               "strongs_def": "Rode, a servant girl",
               "kjv_def": ":--Rhoda.",
               "_strongs": "04498"
            },
            {
               "strongs": "4499",
               "greek": [
                  {
                     "_BETA": "*(RO/DOS",
                     "_unicode": "Ῥόδος",
                     "_translit": "Rhódos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrod'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "R(O/DON",
                        "_unicode": "ῥόδον",
                        "_translit": "rhódon"
                     }
                  ],
                  "__text": "probably from \n (a rose);"
               },
               "strongs_def": "Rhodus, an island of the\n Mediterranean",
               "kjv_def": ":--Rhodes.",
               "_strongs": "04499"
            },
            {
               "strongs": "4500",
               "greek": [
                  {
                     "_BETA": "R(OIZHDO/N",
                     "_unicode": "ῥοιζηδόν",
                     "_translit": "rhoizēdón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hroyd-zay-don'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "R(OI=ZOS",
                        "_unicode": "ῥοῖζος",
                        "_translit": "rhoîzos"
                     }
                  ],
                  "__text": "adverb from a derivative of \n (a whir);"
               },
               "strongs_def": "whizzingly, i.e. with a\n crash",
               "kjv_def": ":--with a great noise.",
               "_strongs": "04500"
            },
            {
               "strongs": "4501",
               "greek": [
                  {
                     "_BETA": "R(OMFAI/A",
                     "_unicode": "ῥομφαία",
                     "_translit": "rhomphaía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrom-fah'-yah"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "a sabre, i.e. a long and broad cutlass\n (any weapon of the kind, literally or figuratively)",
               "kjv_def": ":--sword.",
               "_strongs": "04501"
            },
            {
               "strongs": "4502",
               "greek": [
                  {
                     "_BETA": "*(ROUBH/N",
                     "_unicode": "Ῥουβήν",
                     "_translit": "Rhoubḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hroo-bane'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07205"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Ruben (i.e. Reuben), an Israelite",
               "kjv_def": ":--Reuben.",
               "_strongs": "04502"
            },
            {
               "strongs": "4503",
               "greek": [
                  {
                     "_BETA": "*(ROU/Q",
                     "_unicode": "Ῥούθ",
                     "_translit": "Rhoúth"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrooth"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07327"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Ruth, a Moabitess",
               "kjv_def": ":--Ruth.",
               "_strongs": "04503"
            },
            {
               "strongs": "4504",
               "greek": [
                  {
                     "_BETA": "*(ROU=FOS",
                     "_unicode": "Ῥοῦφος",
                     "_translit": "Rhoûphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hroo'-fos"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "red; Rufus, a Christian",
               "kjv_def": ":--Rufus.",
               "_strongs": "04504"
            },
            {
               "strongs": "4505",
               "greek": [
                  {
                     "_BETA": "R(U/MH",
                     "_unicode": "ῥύμη",
                     "_translit": "rhýmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hroo'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4506"
                     }
                  ],
                  "__text": "prolongation from \n in its original sense;"
               },
               "strongs_def": "an alley or avenue (as\n crowded)",
               "kjv_def": ":--lane, street.",
               "_strongs": "04505"
            },
            {
               "strongs": "4506",
               "greek": [
                  {
                     "_BETA": "R(U/OMAI",
                     "_unicode": "ῥύομαι",
                     "_translit": "rhýomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "rhoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4482"
                     }
                  ],
                  "__text": "middle voice of an obsolete verb, akin to \n (through the idea of a\n current;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4511"
                     }
                  ],
                  "__text": "compare \n); to rush or draw (for oneself), i.e.\n rescue"
               },
               "kjv_def": ":--deliver(-er).",
               "_strongs": "04506"
            },
            {
               "strongs": "4507",
               "greek": [
                  {
                     "_BETA": "R(UPARI/A",
                     "_unicode": "ῥυπαρία",
                     "_translit": "rhyparía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hroo-par-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4508"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "dirtiness (morally)",
               "kjv_def": ":--turpitude.",
               "_strongs": "04507"
            },
            {
               "strongs": "4508",
               "greek": [
                  {
                     "_BETA": "R(UPARO/S",
                     "_unicode": "ῥυπαρός",
                     "_translit": "rhyparós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "rhoo-par-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4509"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "dirty, i.e. (relatively) cheap or shabby; morally,\n wicked",
               "kjv_def": ":--vile.",
               "_strongs": "04508"
            },
            {
               "strongs": "4509",
               "greek": [
                  {
                     "_BETA": "R(U/POS",
                     "_unicode": "ῥύπος",
                     "_translit": "rhýpos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hroo'-pos"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "dirt, i.e. (morally) depravity",
               "kjv_def": ":--filth.",
               "_strongs": "04509"
            },
            {
               "strongs": "4510",
               "greek": [
                  {
                     "_BETA": "R(UPO/W",
                     "_unicode": "ῥυπόω",
                     "_translit": "rhypóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "rhoo-po'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4509"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to soil, i.e. (intransitively) to become dirty\n (morally)",
               "kjv_def": ":--be filthy.",
               "_strongs": "04510"
            },
            {
               "strongs": "4511",
               "greek": [
                  {
                     "_BETA": "R(U/SIS",
                     "_unicode": "ῥύσις",
                     "_translit": "rhýsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hroo'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4506"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4482"
                     }
                  ],
                  "__text": "from \n in the sense of its congener \n;"
               },
               "strongs_def": "a flux (of\n blood)",
               "kjv_def": ":--issue.",
               "_strongs": "04511"
            },
            {
               "strongs": "4512",
               "greek": [
                  {
                     "_BETA": "R(UTI/S",
                     "_unicode": "ῥυτίς",
                     "_translit": "rhytís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hroo-tece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4506"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a fold (as drawing together), i.e. a wrinkle (especially on\n the face)",
               "kjv_def": ":--wrinkle.",
               "_strongs": "04512"
            },
            {
               "strongs": "4513",
               "greek": [
                  {
                     "_BETA": "*(RWMAI+KO/S",
                     "_unicode": "Ῥωμαϊκός",
                     "_translit": "Rhōmaïkós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "rho-mah-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4514"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Romaic, i.e. Latin",
               "kjv_def": ":--Latin.",
               "_strongs": "04513"
            },
            {
               "strongs": "4514",
               "greek": [
                  {
                     "_BETA": "*(RWMAI=OS",
                     "_unicode": "Ῥωμαῖος",
                     "_translit": "Rhōmaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hro-mah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4516"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Romæan, i.e. Roman (as noun)",
               "kjv_def": ":--Roman, of Rome.",
               "_strongs": "04514"
            },
            {
               "strongs": "4515",
               "greek": [
                  {
                     "_BETA": "*(RWMAI+STI/",
                     "_unicode": "Ῥωμαϊστί",
                     "_translit": "Rhōmaïstí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hro-mah-is-tee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4516"
                     }
                  ],
                  "__text": "adverb from a presumed derivative of \n;"
               },
               "strongs_def": "Romaistically, i.e. in the\n Latin language",
               "kjv_def": ":--Latin.",
               "_strongs": "04515"
            },
            {
               "strongs": "4516",
               "greek": [
                  {
                     "_BETA": "*(RW/MH",
                     "_unicode": "Ῥώμη",
                     "_translit": "Rhṓmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hro'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4517"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "strength; Roma, the capital of Italy",
               "kjv_def": ":--Rome.",
               "_strongs": "04516"
            },
            {
               "strongs": "4517",
               "greek": [
                  {
                     "_BETA": "R(W/NNUMI",
                     "_unicode": "ῥώννυμι",
                     "_translit": "rhṓnnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hrone'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "R(W/OMAI",
                        "_unicode": "ῥώομαι",
                        "_translit": "rhṓomai"
                     }
                  ],
                  "__text": "prolongation from \n (to dart;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4506"
                     }
                  ],
                  "__text": "probably akin to \n); to\n strengthen, i.e. (impersonal passive) have health (as a parting\n exclamation, good-bye)"
               },
               "kjv_def": ":--farewell.",
               "_strongs": "04517"
            },
            {
               "strongs": "4518",
               "greek": [
                  {
                     "_BETA": "SABAXQA/NI",
                     "_unicode": "σαβαχθάνι",
                     "_translit": "sabachtháni"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sab-akh-than-ee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07662"
                     }
                  ],
                  "__text": "of Chaldee or (\n with pronominal suffix);"
               },
               "strongs_def": "thou hast left me;\n sabachthani (i.e. shebakthani), a cry of distress",
               "kjv_def": ":--sabachthani.",
               "_strongs": "04518"
            },
            {
               "strongs": "4519",
               "greek": [
                  {
                     "_BETA": "SABAW/Q",
                     "_unicode": "σαβαώθ",
                     "_translit": "sabaṓth"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sab-ah-owth'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06635"
                     }
                  ],
                  "__text": "of Hebrew origin (\n in feminine plural);"
               },
               "strongs_def": "armies; sabaoth (i.e.\n tsebaoth), a military epithet of God",
               "kjv_def": ":--sabaoth.",
               "_strongs": "04519"
            },
            {
               "strongs": "4520",
               "greek": [
                  {
                     "_BETA": "SABBATISMO/S",
                     "_unicode": "σαββατισμός",
                     "_translit": "sabbatismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sab-bat-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4521"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "a \"sabbatism\", i.e. (figuratively) the\n repose of Christianity (as a type of heaven)",
               "kjv_def": ":--rest.",
               "_strongs": "04520"
            },
            {
               "strongs": "4521",
               "greek": [
                  {
                     "_BETA": "SA/BBATON",
                     "_unicode": "σάββατον",
                     "_translit": "sábbaton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sab'-bat-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07676"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "the Sabbath (i.e. Shabbath), or day of weekly\n repose from secular avocations (also the observance or institution\n itself); by extension, a se'nnight, i.e. the interval between two\n Sabbaths; likewise the plural in all the above applications",
               "kjv_def": ":--sabbath\n (day), week.",
               "_strongs": "04521"
            },
            {
               "strongs": "4522",
               "greek": [
                  {
                     "_BETA": "SAGH/NH",
                     "_unicode": "σαγήνη",
                     "_translit": "sagḗnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sag-ay'-nay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SA/TTW",
                        "_unicode": "σάττω",
                        "_translit": "sáttō"
                     }
                  ],
                  "__text": "from a derivative of \n (to equip) meaning furniture, especially a\n pack-saddle (which in the East is merely a bag of netted rope);"
               },
               "strongs_def": "a\n \"seine\" for fishing",
               "kjv_def": ":--net.",
               "_strongs": "04522"
            },
            {
               "strongs": "4523",
               "greek": [
                  {
                     "_BETA": "*SADDOUKAI=OS",
                     "_unicode": "Σαδδουκαῖος",
                     "_translit": "Saddoukaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sad-doo-kah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4524"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "a Sadducæan (i.e. Tsadokian), or follower of a\n certain heretical Israelite",
               "kjv_def": ":--Sadducee.",
               "_strongs": "04523"
            },
            {
               "strongs": "4524",
               "greek": [
                  {
                     "_BETA": "*SADW/K",
                     "_unicode": "Σαδώκ",
                     "_translit": "Sadṓk"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sad-oke'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06659"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sadoc (i.e. Tsadok), an Israelite",
               "kjv_def": ":--Sadoc.",
               "_strongs": "04524"
            },
            {
               "strongs": "4525",
               "greek": [
                  {
                     "_BETA": "SAI/NW",
                     "_unicode": "σαίνω",
                     "_translit": "saínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4579"
                     }
                  ],
                  "__text": "akin to \n;"
               },
               "strongs_def": "to wag (as a dog its tail fawningly), i.e. (generally)\n to shake (figuratively, disturb)",
               "kjv_def": ":--move.",
               "_strongs": "04525"
            },
            {
               "strongs": "4526",
               "greek": [
                  {
                     "_BETA": "SA/KKOS",
                     "_unicode": "σάκκος",
                     "_translit": "sákkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sak'-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08242"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "\"sack\"-cloth, i.e. mohair (the material or\n garments made of it, worn as a sign of grief)",
               "kjv_def": ":-- sackcloth.",
               "_strongs": "04526"
            },
            {
               "strongs": "4527",
               "greek": [
                  {
                     "_BETA": "*SALA/",
                     "_unicode": "Σαλά",
                     "_translit": "Salá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07974"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sala (i.e. Shelach), a patriarch",
               "kjv_def": ":--Sala.",
               "_strongs": "04527"
            },
            {
               "strongs": "4528",
               "greek": [
                  {
                     "_BETA": "*SALAQIH/L",
                     "_unicode": "Σαλαθιήλ",
                     "_translit": "Salathiḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-ath-ee-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07597"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Salathiel (i.e. Shealtiel), an\n Israelite",
               "kjv_def": ":--Salathiel.",
               "_strongs": "04528"
            },
            {
               "strongs": "4529",
               "greek": [
                  {
                     "_BETA": "*SALAMI/S",
                     "_unicode": "Σαλαμίς",
                     "_translit": "Salamís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-am-ece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4535"
                     }
                  ],
                  "__text": "probably from \n (from the surge on the shore);"
               },
               "strongs_def": "Salamis, a place in\n Cyprus",
               "kjv_def": ":--Salamis.",
               "_strongs": "04529"
            },
            {
               "strongs": "4530",
               "greek": [
                  {
                     "_BETA": "*SALEI/M",
                     "_unicode": "Σαλείμ",
                     "_translit": "Saleím"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-ime'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4531"
                     }
                  ],
                  "__text": "probably from the same as \n;"
               },
               "strongs_def": "Salim, a place in Palestine",
               "kjv_def": ":--Salim.",
               "_strongs": "04530"
            },
            {
               "strongs": "4531",
               "greek": [
                  {
                     "_BETA": "SALEU/W",
                     "_unicode": "σαλεύω",
                     "_translit": "saleúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4535"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to waver, i.e. agitate, rock, topple or (by implication)\n destroy; figuratively, to disturb, incite",
               "kjv_def": ":--move, shake (together),\n which can(-not) be shaken, stir up.",
               "_strongs": "04531"
            },
            {
               "strongs": "4532",
               "greek": [
                  {
                     "_BETA": "*SALH/M",
                     "_unicode": "Σαλήμ",
                     "_translit": "Salḗm"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-ame'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08004"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Salem (i.e. Shalem), a place in\n Palestine",
               "kjv_def": ":--Salem.",
               "_strongs": "04532"
            },
            {
               "strongs": "4533",
               "greek": [
                  {
                     "_BETA": "*SALMW/N",
                     "_unicode": "Σαλμών",
                     "_translit": "Salmṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-mone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08012"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Salmon, an Israelite",
               "kjv_def": ":--Salmon.",
               "_strongs": "04533"
            },
            {
               "strongs": "4534",
               "greek": [
                  {
                     "_BETA": "*SALMW/NH",
                     "_unicode": "Σαλμώνη",
                     "_translit": "Salmṓnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-mo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4529"
                     }
                  ],
                  "__text": "perhaps of similar origin to \n;"
               },
               "strongs_def": "Salmone, a place in\n Crete",
               "kjv_def": ":--Salmone.",
               "_strongs": "04534"
            },
            {
               "strongs": "4535",
               "greek": [
                  {
                     "_BETA": "SA/LOS",
                     "_unicode": "σάλος",
                     "_translit": "sálos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4525"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "a vibration, i.e. (specially),\n billow",
               "kjv_def": ":--wave.",
               "_strongs": "04535"
            },
            {
               "strongs": "4536",
               "greek": [
                  {
                     "_BETA": "SA/LPIGC",
                     "_unicode": "σάλπιγξ",
                     "_translit": "sálpinx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal'-pinx"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4535"
                     }
                  ],
                  "__text": "perhaps from \n (through the idea of quavering or reverberation);"
               },
               "strongs_def": "a\n trumpet",
               "kjv_def": ":--trump(-et).",
               "_strongs": "04536"
            },
            {
               "strongs": "4537",
               "greek": [
                  {
                     "_BETA": "SALPI/ZW",
                     "_unicode": "σαλπίζω",
                     "_translit": "salpízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-pid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4536"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to trumpet, i.e. sound a blast (literally or\n figuratively)",
               "kjv_def": ":--(which are yet to) sound (a trumpet).",
               "_strongs": "04537"
            },
            {
               "strongs": "4538",
               "greek": [
                  {
                     "_BETA": "SALPISTH/S",
                     "_unicode": "σαλπιστής",
                     "_translit": "salpistḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-pis-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4537"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a trumpeter",
               "kjv_def": ":--trumpeter.",
               "_strongs": "04538"
            },
            {
               "strongs": "4539",
               "greek": [
                  {
                     "_BETA": "*SALW/MH",
                     "_unicode": "Σαλώμη",
                     "_translit": "Salṓmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sal-o'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07965"
                     }
                  ],
                  "__text": "probably of Hebrew origin (feminine from \n);"
               },
               "strongs_def": "Salome (i.e.\n Shelomah), an Israelitess",
               "kjv_def": ":--Salome.",
               "_strongs": "04539"
            },
            {
               "strongs": "4540",
               "greek": [
                  {
                     "_BETA": "*SAMA/REIA",
                     "_unicode": "Σαμάρεια",
                     "_translit": "Samáreia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sam-ar'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08111"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Samaria (i.e. Shomeron), a city and region of\n Palestine",
               "kjv_def": ":--Samaria.",
               "_strongs": "04540"
            },
            {
               "strongs": "4541",
               "greek": [
                  {
                     "_BETA": "*SAMAREI/THS",
                     "_unicode": "Σαμαρείτης",
                     "_translit": "Samareítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sam-ar-i'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4540"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Samarite, i.e. inhabitant of Samaria",
               "kjv_def": ":--Samaritan.",
               "_strongs": "04541"
            },
            {
               "strongs": "4542",
               "greek": [
                  {
                     "_BETA": "*SAMAREI=TIS",
                     "_unicode": "Σαμαρεῖτις",
                     "_translit": "Samareîtis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sam-ar-i'-tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4541"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a Samaritess, i.e. woman of Samaria",
               "kjv_def": ":--of Samaria.",
               "_strongs": "04542"
            },
            {
               "strongs": "4543",
               "greek": [
                  {
                     "_BETA": "*SAMOQRA/|KH",
                     "_unicode": "Σαμοθρᾴκη",
                     "_translit": "Samothráikē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sam-oth-rak'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4544"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "*QTRA/|KH",
                        "_unicode": "Θτρᾴκη",
                        "_translit": "Thtráikē"
                     }
                  ],
                  "__text": "from \n and \n (Thrace);"
               },
               "strongs_def": "Samo-thrace (Samos of Thrace), an\n island in the Mediterranean",
               "kjv_def": ":--Samothracia.",
               "_strongs": "04543"
            },
            {
               "strongs": "4544",
               "greek": [
                  {
                     "_BETA": "*SA/MOS",
                     "_unicode": "Σάμος",
                     "_translit": "Sámos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sam'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "Samus, an island of the Mediterranean",
               "kjv_def": ":--Samos.",
               "_strongs": "04544"
            },
            {
               "strongs": "4545",
               "greek": [
                  {
                     "_BETA": "*SAMOUH/L",
                     "_unicode": "Σαμουήλ",
                     "_translit": "Samouḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sam-oo-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08050"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Samuel (i.e. Shemuel), an Israelite",
               "kjv_def": ":--Samuel.",
               "_strongs": "04545"
            },
            {
               "strongs": "4546",
               "greek": [
                  {
                     "_BETA": "*SAMYW/N",
                     "_unicode": "Σαμψών",
                     "_translit": "Sampsṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "samp-sone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08123"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sampson (i.e. Shimshon), an\n Israelite",
               "kjv_def": ":--Samson.",
               "_strongs": "04546"
            },
            {
               "strongs": "4547",
               "greek": [
                  {
                     "_BETA": "SANDA/LION",
                     "_unicode": "σανδάλιον",
                     "_translit": "sandálion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "san-dal'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SA/NDALON",
                        "_unicode": "σάνδαλον",
                        "_translit": "sándalon"
                     }
                  ],
                  "__text": "neuter of a derivative of \n (a \"sandal\"; of uncertain origin);"
               },
               "strongs_def": "a slipper or sole-pad",
               "kjv_def": ":--sandal.",
               "_strongs": "04547"
            },
            {
               "strongs": "4548",
               "greek": [
                  {
                     "_BETA": "SANI/S",
                     "_unicode": "σανίς",
                     "_translit": "sanís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "san-ece'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a plank",
               "kjv_def": ":--board.",
               "_strongs": "04548"
            },
            {
               "strongs": "4549",
               "greek": [
                  {
                     "_BETA": "*SAOU/L",
                     "_unicode": "Σαούλ",
                     "_translit": "Saoúl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sah-ool'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07586"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Saul (i.e. Shaul), the Jewish name of\n Paul",
               "kjv_def": ":--Saul.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4569"
                  }
               ],
               "_strongs": "04549",
               "__text": "Compare \n."
            },
            {
               "strongs": "4550",
               "greek": [
                  {
                     "_BETA": "SAPRO/S",
                     "_unicode": "σαπρός",
                     "_translit": "saprós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sap-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4595"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "rotten, i.e. worthless (literally or morally)",
               "kjv_def": ":--bad,\n corrupt.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4190"
                  }
               ],
               "_strongs": "04550",
               "__text": "Compare \n."
            },
            {
               "strongs": "4551",
               "greek": [
                  {
                     "_BETA": "*SAPFEI/RH",
                     "_unicode": "Σαπφείρη",
                     "_translit": "Sappheírē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sap-fi'-ray"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4552"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "Sapphire, an Israelitess",
               "kjv_def": ":--Sapphira.",
               "_strongs": "04551"
            },
            {
               "strongs": "4552",
               "greek": [
                  {
                     "_BETA": "SA/PFEIROS",
                     "_unicode": "σάπφειρος",
                     "_translit": "sáppheiros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sap'-fi-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05601"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "a \"sapphire\" or lapis-lazuli gem",
               "kjv_def": ":--sapphire.",
               "_strongs": "04552"
            },
            {
               "strongs": "4553",
               "greek": [
                  {
                     "_BETA": "SARGA/NH",
                     "_unicode": "σαργάνη",
                     "_translit": "sargánē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar-gan'-ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08276"
                     }
                  ],
                  "__text": "apparently of Hebrew origin (\n);"
               },
               "strongs_def": "a basket (as interwoven or\n wicker-work",
               "kjv_def": ":--basket.",
               "_strongs": "04553"
            },
            {
               "strongs": "4554",
               "greek": [
                  {
                     "_BETA": "*SA/RDEIS",
                     "_unicode": "Σάρδεις",
                     "_translit": "Sárdeis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar'-dice"
                  }
               ],
               "strongs_derivation": "plural of uncertain derivation;",
               "strongs_def": "Sardis, a place in Asia\n Minor",
               "kjv_def": ":--Sardis.",
               "_strongs": "04554"
            },
            {
               "strongs": "4555",
               "greek": [
                  {
                     "_BETA": "SA/RDINOS",
                     "_unicode": "σάρδινος",
                     "_translit": "sárdinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar'-dee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4556"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3037"
                     }
                  ],
                  "__text": "sardine (\n being implied), i.e. a gem, so\n called"
               },
               "kjv_def": ":--sardine.",
               "_strongs": "04555"
            },
            {
               "strongs": "4556",
               "greek": [
                  {
                     "_BETA": "SA/RDIOS",
                     "_unicode": "σάρδιος",
                     "_translit": "sárdios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar'-dee-os"
                  }
               ],
               "strongs_derivation": "properly, an adjective from an uncertain base;",
               "strongs_def": "sardian (3037 being\n implied), i.e. (as noun) the gem so called",
               "kjv_def": ":--sardius.",
               "_strongs": "04556"
            },
            {
               "strongs": "4557",
               "greek": [
                  {
                     "_BETA": "SARDO/NUC",
                     "_unicode": "σαρδόνυξ",
                     "_translit": "sardónyx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar-don'-oox"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4556"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "O)/NUC",
                        "_unicode": "ὄνυξ",
                        "_translit": "ónyx"
                     }
                  ],
                  "__text": "from the base of \n and \n (the nail of a finger; hence the \"onyx\"\n stone);"
               },
               "strongs_def": "a \"sardonyx\", i.e. the gem so called",
               "kjv_def": ":-- sardonyx.",
               "_strongs": "04557"
            },
            {
               "strongs": "4558",
               "greek": [
                  {
                     "_BETA": "*SA/REPTA",
                     "_unicode": "Σάρεπτα",
                     "_translit": "Sárepta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar'-ep-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06886"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sarepta (i.e. Tsarephath), a place in\n Palestine",
               "kjv_def": ":--Sarepta.",
               "_strongs": "04558"
            },
            {
               "strongs": "4559",
               "greek": [
                  {
                     "_BETA": "SARKIKO/S",
                     "_unicode": "σαρκικός",
                     "_translit": "sarkikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar-kee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4561"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pertaining to flesh, i.e. (by extension) bodily, temporal,\n or (by implication) animal, unregenerate",
               "kjv_def": ":--carnal, fleshly.",
               "_strongs": "04559"
            },
            {
               "strongs": "4560",
               "greek": [
                  {
                     "_BETA": "SA/RKINOS",
                     "_unicode": "σάρκινος",
                     "_translit": "sárkinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar'-kee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4561"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "similar to flesh, i.e. (by analogy) soft",
               "kjv_def": ":--fleshly.",
               "_strongs": "04560"
            },
            {
               "strongs": "4561",
               "greek": [
                  {
                     "_BETA": "SA/RC",
                     "_unicode": "σάρξ",
                     "_translit": "sárx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sarx"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4563"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "flesh (as stripped of the skin), i.e.\n (strictly) the meat of an animal (as food), or (by extension) the body\n (as opposed to the soul (or spirit), or as the symbol of what is\n external, or as the means of kindred), or (by implication) human\n nature (with its frailties (physically or morally) and passions), or\n (specially), a human being (as such)",
               "kjv_def": ":--carnal(-ly, + -ly minded),\n flesh(-ly).",
               "_strongs": "04561"
            },
            {
               "strongs": "4562",
               "greek": [
                  {
                     "_BETA": "*SAROU/X",
                     "_unicode": "Σαρούχ",
                     "_translit": "Saroúch"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar-ooch'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08286"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Saruch (i.e. Serug), a patriarch",
               "kjv_def": ":--Saruch.",
               "_strongs": "04562"
            },
            {
               "strongs": "4563",
               "greek": [
                  {
                     "_BETA": "SARO/W",
                     "_unicode": "σαρόω",
                     "_translit": "saróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SAI/RW",
                        "_unicode": "σαίρω",
                        "_translit": "saírō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4951"
                     }
                  ],
                  "__text": "from a derivative of \n (to brush off; akin to \n);"
               },
               "strongs_def": "meaning a\n broom; to sweep",
               "kjv_def": ":--sweep.",
               "_strongs": "04563"
            },
            {
               "strongs": "4564",
               "greek": [
                  {
                     "_BETA": "*SA/R)R(A",
                     "_unicode": "Σάῤῥα",
                     "_translit": "Sárrha"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar'-hrah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08283"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sarra (i.e. Sarah), the wife of\n Abraham",
               "kjv_def": ":--Sara, Sarah.",
               "_strongs": "04564"
            },
            {
               "strongs": "4565",
               "greek": [
                  {
                     "_BETA": "*SA/RWN",
                     "_unicode": "Σάρων",
                     "_translit": "Sárōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sar'-one"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08289"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Saron (i.e. Sharon), a district of\n Palestine",
               "kjv_def": ":--Saron.",
               "_strongs": "04565"
            },
            {
               "strongs": "4566",
               "greek": [
                  {
                     "_BETA": "*SATA=N",
                     "_unicode": "Σατᾶν",
                     "_translit": "Satân"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sat-an'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07854"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Satan, i.e. the devil",
               "kjv_def": ":--Satan.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4567"
                  }
               ],
               "_strongs": "04566",
               "__text": "Compare \n."
            },
            {
               "strongs": "4567",
               "greek": [
                  {
                     "_BETA": "*SATANA=S",
                     "_unicode": "Σατανᾶς",
                     "_translit": "Satanâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sat-an-as'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "04566"
                     }
                  ],
                  "__text": "of Chaldee origin corresponding to \n (with the definite affix);"
               },
               "strongs_def": "the\n accuser, i.e. the devil",
               "kjv_def": ":--Satan.",
               "_strongs": "04567"
            },
            {
               "strongs": "4568",
               "greek": [
                  {
                     "_BETA": "SA/TON",
                     "_unicode": "σάτον",
                     "_translit": "sáton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sat'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05429"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "a certain measure for things dry",
               "kjv_def": ":--measure.",
               "_strongs": "04568"
            },
            {
               "strongs": "4569",
               "greek": [
                  {
                     "_BETA": "*SAU=LOS",
                     "_unicode": "Σαῦλος",
                     "_translit": "Saûlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sow'-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4549"
                     }
                  ],
                  "__text": "of Hebrew origin, the same as \n;"
               },
               "strongs_def": "Saulus (i.e. Shaul), the Jewish\n name of Paul",
               "kjv_def": ":--Saul.",
               "_strongs": "04569"
            },
            {
               "strongs": "4570",
               "greek": [
                  {
                     "_BETA": "SBE/NNUMI",
                     "_unicode": "σβέννυμι",
                     "_translit": "sbénnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sben'-noo-mee"
                  }
               ],
               "strongs_derivation": "a prolonged form of an apparently primary verb;",
               "strongs_def": "to extinguish\n (literally or figuratively)",
               "kjv_def": ":--go out, quench.",
               "_strongs": "04570"
            },
            {
               "strongs": "4571",
               "greek": [
                  {
                     "_BETA": "SE/",
                     "_unicode": "σέ",
                     "_translit": "sé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "seh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4771"
                     }
                  ],
                  "__text": "accusative case singular of \n;"
               },
               "strongs_def": "thee",
               "kjv_def": ":--thee, thou, X thy house.",
               "_strongs": "04571"
            },
            {
               "strongs": "4572",
               "greek": [
                  {
                     "_BETA": "SEAUTOU=",
                     "_unicode": "σεαυτοῦ",
                     "_translit": "seautoû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "seh-ow-too'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "SEAUTW=|",
                        "_unicode": "σεαυτῷ",
                        "_translit": "seautōi"
                     },
                     {
                        "_BETA": "SEAUTO/N",
                        "_unicode": "σεαυτόν",
                        "_translit": "seautón"
                     },
                     {
                        "_BETA": "SAUTOU=",
                        "_unicode": "σαυτοῦ",
                        "_translit": "sautoû"
                     },
                     {
                        "_BETA": "SAUTW=|",
                        "_unicode": "σαυτῷ",
                        "_translit": "sautōi"
                     },
                     {
                        "_BETA": "SAUTO/N",
                        "_unicode": "σαυτόν",
                        "_translit": "sautón"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "seh-ow-to'"
                     },
                     {
                        "_strongs": "seh-ow-ton'"
                     },
                     {
                        "_strongs": "sow-too'"
                     },
                     {
                        "_strongs": "sow-to'"
                     },
                     {
                        "_strongs": "sow-ton'"
                     }
                  ],
                  "__text": "genitive case from \n and \n,\n                             also dative case of the same,\n      \n  \n,  and accusative case\n      \n  \n, likewise contracted\n      \n  \n,\n      \n  \n,     and\n      \n  \n,    respectively;"
               },
               "strongs_def": "of (with, to) thyself",
               "kjv_def": ":--thee, thine own self, (thou) thy(-self).",
               "_strongs": "04572",
               "__text": ";"
            },
            {
               "strongs": "4573",
               "greek": [
                  {
                     "_BETA": "SEBA/ZOMAI",
                     "_unicode": "σεβάζομαι",
                     "_translit": "sebázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "seb-ad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4576"
                     }
                  ],
                  "__text": "middle voice from a derivative of \n;"
               },
               "strongs_def": "to venerate, i.e.\n adore",
               "kjv_def": ":--worship.",
               "_strongs": "04573"
            },
            {
               "strongs": "4574",
               "greek": [
                  {
                     "_BETA": "SE/BASMA",
                     "_unicode": "σέβασμα",
                     "_translit": "sébasma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "seb'-as-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4573"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something adored, i.e. an object of worship (god, altar,\n etc)",
               "kjv_def": ":--devotion, that is worshipped.",
               "_strongs": "04574"
            },
            {
               "strongs": "4575",
               "greek": [
                  {
                     "_BETA": "SEBASTO/S",
                     "_unicode": "σεβαστός",
                     "_translit": "sebastós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "seb-as-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4573"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "venerable (august), i.e. (as noun) a title of the Roman\n Emperor, or (as adjective) imperial",
               "kjv_def": ":--Augustus(-').",
               "_strongs": "04575"
            },
            {
               "strongs": "4576",
               "greek": [
                  {
                     "_BETA": "SE/BOMAI",
                     "_unicode": "σέβομαι",
                     "_translit": "sébomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "seb'-om-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of an apparently primary verb;",
               "strongs_def": "to revere, i.e.\n adore",
               "kjv_def": ":--devout, religious, worship.",
               "_strongs": "04576"
            },
            {
               "strongs": "4577",
               "greek": [
                  {
                     "_BETA": "SEIRA/",
                     "_unicode": "σειρά",
                     "_translit": "seirá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "si-rah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4951"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)/RW",
                        "_unicode": "εἴρω",
                        "_translit": "eírō"
                     }
                  ],
                  "__text": "probably from \n through its congener \n (to fasten;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "akin to \n);\n a chain (as binding or drawing)"
               },
               "kjv_def": ":--chain.",
               "_strongs": "04577"
            },
            {
               "strongs": "4578",
               "greek": [
                  {
                     "_BETA": "SEISMO/S",
                     "_unicode": "σεισμός",
                     "_translit": "seismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sice-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4579"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a commotion, i.e. (of the air) a gale, (of the ground) an\n earthquake",
               "kjv_def": ":--earthquake, tempest.",
               "_strongs": "04578"
            },
            {
               "strongs": "4579",
               "greek": [
                  {
                     "_BETA": "SEI/W",
                     "_unicode": "σείω",
                     "_translit": "seíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "si'-o"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to rock (vibrate, properly, sideways or to\n and fro), i.e. (generally) to agitate (in any direction; cause to\n tremble); figuratively, to throw into a tremor (of fear or\n concern)",
               "kjv_def": ":--move, quake, shake.",
               "_strongs": "04579"
            },
            {
               "strongs": "4580",
               "greek": [
                  {
                     "_BETA": "*SEKOU=NDOS",
                     "_unicode": "Σεκοῦνδος",
                     "_translit": "Sekoûndos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sek-oon'-dos"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "\"second\"; Secundus, a Christian",
               "kjv_def": ":--Secundus.",
               "_strongs": "04580"
            },
            {
               "strongs": "4581",
               "greek": [
                  {
                     "_BETA": "*SELEU/KEIA",
                     "_unicode": "Σελεύκεια",
                     "_translit": "Seleúkeia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sel-yook'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*SE/LEUKOS",
                        "_unicode": "Σέλευκος",
                        "_translit": "Séleukos"
                     }
                  ],
                  "__text": "from \n (Seleucus, a Syrian king);"
               },
               "strongs_def": "Seleuceia, a place in\n Syria",
               "kjv_def": ":--Seleucia.",
               "_strongs": "04581"
            },
            {
               "strongs": "4582",
               "greek": [
                  {
                     "_BETA": "SELH/NH",
                     "_unicode": "σελήνη",
                     "_translit": "selḗnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sel-ay'-nay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SE/LAS",
                        "_unicode": "σέλας",
                        "_translit": "sélas"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "from \n (brilliancy; probably akin to the alternate of \n, through\n the idea of attractiveness);"
               },
               "strongs_def": "the moon",
               "kjv_def": ":--moon.",
               "_strongs": "04582"
            },
            {
               "strongs": "4583",
               "greek": [
                  {
                     "_BETA": "SELHNIA/ZOMAI",
                     "_unicode": "σεληνιάζομαι",
                     "_translit": "selēniázomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sel-ay-nee-ad'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4582"
                     }
                  ],
                  "__text": "middle voice or passive from a presumed derivative of \n;"
               },
               "strongs_def": "to be\n moon-struck, i.e. crazy",
               "kjv_def": ":--be a lunatic.",
               "_strongs": "04583"
            },
            {
               "strongs": "4584",
               "greek": [
                  {
                     "_BETA": "*SEMEI/+",
                     "_unicode": "Σεμεΐ",
                     "_translit": "Semeḯ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sem-eh-ee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08096"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Semei (i.e. Shimi), an Israelite",
               "kjv_def": ":--Semei.",
               "_strongs": "04584"
            },
            {
               "strongs": "4585",
               "greek": [
                  {
                     "_BETA": "SEMI/DALIS",
                     "_unicode": "σεμίδαλις",
                     "_translit": "semídalis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sem-id'-al-is"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "fine wheaten flour",
               "kjv_def": ":--fine flour.",
               "_strongs": "04585"
            },
            {
               "strongs": "4586",
               "greek": [
                  {
                     "_BETA": "SEMNO/S",
                     "_unicode": "σεμνός",
                     "_translit": "semnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sem-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4576"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "venerable, i.e. honorable",
               "kjv_def": ":--grave, honest.",
               "_strongs": "04586"
            },
            {
               "strongs": "4587",
               "greek": [
                  {
                     "_BETA": "SEMNO/THS",
                     "_unicode": "σεμνότης",
                     "_translit": "semnótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sem-not'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4586"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "venerableness, i.e. probity",
               "kjv_def": ":--gravity, honesty.",
               "_strongs": "04587"
            },
            {
               "strongs": "4588",
               "greek": [
                  {
                     "_BETA": "*SE/RGIOS",
                     "_unicode": "Σέργιος",
                     "_translit": "Sérgios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "serg'-ee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "Sergius, a Roman",
               "kjv_def": ":--Sergius.",
               "_strongs": "04588"
            },
            {
               "strongs": "4589",
               "greek": [
                  {
                     "_BETA": "*SH/Q",
                     "_unicode": "Σήθ",
                     "_translit": "Sḗth"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sayth"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08352"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Seth (i.e. Sheth), a patriarch",
               "kjv_def": ":--Seth.",
               "_strongs": "04589"
            },
            {
               "strongs": "4590",
               "greek": [
                  {
                     "_BETA": "*SH/M",
                     "_unicode": "Σήμ",
                     "_translit": "Sḗm"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "same"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08035"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sem (i.e. Shem), a patriarch",
               "kjv_def": ":-- Sem.",
               "_strongs": "04590"
            },
            {
               "strongs": "4591",
               "greek": [
                  {
                     "_BETA": "SHMAI/NW",
                     "_unicode": "σημαίνω",
                     "_translit": "sēmaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "say-mah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SH=MA",
                        "_unicode": "σῆμα",
                        "_translit": "sēma"
                     }
                  ],
                  "__text": "from \n (a mark; of uncertain derivation);"
               },
               "strongs_def": "to indicate",
               "kjv_def": ":--signify.",
               "_strongs": "04591"
            },
            {
               "strongs": "4592",
               "greek": [
                  {
                     "_BETA": "SHMEI=ON",
                     "_unicode": "σημεῖον",
                     "_translit": "sēmeîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "say-mi'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4591"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of the base of \n;"
               },
               "strongs_def": "an indication,\n especially ceremonially or supernaturally",
               "kjv_def": ":--miracle, sign, token,\n wonder.",
               "_strongs": "04592"
            },
            {
               "strongs": "4593",
               "greek": [
                  {
                     "_BETA": "SHMEIO/W",
                     "_unicode": "σημειόω",
                     "_translit": "sēmeióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "say-mi-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4592"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to distinguish, i.e. mark (for avoidance)",
               "kjv_def": ":--note.",
               "_strongs": "04593"
            },
            {
               "strongs": "4594",
               "greek": [
                  {
                     "_BETA": "SH/MERON",
                     "_unicode": "σήμερον",
                     "_translit": "sḗmeron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "say'-mer-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2250"
                     }
                  ],
                  "__text": "neuter (as adverb) of a presumed compound of the article \n  (t\n changed to s) and \n;"
               },
               "strongs_def": "on the (i.e. this) day (or night current or\n just passed); generally, now (i.e. at present, hitherto)",
               "kjv_def": ":--this\n (to-)day.",
               "_strongs": "04594"
            },
            {
               "strongs": "4595",
               "greek": [
                  {
                     "_BETA": "SH/PW",
                     "_unicode": "σήπω",
                     "_translit": "sḗpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "say'-po"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to putrefy, i.e. (figuratively) perish",
               "kjv_def": ":--be\n corrupted.",
               "_strongs": "04595"
            },
            {
               "strongs": "4596",
               "greek": [
                  {
                     "_BETA": "SHRIKO/S",
                     "_unicode": "σηρικός",
                     "_translit": "sērikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "say-ree-kos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*SH/R",
                        "_unicode": "Σήρ",
                        "_translit": "Sḗr"
                     }
                  ],
                  "__text": "from \n (an Indian tribe from whom silk was procured; hence the name\n of the silk-worm);"
               },
               "strongs_def": "Seric, i.e. silken (neuter as noun, a silky\n fabric)",
               "kjv_def": ":--silk.",
               "_strongs": "04596"
            },
            {
               "strongs": "4597",
               "greek": [
                  {
                     "_BETA": "SH/S",
                     "_unicode": "σής",
                     "_translit": "sḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05580"
                     }
                  ],
                  "__text": "apparently of Hebrew origin (\n);"
               },
               "strongs_def": "a moth",
               "kjv_def": ":--moth.",
               "_strongs": "04597"
            },
            {
               "strongs": "4598",
               "greek": [
                  {
                     "_BETA": "SHTO/BRWTOS",
                     "_unicode": "σητόβρωτος",
                     "_translit": "sētóbrōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "say-tob'-ro-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4597"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "977"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "moth-eaten",
               "kjv_def": ":--motheaten.",
               "_strongs": "04598"
            },
            {
               "strongs": "4599",
               "greek": [
                  {
                     "_BETA": "SQENO/W",
                     "_unicode": "σθενόω",
                     "_translit": "sthenóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sthen-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SQE/NOS",
                        "_unicode": "σθένος",
                        "_translit": "sthénos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n (bodily vigor; probably akin to the base of \n);"
               },
               "strongs_def": "to\n strengthen, i.e. (figuratively) confirm (in spiritual knowledge and\n power)",
               "kjv_def": ":--strengthen.",
               "_strongs": "04599"
            },
            {
               "strongs": "4600",
               "greek": [
                  {
                     "_BETA": "SIAGW/N",
                     "_unicode": "σιαγών",
                     "_translit": "siagṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see-ag-one'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "the jaw-bone, i.e. (by implication) the cheek\n or side of the face",
               "kjv_def": ":--cheek.",
               "_strongs": "04600"
            },
            {
               "strongs": "4601",
               "greek": [
                  {
                     "_BETA": "SIGA/W",
                     "_unicode": "σιγάω",
                     "_translit": "sigáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see-gah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4602"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to keep silent (transitively or intransitively)",
               "kjv_def": ":--keep\n close (secret, silence), hold peace.",
               "_strongs": "04601"
            },
            {
               "strongs": "4602",
               "greek": [
                  {
                     "_BETA": "SIGH/",
                     "_unicode": "σιγή",
                     "_translit": "sigḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see-gay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SI/ZW",
                        "_unicode": "σίζω",
                        "_translit": "sízō"
                     }
                  ],
                  "__text": "apparently from \n (to hiss, i.e. hist or hush);"
               },
               "strongs_def": "silence",
               "kjv_def": ":--silence.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4623"
                  }
               ],
               "_strongs": "04602",
               "__text": "Compare \n."
            },
            {
               "strongs": "4603",
               "greek": [
                  {
                     "_BETA": "SIDH/REOS",
                     "_unicode": "σιδήρεος",
                     "_translit": "sidḗreos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sid-ay'-reh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4604"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "made of iron",
               "kjv_def": ":--(of) iron.",
               "_strongs": "04603"
            },
            {
               "strongs": "4604",
               "greek": [
                  {
                     "_BETA": "SI/DHROS",
                     "_unicode": "σίδηρος",
                     "_translit": "sídēros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sid'-ay-ros"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "iron",
               "kjv_def": ":--iron.",
               "_strongs": "04604"
            },
            {
               "strongs": "4605",
               "greek": [
                  {
                     "_BETA": "*SIDW/N",
                     "_unicode": "Σιδών",
                     "_translit": "Sidṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sid-one'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06721"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sidon (i.e. Tsidon), a place in\n Palestine",
               "kjv_def": ":--Sidon.",
               "_strongs": "04605"
            },
            {
               "strongs": "4606",
               "greek": [
                  {
                     "_BETA": "*SIDW/NIOS",
                     "_unicode": "Σιδώνιος",
                     "_translit": "Sidṓnios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sid-o'-nee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4605"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Sidonian, i.e. inhabitant of Sidon",
               "kjv_def": ":--of Sidon.",
               "_strongs": "04606"
            },
            {
               "strongs": "4607",
               "greek": [
                  {
                     "_BETA": "SIKA/RIOS",
                     "_unicode": "σικάριος",
                     "_translit": "sikários"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sik-ar'-ee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a dagger-man or assassin; a freebooter (Jewish\n fanatic outlawed by the Romans)",
               "kjv_def": ":--murderer.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5406"
                  }
               ],
               "_strongs": "04607",
               "__text": "Compare \n."
            },
            {
               "strongs": "4608",
               "greek": [
                  {
                     "_BETA": "SI/KERA",
                     "_unicode": "σίκερα",
                     "_translit": "síkera"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sik'-er-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07941"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "an intoxicant, i.e. intensely fermented\n liquor",
               "kjv_def": ":--strong drink.",
               "_strongs": "04608"
            },
            {
               "strongs": "4609",
               "greek": [
                  {
                     "_BETA": "*SI/LAS",
                     "_unicode": "Σίλας",
                     "_translit": "Sílas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see'-las"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4610"
                     }
                  ],
                  "__text": "contraction for \n;"
               },
               "strongs_def": "Silas, a Christian",
               "kjv_def": ":--Silas.",
               "_strongs": "04609"
            },
            {
               "strongs": "4610",
               "greek": [
                  {
                     "_BETA": "*SILOUANO/S",
                     "_unicode": "Σιλουανός",
                     "_translit": "Silouanós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sil-oo-an-os'"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "\"silvan\"; Silvanus, a Christian",
               "kjv_def": ":--Silvanus.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4609"
                  }
               ],
               "_strongs": "04610",
               "__text": "Compare\n \n."
            },
            {
               "strongs": "4611",
               "greek": [
                  {
                     "_BETA": "*SILWA/M",
                     "_unicode": "Σιλωάμ",
                     "_translit": "Silōám"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sil-o-am'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07975"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Siloam (i.e. Shiloach), a pool of\n Jerusalem",
               "kjv_def": ":--Siloam.",
               "_strongs": "04611"
            },
            {
               "strongs": "4612",
               "greek": [
                  {
                     "_BETA": "SIMIKI/NQION",
                     "_unicode": "σιμικίνθιον",
                     "_translit": "simikínthion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sim-ee-kin'-thee-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a semicinctium or half-girding, i.e. narrow covering\n (apron)",
               "kjv_def": ":--apron.",
               "_strongs": "04612"
            },
            {
               "strongs": "4613",
               "greek": [
                  {
                     "_BETA": "*SI/MWN",
                     "_unicode": "Σίμων",
                     "_translit": "Símōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08095"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Simon (i.e. Shimon), the name of nine\n Israelites",
               "kjv_def": ":--Simon.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4826"
                  }
               ],
               "_strongs": "04613",
               "__text": "Compare \n."
            },
            {
               "strongs": "4614",
               "greek": [
                  {
                     "_BETA": "*SINA=",
                     "_unicode": "Σινᾶ",
                     "_translit": "Sinâ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see-nah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05514"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sina (i.e. Sinai), a mountain in\n Arabia",
               "kjv_def": ":--Sina.",
               "_strongs": "04614"
            },
            {
               "strongs": "4615",
               "greek": [
                  {
                     "_BETA": "SI/NAPI",
                     "_unicode": "σίναπι",
                     "_translit": "sínapi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sin'-ap-ee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SI/NOMAI",
                        "_unicode": "σίνομαι",
                        "_translit": "sínomai"
                     }
                  ],
                  "__text": "perhaps from \n (to hurt, i.e. sting);"
               },
               "strongs_def": "mustard (the\n plant)",
               "kjv_def": ":--mustard.",
               "_strongs": "04615"
            },
            {
               "strongs": "4616",
               "greek": [
                  {
                     "_BETA": "SINDW/N",
                     "_unicode": "σινδών",
                     "_translit": "sindṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sin-done'"
                  }
               ],
               "strongs_derivation": "of uncertain (perhaps foreign) origin;",
               "strongs_def": "byssos, i.e. bleached linen\n (the cloth or a garment of it)",
               "kjv_def": ":--(fine) linen (cloth).",
               "_strongs": "04616"
            },
            {
               "strongs": "4617",
               "greek": [
                  {
                     "_BETA": "SINIA/ZW",
                     "_unicode": "σινιάζω",
                     "_translit": "siniázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sin-ee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SINI/ON",
                        "_unicode": "σινίον",
                        "_translit": "siníon"
                     }
                  ],
                  "__text": "from \n (a sieve);"
               },
               "strongs_def": "to riddle (figuratively)",
               "kjv_def": ":--sift.",
               "_strongs": "04617"
            },
            {
               "strongs": "4618",
               "greek": [
                  {
                     "_BETA": "SITEUTO/S",
                     "_unicode": "σιτευτός",
                     "_translit": "siteutós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sit-yoo-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4621"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "grain-fed, i.e. fattened",
               "kjv_def": ":--fatted.",
               "_strongs": "04618"
            },
            {
               "strongs": "4619",
               "greek": [
                  {
                     "_BETA": "SITISTO/S",
                     "_unicode": "σιτιστός",
                     "_translit": "sitistós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sit-is-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4621"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "grained, i.e. fatted",
               "kjv_def": ":--fatling.",
               "_strongs": "04619"
            },
            {
               "strongs": "4620",
               "greek": [
                  {
                     "_BETA": "SITO/METRON",
                     "_unicode": "σιτόμετρον",
                     "_translit": "sitómetron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sit-om'-et-ron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4621"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3358"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a grain-measure, i.e. (by implication) ration\n (allowance of food)",
               "kjv_def": ":--portion of meat.",
               "_strongs": "04620"
            },
            {
               "strongs": "4621",
               "greek": [
                  {
                     "_BETA": "SI=TOS",
                     "_unicode": "σῖτος",
                     "_translit": "sîtos"
                  },
                  {
                     "_BETA": "SI=TA",
                     "_unicode": "σῖτα",
                     "_translit": "sîta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see'-tos"
                  },
                  {
                     "_strongs": "see'-tah"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "grain, especially wheat",
               "kjv_def": ":--corn, wheat.",
               "_strongs": "04621",
               "__text": ", also plural irregular neuter"
            },
            {
               "strongs": "4622",
               "greek": [
                  {
                     "_BETA": "*SIW/N",
                     "_unicode": "Σιών",
                     "_translit": "Siṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see-own'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06726"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sion (i.e. Tsijon), a hill of Jerusalem;\n figuratively, the Church (militant or triumphant)",
               "kjv_def": ":--Sion.",
               "_strongs": "04622"
            },
            {
               "strongs": "4623",
               "greek": [
                  {
                     "_BETA": "SIWPA/W",
                     "_unicode": "σιωπάω",
                     "_translit": "siōpáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "see-o-pah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SIWPH/",
                        "_unicode": "σιωπή",
                        "_translit": "siōpḗ"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4602"
                     }
                  ],
                  "__text": "from \n (silence, i.e. a hush; properly, muteness, i.e. involuntary\n stillness, or inability to speak; and thus differing from \n, which\n is rather a voluntary refusal or indisposition to speak, although the\n terms are often used synonymously);"
               },
               "strongs_def": "to be dumb (but not deaf also,\n like 2974 properly); figuratively, to be calm (as quiet water)",
               "kjv_def": ":--dumb,\n (hold) peace.",
               "_strongs": "04623"
            },
            {
               "strongs": "4624",
               "greek": [
                  {
                     "_BETA": "SKANDALI/ZW",
                     "_unicode": "σκανδαλίζω",
                     "_translit": "skandalízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skan-dal-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4625"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to entrap, i.e. trip up (figuratively, stumble\n (transitively) or entice to sin, apostasy or displeasure)",
               "kjv_def": ":--(make to)\n offend.",
               "_strongs": "04624"
            },
            {
               "strongs": "4625",
               "greek": [
                  {
                     "_BETA": "SKA/NDALON",
                     "_unicode": "σκάνδαλον",
                     "_translit": "skándalon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skan'-dal-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2578"
                     }
                  ],
                  "__text": "(\"scandal\"); probably from a derivative of \n;"
               },
               "strongs_def": "a  trap-stick (bent\n sapling), i.e. snare (figuratively, cause of displeasure or\n sin)",
               "kjv_def": ":--occasion to fall (of stumbling), offence, thing that offends,\n stumblingblock.",
               "_strongs": "04625"
            },
            {
               "strongs": "4626",
               "greek": [
                  {
                     "_BETA": "SKA/PTW",
                     "_unicode": "σκάπτω",
                     "_translit": "skáptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skap'-to"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to dig",
               "kjv_def": ":--dig.",
               "_strongs": "04626"
            },
            {
               "strongs": "4627",
               "greek": [
                  {
                     "_BETA": "SKA/FH",
                     "_unicode": "σκάφη",
                     "_translit": "skáphē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skaf'-ay"
                  }
               ],
               "strongs_def": "a \"skiff\" (as if dug out), or yawl (carried aboard a large vessel for\n landing)",
               "kjv_def": ":--boat.",
               "_strongs": "04627"
            },
            {
               "strongs": "4628",
               "greek": [
                  {
                     "_BETA": "SKE/LOS",
                     "_unicode": "σκέλος",
                     "_translit": "skélos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skel'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SKE/LLW",
                        "_unicode": "σκέλλω",
                        "_translit": "skéllō"
                     }
                  ],
                  "__text": "apparently from \n (to parch;"
               },
               "strongs_def": "through the idea of leanness); the\n leg (as lank)",
               "kjv_def": ":--leg.",
               "_strongs": "04628"
            },
            {
               "strongs": "4629",
               "greek": [
                  {
                     "_BETA": "SKE/PASMA",
                     "_unicode": "σκέπασμα",
                     "_translit": "sképasma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skep'-as-mah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SKE/PAS",
                        "_unicode": "σκέπας",
                        "_translit": "sképas"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4649"
                     }
                  ],
                  "__text": "from a derivative of \n (a covering; perhaps akin to the base of\n \n through the idea of noticeableness);"
               },
               "strongs_def": "clothing",
               "kjv_def": ":--raiment.",
               "_strongs": "04629"
            },
            {
               "strongs": "4630",
               "greek": [
                  {
                     "_BETA": "*SKEUA=S",
                     "_unicode": "Σκευᾶς",
                     "_translit": "Skeuâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skyoo-as'"
                  }
               ],
               "strongs_derivation": "apparently of Latin origin;",
               "strongs_def": "left-handed; Scevas (i.e. Scævus), an\n Israelite",
               "kjv_def": ":--Sceva.",
               "_strongs": "04630"
            },
            {
               "strongs": "4631",
               "greek": [
                  {
                     "_BETA": "SKEUH/",
                     "_unicode": "σκευή",
                     "_translit": "skeuḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skyoo-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4632"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "furniture, i.e. spare tackle",
               "kjv_def": ":--tackling.",
               "_strongs": "04631"
            },
            {
               "strongs": "4632",
               "greek": [
                  {
                     "_BETA": "SKEU=OS",
                     "_unicode": "σκεῦος",
                     "_translit": "skeûos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skyoo'-os"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a vessel, implement, equipment or apparatus\n (literally or figuratively [specially, a wife as contributing to the\n usefulness of the husband])",
               "kjv_def": ":--goods, sail, stuff, vessel.",
               "_strongs": "04632"
            },
            {
               "strongs": "4633",
               "greek": [
                  {
                     "_BETA": "SKHNH/",
                     "_unicode": "σκηνή",
                     "_translit": "skēnḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skay-nay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4632"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4639"
                     }
                  ],
                  "__text": "apparently akin to \n and \n;"
               },
               "strongs_def": "a tent or cloth hut (literally or\n figuratively)",
               "kjv_def": ":--habitation, tabernacle.",
               "_strongs": "04633"
            },
            {
               "strongs": "4634",
               "greek": [
                  {
                     "_BETA": "SKHNOPHGI/A",
                     "_unicode": "σκηνοπηγία",
                     "_translit": "skēnopēgía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skay-nop-ayg-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4636"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4078"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the Festival of Tabernacles (so called from the\n custom of erecting booths for temporary homes)",
               "kjv_def": ":--tabernacles.",
               "_strongs": "04634"
            },
            {
               "strongs": "4635",
               "greek": [
                  {
                     "_BETA": "SKHNOPOIO/S",
                     "_unicode": "σκηνοποιός",
                     "_translit": "skēnopoiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skay-nop-oy-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4633"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a manufacturer of tents",
               "kjv_def": ":--tent-maker.",
               "_strongs": "04635"
            },
            {
               "strongs": "4636",
               "greek": [
                  {
                     "_BETA": "SKH=NOS",
                     "_unicode": "σκῆνος",
                     "_translit": "skēnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skay'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4633"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a hut or temporary residence, i.e. (figuratively) the human\n body (as the abode of the spirit)",
               "kjv_def": ":--tabernacle.",
               "_strongs": "04636"
            },
            {
               "strongs": "4637",
               "greek": [
                  {
                     "_BETA": "SKHNO/W",
                     "_unicode": "σκηνόω",
                     "_translit": "skēnóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skay-no'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4636"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to tent or encamp, i.e. (figuratively) to occupy (as a\n mansion) or (specially), to reside (as God did in the Tabernacle of\n old, a symbol of protection and communion)",
               "kjv_def": ":-- dwell.",
               "_strongs": "04637"
            },
            {
               "strongs": "4638",
               "greek": [
                  {
                     "_BETA": "SKH/NWMA",
                     "_unicode": "σκήνωμα",
                     "_translit": "skḗnōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skay'-no-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4637"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an encampment, i.e. (figuratively) the Temple (as God's\n residence), the body (as a tenement for the soul)",
               "kjv_def": ":-- tabernacle.",
               "_strongs": "04638"
            },
            {
               "strongs": "4639",
               "greek": [
                  {
                     "_BETA": "SKIA/",
                     "_unicode": "σκιά",
                     "_translit": "skiá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skee'-ah"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "\"shade\" or a shadow (literally or\n figuratively (darkness of error or an adumbration))",
               "kjv_def": ":-- shadow.",
               "_strongs": "04639"
            },
            {
               "strongs": "4640",
               "greek": [
                  {
                     "_BETA": "SKIRTA/W",
                     "_unicode": "σκιρτάω",
                     "_translit": "skirtáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skeer-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SKAI/RW",
                        "_unicode": "σκαίρω",
                        "_translit": "skaírō"
                     }
                  ],
                  "__text": "akin to \n (to skip);"
               },
               "strongs_def": "to jump, i.e. sympathetically move (as the\n quickening of a fetus)",
               "kjv_def": ":--leap (for joy).",
               "_strongs": "04640"
            },
            {
               "strongs": "4641",
               "greek": [
                  {
                     "_BETA": "SKLHROKARDI/A",
                     "_unicode": "σκληροκαρδία",
                     "_translit": "sklērokardía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sklay-rok-ar-dee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4642"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2588"
                     }
                  ],
                  "__text": "feminine of a compound of \n and \n;"
               },
               "strongs_def": "hard-heartedness, i.e.\n (specially), destitution of (spiritual) perception",
               "kjv_def": ":--hardness of\n heart.",
               "_strongs": "04641"
            },
            {
               "strongs": "4642",
               "greek": [
                  {
                     "_BETA": "SKLHRO/S",
                     "_unicode": "σκληρός",
                     "_translit": "sklērós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sklay-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4628"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "dry, i.e. hard or tough (figuratively, harsh,\n severe)",
               "kjv_def": ":--fierce, hard.",
               "_strongs": "04642"
            },
            {
               "strongs": "4643",
               "greek": [
                  {
                     "_BETA": "SKLHRO/THS",
                     "_unicode": "σκληρότης",
                     "_translit": "sklērótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sklay-rot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4642"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "callousness, i.e. (figuratively) stubbornness",
               "kjv_def": ":--hardness.",
               "_strongs": "04643"
            },
            {
               "strongs": "4644",
               "greek": [
                  {
                     "_BETA": "SKLHROTRA/XHLOS",
                     "_unicode": "σκληροτράχηλος",
                     "_translit": "sklērotráchēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sklay-rot-rakh'-ay-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4642"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5137"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "hardnaped, i.e. (figuratively)\n obstinate",
               "kjv_def": ":--stiffnecked.",
               "_strongs": "04644"
            },
            {
               "strongs": "4645",
               "greek": [
                  {
                     "_BETA": "SKLHRU/NW",
                     "_unicode": "σκληρύνω",
                     "_translit": "sklērýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sklay-roo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4642"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to indurate, i.e. (figuratively) render stubborn",
               "kjv_def": ":--harden.",
               "_strongs": "04645"
            },
            {
               "strongs": "4646",
               "greek": [
                  {
                     "_BETA": "SKOLIO/S",
                     "_unicode": "σκολιός",
                     "_translit": "skoliós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skol-ee-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4628"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "warped, i.e. winding; figuratively,\n perverse",
               "kjv_def": ":--crooked, froward, untoward.",
               "_strongs": "04646"
            },
            {
               "strongs": "4647",
               "greek": [
                  {
                     "_BETA": "SKO/LOY",
                     "_unicode": "σκόλοψ",
                     "_translit": "skólops"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skol'-ops"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4628"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "perhaps from the base of \n and \n;"
               },
               "strongs_def": "withered at the front, i.e. a\n point or prickle (figuratively, a bodily annoyance or\n disability)",
               "kjv_def": ":--thorn.",
               "_strongs": "04647"
            },
            {
               "strongs": "4648",
               "greek": [
                  {
                     "_BETA": "SKOPE/W",
                     "_unicode": "σκοπέω",
                     "_translit": "skopéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skop-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4649"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to take aim at (spy), i.e. (figuratively)\n regard",
               "kjv_def": ":--consider, take heed, look at (on), mark.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3700"
                  }
               ],
               "_strongs": "04648",
               "__text": "Compare \n."
            },
            {
               "strongs": "4649",
               "greek": [
                  {
                     "_BETA": "SKOPO/S",
                     "_unicode": "σκοπός",
                     "_translit": "skopós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skop-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SKE/PTOMAI",
                        "_unicode": "σκέπτομαι",
                        "_translit": "sképtomai"
                     }
                  ],
                  "__text": "from \n (to peer about (\"skeptic\");"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4626"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4629"
                     }
                  ],
                  "__text": "perhaps akin to \n\n through the idea of concealment; compare \n); a watch (sentry or\n scout), i.e. (by implication) a goal"
               },
               "kjv_def": ":--mark.",
               "_strongs": "04649"
            },
            {
               "strongs": "4650",
               "greek": [
                  {
                     "_BETA": "SKORPI/ZW",
                     "_unicode": "σκορπίζω",
                     "_translit": "skorpízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skor-pid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4651"
                     }
                  ],
                  "__text": "apparently from the same as \n (through the idea of penetrating);"
               },
               "strongs_def": "to\n dissipate, i.e. (figuratively) put to flight, waste, be\n liberal",
               "kjv_def": ":--disperse abroad, scatter (abroad).",
               "_strongs": "04650"
            },
            {
               "strongs": "4651",
               "greek": [
                  {
                     "_BETA": "SKORPI/OS",
                     "_unicode": "σκορπίος",
                     "_translit": "skorpíos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skor-pee'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SKE/RPW",
                        "_unicode": "σκέρπω",
                        "_translit": "skérpō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4649"
                     }
                  ],
                  "__text": "probably from an obsolete \n (perhaps strengthened from the base\n of \n and meaning to pierce);"
               },
               "strongs_def": "a \"scorpion\" (from its\n sting)",
               "kjv_def": ":--scorpion.",
               "_strongs": "04651"
            },
            {
               "strongs": "4652",
               "greek": [
                  {
                     "_BETA": "SKOTEINO/S",
                     "_unicode": "σκοτεινός",
                     "_translit": "skoteinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skot-i-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4655"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "opaque, i.e. (figuratively) benighted",
               "kjv_def": ":--dark, full of\n darkness.",
               "_strongs": "04652"
            },
            {
               "strongs": "4653",
               "greek": [
                  {
                     "_BETA": "SKOTI/A",
                     "_unicode": "σκοτία",
                     "_translit": "skotía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skot-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4655"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "dimness, obscurity (literally or\n figuratively)",
               "kjv_def": ":--dark(-ness).",
               "_strongs": "04653"
            },
            {
               "strongs": "4654",
               "greek": [
                  {
                     "_BETA": "SKOTI/ZW",
                     "_unicode": "σκοτίζω",
                     "_translit": "skotízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skot-id-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4655"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to obscure (literally or figuratively)",
               "kjv_def": ":--darken.",
               "_strongs": "04654"
            },
            {
               "strongs": "4655",
               "greek": [
                  {
                     "_BETA": "SKO/TOS",
                     "_unicode": "σκότος",
                     "_translit": "skótos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skot'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4639"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "shadiness, i.e. obscurity (literally or\n figuratively)",
               "kjv_def": ":--darkness.",
               "_strongs": "04655"
            },
            {
               "strongs": "4656",
               "greek": [
                  {
                     "_BETA": "SKOTO/W",
                     "_unicode": "σκοτόω",
                     "_translit": "skotóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skot-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4655"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to obscure or blind (literally or figuratively)",
               "kjv_def": ":--be full\n of darkness.",
               "_strongs": "04656"
            },
            {
               "strongs": "4657",
               "greek": [
                  {
                     "_BETA": "SKU/BALON",
                     "_unicode": "σκύβαλον",
                     "_translit": "skýbalon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skoo'-bal-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2965"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n and \n and \n;"
               },
               "strongs_def": "what is\n thrown to the dogs, i.e. refuse (ordure)",
               "kjv_def": ":--dung.",
               "_strongs": "04657"
            },
            {
               "strongs": "4658",
               "greek": [
                  {
                     "_BETA": "*SKU/QHS",
                     "_unicode": "Σκύθης",
                     "_translit": "Skýthēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skoo'-thace"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "a Scythene or Scythian, i.e. (by\n implication) a savage",
               "kjv_def": ":--Scythian.",
               "_strongs": "04658"
            },
            {
               "strongs": "4659",
               "greek": [
                  {
                     "_BETA": "SKUQRWPO/S",
                     "_unicode": "σκυθρωπός",
                     "_translit": "skythrōpós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skoo-thro-pos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SKUQRO/S",
                        "_unicode": "σκυθρός",
                        "_translit": "skythrós"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from \n (sullen) and a derivative of \n;"
               },
               "strongs_def": "angry-visaged, i.e.\n gloomy or affecting a mournful appearance",
               "kjv_def": ":--of a sad countenance.",
               "_strongs": "04659"
            },
            {
               "strongs": "4660",
               "greek": [
                  {
                     "_BETA": "SKU/LLW",
                     "_unicode": "σκύλλω",
                     "_translit": "skýllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skool'-lo"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to flay, i.e. (figuratively) to\n harass",
               "kjv_def": ":--trouble(self).",
               "_strongs": "04660"
            },
            {
               "strongs": "4661",
               "greek": [
                  {
                     "_BETA": "SKU=LON",
                     "_unicode": "σκῦλον",
                     "_translit": "skŷlon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skoo'-lon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4660"
                     }
                  ],
                  "__text": "neuter from \n;"
               },
               "strongs_def": "something stripped (as a hide), i.e. booty",
               "kjv_def": ":--spoil.",
               "_strongs": "04661"
            },
            {
               "strongs": "4662",
               "greek": [
                  {
                     "_BETA": "SKWLHKO/BRWTOS",
                     "_unicode": "σκωληκόβρωτος",
                     "_translit": "skōlēkóbrōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sko-lay-kob'-ro-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4663"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "977"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "worm-eaten, i.e. diseased with\n maggots",
               "kjv_def": ":--eaten of worms.",
               "_strongs": "04662"
            },
            {
               "strongs": "4663",
               "greek": [
                  {
                     "_BETA": "SKW/LHC",
                     "_unicode": "σκώληξ",
                     "_translit": "skṓlēx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sko'-lakes"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a grub, maggot or earth-worm",
               "kjv_def": ":--worm.",
               "_strongs": "04663"
            },
            {
               "strongs": "4664",
               "greek": [
                  {
                     "_BETA": "SMARA/GDINOS",
                     "_unicode": "σμαράγδινος",
                     "_translit": "smarágdinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "smar-ag'-dee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4665"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "consisting of emerald",
               "kjv_def": ":--emerald.",
               "_strongs": "04664"
            },
            {
               "strongs": "4665",
               "greek": [
                  {
                     "_BETA": "SMA/RAGDOS",
                     "_unicode": "σμάραγδος",
                     "_translit": "smáragdos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "smar'-ag-dos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "the emerald or green gem so called",
               "kjv_def": ":--emerald.",
               "_strongs": "04665"
            },
            {
               "strongs": "4666",
               "greek": [
                  {
                     "_BETA": "SMU/RNA",
                     "_unicode": "σμύρνα",
                     "_translit": "smýrna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "smoor'-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3464"
                     }
                  ],
                  "__text": "apparently strengthened for \n;"
               },
               "strongs_def": "myrrh",
               "kjv_def": ":--myrrh.",
               "_strongs": "04666"
            },
            {
               "strongs": "4667",
               "greek": [
                  {
                     "_BETA": "*SMU/RNA",
                     "_unicode": "Σμύρνα",
                     "_translit": "Smýrna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "smoor'-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4666"
                     }
                  ],
                  "__text": "the same as \n;"
               },
               "strongs_def": "Smyrna, a place in Asia Minor",
               "kjv_def": ":--Smyrna.",
               "_strongs": "04667"
            },
            {
               "strongs": "4668",
               "greek": [
                  {
                     "_BETA": "*SMURNAI=OS",
                     "_unicode": "Σμυρναῖος",
                     "_translit": "Smyrnaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "smoor-nah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4667"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Smyrnæan",
               "kjv_def": ":--in Smyrna.",
               "_strongs": "04668"
            },
            {
               "strongs": "4669",
               "greek": [
                  {
                     "_BETA": "SMURNI/ZW",
                     "_unicode": "σμυρνίζω",
                     "_translit": "smyrnízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "smoor-nid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4667"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to tincture with myrrh, i.e. embitter (as a\n narcotic)",
               "kjv_def": ":--mingle with myrrh.",
               "_strongs": "04669"
            },
            {
               "strongs": "4670",
               "greek": [
                  {
                     "_BETA": "*SO/DOMA",
                     "_unicode": "Σόδομα",
                     "_translit": "Sódoma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sod'-om-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05467"
                     }
                  ],
                  "__text": "plural of Hebrew origin (\n);"
               },
               "strongs_def": "Sodoma (i.e. Sedom), a place in\n Palestine",
               "kjv_def": ":--Sodom.",
               "_strongs": "04670"
            },
            {
               "strongs": "4671",
               "greek": [
                  {
                     "_BETA": "SOI/",
                     "_unicode": "σοί",
                     "_translit": "soí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4771"
                     }
                  ],
                  "__text": "dative case of \n;"
               },
               "strongs_def": "to thee",
               "kjv_def": ":--thee, thine own, thou, thy.",
               "_strongs": "04671"
            },
            {
               "strongs": "4672",
               "greek": [
                  {
                     "_BETA": "*SOLOMW/N",
                     "_unicode": "Σολομών",
                     "_translit": "Solomṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sol-om-one'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08010"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Solomon (i.e. Shelomoh), the son of\n David",
               "kjv_def": ":--Solomon.",
               "_strongs": "04672"
            },
            {
               "strongs": "4673",
               "greek": [
                  {
                     "_BETA": "SORO/S",
                     "_unicode": "σορός",
                     "_translit": "sorós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sor-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4987"
                     }
                  ],
                  "__text": "probably akin to the base of \n;"
               },
               "strongs_def": "a funereal receptacle (urn,\n coffin), i.e. (by analogy) a bier",
               "kjv_def": ":--bier.",
               "_strongs": "04673"
            },
            {
               "strongs": "4674",
               "greek": [
                  {
                     "_BETA": "SO/S",
                     "_unicode": "σός",
                     "_translit": "sós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4771"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "thine",
               "kjv_def": ":--thine (own), thy (friend).",
               "_strongs": "04674"
            },
            {
               "strongs": "4675",
               "greek": [
                  {
                     "_BETA": "SOU=",
                     "_unicode": "σοῦ",
                     "_translit": "soû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4771"
                     }
                  ],
                  "__text": "genitive case of \n;"
               },
               "strongs_def": "of thee, thy",
               "kjv_def": ":--X home, thee, thine (own), thou,\n thy.",
               "_strongs": "04675"
            },
            {
               "strongs": "4676",
               "greek": [
                  {
                     "_BETA": "SOUDA/RION",
                     "_unicode": "σουδάριον",
                     "_translit": "soudárion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-dar'-ee-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a sudarium (sweat-cloth), i.e. towel (for wiping the\n perspiration from the face, or binding the face of a\n corpse)",
               "kjv_def": ":--handkerchief, napkin.",
               "_strongs": "04676"
            },
            {
               "strongs": "4677",
               "greek": [
                  {
                     "_BETA": "*SOUSA/NNA",
                     "_unicode": "Σουσάννα",
                     "_translit": "Sousánna"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-san'-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07799"
                     }
                  ],
                  "__text": "of Hebrew origin (\n feminine);"
               },
               "strongs_def": "lily; Susannah (i.e. Shoshannah), an\n Israelitess",
               "kjv_def": ":--Susanna.",
               "_strongs": "04677"
            },
            {
               "strongs": "4678",
               "greek": [
                  {
                     "_BETA": "SOFI/A",
                     "_unicode": "σοφία",
                     "_translit": "sophía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sof-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4680"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "wisdom (higher or lower, worldly or spiritual)",
               "kjv_def": ":--wisdom.",
               "_strongs": "04678"
            },
            {
               "strongs": "4679",
               "greek": [
                  {
                     "_BETA": "SOFI/ZW",
                     "_unicode": "σοφίζω",
                     "_translit": "sophízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sof-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4680"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render wise; in a sinister acceptation, to form\n \"sophisms\", i.e. continue plausible error",
               "kjv_def": ":--cunningly devised, make\n wise.",
               "_strongs": "04679"
            },
            {
               "strongs": "4680",
               "greek": [
                  {
                     "_BETA": "SOFO/S",
                     "_unicode": "σοφός",
                     "_translit": "sophós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sof-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SAFH/S",
                        "_unicode": "σαφής",
                        "_translit": "saphḗs"
                     }
                  ],
                  "__text": "akin to \n (clear);"
               },
               "strongs_def": "wise (in a most general application)",
               "kjv_def": ":--wise.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5429"
                  }
               ],
               "_strongs": "04680",
               "__text": "Compare \n."
            },
            {
               "strongs": "4681",
               "greek": [
                  {
                     "_BETA": "*SPANI/A",
                     "_unicode": "Σπανία",
                     "_translit": "Spanía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "span-ee'-ah"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Spania, a region of Europe",
               "kjv_def": ":--Spain.",
               "_strongs": "04681"
            },
            {
               "strongs": "4682",
               "greek": [
                  {
                     "_BETA": "SPARA/SSW",
                     "_unicode": "σπαράσσω",
                     "_translit": "sparássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spar-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SPAI/RW",
                        "_unicode": "σπαίρω",
                        "_translit": "spaírō"
                     }
                  ],
                  "__text": "prolongation from \n (to grasp;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4685"
                     }
                  ],
                  "__text": "apparently strengthened from \n\n through the idea of spasmodic contraction); to mangle, i.e. convluse\n with epilepsy"
               },
               "kjv_def": ":--rend, tear.",
               "_strongs": "04682"
            },
            {
               "strongs": "4683",
               "greek": [
                  {
                     "_BETA": "SPARGANO/W",
                     "_unicode": "σπαργανόω",
                     "_translit": "sparganóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spar-gan-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SPA/RGANON",
                        "_unicode": "σπάργανον",
                        "_translit": "spárganon"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4682"
                     }
                  ],
                  "__text": "from \n (a strip; from a derivative of the base of \n meaning\n to strap or wrap with strips);"
               },
               "strongs_def": "to swathe (an infant after the Oriental\n custom)",
               "kjv_def": ":--wrap in swaddling clothes.",
               "_strongs": "04683"
            },
            {
               "strongs": "4684",
               "greek": [
                  {
                     "_BETA": "SPATALA/W",
                     "_unicode": "σπαταλάω",
                     "_translit": "spataláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spat-al-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SPATA/LH",
                        "_unicode": "σπατάλη",
                        "_translit": "spatálē"
                     }
                  ],
                  "__text": "from \n (luxury);"
               },
               "strongs_def": "to be voluptuous",
               "kjv_def": ":--live in pleasure, be wanton.",
               "_strongs": "04684"
            },
            {
               "strongs": "4685",
               "greek": [
                  {
                     "_BETA": "SPA/W",
                     "_unicode": "σπάω",
                     "_translit": "spáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spah'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to draw",
               "kjv_def": ":--draw (out).",
               "_strongs": "04685"
            },
            {
               "strongs": "4686",
               "greek": [
                  {
                     "_BETA": "SPEI=RA",
                     "_unicode": "σπεῖρα",
                     "_translit": "speîra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spi'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1507"
                     }
                  ],
                  "__text": "of immediate Latin origin, but ultimately a derivative of \n in the\n sense of its cognate \n;"
               },
               "strongs_def": "a coil (spira, \"spire\"), i.e.\n (figuratively) a mass of men (a Roman military cohort; also (by\n analogy) a squad of Levitical janitors)",
               "kjv_def": ":--band.",
               "_strongs": "04686"
            },
            {
               "strongs": "4687",
               "greek": [
                  {
                     "_BETA": "SPEI/RW",
                     "_unicode": "σπείρω",
                     "_translit": "speírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spi'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4685"
                     }
                  ],
                  "__text": "probably strengthened from \n (through the idea of extending);"
               },
               "strongs_def": "to\n scatter, i.e. sow (literally or figuratively)",
               "kjv_def": ":--sow(- er), receive\n seed.",
               "_strongs": "04687"
            },
            {
               "strongs": "4688",
               "greek": [
                  {
                     "_BETA": "SPEKOULA/TWR",
                     "_unicode": "σπεκουλάτωρ",
                     "_translit": "spekoulátōr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spek-oo-lat'-ore"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a speculator, i.e. military scout (spy or (by\n extension) life-guardsman)",
               "kjv_def": ":--executioner.",
               "_strongs": "04688"
            },
            {
               "strongs": "4689",
               "greek": [
                  {
                     "_BETA": "SPE/NDW",
                     "_unicode": "σπένδω",
                     "_translit": "spéndō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spen'-do"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to pour out as a libation, i.e.\n (figuratively) to devote (one's life or blood, as a sacrifice)\n (\"spend\")",
               "kjv_def": ":--(be ready to) be offered.",
               "_strongs": "04689"
            },
            {
               "strongs": "4690",
               "greek": [
                  {
                     "_BETA": "SPE/RMA",
                     "_unicode": "σπέρμα",
                     "_translit": "spérma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sper'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4687"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something sown, i.e. seed (including the male \"sperm\"); by\n implication, offspring; specially, a remnant (figuratively, as if kept\n over for planting)",
               "kjv_def": ":--issue, seed.",
               "_strongs": "04690"
            },
            {
               "strongs": "4691",
               "greek": [
                  {
                     "_BETA": "SPERMOLO/GOS",
                     "_unicode": "σπερμολόγος",
                     "_translit": "spermológos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sper-mol-og'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4690"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a seed-picker (as the crow), i.e. (figuratively) a\n sponger, loafer (specially, a gossip or trifler in talk)",
               "kjv_def": ":--babbler.",
               "_strongs": "04691"
            },
            {
               "strongs": "4692",
               "greek": [
                  {
                     "_BETA": "SPEU/DW",
                     "_unicode": "σπεύδω",
                     "_translit": "speúdō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spyoo'-do"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "probably strengthened from \n;"
               },
               "strongs_def": "to \"speed\" (\"study\"), i.e. urge on\n (diligently or earnestly); by implication, to await eagerly",
               "kjv_def": ":--(make,\n with) haste unto.",
               "_strongs": "04692"
            },
            {
               "strongs": "4693",
               "greek": [
                  {
                     "_BETA": "SPH/LAION",
                     "_unicode": "σπήλαιον",
                     "_translit": "spḗlaion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spay'-lah-yon"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SPE/OS",
                        "_unicode": "σπέος",
                        "_translit": "spéos"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n (a grotto);"
               },
               "strongs_def": "a cavern; by\n implication, a hiding-place or resort",
               "kjv_def": ":--cave, den.",
               "_strongs": "04693"
            },
            {
               "strongs": "4694",
               "greek": [
                  {
                     "_BETA": "SPILA/S",
                     "_unicode": "σπιλάς",
                     "_translit": "spilás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spee-las'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a ledge or reef of rock in the sea",
               "kjv_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4696"
                     }
                  ],
                  "__text": ":--spot (by\n confusion with \n)."
               },
               "_strongs": "04694"
            },
            {
               "strongs": "4695",
               "greek": [
                  {
                     "_BETA": "SPILO/W",
                     "_unicode": "σπιλόω",
                     "_translit": "spilóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spee-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4696"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to stain or soil (literally or figuratively)",
               "kjv_def": ":--defile,\n spot.",
               "_strongs": "04695"
            },
            {
               "strongs": "4696",
               "greek": [
                  {
                     "_BETA": "SPI/LOS",
                     "_unicode": "σπίλος",
                     "_translit": "spílos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spee'-los"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a stain or blemish, i.e. (figuratively)\n defect, disgrace",
               "kjv_def": ":--spot.",
               "_strongs": "04696"
            },
            {
               "strongs": "4697",
               "greek": [
                  {
                     "_BETA": "SPLAGXNI/ZOMAI",
                     "_unicode": "σπλαγχνίζομαι",
                     "_translit": "splanchnízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "splangkh-nid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4698"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to have the bowels yearn, i.e. (figuratively)\n feel sympathy, to pity",
               "kjv_def": ":--have (be moved with) compassion.",
               "_strongs": "04697"
            },
            {
               "strongs": "4698",
               "greek": [
                  {
                     "_BETA": "SPLA/GXNON",
                     "_unicode": "σπλάγχνον",
                     "_translit": "splánchnon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "splangkh'-non"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SPLH/N",
                        "_unicode": "σπλήν",
                        "_translit": "splḗn"
                     }
                  ],
                  "__text": "probably strengthened from \n (the \"spleen\");"
               },
               "strongs_def": "an intestine\n (plural); figuratively, pity or sympathy",
               "kjv_def": ":--bowels, inward affection, +\n tender mercy.",
               "_strongs": "04698"
            },
            {
               "strongs": "4699",
               "greek": [
                  {
                     "_BETA": "SPO/GGOS",
                     "_unicode": "σπόγγος",
                     "_translit": "spóngos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spong'-gos"
                  }
               ],
               "strongs_derivation": "perhaps of foreign origin;",
               "strongs_def": "a \"sponge\"",
               "kjv_def": ":--spunge.",
               "_strongs": "04699"
            },
            {
               "strongs": "4700",
               "greek": [
                  {
                     "_BETA": "SPODO/S",
                     "_unicode": "σποδός",
                     "_translit": "spodós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spod-os'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "ashes",
               "kjv_def": ":--ashes.",
               "_strongs": "04700"
            },
            {
               "strongs": "4701",
               "greek": [
                  {
                     "_BETA": "SPORA/",
                     "_unicode": "σπορά",
                     "_translit": "sporá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spor-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4687"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sowing, i.e. (by implication) parentage",
               "kjv_def": ":--seed.",
               "_strongs": "04701"
            },
            {
               "strongs": "4702",
               "greek": [
                  {
                     "_BETA": "SPO/RIMOS",
                     "_unicode": "σπόριμος",
                     "_translit": "spórimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spor'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4703"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "sown, i.e. (neuter plural) a planted field",
               "kjv_def": ":--corn(-field).",
               "_strongs": "04702"
            },
            {
               "strongs": "4703",
               "greek": [
                  {
                     "_BETA": "SPO/ROS",
                     "_unicode": "σπόρος",
                     "_translit": "spóros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spro'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4687"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a scattering (of seed), i.e. (concretely) seed (as\n sown)",
               "kjv_def": ":--seed (X sown).",
               "_strongs": "04703"
            },
            {
               "strongs": "4704",
               "greek": [
                  {
                     "_BETA": "SPOUDA/ZW",
                     "_unicode": "σπουδάζω",
                     "_translit": "spoudázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spoo-dad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4710"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to use speed, i.e. to make effort, be prompt or\n earnest",
               "kjv_def": ":--do (give) diligence, be diligent (forward), endeavour,\n labour, study.",
               "_strongs": "04704"
            },
            {
               "strongs": "4705",
               "greek": [
                  {
                     "_BETA": "SPOUDAI=OS",
                     "_unicode": "σπουδαῖος",
                     "_translit": "spoudaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spoo-dah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4710"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "prompt, energetic, earnest",
               "kjv_def": ":--diligent.",
               "_strongs": "04705"
            },
            {
               "strongs": "4706",
               "greek": [
                  {
                     "_BETA": "SPOUDAIO/TERON",
                     "_unicode": "σπουδαιότερον",
                     "_translit": "spoudaióteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spoo-dah-yot'-er-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4707"
                     }
                  ],
                  "__text": "neuter of \n as adverb;"
               },
               "strongs_def": "more earnestly than others), i.e. very\n promptly",
               "kjv_def": ":--very diligently.",
               "_strongs": "04706"
            },
            {
               "strongs": "4707",
               "greek": [
                  {
                     "_BETA": "SPOUDAIO/TEROS",
                     "_unicode": "σπουδαιότερος",
                     "_translit": "spoudaióteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spoo-dah-yot'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4705"
                     }
                  ],
                  "__text": "comparative of \n;"
               },
               "strongs_def": "more prompt, more earnest",
               "kjv_def": ":--more diligent\n (forward).",
               "_strongs": "04707"
            },
            {
               "strongs": "4708",
               "greek": [
                  {
                     "_BETA": "SPOUDAIOTE/RWS",
                     "_unicode": "σπουδαιοτέρως",
                     "_translit": "spoudaiotérōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spoo-dah-yot-er'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4707"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "more speedily, i.e. sooner than otherwise",
               "kjv_def": ":--more\n carefully.",
               "_strongs": "04708"
            },
            {
               "strongs": "4709",
               "greek": [
                  {
                     "_BETA": "SPOUDAI/WS",
                     "_unicode": "σπουδαίως",
                     "_translit": "spoudaíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spoo-dah'-yoce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4705"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "earnestly, promptly",
               "kjv_def": ":--diligently, instantly.",
               "_strongs": "04709"
            },
            {
               "strongs": "4710",
               "greek": [
                  {
                     "_BETA": "SPOUDH/",
                     "_unicode": "σπουδή",
                     "_translit": "spoudḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spoo-day'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4692"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "\"speed\", i.e. (by implication) despatch, eagerness,\n earnestness",
               "kjv_def": ":--business, (earnest) care(-fulness), diligence,\n forwardness, haste.",
               "_strongs": "04710"
            },
            {
               "strongs": "4711",
               "greek": [
                  {
                     "_BETA": "SPURI/S",
                     "_unicode": "σπυρίς",
                     "_translit": "spyrís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "spoo-rece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4687"
                     }
                  ],
                  "__text": "from \n (as woven);"
               },
               "strongs_def": "a hamper or lunch-receptacle",
               "kjv_def": ":--basket.",
               "_strongs": "04711"
            },
            {
               "strongs": "4712",
               "greek": [
                  {
                     "_BETA": "STA/DION",
                     "_unicode": "στάδιον",
                     "_translit": "stádion"
                  },
                  {
                     "_BETA": "STA/DIOS",
                     "_unicode": "στάδιος",
                     "_translit": "stádios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stad'-ee-on"
                  },
                  {
                     "_strongs": "stad'-ee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from the base of \n (as fixed);"
               },
               "strongs_def": "a stade or certain measure of\n distance; by implication, a stadium or race-course",
               "kjv_def": ":--furlong, race.",
               "_strongs": "04712",
               "__text": ", or masculine (in plural)"
            },
            {
               "strongs": "4713",
               "greek": [
                  {
                     "_BETA": "STA/MNOS",
                     "_unicode": "στάμνος",
                     "_translit": "stámnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stam'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from the base of \n (as stationary);"
               },
               "strongs_def": "a jar or earthen tank",
               "kjv_def": ":--pot.",
               "_strongs": "04713"
            },
            {
               "strongs": "4714",
               "greek": [
                  {
                     "_BETA": "STA/SIS",
                     "_unicode": "στάσις",
                     "_translit": "stásis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stas'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a standing (properly, the act), i.e. (by\n analogy) position (existence); by implication, a popular uprising;\n figuratively, controversy",
               "kjv_def": ":--dissension, insurrection, X standing,\n uproar.",
               "_strongs": "04714"
            },
            {
               "strongs": "4715",
               "greek": [
                  {
                     "_BETA": "STATH/R",
                     "_unicode": "στατήρ",
                     "_translit": "statḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stat-air'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2746"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a stander (standard of value), i.e.\n (specially), a stater or certain coin",
               "kjv_def": ":--piece of money.",
               "_strongs": "04715"
            },
            {
               "strongs": "4716",
               "greek": [
                  {
                     "_BETA": "STAURO/S",
                     "_unicode": "σταυρός",
                     "_translit": "staurós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stow-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a stake or post (as set upright), i.e.\n (specially), a pole or cross (as an instrument of capital punishment);\n figuratively, exposure to death, i.e. self-denial; by implication, the\n atonement of Christ",
               "kjv_def": ":--cross.",
               "_strongs": "04716"
            },
            {
               "strongs": "4717",
               "greek": [
                  {
                     "_BETA": "STAURO/W",
                     "_unicode": "σταυρόω",
                     "_translit": "stauróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stow-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4716"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to impale on the cross; figuratively, to extinguish\n (subdue) passion or selfishness",
               "kjv_def": ":--crucify.",
               "_strongs": "04717"
            },
            {
               "strongs": "4718",
               "greek": [
                  {
                     "_BETA": "STAFULH/",
                     "_unicode": "σταφυλή",
                     "_translit": "staphylḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "staf-oo-lay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4735"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "a cluster of grapes (as if\n intertwined)",
               "kjv_def": ":--grapes.",
               "_strongs": "04718"
            },
            {
               "strongs": "4719",
               "greek": [
                  {
                     "_BETA": "STA/XUS",
                     "_unicode": "στάχυς",
                     "_translit": "stáchys"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stakh'-oos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a head of grain (as standing out from the\n stalk)",
               "kjv_def": ":--ear (of corn).",
               "_strongs": "04719"
            },
            {
               "strongs": "4720",
               "greek": [
                  {
                     "_BETA": "*STA/XUS",
                     "_unicode": "Στάχυς",
                     "_translit": "Stáchys"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stakh'-oos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4719"
                     }
                  ],
                  "__text": "the same as \n;"
               },
               "strongs_def": "Stachys, a Christian",
               "kjv_def": ":--Stachys.",
               "_strongs": "04720"
            },
            {
               "strongs": "4721",
               "greek": [
                  {
                     "_BETA": "STE/GH",
                     "_unicode": "στέγη",
                     "_translit": "stégē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "steg'-ay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TE/GOS",
                        "_unicode": "τέγος",
                        "_translit": "tégos"
                     }
                  ],
                  "__text": "strengthened from a primary \n (a \"thatch\" or \"deck\" of a\n building);"
               },
               "strongs_def": "a roof",
               "kjv_def": ":--roof.",
               "_strongs": "04721"
            },
            {
               "strongs": "4722",
               "greek": [
                  {
                     "_BETA": "STE/GW",
                     "_unicode": "στέγω",
                     "_translit": "stégō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "steg'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4721"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to roof over, i.e. (figuratively) to cover with silence\n (endure patiently)",
               "kjv_def": ":--(for-)bear, suffer.",
               "_strongs": "04722"
            },
            {
               "strongs": "4723",
               "greek": [
                  {
                     "_BETA": "STEI/ROS",
                     "_unicode": "στείρος",
                     "_translit": "steíros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sti'-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4731"
                     }
                  ],
                  "__text": "a contraction from \n (as stiff and unnatural);"
               },
               "strongs_def": "\"sterile\"",
               "kjv_def": ":--barren.",
               "_strongs": "04723"
            },
            {
               "strongs": "4724",
               "greek": [
                  {
                     "_BETA": "STE/LLW",
                     "_unicode": "στέλλω",
                     "_translit": "stéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "probably strengthened from the base of \n;"
               },
               "strongs_def": "properly, to set fast\n (\"stall\"), i.e. (figuratively) to repress (reflexively, abstain from\n associating with)",
               "kjv_def": ":--avoid, withdraw self.",
               "_strongs": "04724"
            },
            {
               "strongs": "4725",
               "greek": [
                  {
                     "_BETA": "STE/MMA",
                     "_unicode": "στέμμα",
                     "_translit": "stémma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stem'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4735"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a wreath for show",
               "kjv_def": ":--garland.",
               "_strongs": "04725"
            },
            {
               "strongs": "4726",
               "greek": [
                  {
                     "_BETA": "STENAGMO/S",
                     "_unicode": "στεναγμός",
                     "_translit": "stenagmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sten-ag-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4727"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a sigh",
               "kjv_def": ":--groaning.",
               "_strongs": "04726"
            },
            {
               "strongs": "4727",
               "greek": [
                  {
                     "_BETA": "STENA/ZW",
                     "_unicode": "στενάζω",
                     "_translit": "stenázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sten-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4728"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make (intransitively, be) in straits, i.e. (by\n implication) to sigh, murmur, pray inaudibly",
               "kjv_def": ":--with grief, groan,\n grudge, sigh.",
               "_strongs": "04727"
            },
            {
               "strongs": "4728",
               "greek": [
                  {
                     "_BETA": "STENO/S",
                     "_unicode": "στενός",
                     "_translit": "stenós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sten-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "probably from the base of \n;"
               },
               "strongs_def": "narrow (from obstacles standing close\n about)",
               "kjv_def": ":--strait.",
               "_strongs": "04728"
            },
            {
               "strongs": "4729",
               "greek": [
                  {
                     "_BETA": "STENOXWRE/W",
                     "_unicode": "στενοχωρέω",
                     "_translit": "stenochōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sten-okh-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4730"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to hem in closely, i.e. (figuratively)\n cramp",
               "kjv_def": ":--distress, straiten.",
               "_strongs": "04729"
            },
            {
               "strongs": "4730",
               "greek": [
                  {
                     "_BETA": "STENOXWRI/A",
                     "_unicode": "στενοχωρία",
                     "_translit": "stenochōría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sten-okh-o-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4728"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "narrowness of room, i.e.\n (figuratively) calamity",
               "kjv_def": ":--anguish, distress.",
               "_strongs": "04730"
            },
            {
               "strongs": "4731",
               "greek": [
                  {
                     "_BETA": "STEREO/S",
                     "_unicode": "στερεός",
                     "_translit": "stereós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ster-eh-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "stiff, i.e. solid, stable (literally or\n figuratively)",
               "kjv_def": ":--stedfast, strong, sure.",
               "_strongs": "04731"
            },
            {
               "strongs": "4732",
               "greek": [
                  {
                     "_BETA": "STEREO/W",
                     "_unicode": "στερεόω",
                     "_translit": "stereóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ster-eh-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4731"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to solidify, i.e. confirm (literally or\n figuratively)",
               "kjv_def": ":--establish, receive strength, make strong.",
               "_strongs": "04732"
            },
            {
               "strongs": "4733",
               "greek": [
                  {
                     "_BETA": "STERE/WMA",
                     "_unicode": "στερέωμα",
                     "_translit": "steréōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ster-eh'-o-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4732"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something established, i.e. (abstractly) confirmation\n (stability)",
               "kjv_def": ":--stedfastness.",
               "_strongs": "04733"
            },
            {
               "strongs": "4734",
               "greek": [
                  {
                     "_BETA": "*STEFANA=S",
                     "_unicode": "Στεφανᾶς",
                     "_translit": "Stephanâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stef-an-as'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STEFANWTO/S",
                        "_unicode": "στεφανωτός",
                        "_translit": "stephanōtós"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4737"
                     }
                  ],
                  "__text": "probably contraction for \n (crowned; from \n);"
               },
               "strongs_def": "Stephanas,\n a Christian",
               "kjv_def": ":--Stephanas.",
               "_strongs": "04734"
            },
            {
               "strongs": "4735",
               "greek": [
                  {
                     "_BETA": "STE/FANOS",
                     "_unicode": "στέφανος",
                     "_translit": "stéphanos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stef'-an-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STE/FW",
                        "_unicode": "στέφω",
                        "_translit": "stéphō"
                     }
                  ],
                  "__text": "from an apparently primary \n (to twine or wreathe);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1238"
                     }
                  ],
                  "__text": "a chaplet (as\n a badge of royalty, a prize in the public games or a symbol of honor\n generally; but more conspicuous and elaborate than the simple fillet,\n \n), literally or figuratively"
               },
               "kjv_def": ":--crown.",
               "_strongs": "04735"
            },
            {
               "strongs": "4736",
               "greek": [
                  {
                     "_BETA": "*STE/FANOS",
                     "_unicode": "Στέφανος",
                     "_translit": "Stéphanos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stef'-an-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4735"
                     }
                  ],
                  "__text": "the same as \n;"
               },
               "strongs_def": "Stephanus, a Christian",
               "kjv_def": ":--Stephen.",
               "_strongs": "04736"
            },
            {
               "strongs": "4737",
               "greek": [
                  {
                     "_BETA": "STEFANO/W",
                     "_unicode": "στεφανόω",
                     "_translit": "stephanóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stef-an-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4735"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to adorn with an honorary wreath (literally or\n figuratively)",
               "kjv_def": ":--crown.",
               "_strongs": "04737"
            },
            {
               "strongs": "4738",
               "greek": [
                  {
                     "_BETA": "STH=QOS",
                     "_unicode": "στῆθος",
                     "_translit": "stēthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stay'-thos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n (as standing prominently);"
               },
               "strongs_def": "the (entire external) bosom, i.e.\n chest",
               "kjv_def": ":--breast.",
               "_strongs": "04738"
            },
            {
               "strongs": "4739",
               "greek": [
                  {
                     "_BETA": "STH/KW",
                     "_unicode": "στήκω",
                     "_translit": "stḗkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stay'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from the perfect tense of \n;"
               },
               "strongs_def": "to be stationary, i.e. (figuratively)\n to persevere",
               "kjv_def": ":--stand (fast).",
               "_strongs": "04739"
            },
            {
               "strongs": "4740",
               "greek": [
                  {
                     "_BETA": "STHRIGMO/S",
                     "_unicode": "στηριγμός",
                     "_translit": "stērigmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stay-rig-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4741"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "stability (figuratively)",
               "kjv_def": ":--stedfastness.",
               "_strongs": "04740"
            },
            {
               "strongs": "4741",
               "greek": [
                  {
                     "_BETA": "STHRI/ZW",
                     "_unicode": "στηρίζω",
                     "_translit": "stērízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stay-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4731"
                     }
                  ],
                  "__text": "from a presumed derivative of \n (like \n);"
               },
               "strongs_def": "to set fast, i.e.\n (literally) to turn resolutely in a certain direction, or\n (figuratively) to confirm",
               "kjv_def": ":--fix, (e-)stablish, stedfastly set,\n strengthen.",
               "_strongs": "04741"
            },
            {
               "strongs": "4742",
               "greek": [
                  {
                     "_BETA": "STI/GMA",
                     "_unicode": "στίγμα",
                     "_translit": "stígma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stig'-mah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STI/ZW",
                        "_unicode": "στίζω",
                        "_translit": "stízō"
                     }
                  ],
                  "__text": "from a primary \n (to \"stick\", i.e. prick);"
               },
               "strongs_def": "a mark incised or\n punched (for recognition of ownership), i.e. (figuratively) scar of\n service",
               "kjv_def": ":--mark.",
               "_strongs": "04742"
            },
            {
               "strongs": "4743",
               "greek": [
                  {
                     "_BETA": "STIGMH/",
                     "_unicode": "στιγμή",
                     "_translit": "stigmḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stig-may'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4742"
                     }
                  ],
                  "__text": "feminine of \n;"
               },
               "strongs_def": "a point of time, i.e. an instant",
               "kjv_def": ":--moment.",
               "_strongs": "04743"
            },
            {
               "strongs": "4744",
               "greek": [
                  {
                     "_BETA": "STI/LBW",
                     "_unicode": "στίλβω",
                     "_translit": "stílbō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stil'-bo"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to gleam, i.e. flash intensely",
               "kjv_def": ":--shining.",
               "_strongs": "04744"
            },
            {
               "strongs": "4745",
               "greek": [
                  {
                     "_BETA": "STOA/",
                     "_unicode": "στοά",
                     "_translit": "stoá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sto-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "a colonnade or interior piazza",
               "kjv_def": ":--porch.",
               "_strongs": "04745"
            },
            {
               "strongs": "4746",
               "greek": [
                  {
                     "_BETA": "STOIBA/S",
                     "_unicode": "στοιβάς",
                     "_translit": "stoibás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stoy-bas'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STEI/BW",
                        "_unicode": "στείβω",
                        "_translit": "steíbō"
                     }
                  ],
                  "__text": "from a primary \n (to \"step\" or \"stamp\");"
               },
               "strongs_def": "a spread (as if tramped\n flat) of loose materials for a couch, i.e. (by implication) a bough of\n a tree so employed",
               "kjv_def": ":--branch.",
               "_strongs": "04746"
            },
            {
               "strongs": "4747",
               "greek": [
                  {
                     "_BETA": "STOIXEI=ON",
                     "_unicode": "στοιχεῖον",
                     "_translit": "stoicheîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stoy-khi'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4748"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of the base of \n;"
               },
               "strongs_def": "something orderly\n in arrangement, i.e. (by implication) a serial (basal, fundamental,\n initial) constituent (literally), proposition\n (figuratively)",
               "kjv_def": ":--element, principle, rudiment.",
               "_strongs": "04747"
            },
            {
               "strongs": "4748",
               "greek": [
                  {
                     "_BETA": "STOIXE/W",
                     "_unicode": "στοιχέω",
                     "_translit": "stoichéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stoy-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STEI/XW",
                        "_unicode": "στείχω",
                        "_translit": "steíchō"
                     }
                  ],
                  "__text": "from a derivative of \n (to range in regular line);"
               },
               "strongs_def": "to march in\n (military) rank (keep step), i.e. (figuratively) to conform to virtue\n and piety",
               "kjv_def": ":--walk (orderly).",
               "_strongs": "04748"
            },
            {
               "strongs": "4749",
               "greek": [
                  {
                     "_BETA": "STOLH/",
                     "_unicode": "στολή",
                     "_translit": "stolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4724"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "equipment, i.e. (specially), a \"stole\" or long-fitting gown\n (as a mark of dignity)",
               "kjv_def": ":--long clothing (garment), (long) robe.",
               "_strongs": "04749"
            },
            {
               "strongs": "4750",
               "greek": [
                  {
                     "_BETA": "STO/MA",
                     "_unicode": "στόμα",
                     "_translit": "stóma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stom'-a"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5114"
                     }
                  ],
                  "__text": "probably strengthened from a presumed derivative of the base of \n;"
               },
               "strongs_def": "the mouth (as if a gash in the face); by implication, language (and\n its relations); figuratively, an opening (in the earth); specially,\n the front or edge (of a weapon)",
               "kjv_def": ":--edge, face, mouth.",
               "_strongs": "04750"
            },
            {
               "strongs": "4751",
               "greek": [
                  {
                     "_BETA": "STO/MAXOS",
                     "_unicode": "στόμαχος",
                     "_translit": "stómachos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stom'-akh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4750"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an orifice (the gullet), i.e. (specially), the\n \"stomach\"",
               "kjv_def": ":--stomach.",
               "_strongs": "04751"
            },
            {
               "strongs": "4752",
               "greek": [
                  {
                     "_BETA": "STRATEI/A",
                     "_unicode": "στρατεία",
                     "_translit": "strateía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4754"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "military service, i.e. (figuratively) the apostolic career\n (as one of hardship and danger)",
               "kjv_def": ":--warfare.",
               "_strongs": "04752"
            },
            {
               "strongs": "4753",
               "greek": [
                  {
                     "_BETA": "STRA/TEUMA",
                     "_unicode": "στράτευμα",
                     "_translit": "stráteuma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat'-yoo-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4754"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an armament, i.e. (by implication) a body of troops (more\n or less extensive or systematic)",
               "kjv_def": ":--army, soldier, man of war.",
               "_strongs": "04753"
            },
            {
               "strongs": "4754",
               "greek": [
                  {
                     "_BETA": "STRATEU/OMAI",
                     "_unicode": "στρατεύομαι",
                     "_translit": "strateúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4756"
                     }
                  ],
                  "__text": "middle voice from the base of \n;"
               },
               "strongs_def": "to serve in a military campaign;\n figuratively, to execute the apostolate (with its arduous duties and\n functions), to contend with carnal inclinations",
               "kjv_def": ":--soldier, (go to)\n war(-fare).",
               "_strongs": "04754"
            },
            {
               "strongs": "4755",
               "greek": [
                  {
                     "_BETA": "STRATHGO/S",
                     "_unicode": "στρατηγός",
                     "_translit": "stratēgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat-ay-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2233"
                     }
                  ],
                  "__text": "from the base of \n and \n or \n;"
               },
               "strongs_def": "a general, i.e. (by implication\n or analogy) a (military) governor (prætor), the chief (præfect) of\n the (Levitical) temple-wardens",
               "kjv_def": ":--captain, magistrate.",
               "_strongs": "04755"
            },
            {
               "strongs": "4756",
               "greek": [
                  {
                     "_BETA": "STRATIA/",
                     "_unicode": "στρατιά",
                     "_translit": "stratiá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STRATO/S",
                        "_unicode": "στρατός",
                        "_translit": "stratós"
                     }
                  ],
                  "__text": "feminine of a derivative of \n (an army;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4766"
                     }
                  ],
                  "__text": "from the base of \n,\n as encamped); camp-likeness, i.e. an army, i.e. (figuratively) the\n angels, the celestial luminaries"
               },
               "kjv_def": ":--host.",
               "_strongs": "04756"
            },
            {
               "strongs": "4757",
               "greek": [
                  {
                     "_BETA": "STRATIW/THS",
                     "_unicode": "στρατιώτης",
                     "_translit": "stratiṓtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat-ee-o'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4756"
                     }
                  ],
                  "__text": "from a presumed derivative of the same as \n;"
               },
               "strongs_def": "a camper-out, i.e. a\n (common) warrior (literally or figuratively)",
               "kjv_def": ":--soldier.",
               "_strongs": "04757"
            },
            {
               "strongs": "4758",
               "greek": [
                  {
                     "_BETA": "STRATOLOGE/W",
                     "_unicode": "στρατολογέω",
                     "_translit": "stratologéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat-ol-og-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from a compound of the base of \n and \n (in its original sense);"
               },
               "strongs_def": "to gather (or select) as a warrior, i.e. enlist in the army",
               "kjv_def": ":--choose\n to be a soldier.",
               "_strongs": "04758"
            },
            {
               "strongs": "4759",
               "greek": [
                  {
                     "_BETA": "STRATOPEDA/RXHS",
                     "_unicode": "στρατοπεδάρχης",
                     "_translit": "stratopedárchēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat-op-ed-ar'-khace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4760"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a ruler of an army, i.e. (specially), a Prætorian\n præfect",
               "kjv_def": ":--captain of the guard.",
               "_strongs": "04759"
            },
            {
               "strongs": "4760",
               "greek": [
                  {
                     "_BETA": "STRATO/PEDON",
                     "_unicode": "στρατόπεδον",
                     "_translit": "stratópedon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strat-op'-ed-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4756"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3977"
                     }
                  ],
                  "__text": "from the base of \n and the same as \n;"
               },
               "strongs_def": "a camping-ground, i.e. (by\n implication) a body of troops",
               "kjv_def": ":--army.",
               "_strongs": "04760"
            },
            {
               "strongs": "4761",
               "greek": [
                  {
                     "_BETA": "STREBLO/W",
                     "_unicode": "στρεβλόω",
                     "_translit": "streblóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "streb-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to wrench, i.e. (specially), to torture (by\n the rack), but only figuratively, to pervert",
               "kjv_def": ":-- wrest.",
               "_strongs": "04761"
            },
            {
               "strongs": "4762",
               "greek": [
                  {
                     "_BETA": "STRE/FW",
                     "_unicode": "στρέφω",
                     "_translit": "stréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "strengthened from the base of \n;"
               },
               "strongs_def": "to twist, i.e. turn quite around\n or reverse (literally or figuratively)",
               "kjv_def": ":--convert, turn (again, back\n again, self, self about).",
               "_strongs": "04762"
            },
            {
               "strongs": "4763",
               "greek": [
                  {
                     "_BETA": "STRHNIA/W",
                     "_unicode": "στρηνιάω",
                     "_translit": "strēniáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stray-nee-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4764"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": "to be luxurious",
               "kjv_def": ":--live\n deliciously.",
               "_strongs": "04763"
            },
            {
               "strongs": "4764",
               "greek": [
                  {
                     "_BETA": "STRH=NOS",
                     "_unicode": "στρῆνος",
                     "_translit": "strēnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stray'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4731"
                     }
                  ],
                  "__text": "akin to \n;"
               },
               "strongs_def": "a \"straining\", \"strenuousness\" or \"strength\", i.e.\n (figuratively) luxury (voluptuousness)",
               "kjv_def": ":--delicacy.",
               "_strongs": "04764"
            },
            {
               "strongs": "4765",
               "greek": [
                  {
                     "_BETA": "STROUQI/ON",
                     "_unicode": "στρουθίον",
                     "_translit": "strouthíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stroo-thee'-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STROUQO/S",
                        "_unicode": "στρουθός",
                        "_translit": "strouthós"
                     }
                  ],
                  "__text": "diminutive of \n (a sparrow);"
               },
               "strongs_def": "a little sparrow",
               "kjv_def": ":--sparrow.",
               "_strongs": "04765"
            },
            {
               "strongs": "4766",
               "greek": [
                  {
                     "_BETA": "STRW/NNUMI",
                     "_unicode": "στρώννυμι",
                     "_translit": "strṓnnymi"
                  },
                  {
                     "_BETA": "STRWNNU/W",
                     "_unicode": "στρωννύω",
                     "_translit": "strōnnýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "strone'-noo-mee"
                  },
                  {
                     "_strongs": "strone-noo'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STRO/W",
                        "_unicode": "στρόω",
                        "_translit": "stróō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "stro'-o"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4731"
                     }
                  ],
                  "__text": "prolongation from a still simpler\n      \n  \n, (used only as an alternate in certain tenses)\n (probably akin to \n through the idea of positing);"
               },
               "strongs_def": "to \"strew,\" i.e.\n spread (as a carpet or couch)",
               "kjv_def": ":--make bed, furnish, spread, strew.",
               "_strongs": "04766",
               "__text": ",  or simpler\n      \n  \n;"
            },
            {
               "strongs": "4767",
               "greek": [
                  {
                     "_BETA": "STUGNHTO/S",
                     "_unicode": "στυγνητός",
                     "_translit": "stygnētós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stoog-nay-tos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STU/GW",
                        "_unicode": "στύγω",
                        "_translit": "stýgō"
                     }
                  ],
                  "__text": "from a derivative of an obsolete apparently primary \n (to hate);"
               },
               "strongs_def": "hated, i.e. odious",
               "kjv_def": ":--hateful.",
               "_strongs": "04767"
            },
            {
               "strongs": "4768",
               "greek": [
                  {
                     "_BETA": "STUGNA/ZW",
                     "_unicode": "στυγνάζω",
                     "_translit": "stygnázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stoog-nad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4767"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to render gloomy, i.e. (by implication) glower\n (be overcast with clouds, or sombreness of speech)",
               "kjv_def": ":--lower, be sad.",
               "_strongs": "04768"
            },
            {
               "strongs": "4769",
               "greek": [
                  {
                     "_BETA": "STU=LOS",
                     "_unicode": "στῦλος",
                     "_translit": "stŷlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "stoo'-los"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "STU/W",
                        "_unicode": "στύω",
                        "_translit": "stýō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n (to stiffen; properly akin to the base of \n);"
               },
               "strongs_def": "a post\n (\"style\"), i.e. (figuratively) support",
               "kjv_def": ":--pillar.",
               "_strongs": "04769"
            },
            {
               "strongs": "4770",
               "greek": [
                  {
                     "_BETA": "*STWI+KO/S",
                     "_unicode": "Στωϊκός",
                     "_translit": "Stōïkós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sto-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4745"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a \"Stoic\" (as occupying a particular porch in Athens), i.e.\n adherent of a certin philosophy",
               "kjv_def": ":--Stoick.",
               "_strongs": "04770"
            },
            {
               "strongs": "4771",
               "greek": [
                  {
                     "_BETA": "SU/",
                     "_unicode": "σύ",
                     "_translit": "sý"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo"
                  }
               ],
               "strongs_derivation": "the personal pronoun of the second person singular;",
               "strongs_def": "thou",
               "kjv_def": ":-- thou.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4571"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "4671"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "4675"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "5209"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "5210"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "5213"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "5216"
                  }
               ],
               "_strongs": "04771",
               "__text": "See\n also \n, \n, \n; and for the plural \n, \n, \n, \n."
            },
            {
               "strongs": "4772",
               "greek": [
                  {
                     "_BETA": "SUGGE/NEIA",
                     "_unicode": "συγγένεια",
                     "_translit": "syngéneia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-ghen'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4773"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "relationship, i.e. (concretely) relatives",
               "kjv_def": ":--kindred.",
               "_strongs": "04772"
            },
            {
               "strongs": "4773",
               "greek": [
                  {
                     "_BETA": "SUGGENH/S",
                     "_unicode": "συγγενής",
                     "_translit": "syngenḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-ghen-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1085"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a relative (by blood); by extension, a fellow\n countryman",
               "kjv_def": ":--cousin, kin(-sfolk, -sman).",
               "_strongs": "04773"
            },
            {
               "strongs": "4774",
               "greek": [
                  {
                     "_BETA": "SUGGNW/MH",
                     "_unicode": "συγγνώμη",
                     "_translit": "syngnṓmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-gno'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1097"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "fellow knowledge, i.e.\n concession",
               "kjv_def": ":--permission.",
               "_strongs": "04774"
            },
            {
               "strongs": "4775",
               "greek": [
                  {
                     "_BETA": "SUGKA/QHMAI",
                     "_unicode": "συγκάθημαι",
                     "_translit": "synkáthēmai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kath'-ay-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2521"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to seat oneself in company with",
               "kjv_def": ":--sit with.",
               "_strongs": "04775"
            },
            {
               "strongs": "4776",
               "greek": [
                  {
                     "_BETA": "SUGKAQI/ZW",
                     "_unicode": "συγκαθίζω",
                     "_translit": "synkathízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kath-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2523"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give (or take) a seat in company with",
               "kjv_def": ":--(make)\n sit (down) together.",
               "_strongs": "04776"
            },
            {
               "strongs": "4777",
               "greek": [
                  {
                     "_BETA": "SUGKAKOPAQE/W",
                     "_unicode": "συγκακοπαθέω",
                     "_translit": "synkakopathéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kak-op-ath-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2553"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to suffer hardship in company with",
               "kjv_def": ":--be partaker\n of afflictions.",
               "_strongs": "04777"
            },
            {
               "strongs": "4778",
               "greek": [
                  {
                     "_BETA": "SUGKAKOUXE/W",
                     "_unicode": "συγκακουχέω",
                     "_translit": "synkakouchéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kak-oo-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2558"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to maltreat in company with, i.e. (passively)\n endure persecution together",
               "kjv_def": ":--suffer affliction with.",
               "_strongs": "04778"
            },
            {
               "strongs": "4779",
               "greek": [
                  {
                     "_BETA": "SUGKALE/W",
                     "_unicode": "συγκαλέω",
                     "_translit": "synkaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2564"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to convoke",
               "kjv_def": ":--call together.",
               "_strongs": "04779"
            },
            {
               "strongs": "4780",
               "greek": [
                  {
                     "_BETA": "SUGKALU/PTW",
                     "_unicode": "συγκαλύπτω",
                     "_translit": "synkalýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kal-oop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2572"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to conceal altogether",
               "kjv_def": ":--cover.",
               "_strongs": "04780"
            },
            {
               "strongs": "4781",
               "greek": [
                  {
                     "_BETA": "SUGKA/MPTW",
                     "_unicode": "συγκάμπτω",
                     "_translit": "synkámptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kamp'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2578"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bend together, i.e. (figuratively) to\n afflict",
               "kjv_def": ":--bow down.",
               "_strongs": "04781"
            },
            {
               "strongs": "4782",
               "greek": [
                  {
                     "_BETA": "SUGKATABAI/NW",
                     "_unicode": "συγκαταβαίνω",
                     "_translit": "synkatabaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kat-ab-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2597"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to descend in company with",
               "kjv_def": ":--go down with.",
               "_strongs": "04782"
            },
            {
               "strongs": "4783",
               "greek": [
                  {
                     "_BETA": "SUGKATA/QESIS",
                     "_unicode": "συγκατάθεσις",
                     "_translit": "synkatáthesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kat-ath'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4784"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deposition (of sentiment) in company with, i.e.\n (figuratively) accord with",
               "kjv_def": ":--agreement.",
               "_strongs": "04783"
            },
            {
               "strongs": "4784",
               "greek": [
                  {
                     "_BETA": "SUGKATATI/QEMAI",
                     "_unicode": "συγκατατίθεμαι",
                     "_translit": "synkatatíthemai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kat-at-ith'-em-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2698"
                     }
                  ],
                  "__text": "middle from \n and \n;"
               },
               "strongs_def": "to deposit (one's vote or opinion) in company\n with, i.e. (figuratively) to accord with",
               "kjv_def": ":--consent.",
               "_strongs": "04784"
            },
            {
               "strongs": "4785",
               "greek": [
                  {
                     "_BETA": "SUGKATAYHFI/ZW",
                     "_unicode": "συγκαταψηφίζω",
                     "_translit": "synkatapsēphízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kat-aps-ay-fid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5585"
                     }
                  ],
                  "__text": "from \n and a compound of \n and \n;"
               },
               "strongs_def": "to count down in company\n with, i.e. enroll among",
               "kjv_def": ":--number with.",
               "_strongs": "04785"
            },
            {
               "strongs": "4786",
               "greek": [
                  {
                     "_BETA": "SUGKERA/NNUMI",
                     "_unicode": "συγκεράννυμι",
                     "_translit": "synkeránnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-ker-an'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2767"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to commingle, i.e. (figuratively) to combine or\n assimilate",
               "kjv_def": ":--mix with, temper together.",
               "_strongs": "04786"
            },
            {
               "strongs": "4787",
               "greek": [
                  {
                     "_BETA": "SUGKINE/W",
                     "_unicode": "συγκινέω",
                     "_translit": "synkinéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kin-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4682"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2795"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to move together, i.e. (specially), to excite as a\n mass (to sedition)",
               "kjv_def": ":--stir up.",
               "_strongs": "04787"
            },
            {
               "strongs": "4788",
               "greek": [
                  {
                     "_BETA": "SUGKLEI/W",
                     "_unicode": "συγκλείω",
                     "_translit": "synkleíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kli'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2808"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to shut together, i.e. include or (figuratively)\n embrace in a common subjection to",
               "kjv_def": ":--conclude, inclose, shut up.",
               "_strongs": "04788"
            },
            {
               "strongs": "4789",
               "greek": [
                  {
                     "_BETA": "SUGKLHRONO/MOS",
                     "_unicode": "συγκληρονόμος",
                     "_translit": "synklēronómos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-klay-ron-om'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2818"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a co-heir, i.e. (by analogy) participant in\n common",
               "kjv_def": ":--fellow (joint)-heir, heir together, heir with.",
               "_strongs": "04789"
            },
            {
               "strongs": "4790",
               "greek": [
                  {
                     "_BETA": "SUGKOINWNE/W",
                     "_unicode": "συγκοινωνέω",
                     "_translit": "synkoinōnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-koy-no-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2841"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to share in company with, i.e. co-participate\n in",
               "kjv_def": ":--communicate (have fellowship) with, be partaker of.",
               "_strongs": "04790"
            },
            {
               "strongs": "4791",
               "greek": [
                  {
                     "_BETA": "SUGKOINWNO/S",
                     "_unicode": "συγκοινωνός",
                     "_translit": "synkoinōnós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-koy-no-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2844"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a co-participant",
               "kjv_def": ":--companion, partake(-r, -r\n with).",
               "_strongs": "04791"
            },
            {
               "strongs": "4792",
               "greek": [
                  {
                     "_BETA": "SUGKOMI/ZW",
                     "_unicode": "συγκομίζω",
                     "_translit": "synkomízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kom-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2865"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to convey together, i.e. collect or bear away in\n company with others",
               "kjv_def": ":--carry.",
               "_strongs": "04792"
            },
            {
               "strongs": "4793",
               "greek": [
                  {
                     "_BETA": "SUGKRI/NW",
                     "_unicode": "συγκρίνω",
                     "_translit": "synkrínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kree'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to judge of one thing in connection with another,\n i.e. combine (spiritual ideas with appropriate expressions) or collate\n (one person with another by way of contrast or resemblance)",
               "kjv_def": ":--compare\n among (with).",
               "_strongs": "04793"
            },
            {
               "strongs": "4794",
               "greek": [
                  {
                     "_BETA": "SUGKU/PTW",
                     "_unicode": "συγκύπτω",
                     "_translit": "synkýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-koop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2955"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stoop altogether, i.e. be completely overcome\n by",
               "kjv_def": ":--bow together.",
               "_strongs": "04794"
            },
            {
               "strongs": "4795",
               "greek": [
                  {
                     "_BETA": "SUGKURI/A",
                     "_unicode": "συγκυρία",
                     "_translit": "synkyría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-koo-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2962"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "KURE/W",
                        "_unicode": "κυρέω",
                        "_translit": "kyréō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to light or happen; from the\n base of \n);"
               },
               "strongs_def": "concurrence, i.e. accident",
               "kjv_def": ":--chance.",
               "_strongs": "04795"
            },
            {
               "strongs": "4796",
               "greek": [
                  {
                     "_BETA": "SUGXAI/RW",
                     "_unicode": "συγχαίρω",
                     "_translit": "synchaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-khah'-ee-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5463"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sympathize in gladness, congratulate",
               "kjv_def": ":--rejoice\n in (with).",
               "_strongs": "04796"
            },
            {
               "strongs": "4797",
               "greek": [
                  {
                     "_BETA": "SUGXE/W",
                     "_unicode": "συγχέω",
                     "_translit": "synchéō"
                  },
                  {
                     "_BETA": "SUGXU/NW",
                     "_unicode": "συγχύνω",
                     "_translit": "synchýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-kheh'-o"
                  },
                  {
                     "_strongs": "soong-khoo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "XE/W",
                        "_unicode": "χέω",
                        "_translit": "chéō"
                     }
                  ],
                  "__text": "from \n and \n (to pour) or its alternate;"
               },
               "strongs_def": "to commingle\n promiscuously, i.e. (figuratively) to throw (an assembly) into\n disorder, to perplex (the mind)",
               "kjv_def": ":--confound, confuse, stir up, be in an\n uproar.",
               "_strongs": "04797",
               "__text": "or"
            },
            {
               "strongs": "4798",
               "greek": [
                  {
                     "_BETA": "SUGXRA/OMAI",
                     "_unicode": "συγχράομαι",
                     "_translit": "synchráomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong-khrah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to use jointly, i.e. (by implication) to hold\n intercourse in common",
               "kjv_def": ":--have dealings with.",
               "_strongs": "04798"
            },
            {
               "strongs": "4799",
               "greek": [
                  {
                     "_BETA": "SU/GXUSIS",
                     "_unicode": "σύγχυσις",
                     "_translit": "sýnchysis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soong'-khoo-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4797"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "commixture, i.e. (figuratively) riotous\n disturbance",
               "kjv_def": ":--confusion.",
               "_strongs": "04799"
            },
            {
               "strongs": "4800",
               "greek": [
                  {
                     "_BETA": "SUZA/W",
                     "_unicode": "συζάω",
                     "_translit": "syzáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sood-zah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to continue to live in common with, i.e.\n co-survive (literally or figuratively)",
               "kjv_def": ":--live with.",
               "_strongs": "04800"
            },
            {
               "strongs": "4801",
               "greek": [
                  {
                     "_BETA": "SUZEU/GNUMI",
                     "_unicode": "συζεύγνυμι",
                     "_translit": "syzeúgnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sood-zyoog'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2201"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to yoke together, i.e. (figuratively)\n conjoin (in marriage)",
               "kjv_def": ":--join together.",
               "_strongs": "04801"
            },
            {
               "strongs": "4802",
               "greek": [
                  {
                     "_BETA": "SUZHTE/W",
                     "_unicode": "συζητέω",
                     "_translit": "syzētéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sood-zay-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2212"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to investigate jointly, i.e. discuss, controvert,\n cavil",
               "kjv_def": ":--dispute (with), enquire, question (with), reason (together).",
               "_strongs": "04802"
            },
            {
               "strongs": "4803",
               "greek": [
                  {
                     "_BETA": "SUZH/THSIS",
                     "_unicode": "συζήτησις",
                     "_translit": "syzḗtēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sood-zay'-tay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4802"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "mutual questioning, i.e. discussion",
               "kjv_def": ":--disputation(-ting),\n reasoning.",
               "_strongs": "04803"
            },
            {
               "strongs": "4804",
               "greek": [
                  {
                     "_BETA": "SUZHTHTH/S",
                     "_unicode": "συζητητής",
                     "_translit": "syzētētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sood-zay-tay-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4802"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a disputant, i.e. sophist",
               "kjv_def": ":--disputer.",
               "_strongs": "04804"
            },
            {
               "strongs": "4805",
               "greek": [
                  {
                     "_BETA": "SU/ZUGOS",
                     "_unicode": "σύζυγος",
                     "_translit": "sýzygos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sood'-zoo-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4801"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "co-yoked, i.e. (figuratively) as noun, a colleague;\n probably rather as a proper name; Syzygus, a Christian",
               "kjv_def": ":--yokefellow.",
               "_strongs": "04805"
            },
            {
               "strongs": "4806",
               "greek": [
                  {
                     "_BETA": "SUZWOPOIE/W",
                     "_unicode": "συζωοποιέω",
                     "_translit": "syzōopoiéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sood-zo-op-oy-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2227"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reanimate conjointly with\n (figuratively)",
               "kjv_def": ":--quicken together with.",
               "_strongs": "04806"
            },
            {
               "strongs": "4807",
               "greek": [
                  {
                     "_BETA": "SUKA/MINOS",
                     "_unicode": "συκάμινος",
                     "_translit": "sykáminos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-kam'-ee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08256"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4809"
                     }
                  ],
                  "__text": "of Hebrew origin (\n) in imitation of \n;"
               },
               "strongs_def": "a sycamore-fig\n tree",
               "kjv_def": ":--sycamine tree.",
               "_strongs": "04807"
            },
            {
               "strongs": "4808",
               "greek": [
                  {
                     "_BETA": "SUKH=",
                     "_unicode": "συκῆ",
                     "_translit": "sykē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-kay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4810"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a fig-tree",
               "kjv_def": ":--fig tree.",
               "_strongs": "04808"
            },
            {
               "strongs": "4809",
               "greek": [
                  {
                     "_BETA": "SUKOMWRAI/A",
                     "_unicode": "συκομωραία",
                     "_translit": "sykomōraía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-kom-o-rah'-yah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4810"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "MO/RON",
                        "_unicode": "μόρον",
                        "_translit": "móron"
                     }
                  ],
                  "__text": "from \n and \n (the mulberry);"
               },
               "strongs_def": "the \"sycamore\"-fig tree",
               "kjv_def": ":--sycamore\n tree.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4807"
                  }
               ],
               "_strongs": "04809",
               "__text": "Compare \n."
            },
            {
               "strongs": "4810",
               "greek": [
                  {
                     "_BETA": "SU=KON",
                     "_unicode": "σῦκον",
                     "_translit": "sŷkon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo'-kon"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a fig",
               "kjv_def": ":--fig.",
               "_strongs": "04810"
            },
            {
               "strongs": "4811",
               "greek": [
                  {
                     "_BETA": "SUKOFANTE/W",
                     "_unicode": "συκοφαντέω",
                     "_translit": "sykophantéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-kof-an-teh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4810"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "to be a fig-informer\n (reporter of the law forbidding the exportation of figs from Greece),\n \"sycophant\", i.e. (genitive and by extension) to defraud (exact\n unlawfully, extort)",
               "kjv_def": ":--accuse falsely, take by false accusation.",
               "_strongs": "04811"
            },
            {
               "strongs": "4812",
               "greek": [
                  {
                     "_BETA": "SULAGWGE/W",
                     "_unicode": "συλαγωγέω",
                     "_translit": "sylagōgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-lag-ogue-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4813"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from the base of \n and (the reduplicated form of) \n;"
               },
               "strongs_def": "to lead away\n as booty, i.e. (figuratively) seduce",
               "kjv_def": ":--spoil.",
               "_strongs": "04812"
            },
            {
               "strongs": "4813",
               "greek": [
                  {
                     "_BETA": "SULA/W",
                     "_unicode": "συλάω",
                     "_translit": "syláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-lah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SU/LLW",
                        "_unicode": "σύλλω",
                        "_translit": "sýllō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4661"
                     }
                  ],
                  "__text": "from a derivative of \n (to strip; probably akin to \n; compare\n \n);"
               },
               "strongs_def": "to despoil",
               "kjv_def": ":--rob.",
               "_strongs": "04813"
            },
            {
               "strongs": "4814",
               "greek": [
                  {
                     "_BETA": "SULLALE/W",
                     "_unicode": "συλλαλέω",
                     "_translit": "syllaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sool-lal-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2980"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to talk together, i.e. converse",
               "kjv_def": ":--commune (confer,\n talk) with, speak among.",
               "_strongs": "04814"
            },
            {
               "strongs": "4815",
               "greek": [
                  {
                     "_BETA": "SULLAMBA/NW",
                     "_unicode": "συλλαμβάνω",
                     "_translit": "syllambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sool-lam-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to clasp, i.e. seize (arrest, capture); specially,\n to conceive (literally or figuratively); by implication, to\n aid",
               "kjv_def": ":--catch, conceive, help, take.",
               "_strongs": "04815"
            },
            {
               "strongs": "4816",
               "greek": [
                  {
                     "_BETA": "SULLE/GW",
                     "_unicode": "συλλέγω",
                     "_translit": "syllégō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sool-leg'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and \n in its original sense;"
               },
               "strongs_def": "to collect",
               "kjv_def": ":--gather\n (together, up).",
               "_strongs": "04816"
            },
            {
               "strongs": "4817",
               "greek": [
                  {
                     "_BETA": "SULLOGI/ZOMAI",
                     "_unicode": "συλλογίζομαι",
                     "_translit": "syllogízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sool-log-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3049"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reckon together (with oneself), i.e.\n deliberate",
               "kjv_def": ":--reason with.",
               "_strongs": "04817"
            },
            {
               "strongs": "4818",
               "greek": [
                  {
                     "_BETA": "SULLUPE/W",
                     "_unicode": "συλλυπέω",
                     "_translit": "syllypéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sool-loop-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3076"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to afflict jointly, i.e. (passive) sorrow at (on\n account of) someone",
               "kjv_def": ":--be grieved.",
               "_strongs": "04818"
            },
            {
               "strongs": "4819",
               "greek": [
                  {
                     "_BETA": "SUMBAI/NW",
                     "_unicode": "συμβαίνω",
                     "_translit": "symbaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-bah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to walk (figuratively, transpire)\n together, i.e. concur (take place)",
               "kjv_def": ":--be(-fall), happen (unto).",
               "_strongs": "04819"
            },
            {
               "strongs": "4820",
               "greek": [
                  {
                     "_BETA": "SUMBA/LLW",
                     "_unicode": "συμβάλλω",
                     "_translit": "symbállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-bal'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to combine, i.e. (in speaking) to converse,\n consult, dispute, (mentally) to consider, (by implication) to aid,\n (personally) to join, attack",
               "kjv_def": ":--confer, encounter, help, make, meet\n with, ponder.",
               "_strongs": "04820"
            },
            {
               "strongs": "4821",
               "greek": [
                  {
                     "_BETA": "SUMBASILEU/W",
                     "_unicode": "συμβασιλεύω",
                     "_translit": "symbasileúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-bas-il-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "936"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be co-regent (figuratively)",
               "kjv_def": ":--reign with.",
               "_strongs": "04821"
            },
            {
               "strongs": "4822",
               "greek": [
                  {
                     "_BETA": "SUMBIBA/ZW",
                     "_unicode": "συμβιβάζω",
                     "_translit": "symbibázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-bib-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "BIBA/ZW",
                        "_unicode": "βιβάζω",
                        "_translit": "bibázō"
                     }
                  ],
                  "__text": "from \n and \n (to force;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "causative (by reduplication) of the\n base of \n); to drive together, i.e. unite (in association or\n affection), (mentally) to infer, show, teach"
               },
               "kjv_def": ":--compact, assuredly\n gather, intrust, knit together, prove.",
               "_strongs": "04822"
            },
            {
               "strongs": "4823",
               "greek": [
                  {
                     "_BETA": "SUMBOULEU/W",
                     "_unicode": "συμβουλεύω",
                     "_translit": "symbouleúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-bool-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1011"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to give (or take) advice jointly, i.e. recommend,\n deliberate or determine",
               "kjv_def": ":--consult, (give, take) counsel (together).",
               "_strongs": "04823"
            },
            {
               "strongs": "4824",
               "greek": [
                  {
                     "_BETA": "SUMBOU/LION",
                     "_unicode": "συμβούλιον",
                     "_translit": "symboúlion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-boo'-lee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4825"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "advisement; specially, a\n deliberative body, i.e. the provincial assessors or\n lay-court",
               "kjv_def": ":--consultation, counsel, council.",
               "_strongs": "04824"
            },
            {
               "strongs": "4825",
               "greek": [
                  {
                     "_BETA": "SU/MBOULOS",
                     "_unicode": "σύμβουλος",
                     "_translit": "sýmboulos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom'-boo-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1012"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a consultor, i.e. adviser",
               "kjv_def": ":--counsellor.",
               "_strongs": "04825"
            },
            {
               "strongs": "4826",
               "greek": [
                  {
                     "_BETA": "*SUMEW/N",
                     "_unicode": "Συμεών",
                     "_translit": "Symeṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-eh-one'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4613"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "Symeon (i.e. Shimon), the name of five\n Israelites",
               "kjv_def": ":--Simeon, Simon.",
               "_strongs": "04826"
            },
            {
               "strongs": "4827",
               "greek": [
                  {
                     "_BETA": "SUMMAQHTH/S",
                     "_unicode": "συμμαθητής",
                     "_translit": "symmathētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-math-ay-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3129"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a co-learner (of\n Christianity)",
               "kjv_def": ":--fellow disciple.",
               "_strongs": "04827"
            },
            {
               "strongs": "4828",
               "greek": [
                  {
                     "_BETA": "SUMMARTURE/W",
                     "_unicode": "συμμαρτυρέω",
                     "_translit": "symmartyréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-mar-too-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3140"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to testify jointly, i.e. corroborate by\n (concurrent) evidence",
               "kjv_def": ":--testify unto, (also) bear witness (with).",
               "_strongs": "04828"
            },
            {
               "strongs": "4829",
               "greek": [
                  {
                     "_BETA": "SUMMERI/ZOMAI",
                     "_unicode": "συμμερίζομαι",
                     "_translit": "symmerízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-mer-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3307"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to share jointly, i.e. participate\n in",
               "kjv_def": ":--be partaker with.",
               "_strongs": "04829"
            },
            {
               "strongs": "4830",
               "greek": [
                  {
                     "_BETA": "SUMME/TOXOS",
                     "_unicode": "συμμέτοχος",
                     "_translit": "symmétochos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-met'-okh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3353"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a co-participant",
               "kjv_def": ":--partaker.",
               "_strongs": "04830"
            },
            {
               "strongs": "4831",
               "greek": [
                  {
                     "_BETA": "SUMMIMHTH/S",
                     "_unicode": "συμμιμητής",
                     "_translit": "symmimētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-mim-ay-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3401"
                     }
                  ],
                  "__text": "from a presumed compound of \n and \n;"
               },
               "strongs_def": "a co-imitator, i.e. fellow\n votary",
               "kjv_def": ":--follower together.",
               "_strongs": "04831"
            },
            {
               "strongs": "4832",
               "greek": [
                  {
                     "_BETA": "SU/MMORFOS",
                     "_unicode": "σύμμορφος",
                     "_translit": "sýmmorphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-mor-fos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3444"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "jointly formed, i.e. (figuratively)\n similar",
               "kjv_def": ":--conformed to, fashioned like unto.",
               "_strongs": "04832"
            },
            {
               "strongs": "4833",
               "greek": [
                  {
                     "_BETA": "SUMMORFO/W",
                     "_unicode": "συμμορφόω",
                     "_translit": "symmorphóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-mor-fo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4832"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render like, i.e. (figuratively) to assimilate",
               "kjv_def": ":--make\n conformable unto.",
               "_strongs": "04833"
            },
            {
               "strongs": "4834",
               "greek": [
                  {
                     "_BETA": "SUMPAQE/W",
                     "_unicode": "συμπαθέω",
                     "_translit": "sympathéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-path-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4835"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to feel \"sympathy\" with, i.e. (by implication) to\n commiserate",
               "kjv_def": ":--have compassion, be touched with a feeling of.",
               "_strongs": "04834"
            },
            {
               "strongs": "4835",
               "greek": [
                  {
                     "_BETA": "SUMPAQH/S",
                     "_unicode": "συμπαθής",
                     "_translit": "sympathḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-path-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4841"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "having a fellow-feeling (\"sympathetic\"), i.e. (by\n implication) mutually commiserative",
               "kjv_def": ":--having compassion one of\n another.",
               "_strongs": "04835"
            },
            {
               "strongs": "4836",
               "greek": [
                  {
                     "_BETA": "SUMPARAGI/NOMAI",
                     "_unicode": "συμπαραγίνομαι",
                     "_translit": "symparagínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-par-ag-in'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3854"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be present together, i.e. to convene; by\n implication, to appear in aid",
               "kjv_def": ":--come together, stand with.",
               "_strongs": "04836"
            },
            {
               "strongs": "4837",
               "greek": [
                  {
                     "_BETA": "SUMPARAKALE/W",
                     "_unicode": "συμπαρακαλέω",
                     "_translit": "symparakaléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-par-ak-al-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3870"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to console jointly",
               "kjv_def": ":--comfort together.",
               "_strongs": "04837"
            },
            {
               "strongs": "4838",
               "greek": [
                  {
                     "_BETA": "SUMPARALAMBA/NW",
                     "_unicode": "συμπαραλαμβάνω",
                     "_translit": "symparalambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-par-al-am-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3880"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take along in company",
               "kjv_def": ":--take with.",
               "_strongs": "04838"
            },
            {
               "strongs": "4839",
               "greek": [
                  {
                     "_BETA": "SUMPARAME/NW",
                     "_unicode": "συμπαραμένω",
                     "_translit": "symparaménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-par-am-en'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3887"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to remain in company, i.e. still live",
               "kjv_def": ":--continue\n with.",
               "_strongs": "04839"
            },
            {
               "strongs": "4840",
               "greek": [
                  {
                     "_BETA": "SUMPA/REIMI",
                     "_unicode": "συμπάρειμι",
                     "_translit": "sympáreimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-par'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3918"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to be at hand together, i.e. now present",
               "kjv_def": ":--be here\n present with.",
               "_strongs": "04840"
            },
            {
               "strongs": "4841",
               "greek": [
                  {
                     "_BETA": "SUMPA/SXW",
                     "_unicode": "συμπάσχω",
                     "_translit": "sympáschō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-pas'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3958"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to experience pain\n jointly or of the same kind (specially, persecution; to\n \"sympathize\")",
               "kjv_def": ":--suffer with.",
               "_strongs": "04841"
            },
            {
               "strongs": "4842",
               "greek": [
                  {
                     "_BETA": "SUMPE/MPW",
                     "_unicode": "συμπέμπω",
                     "_translit": "sympémpō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-pem'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3992"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to despatch in company",
               "kjv_def": ":--send with.",
               "_strongs": "04842"
            },
            {
               "strongs": "4843",
               "greek": [
                  {
                     "_BETA": "SUMPERILAMBA/NW",
                     "_unicode": "συμπεριλαμβάνω",
                     "_translit": "symperilambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-per-ee-lam-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4012"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and a compound of \n and \n;"
               },
               "strongs_def": "to take by enclosing\n altogether, i.e. earnestly throw the arms about one",
               "kjv_def": ":--embrace.",
               "_strongs": "04843"
            },
            {
               "strongs": "4844",
               "greek": [
                  {
                     "_BETA": "SUMPI/NW",
                     "_unicode": "συμπίνω",
                     "_translit": "sympínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-pee'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to partake a beverage in company",
               "kjv_def": ":--drink with.",
               "_strongs": "04844"
            },
            {
               "strongs": "4845",
               "greek": [
                  {
                     "_BETA": "SUMPLHRO/W",
                     "_unicode": "συμπληρόω",
                     "_translit": "symplēróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-play-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4137"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to implenish completely, i.e. (of space) to swamp\n (a boat), or (of time) to accomplish (passive, be complete)",
               "kjv_def": ":--(fully)\n come, fill up.",
               "_strongs": "04845"
            },
            {
               "strongs": "4846",
               "greek": [
                  {
                     "_BETA": "SUMPNI/GW",
                     "_unicode": "συμπνίγω",
                     "_translit": "sympnígō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-pnee'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4155"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to strangle completely, i.e. (literally) to drown,\n or (figuratively) to crowd",
               "kjv_def": ":--choke, throng.",
               "_strongs": "04846"
            },
            {
               "strongs": "4847",
               "greek": [
                  {
                     "_BETA": "SUMPOLI/THS",
                     "_unicode": "συμπολίτης",
                     "_translit": "sympolítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-pol-ee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4177"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a native of the same town, i.e. (figuratively)\n co-religionist (fellow-Christian)",
               "kjv_def": ":--fellow- citizen.",
               "_strongs": "04847"
            },
            {
               "strongs": "4848",
               "greek": [
                  {
                     "_BETA": "SUMPOREU/OMAI",
                     "_unicode": "συμπορεύομαι",
                     "_translit": "symporeúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-por-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4198"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to journey together; by implication, to\n assemble",
               "kjv_def": ":--go with, resort.",
               "_strongs": "04848"
            },
            {
               "strongs": "4849",
               "greek": [
                  {
                     "_BETA": "SUMPO/SION",
                     "_unicode": "συμπόσιον",
                     "_translit": "sympósion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-pos'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4844"
                     }
                  ],
                  "__text": "neuter of a derivative of the alternate of \n;"
               },
               "strongs_def": "a drinking-party\n (\"symposium\"), i.e. (by extension) a room of guests",
               "kjv_def": ":--company.",
               "_strongs": "04849"
            },
            {
               "strongs": "4850",
               "greek": [
                  {
                     "_BETA": "SUMPRESBU/TEROS",
                     "_unicode": "συμπρεσβύτερος",
                     "_translit": "sympresbýteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-pres-boo'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4245"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a co-presbyter",
               "kjv_def": ":--presbyter, also an elder.",
               "_strongs": "04850"
            },
            {
               "strongs": "4851",
               "greek": [
                  {
                     "_BETA": "SUMFE/RW",
                     "_unicode": "συμφέρω",
                     "_translit": "symphérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-fer'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to bear together\n (contribute), i.e. (literally) to collect, or (figuratively) to\n conduce; especially (neuter participle as a noun) advantage",
               "kjv_def": ":--be\n better for, bring together, be expedient (for), be good, (be)\n profit(-able for).",
               "_strongs": "04851"
            },
            {
               "strongs": "4852",
               "greek": [
                  {
                     "_BETA": "SU/MFHMI",
                     "_unicode": "σύμφημι",
                     "_translit": "sýmphēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom'-fay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to say jointly, i.e. assent to",
               "kjv_def": ":--consent unto.",
               "_strongs": "04852"
            },
            {
               "strongs": "4853",
               "greek": [
                  {
                     "_BETA": "SUMFULE/THS",
                     "_unicode": "συμφυλέτης",
                     "_translit": "symphylétēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-foo-let'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5443"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "a co-tribesman, i.e. native of the\n same country",
               "kjv_def": ":--countryman.",
               "_strongs": "04853"
            },
            {
               "strongs": "4854",
               "greek": [
                  {
                     "_BETA": "SU/MFUTOS",
                     "_unicode": "σύμφυτος",
                     "_translit": "sýmphytos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom'-foo-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "grown along with (connate), i.e.\n (figuratively) closely united to",
               "kjv_def": ":--planted together.",
               "_strongs": "04854"
            },
            {
               "strongs": "4855",
               "greek": [
                  {
                     "_BETA": "SUMFU/W",
                     "_unicode": "συμφύω",
                     "_translit": "symphýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-foo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "passive, to grow jointly",
               "kjv_def": ":--spring up with.",
               "_strongs": "04855"
            },
            {
               "strongs": "4856",
               "greek": [
                  {
                     "_BETA": "SUMFWNE/W",
                     "_unicode": "συμφωνέω",
                     "_translit": "symphōnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-fo-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4859"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be harmonious, i.e. (figuratively) to accord (be\n suitable, concur) or stipulate (by compact)",
               "kjv_def": ":--agree (together, with).",
               "_strongs": "04856"
            },
            {
               "strongs": "4857",
               "greek": [
                  {
                     "_BETA": "SUMFW/NHSIS",
                     "_unicode": "συμφώνησις",
                     "_translit": "symphṓnēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-fo'-nay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4856"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "accordance",
               "kjv_def": ":--concord.",
               "_strongs": "04857"
            },
            {
               "strongs": "4858",
               "greek": [
                  {
                     "_BETA": "SUMFWNI/A",
                     "_unicode": "συμφωνία",
                     "_translit": "symphōnía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-fo-nee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4859"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "unison of sound (\"symphony\"), i.e. a concert of instruments\n (harmonious note)",
               "kjv_def": ":--music.",
               "_strongs": "04858"
            },
            {
               "strongs": "4859",
               "greek": [
                  {
                     "_BETA": "SU/MFWNOS",
                     "_unicode": "σύμφωνος",
                     "_translit": "sýmphōnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom'-fo-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5456"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "sounding together (alike), i.e. (figuratively)\n accordant (neuter as noun, agreement)",
               "kjv_def": ":-- consent.",
               "_strongs": "04859"
            },
            {
               "strongs": "4860",
               "greek": [
                  {
                     "_BETA": "SUMYHFI/ZW",
                     "_unicode": "συμψηφίζω",
                     "_translit": "sympsēphízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom-psay-fid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5585"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to compute jointly",
               "kjv_def": ":--reckon.",
               "_strongs": "04860"
            },
            {
               "strongs": "4861",
               "greek": [
                  {
                     "_BETA": "SU/MYUXOS",
                     "_unicode": "σύμψυχος",
                     "_translit": "sýmpsychos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soom'-psoo-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5590"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "co-spirited, i.e. similar in\n sentiment",
               "kjv_def": ":--like-minded.",
               "_strongs": "04861"
            },
            {
               "strongs": "4862",
               "greek": [
                  {
                     "_BETA": "SU/N",
                     "_unicode": "σύν",
                     "_translit": "sýn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon"
                  }
               ],
               "strongs_derivation": "a primary preposition denoting union;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3326"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3844"
                     }
                  ],
                  "__text": "with or together (but much\n closer than \n or \n), i.e. by association, companionship,\n process, resemblance, possession, instrumentality, addition,\n etc."
               },
               "kjv_def": ":--beside, with.",
               "_strongs": "04862",
               "__text": "In composition it has similar applications,\n including completeness."
            },
            {
               "strongs": "4863",
               "greek": [
                  {
                     "_BETA": "SUNA/GW",
                     "_unicode": "συνάγω",
                     "_translit": "synágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead together, i.e. collect or convene;\n specially, to entertain (hospitably)",
               "kjv_def": ":--+ accompany, assemble (selves,\n together), bestow, come together, gather (selves together, up,\n together), lead into, resort, take in.",
               "_strongs": "04863"
            },
            {
               "strongs": "4864",
               "greek": [
                  {
                     "_BETA": "SUNAGWGH/",
                     "_unicode": "συναγωγή",
                     "_translit": "synagōgḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ag-o-gay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4863"
                     }
                  ],
                  "__text": "from (the reduplicated form of) \n;"
               },
               "strongs_def": "an assemblage of persons;\n specially, a Jewish \"synagogue\" (the meeting or the place); by\n analogy, a Christian church",
               "kjv_def": ":--assembly, congregation, synagogue.",
               "_strongs": "04864"
            },
            {
               "strongs": "4865",
               "greek": [
                  {
                     "_BETA": "SUNAGWNI/ZOMAI",
                     "_unicode": "συναγωνίζομαι",
                     "_translit": "synagōnízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ag-o-nid'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "75"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to struggle in company with, i.e. (figuratively) to\n be a partner (assistant)",
               "kjv_def": ":--strive together with.",
               "_strongs": "04865"
            },
            {
               "strongs": "4866",
               "greek": [
                  {
                     "_BETA": "SUNAQLE/W",
                     "_unicode": "συναθλέω",
                     "_translit": "synathléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ath-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "118"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to wrestle in company with, i.e. (figuratively) to\n seek jointly",
               "kjv_def": ":--labour with, strive together for.",
               "_strongs": "04866"
            },
            {
               "strongs": "4867",
               "greek": [
                  {
                     "_BETA": "SUNAQROI/ZW",
                     "_unicode": "συναθροίζω",
                     "_translit": "synathroízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ath-royd'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A)QROI/ZW",
                        "_unicode": "ἀθροίζω",
                        "_translit": "athroízō"
                     }
                  ],
                  "__text": "from \n and \n (to hoard);"
               },
               "strongs_def": "to convene",
               "kjv_def": ":--call (gather)\n together.",
               "_strongs": "04867"
            },
            {
               "strongs": "4868",
               "greek": [
                  {
                     "_BETA": "SUNAI/RW",
                     "_unicode": "συναίρω",
                     "_translit": "synaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ah'-ee-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to make up together, i.e. (figuratively) to compute\n (an account)",
               "kjv_def": ":--reckon, take.",
               "_strongs": "04868"
            },
            {
               "strongs": "4869",
               "greek": [
                  {
                     "_BETA": "SUNAIXMA/LWTOS",
                     "_unicode": "συναιχμάλωτος",
                     "_translit": "synaichmálōtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-aheekh-mal'-o-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "164"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a co-captive",
               "kjv_def": ":--fellowprisoner.",
               "_strongs": "04869"
            },
            {
               "strongs": "4870",
               "greek": [
                  {
                     "_BETA": "SUNAKOLOUQE/W",
                     "_unicode": "συνακολουθέω",
                     "_translit": "synakolouthéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ak-ol-oo-theh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "190"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to accompany",
               "kjv_def": ":--follow.",
               "_strongs": "04870"
            },
            {
               "strongs": "4871",
               "greek": [
                  {
                     "_BETA": "SUNALI/ZW",
                     "_unicode": "συναλίζω",
                     "_translit": "synalízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-al-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "A(LI/ZW",
                        "_unicode": "ἁλίζω",
                        "_translit": "halízō"
                     }
                  ],
                  "__text": "from \n and \n (to throng);"
               },
               "strongs_def": "to accumulate, i.e.\n convene",
               "kjv_def": ":--assemble together.",
               "_strongs": "04871"
            },
            {
               "strongs": "4872",
               "greek": [
                  {
                     "_BETA": "SUNANABAI/NW",
                     "_unicode": "συναναβαίνω",
                     "_translit": "synanabaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-an-ab-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "305"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to ascend in company with",
               "kjv_def": ":--come up with.",
               "_strongs": "04872"
            },
            {
               "strongs": "4873",
               "greek": [
                  {
                     "_BETA": "SUNANA/KEIMAI",
                     "_unicode": "συνανάκειμαι",
                     "_translit": "synanákeimai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-an-ak'-i-mahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "345"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to recline in company with (at a meal)",
               "kjv_def": ":--sit (down,\n at the table, together) with (at meat).",
               "_strongs": "04873"
            },
            {
               "strongs": "4874",
               "greek": [
                  {
                     "_BETA": "SUNANAMI/GNUMI",
                     "_unicode": "συναναμίγνυμι",
                     "_translit": "synanamígnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-an-am-ig'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "303"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3396"
                     }
                  ],
                  "__text": "from \n and a compound of \n and \n;"
               },
               "strongs_def": "to mix up together, i.e.\n (figurative) associate with",
               "kjv_def": ":--(have, keep) company (with).",
               "_strongs": "04874"
            },
            {
               "strongs": "4875",
               "greek": [
                  {
                     "_BETA": "SUNANAPAU/OMAI",
                     "_unicode": "συναναπαύομαι",
                     "_translit": "synanapaúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-an-ap-ow'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "373"
                     }
                  ],
                  "__text": "middle from \n and \n;"
               },
               "strongs_def": "to recruit oneself in company with",
               "kjv_def": ":--refresh\n with.",
               "_strongs": "04875"
            },
            {
               "strongs": "4876",
               "greek": [
                  {
                     "_BETA": "SUNANTA/W",
                     "_unicode": "συναντάω",
                     "_translit": "synantáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-an-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to meet with; figuratively, to\n occur",
               "kjv_def": ":--befall, meet.",
               "_strongs": "04876"
            },
            {
               "strongs": "4877",
               "greek": [
                  {
                     "_BETA": "SUNA/NTHSIS",
                     "_unicode": "συνάντησις",
                     "_translit": "synántēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-an'-tay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4876"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a meeting with",
               "kjv_def": ":--meet.",
               "_strongs": "04877"
            },
            {
               "strongs": "4878",
               "greek": [
                  {
                     "_BETA": "SUNANTILAMBA/NOMAI",
                     "_unicode": "συναντιλαμβάνομαι",
                     "_translit": "synantilambánomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-an-tee-lam-ban'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "482"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take hold of opposite together, i.e. co-operate\n (assist)",
               "kjv_def": ":--help.",
               "_strongs": "04878"
            },
            {
               "strongs": "4879",
               "greek": [
                  {
                     "_BETA": "SUNAPA/GW",
                     "_unicode": "συναπάγω",
                     "_translit": "synapágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ap-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "520"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take off together, i.e. transport with (seduce,\n passively, yield)",
               "kjv_def": ":--carry (lead) away with, condescend.",
               "_strongs": "04879"
            },
            {
               "strongs": "4880",
               "greek": [
                  {
                     "_BETA": "SUNAPOQNH/SKW",
                     "_unicode": "συναποθνήσκω",
                     "_translit": "synapothnḗskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ap-oth-nace'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "599"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to decease (literally) in company with, or\n (figuratively), similarly to",
               "kjv_def": ":--be dead (die) with.",
               "_strongs": "04880"
            },
            {
               "strongs": "4881",
               "greek": [
                  {
                     "_BETA": "SUNAPO/LLUMI",
                     "_unicode": "συναπόλλυμι",
                     "_translit": "synapóllymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ap-ol'-loo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "622"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to destroy (middle voice or passively, be slain) in\n company with",
               "kjv_def": ":--perish with.",
               "_strongs": "04881"
            },
            {
               "strongs": "4882",
               "greek": [
                  {
                     "_BETA": "SUNAPOSTE/LLW",
                     "_unicode": "συναποστέλλω",
                     "_translit": "synapostéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ap-os-tel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "649"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to despatch (on an errand) in company with",
               "kjv_def": ":--send\n with.",
               "_strongs": "04882"
            },
            {
               "strongs": "4883",
               "greek": [
                  {
                     "_BETA": "SUNARMOLOGE/W",
                     "_unicode": "συναρμολογέω",
                     "_translit": "synarmologéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ar-mol-og-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "719"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and a derivative of a compound of \n and \n (in its\n original sense of laying);"
               },
               "strongs_def": "to render close-jointed together, i.e.\n organize compactly",
               "kjv_def": ":--be fitly framed (joined) together.",
               "_strongs": "04883"
            },
            {
               "strongs": "4884",
               "greek": [
                  {
                     "_BETA": "SUNARPA/ZW",
                     "_unicode": "συναρπάζω",
                     "_translit": "synarpázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ar-pad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "726"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to snatch together, i.e. seize",
               "kjv_def": ":--catch.",
               "_strongs": "04884"
            },
            {
               "strongs": "4885",
               "greek": [
                  {
                     "_BETA": "SUNAUCA/NW",
                     "_unicode": "συναυξάνω",
                     "_translit": "synauxánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-owx-an'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "837"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to increase (grow up) together",
               "kjv_def": ":--grow together.",
               "_strongs": "04885"
            },
            {
               "strongs": "4886",
               "greek": [
                  {
                     "_BETA": "SU/NDESMOS",
                     "_unicode": "σύνδεσμος",
                     "_translit": "sýndesmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon'-des-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1199"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a joint tie, i.e. ligament, (figuratively) uniting\n principle, control",
               "kjv_def": ":--band, bond.",
               "_strongs": "04886"
            },
            {
               "strongs": "4887",
               "greek": [
                  {
                     "_BETA": "SUNDE/W",
                     "_unicode": "συνδέω",
                     "_translit": "syndéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-deh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bind with, i.e. (passively) be a\n fellow-prisoner (figuratively)",
               "kjv_def": ":--be bound with.",
               "_strongs": "04887"
            },
            {
               "strongs": "4888",
               "greek": [
                  {
                     "_BETA": "SUNDOCA/ZW",
                     "_unicode": "συνδοξάζω",
                     "_translit": "syndoxázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-dox-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1392"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exalt to dignity in company (i.e. similarly)\n with",
               "kjv_def": ":--glorify together.",
               "_strongs": "04888"
            },
            {
               "strongs": "4889",
               "greek": [
                  {
                     "_BETA": "SU/NDOULOS",
                     "_unicode": "σύνδουλος",
                     "_translit": "sýndoulos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon'-doo-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1401"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a co-slave, i.e. servitor or ministrant of the\n same master (human or divine)",
               "kjv_def": ":--fellowservant.",
               "_strongs": "04889"
            },
            {
               "strongs": "4890",
               "greek": [
                  {
                     "_BETA": "SUNDROMH/",
                     "_unicode": "συνδρομή",
                     "_translit": "syndromḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-drom-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4936"
                     }
                  ],
                  "__text": "from (the alternate of) \n;"
               },
               "strongs_def": "a running together, i.e. (riotous)\n concourse",
               "kjv_def": ":--run together.",
               "_strongs": "04890"
            },
            {
               "strongs": "4891",
               "greek": [
                  {
                     "_BETA": "SUNEGEI/RW",
                     "_unicode": "συνεγείρω",
                     "_translit": "synegeírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-eg-i'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1453"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rouse (from death) in company with, i.e.\n (figuratively) to revivify (spirtually) in resemblance to",
               "kjv_def": ":--raise up\n together, rise with.",
               "_strongs": "04891"
            },
            {
               "strongs": "4892",
               "greek": [
                  {
                     "_BETA": "SUNE/DRION",
                     "_unicode": "συνέδριον",
                     "_translit": "synédrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ed'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1476"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of a compound of \n and the base of\n \n;"
               },
               "strongs_def": "a joint session, i.e. (specially), the Jewish Sanhedrin; by\n analogy, a subordinate tribunal",
               "kjv_def": ":--council.",
               "_strongs": "04892"
            },
            {
               "strongs": "4893",
               "greek": [
                  {
                     "_BETA": "SUNEI/DHSIS",
                     "_unicode": "συνείδησις",
                     "_translit": "syneídēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-i'-day-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4894"
                     }
                  ],
                  "__text": "from a prolonged form of \n;"
               },
               "strongs_def": "co-perception, i.e. moral\n consciousness",
               "kjv_def": ":--conscience.",
               "_strongs": "04893"
            },
            {
               "strongs": "4894",
               "greek": [
                  {
                     "_BETA": "SUNEI/DW",
                     "_unicode": "συνείδω",
                     "_translit": "syneídō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-i'-do"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to see completely; used (like its primary) only in\n two past tenses, respectively meaning to understand or become aware,\n and to be conscious or (clandestinely) informed of",
               "kjv_def": ":--consider, know,\n be privy, be ware of.",
               "_strongs": "04894"
            },
            {
               "strongs": "4895",
               "greek": [
                  {
                     "_BETA": "SU/NEIMI",
                     "_unicode": "σύνειμι",
                     "_translit": "sýneimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "from \n and \n (including its various inflections);"
               },
               "strongs_def": "to be in\n company with, i.e. present at the time",
               "kjv_def": ":--be with.",
               "_strongs": "04895"
            },
            {
               "strongs": "4896",
               "greek": [
                  {
                     "_BETA": "SU/NEIMI",
                     "_unicode": "σύνειμι",
                     "_translit": "sýneimi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon'-i-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)=MI",
                        "_unicode": "εἶμι",
                        "_translit": "eîmi"
                     }
                  ],
                  "__text": "from \n and \n (to go);"
               },
               "strongs_def": "to assemble",
               "kjv_def": ":--gather together.",
               "_strongs": "04896"
            },
            {
               "strongs": "4897",
               "greek": [
                  {
                     "_BETA": "SUNEISE/RXOMAI",
                     "_unicode": "συνεισέρχομαι",
                     "_translit": "syneisérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ice-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1525"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to enter in company with",
               "kjv_def": ":--go in with, go with\n into.",
               "_strongs": "04897"
            },
            {
               "strongs": "4898",
               "greek": [
                  {
                     "_BETA": "SUNE/KDHMOS",
                     "_unicode": "συνέκδημος",
                     "_translit": "synékdēmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ek'-day-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1553"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "a co-absentee from home, i.e.\n fellow-traveller",
               "kjv_def": ":--companion in travel, travel with.",
               "_strongs": "04898"
            },
            {
               "strongs": "4899",
               "greek": [
                  {
                     "_BETA": "SUNEKLEKTO/S",
                     "_unicode": "συνεκλεκτός",
                     "_translit": "syneklektós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ek-lek-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1586"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "chosen in company with, i.e.\n co-elect (fellow Christian)",
               "kjv_def": ":--elected together with.",
               "_strongs": "04899"
            },
            {
               "strongs": "4900",
               "greek": [
                  {
                     "_BETA": "SUNELAU/NW",
                     "_unicode": "συνελαύνω",
                     "_translit": "synelaúnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-el-ow'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1643"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to drive together, i.e. (figuratively) exhort (to\n reconciliation)",
               "kjv_def": ":--+ set at one again.",
               "_strongs": "04900"
            },
            {
               "strongs": "4901",
               "greek": [
                  {
                     "_BETA": "SUNEPIMARTURE/W",
                     "_unicode": "συνεπιμαρτυρέω",
                     "_translit": "synepimartyréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ep-ee-mar-too-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1957"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to testify further jointly, i.e. unite in adding\n evidence",
               "kjv_def": ":--also bear witness.",
               "_strongs": "04901"
            },
            {
               "strongs": "4902",
               "greek": [
                  {
                     "_BETA": "SUNE/POMAI",
                     "_unicode": "συνέπομαι",
                     "_translit": "synépomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ep'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "E(/PW",
                        "_unicode": "ἕπω",
                        "_translit": "hépō"
                     }
                  ],
                  "__text": "middle voice from \n and a primary \n (to follow);"
               },
               "strongs_def": "to attend\n (travel) in company with",
               "kjv_def": ":--accompany.",
               "_strongs": "04902"
            },
            {
               "strongs": "4903",
               "greek": [
                  {
                     "_BETA": "SUNERGE/W",
                     "_unicode": "συνεργέω",
                     "_translit": "synergéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-erg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4904"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a fellow-worker, i.e. co-operate",
               "kjv_def": ":--help (work) with,\n work(-er) together.",
               "_strongs": "04903"
            },
            {
               "strongs": "4904",
               "greek": [
                  {
                     "_BETA": "SUNERGO/S",
                     "_unicode": "συνεργός",
                     "_translit": "synergós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-er-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from a presumed compound of \n and the base of \n;"
               },
               "strongs_def": "a co-laborer,\n i.e. coadjutor",
               "kjv_def": ":--companion in labour, (fellow-)helper(-labourer,\n -worker), labourer together with, workfellow.",
               "_strongs": "04904"
            },
            {
               "strongs": "4905",
               "greek": [
                  {
                     "_BETA": "SUNE/RXOMAI",
                     "_unicode": "συνέρχομαι",
                     "_translit": "synérchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-er'-khom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2064"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to convene, depart in company with, associate\n with, or (specially), cohabit (conjugally)",
               "kjv_def": ":--accompany, assemble\n (with), come (together), come (company, go) with, resort.",
               "_strongs": "04905"
            },
            {
               "strongs": "4906",
               "greek": [
                  {
                     "_BETA": "SUNESQI/W",
                     "_unicode": "συνεσθίω",
                     "_translit": "synesthíō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-es-thee'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2068"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to take food in company\n with",
               "kjv_def": ":--eat with.",
               "_strongs": "04906"
            },
            {
               "strongs": "4907",
               "greek": [
                  {
                     "_BETA": "SU/NESIS",
                     "_unicode": "σύνεσις",
                     "_translit": "sýnesis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon'-es-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4920"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a mental putting together, i.e. intelligence or\n (concretely) the intellect",
               "kjv_def": ":--knowledge, understanding.",
               "_strongs": "04907"
            },
            {
               "strongs": "4908",
               "greek": [
                  {
                     "_BETA": "SUNETO/S",
                     "_unicode": "συνετός",
                     "_translit": "synetós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-et'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4920"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "mentally put (or putting) together, i.e.\n sagacious",
               "kjv_def": ":--prudent.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5429"
                  }
               ],
               "_strongs": "04908",
               "__text": "Compare \n."
            },
            {
               "strongs": "4909",
               "greek": [
                  {
                     "_BETA": "SUNEUDOKE/W",
                     "_unicode": "συνευδοκέω",
                     "_translit": "syneudokéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-yoo-dok-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2106"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to think well of in common, i.e. assent to, feel\n gratified with",
               "kjv_def": ":--allow, assent, be pleased, have pleasure.",
               "_strongs": "04909"
            },
            {
               "strongs": "4910",
               "greek": [
                  {
                     "_BETA": "SUNEUWXE/W",
                     "_unicode": "συνευωχέω",
                     "_translit": "syneuōchéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-yoo-o-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2095"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and a derivative of a presumed compound of \n and a\n derivative of \n (meaning to be in good condition, i.e. (by\n implication) to fare well, or feast);"
               },
               "strongs_def": "to entertain sumptuously in\n company with, i.e. (middle voice or passive) to revel together",
               "kjv_def": ":--feast\n with.",
               "_strongs": "04910"
            },
            {
               "strongs": "4911",
               "greek": [
                  {
                     "_BETA": "SUNEFI/STHMI",
                     "_unicode": "συνεφίστημι",
                     "_translit": "synephístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ef-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2186"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stand up together, i.e. to resist (or assault)\n jointly",
               "kjv_def": ":--rise up together.",
               "_strongs": "04911"
            },
            {
               "strongs": "4912",
               "greek": [
                  {
                     "_BETA": "SUNE/XW",
                     "_unicode": "συνέχω",
                     "_translit": "synéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hold together, i.e. to compress (the ears, with\n a crowd or siege) or arrest (a prisoner); figuratively, to compel,\n perplex, afflict, preoccupy",
               "kjv_def": ":--constrain, hold, keep in, press, lie\n sick of, stop, be in a strait, straiten, be taken with, throng.",
               "_strongs": "04912"
            },
            {
               "strongs": "4913",
               "greek": [
                  {
                     "_BETA": "SUNH/DOMAI",
                     "_unicode": "συνήδομαι",
                     "_translit": "synḗdomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ay'-dom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2237"
                     }
                  ],
                  "__text": "middle voice from \n and the base of \n;"
               },
               "strongs_def": "to rejoice in with\n oneself, i.e. feel satisfaction concerning",
               "kjv_def": ":--delight.",
               "_strongs": "04913"
            },
            {
               "strongs": "4914",
               "greek": [
                  {
                     "_BETA": "SUNH/QEIA",
                     "_unicode": "συνήθεια",
                     "_translit": "synḗtheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ay'-thi-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2239"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "mutual habituation, i.e.\n usage",
               "kjv_def": ":--custom.",
               "_strongs": "04914"
            },
            {
               "strongs": "4915",
               "greek": [
                  {
                     "_BETA": "SUNHLIKIW/THS",
                     "_unicode": "συνηλικιώτης",
                     "_translit": "synēlikiṓtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ay-lik-ee-o'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2244"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "a co-aged person, i.e. alike in\n years",
               "kjv_def": ":--equal.",
               "_strongs": "04915"
            },
            {
               "strongs": "4916",
               "greek": [
                  {
                     "_BETA": "SUNQA/PTW",
                     "_unicode": "συνθάπτω",
                     "_translit": "syntháptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-thap'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2290"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to inter in company with, i.e. (figuratively) to\n assimilate spiritually (to Christ by a sepulture as to sin)",
               "kjv_def": ":--bury\n with.",
               "_strongs": "04916"
            },
            {
               "strongs": "4917",
               "greek": [
                  {
                     "_BETA": "SUNQLA/W",
                     "_unicode": "συνθλάω",
                     "_translit": "synthláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-thlah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "__text": "from \n and thlao (to crush);"
               },
               "strongs_def": "to dash together, i.e.\n shatter",
               "kjv_def": ":--break.",
               "_strongs": "04917"
            },
            {
               "strongs": "4918",
               "greek": [
                  {
                     "_BETA": "SUNQLI/BW",
                     "_unicode": "συνθλίβω",
                     "_translit": "synthlíbō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-thlee'-bo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2346"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to compress, i.e. crowd on all sides",
               "kjv_def": ":--throng.",
               "_strongs": "04918"
            },
            {
               "strongs": "4919",
               "greek": [
                  {
                     "_BETA": "SUNQRU/PTW",
                     "_unicode": "συνθρύπτω",
                     "_translit": "synthrýptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-throop'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "QRU/PTW",
                        "_unicode": "θρύπτω",
                        "_translit": "thrýptō"
                     }
                  ],
                  "__text": "from \n and \n (to crumble);"
               },
               "strongs_def": "to crush together, i.e.\n (figuratively) to dispirit",
               "kjv_def": ":--break.",
               "_strongs": "04919"
            },
            {
               "strongs": "4920",
               "greek": [
                  {
                     "_BETA": "SUNI/HMI",
                     "_unicode": "συνίημι",
                     "_translit": "syníēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-ee'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "I(/HMI",
                        "_unicode": "ἵημι",
                        "_translit": "híēmi"
                     }
                  ],
                  "__text": "from \n and \n (to send);"
               },
               "strongs_def": "to put together, i.e. (mentally) to\n comprehend; by implication, to act piously",
               "kjv_def": ":-- consider, understand, be\n wise.",
               "_strongs": "04920"
            },
            {
               "strongs": "4921",
               "greek": [
                  {
                     "_BETA": "SUNISTA/W",
                     "_unicode": "συνιστάω",
                     "_translit": "synistáō"
                  },
                  {
                     "_BETA": "SUNISTA/NW",
                     "_unicode": "συνιστάνω",
                     "_translit": "synistánō"
                  },
                  {
                     "_BETA": "SUNI/STHMI",
                     "_unicode": "συνίστημι",
                     "_translit": "synístēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-is-tah'-o"
                  },
                  {
                     "_strongs": "soon-is-tan'-o"
                  },
                  {
                     "_strongs": "soon-is'-tay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from \n and \n (including its collateral forms);"
               },
               "strongs_def": "to set together,\n i.e. (by implication) to introduce (favorably), or (figuratively) to\n exhibit; intransitively, to stand near, or (figuratively) to\n constitute",
               "kjv_def": ":--approve, commend, consist, make, stand (with).",
               "_strongs": "04921",
               "__text": ",   or (strengthened)\n      \n  \n,   or"
            },
            {
               "strongs": "4922",
               "greek": [
                  {
                     "_BETA": "SUNODEU/W",
                     "_unicode": "συνοδεύω",
                     "_translit": "synodeúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-od-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3593"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to travel in company with",
               "kjv_def": ":--journey with.",
               "_strongs": "04922"
            },
            {
               "strongs": "4923",
               "greek": [
                  {
                     "_BETA": "SUNODI/A",
                     "_unicode": "συνοδία",
                     "_translit": "synodía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-od-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3598"
                     }
                  ],
                  "__text": "from a compound of \n and \n (\"synod\");"
               },
               "strongs_def": "companionship on a\n journey, i.e. (by implication), a caravan",
               "kjv_def": ":--company.",
               "_strongs": "04923"
            },
            {
               "strongs": "4924",
               "greek": [
                  {
                     "_BETA": "SUNOIKE/W",
                     "_unicode": "συνοικέω",
                     "_translit": "synoikéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-oy-keh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3611"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to reside together (as a family)",
               "kjv_def": ":--dwell together.",
               "_strongs": "04924"
            },
            {
               "strongs": "4925",
               "greek": [
                  {
                     "_BETA": "SUNOIKODOME/W",
                     "_unicode": "συνοικοδομέω",
                     "_translit": "synoikodoméō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-oy-kod-om-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3618"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to construct, i.e. (passively) to compose (in\n company with other Christians, figuratively)",
               "kjv_def": ":--build together.",
               "_strongs": "04925"
            },
            {
               "strongs": "4926",
               "greek": [
                  {
                     "_BETA": "SUNOMILE/W",
                     "_unicode": "συνομιλέω",
                     "_translit": "synomiléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-om-il-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3656"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to converse mutually",
               "kjv_def": ":--talk with.",
               "_strongs": "04926"
            },
            {
               "strongs": "4927",
               "greek": [
                  {
                     "_BETA": "SUNOMORE/W",
                     "_unicode": "συνομορέω",
                     "_translit": "synomoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-om-or-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3725"
                     }
                  ],
                  "__text": "from \n and a derivative of a compound of the base of 3674 and the\n base of \n;"
               },
               "strongs_def": "to border together, i.e. adjoin",
               "kjv_def": ":--join hard.",
               "_strongs": "04927"
            },
            {
               "strongs": "4928",
               "greek": [
                  {
                     "_BETA": "SUNOXH/",
                     "_unicode": "συνοχή",
                     "_translit": "synochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-okh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4912"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "restraint, i.e. (figuratively) anxiety",
               "kjv_def": ":--anguish, distress.",
               "_strongs": "04928"
            },
            {
               "strongs": "4929",
               "greek": [
                  {
                     "_BETA": "SUNTA/SSW",
                     "_unicode": "συντάσσω",
                     "_translit": "syntássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-tas-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to arrange jointly, i.e. (figuratively) to\n direct",
               "kjv_def": ":--appoint.",
               "_strongs": "04929"
            },
            {
               "strongs": "4930",
               "greek": [
                  {
                     "_BETA": "SUNTE/LEIA",
                     "_unicode": "συντέλεια",
                     "_translit": "syntéleia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-tel'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4931"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "entire completion, i.e. consummation (of a\n dispensation)",
               "kjv_def": ":--end.",
               "_strongs": "04930"
            },
            {
               "strongs": "4931",
               "greek": [
                  {
                     "_BETA": "SUNTELE/W",
                     "_unicode": "συντελέω",
                     "_translit": "synteléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-tel-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5055"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to complete entirely; generally, to execute\n (literally or figuratively)",
               "kjv_def": ":--end, finish, fulfil, make.",
               "_strongs": "04931"
            },
            {
               "strongs": "4932",
               "greek": [
                  {
                     "_BETA": "SUNTE/MNW",
                     "_unicode": "συντέμνω",
                     "_translit": "syntémnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-tem'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5114"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to contract by cutting, i.e.\n (figuratively) do concisely (speedily)",
               "kjv_def": ":--(cut) short.",
               "_strongs": "04932"
            },
            {
               "strongs": "4933",
               "greek": [
                  {
                     "_BETA": "SUNTHRE/W",
                     "_unicode": "συντηρέω",
                     "_translit": "syntēréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-tay-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5083"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to keep closely together, i.e. (by implication) to\n conserve (from ruin); mentally, to remember (and obey)",
               "kjv_def": ":--keep,\n observe, preserve.",
               "_strongs": "04933"
            },
            {
               "strongs": "4934",
               "greek": [
                  {
                     "_BETA": "SUNTI/QEMAI",
                     "_unicode": "συντίθεμαι",
                     "_translit": "syntíthemai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-tith'-em-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to place jointly, i.e. (figuratively)\n to consent (bargain, stipulate), concur",
               "kjv_def": ":--agree, assent, covenant.",
               "_strongs": "04934"
            },
            {
               "strongs": "4935",
               "greek": [
                  {
                     "_BETA": "SUNTO/MWS",
                     "_unicode": "συντόμως",
                     "_translit": "syntómōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-tom'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4932"
                     }
                  ],
                  "__text": "adverb from a derivative of \n;"
               },
               "strongs_def": "concisely (briefly)",
               "kjv_def": ":--a few words.",
               "_strongs": "04935"
            },
            {
               "strongs": "4936",
               "greek": [
                  {
                     "_BETA": "SUNTRE/XW",
                     "_unicode": "συντρέχω",
                     "_translit": "syntréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-trekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to rush together\n (hastily assemble) or headlong (figuratively)",
               "kjv_def": ":--run (together, with).",
               "_strongs": "04936"
            },
            {
               "strongs": "4937",
               "greek": [
                  {
                     "_BETA": "SUNTRI/BW",
                     "_unicode": "συντρίβω",
                     "_translit": "syntríbō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-tree'-bo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5147"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to crush completely, i.e. to shatter\n (literally or figuratively)",
               "kjv_def": ":--break (in pieces), broken to shivers (+\n -hearted), bruise.",
               "_strongs": "04937"
            },
            {
               "strongs": "4938",
               "greek": [
                  {
                     "_BETA": "SU/NTRIMMA",
                     "_unicode": "σύντριμμα",
                     "_translit": "sýntrimma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-trim'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4937"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "concussion or utter fracture (properly, concretely), i.e.\n complete ruin",
               "kjv_def": ":--destruction.",
               "_strongs": "04938"
            },
            {
               "strongs": "4939",
               "greek": [
                  {
                     "_BETA": "SU/NTROFOS",
                     "_unicode": "σύντροφος",
                     "_translit": "sýntrophos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon'-trof-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5162"
                     }
                  ],
                  "__text": "from \n and \n (in a passive sense);"
               },
               "strongs_def": "a fellow-nursling, i.e.\n comrade",
               "kjv_def": ":--brought up with.",
               "_strongs": "04939"
            },
            {
               "strongs": "4940",
               "greek": [
                  {
                     "_BETA": "SUNTUGXA/NW",
                     "_unicode": "συντυγχάνω",
                     "_translit": "syntynchánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-toong-khan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5177"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to chance together, i.e. meet with (reach)",
               "kjv_def": ":--come\n at.",
               "_strongs": "04940"
            },
            {
               "strongs": "4941",
               "greek": [
                  {
                     "_BETA": "*SUNTU/XH",
                     "_unicode": "Συντύχη",
                     "_translit": "Syntýchē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-too'-khay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4940"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an accident; Syntyche, a Christian female",
               "kjv_def": ":--Syntyche.",
               "_strongs": "04941"
            },
            {
               "strongs": "4942",
               "greek": [
                  {
                     "_BETA": "SUNUPOKRI/NOMAI",
                     "_unicode": "συνυποκρίνομαι",
                     "_translit": "synypokrínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-oo-pok-rin'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5271"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to act hypocritically in concert with",
               "kjv_def": ":--dissemble\n with.",
               "_strongs": "04942"
            },
            {
               "strongs": "4943",
               "greek": [
                  {
                     "_BETA": "SUNUPOURGE/W",
                     "_unicode": "συνυπουργέω",
                     "_translit": "synypourgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-oop-oorg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2041"
                     }
                  ],
                  "__text": "from \n and a derivative of a compound of \n and the base of \n;"
               },
               "strongs_def": "to be a co-auxiliary, i.e. assist",
               "kjv_def": ":--help together.",
               "_strongs": "04943"
            },
            {
               "strongs": "4944",
               "greek": [
                  {
                     "_BETA": "SUNWDI/NW",
                     "_unicode": "συνωδίνω",
                     "_translit": "synōdínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-o-dee'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5605"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to have (parturition) pangs in company (concert,\n simultaneously) with, i.e. (figuratively) to sympathize (in\n expectation of relief from suffering)",
               "kjv_def": ":--travail in pain together.",
               "_strongs": "04944"
            },
            {
               "strongs": "4945",
               "greek": [
                  {
                     "_BETA": "SUNWMOSI/A",
                     "_unicode": "συνωμοσία",
                     "_translit": "synōmosía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soon-o-mos-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3660"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a swearing together, i.e. (by\n implication) a plot",
               "kjv_def": ":--comspiracy.",
               "_strongs": "04945"
            },
            {
               "strongs": "4946",
               "greek": [
                  {
                     "_BETA": "*SURA/KOUSAI",
                     "_unicode": "Συράκουσαι",
                     "_translit": "Syrákousai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-rak'-oo-sahee"
                  }
               ],
               "strongs_derivation": "plural of uncertain derivation;",
               "strongs_def": "Syracuse, the capital of\n Sicily",
               "kjv_def": ":--Syracuse.",
               "_strongs": "04946"
            },
            {
               "strongs": "4947",
               "greek": [
                  {
                     "_BETA": "*SURI/A",
                     "_unicode": "Συρία",
                     "_translit": "Syría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06865"
                     }
                  ],
                  "__text": "probably of Hebrew origin (\n);"
               },
               "strongs_def": "Syria (i.e. Tsyria or Tyre), a\n region of Asia",
               "kjv_def": ":--Syria.",
               "_strongs": "04947"
            },
            {
               "strongs": "4948",
               "greek": [
                  {
                     "_BETA": "*SU/ROS",
                     "_unicode": "Σύρος",
                     "_translit": "Sýros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo'-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4947"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a Syran (i.e. probably Tyrian), a native of\n Syria",
               "kjv_def": ":--Syrian.",
               "_strongs": "04948"
            },
            {
               "strongs": "4949",
               "greek": [
                  {
                     "_BETA": "*SUROFOI/NISSA",
                     "_unicode": "Συροφοίνισσα",
                     "_translit": "Syrophoínissa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-rof-oy'-nis-sah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4948"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5403"
                     }
                  ],
                  "__text": "feminine of a compound of \n and the same as \n;"
               },
               "strongs_def": "a Syro-phœnician\n woman, i.e. a female native of Phœnicia in Syria",
               "kjv_def": ":--Syrophenician.",
               "_strongs": "04949"
            },
            {
               "strongs": "4950",
               "greek": [
                  {
                     "_BETA": "SU/RTIS",
                     "_unicode": "σύρτις",
                     "_translit": "sýrtis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soor'-tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4951"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a shoal (from the sand drawn thither by the waves), i.e.\n the Syrtis Major or great bay on the north coast of\n Africa",
               "kjv_def": ":--quicksands.",
               "_strongs": "04950"
            },
            {
               "strongs": "4951",
               "greek": [
                  {
                     "_BETA": "SU/RW",
                     "_unicode": "σύρω",
                     "_translit": "sýrō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo'-ro"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     }
                  ],
                  "__text": "probably akin to \n;"
               },
               "strongs_def": "to trail",
               "kjv_def": ":--drag, draw, hale.",
               "_strongs": "04951"
            },
            {
               "strongs": "4952",
               "greek": [
                  {
                     "_BETA": "SUSPARA/SSW",
                     "_unicode": "συσπαράσσω",
                     "_translit": "sysparássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-par-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4682"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to rend completely, i.e. (by analogy) to convulse\n violently",
               "kjv_def": ":--throw down.",
               "_strongs": "04952"
            },
            {
               "strongs": "4953",
               "greek": [
                  {
                     "_BETA": "SU/SSHMON",
                     "_unicode": "σύσσημον",
                     "_translit": "sýssēmon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos'-say-mon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4591"
                     }
                  ],
                  "__text": "neuter of a compound of \n and the base of \n;"
               },
               "strongs_def": "a sign in common,\n i.e. preconcerted signal",
               "kjv_def": ":--token.",
               "_strongs": "04953"
            },
            {
               "strongs": "4954",
               "greek": [
                  {
                     "_BETA": "SU/SSWMOS",
                     "_unicode": "σύσσωμος",
                     "_translit": "sýssōmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos'-so-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "of a joint body, i.e. (figuratively) a\n fellow-member of the Christian community",
               "kjv_def": ":--of the same body.",
               "_strongs": "04954"
            },
            {
               "strongs": "4955",
               "greek": [
                  {
                     "_BETA": "SUSTASIASTH/S",
                     "_unicode": "συστασιαστής",
                     "_translit": "systasiastḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-tas-ee-as-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4714"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "a\n fellow-insurgent",
               "kjv_def": ":--make insurrection with.",
               "_strongs": "04955"
            },
            {
               "strongs": "4956",
               "greek": [
                  {
                     "_BETA": "SUSTATIKO/S",
                     "_unicode": "συστατικός",
                     "_translit": "systatikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-tat-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4921"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "introductory, i.e. recommendatory",
               "kjv_def": ":--of\n commendation.",
               "_strongs": "04956"
            },
            {
               "strongs": "4957",
               "greek": [
                  {
                     "_BETA": "SUSTAURO/W",
                     "_unicode": "συσταυρόω",
                     "_translit": "systauróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-tow-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4717"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to impale in company with (literally or\n figuratively)",
               "kjv_def": ":--crucify with.",
               "_strongs": "04957"
            },
            {
               "strongs": "4958",
               "greek": [
                  {
                     "_BETA": "SUSTE/LLW",
                     "_unicode": "συστέλλω",
                     "_translit": "systéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-tel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4724"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to send (draw) together, i.e. enwrap (enshroud a\n corpse for burial), contract (an interval)",
               "kjv_def": ":-- short, wind up.",
               "_strongs": "04958"
            },
            {
               "strongs": "4959",
               "greek": [
                  {
                     "_BETA": "SUSTENA/ZW",
                     "_unicode": "συστενάζω",
                     "_translit": "systenázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-ten-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4727"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to moan jointly, i.e. (figuratively) experience a\n common calamity",
               "kjv_def": ":--groan together.",
               "_strongs": "04959"
            },
            {
               "strongs": "4960",
               "greek": [
                  {
                     "_BETA": "SUSTOIXE/W",
                     "_unicode": "συστοιχέω",
                     "_translit": "systoichéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-toy-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4748"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to file together (as soldiers in ranks), i.e.\n (figuratively) to correspond to",
               "kjv_def": ":--answer to.",
               "_strongs": "04960"
            },
            {
               "strongs": "4961",
               "greek": [
                  {
                     "_BETA": "SUSTRATIW/THS",
                     "_unicode": "συστρατιώτης",
                     "_translit": "systratiṓtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-trat-ee-o'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4757"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a co-campaigner, i.e. (figuratively) an associate\n in Christian toil",
               "kjv_def": ":--fellowsoldier.",
               "_strongs": "04961"
            },
            {
               "strongs": "4962",
               "greek": [
                  {
                     "_BETA": "SUSTRE/FW",
                     "_unicode": "συστρέφω",
                     "_translit": "systréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to twist together, i.e. collect (a bundle, a\n crowd)",
               "kjv_def": ":--gather.",
               "_strongs": "04962"
            },
            {
               "strongs": "4963",
               "greek": [
                  {
                     "_BETA": "SUSTROFH/",
                     "_unicode": "συστροφή",
                     "_translit": "systrophḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-trof-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4962"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a twisting together, i.e. (figuratively) a secret\n coalition, riotous crowd",
               "kjv_def": ":--+ band together, concourse.",
               "_strongs": "04963"
            },
            {
               "strongs": "4964",
               "greek": [
                  {
                     "_BETA": "SUSXHMATI/ZW",
                     "_unicode": "συσχηματίζω",
                     "_translit": "syschēmatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soos-khay-mat-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4862"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4976"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to fashion alike, i.e. conform to\n the same pattern (figuratively)",
               "kjv_def": ":--conform to, fashion self according\n to.",
               "_strongs": "04964"
            },
            {
               "strongs": "4965",
               "greek": [
                  {
                     "_BETA": "*SUXA/R",
                     "_unicode": "Συχάρ",
                     "_translit": "Sychár"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-khar'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07941"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sychar (i.e. Shekar), a place in\n Palestine",
               "kjv_def": ":--Sychar.",
               "_strongs": "04965"
            },
            {
               "strongs": "4966",
               "greek": [
                  {
                     "_BETA": "*SUXE/M",
                     "_unicode": "Συχέμ",
                     "_translit": "Sychém"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soo-khem'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "07927"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Sychem (i.e. Shekem), the name of a Canaanite\n and of a place in Palestine",
               "kjv_def": ":--Sychem.",
               "_strongs": "04966"
            },
            {
               "strongs": "4967",
               "greek": [
                  {
                     "_BETA": "SFAGH/",
                     "_unicode": "σφαγή",
                     "_translit": "sphagḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sfag-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4969"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "butchery (of animals for food or sacrifice, or\n (figuratively) of men (destruction))",
               "kjv_def": ":--slaughter.",
               "_strongs": "04967"
            },
            {
               "strongs": "4968",
               "greek": [
                  {
                     "_BETA": "SFA/GION",
                     "_unicode": "σφάγιον",
                     "_translit": "sphágion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sfag'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4967"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "a victim (in sacrifice)",
               "kjv_def": ":--slain beast.",
               "_strongs": "04968"
            },
            {
               "strongs": "4969",
               "greek": [
                  {
                     "_BETA": "SFA/ZW",
                     "_unicode": "σφάζω",
                     "_translit": "spházō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sfad'-zo"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to butcher (especially an animal for food or in\n sacrifice) or (generally) to slaughter, or (specially), to maim\n (violently)",
               "kjv_def": ":--kill, slay, wound.",
               "_strongs": "04969"
            },
            {
               "strongs": "4970",
               "greek": [
                  {
                     "_BETA": "SFO/DRA",
                     "_unicode": "σφόδρα",
                     "_translit": "sphódra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sfod'-rah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SFODRO/S",
                        "_unicode": "σφοδρός",
                        "_translit": "sphodrós"
                     }
                  ],
                  "__text": "neuter plural of \n (violent;"
               },
               "strongs_def": "of uncertain derivation) as\n adverb; vehemently, i.e. in a high degree, much",
               "kjv_def": ":-- exceeding(-ly),\n greatly, sore, very.",
               "_strongs": "04970"
            },
            {
               "strongs": "4971",
               "greek": [
                  {
                     "_BETA": "SFODRW=S",
                     "_unicode": "σφοδρῶς",
                     "_translit": "sphodrōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sfod-roce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4970"
                     }
                  ],
                  "__text": "adverb from the same as \n;"
               },
               "strongs_def": "very much",
               "kjv_def": ":--exceedingly.",
               "_strongs": "04971"
            },
            {
               "strongs": "4972",
               "greek": [
                  {
                     "_BETA": "SFRAGI/ZW",
                     "_unicode": "σφραγίζω",
                     "_translit": "sphragízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sfrag-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4973"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to stamp (with a signet or private mark) for security or\n preservation (literally or figuratively); by implication, to keep\n secret, to attest",
               "kjv_def": ":--(set a, set to) seal up, stop.",
               "_strongs": "04972"
            },
            {
               "strongs": "4973",
               "greek": [
                  {
                     "_BETA": "SFRAGI/S",
                     "_unicode": "σφραγίς",
                     "_translit": "sphragís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sfrag-ece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5420"
                     }
                  ],
                  "__text": "probably strengthened from \n;"
               },
               "strongs_def": "a signet (as fencing in or protecting\n from misappropriation); by implication, the stamp impressed (as a mark\n of privacy, or genuineness), literally or figuratively",
               "kjv_def": ":--seal.",
               "_strongs": "04973"
            },
            {
               "strongs": "4974",
               "greek": [
                  {
                     "_BETA": "SFURO/N",
                     "_unicode": "σφυρόν",
                     "_translit": "sphyrón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sfoo-ron'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SFAI=RA",
                        "_unicode": "σφαῖρα",
                        "_translit": "sphaîra"
                     },
                     {
                        "_BETA": "SFU=RA",
                        "_unicode": "σφῦρα",
                        "_translit": "sphŷra"
                     }
                  ],
                  "__text": "neuter of a presumed derivative probably of the same as\n \n (a ball, \"sphere\"; compare the feminine \n, a\n hammer);"
               },
               "strongs_def": "the ankle (as globular)",
               "kjv_def": ":--ancle bone.",
               "_strongs": "04974"
            },
            {
               "strongs": "4975",
               "greek": [
                  {
                     "_BETA": "SXEDO/N",
                     "_unicode": "σχεδόν",
                     "_translit": "schedón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skhed-on'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of the alternate of \n as adverb;"
               },
               "strongs_def": "nigh, i.e. nearly",
               "kjv_def": ":--almost.",
               "_strongs": "04975"
            },
            {
               "strongs": "4976",
               "greek": [
                  {
                     "_BETA": "SXH=MA",
                     "_unicode": "σχῆμα",
                     "_translit": "schēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skhay'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from the alternate of \n;"
               },
               "strongs_def": "a figure (as a mode or circumstance), i.e.\n (by implication) external condition",
               "kjv_def": ":--fashion.",
               "_strongs": "04976"
            },
            {
               "strongs": "4977",
               "greek": [
                  {
                     "_BETA": "SXI/ZW",
                     "_unicode": "σχίζω",
                     "_translit": "schízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skhid'-zo"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to split or sever (literally or\n figuratively)",
               "kjv_def": ":--break, divide, open, rend, make a rent.",
               "_strongs": "04977"
            },
            {
               "strongs": "4978",
               "greek": [
                  {
                     "_BETA": "SXI/SMA",
                     "_unicode": "σχίσμα",
                     "_translit": "schísma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skhis'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4977"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a split or gap (\"schism\"), literally or\n figuratively",
               "kjv_def": ":--division, rent, schism.",
               "_strongs": "04978"
            },
            {
               "strongs": "4979",
               "greek": [
                  {
                     "_BETA": "SXOINI/ON",
                     "_unicode": "σχοινίον",
                     "_translit": "schoiníon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skhoy-nee'-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SXOI=NOS",
                        "_unicode": "σχοῖνος",
                        "_translit": "schoînos"
                     }
                  ],
                  "__text": "diminutive of \n (a rush or flag-plant;"
               },
               "strongs_def": "of uncertain\n derivation); a rushlet, i.e. grass-withe or tie (generally)",
               "kjv_def": ":--small\n cord, rope.",
               "_strongs": "04979"
            },
            {
               "strongs": "4980",
               "greek": [
                  {
                     "_BETA": "SXOLA/ZW",
                     "_unicode": "σχολάζω",
                     "_translit": "scholázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skhol-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4981"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to take a holiday, i.e. be at leisure for (by implication,\n devote oneself wholly to); figuratively, to be vacant (of a\n house)",
               "kjv_def": ":--empty, give self.",
               "_strongs": "04980"
            },
            {
               "strongs": "4981",
               "greek": [
                  {
                     "_BETA": "SXOLH/",
                     "_unicode": "σχολή",
                     "_translit": "scholḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "skhol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "probably feminine of a presumed derivative of the alternate of \n;"
               },
               "strongs_def": "properly, loitering (as a withholding of oneself from work) or\n leisure, i.e. (by implication) a \"school\" (as vacation from physical\n employment)",
               "kjv_def": ":--school.",
               "_strongs": "04981"
            },
            {
               "strongs": "4982",
               "greek": [
                  {
                     "_BETA": "SW/ZW",
                     "_unicode": "σώζω",
                     "_translit": "sṓzō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sode'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "SW=S",
                        "_unicode": "σῶς",
                        "_translit": "sōs"
                     },
                     {
                        "_BETA": "SA/OS",
                        "_unicode": "σάος",
                        "_translit": "sáos"
                     }
                  ],
                  "__text": "from a primary \n (contraction for obsolete \n, \"safe\");"
               },
               "strongs_def": "to save,\n i.e. deliver or protect (literally or figuratively)",
               "kjv_def": ":--heal, preserve,\n save (self), do well, be (make) whole.",
               "_strongs": "04982"
            },
            {
               "strongs": "4983",
               "greek": [
                  {
                     "_BETA": "SW=MA",
                     "_unicode": "σῶμα",
                     "_translit": "sōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4982"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "the body (as a sound whole), used in a very wide\n application, literally or figuratively",
               "kjv_def": ":--bodily, body, slave.",
               "_strongs": "04983"
            },
            {
               "strongs": "4984",
               "greek": [
                  {
                     "_BETA": "SWMATIKO/S",
                     "_unicode": "σωματικός",
                     "_translit": "sōmatikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-mat-ee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4983"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "corporeal or physical",
               "kjv_def": ":--bodily.",
               "_strongs": "04984"
            },
            {
               "strongs": "4985",
               "greek": [
                  {
                     "_BETA": "SWMATIKW=S",
                     "_unicode": "σωματικῶς",
                     "_translit": "sōmatikōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-mat-ee-koce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4984"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "corporeally or physically",
               "kjv_def": ":--bodily.",
               "_strongs": "04985"
            },
            {
               "strongs": "4986",
               "greek": [
                  {
                     "_BETA": "*SW/PATROS",
                     "_unicode": "Σώπατρος",
                     "_translit": "Sṓpatros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so'-pat-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4982"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3962"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "of a safe father; Sopatrus, a\n Christian",
               "kjv_def": ":--Sopater.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "4989"
                  }
               ],
               "_strongs": "04986",
               "__text": "Compare \n."
            },
            {
               "strongs": "4987",
               "greek": [
                  {
                     "_BETA": "SWREU/W",
                     "_unicode": "σωρεύω",
                     "_translit": "sōreúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "sore-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4673"
                     }
                  ],
                  "__text": "from another form of \n;"
               },
               "strongs_def": "to pile up (literally or\n figuratively)",
               "kjv_def": ":--heap, load.",
               "_strongs": "04987"
            },
            {
               "strongs": "4988",
               "greek": [
                  {
                     "_BETA": "*SWSQE/NHS",
                     "_unicode": "Σωσθένης",
                     "_translit": "Sōsthénēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "soce-then'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4982"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4599"
                     }
                  ],
                  "__text": "from the base of \n and that of \n;"
               },
               "strongs_def": "of safe strength; Sosthenes, a\n Christian",
               "kjv_def": ":--Sosthenes.",
               "_strongs": "04988"
            },
            {
               "strongs": "4989",
               "greek": [
                  {
                     "_BETA": "*SWSI/PATROS",
                     "_unicode": "Σωσίπατρος",
                     "_translit": "Sōsípatros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-sip'-at-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4986"
                     }
                  ],
                  "__text": "prolongation for \n;"
               },
               "strongs_def": "Sosipatrus, a Christian",
               "kjv_def": ":--Sosipater.",
               "_strongs": "04989"
            },
            {
               "strongs": "4990",
               "greek": [
                  {
                     "_BETA": "SWTH/R",
                     "_unicode": "σωτήρ",
                     "_translit": "sōtḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-tare'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4982"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deliverer, i.e. God or Christ",
               "kjv_def": ":--saviour.",
               "_strongs": "04990"
            },
            {
               "strongs": "4991",
               "greek": [
                  {
                     "_BETA": "SWTHRI/A",
                     "_unicode": "σωτηρία",
                     "_translit": "sōtēría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-tay-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4990"
                     }
                  ],
                  "__text": "feminine of a derivative of \n as (properly, abstract) noun;"
               },
               "strongs_def": "rescue\n or safety (physically or morally)",
               "kjv_def": ":--deliver, health, salvation, save,\n saving.",
               "_strongs": "04991"
            },
            {
               "strongs": "4992",
               "greek": [
                  {
                     "_BETA": "SWTH/RION",
                     "_unicode": "σωτήριον",
                     "_translit": "sōtḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4991"
                     }
                  ],
                  "__text": "neuter of the same as \n as (properly, concretely) noun;"
               },
               "strongs_def": "defender or\n (by implication) defence",
               "kjv_def": ":--salvation.",
               "_strongs": "04992"
            },
            {
               "strongs": "4993",
               "greek": [
                  {
                     "_BETA": "SWFRONE/W",
                     "_unicode": "σωφρονέω",
                     "_translit": "sōphronéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-fron-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4998"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be of sound mind, i.e. sane, (figuratively)\n moderate",
               "kjv_def": ":--be in right mind, be sober (minded), soberly.",
               "_strongs": "04993"
            },
            {
               "strongs": "4994",
               "greek": [
                  {
                     "_BETA": "SWFRONI/ZW",
                     "_unicode": "σωφρονίζω",
                     "_translit": "sōphronízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-fron-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4998"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make of sound mind, i.e. (figuratively) to discipline or\n correct",
               "kjv_def": ":--teach to be sober.",
               "_strongs": "04994"
            },
            {
               "strongs": "4995",
               "greek": [
                  {
                     "_BETA": "SWFRONISMO/S",
                     "_unicode": "σωφρονισμός",
                     "_translit": "sōphronismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-fron-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4994"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "discipline, i.e. self-control",
               "kjv_def": ":--sound mind.",
               "_strongs": "04995"
            },
            {
               "strongs": "4996",
               "greek": [
                  {
                     "_BETA": "SWFRO/NWS",
                     "_unicode": "σωφρόνως",
                     "_translit": "sōphrónōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-fron'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4998"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "with sound mind, i.e. moderately",
               "kjv_def": ":--soberly.",
               "_strongs": "04996"
            },
            {
               "strongs": "4997",
               "greek": [
                  {
                     "_BETA": "SWFROSU/NH",
                     "_unicode": "σωφροσύνη",
                     "_translit": "sōphrosýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so-fros-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4998"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "soundness of mind, i.e. (literally) sanity or\n (figuratively) self-control",
               "kjv_def": ":--soberness, sobriety.",
               "_strongs": "04997"
            },
            {
               "strongs": "4998",
               "greek": [
                  {
                     "_BETA": "SW/FRWN",
                     "_unicode": "σώφρων",
                     "_translit": "sṓphrōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "so'-frone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4982"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from the base of \n and that of \n;"
               },
               "strongs_def": "safe (sound) in mind, i.e.\n self-controlled (moderate as to opinion or passion)",
               "kjv_def": ":--discreet, sober,\n temperate.",
               "_strongs": "04998"
            },
            {
               "strongs": "4999",
               "greek": [
                  {
                     "_BETA": "*TABE/RNAI",
                     "_unicode": "Ταβέρναι",
                     "_translit": "Tabérnai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tab-er'-nahee"
                  }
               ],
               "strongs_derivation": "plural of Latin origin;",
               "strongs_def": "huts or wooden-walled buildings;\n Tabernæ",
               "kjv_def": ":--taverns.",
               "_strongs": "04999"
            },
            {
               "strongs": "5000",
               "greek": [
                  {
                     "_BETA": "*TABIQA/",
                     "_unicode": "Ταβιθά",
                     "_translit": "Tabithá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tab-ee-thah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06646"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "the gazelle; Tabitha (i.e.\n Tabjetha), a Christian female",
               "kjv_def": ":--Tabitha.",
               "_strongs": "05000"
            },
            {
               "strongs": "5001",
               "greek": [
                  {
                     "_BETA": "TA/GMA",
                     "_unicode": "τάγμα",
                     "_translit": "tágma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tag'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something orderly in arrangement (a troop), i.e.\n (figuratively) a series or succession",
               "kjv_def": ":--order.",
               "_strongs": "05001"
            },
            {
               "strongs": "5002",
               "greek": [
                  {
                     "_BETA": "TAKTO/S",
                     "_unicode": "τακτός",
                     "_translit": "taktós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tak-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "arranged, i.e. appointed or stated",
               "kjv_def": ":--set.",
               "_strongs": "05002"
            },
            {
               "strongs": "5003",
               "greek": [
                  {
                     "_BETA": "TALAIPWRE/W",
                     "_unicode": "ταλαιπωρέω",
                     "_translit": "talaipōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tal-ahee-po-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5005"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be wretched, i.e. realize one's own misery",
               "kjv_def": ":--be\n afflicted.",
               "_strongs": "05003"
            },
            {
               "strongs": "5004",
               "greek": [
                  {
                     "_BETA": "TALAIPWRI/A",
                     "_unicode": "ταλαιπωρία",
                     "_translit": "talaipōría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tal-ahee-po-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5005"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "wretchedness, i.e. calamity",
               "kjv_def": ":--misery.",
               "_strongs": "05004"
            },
            {
               "strongs": "5005",
               "greek": [
                  {
                     "_BETA": "TALAI/PWROS",
                     "_unicode": "ταλαίπωρος",
                     "_translit": "talaípōros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tal-ah'-ee-po-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5007"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3984"
                     }
                  ],
                  "__text": "from the base of \n and a derivative of the base of \n;"
               },
               "strongs_def": "enduring\n trial, i.e. miserable",
               "kjv_def": ":--wretched.",
               "_strongs": "05005"
            },
            {
               "strongs": "5006",
               "greek": [
                  {
                     "_BETA": "TALANTIAI=OS",
                     "_unicode": "ταλαντιαῖος",
                     "_translit": "talantiaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tal-an-tee-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5007"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "talent-like in weight",
               "kjv_def": ":--weight of a talent.",
               "_strongs": "05006"
            },
            {
               "strongs": "5007",
               "greek": [
                  {
                     "_BETA": "TA/LANTON",
                     "_unicode": "τάλαντον",
                     "_translit": "tálanton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tal'-an-ton"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TLA/W",
                        "_unicode": "τλάω",
                        "_translit": "tláō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of the original form of \n (to bear;\n equivalent to \n);"
               },
               "strongs_def": "a balance (as supporting weights), i.e. (by\n implication) a certain weight (and thence a coin or rather sum of\n money) or \"talent\"",
               "kjv_def": ":--talent.",
               "_strongs": "05007"
            },
            {
               "strongs": "5008",
               "greek": [
                  {
                     "_BETA": "TALIQA/",
                     "_unicode": "ταλιθά",
                     "_translit": "talithá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tal-ee-thah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02924"
                     }
                  ],
                  "__text": "of Chaldee origin (compare \n);"
               },
               "strongs_def": "the fresh, i.e. young girl; talitha\n (O maiden)",
               "kjv_def": ":--talitha.",
               "_strongs": "05008"
            },
            {
               "strongs": "5009",
               "greek": [
                  {
                     "_BETA": "TAMEI=ON",
                     "_unicode": "ταμεῖον",
                     "_translit": "tameîon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tam-i'-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TAMI/AS",
                        "_unicode": "ταμίας",
                        "_translit": "tamías"
                     },
                     {
                        "_BETA": "TE/MNW",
                        "_unicode": "τέμνω",
                        "_translit": "témnō"
                     }
                  ],
                  "__text": "neuter contraction of a presumed derivative of \n (a dispenser or\n distributor; akin to \n, to cut);"
               },
               "strongs_def": "a dispensary or magazine, i.e. a\n chamber on the ground-floor or interior of an Oriental house\n (generally used for storage or privacy, a spot for\n retirement)",
               "kjv_def": ":--secret chamber, closet, storehouse.",
               "_strongs": "05009"
            },
            {
               "strongs": "5010",
               "greek": [
                  {
                     "_BETA": "TA/CIS",
                     "_unicode": "τάξις",
                     "_translit": "táxis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tax'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "regular arrangement, i.e. (in time) fixed succession (of\n rank or character), official dignity",
               "kjv_def": ":--order.",
               "_strongs": "05010"
            },
            {
               "strongs": "5011",
               "greek": [
                  {
                     "_BETA": "TAPEINO/S",
                     "_unicode": "ταπεινός",
                     "_translit": "tapeinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tap-i-nos'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "depressed, i.e. (figuratively) humiliated (in\n circumstances or disposition)",
               "kjv_def": ":--base, cast down, humble, of low degree\n (estate), lowly.",
               "_strongs": "05011"
            },
            {
               "strongs": "5012",
               "greek": [
                  {
                     "_BETA": "TAPEINOFROSU/NH",
                     "_unicode": "ταπεινοφροσύνη",
                     "_translit": "tapeinophrosýnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tap-i-nof-ros-oo'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5011"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n;"
               },
               "strongs_def": "humiliation of mind,\n i.e. modesty",
               "kjv_def": ":--humbleness of mind, humility (of mind, loneliness (of\n mind).",
               "_strongs": "05012"
            },
            {
               "strongs": "5013",
               "greek": [
                  {
                     "_BETA": "TAPEINO/W",
                     "_unicode": "ταπεινόω",
                     "_translit": "tapeinóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tap-i-no'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5011"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to depress; figuratively, to humiliate (in condition or\n heart)",
               "kjv_def": ":--abase, bring low, humble (self).",
               "_strongs": "05013"
            },
            {
               "strongs": "5014",
               "greek": [
                  {
                     "_BETA": "TAPEI/NWSIS",
                     "_unicode": "ταπείνωσις",
                     "_translit": "tapeínōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tap-i'-no-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5013"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "depression (in rank or feeling)",
               "kjv_def": ":--humiliation, be made low,\n low estate, vile.",
               "_strongs": "05014"
            },
            {
               "strongs": "5015",
               "greek": [
                  {
                     "_BETA": "TARA/SSW",
                     "_unicode": "ταράσσω",
                     "_translit": "tarássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tar-as'-so"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to stir or agitate (roil water)",
               "kjv_def": ":--trouble.",
               "_strongs": "05015"
            },
            {
               "strongs": "5016",
               "greek": [
                  {
                     "_BETA": "TARAXH/",
                     "_unicode": "ταραχή",
                     "_translit": "tarachḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tar-akh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5015"
                     }
                  ],
                  "__text": "feminine from \n;"
               },
               "strongs_def": "disturbance, i.e. (of water) roiling, or (of a\n mob) sedition",
               "kjv_def": ":--trouble(-ing).",
               "_strongs": "05016"
            },
            {
               "strongs": "5017",
               "greek": [
                  {
                     "_BETA": "TA/RAXOS",
                     "_unicode": "τάραχος",
                     "_translit": "tárachos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tar'-akh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5015"
                     }
                  ],
                  "__text": "masculine from \n;"
               },
               "strongs_def": "a disturbance, i.e. (popular) tumult",
               "kjv_def": ":--stir.",
               "_strongs": "05017"
            },
            {
               "strongs": "5018",
               "greek": [
                  {
                     "_BETA": "*TARSEU/S",
                     "_unicode": "Ταρσεύς",
                     "_translit": "Tarseús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tar-syoos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5019"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Tarsean, i.e. native of Tarsus",
               "kjv_def": ":--of Tarsus.",
               "_strongs": "05018"
            },
            {
               "strongs": "5019",
               "greek": [
                  {
                     "_BETA": "*TARSO/S",
                     "_unicode": "Ταρσός",
                     "_translit": "Tarsós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tar-sos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TARSO/S",
                        "_unicode": "ταρσός",
                        "_translit": "tarsós"
                     }
                  ],
                  "__text": "perhaps the same as \n (a flat basket);"
               },
               "strongs_def": "Tarsus, a place in Asia\n Minor",
               "kjv_def": ":--Tarsus.",
               "_strongs": "05019"
            },
            {
               "strongs": "5020",
               "greek": [
                  {
                     "_BETA": "TARTARO/W",
                     "_unicode": "ταρταρόω",
                     "_translit": "tartaróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tar-tar-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*TA/RTAROS",
                        "_unicode": "Τάρταρος",
                        "_translit": "Tártaros"
                     }
                  ],
                  "__text": "from \n (the deepest abyss of Hades);"
               },
               "strongs_def": "to incarcerate in eternal\n torment",
               "kjv_def": ":--cast down to hell.",
               "_strongs": "05020"
            },
            {
               "strongs": "5021",
               "greek": [
                  {
                     "_BETA": "TA/SSW",
                     "_unicode": "τάσσω",
                     "_translit": "tássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tas'-so"
                  }
               ],
               "strongs_derivation": "a prolonged form of a primary verb (which latter appears only in\n certain tenses);",
               "strongs_def": "to arrange in an orderly manner, i.e. assign or\n dispose (to a certain position or lot)",
               "kjv_def": ":--addict, appoint, determine,\n ordain, set.",
               "_strongs": "05021"
            },
            {
               "strongs": "5022",
               "greek": [
                  {
                     "_BETA": "TAU=ROS",
                     "_unicode": "ταῦρος",
                     "_translit": "taûros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tow'-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "08450"
                     }
                  ],
                  "__text": "apparently a primary word (compare \n, \"steer\");"
               },
               "strongs_def": "a bullock",
               "kjv_def": ":--bull,\n ox.",
               "_strongs": "05022"
            },
            {
               "strongs": "5023",
               "greek": [
                  {
                     "_BETA": "TAU=TA",
                     "_unicode": "ταῦτα",
                     "_translit": "taûta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tow'-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "nominative or accusative case neuter plural of \n;"
               },
               "strongs_def": "these things",
               "kjv_def": ":--+\n afterward, follow, + hereafter, X him, the same, so, such, that, then,\n these, they, this, those, thus.",
               "_strongs": "05023"
            },
            {
               "strongs": "5024",
               "greek": [
                  {
                     "_BETA": "TAU)TA/",
                     "_unicode": "ταὐτά",
                     "_translit": "tautá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tow-tah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "__text": "neuter plural of \n and \n as adverb;"
               },
               "strongs_def": "in the same way",
               "kjv_def": ":--even thus,\n (manner) like, so.",
               "_strongs": "05024"
            },
            {
               "strongs": "5025",
               "greek": [
                  {
                     "_BETA": "TAU/TAIS",
                     "_unicode": "ταύταις",
                     "_translit": "taútais"
                  },
                  {
                     "_BETA": "TAU/TAS",
                     "_unicode": "ταύτας",
                     "_translit": "taútas"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tow'-taheece"
                  },
                  {
                     "_strongs": "tow'-tas"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "dative case and accusative case feminine plural respectively of \n;"
               },
               "strongs_def": "(to or with or by, etc.) these",
               "kjv_def": ":--hence, that, then, these, those.",
               "_strongs": "05025",
               "__text": ", and"
            },
            {
               "strongs": "5026",
               "greek": [
                  {
                     "_BETA": "TAU/TH|",
                     "_unicode": "ταύτῃ",
                     "_translit": "taútēi"
                  },
                  {
                     "_BETA": "TAU/THN",
                     "_unicode": "ταύτην",
                     "_translit": "taútēn"
                  },
                  {
                     "_BETA": "TAU/THS",
                     "_unicode": "ταύτης",
                     "_translit": "taútēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tow'-tay"
                  },
                  {
                     "_strongs": "tow'-tane"
                  },
                  {
                     "_strongs": "tow'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "dative case, accusative case and genitive case respectively of the\n feminine singular of \n;"
               },
               "strongs_def": "(towards or of) this",
               "kjv_def": ":--her,\n + hereof, it, that, + thereby, the (same), this (same).",
               "_strongs": "05026",
               "__text": ",  and\n      \n  \n, and"
            },
            {
               "strongs": "5027",
               "greek": [
                  {
                     "_BETA": "TAFH/",
                     "_unicode": "ταφή",
                     "_translit": "taphḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "taf-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2290"
                     }
                  ],
                  "__text": "feminine from \n;"
               },
               "strongs_def": "burial (the act)",
               "kjv_def": ":--X bury.",
               "_strongs": "05027"
            },
            {
               "strongs": "5028",
               "greek": [
                  {
                     "_BETA": "TA/FOS",
                     "_unicode": "τάφος",
                     "_translit": "táphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "taf'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2290"
                     }
                  ],
                  "__text": "masculine from \n;"
               },
               "strongs_def": "a grave (the place of interment)",
               "kjv_def": ":--sepulchre,\n tomb.",
               "_strongs": "05028"
            },
            {
               "strongs": "5029",
               "greek": [
                  {
                     "_BETA": "TA/XA",
                     "_unicode": "τάχα",
                     "_translit": "tácha"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "takh'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5036"
                     }
                  ],
                  "__text": "as if neuter plural of \n (adverbially);"
               },
               "strongs_def": "shortly, i.e.\n (figuratively) possibly",
               "kjv_def": ":--peradventure(-haps).",
               "_strongs": "05029"
            },
            {
               "strongs": "5030",
               "greek": [
                  {
                     "_BETA": "TAXE/WS",
                     "_unicode": "ταχέως",
                     "_translit": "tachéōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "takh-eh'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5036"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "briefly, i.e. (in time) speedily, or (in manner)\n rapidly",
               "kjv_def": ":--hastily, quickly, shortly, soon, suddenly.",
               "_strongs": "05030"
            },
            {
               "strongs": "5031",
               "greek": [
                  {
                     "_BETA": "TAXINO/S",
                     "_unicode": "ταχινός",
                     "_translit": "tachinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "takh-ee-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5034"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "curt, i.e. impending",
               "kjv_def": ":--shortly, swift.",
               "_strongs": "05031"
            },
            {
               "strongs": "5032",
               "greek": [
                  {
                     "_BETA": "TA/XION",
                     "_unicode": "τάχιον",
                     "_translit": "táchion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "takh'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5036"
                     }
                  ],
                  "__text": "neuter singular of the comparative of \n (as adverb);"
               },
               "strongs_def": "more swiftly,\n i.e. (in manner) more rapidly, or (in time) more speedily",
               "kjv_def": ":--out (run),\n quickly, shortly, sooner.",
               "_strongs": "05032"
            },
            {
               "strongs": "5033",
               "greek": [
                  {
                     "_BETA": "TA/XISTA",
                     "_unicode": "τάχιστα",
                     "_translit": "táchista"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "takh'-is-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5036"
                     }
                  ],
                  "__text": "neuter plural of the superlative of \n (as adverb);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5613"
                     }
                  ],
                  "__text": "most quickly,\n i.e. (with \n prefixed) as soon as possible"
               },
               "kjv_def": ":--+ with all speed.",
               "_strongs": "05033"
            },
            {
               "strongs": "5034",
               "greek": [
                  {
                     "_BETA": "TA/XOS",
                     "_unicode": "τάχος",
                     "_translit": "táchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "takh'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5036"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1722"
                     }
                  ],
                  "__text": "a brief space (of time), i.e. (with \n\n prefixed) in haste"
               },
               "kjv_def": ":--+ quickly, + shortly, + speedily.",
               "_strongs": "05034"
            },
            {
               "strongs": "5035",
               "greek": [
                  {
                     "_BETA": "TAXU/",
                     "_unicode": "ταχύ",
                     "_translit": "tachý"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "takh-oo'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5036"
                     }
                  ],
                  "__text": "neuter singular of \n (as adverb);"
               },
               "strongs_def": "shortly, i.e. without delay,\n soon, or (by surprise) suddenly, or (by implication, of ease)\n readily",
               "kjv_def": ":--lightly, quickly.",
               "_strongs": "05035"
            },
            {
               "strongs": "5036",
               "greek": [
                  {
                     "_BETA": "TAXU/S",
                     "_unicode": "ταχύς",
                     "_translit": "tachýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "takh-oos'"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "fleet, i.e. (figuratively) prompt or\n ready",
               "kjv_def": ":--swift.",
               "_strongs": "05036"
            },
            {
               "strongs": "5037",
               "greek": [
                  {
                     "_BETA": "TE/",
                     "_unicode": "τέ",
                     "_translit": "té"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "teh"
                  }
               ],
               "strongs_derivation": "a primary particle (enclitic) of connection or addition;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     }
                  ],
                  "__text": "both or also\n (properly, as correlation of \n)"
               },
               "kjv_def": ":--also, and, both, even, then,\n whether.",
               "_strongs": "05037",
               "__text": "Often used in composition, usually as the latter particle."
            },
            {
               "strongs": "5038",
               "greek": [
                  {
                     "_BETA": "TEI=XOS",
                     "_unicode": "τεῖχος",
                     "_translit": "teîchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ti'-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5088"
                     }
                  ],
                  "__text": "akin to the base of \n;"
               },
               "strongs_def": "a wall (as formative of a house)",
               "kjv_def": ":--wall.",
               "_strongs": "05038"
            },
            {
               "strongs": "5039",
               "greek": [
                  {
                     "_BETA": "TEKMH/RION",
                     "_unicode": "τεκμήριον",
                     "_translit": "tekmḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tek-may'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TEKMA/R",
                        "_unicode": "τεκμάρ",
                        "_translit": "tekmár"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n (a goal or fixed limit);"
               },
               "strongs_def": "a\n token (as defining a fact), i.e. criterion of certainty",
               "kjv_def": ":--infallible\n proof.",
               "_strongs": "05039"
            },
            {
               "strongs": "5040",
               "greek": [
                  {
                     "_BETA": "TEKNI/ON",
                     "_unicode": "τεκνίον",
                     "_translit": "tekníon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tek-nee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5043"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "an infant, i.e. (plural figuratively) darlings\n (Christian converts)",
               "kjv_def": ":--little children.",
               "_strongs": "05040"
            },
            {
               "strongs": "5041",
               "greek": [
                  {
                     "_BETA": "TEKNOGONE/W",
                     "_unicode": "τεκνογονέω",
                     "_translit": "teknogonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tek-nog-on-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5043"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1096"
                     }
                  ],
                  "__text": "from a compound of \n and the base of \n;"
               },
               "strongs_def": "to be a child-bearer,\n i.e. parent (mother)",
               "kjv_def": ":--bear children.",
               "_strongs": "05041"
            },
            {
               "strongs": "5042",
               "greek": [
                  {
                     "_BETA": "TEKNOGONI/A",
                     "_unicode": "τεκνογονία",
                     "_translit": "teknogonía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tek-nog-on-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5041"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "childbirth (parentage), i.e. (by implication)\n maternity (the performance of maternal duties)",
               "kjv_def": ":--childbearing.",
               "_strongs": "05042"
            },
            {
               "strongs": "5043",
               "greek": [
                  {
                     "_BETA": "TE/KNON",
                     "_unicode": "τέκνον",
                     "_translit": "téknon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tek'-non"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5088"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a child (as produced)",
               "kjv_def": ":--child, daughter, son.",
               "_strongs": "05043"
            },
            {
               "strongs": "5044",
               "greek": [
                  {
                     "_BETA": "TEKNOTROFE/W",
                     "_unicode": "τεκνοτροφέω",
                     "_translit": "teknotrophéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tek-not-rof-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5043"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be a childrearer, i.e. fulfil the\n duties of a female parent",
               "kjv_def": ":--bring up children.",
               "_strongs": "05044"
            },
            {
               "strongs": "5045",
               "greek": [
                  {
                     "_BETA": "TE/KTWN",
                     "_unicode": "τέκτων",
                     "_translit": "téktōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tek'-tone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5098"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "an artificer (as producer of fabrics), i.e.\n (specially), a craftsman in wood",
               "kjv_def": ":--carpenter.",
               "_strongs": "05045"
            },
            {
               "strongs": "5046",
               "greek": [
                  {
                     "_BETA": "TE/LEIOS",
                     "_unicode": "τέλειος",
                     "_translit": "téleios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel'-i-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     }
                  ],
                  "__text": "complete (in various applications of labor, growth, mental\n and moral character, etc.); neuter (as noun, with \n)\n completeness"
               },
               "kjv_def": ":--of full age, man, perfect.",
               "_strongs": "05046"
            },
            {
               "strongs": "5047",
               "greek": [
                  {
                     "_BETA": "TELEIO/THS",
                     "_unicode": "τελειότης",
                     "_translit": "teleiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-i-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5046"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(the state) completeness (mentally or\n morally)",
               "kjv_def": ":--perfection(-ness).",
               "_strongs": "05047"
            },
            {
               "strongs": "5048",
               "greek": [
                  {
                     "_BETA": "TELEIO/W",
                     "_unicode": "τελειόω",
                     "_translit": "teleióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-i-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5046"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to complete, i.e. (literally) accomplish, or (figuratively)\n consummate (in character)",
               "kjv_def": ":--consecrate, finish, fulfil, make) perfect.",
               "_strongs": "05048"
            },
            {
               "strongs": "5049",
               "greek": [
                  {
                     "_BETA": "TELEI/WS",
                     "_unicode": "τελείως",
                     "_translit": "teleíōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-i'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5046"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "completely, i.e. (of hope) without wavering",
               "kjv_def": ":--to the\n end.",
               "_strongs": "05049"
            },
            {
               "strongs": "5050",
               "greek": [
                  {
                     "_BETA": "TELEI/WSIS",
                     "_unicode": "τελείωσις",
                     "_translit": "teleíōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-i'-o-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5448"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(the act) completion, i.e. (of prophecy) verification, or\n (of expiation) absolution",
               "kjv_def": ":--perfection, performance.",
               "_strongs": "05050"
            },
            {
               "strongs": "5051",
               "greek": [
                  {
                     "_BETA": "TELEIWTH/S",
                     "_unicode": "τελειωτής",
                     "_translit": "teleiōtḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-i-o-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5048"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a completer, i.e. consummater",
               "kjv_def": ":--finisher.",
               "_strongs": "05051"
            },
            {
               "strongs": "5052",
               "greek": [
                  {
                     "_BETA": "TELESFORE/W",
                     "_unicode": "τελεσφορέω",
                     "_translit": "telesphoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-es-for-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be a bearer to completion\n (maturity), i.e. to ripen fruit (figuratively)",
               "kjv_def": ":--bring fruit to\n perfection.",
               "_strongs": "05052"
            },
            {
               "strongs": "5053",
               "greek": [
                  {
                     "_BETA": "TELEUTA/W",
                     "_unicode": "τελευτάω",
                     "_translit": "teleutáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-yoo-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5055"
                     }
                  ],
                  "__text": "from a presumed derivative of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "979"
                     }
                  ],
                  "__text": "to finish life (by implication, of\n \n), i.e. expire (demise)"
               },
               "kjv_def": ":--be dead, decease, die.",
               "_strongs": "05053"
            },
            {
               "strongs": "5054",
               "greek": [
                  {
                     "_BETA": "TELEUTH/",
                     "_unicode": "τελευτή",
                     "_translit": "teleutḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-yoo-tay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5053"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "decease",
               "kjv_def": ":--death.",
               "_strongs": "05054"
            },
            {
               "strongs": "5055",
               "greek": [
                  {
                     "_BETA": "TELE/W",
                     "_unicode": "τελέω",
                     "_translit": "teléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to end, i.e. complete, execute, conclude, discharge (a\n debt)",
               "kjv_def": ":--accomplish, make an end, expire, fill up, finish, go over,\n pay, perform.",
               "_strongs": "05055"
            },
            {
               "strongs": "5056",
               "greek": [
                  {
                     "_BETA": "TE/LOS",
                     "_unicode": "τέλος",
                     "_translit": "télos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TE/LLW",
                        "_unicode": "τέλλω",
                        "_translit": "téllō"
                     }
                  ],
                  "__text": "from a primary \n (to set out for a definite point or goal);"
               },
               "strongs_def": "properly, the point aimed at as a limit, i.e. (by implication) the\n conclusion of an act or state (termination (literally, figuratively or\n indefinitely), result (immediate, ultimate or prophetic), purpose);\n specially, an impost or levy (as paid)",
               "kjv_def": ":--+ continual, custom,\n end(-ing), finally, uttermost.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5411"
                  }
               ],
               "_strongs": "05056",
               "__text": "Compare \n."
            },
            {
               "strongs": "5057",
               "greek": [
                  {
                     "_BETA": "TELW/NHS",
                     "_unicode": "τελώνης",
                     "_translit": "telṓnēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-o'-nace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5608"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a tax-farmer, i.e. collector of public\n revenue",
               "kjv_def": ":--publican.",
               "_strongs": "05057"
            },
            {
               "strongs": "5058",
               "greek": [
                  {
                     "_BETA": "TELW/NION",
                     "_unicode": "τελώνιον",
                     "_translit": "telṓnion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tel-o'-nee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5057"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n;"
               },
               "strongs_def": "a tax-gatherer's place of\n business",
               "kjv_def": ":--receipt of custom.",
               "_strongs": "05058"
            },
            {
               "strongs": "5059",
               "greek": [
                  {
                     "_BETA": "TE/RAS",
                     "_unicode": "τέρας",
                     "_translit": "téras"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ter'-as"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a prodigy or omen",
               "kjv_def": ":--wonder.",
               "_strongs": "05059"
            },
            {
               "strongs": "5060",
               "greek": [
                  {
                     "_BETA": "*TE/RTIOS",
                     "_unicode": "Τέρτιος",
                     "_translit": "Tértios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ter'-tee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "third; Tertius, a Christian",
               "kjv_def": ":--Tertius.",
               "_strongs": "05060"
            },
            {
               "strongs": "5061",
               "greek": [
                  {
                     "_BETA": "*TE/RTULLOS",
                     "_unicode": "Τέρτυλλος",
                     "_translit": "Tértyllos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ter'-tool-los"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Tertullus, a Roman",
               "kjv_def": ":--Tertullus.",
               "_strongs": "05061"
            },
            {
               "strongs": "5062",
               "greek": [
                  {
                     "_BETA": "TESSARA/KONTA",
                     "_unicode": "τεσσαράκοντα",
                     "_translit": "tessarákonta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tes-sar-ak'-on-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     }
                  ],
                  "__text": "the decade of \n;"
               },
               "strongs_def": "forty",
               "kjv_def": ":--forty.",
               "_strongs": "05062"
            },
            {
               "strongs": "5063",
               "greek": [
                  {
                     "_BETA": "TESSARAKONTAETH/S",
                     "_unicode": "τεσσαρακονταετής",
                     "_translit": "tessarakontaetḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tes-sar-ak-on-tah-et-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5062"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2094"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "of forty years of age",
               "kjv_def": ":--(+ full, of) forty years\n (old).",
               "_strongs": "05063"
            },
            {
               "strongs": "5064",
               "greek": [
                  {
                     "_BETA": "TE/SSARES",
                     "_unicode": "τέσσαρες",
                     "_translit": "téssares"
                  },
                  {
                     "_BETA": "TE/SSARA",
                     "_unicode": "τέσσαρα",
                     "_translit": "téssara"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tes'-sar-es"
                  },
                  {
                     "_strongs": "tes'-sar-ah"
                  }
               ],
               "strongs_derivation": "a plural number;",
               "strongs_def": "four",
               "kjv_def": ":--four.",
               "_strongs": "05064",
               "__text": ", or neuter"
            },
            {
               "strongs": "5065",
               "greek": [
                  {
                     "_BETA": "TESSARESKAIDE/KATOS",
                     "_unicode": "τεσσαρεσκαιδέκατος",
                     "_translit": "tessareskaidékatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tes-sar-es-kahee-dek'-at-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2532"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1182"
                     }
                  ],
                  "__text": "from \n and \n and \n;"
               },
               "strongs_def": "fourteenth",
               "kjv_def": ":--fourteenth.",
               "_strongs": "05065"
            },
            {
               "strongs": "5066",
               "greek": [
                  {
                     "_BETA": "TETARTAI=OS",
                     "_unicode": "τεταρταῖος",
                     "_translit": "tetartaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-ar-tah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "pertaining to the fourth day",
               "kjv_def": ":--four days.",
               "_strongs": "05066"
            },
            {
               "strongs": "5067",
               "greek": [
                  {
                     "_BETA": "TE/TARTOS",
                     "_unicode": "τέταρτος",
                     "_translit": "tétartos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet'-ar-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     }
                  ],
                  "__text": "ordinal from \n;"
               },
               "strongs_def": "fourth",
               "kjv_def": ":--four(-th).",
               "_strongs": "05067"
            },
            {
               "strongs": "5068",
               "greek": [
                  {
                     "_BETA": "TETRA/GWNOS",
                     "_unicode": "τετράγωνος",
                     "_translit": "tetrágōnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-rag'-o-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1137"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "four-cornered, i.e. square",
               "kjv_def": ":--foursquare.",
               "_strongs": "05068"
            },
            {
               "strongs": "5069",
               "greek": [
                  {
                     "_BETA": "TETRA/DION",
                     "_unicode": "τετράδιον",
                     "_translit": "tetrádion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-rad'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TE/TRAS",
                        "_unicode": "τέτρας",
                        "_translit": "tétras"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n (a tetrad; from \n);"
               },
               "strongs_def": "a\n quaternion or squad (picket) of four Roman soldiers",
               "kjv_def": ":--quaternion.",
               "_strongs": "05069"
            },
            {
               "strongs": "5070",
               "greek": [
                  {
                     "_BETA": "TETRAKISXI/LIOI",
                     "_unicode": "τετρακισχίλιοι",
                     "_translit": "tetrakischílioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-rak-is-khil'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5507"
                     }
                  ],
                  "__text": "from the multiplicative adverb of \n and \n;"
               },
               "strongs_def": "four times a\n thousand",
               "kjv_def": ":--four thousand.",
               "_strongs": "05070"
            },
            {
               "strongs": "5071",
               "greek": [
                  {
                     "_BETA": "TETRAKO/SIOI",
                     "_unicode": "τετρακόσιοι",
                     "_translit": "tetrakósioi"
                  },
                  {
                     "_BETA": "TETRAKO/SIA",
                     "_unicode": "τετρακόσια",
                     "_translit": "tetrakósia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-rak-os'-ee-oy"
                  },
                  {
                     "_strongs": "tet-rak-os'-ee-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1540"
                     }
                  ],
                  "__text": "plural from \n and \n;"
               },
               "strongs_def": "four hundred",
               "kjv_def": ":--four hundred.",
               "_strongs": "05071",
               "__text": ",  or neuter"
            },
            {
               "strongs": "5072",
               "greek": [
                  {
                     "_BETA": "TETRA/MHNON",
                     "_unicode": "τετράμηνον",
                     "_translit": "tetrámēnon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-ram'-ay-non"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3376"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n;"
               },
               "strongs_def": "a four months' space",
               "kjv_def": ":--four\n months.",
               "_strongs": "05072"
            },
            {
               "strongs": "5073",
               "greek": [
                  {
                     "_BETA": "TETRAPLO/OS",
                     "_unicode": "τετραπλόος",
                     "_translit": "tetraplóos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-rap-lo'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4118"
                     }
                  ],
                  "__text": "from \n and a derivative of the base of \n;"
               },
               "strongs_def": "quadruple",
               "kjv_def": ":--fourfold.",
               "_strongs": "05073"
            },
            {
               "strongs": "5074",
               "greek": [
                  {
                     "_BETA": "TETRA/POUS",
                     "_unicode": "τετράπους",
                     "_translit": "tetrápous"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-rap'-ooce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a quadruped",
               "kjv_def": ":--fourfooted beast.",
               "_strongs": "05074"
            },
            {
               "strongs": "5075",
               "greek": [
                  {
                     "_BETA": "TETRARXE/W",
                     "_unicode": "τετραρχέω",
                     "_translit": "tetrarchéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-rar-kheh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5076"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a tetrarch",
               "kjv_def": ":--(be) tetrarch.",
               "_strongs": "05075"
            },
            {
               "strongs": "5076",
               "greek": [
                  {
                     "_BETA": "TETRA/RXHS",
                     "_unicode": "τετράρχης",
                     "_translit": "tetrárchēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tet-rar'-khace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the ruler of a fourth part of a country\n (\"tetrarch\")",
               "kjv_def": ":--tetrarch.",
               "_strongs": "05076"
            },
            {
               "strongs": "5077",
               "greek": [
                  {
                     "_BETA": "TEFRO/W",
                     "_unicode": "τεφρόω",
                     "_translit": "tephróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tef-ro'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TE/FRA",
                        "_unicode": "τέφρα",
                        "_translit": "téphra"
                     }
                  ],
                  "__text": "from \n (ashes);"
               },
               "strongs_def": "to incinerate, i.e. consume",
               "kjv_def": ":--turn to ashes.",
               "_strongs": "05077"
            },
            {
               "strongs": "5078",
               "greek": [
                  {
                     "_BETA": "TE/XNH",
                     "_unicode": "τέχνη",
                     "_translit": "téchnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tekh'-nay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5088"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "art (as productive), i.e. (specially), a trade,\n or (generally) skill",
               "kjv_def": ":--art, craft, occupation.",
               "_strongs": "05078"
            },
            {
               "strongs": "5079",
               "greek": [
                  {
                     "_BETA": "TEXNI/THS",
                     "_unicode": "τεχνίτης",
                     "_translit": "technítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tekh-nee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5078"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an artisan; figuratively, a founder (Creator)",
               "kjv_def": ":--builder,\n craftsman.",
               "_strongs": "05079"
            },
            {
               "strongs": "5080",
               "greek": [
                  {
                     "_BETA": "TH/KW",
                     "_unicode": "τήκω",
                     "_translit": "tḗkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tay'-ko"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to liquefy",
               "kjv_def": ":--melt.",
               "_strongs": "05080"
            },
            {
               "strongs": "5081",
               "greek": [
                  {
                     "_BETA": "THLAUGW=S",
                     "_unicode": "τηλαυγῶς",
                     "_translit": "tēlaugōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tay-low-goce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "827"
                     }
                  ],
                  "__text": "adverb from a compound of a derivative of \n and \n;"
               },
               "strongs_def": "in a\n far-shining manner, i.e. plainly",
               "kjv_def": ":--clearly.",
               "_strongs": "05081"
            },
            {
               "strongs": "5082",
               "greek": [
                  {
                     "_BETA": "THLIKOU=TOS",
                     "_unicode": "τηλικοῦτος",
                     "_translit": "tēlikoûtos"
                  },
                  {
                     "_BETA": "THLIKAU/TH",
                     "_unicode": "τηλικαύτη",
                     "_translit": "tēlikaútē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tay-lik-oo'-tos"
                  },
                  {
                     "_strongs": "tay-lik-ow'-tay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2245"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "from a compound of \n with \n and \n;"
               },
               "strongs_def": "such as this, i.e. (in\n (figurative) magnitude) so vast",
               "kjv_def": ":--so great, so mighty.",
               "_strongs": "05082",
               "__text": ", or feminine"
            },
            {
               "strongs": "5083",
               "greek": [
                  {
                     "_BETA": "THRE/W",
                     "_unicode": "τηρέω",
                     "_translit": "tēréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tay-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TERO/S",
                        "_unicode": "τερός",
                        "_translit": "terós"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2334"
                     }
                  ],
                  "__text": "from \n (a watch; perhaps akin to \n);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5442"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2892"
                     }
                  ],
                  "__text": "to guard (from loss or\n injury, properly, by keeping the eye upon; and thus differing from\n \n, which is properly to prevent escaping; and from \n, which\n implies a fortress or full military lines of apparatus), i.e. to note\n (a prophecy; figuratively, to fulfil a command); by implication, to\n detain (in custody; figuratively, to maintain); by extension, to\n withhold (for personal ends; figuratively, to keep unmarried); by\n extension, to withhold (for personal ends; figuratively, to keep\n unmarried)"
               },
               "kjv_def": ":--hold fast, keep(- er), (pre-, re-)serve, watch.",
               "_strongs": "05083"
            },
            {
               "strongs": "5084",
               "greek": [
                  {
                     "_BETA": "TH/RHSIS",
                     "_unicode": "τήρησις",
                     "_translit": "tḗrēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tay'-ray-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5083"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a watching, i.e. (figuratively) observance, or (concretely)\n a prison",
               "kjv_def": ":--hold.",
               "_strongs": "05084"
            },
            {
               "strongs": "5085",
               "greek": [
                  {
                     "_BETA": "*TIBERIA/S",
                     "_unicode": "Τιβεριάς",
                     "_translit": "Tiberiás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tib-er-ee-as'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5086"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "Tiberias, the name of a town and a lake in\n Palestine",
               "kjv_def": ":--Tiberias.",
               "_strongs": "05085"
            },
            {
               "strongs": "5086",
               "greek": [
                  {
                     "_BETA": "*TIBE/RIOS",
                     "_unicode": "Τιβέριος",
                     "_translit": "Tibérios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tib-er'-ee-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "probably pertaining to the river Tiberis or Tiber;\n Tiberius, a Roman emperor",
               "kjv_def": ":--Tiberius.",
               "_strongs": "05086"
            },
            {
               "strongs": "5087",
               "greek": [
                  {
                     "_BETA": "TI/QHMI",
                     "_unicode": "τίθημι",
                     "_translit": "títhēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QE/W",
                        "_unicode": "θέω",
                        "_translit": "théō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "theh'-o"
                     }
                  ],
                  "__text": "a prolonged form of a primary\n      \n  \n       (which is used only as alternate in\n                               certain tenses);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2749"
                     }
                  ],
                  "__text": "to place (in the widest application, literally and figuratively;\n properly, in a passive or horizontal posture, and thus different from\n \n, which properly denotes an upright and active position, while\n \n is properly reflexive and utterly  prostrate)"
               },
               "kjv_def": ":--+ advise,\n appoint, bow, commit, conceive, give,\n X kneel down, lay (aside, down, up), make, ordain, purpose,\n put, set (forth), settle, sink down.",
               "_strongs": "05087",
               "__text": ";"
            },
            {
               "strongs": "5088",
               "greek": [
                  {
                     "_BETA": "TI/KTW",
                     "_unicode": "τίκτω",
                     "_translit": "tíktō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tik'-to"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TE/KW",
                        "_unicode": "τέκω",
                        "_translit": "tékō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "tek'-o"
                     }
                  ],
                  "__text": "a strengthened form of a primary \n \n (which is used only as\n alternate in certain tenses);"
               },
               "strongs_def": "to produce (from seed, as a mother, a\n plant, the earth, etc.), literally or figuratively",
               "kjv_def": ":--bear, be born,\n bring forth, be delivered, be in travail.",
               "_strongs": "05088"
            },
            {
               "strongs": "5089",
               "greek": [
                  {
                     "_BETA": "TI/LLW",
                     "_unicode": "τίλλω",
                     "_translit": "tíllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "til'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "138"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4951"
                     }
                  ],
                  "__text": "perhaps akin to the alternate of \n, and thus to \n;"
               },
               "strongs_def": "to pull\n off",
               "kjv_def": ":--pluck.",
               "_strongs": "05089"
            },
            {
               "strongs": "5090",
               "greek": [
                  {
                     "_BETA": "*TIMAI=OS",
                     "_unicode": "Τιμαῖος",
                     "_translit": "Timaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tim'-ah-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02931"
                     }
                  ],
                  "__text": "probably of Chaldee origin (compare \n);"
               },
               "strongs_def": "Timæus (i.e. Timay), an\n Israelite",
               "kjv_def": ":--Timæus.",
               "_strongs": "05090"
            },
            {
               "strongs": "5091",
               "greek": [
                  {
                     "_BETA": "TIMA/W",
                     "_unicode": "τιμάω",
                     "_translit": "timáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tim-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5093"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to prize, i.e. fix a valuation upon; by implication, to\n revere",
               "kjv_def": ":--honour, value.",
               "_strongs": "05091"
            },
            {
               "strongs": "5092",
               "greek": [
                  {
                     "_BETA": "TIMH/",
                     "_unicode": "τιμή",
                     "_translit": "timḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tee-may'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5099"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a value, i.e. money paid, or (concretely and collectively)\n valuables; by analogy, esteem (especially of the highest degree), or\n the dignity itself",
               "kjv_def": ":--honour, precious, price, some.",
               "_strongs": "05092"
            },
            {
               "strongs": "5093",
               "greek": [
                  {
                     "_BETA": "TI/MIOS",
                     "_unicode": "τίμιος",
                     "_translit": "tímios"
                  },
                  {
                     "_BETA": "TIMIW/TEROS",
                     "_unicode": "τιμιώτερος",
                     "_translit": "timiṓteros"
                  },
                  {
                     "_BETA": "TIMIW/TATOS",
                     "_unicode": "τιμιώτατος",
                     "_translit": "timiṓtatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tim'-ee-os"
                  },
                  {
                     "_strongs": "tim-ee-o'-ter-os"
                  },
                  {
                     "_strongs": "tim-ee-o'-tat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "valuable, i.e. (objectively) costly, or (subjectively)\n honored, esteemed, or (figuratively) beloved",
               "kjv_def": ":--dear, honourable,\n (more, most) precious, had in reputation.",
               "_strongs": "05093",
               "__text": ",        including the comparative\n      \n  \n,  and the superlative"
            },
            {
               "strongs": "5094",
               "greek": [
                  {
                     "_BETA": "TIMIO/THS",
                     "_unicode": "τιμιότης",
                     "_translit": "timiótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tim-ee-ot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5093"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "expensiveness, i.e. (by implication)\n magnificence",
               "kjv_def": ":--costliness.",
               "_strongs": "05094"
            },
            {
               "strongs": "5095",
               "greek": [
                  {
                     "_BETA": "*TIMO/QEOS",
                     "_unicode": "Τιμόθεος",
                     "_translit": "Timótheos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tee-moth'-eh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "dear to God; Timotheus, a Christian",
               "kjv_def": ":--Timotheus,\n Timothy.",
               "_strongs": "05095"
            },
            {
               "strongs": "5096",
               "greek": [
                  {
                     "_BETA": "*TI/MWN",
                     "_unicode": "Τίμων",
                     "_translit": "Tímōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tee'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "valuable; Timon, a Christian",
               "kjv_def": ":--Timon.",
               "_strongs": "05096"
            },
            {
               "strongs": "5097",
               "greek": [
                  {
                     "_BETA": "TIMWRE/W",
                     "_unicode": "τιμωρέω",
                     "_translit": "timōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tim-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "OU)=ROS",
                        "_unicode": "οὖρος",
                        "_translit": "oûros"
                     }
                  ],
                  "__text": "from a compound of \n and \n ouros (a guard);"
               },
               "strongs_def": "properly, to protect\n one's honor, i.e. to avenge (inflict a penalty)",
               "kjv_def": ":--punish.",
               "_strongs": "05097"
            },
            {
               "strongs": "5098",
               "greek": [
                  {
                     "_BETA": "TIMWRI/A",
                     "_unicode": "τιμωρία",
                     "_translit": "timōría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tee-mo-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5097"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "vindication, i.e. (by implication) a penalty",
               "kjv_def": ":--punishment.",
               "_strongs": "05098"
            },
            {
               "strongs": "5099",
               "greek": [
                  {
                     "_BETA": "TI/NW",
                     "_unicode": "τίνω",
                     "_translit": "tínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tee'-no"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TI/W",
                        "_unicode": "τίω",
                        "_translit": "tíō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "tee'-o"
                     }
                  ],
                  "__text": "strengthened for a primary\n      \n  \n    (which is only used as an alternate in\n                        certain tenses);"
               },
               "strongs_def": "to pay a price, i.e. as a penalty",
               "kjv_def": ":--be punished with.",
               "_strongs": "05099",
               "__text": ";"
            },
            {
               "strongs": "5100",
               "greek": [
                  {
                     "_BETA": "TI\\S",
                     "_unicode": "τὶς",
                     "_translit": "tìs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tis"
                  }
               ],
               "strongs_derivation": "an enclitic indefinite pronoun;",
               "strongs_def": "some or any person or object",
               "kjv_def": ":--a (kind\n of), any (man, thing, thing at all), certain (thing), divers, he\n (every) man, one (X thing), ought, + partly, some (man, -body, -\n thing, -what), (+ that no-)thing, what(-soever), X wherewith,\n whom(-soever), whose(-soever).",
               "_strongs": "05100"
            },
            {
               "strongs": "5101",
               "greek": [
                  {
                     "_BETA": "TI/S",
                     "_unicode": "τίς",
                     "_translit": "tís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5100"
                     }
                  ],
                  "__text": "probably emphatic of \n;"
               },
               "strongs_def": "an interrogative pronoun, who, which or\n what (in direct or indirect questions)",
               "kjv_def": ":--every man, how (much), +\n no(-ne, thing), what (manner, thing), where (-by, -fore, -of, -unto, -\n with, -withal), whether, which, who(-m, -se), why.",
               "_strongs": "05101"
            },
            {
               "strongs": "5102",
               "greek": [
                  {
                     "_BETA": "TI/TLOS",
                     "_unicode": "τίτλος",
                     "_translit": "títlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tit'-los"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "a titulus or \"title\" (placard)",
               "kjv_def": ":--title.",
               "_strongs": "05102"
            },
            {
               "strongs": "5103",
               "greek": [
                  {
                     "_BETA": "*TI/TOS",
                     "_unicode": "Τίτος",
                     "_translit": "Títos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tee'-tos"
                  }
               ],
               "strongs_derivation": "of Latin origin but uncertain significance;",
               "strongs_def": "Titus, a\n Christian",
               "kjv_def": ":--Titus.",
               "_strongs": "05103"
            },
            {
               "strongs": "5104",
               "greek": [
                  {
                     "_BETA": "TOI/",
                     "_unicode": "τοί",
                     "_translit": "toí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     }
                  ],
                  "__text": "probably for the dative case of \n;"
               },
               "strongs_def": "an enclitic particle of\n asseveration by way of contrast; in sooth",
               "kjv_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2544"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3305"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5105"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5106"
                     }
                  ],
                  "__text": ":--(used only with other\n particles in the compound, as \n, \n, \n, \n, etc."
               },
               "_strongs": "05104",
               "__text": ")"
            },
            {
               "strongs": "5105",
               "greek": [
                  {
                     "_BETA": "TOIGAROU=N",
                     "_unicode": "τοιγαροῦν",
                     "_translit": "toigaroûn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toy-gar-oon'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5104"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1063"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3767"
                     }
                  ],
                  "__text": "from \n and \n and \n;"
               },
               "strongs_def": "truly for then, i.e.\n consequently",
               "kjv_def": ":--there-(where-)fore.",
               "_strongs": "05105"
            },
            {
               "strongs": "5106",
               "greek": [
                  {
                     "_BETA": "TOI/NUN",
                     "_unicode": "τοίνυν",
                     "_translit": "toínyn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toy'-noon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5104"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3568"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "truly now, i.e. accordingly",
               "kjv_def": ":--then, therefore.",
               "_strongs": "05106"
            },
            {
               "strongs": "5107",
               "greek": [
                  {
                     "_BETA": "TOIO/SDE",
                     "_unicode": "τοιόσδε",
                     "_translit": "toiósde"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toy-os'-deh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1161"
                     }
                  ],
                  "__text": "(including the other inflections); from a derivative of 5104 and \n;"
               },
               "strongs_def": "such-like then, i.e. so great",
               "kjv_def": ":--such.",
               "_strongs": "05107"
            },
            {
               "strongs": "5108",
               "greek": [
                  {
                     "_BETA": "TOIOU=TOS",
                     "_unicode": "τοιοῦτος",
                     "_translit": "toioûtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toy-oo'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5104"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "(including the other inflections); from \n and \n;"
               },
               "strongs_def": "truly this,\n i.e. of this sort (to denote character or individuality)",
               "kjv_def": ":--like, such\n (an one).",
               "_strongs": "05108"
            },
            {
               "strongs": "5109",
               "greek": [
                  {
                     "_BETA": "TOI=XOS",
                     "_unicode": "τοῖχος",
                     "_translit": "toîchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toy'-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5038"
                     }
                  ],
                  "__text": "another form of \n;"
               },
               "strongs_def": "a wall",
               "kjv_def": ":--wall.",
               "_strongs": "05109"
            },
            {
               "strongs": "5110",
               "greek": [
                  {
                     "_BETA": "TO/KOS",
                     "_unicode": "τόκος",
                     "_translit": "tókos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tok'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5088"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "interest on money loaned (as a\n produce)",
               "kjv_def": ":--usury.",
               "_strongs": "05110"
            },
            {
               "strongs": "5111",
               "greek": [
                  {
                     "_BETA": "TOLMA/W",
                     "_unicode": "τολμάω",
                     "_translit": "tolmáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tol-mah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TO/LMA",
                        "_unicode": "τόλμα",
                        "_translit": "tólma"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "from \n (boldness; probably itself from the base of \n through\n the idea of extreme conduct);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2292"
                     }
                  ],
                  "__text": "to venture (objectively or in act; while\n \n is rather subjective or in feeling); by implication, to be\n courageous"
               },
               "kjv_def": ":--be bold, boldly, dare, durst.",
               "_strongs": "05111"
            },
            {
               "strongs": "5112",
               "greek": [
                  {
                     "_BETA": "TOLMHRO/TERON",
                     "_unicode": "τολμηρότερον",
                     "_translit": "tolmēróteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tol-may-rot'-er-on"
                  }
               ],
               "strongs_derivation": "neuter of the compound of a derivative of the base of 5111 (as\n adverb);",
               "strongs_def": "more daringly, i.e. with greater confidence than\n otherwise",
               "kjv_def": ":--the more boldly.",
               "_strongs": "05112"
            },
            {
               "strongs": "5113",
               "greek": [
                  {
                     "_BETA": "TOLMHTH/S",
                     "_unicode": "τολμητής",
                     "_translit": "tolmētḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tol-may-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5111"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a daring (audacious) man",
               "kjv_def": ":--presumptuous.",
               "_strongs": "05113"
            },
            {
               "strongs": "5114",
               "greek": [
                  {
                     "_BETA": "TOMW/TEROS",
                     "_unicode": "τομώτερος",
                     "_translit": "tomṓteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tom-o'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TE/MNW",
                        "_unicode": "τέμνω",
                        "_translit": "témnō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2875"
                     }
                  ],
                  "__text": "comparative of a derivative of the primary \n (to cut; more\n comprehensive or decisive than \n, as if by a single stroke; whereas\n that implies repeated blows, like hacking);"
               },
               "strongs_def": "more keen",
               "kjv_def": ":--sharper.",
               "_strongs": "05114"
            },
            {
               "strongs": "5115",
               "greek": [
                  {
                     "_BETA": "TO/CON",
                     "_unicode": "τόξον",
                     "_translit": "tóxon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tox'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5088"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a bow (apparently as the simplest\n fabric)",
               "kjv_def": ":--bow.",
               "_strongs": "05115"
            },
            {
               "strongs": "5116",
               "greek": [
                  {
                     "_BETA": "TOPA/ZION",
                     "_unicode": "τοπάζιον",
                     "_translit": "topázion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "top-ad'-zee-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TO/PAZOS",
                        "_unicode": "τόπαζος",
                        "_translit": "tópazos"
                     }
                  ],
                  "__text": "neuter of a presumed derivative (alternately) of \n (a \"topaz\";\n of uncertain origin);"
               },
               "strongs_def": "a gem, probably the chrysolite",
               "kjv_def": ":--topaz.",
               "_strongs": "05116"
            },
            {
               "strongs": "5117",
               "greek": [
                  {
                     "_BETA": "TO/POS",
                     "_unicode": "τόπος",
                     "_translit": "tópos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "top'-os"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "a spot (generally in space, but limited by\n occupancy; whereas \n is a large but particular locality), i.e.\n location (as a position, home, tract, etc.); figuratively, condition,\n opportunity; specially, a scabbard"
               },
               "kjv_def": ":--coast, licence, place, X plain,\n quarter, + rock, room, where.",
               "_strongs": "05117"
            },
            {
               "strongs": "5118",
               "greek": [
                  {
                     "_BETA": "TOSOU=TOS",
                     "_unicode": "τοσοῦτος",
                     "_translit": "tosoûtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tos-oo'-tos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TO/SOS",
                        "_unicode": "τόσος",
                        "_translit": "tósos"
                     }
                  ],
                  "__text": "from \n (so much;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "apparently from \n and \n) and \n\n (including its variations); so vast as this, i.e. such (in quantity,\n amount, number of space)"
               },
               "kjv_def": ":--as large, so great (long, many, much),\n these many.",
               "_strongs": "05118"
            },
            {
               "strongs": "5119",
               "greek": [
                  {
                     "_BETA": "TO/TE",
                     "_unicode": "τότε",
                     "_translit": "tóte"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tot'-eh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3753"
                     }
                  ],
                  "__text": "from (the neuter of) \n and \n;"
               },
               "strongs_def": "the when, i.e. at the time that\n (of the past or future, also in consecution)",
               "kjv_def": ":--that time, then.",
               "_strongs": "05119"
            },
            {
               "strongs": "5120",
               "greek": [
                  {
                     "_BETA": "TOU=",
                     "_unicode": "τοῦ",
                     "_translit": "toû"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     }
                  ],
                  "__text": "properly, the genitive case of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5127"
                     }
                  ],
                  "__text": "sometimes used for \n; of this\n person"
               },
               "kjv_def": ":--his.",
               "_strongs": "05120"
            },
            {
               "strongs": "5121",
               "greek": [
                  {
                     "_BETA": "TOU)NANTI/ON",
                     "_unicode": "τοὐναντίον",
                     "_translit": "tounantíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too-nan-tee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1726"
                     }
                  ],
                  "__text": "contraction for the neuter of \n and \n;"
               },
               "strongs_def": "on the\n contrary",
               "kjv_def": ":--contrariwise.",
               "_strongs": "05121"
            },
            {
               "strongs": "5122",
               "greek": [
                  {
                     "_BETA": "TOU)/NOMA",
                     "_unicode": "τοὔνομα",
                     "_translit": "toúnoma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-no-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3588"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3686"
                     }
                  ],
                  "__text": "contraction for the neuter of \n and \n;"
               },
               "strongs_def": "the name (is)",
               "kjv_def": ":--named.",
               "_strongs": "05122"
            },
            {
               "strongs": "5123",
               "greek": [
                  {
                     "_BETA": "TOUTE/STI",
                     "_unicode": "τουτέστι",
                     "_translit": "toutésti"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toot-es'-tee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5124"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2076"
                     }
                  ],
                  "__text": "contraction for \n and \n;"
               },
               "strongs_def": "that is",
               "kjv_def": ":--that is (to say).",
               "_strongs": "05123"
            },
            {
               "strongs": "5124",
               "greek": [
                  {
                     "_BETA": "TOU=TO",
                     "_unicode": "τοῦτο",
                     "_translit": "toûto"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "neuter singular nominative or accusative case of \n;"
               },
               "strongs_def": "that\n thing",
               "kjv_def": ":--here (-unto), it, partly, self(-same), so, that (intent), the\n same, there(-fore, -unto), this, thus, where(-fore).",
               "_strongs": "05124"
            },
            {
               "strongs": "5125",
               "greek": [
                  {
                     "_BETA": "TOU/TOIS",
                     "_unicode": "τούτοις",
                     "_translit": "toútois"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-toice"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "dative case plural masculine or neuter of \n;"
               },
               "strongs_def": "to (for, in, with or\n by) these (persons or things)",
               "kjv_def": ":--such, them, there(-in, -with), these,\n this, those.",
               "_strongs": "05125"
            },
            {
               "strongs": "5126",
               "greek": [
                  {
                     "_BETA": "TOU=TON",
                     "_unicode": "τοῦτον",
                     "_translit": "toûton"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-ton"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "accusative case singular masculine of \n;"
               },
               "strongs_def": "this (person, as objective\n of verb or preposition)",
               "kjv_def": ":--him, the same, that, this.",
               "_strongs": "05126"
            },
            {
               "strongs": "5127",
               "greek": [
                  {
                     "_BETA": "TOU/TOU",
                     "_unicode": "τούτου",
                     "_translit": "toútou"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-too"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "genitive case singular masculine or neuter of \n;"
               },
               "strongs_def": "of (from or\n concerning) this (person or thing)",
               "kjv_def": ":--here(-by), him, it, + such manner\n of, that, thence(-forth), thereabout, this, thus.",
               "_strongs": "05127"
            },
            {
               "strongs": "5128",
               "greek": [
                  {
                     "_BETA": "TOU/TOUS",
                     "_unicode": "τούτους",
                     "_translit": "toútous"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-tooce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "accusative case plural masculine of \n;"
               },
               "strongs_def": "these (persons, as objective\n of verb or preposition)",
               "kjv_def": ":--such, them, these, this.",
               "_strongs": "05128"
            },
            {
               "strongs": "5129",
               "greek": [
                  {
                     "_BETA": "TOU/TW|",
                     "_unicode": "τούτῳ",
                     "_translit": "toútōi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-to"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "dative case singular masculine or neuter of \n;"
               },
               "strongs_def": "to (in, with or by)\n this (person or thing)",
               "kjv_def": ":--here(-by, -in), him, one, the same,\n there(-in), this.",
               "_strongs": "05129"
            },
            {
               "strongs": "5130",
               "greek": [
                  {
                     "_BETA": "TOU/TWN",
                     "_unicode": "τούτων",
                     "_translit": "toútōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-tone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3778"
                     }
                  ],
                  "__text": "genitive case plural masculine or neuter of \n;"
               },
               "strongs_def": "of (from or\n concerning) these (persons or things)",
               "kjv_def": ":--such, their, these (things),\n they, this sort, those.",
               "_strongs": "05130"
            },
            {
               "strongs": "5131",
               "greek": [
                  {
                     "_BETA": "TRA/GOS",
                     "_unicode": "τράγος",
                     "_translit": "trágos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trag'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5176"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a he-goat (as a gnawer)",
               "kjv_def": ":--goat.",
               "_strongs": "05131"
            },
            {
               "strongs": "5132",
               "greek": [
                  {
                     "_BETA": "TRA/PEZA",
                     "_unicode": "τράπεζα",
                     "_translit": "trápeza"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trap'-ed-zah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5064"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3979"
                     }
                  ],
                  "__text": "probably contracted from \n and \n;"
               },
               "strongs_def": "a table or stool (as being\n four-legged), usually for food (figuratively, a meal); also a counter\n for money (figuratively, a broker's office for loans at\n interest)",
               "kjv_def": ":--bank, meat, table.",
               "_strongs": "05132"
            },
            {
               "strongs": "5133",
               "greek": [
                  {
                     "_BETA": "TRAPEZI/THS",
                     "_unicode": "τραπεζίτης",
                     "_translit": "trapezítēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trap-ed-zee'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5132"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a money-broker or banker",
               "kjv_def": ":--exchanger.",
               "_strongs": "05133"
            },
            {
               "strongs": "5134",
               "greek": [
                  {
                     "_BETA": "TRAU=MA",
                     "_unicode": "τραῦμα",
                     "_translit": "traûma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trow'-mah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TITRW/SKW",
                        "_unicode": "τιτρώσκω",
                        "_translit": "titrṓskō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2352"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5147"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5149"
                     }
                  ],
                  "__text": "from the base of \n (to wound; akin to the base of \n, \n,\n \n, etc.);"
               },
               "strongs_def": "a wound",
               "kjv_def": ":--wound.",
               "_strongs": "05134"
            },
            {
               "strongs": "5135",
               "greek": [
                  {
                     "_BETA": "TRAUMATI/ZW",
                     "_unicode": "τραυματίζω",
                     "_translit": "traumatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trow-mat-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5134"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to inflict a wound",
               "kjv_def": ":--wound.",
               "_strongs": "05135"
            },
            {
               "strongs": "5136",
               "greek": [
                  {
                     "_BETA": "TRAXHLI/ZW",
                     "_unicode": "τραχηλίζω",
                     "_translit": "trachēlízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trakh-ay-lid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5137"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to seize by the throat or neck, i.e. to expose the gullet\n of a victim for killing (generally, to lay bare)",
               "kjv_def": ":--opened.",
               "_strongs": "05136"
            },
            {
               "strongs": "5137",
               "greek": [
                  {
                     "_BETA": "TRA/XHLOS",
                     "_unicode": "τράχηλος",
                     "_translit": "tráchēlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trakh'-ay-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "probably from \n (through the idea of mobility);"
               },
               "strongs_def": "the throat (neck),\n i.e. (figuratively) life",
               "kjv_def": ":--neck.",
               "_strongs": "05137"
            },
            {
               "strongs": "5138",
               "greek": [
                  {
                     "_BETA": "TRAXU/S",
                     "_unicode": "τραχύς",
                     "_translit": "trachýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trakh-oos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "perhaps strengthened from the base of \n (as if jagged by rents);"
               },
               "strongs_def": "uneven, rocky (reefy)",
               "kjv_def": ":--rock, rough.",
               "_strongs": "05138"
            },
            {
               "strongs": "5139",
               "greek": [
                  {
                     "_BETA": "*TRAXWNI=TIS",
                     "_unicode": "Τραχωνῖτις",
                     "_translit": "Trachōnîtis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trakh-o-nee'-tis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5138"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "rough district; Trachonitis, a region of\n Syria",
               "kjv_def": ":--Trachonitis.",
               "_strongs": "05139"
            },
            {
               "strongs": "5140",
               "greek": [
                  {
                     "_BETA": "TREI=S",
                     "_unicode": "τρεῖς",
                     "_translit": "treîs"
                  },
                  {
                     "_BETA": "TRI/A",
                     "_unicode": "τρία",
                     "_translit": "tría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trice"
                  },
                  {
                     "_strongs": "tree'-ah"
                  }
               ],
               "strongs_derivation": "a primary (plural) number;",
               "strongs_def": "\"three\"",
               "kjv_def": ":--three.",
               "_strongs": "05140",
               "__text": ",   or neuter"
            },
            {
               "strongs": "5141",
               "greek": [
                  {
                     "_BETA": "TRE/MW",
                     "_unicode": "τρέμω",
                     "_translit": "trémō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trem'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TRE/W",
                        "_unicode": "τρέω",
                        "_translit": "tréō"
                     }
                  ],
                  "__text": "strengthened from a primary \n (to \"dread\", \"terrify\");"
               },
               "strongs_def": "to \"tremble\"\n or fear",
               "kjv_def": ":--be afraid, trembling.",
               "_strongs": "05141"
            },
            {
               "strongs": "5142",
               "greek": [
                  {
                     "_BETA": "TRE/FW",
                     "_unicode": "τρέφω",
                     "_translit": "tréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TRE/FW",
                        "_unicode": "τρέφω",
                        "_translit": "tréphō"
                     }
                  ],
                  "__text": "a primary verb (properly, \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "but perhaps strengthened from the\n base of \n through the idea of convolution); properly, to stiffen,\n i.e. fatten (by implication, to cherish (with food, etc.), pamper,\n rear)"
               },
               "kjv_def": ":--bring up, feed, nourish.",
               "_strongs": "05142"
            },
            {
               "strongs": "5143",
               "greek": [
                  {
                     "_BETA": "TRE/XW",
                     "_unicode": "τρέχω",
                     "_translit": "tréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QRE/XW",
                        "_unicode": "θρέχω",
                        "_translit": "thréchō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2359"
                     }
                  ],
                  "__text": "apparently a primary verb (properly, \n; compare \n);"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "DRE/MW",
                        "_unicode": "δρέμω",
                        "_translit": "drémō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "drem'-o"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1408"
                     }
                  ],
                  "__text": "which\n uses \n \n (the base of \n) as alternate in certain tenses;\n to run or walk hastily (literally or figuratively)"
               },
               "kjv_def": ":--have course, run.",
               "_strongs": "05143"
            },
            {
               "strongs": "5144",
               "greek": [
                  {
                     "_BETA": "TRIA/KONTA",
                     "_unicode": "τριάκοντα",
                     "_translit": "triákonta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tree-ak'-on-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     }
                  ],
                  "__text": "the decade of \n;"
               },
               "strongs_def": "thirty",
               "kjv_def": ":--thirty.",
               "_strongs": "05144"
            },
            {
               "strongs": "5145",
               "greek": [
                  {
                     "_BETA": "TRIAKO/SIOI",
                     "_unicode": "τριακόσιοι",
                     "_translit": "triakósioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tree-ak-os'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1540"
                     }
                  ],
                  "__text": "plural from \n and \n;"
               },
               "strongs_def": "three hundred",
               "kjv_def": ":--three hundred.",
               "_strongs": "05145"
            },
            {
               "strongs": "5146",
               "greek": [
                  {
                     "_BETA": "TRI/BOLOS",
                     "_unicode": "τρίβολος",
                     "_translit": "tríbolos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trib'-ol-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "956"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "properly, a crow-foot (three-pronged obstruction in\n war), i.e. (by analogy) a thorny plant (caltrop)",
               "kjv_def": ":--brier, thistle.",
               "_strongs": "05146"
            },
            {
               "strongs": "5147",
               "greek": [
                  {
                     "_BETA": "TRI/BOS",
                     "_unicode": "τρίβος",
                     "_translit": "tríbos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tree'-bos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TRI/BW",
                        "_unicode": "τρίβω",
                        "_translit": "tríbō"
                     },
                     {
                        "_BETA": "TEI/RW",
                        "_unicode": "τείρω",
                        "_translit": "teírō"
                     },
                     {
                        "_BETA": "TRU/W",
                        "_unicode": "τρύω",
                        "_translit": "trýō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5131"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5134"
                     }
                  ],
                  "__text": "from \n (to \"rub\"; akin to \n, \n, and the base of \n,\n \n);"
               },
               "strongs_def": "a rut or worn track",
               "kjv_def": ":--path.",
               "_strongs": "05147"
            },
            {
               "strongs": "5148",
               "greek": [
                  {
                     "_BETA": "TRIETI/A",
                     "_unicode": "τριετία",
                     "_translit": "trietía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tree-et-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2094"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a three years' period\n (triennium)",
               "kjv_def": ":--space of three years.",
               "_strongs": "05148"
            },
            {
               "strongs": "5149",
               "greek": [
                  {
                     "_BETA": "TRI/ZW",
                     "_unicode": "τρίζω",
                     "_translit": "trízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trid'-zo"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to creak (squeak), i.e. (by analogy) to\n grate the teeth (in frenzy)",
               "kjv_def": ":--gnash.",
               "_strongs": "05149"
            },
            {
               "strongs": "5150",
               "greek": [
                  {
                     "_BETA": "TRI/MHNON",
                     "_unicode": "τρίμηνον",
                     "_translit": "trímēnon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trim'-ay-non"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3376"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n as noun;"
               },
               "strongs_def": "a three months'\n space",
               "kjv_def": ":--three months.",
               "_strongs": "05150"
            },
            {
               "strongs": "5151",
               "greek": [
                  {
                     "_BETA": "TRI/S",
                     "_unicode": "τρίς",
                     "_translit": "trís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trece"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "three times",
               "kjv_def": ":--three times, thrice.",
               "_strongs": "05151"
            },
            {
               "strongs": "5152",
               "greek": [
                  {
                     "_BETA": "TRI/STEGON",
                     "_unicode": "τρίστεγον",
                     "_translit": "trístegon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tris'-teg-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4721"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n as noun;"
               },
               "strongs_def": "a third roof\n (story)",
               "kjv_def": ":--third loft.",
               "_strongs": "05152"
            },
            {
               "strongs": "5153",
               "greek": [
                  {
                     "_BETA": "TRISXI/LIOI",
                     "_unicode": "τρισχίλιοι",
                     "_translit": "trischílioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tris-khil'-ee-oy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5151"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5507"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "three times a thousand",
               "kjv_def": ":--three thousand.",
               "_strongs": "05153"
            },
            {
               "strongs": "5154",
               "greek": [
                  {
                     "_BETA": "TRI/TOS",
                     "_unicode": "τρίτος",
                     "_translit": "trítos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tree'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5140"
                     }
                  ],
                  "__text": "ordinal from \n;"
               },
               "strongs_def": "third; neuter (as noun) a third part, or (as\n adverb) a (or the) third time, thirdly",
               "kjv_def": ":--third(-ly).",
               "_strongs": "05154"
            },
            {
               "strongs": "5155",
               "greek": [
                  {
                     "_BETA": "TRI/XINOS",
                     "_unicode": "τρίχινος",
                     "_translit": "tríchinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trikh'-ee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2359"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "hairy, i.e. made of hair (mohair)",
               "kjv_def": ":--of hair.",
               "_strongs": "05155"
            },
            {
               "strongs": "5156",
               "greek": [
                  {
                     "_BETA": "TRO/MOS",
                     "_unicode": "τρόμος",
                     "_translit": "trómos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trom'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5141"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a \"trembling\", i.e. quaking with fear",
               "kjv_def": ":--+ tremble(-ing).",
               "_strongs": "05156"
            },
            {
               "strongs": "5157",
               "greek": [
                  {
                     "_BETA": "TROPH/",
                     "_unicode": "τροπή",
                     "_translit": "tropḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trop-ay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TRE/PW",
                        "_unicode": "τρέπω",
                        "_translit": "trépō"
                     }
                  ],
                  "__text": "from an apparently primary \n to turn;"
               },
               "strongs_def": "a turn (\"trope\"), i.e.\n revolution (figuratively, variation)",
               "kjv_def": ":--turning.",
               "_strongs": "05157"
            },
            {
               "strongs": "5158",
               "greek": [
                  {
                     "_BETA": "TRO/POS",
                     "_unicode": "τρόπος",
                     "_translit": "trópos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trop'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5157"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a turn, i.e. (by implication) mode or style\n (especially with preposition or relative prefix as adverb, like);\n figuratively, deportment or character",
               "kjv_def": ":--(even) as, conversation, (+\n like) manner, (+ by any) means, way.",
               "_strongs": "05158"
            },
            {
               "strongs": "5159",
               "greek": [
                  {
                     "_BETA": "TROPOFORE/W",
                     "_unicode": "τροποφορέω",
                     "_translit": "tropophoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trop-of-or-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5158"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5409"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to endure one's habits",
               "kjv_def": ":--suffer the manners.",
               "_strongs": "05159"
            },
            {
               "strongs": "5160",
               "greek": [
                  {
                     "_BETA": "TROFH/",
                     "_unicode": "τροφή",
                     "_translit": "trophḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trof-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "nourishment (literally or figuratively); by implication,\n rations (wages)",
               "kjv_def": ":--food, meat.",
               "_strongs": "05160"
            },
            {
               "strongs": "5161",
               "greek": [
                  {
                     "_BETA": "*TRO/FIMOS",
                     "_unicode": "Τρόφιμος",
                     "_translit": "Tróphimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trof'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5160"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "nutritive; Trophimus, a Christian",
               "kjv_def": ":--Trophimus.",
               "_strongs": "05161"
            },
            {
               "strongs": "5162",
               "greek": [
                  {
                     "_BETA": "TROFO/S",
                     "_unicode": "τροφός",
                     "_translit": "trophós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trof-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5142"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a nourisher, i.e. nurse",
               "kjv_def": ":--nurse.",
               "_strongs": "05162"
            },
            {
               "strongs": "5163",
               "greek": [
                  {
                     "_BETA": "TROXIA/",
                     "_unicode": "τροχιά",
                     "_translit": "trochiá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trokh-ee-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5164"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a track (as a wheel-rut), i.e. (figuratively) a course of\n conduct",
               "kjv_def": ":--path.",
               "_strongs": "05163"
            },
            {
               "strongs": "5164",
               "greek": [
                  {
                     "_BETA": "TROXO/S",
                     "_unicode": "τροχός",
                     "_translit": "trochós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "trokh-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a wheel (as a runner), i.e. (figuratively) a circuit of\n physical effects",
               "kjv_def": ":--course.",
               "_strongs": "05164"
            },
            {
               "strongs": "5165",
               "greek": [
                  {
                     "_BETA": "TRU/BLION",
                     "_unicode": "τρύβλιον",
                     "_translit": "trýblion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troob'-lee-on"
                  }
               ],
               "strongs_derivation": "neuter of a presumed derivative of uncertain affinity;",
               "strongs_def": "a bowl",
               "kjv_def": ":--dish.",
               "_strongs": "05165"
            },
            {
               "strongs": "5166",
               "greek": [
                  {
                     "_BETA": "TRUGA/W",
                     "_unicode": "τρυγάω",
                     "_translit": "trygáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troo-gah'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TRU/GW",
                        "_unicode": "τρύγω",
                        "_translit": "trýgō"
                     }
                  ],
                  "__text": "from a derivative of \n (to dry) meaning ripe fruit (as if dry);"
               },
               "strongs_def": "to\n collect the vintage",
               "kjv_def": ":--gather.",
               "_strongs": "05166"
            },
            {
               "strongs": "5167",
               "greek": [
                  {
                     "_BETA": "TRUGW/N",
                     "_unicode": "τρυγών",
                     "_translit": "trygṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troo-gone'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TRU/ZW",
                        "_unicode": "τρύζω",
                        "_translit": "trýzō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5149"
                     }
                  ],
                  "__text": "from \n (to murmur; akin to \n, but denoting a duller sound);"
               },
               "strongs_def": "a\n turtle-dove (as cooing)",
               "kjv_def": ":--turtle-dove.",
               "_strongs": "05167"
            },
            {
               "strongs": "5168",
               "greek": [
                  {
                     "_BETA": "TRUMALIA/",
                     "_unicode": "τρυμαλιά",
                     "_translit": "trymaliá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troo-mal-ee-ah'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TRU/W",
                        "_unicode": "τρύω",
                        "_translit": "trýō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5134"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5147"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5176"
                     }
                  ],
                  "__text": "from a derivative of \n (to wear away; akin to the base of \n,\n \n and \n);"
               },
               "strongs_def": "an orifice, i.e. needle's eye",
               "kjv_def": ":--eye.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5169"
                  }
               ],
               "_strongs": "05168",
               "__text": "Compare \n."
            },
            {
               "strongs": "5169",
               "greek": [
                  {
                     "_BETA": "TRU/PHMA",
                     "_unicode": "τρύπημα",
                     "_translit": "trýpēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troo'-pay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5168"
                     }
                  ],
                  "__text": "from a derivative of the base of \n;"
               },
               "strongs_def": "an aperture, i.e. a needle's\n eye",
               "kjv_def": ":--eye.",
               "_strongs": "05169"
            },
            {
               "strongs": "5170",
               "greek": [
                  {
                     "_BETA": "*TRU/FAINA",
                     "_unicode": "Τρύφαινα",
                     "_translit": "Trýphaina"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troo'-fahee-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5172"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "luxurious; Tryphæna, a Christian woman",
               "kjv_def": ":--Tryphena.",
               "_strongs": "05170"
            },
            {
               "strongs": "5171",
               "greek": [
                  {
                     "_BETA": "TRUFA/W",
                     "_unicode": "τρυφάω",
                     "_translit": "trypháō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troo-fah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5172"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to indulge in luxury",
               "kjv_def": ":--live in pleasure.",
               "_strongs": "05171"
            },
            {
               "strongs": "5172",
               "greek": [
                  {
                     "_BETA": "TRUFH/",
                     "_unicode": "τρυφή",
                     "_translit": "tryphḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troo-fay'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "QRU/PTW",
                        "_unicode": "θρύπτω",
                        "_translit": "thrýptō"
                     }
                  ],
                  "__text": "from \n (to break up or (figuratively) enfeeble, especially the\n mind and body by indulgence);"
               },
               "strongs_def": "effeminacy, i.e. luxury or\n debauchery",
               "kjv_def": ":--delicately, riot.",
               "_strongs": "05172"
            },
            {
               "strongs": "5173",
               "greek": [
                  {
                     "_BETA": "*TRUFW=SA",
                     "_unicode": "Τρυφῶσα",
                     "_translit": "Tryphōsa"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "troo-fo'-sah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5172"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "luxuriating; Tryphosa, a Christian female",
               "kjv_def": ":--Tryphosa.",
               "_strongs": "05173"
            },
            {
               "strongs": "5174",
               "greek": [
                  {
                     "_BETA": "*TRWA/S",
                     "_unicode": "Τρωάς",
                     "_translit": "Trōás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tro-as'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*TRO/S",
                        "_unicode": "Τρός",
                        "_translit": "Trós"
                     }
                  ],
                  "__text": "from \n (a Trojan);"
               },
               "strongs_def": "the Troad (or plain of Troy), i.e. Troas, a\n place in Asia Minor",
               "kjv_def": ":--Troas.",
               "_strongs": "05174"
            },
            {
               "strongs": "5175",
               "greek": [
                  {
                     "_BETA": "*TRWGU/LLION",
                     "_unicode": "Τρωγύλλιον",
                     "_translit": "Trōgýllion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tro-gool'-lee-on"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Trogyllium, a place in Asia\n Minor",
               "kjv_def": ":--Trogyllium.",
               "_strongs": "05175"
            },
            {
               "strongs": "5176",
               "greek": [
                  {
                     "_BETA": "TRW/GW",
                     "_unicode": "τρώγω",
                     "_translit": "trṓgō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "tro'-go"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5134"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5147"
                     }
                  ],
                  "__text": "probably strengthened from a collateral form of the base of \n and\n \n through the idea of corrosion or wear;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5167"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5149"
                     }
                  ],
                  "__text": "or perhaps rather of a\n base of \n and \n through the idea of a craunching sound; to gnaw\n or chew, i.e. (generally) to eat"
               },
               "kjv_def": ":--eat.",
               "_strongs": "05176"
            },
            {
               "strongs": "5177",
               "greek": [
                  {
                     "_BETA": "TUGXA/NW",
                     "_unicode": "τυγχάνω",
                     "_translit": "tynchánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toong-khan'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TU/XW",
                        "_unicode": "τύχω",
                        "_translit": "týchō"
                     },
                     {
                        "_BETA": "TEU/XW",
                        "_unicode": "τεύχω",
                        "_translit": "teúchō"
                     }
                  ],
                  "__text": "probably for an obsolete \n (for which the middle voice of another\n alternate \n (to make ready or bring to pass) is used in certain\n tenses;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5088"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3756"
                     }
                  ],
                  "__text": "akin to the base of \n through the idea of effecting;\n properly, to affect; or (specially), to hit or light upon (as a mark\n to be reached), i.e. (transitively) to attain or secure an object or\n end, or (intransitively) to happen (as if meeting with); but in the\n latter application only impersonal (with \n), i.e. perchance; or\n (present participle) as adjective, usual (as if commonly met with,\n with \n, extraordinary), neuter (as adverb) perhaps; or (with\n another verb) as adverb, by accident (as it were)"
               },
               "kjv_def": ":--be, chance, enjoy,\n little, obtain, X refresh…self, + special.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5180"
                  }
               ],
               "_strongs": "05177",
               "__text": "Compare \n."
            },
            {
               "strongs": "5178",
               "greek": [
                  {
                     "_BETA": "TUMPANI/ZW",
                     "_unicode": "τυμπανίζω",
                     "_translit": "tympanízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toom-pan-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5180"
                     }
                  ],
                  "__text": "from a derivative of \n (meaning a drum, \"tympanum\");"
               },
               "strongs_def": "to stretch on\n an instrument of torture resembling a drum, and thus beat to\n death",
               "kjv_def": ":--torture.",
               "_strongs": "05178"
            },
            {
               "strongs": "5179",
               "greek": [
                  {
                     "_BETA": "TU/POS",
                     "_unicode": "τύπος",
                     "_translit": "týpos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5180"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a die (as struck), i.e. (by implication) a stamp or scar;\n by analogy, a shape, i.e. a statue, (figuratively) style or\n resemblance; specially, a sampler (\"type\"), i.e. a model (for\n imitation) or instance (for warning)",
               "kjv_def": ":--en-(ex-)ample, fashion, figure,\n form, manner, pattern, print.",
               "_strongs": "05179"
            },
            {
               "strongs": "5180",
               "greek": [
                  {
                     "_BETA": "TU/PTW",
                     "_unicode": "τύπτω",
                     "_translit": "týptō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toop'-to"
                  }
               ],
               "strongs_derivation": "a primary verb (in a strengthened form);",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3817"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3960"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4141"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4474"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5177"
                     }
                  ],
                  "__text": "to \"thump\", i.e. cudgel or\n pummel (properly, with a stick or bastinado), but in any case by\n repeated blows; thus differing from \n and \n, which denote a\n (usually single) blow with the hand or any instrument, or \n with\n the fist (or a hammer), or \n with the palm; as well as from \n,\n an accidental collision); by implication, to punish; figuratively, to\n offend (the conscience)"
               },
               "kjv_def": ":--beat, smite, strike, wound.",
               "_strongs": "05180"
            },
            {
               "strongs": "5181",
               "greek": [
                  {
                     "_BETA": "*TU/RANNOS",
                     "_unicode": "Τύραννος",
                     "_translit": "Týrannos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-ran-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2962"
                     }
                  ],
                  "__text": "a provincial form of the derivative of the base of \n;"
               },
               "strongs_def": "a \"tyrant\";\n Tyrannus, an Ephesian",
               "kjv_def": ":--Tyrannus.",
               "_strongs": "05181"
            },
            {
               "strongs": "5182",
               "greek": [
                  {
                     "_BETA": "TURBA/ZW",
                     "_unicode": "τυρβάζω",
                     "_translit": "tyrbázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toor-bad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "TU/RBH",
                        "_unicode": "τύρβη",
                        "_translit": "týrbē"
                     }
                  ],
                  "latin": "turba",
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2351"
                     }
                  ],
                  "__text": "from \n (Latin \n, a crowd; akin to \n);"
               },
               "strongs_def": "to make \"turbid\",\n i.e. disturb",
               "kjv_def": ":--trouble.",
               "_strongs": "05182"
            },
            {
               "strongs": "5183",
               "greek": [
                  {
                     "_BETA": "*TU/RIOS",
                     "_unicode": "Τύριος",
                     "_translit": "Týrios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-ree-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5184"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Tyrian, i.e. inhabitant of Tyrus",
               "kjv_def": ":--of Tyre.",
               "_strongs": "05183"
            },
            {
               "strongs": "5184",
               "greek": [
                  {
                     "_BETA": "*TU/ROS",
                     "_unicode": "Τύρος",
                     "_translit": "Týros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06865"
                     }
                  ],
                  "__text": "of Hebrew origin (\n): Tyrus (i.e. Tsor), a place in\n Palestine"
               },
               "kjv_def": ":--Tyre.",
               "_strongs": "05184"
            },
            {
               "strongs": "5185",
               "greek": [
                  {
                     "_BETA": "TUFLO/S",
                     "_unicode": "τυφλός",
                     "_translit": "typhlós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toof-los'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5187"
                     }
                  ],
                  "__text": "from, \n;"
               },
               "strongs_def": "opaque (as if smoky), i.e. (by analogy) blind (physically\n or mentally)",
               "kjv_def": ":--blind.",
               "_strongs": "05185"
            },
            {
               "strongs": "5186",
               "greek": [
                  {
                     "_BETA": "TUFLO/W",
                     "_unicode": "τυφλόω",
                     "_translit": "typhlóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toof-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5185"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make blind, i.e. (figuratively) to obscure",
               "kjv_def": ":--blind.",
               "_strongs": "05186"
            },
            {
               "strongs": "5187",
               "greek": [
                  {
                     "_BETA": "TUFO/W",
                     "_unicode": "τυφόω",
                     "_translit": "typhóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "toof-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5188"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to envelop with smoke, i.e. (figuratively)\n to inflate with self-conceit",
               "kjv_def": ":--high-minded, be lifted up with pride,\n be proud.",
               "_strongs": "05187"
            },
            {
               "strongs": "5188",
               "greek": [
                  {
                     "_BETA": "TU/FW",
                     "_unicode": "τύφω",
                     "_translit": "týphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too'-fo"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to make a smoke, i.e. slowly consume\n without flame",
               "kjv_def": ":--smoke.",
               "_strongs": "05188"
            },
            {
               "strongs": "5189",
               "greek": [
                  {
                     "_BETA": "TUFWNIKO/S",
                     "_unicode": "τυφωνικός",
                     "_translit": "typhōnikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too-fo-nee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5188"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "stormy (as if smoky)",
               "kjv_def": ":--tempestuous.",
               "_strongs": "05189"
            },
            {
               "strongs": "5190",
               "greek": [
                  {
                     "_BETA": "*TUXIKO/S",
                     "_unicode": "Τυχικός",
                     "_translit": "Tychikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "too-khee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5177"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "fortuitous, i.e. fortunate; Tychicus, a\n Christian",
               "kjv_def": ":--Tychicus.",
               "_strongs": "05190"
            },
            {
               "strongs": "5191",
               "greek": [
                  {
                     "_BETA": "U(AKI/NQINOS",
                     "_unicode": "ὑακίνθινος",
                     "_translit": "hyakínthinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-ak-in'-thee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5192"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "\"hyacinthine\" or \"jacinthine\", i.e. deep blue",
               "kjv_def": ":--jacinth.",
               "_strongs": "05191"
            },
            {
               "strongs": "5192",
               "greek": [
                  {
                     "_BETA": "U(A/KINQOS",
                     "_unicode": "ὑάκινθος",
                     "_translit": "hyákinthos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-ak'-in-thos"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "the \"hyacinth\" or \"jacinth\", i.e. some gem of\n a deep blue color, probably the zirkon",
               "kjv_def": ":-- jacinth.",
               "_strongs": "05192"
            },
            {
               "strongs": "5193",
               "greek": [
                  {
                     "_BETA": "U(A/LINOS",
                     "_unicode": "ὑάλινος",
                     "_translit": "hyálinos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-al'-ee-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5194"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "glassy, i.e. transparent",
               "kjv_def": ":--of glass.",
               "_strongs": "05193"
            },
            {
               "strongs": "5194",
               "greek": [
                  {
                     "_BETA": "U(/ALOS",
                     "_unicode": "ὕαλος",
                     "_translit": "hýalos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo'-al-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5205"
                     }
                  ],
                  "__text": "perhaps from the same as \n (as being transparent like rain);"
               },
               "strongs_def": "glass",
               "kjv_def": ":--glass.",
               "_strongs": "05194"
            },
            {
               "strongs": "5195",
               "greek": [
                  {
                     "_BETA": "U(BRI/ZW",
                     "_unicode": "ὑβρίζω",
                     "_translit": "hybrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-brid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5196"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to exercise violence, i.e. abuse",
               "kjv_def": ":--use despitefully,\n reproach, entreat shamefully (spitefully).",
               "_strongs": "05195"
            },
            {
               "strongs": "5196",
               "greek": [
                  {
                     "_BETA": "U(/BRIS",
                     "_unicode": "ὕβρις",
                     "_translit": "hýbris"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo'-bris"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "insolence (as over-bearing), i.e. insult, injury",
               "kjv_def": ":--harm,\n hurt, reproach.",
               "_strongs": "05196"
            },
            {
               "strongs": "5197",
               "greek": [
                  {
                     "_BETA": "U(BRISTH/S",
                     "_unicode": "ὑβριστής",
                     "_translit": "hybristḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-bris-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5195"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an insulter, i.e. maltreater",
               "kjv_def": ":--despiteful, injurious.",
               "_strongs": "05197"
            },
            {
               "strongs": "5198",
               "greek": [
                  {
                     "_BETA": "U(GIAI/NW",
                     "_unicode": "ὑγιαίνω",
                     "_translit": "hygiaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoog-ee-ah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5199"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to have sound health, i.e. be well (in body); figuratively,\n to be uncorrupt (true in doctrine)",
               "kjv_def": ":--be in health, (be safe and)\n sound, (be) whole(-some).",
               "_strongs": "05198"
            },
            {
               "strongs": "5199",
               "greek": [
                  {
                     "_BETA": "U(GIH/S",
                     "_unicode": "ὑγιής",
                     "_translit": "hygiḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoog-ee-ace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "837"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "healthy, i.e. well (in body); figuratively, true\n (in doctrine)",
               "kjv_def": ":--sound, whole.",
               "_strongs": "05199"
            },
            {
               "strongs": "5200",
               "greek": [
                  {
                     "_BETA": "U(GRO/S",
                     "_unicode": "ὑγρός",
                     "_translit": "hygrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-gros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5205"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "wet (as if with rain), i.e. (by implication)\n sappy (fresh)",
               "kjv_def": ":--green.",
               "_strongs": "05200"
            },
            {
               "strongs": "5201",
               "greek": [
                  {
                     "_BETA": "U(DRI/A",
                     "_unicode": "ὑδρία",
                     "_translit": "hydría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-dree-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5204"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a water-jar, i.e. receptacle for family supply",
               "kjv_def": ":--water-pot.",
               "_strongs": "05201"
            },
            {
               "strongs": "5202",
               "greek": [
                  {
                     "_BETA": "U(DROPOTE/W",
                     "_unicode": "ὑδροποτέω",
                     "_translit": "hydropotéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-drop-ot-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5204"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4095"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "to be a\n water-drinker, i.e. to abstain from vinous beverages",
               "kjv_def": ":--drink water.",
               "_strongs": "05202"
            },
            {
               "strongs": "5203",
               "greek": [
                  {
                     "_BETA": "U(DRWPIKO/S",
                     "_unicode": "ὑδρωπικός",
                     "_translit": "hydrōpikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-dro-pik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5204"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n (as if looking\n watery);"
               },
               "strongs_def": "to be \"dropsical\"",
               "kjv_def": ":--have the dropsy.",
               "_strongs": "05203"
            },
            {
               "strongs": "5204",
               "greek": [
                  {
                     "_BETA": "U(/DWR",
                     "_unicode": "ὕδωρ",
                     "_translit": "hýdōr"
                  },
                  {
                     "_BETA": "U(/DATOS",
                     "_unicode": "ὕδατος",
                     "_translit": "hýdatos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo'-dore"
                  },
                  {
                     "_strongs": "hoo'-dat-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5205"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "water (as if rainy) literally or\n figuratively",
               "kjv_def": ":--water.",
               "_strongs": "05204",
               "__text": ",   and genitive case,\n      \n  \n, etc."
            },
            {
               "strongs": "5205",
               "greek": [
                  {
                     "_BETA": "U(ETO/S",
                     "_unicode": "ὑετός",
                     "_translit": "hyetós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-et-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "U(/W",
                        "_unicode": "ὕω",
                        "_translit": "hýō"
                     }
                  ],
                  "__text": "from a primary \n (to rain);"
               },
               "strongs_def": "rain, especially a shower",
               "kjv_def": ":--rain.",
               "_strongs": "05205"
            },
            {
               "strongs": "5206",
               "greek": [
                  {
                     "_BETA": "UI(OQESI/A",
                     "_unicode": "υἱοθεσία",
                     "_translit": "huiothesía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hwee-oth-es-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5207"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from a presumed compound of \n and a derivative of \n;"
               },
               "strongs_def": "the placing\n as a son, i.e. adoption (figuratively, Christian sonship in respect to\n God)",
               "kjv_def": ":--adoption (of children, of sons).",
               "_strongs": "05206"
            },
            {
               "strongs": "5207",
               "greek": [
                  {
                     "_BETA": "UI(O/S",
                     "_unicode": "υἱός",
                     "_translit": "huiós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hwee-os'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a \"son\" (sometimes of animals), used very\n widely of immediate, remote or figuratively, kinship",
               "kjv_def": ":--child, foal,\n son.",
               "_strongs": "05207"
            },
            {
               "strongs": "5208",
               "greek": [
                  {
                     "_BETA": "U(/LH",
                     "_unicode": "ὕλη",
                     "_translit": "hýlē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-lay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3586"
                     }
                  ],
                  "__text": "perhaps akin to \n;"
               },
               "strongs_def": "a forest, i.e. (by implication) fuel",
               "kjv_def": ":--matter.",
               "_strongs": "05208"
            },
            {
               "strongs": "5209",
               "greek": [
                  {
                     "_BETA": "U(MA=S",
                     "_unicode": "ὑμᾶς",
                     "_translit": "hymâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-mas'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5210"
                     }
                  ],
                  "__text": "accusative case of \n;"
               },
               "strongs_def": "you (as the objective of a verb or\n preposition)",
               "kjv_def": ":--ye, you (+ -ward), your (+ own).",
               "_strongs": "05209"
            },
            {
               "strongs": "5210",
               "greek": [
                  {
                     "_BETA": "U(MEI=S",
                     "_unicode": "ὑμεῖς",
                     "_translit": "hymeîs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-mice'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4771"
                     }
                  ],
                  "__text": "irregular plural of \n;"
               },
               "strongs_def": "you (as subjective of verb)",
               "kjv_def": ":--ye\n (yourselves), you.",
               "_strongs": "05210"
            },
            {
               "strongs": "5211",
               "greek": [
                  {
                     "_BETA": "*(UMENAI=OS",
                     "_unicode": "Ὑμεναῖος",
                     "_translit": "Hymenaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-men-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*(UMH/N",
                        "_unicode": "Ὑμήν",
                        "_translit": "Hymḗn"
                     }
                  ],
                  "__text": "from \n (the god of weddings);"
               },
               "strongs_def": "\"hymenæal\"; Hymenæus, an opponent of\n Christianity",
               "kjv_def": ":--Hymenæus.",
               "_strongs": "05211"
            },
            {
               "strongs": "5212",
               "greek": [
                  {
                     "_BETA": "U(ME/TEROS",
                     "_unicode": "ὑμέτερος",
                     "_translit": "hyméteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-met'-er-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5210"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "yours, i.e. pertaining to you",
               "kjv_def": ":--your (own).",
               "_strongs": "05212"
            },
            {
               "strongs": "5213",
               "greek": [
                  {
                     "_BETA": "U(MI=N",
                     "_unicode": "ὑμῖν",
                     "_translit": "hymîn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-min'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5210"
                     }
                  ],
                  "__text": "irregular dative case of \n;"
               },
               "strongs_def": "to (with or by) you",
               "kjv_def": ":--ye, you,\n your(-selves).",
               "_strongs": "05213"
            },
            {
               "strongs": "5214",
               "greek": [
                  {
                     "_BETA": "U(MNE/W",
                     "_unicode": "ὑμνέω",
                     "_translit": "hymnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoom-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5215"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to hymn, i.e. sing a religious ode; by implication, to\n celebrate (God) in song",
               "kjv_def": ":--sing a hymn (praise unto).",
               "_strongs": "05214"
            },
            {
               "strongs": "5215",
               "greek": [
                  {
                     "_BETA": "U(/MNOS",
                     "_unicode": "ὕμνος",
                     "_translit": "hýmnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoom'-nos"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "U(DE/W",
                        "_unicode": "ὑδέω",
                        "_translit": "hydéō"
                     }
                  ],
                  "__text": "apparently from a simpler (obsolete) form of \n (to celebrate;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "103"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "05667"
                     }
                  ],
                  "__text": "probably akin to \n; compare \n); a \"hymn\" or religious ode (one of\n the Psalms)"
               },
               "kjv_def": ":--hymn.",
               "_strongs": "05215"
            },
            {
               "strongs": "5216",
               "greek": [
                  {
                     "_BETA": "U(MW=N",
                     "_unicode": "ὑμῶν",
                     "_translit": "hymōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-mone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5210"
                     }
                  ],
                  "__text": "genitive case of \n;"
               },
               "strongs_def": "of (from or concerning) you",
               "kjv_def": ":--ye, you, your\n (own, -selves).",
               "_strongs": "05216"
            },
            {
               "strongs": "5217",
               "greek": [
                  {
                     "_BETA": "U(PA/GW",
                     "_unicode": "ὑπάγω",
                     "_translit": "hypágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to lead (oneself) under, i.e. withdraw or retire (as\n if sinking out of sight), literally or figuratively",
               "kjv_def": ":--depart, get\n hence, go (a-)way.",
               "_strongs": "05217"
            },
            {
               "strongs": "5218",
               "greek": [
                  {
                     "_BETA": "U(PAKOH/",
                     "_unicode": "ὑπακοή",
                     "_translit": "hypakoḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ak-o-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5219"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "attentive hearkening, i.e. (by implication) compliance or\n submission",
               "kjv_def": ":--obedience, (make) obedient, obey(-ing).",
               "_strongs": "05218"
            },
            {
               "strongs": "5219",
               "greek": [
                  {
                     "_BETA": "U(PAKOU/W",
                     "_unicode": "ὑπακούω",
                     "_translit": "hypakoúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ak-oo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "191"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hear under (as a subordinate), i.e. to listen\n attentively; by implication, to heed or conform to a command or\n authority",
               "kjv_def": ":--hearken, be obedient to, obey.",
               "_strongs": "05219"
            },
            {
               "strongs": "5220",
               "greek": [
                  {
                     "_BETA": "U(/PANDROS",
                     "_unicode": "ὕπανδρος",
                     "_translit": "hýpandros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop'-an-dros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "in subjection under a man, i.e. a married\n woman",
               "kjv_def": ":--which hath an husband.",
               "_strongs": "05220"
            },
            {
               "strongs": "5221",
               "greek": [
                  {
                     "_BETA": "U(PANTA/W",
                     "_unicode": "ὑπαντάω",
                     "_translit": "hypantáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-an-tah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "473"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "to go opposite (meet) under\n (quietly), i.e. to encounter, fall in with",
               "kjv_def": ":--(go to) meet.",
               "_strongs": "05221"
            },
            {
               "strongs": "5222",
               "greek": [
                  {
                     "_BETA": "U(PA/NTHSIS",
                     "_unicode": "ὑπάντησις",
                     "_translit": "hypántēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-an'-tay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5221"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     }
                  ],
                  "__text": "an encounter or concurrence (with \n for infinitive, in\n order to fall in with)"
               },
               "kjv_def": ":--meeting.",
               "_strongs": "05222"
            },
            {
               "strongs": "5223",
               "greek": [
                  {
                     "_BETA": "U(/PARCIS",
                     "_unicode": "ὕπαρξις",
                     "_translit": "hýparxis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop'-arx-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5225"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "existency or proprietorship, i.e. (concretely) property,\n wealth",
               "kjv_def": ":--goods, substance.",
               "_strongs": "05223"
            },
            {
               "strongs": "5224",
               "greek": [
                  {
                     "_BETA": "U(PA/RXONTA",
                     "_unicode": "ὑπάρχοντα",
                     "_translit": "hypárchonta"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ar'-khon-tah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5225"
                     }
                  ],
                  "__text": "neuter plural of present participle active of \n as noun;"
               },
               "strongs_def": "things\n extant or in hand, i.e. property or possessions",
               "kjv_def": ":--goods, that which\n one has, things which (one) possesseth, substance, that hast.",
               "_strongs": "05224"
            },
            {
               "strongs": "5225",
               "greek": [
                  {
                     "_BETA": "U(PA/RXW",
                     "_unicode": "ὑπάρχω",
                     "_translit": "hypárchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ar'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "756"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to begin under (quietly), i.e. come into existence\n (be present or at hand); expletively, to exist (as copula or\n subordinate to an adjective, participle, adverb or preposition, or as\n an auxiliary to a principal (verb)",
               "kjv_def": ":--after, behave, live.",
               "_strongs": "05225"
            },
            {
               "strongs": "5226",
               "greek": [
                  {
                     "_BETA": "U(PEI/KW",
                     "_unicode": "ὑπείκω",
                     "_translit": "hypeíkō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-i'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "EI)/KW",
                        "_unicode": "εἴκω",
                        "_translit": "eíkō"
                     }
                  ],
                  "__text": "from \n and \n (to yield, be \"weak\");"
               },
               "strongs_def": "to surrender",
               "kjv_def": ":--submit self.",
               "_strongs": "05226"
            },
            {
               "strongs": "5227",
               "greek": [
                  {
                     "_BETA": "U(PENANTI/OS",
                     "_unicode": "ὑπεναντίος",
                     "_translit": "hypenantíos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-en-an-tee'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1727"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "under (covertly) contrary to, i.e. opposed or (as\n noun) an opponent",
               "kjv_def": ":--adversary, against.",
               "_strongs": "05227"
            },
            {
               "strongs": "5228",
               "greek": [
                  {
                     "_BETA": "U(PE/R",
                     "_unicode": "ὑπέρ",
                     "_translit": "hypér"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er'"
                  }
               ],
               "strongs_derivation": "a primary preposition;",
               "strongs_def": "\"over\", i.e. (with the genitive case) of place,\n above, beyond, across, or causal, for the sake of, instead, regarding;\n with the accusative case superior to, more than",
               "kjv_def": ":--(+ exceeding,\n abundantly) above, in (on) behalf of, beyond, by, + very chiefest,\n concerning, exceeding (above, -ly), for, + very highly, more (than),\n of, over, on the part of, for sake of, in stead, than, to(-ward),\n very.",
               "_strongs": "05228",
               "__text": "In the compounds, it retains many of the above applications."
            },
            {
               "strongs": "5229",
               "greek": [
                  {
                     "_BETA": "U(PERAI/ROMAI",
                     "_unicode": "ὑπεραίρομαι",
                     "_translit": "hyperaíromai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-ah'-ee-rom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "142"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to raise oneself over, i.e.\n (figuratively) to become haughty",
               "kjv_def": ":--exalt self, be exalted above\n measure.",
               "_strongs": "05229"
            },
            {
               "strongs": "5230",
               "greek": [
                  {
                     "_BETA": "U(PE/RAKMOS",
                     "_unicode": "ὑπέρακμος",
                     "_translit": "hypérakmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er'-ak-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "188"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "beyond the \"acme\", i.e. figuratively\n (of a daughter) past the bloom (prime) of youth",
               "kjv_def": ":--+ pass the flower of\n (her) age.",
               "_strongs": "05230"
            },
            {
               "strongs": "5231",
               "greek": [
                  {
                     "_BETA": "U(PERA/NW",
                     "_unicode": "ὑπεράνω",
                     "_translit": "hyperánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-an'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "507"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "above upward, i.e. greatly higher (in place or\n rank)",
               "kjv_def": ":--far above, over.",
               "_strongs": "05231"
            },
            {
               "strongs": "5232",
               "greek": [
                  {
                     "_BETA": "U(PERAUCA/NW",
                     "_unicode": "ὑπεραυξάνω",
                     "_translit": "hyperauxánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-owx-an'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "837"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to increase above ordinary degree",
               "kjv_def": ":--grow\n exceedingly.",
               "_strongs": "05232"
            },
            {
               "strongs": "5233",
               "greek": [
                  {
                     "_BETA": "U(PERBAI/NW",
                     "_unicode": "ὑπερβαίνω",
                     "_translit": "hyperbaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-bah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "939"
                     }
                  ],
                  "__text": "from \n and the base of \n;"
               },
               "strongs_def": "to transcend, i.e. (figuratively) to\n overreach",
               "kjv_def": ":--go beyond.",
               "_strongs": "05233"
            },
            {
               "strongs": "5234",
               "greek": [
                  {
                     "_BETA": "U(PERBALLO/NTWS",
                     "_unicode": "ὑπερβαλλόντως",
                     "_translit": "hyperballóntōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-bal-lon'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5235"
                     }
                  ],
                  "__text": "adverb from present participle active of \n;"
               },
               "strongs_def": "excessively",
               "kjv_def": ":--beyond\n measure.",
               "_strongs": "05234"
            },
            {
               "strongs": "5235",
               "greek": [
                  {
                     "_BETA": "U(PERBA/LLW",
                     "_unicode": "ὑπερβάλλω",
                     "_translit": "hyperbállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-bal'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw beyod the usual mark, i.e. (figuratively)\n to surpass (only active participle supereminent)",
               "kjv_def": ":--exceeding, excel,\n pass.",
               "_strongs": "05235"
            },
            {
               "strongs": "5236",
               "greek": [
                  {
                     "_BETA": "U(PERBOLH/",
                     "_unicode": "ὑπερβολή",
                     "_translit": "hyperbolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-bol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5235"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1519"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2596"
                     }
                  ],
                  "__text": "a throwing beyond others, i.e. (figuratively)\n supereminence; adverbially (with \n or \n) pre-\n eminently"
               },
               "kjv_def": ":--abundance, (far more) exceeding, excellency, more\n excellent, beyond (out of) measure.",
               "_strongs": "05236"
            },
            {
               "strongs": "5237",
               "greek": [
                  {
                     "_BETA": "U(PEREI/DW",
                     "_unicode": "ὑπερείδω",
                     "_translit": "hypereídō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-i'-do"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1492"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to overlook, i.e. not punish",
               "kjv_def": ":--wink at.",
               "_strongs": "05237"
            },
            {
               "strongs": "5238",
               "greek": [
                  {
                     "_BETA": "U(PERE/KEINA",
                     "_unicode": "ὑπερέκεινα",
                     "_translit": "hyperékeina"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-ek'-i-nah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1565"
                     }
                  ],
                  "__text": "from \n and the neuter plural of \n;"
               },
               "strongs_def": "above those parts, i.e. still\n farther",
               "kjv_def": ":--beyond.",
               "_strongs": "05238"
            },
            {
               "strongs": "5239",
               "greek": [
                  {
                     "_BETA": "U(PEREKTEI/NW",
                     "_unicode": "ὑπερεκτείνω",
                     "_translit": "hyperekteínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-ek-ti'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1614"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to extend inordinately",
               "kjv_def": ":--stretch beyond.",
               "_strongs": "05239"
            },
            {
               "strongs": "5240",
               "greek": [
                  {
                     "_BETA": "U(PEREKXU/NW",
                     "_unicode": "ὑπερεκχύνω",
                     "_translit": "hyperekchýnō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-ek-khoo'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1632"
                     }
                  ],
                  "__text": "from \n and the alternate form of \n;"
               },
               "strongs_def": "to pour out over, i.e.\n (passively) to overflow",
               "kjv_def": ":--run over.",
               "_strongs": "05240"
            },
            {
               "strongs": "5241",
               "greek": [
                  {
                     "_BETA": "U(PERENTUGXA/NW",
                     "_unicode": "ὑπερεντυγχάνω",
                     "_translit": "hyperentynchánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-en-toong-khan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1793"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to intercede in behalf of",
               "kjv_def": ":--make intercession for.",
               "_strongs": "05241"
            },
            {
               "strongs": "5242",
               "greek": [
                  {
                     "_BETA": "U(PERE/XW",
                     "_unicode": "ὑπερέχω",
                     "_translit": "hyperéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hold oneself above, i.e. (figuratively) to\n excel; participle (as adjective, or neuter as noun) superior,\n superiority",
               "kjv_def": ":--better, excellency, higher, pass, supreme.",
               "_strongs": "05242"
            },
            {
               "strongs": "5243",
               "greek": [
                  {
                     "_BETA": "U(PERHFANI/A",
                     "_unicode": "ὑπερηφανία",
                     "_translit": "hyperēphanía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-ay-fan-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5244"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "haughtiness",
               "kjv_def": ":--pride.",
               "_strongs": "05243"
            },
            {
               "strongs": "5244",
               "greek": [
                  {
                     "_BETA": "U(PERH/FANOS",
                     "_unicode": "ὑπερήφανος",
                     "_translit": "hyperḗphanos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-ay'-fan-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "appearing above others (conspicuous), i.e.\n (figuratively) haughty",
               "kjv_def": ":--proud.",
               "_strongs": "05244"
            },
            {
               "strongs": "5245",
               "greek": [
                  {
                     "_BETA": "U(PERNIKA/W",
                     "_unicode": "ὑπερνικάω",
                     "_translit": "hypernikáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-nik-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3528"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to vanquish beyond, i.e. gain a decisive\n victory",
               "kjv_def": ":--more than conquer.",
               "_strongs": "05245"
            },
            {
               "strongs": "5246",
               "greek": [
                  {
                     "_BETA": "U(PE/ROGKOS",
                     "_unicode": "ὑπέρογκος",
                     "_translit": "hypéronkos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er'-ong-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3591"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "bulging over, i.e. (figuratively) insolent",
               "kjv_def": ":--great\n swelling.",
               "_strongs": "05246"
            },
            {
               "strongs": "5247",
               "greek": [
                  {
                     "_BETA": "U(PEROXH/",
                     "_unicode": "ὑπεροχή",
                     "_translit": "hyperochḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-okh-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5242"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "prominence, i.e. (figuratively) superiority (in rank or\n character)",
               "kjv_def": ":--authority, excellency.",
               "_strongs": "05247"
            },
            {
               "strongs": "5248",
               "greek": [
                  {
                     "_BETA": "U(PERPERISSEU/W",
                     "_unicode": "ὑπερπερισσεύω",
                     "_translit": "hyperperisseúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-per-is-syoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4052"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to super-abound",
               "kjv_def": ":--abound much more, exceeding.",
               "_strongs": "05248"
            },
            {
               "strongs": "5249",
               "greek": [
                  {
                     "_BETA": "U(PERPERISSW=S",
                     "_unicode": "ὑπερπερισσῶς",
                     "_translit": "hyperperissōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-per-is-soce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4057"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "superabundantly, i.e. exceedingly",
               "kjv_def": ":--beyond\n measure.",
               "_strongs": "05249"
            },
            {
               "strongs": "5250",
               "greek": [
                  {
                     "_BETA": "U(PERPLEONA/ZW",
                     "_unicode": "ὑπερπλεονάζω",
                     "_translit": "hyperpleonázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-pleh-on-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4121"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to superabound",
               "kjv_def": ":--be exceeding abundant.",
               "_strongs": "05250"
            },
            {
               "strongs": "5251",
               "greek": [
                  {
                     "_BETA": "U(PERUYO/W",
                     "_unicode": "ὑπερυψόω",
                     "_translit": "hyperypsóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-oop-so'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5312"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to elevate above others, i.e. raise to the highest\n position",
               "kjv_def": ":--highly exalt.",
               "_strongs": "05251"
            },
            {
               "strongs": "5252",
               "greek": [
                  {
                     "_BETA": "U(PERFRONE/W",
                     "_unicode": "ὑπερφρονέω",
                     "_translit": "hyperphronéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-fron-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5426"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to esteem oneself overmuch, i.e. be vain or\n arrogant",
               "kjv_def": ":--think more highly.",
               "_strongs": "05252"
            },
            {
               "strongs": "5253",
               "greek": [
                  {
                     "_BETA": "U(PERW=|ON",
                     "_unicode": "ὑπερῷον",
                     "_translit": "hyperōion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-er-o'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "a higher part of the house, i.e.\n apartment in the third story",
               "kjv_def": ":--upper chamber (room).",
               "_strongs": "05253"
            },
            {
               "strongs": "5254",
               "greek": [
                  {
                     "_BETA": "U(PE/XW",
                     "_unicode": "ὑπέχω",
                     "_translit": "hypéchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2192"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to hold oneself under, i.e. endure with\n patience",
               "kjv_def": ":--suffer.",
               "_strongs": "05254"
            },
            {
               "strongs": "5255",
               "greek": [
                  {
                     "_BETA": "U(PH/KOOS",
                     "_unicode": "ὑπήκοος",
                     "_translit": "hypḗkoos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ay'-ko-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5219"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "attentively listening, i.e. (by implication)\n submissive",
               "kjv_def": ":--obedient.",
               "_strongs": "05255"
            },
            {
               "strongs": "5256",
               "greek": [
                  {
                     "_BETA": "U(PHRETE/W",
                     "_unicode": "ὑπηρετέω",
                     "_translit": "hypēretéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ay-ret-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5257"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a subordinate, i.e. (by implication)\n subserve",
               "kjv_def": ":--minister (unto), serve.",
               "_strongs": "05256"
            },
            {
               "strongs": "5257",
               "greek": [
                  {
                     "_BETA": "U(PHRE/THS",
                     "_unicode": "ὑπηρέτης",
                     "_translit": "hypērétēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ay-ret'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "E)RE/SSW",
                        "_unicode": "ἐρέσσω",
                        "_translit": "eréssō"
                     }
                  ],
                  "__text": "from \n and a derivative of \n (to row);"
               },
               "strongs_def": "an under-oarsman, i.e.\n (generally) subordinate (assistant, sexton, constable)",
               "kjv_def": ":--minister,\n officer, servant.",
               "_strongs": "05257"
            },
            {
               "strongs": "5258",
               "greek": [
                  {
                     "_BETA": "U(/PNOS",
                     "_unicode": "ὕπνος",
                     "_translit": "hýpnos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop'-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     }
                  ],
                  "__text": "from an obsolete primary (perhaps akin to \n through the idea of\n subsilience);"
               },
               "strongs_def": "sleep, i.e. (figuratively) spiritual torpor",
               "kjv_def": ":--sleep.",
               "_strongs": "05258"
            },
            {
               "strongs": "5259",
               "greek": [
                  {
                     "_BETA": "U(PO/",
                     "_unicode": "ὑπό",
                     "_translit": "hypó"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-o'"
                  }
               ],
               "strongs_derivation": "a primary preposition;",
               "strongs_def": "under, i.e. (with the genitive case) of place\n (beneath), or with verbs (the agency or means, through); (with the\n accusative case) of place (whither (underneath) or where (below) or\n time (when (at))",
               "kjv_def": ":--among, by, from, in, of, under, with.",
               "_strongs": "05259",
               "__text": "In the\n compounds, it retains the same general applications, especially of\n inferior position or condition, and specially, covertly or moderately."
            },
            {
               "strongs": "5260",
               "greek": [
                  {
                     "_BETA": "U(POBA/LLW",
                     "_unicode": "ὑποβάλλω",
                     "_translit": "hypobállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ob-al'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "906"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to throw in stealthily, i.e. introduce by\n collusion",
               "kjv_def": ":--suborn.",
               "_strongs": "05260"
            },
            {
               "strongs": "5261",
               "greek": [
                  {
                     "_BETA": "U(POGRAMMO/S",
                     "_unicode": "ὑπογραμμός",
                     "_translit": "hypogrammós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-og-ram-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "an underwriting, i.e. copy for\n imitation (figuratively)",
               "kjv_def": ":--example.",
               "_strongs": "05261"
            },
            {
               "strongs": "5262",
               "greek": [
                  {
                     "_BETA": "U(PO/DEIGMA",
                     "_unicode": "ὑπόδειγμα",
                     "_translit": "hypódeigma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-od'-igue-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5263"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an exhibit for imitation or warning (figuratively,\n specimen, adumbration)",
               "kjv_def": ":--en-(ex-)ample, pattern.",
               "_strongs": "05262"
            },
            {
               "strongs": "5263",
               "greek": [
                  {
                     "_BETA": "U(PODEI/KNUMI",
                     "_unicode": "ὑποδείκνυμι",
                     "_translit": "hypodeíknymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-od-ike'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1166"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to exhibit under the eyes, i.e. (figuratively) to\n exemplify (instruct, admonish)",
               "kjv_def": ":--show, (fore-)warn.",
               "_strongs": "05263"
            },
            {
               "strongs": "5264",
               "greek": [
                  {
                     "_BETA": "U(PODE/XOMAI",
                     "_unicode": "ὑποδέχομαι",
                     "_translit": "hypodéchomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-od-ekh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1209"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to admit under one's roof, i.e. entertain\n hospitably",
               "kjv_def": ":--receive.",
               "_strongs": "05264"
            },
            {
               "strongs": "5265",
               "greek": [
                  {
                     "_BETA": "U(PODE/W",
                     "_unicode": "ὑποδέω",
                     "_translit": "hypodéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-od-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1210"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bind under one's feet, i.e. put on shoes or\n sandals",
               "kjv_def": ":--bind on, (be) shod.",
               "_strongs": "05265"
            },
            {
               "strongs": "5266",
               "greek": [
                  {
                     "_BETA": "U(PO/DHMA",
                     "_unicode": "ὑπόδημα",
                     "_translit": "hypódēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-od'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5265"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something bound under the feet, i.e. a shoe or\n sandal",
               "kjv_def": ":--shoe.",
               "_strongs": "05266"
            },
            {
               "strongs": "5267",
               "greek": [
                  {
                     "_BETA": "U(PO/DIKOS",
                     "_unicode": "ὑπόδικος",
                     "_translit": "hypódikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-od'-ee-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1349"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "under sentence, i.e. (by implication)\n condemned",
               "kjv_def": ":--guilty.",
               "_strongs": "05267"
            },
            {
               "strongs": "5268",
               "greek": [
                  {
                     "_BETA": "U(POZU/GION",
                     "_unicode": "ὑποζύγιον",
                     "_translit": "hypozýgion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-od-zoog'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2218"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n;"
               },
               "strongs_def": "an animal under the yoke\n (draught-beast), i.e. (specially), a donkey",
               "kjv_def": ":--ass.",
               "_strongs": "05268"
            },
            {
               "strongs": "5269",
               "greek": [
                  {
                     "_BETA": "U(POZW/NNUMI",
                     "_unicode": "ὑποζώννυμι",
                     "_translit": "hypozṓnnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-od-zone'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2224"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to gird under, i.e. frap (a vessel with cables\n across the keel, sides and deck)",
               "kjv_def": ":--undergirt.",
               "_strongs": "05269"
            },
            {
               "strongs": "5270",
               "greek": [
                  {
                     "_BETA": "U(POKA/TW",
                     "_unicode": "ὑποκάτω",
                     "_translit": "hypokátō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ok-at'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2736"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "down under, i.e. beneath",
               "kjv_def": ":--under.",
               "_strongs": "05270"
            },
            {
               "strongs": "5271",
               "greek": [
                  {
                     "_BETA": "U(POKRI/NOMAI",
                     "_unicode": "ὑποκρίνομαι",
                     "_translit": "hypokrínomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ok-rin'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2919"
                     }
                  ],
                  "__text": "middle voice from \n and \n;"
               },
               "strongs_def": "to decide (speak or act) under a\n false part, i.e. (figuratively) dissemble (pretend)",
               "kjv_def": ":--feign.",
               "_strongs": "05271"
            },
            {
               "strongs": "5272",
               "greek": [
                  {
                     "_BETA": "U(PO/KRISIS",
                     "_unicode": "ὑπόκρισις",
                     "_translit": "hypókrisis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ok'-ree-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5271"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "acting under a feigned part, i.e. (figuratively) deceit\n (\"hypocrisy\")",
               "kjv_def": ":--condemnation, dissimulation, hypocrisy.",
               "_strongs": "05272"
            },
            {
               "strongs": "5273",
               "greek": [
                  {
                     "_BETA": "U(POKRITH/S",
                     "_unicode": "ὑποκριτής",
                     "_translit": "hypokritḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ok-ree-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5271"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an actor under an assumed character (stage-player), i.e.\n (figuratively) a dissembler (\"hypocrite\"",
               "kjv_def": ":--hypocrite.",
               "_strongs": "05273"
            },
            {
               "strongs": "5274",
               "greek": [
                  {
                     "_BETA": "U(POLAMBA/NW",
                     "_unicode": "ὑπολαμβάνω",
                     "_translit": "hypolambánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ol-am-ban'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2983"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to take from below, i.e. carry upward;\n figuratively, to take up, i.e. continue a discourse or topic;\n mentally, to assume (presume)",
               "kjv_def": ":--answer, receive, suppose.",
               "_strongs": "05274"
            },
            {
               "strongs": "5275",
               "greek": [
                  {
                     "_BETA": "U(POLEI/PW",
                     "_unicode": "ὑπολείπω",
                     "_translit": "hypoleípō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ol-i'-po"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5295"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to leave under (behind), i.e. (passively) to\n remain (survive)",
               "kjv_def": ":--be left.",
               "_strongs": "05275"
            },
            {
               "strongs": "5276",
               "greek": [
                  {
                     "_BETA": "U(POLH/NION",
                     "_unicode": "ὑπολήνιον",
                     "_translit": "hypolḗnion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ol-ay'-nee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3025"
                     }
                  ],
                  "__text": "neuter of a presumed compound of \n and \n;"
               },
               "strongs_def": "vessel or receptacle\n under the press, i.e. lower wine-vat",
               "kjv_def": ":--winefat.",
               "_strongs": "05276"
            },
            {
               "strongs": "5277",
               "greek": [
                  {
                     "_BETA": "U(POLIMPA/NW",
                     "_unicode": "ὑπολιμπάνω",
                     "_translit": "hypolimpánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ol-im-pan'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5275"
                     }
                  ],
                  "__text": "a prolonged form for \n;"
               },
               "strongs_def": "to leave behind, i.e. bequeath",
               "kjv_def": ":--leave.",
               "_strongs": "05277"
            },
            {
               "strongs": "5278",
               "greek": [
                  {
                     "_BETA": "U(POME/NW",
                     "_unicode": "ὑπομένω",
                     "_translit": "hypoménō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-om-en'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3306"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to stay under (behind), i.e. remain; figuratively,\n to undergo, i.e. bear (trials), have fortitude, persevere",
               "kjv_def": ":--abide,\n endure, (take) patient(-ly), suffer, tarry behind.",
               "_strongs": "05278"
            },
            {
               "strongs": "5279",
               "greek": [
                  {
                     "_BETA": "U(POMIMNH/SKW",
                     "_unicode": "ὑπομιμνήσκω",
                     "_translit": "hypomimnḗskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-om-im-nace'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3403"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to remind quietly, i.e. suggest to the (middle\n voice, one's own) memory",
               "kjv_def": ":--put in mind, remember, bring to (put in)\n remembrance.",
               "_strongs": "05279"
            },
            {
               "strongs": "5280",
               "greek": [
                  {
                     "_BETA": "U(PO/MNHSIS",
                     "_unicode": "ὑπόμνησις",
                     "_translit": "hypómnēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-om'-nay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5279"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a reminding or (reflexively) recollection",
               "kjv_def": ":--remembrance.",
               "_strongs": "05280"
            },
            {
               "strongs": "5281",
               "greek": [
                  {
                     "_BETA": "U(POMONH/",
                     "_unicode": "ὑπομονή",
                     "_translit": "hypomonḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-om-on-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5278"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cheerful (or hopeful) endurance, constancy",
               "kjv_def": ":--enduring,\n patience, patient continuance (waiting).",
               "_strongs": "05281"
            },
            {
               "strongs": "5282",
               "greek": [
                  {
                     "_BETA": "U(PONOE/W",
                     "_unicode": "ὑπονοέω",
                     "_translit": "hyponoéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-on-o-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3539"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to think under (privately), i.e. to surmise or\n conjecture",
               "kjv_def": ":--think, suppose, deem.",
               "_strongs": "05282"
            },
            {
               "strongs": "5283",
               "greek": [
                  {
                     "_BETA": "U(PO/NOIA",
                     "_unicode": "ὑπόνοια",
                     "_translit": "hypónoia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-on'-oy-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5282"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "suspicion",
               "kjv_def": ":--surmising.",
               "_strongs": "05283"
            },
            {
               "strongs": "5284",
               "greek": [
                  {
                     "_BETA": "U(POPLE/W",
                     "_unicode": "ὑποπλέω",
                     "_translit": "hypopléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-op-leh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4126"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to sail under the lee of",
               "kjv_def": ":--sail under.",
               "_strongs": "05284"
            },
            {
               "strongs": "5285",
               "greek": [
                  {
                     "_BETA": "U(POPNE/W",
                     "_unicode": "ὑποπνέω",
                     "_translit": "hypopnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-op-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4154"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to breathe gently, i.e. breeze",
               "kjv_def": ":--blow softly.",
               "_strongs": "05285"
            },
            {
               "strongs": "5286",
               "greek": [
                  {
                     "_BETA": "U(POPO/DION",
                     "_unicode": "ὑποπόδιον",
                     "_translit": "hypopódion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-op-od'-ee-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4228"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n;"
               },
               "strongs_def": "something under the feet, i.e.\n a foot-rest (figuratively)",
               "kjv_def": ":--footstool.",
               "_strongs": "05286"
            },
            {
               "strongs": "5287",
               "greek": [
                  {
                     "_BETA": "U(PO/STASIS",
                     "_unicode": "ὑπόστασις",
                     "_translit": "hypóstasis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-os'-tas-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2476"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "a setting under (support), i.e.\n (figuratively) concretely, essence, or abstractly, assurance\n (objectively or subjectively)",
               "kjv_def": ":--confidence, confident, person,\n substance.",
               "_strongs": "05287"
            },
            {
               "strongs": "5288",
               "greek": [
                  {
                     "_BETA": "U(POSTE/LLW",
                     "_unicode": "ὑποστέλλω",
                     "_translit": "hypostéllō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-os-tel'-lo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4724"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to withhold under (out of sight), i.e.\n (reflexively) to cower or shrink, (figuratively) to conceal\n (reserve)",
               "kjv_def": ":--draw (keep) back, shun, withdraw.",
               "_strongs": "05288"
            },
            {
               "strongs": "5289",
               "greek": [
                  {
                     "_BETA": "U(POSTOLH/",
                     "_unicode": "ὑποστολή",
                     "_translit": "hypostolḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-os-tol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5288"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "shrinkage (timidity), i.e. (by implication) apostasy",
               "kjv_def": ":--draw\n back.",
               "_strongs": "05289"
            },
            {
               "strongs": "5290",
               "greek": [
                  {
                     "_BETA": "U(POSTRE/FW",
                     "_unicode": "ὑποστρέφω",
                     "_translit": "hypostréphō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-os-tref'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4762"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to turn under (behind), i.e. to return (literally\n or figuratively)",
               "kjv_def": ":--come again, return (again, back again), turn back\n (again).",
               "_strongs": "05290"
            },
            {
               "strongs": "5291",
               "greek": [
                  {
                     "_BETA": "U(POSTRW/NNUMI",
                     "_unicode": "ὑποστρώννυμι",
                     "_translit": "hypostrṓnnymi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-os-trone'-noo-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4766"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to strew underneath (the feet as a\n carpet)",
               "kjv_def": ":--spread.",
               "_strongs": "05291"
            },
            {
               "strongs": "5292",
               "greek": [
                  {
                     "_BETA": "U(POTAGH/",
                     "_unicode": "ὑποταγή",
                     "_translit": "hypotagḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ot-ag-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5293"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "subordination",
               "kjv_def": ":--subjection.",
               "_strongs": "05292"
            },
            {
               "strongs": "5293",
               "greek": [
                  {
                     "_BETA": "U(POTA/SSW",
                     "_unicode": "ὑποτάσσω",
                     "_translit": "hypotássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ot-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5021"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to subordinate; reflexively, to obey",
               "kjv_def": ":--be under\n obedience (obedient), put under, subdue unto, (be, make) subject (to,\n unto), be (put) in subjection (to, under), submit self unto.",
               "_strongs": "05293"
            },
            {
               "strongs": "5294",
               "greek": [
                  {
                     "_BETA": "U(POTI/QHMI",
                     "_unicode": "ὑποτίθημι",
                     "_translit": "hypotíthēmi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ot-ith'-ay-mee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5087"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to place underneath, i.e. (figuratively) to\n hazard, (reflexively) to suggest",
               "kjv_def": ":--lay down, put in remembrance.",
               "_strongs": "05294"
            },
            {
               "strongs": "5295",
               "greek": [
                  {
                     "_BETA": "U(POTRE/XW",
                     "_unicode": "ὑποτρέχω",
                     "_translit": "hypotréchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ot-rekh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5143"
                     }
                  ],
                  "__text": "from \n and \n (including its alternate);"
               },
               "strongs_def": "to run under, i.e.\n (specially), to sail past",
               "kjv_def": ":--run under.",
               "_strongs": "05295"
            },
            {
               "strongs": "5296",
               "greek": [
                  {
                     "_BETA": "U(POTU/PWSIS",
                     "_unicode": "ὑποτύπωσις",
                     "_translit": "hypotýpōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-ot-oop'-o-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5179"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "typification under\n (after), i.e. (concretely) a sketch (figuratively) for\n imitation",
               "kjv_def": ":--form, pattern.",
               "_strongs": "05296"
            },
            {
               "strongs": "5297",
               "greek": [
                  {
                     "_BETA": "U(POFE/RW",
                     "_unicode": "ὑποφέρω",
                     "_translit": "hypophérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-of-er'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to bear from underneath, i.e. (figuratively) to\n undergo hardship",
               "kjv_def": ":--bear, endure.",
               "_strongs": "05297"
            },
            {
               "strongs": "5298",
               "greek": [
                  {
                     "_BETA": "U(POXWRE/W",
                     "_unicode": "ὑποχωρέω",
                     "_translit": "hypochōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-okh-o-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5562"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "to vacate down, i.e. retire quietly",
               "kjv_def": ":--go aside,\n withdraw self.",
               "_strongs": "05298"
            },
            {
               "strongs": "5299",
               "greek": [
                  {
                     "_BETA": "U(PWPIA/ZW",
                     "_unicode": "ὑπωπιάζω",
                     "_translit": "hypōpiázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-o-pee-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3700"
                     }
                  ],
                  "__text": "from a compound of \n and a derivative of \n;"
               },
               "strongs_def": "to hit under the eye\n (buffet or disable an antagonist as a pugilist), i.e. (figuratively)\n to tease or annoy (into compliance), subdue (one's passions)",
               "kjv_def": ":--keep\n under, weary.",
               "_strongs": "05299"
            },
            {
               "strongs": "5300",
               "greek": [
                  {
                     "_BETA": "U(=S",
                     "_unicode": "ὗς",
                     "_translit": "hŷs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoos"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a hog (\"swine\")",
               "kjv_def": ":--sow.",
               "_strongs": "05300"
            },
            {
               "strongs": "5301",
               "greek": [
                  {
                     "_BETA": "U(/SSWPOS",
                     "_unicode": "ὕσσωπος",
                     "_translit": "hýssōpos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoos'-so-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "0231"
                     }
                  ],
                  "__text": "of foreign origin (\n);"
               },
               "strongs_def": "\"hyssop\"",
               "kjv_def": ":--hyssop.",
               "_strongs": "05301"
            },
            {
               "strongs": "5302",
               "greek": [
                  {
                     "_BETA": "U(STERE/W",
                     "_unicode": "ὑστερέω",
                     "_translit": "hysteréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoos-ter-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5306"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be later, i.e. (by implication) to be inferior;\n generally, to fall short (be deficient)",
               "kjv_def": ":--come behind (short), be\n destitute, fail, lack, suffer need, (be in) want, be the worse.",
               "_strongs": "05302"
            },
            {
               "strongs": "5303",
               "greek": [
                  {
                     "_BETA": "U(STE/RHMA",
                     "_unicode": "ὑστέρημα",
                     "_translit": "hystérēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoos-ter'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5302"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a deficit; specially, poverty",
               "kjv_def": ":--that which is behind, (that\n which was) lack(-ing), penury, want.",
               "_strongs": "05303"
            },
            {
               "strongs": "5304",
               "greek": [
                  {
                     "_BETA": "U(STE/RHSIS",
                     "_unicode": "ὑστέρησις",
                     "_translit": "hystérēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoos-ter'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5302"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a falling short, i.e. (specially), penury",
               "kjv_def": ":--want.",
               "_strongs": "05304"
            },
            {
               "strongs": "5305",
               "greek": [
                  {
                     "_BETA": "U(/STERON",
                     "_unicode": "ὕστερον",
                     "_translit": "hýsteron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoos'-ter-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5306"
                     }
                  ],
                  "__text": "neuter of \n as adverb;"
               },
               "strongs_def": "more lately, i.e. eventually",
               "kjv_def": ":--afterward,\n (at the) last (of all).",
               "_strongs": "05305"
            },
            {
               "strongs": "5306",
               "greek": [
                  {
                     "_BETA": "U(/STEROS",
                     "_unicode": "ὕστερος",
                     "_translit": "hýsteros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoos'-ter-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5259"
                     }
                  ],
                  "__text": "comparative from \n (in the sense of behind);"
               },
               "strongs_def": "later",
               "kjv_def": ":--latter.",
               "_strongs": "05306"
            },
            {
               "strongs": "5307",
               "greek": [
                  {
                     "_BETA": "U(FANTO/S",
                     "_unicode": "ὑφαντός",
                     "_translit": "hyphantós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoo-fan-tos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "U(FAI/NW",
                        "_unicode": "ὑφαίνω",
                        "_translit": "hyphaínō"
                     }
                  ],
                  "__text": "from \n to weave;"
               },
               "strongs_def": "woven, i.e. (perhaps) knitted",
               "kjv_def": ":--woven.",
               "_strongs": "05307"
            },
            {
               "strongs": "5308",
               "greek": [
                  {
                     "_BETA": "U(YHLO/S",
                     "_unicode": "ὑψηλός",
                     "_translit": "hypsēlós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-say-los'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5311"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "lofty (in place or character)",
               "kjv_def": ":--high(-er, -ly) (esteemed).",
               "_strongs": "05308"
            },
            {
               "strongs": "5309",
               "greek": [
                  {
                     "_BETA": "U(YHLOFRONE/W",
                     "_unicode": "ὑψηλοφρονέω",
                     "_translit": "hypsēlophronéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-say-lo-fron-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5308"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be lofty in mind, i.e.\n arrogant",
               "kjv_def": ":--be highminded.",
               "_strongs": "05309"
            },
            {
               "strongs": "5310",
               "greek": [
                  {
                     "_BETA": "U(/YISTOS",
                     "_unicode": "ὕψιστος",
                     "_translit": "hýpsistos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop'-sis-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5311"
                     }
                  ],
                  "__text": "superlative from the base of \n;"
               },
               "strongs_def": "highest, i.e. (masculine singular)\n the Supreme (God), or (neuter plural) the heavens",
               "kjv_def": ":--most high,\n highest.",
               "_strongs": "05310"
            },
            {
               "strongs": "5311",
               "greek": [
                  {
                     "_BETA": "U(/YOS",
                     "_unicode": "ὕψος",
                     "_translit": "hýpsos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop'-sos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5228"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "elevation, i.e. (abstractly) altitude,\n (specially), the sky, or (figuratively) dignity",
               "kjv_def": ":--be exalted, height,\n (on) high.",
               "_strongs": "05311"
            },
            {
               "strongs": "5312",
               "greek": [
                  {
                     "_BETA": "U(YO/W",
                     "_unicode": "ὑψόω",
                     "_translit": "hypsóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop-so'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5311"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to elevate (literally or figuratively)",
               "kjv_def": ":--exalt, lift up.",
               "_strongs": "05312"
            },
            {
               "strongs": "5313",
               "greek": [
                  {
                     "_BETA": "U(/YWMA",
                     "_unicode": "ὕψωμα",
                     "_translit": "hýpsōma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoop'-so-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5312"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an elevated place or thing, i.e. (abstractly) altitude, or\n (by implication) a barrier (figuratively)",
               "kjv_def": ":-- height, high thing.",
               "_strongs": "05313"
            },
            {
               "strongs": "5314",
               "greek": [
                  {
                     "_BETA": "FA/GOS",
                     "_unicode": "φάγος",
                     "_translit": "phágos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fag'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5315"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a glutton",
               "kjv_def": ":--gluttonous.",
               "_strongs": "05314"
            },
            {
               "strongs": "5315",
               "greek": [
                  {
                     "_BETA": "FA/GW",
                     "_unicode": "φάγω",
                     "_translit": "phágō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fag'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2068"
                     }
                  ],
                  "__text": "a primary verb (used as an alternate of \n in certain tenses);"
               },
               "strongs_def": "to\n eat (literally or figuratively)",
               "kjv_def": ":--eat, meat.",
               "_strongs": "05315"
            },
            {
               "strongs": "5316",
               "greek": [
                  {
                     "_BETA": "FAI/NW",
                     "_unicode": "φαίνω",
                     "_translit": "phaínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fah'-ee-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5457"
                     }
                  ],
                  "__text": "prolongation for the base of \n;"
               },
               "strongs_def": "to lighten (shine), i.e. show\n (transitive or intransitive, literal or figurative)",
               "kjv_def": ":-- appear, seem,\n be seen, shine, X think.",
               "_strongs": "05316"
            },
            {
               "strongs": "5317",
               "greek": [
                  {
                     "_BETA": "*FA/LEK",
                     "_unicode": "Φάλεκ",
                     "_translit": "Phálek"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fal'-ek"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06389"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Phalek (i.e. Peleg), a patriarch",
               "kjv_def": ":--Phalec.",
               "_strongs": "05317"
            },
            {
               "strongs": "5318",
               "greek": [
                  {
                     "_BETA": "FANERO/S",
                     "_unicode": "φανερός",
                     "_translit": "phanerós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan-er-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "shining, i.e. apparent (literally or figuratively); neuter\n (as adverb) publicly, externally",
               "kjv_def": ":--abroad, + appear, known, manifest,\n open (+ -ly), outward (+ -ly).",
               "_strongs": "05318"
            },
            {
               "strongs": "5319",
               "greek": [
                  {
                     "_BETA": "FANERO/W",
                     "_unicode": "φανερόω",
                     "_translit": "phaneróō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan-er-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5318"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to render apparent (literally or figuratively)",
               "kjv_def": ":--appear,\n manifestly declare, (make) manifest (forth), shew (self).",
               "_strongs": "05319"
            },
            {
               "strongs": "5320",
               "greek": [
                  {
                     "_BETA": "FANERW=S",
                     "_unicode": "φανερῶς",
                     "_translit": "phanerōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan-er-oce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5318"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "plainly, i.e. clearly or publicly",
               "kjv_def": ":--evidently,\n openly.",
               "_strongs": "05320"
            },
            {
               "strongs": "5321",
               "greek": [
                  {
                     "_BETA": "FANE/RWSIS",
                     "_unicode": "φανέρωσις",
                     "_translit": "phanérōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan-er'-o-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5319"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "exhibition, i.e. (figuratively) expression, (by extension)\n a bestowment",
               "kjv_def": ":--manifestation.",
               "_strongs": "05321"
            },
            {
               "strongs": "5322",
               "greek": [
                  {
                     "_BETA": "FANO/S",
                     "_unicode": "φανός",
                     "_translit": "phanós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a lightener, i.e. light; lantern",
               "kjv_def": ":--lantern.",
               "_strongs": "05322"
            },
            {
               "strongs": "5323",
               "greek": [
                  {
                     "_BETA": "*FANOUH/L",
                     "_unicode": "Φανουήλ",
                     "_translit": "Phanouḗl"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan-oo-ale'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06439"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Phanuel (i.e. Penuel), an\n Israelite",
               "kjv_def": ":--Phanuel.",
               "_strongs": "05323"
            },
            {
               "strongs": "5324",
               "greek": [
                  {
                     "_BETA": "FANTA/ZW",
                     "_unicode": "φαντάζω",
                     "_translit": "phantázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan-tad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to make apparent, i.e. (passively) to\n appear (neuter participle as noun, a spectacle)",
               "kjv_def": ":--sight.",
               "_strongs": "05324"
            },
            {
               "strongs": "5325",
               "greek": [
                  {
                     "_BETA": "FANTASI/A",
                     "_unicode": "φαντασία",
                     "_translit": "phantasía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan-tas-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5324"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "(properly abstract) a (vain) show\n (\"fantasy\")",
               "kjv_def": ":--pomp.",
               "_strongs": "05325"
            },
            {
               "strongs": "5326",
               "greek": [
                  {
                     "_BETA": "FA/NTASMA",
                     "_unicode": "φάντασμα",
                     "_translit": "phántasma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fan'-tas-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5324"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(properly concrete) a (mere) show (\"phantasm\"), i.e.\n spectre",
               "kjv_def": ":--spirit.",
               "_strongs": "05326"
            },
            {
               "strongs": "5327",
               "greek": [
                  {
                     "_BETA": "FA/RAGC",
                     "_unicode": "φάραγξ",
                     "_translit": "pháranx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "far'-anx"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4008"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4486"
                     }
                  ],
                  "__text": "properly, strengthened from the base of \n or rather of \n;"
               },
               "strongs_def": "a gap\n or chasm, i.e. ravine (winter-torrent)",
               "kjv_def": ":--valley.",
               "_strongs": "05327"
            },
            {
               "strongs": "5328",
               "greek": [
                  {
                     "_BETA": "*FARAW/",
                     "_unicode": "Φαραώ",
                     "_translit": "Pharaṓ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "far-ah-o'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06547"
                     }
                  ],
                  "__text": "of foreign origin (\n);"
               },
               "strongs_def": "Pharao (i.e. Pharoh), an Egyptian\n king",
               "kjv_def": ":--Pharaoh.",
               "_strongs": "05328"
            },
            {
               "strongs": "5329",
               "greek": [
                  {
                     "_BETA": "*FA/RES",
                     "_unicode": "Φάρες",
                     "_translit": "Pháres"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "far-es'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06557"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Phares (i.e. Perets), an Israelite",
               "kjv_def": ":--Phares.",
               "_strongs": "05329"
            },
            {
               "strongs": "5330",
               "greek": [
                  {
                     "_BETA": "*FARISAI=OS",
                     "_unicode": "Φαρισαῖος",
                     "_translit": "Pharisaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "far-is-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "06567"
                     }
                  ],
                  "__text": "of Hebrew origin (compare \n);"
               },
               "strongs_def": "a separatist, i.e. exclusively\n religious; a Pharisean, i.e. Jewish sectary",
               "kjv_def": ":--Pharisee.",
               "_strongs": "05330"
            },
            {
               "strongs": "5331",
               "greek": [
                  {
                     "_BETA": "FARMAKEI/A",
                     "_unicode": "φαρμακεία",
                     "_translit": "pharmakeía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "far-mak-i'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5332"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "medication (\"pharmacy\"), i.e. (by extension) magic\n (literally or figuratively)",
               "kjv_def": ":--sorcery, witchcraft.",
               "_strongs": "05331"
            },
            {
               "strongs": "5332",
               "greek": [
                  {
                     "_BETA": "FARMAKEU/S",
                     "_unicode": "φαρμακεύς",
                     "_translit": "pharmakeús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "far-mak-yoos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FA/RMAKON",
                        "_unicode": "φάρμακον",
                        "_translit": "phármakon"
                     }
                  ],
                  "__text": "from \n (a drug, i.e. spell-giving potion);"
               },
               "strongs_def": "a druggist\n (\"pharmacist\") or poisoner, i.e. (by extension) a magician",
               "kjv_def": ":--sorcerer.",
               "_strongs": "05332"
            },
            {
               "strongs": "5333",
               "greek": [
                  {
                     "_BETA": "FA/RMAKOS",
                     "_unicode": "φάρμακος",
                     "_translit": "phármakos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "far-mak-os'"
                  }
               ],
               "strongs_derivation": "the same as 5332",
               "kjv_def": ":--sorcerer.",
               "_strongs": "05333"
            },
            {
               "strongs": "5334",
               "greek": [
                  {
                     "_BETA": "FA/SIS",
                     "_unicode": "φάσις",
                     "_translit": "phásis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fas'-is"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "from \n (not the same as \"phase\", which is from \n);"
               },
               "strongs_def": "a saying,\n i.e. report",
               "kjv_def": ":--tidings.",
               "_strongs": "05334"
            },
            {
               "strongs": "5335",
               "greek": [
                  {
                     "_BETA": "FA/SKW",
                     "_unicode": "φάσκω",
                     "_translit": "pháskō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fas'-ko"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     }
                  ],
                  "__text": "prolongation from the same as \n;"
               },
               "strongs_def": "to assert",
               "kjv_def": ":--affirm, profess, say.",
               "_strongs": "05335"
            },
            {
               "strongs": "5336",
               "greek": [
                  {
                     "_BETA": "FA/TNH",
                     "_unicode": "φάτνη",
                     "_translit": "phátnē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fat'-nay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "PATE/OMAI",
                        "_unicode": "πατέομαι",
                        "_translit": "patéomai"
                     }
                  ],
                  "__text": "from \n (to eat);"
               },
               "strongs_def": "a crib (for fodder)",
               "kjv_def": ":--manager, stall.",
               "_strongs": "05336"
            },
            {
               "strongs": "5337",
               "greek": [
                  {
                     "_BETA": "FAU=LOS",
                     "_unicode": "φαῦλος",
                     "_translit": "phaûlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fow'-los"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "\"foul\" or \"flawy\", i.e. (figuratively)\n wicked",
               "kjv_def": ":--evil.",
               "_strongs": "05337"
            },
            {
               "strongs": "5338",
               "greek": [
                  {
                     "_BETA": "FE/GGOS",
                     "_unicode": "φέγγος",
                     "_translit": "phéngos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "feng'-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5457"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5350"
                     }
                  ],
                  "__text": "probably akin to the base of \n (compare \n);"
               },
               "strongs_def": "brilliancy",
               "kjv_def": ":--light.",
               "_strongs": "05338"
            },
            {
               "strongs": "5339",
               "greek": [
                  {
                     "_BETA": "FEI/DOMAI",
                     "_unicode": "φείδομαι",
                     "_translit": "pheídomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fi'-dom-ahee"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "to be chary of, i.e. (subjectively) to abstain\n or (objectively) to treat leniently",
               "kjv_def": ":--forbear, spare.",
               "_strongs": "05339"
            },
            {
               "strongs": "5340",
               "greek": [
                  {
                     "_BETA": "FEIDOME/NWS",
                     "_unicode": "φειδομένως",
                     "_translit": "pheidoménōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fi-dom-en'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5339"
                     }
                  ],
                  "__text": "adverb from participle of \n;"
               },
               "strongs_def": "abstemiously, i.e.\n stingily",
               "kjv_def": ":--sparingly.",
               "_strongs": "05340"
            },
            {
               "strongs": "5341",
               "greek": [
                  {
                     "_BETA": "FELO/NHS",
                     "_unicode": "φελόνης",
                     "_translit": "phelónēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fel-on'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "by transposition for a derivative probably of \n (as showing outside\n the other garments);"
               },
               "strongs_def": "a mantle (surtout)",
               "kjv_def": ":-- cloke.",
               "_strongs": "05341"
            },
            {
               "strongs": "5342",
               "greek": [
                  {
                     "_BETA": "FE/RW",
                     "_unicode": "φέρω",
                     "_translit": "phérō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fer'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "OI)/W",
                        "_unicode": "οἴω",
                        "_translit": "oíō"
                     },
                     {
                        "_BETA": "E)NE/GKW",
                        "_unicode": "ἐνέγκω",
                        "_translit": "enénkō"
                     }
                  ],
                  "pronunciation": [
                     {
                        "_strongs": "oy'-o"
                     },
                     {
                        "_strongs": "en-eng'-ko"
                     }
                  ],
                  "__text": "a primary verb (for which other, and apparently not cognate ones are\n used in certain tenses only; namely,\n    \n      \n  \n;     \n  and \n  \n;"
               },
               "strongs_def": "to \"bear\" or carry (in a very wide application, literally and\n figuratively, as follows)",
               "kjv_def": ":--be, bear, bring (forth), carry, come, +\n let her drive, be driven, endure, go on, lay, lead, move, reach,\n rushing, uphold.",
               "_strongs": "05342"
            },
            {
               "strongs": "5343",
               "greek": [
                  {
                     "_BETA": "FEU/GW",
                     "_unicode": "φεύγω",
                     "_translit": "pheúgō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fyoo'-go"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to run away (literally or figuratively); by\n implication, to shun; by analogy, to vanish",
               "kjv_def": ":--escape, flee (away).",
               "_strongs": "05343"
            },
            {
               "strongs": "5344",
               "greek": [
                  {
                     "_BETA": "*FH=LIC",
                     "_unicode": "Φῆλιξ",
                     "_translit": "Phēlix"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fay'-lix"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "happy; Phelix (i.e. Felix), a Roman",
               "kjv_def": ":--Felix.",
               "_strongs": "05344"
            },
            {
               "strongs": "5345",
               "greek": [
                  {
                     "_BETA": "FH/MH",
                     "_unicode": "φήμη",
                     "_translit": "phḗmē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fay'-may"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a saying, i.e. rumor (\"fame\")",
               "kjv_def": ":--fame.",
               "_strongs": "05345"
            },
            {
               "strongs": "5346",
               "greek": [
                  {
                     "_BETA": "FHMI/",
                     "_unicode": "φημί",
                     "_translit": "phēmí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fay-mee'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5457"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "properly, the same as the base of \n and \n;"
               },
               "strongs_def": "to show or make known\n one's thoughts, i.e. speak or say",
               "kjv_def": ":--affirm, say.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "3004"
                  }
               ],
               "_strongs": "05346",
               "__text": "Compare \n."
            },
            {
               "strongs": "5347",
               "greek": [
                  {
                     "_BETA": "*FH=STOS",
                     "_unicode": "Φῆστος",
                     "_translit": "Phēstos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "face'-tos"
                  }
               ],
               "strongs_derivation": "of Latin derivation;",
               "strongs_def": "festal; Phestus (i.e. Festus), a Roman",
               "kjv_def": ":--Festus.",
               "_strongs": "05347"
            },
            {
               "strongs": "5348",
               "greek": [
                  {
                     "_BETA": "FQA/NW",
                     "_unicode": "φθάνω",
                     "_translit": "phthánō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fthan'-o"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to be beforehand, i.e. anticipate or\n precede; by extension, to have arrived at",
               "kjv_def": ":--(already) attain, come,\n prevent.",
               "_strongs": "05348"
            },
            {
               "strongs": "5349",
               "greek": [
                  {
                     "_BETA": "FQARTO/S",
                     "_unicode": "φθαρτός",
                     "_translit": "phthartós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fthar-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5351"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "decayed, i.e. (by implication) perishable",
               "kjv_def": ":--corruptible.",
               "_strongs": "05349"
            },
            {
               "strongs": "5350",
               "greek": [
                  {
                     "_BETA": "FQE/GGOMAI",
                     "_unicode": "φθέγγομαι",
                     "_translit": "phthéngomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ftheng'-gom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5338"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     }
                  ],
                  "__text": "probably akin to \n and thus to \n;"
               },
               "strongs_def": "to utter a clear sound, i.e.\n (generally) to proclaim",
               "kjv_def": ":--speak.",
               "_strongs": "05350"
            },
            {
               "strongs": "5351",
               "greek": [
                  {
                     "_BETA": "FQEI/RW",
                     "_unicode": "φθείρω",
                     "_translit": "phtheírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fthi'-ro"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FQI/W",
                        "_unicode": "φθίω",
                        "_translit": "phthíō"
                     }
                  ],
                  "__text": "probably strengthened from \n (to pine or waste);"
               },
               "strongs_def": "properly, to\n shrivel or wither, i.e. to spoil (by any process) or (generally) to\n ruin (especially figuratively, by moral influences, to\n deprave)",
               "kjv_def": ":--corrupt (self), defile, destroy.",
               "_strongs": "05351"
            },
            {
               "strongs": "5352",
               "greek": [
                  {
                     "_BETA": "FQINOPWRINO/S",
                     "_unicode": "φθινοπωρινός",
                     "_translit": "phthinopōrinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fthin-op-o-ree-nos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FQI/NW",
                        "_unicode": "φθίνω",
                        "_translit": "phthínō"
                     }
                  ],
                  "__text": "from derivative of \n  (to wane;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5351"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3703"
                     }
                  ],
                  "__text": "akin to the base of \n) and\n \n (meaning late autumn); autumnal (as stripped of leaves)"
               },
               "kjv_def": ":--whose\n fruit withereth.",
               "_strongs": "05352"
            },
            {
               "strongs": "5353",
               "greek": [
                  {
                     "_BETA": "FQO/GGOS",
                     "_unicode": "φθόγγος",
                     "_translit": "phthóngos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ftong'-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5350"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "utterance, i.e. a musical note (vocal or\n instrumental)",
               "kjv_def": ":--sound.",
               "_strongs": "05353"
            },
            {
               "strongs": "5354",
               "greek": [
                  {
                     "_BETA": "FQONE/W",
                     "_unicode": "φθονέω",
                     "_translit": "phthonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fthon-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5355"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be jealous of",
               "kjv_def": ":--envy.",
               "_strongs": "05354"
            },
            {
               "strongs": "5355",
               "greek": [
                  {
                     "_BETA": "FQO/NOS",
                     "_unicode": "φθόνος",
                     "_translit": "phthónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fthon'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5351"
                     }
                  ],
                  "__text": "probably akin to the base of \n;"
               },
               "strongs_def": "ill-will (as detraction), i.e.\n jealousy (spite)",
               "kjv_def": ":--envy.",
               "_strongs": "05355"
            },
            {
               "strongs": "5356",
               "greek": [
                  {
                     "_BETA": "FQORA/",
                     "_unicode": "φθορά",
                     "_translit": "phthorá"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fthor-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5351"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "decay, i.e. ruin (spontaneous or inflicted, literally or\n figuratively)",
               "kjv_def": ":--corruption, destroy, perish.",
               "_strongs": "05356"
            },
            {
               "strongs": "5357",
               "greek": [
                  {
                     "_BETA": "FIA/LH",
                     "_unicode": "φιάλη",
                     "_translit": "phiálē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fee-al'-ay"
                  }
               ],
               "strongs_derivation": "of uncertain affinity;",
               "strongs_def": "a broad shallow cup (\"phial\")",
               "kjv_def": ":--vial.",
               "_strongs": "05357"
            },
            {
               "strongs": "5358",
               "greek": [
                  {
                     "_BETA": "FILA/GAQOS",
                     "_unicode": "φιλάγαθος",
                     "_translit": "philágathos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ag'-ath-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "18"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond to good, i.e. a promoter of virtue",
               "kjv_def": ":--love of\n good men.",
               "_strongs": "05358"
            },
            {
               "strongs": "5359",
               "greek": [
                  {
                     "_BETA": "*FILADE/LFEIA",
                     "_unicode": "Φιλαδέλφεια",
                     "_translit": "Philadélpheia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ad-el'-fee-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "*FILA/DELFOS",
                        "_unicode": "Φιλάδελφος",
                        "_translit": "Philádelphos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5361"
                     }
                  ],
                  "__text": "from \n (the same as \n), a king of Pergamos;"
               },
               "strongs_def": "Philadelphia, a place in Asia Minor",
               "kjv_def": ":--Philadelphia.",
               "_strongs": "05359"
            },
            {
               "strongs": "5360",
               "greek": [
                  {
                     "_BETA": "FILADELFI/A",
                     "_unicode": "φιλαδελφία",
                     "_translit": "philadelphía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ad-el-fee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5361"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fraternal affection",
               "kjv_def": ":--brotherly love (kindness), love of\n the brethren.",
               "_strongs": "05360"
            },
            {
               "strongs": "5361",
               "greek": [
                  {
                     "_BETA": "FILA/DELFOS",
                     "_unicode": "φιλάδελφος",
                     "_translit": "philádelphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ad'-el-fos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "80"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of brethren, i.e. fraternal",
               "kjv_def": ":--love as brethren.",
               "_strongs": "05361"
            },
            {
               "strongs": "5362",
               "greek": [
                  {
                     "_BETA": "FI/LANDROS",
                     "_unicode": "φίλανδρος",
                     "_translit": "phílandros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil'-an-dros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "435"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of man, i.e. affectionate as a wife",
               "kjv_def": ":--love\n their husbands.",
               "_strongs": "05362"
            },
            {
               "strongs": "5363",
               "greek": [
                  {
                     "_BETA": "FILANQRWPI/A",
                     "_unicode": "φιλανθρωπία",
                     "_translit": "philanthrōpía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-an-thro-pee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5364"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "fondness of mankind, i.e. benevolence\n (\"philanthropy\")",
               "kjv_def": ":--kindness, love towards man.",
               "_strongs": "05363"
            },
            {
               "strongs": "5364",
               "greek": [
                  {
                     "_BETA": "FILANQRW/PWS",
                     "_unicode": "φιλανθρώπως",
                     "_translit": "philanthrṓpōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-an-thro'-poce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "444"
                     }
                  ],
                  "__text": "adverb from a compound of \n and \n;"
               },
               "strongs_def": "fondly to man\n (\"philanthropically\"), i.e. humanely",
               "kjv_def": ":--courteously.",
               "_strongs": "05364"
            },
            {
               "strongs": "5365",
               "greek": [
                  {
                     "_BETA": "FILARGURI/A",
                     "_unicode": "φιλαργυρία",
                     "_translit": "philargyría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ar-goo-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5366"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "avarice",
               "kjv_def": ":--love of money.",
               "_strongs": "05365"
            },
            {
               "strongs": "5366",
               "greek": [
                  {
                     "_BETA": "FILA/RGUROS",
                     "_unicode": "φιλάργυρος",
                     "_translit": "philárgyros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ar'-goo-ros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "696"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of silver (money), i.e. avaricious",
               "kjv_def": ":--covetous.",
               "_strongs": "05366"
            },
            {
               "strongs": "5367",
               "greek": [
                  {
                     "_BETA": "FI/LAUTOS",
                     "_unicode": "φίλαυτος",
                     "_translit": "phílautos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil'-ow-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of self, i.e. selfish",
               "kjv_def": ":--lover of own self.",
               "_strongs": "05367"
            },
            {
               "strongs": "5368",
               "greek": [
                  {
                     "_BETA": "FILE/W",
                     "_unicode": "φιλέω",
                     "_translit": "philéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "25"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2309"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1014"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2372"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3563"
                     }
                  ],
                  "__text": "to be a friend to (fond of (an individual or an object)),\n i.e. have affection for (denoting personal attachment, as a matter of\n sentiment or feeling; while \n is wider, embracing especially the\n judgment and the deliberate assent of the will as a matter of\n principle, duty and propriety: the two thus stand related very much as\n \n and \n, or as \n and \n respectively; the former being\n chiefly of the heart and the latter of the head); specially, to kiss\n (as a mark of tenderness)"
               },
               "kjv_def": ":--kiss, love.",
               "_strongs": "05368"
            },
            {
               "strongs": "5369",
               "greek": [
                  {
                     "_BETA": "FILH/DONOS",
                     "_unicode": "φιλήδονος",
                     "_translit": "philḗdonos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ay'-don-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2237"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of pleasure, i.e. voluptuous",
               "kjv_def": ":--lover of\n pleasure.",
               "_strongs": "05369"
            },
            {
               "strongs": "5370",
               "greek": [
                  {
                     "_BETA": "FI/LHMA",
                     "_unicode": "φίλημα",
                     "_translit": "phílēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5368"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a kiss",
               "kjv_def": ":--kiss.",
               "_strongs": "05370"
            },
            {
               "strongs": "5371",
               "greek": [
                  {
                     "_BETA": "*FILH/MWN",
                     "_unicode": "Φιλήμων",
                     "_translit": "Philḗmōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ay'-mone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5368"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "friendly; Philemon, a Christian",
               "kjv_def": ":--Philemon.",
               "_strongs": "05371"
            },
            {
               "strongs": "5372",
               "greek": [
                  {
                     "_BETA": "*FI/LHTOS",
                     "_unicode": "Φίλητος",
                     "_translit": "Phílētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ay-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5368"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "amiable; Philetus, an opposer of Christianity",
               "kjv_def": ":--Philetus.",
               "_strongs": "05372"
            },
            {
               "strongs": "5373",
               "greek": [
                  {
                     "_BETA": "FILI/A",
                     "_unicode": "φιλία",
                     "_translit": "philía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "fondness",
               "kjv_def": ":--friendship.",
               "_strongs": "05373"
            },
            {
               "strongs": "5374",
               "greek": [
                  {
                     "_BETA": "*FILIPPH/SIOS",
                     "_unicode": "Φιλιππήσιος",
                     "_translit": "Philippḗsios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ip-pay'-see-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5375"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Philippesian (Philippian), i.e. native of\n Philippi",
               "kjv_def": ":--Philippian.",
               "_strongs": "05374"
            },
            {
               "strongs": "5375",
               "greek": [
                  {
                     "_BETA": "*FI/LIPPOI",
                     "_unicode": "Φίλιπποι",
                     "_translit": "Phílippoi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil'-ip-poy"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5376"
                     }
                  ],
                  "__text": "plural of \n;"
               },
               "strongs_def": "Philippi, a place in Macedonia",
               "kjv_def": ":--Philippi.",
               "_strongs": "05375"
            },
            {
               "strongs": "5376",
               "greek": [
                  {
                     "_BETA": "*FI/LIPPOS",
                     "_unicode": "Φίλιππος",
                     "_translit": "Phílippos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil'-ip-pos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2462"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of horses; Philippus, the name of four\n Israelites",
               "kjv_def": ":--Philip.",
               "_strongs": "05376"
            },
            {
               "strongs": "5377",
               "greek": [
                  {
                     "_BETA": "FILO/QEOS",
                     "_unicode": "φιλόθεος",
                     "_translit": "philótheos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-oth'-eh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2316"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of God, i.e. pious",
               "kjv_def": ":--lover of God.",
               "_strongs": "05377"
            },
            {
               "strongs": "5378",
               "greek": [
                  {
                     "_BETA": "*FILO/LOGOS",
                     "_unicode": "Φιλόλογος",
                     "_translit": "Philólogos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ol'-og-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3056"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of words, i.e. talkative (argumentative,\n learned, \"philological\"); Philologus, a Christian",
               "kjv_def": ":--Philologus.",
               "_strongs": "05378"
            },
            {
               "strongs": "5379",
               "greek": [
                  {
                     "_BETA": "FILONEIKI/A",
                     "_unicode": "φιλονεικία",
                     "_translit": "philoneikía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-on-i-kee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5380"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "quarrelsomeness, i.e. a dispute",
               "kjv_def": ":--strife.",
               "_strongs": "05379"
            },
            {
               "strongs": "5380",
               "greek": [
                  {
                     "_BETA": "FILO/NEIKOS",
                     "_unicode": "φιλόνεικος",
                     "_translit": "philóneikos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-on'-i-kos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3534"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "NEI=KOS",
                        "_unicode": "νεῖκος",
                        "_translit": "neîkos"
                     }
                  ],
                  "__text": "from \n and \n (a quarrel; probably akin to \n);"
               },
               "strongs_def": "fond of\n strife, i.e. disputatious",
               "kjv_def": ":--contentious.",
               "_strongs": "05380"
            },
            {
               "strongs": "5381",
               "greek": [
                  {
                     "_BETA": "FILONECI/A",
                     "_unicode": "φιλονεξία",
                     "_translit": "philonexía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-on-ex-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5382"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "hospitableness",
               "kjv_def": ":--entertain stranger, hospitality.",
               "_strongs": "05381"
            },
            {
               "strongs": "5382",
               "greek": [
                  {
                     "_BETA": "FILO/CENOS",
                     "_unicode": "φιλόξενος",
                     "_translit": "philóxenos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ox'-en-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3581"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of guests, i.e. hospitable",
               "kjv_def": ":--given to (lover\n of, use) hospitality.",
               "_strongs": "05382"
            },
            {
               "strongs": "5383",
               "greek": [
                  {
                     "_BETA": "FILOPRWTEU/W",
                     "_unicode": "φιλοπρωτεύω",
                     "_translit": "philoprōteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-op-rote-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4413"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be fond of being first, i.e.\n ambitious of distinction",
               "kjv_def": ":--love to have the preeminence.",
               "_strongs": "05383"
            },
            {
               "strongs": "5384",
               "greek": [
                  {
                     "_BETA": "FI/LOS",
                     "_unicode": "φίλος",
                     "_translit": "phílos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fee'-los"
                  }
               ],
               "strongs_derivation": "properly, dear, i.e. a friend;",
               "strongs_def": "actively, fond, i.e. friendly (still as\n a noun, an associate, neighbor, etc.)",
               "kjv_def": ":--friend.",
               "_strongs": "05384"
            },
            {
               "strongs": "5385",
               "greek": [
                  {
                     "_BETA": "FILOSOFI/A",
                     "_unicode": "φιλοσοφία",
                     "_translit": "philosophía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-os-of-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5386"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "\"philosophy\", i.e. (specially), Jewish\n sophistry",
               "kjv_def": ":--philosophy.",
               "_strongs": "05385"
            },
            {
               "strongs": "5386",
               "greek": [
                  {
                     "_BETA": "FILO/SOFOS",
                     "_unicode": "φιλόσοφος",
                     "_translit": "philósophos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-os'-of-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4680"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of wise things, i.e. a\n \"philosopher\"",
               "kjv_def": ":--philosopher.",
               "_strongs": "05386"
            },
            {
               "strongs": "5387",
               "greek": [
                  {
                     "_BETA": "FILO/STORGOS",
                     "_unicode": "φιλόστοργος",
                     "_translit": "philóstorgos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-os'-tor-gos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "STORGH/",
                        "_unicode": "στοργή",
                        "_translit": "storgḗ"
                     }
                  ],
                  "__text": "from \n and \n (cherishing one's kindred, especially parents or\n children);"
               },
               "strongs_def": "fond of natural relatives, i.e. fraternal towards fellow\n Christian",
               "kjv_def": ":--kindly affectioned.",
               "_strongs": "05387"
            },
            {
               "strongs": "5388",
               "greek": [
                  {
                     "_BETA": "FILO/TEKNOS",
                     "_unicode": "φιλότεκνος",
                     "_translit": "philóteknos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ot'-ek-nos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5043"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "fond of one's children, i.e. maternal",
               "kjv_def": ":--love their\n children.",
               "_strongs": "05388"
            },
            {
               "strongs": "5389",
               "greek": [
                  {
                     "_BETA": "FILOTIME/OMAI",
                     "_unicode": "φιλοτιμέομαι",
                     "_translit": "philotiméomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-ot-im-eh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5092"
                     }
                  ],
                  "__text": "middle voice from a compound of \n and \n;"
               },
               "strongs_def": "to be fond of honor,\n i.e. emulous (eager or earnest to do something)",
               "kjv_def": ":--labour, strive,\n study.",
               "_strongs": "05389"
            },
            {
               "strongs": "5390",
               "greek": [
                  {
                     "_BETA": "FILOFRO/NWS",
                     "_unicode": "φιλοφρόνως",
                     "_translit": "philophrónōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-of-ron'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5391"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "with friendliness of mind, i.e.\n kindly",
               "kjv_def": ":--courteously.",
               "_strongs": "05390"
            },
            {
               "strongs": "5391",
               "greek": [
                  {
                     "_BETA": "FILO/FRWN",
                     "_unicode": "φιλόφρων",
                     "_translit": "philóphrōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fil-of'-rone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5384"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "friendly of mind, i.e. kind",
               "kjv_def": ":--courteous.",
               "_strongs": "05391"
            },
            {
               "strongs": "5392",
               "greek": [
                  {
                     "_BETA": "FIMO/W",
                     "_unicode": "φιμόω",
                     "_translit": "phimóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fee-mo'-o"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FIMO/S",
                        "_unicode": "φιμός",
                        "_translit": "phimós"
                     }
                  ],
                  "__text": "from \n (a muzzle);"
               },
               "strongs_def": "to muzzle",
               "kjv_def": ":--muzzle.",
               "_strongs": "05392"
            },
            {
               "strongs": "5393",
               "greek": [
                  {
                     "_BETA": "*FLE/GWN",
                     "_unicode": "Φλέγων",
                     "_translit": "Phlégōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fleg'-one"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5395"
                     }
                  ],
                  "__text": "active participle of the base of \n;"
               },
               "strongs_def": "blazing; Phlegon, a\n Christian",
               "kjv_def": ":--Phlegon.",
               "_strongs": "05393"
            },
            {
               "strongs": "5394",
               "greek": [
                  {
                     "_BETA": "FLOGI/ZW",
                     "_unicode": "φλογίζω",
                     "_translit": "phlogízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "flog-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5395"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to cause a blaze, i.e. ignite (figuratively, to inflame\n with passion)",
               "kjv_def": ":--set on fire.",
               "_strongs": "05394"
            },
            {
               "strongs": "5395",
               "greek": [
                  {
                     "_BETA": "FLO/C",
                     "_unicode": "φλόξ",
                     "_translit": "phlóx"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "flox"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FLE/GW",
                        "_unicode": "φλέγω",
                        "_translit": "phlégō"
                     }
                  ],
                  "__text": "from a primary \n (to \"flash\" or \"flame\");"
               },
               "strongs_def": "a blaze",
               "kjv_def": ":--flame(-ing).",
               "_strongs": "05395"
            },
            {
               "strongs": "5396",
               "greek": [
                  {
                     "_BETA": "FLUARE/W",
                     "_unicode": "φλυαρέω",
                     "_translit": "phlyaréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "floo-ar-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5397"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a babbler or trifler, i.e. (by implication) to berate\n idly or mischievously",
               "kjv_def": ":--prate against.",
               "_strongs": "05396"
            },
            {
               "strongs": "5397",
               "greek": [
                  {
                     "_BETA": "FLU/AROS",
                     "_unicode": "φλύαρος",
                     "_translit": "phlýaros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "floo'-ar-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FLU/W",
                        "_unicode": "φλύω",
                        "_translit": "phlýō"
                     }
                  ],
                  "__text": "from \n (to bubble);"
               },
               "strongs_def": "a garrulous person, i.e. prater",
               "kjv_def": ":--tattler.",
               "_strongs": "05397"
            },
            {
               "strongs": "5398",
               "greek": [
                  {
                     "_BETA": "FOBERO/S",
                     "_unicode": "φοβερός",
                     "_translit": "phoberós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fob-er-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5401"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "frightful, i.e. (objectively) formidable",
               "kjv_def": ":--fearful,\n terrible.",
               "_strongs": "05398"
            },
            {
               "strongs": "5399",
               "greek": [
                  {
                     "_BETA": "FOBE/W",
                     "_unicode": "φοβέω",
                     "_translit": "phobéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fob-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5401"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to frighten, i.e. (passively) to be alarmed; by analogy, to\n be in awe of, i.e. revere",
               "kjv_def": ":--be (+ sore) afraid, fear (exceedingly),\n reverence.",
               "_strongs": "05399"
            },
            {
               "strongs": "5400",
               "greek": [
                  {
                     "_BETA": "FO/BHTRON",
                     "_unicode": "φόβητρον",
                     "_translit": "phóbētron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fob'-ay-tron"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5399"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "a frightening thing, i.e. terrific\n portent",
               "kjv_def": ":--fearful sight.",
               "_strongs": "05400"
            },
            {
               "strongs": "5401",
               "greek": [
                  {
                     "_BETA": "FO/BOS",
                     "_unicode": "φόβος",
                     "_translit": "phóbos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fob'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FE/BOMAI",
                        "_unicode": "φέβομαι",
                        "_translit": "phébomai"
                     }
                  ],
                  "__text": "from a primary \n (to be put in fear);"
               },
               "strongs_def": "alarm or fright",
               "kjv_def": ":--be\n afraid, + exceedingly, fear, terror.",
               "_strongs": "05401"
            },
            {
               "strongs": "5402",
               "greek": [
                  {
                     "_BETA": "*FOI/BH",
                     "_unicode": "Φοίβη",
                     "_translit": "Phoíbē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foy'-bay"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FOI=BOS",
                        "_unicode": "φοῖβος",
                        "_translit": "phoîbos"
                     }
                  ],
                  "__text": "feminine of \n (bright;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5457"
                     }
                  ],
                  "__text": "probably akin to the base of \n);\n Phœbe, a Christian woman"
               },
               "kjv_def": ":--Phebe.",
               "_strongs": "05402"
            },
            {
               "strongs": "5403",
               "greek": [
                  {
                     "_BETA": "*FOINI/KH",
                     "_unicode": "Φοινίκη",
                     "_translit": "Phoiníkē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foy-nee'-kay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5404"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "palm-country; Phœnice (or Phœnicia), a region of\n Palestine",
               "kjv_def": ":--Phenice, Phenicia.",
               "_strongs": "05403"
            },
            {
               "strongs": "5404",
               "greek": [
                  {
                     "_BETA": "FOI=NIC",
                     "_unicode": "φοῖνιξ",
                     "_translit": "phoînix"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foy'-nix"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a palm-tree",
               "kjv_def": ":--palm (tree).",
               "_strongs": "05404"
            },
            {
               "strongs": "5405",
               "greek": [
                  {
                     "_BETA": "*FOI=NIC",
                     "_unicode": "Φοῖνιξ",
                     "_translit": "Phoînix"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foy'-nix"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5404"
                     }
                  ],
                  "__text": "probably the same as \n;"
               },
               "strongs_def": "Phœnix, a place in Crete",
               "kjv_def": ":--Phenice.",
               "_strongs": "05405"
            },
            {
               "strongs": "5406",
               "greek": [
                  {
                     "_BETA": "FONEU/S",
                     "_unicode": "φονεύς",
                     "_translit": "phoneús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fon-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5408"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "443"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4607"
                     }
                  ],
                  "__text": "a murderer (always of criminal (or at least intentional)\n homicide; which \n does not necessarily imply; while \n is a\n special term for a public bandit)"
               },
               "kjv_def": ":--murderer.",
               "_strongs": "05406"
            },
            {
               "strongs": "5407",
               "greek": [
                  {
                     "_BETA": "FONEU/W",
                     "_unicode": "φονεύω",
                     "_translit": "phoneúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fon-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5406"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a murderer (of)",
               "kjv_def": ":--kill, do murder, slay.",
               "_strongs": "05407"
            },
            {
               "strongs": "5408",
               "greek": [
                  {
                     "_BETA": "FO/NOS",
                     "_unicode": "φόνος",
                     "_translit": "phónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fon'-os"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FE/NW",
                        "_unicode": "φένω",
                        "_translit": "phénō"
                     }
                  ],
                  "__text": "from an obsolete primary \n (to slay);"
               },
               "strongs_def": "murder",
               "kjv_def": ":--murder, + be slain\n with, slaughter.",
               "_strongs": "05408"
            },
            {
               "strongs": "5409",
               "greek": [
                  {
                     "_BETA": "FORE/W",
                     "_unicode": "φορέω",
                     "_translit": "phoréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "for-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5411"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to have a burden, i.e. (by analogy) to wear as clothing or\n a constant accompaniment",
               "kjv_def": ":--bear, wear.",
               "_strongs": "05409"
            },
            {
               "strongs": "5410",
               "greek": [
                  {
                     "_BETA": "*FO/RON",
                     "_unicode": "Φόρον",
                     "_translit": "Phóron"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "for'-on"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "675"
                     }
                  ],
                  "__text": "a forum or market-place; only in compound with\n \n; a station on the Appian road"
               },
               "kjv_def": ":--forum.",
               "_strongs": "05410"
            },
            {
               "strongs": "5411",
               "greek": [
                  {
                     "_BETA": "FO/ROS",
                     "_unicode": "φόρος",
                     "_translit": "phóros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "for'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5056"
                     }
                  ],
                  "__text": "a load (as borne), i.e. (figuratively) a tax (properly, an\n individual assessment on persons or property; whereas \n is usually\n a general toll on goods or travel)"
               },
               "kjv_def": ":--tribute.",
               "_strongs": "05411"
            },
            {
               "strongs": "5412",
               "greek": [
                  {
                     "_BETA": "FORTI/ZW",
                     "_unicode": "φορτίζω",
                     "_translit": "phortízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "for-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5414"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to load up (properly, as a vessel or animal), i.e.\n (figuratively) to overburden with ceremony (or spiritual\n anxiety)",
               "kjv_def": ":--lade, by heavy laden.",
               "_strongs": "05412"
            },
            {
               "strongs": "5413",
               "greek": [
                  {
                     "_BETA": "FORTI/ON",
                     "_unicode": "φορτίον",
                     "_translit": "phortíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "for-tee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5414"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "an invoice (as part of freight), i.e.\n (figuratively) a task or service",
               "kjv_def": ":--burden.",
               "_strongs": "05413"
            },
            {
               "strongs": "5414",
               "greek": [
                  {
                     "_BETA": "FO/RTOS",
                     "_unicode": "φόρτος",
                     "_translit": "phórtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "for'-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "something carried, i.e. the cargo of a ship",
               "kjv_def": ":--lading.",
               "_strongs": "05414"
            },
            {
               "strongs": "5415",
               "greek": [
                  {
                     "_BETA": "*FORTOUNA=TOS",
                     "_unicode": "Φορτουνᾶτος",
                     "_translit": "Phortounâtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "for-too-nat'-os"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "\"fortunate\"; Fortunatus, a Christian",
               "kjv_def": ":--Fortunatus.",
               "_strongs": "05415"
            },
            {
               "strongs": "5416",
               "greek": [
                  {
                     "_BETA": "FRAGE/LLION",
                     "_unicode": "φραγέλλιον",
                     "_translit": "phragéllion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "frag-el'-le-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5417"
                     }
                  ],
                  "__text": "neuter of a derivative from the base of \n;"
               },
               "strongs_def": "a whip, i.e. Roman lash\n as a public punishment",
               "kjv_def": ":--scourge.",
               "_strongs": "05416"
            },
            {
               "strongs": "5417",
               "greek": [
                  {
                     "_BETA": "FRAGELLO/W",
                     "_unicode": "φραγελλόω",
                     "_translit": "phragellóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "frag-el-lo'-o"
                  }
               ],
               "strongs_derivation": {
                  "latin": "flagellum",
                  "__text": "from a presumed equivalent of the Latin \n;"
               },
               "strongs_def": "to whip, i.e. lash\n as a public punishment",
               "kjv_def": ":--scourge.",
               "_strongs": "05417"
            },
            {
               "strongs": "5418",
               "greek": [
                  {
                     "_BETA": "FRAGMO/S",
                     "_unicode": "φραγμός",
                     "_translit": "phragmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "frag-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5420"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a fence, or inclosing barrier (literally or\n figuratively)",
               "kjv_def": ":--hedge (+ round about), partition.",
               "_strongs": "05418"
            },
            {
               "strongs": "5419",
               "greek": [
                  {
                     "_BETA": "FRA/ZW",
                     "_unicode": "φράζω",
                     "_translit": "phrázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "frad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5420"
                     }
                  ],
                  "__text": "probably akin to \n through the idea of defining;"
               },
               "strongs_def": "to indicate (by\n word or act), i.e. (specially), to expound",
               "kjv_def": ":-- declare.",
               "_strongs": "05419"
            },
            {
               "strongs": "5420",
               "greek": [
                  {
                     "_BETA": "FRA/SSW",
                     "_unicode": "φράσσω",
                     "_translit": "phrássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fras'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "apparently a strengthening form of the base of \n;"
               },
               "strongs_def": "to fence or\n inclose, i.e. (specially), to block up (figuratively, to\n silence)",
               "kjv_def": ":--stop.",
               "_strongs": "05420"
            },
            {
               "strongs": "5421",
               "greek": [
                  {
                     "_BETA": "FRE/AR",
                     "_unicode": "φρέαρ",
                     "_translit": "phréar"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "freh'-ar"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a hole in the ground (dug for obtaining or\n holding water or other purposes), i.e. a cistern or well;\n figuratively, an abyss (as a prison)",
               "kjv_def": ":--well, pit.",
               "_strongs": "05421"
            },
            {
               "strongs": "5422",
               "greek": [
                  {
                     "_BETA": "FRENAPATA/W",
                     "_unicode": "φρεναπατάω",
                     "_translit": "phrenapatáō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fren-ap-at-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5423"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a mind-misleader, i.e. delude",
               "kjv_def": ":--deceive.",
               "_strongs": "05422"
            },
            {
               "strongs": "5423",
               "greek": [
                  {
                     "_BETA": "FRENAPA/THS",
                     "_unicode": "φρεναπάτης",
                     "_translit": "phrenapátēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fren-ap-at'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "539"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a mind-misleader, i.e. seducer",
               "kjv_def": ":--deceiver.",
               "_strongs": "05423"
            },
            {
               "strongs": "5424",
               "greek": [
                  {
                     "_BETA": "FRH/N",
                     "_unicode": "φρήν",
                     "_translit": "phrḗn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "frane"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FRA/W",
                        "_unicode": "φράω",
                        "_translit": "phráō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5420"
                     }
                  ],
                  "__text": "probably from an obsolete \n (to rein in or curb; compare \n);"
               },
               "strongs_def": "the midrif (as a partition of the body), i.e. (figuratively and by\n implication, of sympathy) the feelings (or sensitive nature; by\n extension (also in the plural) the mind or cognitive\n faculties)",
               "kjv_def": ":--understanding.",
               "_strongs": "05424"
            },
            {
               "strongs": "5425",
               "greek": [
                  {
                     "_BETA": "FRI/SSW",
                     "_unicode": "φρίσσω",
                     "_translit": "phríssō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fris'-so"
                  }
               ],
               "strongs_derivation": "apparently a primary verb;",
               "strongs_def": "to \"bristle\" or chill, i.e. shudder\n (fear)",
               "kjv_def": ":--tremble.",
               "_strongs": "05425"
            },
            {
               "strongs": "5426",
               "greek": [
                  {
                     "_BETA": "FRONE/W",
                     "_unicode": "φρονέω",
                     "_translit": "phronéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fron-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to exercise the mind, i.e. entertain or have a sentiment or\n opinion; by implication, to be (mentally) disposed (more or less\n earnestly in a certain direction); intensively, to interest oneself in\n (with concern or obedience)",
               "kjv_def": ":--set the affection on, (be) care(-ful),\n (be like-, + be of one, + be of the same, + let this) mind(-ed),\n regard, savour, think.",
               "_strongs": "05426"
            },
            {
               "strongs": "5427",
               "greek": [
                  {
                     "_BETA": "FRO/NHMA",
                     "_unicode": "φρόνημα",
                     "_translit": "phrónēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fron'-ay-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5426"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "(mental) inclination or purpose",
               "kjv_def": ":--(be, + be carnally, + be\n spiritually) mind(-ed).",
               "_strongs": "05427"
            },
            {
               "strongs": "5428",
               "greek": [
                  {
                     "_BETA": "FRO/NHSIS",
                     "_unicode": "φρόνησις",
                     "_translit": "phrónēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fron'-ay-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5426"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "mental action or activity, i.e. intellectual or moral\n insight",
               "kjv_def": ":--prudence, wisdom.",
               "_strongs": "05428"
            },
            {
               "strongs": "5429",
               "greek": [
                  {
                     "_BETA": "FRO/NIMOS",
                     "_unicode": "φρόνιμος",
                     "_translit": "phrónimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fron'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4680"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4908"
                     }
                  ],
                  "__text": "thoughtful, i.e. sagacious or discreet (implying a cautious\n character; while \n denotes practical skill or acumen; and \n\n indicates rather intelligence or mental acquirement); in a bad sense\n conceited (also in the comparative)"
               },
               "kjv_def": ":--wise(-r).",
               "_strongs": "05429"
            },
            {
               "strongs": "5430",
               "greek": [
                  {
                     "_BETA": "FRONI/MWS",
                     "_unicode": "φρονίμως",
                     "_translit": "phronímōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fron-im'-oce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5429"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "prudently",
               "kjv_def": ":--wisely.",
               "_strongs": "05430"
            },
            {
               "strongs": "5431",
               "greek": [
                  {
                     "_BETA": "FRONTI/ZW",
                     "_unicode": "φροντίζω",
                     "_translit": "phrontízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fron-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5424"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to exercise thought, i.e. be anxious",
               "kjv_def": ":--be\n careful.",
               "_strongs": "05431"
            },
            {
               "strongs": "5432",
               "greek": [
                  {
                     "_BETA": "FROURE/W",
                     "_unicode": "φρουρέω",
                     "_translit": "phrouréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "froo-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4253"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3708"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be a watcher in advance, i.e. to\n mount guard as a sentinel (post spies at gates); figuratively, to hem\n in, protect",
               "kjv_def": ":--keep (with a garrison).",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5083"
                  }
               ],
               "_strongs": "05432",
               "__text": "Compare \n."
            },
            {
               "strongs": "5433",
               "greek": [
                  {
                     "_BETA": "FRUA/SSW",
                     "_unicode": "φρυάσσω",
                     "_translit": "phryássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "froo-as'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1032"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1031"
                     }
                  ],
                  "__text": "akin to \n, \n;"
               },
               "strongs_def": "to snort (as a spirited horse), i.e.\n (figuratively) to make a tumult",
               "kjv_def": ":--rage.",
               "_strongs": "05433"
            },
            {
               "strongs": "5434",
               "greek": [
                  {
                     "_BETA": "FRU/GANON",
                     "_unicode": "φρύγανον",
                     "_translit": "phrýganon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "froo'-gan-on"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FRU/GW",
                        "_unicode": "φρύγω",
                        "_translit": "phrýgō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5395"
                     }
                  ],
                  "__text": "neuter of a presumed derivative of \n (to roast or parch; akin to\n the base of \n);"
               },
               "strongs_def": "something desiccated, i.e. a dry twig",
               "kjv_def": ":--stick.",
               "_strongs": "05434"
            },
            {
               "strongs": "5435",
               "greek": [
                  {
                     "_BETA": "*FRUGI/A",
                     "_unicode": "Φρυγία",
                     "_translit": "Phrygía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "froog-ee'-ah"
                  }
               ],
               "strongs_derivation": "probably of foreign origin;",
               "strongs_def": "Phrygia, a region of Asia Minor",
               "kjv_def": ":--Phrygia.",
               "_strongs": "05435"
            },
            {
               "strongs": "5436",
               "greek": [
                  {
                     "_BETA": "*FU/GELLOS",
                     "_unicode": "Φύγελλος",
                     "_translit": "Phýgellos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foog'-el-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5343"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "fugitive; Phygellus, an apostate\n Christian",
               "kjv_def": ":--Phygellus.",
               "_strongs": "05436"
            },
            {
               "strongs": "5437",
               "greek": [
                  {
                     "_BETA": "FUGH/",
                     "_unicode": "φυγή",
                     "_translit": "phygḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foog-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5343"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a fleeing, i.e. escape",
               "kjv_def": ":--flight.",
               "_strongs": "05437"
            },
            {
               "strongs": "5438",
               "greek": [
                  {
                     "_BETA": "FULAKH/",
                     "_unicode": "φυλακή",
                     "_translit": "phylakḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-lak-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5442"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a guarding or (concretely, guard), the act, the person;\n figuratively, the place, the condition, or (specially), the time (as a\n division of day or night), literally or figuratively",
               "kjv_def": ":--cage, hold,\n (im-)prison(-ment), ward, watch.",
               "_strongs": "05438"
            },
            {
               "strongs": "5439",
               "greek": [
                  {
                     "_BETA": "FULAKI/ZW",
                     "_unicode": "φυλακίζω",
                     "_translit": "phylakízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-lak-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5441"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to incarcerate",
               "kjv_def": ":--imprison.",
               "_strongs": "05439"
            },
            {
               "strongs": "5440",
               "greek": [
                  {
                     "_BETA": "FULAKTH/RION",
                     "_unicode": "φυλακτήριον",
                     "_translit": "phylaktḗrion"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-lak-tay'-ree-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5442"
                     }
                  ],
                  "__text": "neuter of a derivative of \n;"
               },
               "strongs_def": "a guard-case, i.e. \"phylactery\" for\n wearing slips of Scripture texts",
               "kjv_def": ":-- phylactery.",
               "_strongs": "05440"
            },
            {
               "strongs": "5441",
               "greek": [
                  {
                     "_BETA": "FU/LAC",
                     "_unicode": "φύλαξ",
                     "_translit": "phýlax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo'-lax"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5442"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a watcher or sentry",
               "kjv_def": ":--keeper.",
               "_strongs": "05441"
            },
            {
               "strongs": "5442",
               "greek": [
                  {
                     "_BETA": "FULA/SSW",
                     "_unicode": "φυλάσσω",
                     "_translit": "phylássō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-las'-so"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5443"
                     }
                  ],
                  "__text": "probably from \n through the idea of isolation;"
               },
               "strongs_def": "to watch, i.e. be on\n guard (literally of figuratively); by implication, to preserve, obey,\n avoid",
               "kjv_def": ":--beward, keep (self), observe, save.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5083"
                  }
               ],
               "_strongs": "05442",
               "__text": "Compare \n."
            },
            {
               "strongs": "5443",
               "greek": [
                  {
                     "_BETA": "FULH/",
                     "_unicode": "φυλή",
                     "_translit": "phylḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-lay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5444"
                     }
                  ],
                  "__text": "from \n (compare \n);"
               },
               "strongs_def": "an offshoot, i.e. race or clan",
               "kjv_def": ":--kindred,\n tribe.",
               "_strongs": "05443"
            },
            {
               "strongs": "5444",
               "greek": [
                  {
                     "_BETA": "FU/LLON",
                     "_unicode": "φύλλον",
                     "_translit": "phýllon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fool'-lon"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5443"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a sprout, i.e. leaf",
               "kjv_def": ":--leaf.",
               "_strongs": "05444"
            },
            {
               "strongs": "5445",
               "greek": [
                  {
                     "_BETA": "FU/RAMA",
                     "_unicode": "φύραμα",
                     "_translit": "phýrama"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo'-ram-ah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FU/RW",
                        "_unicode": "φύρω",
                        "_translit": "phýrō"
                     }
                  ],
                  "__text": "from a prolonged form of \n (to mix a liquid with a solid;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "__text": "perhaps\n akin to \n through the idea of swelling in bulk), mean to knead; a\n mass of dough"
               },
               "kjv_def": ":--lump.",
               "_strongs": "05445"
            },
            {
               "strongs": "5446",
               "greek": [
                  {
                     "_BETA": "FUSIKO/S",
                     "_unicode": "φυσικός",
                     "_translit": "physikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-see-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5449"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "\"physical\", i.e. (by implication) instinctive",
               "kjv_def": ":--natural.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5591"
                  }
               ],
               "_strongs": "05446",
               "__text": "Compare \n."
            },
            {
               "strongs": "5447",
               "greek": [
                  {
                     "_BETA": "FUSIKW=S",
                     "_unicode": "φυσικῶς",
                     "_translit": "physikōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-see-koce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5446"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "\"physically\", i.e. (by implication)\n instinctively",
               "kjv_def": ":--naturally.",
               "_strongs": "05447"
            },
            {
               "strongs": "5448",
               "greek": [
                  {
                     "_BETA": "FUSIO/W",
                     "_unicode": "φυσιόω",
                     "_translit": "physióō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-see-o'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5449"
                     }
                  ],
                  "__text": "from \n in the primary sense of blowing;"
               },
               "strongs_def": "to inflate, i.e.\n (figuratively) make proud (haughty)",
               "kjv_def": ":--puff up.",
               "_strongs": "05448"
            },
            {
               "strongs": "5449",
               "greek": [
                  {
                     "_BETA": "FU/SIS",
                     "_unicode": "φύσις",
                     "_translit": "phýsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "growth (by germination or expansion), i.e. (by implication)\n natural production (lineal descent); by extension, a genus or sort;\n figuratively, native disposition, constitution or usage",
               "kjv_def": ":--(man-)kind,\n nature(-al).",
               "_strongs": "05449"
            },
            {
               "strongs": "5450",
               "greek": [
                  {
                     "_BETA": "FUSI/WSIS",
                     "_unicode": "φυσίωσις",
                     "_translit": "physíōsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-see'-o-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5448"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "inflation, i.e. (figuratively) haughtiness",
               "kjv_def": ":--swelling.",
               "_strongs": "05450"
            },
            {
               "strongs": "5451",
               "greek": [
                  {
                     "_BETA": "FUTEI/A",
                     "_unicode": "φυτεία",
                     "_translit": "phyteía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo-ti'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5452"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "trans-planting, i.e. (concretely) a shrub or\n vegetable",
               "kjv_def": ":--plant.",
               "_strongs": "05451"
            },
            {
               "strongs": "5452",
               "greek": [
                  {
                     "_BETA": "FUTEU/W",
                     "_unicode": "φυτεύω",
                     "_translit": "phyteúō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foot-yoo'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5453"
                     }
                  ],
                  "__text": "from a derivative of \n;"
               },
               "strongs_def": "to set out in the earth, i.e. implant;\n figuratively, to instil doctrine",
               "kjv_def": ":--plant.",
               "_strongs": "05452"
            },
            {
               "strongs": "5453",
               "greek": [
                  {
                     "_BETA": "FU/W",
                     "_unicode": "φύω",
                     "_translit": "phýō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foo'-o"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "probably originally, to \"puff\" or blow, i.e. to swell\n up; but only used in the implied sense, to germinate or grow (sprout,\n produce), literally or figuratively",
               "kjv_def": ":--spring (up).",
               "_strongs": "05453"
            },
            {
               "strongs": "5454",
               "greek": [
                  {
                     "_BETA": "FWLEO/S",
                     "_unicode": "φωλεός",
                     "_translit": "phōleós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fo-leh-os'"
                  }
               ],
               "strongs_derivation": "of uncertain derivative;",
               "strongs_def": "a burrow or lurking-place",
               "kjv_def": ":--hole.",
               "_strongs": "05454"
            },
            {
               "strongs": "5455",
               "greek": [
                  {
                     "_BETA": "FWNE/W",
                     "_unicode": "φωνέω",
                     "_translit": "phōnéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fo-neh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5456"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to emit a sound (animal, human or instrumental); by\n implication, to address in words or by name, also in imitation",
               "kjv_def": ":--call\n (for), crow, cry.",
               "_strongs": "05455"
            },
            {
               "strongs": "5456",
               "greek": [
                  {
                     "_BETA": "FWNH/",
                     "_unicode": "φωνή",
                     "_translit": "phōnḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fo-nay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     }
                  ],
                  "__text": "probably akin to \n through the idea of disclosure;"
               },
               "strongs_def": "a tone\n (articulate, bestial or artificial); by implication, an address (for\n any purpose), saying or language",
               "kjv_def": ":--noise, sound, voice.",
               "_strongs": "05456"
            },
            {
               "strongs": "5457",
               "greek": [
                  {
                     "_BETA": "FW=S",
                     "_unicode": "φῶς",
                     "_translit": "phōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foce"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "FA/W",
                        "_unicode": "φάω",
                        "_translit": "pháō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5316"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5346"
                     }
                  ],
                  "__text": "from an obsolete \n (to shine or make manifest, especially by rays;\n compare \n, \n);"
               },
               "strongs_def": "luminousness (in the widest application, natural\n or artificial, abstract or concrete, literal or figurative)",
               "kjv_def": ":--fire,\n light.",
               "_strongs": "05457"
            },
            {
               "strongs": "5458",
               "greek": [
                  {
                     "_BETA": "FWSTH/R",
                     "_unicode": "φωστήρ",
                     "_translit": "phōstḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foce-tare'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5457"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an illuminator, i.e. (concretely) a luminary, or\n (abstractly) brilliancy",
               "kjv_def": ":--light.",
               "_strongs": "05458"
            },
            {
               "strongs": "5459",
               "greek": [
                  {
                     "_BETA": "FWSFO/ROS",
                     "_unicode": "φωσφόρος",
                     "_translit": "phōsphóros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "foce-for'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5457"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "light-bearing (\"phosphorus\"), i.e. (specially),\n the morning-star (figuratively)",
               "kjv_def": ":--day star.",
               "_strongs": "05459"
            },
            {
               "strongs": "5460",
               "greek": [
                  {
                     "_BETA": "FWTEINO/S",
                     "_unicode": "φωτεινός",
                     "_translit": "phōteinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fo-ti-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5457"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "lustrous, i.e. transparent or well-illuminated\n (figuratively)",
               "kjv_def": ":--bright, full of light.",
               "_strongs": "05460"
            },
            {
               "strongs": "5461",
               "greek": [
                  {
                     "_BETA": "FWTI/ZW",
                     "_unicode": "φωτίζω",
                     "_translit": "phōtízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fo-tid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5457"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to shed rays, i.e. to shine or (transitively) to brighten\n up (literally or figuratively)",
               "kjv_def": ":--enlighten, illuminate, (bring to,\n give) light, make to see.",
               "_strongs": "05461"
            },
            {
               "strongs": "5462",
               "greek": [
                  {
                     "_BETA": "FWTISMO/S",
                     "_unicode": "φωτισμός",
                     "_translit": "phōtismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "fo-tis-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5461"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "illumination (figuratively)",
               "kjv_def": ":--light.",
               "_strongs": "05462"
            },
            {
               "strongs": "5463",
               "greek": [
                  {
                     "_BETA": "XAI/RW",
                     "_unicode": "χαίρω",
                     "_translit": "chaírō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khah'-ee-ro"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": "to be \"cheer\"ful, i.e. calmly happy or well-off;\n impersonally, especially as salutation (on meeting or parting), be\n well",
               "kjv_def": ":--farewell, be glad, God speed, greeting, hall, joy(- fully),\n rejoice.",
               "_strongs": "05463"
            },
            {
               "strongs": "5464",
               "greek": [
                  {
                     "_BETA": "XA/LAZA",
                     "_unicode": "χάλαζα",
                     "_translit": "chálaza"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal'-ad-zah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5465"
                     }
                  ],
                  "__text": "probably from \n;"
               },
               "strongs_def": "hail",
               "kjv_def": ":--hail.",
               "_strongs": "05464"
            },
            {
               "strongs": "5465",
               "greek": [
                  {
                     "_BETA": "XALA/W",
                     "_unicode": "χαλάω",
                     "_translit": "chaláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5490"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "to lower (as into a void)",
               "kjv_def": ":--let down, strike.",
               "_strongs": "05465"
            },
            {
               "strongs": "5466",
               "greek": [
                  {
                     "_BETA": "*XALDAI=OS",
                     "_unicode": "Χαλδαῖος",
                     "_translit": "Chaldaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-dah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03778"
                     }
                  ],
                  "__text": "probably of Hebrew or (\n);"
               },
               "strongs_def": "a Chaldæan (i.e. Kasdi), or native or\n the region of the lower Euphrates",
               "kjv_def": ":--Chaldæan.",
               "_strongs": "05466"
            },
            {
               "strongs": "5467",
               "greek": [
                  {
                     "_BETA": "XALEPO/S",
                     "_unicode": "χαλεπός",
                     "_translit": "chalepós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-ep-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5465"
                     }
                  ],
                  "__text": "perhaps from \n through the idea of reducing the strength;"
               },
               "strongs_def": "difficult, i.e. dangerous, or (by implication) furious",
               "kjv_def": ":--fierce,\n perilous.",
               "_strongs": "05467"
            },
            {
               "strongs": "5468",
               "greek": [
                  {
                     "_BETA": "XALINAGWGE/W",
                     "_unicode": "χαλιναγωγέω",
                     "_translit": "chalinagōgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-in-ag-ogue-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5469"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from a compound of \n and the reduplicated form of \n;"
               },
               "strongs_def": "to be a\n bit-leader, i.e. to curb (figuratively)",
               "kjv_def": ":--bridle.",
               "_strongs": "05468"
            },
            {
               "strongs": "5469",
               "greek": [
                  {
                     "_BETA": "XALINO/S",
                     "_unicode": "χαλινός",
                     "_translit": "chalinós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-ee-nos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5465"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a curb or head-stall (as curbing the spirit)",
               "kjv_def": ":--bit, bridle.",
               "_strongs": "05469"
            },
            {
               "strongs": "5470",
               "greek": [
                  {
                     "_BETA": "XA/LKEOS",
                     "_unicode": "χάλκεος",
                     "_translit": "chálkeos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal'-keh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5475"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "coppery",
               "kjv_def": ":--brass.",
               "_strongs": "05470"
            },
            {
               "strongs": "5471",
               "greek": [
                  {
                     "_BETA": "XALKEU/S",
                     "_unicode": "χαλκεύς",
                     "_translit": "chalkeús"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khalk-yooce'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5475"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a copper-worker or brazier",
               "kjv_def": ":--coppersmith.",
               "_strongs": "05471"
            },
            {
               "strongs": "5472",
               "greek": [
                  {
                     "_BETA": "XALKHDW/N",
                     "_unicode": "χαλκηδών",
                     "_translit": "chalkēdṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-kay-dohn'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5475"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1491"
                     }
                  ],
                  "__text": "from \n and perhaps \n;"
               },
               "strongs_def": "copper-like, i.e.\n \"chalcedony\"",
               "kjv_def": ":--chalcedony.",
               "_strongs": "05472"
            },
            {
               "strongs": "5473",
               "greek": [
                  {
                     "_BETA": "XALKI/ON",
                     "_unicode": "χαλκίον",
                     "_translit": "chalkíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-kee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5475"
                     }
                  ],
                  "__text": "diminutive from \n;"
               },
               "strongs_def": "a copper dish",
               "kjv_def": ":--brazen vessel.",
               "_strongs": "05473"
            },
            {
               "strongs": "5474",
               "greek": [
                  {
                     "_BETA": "XALKOLI/BANON",
                     "_unicode": "χαλκολίβανον",
                     "_translit": "chalkolíbanon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-kol-ib'-an-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5475"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3030"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n (in the implied mean of\n whiteness or brilliancy);"
               },
               "strongs_def": "burnished copper, an alloy of copper (or\n gold) and silver having a brilliant lustre",
               "kjv_def": ":--fine brass.",
               "_strongs": "05474"
            },
            {
               "strongs": "5475",
               "greek": [
                  {
                     "_BETA": "XALKO/S",
                     "_unicode": "χαλκός",
                     "_translit": "chalkós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khal-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5465"
                     }
                  ],
                  "__text": "perhaps from \n through the idea of hollowing out as a vessel (this\n metal being chiefly used for that purpose);"
               },
               "strongs_def": "copper (the substance, or\n some implement or coin made of it)",
               "kjv_def": ":--brass, money.",
               "_strongs": "05475"
            },
            {
               "strongs": "5476",
               "greek": [
                  {
                     "_BETA": "XAMAI/",
                     "_unicode": "χαμαί",
                     "_translit": "chamaí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kham-ah'-ee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5490"
                     }
                  ],
                  "__text": "adverb perhaps from the base of \n through the idea of a fissure in\n the soil;"
               },
               "strongs_def": "earthward, i.e. prostrate",
               "kjv_def": ":--on (to) the ground.",
               "_strongs": "05476"
            },
            {
               "strongs": "5477",
               "greek": [
                  {
                     "_BETA": "*XANAA/N",
                     "_unicode": "Χαναάν",
                     "_translit": "Chanaán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khan-ah-an'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03667"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Chanaan (i.e. Kenaan), the early name of\n Palestine",
               "kjv_def": ":--Chanaan.",
               "_strongs": "05477"
            },
            {
               "strongs": "5478",
               "greek": [
                  {
                     "_BETA": "*XANAANAI=OS",
                     "_unicode": "Χανααναῖος",
                     "_translit": "Chanaanaîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khan-ah-an-ah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5477"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Chanaanæan (i.e. Kenaanite), or native of gentile\n Palestine",
               "kjv_def": ":--of Canaan.",
               "_strongs": "05478"
            },
            {
               "strongs": "5479",
               "greek": [
                  {
                     "_BETA": "XARA/",
                     "_unicode": "χαρά",
                     "_translit": "chará"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar-ah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5463"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "cheerfulness, i.e. calm delight",
               "kjv_def": ":--gladness, X greatly, (X\n be exceeding) joy(-ful, -fully, -fulness, -ous).",
               "_strongs": "05479"
            },
            {
               "strongs": "5480",
               "greek": [
                  {
                     "_BETA": "XA/RAGMA",
                     "_unicode": "χάραγμα",
                     "_translit": "cháragma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar'-ag-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5482"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a scratch or etching, i.e. stamp (as a badge of\n servitude), or sculptured figure (statue)",
               "kjv_def": ":--graven, mark.",
               "_strongs": "05480"
            },
            {
               "strongs": "5481",
               "greek": [
                  {
                     "_BETA": "XARAKTH/R",
                     "_unicode": "χαρακτήρ",
                     "_translit": "charaktḗr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar-ak-tare'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5482"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a graver (the tool or the person), i.e. (by\n implication) engraving ((\"character\"), the figure stamped, i.e. an\n exact copy or (figuratively) representation)",
               "kjv_def": ":--express image.",
               "_strongs": "05481"
            },
            {
               "strongs": "5482",
               "greek": [
                  {
                     "_BETA": "XA/RAC",
                     "_unicode": "χάραξ",
                     "_translit": "chárax"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar'-ax"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "XARA/SSW",
                        "_unicode": "χαράσσω",
                        "_translit": "charássō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "from \n (to sharpen to a point; akin to \n through the idea of\n scratching);"
               },
               "strongs_def": "a stake, i.e. (by implication) a palisade or rampart\n (military mound for circumvallation in a siege)",
               "kjv_def": ":--trench.",
               "_strongs": "05482"
            },
            {
               "strongs": "5483",
               "greek": [
                  {
                     "_BETA": "XARI/ZOMAI",
                     "_unicode": "χαρίζομαι",
                     "_translit": "charízomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar-id'-zom-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5485"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to grant as a favor, i.e. gratuitously, in\n kindness, pardon or rescue",
               "kjv_def": ":--deliver, (frankly) forgive, (freely)\n give, grant.",
               "_strongs": "05483"
            },
            {
               "strongs": "5484",
               "greek": [
                  {
                     "_BETA": "XA/RIN",
                     "_unicode": "χάριν",
                     "_translit": "chárin"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar'-in"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5485"
                     }
                  ],
                  "__text": "accusative case of \n as preposition;"
               },
               "strongs_def": "through favor of, i.e. on\n account of",
               "kjv_def": ":--be-(for) cause of, for sake of,\n +…fore, X reproachfully.",
               "_strongs": "05484"
            },
            {
               "strongs": "5485",
               "greek": [
                  {
                     "_BETA": "XA/RIS",
                     "_unicode": "χάρις",
                     "_translit": "cháris"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar'-ece"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5463"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "graciousness (as gratifying), of manner or act (abstract or\n concrete; literal, figurative or spiritual; especially the divine\n influence upon the heart, and its reflection in the life; including\n gratitude)",
               "kjv_def": ":--acceptable, benefit, favour, gift, grace(- ious), joy,\n liberality, pleasure, thank(-s, -worthy).",
               "_strongs": "05485"
            },
            {
               "strongs": "5486",
               "greek": [
                  {
                     "_BETA": "XA/RISMA",
                     "_unicode": "χάρισμα",
                     "_translit": "chárisma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar'-is-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5483"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a (divine) gratuity, i.e. deliverance (from danger or\n passion); (specially), a (spiritual) endowment, i.e. (subjectively)\n religious qualification, or (objectively) miraculous faculty",
               "kjv_def": ":--(free)\n gift.",
               "_strongs": "05486"
            },
            {
               "strongs": "5487",
               "greek": [
                  {
                     "_BETA": "XARITO/W",
                     "_unicode": "χαριτόω",
                     "_translit": "charitóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar-ee-to'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5485"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to grace, i.e. indue with special honor",
               "kjv_def": ":--make accepted, be\n highly favoured.",
               "_strongs": "05487"
            },
            {
               "strongs": "5488",
               "greek": [
                  {
                     "_BETA": "*XAR)R(A/N",
                     "_unicode": "Χαῤῥάν",
                     "_translit": "Charrhán"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar-hran'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "02771"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Charrhan (i.e. Charan), a place in\n Mesopotamia",
               "kjv_def": ":--Charran.",
               "_strongs": "05488"
            },
            {
               "strongs": "5489",
               "greek": [
                  {
                     "_BETA": "XA/RTHS",
                     "_unicode": "χάρτης",
                     "_translit": "chártēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khar'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5482"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a sheet (\"chart\") of writing-material (as to be\n scribbled over)",
               "kjv_def": ":--paper.",
               "_strongs": "05489"
            },
            {
               "strongs": "5490",
               "greek": [
                  {
                     "_BETA": "XA/SMA",
                     "_unicode": "χάσμα",
                     "_translit": "chásma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khas'-mah"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "XA/W",
                        "_unicode": "χάω",
                        "_translit": "cháō"
                     }
                  ],
                  "__text": "from a form of an obsolete primary \n (to \"gape\" or \"yawn\");"
               },
               "strongs_def": "a\n \"chasm\" or vacancy (impassable interval)",
               "kjv_def": ":--gulf.",
               "_strongs": "05490"
            },
            {
               "strongs": "5491",
               "greek": [
                  {
                     "_BETA": "XEI=LOS",
                     "_unicode": "χεῖλος",
                     "_translit": "cheîlos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi'-los"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5490"
                     }
                  ],
                  "__text": "from a form of the same as \n;"
               },
               "strongs_def": "a lip (as a pouring place);\n figuratively, a margin (of water)",
               "kjv_def": ":--lip, shore.",
               "_strongs": "05491"
            },
            {
               "strongs": "5492",
               "greek": [
                  {
                     "_BETA": "XEIMA/ZW",
                     "_unicode": "χειμάζω",
                     "_translit": "cheimázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi-mad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5494"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to storm, i.e. (passively) to labor under a\n gale",
               "kjv_def": ":--be tossed with tempest.",
               "_strongs": "05492"
            },
            {
               "strongs": "5493",
               "greek": [
                  {
                     "_BETA": "XEI/MAR)R(OS",
                     "_unicode": "χείμαῤῥος",
                     "_translit": "cheímarrhos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi'-mar-hros"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5494"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4482"
                     }
                  ],
                  "__text": "from the base of \n and \n;"
               },
               "strongs_def": "a storm-runlet, i.e.\n winter-torrent",
               "kjv_def": ":--brook.",
               "_strongs": "05493"
            },
            {
               "strongs": "5494",
               "greek": [
                  {
                     "_BETA": "XEIMW/N",
                     "_unicode": "χειμών",
                     "_translit": "cheimṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi-mone'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "XE/W",
                        "_unicode": "χέω",
                        "_translit": "chéō"
                     }
                  ],
                  "__text": "from a derivative of \n (to pour;"
               },
               "strongs_def": "akin to the base of 5490 through\n the idea of a channel), meaning a storm (as pouring rain); by\n implication, the rainy season, i.e. winter",
               "kjv_def": ":--tempest, foul weather,\n winter.",
               "_strongs": "05494"
            },
            {
               "strongs": "5495",
               "greek": [
                  {
                     "_BETA": "XEI/R",
                     "_unicode": "χείρ",
                     "_translit": "cheír"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khire"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5494"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5490"
                     }
                  ],
                  "__text": "perhaps from the base of \n in the sense of its congener the base of\n \n (through the idea of hollowness for grasping);"
               },
               "strongs_def": "the hand\n (literally or figuratively (power); especially (by Hebraism) a means\n or instrument)",
               "kjv_def": ":--hand.",
               "_strongs": "05495"
            },
            {
               "strongs": "5496",
               "greek": [
                  {
                     "_BETA": "XEIRAGWGE/W",
                     "_unicode": "χειραγωγέω",
                     "_translit": "cheiragōgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi-rag-ogue-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5497"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be a hand-leader, i.e. to guide (a blind person)",
               "kjv_def": ":--lead\n by the hand.",
               "_strongs": "05496"
            },
            {
               "strongs": "5497",
               "greek": [
                  {
                     "_BETA": "XEIRAGWGO/S",
                     "_unicode": "χειραγωγός",
                     "_translit": "cheiragōgós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi-rag-o-gos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from \n and a reduplicated form of \n;"
               },
               "strongs_def": "a hand-leader, i.e. personal\n conductor (of a blind person)",
               "kjv_def": ":--some to lead by the hand.",
               "_strongs": "05497"
            },
            {
               "strongs": "5498",
               "greek": [
                  {
                     "_BETA": "XEIRO/GRAFON",
                     "_unicode": "χειρόγραφον",
                     "_translit": "cheirógraphon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi-rog'-raf-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1125"
                     }
                  ],
                  "__text": "neuter of a compound of \n and \n;"
               },
               "strongs_def": "something hand-written\n (\"chirograph\"), i.e. a manuscript (specially, a legal document or bond\n (figuratively))",
               "kjv_def": ":--handwriting.",
               "_strongs": "05498"
            },
            {
               "strongs": "5499",
               "greek": [
                  {
                     "_BETA": "XEIROPOI/HTOS",
                     "_unicode": "χειροποίητος",
                     "_translit": "cheiropoíētos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi-rop-oy'-ay-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4160"
                     }
                  ],
                  "__text": "from \n and a derivative of \n;"
               },
               "strongs_def": "manufactured, i.e. of human\n construction",
               "kjv_def": ":--made by (make with) hands.",
               "_strongs": "05499"
            },
            {
               "strongs": "5500",
               "greek": [
                  {
                     "_BETA": "XEIROTONE/W",
                     "_unicode": "χειροτονέω",
                     "_translit": "cheirotonéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi-rot-on-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "TEI/NW",
                        "_unicode": "τείνω",
                        "_translit": "teínō"
                     }
                  ],
                  "__text": "from a compound of \n and \n (to stretch);"
               },
               "strongs_def": "to be a\n hand-reacher or voter (by raising the hand), i.e. (generally) to\n select or appoint",
               "kjv_def": ":--choose, ordain.",
               "_strongs": "05500"
            },
            {
               "strongs": "5501",
               "greek": [
                  {
                     "_BETA": "XEI/RWN",
                     "_unicode": "χείρων",
                     "_translit": "cheírōn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khi'-rone"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2556"
                     }
                  ],
                  "__text": "irregular comparative of \n;"
               },
               "strongs_def": {
                  "greek": [
                     {
                        "_BETA": "XE/RHS",
                        "_unicode": "χέρης",
                        "_translit": "chérēs"
                     }
                  ],
                  "__text": "from an obsolete equivalent\n \n (of uncertain derivation); more evil or aggravated\n (physically, mentally or morally)"
               },
               "kjv_def": ":--sorer, worse.",
               "_strongs": "05501"
            },
            {
               "strongs": "5502",
               "greek": [
                  {
                     "_BETA": "XEROUBI/M",
                     "_unicode": "χερουβίμ",
                     "_translit": "cheroubím"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kher-oo-beem'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03742"
                     }
                  ],
                  "__text": "plural of Hebrew origin (\n);"
               },
               "strongs_def": "\"cherubim\" (i.e. cherubs or\n kerubim)",
               "kjv_def": ":--cherubims.",
               "_strongs": "05502"
            },
            {
               "strongs": "5503",
               "greek": [
                  {
                     "_BETA": "XH/RA",
                     "_unicode": "χήρα",
                     "_translit": "chḗra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khay'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5490"
                     }
                  ],
                  "__text": "feminine of a presumed derivative apparently from the base of \n\n through the idea of deficiency;"
               },
               "strongs_def": "a widow (as lacking a husband),\n literally or figuratively",
               "kjv_def": ":--widow.",
               "_strongs": "05503"
            },
            {
               "strongs": "5504",
               "greek": [
                  {
                     "_BETA": "XQE/S",
                     "_unicode": "χθές",
                     "_translit": "chthés"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khthes"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "\"yesterday\"; by extension, in time past or\n hitherto",
               "kjv_def": ":--yesterday.",
               "_strongs": "05504"
            },
            {
               "strongs": "5505",
               "greek": [
                  {
                     "_BETA": "XILIA/S",
                     "_unicode": "χιλιάς",
                     "_translit": "chiliás"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khil-ee-as'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5507"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "one thousand (\"chiliad\")",
               "kjv_def": ":--thousand.",
               "_strongs": "05505"
            },
            {
               "strongs": "5506",
               "greek": [
                  {
                     "_BETA": "XILI/ARXOS",
                     "_unicode": "χιλίαρχος",
                     "_translit": "chilíarchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khil-ee'-ar-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5507"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "757"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "the commander of a thousand soldiers (\"chiliarch\";\n i.e. colonel",
               "kjv_def": ":--(chief, high) captain.",
               "_strongs": "05506"
            },
            {
               "strongs": "5507",
               "greek": [
                  {
                     "_BETA": "XI/LIOI",
                     "_unicode": "χίλιοι",
                     "_translit": "chílioi"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khil'-ee-oy"
                  }
               ],
               "strongs_derivation": "plural of uncertain affinity;",
               "strongs_def": "a thousand",
               "kjv_def": ":--thousand.",
               "_strongs": "05507"
            },
            {
               "strongs": "5508",
               "greek": [
                  {
                     "_BETA": "*XI/OS",
                     "_unicode": "Χίος",
                     "_translit": "Chíos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khee'-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Chios, an island in the\n Mediterranean",
               "kjv_def": ":--Chios.",
               "_strongs": "05508"
            },
            {
               "strongs": "5509",
               "greek": [
                  {
                     "_BETA": "XITW/N",
                     "_unicode": "χιτών",
                     "_translit": "chitṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khee-tone'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03801"
                     }
                  ],
                  "__text": "of foreign origin (\n);"
               },
               "strongs_def": "a tunic or shirt",
               "kjv_def": ":--clothes, coat, garment.",
               "_strongs": "05509"
            },
            {
               "strongs": "5510",
               "greek": [
                  {
                     "_BETA": "XIW/N",
                     "_unicode": "χιών",
                     "_translit": "chiṓn"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khee-one'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5490"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5465"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5494"
                     }
                  ],
                  "__text": "perhaps akin to the base of \n (\n) or \n (as descending or\n empty);"
               },
               "strongs_def": "snow",
               "kjv_def": ":--snow.",
               "_strongs": "05510"
            },
            {
               "strongs": "5511",
               "greek": [
                  {
                     "_BETA": "XLAMU/S",
                     "_unicode": "χλαμύς",
                     "_translit": "chlamýs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khlam-ooce'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a military cloak",
               "kjv_def": ":--robe.",
               "_strongs": "05511"
            },
            {
               "strongs": "5512",
               "greek": [
                  {
                     "_BETA": "XLEUA/ZW",
                     "_unicode": "χλευάζω",
                     "_translit": "chleuázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khlyoo-ad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5491"
                     }
                  ],
                  "__text": "from a derivative probably of \n;"
               },
               "strongs_def": "to throw out the lip, i.e. jeer\n at",
               "kjv_def": ":--mock.",
               "_strongs": "05512"
            },
            {
               "strongs": "5513",
               "greek": [
                  {
                     "_BETA": "XLIARO/S",
                     "_unicode": "χλιαρός",
                     "_translit": "chliarós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khlee-ar-os'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "XLI/W",
                        "_unicode": "χλίω",
                        "_translit": "chlíō"
                     }
                  ],
                  "__text": "from \n (to warm);"
               },
               "strongs_def": "tepid",
               "kjv_def": ":--lukewarm.",
               "_strongs": "05513"
            },
            {
               "strongs": "5514",
               "greek": [
                  {
                     "_BETA": "*XLO/H",
                     "_unicode": "Χλόη",
                     "_translit": "Chlóē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khlo'-ay"
                  }
               ],
               "strongs_derivation": "feminine of apparently a primary word;",
               "strongs_def": "\"green\"; Chloë, a Christian\n female",
               "kjv_def": ":--Chloe.",
               "_strongs": "05514"
            },
            {
               "strongs": "5515",
               "greek": [
                  {
                     "_BETA": "XLWRO/S",
                     "_unicode": "χλωρός",
                     "_translit": "chlōrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khlo-ros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5514"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "greenish, i.e. verdant, dun-colored",
               "kjv_def": ":--green,\n pale.",
               "_strongs": "05515"
            },
            {
               "strongs": "5516",
               "greek": [
                  {
                     "_BETA": "XC#2",
                     "_unicode": "χξϛ",
                     "_translit": "chx stigma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khee xee stig'-ma"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4742"
                     }
                  ],
                  "__text": "the 22nd, 14th and an obsolete letter (\n as a cross) of the Greek\n alphabet (intermediate between the 5th and 6th), used as numbers;\n denoting respectively 600, 60 and 6;"
               },
               "strongs_def": "666 as a numeral",
               "kjv_def": ":--six hundred\n threescore and six.",
               "_strongs": "05516"
            },
            {
               "strongs": "5517",
               "greek": [
                  {
                     "_BETA": "XOI+KO/S",
                     "_unicode": "χοϊκός",
                     "_translit": "choïkós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho-ik-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5522"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "dusty or dirty (soil-like), i.e. (by implication)\n terrene",
               "kjv_def": ":--earthy.",
               "_strongs": "05517"
            },
            {
               "strongs": "5518",
               "greek": [
                  {
                     "_BETA": "XOI=NIC",
                     "_unicode": "χοῖνιξ",
                     "_translit": "choînix"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khoy'-nix"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a chœnix or certain dry measure",
               "kjv_def": ":--measure.",
               "_strongs": "05518"
            },
            {
               "strongs": "5519",
               "greek": [
                  {
                     "_BETA": "XOI=ROS",
                     "_unicode": "χοῖρος",
                     "_translit": "choîros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khoy'-ros"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a hog",
               "kjv_def": ":--swine.",
               "_strongs": "05519"
            },
            {
               "strongs": "5520",
               "greek": [
                  {
                     "_BETA": "XOLA/W",
                     "_unicode": "χολάω",
                     "_translit": "choláō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khol-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5521"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be bilious, i.e. (by implication) irritable (enraged,\n \"choleric\")",
               "kjv_def": ":--be angry.",
               "_strongs": "05520"
            },
            {
               "strongs": "5521",
               "greek": [
                  {
                     "_BETA": "XOLH/",
                     "_unicode": "χολή",
                     "_translit": "cholḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khol-ay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5514"
                     }
                  ],
                  "__text": "feminine of an equivalent perhaps akin to the same as \n (from the\n greenish hue);"
               },
               "strongs_def": "\"gall\" or bile, i.e. (by analogy) poison or an anodyne\n (wormwood, poppy, etc.)",
               "kjv_def": ":--gall.",
               "_strongs": "05521"
            },
            {
               "strongs": "5522",
               "greek": [
                  {
                     "_BETA": "XO/OS",
                     "_unicode": "χόος",
                     "_translit": "chóos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5494"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "a heap (as poured out), i.e. rubbish; loose\n dirt",
               "kjv_def": ":--dust.",
               "_strongs": "05522"
            },
            {
               "strongs": "5523",
               "greek": [
                  {
                     "_BETA": "*XORAZI/N",
                     "_unicode": "Χοραζίν",
                     "_translit": "Chorazín"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khor-ad-zin'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "Chorazin, a place in Palestine",
               "kjv_def": ":--Chorazin.",
               "_strongs": "05523"
            },
            {
               "strongs": "5524",
               "greek": [
                  {
                     "_BETA": "XORHGE/W",
                     "_unicode": "χορηγέω",
                     "_translit": "chorēgéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khor-ayg-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5525"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "71"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "to be a dance-leader, i.e. (generally)\n to furnish",
               "kjv_def": ":--give, minister.",
               "_strongs": "05524"
            },
            {
               "strongs": "5525",
               "greek": [
                  {
                     "_BETA": "XORO/S",
                     "_unicode": "χορός",
                     "_translit": "chorós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khor-os'"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": "a ring, i.e. round dance (\"choir\"",
               "kjv_def": ":--dancing.",
               "_strongs": "05525"
            },
            {
               "strongs": "5526",
               "greek": [
                  {
                     "_BETA": "XORTA/ZW",
                     "_unicode": "χορτάζω",
                     "_translit": "chortázō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khor-tad'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5528"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to fodder, i.e. (generally) to gorge (supply food in\n abundance)",
               "kjv_def": ":--feed, fill, satisfy.",
               "_strongs": "05526"
            },
            {
               "strongs": "5527",
               "greek": [
                  {
                     "_BETA": "XO/RTASMA",
                     "_unicode": "χόρτασμα",
                     "_translit": "chórtasma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khor'-tas-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5526"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "forage, i.e. food",
               "kjv_def": ":--sustenance.",
               "_strongs": "05527"
            },
            {
               "strongs": "5528",
               "greek": [
                  {
                     "_BETA": "XO/RTOS",
                     "_unicode": "χόρτος",
                     "_translit": "chórtos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khor'-tos"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "a \"court\" or \"garden\", i.e. (by\n implication, of pasture) herbage or vegetation",
               "kjv_def": ":--blade, grass, hay.",
               "_strongs": "05528"
            },
            {
               "strongs": "5529",
               "greek": [
                  {
                     "_BETA": "*XOUZA=S",
                     "_unicode": "Χουζᾶς",
                     "_translit": "Chouzâs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khood-zas'"
                  }
               ],
               "strongs_derivation": "of uncertain origin;",
               "strongs_def": "Chuzas, an officer of Herod",
               "kjv_def": ":--Chuza.",
               "_strongs": "05529"
            },
            {
               "strongs": "5530",
               "greek": [
                  {
                     "_BETA": "XRA/OMAI",
                     "_unicode": "χράομαι",
                     "_translit": "chráomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khrah'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5495"
                     }
                  ],
                  "__text": "middle voice of a primary verb (perhaps rather from \n, to handle);"
               },
               "strongs_def": "to furnish what is needed; (give an oracle, \"graze\" (touch slightly),\n light upon, etc.), i.e. (by implication) to employ or (by extension)\n to act towards one in a given manner",
               "kjv_def": ":--entreat, use.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5531"
                  },
                  {
                     "_language": "GREEK",
                     "_strongs": "5534"
                  }
               ],
               "_strongs": "05530",
               "__text": "Compare \n;\n \n."
            },
            {
               "strongs": "5531",
               "greek": [
                  {
                     "_BETA": "XRA/W",
                     "_unicode": "χράω",
                     "_translit": "chráō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khrah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "probably the same as the base of \n;"
               },
               "strongs_def": "to loan",
               "kjv_def": ":--lend.",
               "_strongs": "05531"
            },
            {
               "strongs": "5532",
               "greek": [
                  {
                     "_BETA": "XREI/A",
                     "_unicode": "χρεία",
                     "_translit": "chreía"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khri'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5534"
                     }
                  ],
                  "__text": "from the base of \n or \n;"
               },
               "strongs_def": "employment, i.e. an affair; also (by\n implication) occasion, demand, requirement or destitution",
               "kjv_def": ":--business,\n lack, necessary(-ity), need(-ful), use, want.",
               "_strongs": "05532"
            },
            {
               "strongs": "5533",
               "greek": [
                  {
                     "_BETA": "XREWFEILE/THS",
                     "_unicode": "χρεωφειλέτης",
                     "_translit": "chreōpheilétēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khreh-o-fi-let'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5531"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3781"
                     }
                  ],
                  "__text": "from a derivative of \n and \n;"
               },
               "strongs_def": "a loan-ower, i.e. indebted\n person",
               "kjv_def": ":--debtor.",
               "_strongs": "05533"
            },
            {
               "strongs": "5534",
               "greek": [
                  {
                     "_BETA": "XRH/",
                     "_unicode": "χρή",
                     "_translit": "chrḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khray"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5531"
                     }
                  ],
                  "__text": "third person singular of the same as \n or \n used impersonally;"
               },
               "strongs_def": "it needs (must or should) be",
               "kjv_def": ":--ought.",
               "_strongs": "05534"
            },
            {
               "strongs": "5535",
               "greek": [
                  {
                     "_BETA": "XRH/|ZW",
                     "_unicode": "χρῄζω",
                     "_translit": "chrḗizō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khrade'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5532"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to make (i.e. have) necessity, i.e. be in want of",
               "kjv_def": ":--(have)\n need.",
               "_strongs": "05535"
            },
            {
               "strongs": "5536",
               "greek": [
                  {
                     "_BETA": "XRH=MA",
                     "_unicode": "χρῆμα",
                     "_translit": "chrēma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khray'-mah"
                  }
               ],
               "strongs_def": "something useful or needed, i.e. wealth, price",
               "kjv_def": ":--money, riches.",
               "_strongs": "05536"
            },
            {
               "strongs": "5537",
               "greek": [
                  {
                     "_BETA": "XRHMATI/ZW",
                     "_unicode": "χρηματίζω",
                     "_translit": "chrēmatízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khray-mat-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5536"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5532"
                     }
                  ],
                  "__text": "to utter an oracle (compare the original sense of \n),\n i.e. divinely intimate; by implication, (compare the secular sense of\n \n) to constitute a firm for business, i.e. (generally) bear as a\n title"
               },
               "kjv_def": ":--be called, be admonished (warned) of God, reveal, speak.",
               "_strongs": "05537"
            },
            {
               "strongs": "5538",
               "greek": [
                  {
                     "_BETA": "XRHMATISMO/S",
                     "_unicode": "χρηματισμός",
                     "_translit": "chrēmatismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khray-mat-is-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5537"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a divine response or revelation",
               "kjv_def": ":--answer of God.",
               "_strongs": "05538"
            },
            {
               "strongs": "5539",
               "greek": [
                  {
                     "_BETA": "XRH/SIMOS",
                     "_unicode": "χρήσιμος",
                     "_translit": "chrḗsimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khray'-see-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5540"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "serviceable",
               "kjv_def": ":--profit.",
               "_strongs": "05539"
            },
            {
               "strongs": "5540",
               "greek": [
                  {
                     "_BETA": "XRH=SIS",
                     "_unicode": "χρῆσις",
                     "_translit": "chrēsis"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khray'-sis"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "employment, i.e. (specially), sexual intercourse (as an\n occupation of the body)",
               "kjv_def": ":--use.",
               "_strongs": "05540"
            },
            {
               "strongs": "5541",
               "greek": [
                  {
                     "_BETA": "XRHSTEU/OMAI",
                     "_unicode": "χρηστεύομαι",
                     "_translit": "chrēsteúomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khraste-yoo'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5543"
                     }
                  ],
                  "__text": "middle voice from \n;"
               },
               "strongs_def": "to show oneself useful, i.e. act\n benevolently",
               "kjv_def": ":--be kind.",
               "_strongs": "05541"
            },
            {
               "strongs": "5542",
               "greek": [
                  {
                     "_BETA": "XRHSTOLOGI/A",
                     "_unicode": "χρηστολογία",
                     "_translit": "chrēstología"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khrase-tol-og-ee'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5543"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from a compound of \n and \n;"
               },
               "strongs_def": "fair speech, i.e.\n plausibility",
               "kjv_def": ":--good words.",
               "_strongs": "05542"
            },
            {
               "strongs": "5543",
               "greek": [
                  {
                     "_BETA": "XRHSTO/S",
                     "_unicode": "χρηστός",
                     "_translit": "chrēstós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khrase-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "employed, i.e. (by implication) useful (in manner or\n morals)",
               "kjv_def": ":--better, easy, good(-ness), gracious, kind.",
               "_strongs": "05543"
            },
            {
               "strongs": "5544",
               "greek": [
                  {
                     "_BETA": "XRHSTO/THS",
                     "_unicode": "χρηστότης",
                     "_translit": "chrēstótēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khray-stot'-ace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5543"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "usefulness, i.e. morally, excellence (in character or\n demeanor)",
               "kjv_def": ":--gentleness, good(-ness), kindness.",
               "_strongs": "05544"
            },
            {
               "strongs": "5545",
               "greek": [
                  {
                     "_BETA": "XRI=SMA",
                     "_unicode": "χρῖσμα",
                     "_translit": "chrîsma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khris'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5548"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "an unguent or smearing, i.e. (figuratively) the special\n endowment (\"chrism\") of the Holy Spirit",
               "kjv_def": ":--anointing, unction.",
               "_strongs": "05545"
            },
            {
               "strongs": "5546",
               "greek": [
                  {
                     "_BETA": "*XRISTIANO/S",
                     "_unicode": "Χριστιανός",
                     "_translit": "Christianós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khris-tee-an-os'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5547"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a Christian, i.e. follower of Christ",
               "kjv_def": ":--Christian.",
               "_strongs": "05546"
            },
            {
               "strongs": "5547",
               "greek": [
                  {
                     "_BETA": "*XRISTO/S",
                     "_unicode": "Χριστός",
                     "_translit": "Christós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khris-tos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5548"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "anointed, i.e. the Messiah, an epithet of Jesus",
               "kjv_def": ":--Christ.",
               "_strongs": "05547"
            },
            {
               "strongs": "5548",
               "greek": [
                  {
                     "_BETA": "XRI/W",
                     "_unicode": "χρίω",
                     "_translit": "chríō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khree'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "probably akin to \n through the idea of contact;"
               },
               "strongs_def": "to smear or rub\n with oil, i.e. (by implication) to consecrate to an office or\n religious service",
               "kjv_def": ":--anoint.",
               "_strongs": "05548"
            },
            {
               "strongs": "5549",
               "greek": [
                  {
                     "_BETA": "XRONI/ZW",
                     "_unicode": "χρονίζω",
                     "_translit": "chronízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khron-id'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5550"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to take time, i.e. linger",
               "kjv_def": ":--delay, tarry.",
               "_strongs": "05549"
            },
            {
               "strongs": "5550",
               "greek": [
                  {
                     "_BETA": "XRO/NOS",
                     "_unicode": "χρόνος",
                     "_translit": "chrónos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khron'-os"
                  }
               ],
               "strongs_derivation": "of uncertain derivation;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "2540"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "165"
                     }
                  ],
                  "__text": "a space of time (in general, and thus\n properly distinguished from \n, which designates a fixed or special\n occasion; and from \n, which denotes a particular period) or\n interval; by extension, an individual opportunity; by implication,\n delay"
               },
               "kjv_def": ":--+ years old, season, space, (X often-)time(-s), (a) while.",
               "_strongs": "05550"
            },
            {
               "strongs": "5551",
               "greek": [
                  {
                     "_BETA": "XRONOTRIBE/W",
                     "_unicode": "χρονοτριβέω",
                     "_translit": "chronotribéō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khron-ot-rib-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5550"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5147"
                     }
                  ],
                  "__text": "from a presumed compound of \n and the base of \n;"
               },
               "strongs_def": "to be a\n time-wearer, i.e. to procrastinate (linger)",
               "kjv_def": ":--spend time.",
               "_strongs": "05551"
            },
            {
               "strongs": "5552",
               "greek": [
                  {
                     "_BETA": "XRU/SEOS",
                     "_unicode": "χρύσεος",
                     "_translit": "chrýseos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khroo'-seh-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5557"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "made of gold",
               "kjv_def": ":--of gold, golden.",
               "_strongs": "05552"
            },
            {
               "strongs": "5553",
               "greek": [
                  {
                     "_BETA": "XRUSI/ON",
                     "_unicode": "χρυσίον",
                     "_translit": "chrysíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khroo-see'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5557"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "a golden article, i.e. gold plating, ornament, or\n coin",
               "kjv_def": ":--gold.",
               "_strongs": "05553"
            },
            {
               "strongs": "5554",
               "greek": [
                  {
                     "_BETA": "XRUSODAKTU/LIOS",
                     "_unicode": "χρυσοδακτύλιος",
                     "_translit": "chrysodaktýlios"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khroo-sod-ak-too'-lee-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5557"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1146"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "gold-ringed, i.e. wearing a golden finger-ring or\n similar jewelry",
               "kjv_def": ":--with a gold ring.",
               "_strongs": "05554"
            },
            {
               "strongs": "5555",
               "greek": [
                  {
                     "_BETA": "XRUSO/LIQOS",
                     "_unicode": "χρυσόλιθος",
                     "_translit": "chrysólithos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khroo-sol'-ee-thos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5557"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3037"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "gold-stone, i.e. a yellow gem\n (\"chrysolite\")",
               "kjv_def": ":--chrysolite.",
               "_strongs": "05555"
            },
            {
               "strongs": "5556",
               "greek": [
                  {
                     "_BETA": "XRUSO/PRASOS",
                     "_unicode": "χρυσόπρασος",
                     "_translit": "chrysóprasos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khroo-sop'-ras-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5557"
                     }
                  ],
                  "greek": [
                     {
                        "_BETA": "PRA/SON",
                        "_unicode": "πράσον",
                        "_translit": "práson"
                     }
                  ],
                  "__text": "from \n and \n (a leek);"
               },
               "strongs_def": "a greenish-yellow gem\n (\"chrysoprase\")",
               "kjv_def": ":--chrysoprase.",
               "_strongs": "05556"
            },
            {
               "strongs": "5557",
               "greek": [
                  {
                     "_BETA": "XRUSO/S",
                     "_unicode": "χρυσός",
                     "_translit": "chrysós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khroo-sos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "perhaps from the base of \n (through the idea of the utility of the\n metal);"
               },
               "strongs_def": "gold; by extension, a golden article, as an ornament or\n coin",
               "kjv_def": ":--gold.",
               "_strongs": "05557"
            },
            {
               "strongs": "5558",
               "greek": [
                  {
                     "_BETA": "XRUSO/W",
                     "_unicode": "χρυσόω",
                     "_translit": "chrysóō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khroo-so'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5557"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to gild, i.e. bespangle with golden ornaments",
               "kjv_def": ":--deck.",
               "_strongs": "05558"
            },
            {
               "strongs": "5559",
               "greek": [
                  {
                     "_BETA": "XRW/S",
                     "_unicode": "χρώς",
                     "_translit": "chrṓs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "khroce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5530"
                     }
                  ],
                  "__text": "probably akin to the base of \n through the idea of handling;"
               },
               "strongs_def": "the\n body (properly, its surface or skin)",
               "kjv_def": ":--body.",
               "_strongs": "05559"
            },
            {
               "strongs": "5560",
               "greek": [
                  {
                     "_BETA": "XWLO/S",
                     "_unicode": "χωλός",
                     "_translit": "chōlós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho-los'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "\"halt\", i.e. limping",
               "kjv_def": ":--cripple, halt, lame.",
               "_strongs": "05560"
            },
            {
               "strongs": "5561",
               "greek": [
                  {
                     "_BETA": "XW/RA",
                     "_unicode": "χώρα",
                     "_translit": "chṓra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho'-rah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5490"
                     }
                  ],
                  "__text": "feminine of a derivative of the base of \n through the idea of empty\n expanse;"
               },
               "strongs_def": "room, i.e. a space of territory (more or less extensive;\n often including its inhabitants)",
               "kjv_def": ":--coast, county, fields, ground,\n land, region.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5117"
                  }
               ],
               "_strongs": "05561",
               "__text": "Compare \n."
            },
            {
               "strongs": "5562",
               "greek": [
                  {
                     "_BETA": "XWRE/W",
                     "_unicode": "χωρέω",
                     "_translit": "chōréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be in (give) space, i.e. (intransitively) to pass,\n enter, or (transitively) to hold, admit (literally or\n figuratively)",
               "kjv_def": ":--come, contain, go, have place, (can, be room to)\n receive.",
               "_strongs": "05562"
            },
            {
               "strongs": "5563",
               "greek": [
                  {
                     "_BETA": "XWRI/ZW",
                     "_unicode": "χωρίζω",
                     "_translit": "chōrízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho-rid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to place room between, i.e. part; reflexively, to go\n away",
               "kjv_def": ":--depart, put asunder, separate.",
               "_strongs": "05563"
            },
            {
               "strongs": "5564",
               "greek": [
                  {
                     "_BETA": "XWRI/ON",
                     "_unicode": "χωρίον",
                     "_translit": "chōríon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho-ree'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "a spot or plot of ground",
               "kjv_def": ":--field, land, parcel of\n ground, place, possession.",
               "_strongs": "05564"
            },
            {
               "strongs": "5565",
               "greek": [
                  {
                     "_BETA": "XWRI/S",
                     "_unicode": "χωρίς",
                     "_translit": "chōrís"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho-rece'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5561"
                     }
                  ],
                  "__text": "adverb from \n;"
               },
               "strongs_def": "at a space, i.e. separately or apart from (often as\n preposition)",
               "kjv_def": ":--beside, by itself, without.",
               "_strongs": "05565"
            },
            {
               "strongs": "5566",
               "greek": [
                  {
                     "_BETA": "XW=ROS",
                     "_unicode": "χῶρος",
                     "_translit": "chōros"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "kho'-ros"
                  }
               ],
               "strongs_derivation": "of Latin origin;",
               "strongs_def": "the north-west wind",
               "kjv_def": ":--north west.",
               "_strongs": "05566"
            },
            {
               "strongs": "5567",
               "greek": [
                  {
                     "_BETA": "YA/LLW",
                     "_unicode": "ψάλλω",
                     "_translit": "psállō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psal'-lo"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "YA/W",
                        "_unicode": "ψάω",
                        "_translit": "psáō"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5597"
                     }
                  ],
                  "__text": "probably strengthened from \n (to rub or touch the surface; compare\n \n);"
               },
               "strongs_def": "to twitch or twang, i.e. to play on a stringed instrument\n (celebrate the divine worship with music and accompanying odes)",
               "kjv_def": ":--make\n melody, sing (psalms).",
               "_strongs": "05567"
            },
            {
               "strongs": "5568",
               "greek": [
                  {
                     "_BETA": "YALMO/S",
                     "_unicode": "ψαλμός",
                     "_translit": "psalmós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psal-mos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5567"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a set piece of music, i.e. a sacred ode (accompanied with\n the voice, harp or other instrument; a \"psalm\"); collectively, the\n book of the Psalms",
               "kjv_def": ":--psalm.",
               "strongsref": [
                  {
                     "_language": "GREEK",
                     "_strongs": "5603"
                  }
               ],
               "_strongs": "05568",
               "__text": "Compare \n."
            },
            {
               "strongs": "5569",
               "greek": [
                  {
                     "_BETA": "YEUDA/DELFOS",
                     "_unicode": "ψευδάδελφος",
                     "_translit": "pseudádelphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dad'-el-fos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "80"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a spurious brother, i.e. pretended associate",
               "kjv_def": ":--false\n brethren.",
               "_strongs": "05569"
            },
            {
               "strongs": "5570",
               "greek": [
                  {
                     "_BETA": "YEUDAPO/STOLOS",
                     "_unicode": "ψευδαπόστολος",
                     "_translit": "pseudapóstolos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dap-os'-tol-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "652"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a spurious apostle, i.e. pretended pracher",
               "kjv_def": ":--false\n teacher.",
               "_strongs": "05570"
            },
            {
               "strongs": "5571",
               "greek": [
                  {
                     "_BETA": "YEUDH/S",
                     "_unicode": "ψευδής",
                     "_translit": "pseudḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5574"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "untrue, i.e. erroneous, deceitful, wicked",
               "kjv_def": ":--false, liar.",
               "_strongs": "05571"
            },
            {
               "strongs": "5572",
               "greek": [
                  {
                     "_BETA": "YEUDODIDA/SKALOS",
                     "_unicode": "ψευδοδιδάσκαλος",
                     "_translit": "pseudodidáskalos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dod-id-as'-kal-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1320"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a spurious teacher, i.e. propagator of erroneous\n Christian doctrine",
               "kjv_def": ":--false teacher.",
               "_strongs": "05572"
            },
            {
               "strongs": "5573",
               "greek": [
                  {
                     "_BETA": "YEUDOLO/GOS",
                     "_unicode": "ψευδολόγος",
                     "_translit": "pseudológos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dol-og'-os"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3004"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "mendacious, i.e. promulgating erroneous Christian\n doctrine",
               "kjv_def": ":--speaking lies.",
               "_strongs": "05573"
            },
            {
               "strongs": "5574",
               "greek": [
                  {
                     "_BETA": "YEU/DOMAI",
                     "_unicode": "ψεύδομαι",
                     "_translit": "pseúdomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo'-dom-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of an apparently primary verb;",
               "strongs_def": "to utter an untruth or\n attempt to deceive by falsehood",
               "kjv_def": ":--falsely, lie.",
               "_strongs": "05574"
            },
            {
               "strongs": "5575",
               "greek": [
                  {
                     "_BETA": "YEUDOMA/RTUR",
                     "_unicode": "ψευδομάρτυρ",
                     "_translit": "pseudomártyr"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dom-ar'-toor"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3144"
                     }
                  ],
                  "__text": "from \n and a kindred form of \n;"
               },
               "strongs_def": "a spurious witness, i.e. bearer\n of untrue testimony",
               "kjv_def": ":--false witness.",
               "_strongs": "05575"
            },
            {
               "strongs": "5576",
               "greek": [
                  {
                     "_BETA": "YEUDOMARTURE/W",
                     "_unicode": "ψευδομαρτυρέω",
                     "_translit": "pseudomartyréō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dom-ar-too-reh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5575"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to be an untrue testifier, i.e. offer falsehood in\n evidence",
               "kjv_def": ":--be a false witness.",
               "_strongs": "05576"
            },
            {
               "strongs": "5577",
               "greek": [
                  {
                     "_BETA": "YEUDOMARTURI/A",
                     "_unicode": "ψευδομαρτυρία",
                     "_translit": "pseudomartyría"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dom-ar-too-ree'-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5575"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "untrue testimony",
               "kjv_def": ":--false witness.",
               "_strongs": "05577"
            },
            {
               "strongs": "5578",
               "greek": [
                  {
                     "_BETA": "YEUDOPROFH/THS",
                     "_unicode": "ψευδοπροφήτης",
                     "_translit": "pseudoprophḗtēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dop-rof-ay'-tace"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4396"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a spurious prophet, i.e. pretended foreteller or\n religious impostor",
               "kjv_def": ":--false prophet.",
               "_strongs": "05578"
            },
            {
               "strongs": "5579",
               "greek": [
                  {
                     "_BETA": "YEU=DOS",
                     "_unicode": "ψεῦδος",
                     "_translit": "pseûdos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo'-dos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5574"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a falsehood",
               "kjv_def": ":--lie, lying.",
               "_strongs": "05579"
            },
            {
               "strongs": "5580",
               "greek": [
                  {
                     "_BETA": "YEUDO/XRISTOS",
                     "_unicode": "ψευδόχριστος",
                     "_translit": "pseudóchristos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-dokh'-ris-tos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5547"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "a spurious Messiah",
               "kjv_def": ":--false Christ.",
               "_strongs": "05580"
            },
            {
               "strongs": "5581",
               "greek": [
                  {
                     "_BETA": "YEUDW/NUMOS",
                     "_unicode": "ψευδώνυμος",
                     "_translit": "pseudṓnymos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoo-do'-noo-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5571"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "3686"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "untruly named",
               "kjv_def": ":--falsely so called.",
               "_strongs": "05581"
            },
            {
               "strongs": "5582",
               "greek": [
                  {
                     "_BETA": "YEU=SMA",
                     "_unicode": "ψεῦσμα",
                     "_translit": "pseûsma"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoos'-mah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5574"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a fabrication, i.e. falsehood",
               "kjv_def": ":--lie.",
               "_strongs": "05582"
            },
            {
               "strongs": "5583",
               "greek": [
                  {
                     "_BETA": "YEU/STHS",
                     "_unicode": "ψεύστης",
                     "_translit": "pseústēs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psyoos-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5574"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "a falsifier",
               "kjv_def": ":--liar.",
               "_strongs": "05583"
            },
            {
               "strongs": "5584",
               "greek": [
                  {
                     "_BETA": "YHLAFA/W",
                     "_unicode": "ψηλαφάω",
                     "_translit": "psēlapháō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psay-laf-ah'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5567"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5586"
                     }
                  ],
                  "__text": "from the base of \n (compare \n);"
               },
               "strongs_def": "to manipulate, i.e. verify by\n contact; figuratively, to search for",
               "kjv_def": ":--feel after, handle, touch.",
               "_strongs": "05584"
            },
            {
               "strongs": "5585",
               "greek": [
                  {
                     "_BETA": "YHFI/ZW",
                     "_unicode": "ψηφίζω",
                     "_translit": "psēphízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psay-fid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5586"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to use pebbles in enumeration, i.e. (generally) to\n compute",
               "kjv_def": ":--count.",
               "_strongs": "05585"
            },
            {
               "strongs": "5586",
               "greek": [
                  {
                     "_BETA": "YH=FOS",
                     "_unicode": "ψῆφος",
                     "_translit": "psēphos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psay'-fos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5584"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a pebble (as worn smooth by handling), i.e. (by\n implication, of use as a counter or ballot) a verdict (of acquittal)\n or ticket (of admission); a vote",
               "kjv_def": ":--stone, voice.",
               "_strongs": "05586"
            },
            {
               "strongs": "5587",
               "greek": [
                  {
                     "_BETA": "YIQURISMO/S",
                     "_unicode": "ψιθυρισμός",
                     "_translit": "psithyrismós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psith-oo-ris-mos'"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "YI/QOS",
                        "_unicode": "ψίθος",
                        "_translit": "psíthos"
                     }
                  ],
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5574"
                     }
                  ],
                  "__text": "from a derivative of \n (a whisper; by implication, a slander;\n probably akin to \n);"
               },
               "strongs_def": "whispering, i.e. secret\n detraction",
               "kjv_def": ":--whispering.",
               "_strongs": "05587"
            },
            {
               "strongs": "5588",
               "greek": [
                  {
                     "_BETA": "YIQURISTH/S",
                     "_unicode": "ψιθυριστής",
                     "_translit": "psithyristḗs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psith-oo-ris-tace'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5587"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "a secret calumniator",
               "kjv_def": ":--whisperer.",
               "_strongs": "05588"
            },
            {
               "strongs": "5589",
               "greek": [
                  {
                     "_BETA": "YIXI/ON",
                     "_unicode": "ψιχίον",
                     "_translit": "psichíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psikh-ee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5567"
                     }
                  ],
                  "__text": "diminutive from a derivative of the base of \n (meaning a crumb);"
               },
               "strongs_def": "a\n little bit or morsel",
               "kjv_def": ":--crumb.",
               "_strongs": "05589"
            },
            {
               "strongs": "5590",
               "greek": [
                  {
                     "_BETA": "YUXH/",
                     "_unicode": "ψυχή",
                     "_translit": "psychḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psoo-khay'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5594"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4151"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "2222"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "05315"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "07307"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "02416"
                     }
                  ],
                  "__text": "breath, i.e. (by implication) spirit, abstractly or\n concretely (the animal sentient principle only; thus distinguished on\n the one hand from \n, which is the rational and immortal soul; and\n on the other from \n, which is mere vitality, even of plants: these\n terms thus exactly correspond respectively to the Hebrew \n, \n\n and \n)"
               },
               "kjv_def": ":--heart (+ -ily), life, mind, soul, + us, + you.",
               "_strongs": "05590"
            },
            {
               "strongs": "5591",
               "greek": [
                  {
                     "_BETA": "YUXIKO/S",
                     "_unicode": "ψυχικός",
                     "_translit": "psychikós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psoo-khee-kos'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5590"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4152"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5446"
                     }
                  ],
                  "__text": "sensitive, i.e. animate (in distinction on the one hand\n from \n, which is the higher or renovated nature; and on the other\n from \n, which is the lower or bestial nature)"
               },
               "kjv_def": ":--natural, sensual.",
               "_strongs": "05591"
            },
            {
               "strongs": "5592",
               "greek": [
                  {
                     "_BETA": "YU/XOS",
                     "_unicode": "ψύχος",
                     "_translit": "psýchos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psoo'-khos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5594"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "coolness",
               "kjv_def": ":--cold.",
               "_strongs": "05592"
            },
            {
               "strongs": "5593",
               "greek": [
                  {
                     "_BETA": "YUXRO/S",
                     "_unicode": "ψυχρός",
                     "_translit": "psychrós"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psoo-chros'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5592"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "chilly (literally or figuratively)",
               "kjv_def": ":--cold.",
               "_strongs": "05593"
            },
            {
               "strongs": "5594",
               "greek": [
                  {
                     "_BETA": "YU/XW",
                     "_unicode": "ψύχω",
                     "_translit": "psýchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "psoo'-kho"
                  }
               ],
               "strongs_derivation": "a primary verb;",
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4154"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "109"
                     }
                  ],
                  "__text": "to breathe (voluntarily but gently, thus differing on\n the one hand from \n, which denotes properly a forcible respiration;\n and on the other from the base of \n, which refers properly to an\n inanimate breeze), i.e. (by implication, of reduction of temperature\n by  evaporation) to chill (figuratively)"
               },
               "kjv_def": ":--wax cold.",
               "_strongs": "05594"
            },
            {
               "strongs": "5595",
               "greek": [
                  {
                     "_BETA": "YWMI/ZW",
                     "_unicode": "ψωμίζω",
                     "_translit": "psōmízō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pso-mid'-zo"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5596"
                     }
                  ],
                  "__text": "from the base of \n;"
               },
               "strongs_def": "to supply with bits, i.e. (generally) to\n nourish",
               "kjv_def": ":--(bestow to) feed.",
               "_strongs": "05595"
            },
            {
               "strongs": "5596",
               "greek": [
                  {
                     "_BETA": "YWMI/ON",
                     "_unicode": "ψωμίον",
                     "_translit": "psōmíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pso-mee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5597"
                     }
                  ],
                  "__text": "diminutive from a derivative of the base of \n;"
               },
               "strongs_def": "a crumb or morsel\n (as if rubbed off), i.e. a mouthful",
               "kjv_def": ":--sop.",
               "_strongs": "05596"
            },
            {
               "strongs": "5597",
               "greek": [
                  {
                     "_BETA": "YW/XW",
                     "_unicode": "ψώχω",
                     "_translit": "psṓchō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "pso'-kho"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5567"
                     }
                  ],
                  "__text": "prolongation from the same base as \n;"
               },
               "strongs_def": "to triturate, i.e. (by\n analogy) to rub out (kernels from husks with the fingers or\n hand)",
               "kjv_def": ":--rub.",
               "_strongs": "05597"
            },
            {
               "strongs": "5598",
               "greek": [
                  {
                     "_BETA": "*W",
                     "_unicode": "Ω",
                     "_translit": "Ō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o'-meg-ah"
                  }
               ],
               "strongs_def": "the last letter of the Greek alphabet, i.e. (figuratively) the\n finality",
               "kjv_def": ":--Omega.",
               "_strongs": "05598"
            },
            {
               "strongs": "5599",
               "greek": [
                  {
                     "_BETA": "W)=",
                     "_unicode": "ὦ",
                     "_translit": "ō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o"
                  }
               ],
               "strongs_derivation": "a primary interjection;",
               "strongs_def": "as a sign of the vocative case, O; as a note\n of exclamation, oh",
               "kjv_def": ":--O.",
               "_strongs": "05599"
            },
            {
               "strongs": "5600",
               "greek": [
                  {
                     "_BETA": "W)=",
                     "_unicode": "ὦ",
                     "_translit": "ō"
                  },
                  {
                     "_BETA": "H)=S",
                     "_unicode": "ἦς",
                     "_translit": "ēs"
                  },
                  {
                     "_BETA": "H)=",
                     "_unicode": "ἦ",
                     "_translit": "ē"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o"
                  },
                  {
                     "_strongs": "ace"
                  },
                  {
                     "_strongs": "ay"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "the subjunctive of \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     }
                  ],
                  "__text": "(may, might, can, could, would, should, must,\n etc.; also with \n and its compounds, as well as with other\n particles) be"
               },
               "kjv_def": ":--+ appear, are, (may, might,  should) be, X have, is, +\n pass the flower of her age, should stand, were.",
               "_strongs": "05600",
               "__text": ",   including the oblique forms, as well as\n      \n  \n;\n      \n  \n;  etc."
            },
            {
               "strongs": "5601",
               "greek": [
                  {
                     "_BETA": "*)WBH/D",
                     "_unicode": "Ὠβήδ",
                     "_translit": "Ōbḗd"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-bade'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "05744"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Obed, an Israelite",
               "kjv_def": ":--Obed.",
               "_strongs": "05601"
            },
            {
               "strongs": "5602",
               "greek": [
                  {
                     "_BETA": "W(=DE",
                     "_unicode": "ὧδε",
                     "_translit": "hōde"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho'-deh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3592"
                     }
                  ],
                  "__text": "from an adverb form of \n;"
               },
               "strongs_def": "in this same spot, i.e. here or\n hither",
               "kjv_def": ":--here, hither, (in) this place, there.",
               "_strongs": "05602"
            },
            {
               "strongs": "5603",
               "greek": [
                  {
                     "_BETA": "W)|DH/",
                     "_unicode": "ᾠδή",
                     "_translit": "ōidḗ"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-day'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "103"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5215"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5568"
                     }
                  ],
                  "__text": "a chant or \"ode\" (the general term for any words sung; while\n \n denotes especially a religious metrical composition, and \n\n still more specially, a Hebrew cantillation)"
               },
               "kjv_def": ":--song.",
               "_strongs": "05603"
            },
            {
               "strongs": "5604",
               "greek": [
                  {
                     "_BETA": "W)DI/N",
                     "_unicode": "ὠδίν",
                     "_translit": "ōdín"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-deen'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3601"
                     }
                  ],
                  "__text": "akin to \n;"
               },
               "strongs_def": "a pang or throe, especially of childbirth",
               "kjv_def": ":--pain,\n sorrow, travail.",
               "_strongs": "05604"
            },
            {
               "strongs": "5605",
               "greek": [
                  {
                     "_BETA": "W)DI/NW",
                     "_unicode": "ὠδίνω",
                     "_translit": "ōdínō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-dee'-no"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5604"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "to experience the pains of parturition (literally or\n figuratively)",
               "kjv_def": ":--travail in (birth).",
               "_strongs": "05605"
            },
            {
               "strongs": "5606",
               "greek": [
                  {
                     "_BETA": "W)=MOS",
                     "_unicode": "ὦμος",
                     "_translit": "ōmos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o'-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5342"
                     }
                  ],
                  "__text": "perhaps from the alternate of \n;"
               },
               "strongs_def": "the shoulder (as that on which\n burdens are borne)",
               "kjv_def": ":--shoulder.",
               "_strongs": "05606"
            },
            {
               "strongs": "5607",
               "greek": [
                  {
                     "_BETA": "W)/N",
                     "_unicode": "ὤν",
                     "_translit": "ṓn"
                  },
                  {
                     "_BETA": "OU)=SA",
                     "_unicode": "οὖσα",
                     "_translit": "oûsa"
                  },
                  {
                     "_BETA": "O)/N",
                     "_unicode": "ὄν",
                     "_translit": "ón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "oan"
                  },
                  {
                     "_strongs": "oo'-sah"
                  },
                  {
                     "_strongs": "on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "1510"
                     }
                  ],
                  "__text": "present participle of \n;"
               },
               "strongs_def": "being",
               "kjv_def": ":--be, come, have.",
               "_strongs": "05607",
               "__text": ",     including the feminine\n      \n  \n; and the neuter"
            },
            {
               "strongs": "5608",
               "greek": [
                  {
                     "_BETA": "W)NE/OMAI",
                     "_unicode": "ὠνέομαι",
                     "_translit": "ōnéomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-neh'-om-ahee"
                  }
               ],
               "strongs_derivation": {
                  "greek": [
                     {
                        "_BETA": "W)=NOS",
                        "_unicode": "ὦνος",
                        "_translit": "ōnos"
                     }
                  ],
                  "__text": "middle voice from an apparently primary \n (a sum or price);"
               },
               "strongs_def": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "4092"
                     }
                  ],
                  "__text": "to\n purchase (synonymous with the earlier \n)"
               },
               "kjv_def": ":-- buy.",
               "_strongs": "05608"
            },
            {
               "strongs": "5609",
               "greek": [
                  {
                     "_BETA": "W)O/N",
                     "_unicode": "ὠόν",
                     "_translit": "ōón"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-on'"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "an \"egg\"",
               "kjv_def": ":--egg.",
               "_strongs": "05609"
            },
            {
               "strongs": "5610",
               "greek": [
                  {
                     "_BETA": "W(/RA",
                     "_unicode": "ὥρα",
                     "_translit": "hṓra"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho'-rah"
                  }
               ],
               "strongs_derivation": "apparently a primary word;",
               "strongs_def": "an \"hour\" (literally or\n figuratively)",
               "kjv_def": ":--day, hour, instant, season, X short, (even-)tide,\n (high) time.",
               "_strongs": "05610"
            },
            {
               "strongs": "5611",
               "greek": [
                  {
                     "_BETA": "W(RAI=OS",
                     "_unicode": "ὡραῖος",
                     "_translit": "hōraîos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho-rah'-yos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5610"
                     }
                  ],
                  "__text": "from \n;"
               },
               "strongs_def": "belonging to the right hour or season (timely), i.e. (by\n implication) flourishing (beauteous (figuratively))",
               "kjv_def": ":--beautiful.",
               "_strongs": "05611"
            },
            {
               "strongs": "5612",
               "greek": [
                  {
                     "_BETA": "W)RU/OMAI",
                     "_unicode": "ὠρύομαι",
                     "_translit": "ōrýomai"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-roo'-om-ahee"
                  }
               ],
               "strongs_derivation": "middle voice of an apparently primary verb;",
               "strongs_def": "to \"roar\"",
               "kjv_def": ":--roar.",
               "_strongs": "05612"
            },
            {
               "strongs": "5613",
               "greek": [
                  {
                     "_BETA": "W(S",
                     "_unicode": "ὡς",
                     "_translit": "hōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3739"
                     }
                  ],
                  "__text": "probably adverb of comparative from \n;"
               },
               "strongs_def": "which how, i.e. in that\n manner (very variously used, as follows)",
               "kjv_def": ":--about, after (that),\n (according) as (it had been, it were), as soon (as), even as (like),\n for, how (greatly), like (as, unto), since, so (that), that, to wit,\n unto, when(-soever), while, X with all speed.",
               "_strongs": "05613"
            },
            {
               "strongs": "5614",
               "greek": [
                  {
                     "_BETA": "W(SANNA/",
                     "_unicode": "ὡσαννά",
                     "_translit": "hōsanná"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho-san-nah'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "03467"
                     },
                     {
                        "_language": "HEBREW",
                        "_strongs": "04994"
                     }
                  ],
                  "__text": "of Hebrew origin (\n and \n);"
               },
               "strongs_def": "oh save!; hosanna (i.e. hoshia-na),\n an exclamation of adoration",
               "kjv_def": ":--hosanna.",
               "_strongs": "05614"
            },
            {
               "strongs": "5615",
               "greek": [
                  {
                     "_BETA": "W(SAU/TWS",
                     "_unicode": "ὡσαύτως",
                     "_translit": "hōsaútōs"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho-sow'-toce"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5613"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "846"
                     }
                  ],
                  "__text": "from \n and an adverb from \n;"
               },
               "strongs_def": "as thus, i.e. in the same way",
               "kjv_def": ":--even\n so, likewise, after the same (in like) manner.",
               "_strongs": "05615"
            },
            {
               "strongs": "5616",
               "greek": [
                  {
                     "_BETA": "W(SEI/",
                     "_unicode": "ὡσεί",
                     "_translit": "hōseí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho-si'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5613"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "as if",
               "kjv_def": ":--about, as (it had been, it were), like\n (as).",
               "_strongs": "05616"
            },
            {
               "strongs": "5617",
               "greek": [
                  {
                     "_BETA": "*(WSHE/",
                     "_unicode": "Ὡσηέ",
                     "_translit": "Hōsēé"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "ho-say-eh'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "HEBREW",
                        "_strongs": "01954"
                     }
                  ],
                  "__text": "of Hebrew origin (\n);"
               },
               "strongs_def": "Hosee (i.e. Hoshea), an Israelite",
               "kjv_def": ":--Osee.",
               "_strongs": "05617"
            },
            {
               "strongs": "5618",
               "greek": [
                  {
                     "_BETA": "W(/SPER",
                     "_unicode": "ὥσπερ",
                     "_translit": "hṓsper"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoce'-per"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5613"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "4007"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "just as, i.e. exactly like",
               "kjv_def": ":--(even, like) as.",
               "_strongs": "05618"
            },
            {
               "strongs": "5619",
               "greek": [
                  {
                     "_BETA": "W(SPEREI/",
                     "_unicode": "ὡσπερεί",
                     "_translit": "hōspereí"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoce-per-i'"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5618"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "1487"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "just as if, i.e. as it were",
               "kjv_def": ":--as.",
               "_strongs": "05619"
            },
            {
               "strongs": "5620",
               "greek": [
                  {
                     "_BETA": "W(/STE",
                     "_unicode": "ὥστε",
                     "_translit": "hṓste"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "hoce'-teh"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5613"
                     },
                     {
                        "_language": "GREEK",
                        "_strongs": "5037"
                     }
                  ],
                  "__text": "from \n and \n;"
               },
               "strongs_def": "so too, i.e. thus therefore (in various relations\n of consecution, as follow)",
               "kjv_def": ":--(insomuch) as, so that (then), (insomuch)\n that, therefore, to, wherefore.",
               "_strongs": "05620"
            },
            {
               "strongs": "5621",
               "greek": [
                  {
                     "_BETA": "W)TI/ON",
                     "_unicode": "ὠτίον",
                     "_translit": "ōtíon"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-tee'-on"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3775"
                     }
                  ],
                  "__text": "diminutive of \n;"
               },
               "strongs_def": "an earlet, i.e. one of the ears, or perhaps the\n lobe of the ear",
               "kjv_def": ":--ear.",
               "_strongs": "05621"
            },
            {
               "strongs": "5622",
               "greek": [
                  {
                     "_BETA": "W)FE/LEIA",
                     "_unicode": "ὠφέλεια",
                     "_translit": "ōphéleia"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-fel'-i-ah"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5624"
                     }
                  ],
                  "__text": "from a derivative of the base of \n;"
               },
               "strongs_def": "usefulness, i.e.\n benefit",
               "kjv_def": ":--advantage, profit.",
               "_strongs": "05622"
            },
            {
               "strongs": "5623",
               "greek": [
                  {
                     "_BETA": "W)FELE/W",
                     "_unicode": "ὠφελέω",
                     "_translit": "ōpheléō"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-fel-eh'-o"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "5622"
                     }
                  ],
                  "__text": "from the same as \n;"
               },
               "strongs_def": "to be useful, i.e. to benefit",
               "kjv_def": ":--advantage,\n better, prevail, profit.",
               "_strongs": "05623"
            },
            {
               "strongs": "5624",
               "greek": [
                  {
                     "_BETA": "W)FE/LIMOS",
                     "_unicode": "ὠφέλιμος",
                     "_translit": "ōphélimos"
                  }
               ],
               "pronunciation": [
                  {
                     "_strongs": "o-fel'-ee-mos"
                  }
               ],
               "strongs_derivation": {
                  "strongsref": [
                     {
                        "_language": "GREEK",
                        "_strongs": "3786"
                     }
                  ],
                  "__text": "from a form of \n;"
               },
               "strongs_def": "helpful or serviceable, i.e.\n advantageous",
               "kjv_def": ":--profit(-able).",
               "_strongs": "05624"
            }
         ]
      }
   }
}